import { isVue3 as l0, defineComponent as oO, getCurrentInstance as sO, ref as nm, onUnmounted as aO, onMounted as lO, watch as jf, unref as cO, h as uO } from "vue-demi";
var fO = typeof global == "object" && global && global.Object === Object && global;
const c4 = fO;
var dO = typeof self == "object" && self && self.Object === Object && self, hO = c4 || dO || Function("return this")();
const Go = hO;
var pO = Go.Symbol;
const qo = pO;
var u4 = Object.prototype, mO = u4.hasOwnProperty, gO = u4.toString, Ec = qo ? qo.toStringTag : void 0;
function vO(t) {
  var e = mO.call(t, Ec), n = t[Ec];
  try {
    t[Ec] = void 0;
    var r = !0;
  } catch {
  }
  var i = gO.call(t);
  return r && (e ? t[Ec] = n : delete t[Ec]), i;
}
var yO = Object.prototype, bO = yO.toString;
function xO(t) {
  return bO.call(t);
}
var wO = "[object Null]", jO = "[object Undefined]", Iy = qo ? qo.toStringTag : void 0;
function nl(t) {
  return t == null ? t === void 0 ? jO : wO : Iy && Iy in Object(t) ? vO(t) : xO(t);
}
function zo(t) {
  return t != null && typeof t == "object";
}
var kO = "[object Symbol]";
function c0(t) {
  return typeof t == "symbol" || zo(t) && nl(t) == kO;
}
function $O(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = Array(r); ++n < r; )
    i[n] = e(t[n], n, t);
  return i;
}
var SO = Array.isArray;
const qi = SO;
var CO = 1 / 0, Dy = qo ? qo.prototype : void 0, Ly = Dy ? Dy.toString : void 0;
function f4(t) {
  if (typeof t == "string")
    return t;
  if (qi(t))
    return $O(t, f4) + "";
  if (c0(t))
    return Ly ? Ly.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -CO ? "-0" : e;
}
function Qo(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
function u0(t) {
  return t;
}
var OO = "[object AsyncFunction]", EO = "[object Function]", AO = "[object GeneratorFunction]", MO = "[object Proxy]";
function f0(t) {
  if (!Qo(t))
    return !1;
  var e = nl(t);
  return e == EO || e == AO || e == OO || e == MO;
}
var _O = Go["__core-js_shared__"];
const rm = _O;
var By = function() {
  var t = /[^.]+$/.exec(rm && rm.keys && rm.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function TO(t) {
  return !!By && By in t;
}
var PO = Function.prototype, RO = PO.toString;
function rl(t) {
  if (t != null) {
    try {
      return RO.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var NO = /[\\^$.*+?()[\]{}|]/g, IO = /^\[object .+?Constructor\]$/, DO = Function.prototype, LO = Object.prototype, BO = DO.toString, qO = LO.hasOwnProperty, zO = RegExp(
  "^" + BO.call(qO).replace(NO, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function FO(t) {
  if (!Qo(t) || TO(t))
    return !1;
  var e = f0(t) ? zO : IO;
  return e.test(rl(t));
}
function VO(t, e) {
  return t == null ? void 0 : t[e];
}
function il(t, e) {
  var n = VO(t, e);
  return FO(n) ? n : void 0;
}
var HO = il(Go, "WeakMap");
const ag = HO;
var qy = Object.create, UO = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!Qo(e))
      return {};
    if (qy)
      return qy(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}();
const WO = UO;
function JO(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
function d4(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var KO = 800, GO = 16, QO = Date.now;
function YO(t) {
  var e = 0, n = 0;
  return function() {
    var r = QO(), i = GO - (r - n);
    if (n = r, i > 0) {
      if (++e >= KO)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
function XO(t) {
  return function() {
    return t;
  };
}
var ZO = function() {
  try {
    var t = il(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
const Kd = ZO;
var eE = Kd ? function(t, e) {
  return Kd(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: XO(e),
    writable: !0
  });
} : u0;
const tE = eE;
var nE = YO(tE);
const rE = nE;
function iE(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var oE = 9007199254740991, sE = /^(?:0|[1-9]\d*)$/;
function d0(t, e) {
  var n = typeof t;
  return e = e ?? oE, !!e && (n == "number" || n != "symbol" && sE.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function tp(t, e, n) {
  e == "__proto__" && Kd ? Kd(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
function Qu(t, e) {
  return t === e || t !== t && e !== e;
}
var aE = Object.prototype, lE = aE.hasOwnProperty;
function h4(t, e, n) {
  var r = t[e];
  (!(lE.call(t, e) && Qu(r, n)) || n === void 0 && !(e in t)) && tp(t, e, n);
}
function dc(t, e, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, s = e.length; ++o < s; ) {
    var a = e[o], l = r ? r(n[a], t[a], a, n, t) : void 0;
    l === void 0 && (l = t[a]), i ? tp(n, a, l) : h4(n, a, l);
  }
  return n;
}
var zy = Math.max;
function cE(t, e, n) {
  return e = zy(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, i = -1, o = zy(r.length - e, 0), s = Array(o); ++i < o; )
      s[i] = r[e + i];
    i = -1;
    for (var a = Array(e + 1); ++i < e; )
      a[i] = r[i];
    return a[e] = n(s), JO(t, this, a);
  };
}
function uE(t, e) {
  return rE(cE(t, e, u0), t + "");
}
var fE = 9007199254740991;
function h0(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= fE;
}
function np(t) {
  return t != null && h0(t.length) && !f0(t);
}
function dE(t, e, n) {
  if (!Qo(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? np(n) && d0(e, n.length) : r == "string" && e in n) ? Qu(n[e], t) : !1;
}
function p4(t) {
  return uE(function(e, n) {
    var r = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, s = i > 2 ? n[2] : void 0;
    for (o = t.length > 3 && typeof o == "function" ? (i--, o) : void 0, s && dE(n[0], n[1], s) && (o = i < 3 ? void 0 : o, i = 1), e = Object(e); ++r < i; ) {
      var a = n[r];
      a && t(e, a, r, o);
    }
    return e;
  });
}
var hE = Object.prototype;
function p0(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || hE;
  return t === n;
}
function pE(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var mE = "[object Arguments]";
function Fy(t) {
  return zo(t) && nl(t) == mE;
}
var m4 = Object.prototype, gE = m4.hasOwnProperty, vE = m4.propertyIsEnumerable, yE = Fy(/* @__PURE__ */ function() {
  return arguments;
}()) ? Fy : function(t) {
  return zo(t) && gE.call(t, "callee") && !vE.call(t, "callee");
};
const Gd = yE;
function bE() {
  return !1;
}
var g4 = typeof exports == "object" && exports && !exports.nodeType && exports, Vy = g4 && typeof module == "object" && module && !module.nodeType && module, xE = Vy && Vy.exports === g4, Hy = xE ? Go.Buffer : void 0, wE = Hy ? Hy.isBuffer : void 0, jE = wE || bE;
const pu = jE;
var kE = "[object Arguments]", $E = "[object Array]", SE = "[object Boolean]", CE = "[object Date]", OE = "[object Error]", EE = "[object Function]", AE = "[object Map]", ME = "[object Number]", _E = "[object Object]", TE = "[object RegExp]", PE = "[object Set]", RE = "[object String]", NE = "[object WeakMap]", IE = "[object ArrayBuffer]", DE = "[object DataView]", LE = "[object Float32Array]", BE = "[object Float64Array]", qE = "[object Int8Array]", zE = "[object Int16Array]", FE = "[object Int32Array]", VE = "[object Uint8Array]", HE = "[object Uint8ClampedArray]", UE = "[object Uint16Array]", WE = "[object Uint32Array]", Kn = {};
Kn[LE] = Kn[BE] = Kn[qE] = Kn[zE] = Kn[FE] = Kn[VE] = Kn[HE] = Kn[UE] = Kn[WE] = !0;
Kn[kE] = Kn[$E] = Kn[IE] = Kn[SE] = Kn[DE] = Kn[CE] = Kn[OE] = Kn[EE] = Kn[AE] = Kn[ME] = Kn[_E] = Kn[TE] = Kn[PE] = Kn[RE] = Kn[NE] = !1;
function JE(t) {
  return zo(t) && h0(t.length) && !!Kn[nl(t)];
}
function m0(t) {
  return function(e) {
    return t(e);
  };
}
var v4 = typeof exports == "object" && exports && !exports.nodeType && exports, Qc = v4 && typeof module == "object" && module && !module.nodeType && module, KE = Qc && Qc.exports === v4, im = KE && c4.process, GE = function() {
  try {
    var t = Qc && Qc.require && Qc.require("util").types;
    return t || im && im.binding && im.binding("util");
  } catch {
  }
}();
const Ul = GE;
var Uy = Ul && Ul.isTypedArray, QE = Uy ? m0(Uy) : JE;
const g0 = QE;
var YE = Object.prototype, XE = YE.hasOwnProperty;
function y4(t, e) {
  var n = qi(t), r = !n && Gd(t), i = !n && !r && pu(t), o = !n && !r && !i && g0(t), s = n || r || i || o, a = s ? pE(t.length, String) : [], l = a.length;
  for (var c in t)
    (e || XE.call(t, c)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    d0(c, l))) && a.push(c);
  return a;
}
function b4(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var ZE = b4(Object.keys, Object);
const eA = ZE;
var tA = Object.prototype, nA = tA.hasOwnProperty;
function rA(t) {
  if (!p0(t))
    return eA(t);
  var e = [];
  for (var n in Object(t))
    nA.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
function Yu(t) {
  return np(t) ? y4(t) : rA(t);
}
function iA(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var oA = Object.prototype, sA = oA.hasOwnProperty;
function aA(t) {
  if (!Qo(t))
    return iA(t);
  var e = p0(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !sA.call(t, r)) || n.push(r);
  return n;
}
function hc(t) {
  return np(t) ? y4(t, !0) : aA(t);
}
var lA = p4(function(t, e, n, r) {
  dc(e, hc(e), t, r);
});
const cA = lA;
var uA = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, fA = /^\w*$/;
function v0(t, e) {
  if (qi(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || c0(t) ? !0 : fA.test(t) || !uA.test(t) || e != null && t in Object(e);
}
var dA = il(Object, "create");
const mu = dA;
function hA() {
  this.__data__ = mu ? mu(null) : {}, this.size = 0;
}
function pA(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var mA = "__lodash_hash_undefined__", gA = Object.prototype, vA = gA.hasOwnProperty;
function yA(t) {
  var e = this.__data__;
  if (mu) {
    var n = e[t];
    return n === mA ? void 0 : n;
  }
  return vA.call(e, t) ? e[t] : void 0;
}
var bA = Object.prototype, xA = bA.hasOwnProperty;
function wA(t) {
  var e = this.__data__;
  return mu ? e[t] !== void 0 : xA.call(e, t);
}
var jA = "__lodash_hash_undefined__";
function kA(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = mu && e === void 0 ? jA : e, this;
}
function La(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
La.prototype.clear = hA;
La.prototype.delete = pA;
La.prototype.get = yA;
La.prototype.has = wA;
La.prototype.set = kA;
function $A() {
  this.__data__ = [], this.size = 0;
}
function rp(t, e) {
  for (var n = t.length; n--; )
    if (Qu(t[n][0], e))
      return n;
  return -1;
}
var SA = Array.prototype, CA = SA.splice;
function OA(t) {
  var e = this.__data__, n = rp(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : CA.call(e, n, 1), --this.size, !0;
}
function EA(t) {
  var e = this.__data__, n = rp(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function AA(t) {
  return rp(this.__data__, t) > -1;
}
function MA(t, e) {
  var n = this.__data__, r = rp(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
function ws(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
ws.prototype.clear = $A;
ws.prototype.delete = OA;
ws.prototype.get = EA;
ws.prototype.has = AA;
ws.prototype.set = MA;
var _A = il(Go, "Map");
const gu = _A;
function TA() {
  this.size = 0, this.__data__ = {
    hash: new La(),
    map: new (gu || ws)(),
    string: new La()
  };
}
function PA(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function ip(t, e) {
  var n = t.__data__;
  return PA(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function RA(t) {
  var e = ip(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function NA(t) {
  return ip(this, t).get(t);
}
function IA(t) {
  return ip(this, t).has(t);
}
function DA(t, e) {
  var n = ip(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
function js(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
js.prototype.clear = TA;
js.prototype.delete = RA;
js.prototype.get = NA;
js.prototype.has = IA;
js.prototype.set = DA;
var LA = "Expected a function";
function y0(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(LA);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var s = t.apply(this, r);
    return n.cache = o.set(i, s) || o, s;
  };
  return n.cache = new (y0.Cache || js)(), n;
}
y0.Cache = js;
var BA = 500;
function qA(t) {
  var e = y0(t, function(r) {
    return n.size === BA && n.clear(), r;
  }), n = e.cache;
  return e;
}
var zA = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, FA = /\\(\\)?/g, VA = qA(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(zA, function(n, r, i, o) {
    e.push(i ? o.replace(FA, "$1") : r || n);
  }), e;
});
const HA = VA;
function UA(t) {
  return t == null ? "" : f4(t);
}
function x4(t, e) {
  return qi(t) ? t : v0(t, e) ? [t] : HA(UA(t));
}
var WA = 1 / 0;
function op(t) {
  if (typeof t == "string" || c0(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -WA ? "-0" : e;
}
function w4(t, e) {
  e = x4(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[op(e[n++])];
  return n && n == r ? t : void 0;
}
function JA(t, e, n) {
  var r = t == null ? void 0 : w4(t, e);
  return r === void 0 ? n : r;
}
function j4(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var KA = b4(Object.getPrototypeOf, Object);
const b0 = KA;
var GA = "[object Object]", QA = Function.prototype, YA = Object.prototype, k4 = QA.toString, XA = YA.hasOwnProperty, ZA = k4.call(Object);
function $4(t) {
  if (!zo(t) || nl(t) != GA)
    return !1;
  var e = b0(t);
  if (e === null)
    return !0;
  var n = XA.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && k4.call(n) == ZA;
}
function eM() {
  this.__data__ = new ws(), this.size = 0;
}
function tM(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
function nM(t) {
  return this.__data__.get(t);
}
function rM(t) {
  return this.__data__.has(t);
}
var iM = 200;
function oM(t, e) {
  var n = this.__data__;
  if (n instanceof ws) {
    var r = n.__data__;
    if (!gu || r.length < iM - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new js(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
function oo(t) {
  var e = this.__data__ = new ws(t);
  this.size = e.size;
}
oo.prototype.clear = eM;
oo.prototype.delete = tM;
oo.prototype.get = nM;
oo.prototype.has = rM;
oo.prototype.set = oM;
function sM(t, e) {
  return t && dc(e, Yu(e), t);
}
function aM(t, e) {
  return t && dc(e, hc(e), t);
}
var S4 = typeof exports == "object" && exports && !exports.nodeType && exports, Wy = S4 && typeof module == "object" && module && !module.nodeType && module, lM = Wy && Wy.exports === S4, Jy = lM ? Go.Buffer : void 0, Ky = Jy ? Jy.allocUnsafe : void 0;
function C4(t, e) {
  if (e)
    return t.slice();
  var n = t.length, r = Ky ? Ky(n) : new t.constructor(n);
  return t.copy(r), r;
}
function cM(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var s = t[n];
    e(s, n, t) && (o[i++] = s);
  }
  return o;
}
function O4() {
  return [];
}
var uM = Object.prototype, fM = uM.propertyIsEnumerable, Gy = Object.getOwnPropertySymbols, dM = Gy ? function(t) {
  return t == null ? [] : (t = Object(t), cM(Gy(t), function(e) {
    return fM.call(t, e);
  }));
} : O4;
const x0 = dM;
function hM(t, e) {
  return dc(t, x0(t), e);
}
var pM = Object.getOwnPropertySymbols, mM = pM ? function(t) {
  for (var e = []; t; )
    j4(e, x0(t)), t = b0(t);
  return e;
} : O4;
const E4 = mM;
function gM(t, e) {
  return dc(t, E4(t), e);
}
function A4(t, e, n) {
  var r = e(t);
  return qi(t) ? r : j4(r, n(t));
}
function lg(t) {
  return A4(t, Yu, x0);
}
function vM(t) {
  return A4(t, hc, E4);
}
var yM = il(Go, "DataView");
const cg = yM;
var bM = il(Go, "Promise");
const ug = bM;
var xM = il(Go, "Set");
const fg = xM;
var Qy = "[object Map]", wM = "[object Object]", Yy = "[object Promise]", Xy = "[object Set]", Zy = "[object WeakMap]", eb = "[object DataView]", jM = rl(cg), kM = rl(gu), $M = rl(ug), SM = rl(fg), CM = rl(ag), wa = nl;
(cg && wa(new cg(new ArrayBuffer(1))) != eb || gu && wa(new gu()) != Qy || ug && wa(ug.resolve()) != Yy || fg && wa(new fg()) != Xy || ag && wa(new ag()) != Zy) && (wa = function(t) {
  var e = nl(t), n = e == wM ? t.constructor : void 0, r = n ? rl(n) : "";
  if (r)
    switch (r) {
      case jM:
        return eb;
      case kM:
        return Qy;
      case $M:
        return Yy;
      case SM:
        return Xy;
      case CM:
        return Zy;
    }
  return e;
});
const vu = wa;
var OM = Object.prototype, EM = OM.hasOwnProperty;
function AM(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && EM.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var MM = Go.Uint8Array;
const Qd = MM;
function w0(t) {
  var e = new t.constructor(t.byteLength);
  return new Qd(e).set(new Qd(t)), e;
}
function _M(t, e) {
  var n = e ? w0(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var TM = /\w*$/;
function PM(t) {
  var e = new t.constructor(t.source, TM.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var tb = qo ? qo.prototype : void 0, nb = tb ? tb.valueOf : void 0;
function RM(t) {
  return nb ? Object(nb.call(t)) : {};
}
function M4(t, e) {
  var n = e ? w0(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var NM = "[object Boolean]", IM = "[object Date]", DM = "[object Map]", LM = "[object Number]", BM = "[object RegExp]", qM = "[object Set]", zM = "[object String]", FM = "[object Symbol]", VM = "[object ArrayBuffer]", HM = "[object DataView]", UM = "[object Float32Array]", WM = "[object Float64Array]", JM = "[object Int8Array]", KM = "[object Int16Array]", GM = "[object Int32Array]", QM = "[object Uint8Array]", YM = "[object Uint8ClampedArray]", XM = "[object Uint16Array]", ZM = "[object Uint32Array]";
function e_(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case VM:
      return w0(t);
    case NM:
    case IM:
      return new r(+t);
    case HM:
      return _M(t, n);
    case UM:
    case WM:
    case JM:
    case KM:
    case GM:
    case QM:
    case YM:
    case XM:
    case ZM:
      return M4(t, n);
    case DM:
      return new r();
    case LM:
    case zM:
      return new r(t);
    case BM:
      return PM(t);
    case qM:
      return new r();
    case FM:
      return RM(t);
  }
}
function _4(t) {
  return typeof t.constructor == "function" && !p0(t) ? WO(b0(t)) : {};
}
var t_ = "[object Map]";
function n_(t) {
  return zo(t) && vu(t) == t_;
}
var rb = Ul && Ul.isMap, r_ = rb ? m0(rb) : n_;
const i_ = r_;
var o_ = "[object Set]";
function s_(t) {
  return zo(t) && vu(t) == o_;
}
var ib = Ul && Ul.isSet, a_ = ib ? m0(ib) : s_;
const l_ = a_;
var c_ = 1, u_ = 2, f_ = 4, T4 = "[object Arguments]", d_ = "[object Array]", h_ = "[object Boolean]", p_ = "[object Date]", m_ = "[object Error]", P4 = "[object Function]", g_ = "[object GeneratorFunction]", v_ = "[object Map]", y_ = "[object Number]", R4 = "[object Object]", b_ = "[object RegExp]", x_ = "[object Set]", w_ = "[object String]", j_ = "[object Symbol]", k_ = "[object WeakMap]", $_ = "[object ArrayBuffer]", S_ = "[object DataView]", C_ = "[object Float32Array]", O_ = "[object Float64Array]", E_ = "[object Int8Array]", A_ = "[object Int16Array]", M_ = "[object Int32Array]", __ = "[object Uint8Array]", T_ = "[object Uint8ClampedArray]", P_ = "[object Uint16Array]", R_ = "[object Uint32Array]", Fn = {};
Fn[T4] = Fn[d_] = Fn[$_] = Fn[S_] = Fn[h_] = Fn[p_] = Fn[C_] = Fn[O_] = Fn[E_] = Fn[A_] = Fn[M_] = Fn[v_] = Fn[y_] = Fn[R4] = Fn[b_] = Fn[x_] = Fn[w_] = Fn[j_] = Fn[__] = Fn[T_] = Fn[P_] = Fn[R_] = !0;
Fn[m_] = Fn[P4] = Fn[k_] = !1;
function Cd(t, e, n, r, i, o) {
  var s, a = e & c_, l = e & u_, c = e & f_;
  if (n && (s = i ? n(t, r, i, o) : n(t)), s !== void 0)
    return s;
  if (!Qo(t))
    return t;
  var u = qi(t);
  if (u) {
    if (s = AM(t), !a)
      return d4(t, s);
  } else {
    var f = vu(t), d = f == P4 || f == g_;
    if (pu(t))
      return C4(t, a);
    if (f == R4 || f == T4 || d && !i) {
      if (s = l || d ? {} : _4(t), !a)
        return l ? gM(t, aM(s, t)) : hM(t, sM(s, t));
    } else {
      if (!Fn[f])
        return i ? t : {};
      s = e_(t, f, a);
    }
  }
  o || (o = new oo());
  var h = o.get(t);
  if (h)
    return h;
  o.set(t, s), l_(t) ? t.forEach(function(g) {
    s.add(Cd(g, e, n, g, t, o));
  }) : i_(t) && t.forEach(function(g, v) {
    s.set(v, Cd(g, e, n, v, t, o));
  });
  var p = c ? l ? vM : lg : l ? hc : Yu, m = u ? void 0 : p(t);
  return iE(m || t, function(g, v) {
    m && (v = g, g = t[v]), h4(s, v, Cd(g, e, n, v, t, o));
  }), s;
}
var N_ = 1, I_ = 4;
function D_(t) {
  return Cd(t, N_ | I_);
}
var L_ = "__lodash_hash_undefined__";
function B_(t) {
  return this.__data__.set(t, L_), this;
}
function q_(t) {
  return this.__data__.has(t);
}
function Yd(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new js(); ++e < n; )
    this.add(t[e]);
}
Yd.prototype.add = Yd.prototype.push = B_;
Yd.prototype.has = q_;
function z_(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
function F_(t, e) {
  return t.has(e);
}
var V_ = 1, H_ = 2;
function N4(t, e, n, r, i, o) {
  var s = n & V_, a = t.length, l = e.length;
  if (a != l && !(s && l > a))
    return !1;
  var c = o.get(t), u = o.get(e);
  if (c && u)
    return c == e && u == t;
  var f = -1, d = !0, h = n & H_ ? new Yd() : void 0;
  for (o.set(t, e), o.set(e, t); ++f < a; ) {
    var p = t[f], m = e[f];
    if (r)
      var g = s ? r(m, p, f, e, t, o) : r(p, m, f, t, e, o);
    if (g !== void 0) {
      if (g)
        continue;
      d = !1;
      break;
    }
    if (h) {
      if (!z_(e, function(v, y) {
        if (!F_(h, y) && (p === v || i(p, v, n, r, o)))
          return h.push(y);
      })) {
        d = !1;
        break;
      }
    } else if (!(p === m || i(p, m, n, r, o))) {
      d = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), d;
}
function U_(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
function W_(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var J_ = 1, K_ = 2, G_ = "[object Boolean]", Q_ = "[object Date]", Y_ = "[object Error]", X_ = "[object Map]", Z_ = "[object Number]", eT = "[object RegExp]", tT = "[object Set]", nT = "[object String]", rT = "[object Symbol]", iT = "[object ArrayBuffer]", oT = "[object DataView]", ob = qo ? qo.prototype : void 0, om = ob ? ob.valueOf : void 0;
function sT(t, e, n, r, i, o, s) {
  switch (n) {
    case oT:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case iT:
      return !(t.byteLength != e.byteLength || !o(new Qd(t), new Qd(e)));
    case G_:
    case Q_:
    case Z_:
      return Qu(+t, +e);
    case Y_:
      return t.name == e.name && t.message == e.message;
    case eT:
    case nT:
      return t == e + "";
    case X_:
      var a = U_;
    case tT:
      var l = r & J_;
      if (a || (a = W_), t.size != e.size && !l)
        return !1;
      var c = s.get(t);
      if (c)
        return c == e;
      r |= K_, s.set(t, e);
      var u = N4(a(t), a(e), r, i, o, s);
      return s.delete(t), u;
    case rT:
      if (om)
        return om.call(t) == om.call(e);
  }
  return !1;
}
var aT = 1, lT = Object.prototype, cT = lT.hasOwnProperty;
function uT(t, e, n, r, i, o) {
  var s = n & aT, a = lg(t), l = a.length, c = lg(e), u = c.length;
  if (l != u && !s)
    return !1;
  for (var f = l; f--; ) {
    var d = a[f];
    if (!(s ? d in e : cT.call(e, d)))
      return !1;
  }
  var h = o.get(t), p = o.get(e);
  if (h && p)
    return h == e && p == t;
  var m = !0;
  o.set(t, e), o.set(e, t);
  for (var g = s; ++f < l; ) {
    d = a[f];
    var v = t[d], y = e[d];
    if (r)
      var w = s ? r(y, v, d, e, t, o) : r(v, y, d, t, e, o);
    if (!(w === void 0 ? v === y || i(v, y, n, r, o) : w)) {
      m = !1;
      break;
    }
    g || (g = d == "constructor");
  }
  if (m && !g) {
    var x = t.constructor, b = e.constructor;
    x != b && "constructor" in t && "constructor" in e && !(typeof x == "function" && x instanceof x && typeof b == "function" && b instanceof b) && (m = !1);
  }
  return o.delete(t), o.delete(e), m;
}
var fT = 1, sb = "[object Arguments]", ab = "[object Array]", kf = "[object Object]", dT = Object.prototype, lb = dT.hasOwnProperty;
function hT(t, e, n, r, i, o) {
  var s = qi(t), a = qi(e), l = s ? ab : vu(t), c = a ? ab : vu(e);
  l = l == sb ? kf : l, c = c == sb ? kf : c;
  var u = l == kf, f = c == kf, d = l == c;
  if (d && pu(t)) {
    if (!pu(e))
      return !1;
    s = !0, u = !1;
  }
  if (d && !u)
    return o || (o = new oo()), s || g0(t) ? N4(t, e, n, r, i, o) : sT(t, e, l, n, r, i, o);
  if (!(n & fT)) {
    var h = u && lb.call(t, "__wrapped__"), p = f && lb.call(e, "__wrapped__");
    if (h || p) {
      var m = h ? t.value() : t, g = p ? e.value() : e;
      return o || (o = new oo()), i(m, g, n, r, o);
    }
  }
  return d ? (o || (o = new oo()), uT(t, e, n, r, i, o)) : !1;
}
function j0(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !zo(t) && !zo(e) ? t !== t && e !== e : hT(t, e, n, r, j0, i);
}
var pT = 1, mT = 2;
function gT(t, e, n, r) {
  var i = n.length, o = i, s = !r;
  if (t == null)
    return !o;
  for (t = Object(t); i--; ) {
    var a = n[i];
    if (s && a[2] ? a[1] !== t[a[0]] : !(a[0] in t))
      return !1;
  }
  for (; ++i < o; ) {
    a = n[i];
    var l = a[0], c = t[l], u = a[1];
    if (s && a[2]) {
      if (c === void 0 && !(l in t))
        return !1;
    } else {
      var f = new oo();
      if (r)
        var d = r(c, u, l, t, e, f);
      if (!(d === void 0 ? j0(u, c, pT | mT, r, f) : d))
        return !1;
    }
  }
  return !0;
}
function I4(t) {
  return t === t && !Qo(t);
}
function vT(t) {
  for (var e = Yu(t), n = e.length; n--; ) {
    var r = e[n], i = t[r];
    e[n] = [r, i, I4(i)];
  }
  return e;
}
function D4(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
function yT(t) {
  var e = vT(t);
  return e.length == 1 && e[0][2] ? D4(e[0][0], e[0][1]) : function(n) {
    return n === t || gT(n, t, e);
  };
}
function bT(t, e) {
  return t != null && e in Object(t);
}
function xT(t, e, n) {
  e = x4(e, t);
  for (var r = -1, i = e.length, o = !1; ++r < i; ) {
    var s = op(e[r]);
    if (!(o = t != null && n(t, s)))
      break;
    t = t[s];
  }
  return o || ++r != i ? o : (i = t == null ? 0 : t.length, !!i && h0(i) && d0(s, i) && (qi(t) || Gd(t)));
}
function wT(t, e) {
  return t != null && xT(t, e, bT);
}
var jT = 1, kT = 2;
function $T(t, e) {
  return v0(t) && I4(e) ? D4(op(t), e) : function(n) {
    var r = JA(n, t);
    return r === void 0 && r === e ? wT(n, t) : j0(e, r, jT | kT);
  };
}
function ST(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
function CT(t) {
  return function(e) {
    return w4(e, t);
  };
}
function OT(t) {
  return v0(t) ? ST(op(t)) : CT(t);
}
function ET(t) {
  return typeof t == "function" ? t : t == null ? u0 : typeof t == "object" ? qi(t) ? $T(t[0], t[1]) : yT(t) : OT(t);
}
function AT(t) {
  return function(e, n, r) {
    for (var i = -1, o = Object(e), s = r(e), a = s.length; a--; ) {
      var l = s[t ? a : ++i];
      if (n(o[l], l, o) === !1)
        break;
    }
    return e;
  };
}
var MT = AT();
const L4 = MT;
function _T(t, e) {
  return t && L4(t, e, Yu);
}
function dg(t, e, n) {
  (n !== void 0 && !Qu(t[e], n) || n === void 0 && !(e in t)) && tp(t, e, n);
}
function TT(t) {
  return zo(t) && np(t);
}
function hg(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
function PT(t) {
  return dc(t, hc(t));
}
function RT(t, e, n, r, i, o, s) {
  var a = hg(t, n), l = hg(e, n), c = s.get(l);
  if (c) {
    dg(t, n, c);
    return;
  }
  var u = o ? o(a, l, n + "", t, e, s) : void 0, f = u === void 0;
  if (f) {
    var d = qi(l), h = !d && pu(l), p = !d && !h && g0(l);
    u = l, d || h || p ? qi(a) ? u = a : TT(a) ? u = d4(a) : h ? (f = !1, u = C4(l, !0)) : p ? (f = !1, u = M4(l, !0)) : u = [] : $4(l) || Gd(l) ? (u = a, Gd(a) ? u = PT(a) : (!Qo(a) || f0(a)) && (u = _4(l))) : f = !1;
  }
  f && (s.set(l, u), i(u, l, r, o, s), s.delete(l)), dg(t, n, u);
}
function B4(t, e, n, r, i) {
  t !== e && L4(e, function(o, s) {
    if (i || (i = new oo()), Qo(o))
      RT(t, e, s, n, B4, r, i);
    else {
      var a = r ? r(hg(t, s), o, s + "", t, e, i) : void 0;
      a === void 0 && (a = o), dg(t, s, a);
    }
  }, hc);
}
var NT = p4(function(t, e, n, r) {
  B4(t, e, n, r);
});
const IT = NT;
function DT(t, e) {
  var n = {};
  return e = ET(e), _T(t, function(r, i, o) {
    tp(n, e(r, i, o), r);
  }), n;
}
const LT = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), BT = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), qT = new RegExp("(\\d)(\\p{Ll})", "gu"), zT = new RegExp("(\\p{L})(\\d)", "gu"), FT = /[^\p{L}\d]+/giu, $f = "$1\0$2", cb = "";
function VT(t, e) {
  let n = t.trim();
  n = n.replace(LT, $f).replace(BT, $f), e != null && e.separateNumbers && (n = n.replace(qT, $f).replace(zT, $f)), n = n.replace(FT, "\0");
  let r = 0, i = n.length;
  for (; n.charAt(r) === "\0"; )
    r++;
  if (r === i)
    return [];
  for (; n.charAt(i - 1) === "\0"; )
    i--;
  return n.slice(r, i).split(/\0/g);
}
function HT(t, e) {
  const [n, r, i] = GT(t, e), o = UT(e == null ? void 0 : e.locale), s = WT(e == null ? void 0 : e.locale), a = e != null && e.mergeAmbiguousCharacters ? JT(o, s) : KT(o, s);
  return n + VT(r, e).map((l, c) => c === 0 ? o(l) : a(l, c)).join((e == null ? void 0 : e.delimiter) ?? "") + i;
}
function UT(t) {
  return t === !1 ? (e) => e.toLowerCase() : (e) => e.toLocaleLowerCase(t);
}
function WT(t) {
  return t === !1 ? (e) => e.toUpperCase() : (e) => e.toLocaleUpperCase(t);
}
function JT(t, e) {
  return (n) => `${e(n[0])}${t(n.slice(1))}`;
}
function KT(t, e) {
  return (n, r) => {
    const i = n[0];
    return (r > 0 && i >= "0" && i <= "9" ? "_" + i : e(i)) + t(n.slice(1));
  };
}
function GT(t, e) {
  const n = (e == null ? void 0 : e.prefixCharacters) ?? cb, r = (e == null ? void 0 : e.suffixCharacters) ?? cb;
  let i = 0, o = t.length;
  for (; i < t.length; ) {
    const s = t.charAt(i);
    if (!n.includes(s))
      break;
    i++;
  }
  for (; o > i; ) {
    const s = o - 1, a = t.charAt(s);
    if (!r.includes(a))
      break;
    o = s;
  }
  return [
    t.slice(0, i),
    t.slice(i, o),
    t.slice(o)
  ];
}
const Yc = (t) => /.+-.+/.test(t) ? HT(t) : t;
function QT(t, e) {
  const n = /* @__PURE__ */ Object.create(null), r = t.split(",");
  for (let i = 0; i < r.length; i++)
    n[r[i]] = !0;
  return e ? (i) => !!n[i.toLowerCase()] : (i) => !!n[i];
}
const YT = /* @__PURE__ */ QT("String,Number,Boolean,Function,Symbol,BigInt");
function XT(t) {
  const e = t == null ? void 0 : t.toString().match(/^\s*function (\w+)/);
  return e ? e[1] : t === null ? "null" : "";
}
function ZT(t, e) {
  let n;
  const r = XT(e);
  if (YT(r)) {
    const i = typeof t;
    n = i === r.toLowerCase(), !n && i === "object" && (n = t instanceof e);
  } else
    r === "Object" ? n = Qo(t) : r === "Array" ? n = Array.isArray(t) : r === "null" ? n = t === null : n = t instanceof e;
  return {
    valid: n,
    expectedType: r
  };
}
function eP({
  prop: t,
  type: e,
  validator: n
}) {
  if (![void 0, null].includes(t) && e) {
    let r = !1;
    const i = Array.isArray(e) ? e : [e], o = [];
    for (let s = 0; s < i.length && !r; s++) {
      const { valid: a, expectedType: l } = ZT(t, i[s]);
      o.push(l || ""), r = a;
    }
    if (!r)
      throw new TypeError(
        `Invalid prop: type check failed, expecting [${o.join(
          ", "
        )}], receiving: ${t}`
      );
  }
  if (n && !n(t))
    throw new Error(`Invalid prop: validator check failed, receiving: ${t}`);
}
function tP(t, {
  mergeObject: e,
  mergeFunction: n
}) {
  const r = [];
  for (let o = t.length - 1; o >= 0; o--)
    r.push(t[o]);
  const i = n ? (o, s) => typeof o == "function" && typeof s == "function" ? n(s, o) : void 0 : void 0;
  return e === "deep" ? IT(...r, i) : cA(...r, i);
}
function nP(t, {
  mergeFunction: e
}) {
  return t.reduce(e, () => {
  });
}
function gl(t, e = {}) {
  const {
    type: n,
    default: r,
    defaultIsDynamic: i = !1,
    required: o = !1,
    validator: s,
    camelizeObjectKeys: a = !1,
    mergeObjectApplyOnlyToDefault: l = !1,
    mergeFunctionApplyOnlyToDefault: c = !0
  } = e;
  let { mergeObject: u = "deep", mergeFunction: f = !1 } = e;
  const d = [];
  let h, p = !1, m = !1;
  const g = (v) => {
    if (v !== void 0) {
      eP({ type: n, prop: v, validator: s });
      const y = $4(v), w = typeof v == "function";
      return p = y, m = w, y ? (v = D_(v), a ? DT(v, (x, b) => Yc(b)) : v) : v;
    }
  };
  for (const v of t)
    d.push(g(v));
  if (!i)
    d.push(g(r));
  else if (typeof r != "function")
    throw new TypeError(
      `Invalid option: options.default should be Function when options.defaultIsDynamic enabled, receiving: ${r}`
    );
  p || (u = !1, m || (f = !1));
  for (let v = 0; v < d.length; v++) {
    const y = d[v];
    if (y !== void 0) {
      v === d.length - 1 ? h = y : u ? h = tP(
        l ? [y, r] : d,
        {
          mergeObject: u,
          mergeFunction: f
        }
      ) : f ? h = nP(
        c ? [y, r] : d,
        {
          mergeFunction: f
        }
      ) : h = y;
      break;
    }
  }
  if (o && [void 0, null].includes(h))
    throw new Error("Missing required prop");
  return i ? gl(t, {
    ...e,
    default: r(h),
    defaultIsDynamic: !1
  }) : h;
}
function sm(t) {
  const e = Array.from(Yc(t));
  return e[0] = e[0].toUpperCase(), e.unshift("o", "n"), e.join("");
}
function rP(t, {
  props: e = [],
  camelizePropNames: n = !1
} = {}) {
  const r = {
    props: {},
    attrs: {},
    listeners: {},
    hooks: {},
    slots: {}
  };
  let i;
  if (Array.isArray(e))
    i = n ? e.map((o) => Yc(o)) : e;
  else if (n) {
    i = [];
    for (const o in e)
      i.push(Yc(o));
  } else
    i = Object.keys(e);
  for (const o in t)
    if (o.startsWith("@")) {
      const s = o.substring(1);
      l0 ? s.startsWith("vue:") ? r.hooks[sm(s.replace("vue:", "vnode-"))] = t[o] : s.startsWith("vnode") ? r.hooks[sm(s)] = t[o] : r.listeners[sm(s)] = t[o] : s.startsWith("hook:") ? r.hooks[s] = t[o] : r.listeners[s] = t[o];
    } else if (o.startsWith("#")) {
      const s = o.substring(1);
      s && (r.slots[s] = t[o]);
    } else {
      const s = n ? Yc(o) : o;
      i.includes(s) ? r.props[s] = t[o] : r.attrs[o] = t[o];
    }
  return r;
}
var iP = typeof global == "object" && global && global.Object === Object && global;
const q4 = iP;
var oP = typeof self == "object" && self && self.Object === Object && self, sP = q4 || oP || Function("return this")();
const mo = sP;
var aP = mo.Symbol;
const zi = aP;
var z4 = Object.prototype, lP = z4.hasOwnProperty, cP = z4.toString, Ac = zi ? zi.toStringTag : void 0;
function uP(t) {
  var e = lP.call(t, Ac), n = t[Ac];
  try {
    t[Ac] = void 0;
    var r = !0;
  } catch {
  }
  var i = cP.call(t);
  return r && (e ? t[Ac] = n : delete t[Ac]), i;
}
var fP = Object.prototype, dP = fP.toString;
function hP(t) {
  return dP.call(t);
}
var pP = "[object Null]", mP = "[object Undefined]", ub = zi ? zi.toStringTag : void 0;
function pc(t) {
  return t == null ? t === void 0 ? mP : pP : ub && ub in Object(t) ? uP(t) : hP(t);
}
function Xs(t) {
  return t != null && typeof t == "object";
}
var gP = "[object Symbol]";
function Ba(t) {
  return typeof t == "symbol" || Xs(t) && pc(t) == gP;
}
function Xc(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = Array(r); ++n < r; )
    i[n] = e(t[n], n, t);
  return i;
}
var vP = Array.isArray;
const Xr = vP;
var yP = 1 / 0, fb = zi ? zi.prototype : void 0, db = fb ? fb.toString : void 0;
function F4(t) {
  if (typeof t == "string")
    return t;
  if (Xr(t))
    return Xc(t, F4) + "";
  if (Ba(t))
    return db ? db.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -yP ? "-0" : e;
}
var bP = /\s/;
function xP(t) {
  for (var e = t.length; e-- && bP.test(t.charAt(e)); )
    ;
  return e;
}
var wP = /^\s+/;
function jP(t) {
  return t && t.slice(0, xP(t) + 1).replace(wP, "");
}
function co(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var hb = NaN, kP = /^[-+]0x[0-9a-f]+$/i, $P = /^0b[01]+$/i, SP = /^0o[0-7]+$/i, CP = parseInt;
function pg(t) {
  if (typeof t == "number")
    return t;
  if (Ba(t))
    return hb;
  if (co(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = co(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = jP(t);
  var n = $P.test(t);
  return n || SP.test(t) ? CP(t.slice(2), n ? 2 : 8) : kP.test(t) ? hb : +t;
}
var pb = 1 / 0, OP = 17976931348623157e292;
function Od(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = pg(t), t === pb || t === -pb) {
    var e = t < 0 ? -1 : 1;
    return e * OP;
  }
  return t === t ? t : 0;
}
function EP(t) {
  var e = Od(t), n = e % 1;
  return e === e ? n ? e - n : e : 0;
}
function Xu(t) {
  return t;
}
var AP = "[object AsyncFunction]", MP = "[object Function]", _P = "[object GeneratorFunction]", TP = "[object Proxy]";
function V4(t) {
  if (!co(t))
    return !1;
  var e = pc(t);
  return e == MP || e == _P || e == AP || e == TP;
}
var PP = mo["__core-js_shared__"];
const am = PP;
var mb = function() {
  var t = /[^.]+$/.exec(am && am.keys && am.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function RP(t) {
  return !!mb && mb in t;
}
var NP = Function.prototype, IP = NP.toString;
function ol(t) {
  if (t != null) {
    try {
      return IP.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var DP = /[\\^$.*+?()[\]{}|]/g, LP = /^\[object .+?Constructor\]$/, BP = Function.prototype, qP = Object.prototype, zP = BP.toString, FP = qP.hasOwnProperty, VP = RegExp(
  "^" + zP.call(FP).replace(DP, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function HP(t) {
  if (!co(t) || RP(t))
    return !1;
  var e = V4(t) ? VP : LP;
  return e.test(ol(t));
}
function UP(t, e) {
  return t == null ? void 0 : t[e];
}
function sl(t, e) {
  var n = UP(t, e);
  return HP(n) ? n : void 0;
}
var WP = sl(mo, "WeakMap");
const mg = WP;
var gb = Object.create, JP = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!co(e))
      return {};
    if (gb)
      return gb(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}();
const KP = JP;
function GP(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
function nr() {
}
function QP(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var YP = 800, XP = 16, ZP = Date.now;
function e7(t) {
  var e = 0, n = 0;
  return function() {
    var r = ZP(), i = XP - (r - n);
    if (n = r, i > 0) {
      if (++e >= YP)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
function t7(t) {
  return function() {
    return t;
  };
}
var n7 = function() {
  try {
    var t = sl(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
const Xd = n7;
var r7 = Xd ? function(t, e) {
  return Xd(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: t7(e),
    writable: !0
  });
} : Xu;
const i7 = r7;
var o7 = e7(i7);
const s7 = o7;
function a7(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var l7 = 9007199254740991, c7 = /^(?:0|[1-9]\d*)$/;
function k0(t, e) {
  var n = typeof t;
  return e = e ?? l7, !!e && (n == "number" || n != "symbol" && c7.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function sp(t, e, n) {
  e == "__proto__" && Xd ? Xd(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
function ap(t, e) {
  return t === e || t !== t && e !== e;
}
var u7 = Object.prototype, f7 = u7.hasOwnProperty;
function H4(t, e, n) {
  var r = t[e];
  (!(f7.call(t, e) && ap(r, n)) || n === void 0 && !(e in t)) && sp(t, e, n);
}
function lp(t, e, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, s = e.length; ++o < s; ) {
    var a = e[o], l = r ? r(n[a], t[a], a, n, t) : void 0;
    l === void 0 && (l = t[a]), i ? sp(n, a, l) : H4(n, a, l);
  }
  return n;
}
var vb = Math.max;
function d7(t, e, n) {
  return e = vb(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, i = -1, o = vb(r.length - e, 0), s = Array(o); ++i < o; )
      s[i] = r[e + i];
    i = -1;
    for (var a = Array(e + 1); ++i < e; )
      a[i] = r[i];
    return a[e] = n(s), GP(t, this, a);
  };
}
function h7(t, e) {
  return s7(d7(t, e, Xu), t + "");
}
var p7 = 9007199254740991;
function $0(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= p7;
}
function mc(t) {
  return t != null && $0(t.length) && !V4(t);
}
function gg(t, e, n) {
  if (!co(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? mc(n) && k0(e, n.length) : r == "string" && e in n) ? ap(n[e], t) : !1;
}
var m7 = Object.prototype;
function cp(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || m7;
  return t === n;
}
function U4(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var g7 = "[object Arguments]";
function yb(t) {
  return Xs(t) && pc(t) == g7;
}
var W4 = Object.prototype, v7 = W4.hasOwnProperty, y7 = W4.propertyIsEnumerable, b7 = yb(/* @__PURE__ */ function() {
  return arguments;
}()) ? yb : function(t) {
  return Xs(t) && v7.call(t, "callee") && !y7.call(t, "callee");
};
const up = b7;
function x7() {
  return !1;
}
var J4 = typeof exports == "object" && exports && !exports.nodeType && exports, bb = J4 && typeof module == "object" && module && !module.nodeType && module, w7 = bb && bb.exports === J4, xb = w7 ? mo.Buffer : void 0, j7 = xb ? xb.isBuffer : void 0, k7 = j7 || x7;
const yu = k7;
var $7 = "[object Arguments]", S7 = "[object Array]", C7 = "[object Boolean]", O7 = "[object Date]", E7 = "[object Error]", A7 = "[object Function]", M7 = "[object Map]", _7 = "[object Number]", T7 = "[object Object]", P7 = "[object RegExp]", R7 = "[object Set]", N7 = "[object String]", I7 = "[object WeakMap]", D7 = "[object ArrayBuffer]", L7 = "[object DataView]", B7 = "[object Float32Array]", q7 = "[object Float64Array]", z7 = "[object Int8Array]", F7 = "[object Int16Array]", V7 = "[object Int32Array]", H7 = "[object Uint8Array]", U7 = "[object Uint8ClampedArray]", W7 = "[object Uint16Array]", J7 = "[object Uint32Array]", Gn = {};
Gn[B7] = Gn[q7] = Gn[z7] = Gn[F7] = Gn[V7] = Gn[H7] = Gn[U7] = Gn[W7] = Gn[J7] = !0;
Gn[$7] = Gn[S7] = Gn[D7] = Gn[C7] = Gn[L7] = Gn[O7] = Gn[E7] = Gn[A7] = Gn[M7] = Gn[_7] = Gn[T7] = Gn[P7] = Gn[R7] = Gn[N7] = Gn[I7] = !1;
function K7(t) {
  return Xs(t) && $0(t.length) && !!Gn[pc(t)];
}
function fp(t) {
  return function(e) {
    return t(e);
  };
}
var K4 = typeof exports == "object" && exports && !exports.nodeType && exports, Zc = K4 && typeof module == "object" && module && !module.nodeType && module, G7 = Zc && Zc.exports === K4, lm = G7 && q4.process, Q7 = function() {
  try {
    var t = Zc && Zc.require && Zc.require("util").types;
    return t || lm && lm.binding && lm.binding("util");
  } catch {
  }
}();
const Wl = Q7;
var wb = Wl && Wl.isTypedArray, Y7 = wb ? fp(wb) : K7;
const S0 = Y7;
var X7 = Object.prototype, Z7 = X7.hasOwnProperty;
function G4(t, e) {
  var n = Xr(t), r = !n && up(t), i = !n && !r && yu(t), o = !n && !r && !i && S0(t), s = n || r || i || o, a = s ? U4(t.length, String) : [], l = a.length;
  for (var c in t)
    (e || Z7.call(t, c)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    k0(c, l))) && a.push(c);
  return a;
}
function Q4(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var eR = Q4(Object.keys, Object);
const tR = eR;
var nR = Object.prototype, rR = nR.hasOwnProperty;
function Y4(t) {
  if (!cp(t))
    return tR(t);
  var e = [];
  for (var n in Object(t))
    rR.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
function gc(t) {
  return mc(t) ? G4(t) : Y4(t);
}
function iR(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var oR = Object.prototype, sR = oR.hasOwnProperty;
function aR(t) {
  if (!co(t))
    return iR(t);
  var e = cp(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !sR.call(t, r)) || n.push(r);
  return n;
}
function C0(t) {
  return mc(t) ? G4(t, !0) : aR(t);
}
var lR = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, cR = /^\w*$/;
function O0(t, e) {
  if (Xr(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || Ba(t) ? !0 : cR.test(t) || !lR.test(t) || e != null && t in Object(e);
}
var uR = sl(Object, "create");
const bu = uR;
function fR() {
  this.__data__ = bu ? bu(null) : {}, this.size = 0;
}
function dR(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var hR = "__lodash_hash_undefined__", pR = Object.prototype, mR = pR.hasOwnProperty;
function gR(t) {
  var e = this.__data__;
  if (bu) {
    var n = e[t];
    return n === hR ? void 0 : n;
  }
  return mR.call(e, t) ? e[t] : void 0;
}
var vR = Object.prototype, yR = vR.hasOwnProperty;
function bR(t) {
  var e = this.__data__;
  return bu ? e[t] !== void 0 : yR.call(e, t);
}
var xR = "__lodash_hash_undefined__";
function wR(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = bu && e === void 0 ? xR : e, this;
}
function qa(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
qa.prototype.clear = fR;
qa.prototype.delete = dR;
qa.prototype.get = gR;
qa.prototype.has = bR;
qa.prototype.set = wR;
function jR() {
  this.__data__ = [], this.size = 0;
}
function dp(t, e) {
  for (var n = t.length; n--; )
    if (ap(t[n][0], e))
      return n;
  return -1;
}
var kR = Array.prototype, $R = kR.splice;
function SR(t) {
  var e = this.__data__, n = dp(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : $R.call(e, n, 1), --this.size, !0;
}
function CR(t) {
  var e = this.__data__, n = dp(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function OR(t) {
  return dp(this.__data__, t) > -1;
}
function ER(t, e) {
  var n = this.__data__, r = dp(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
function ks(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
ks.prototype.clear = jR;
ks.prototype.delete = SR;
ks.prototype.get = CR;
ks.prototype.has = OR;
ks.prototype.set = ER;
var AR = sl(mo, "Map");
const xu = AR;
function MR() {
  this.size = 0, this.__data__ = {
    hash: new qa(),
    map: new (xu || ks)(),
    string: new qa()
  };
}
function _R(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function hp(t, e) {
  var n = t.__data__;
  return _R(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function TR(t) {
  var e = hp(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function PR(t) {
  return hp(this, t).get(t);
}
function RR(t) {
  return hp(this, t).has(t);
}
function NR(t, e) {
  var n = hp(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
function $s(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
$s.prototype.clear = MR;
$s.prototype.delete = TR;
$s.prototype.get = PR;
$s.prototype.has = RR;
$s.prototype.set = NR;
var IR = "Expected a function";
function pp(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(IR);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var s = t.apply(this, r);
    return n.cache = o.set(i, s) || o, s;
  };
  return n.cache = new (pp.Cache || $s)(), n;
}
pp.Cache = $s;
var DR = 500;
function LR(t) {
  var e = pp(t, function(r) {
    return n.size === DR && n.clear(), r;
  }), n = e.cache;
  return e;
}
var BR = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, qR = /\\(\\)?/g, zR = LR(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(BR, function(n, r, i, o) {
    e.push(i ? o.replace(qR, "$1") : r || n);
  }), e;
});
const FR = zR;
function X4(t) {
  return t == null ? "" : F4(t);
}
function Z4(t, e) {
  return Xr(t) ? t : O0(t, e) ? [t] : FR(X4(t));
}
var VR = 1 / 0;
function mp(t) {
  if (typeof t == "string" || Ba(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -VR ? "-0" : e;
}
function E0(t, e) {
  e = Z4(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[mp(e[n++])];
  return n && n == r ? t : void 0;
}
function HR(t, e, n) {
  var r = t == null ? void 0 : E0(t, e);
  return r === void 0 ? n : r;
}
function A0(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var jb = zi ? zi.isConcatSpreadable : void 0;
function UR(t) {
  return Xr(t) || up(t) || !!(jb && t && t[jb]);
}
function eS(t, e, n, r, i) {
  var o = -1, s = t.length;
  for (n || (n = UR), i || (i = []); ++o < s; ) {
    var a = t[o];
    e > 0 && n(a) ? e > 1 ? eS(a, e - 1, n, r, i) : A0(i, a) : r || (i[i.length] = a);
  }
  return i;
}
var WR = Q4(Object.getPrototypeOf, Object);
const tS = WR;
function JR(t, e, n) {
  var r = -1, i = t.length;
  e < 0 && (e = -e > i ? 0 : i + e), n = n > i ? i : n, n < 0 && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = t[r + e];
  return o;
}
function KR() {
  this.__data__ = new ks(), this.size = 0;
}
function GR(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
function QR(t) {
  return this.__data__.get(t);
}
function YR(t) {
  return this.__data__.has(t);
}
var XR = 200;
function ZR(t, e) {
  var n = this.__data__;
  if (n instanceof ks) {
    var r = n.__data__;
    if (!xu || r.length < XR - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new $s(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
function Io(t) {
  var e = this.__data__ = new ks(t);
  this.size = e.size;
}
Io.prototype.clear = KR;
Io.prototype.delete = GR;
Io.prototype.get = QR;
Io.prototype.has = YR;
Io.prototype.set = ZR;
function eN(t, e) {
  return t && lp(e, gc(e), t);
}
function tN(t, e) {
  return t && lp(e, C0(e), t);
}
var nS = typeof exports == "object" && exports && !exports.nodeType && exports, kb = nS && typeof module == "object" && module && !module.nodeType && module, nN = kb && kb.exports === nS, $b = nN ? mo.Buffer : void 0, Sb = $b ? $b.allocUnsafe : void 0;
function rN(t, e) {
  if (e)
    return t.slice();
  var n = t.length, r = Sb ? Sb(n) : new t.constructor(n);
  return t.copy(r), r;
}
function iN(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var s = t[n];
    e(s, n, t) && (o[i++] = s);
  }
  return o;
}
function rS() {
  return [];
}
var oN = Object.prototype, sN = oN.propertyIsEnumerable, Cb = Object.getOwnPropertySymbols, aN = Cb ? function(t) {
  return t == null ? [] : (t = Object(t), iN(Cb(t), function(e) {
    return sN.call(t, e);
  }));
} : rS;
const M0 = aN;
function lN(t, e) {
  return lp(t, M0(t), e);
}
var cN = Object.getOwnPropertySymbols, uN = cN ? function(t) {
  for (var e = []; t; )
    A0(e, M0(t)), t = tS(t);
  return e;
} : rS;
const iS = uN;
function fN(t, e) {
  return lp(t, iS(t), e);
}
function oS(t, e, n) {
  var r = e(t);
  return Xr(t) ? r : A0(r, n(t));
}
function vg(t) {
  return oS(t, gc, M0);
}
function dN(t) {
  return oS(t, C0, iS);
}
var hN = sl(mo, "DataView");
const yg = hN;
var pN = sl(mo, "Promise");
const bg = pN;
var mN = sl(mo, "Set");
const xg = mN;
var Ob = "[object Map]", gN = "[object Object]", Eb = "[object Promise]", Ab = "[object Set]", Mb = "[object WeakMap]", _b = "[object DataView]", vN = ol(yg), yN = ol(xu), bN = ol(bg), xN = ol(xg), wN = ol(mg), ja = pc;
(yg && ja(new yg(new ArrayBuffer(1))) != _b || xu && ja(new xu()) != Ob || bg && ja(bg.resolve()) != Eb || xg && ja(new xg()) != Ab || mg && ja(new mg()) != Mb) && (ja = function(t) {
  var e = pc(t), n = e == gN ? t.constructor : void 0, r = n ? ol(n) : "";
  if (r)
    switch (r) {
      case vN:
        return _b;
      case yN:
        return Ob;
      case bN:
        return Eb;
      case xN:
        return Ab;
      case wN:
        return Mb;
    }
  return e;
});
const Jl = ja;
var jN = Object.prototype, kN = jN.hasOwnProperty;
function $N(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && kN.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var SN = mo.Uint8Array;
const Zd = SN;
function _0(t) {
  var e = new t.constructor(t.byteLength);
  return new Zd(e).set(new Zd(t)), e;
}
function CN(t, e) {
  var n = e ? _0(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var ON = /\w*$/;
function EN(t) {
  var e = new t.constructor(t.source, ON.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var Tb = zi ? zi.prototype : void 0, Pb = Tb ? Tb.valueOf : void 0;
function AN(t) {
  return Pb ? Object(Pb.call(t)) : {};
}
function MN(t, e) {
  var n = e ? _0(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var _N = "[object Boolean]", TN = "[object Date]", PN = "[object Map]", RN = "[object Number]", NN = "[object RegExp]", IN = "[object Set]", DN = "[object String]", LN = "[object Symbol]", BN = "[object ArrayBuffer]", qN = "[object DataView]", zN = "[object Float32Array]", FN = "[object Float64Array]", VN = "[object Int8Array]", HN = "[object Int16Array]", UN = "[object Int32Array]", WN = "[object Uint8Array]", JN = "[object Uint8ClampedArray]", KN = "[object Uint16Array]", GN = "[object Uint32Array]";
function QN(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case BN:
      return _0(t);
    case _N:
    case TN:
      return new r(+t);
    case qN:
      return CN(t, n);
    case zN:
    case FN:
    case VN:
    case HN:
    case UN:
    case WN:
    case JN:
    case KN:
    case GN:
      return MN(t, n);
    case PN:
      return new r();
    case RN:
    case DN:
      return new r(t);
    case NN:
      return EN(t);
    case IN:
      return new r();
    case LN:
      return AN(t);
  }
}
function YN(t) {
  return typeof t.constructor == "function" && !cp(t) ? KP(tS(t)) : {};
}
var XN = "[object Map]";
function ZN(t) {
  return Xs(t) && Jl(t) == XN;
}
var Rb = Wl && Wl.isMap, e9 = Rb ? fp(Rb) : ZN;
const t9 = e9;
var n9 = "[object Set]";
function r9(t) {
  return Xs(t) && Jl(t) == n9;
}
var Nb = Wl && Wl.isSet, i9 = Nb ? fp(Nb) : r9;
const o9 = i9;
var s9 = 1, a9 = 2, l9 = 4, sS = "[object Arguments]", c9 = "[object Array]", u9 = "[object Boolean]", f9 = "[object Date]", d9 = "[object Error]", aS = "[object Function]", h9 = "[object GeneratorFunction]", p9 = "[object Map]", m9 = "[object Number]", lS = "[object Object]", g9 = "[object RegExp]", v9 = "[object Set]", y9 = "[object String]", b9 = "[object Symbol]", x9 = "[object WeakMap]", w9 = "[object ArrayBuffer]", j9 = "[object DataView]", k9 = "[object Float32Array]", $9 = "[object Float64Array]", S9 = "[object Int8Array]", C9 = "[object Int16Array]", O9 = "[object Int32Array]", E9 = "[object Uint8Array]", A9 = "[object Uint8ClampedArray]", M9 = "[object Uint16Array]", _9 = "[object Uint32Array]", Vn = {};
Vn[sS] = Vn[c9] = Vn[w9] = Vn[j9] = Vn[u9] = Vn[f9] = Vn[k9] = Vn[$9] = Vn[S9] = Vn[C9] = Vn[O9] = Vn[p9] = Vn[m9] = Vn[lS] = Vn[g9] = Vn[v9] = Vn[y9] = Vn[b9] = Vn[E9] = Vn[A9] = Vn[M9] = Vn[_9] = !0;
Vn[d9] = Vn[aS] = Vn[x9] = !1;
function Ed(t, e, n, r, i, o) {
  var s, a = e & s9, l = e & a9, c = e & l9;
  if (n && (s = i ? n(t, r, i, o) : n(t)), s !== void 0)
    return s;
  if (!co(t))
    return t;
  var u = Xr(t);
  if (u) {
    if (s = $N(t), !a)
      return QP(t, s);
  } else {
    var f = Jl(t), d = f == aS || f == h9;
    if (yu(t))
      return rN(t, a);
    if (f == lS || f == sS || d && !i) {
      if (s = l || d ? {} : YN(t), !a)
        return l ? fN(t, tN(s, t)) : lN(t, eN(s, t));
    } else {
      if (!Vn[f])
        return i ? t : {};
      s = QN(t, f, a);
    }
  }
  o || (o = new Io());
  var h = o.get(t);
  if (h)
    return h;
  o.set(t, s), o9(t) ? t.forEach(function(g) {
    s.add(Ed(g, e, n, g, t, o));
  }) : t9(t) && t.forEach(function(g, v) {
    s.set(v, Ed(g, e, n, v, t, o));
  });
  var p = c ? l ? dN : vg : l ? C0 : gc, m = u ? void 0 : p(t);
  return a7(m || t, function(g, v) {
    m && (v = g, g = t[v]), H4(s, v, Ed(g, e, n, v, t, o));
  }), s;
}
var T9 = 1, P9 = 4;
function R9(t, e) {
  return e = typeof e == "function" ? e : void 0, Ed(t, T9 | P9, e);
}
var N9 = "__lodash_hash_undefined__";
function I9(t) {
  return this.__data__.set(t, N9), this;
}
function D9(t) {
  return this.__data__.has(t);
}
function eh(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new $s(); ++e < n; )
    this.add(t[e]);
}
eh.prototype.add = eh.prototype.push = I9;
eh.prototype.has = D9;
function L9(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
function B9(t, e) {
  return t.has(e);
}
var q9 = 1, z9 = 2;
function cS(t, e, n, r, i, o) {
  var s = n & q9, a = t.length, l = e.length;
  if (a != l && !(s && l > a))
    return !1;
  var c = o.get(t), u = o.get(e);
  if (c && u)
    return c == e && u == t;
  var f = -1, d = !0, h = n & z9 ? new eh() : void 0;
  for (o.set(t, e), o.set(e, t); ++f < a; ) {
    var p = t[f], m = e[f];
    if (r)
      var g = s ? r(m, p, f, e, t, o) : r(p, m, f, t, e, o);
    if (g !== void 0) {
      if (g)
        continue;
      d = !1;
      break;
    }
    if (h) {
      if (!L9(e, function(v, y) {
        if (!B9(h, y) && (p === v || i(p, v, n, r, o)))
          return h.push(y);
      })) {
        d = !1;
        break;
      }
    } else if (!(p === m || i(p, m, n, r, o))) {
      d = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), d;
}
function F9(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
function V9(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var H9 = 1, U9 = 2, W9 = "[object Boolean]", J9 = "[object Date]", K9 = "[object Error]", G9 = "[object Map]", Q9 = "[object Number]", Y9 = "[object RegExp]", X9 = "[object Set]", Z9 = "[object String]", eI = "[object Symbol]", tI = "[object ArrayBuffer]", nI = "[object DataView]", Ib = zi ? zi.prototype : void 0, cm = Ib ? Ib.valueOf : void 0;
function rI(t, e, n, r, i, o, s) {
  switch (n) {
    case nI:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case tI:
      return !(t.byteLength != e.byteLength || !o(new Zd(t), new Zd(e)));
    case W9:
    case J9:
    case Q9:
      return ap(+t, +e);
    case K9:
      return t.name == e.name && t.message == e.message;
    case Y9:
    case Z9:
      return t == e + "";
    case G9:
      var a = F9;
    case X9:
      var l = r & H9;
      if (a || (a = V9), t.size != e.size && !l)
        return !1;
      var c = s.get(t);
      if (c)
        return c == e;
      r |= U9, s.set(t, e);
      var u = cS(a(t), a(e), r, i, o, s);
      return s.delete(t), u;
    case eI:
      if (cm)
        return cm.call(t) == cm.call(e);
  }
  return !1;
}
var iI = 1, oI = Object.prototype, sI = oI.hasOwnProperty;
function aI(t, e, n, r, i, o) {
  var s = n & iI, a = vg(t), l = a.length, c = vg(e), u = c.length;
  if (l != u && !s)
    return !1;
  for (var f = l; f--; ) {
    var d = a[f];
    if (!(s ? d in e : sI.call(e, d)))
      return !1;
  }
  var h = o.get(t), p = o.get(e);
  if (h && p)
    return h == e && p == t;
  var m = !0;
  o.set(t, e), o.set(e, t);
  for (var g = s; ++f < l; ) {
    d = a[f];
    var v = t[d], y = e[d];
    if (r)
      var w = s ? r(y, v, d, e, t, o) : r(v, y, d, t, e, o);
    if (!(w === void 0 ? v === y || i(v, y, n, r, o) : w)) {
      m = !1;
      break;
    }
    g || (g = d == "constructor");
  }
  if (m && !g) {
    var x = t.constructor, b = e.constructor;
    x != b && "constructor" in t && "constructor" in e && !(typeof x == "function" && x instanceof x && typeof b == "function" && b instanceof b) && (m = !1);
  }
  return o.delete(t), o.delete(e), m;
}
var lI = 1, Db = "[object Arguments]", Lb = "[object Array]", Sf = "[object Object]", cI = Object.prototype, Bb = cI.hasOwnProperty;
function uI(t, e, n, r, i, o) {
  var s = Xr(t), a = Xr(e), l = s ? Lb : Jl(t), c = a ? Lb : Jl(e);
  l = l == Db ? Sf : l, c = c == Db ? Sf : c;
  var u = l == Sf, f = c == Sf, d = l == c;
  if (d && yu(t)) {
    if (!yu(e))
      return !1;
    s = !0, u = !1;
  }
  if (d && !u)
    return o || (o = new Io()), s || S0(t) ? cS(t, e, n, r, i, o) : rI(t, e, l, n, r, i, o);
  if (!(n & lI)) {
    var h = u && Bb.call(t, "__wrapped__"), p = f && Bb.call(e, "__wrapped__");
    if (h || p) {
      var m = h ? t.value() : t, g = p ? e.value() : e;
      return o || (o = new Io()), i(m, g, n, r, o);
    }
  }
  return d ? (o || (o = new Io()), aI(t, e, n, r, i, o)) : !1;
}
function gp(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !Xs(t) && !Xs(e) ? t !== t && e !== e : uI(t, e, n, r, gp, i);
}
var fI = 1, dI = 2;
function hI(t, e, n, r) {
  var i = n.length, o = i, s = !r;
  if (t == null)
    return !o;
  for (t = Object(t); i--; ) {
    var a = n[i];
    if (s && a[2] ? a[1] !== t[a[0]] : !(a[0] in t))
      return !1;
  }
  for (; ++i < o; ) {
    a = n[i];
    var l = a[0], c = t[l], u = a[1];
    if (s && a[2]) {
      if (c === void 0 && !(l in t))
        return !1;
    } else {
      var f = new Io();
      if (r)
        var d = r(c, u, l, t, e, f);
      if (!(d === void 0 ? gp(u, c, fI | dI, r, f) : d))
        return !1;
    }
  }
  return !0;
}
function uS(t) {
  return t === t && !co(t);
}
function pI(t) {
  for (var e = gc(t), n = e.length; n--; ) {
    var r = e[n], i = t[r];
    e[n] = [r, i, uS(i)];
  }
  return e;
}
function fS(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
function mI(t) {
  var e = pI(t);
  return e.length == 1 && e[0][2] ? fS(e[0][0], e[0][1]) : function(n) {
    return n === t || hI(n, t, e);
  };
}
function gI(t, e) {
  return t != null && e in Object(t);
}
function vI(t, e, n) {
  e = Z4(e, t);
  for (var r = -1, i = e.length, o = !1; ++r < i; ) {
    var s = mp(e[r]);
    if (!(o = t != null && n(t, s)))
      break;
    t = t[s];
  }
  return o || ++r != i ? o : (i = t == null ? 0 : t.length, !!i && $0(i) && k0(s, i) && (Xr(t) || up(t)));
}
function yI(t, e) {
  return t != null && vI(t, e, gI);
}
var bI = 1, xI = 2;
function wI(t, e) {
  return O0(t) && uS(e) ? fS(mp(t), e) : function(n) {
    var r = HR(n, t);
    return r === void 0 && r === e ? yI(n, t) : gp(e, r, bI | xI);
  };
}
function jI(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
function kI(t) {
  return function(e) {
    return E0(e, t);
  };
}
function $I(t) {
  return O0(t) ? jI(mp(t)) : kI(t);
}
function Zu(t) {
  return typeof t == "function" ? t : t == null ? Xu : typeof t == "object" ? Xr(t) ? wI(t[0], t[1]) : mI(t) : $I(t);
}
function SI(t, e, n, r) {
  for (var i = -1, o = t == null ? 0 : t.length; ++i < o; ) {
    var s = t[i];
    e(r, s, n(s), t);
  }
  return r;
}
function dS(t) {
  return function(e, n, r) {
    for (var i = -1, o = Object(e), s = r(e), a = s.length; a--; ) {
      var l = s[t ? a : ++i];
      if (n(o[l], l, o) === !1)
        break;
    }
    return e;
  };
}
var CI = dS();
const OI = CI;
function hS(t, e) {
  return t && OI(t, e, gc);
}
function pS(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!mc(n))
      return t(n, r);
    for (var i = n.length, o = e ? i : -1, s = Object(n); (e ? o-- : ++o < i) && r(s[o], o, s) !== !1; )
      ;
    return n;
  };
}
var EI = pS(hS);
const mS = EI;
function AI(t, e, n, r) {
  return mS(t, function(i, o, s) {
    e(r, i, n(i), s);
  }), r;
}
function gS(t, e) {
  return function(n, r) {
    var i = Xr(n) ? SI : AI, o = e ? e() : {};
    return i(n, t, Zu(r), o);
  };
}
var MI = function() {
  return mo.Date.now();
};
const um = MI;
var _I = "Expected a function", TI = Math.max, PI = Math.min;
function ef(t, e, n) {
  var r, i, o, s, a, l, c = 0, u = !1, f = !1, d = !0;
  if (typeof t != "function")
    throw new TypeError(_I);
  e = pg(e) || 0, co(n) && (u = !!n.leading, f = "maxWait" in n, o = f ? TI(pg(n.maxWait) || 0, e) : o, d = "trailing" in n ? !!n.trailing : d);
  function h(j) {
    var $ = r, N = i;
    return r = i = void 0, c = j, s = t.apply(N, $), s;
  }
  function p(j) {
    return c = j, a = setTimeout(v, e), u ? h(j) : s;
  }
  function m(j) {
    var $ = j - l, N = j - c, B = e - $;
    return f ? PI(B, o - N) : B;
  }
  function g(j) {
    var $ = j - l, N = j - c;
    return l === void 0 || $ >= e || $ < 0 || f && N >= o;
  }
  function v() {
    var j = um();
    if (g(j))
      return y(j);
    a = setTimeout(v, m(j));
  }
  function y(j) {
    return a = void 0, d && r ? h(j) : (r = i = void 0, s);
  }
  function w() {
    a !== void 0 && clearTimeout(a), c = 0, r = l = i = a = void 0;
  }
  function x() {
    return a === void 0 ? s : y(um());
  }
  function b() {
    var j = um(), $ = g(j);
    if (r = arguments, i = this, l = j, $) {
      if (a === void 0)
        return p(l);
      if (f)
        return clearTimeout(a), a = setTimeout(v, e), h(l);
    }
    return a === void 0 && (a = setTimeout(v, e)), s;
  }
  return b.cancel = w, b.flush = x, b;
}
function Yt(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
function vS(t) {
  return typeof t == "function" ? t : Xu;
}
function RI(t, e) {
  for (var n = t == null ? 0 : t.length; n-- && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var NI = dS(!0);
const II = NI;
function DI(t, e) {
  return t && II(t, e, gc);
}
var LI = pS(DI, !0);
const BI = LI;
function qI(t, e) {
  var n = Xr(t) ? RI : BI;
  return n(t, vS(e));
}
function ss(t) {
  return t && t.length ? t[0] : void 0;
}
function yS(t, e) {
  var n = -1, r = mc(t) ? Array(t.length) : [];
  return mS(t, function(i, o, s) {
    r[++n] = e(i, o, s);
  }), r;
}
function zI(t, e) {
  var n = Xr(t) ? Xc : yS;
  return n(t, Zu(e));
}
var FI = Object.prototype, VI = FI.hasOwnProperty, HI = gS(function(t, e, n) {
  VI.call(t, n) ? t[n].push(e) : sp(t, n, [e]);
});
const vp = HI;
function en(t) {
  var e = t == null ? 0 : t.length;
  return e ? JR(t, 0, -1) : [];
}
var UI = "[object Map]", WI = "[object Set]", JI = Object.prototype, KI = JI.hasOwnProperty;
function nn(t) {
  if (t == null)
    return !0;
  if (mc(t) && (Xr(t) || typeof t == "string" || typeof t.splice == "function" || yu(t) || S0(t) || up(t)))
    return !t.length;
  var e = Jl(t);
  if (e == UI || e == WI)
    return !t.size;
  if (cp(t))
    return !Y4(t).length;
  for (var n in t)
    if (KI.call(t, n))
      return !1;
  return !0;
}
function tn(t, e) {
  return gp(t, e);
}
function GI(t, e) {
  return t < e;
}
function QI(t, e) {
  var n = {};
  return e = Zu(e), hS(t, function(r, i, o) {
    sp(n, i, e(r, i, o));
  }), n;
}
function YI(t, e, n) {
  for (var r = -1, i = t.length; ++r < i; ) {
    var o = t[r], s = e(o);
    if (s != null && (a === void 0 ? s === s && !Ba(s) : n(s, a)))
      var a = s, l = o;
  }
  return l;
}
function Cf(t, e) {
  return t && t.length ? YI(t, Zu(e), GI) : void 0;
}
function XI(t, e) {
  var n = t.length;
  for (t.sort(e); n--; )
    t[n] = t[n].value;
  return t;
}
function ZI(t, e) {
  if (t !== e) {
    var n = t !== void 0, r = t === null, i = t === t, o = Ba(t), s = e !== void 0, a = e === null, l = e === e, c = Ba(e);
    if (!a && !c && !o && t > e || o && s && l && !a && !c || r && s && l || !n && l || !i)
      return 1;
    if (!r && !o && !c && t < e || c && n && i && !r && !o || a && n && i || !s && i || !l)
      return -1;
  }
  return 0;
}
function eD(t, e, n) {
  for (var r = -1, i = t.criteria, o = e.criteria, s = i.length, a = n.length; ++r < s; ) {
    var l = ZI(i[r], o[r]);
    if (l) {
      if (r >= a)
        return l;
      var c = n[r];
      return l * (c == "desc" ? -1 : 1);
    }
  }
  return t.index - e.index;
}
function tD(t, e, n) {
  e.length ? e = Xc(e, function(o) {
    return Xr(o) ? function(s) {
      return E0(s, o.length === 1 ? o[0] : o);
    } : o;
  }) : e = [Xu];
  var r = -1;
  e = Xc(e, fp(Zu));
  var i = yS(t, function(o, s, a) {
    var l = Xc(e, function(c) {
      return c(o);
    });
    return { criteria: l, index: ++r, value: o };
  });
  return XI(i, function(o, s) {
    return eD(o, s, n);
  });
}
var nD = gS(function(t, e, n) {
  t[n ? 0 : 1].push(e);
}, function() {
  return [[], []];
});
const rD = nD;
var iD = Math.ceil, oD = Math.max;
function sD(t, e, n, r) {
  for (var i = -1, o = oD(iD((e - t) / (n || 1)), 0), s = Array(o); o--; )
    s[r ? o : ++i] = t, t += n;
  return s;
}
function aD(t) {
  return function(e, n, r) {
    return r && typeof r != "number" && gg(e, n, r) && (n = r = void 0), e = Od(e), n === void 0 ? (n = e, e = 0) : n = Od(n), r = r === void 0 ? e < n ? 1 : -1 : Od(r), sD(e, n, r, t);
  };
}
var lD = aD();
const cD = lD;
var uD = h7(function(t, e) {
  if (t == null)
    return [];
  var n = e.length;
  return n > 1 && gg(t, e[0], e[1]) ? e = [] : n > 2 && gg(e[0], e[1], e[2]) && (e = [e[0]]), tD(t, eS(e, 1), []);
});
const fD = uD;
var dD = "Expected a function";
function hD(t, e, n) {
  var r = !0, i = !0;
  if (typeof t != "function")
    throw new TypeError(dD);
  return co(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), ef(t, e, {
    leading: r,
    maxWait: e,
    trailing: i
  });
}
var pD = 9007199254740991, fm = 4294967295, mD = Math.min;
function gD(t, e) {
  if (t = EP(t), t < 1 || t > pD)
    return [];
  var n = fm, r = mD(t, fm);
  e = vS(e), t -= fm;
  for (var i = U4(r, e); ++n < t; )
    e(n);
  return i;
}
var vD = 0;
function Kl(t) {
  var e = ++vD;
  return X4(t) + e;
}
function Zs(t) {
  "@babel/helpers - typeof";
  return Zs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Zs(t);
}
function Tn(t) {
  return Array.isArray(t);
}
function er(t) {
  return t !== null && Zs(t) === "object" && t.constructor === Object;
}
function bS(t) {
  return t && Zs(t) === "object" ? t.op === "add" : !1;
}
function xS(t) {
  return t && Zs(t) === "object" ? t.op === "remove" : !1;
}
function T0(t) {
  return t && Zs(t) === "object" ? t.op === "replace" : !1;
}
function wg(t) {
  return t && Zs(t) === "object" ? t.op === "copy" : !1;
}
function Ml(t) {
  return t && Zs(t) === "object" ? t.op === "move" : !1;
}
function jg(t) {
  "@babel/helpers - typeof";
  return jg = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, jg(t);
}
function yD(t, e) {
  return JSON.stringify(t) === JSON.stringify(e);
}
function bD(t, e) {
  return t === e;
}
function wS(t) {
  return t.slice(0, t.length - 1);
}
function xD(t) {
  return t[t.length - 1];
}
function wD(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : bD;
  if (t.length < e.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!n(t[r], e[r]))
      return !1;
  return !0;
}
function jS(t) {
  return jg(t) === "object" && t !== null;
}
function wu(t) {
  "@babel/helpers - typeof";
  return wu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, wu(t);
}
function qb(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jD(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qb(Object(n), !0).forEach(function(r) {
      kD(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : qb(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function kD(t, e, n) {
  return e = $D(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function $D(t) {
  var e = SD(t, "string");
  return wu(e) === "symbol" ? e : String(e);
}
function SD(t, e) {
  if (wu(t) !== "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (wu(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function P0(t) {
  if (Tn(t)) {
    var e = t.slice();
    return Object.getOwnPropertySymbols(t).forEach(function(r) {
      e[r] = t[r];
    }), e;
  } else if (er(t)) {
    var n = jD({}, t);
    return Object.getOwnPropertySymbols(t).forEach(function(r) {
      n[r] = t[r];
    }), n;
  } else
    return t;
}
function R0(t, e, n) {
  if (t[e] === n)
    return t;
  var r = P0(t);
  return r[e] = n, r;
}
function it(t, e) {
  for (var n = t, r = 0; r < e.length; )
    er(n) ? n = n[e[r]] : Tn(n) ? n = n[parseInt(e[r])] : n = void 0, r++;
  return n;
}
function Xi(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (e.length === 0)
    return n;
  var i = e[0], o = Xi(t ? t[i] : void 0, e.slice(1), n, r);
  if (er(t) || Tn(t))
    return R0(t, i, o);
  if (r) {
    var s = CD.test(i) ? [] : {};
    return s[i] = o, s;
  } else
    throw new Error("Path does not exist");
}
var CD = /^\d+$/;
function kS(t, e, n) {
  if (e.length === 0)
    return n(t);
  if (!jS(t))
    throw new Error("Path doesn't exist");
  var r = e[0], i = kS(t[r], e.slice(1), n);
  return R0(t, r, i);
}
function N0(t, e) {
  if (e.length === 0)
    return t;
  if (!jS(t))
    throw new Error("Path does not exist");
  if (e.length === 1) {
    var n = e[0];
    if (n in t) {
      var r = P0(t);
      return Tn(r) && r.splice(parseInt(n), 1), er(r) && delete r[n], r;
    } else
      return t;
  }
  var i = e[0], o = N0(t[i], e.slice(1));
  return R0(t, i, o);
}
function I0(t, e, n) {
  var r = e.slice(0, e.length - 1), i = e[e.length - 1];
  return kS(t, r, function(o) {
    if (!Array.isArray(o))
      throw new TypeError("Array expected at path " + JSON.stringify(r));
    var s = P0(o);
    return s.splice(parseInt(i), 0, n), s;
  });
}
function Ri(t, e) {
  return t === void 0 ? !1 : e.length === 0 ? !0 : t === null ? !1 : Ri(t[e[0]], e.slice(1));
}
function uo(t) {
  var e = t.split("/");
  return e.shift(), e.map(function(n) {
    return n.replace(/~1/g, "/").replace(/~0/g, "~");
  });
}
function Je(t) {
  return t.map($S).join("");
}
function $S(t) {
  return "/" + String(t).replace(/~/g, "~0").replace(/\//g, "~1");
}
function zb(t, e) {
  return t + $S(e);
}
function yp(t, e) {
  return t.startsWith(e) && (t.length === e.length || t[e.length] === "/");
}
function so(t, e, n) {
  for (var r = t, i = 0; i < e.length; i++) {
    RD(e[i]);
    var o = e[i];
    if (n && n.before) {
      var s = n.before(r, o);
      if (s !== void 0) {
        if (s.document !== void 0 && (r = s.document), s.json !== void 0)
          throw new Error('Deprecation warning: returned object property ".json" has been renamed to ".document"');
        s.operation !== void 0 && (o = s.operation);
      }
    }
    var a = r, l = Do(r, o.path);
    if (o.op === "add")
      r = AD(r, l, o.value);
    else if (o.op === "remove")
      r = ED(r, l);
    else if (o.op === "replace")
      r = OD(r, l, o.value);
    else if (o.op === "copy")
      r = MD(r, l, kg(o.from));
    else if (o.op === "move")
      r = _D(r, l, kg(o.from));
    else if (o.op === "test")
      TD(r, l, o.value);
    else
      throw new Error("Unknown JSONPatch operation " + JSON.stringify(o));
    if (n && n.after) {
      var c = n.after(r, o, a);
      c !== void 0 && (r = c);
    }
  }
  return r;
}
function OD(t, e, n) {
  return Xi(t, e, n);
}
function ED(t, e) {
  return N0(t, e);
}
function AD(t, e, n) {
  return tf(t, e) ? I0(t, e, n) : Xi(t, e, n);
}
function MD(t, e, n) {
  var r = it(t, n);
  if (tf(t, e))
    return I0(t, e, r);
  var i = it(t, n);
  return Xi(t, e, i);
}
function _D(t, e, n) {
  var r = it(t, n), i = N0(t, n);
  return tf(i, e) ? I0(i, e, r) : Xi(i, e, r);
}
function TD(t, e, n) {
  if (n === void 0)
    throw new Error('Test failed: no value provided (path: "'.concat(Je(e), '")'));
  if (!Ri(t, e))
    throw new Error('Test failed: path not found (path: "'.concat(Je(e), '")'));
  var r = it(t, e);
  if (!yD(r, n))
    throw new Error('Test failed, value differs (path: "'.concat(Je(e), '")'));
}
function tf(t, e) {
  if (e.length === 0)
    return !1;
  var n = it(t, wS(e));
  return Array.isArray(n);
}
function PD(t, e) {
  if (xD(e) !== "-")
    return e;
  var n = wS(e), r = it(t, n);
  return n.concat(r.length);
}
function RD(t) {
  var e = ["add", "remove", "replace", "copy", "move", "test"];
  if (!e.includes(t.op))
    throw new Error("Unknown JSONPatch op " + JSON.stringify(t.op));
  if (typeof t.path != "string")
    throw new Error('Required property "path" missing or not a string in operation ' + JSON.stringify(t));
  if ((t.op === "copy" || t.op === "move") && typeof t.from != "string")
    throw new Error('Required property "from" missing or not a string in operation ' + JSON.stringify(t));
}
function Do(t, e) {
  return PD(t, uo(e));
}
function kg(t) {
  return uo(t);
}
function ND(t) {
  return BD(t) || LD(t) || DD(t) || ID();
}
function ID() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DD(t, e) {
  if (t) {
    if (typeof t == "string")
      return $g(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return $g(t, e);
  }
}
function LD(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function BD(t) {
  if (Array.isArray(t))
    return $g(t);
}
function $g(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function SS(t, e, n) {
  var r = [];
  return so(t, e, {
    before: function(o, s) {
      var a, l = Do(o, s.path);
      if (s.op === "add")
        a = ES(o, l);
      else if (s.op === "remove")
        a = OS(o, l);
      else if (s.op === "replace")
        a = CS(o, l);
      else if (s.op === "copy")
        a = qD(o, l);
      else if (s.op === "move")
        a = zD(o, l, kg(s.from));
      else if (s.op === "test")
        a = [];
      else
        throw new Error("Unknown JSONPatch operation " + JSON.stringify(s));
      var c;
      if (n && n.before) {
        var u = n.before(o, s, a);
        if (u && u.revertOperations && (a = u.revertOperations), u && u.document && (c = u.document), u && u.json)
          throw new Error('Deprecation warning: returned object property ".json" has been renamed to ".document"');
      }
      if (r = a.concat(r), c !== void 0)
        return {
          document: c
        };
    }
  }), r;
}
function CS(t, e) {
  return [{
    op: "replace",
    path: Je(e),
    value: it(t, e)
  }];
}
function OS(t, e) {
  return [{
    op: "add",
    path: Je(e),
    value: it(t, e)
  }];
}
function ES(t, e) {
  return tf(t, e) || !Ri(t, e) ? [{
    op: "remove",
    path: Je(e)
  }] : CS(t, e);
}
function qD(t, e) {
  return ES(t, e);
}
function zD(t, e, n) {
  if (e.length < n.length && wD(n, e))
    return [{
      op: "replace",
      path: Je(e),
      value: t
    }];
  var r = {
    op: "move",
    from: Je(e),
    path: Je(n)
  };
  return !tf(t, e) && Ri(t, e) ? [r].concat(ND(OS(t, e))) : [r];
}
var FD = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function VD(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var th = {}, Fb = {
  b: "\b",
  f: "\f",
  n: `
`,
  r: "\r",
  t: "	",
  '"': '"',
  "/": "/",
  "\\": "\\"
}, HD = 97;
th.parse = function(t, e, n) {
  var r = {}, i = 0, o = 0, s = 0, a = n && n.bigint && typeof BigInt < "u";
  return {
    data: l("", !0),
    pointers: r
  };
  function l(B, O) {
    c();
    var I;
    w(B, "value");
    var P = m();
    switch (P) {
      case "t":
        p("rue"), I = !0;
        break;
      case "f":
        p("alse"), I = !1;
        break;
      case "n":
        p("ull"), I = null;
        break;
      case '"':
        I = u();
        break;
      case "[":
        I = d(B);
        break;
      case "{":
        I = h(B);
        break;
      default:
        g(), "-0123456789".indexOf(P) >= 0 ? I = f() : j();
    }
    return w(B, "valueEnd"), c(), O && s < t.length && j(), I;
  }
  function c() {
    e:
      for (; s < t.length; ) {
        switch (t[s]) {
          case " ":
            o++;
            break;
          case "	":
            o += 4;
            break;
          case "\r":
            o = 0;
            break;
          case `
`:
            o = 0, i++;
            break;
          default:
            break e;
        }
        s++;
      }
  }
  function u() {
    for (var B = "", O; O = m(), O != '"'; )
      O == "\\" ? (O = m(), O in Fb ? B += Fb[O] : O == "u" ? B += v() : $()) : B += O;
    return B;
  }
  function f() {
    var B = "", O = !0;
    t[s] == "-" && (B += m()), B += t[s] == "0" ? m() : y(), t[s] == "." && (B += m() + y(), O = !1), (t[s] == "e" || t[s] == "E") && (B += m(), (t[s] == "+" || t[s] == "-") && (B += m()), B += y(), O = !1);
    var I = +B;
    return a && O && (I > Number.MAX_SAFE_INTEGER || I < Number.MIN_SAFE_INTEGER) ? BigInt(B) : I;
  }
  function d(B) {
    c();
    var O = [], I = 0;
    if (m() == "]")
      return O;
    for (g(); ; ) {
      var P = B + "/" + I;
      O.push(l(P)), c();
      var J = m();
      if (J == "]")
        break;
      J != "," && $(), c(), I++;
    }
    return O;
  }
  function h(B) {
    c();
    var O = {};
    if (m() == "}")
      return O;
    for (g(); ; ) {
      var I = b();
      m() != '"' && $();
      var P = u(), J = B + "/" + Sg(P);
      x(J, "key", I), w(J, "keyEnd"), c(), m() != ":" && $(), c(), O[P] = l(J), c();
      var D = m();
      if (D == "}")
        break;
      D != "," && $(), c();
    }
    return O;
  }
  function p(B) {
    for (var O = 0; O < B.length; O++)
      m() !== B[O] && $();
  }
  function m() {
    N();
    var B = t[s];
    return s++, o++, B;
  }
  function g() {
    s--, o--;
  }
  function v() {
    for (var B = 4, O = 0; B--; ) {
      O <<= 4;
      var I = m().toLowerCase();
      I >= "a" && I <= "f" ? O += I.charCodeAt() - HD + 10 : I >= "0" && I <= "9" ? O += +I : $();
    }
    return String.fromCharCode(O);
  }
  function y() {
    for (var B = ""; t[s] >= "0" && t[s] <= "9"; )
      B += m();
    if (B.length)
      return B;
    N(), j();
  }
  function w(B, O) {
    x(B, O, b());
  }
  function x(B, O, I) {
    r[B] = r[B] || {}, r[B][O] = I;
  }
  function b() {
    return {
      line: i,
      column: o,
      pos: s
    };
  }
  function j() {
    throw new SyntaxError("Unexpected token " + t[s] + " in JSON at position " + s);
  }
  function $() {
    g(), j();
  }
  function N() {
    if (s >= t.length)
      throw new SyntaxError("Unexpected end of JSON input");
  }
};
th.stringify = function(t, e, n) {
  if (!Of(t))
    return;
  var r = 0, i, o, s = typeof n == "object" ? n.space : n;
  switch (typeof s) {
    case "number":
      var a = s > 10 ? 10 : s < 0 ? 0 : Math.floor(s);
      s = a && x(a, " "), i = a, o = a;
      break;
    case "string":
      s = s.slice(0, 10), i = 0, o = 0;
      for (var l = 0; l < s.length; l++) {
        var c = s[l];
        switch (c) {
          case " ":
            o++;
            break;
          case "	":
            o += 4;
            break;
          case "\r":
            o = 0;
            break;
          case `
`:
            o = 0, r++;
            break;
          default:
            throw new Error("whitespace characters not allowed in JSON");
        }
        i++;
      }
      break;
    default:
      s = void 0;
  }
  var u = "", f = {}, d = 0, h = 0, p = 0, m = n && n.es6 && typeof Map == "function";
  return g(t, 0, ""), {
    json: u,
    pointers: f
  };
  function g(b, j, $) {
    switch (w($, "value"), typeof b) {
      case "number":
      case "bigint":
      case "boolean":
        v("" + b);
        break;
      case "string":
        v(Ef(b));
        break;
      case "object":
        b === null ? v("null") : typeof b.toJSON == "function" ? v(Ef(b.toJSON())) : Array.isArray(b) ? N() : m ? b.constructor.BYTES_PER_ELEMENT ? N() : b instanceof Map ? O() : b instanceof Set ? O(!0) : B() : B();
    }
    w($, "valueEnd");
    function N() {
      if (b.length) {
        v("[");
        for (var I = j + 1, P = 0; P < b.length; P++) {
          P && v(","), y(I);
          var J = Of(b[P]) ? b[P] : null, D = $ + "/" + P;
          g(J, I, D);
        }
        y(j), v("]");
      } else
        v("[]");
    }
    function B() {
      var I = Object.keys(b);
      if (I.length) {
        v("{");
        for (var P = j + 1, J = 0; J < I.length; J++) {
          var D = I[J], Q = b[D];
          if (Of(Q)) {
            J && v(",");
            var Z = $ + "/" + Sg(D);
            y(P), w(Z, "key"), v(Ef(D)), w(Z, "keyEnd"), v(":"), s && v(" "), g(Q, P, Z);
          }
        }
        y(j), v("}");
      } else
        v("{}");
    }
    function O(I) {
      if (b.size) {
        v("{");
        for (var P = j + 1, J = !0, D = b.entries(), Q = D.next(); !Q.done; ) {
          var Z = Q.value, L = Z[0], R = I ? !0 : Z[1];
          if (Of(R)) {
            J || v(","), J = !1;
            var V = $ + "/" + Sg(L);
            y(P), w(V, "key"), v(Ef(L)), w(V, "keyEnd"), v(":"), s && v(" "), g(R, P, V);
          }
          Q = D.next();
        }
        y(j), v("}");
      } else
        v("{}");
    }
  }
  function v(b) {
    h += b.length, p += b.length, u += b;
  }
  function y(b) {
    if (s) {
      for (u += `
` + x(b, s), d++, h = 0; b--; )
        r ? (d += r, h = o) : h += o, p += i;
      p += 1;
    }
  }
  function w(b, j) {
    f[b] = f[b] || {}, f[b][j] = {
      line: d,
      column: h,
      pos: p
    };
  }
  function x(b, j) {
    return Array(b + 1).join(j);
  }
};
var UD = ["number", "bigint", "boolean", "string", "object"];
function Of(t) {
  return UD.indexOf(typeof t) >= 0;
}
var WD = /"|\\/g, JD = /[\b]/g, KD = /\f/g, GD = /\n/g, QD = /\r/g, YD = /\t/g;
function Ef(t) {
  return t = t.replace(WD, "\\$&").replace(KD, "\\f").replace(JD, "\\b").replace(GD, "\\n").replace(QD, "\\r").replace(YD, "\\t"), '"' + t + '"';
}
var XD = /~/g, ZD = /\//g;
function Sg(t) {
  return t.replace(XD, "~0").replace(ZD, "~1");
}
class ga extends Error {
  constructor(e, n) {
    super(e + " at position " + n), this.position = n;
  }
}
const Af = 92, dm = 47, eL = 42, Vb = 123, Mf = 125, Hb = 91, _f = 93, tL = 40, nL = 41, rL = 32, D0 = 10, AS = 9, MS = 13, iL = 8, oL = 12, nh = 34, Ub = 43, Wb = 45, _S = 39, TS = 48, PS = 57, Tf = 44, sL = 46, aL = 58, lL = 59, cL = 65, uL = 97, fL = 69, dL = 101, hL = 70, pL = 102, mL = 160, gL = 8192, vL = 8202, yL = 8239, bL = 8287, xL = 12288, wL = 8220, jL = 8221, kL = 8216, $L = 8217, SL = 96, CL = 180;
function OL(t) {
  return t >= TS && t <= PS || t >= cL && t <= hL || t >= uL && t <= pL;
}
function Pf(t) {
  return t >= TS && t <= PS;
}
function EL(t) {
  return t >= 32 && t <= 1114111;
}
function hm(t) {
  return AL.test(t) || t && rh(t.charCodeAt(0));
}
const AL = /^[,:[\]{}()\n+]$/;
function Jb(t) {
  return ML.test(t) || t && rh(t.charCodeAt(0));
}
const ML = /^[[{\w-]$/;
function _L(t) {
  return t === D0 || t === MS || t === AS || t === iL || t === oL;
}
function ju(t) {
  return t === rL || t === D0 || t === AS || t === MS;
}
function TL(t) {
  return t === mL || t >= gL && t <= vL || t === yL || t === bL || t === xL;
}
function rh(t) {
  return RS(t) || Cg(t);
}
function RS(t) {
  return t === nh || t === wL || t === jL;
}
function Kb(t) {
  return t === nh;
}
function Cg(t) {
  return t === _S || t === kL || t === $L || t === SL || t === CL;
}
function Gb(t) {
  return t === _S;
}
function Mc(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  const r = t.lastIndexOf(e);
  return r !== -1 ? t.substring(0, r) + (n ? "" : t.substring(r + 1)) : t;
}
function Os(t, e) {
  let n = t.length;
  if (!ju(t.charCodeAt(n - 1)))
    return t + e;
  for (; ju(t.charCodeAt(n - 1)); )
    n--;
  return t.substring(0, n) + e + t.substring(n);
}
function PL(t, e, n) {
  return t.substring(0, e) + t.substring(e + n);
}
function RL(t) {
  return /[,\n][ \t\r]*$/.test(t);
}
function NL(t, e) {
  let n = e;
  for (; ju(t.charCodeAt(n)); )
    n++;
  return t.charAt(n);
}
const IL = {
  "\b": "\\b",
  "\f": "\\f",
  "\n": "\\n",
  "\r": "\\r",
  "	": "\\t"
}, DL = {
  '"': '"',
  "\\": "\\",
  "/": "/",
  b: "\b",
  f: "\f",
  n: `
`,
  r: "\r",
  t: "	"
  // note that \u is handled separately in parseString()
};
function Lo(t) {
  let e = 0, n = "";
  o() || B();
  const i = c(Tf);
  for (i && s(), Jb(t[e]) && RL(n) ? (i || (n = Os(n, ",")), p()) : i && (n = Mc(n, ",")); t.charCodeAt(e) === Mf || t.charCodeAt(e) === _f; )
    e++, s();
  if (e >= t.length)
    return n;
  N();
  function o() {
    s();
    const D = d() || h() || m() || v() || y() || x();
    return s(), D;
  }
  function s() {
    const D = e;
    let Q = a();
    do
      Q = l(), Q && (Q = a());
    while (Q);
    return e > D;
  }
  function a() {
    let D = "", Q;
    for (; (Q = ju(t.charCodeAt(e))) || TL(t.charCodeAt(e)); )
      Q ? D += t[e] : D += " ", e++;
    return D.length > 0 ? (n += D, !0) : !1;
  }
  function l() {
    if (t.charCodeAt(e) === dm && t.charCodeAt(e + 1) === eL) {
      for (; e < t.length && !LL(t, e); )
        e++;
      return e += 2, !0;
    }
    if (t.charCodeAt(e) === dm && t.charCodeAt(e + 1) === dm) {
      for (; e < t.length && t.charCodeAt(e) !== D0; )
        e++;
      return !0;
    }
    return !1;
  }
  function c(D) {
    return t.charCodeAt(e) === D ? (n += t[e], e++, !0) : !1;
  }
  function u(D) {
    return t.charCodeAt(e) === D ? (e++, !0) : !1;
  }
  function f() {
    return u(Af);
  }
  function d() {
    if (t.charCodeAt(e) === Vb) {
      n += "{", e++, s();
      let D = !0;
      for (; e < t.length && t.charCodeAt(e) !== Mf; ) {
        let Q;
        if (D ? (Q = !0, D = !1) : (Q = c(Tf), Q || (n = Os(n, ",")), s()), !(m() || x())) {
          t.charCodeAt(e) === Mf || t.charCodeAt(e) === Vb || t.charCodeAt(e) === _f || t.charCodeAt(e) === Hb || t[e] === void 0 ? n = Mc(n, ",") : O();
          break;
        }
        s();
        const L = c(aL), R = e >= t.length;
        L || (Jb(t[e]) || R ? n = Os(n, ":") : I()), o() || (L || R ? n += "null" : I());
      }
      return t.charCodeAt(e) === Mf ? (n += "}", e++) : n = Os(n, "}"), !0;
    }
    return !1;
  }
  function h() {
    if (t.charCodeAt(e) === Hb) {
      n += "[", e++, s();
      let D = !0;
      for (; e < t.length && t.charCodeAt(e) !== _f; )
        if (D ? D = !1 : c(Tf) || (n = Os(n, ",")), !o()) {
          n = Mc(n, ",");
          break;
        }
      return t.charCodeAt(e) === _f ? (n += "]", e++) : n = Os(n, "]"), !0;
    }
    return !1;
  }
  function p() {
    let D = !0, Q = !0;
    for (; Q; )
      D ? D = !1 : c(Tf) || (n = Os(n, ",")), Q = o();
    Q || (n = Mc(n, ",")), n = `[
${n}
]`;
  }
  function m() {
    let D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, Q = t.charCodeAt(e) === Af;
    if (Q && (e++, Q = !0), rh(t.charCodeAt(e))) {
      const Z = Kb(t.charCodeAt(e)) ? Kb : Gb(t.charCodeAt(e)) ? Gb : Cg(t.charCodeAt(e)) ? Cg : RS, L = e, R = n;
      n += '"', e++;
      const V = D ? (F) => hm(t[F]) : (F) => Z(t.charCodeAt(F));
      for (; e < t.length && !V(e); ) {
        if (t.charCodeAt(e) === Af) {
          const F = t.charAt(e + 1);
          if (DL[F] !== void 0)
            n += t.slice(e, e + 2), e += 2;
          else if (F === "u") {
            let E = 2;
            for (; E < 6 && OL(t.charCodeAt(e + E)); )
              E++;
            E === 6 ? (n += t.slice(e, e + 6), e += 6) : E < 6 && e + E >= t.length ? e = t.length : P(e);
          } else
            n += F, e += 2;
        } else {
          const F = t.charAt(e), z = t.charCodeAt(e);
          z === nh && t.charCodeAt(e - 1) !== Af ? (n += "\\" + F, e++) : _L(z) ? (n += IL[F], e++) : (EL(z) || $(F), n += F, e++);
        }
        Q && f();
      }
      const M = rh(t.charCodeAt(e));
      return !(M && (e + 1 >= t.length || hm(NL(t, e + 1)))) && !D ? (e = L, n = R, m(!0)) : (M ? (n += '"', e++) : n = Os(n, '"'), g(), !0);
    }
    return !1;
  }
  function g() {
    let D = !1;
    for (s(); t.charCodeAt(e) === Ub; ) {
      D = !0, e++, s(), n = Mc(n, '"', !0);
      const Q = n.length;
      m(), n = PL(n, Q, 1);
    }
    return D;
  }
  function v() {
    const D = e;
    if (t.charCodeAt(e) === Wb && (e++, j(D)))
      return !0;
    for (; Pf(t.charCodeAt(e)); )
      e++;
    if (t.charCodeAt(e) === sL) {
      if (e++, j(D))
        return !0;
      for (; Pf(t.charCodeAt(e)); )
        e++;
    }
    if (t.charCodeAt(e) === dL || t.charCodeAt(e) === fL) {
      if (e++, (t.charCodeAt(e) === Wb || t.charCodeAt(e) === Ub) && e++, j(D))
        return !0;
      for (; Pf(t.charCodeAt(e)); )
        e++;
    }
    if (e > D) {
      const Q = t.slice(D, e), Z = /^0\d/.test(Q);
      return n += Z ? `"${Q}"` : Q, !0;
    }
    return !1;
  }
  function y() {
    return w("true", "true") || w("false", "false") || w("null", "null") || // repair Python keywords True, False, None
    w("True", "true") || w("False", "false") || w("None", "null");
  }
  function w(D, Q) {
    return t.slice(e, e + D.length) === D ? (n += Q, e += D.length, !0) : !1;
  }
  function x() {
    const D = e;
    for (; e < t.length && !hm(t[e]); )
      e++;
    if (e > D) {
      if (t.charCodeAt(e) === tL)
        return e++, o(), t.charCodeAt(e) === nL && (e++, t.charCodeAt(e) === lL && e++), !0;
      {
        for (; ju(t.charCodeAt(e - 1)) && e > 0; )
          e--;
        const Q = t.slice(D, e);
        return n += Q === "undefined" ? "null" : JSON.stringify(Q), t.charCodeAt(e) === nh && e++, !0;
      }
    }
  }
  function b(D) {
    if (!Pf(t.charCodeAt(e))) {
      const Q = t.slice(D, e);
      throw new ga(`Invalid number '${Q}', expecting a digit ${J()}`, e);
    }
  }
  function j(D) {
    return e >= t.length ? (n += t.slice(D, e) + "0", !0) : (b(D), !1);
  }
  function $(D) {
    throw new ga("Invalid character " + JSON.stringify(D), e);
  }
  function N() {
    throw new ga("Unexpected character " + JSON.stringify(t[e]), e);
  }
  function B() {
    throw new ga("Unexpected end of json string", t.length);
  }
  function O() {
    throw new ga("Object key expected", e);
  }
  function I() {
    throw new ga("Colon expected", e);
  }
  function P(D) {
    const Q = t.slice(D, D + 6);
    throw new ga(`Invalid unicode character "${Q}"`, D);
  }
  function J() {
    return t[e] ? `but got '${t[e]}'` : "but reached end of input";
  }
}
function LL(t, e) {
  return t[e] === "*" && t[e + 1] === "/";
}
var BL = {
  prefix: "far",
  iconName: "lightbulb",
  icon: [384, 512, [128161], "f0eb", "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80V416H272v16c0 44.2-35.8 80-80 80z"]
}, qL = {
  prefix: "far",
  iconName: "square-check",
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, ku = qL, $u = {
  prefix: "far",
  iconName: "square",
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
}, zL = {
  prefix: "far",
  iconName: "clock",
  icon: [512, 512, [128339, "clock-four"], "f017", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
}, Og = {
  prefix: "fas",
  iconName: "trash-can",
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
}, Ds = {
  prefix: "fas",
  iconName: "caret-right",
  icon: [256, 512, [], "f0da", "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"]
}, NS = {
  prefix: "fas",
  iconName: "paste",
  icon: [512, 512, ["file-clipboard"], "f0ea", "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
}, FL = {
  prefix: "fas",
  iconName: "circle-notch",
  icon: [512, 512, [], "f1ce", "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"]
}, VL = {
  prefix: "fas",
  iconName: "scissors",
  icon: [512, 512, [9984, 9986, 9988, "cut"], "f0c4", "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
}, _l = VL, HL = {
  prefix: "fas",
  iconName: "square-caret-down",
  icon: [448, 512, ["caret-square-down"], "f150", "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"]
}, UL = HL, WL = {
  prefix: "fas",
  iconName: "caret-left",
  icon: [256, 512, [], "f0d9", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"]
}, JL = {
  prefix: "fas",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"]
}, Qb = JL, KL = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, IS = {
  prefix: "fas",
  iconName: "angle-right",
  icon: [320, 512, [8250], "f105", "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"]
}, GL = {
  prefix: "fas",
  iconName: "square-caret-up",
  icon: [448, 512, ["caret-square-up"], "f151", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"]
}, QL = GL, Yb = {
  prefix: "fas",
  iconName: "caret-up",
  icon: [320, 512, [], "f0d8", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
}, bp = {
  prefix: "fas",
  iconName: "filter",
  icon: [512, 512, [], "f0b0", "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"]
}, ea = {
  prefix: "fas",
  iconName: "code",
  icon: [640, 512, [], "f121", "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]
}, xp = {
  prefix: "fas",
  iconName: "wrench",
  icon: [512, 512, [128295], "f0ad", "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
}, YL = {
  prefix: "fas",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
}, Tl = {
  prefix: "fas",
  iconName: "pen",
  icon: [512, 512, [128394], "f304", "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"]
}, XL = {
  prefix: "fas",
  iconName: "arrow-rotate-right",
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"]
}, L0 = XL, ZL = {
  prefix: "fas",
  iconName: "arrow-rotate-left",
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"]
}, B0 = ZL, eB = {
  prefix: "fas",
  iconName: "crop-simple",
  icon: [512, 512, ["crop-alt"], "f565", "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"]
}, tB = eB, nB = {
  prefix: "fas",
  iconName: "gear",
  icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
}, rB = nB, Ti = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, iB = {
  prefix: "fas",
  iconName: "ellipsis-vertical",
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"]
}, DS = iB, Rf = {
  prefix: "fas",
  iconName: "arrow-right-arrow-left",
  icon: [448, 512, [8644, "exchange"], "f0ec", "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"]
}, oB = {
  prefix: "fas",
  iconName: "arrow-down-short-wide",
  icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
}, wp = oB, sB = {
  prefix: "fas",
  iconName: "angle-down",
  icon: [448, 512, [8964], "f107", "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
}, aB = {
  prefix: "fas",
  iconName: "arrow-down",
  icon: [384, 512, [8595], "f063", "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
}, lB = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, q0 = lB, cB = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, Vs = {
  prefix: "fas",
  iconName: "copy",
  icon: [448, 512, [], "f0c5", "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"]
}, kl = {
  prefix: "fas",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"]
}, LS = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, Xb = LS, Gl = LS, uB = {
  prefix: "fas",
  iconName: "rotate",
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"]
}, BS = {
  prefix: "fas",
  iconName: "clone",
  icon: [512, 512, [], "f24d", "M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"]
}, Su = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
}, fB = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, al = fB, qS = { exports: {} };
/*
 * @version    1.4.0
 * @date       2015-10-26
 * @stability  3 - Stable
 * @author     Lauri Rooden (https://github.com/litejs/natural-compare-lite)
 * @license    MIT License
 */
var Zb = function(t, e) {
  var n, r, i = 1, o = 0, s = 0, a = String.alphabet;
  function l(c, u, f) {
    if (f) {
      for (n = u; f = l(c, n), f < 76 && f > 65; )
        ++n;
      return +c.slice(u - 1, n);
    }
    return f = a && a.indexOf(c.charAt(u)), f > -1 ? f + 76 : (f = c.charCodeAt(u) || 0, f < 45 || f > 127 ? f : f < 46 ? 65 : f < 48 ? f - 1 : f < 58 ? f + 18 : f < 65 ? f - 11 : f < 91 ? f + 11 : f < 97 ? f - 37 : f < 123 ? f + 5 : f - 63);
  }
  if ((t += "") != (e += "")) {
    for (; i; )
      if (r = l(t, o++), i = l(e, s++), r < 76 && i < 76 && r > 66 && i > 66 && (r = l(t, o, o), i = l(e, s, o = n), s = n), r != i)
        return r < i ? -1 : 1;
  }
  return 0;
};
try {
  qS.exports = Zb;
} catch {
  String.naturalCompare = Zb;
}
var dB = qS.exports;
const hB = /* @__PURE__ */ VD(dB);
var e2 = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function pB(t, e) {
  return !!(t === e || e2(t) && e2(e));
}
function mB(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (!pB(t[n], e[n]))
      return !1;
  return !0;
}
function nf(t, e) {
  e === void 0 && (e = mB);
  var n = null;
  function r() {
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    if (n && n.lastThis === this && e(i, n.lastArgs))
      return n.lastResult;
    var s = t.apply(this, i);
    return n = {
      lastResult: s,
      lastArgs: i,
      lastThis: this
    }, s;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
class Cn {
  /**
  Get the line description around the given position.
  */
  lineAt(e) {
    if (e < 0 || e > this.length)
      throw new RangeError(`Invalid position ${e} in document of length ${this.length}`);
    return this.lineInner(e, !1, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(e) {
    if (e < 1 || e > this.lines)
      throw new RangeError(`Invalid line number ${e} in ${this.lines}-line document`);
    return this.lineInner(e, !0, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(e, n, r) {
    [e, n] = Ql(this, e, n);
    let i = [];
    return this.decompose(
      0,
      e,
      i,
      2
      /* Open.To */
    ), r.length && r.decompose(
      0,
      r.length,
      i,
      3
      /* Open.To */
    ), this.decompose(
      n,
      this.length,
      i,
      1
      /* Open.From */
    ), Ao.from(i, this.length - (n - e) + r.length);
  }
  /**
  Append another document to this one.
  */
  append(e) {
    return this.replace(this.length, this.length, e);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(e, n = this.length) {
    [e, n] = Ql(this, e, n);
    let r = [];
    return this.decompose(e, n, r, 0), Ao.from(r, n - e);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(e) {
    if (e == this)
      return !0;
    if (e.length != this.length || e.lines != this.lines)
      return !1;
    let n = this.scanIdentical(e, 1), r = this.length - this.scanIdentical(e, -1), i = new eu(this), o = new eu(e);
    for (let s = n, a = n; ; ) {
      if (i.next(s), o.next(s), s = 0, i.lineBreak != o.lineBreak || i.done != o.done || i.value != o.value)
        return !1;
      if (a += i.value.length, i.done || a >= r)
        return !0;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(e = 1) {
    return new eu(this, e);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(e, n = this.length) {
    return new zS(this, e, n);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(e, n) {
    let r;
    if (e == null)
      r = this.iter();
    else {
      n == null && (n = this.lines + 1);
      let i = this.line(e).from;
      r = this.iterRange(i, Math.max(i, n == this.lines + 1 ? this.length : n <= 1 ? 0 : this.line(n - 1).to));
    }
    return new FS(r);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let e = [];
    return this.flatten(e), e;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(e) {
    if (e.length == 0)
      throw new RangeError("A document must have at least one line");
    return e.length == 1 && !e[0] ? Cn.empty : e.length <= 32 ? new gr(e) : Ao.from(gr.split(e, []));
  }
}
class gr extends Cn {
  constructor(e, n = gB(e)) {
    super(), this.text = e, this.length = n;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(e, n, r, i) {
    for (let o = 0; ; o++) {
      let s = this.text[o], a = i + s.length;
      if ((n ? r : a) >= e)
        return new vB(i, a, r, s);
      i = a + 1, r++;
    }
  }
  decompose(e, n, r, i) {
    let o = e <= 0 && n >= this.length ? this : new gr(t2(this.text, e, n), Math.min(n, this.length) - Math.max(0, e));
    if (i & 1) {
      let s = r.pop(), a = Ad(o.text, s.text.slice(), 0, o.length);
      if (a.length <= 32)
        r.push(new gr(a, s.length + o.length));
      else {
        let l = a.length >> 1;
        r.push(new gr(a.slice(0, l)), new gr(a.slice(l)));
      }
    } else
      r.push(o);
  }
  replace(e, n, r) {
    if (!(r instanceof gr))
      return super.replace(e, n, r);
    [e, n] = Ql(this, e, n);
    let i = Ad(this.text, Ad(r.text, t2(this.text, 0, e)), n), o = this.length + r.length - (n - e);
    return i.length <= 32 ? new gr(i, o) : Ao.from(gr.split(i, []), o);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = Ql(this, e, n);
    let i = "";
    for (let o = 0, s = 0; o <= n && s < this.text.length; s++) {
      let a = this.text[s], l = o + a.length;
      o > e && s && (i += r), e < l && n > o && (i += a.slice(Math.max(0, e - o), n - o)), o = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let n of this.text)
      e.push(n);
  }
  scanIdentical() {
    return 0;
  }
  static split(e, n) {
    let r = [], i = -1;
    for (let o of e)
      r.push(o), i += o.length + 1, r.length == 32 && (n.push(new gr(r, i)), r = [], i = -1);
    return i > -1 && n.push(new gr(r, i)), n;
  }
}
class Ao extends Cn {
  constructor(e, n) {
    super(), this.children = e, this.length = n, this.lines = 0;
    for (let r of e)
      this.lines += r.lines;
  }
  lineInner(e, n, r, i) {
    for (let o = 0; ; o++) {
      let s = this.children[o], a = i + s.length, l = r + s.lines - 1;
      if ((n ? l : a) >= e)
        return s.lineInner(e, n, r, i);
      i = a + 1, r = l + 1;
    }
  }
  decompose(e, n, r, i) {
    for (let o = 0, s = 0; s <= n && o < this.children.length; o++) {
      let a = this.children[o], l = s + a.length;
      if (e <= l && n >= s) {
        let c = i & ((s <= e ? 1 : 0) | (l >= n ? 2 : 0));
        s >= e && l <= n && !c ? r.push(a) : a.decompose(e - s, n - s, r, c);
      }
      s = l + 1;
    }
  }
  replace(e, n, r) {
    if ([e, n] = Ql(this, e, n), r.lines < this.lines)
      for (let i = 0, o = 0; i < this.children.length; i++) {
        let s = this.children[i], a = o + s.length;
        if (e >= o && n <= a) {
          let l = s.replace(e - o, n - o, r), c = this.lines - s.lines + l.lines;
          if (l.lines < c >> 4 && l.lines > c >> 6) {
            let u = this.children.slice();
            return u[i] = l, new Ao(u, this.length - (n - e) + r.length);
          }
          return super.replace(o, a, l);
        }
        o = a + 1;
      }
    return super.replace(e, n, r);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = Ql(this, e, n);
    let i = "";
    for (let o = 0, s = 0; o < this.children.length && s <= n; o++) {
      let a = this.children[o], l = s + a.length;
      s > e && o && (i += r), e < l && n > s && (i += a.sliceString(e - s, n - s, r)), s = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let n of this.children)
      n.flatten(e);
  }
  scanIdentical(e, n) {
    if (!(e instanceof Ao))
      return 0;
    let r = 0, [i, o, s, a] = n > 0 ? [0, 0, this.children.length, e.children.length] : [this.children.length - 1, e.children.length - 1, -1, -1];
    for (; ; i += n, o += n) {
      if (i == s || o == a)
        return r;
      let l = this.children[i], c = e.children[o];
      if (l != c)
        return r + l.scanIdentical(c, n);
      r += l.length + 1;
    }
  }
  static from(e, n = e.reduce((r, i) => r + i.length + 1, -1)) {
    let r = 0;
    for (let h of e)
      r += h.lines;
    if (r < 32) {
      let h = [];
      for (let p of e)
        p.flatten(h);
      return new gr(h, n);
    }
    let i = Math.max(
      32,
      r >> 5
      /* Tree.BranchShift */
    ), o = i << 1, s = i >> 1, a = [], l = 0, c = -1, u = [];
    function f(h) {
      let p;
      if (h.lines > o && h instanceof Ao)
        for (let m of h.children)
          f(m);
      else
        h.lines > s && (l > s || !l) ? (d(), a.push(h)) : h instanceof gr && l && (p = u[u.length - 1]) instanceof gr && h.lines + p.lines <= 32 ? (l += h.lines, c += h.length + 1, u[u.length - 1] = new gr(p.text.concat(h.text), p.length + 1 + h.length)) : (l + h.lines > i && d(), l += h.lines, c += h.length + 1, u.push(h));
    }
    function d() {
      l != 0 && (a.push(u.length == 1 ? u[0] : Ao.from(u, c)), c = -1, l = u.length = 0);
    }
    for (let h of e)
      f(h);
    return d(), a.length == 1 ? a[0] : new Ao(a, n);
  }
}
Cn.empty = /* @__PURE__ */ new gr([""], 0);
function gB(t) {
  let e = -1;
  for (let n of t)
    e += n.length + 1;
  return e;
}
function Ad(t, e, n = 0, r = 1e9) {
  for (let i = 0, o = 0, s = !0; o < t.length && i <= r; o++) {
    let a = t[o], l = i + a.length;
    l >= n && (l > r && (a = a.slice(0, r - i)), i < n && (a = a.slice(n - i)), s ? (e[e.length - 1] += a, s = !1) : e.push(a)), i = l + 1;
  }
  return e;
}
function t2(t, e, n) {
  return Ad(t, [""], e, n);
}
class eu {
  constructor(e, n = 1) {
    this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [e], this.offsets = [n > 0 ? 1 : (e instanceof gr ? e.text.length : e.children.length) << 1];
  }
  nextInner(e, n) {
    for (this.done = this.lineBreak = !1; ; ) {
      let r = this.nodes.length - 1, i = this.nodes[r], o = this.offsets[r], s = o >> 1, a = i instanceof gr ? i.text.length : i.children.length;
      if (s == (n > 0 ? a : 0)) {
        if (r == 0)
          return this.done = !0, this.value = "", this;
        n > 0 && this.offsets[r - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((o & 1) == (n > 0 ? 0 : 1)) {
        if (this.offsets[r] += n, e == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        e--;
      } else if (i instanceof gr) {
        let l = i.text[s + (n < 0 ? -1 : 0)];
        if (this.offsets[r] += n, l.length > Math.max(0, e))
          return this.value = e == 0 ? l : n > 0 ? l.slice(e) : l.slice(0, l.length - e), this;
        e -= l.length;
      } else {
        let l = i.children[s + (n < 0 ? -1 : 0)];
        e > l.length ? (e -= l.length, this.offsets[r] += n) : (n < 0 && this.offsets[r]--, this.nodes.push(l), this.offsets.push(n > 0 ? 1 : (l instanceof gr ? l.text.length : l.children.length) << 1));
      }
    }
  }
  next(e = 0) {
    return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
  }
}
class zS {
  constructor(e, n, r) {
    this.value = "", this.done = !1, this.cursor = new eu(e, n > r ? -1 : 1), this.pos = n > r ? e.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
  }
  nextInner(e, n) {
    if (n < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    e += Math.max(0, n < 0 ? this.pos - this.to : this.from - this.pos);
    let r = n < 0 ? this.pos - this.from : this.to - this.pos;
    e > r && (e = r), r -= e;
    let { value: i } = this.cursor.next(e);
    return this.pos += (i.length + e) * n, this.value = i.length <= r ? i : n < 0 ? i.slice(i.length - r) : i.slice(0, r), this.done = !this.value, this;
  }
  next(e = 0) {
    return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class FS {
  constructor(e) {
    this.inner = e, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(e = 0) {
    let { done: n, lineBreak: r, value: i } = this.inner.next(e);
    return n && this.afterBreak ? (this.value = "", this.afterBreak = !1) : n ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = i, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}
typeof Symbol < "u" && (Cn.prototype[Symbol.iterator] = function() {
  return this.iter();
}, eu.prototype[Symbol.iterator] = zS.prototype[Symbol.iterator] = FS.prototype[Symbol.iterator] = function() {
  return this;
});
class vB {
  /**
  @internal
  */
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.number = r, this.text = i;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
}
function Ql(t, e, n) {
  return e = Math.max(0, Math.min(t.length, e)), [e, Math.max(e, Math.min(t.length, n))];
}
let Pl = /* @__PURE__ */ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((t) => t ? parseInt(t, 36) : 1);
for (let t = 1; t < Pl.length; t++)
  Pl[t] += Pl[t - 1];
function yB(t) {
  for (let e = 1; e < Pl.length; e += 2)
    if (Pl[e] > t)
      return Pl[e - 1] <= t;
  return !1;
}
function n2(t) {
  return t >= 127462 && t <= 127487;
}
const r2 = 8205;
function Br(t, e, n = !0, r = !0) {
  return (n ? VS : bB)(t, e, r);
}
function VS(t, e, n) {
  if (e == t.length)
    return e;
  e && HS(t.charCodeAt(e)) && US(t.charCodeAt(e - 1)) && e--;
  let r = Nr(t, e);
  for (e += Mi(r); e < t.length; ) {
    let i = Nr(t, e);
    if (r == r2 || i == r2 || n && yB(i))
      e += Mi(i), r = i;
    else if (n2(i)) {
      let o = 0, s = e - 2;
      for (; s >= 0 && n2(Nr(t, s)); )
        o++, s -= 2;
      if (o % 2 == 0)
        break;
      e += 2;
    } else
      break;
  }
  return e;
}
function bB(t, e, n) {
  for (; e > 0; ) {
    let r = VS(t, e - 2, n);
    if (r < e)
      return r;
    e--;
  }
  return 0;
}
function HS(t) {
  return t >= 56320 && t < 57344;
}
function US(t) {
  return t >= 55296 && t < 56320;
}
function Nr(t, e) {
  let n = t.charCodeAt(e);
  if (!US(n) || e + 1 == t.length)
    return n;
  let r = t.charCodeAt(e + 1);
  return HS(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function z0(t) {
  return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10) + 55296, (t & 1023) + 56320));
}
function Mi(t) {
  return t < 65536 ? 1 : 2;
}
const Eg = /\r\n?|\n/;
var ni = /* @__PURE__ */ function(t) {
  return t[t.Simple = 0] = "Simple", t[t.TrackDel = 1] = "TrackDel", t[t.TrackBefore = 2] = "TrackBefore", t[t.TrackAfter = 3] = "TrackAfter", t;
}(ni || (ni = {}));
class Bo {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(e) {
    this.sections = e;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2)
      e += this.sections[n];
    return e;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n + 1];
      e += r < 0 ? this.sections[n] : r;
    }
    return e;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(e) {
    for (let n = 0, r = 0, i = 0; n < this.sections.length; ) {
      let o = this.sections[n++], s = this.sections[n++];
      s < 0 ? (e(r, i, o), i += o) : i += s, r += o;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(e, n = !1) {
    Ag(this, e, n);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let e = [];
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], i = this.sections[n++];
      i < 0 ? e.push(r, i) : e.push(i, r);
    }
    return new Bo(e);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(e) {
    return this.empty ? e : e.empty ? this : WS(this, e);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `other` happened before the ones in `this`.
  */
  mapDesc(e, n = !1) {
    return e.empty ? this : Mg(this, e, n);
  }
  mapPos(e, n = -1, r = ni.Simple) {
    let i = 0, o = 0;
    for (let s = 0; s < this.sections.length; ) {
      let a = this.sections[s++], l = this.sections[s++], c = i + a;
      if (l < 0) {
        if (c > e)
          return o + (e - i);
        o += a;
      } else {
        if (r != ni.Simple && c >= e && (r == ni.TrackDel && i < e && c > e || r == ni.TrackBefore && i < e || r == ni.TrackAfter && c > e))
          return null;
        if (c > e || c == e && n < 0 && !a)
          return e == i || n < 0 ? o : o + l;
        o += l;
      }
      i = c;
    }
    if (e > i)
      throw new RangeError(`Position ${e} is out of range for changeset of length ${i}`);
    return o;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(e, n = e) {
    for (let r = 0, i = 0; r < this.sections.length && i <= n; ) {
      let o = this.sections[r++], s = this.sections[r++], a = i + o;
      if (s >= 0 && i <= n && a >= e)
        return i < e && a > n ? "cover" : !0;
      i = a;
    }
    return !1;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], i = this.sections[n++];
      e += (e ? " " : "") + r + (i >= 0 ? ":" + i : "");
    }
    return e;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e) || e.length % 2 || e.some((n) => typeof n != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new Bo(e);
  }
  /**
  @internal
  */
  static create(e) {
    return new Bo(e);
  }
}
class $r extends Bo {
  constructor(e, n) {
    super(e), this.inserted = n;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(e) {
    if (this.length != e.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return Ag(this, (n, r, i, o, s) => e = e.replace(i, i + (r - n), s), !1), e;
  }
  mapDesc(e, n = !1) {
    return Mg(this, e, n, !0);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(e) {
    let n = this.sections.slice(), r = [];
    for (let i = 0, o = 0; i < n.length; i += 2) {
      let s = n[i], a = n[i + 1];
      if (a >= 0) {
        n[i] = a, n[i + 1] = s;
        let l = i >> 1;
        for (; r.length < l; )
          r.push(Cn.empty);
        r.push(s ? e.slice(o, o + s) : Cn.empty);
      }
      o += s;
    }
    return new $r(n, r);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(e) {
    return this.empty ? e : e.empty ? this : WS(this, e, !0);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(e, n = !1) {
    return e.empty ? this : Mg(this, e, n, !0);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(e, n = !1) {
    Ag(this, e, n);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return Bo.create(this.sections);
  }
  /**
  @internal
  */
  filter(e) {
    let n = [], r = [], i = [], o = new Cu(this);
    e:
      for (let s = 0, a = 0; ; ) {
        let l = s == e.length ? 1e9 : e[s++];
        for (; a < l || a == l && o.len == 0; ) {
          if (o.done)
            break e;
          let u = Math.min(o.len, l - a);
          Ur(i, u, -1);
          let f = o.ins == -1 ? -1 : o.off == 0 ? o.ins : 0;
          Ur(n, u, f), f > 0 && Ls(r, n, o.text), o.forward(u), a += u;
        }
        let c = e[s++];
        for (; a < c; ) {
          if (o.done)
            break e;
          let u = Math.min(o.len, c - a);
          Ur(n, u, -1), Ur(i, u, o.ins == -1 ? -1 : o.off == 0 ? o.ins : 0), o.forward(u), a += u;
        }
      }
    return {
      changes: new $r(n, r),
      filtered: Bo.create(i)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let e = [];
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n], i = this.sections[n + 1];
      i < 0 ? e.push(r) : i == 0 ? e.push([r]) : e.push([r].concat(this.inserted[n >> 1].toJSON()));
    }
    return e;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(e, n, r) {
    let i = [], o = [], s = 0, a = null;
    function l(u = !1) {
      if (!u && !i.length)
        return;
      s < n && Ur(i, n - s, -1);
      let f = new $r(i, o);
      a = a ? a.compose(f.map(a)) : f, i = [], o = [], s = 0;
    }
    function c(u) {
      if (Array.isArray(u))
        for (let f of u)
          c(f);
      else if (u instanceof $r) {
        if (u.length != n)
          throw new RangeError(`Mismatched change set length (got ${u.length}, expected ${n})`);
        l(), a = a ? a.compose(u.map(a)) : u;
      } else {
        let { from: f, to: d = f, insert: h } = u;
        if (f > d || f < 0 || d > n)
          throw new RangeError(`Invalid change range ${f} to ${d} (in doc of length ${n})`);
        let p = h ? typeof h == "string" ? Cn.of(h.split(r || Eg)) : h : Cn.empty, m = p.length;
        if (f == d && m == 0)
          return;
        f < s && l(), f > s && Ur(i, f - s, -1), Ur(i, d - f, m), Ls(o, i, p), s = d;
      }
    }
    return c(e), l(!a), a;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(e) {
    return new $r(e ? [e, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let n = [], r = [];
    for (let i = 0; i < e.length; i++) {
      let o = e[i];
      if (typeof o == "number")
        n.push(o, -1);
      else {
        if (!Array.isArray(o) || typeof o[0] != "number" || o.some((s, a) => a && typeof s != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (o.length == 1)
          n.push(o[0], 0);
        else {
          for (; r.length < i; )
            r.push(Cn.empty);
          r[i] = Cn.of(o.slice(1)), n.push(o[0], r[i].length);
        }
      }
    }
    return new $r(n, r);
  }
  /**
  @internal
  */
  static createSet(e, n) {
    return new $r(e, n);
  }
}
function Ur(t, e, n, r = !1) {
  if (e == 0 && n <= 0)
    return;
  let i = t.length - 2;
  i >= 0 && n <= 0 && n == t[i + 1] ? t[i] += e : e == 0 && t[i] == 0 ? t[i + 1] += n : r ? (t[i] += e, t[i + 1] += n) : t.push(e, n);
}
function Ls(t, e, n) {
  if (n.length == 0)
    return;
  let r = e.length - 2 >> 1;
  if (r < t.length)
    t[t.length - 1] = t[t.length - 1].append(n);
  else {
    for (; t.length < r; )
      t.push(Cn.empty);
    t.push(n);
  }
}
function Ag(t, e, n) {
  let r = t.inserted;
  for (let i = 0, o = 0, s = 0; s < t.sections.length; ) {
    let a = t.sections[s++], l = t.sections[s++];
    if (l < 0)
      i += a, o += a;
    else {
      let c = i, u = o, f = Cn.empty;
      for (; c += a, u += l, l && r && (f = f.append(r[s - 2 >> 1])), !(n || s == t.sections.length || t.sections[s + 1] < 0); )
        a = t.sections[s++], l = t.sections[s++];
      e(i, c, o, u, f), i = c, o = u;
    }
  }
}
function Mg(t, e, n, r = !1) {
  let i = [], o = r ? [] : null, s = new Cu(t), a = new Cu(e);
  for (let l = -1; ; )
    if (s.ins == -1 && a.ins == -1) {
      let c = Math.min(s.len, a.len);
      Ur(i, c, -1), s.forward(c), a.forward(c);
    } else if (a.ins >= 0 && (s.ins < 0 || l == s.i || s.off == 0 && (a.len < s.len || a.len == s.len && !n))) {
      let c = a.len;
      for (Ur(i, a.ins, -1); c; ) {
        let u = Math.min(s.len, c);
        s.ins >= 0 && l < s.i && s.len <= u && (Ur(i, 0, s.ins), o && Ls(o, i, s.text), l = s.i), s.forward(u), c -= u;
      }
      a.next();
    } else if (s.ins >= 0) {
      let c = 0, u = s.len;
      for (; u; )
        if (a.ins == -1) {
          let f = Math.min(u, a.len);
          c += f, u -= f, a.forward(f);
        } else if (a.ins == 0 && a.len < u)
          u -= a.len, a.next();
        else
          break;
      Ur(i, c, l < s.i ? s.ins : 0), o && l < s.i && Ls(o, i, s.text), l = s.i, s.forward(s.len - u);
    } else {
      if (s.done && a.done)
        return o ? $r.createSet(i, o) : Bo.create(i);
      throw new Error("Mismatched change set lengths");
    }
}
function WS(t, e, n = !1) {
  let r = [], i = n ? [] : null, o = new Cu(t), s = new Cu(e);
  for (let a = !1; ; ) {
    if (o.done && s.done)
      return i ? $r.createSet(r, i) : Bo.create(r);
    if (o.ins == 0)
      Ur(r, o.len, 0, a), o.next();
    else if (s.len == 0 && !s.done)
      Ur(r, 0, s.ins, a), i && Ls(i, r, s.text), s.next();
    else {
      if (o.done || s.done)
        throw new Error("Mismatched change set lengths");
      {
        let l = Math.min(o.len2, s.len), c = r.length;
        if (o.ins == -1) {
          let u = s.ins == -1 ? -1 : s.off ? 0 : s.ins;
          Ur(r, l, u, a), i && u && Ls(i, r, s.text);
        } else
          s.ins == -1 ? (Ur(r, o.off ? 0 : o.len, l, a), i && Ls(i, r, o.textBit(l))) : (Ur(r, o.off ? 0 : o.len, s.off ? 0 : s.ins, a), i && !s.off && Ls(i, r, s.text));
        a = (o.ins > l || s.ins >= 0 && s.len > l) && (a || r.length > c), o.forward2(l), s.forward(l);
      }
    }
  }
}
class Cu {
  constructor(e) {
    this.set = e, this.i = 0, this.next();
  }
  next() {
    let { sections: e } = this.set;
    this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: e } = this.set, n = this.i - 2 >> 1;
    return n >= e.length ? Cn.empty : e[n];
  }
  textBit(e) {
    let { inserted: n } = this.set, r = this.i - 2 >> 1;
    return r >= n.length && !e ? Cn.empty : n[r].slice(this.off, e == null ? void 0 : this.off + e);
  }
  forward(e) {
    e == this.len ? this.next() : (this.len -= e, this.off += e);
  }
  forward2(e) {
    this.ins == -1 ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
  }
}
class Aa {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.flags = r;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let e = this.flags & 7;
    return e == 7 ? null : e;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let e = this.flags >> 6;
    return e == 16777215 ? void 0 : e;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(e, n = -1) {
    let r, i;
    return this.empty ? r = i = e.mapPos(this.from, n) : (r = e.mapPos(this.from, 1), i = e.mapPos(this.to, -1)), r == this.from && i == this.to ? this : new Aa(r, i, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(e, n = e) {
    if (e <= this.anchor && n >= this.anchor)
      return Te.range(e, n);
    let r = Math.abs(e - this.anchor) > Math.abs(n - this.anchor) ? e : n;
    return Te.range(this.anchor, r);
  }
  /**
  Compare this range to another range.
  */
  eq(e) {
    return this.anchor == e.anchor && this.head == e.head;
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(e) {
    if (!e || typeof e.anchor != "number" || typeof e.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return Te.range(e.anchor, e.head);
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new Aa(e, n, r);
  }
}
class Te {
  constructor(e, n) {
    this.ranges = e, this.mainIndex = n;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(e, n = -1) {
    return e.empty ? this : Te.create(this.ranges.map((r) => r.map(e, n)), this.mainIndex);
  }
  /**
  Compare this selection to another selection.
  */
  eq(e) {
    if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex)
      return !1;
    for (let n = 0; n < this.ranges.length; n++)
      if (!this.ranges[n].eq(e.ranges[n]))
        return !1;
    return !0;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new Te([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(e, n = !0) {
    return Te.create([e].concat(this.ranges), n ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(e, n = this.mainIndex) {
    let r = this.ranges.slice();
    return r[n] = e, Te.create(r, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((e) => e.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(e) {
    if (!e || !Array.isArray(e.ranges) || typeof e.main != "number" || e.main >= e.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new Te(e.ranges.map((n) => Aa.fromJSON(n)), e.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(e, n = e) {
    return new Te([Te.range(e, n)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(e, n = 0) {
    if (e.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let r = 0, i = 0; i < e.length; i++) {
      let o = e[i];
      if (o.empty ? o.from <= r : o.from < r)
        return Te.normalized(e.slice(), n);
      r = o.to;
    }
    return new Te(e, n);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(e, n = 0, r, i) {
    return Aa.create(e, e, (n == 0 ? 0 : n < 0 ? 8 : 16) | (r == null ? 7 : Math.min(6, r)) | (i ?? 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(e, n, r, i) {
    let o = (r ?? 16777215) << 6 | (i == null ? 7 : Math.min(6, i));
    return n < e ? Aa.create(n, e, 48 | o) : Aa.create(e, n, (n > e ? 8 : 0) | o);
  }
  /**
  @internal
  */
  static normalized(e, n = 0) {
    let r = e[n];
    e.sort((i, o) => i.from - o.from), n = e.indexOf(r);
    for (let i = 1; i < e.length; i++) {
      let o = e[i], s = e[i - 1];
      if (o.empty ? o.from <= s.to : o.from < s.to) {
        let a = s.from, l = Math.max(o.to, s.to);
        i <= n && n--, e.splice(--i, 2, o.anchor > o.head ? Te.range(l, a) : Te.range(a, l));
      }
    }
    return new Te(e, n);
  }
}
function JS(t, e) {
  for (let n of t.ranges)
    if (n.to > e)
      throw new RangeError("Selection points outside of document");
}
let F0 = 0;
class vt {
  constructor(e, n, r, i, o) {
    this.combine = e, this.compareInput = n, this.compare = r, this.isStatic = i, this.id = F0++, this.default = e([]), this.extensions = typeof o == "function" ? o(this) : o;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(e = {}) {
    return new vt(e.combine || ((n) => n), e.compareInput || ((n, r) => n === r), e.compare || (e.combine ? (n, r) => n === r : V0), !!e.static, e.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(e) {
    return new Md([], this, 0, e);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(e, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new Md(e, this, 1, n);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(e, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new Md(e, this, 2, n);
  }
  from(e, n) {
    return n || (n = (r) => r), this.compute([e], (r) => n(r.field(e)));
  }
}
function V0(t, e) {
  return t == e || t.length == e.length && t.every((n, r) => n === e[r]);
}
class Md {
  constructor(e, n, r, i) {
    this.dependencies = e, this.facet = n, this.type = r, this.value = i, this.id = F0++;
  }
  dynamicSlot(e) {
    var n;
    let r = this.value, i = this.facet.compareInput, o = this.id, s = e[o] >> 1, a = this.type == 2, l = !1, c = !1, u = [];
    for (let f of this.dependencies)
      f == "doc" ? l = !0 : f == "selection" ? c = !0 : ((n = e[f.id]) !== null && n !== void 0 ? n : 1) & 1 || u.push(e[f.id]);
    return {
      create(f) {
        return f.values[s] = r(f), 1;
      },
      update(f, d) {
        if (l && d.docChanged || c && (d.docChanged || d.selection) || _g(f, u)) {
          let h = r(f);
          if (a ? !i2(h, f.values[s], i) : !i(h, f.values[s]))
            return f.values[s] = h, 1;
        }
        return 0;
      },
      reconfigure: (f, d) => {
        let h, p = d.config.address[o];
        if (p != null) {
          let m = oh(d, p);
          if (this.dependencies.every((g) => g instanceof vt ? d.facet(g) === f.facet(g) : g instanceof Cr ? d.field(g, !1) == f.field(g, !1) : !0) || (a ? i2(h = r(f), m, i) : i(h = r(f), m)))
            return f.values[s] = m, 0;
        } else
          h = r(f);
        return f.values[s] = h, 1;
      }
    };
  }
}
function i2(t, e, n) {
  if (t.length != e.length)
    return !1;
  for (let r = 0; r < t.length; r++)
    if (!n(t[r], e[r]))
      return !1;
  return !0;
}
function _g(t, e) {
  let n = !1;
  for (let r of e)
    tu(t, r) & 1 && (n = !0);
  return n;
}
function xB(t, e, n) {
  let r = n.map((l) => t[l.id]), i = n.map((l) => l.type), o = r.filter((l) => !(l & 1)), s = t[e.id] >> 1;
  function a(l) {
    let c = [];
    for (let u = 0; u < r.length; u++) {
      let f = oh(l, r[u]);
      if (i[u] == 2)
        for (let d of f)
          c.push(d);
      else
        c.push(f);
    }
    return e.combine(c);
  }
  return {
    create(l) {
      for (let c of r)
        tu(l, c);
      return l.values[s] = a(l), 1;
    },
    update(l, c) {
      if (!_g(l, o))
        return 0;
      let u = a(l);
      return e.compare(u, l.values[s]) ? 0 : (l.values[s] = u, 1);
    },
    reconfigure(l, c) {
      let u = _g(l, r), f = c.config.facets[e.id], d = c.facet(e);
      if (f && !u && V0(n, f))
        return l.values[s] = d, 0;
      let h = a(l);
      return e.compare(h, d) ? (l.values[s] = d, 0) : (l.values[s] = h, 1);
    }
  };
}
const o2 = /* @__PURE__ */ vt.define({ static: !0 });
class Cr {
  constructor(e, n, r, i, o) {
    this.id = e, this.createF = n, this.updateF = r, this.compareF = i, this.spec = o, this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(e) {
    let n = new Cr(F0++, e.create, e.update, e.compare || ((r, i) => r === i), e);
    return e.provide && (n.provides = e.provide(n)), n;
  }
  create(e) {
    let n = e.facet(o2).find((r) => r.field == this);
    return ((n == null ? void 0 : n.create) || this.createF)(e);
  }
  /**
  @internal
  */
  slot(e) {
    let n = e[this.id] >> 1;
    return {
      create: (r) => (r.values[n] = this.create(r), 1),
      update: (r, i) => {
        let o = r.values[n], s = this.updateF(o, i);
        return this.compareF(o, s) ? 0 : (r.values[n] = s, 1);
      },
      reconfigure: (r, i) => i.config.address[this.id] != null ? (r.values[n] = i.field(this), 0) : (r.values[n] = this.create(r), 1)
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(e) {
    return [this, o2.of({ field: this, create: e })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}
const ka = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function _c(t) {
  return (e) => new KS(e, t);
}
const vc = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ _c(ka.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ _c(ka.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ _c(ka.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ _c(ka.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ _c(ka.lowest)
};
class KS {
  constructor(e, n) {
    this.inner = e, this.prec = n;
  }
}
class ts {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(e) {
    return new Tg(this, e);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(e) {
    return ts.reconfigure.of({ compartment: this, extension: e });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(e) {
    return e.config.compartments.get(this);
  }
}
class Tg {
  constructor(e, n) {
    this.compartment = e, this.inner = n;
  }
}
class ih {
  constructor(e, n, r, i, o, s) {
    for (this.base = e, this.compartments = n, this.dynamicSlots = r, this.address = i, this.staticValues = o, this.facets = s, this.statusTemplate = []; this.statusTemplate.length < r.length; )
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(e) {
    let n = this.address[e.id];
    return n == null ? e.default : this.staticValues[n >> 1];
  }
  static resolve(e, n, r) {
    let i = [], o = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ new Map();
    for (let d of wB(e, n, s))
      d instanceof Cr ? i.push(d) : (o[d.facet.id] || (o[d.facet.id] = [])).push(d);
    let a = /* @__PURE__ */ Object.create(null), l = [], c = [];
    for (let d of i)
      a[d.id] = c.length << 1, c.push((h) => d.slot(h));
    let u = r == null ? void 0 : r.config.facets;
    for (let d in o) {
      let h = o[d], p = h[0].facet, m = u && u[d] || [];
      if (h.every(
        (g) => g.type == 0
        /* Provider.Static */
      ))
        if (a[p.id] = l.length << 1 | 1, V0(m, h))
          l.push(r.facet(p));
        else {
          let g = p.combine(h.map((v) => v.value));
          l.push(r && p.compare(g, r.facet(p)) ? r.facet(p) : g);
        }
      else {
        for (let g of h)
          g.type == 0 ? (a[g.id] = l.length << 1 | 1, l.push(g.value)) : (a[g.id] = c.length << 1, c.push((v) => g.dynamicSlot(v)));
        a[p.id] = c.length << 1, c.push((g) => xB(g, p, h));
      }
    }
    let f = c.map((d) => d(a));
    return new ih(e, s, f, a, l, o);
  }
}
function wB(t, e, n) {
  let r = [[], [], [], [], []], i = /* @__PURE__ */ new Map();
  function o(s, a) {
    let l = i.get(s);
    if (l != null) {
      if (l <= a)
        return;
      let c = r[l].indexOf(s);
      c > -1 && r[l].splice(c, 1), s instanceof Tg && n.delete(s.compartment);
    }
    if (i.set(s, a), Array.isArray(s))
      for (let c of s)
        o(c, a);
    else if (s instanceof Tg) {
      if (n.has(s.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let c = e.get(s.compartment) || s.inner;
      n.set(s.compartment, c), o(c, a);
    } else if (s instanceof KS)
      o(s.inner, s.prec);
    else if (s instanceof Cr)
      r[a].push(s), s.provides && o(s.provides, a);
    else if (s instanceof Md)
      r[a].push(s), s.facet.extensions && o(s.facet.extensions, ka.default);
    else {
      let c = s.extension;
      if (!c)
        throw new Error(`Unrecognized extension value in extension set (${s}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      o(c, a);
    }
  }
  return o(t, ka.default), r.reduce((s, a) => s.concat(a));
}
function tu(t, e) {
  if (e & 1)
    return 2;
  let n = e >> 1, r = t.status[n];
  if (r == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (r & 2)
    return r;
  t.status[n] = 4;
  let i = t.computeSlot(t, t.config.dynamicSlots[n]);
  return t.status[n] = 2 | i;
}
function oh(t, e) {
  return e & 1 ? t.config.staticValues[e >> 1] : t.values[e >> 1];
}
const GS = /* @__PURE__ */ vt.define(), Pg = /* @__PURE__ */ vt.define({
  combine: (t) => t.some((e) => e),
  static: !0
}), QS = /* @__PURE__ */ vt.define({
  combine: (t) => t.length ? t[0] : void 0,
  static: !0
}), YS = /* @__PURE__ */ vt.define(), XS = /* @__PURE__ */ vt.define(), ZS = /* @__PURE__ */ vt.define(), eC = /* @__PURE__ */ vt.define({
  combine: (t) => t.length ? t[0] : !1
});
class Ss {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new jB();
  }
}
class jB {
  /**
  Create an instance of this annotation.
  */
  of(e) {
    return new Ss(this, e);
  }
}
class kB {
  /**
  @internal
  */
  constructor(e) {
    this.map = e;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(e) {
    return new ln(this, e);
  }
}
class ln {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(e) {
    let n = this.type.map(this.value, e);
    return n === void 0 ? void 0 : n == this.value ? this : new ln(this.type, n);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(e) {
    return this.type == e;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(e = {}) {
    return new kB(e.map || ((n) => n));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(e, n) {
    if (!e.length)
      return e;
    let r = [];
    for (let i of e) {
      let o = i.map(n);
      o && r.push(o);
    }
    return r;
  }
}
ln.reconfigure = /* @__PURE__ */ ln.define();
ln.appendConfig = /* @__PURE__ */ ln.define();
class Sr {
  constructor(e, n, r, i, o, s) {
    this.startState = e, this.changes = n, this.selection = r, this.effects = i, this.annotations = o, this.scrollIntoView = s, this._doc = null, this._state = null, r && JS(r, n.newLength), o.some((a) => a.type == Sr.time) || (this.annotations = o.concat(Sr.time.of(Date.now())));
  }
  /**
  @internal
  */
  static create(e, n, r, i, o, s) {
    return new Sr(e, n, r, i, o, s);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(e) {
    for (let n of this.annotations)
      if (n.type == e)
        return n.value;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(e) {
    let n = this.annotation(Sr.userEvent);
    return !!(n && (n == e || n.length > e.length && n.slice(0, e.length) == e && n[e.length] == "."));
  }
}
Sr.time = /* @__PURE__ */ Ss.define();
Sr.userEvent = /* @__PURE__ */ Ss.define();
Sr.addToHistory = /* @__PURE__ */ Ss.define();
Sr.remote = /* @__PURE__ */ Ss.define();
function $B(t, e) {
  let n = [];
  for (let r = 0, i = 0; ; ) {
    let o, s;
    if (r < t.length && (i == e.length || e[i] >= t[r]))
      o = t[r++], s = t[r++];
    else if (i < e.length)
      o = e[i++], s = e[i++];
    else
      return n;
    !n.length || n[n.length - 1] < o ? n.push(o, s) : n[n.length - 1] < s && (n[n.length - 1] = s);
  }
}
function tC(t, e, n) {
  var r;
  let i, o, s;
  return n ? (i = e.changes, o = $r.empty(e.changes.length), s = t.changes.compose(e.changes)) : (i = e.changes.map(t.changes), o = t.changes.mapDesc(e.changes, !0), s = t.changes.compose(i)), {
    changes: s,
    selection: e.selection ? e.selection.map(o) : (r = t.selection) === null || r === void 0 ? void 0 : r.map(i),
    effects: ln.mapEffects(t.effects, i).concat(ln.mapEffects(e.effects, o)),
    annotations: t.annotations.length ? t.annotations.concat(e.annotations) : e.annotations,
    scrollIntoView: t.scrollIntoView || e.scrollIntoView
  };
}
function Rg(t, e, n) {
  let r = e.selection, i = Rl(e.annotations);
  return e.userEvent && (i = i.concat(Sr.userEvent.of(e.userEvent))), {
    changes: e.changes instanceof $r ? e.changes : $r.of(e.changes || [], n, t.facet(QS)),
    selection: r && (r instanceof Te ? r : Te.single(r.anchor, r.head)),
    effects: Rl(e.effects),
    annotations: i,
    scrollIntoView: !!e.scrollIntoView
  };
}
function nC(t, e, n) {
  let r = Rg(t, e.length ? e[0] : {}, t.doc.length);
  e.length && e[0].filter === !1 && (n = !1);
  for (let o = 1; o < e.length; o++) {
    e[o].filter === !1 && (n = !1);
    let s = !!e[o].sequential;
    r = tC(r, Rg(t, e[o], s ? r.changes.newLength : t.doc.length), s);
  }
  let i = Sr.create(t, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return CB(n ? SB(i) : i);
}
function SB(t) {
  let e = t.startState, n = !0;
  for (let i of e.facet(YS)) {
    let o = i(t);
    if (o === !1) {
      n = !1;
      break;
    }
    Array.isArray(o) && (n = n === !0 ? o : $B(n, o));
  }
  if (n !== !0) {
    let i, o;
    if (n === !1)
      o = t.changes.invertedDesc, i = $r.empty(e.doc.length);
    else {
      let s = t.changes.filter(n);
      i = s.changes, o = s.filtered.mapDesc(s.changes).invertedDesc;
    }
    t = Sr.create(e, i, t.selection && t.selection.map(o), ln.mapEffects(t.effects, o), t.annotations, t.scrollIntoView);
  }
  let r = e.facet(XS);
  for (let i = r.length - 1; i >= 0; i--) {
    let o = r[i](t);
    o instanceof Sr ? t = o : Array.isArray(o) && o.length == 1 && o[0] instanceof Sr ? t = o[0] : t = nC(e, Rl(o), !1);
  }
  return t;
}
function CB(t) {
  let e = t.startState, n = e.facet(ZS), r = t;
  for (let i = n.length - 1; i >= 0; i--) {
    let o = n[i](t);
    o && Object.keys(o).length && (r = tC(r, Rg(e, o, t.changes.newLength), !0));
  }
  return r == t ? t : Sr.create(e, t.changes, t.selection, r.effects, r.annotations, r.scrollIntoView);
}
const OB = [];
function Rl(t) {
  return t == null ? OB : Array.isArray(t) ? t : [t];
}
var rr = /* @__PURE__ */ function(t) {
  return t[t.Word = 0] = "Word", t[t.Space = 1] = "Space", t[t.Other = 2] = "Other", t;
}(rr || (rr = {}));
const EB = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let Ng;
try {
  Ng = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function AB(t) {
  if (Ng)
    return Ng.test(t);
  for (let e = 0; e < t.length; e++) {
    let n = t[e];
    if (/\w/.test(n) || n > "" && (n.toUpperCase() != n.toLowerCase() || EB.test(n)))
      return !0;
  }
  return !1;
}
function MB(t) {
  return (e) => {
    if (!/\S/.test(e))
      return rr.Space;
    if (AB(e))
      return rr.Word;
    for (let n = 0; n < t.length; n++)
      if (e.indexOf(t[n]) > -1)
        return rr.Word;
    return rr.Other;
  };
}
class gn {
  constructor(e, n, r, i, o, s) {
    this.config = e, this.doc = n, this.selection = r, this.values = i, this.status = e.statusTemplate.slice(), this.computeSlot = o, s && (s._state = this);
    for (let a = 0; a < this.config.dynamicSlots.length; a++)
      tu(this, a << 1);
    this.computeSlot = null;
  }
  field(e, n = !0) {
    let r = this.config.address[e.id];
    if (r == null) {
      if (n)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return tu(this, r), oh(this, r);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...e) {
    return nC(this, e, !0);
  }
  /**
  @internal
  */
  applyTransaction(e) {
    let n = this.config, { base: r, compartments: i } = n;
    for (let a of e.effects)
      a.is(ts.reconfigure) ? (n && (i = /* @__PURE__ */ new Map(), n.compartments.forEach((l, c) => i.set(c, l)), n = null), i.set(a.value.compartment, a.value.extension)) : a.is(ln.reconfigure) ? (n = null, r = a.value) : a.is(ln.appendConfig) && (n = null, r = Rl(r).concat(a.value));
    let o;
    n ? o = e.startState.values.slice() : (n = ih.resolve(r, i, this), o = new gn(n, this.doc, this.selection, n.dynamicSlots.map(() => null), (l, c) => c.reconfigure(l, this), null).values);
    let s = e.startState.facet(Pg) ? e.newSelection : e.newSelection.asSingle();
    new gn(n, e.newDoc, s, o, (a, l) => l.update(a, e), e);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(e) {
    return typeof e == "string" && (e = this.toText(e)), this.changeByRange((n) => ({
      changes: { from: n.from, to: n.to, insert: e },
      range: Te.cursor(n.from + e.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(e) {
    let n = this.selection, r = e(n.ranges[0]), i = this.changes(r.changes), o = [r.range], s = Rl(r.effects);
    for (let a = 1; a < n.ranges.length; a++) {
      let l = e(n.ranges[a]), c = this.changes(l.changes), u = c.map(i);
      for (let d = 0; d < a; d++)
        o[d] = o[d].map(u);
      let f = i.mapDesc(c, !0);
      o.push(l.range.map(f)), i = i.compose(u), s = ln.mapEffects(s, u).concat(ln.mapEffects(Rl(l.effects), f));
    }
    return {
      changes: i,
      selection: Te.create(o, n.mainIndex),
      effects: s
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(e = []) {
    return e instanceof $r ? e : $r.of(e, this.doc.length, this.facet(gn.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(e) {
    return Cn.of(e.split(this.facet(gn.lineSeparator) || Eg));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(e = 0, n = this.doc.length) {
    return this.doc.sliceString(e, n, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(e) {
    let n = this.config.address[e.id];
    return n == null ? e.default : (tu(this, n), oh(this, n));
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(e) {
    let n = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (e)
      for (let r in e) {
        let i = e[r];
        i instanceof Cr && this.config.address[i.id] != null && (n[r] = i.spec.toJSON(this.field(e[r]), this));
      }
    return n;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(e, n = {}, r) {
    if (!e || typeof e.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let i = [];
    if (r) {
      for (let o in r)
        if (Object.prototype.hasOwnProperty.call(e, o)) {
          let s = r[o], a = e[o];
          i.push(s.init((l) => s.spec.fromJSON(a, l)));
        }
    }
    return gn.create({
      doc: e.doc,
      selection: Te.fromJSON(e.selection),
      extensions: n.extensions ? i.concat([n.extensions]) : i
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(e = {}) {
    let n = ih.resolve(e.extensions || [], /* @__PURE__ */ new Map()), r = e.doc instanceof Cn ? e.doc : Cn.of((e.doc || "").split(n.staticFacet(gn.lineSeparator) || Eg)), i = e.selection ? e.selection instanceof Te ? e.selection : Te.single(e.selection.anchor, e.selection.head) : Te.single(0);
    return JS(i, r.length), n.staticFacet(Pg) || (i = i.asSingle()), new gn(n, r, i, n.dynamicSlots.map(() => null), (o, s) => s.create(o), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(gn.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(gn.lineSeparator) || `
`;
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(eC);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(e, ...n) {
    for (let r of this.facet(gn.phrases))
      if (Object.prototype.hasOwnProperty.call(r, e)) {
        e = r[e];
        break;
      }
    return n.length && (e = e.replace(/\$(\$|\d*)/g, (r, i) => {
      if (i == "$")
        return "$";
      let o = +(i || 1);
      return !o || o > n.length ? r : n[o - 1];
    })), e;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(e, n, r = -1) {
    let i = [];
    for (let o of this.facet(GS))
      for (let s of o(this, n, r))
        Object.prototype.hasOwnProperty.call(s, e) && i.push(s[e]);
    return i;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(e) {
    return MB(this.languageDataAt("wordChars", e).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(e) {
    let { text: n, from: r, length: i } = this.doc.lineAt(e), o = this.charCategorizer(e), s = e - r, a = e - r;
    for (; s > 0; ) {
      let l = Br(n, s, !1);
      if (o(n.slice(l, s)) != rr.Word)
        break;
      s = l;
    }
    for (; a < i; ) {
      let l = Br(n, a);
      if (o(n.slice(a, l)) != rr.Word)
        break;
      a = l;
    }
    return s == a ? null : Te.range(s + r, a + r);
  }
}
gn.allowMultipleSelections = Pg;
gn.tabSize = /* @__PURE__ */ vt.define({
  combine: (t) => t.length ? t[0] : 4
});
gn.lineSeparator = QS;
gn.readOnly = eC;
gn.phrases = /* @__PURE__ */ vt.define({
  compare(t, e) {
    let n = Object.keys(t), r = Object.keys(e);
    return n.length == r.length && n.every((i) => t[i] == e[i]);
  }
});
gn.languageData = GS;
gn.changeFilter = YS;
gn.transactionFilter = XS;
gn.transactionExtender = ZS;
ts.reconfigure = /* @__PURE__ */ ln.define();
function Ui(t, e, n = {}) {
  let r = {};
  for (let i of t)
    for (let o of Object.keys(i)) {
      let s = i[o], a = r[o];
      if (a === void 0)
        r[o] = s;
      else if (!(a === s || s === void 0))
        if (Object.hasOwnProperty.call(n, o))
          r[o] = n[o](a, s);
        else
          throw new Error("Config merge conflict for field " + o);
    }
  for (let i in e)
    r[i] === void 0 && (r[i] = e[i]);
  return r;
}
class za {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(e) {
    return this == e;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(e, n = e) {
    return Ig.create(e, n, this);
  }
}
za.prototype.startSide = za.prototype.endSide = 0;
za.prototype.point = !1;
za.prototype.mapMode = ni.TrackDel;
let Ig = class rC {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.value = r;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new rC(e, n, r);
  }
};
function Dg(t, e) {
  return t.from - e.from || t.value.startSide - e.value.startSide;
}
class H0 {
  constructor(e, n, r, i) {
    this.from = e, this.to = n, this.value = r, this.maxPoint = i;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(e, n, r, i = 0) {
    let o = r ? this.to : this.from;
    for (let s = i, a = o.length; ; ) {
      if (s == a)
        return s;
      let l = s + a >> 1, c = o[l] - e || (r ? this.value[l].endSide : this.value[l].startSide) - n;
      if (l == s)
        return c >= 0 ? s : a;
      c >= 0 ? a = l : s = l + 1;
    }
  }
  between(e, n, r, i) {
    for (let o = this.findIndex(n, -1e9, !0), s = this.findIndex(r, 1e9, !1, o); o < s; o++)
      if (i(this.from[o] + e, this.to[o] + e, this.value[o]) === !1)
        return !1;
  }
  map(e, n) {
    let r = [], i = [], o = [], s = -1, a = -1;
    for (let l = 0; l < this.value.length; l++) {
      let c = this.value[l], u = this.from[l] + e, f = this.to[l] + e, d, h;
      if (u == f) {
        let p = n.mapPos(u, c.startSide, c.mapMode);
        if (p == null || (d = h = p, c.startSide != c.endSide && (h = n.mapPos(u, c.endSide), h < d)))
          continue;
      } else if (d = n.mapPos(u, c.startSide), h = n.mapPos(f, c.endSide), d > h || d == h && c.startSide > 0 && c.endSide <= 0)
        continue;
      (h - d || c.endSide - c.startSide) < 0 || (s < 0 && (s = d), c.point && (a = Math.max(a, h - d)), r.push(c), i.push(d - s), o.push(h - s));
    }
    return { mapped: r.length ? new H0(i, o, r, a) : null, pos: s };
  }
}
class En {
  constructor(e, n, r, i) {
    this.chunkPos = e, this.chunk = n, this.nextLayer = r, this.maxPoint = i;
  }
  /**
  @internal
  */
  static create(e, n, r, i) {
    return new En(e, n, r, i);
  }
  /**
  @internal
  */
  get length() {
    let e = this.chunk.length - 1;
    return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let e = this.nextLayer.size;
    for (let n of this.chunk)
      e += n.value.length;
    return e;
  }
  /**
  @internal
  */
  chunkEnd(e) {
    return this.chunkPos[e] + this.chunk[e].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(e) {
    let { add: n = [], sort: r = !1, filterFrom: i = 0, filterTo: o = this.length } = e, s = e.filter;
    if (n.length == 0 && !s)
      return this;
    if (r && (n = n.slice().sort(Dg)), this.isEmpty)
      return n.length ? En.of(n) : this;
    let a = new iC(this, null, -1).goto(0), l = 0, c = [], u = new Fo();
    for (; a.value || l < n.length; )
      if (l < n.length && (a.from - n[l].from || a.startSide - n[l].value.startSide) >= 0) {
        let f = n[l++];
        u.addInner(f.from, f.to, f.value) || c.push(f);
      } else
        a.rangeIndex == 1 && a.chunkIndex < this.chunk.length && (l == n.length || this.chunkEnd(a.chunkIndex) < n[l].from) && (!s || i > this.chunkEnd(a.chunkIndex) || o < this.chunkPos[a.chunkIndex]) && u.addChunk(this.chunkPos[a.chunkIndex], this.chunk[a.chunkIndex]) ? a.nextChunk() : ((!s || i > a.to || o < a.from || s(a.from, a.to, a.value)) && (u.addInner(a.from, a.to, a.value) || c.push(Ig.create(a.from, a.to, a.value))), a.next());
    return u.finishInner(this.nextLayer.isEmpty && !c.length ? En.empty : this.nextLayer.update({ add: c, filter: s, filterFrom: i, filterTo: o }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(e) {
    if (e.empty || this.isEmpty)
      return this;
    let n = [], r = [], i = -1;
    for (let s = 0; s < this.chunk.length; s++) {
      let a = this.chunkPos[s], l = this.chunk[s], c = e.touchesRange(a, a + l.length);
      if (c === !1)
        i = Math.max(i, l.maxPoint), n.push(l), r.push(e.mapPos(a));
      else if (c === !0) {
        let { mapped: u, pos: f } = l.map(a, e);
        u && (i = Math.max(i, u.maxPoint), n.push(u), r.push(f));
      }
    }
    let o = this.nextLayer.map(e);
    return n.length == 0 ? o : new En(r, n, o || En.empty, i);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(e, n, r) {
    if (!this.isEmpty) {
      for (let i = 0; i < this.chunk.length; i++) {
        let o = this.chunkPos[i], s = this.chunk[i];
        if (n >= o && e <= o + s.length && s.between(o, e - o, n - o, r) === !1)
          return;
      }
      this.nextLayer.between(e, n, r);
    }
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(e = 0) {
    return Ou.from([this]).goto(e);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(e, n = 0) {
    return Ou.from(e).goto(n);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(e, n, r, i, o = -1) {
    let s = e.filter((f) => f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= o), a = n.filter((f) => f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= o), l = s2(s, a, r), c = new Tc(s, l, o), u = new Tc(a, l, o);
    r.iterGaps((f, d, h) => a2(c, f, u, d, h, i)), r.empty && r.length == 0 && a2(c, 0, u, 0, 0, i);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(e, n, r = 0, i) {
    i == null && (i = 999999999);
    let o = e.filter((u) => !u.isEmpty && n.indexOf(u) < 0), s = n.filter((u) => !u.isEmpty && e.indexOf(u) < 0);
    if (o.length != s.length)
      return !1;
    if (!o.length)
      return !0;
    let a = s2(o, s), l = new Tc(o, a, 0).goto(r), c = new Tc(s, a, 0).goto(r);
    for (; ; ) {
      if (l.to != c.to || !Lg(l.active, c.active) || l.point && (!c.point || !l.point.eq(c.point)))
        return !1;
      if (l.to > i)
        return !0;
      l.next(), c.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(e, n, r, i, o = -1) {
    let s = new Tc(e, null, o).goto(n), a = n, l = s.openStart;
    for (; ; ) {
      let c = Math.min(s.to, r);
      if (s.point) {
        let u = s.activeForPoint(s.to), f = s.pointFrom < n ? u.length + 1 : Math.min(u.length, l);
        i.point(a, c, s.point, u, f, s.pointRank), l = Math.min(s.openEnd(c), u.length);
      } else
        c > a && (i.span(a, c, s.active, l), l = s.openEnd(c));
      if (s.to > r)
        return l + (s.point && s.to > r ? 1 : 0);
      a = s.to, s.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(e, n = !1) {
    let r = new Fo();
    for (let i of e instanceof Ig ? [e] : n ? _B(e) : e)
      r.add(i.from, i.to, i.value);
    return r.finish();
  }
}
En.empty = /* @__PURE__ */ new En([], [], null, -1);
function _B(t) {
  if (t.length > 1)
    for (let e = t[0], n = 1; n < t.length; n++) {
      let r = t[n];
      if (Dg(e, r) > 0)
        return t.slice().sort(Dg);
      e = r;
    }
  return t;
}
En.empty.nextLayer = En.empty;
class Fo {
  finishChunk(e) {
    this.chunks.push(new H0(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(e, n, r) {
    this.addInner(e, n, r) || (this.nextLayer || (this.nextLayer = new Fo())).add(e, n, r);
  }
  /**
  @internal
  */
  addInner(e, n, r) {
    let i = e - this.lastTo || r.startSide - this.last.endSide;
    if (i <= 0 && (e - this.lastFrom || r.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return i < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(n - this.chunkStart), this.last = r, this.lastFrom = e, this.lastTo = n, this.value.push(r), r.point && (this.maxPoint = Math.max(this.maxPoint, n - e)), !0);
  }
  /**
  @internal
  */
  addChunk(e, n) {
    if ((e - this.lastTo || n.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, n.maxPoint), this.chunks.push(n), this.chunkPos.push(e);
    let r = n.value.length - 1;
    return this.last = n.value[r], this.lastFrom = n.from[r] + e, this.lastTo = n.to[r] + e, !0;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(En.empty);
  }
  /**
  @internal
  */
  finishInner(e) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return e;
    let n = En.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
    return this.from = null, n;
  }
}
function s2(t, e, n) {
  let r = /* @__PURE__ */ new Map();
  for (let o of t)
    for (let s = 0; s < o.chunk.length; s++)
      o.chunk[s].maxPoint <= 0 && r.set(o.chunk[s], o.chunkPos[s]);
  let i = /* @__PURE__ */ new Set();
  for (let o of e)
    for (let s = 0; s < o.chunk.length; s++) {
      let a = r.get(o.chunk[s]);
      a != null && (n ? n.mapPos(a) : a) == o.chunkPos[s] && !(n != null && n.touchesRange(a, a + o.chunk[s].length)) && i.add(o.chunk[s]);
    }
  return i;
}
class iC {
  constructor(e, n, r, i = 0) {
    this.layer = e, this.skip = n, this.minPoint = r, this.rank = i;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(e, n = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, n, !1), this;
  }
  gotoInner(e, n, r) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let i = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(i) || this.layer.chunkEnd(this.chunkIndex) < e || i.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, r = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let i = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], n, !0);
      (!r || this.rangeIndex < i) && this.setRangeIndex(i);
    }
    this.next();
  }
  forward(e, n) {
    (this.to - e || this.endSide - n) < 0 && this.gotoInner(e, n, !0);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let e = this.layer.chunkPos[this.chunkIndex], n = this.layer.chunk[this.chunkIndex], r = e + n.from[this.rangeIndex];
        if (this.from = r, this.to = e + n.to[this.rangeIndex], this.value = n.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(e) {
    if (e == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = e;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(e) {
    return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
  }
}
class Ou {
  constructor(e) {
    this.heap = e;
  }
  static from(e, n = null, r = -1) {
    let i = [];
    for (let o = 0; o < e.length; o++)
      for (let s = e[o]; !s.isEmpty; s = s.nextLayer)
        s.maxPoint >= r && i.push(new iC(s, n, r, o));
    return i.length == 1 ? i[0] : new Ou(i);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(e, n = -1e9) {
    for (let r of this.heap)
      r.goto(e, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      pm(this.heap, r);
    return this.next(), this;
  }
  forward(e, n) {
    for (let r of this.heap)
      r.forward(e, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      pm(this.heap, r);
    (this.to - e || this.value.endSide - n) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let e = this.heap[0];
      this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), pm(this.heap, 0);
    }
  }
}
function pm(t, e) {
  for (let n = t[e]; ; ) {
    let r = (e << 1) + 1;
    if (r >= t.length)
      break;
    let i = t[r];
    if (r + 1 < t.length && i.compare(t[r + 1]) >= 0 && (i = t[r + 1], r++), n.compare(i) < 0)
      break;
    t[r] = n, t[e] = i, e = r;
  }
}
class Tc {
  constructor(e, n, r) {
    this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = Ou.from(e, n, r);
  }
  goto(e, n = -1e9) {
    return this.cursor.goto(e, n), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = n, this.openStart = -1, this.next(), this;
  }
  forward(e, n) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - n) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(e, n);
  }
  removeActive(e) {
    Nf(this.active, e), Nf(this.activeTo, e), Nf(this.activeRank, e), this.minActive = l2(this.active, this.activeTo);
  }
  addActive(e) {
    let n = 0, { value: r, to: i, rank: o } = this.cursor;
    for (; n < this.activeRank.length && this.activeRank[n] <= o; )
      n++;
    If(this.active, n, r), If(this.activeTo, n, i), If(this.activeRank, n, o), e && If(e, n, this.cursor.from), this.minActive = l2(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let e = this.to, n = this.point;
    this.point = null;
    let r = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let i = this.minActive;
      if (i > -1 && (this.activeTo[i] - this.cursor.from || this.active[i].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[i] > e) {
          this.to = this.activeTo[i], this.endSide = this.active[i].endSide;
          break;
        }
        this.removeActive(i), r && Nf(r, i);
      } else if (this.cursor.value)
        if (this.cursor.from > e) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let o = this.cursor.value;
          if (!o.point)
            this.addActive(r), this.cursor.next();
          else if (n && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = o, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = o.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (r) {
      this.openStart = 0;
      for (let i = r.length - 1; i >= 0 && r[i] < e; i--)
        this.openStart++;
    }
  }
  activeForPoint(e) {
    if (!this.active.length)
      return this.active;
    let n = [];
    for (let r = this.active.length - 1; r >= 0 && !(this.activeRank[r] < this.pointRank); r--)
      (this.activeTo[r] > e || this.activeTo[r] == e && this.active[r].endSide >= this.point.endSide) && n.push(this.active[r]);
    return n.reverse();
  }
  openEnd(e) {
    let n = 0;
    for (let r = this.activeTo.length - 1; r >= 0 && this.activeTo[r] > e; r--)
      n++;
    return n;
  }
}
function a2(t, e, n, r, i, o) {
  t.goto(e), n.goto(r);
  let s = r + i, a = r, l = r - e;
  for (; ; ) {
    let c = t.to + l - n.to || t.endSide - n.endSide, u = c < 0 ? t.to + l : n.to, f = Math.min(u, s);
    if (t.point || n.point ? t.point && n.point && (t.point == n.point || t.point.eq(n.point)) && Lg(t.activeForPoint(t.to), n.activeForPoint(n.to)) || o.comparePoint(a, f, t.point, n.point) : f > a && !Lg(t.active, n.active) && o.compareRange(a, f, t.active, n.active), u > s)
      break;
    a = u, c <= 0 && t.next(), c >= 0 && n.next();
  }
}
function Lg(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] != e[n] && !t[n].eq(e[n]))
      return !1;
  return !0;
}
function Nf(t, e) {
  for (let n = e, r = t.length - 1; n < r; n++)
    t[n] = t[n + 1];
  t.pop();
}
function If(t, e, n) {
  for (let r = t.length - 1; r >= e; r--)
    t[r + 1] = t[r];
  t[e] = n;
}
function l2(t, e) {
  let n = -1, r = 1e9;
  for (let i = 0; i < e.length; i++)
    (e[i] - r || t[i].endSide - t[n].endSide) < 0 && (n = i, r = e[i]);
  return n;
}
function yc(t, e, n = t.length) {
  let r = 0;
  for (let i = 0; i < n; )
    t.charCodeAt(i) == 9 ? (r += e - r % e, i++) : (r++, i = Br(t, i));
  return r;
}
function Bg(t, e, n, r) {
  for (let i = 0, o = 0; ; ) {
    if (o >= e)
      return i;
    if (i == t.length)
      break;
    o += t.charCodeAt(i) == 9 ? n - o % n : 1, i = Br(t, i);
  }
  return r === !0 ? -1 : t.length;
}
const qg = "ͼ", c2 = typeof Symbol > "u" ? "__" + qg : Symbol.for(qg), zg = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), u2 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
class ta {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(e, n) {
    this.rules = [];
    let { finish: r } = n || {};
    function i(s) {
      return /^@/.test(s) ? [s] : s.split(/,\s*/);
    }
    function o(s, a, l, c) {
      let u = [], f = /^@(\w+)\b/.exec(s[0]), d = f && f[1] == "keyframes";
      if (f && a == null)
        return l.push(s[0] + ";");
      for (let h in a) {
        let p = a[h];
        if (/&/.test(h))
          o(
            h.split(/,\s*/).map((m) => s.map((g) => m.replace(/&/, g))).reduce((m, g) => m.concat(g)),
            p,
            l
          );
        else if (p && typeof p == "object") {
          if (!f)
            throw new RangeError("The value of a property (" + h + ") should be a primitive value.");
          o(i(h), p, u, d);
        } else
          p != null && u.push(h.replace(/_.*/, "").replace(/[A-Z]/g, (m) => "-" + m.toLowerCase()) + ": " + p + ";");
      }
      (u.length || d) && l.push((r && !f && !c ? s.map(r) : s).join(", ") + " {" + u.join(" ") + "}");
    }
    for (let s in e)
      o(i(s), e[s], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let e = u2[c2] || 1;
    return u2[c2] = e + 1, qg + e.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(e, n, r) {
    let i = e[zg], o = r && r.nonce;
    i ? o && i.setNonce(o) : i = new TB(e, o), i.mount(Array.isArray(n) ? n : [n]);
  }
}
let f2 = /* @__PURE__ */ new Map();
class TB {
  constructor(e, n) {
    let r = e.ownerDocument || e, i = r.defaultView;
    if (!e.head && e.adoptedStyleSheets && i.CSSStyleSheet) {
      let o = f2.get(r);
      if (o)
        return e.adoptedStyleSheets = [o.sheet, ...e.adoptedStyleSheets], e[zg] = o;
      this.sheet = new i.CSSStyleSheet(), e.adoptedStyleSheets = [this.sheet, ...e.adoptedStyleSheets], f2.set(r, this);
    } else {
      this.styleTag = r.createElement("style"), n && this.styleTag.setAttribute("nonce", n);
      let o = e.head || e;
      o.insertBefore(this.styleTag, o.firstChild);
    }
    this.modules = [], e[zg] = this;
  }
  mount(e) {
    let n = this.sheet, r = 0, i = 0;
    for (let o = 0; o < e.length; o++) {
      let s = e[o], a = this.modules.indexOf(s);
      if (a < i && a > -1 && (this.modules.splice(a, 1), i--, a = -1), a == -1) {
        if (this.modules.splice(i++, 0, s), n)
          for (let l = 0; l < s.rules.length; l++)
            n.insertRule(s.rules[l], r++);
      } else {
        for (; i < a; )
          r += this.modules[i++].rules.length;
        r += s.rules.length, i++;
      }
    }
    if (!n) {
      let o = "";
      for (let s = 0; s < this.modules.length; s++)
        o += this.modules[s].getRules() + `
`;
      this.styleTag.textContent = o;
    }
  }
  setNonce(e) {
    this.styleTag && this.styleTag.getAttribute("nonce") != e && this.styleTag.setAttribute("nonce", e);
  }
}
var na = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Eu = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, PB = typeof navigator < "u" && /Mac/.test(navigator.platform), RB = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Ir = 0; Ir < 10; Ir++)
  na[48 + Ir] = na[96 + Ir] = String(Ir);
for (var Ir = 1; Ir <= 24; Ir++)
  na[Ir + 111] = "F" + Ir;
for (var Ir = 65; Ir <= 90; Ir++)
  na[Ir] = String.fromCharCode(Ir + 32), Eu[Ir] = String.fromCharCode(Ir);
for (var mm in na)
  Eu.hasOwnProperty(mm) || (Eu[mm] = na[mm]);
function NB(t) {
  var e = PB && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || RB && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? Eu : na)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
function sh(t) {
  let e;
  return t.nodeType == 11 ? e = t.getSelection ? t : t.ownerDocument : e = t, e.getSelection();
}
function Fg(t, e) {
  return e ? t == e || t.contains(e.nodeType != 1 ? e.parentNode : e) : !1;
}
function IB(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function _d(t, e) {
  if (!e.anchorNode)
    return !1;
  try {
    return Fg(t, e.anchorNode);
  } catch {
    return !1;
  }
}
function Au(t) {
  return t.nodeType == 3 ? Fa(t, 0, t.nodeValue.length).getClientRects() : t.nodeType == 1 ? t.getClientRects() : [];
}
function ah(t, e, n, r) {
  return n ? d2(t, e, n, r, -1) || d2(t, e, n, r, 1) : !1;
}
function Mu(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}
function d2(t, e, n, r, i) {
  for (; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (i < 0 ? 0 : hs(t))) {
      if (t.nodeName == "DIV")
        return !1;
      let o = t.parentNode;
      if (!o || o.nodeType != 1)
        return !1;
      e = Mu(t) + (i < 0 ? 0 : 1), t = o;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (i < 0 ? -1 : 0)], t.nodeType == 1 && t.contentEditable == "false")
        return !1;
      e = i < 0 ? hs(t) : 0;
    } else
      return !1;
  }
}
function hs(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function U0(t, e) {
  let n = e ? t.left : t.right;
  return { left: n, right: n, top: t.top, bottom: t.bottom };
}
function DB(t) {
  return {
    left: 0,
    right: t.innerWidth,
    top: 0,
    bottom: t.innerHeight
  };
}
function LB(t, e, n, r, i, o, s, a) {
  let l = t.ownerDocument, c = l.defaultView || window;
  for (let u = t, f = !1; u && !f; )
    if (u.nodeType == 1) {
      let d, h = u == l.body, p = 1, m = 1;
      if (h)
        d = DB(c);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(u).position) && (f = !0), u.scrollHeight <= u.clientHeight && u.scrollWidth <= u.clientWidth) {
          u = u.assignedSlot || u.parentNode;
          continue;
        }
        let y = u.getBoundingClientRect();
        p = y.width / u.offsetWidth, m = y.height / u.offsetHeight, d = {
          left: y.left,
          right: y.left + u.clientWidth * p,
          top: y.top,
          bottom: y.top + u.clientHeight * m
        };
      }
      let g = 0, v = 0;
      if (i == "nearest")
        e.top < d.top ? (v = -(d.top - e.top + s), n > 0 && e.bottom > d.bottom + v && (v = e.bottom - d.bottom + v + s)) : e.bottom > d.bottom && (v = e.bottom - d.bottom + s, n < 0 && e.top - v < d.top && (v = -(d.top + v - e.top + s)));
      else {
        let y = e.bottom - e.top, w = d.bottom - d.top;
        v = (i == "center" && y <= w ? e.top + y / 2 - w / 2 : i == "start" || i == "center" && n < 0 ? e.top - s : e.bottom - w + s) - d.top;
      }
      if (r == "nearest" ? e.left < d.left ? (g = -(d.left - e.left + o), n > 0 && e.right > d.right + g && (g = e.right - d.right + g + o)) : e.right > d.right && (g = e.right - d.right + o, n < 0 && e.left < d.left + g && (g = -(d.left + g - e.left + o))) : g = (r == "center" ? e.left + (e.right - e.left) / 2 - (d.right - d.left) / 2 : r == "start" == a ? e.left - o : e.right - (d.right - d.left) + o) - d.left, g || v)
        if (h)
          c.scrollBy(g, v);
        else {
          let y = 0, w = 0;
          if (v) {
            let x = u.scrollTop;
            u.scrollTop += v / m, w = (u.scrollTop - x) * m;
          }
          if (g) {
            let x = u.scrollLeft;
            u.scrollLeft += g / p, y = (u.scrollLeft - x) * p;
          }
          e = {
            left: e.left - y,
            top: e.top - w,
            right: e.right - y,
            bottom: e.bottom - w
          }, y && Math.abs(y - g) < 1 && (r = "nearest"), w && Math.abs(w - v) < 1 && (i = "nearest");
        }
      if (h)
        break;
      u = u.assignedSlot || u.parentNode;
    } else if (u.nodeType == 11)
      u = u.host;
    else
      break;
}
function BB(t) {
  let e = t.ownerDocument;
  for (let n = t.parentNode; n && n != e.body; )
    if (n.nodeType == 1) {
      if (n.scrollHeight > n.clientHeight || n.scrollWidth > n.clientWidth)
        return n;
      n = n.assignedSlot || n.parentNode;
    } else if (n.nodeType == 11)
      n = n.host;
    else
      break;
  return null;
}
class qB {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(e) {
    return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
  }
  setRange(e) {
    let { anchorNode: n, focusNode: r } = e;
    this.set(n, Math.min(e.anchorOffset, n ? hs(n) : 0), r, Math.min(e.focusOffset, r ? hs(r) : 0));
  }
  set(e, n, r, i) {
    this.anchorNode = e, this.anchorOffset = n, this.focusNode = r, this.focusOffset = i;
  }
}
let ul = null;
function oC(t) {
  if (t.setActive)
    return t.setActive();
  if (ul)
    return t.focus(ul);
  let e = [];
  for (let n = t; n && (e.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode)
    ;
  if (t.focus(ul == null ? {
    get preventScroll() {
      return ul = { preventScroll: !0 }, !0;
    }
  } : void 0), !ul) {
    ul = !1;
    for (let n = 0; n < e.length; ) {
      let r = e[n++], i = e[n++], o = e[n++];
      r.scrollTop != i && (r.scrollTop = i), r.scrollLeft != o && (r.scrollLeft = o);
    }
  }
}
let h2;
function Fa(t, e, n = e) {
  let r = h2 || (h2 = document.createRange());
  return r.setEnd(t, n), r.setStart(t, e), r;
}
function Nl(t, e, n) {
  let r = { key: e, code: e, keyCode: n, which: n, cancelable: !0 }, i = new KeyboardEvent("keydown", r);
  i.synthetic = !0, t.dispatchEvent(i);
  let o = new KeyboardEvent("keyup", r);
  return o.synthetic = !0, t.dispatchEvent(o), i.defaultPrevented || o.defaultPrevented;
}
function zB(t) {
  for (; t; ) {
    if (t && (t.nodeType == 9 || t.nodeType == 11 && t.host))
      return t;
    t = t.assignedSlot || t.parentNode;
  }
  return null;
}
function sC(t) {
  for (; t.attributes.length; )
    t.removeAttributeNode(t.attributes[0]);
}
function FB(t, e) {
  let n = e.focusNode, r = e.focusOffset;
  if (!n || e.anchorNode != n || e.anchorOffset != r)
    return !1;
  for (r = Math.min(r, hs(n)); ; )
    if (r) {
      if (n.nodeType != 1)
        return !1;
      let i = n.childNodes[r - 1];
      i.contentEditable == "false" ? r-- : (n = i, r = hs(n));
    } else {
      if (n == t)
        return !0;
      r = Mu(n), n = n.parentNode;
    }
}
function aC(t) {
  return t.scrollTop > Math.max(1, t.scrollHeight - t.clientHeight - 4);
}
class Kr {
  constructor(e, n, r = !0) {
    this.node = e, this.offset = n, this.precise = r;
  }
  static before(e, n) {
    return new Kr(e.parentNode, Mu(e), n);
  }
  static after(e, n) {
    return new Kr(e.parentNode, Mu(e) + 1, n);
  }
}
const W0 = [];
class Zn {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(e) {
    let n = this.posAtStart;
    for (let r of this.children) {
      if (r == e)
        return n;
      n += r.length + r.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(e) {
    return this.posBefore(e) + e.length;
  }
  sync(e, n) {
    if (this.flags & 2) {
      let r = this.dom, i = null, o;
      for (let s of this.children) {
        if (s.flags & 7) {
          if (!s.dom && (o = i ? i.nextSibling : r.firstChild)) {
            let a = Zn.get(o);
            (!a || !a.parent && a.canReuseDOM(s)) && s.reuseDOM(o);
          }
          s.sync(e, n), s.flags &= -8;
        }
        if (o = i ? i.nextSibling : r.firstChild, n && !n.written && n.node == r && o != s.dom && (n.written = !0), s.dom.parentNode == r)
          for (; o && o != s.dom; )
            o = p2(o);
        else
          r.insertBefore(s.dom, o);
        i = s.dom;
      }
      for (o = i ? i.nextSibling : r.firstChild, o && n && n.node == r && (n.written = !0); o; )
        o = p2(o);
    } else if (this.flags & 1)
      for (let r of this.children)
        r.flags & 7 && (r.sync(e, n), r.flags &= -8);
  }
  reuseDOM(e) {
  }
  localPosFromDOM(e, n) {
    let r;
    if (e == this.dom)
      r = this.dom.childNodes[n];
    else {
      let i = hs(e) == 0 ? 0 : n == 0 ? -1 : 1;
      for (; ; ) {
        let o = e.parentNode;
        if (o == this.dom)
          break;
        i == 0 && o.firstChild != o.lastChild && (e == o.firstChild ? i = -1 : i = 1), e = o;
      }
      i < 0 ? r = e : r = e.nextSibling;
    }
    if (r == this.dom.firstChild)
      return 0;
    for (; r && !Zn.get(r); )
      r = r.nextSibling;
    if (!r)
      return this.length;
    for (let i = 0, o = 0; ; i++) {
      let s = this.children[i];
      if (s.dom == r)
        return o;
      o += s.length + s.breakAfter;
    }
  }
  domBoundsAround(e, n, r = 0) {
    let i = -1, o = -1, s = -1, a = -1;
    for (let l = 0, c = r, u = r; l < this.children.length; l++) {
      let f = this.children[l], d = c + f.length;
      if (c < e && d > n)
        return f.domBoundsAround(e, n, c);
      if (d >= e && i == -1 && (i = l, o = c), c > n && f.dom.parentNode == this.dom) {
        s = l, a = u;
        break;
      }
      u = d, c = d + f.breakAfter;
    }
    return {
      from: o,
      to: a < 0 ? r + this.length : a,
      startDOM: (i ? this.children[i - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: s < this.children.length && s >= 0 ? this.children[s].dom : null
    };
  }
  markDirty(e = !1) {
    this.flags |= 2, this.markParentsDirty(e);
  }
  markParentsDirty(e) {
    for (let n = this.parent; n; n = n.parent) {
      if (e && (n.flags |= 2), n.flags & 1)
        return;
      n.flags |= 1, e = !1;
    }
  }
  setParent(e) {
    this.parent != e && (this.parent = e, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(e) {
    this.dom != e && (this.dom && (this.dom.cmView = null), this.dom = e, e.cmView = this);
  }
  get rootView() {
    for (let e = this; ; ) {
      let n = e.parent;
      if (!n)
        return e;
      e = n;
    }
  }
  replaceChildren(e, n, r = W0) {
    this.markDirty();
    for (let i = e; i < n; i++) {
      let o = this.children[i];
      o.parent == this && r.indexOf(o) < 0 && o.destroy();
    }
    this.children.splice(e, n - e, ...r);
    for (let i = 0; i < r.length; i++)
      r[i].setParent(this);
  }
  ignoreMutation(e) {
    return !1;
  }
  ignoreEvent(e) {
    return !1;
  }
  childCursor(e = this.length) {
    return new lC(this.children, e, this.children.length);
  }
  childPos(e, n = 1) {
    return this.childCursor().findPos(e, n);
  }
  toString() {
    let e = this.constructor.name.replace("View", "");
    return e + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (e == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(e) {
    return e.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(e, n, r, i, o, s) {
    return !1;
  }
  become(e) {
    return !1;
  }
  canReuseDOM(e) {
    return e.constructor == this.constructor && !((this.flags | e.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let e of this.children)
      e.destroy();
    this.parent = null;
  }
}
Zn.prototype.breakAfter = 0;
function p2(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class lC {
  constructor(e, n, r) {
    this.children = e, this.pos = n, this.i = r, this.off = 0;
  }
  findPos(e, n = 1) {
    for (; ; ) {
      if (e > this.pos || e == this.pos && (n > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = e - this.pos, this;
      let r = this.children[--this.i];
      this.pos -= r.length + r.breakAfter;
    }
  }
}
function cC(t, e, n, r, i, o, s, a, l) {
  let { children: c } = t, u = c.length ? c[e] : null, f = o.length ? o[o.length - 1] : null, d = f ? f.breakAfter : s;
  if (!(e == r && u && !s && !d && o.length < 2 && u.merge(n, i, o.length ? f : null, n == 0, a, l))) {
    if (r < c.length) {
      let h = c[r];
      h && (i < h.length || h.breakAfter && (f != null && f.breakAfter)) ? (e == r && (h = h.split(i), i = 0), !d && f && h.merge(0, i, f, !0, 0, l) ? o[o.length - 1] = h : ((i || h.children.length && !h.children[0].length) && h.merge(0, i, null, !1, 0, l), o.push(h))) : h != null && h.breakAfter && (f ? f.breakAfter = 1 : s = 1), r++;
    }
    for (u && (u.breakAfter = s, n > 0 && (!s && o.length && u.merge(n, u.length, o[0], !1, a, 0) ? u.breakAfter = o.shift().breakAfter : (n < u.length || u.children.length && u.children[u.children.length - 1].length == 0) && u.merge(n, u.length, null, !1, a, 0), e++)); e < r && o.length; )
      if (c[r - 1].become(o[o.length - 1]))
        r--, o.pop(), l = o.length ? 0 : a;
      else if (c[e].become(o[0]))
        e++, o.shift(), a = o.length ? 0 : l;
      else
        break;
    !o.length && e && r < c.length && !c[e - 1].breakAfter && c[r].merge(0, 0, c[e - 1], !1, a, l) && e--, (e < r || o.length) && t.replaceChildren(e, r, o);
  }
}
function uC(t, e, n, r, i, o) {
  let s = t.childCursor(), { i: a, off: l } = s.findPos(n, 1), { i: c, off: u } = s.findPos(e, -1), f = e - n;
  for (let d of r)
    f += d.length;
  t.length += f, cC(t, c, u, a, l, r, 0, i, o);
}
let xi = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, Vg = typeof document < "u" ? document : { documentElement: { style: {} } };
const Hg = /* @__PURE__ */ /Edge\/(\d+)/.exec(xi.userAgent), fC = /* @__PURE__ */ /MSIE \d/.test(xi.userAgent), Ug = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(xi.userAgent), jp = !!(fC || Ug || Hg), m2 = !jp && /* @__PURE__ */ /gecko\/(\d+)/i.test(xi.userAgent), gm = !jp && /* @__PURE__ */ /Chrome\/(\d+)/.exec(xi.userAgent), g2 = "webkitFontSmoothing" in Vg.documentElement.style, dC = !jp && /* @__PURE__ */ /Apple Computer/.test(xi.vendor), v2 = dC && (/* @__PURE__ */ /Mobile\/\w+/.test(xi.userAgent) || xi.maxTouchPoints > 2);
var jt = {
  mac: v2 || /* @__PURE__ */ /Mac/.test(xi.platform),
  windows: /* @__PURE__ */ /Win/.test(xi.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(xi.platform),
  ie: jp,
  ie_version: fC ? Vg.documentMode || 6 : Ug ? +Ug[1] : Hg ? +Hg[1] : 0,
  gecko: m2,
  gecko_version: m2 ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(xi.userAgent) || [0, 0])[1] : 0,
  chrome: !!gm,
  chrome_version: gm ? +gm[1] : 0,
  ios: v2,
  android: /* @__PURE__ */ /Android\b/.test(xi.userAgent),
  webkit: g2,
  safari: dC,
  webkit_version: g2 ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0,
  tabSize: Vg.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const VB = 256;
class ps extends Zn {
  constructor(e) {
    super(), this.text = e;
  }
  get length() {
    return this.text.length;
  }
  createDOM(e) {
    this.setDOM(e || document.createTextNode(this.text));
  }
  sync(e, n) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (n && n.node == this.dom && (n.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(e) {
    e.nodeType == 3 && this.createDOM(e);
  }
  merge(e, n, r) {
    return this.flags & 8 || r && (!(r instanceof ps) || this.length - (n - e) + r.length > VB || r.flags & 8) ? !1 : (this.text = this.text.slice(0, e) + (r ? r.text : "") + this.text.slice(n), this.markDirty(), !0);
  }
  split(e) {
    let n = new ps(this.text.slice(e));
    return this.text = this.text.slice(0, e), this.markDirty(), n.flags |= this.flags & 8, n;
  }
  localPosFromDOM(e, n) {
    return e == this.dom ? n : n ? this.text.length : 0;
  }
  domAtPos(e) {
    return new Kr(this.dom, e);
  }
  domBoundsAround(e, n, r) {
    return { from: r, to: r + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(e, n) {
    return HB(this.dom, e, n);
  }
}
class ms extends Zn {
  constructor(e, n = [], r = 0) {
    super(), this.mark = e, this.children = n, this.length = r;
    for (let i of n)
      i.setParent(this);
  }
  setAttrs(e) {
    if (sC(e), this.mark.class && (e.className = this.mark.class), this.mark.attrs)
      for (let n in this.mark.attrs)
        e.setAttribute(n, this.mark.attrs[n]);
    return e;
  }
  canReuseDOM(e) {
    return super.canReuseDOM(e) && !((this.flags | e.flags) & 8);
  }
  reuseDOM(e) {
    e.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, n) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(e, n);
  }
  merge(e, n, r, i, o, s) {
    return r && (!(r instanceof ms && r.mark.eq(this.mark)) || e && o <= 0 || n < this.length && s <= 0) ? !1 : (uC(this, e, n, r ? r.children : [], o - 1, s - 1), this.markDirty(), !0);
  }
  split(e) {
    let n = [], r = 0, i = -1, o = 0;
    for (let a of this.children) {
      let l = r + a.length;
      l > e && n.push(r < e ? a.split(e - r) : a), i < 0 && r >= e && (i = o), r = l, o++;
    }
    let s = this.length - e;
    return this.length = e, i > -1 && (this.children.length = i, this.markDirty()), new ms(this.mark, n, s);
  }
  domAtPos(e) {
    return hC(this, e);
  }
  coordsAt(e, n) {
    return mC(this, e, n);
  }
}
function HB(t, e, n) {
  let r = t.nodeValue.length;
  e > r && (e = r);
  let i = e, o = e, s = 0;
  e == 0 && n < 0 || e == r && n >= 0 ? jt.chrome || jt.gecko || (e ? (i--, s = 1) : o < r && (o++, s = -1)) : n < 0 ? i-- : o < r && o++;
  let a = Fa(t, i, o).getClientRects();
  if (!a.length)
    return null;
  let l = a[(s ? s < 0 : n >= 0) ? 0 : a.length - 1];
  return jt.safari && !s && l.width == 0 && (l = Array.prototype.find.call(a, (c) => c.width) || l), s ? U0(l, s < 0) : l || null;
}
class Bs extends Zn {
  static create(e, n, r) {
    return new Bs(e, n, r);
  }
  constructor(e, n, r) {
    super(), this.widget = e, this.length = n, this.side = r, this.prevWidget = null;
  }
  split(e) {
    let n = Bs.create(this.widget, this.length - e, this.side);
    return this.length -= e, n;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.dom.contentEditable = "false");
  }
  getSide() {
    return this.side;
  }
  merge(e, n, r, i, o, s) {
    return r && (!(r instanceof Bs) || !this.widget.compare(r.widget) || e > 0 && o <= 0 || n < this.length && s <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
  }
  become(e) {
    return e instanceof Bs && e.side == this.side && this.widget.constructor == e.widget.constructor ? (this.widget.compare(e.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return Cn.empty;
    let e = this;
    for (; e.parent; )
      e = e.parent;
    let { view: n } = e, r = n && n.state.doc, i = this.posAtStart;
    return r ? r.slice(i, i + this.length) : Cn.empty;
  }
  domAtPos(e) {
    return (this.length ? e == 0 : this.side > 0) ? Kr.before(this.dom) : Kr.after(this.dom, e == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e, n) {
    let r = this.widget.coordsAt(this.dom, e, n);
    if (r)
      return r;
    let i = this.dom.getClientRects(), o = null;
    if (!i.length)
      return null;
    let s = this.side ? this.side < 0 : e > 0;
    for (let a = s ? i.length - 1 : 0; o = i[a], !(e > 0 ? a == 0 : a == i.length - 1 || o.top < o.bottom); a += s ? -1 : 1)
      ;
    return U0(o, !s);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}
class Yl extends Zn {
  constructor(e) {
    super(), this.side = e;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(e) {
    return e instanceof Yl && e.side == this.side;
  }
  split() {
    return new Yl(this.side);
  }
  sync() {
    if (!this.dom) {
      let e = document.createElement("img");
      e.className = "cm-widgetBuffer", e.setAttribute("aria-hidden", "true"), this.setDOM(e);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(e) {
    return this.side > 0 ? Kr.before(this.dom) : Kr.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return Cn.empty;
  }
  get isHidden() {
    return !0;
  }
}
ps.prototype.children = Bs.prototype.children = Yl.prototype.children = W0;
function hC(t, e) {
  let n = t.dom, { children: r } = t, i = 0;
  for (let o = 0; i < r.length; i++) {
    let s = r[i], a = o + s.length;
    if (!(a == o && s.getSide() <= 0)) {
      if (e > o && e < a && s.dom.parentNode == n)
        return s.domAtPos(e - o);
      if (e <= o)
        break;
      o = a;
    }
  }
  for (let o = i; o > 0; o--) {
    let s = r[o - 1];
    if (s.dom.parentNode == n)
      return s.domAtPos(s.length);
  }
  for (let o = i; o < r.length; o++) {
    let s = r[o];
    if (s.dom.parentNode == n)
      return s.domAtPos(0);
  }
  return new Kr(n, 0);
}
function pC(t, e, n) {
  let r, { children: i } = t;
  n > 0 && e instanceof ms && i.length && (r = i[i.length - 1]) instanceof ms && r.mark.eq(e.mark) ? pC(r, e.children[0], n - 1) : (i.push(e), e.setParent(t)), t.length += e.length;
}
function mC(t, e, n) {
  let r = null, i = -1, o = null, s = -1;
  function a(c, u) {
    for (let f = 0, d = 0; f < c.children.length && d <= u; f++) {
      let h = c.children[f], p = d + h.length;
      p >= u && (h.children.length ? a(h, u - d) : (!o || o.isHidden && n > 0) && (p > u || d == p && h.getSide() > 0) ? (o = h, s = u - d) : (d < u || d == p && h.getSide() < 0 && !h.isHidden) && (r = h, i = u - d)), d = p;
    }
  }
  a(t, e);
  let l = (n < 0 ? r : o) || r || o;
  return l ? l.coordsAt(Math.max(0, l == r ? i : s), n) : UB(t);
}
function UB(t) {
  let e = t.dom.lastChild;
  if (!e)
    return t.dom.getBoundingClientRect();
  let n = Au(e);
  return n[n.length - 1] || null;
}
function Wg(t, e) {
  for (let n in t)
    n == "class" && e.class ? e.class += " " + t.class : n == "style" && e.style ? e.style += ";" + t.style : e[n] = t[n];
  return e;
}
const y2 = /* @__PURE__ */ Object.create(null);
function J0(t, e, n) {
  if (t == e)
    return !0;
  t || (t = y2), e || (e = y2);
  let r = Object.keys(t), i = Object.keys(e);
  if (r.length - (n && r.indexOf(n) > -1 ? 1 : 0) != i.length - (n && i.indexOf(n) > -1 ? 1 : 0))
    return !1;
  for (let o of r)
    if (o != n && (i.indexOf(o) == -1 || t[o] !== e[o]))
      return !1;
  return !0;
}
function Jg(t, e, n) {
  let r = !1;
  if (e)
    for (let i in e)
      n && i in n || (r = !0, i == "style" ? t.style.cssText = "" : t.removeAttribute(i));
  if (n)
    for (let i in n)
      e && e[i] == n[i] || (r = !0, i == "style" ? t.style.cssText = n[i] : t.setAttribute(i, n[i]));
  return r;
}
function WB(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n = 0; n < t.attributes.length; n++) {
    let r = t.attributes[n];
    e[r.name] = r.value;
  }
  return e;
}
class kr extends Zn {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(e, n, r, i, o, s) {
    if (r) {
      if (!(r instanceof kr))
        return !1;
      this.dom || r.transferDOM(this);
    }
    return i && this.setDeco(r ? r.attrs : null), uC(this, e, n, r ? r.children : [], o, s), !0;
  }
  split(e) {
    let n = new kr();
    if (n.breakAfter = this.breakAfter, this.length == 0)
      return n;
    let { i: r, off: i } = this.childPos(e);
    i && (n.append(this.children[r].split(i), 0), this.children[r].merge(i, this.children[r].length, null, !1, 0, 0), r++);
    for (let o = r; o < this.children.length; o++)
      n.append(this.children[o], 0);
    for (; r > 0 && this.children[r - 1].length == 0; )
      this.children[--r].destroy();
    return this.children.length = r, this.markDirty(), this.length = e, n;
  }
  transferDOM(e) {
    this.dom && (this.markDirty(), e.setDOM(this.dom), e.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(e) {
    J0(this.attrs, e) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = e);
  }
  append(e, n) {
    pC(this, e, n);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(e) {
    let n = e.spec.attributes, r = e.spec.class;
    n && (this.attrs = Wg(n, this.attrs || {})), r && (this.attrs = Wg({ class: r }, this.attrs || {}));
  }
  domAtPos(e) {
    return hC(this, e);
  }
  reuseDOM(e) {
    e.nodeName == "DIV" && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, n) {
    var r;
    this.dom ? this.flags & 4 && (sC(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (Jg(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(e, n);
    let i = this.dom.lastChild;
    for (; i && Zn.get(i) instanceof ms; )
      i = i.lastChild;
    if (!i || !this.length || i.nodeName != "BR" && ((r = Zn.get(i)) === null || r === void 0 ? void 0 : r.isEditable) == !1 && (!jt.ios || !this.children.some((o) => o instanceof ps))) {
      let o = document.createElement("BR");
      o.cmIgnore = !0, this.dom.appendChild(o);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let e = 0, n;
    for (let r of this.children) {
      if (!(r instanceof ps) || /[^ -~]/.test(r.text))
        return null;
      let i = Au(r.dom);
      if (i.length != 1)
        return null;
      e += i[0].width, n = i[0].height;
    }
    return e ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: e / this.length,
      textHeight: n
    } : null;
  }
  coordsAt(e, n) {
    let r = mC(this, e, n);
    if (!this.children.length && r && this.parent) {
      let { heightOracle: i } = this.parent.view.viewState, o = r.bottom - r.top;
      if (Math.abs(o - i.lineHeight) < 2 && i.textHeight < o) {
        let s = (o - i.textHeight) / 2;
        return { top: r.top + s, bottom: r.bottom - s, left: r.left, right: r.left };
      }
    }
    return r;
  }
  become(e) {
    return !1;
  }
  covers() {
    return !0;
  }
  static find(e, n) {
    for (let r = 0, i = 0; r < e.children.length; r++) {
      let o = e.children[r], s = i + o.length;
      if (s >= n) {
        if (o instanceof kr)
          return o;
        if (s > n)
          break;
      }
      i = s + o.breakAfter;
    }
    return null;
  }
}
class Hs extends Zn {
  constructor(e, n, r) {
    super(), this.widget = e, this.length = n, this.deco = r, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(e, n, r, i, o, s) {
    return r && (!(r instanceof Hs) || !this.widget.compare(r.widget) || e > 0 && o <= 0 || n < this.length && s <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
  }
  domAtPos(e) {
    return e == 0 ? Kr.before(this.dom) : Kr.after(this.dom, e == this.length);
  }
  split(e) {
    let n = this.length - e;
    this.length = e;
    let r = new Hs(this.widget, n, this.deco);
    return r.breakAfter = this.breakAfter, r;
  }
  get children() {
    return W0;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.dom.contentEditable = "false");
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : Cn.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(e) {
    return e instanceof Hs && e.widget.constructor == this.widget.constructor ? (e.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, this.deco = e.deco, this.breakAfter = e.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(e, n) {
    return this.widget.coordsAt(this.dom, e, n);
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(e) {
    let { startSide: n, endSide: r } = this.deco;
    return n == r ? !1 : e < 0 ? n < 0 : r > 0;
  }
}
class ua {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(e) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(e, n) {
    return !1;
  }
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(e) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(e, n, r) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(e) {
  }
}
var ri = /* @__PURE__ */ function(t) {
  return t[t.Text = 0] = "Text", t[t.WidgetBefore = 1] = "WidgetBefore", t[t.WidgetAfter = 2] = "WidgetAfter", t[t.WidgetRange = 3] = "WidgetRange", t;
}(ri || (ri = {}));
class Bt extends za {
  constructor(e, n, r, i) {
    super(), this.startSide = e, this.endSide = n, this.widget = r, this.spec = i;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(e) {
    return new rf(e);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(e) {
    let n = Math.max(-1e4, Math.min(1e4, e.side || 0)), r = !!e.block;
    return n += r && !e.inlineOrder ? n > 0 ? 3e8 : -4e8 : n > 0 ? 1e8 : -1e8, new ra(e, n, n, r, e.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(e) {
    let n = !!e.block, r, i;
    if (e.isBlockGap)
      r = -5e8, i = 4e8;
    else {
      let { start: o, end: s } = gC(e, n);
      r = (o ? n ? -3e8 : -1 : 5e8) - 1, i = (s ? n ? 2e8 : 1 : -6e8) + 1;
    }
    return new ra(e, r, i, n, e.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(e) {
    return new of(e);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(e, n = !1) {
    return En.of(e, n);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}
Bt.none = En.empty;
class rf extends Bt {
  constructor(e) {
    let { start: n, end: r } = gC(e);
    super(n ? -1 : 5e8, r ? 1 : -6e8, null, e), this.tagName = e.tagName || "span", this.class = e.class || "", this.attrs = e.attributes || null;
  }
  eq(e) {
    var n, r;
    return this == e || e instanceof rf && this.tagName == e.tagName && (this.class || ((n = this.attrs) === null || n === void 0 ? void 0 : n.class)) == (e.class || ((r = e.attrs) === null || r === void 0 ? void 0 : r.class)) && J0(this.attrs, e.attrs, "class");
  }
  range(e, n = e) {
    if (e >= n)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(e, n);
  }
}
rf.prototype.point = !1;
class of extends Bt {
  constructor(e) {
    super(-2e8, -2e8, null, e);
  }
  eq(e) {
    return e instanceof of && this.spec.class == e.spec.class && J0(this.spec.attributes, e.spec.attributes);
  }
  range(e, n = e) {
    if (n != e)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(e, n);
  }
}
of.prototype.mapMode = ni.TrackBefore;
of.prototype.point = !0;
class ra extends Bt {
  constructor(e, n, r, i, o, s) {
    super(n, r, o, e), this.block = i, this.isReplace = s, this.mapMode = i ? n <= 0 ? ni.TrackBefore : ni.TrackAfter : ni.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? ri.WidgetRange : this.startSide <= 0 ? ri.WidgetBefore : ri.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(e) {
    return e instanceof ra && JB(this.widget, e.widget) && this.block == e.block && this.startSide == e.startSide && this.endSide == e.endSide;
  }
  range(e, n = e) {
    if (this.isReplace && (e > n || e == n && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && n != e)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(e, n);
  }
}
ra.prototype.point = !0;
function gC(t, e = !1) {
  let { inclusiveStart: n, inclusiveEnd: r } = t;
  return n == null && (n = t.inclusive), r == null && (r = t.inclusive), { start: n ?? e, end: r ?? e };
}
function JB(t, e) {
  return t == e || !!(t && e && t.compare(e));
}
function Kg(t, e, n, r = 0) {
  let i = n.length - 1;
  i >= 0 && n[i] + r >= t ? n[i] = Math.max(n[i], e) : n.push(t, e);
}
class nu {
  constructor(e, n, r, i) {
    this.doc = e, this.pos = n, this.end = r, this.disallowBlockEffectsFor = i, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = e.iter(), this.skip = n;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let e = this.content[this.content.length - 1];
    return !(e.breakAfter || e instanceof Hs && e.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new kr()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(e = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(Df(new Yl(-1), e), e.length), this.pendingBuffer = 0);
  }
  addBlockWidget(e) {
    this.flushBuffer(), this.curLine = null, this.content.push(e);
  }
  finish(e) {
    this.pendingBuffer && e <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(e && this.content.length && this.content[this.content.length - 1] instanceof Hs) && this.getLine();
  }
  buildText(e, n, r) {
    for (; e > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: o, lineBreak: s, done: a } = this.cursor.next(this.skip);
        if (this.skip = 0, a)
          throw new Error("Ran out of text content when drawing inline views");
        if (s) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, e--;
          continue;
        } else
          this.text = o, this.textOff = 0;
      }
      let i = Math.min(
        this.text.length - this.textOff,
        e,
        512
        /* T.Chunk */
      );
      this.flushBuffer(n.slice(n.length - r)), this.getLine().append(Df(new ps(this.text.slice(this.textOff, this.textOff + i)), n), r), this.atCursorPos = !0, this.textOff += i, e -= i, r = 0;
    }
  }
  span(e, n, r, i) {
    this.buildText(n - e, r, i), this.pos = n, this.openStart < 0 && (this.openStart = i);
  }
  point(e, n, r, i, o, s) {
    if (this.disallowBlockEffectsFor[s] && r instanceof ra) {
      if (r.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (n > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let a = n - e;
    if (r instanceof ra)
      if (r.block)
        r.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new Hs(r.widget || new b2("div"), a, r));
      else {
        let l = Bs.create(r.widget || new b2("span"), a, a ? 0 : r.startSide), c = this.atCursorPos && !l.isEditable && o <= i.length && (e < n || r.startSide > 0), u = !l.isEditable && (e < n || o > i.length || r.startSide <= 0), f = this.getLine();
        this.pendingBuffer == 2 && !c && !l.isEditable && (this.pendingBuffer = 0), this.flushBuffer(i), c && (f.append(Df(new Yl(1), i), o), o = i.length + Math.max(0, o - i.length)), f.append(Df(l, i), o), this.atCursorPos = u, this.pendingBuffer = u ? e < n || o > i.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = i.slice());
      }
    else
      this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(r);
    a && (this.textOff + a <= this.text.length ? this.textOff += a : (this.skip += a - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = n), this.openStart < 0 && (this.openStart = o);
  }
  static build(e, n, r, i, o) {
    let s = new nu(e, n, r, o);
    return s.openEnd = En.spans(i, n, r, s), s.openStart < 0 && (s.openStart = s.openEnd), s.finish(s.openEnd), s;
  }
}
function Df(t, e) {
  for (let n of e)
    t = new ms(n, [t], t.length);
  return t;
}
class b2 extends ua {
  constructor(e) {
    super(), this.tag = e;
  }
  eq(e) {
    return e.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(e) {
    return e.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
const vC = /* @__PURE__ */ vt.define(), yC = /* @__PURE__ */ vt.define(), bC = /* @__PURE__ */ vt.define(), xC = /* @__PURE__ */ vt.define(), Gg = /* @__PURE__ */ vt.define(), wC = /* @__PURE__ */ vt.define(), jC = /* @__PURE__ */ vt.define(), kC = /* @__PURE__ */ vt.define({
  combine: (t) => t.some((e) => e)
}), $C = /* @__PURE__ */ vt.define({
  combine: (t) => t.some((e) => e)
});
class Il {
  constructor(e, n = "nearest", r = "nearest", i = 5, o = 5, s = !1) {
    this.range = e, this.y = n, this.x = r, this.yMargin = i, this.xMargin = o, this.isSnapshot = s;
  }
  map(e) {
    return e.empty ? this : new Il(this.range.map(e), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(e) {
    return this.range.to <= e.doc.length ? this : new Il(Te.cursor(e.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const Lf = /* @__PURE__ */ ln.define({ map: (t, e) => t.map(e) });
function $i(t, e, n) {
  let r = t.facet(xC);
  r.length ? r[0](e) : window.onerror ? window.onerror(String(e), n, void 0, void 0, e) : n ? console.error(n + ":", e) : console.error(e);
}
const kp = /* @__PURE__ */ vt.define({ combine: (t) => t.length ? t[0] : !0 });
let KB = 0;
const Fc = /* @__PURE__ */ vt.define();
class ur {
  constructor(e, n, r, i, o) {
    this.id = e, this.create = n, this.domEventHandlers = r, this.domEventObservers = i, this.extension = o(this);
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(e, n) {
    const { eventHandlers: r, eventObservers: i, provide: o, decorations: s } = n || {};
    return new ur(KB++, e, r, i, (a) => {
      let l = [Fc.of(a)];
      return s && l.push(_u.of((c) => {
        let u = c.plugin(a);
        return u ? s(u) : Bt.none;
      })), o && l.push(o(a)), l;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(e, n) {
    return ur.define((r) => new e(r), n);
  }
}
class vm {
  constructor(e) {
    this.spec = e, this.mustUpdate = null, this.value = null;
  }
  update(e) {
    if (this.value) {
      if (this.mustUpdate) {
        let n = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(n);
          } catch (r) {
            if ($i(n.state, r, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(e);
      } catch (n) {
        $i(e.state, n, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(e) {
    var n;
    if (!((n = this.value) === null || n === void 0) && n.destroy)
      try {
        this.value.destroy();
      } catch (r) {
        $i(e.state, r, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const SC = /* @__PURE__ */ vt.define(), K0 = /* @__PURE__ */ vt.define(), _u = /* @__PURE__ */ vt.define(), G0 = /* @__PURE__ */ vt.define(), CC = /* @__PURE__ */ vt.define();
function x2(t, e, n) {
  let r = t.state.facet(CC);
  if (!r.length)
    return r;
  let i = r.map((s) => s instanceof Function ? s(t) : s), o = [];
  return En.spans(i, e, n, {
    point() {
    },
    span(s, a, l, c) {
      let u = o;
      for (let f = l.length - 1; f >= 0; f--, c--) {
        let d = l[f].spec.bidiIsolate, h;
        if (d != null)
          if (c > 0 && u.length && (h = u[u.length - 1]).to == s && h.direction == d)
            h.to = a, u = h.inner;
          else {
            let p = { from: s, to: a, direction: d, inner: [] };
            u.push(p), u = p.inner;
          }
      }
    }
  }), o;
}
const OC = /* @__PURE__ */ vt.define();
function EC(t) {
  let e = 0, n = 0, r = 0, i = 0;
  for (let o of t.state.facet(OC)) {
    let s = o(t);
    s && (s.left != null && (e = Math.max(e, s.left)), s.right != null && (n = Math.max(n, s.right)), s.top != null && (r = Math.max(r, s.top)), s.bottom != null && (i = Math.max(i, s.bottom)));
  }
  return { left: e, right: n, top: r, bottom: i };
}
const Vc = /* @__PURE__ */ vt.define();
class Ni {
  constructor(e, n, r, i) {
    this.fromA = e, this.toA = n, this.fromB = r, this.toB = i;
  }
  join(e) {
    return new Ni(Math.min(this.fromA, e.fromA), Math.max(this.toA, e.toA), Math.min(this.fromB, e.fromB), Math.max(this.toB, e.toB));
  }
  addToSet(e) {
    let n = e.length, r = this;
    for (; n > 0; n--) {
      let i = e[n - 1];
      if (!(i.fromA > r.toA)) {
        if (i.toA < r.fromA)
          break;
        r = r.join(i), e.splice(n - 1, 1);
      }
    }
    return e.splice(n, 0, r), e;
  }
  static extendWithRanges(e, n) {
    if (n.length == 0)
      return e;
    let r = [];
    for (let i = 0, o = 0, s = 0, a = 0; ; i++) {
      let l = i == e.length ? null : e[i], c = s - a, u = l ? l.fromB : 1e9;
      for (; o < n.length && n[o] < u; ) {
        let f = n[o], d = n[o + 1], h = Math.max(a, f), p = Math.min(u, d);
        if (h <= p && new Ni(h + c, p + c, h, p).addToSet(r), d > u)
          break;
        o += 2;
      }
      if (!l)
        return r;
      new Ni(l.fromA, l.toA, l.fromB, l.toB).addToSet(r), s = l.toA, a = l.toB;
    }
  }
}
class lh {
  constructor(e, n, r) {
    this.view = e, this.state = n, this.transactions = r, this.flags = 0, this.startState = e.state, this.changes = $r.empty(this.startState.doc.length);
    for (let o of r)
      this.changes = this.changes.compose(o.changes);
    let i = [];
    this.changes.iterChangedRanges((o, s, a, l) => i.push(new Ni(o, s, a, l))), this.changedRanges = i;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new lh(e, n, r);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 10) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((e) => e.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
var cr = /* @__PURE__ */ function(t) {
  return t[t.LTR = 0] = "LTR", t[t.RTL = 1] = "RTL", t;
}(cr || (cr = {}));
const Tu = cr.LTR, AC = cr.RTL;
function MC(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    e.push(1 << +t[n]);
  return e;
}
const GB = /* @__PURE__ */ MC("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), QB = /* @__PURE__ */ MC("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), Qg = /* @__PURE__ */ Object.create(null), xo = [];
for (let t of ["()", "[]", "{}"]) {
  let e = /* @__PURE__ */ t.charCodeAt(0), n = /* @__PURE__ */ t.charCodeAt(1);
  Qg[e] = n, Qg[n] = -e;
}
function YB(t) {
  return t <= 247 ? GB[t] : 1424 <= t && t <= 1524 ? 2 : 1536 <= t && t <= 1785 ? QB[t - 1536] : 1774 <= t && t <= 2220 ? 4 : 8192 <= t && t <= 8203 ? 256 : 64336 <= t && t <= 65023 ? 4 : t == 8204 ? 256 : 1;
}
const XB = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class qs {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? AC : Tu;
  }
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.level = r;
  }
  /**
  @internal
  */
  side(e, n) {
    return this.dir == n == e ? this.to : this.from;
  }
  /**
  @internal
  */
  static find(e, n, r, i) {
    let o = -1;
    for (let s = 0; s < e.length; s++) {
      let a = e[s];
      if (a.from <= n && a.to >= n) {
        if (a.level == r)
          return s;
        (o < 0 || (i != 0 ? i < 0 ? a.from < n : a.to > n : e[o].level > a.level)) && (o = s);
      }
    }
    if (o < 0)
      throw new RangeError("Index out of range");
    return o;
  }
}
function _C(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++) {
    let r = t[n], i = e[n];
    if (r.from != i.from || r.to != i.to || r.direction != i.direction || !_C(r.inner, i.inner))
      return !1;
  }
  return !0;
}
const Bn = [];
function ZB(t, e, n, r, i) {
  for (let o = 0; o <= r.length; o++) {
    let s = o ? r[o - 1].to : e, a = o < r.length ? r[o].from : n, l = o ? 256 : i;
    for (let c = s, u = l, f = l; c < a; c++) {
      let d = YB(t.charCodeAt(c));
      d == 512 ? d = u : d == 8 && f == 4 && (d = 16), Bn[c] = d == 4 ? 2 : d, d & 7 && (f = d), u = d;
    }
    for (let c = s, u = l, f = l; c < a; c++) {
      let d = Bn[c];
      if (d == 128)
        c < a - 1 && u == Bn[c + 1] && u & 24 ? d = Bn[c] = u : Bn[c] = 256;
      else if (d == 64) {
        let h = c + 1;
        for (; h < a && Bn[h] == 64; )
          h++;
        let p = c && u == 8 || h < n && Bn[h] == 8 ? f == 1 ? 1 : 8 : 256;
        for (let m = c; m < h; m++)
          Bn[m] = p;
        c = h - 1;
      } else
        d == 8 && f == 1 && (Bn[c] = 1);
      u = d, d & 7 && (f = d);
    }
  }
}
function eq(t, e, n, r, i) {
  let o = i == 1 ? 2 : 1;
  for (let s = 0, a = 0, l = 0; s <= r.length; s++) {
    let c = s ? r[s - 1].to : e, u = s < r.length ? r[s].from : n;
    for (let f = c, d, h, p; f < u; f++)
      if (h = Qg[d = t.charCodeAt(f)])
        if (h < 0) {
          for (let m = a - 3; m >= 0; m -= 3)
            if (xo[m + 1] == -h) {
              let g = xo[m + 2], v = g & 2 ? i : g & 4 ? g & 1 ? o : i : 0;
              v && (Bn[f] = Bn[xo[m]] = v), a = m;
              break;
            }
        } else {
          if (xo.length == 189)
            break;
          xo[a++] = f, xo[a++] = d, xo[a++] = l;
        }
      else if ((p = Bn[f]) == 2 || p == 1) {
        let m = p == i;
        l = m ? 0 : 1;
        for (let g = a - 3; g >= 0; g -= 3) {
          let v = xo[g + 2];
          if (v & 2)
            break;
          if (m)
            xo[g + 2] |= 2;
          else {
            if (v & 4)
              break;
            xo[g + 2] |= 4;
          }
        }
      }
  }
}
function tq(t, e, n, r) {
  for (let i = 0, o = r; i <= n.length; i++) {
    let s = i ? n[i - 1].to : t, a = i < n.length ? n[i].from : e;
    for (let l = s; l < a; ) {
      let c = Bn[l];
      if (c == 256) {
        let u = l + 1;
        for (; ; )
          if (u == a) {
            if (i == n.length)
              break;
            u = n[i++].to, a = i < n.length ? n[i].from : e;
          } else if (Bn[u] == 256)
            u++;
          else
            break;
        let f = o == 1, d = (u < e ? Bn[u] : r) == 1, h = f == d ? f ? 1 : 2 : r;
        for (let p = u, m = i, g = m ? n[m - 1].to : t; p > l; )
          p == g && (p = n[--m].from, g = m ? n[m - 1].to : t), Bn[--p] = h;
        l = u;
      } else
        o = c, l++;
    }
  }
}
function Yg(t, e, n, r, i, o, s) {
  let a = r % 2 ? 2 : 1;
  if (r % 2 == i % 2)
    for (let l = e, c = 0; l < n; ) {
      let u = !0, f = !1;
      if (c == o.length || l < o[c].from) {
        let m = Bn[l];
        m != a && (u = !1, f = m == 16);
      }
      let d = !u && a == 1 ? [] : null, h = u ? r : r + 1, p = l;
      e:
        for (; ; )
          if (c < o.length && p == o[c].from) {
            if (f)
              break e;
            let m = o[c];
            if (!u)
              for (let g = m.to, v = c + 1; ; ) {
                if (g == n)
                  break e;
                if (v < o.length && o[v].from == g)
                  g = o[v++].to;
                else {
                  if (Bn[g] == a)
                    break e;
                  break;
                }
              }
            if (c++, d)
              d.push(m);
            else {
              m.from > l && s.push(new qs(l, m.from, h));
              let g = m.direction == Tu != !(h % 2);
              Xg(t, g ? r + 1 : r, i, m.inner, m.from, m.to, s), l = m.to;
            }
            p = m.to;
          } else {
            if (p == n || (u ? Bn[p] != a : Bn[p] == a))
              break;
            p++;
          }
      d ? Yg(t, l, p, r + 1, i, d, s) : l < p && s.push(new qs(l, p, h)), l = p;
    }
  else
    for (let l = n, c = o.length; l > e; ) {
      let u = !0, f = !1;
      if (!c || l > o[c - 1].to) {
        let m = Bn[l - 1];
        m != a && (u = !1, f = m == 16);
      }
      let d = !u && a == 1 ? [] : null, h = u ? r : r + 1, p = l;
      e:
        for (; ; )
          if (c && p == o[c - 1].to) {
            if (f)
              break e;
            let m = o[--c];
            if (!u)
              for (let g = m.from, v = c; ; ) {
                if (g == e)
                  break e;
                if (v && o[v - 1].to == g)
                  g = o[--v].from;
                else {
                  if (Bn[g - 1] == a)
                    break e;
                  break;
                }
              }
            if (d)
              d.push(m);
            else {
              m.to < l && s.push(new qs(m.to, l, h));
              let g = m.direction == Tu != !(h % 2);
              Xg(t, g ? r + 1 : r, i, m.inner, m.from, m.to, s), l = m.from;
            }
            p = m.from;
          } else {
            if (p == e || (u ? Bn[p - 1] != a : Bn[p - 1] == a))
              break;
            p--;
          }
      d ? Yg(t, p, l, r + 1, i, d, s) : p < l && s.push(new qs(p, l, h)), l = p;
    }
}
function Xg(t, e, n, r, i, o, s) {
  let a = e % 2 ? 2 : 1;
  ZB(t, i, o, r, a), eq(t, i, o, r, a), tq(i, o, r, a), Yg(t, i, o, e, n, r, s);
}
function nq(t, e, n) {
  if (!t)
    return [new qs(0, 0, e == AC ? 1 : 0)];
  if (e == Tu && !n.length && !XB.test(t))
    return TC(t.length);
  if (n.length)
    for (; t.length > Bn.length; )
      Bn[Bn.length] = 256;
  let r = [], i = e == Tu ? 0 : 1;
  return Xg(t, i, i, n, 0, t.length, r), r;
}
function TC(t) {
  return [new qs(0, t, 0)];
}
let PC = "";
function rq(t, e, n, r, i) {
  var o;
  let s = r.head - t.from, a = -1;
  if (s == 0) {
    if (!i || !t.length)
      return null;
    e[0].level != n && (s = e[0].side(!1, n), a = 0);
  } else if (s == t.length) {
    if (i)
      return null;
    let d = e[e.length - 1];
    d.level != n && (s = d.side(!0, n), a = e.length - 1);
  }
  a < 0 && (a = qs.find(e, s, (o = r.bidiLevel) !== null && o !== void 0 ? o : -1, r.assoc));
  let l = e[a];
  s == l.side(i, n) && (l = e[a += i ? 1 : -1], s = l.side(!i, n));
  let c = i == (l.dir == n), u = Br(t.text, s, c);
  if (PC = t.text.slice(Math.min(s, u), Math.max(s, u)), u != l.side(i, n))
    return Te.cursor(u + t.from, c ? -1 : 1, l.level);
  let f = a == (i ? e.length - 1 : 0) ? null : e[a + (i ? 1 : -1)];
  return !f && l.level != n ? Te.cursor(i ? t.to : t.from, i ? -1 : 1, n) : f && f.level < l.level ? Te.cursor(f.side(!i, n) + t.from, i ? 1 : -1, f.level) : Te.cursor(u + t.from, i ? -1 : 1, l.level);
}
class w2 extends Zn {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(e) {
    super(), this.view = e, this.decorations = [], this.dynamicDecorationMap = [], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(e.contentDOM), this.children = [new kr()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new Ni(0, 0, 0, e.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(e) {
    var n;
    let r = e.changedRanges;
    this.minWidth > 0 && r.length && (r.every(({ fromA: c, toA: u }) => u < this.minWidthFrom || c > this.minWidthTo) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0);
    let i = -1;
    this.view.inputState.composing >= 0 && (!((n = this.domChanged) === null || n === void 0) && n.newSel ? i = this.domChanged.newSel.head : !uq(e.changes, this.hasComposition) && !e.selectionSet && (i = e.state.selection.main.head));
    let o = i > -1 ? oq(this.view, e.changes, i) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: c, to: u } = this.hasComposition;
      r = new Ni(c, u, e.changes.mapPos(c, -1), e.changes.mapPos(u, 1)).addToSet(r.slice());
    }
    this.hasComposition = o ? { from: o.range.fromB, to: o.range.toB } : null, (jt.ie || jt.chrome) && !o && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
    let s = this.decorations, a = this.updateDeco(), l = lq(s, a, e.changes);
    return r = Ni.extendWithRanges(r, l), !(this.flags & 7) && r.length == 0 ? !1 : (this.updateInner(r, e.startState.doc.length, o), e.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(e, n, r) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(e, n, r);
    let { observer: i } = this.view;
    i.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let s = jt.chrome || jt.ios ? { node: i.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, s), this.flags &= -8, s && (s.written || i.selectionRange.focusNode != s.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (s) => s.flags &= -9
      /* ViewFlag.Composition */
    );
    let o = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let s of this.children)
        s instanceof Hs && s.widget instanceof j2 && o.push(s.dom);
    i.updateGaps(o);
  }
  updateChildren(e, n, r) {
    let i = r ? r.range.addToSet(e.slice()) : e, o = this.childCursor(n);
    for (let s = i.length - 1; ; s--) {
      let a = s >= 0 ? i[s] : null;
      if (!a)
        break;
      let { fromA: l, toA: c, fromB: u, toB: f } = a, d, h, p, m;
      if (r && r.range.fromB < f && r.range.toB > u) {
        let x = nu.build(this.view.state.doc, u, r.range.fromB, this.decorations, this.dynamicDecorationMap), b = nu.build(this.view.state.doc, r.range.toB, f, this.decorations, this.dynamicDecorationMap);
        h = x.breakAtStart, p = x.openStart, m = b.openEnd;
        let j = this.compositionView(r);
        b.breakAtStart ? j.breakAfter = 1 : b.content.length && j.merge(j.length, j.length, b.content[0], !1, b.openStart, 0) && (j.breakAfter = b.content[0].breakAfter, b.content.shift()), x.content.length && j.merge(0, 0, x.content[x.content.length - 1], !0, 0, x.openEnd) && x.content.pop(), d = x.content.concat(j).concat(b.content);
      } else
        ({ content: d, breakAtStart: h, openStart: p, openEnd: m } = nu.build(this.view.state.doc, u, f, this.decorations, this.dynamicDecorationMap));
      let { i: g, off: v } = o.findPos(c, 1), { i: y, off: w } = o.findPos(l, -1);
      cC(this, y, w, g, v, d, h, p, m);
    }
    r && this.fixCompositionDOM(r);
  }
  compositionView(e) {
    let n = new ps(e.text.nodeValue);
    n.flags |= 8;
    for (let { deco: i } of e.marks)
      n = new ms(i, [n], n.length);
    let r = new kr();
    return r.append(n, 0), r;
  }
  fixCompositionDOM(e) {
    let n = (o, s) => {
      s.flags |= 8 | (s.children.some(
        (l) => l.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(s);
      let a = Zn.get(o);
      a && a != s && (a.dom = null), s.setDOM(o);
    }, r = this.childPos(e.range.fromB, 1), i = this.children[r.i];
    n(e.line, i);
    for (let o = e.marks.length - 1; o >= -1; o--)
      r = i.childPos(r.off, 1), i = i.children[r.i], n(o >= 0 ? e.marks[o].node : e.text, i);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(e = !1, n = !1) {
    (e || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let r = this.view.root.activeElement, i = r == this.dom, o = !i && _d(this.dom, this.view.observer.selectionRange) && !(r && this.dom.contains(r));
    if (!(i || n || o))
      return;
    let s = this.forceSelection;
    this.forceSelection = !1;
    let a = this.view.state.selection.main, l = this.moveToLine(this.domAtPos(a.anchor)), c = a.empty ? l : this.moveToLine(this.domAtPos(a.head));
    if (jt.gecko && a.empty && !this.hasComposition && iq(l)) {
      let f = document.createTextNode("");
      this.view.observer.ignore(() => l.node.insertBefore(f, l.node.childNodes[l.offset] || null)), l = c = new Kr(f, 0), s = !0;
    }
    let u = this.view.observer.selectionRange;
    (s || !u.focusNode || !ah(l.node, l.offset, u.anchorNode, u.anchorOffset) || !ah(c.node, c.offset, u.focusNode, u.focusOffset)) && (this.view.observer.ignore(() => {
      jt.android && jt.chrome && this.dom.contains(u.focusNode) && cq(u.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let f = sh(this.view.root);
      if (f)
        if (a.empty) {
          if (jt.gecko) {
            let d = sq(l.node, l.offset);
            if (d && d != 3) {
              let h = NC(l.node, l.offset, d == 1 ? 1 : -1);
              h && (l = new Kr(h.node, h.offset));
            }
          }
          f.collapse(l.node, l.offset), a.bidiLevel != null && f.caretBidiLevel !== void 0 && (f.caretBidiLevel = a.bidiLevel);
        } else if (f.extend) {
          f.collapse(l.node, l.offset);
          try {
            f.extend(c.node, c.offset);
          } catch {
          }
        } else {
          let d = document.createRange();
          a.anchor > a.head && ([l, c] = [c, l]), d.setEnd(c.node, c.offset), d.setStart(l.node, l.offset), f.removeAllRanges(), f.addRange(d);
        }
      o && this.view.root.activeElement == this.dom && (this.dom.blur(), r && r.focus());
    }), this.view.observer.setSelectionRange(l, c)), this.impreciseAnchor = l.precise ? null : new Kr(u.anchorNode, u.anchorOffset), this.impreciseHead = c.precise ? null : new Kr(u.focusNode, u.focusOffset);
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: e } = this, n = e.state.selection.main, r = sh(e.root), { anchorNode: i, anchorOffset: o } = e.observer.selectionRange;
    if (!r || !n.empty || !n.assoc || !r.modify)
      return;
    let s = kr.find(this, n.head);
    if (!s)
      return;
    let a = s.posAtStart;
    if (n.head == a || n.head == a + s.length)
      return;
    let l = this.coordsAt(n.head, -1), c = this.coordsAt(n.head, 1);
    if (!l || !c || l.bottom > c.top)
      return;
    let u = this.domAtPos(n.head + n.assoc);
    r.collapse(u.node, u.offset), r.modify("move", n.assoc < 0 ? "forward" : "backward", "lineboundary"), e.observer.readSelectionRange();
    let f = e.observer.selectionRange;
    e.docView.posFromDOM(f.anchorNode, f.anchorOffset) != n.from && r.collapse(i, o);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(e) {
    let n = this.dom, r;
    if (e.node != n)
      return e;
    for (let i = e.offset; !r && i < n.childNodes.length; i++) {
      let o = Zn.get(n.childNodes[i]);
      o instanceof kr && (r = o.domAtPos(0));
    }
    for (let i = e.offset - 1; !r && i >= 0; i--) {
      let o = Zn.get(n.childNodes[i]);
      o instanceof kr && (r = o.domAtPos(o.length));
    }
    return r ? new Kr(r.node, r.offset, !0) : e;
  }
  nearest(e) {
    for (let n = e; n; ) {
      let r = Zn.get(n);
      if (r && r.rootView == this)
        return r;
      n = n.parentNode;
    }
    return null;
  }
  posFromDOM(e, n) {
    let r = this.nearest(e);
    if (!r)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return r.localPosFromDOM(e, n) + r.posAtStart;
  }
  domAtPos(e) {
    let { i: n, off: r } = this.childCursor().findPos(e, -1);
    for (; n < this.children.length - 1; ) {
      let i = this.children[n];
      if (r < i.length || i instanceof kr)
        break;
      n++, r = 0;
    }
    return this.children[n].domAtPos(r);
  }
  coordsAt(e, n) {
    let r = null, i = 0;
    for (let o = this.length, s = this.children.length - 1; s >= 0; s--) {
      let a = this.children[s], l = o - a.breakAfter, c = l - a.length;
      if (l < e)
        break;
      c <= e && (c < e || a.covers(-1)) && (l > e || a.covers(1)) && (!r || a instanceof kr && !(r instanceof kr && n >= 0)) && (r = a, i = c), o = c;
    }
    return r ? r.coordsAt(e - i, n) : null;
  }
  coordsForChar(e) {
    let { i: n, off: r } = this.childPos(e, 1), i = this.children[n];
    if (!(i instanceof kr))
      return null;
    for (; i.children.length; ) {
      let { i: a, off: l } = i.childPos(r, 1);
      for (; ; a++) {
        if (a == i.children.length)
          return null;
        if ((i = i.children[a]).length)
          break;
      }
      r = l;
    }
    if (!(i instanceof ps))
      return null;
    let o = Br(i.text, r);
    if (o == r)
      return null;
    let s = Fa(i.dom, r, o).getClientRects();
    for (let a = 0; a < s.length; a++) {
      let l = s[a];
      if (a == s.length - 1 || l.top < l.bottom && l.left < l.right)
        return l;
    }
    return null;
  }
  measureVisibleLineHeights(e) {
    let n = [], { from: r, to: i } = e, o = this.view.contentDOM.clientWidth, s = o > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, a = -1, l = this.view.textDirection == cr.LTR;
    for (let c = 0, u = 0; u < this.children.length; u++) {
      let f = this.children[u], d = c + f.length;
      if (d > i)
        break;
      if (c >= r) {
        let h = f.dom.getBoundingClientRect();
        if (n.push(h.height), s) {
          let p = f.dom.lastChild, m = p ? Au(p) : [];
          if (m.length) {
            let g = m[m.length - 1], v = l ? g.right - h.left : h.right - g.left;
            v > a && (a = v, this.minWidth = o, this.minWidthFrom = c, this.minWidthTo = d);
          }
        }
      }
      c = d + f.breakAfter;
    }
    return n;
  }
  textDirectionAt(e) {
    let { i: n } = this.childPos(e, 1);
    return getComputedStyle(this.children[n].dom).direction == "rtl" ? cr.RTL : cr.LTR;
  }
  measureTextSize() {
    for (let o of this.children)
      if (o instanceof kr) {
        let s = o.measureTextSize();
        if (s)
          return s;
      }
    let e = document.createElement("div"), n, r, i;
    return e.className = "cm-line", e.style.width = "99999px", e.style.position = "absolute", e.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(e);
      let o = Au(e.firstChild)[0];
      n = e.getBoundingClientRect().height, r = o ? o.width / 27 : 7, i = o ? o.height : n, e.remove();
    }), { lineHeight: n, charWidth: r, textHeight: i };
  }
  childCursor(e = this.length) {
    let n = this.children.length;
    return n && (e -= this.children[--n].length), new lC(this.children, e, n);
  }
  computeBlockGapDeco() {
    let e = [], n = this.view.viewState;
    for (let r = 0, i = 0; ; i++) {
      let o = i == n.viewports.length ? null : n.viewports[i], s = o ? o.from - 1 : this.length;
      if (s > r) {
        let a = (n.lineBlockAt(s).bottom - n.lineBlockAt(r).top) / this.view.scaleY;
        e.push(Bt.replace({
          widget: new j2(a),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(r, s));
      }
      if (!o)
        break;
      r = o.to + 1;
    }
    return Bt.set(e);
  }
  updateDeco() {
    let e = this.view.state.facet(_u).map((n, r) => (this.dynamicDecorationMap[r] = typeof n == "function") ? n(this.view) : n);
    for (let n = e.length; n < e.length + 3; n++)
      this.dynamicDecorationMap[n] = !1;
    return this.decorations = [
      ...e,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ];
  }
  scrollIntoView(e) {
    if (e.isSnapshot) {
      let c = this.view.viewState.lineBlockAt(e.range.head);
      this.view.scrollDOM.scrollTop = c.top - e.yMargin, this.view.scrollDOM.scrollLeft = e.xMargin;
      return;
    }
    let { range: n } = e, r = this.coordsAt(n.head, n.empty ? n.assoc : n.head > n.anchor ? -1 : 1), i;
    if (!r)
      return;
    !n.empty && (i = this.coordsAt(n.anchor, n.anchor > n.head ? -1 : 1)) && (r = {
      left: Math.min(r.left, i.left),
      top: Math.min(r.top, i.top),
      right: Math.max(r.right, i.right),
      bottom: Math.max(r.bottom, i.bottom)
    });
    let o = EC(this.view), s = {
      left: r.left - o.left,
      top: r.top - o.top,
      right: r.right + o.right,
      bottom: r.bottom + o.bottom
    }, { offsetWidth: a, offsetHeight: l } = this.view.scrollDOM;
    LB(this.view.scrollDOM, s, n.head < n.anchor ? -1 : 1, e.x, e.y, Math.max(Math.min(e.xMargin, a), -a), Math.max(Math.min(e.yMargin, l), -l), this.view.textDirection == cr.LTR);
  }
}
function iq(t) {
  return t.node.nodeType == 1 && t.node.firstChild && (t.offset == 0 || t.node.childNodes[t.offset - 1].contentEditable == "false") && (t.offset == t.node.childNodes.length || t.node.childNodes[t.offset].contentEditable == "false");
}
class j2 extends ua {
  constructor(e) {
    super(), this.height = e;
  }
  toDOM() {
    let e = document.createElement("div");
    return this.updateDOM(e), e;
  }
  eq(e) {
    return e.height == this.height;
  }
  updateDOM(e) {
    return e.style.height = this.height + "px", !0;
  }
  get estimatedHeight() {
    return this.height;
  }
}
function RC(t, e) {
  let n = t.observer.selectionRange, r = n.focusNode && NC(n.focusNode, n.focusOffset, 0);
  if (!r)
    return null;
  let i = e - r.offset;
  return { from: i, to: i + r.node.nodeValue.length, node: r.node };
}
function oq(t, e, n) {
  let r = RC(t, n);
  if (!r)
    return null;
  let { node: i, from: o, to: s } = r, a = i.nodeValue;
  if (/[\n\r]/.test(a) || t.state.doc.sliceString(r.from, r.to) != a)
    return null;
  let l = e.invertedDesc, c = new Ni(l.mapPos(o), l.mapPos(s), o, s), u = [];
  for (let f = i.parentNode; ; f = f.parentNode) {
    let d = Zn.get(f);
    if (d instanceof ms)
      u.push({ node: f, deco: d.mark });
    else {
      if (d instanceof kr || f.nodeName == "DIV" && f.parentNode == t.contentDOM)
        return { range: c, text: i, marks: u, line: f };
      if (f != t.contentDOM)
        u.push({ node: f, deco: new rf({
          inclusive: !0,
          attributes: WB(f),
          tagName: f.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function NC(t, e, n) {
  if (n <= 0)
    for (let r = t, i = e; ; ) {
      if (r.nodeType == 3)
        return { node: r, offset: i };
      if (r.nodeType == 1 && i > 0)
        r = r.childNodes[i - 1], i = hs(r);
      else
        break;
    }
  if (n >= 0)
    for (let r = t, i = e; ; ) {
      if (r.nodeType == 3)
        return { node: r, offset: i };
      if (r.nodeType == 1 && i < r.childNodes.length && n >= 0)
        r = r.childNodes[i], i = 0;
      else
        break;
    }
  return null;
}
function sq(t, e) {
  return t.nodeType != 1 ? 0 : (e && t.childNodes[e - 1].contentEditable == "false" ? 1 : 0) | (e < t.childNodes.length && t.childNodes[e].contentEditable == "false" ? 2 : 0);
}
let aq = class {
  constructor() {
    this.changes = [];
  }
  compareRange(e, n) {
    Kg(e, n, this.changes);
  }
  comparePoint(e, n) {
    Kg(e, n, this.changes);
  }
};
function lq(t, e, n) {
  let r = new aq();
  return En.compare(t, e, n, r), r.changes;
}
function cq(t, e) {
  for (let n = t; n && n != e; n = n.assignedSlot || n.parentNode)
    if (n.nodeType == 1 && n.contentEditable == "false")
      return !0;
  return !1;
}
function uq(t, e) {
  let n = !1;
  return e && t.iterChangedRanges((r, i) => {
    r < e.to && i > e.from && (n = !0);
  }), n;
}
function fq(t, e, n = 1) {
  let r = t.charCategorizer(e), i = t.doc.lineAt(e), o = e - i.from;
  if (i.length == 0)
    return Te.cursor(e);
  o == 0 ? n = 1 : o == i.length && (n = -1);
  let s = o, a = o;
  n < 0 ? s = Br(i.text, o, !1) : a = Br(i.text, o);
  let l = r(i.text.slice(s, a));
  for (; s > 0; ) {
    let c = Br(i.text, s, !1);
    if (r(i.text.slice(c, s)) != l)
      break;
    s = c;
  }
  for (; a < i.length; ) {
    let c = Br(i.text, a);
    if (r(i.text.slice(a, c)) != l)
      break;
    a = c;
  }
  return Te.range(s + i.from, a + i.from);
}
function dq(t, e) {
  return e.left > t ? e.left - t : Math.max(0, t - e.right);
}
function hq(t, e) {
  return e.top > t ? e.top - t : Math.max(0, t - e.bottom);
}
function ym(t, e) {
  return t.top < e.bottom - 1 && t.bottom > e.top + 1;
}
function k2(t, e) {
  return e < t.top ? { top: e, left: t.left, right: t.right, bottom: t.bottom } : t;
}
function $2(t, e) {
  return e > t.bottom ? { top: t.top, left: t.left, right: t.right, bottom: e } : t;
}
function Zg(t, e, n) {
  let r, i, o, s, a = !1, l, c, u, f;
  for (let p = t.firstChild; p; p = p.nextSibling) {
    let m = Au(p);
    for (let g = 0; g < m.length; g++) {
      let v = m[g];
      i && ym(i, v) && (v = k2($2(v, i.bottom), i.top));
      let y = dq(e, v), w = hq(n, v);
      if (y == 0 && w == 0)
        return p.nodeType == 3 ? S2(p, e, n) : Zg(p, e, n);
      if (!r || s > w || s == w && o > y) {
        r = p, i = v, o = y, s = w;
        let x = w ? n < v.top ? -1 : 1 : y ? e < v.left ? -1 : 1 : 0;
        a = !x || (x > 0 ? g < m.length - 1 : g > 0);
      }
      y == 0 ? n > v.bottom && (!u || u.bottom < v.bottom) ? (l = p, u = v) : n < v.top && (!f || f.top > v.top) && (c = p, f = v) : u && ym(u, v) ? u = $2(u, v.bottom) : f && ym(f, v) && (f = k2(f, v.top));
    }
  }
  if (u && u.bottom >= n ? (r = l, i = u) : f && f.top <= n && (r = c, i = f), !r)
    return { node: t, offset: 0 };
  let d = Math.max(i.left, Math.min(i.right, e));
  if (r.nodeType == 3)
    return S2(r, d, n);
  if (a && r.contentEditable != "false")
    return Zg(r, d, n);
  let h = Array.prototype.indexOf.call(t.childNodes, r) + (e >= (i.left + i.right) / 2 ? 1 : 0);
  return { node: t, offset: h };
}
function S2(t, e, n) {
  let r = t.nodeValue.length, i = -1, o = 1e9, s = 0;
  for (let a = 0; a < r; a++) {
    let l = Fa(t, a, a + 1).getClientRects();
    for (let c = 0; c < l.length; c++) {
      let u = l[c];
      if (u.top == u.bottom)
        continue;
      s || (s = e - u.left);
      let f = (u.top > n ? u.top - n : n - u.bottom) - 1;
      if (u.left - 1 <= e && u.right + 1 >= e && f < o) {
        let d = e >= (u.left + u.right) / 2, h = d;
        if ((jt.chrome || jt.gecko) && Fa(t, a).getBoundingClientRect().left == u.right && (h = !d), f <= 0)
          return { node: t, offset: a + (h ? 1 : 0) };
        i = a + (h ? 1 : 0), o = f;
      }
    }
  }
  return { node: t, offset: i > -1 ? i : s > 0 ? t.nodeValue.length : 0 };
}
function IC(t, e, n, r = -1) {
  var i, o;
  let s = t.contentDOM.getBoundingClientRect(), a = s.top + t.viewState.paddingTop, l, { docHeight: c } = t.viewState, { x: u, y: f } = e, d = f - a;
  if (d < 0)
    return 0;
  if (d > c)
    return t.state.doc.length;
  for (let x = t.viewState.heightOracle.textHeight / 2, b = !1; l = t.elementAtHeight(d), l.type != ri.Text; )
    for (; d = r > 0 ? l.bottom + x : l.top - x, !(d >= 0 && d <= c); ) {
      if (b)
        return n ? null : 0;
      b = !0, r = -r;
    }
  f = a + d;
  let h = l.from;
  if (h < t.viewport.from)
    return t.viewport.from == 0 ? 0 : n ? null : C2(t, s, l, u, f);
  if (h > t.viewport.to)
    return t.viewport.to == t.state.doc.length ? t.state.doc.length : n ? null : C2(t, s, l, u, f);
  let p = t.dom.ownerDocument, m = t.root.elementFromPoint ? t.root : p, g = m.elementFromPoint(u, f);
  g && !t.contentDOM.contains(g) && (g = null), g || (u = Math.max(s.left + 1, Math.min(s.right - 1, u)), g = m.elementFromPoint(u, f), g && !t.contentDOM.contains(g) && (g = null));
  let v, y = -1;
  if (g && ((i = t.docView.nearest(g)) === null || i === void 0 ? void 0 : i.isEditable) != !1) {
    if (p.caretPositionFromPoint) {
      let x = p.caretPositionFromPoint(u, f);
      x && ({ offsetNode: v, offset: y } = x);
    } else if (p.caretRangeFromPoint) {
      let x = p.caretRangeFromPoint(u, f);
      x && ({ startContainer: v, startOffset: y } = x, (!t.contentDOM.contains(v) || jt.safari && pq(v, y, u) || jt.chrome && mq(v, y, u)) && (v = void 0));
    }
  }
  if (!v || !t.docView.dom.contains(v)) {
    let x = kr.find(t.docView, h);
    if (!x)
      return d > l.top + l.height / 2 ? l.to : l.from;
    ({ node: v, offset: y } = Zg(x.dom, u, f));
  }
  let w = t.docView.nearest(v);
  if (!w)
    return null;
  if (w.isWidget && ((o = w.dom) === null || o === void 0 ? void 0 : o.nodeType) == 1) {
    let x = w.dom.getBoundingClientRect();
    return e.y < x.top || e.y <= x.bottom && e.x <= (x.left + x.right) / 2 ? w.posAtStart : w.posAtEnd;
  } else
    return w.localPosFromDOM(v, y) + w.posAtStart;
}
function C2(t, e, n, r, i) {
  let o = Math.round((r - e.left) * t.defaultCharacterWidth);
  if (t.lineWrapping && n.height > t.defaultLineHeight * 1.5) {
    let a = t.viewState.heightOracle.textHeight, l = Math.floor((i - n.top - (t.defaultLineHeight - a) * 0.5) / a);
    o += l * t.viewState.heightOracle.lineLength;
  }
  let s = t.state.sliceDoc(n.from, n.to);
  return n.from + Bg(s, o, t.state.tabSize);
}
function pq(t, e, n) {
  let r;
  if (t.nodeType != 3 || e != (r = t.nodeValue.length))
    return !1;
  for (let i = t.nextSibling; i; i = i.nextSibling)
    if (i.nodeType != 1 || i.nodeName != "BR")
      return !1;
  return Fa(t, r - 1, r).getBoundingClientRect().left > n;
}
function mq(t, e, n) {
  if (e != 0)
    return !1;
  for (let i = t; ; ) {
    let o = i.parentNode;
    if (!o || o.nodeType != 1 || o.firstChild != i)
      return !1;
    if (o.classList.contains("cm-line"))
      break;
    i = o;
  }
  let r = t.nodeType == 1 ? t.getBoundingClientRect() : Fa(t, 0, Math.max(t.nodeValue.length, 1)).getBoundingClientRect();
  return n - r.left > 5;
}
function ev(t, e) {
  let n = t.lineBlockAt(e);
  if (Array.isArray(n.type)) {
    for (let r of n.type)
      if (r.to > e || r.to == e && (r.to == n.to || r.type == ri.Text))
        return r;
  }
  return n;
}
function gq(t, e, n, r) {
  let i = ev(t, e.head), o = !r || i.type != ri.Text || !(t.lineWrapping || i.widgetLineBreaks) ? null : t.coordsAtPos(e.assoc < 0 && e.head > i.from ? e.head - 1 : e.head);
  if (o) {
    let s = t.dom.getBoundingClientRect(), a = t.textDirectionAt(i.from), l = t.posAtCoords({
      x: n == (a == cr.LTR) ? s.right - 1 : s.left + 1,
      y: (o.top + o.bottom) / 2
    });
    if (l != null)
      return Te.cursor(l, n ? -1 : 1);
  }
  return Te.cursor(n ? i.to : i.from, n ? -1 : 1);
}
function O2(t, e, n, r) {
  let i = t.state.doc.lineAt(e.head), o = t.bidiSpans(i), s = t.textDirectionAt(i.from);
  for (let a = e, l = null; ; ) {
    let c = rq(i, o, s, a, n), u = PC;
    if (!c) {
      if (i.number == (n ? t.state.doc.lines : 1))
        return a;
      u = `
`, i = t.state.doc.line(i.number + (n ? 1 : -1)), o = t.bidiSpans(i), c = Te.cursor(n ? i.from : i.to);
    }
    if (l) {
      if (!l(u))
        return a;
    } else {
      if (!r)
        return c;
      l = r(u);
    }
    a = c;
  }
}
function vq(t, e, n) {
  let r = t.state.charCategorizer(e), i = r(n);
  return (o) => {
    let s = r(o);
    return i == rr.Space && (i = s), i == s;
  };
}
function yq(t, e, n, r) {
  let i = e.head, o = n ? 1 : -1;
  if (i == (n ? t.state.doc.length : 0))
    return Te.cursor(i, e.assoc);
  let s = e.goalColumn, a, l = t.contentDOM.getBoundingClientRect(), c = t.coordsAtPos(i, e.assoc || -1), u = t.documentTop;
  if (c)
    s == null && (s = c.left - l.left), a = o < 0 ? c.top : c.bottom;
  else {
    let h = t.viewState.lineBlockAt(i);
    s == null && (s = Math.min(l.right - l.left, t.defaultCharacterWidth * (i - h.from))), a = (o < 0 ? h.top : h.bottom) + u;
  }
  let f = l.left + s, d = r ?? t.viewState.heightOracle.textHeight >> 1;
  for (let h = 0; ; h += 10) {
    let p = a + (d + h) * o, m = IC(t, { x: f, y: p }, !1, o);
    if (p < l.top || p > l.bottom || (o < 0 ? m < i : m > i)) {
      let g = t.docView.coordsForChar(m), v = !g || p < g.top ? -1 : 1;
      return Te.cursor(m, v, void 0, s);
    }
  }
}
function Td(t, e, n) {
  for (; ; ) {
    let r = 0;
    for (let i of t)
      i.between(e - 1, e + 1, (o, s, a) => {
        if (e > o && e < s) {
          let l = r || n || (e - o < s - e ? -1 : 1);
          e = l < 0 ? o : s, r = l;
        }
      });
    if (!r)
      return e;
  }
}
function bm(t, e, n) {
  let r = Td(t.state.facet(G0).map((i) => i(t)), n.from, e.head > n.from ? -1 : 1);
  return r == n.from ? n : Te.cursor(r, r < n.from ? 1 : -1);
}
class bq {
  setSelectionOrigin(e) {
    this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
  }
  constructor(e) {
    this.view = e, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastEscPress = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = e.hasFocus, jt.safari && e.contentDOM.addEventListener("input", () => null), jt.gecko && Nq(e.contentDOM.ownerDocument);
  }
  handleEvent(e) {
    !Oq(this.view, e) || this.ignoreDuringComposition(e) || e.type == "keydown" && this.keydown(e) || this.runHandlers(e.type, e);
  }
  runHandlers(e, n) {
    let r = this.handlers[e];
    if (r) {
      for (let i of r.observers)
        i(this.view, n);
      for (let i of r.handlers) {
        if (n.defaultPrevented)
          break;
        if (i(this.view, n)) {
          n.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(e) {
    let n = xq(e), r = this.handlers, i = this.view.contentDOM;
    for (let o in n)
      if (o != "scroll") {
        let s = !n[o].handlers.length, a = r[o];
        a && s != !a.handlers.length && (i.removeEventListener(o, this.handleEvent), a = null), a || i.addEventListener(o, this.handleEvent, { passive: s });
      }
    for (let o in r)
      o != "scroll" && !n[o] && i.removeEventListener(o, this.handleEvent);
    this.handlers = n;
  }
  keydown(e) {
    if (this.lastKeyCode = e.keyCode, this.lastKeyTime = Date.now(), e.keyCode == 9 && Date.now() < this.lastEscPress + 2e3)
      return !0;
    if (e.keyCode != 27 && LC.indexOf(e.keyCode) < 0 && (this.view.inputState.lastEscPress = 0), jt.android && jt.chrome && !e.synthetic && (e.keyCode == 13 || e.keyCode == 8))
      return this.view.observer.delayAndroidKey(e.key, e.keyCode), !0;
    let n;
    return jt.ios && !e.synthetic && !e.altKey && !e.metaKey && ((n = DC.find((r) => r.keyCode == e.keyCode)) && !e.ctrlKey || wq.indexOf(e.key) > -1 && e.ctrlKey && !e.shiftKey) ? (this.pendingIOSKey = n || e, setTimeout(() => this.flushIOSKey(), 250), !0) : (e.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey() {
    let e = this.pendingIOSKey;
    return e ? (this.pendingIOSKey = void 0, Nl(this.view.contentDOM, e.key, e.keyCode)) : !1;
  }
  ignoreDuringComposition(e) {
    return /^key/.test(e.type) ? this.composing > 0 ? !0 : jt.safari && !jt.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1 : !1;
  }
  startMouseSelection(e) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
  }
  update(e) {
    this.mouseSelection && this.mouseSelection.update(e), this.draggedContent && e.docChanged && (this.draggedContent = this.draggedContent.map(e.changes)), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function E2(t, e) {
  return (n, r) => {
    try {
      return e.call(t, r, n);
    } catch (i) {
      $i(n.state, i);
    }
  };
}
function xq(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    return e[r] || (e[r] = { observers: [], handlers: [] });
  }
  for (let r of t) {
    let i = r.spec;
    if (i && i.domEventHandlers)
      for (let o in i.domEventHandlers) {
        let s = i.domEventHandlers[o];
        s && n(o).handlers.push(E2(r.value, s));
      }
    if (i && i.domEventObservers)
      for (let o in i.domEventObservers) {
        let s = i.domEventObservers[o];
        s && n(o).observers.push(E2(r.value, s));
      }
  }
  for (let r in fo)
    n(r).handlers.push(fo[r]);
  for (let r in ho)
    n(r).observers.push(ho[r]);
  return e;
}
const DC = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], wq = "dthko", LC = [16, 17, 18, 20, 91, 92, 224, 225], Bf = 6;
function qf(t) {
  return Math.max(0, t) * 0.7 + 8;
}
function jq(t, e) {
  return Math.max(Math.abs(t.clientX - e.clientX), Math.abs(t.clientY - e.clientY));
}
class kq {
  constructor(e, n, r, i) {
    this.view = e, this.startEvent = n, this.style = r, this.mustSelect = i, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = n, this.scrollParent = BB(e.contentDOM), this.atoms = e.state.facet(G0).map((s) => s(e));
    let o = e.contentDOM.ownerDocument;
    o.addEventListener("mousemove", this.move = this.move.bind(this)), o.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = e.state.facet(gn.allowMultipleSelections) && $q(e, n), this.dragging = Cq(e, n) && FC(n) == 1 ? null : !1;
  }
  start(e) {
    this.dragging === !1 && this.select(e);
  }
  move(e) {
    var n;
    if (e.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && jq(this.startEvent, e) < 10)
      return;
    this.select(this.lastEvent = e);
    let r = 0, i = 0, o = ((n = this.scrollParent) === null || n === void 0 ? void 0 : n.getBoundingClientRect()) || { left: 0, top: 0, right: this.view.win.innerWidth, bottom: this.view.win.innerHeight }, s = EC(this.view);
    e.clientX - s.left <= o.left + Bf ? r = -qf(o.left - e.clientX) : e.clientX + s.right >= o.right - Bf && (r = qf(e.clientX - o.right)), e.clientY - s.top <= o.top + Bf ? i = -qf(o.top - e.clientY) : e.clientY + s.bottom >= o.bottom - Bf && (i = qf(e.clientY - o.bottom)), this.setScrollSpeed(r, i);
  }
  up(e) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let e = this.view.contentDOM.ownerDocument;
    e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(e, n) {
    this.scrollSpeed = { x: e, y: n }, e || n ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    this.scrollParent ? (this.scrollParent.scrollLeft += this.scrollSpeed.x, this.scrollParent.scrollTop += this.scrollSpeed.y) : this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y), this.dragging === !1 && this.select(this.lastEvent);
  }
  skipAtoms(e) {
    let n = null;
    for (let r = 0; r < e.ranges.length; r++) {
      let i = e.ranges[r], o = null;
      if (i.empty) {
        let s = Td(this.atoms, i.from, 0);
        s != i.from && (o = Te.cursor(s, -1));
      } else {
        let s = Td(this.atoms, i.from, -1), a = Td(this.atoms, i.to, 1);
        (s != i.from || a != i.to) && (o = Te.range(i.from == i.anchor ? s : a, i.from == i.head ? s : a));
      }
      o && (n || (n = e.ranges.slice()), n[r] = o);
    }
    return n ? Te.create(n, e.mainIndex) : e;
  }
  select(e) {
    let { view: n } = this, r = this.skipAtoms(this.style.get(e, this.extend, this.multiple));
    (this.mustSelect || !r.eq(n.state.selection) || r.main.assoc != n.state.selection.main.assoc && this.dragging === !1) && this.view.dispatch({
      selection: r,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(e) {
    this.style.update(e) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function $q(t, e) {
  let n = t.state.facet(vC);
  return n.length ? n[0](e) : jt.mac ? e.metaKey : e.ctrlKey;
}
function Sq(t, e) {
  let n = t.state.facet(yC);
  return n.length ? n[0](e) : jt.mac ? !e.altKey : !e.ctrlKey;
}
function Cq(t, e) {
  let { main: n } = t.state.selection;
  if (n.empty)
    return !1;
  let r = sh(t.root);
  if (!r || r.rangeCount == 0)
    return !0;
  let i = r.getRangeAt(0).getClientRects();
  for (let o = 0; o < i.length; o++) {
    let s = i[o];
    if (s.left <= e.clientX && s.right >= e.clientX && s.top <= e.clientY && s.bottom >= e.clientY)
      return !0;
  }
  return !1;
}
function Oq(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target, r; n != t.contentDOM; n = n.parentNode)
    if (!n || n.nodeType == 11 || (r = Zn.get(n)) && r.ignoreEvent(e))
      return !1;
  return !0;
}
const fo = /* @__PURE__ */ Object.create(null), ho = /* @__PURE__ */ Object.create(null), BC = jt.ie && jt.ie_version < 15 || jt.ios && jt.webkit_version < 604;
function Eq(t) {
  let e = t.dom.parentNode;
  if (!e)
    return;
  let n = e.appendChild(document.createElement("textarea"));
  n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    t.focus(), n.remove(), qC(t, n.value);
  }, 50);
}
function qC(t, e) {
  let { state: n } = t, r, i = 1, o = n.toText(e), s = o.lines == n.selection.ranges.length;
  if (tv != null && n.selection.ranges.every((l) => l.empty) && tv == o.toString()) {
    let l = -1;
    r = n.changeByRange((c) => {
      let u = n.doc.lineAt(c.from);
      if (u.from == l)
        return { range: c };
      l = u.from;
      let f = n.toText((s ? o.line(i++).text : e) + n.lineBreak);
      return {
        changes: { from: u.from, insert: f },
        range: Te.cursor(c.from + f.length)
      };
    });
  } else
    s ? r = n.changeByRange((l) => {
      let c = o.line(i++);
      return {
        changes: { from: l.from, to: l.to, insert: c.text },
        range: Te.cursor(l.from + c.length)
      };
    }) : r = n.replaceSelection(o);
  t.dispatch(r, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
ho.scroll = (t) => {
  t.inputState.lastScrollTop = t.scrollDOM.scrollTop, t.inputState.lastScrollLeft = t.scrollDOM.scrollLeft;
};
fo.keydown = (t, e) => (t.inputState.setSelectionOrigin("select"), e.keyCode == 27 && (t.inputState.lastEscPress = Date.now()), !1);
ho.touchstart = (t, e) => {
  t.inputState.lastTouchTime = Date.now(), t.inputState.setSelectionOrigin("select.pointer");
};
ho.touchmove = (t) => {
  t.inputState.setSelectionOrigin("select.pointer");
};
fo.mousedown = (t, e) => {
  if (t.observer.flush(), t.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let n = null;
  for (let r of t.state.facet(bC))
    if (n = r(t, e), n)
      break;
  if (!n && e.button == 0 && (n = _q(t, e)), n) {
    let r = !t.hasFocus;
    t.inputState.startMouseSelection(new kq(t, e, n, r)), r && t.observer.ignore(() => oC(t.contentDOM));
    let i = t.inputState.mouseSelection;
    if (i)
      return i.start(e), i.dragging === !1;
  }
  return !1;
};
function A2(t, e, n, r) {
  if (r == 1)
    return Te.cursor(e, n);
  if (r == 2)
    return fq(t.state, e, n);
  {
    let i = kr.find(t.docView, e), o = t.state.doc.lineAt(i ? i.posAtEnd : e), s = i ? i.posAtStart : o.from, a = i ? i.posAtEnd : o.to;
    return a < t.state.doc.length && a == o.to && a++, Te.range(s, a);
  }
}
let zC = (t, e) => t >= e.top && t <= e.bottom, M2 = (t, e, n) => zC(e, n) && t >= n.left && t <= n.right;
function Aq(t, e, n, r) {
  let i = kr.find(t.docView, e);
  if (!i)
    return 1;
  let o = e - i.posAtStart;
  if (o == 0)
    return 1;
  if (o == i.length)
    return -1;
  let s = i.coordsAt(o, -1);
  if (s && M2(n, r, s))
    return -1;
  let a = i.coordsAt(o, 1);
  return a && M2(n, r, a) ? 1 : s && zC(r, s) ? -1 : 1;
}
function _2(t, e) {
  let n = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1);
  return { pos: n, bias: Aq(t, n, e.clientX, e.clientY) };
}
const Mq = jt.ie && jt.ie_version <= 11;
let T2 = null, P2 = 0, R2 = 0;
function FC(t) {
  if (!Mq)
    return t.detail;
  let e = T2, n = R2;
  return T2 = t, R2 = Date.now(), P2 = !e || n > Date.now() - 400 && Math.abs(e.clientX - t.clientX) < 2 && Math.abs(e.clientY - t.clientY) < 2 ? (P2 + 1) % 3 : 1;
}
function _q(t, e) {
  let n = _2(t, e), r = FC(e), i = t.state.selection;
  return {
    update(o) {
      o.docChanged && (n.pos = o.changes.mapPos(n.pos), i = i.map(o.changes));
    },
    get(o, s, a) {
      let l = _2(t, o), c, u = A2(t, l.pos, l.bias, r);
      if (n.pos != l.pos && !s) {
        let f = A2(t, n.pos, n.bias, r), d = Math.min(f.from, u.from), h = Math.max(f.to, u.to);
        u = d < u.from ? Te.range(d, h) : Te.range(h, d);
      }
      return s ? i.replaceRange(i.main.extend(u.from, u.to)) : a && r == 1 && i.ranges.length > 1 && (c = Tq(i, l.pos)) ? c : a ? i.addRange(u) : Te.create([u]);
    }
  };
}
function Tq(t, e) {
  for (let n = 0; n < t.ranges.length; n++) {
    let { from: r, to: i } = t.ranges[n];
    if (r <= e && i >= e)
      return Te.create(t.ranges.slice(0, n).concat(t.ranges.slice(n + 1)), t.mainIndex == n ? 0 : t.mainIndex - (t.mainIndex > n ? 1 : 0));
  }
  return null;
}
fo.dragstart = (t, e) => {
  let { selection: { main: n } } = t.state;
  if (e.target.draggable) {
    let i = t.docView.nearest(e.target);
    if (i && i.isWidget) {
      let o = i.posAtStart, s = o + i.length;
      (o >= n.to || s <= n.from) && (n = Te.range(o, s));
    }
  }
  let { inputState: r } = t;
  return r.mouseSelection && (r.mouseSelection.dragging = !0), r.draggedContent = n, e.dataTransfer && (e.dataTransfer.setData("Text", t.state.sliceDoc(n.from, n.to)), e.dataTransfer.effectAllowed = "copyMove"), !1;
};
fo.dragend = (t) => (t.inputState.draggedContent = null, !1);
function N2(t, e, n, r) {
  if (!n)
    return;
  let i = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1), { draggedContent: o } = t.inputState, s = r && o && Sq(t, e) ? { from: o.from, to: o.to } : null, a = { from: i, insert: n }, l = t.state.changes(s ? [s, a] : a);
  t.focus(), t.dispatch({
    changes: l,
    selection: { anchor: l.mapPos(i, -1), head: l.mapPos(i, 1) },
    userEvent: s ? "move.drop" : "input.drop"
  }), t.inputState.draggedContent = null;
}
fo.drop = (t, e) => {
  if (!e.dataTransfer)
    return !1;
  if (t.state.readOnly)
    return !0;
  let n = e.dataTransfer.files;
  if (n && n.length) {
    let r = Array(n.length), i = 0, o = () => {
      ++i == n.length && N2(t, e, r.filter((s) => s != null).join(t.state.lineBreak), !1);
    };
    for (let s = 0; s < n.length; s++) {
      let a = new FileReader();
      a.onerror = o, a.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(a.result) || (r[s] = a.result), o();
      }, a.readAsText(n[s]);
    }
    return !0;
  } else {
    let r = e.dataTransfer.getData("Text");
    if (r)
      return N2(t, e, r, !0), !0;
  }
  return !1;
};
fo.paste = (t, e) => {
  if (t.state.readOnly)
    return !0;
  t.observer.flush();
  let n = BC ? null : e.clipboardData;
  return n ? (qC(t, n.getData("text/plain") || n.getData("text/uri-text")), !0) : (Eq(t), !1);
};
function Pq(t, e) {
  let n = t.dom.parentNode;
  if (!n)
    return;
  let r = n.appendChild(document.createElement("textarea"));
  r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = e, r.focus(), r.selectionEnd = e.length, r.selectionStart = 0, setTimeout(() => {
    r.remove(), t.focus();
  }, 50);
}
function Rq(t) {
  let e = [], n = [], r = !1;
  for (let i of t.selection.ranges)
    i.empty || (e.push(t.sliceDoc(i.from, i.to)), n.push(i));
  if (!e.length) {
    let i = -1;
    for (let { from: o } of t.selection.ranges) {
      let s = t.doc.lineAt(o);
      s.number > i && (e.push(s.text), n.push({ from: s.from, to: Math.min(t.doc.length, s.to + 1) })), i = s.number;
    }
    r = !0;
  }
  return { text: e.join(t.lineBreak), ranges: n, linewise: r };
}
let tv = null;
fo.copy = fo.cut = (t, e) => {
  let { text: n, ranges: r, linewise: i } = Rq(t.state);
  if (!n && !i)
    return !1;
  tv = i ? n : null, e.type == "cut" && !t.state.readOnly && t.dispatch({
    changes: r,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let o = BC ? null : e.clipboardData;
  return o ? (o.clearData(), o.setData("text/plain", n), !0) : (Pq(t, n), !1);
};
const VC = /* @__PURE__ */ Ss.define();
function HC(t, e) {
  let n = [];
  for (let r of t.facet(jC)) {
    let i = r(t, e);
    i && n.push(i);
  }
  return n ? t.update({ effects: n, annotations: VC.of(!0) }) : null;
}
function UC(t) {
  setTimeout(() => {
    let e = t.hasFocus;
    if (e != t.inputState.notifiedFocused) {
      let n = HC(t.state, e);
      n ? t.dispatch(n) : t.update([]);
    }
  }, 10);
}
ho.focus = (t) => {
  t.inputState.lastFocusTime = Date.now(), !t.scrollDOM.scrollTop && (t.inputState.lastScrollTop || t.inputState.lastScrollLeft) && (t.scrollDOM.scrollTop = t.inputState.lastScrollTop, t.scrollDOM.scrollLeft = t.inputState.lastScrollLeft), UC(t);
};
ho.blur = (t) => {
  t.observer.clearSelectionRange(), UC(t);
};
ho.compositionstart = ho.compositionupdate = (t) => {
  t.inputState.compositionFirstChange == null && (t.inputState.compositionFirstChange = !0), t.inputState.composing < 0 && (t.inputState.composing = 0);
};
ho.compositionend = (t) => {
  t.inputState.composing = -1, t.inputState.compositionEndedAt = Date.now(), t.inputState.compositionPendingKey = !0, t.inputState.compositionPendingChange = t.observer.pendingRecords().length > 0, t.inputState.compositionFirstChange = null, jt.chrome && jt.android ? t.observer.flushSoon() : t.inputState.compositionPendingChange ? Promise.resolve().then(() => t.observer.flush()) : setTimeout(() => {
    t.inputState.composing < 0 && t.docView.hasComposition && t.update([]);
  }, 50);
};
ho.contextmenu = (t) => {
  t.inputState.lastContextMenu = Date.now();
};
fo.beforeinput = (t, e) => {
  var n;
  let r;
  if (jt.chrome && jt.android && (r = DC.find((i) => i.inputType == e.inputType)) && (t.observer.delayAndroidKey(r.key, r.keyCode), r.key == "Backspace" || r.key == "Delete")) {
    let i = ((n = window.visualViewport) === null || n === void 0 ? void 0 : n.height) || 0;
    setTimeout(() => {
      var o;
      (((o = window.visualViewport) === null || o === void 0 ? void 0 : o.height) || 0) > i + 10 && t.hasFocus && (t.contentDOM.blur(), t.focus());
    }, 100);
  }
  return !1;
};
const I2 = /* @__PURE__ */ new Set();
function Nq(t) {
  I2.has(t) || (I2.add(t), t.addEventListener("copy", () => {
  }), t.addEventListener("cut", () => {
  }));
}
const D2 = ["pre-wrap", "normal", "pre-line", "break-spaces"];
class Iq {
  constructor(e) {
    this.lineWrapping = e, this.doc = Cn.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30, this.heightChanged = !1;
  }
  heightForGap(e, n) {
    let r = this.doc.lineAt(n).number - this.doc.lineAt(e).number + 1;
    return this.lineWrapping && (r += Math.max(0, Math.ceil((n - e - r * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * r;
  }
  heightForLine(e) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(e) {
    return this.doc = e, this;
  }
  mustRefreshForWrapping(e) {
    return D2.indexOf(e) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(e) {
    let n = !1;
    for (let r = 0; r < e.length; r++) {
      let i = e[r];
      i < 0 ? r++ : this.heightSamples[Math.floor(i * 10)] || (n = !0, this.heightSamples[Math.floor(i * 10)] = !0);
    }
    return n;
  }
  refresh(e, n, r, i, o, s) {
    let a = D2.indexOf(e) > -1, l = Math.round(n) != Math.round(this.lineHeight) || this.lineWrapping != a;
    if (this.lineWrapping = a, this.lineHeight = n, this.charWidth = r, this.textHeight = i, this.lineLength = o, l) {
      this.heightSamples = {};
      for (let c = 0; c < s.length; c++) {
        let u = s[c];
        u < 0 ? c++ : this.heightSamples[Math.floor(u * 10)] = !0;
      }
    }
    return l;
  }
}
class Dq {
  constructor(e, n) {
    this.from = e, this.heights = n, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class Mo {
  /**
  @internal
  */
  constructor(e, n, r, i, o) {
    this.from = e, this.length = n, this.top = r, this.height = i, this._content = o;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? ri.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof ra ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(e) {
    let n = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(e._content) ? e._content : [e]);
    return new Mo(this.from, this.length + e.length, this.top, this.height + e.height, n);
  }
}
var Qn = /* @__PURE__ */ function(t) {
  return t[t.ByPos = 0] = "ByPos", t[t.ByHeight = 1] = "ByHeight", t[t.ByPosNoHeight = 2] = "ByPosNoHeight", t;
}(Qn || (Qn = {}));
const Pd = 1e-3;
class ii {
  constructor(e, n, r = 2) {
    this.length = e, this.height = n, this.flags = r;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(e) {
    this.flags = (e ? 2 : 0) | this.flags & -3;
  }
  setHeight(e, n) {
    this.height != n && (Math.abs(this.height - n) > Pd && (e.heightChanged = !0), this.height = n);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(e, n, r) {
    return ii.of(r);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(e, n) {
    n.push(this);
  }
  decomposeRight(e, n) {
    n.push(this);
  }
  applyChanges(e, n, r, i) {
    let o = this, s = r.doc;
    for (let a = i.length - 1; a >= 0; a--) {
      let { fromA: l, toA: c, fromB: u, toB: f } = i[a], d = o.lineAt(l, Qn.ByPosNoHeight, r.setDoc(n), 0, 0), h = d.to >= c ? d : o.lineAt(c, Qn.ByPosNoHeight, r, 0, 0);
      for (f += h.to - c, c = h.to; a > 0 && d.from <= i[a - 1].toA; )
        l = i[a - 1].fromA, u = i[a - 1].fromB, a--, l < d.from && (d = o.lineAt(l, Qn.ByPosNoHeight, r, 0, 0));
      u += d.from - l, l = d.from;
      let p = Q0.build(r.setDoc(s), e, u, f);
      o = o.replace(l, c, p);
    }
    return o.updateHeight(r, 0);
  }
  static empty() {
    return new yi(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(e) {
    if (e.length == 1)
      return e[0];
    let n = 0, r = e.length, i = 0, o = 0;
    for (; ; )
      if (n == r)
        if (i > o * 2) {
          let a = e[n - 1];
          a.break ? e.splice(--n, 1, a.left, null, a.right) : e.splice(--n, 1, a.left, a.right), r += 1 + a.break, i -= a.size;
        } else if (o > i * 2) {
          let a = e[r];
          a.break ? e.splice(r, 1, a.left, null, a.right) : e.splice(r, 1, a.left, a.right), r += 2 + a.break, o -= a.size;
        } else
          break;
      else if (i < o) {
        let a = e[n++];
        a && (i += a.size);
      } else {
        let a = e[--r];
        a && (o += a.size);
      }
    let s = 0;
    return e[n - 1] == null ? (s = 1, n--) : e[n] == null && (s = 1, r++), new Lq(ii.of(e.slice(0, n)), s, ii.of(e.slice(r)));
  }
}
ii.prototype.size = 1;
class WC extends ii {
  constructor(e, n, r) {
    super(e, n), this.deco = r;
  }
  blockAt(e, n, r, i) {
    return new Mo(i, this.length, r, this.height, this.deco || 0);
  }
  lineAt(e, n, r, i, o) {
    return this.blockAt(0, r, i, o);
  }
  forEachLine(e, n, r, i, o, s) {
    e <= o + this.length && n >= o && s(this.blockAt(0, r, i, o));
  }
  updateHeight(e, n = 0, r = !1, i) {
    return i && i.from <= n && i.more && this.setHeight(e, i.heights[i.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class yi extends WC {
  constructor(e, n) {
    super(e, n, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(e, n, r, i) {
    return new Mo(i, this.length, r, this.height, this.breaks);
  }
  replace(e, n, r) {
    let i = r[0];
    return r.length == 1 && (i instanceof yi || i instanceof Rr && i.flags & 4) && Math.abs(this.length - i.length) < 10 ? (i instanceof Rr ? i = new yi(i.length, this.height) : i.height = this.height, this.outdated || (i.outdated = !1), i) : ii.of(r);
  }
  updateHeight(e, n = 0, r = !1, i) {
    return i && i.from <= n && i.more ? this.setHeight(e, i.heights[i.index++]) : (r || this.outdated) && this.setHeight(e, Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) + this.breaks * e.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class Rr extends ii {
  constructor(e) {
    super(e, 0);
  }
  heightMetrics(e, n) {
    let r = e.doc.lineAt(n).number, i = e.doc.lineAt(n + this.length).number, o = i - r + 1, s, a = 0;
    if (e.lineWrapping) {
      let l = Math.min(this.height, e.lineHeight * o);
      s = l / o, this.length > o + 1 && (a = (this.height - l) / (this.length - o - 1));
    } else
      s = this.height / o;
    return { firstLine: r, lastLine: i, perLine: s, perChar: a };
  }
  blockAt(e, n, r, i) {
    let { firstLine: o, lastLine: s, perLine: a, perChar: l } = this.heightMetrics(n, i);
    if (n.lineWrapping) {
      let c = i + Math.round(Math.max(0, Math.min(1, (e - r) / this.height)) * this.length), u = n.doc.lineAt(c), f = a + u.length * l, d = Math.max(r, e - f / 2);
      return new Mo(u.from, u.length, d, f, 0);
    } else {
      let c = Math.max(0, Math.min(s - o, Math.floor((e - r) / a))), { from: u, length: f } = n.doc.line(o + c);
      return new Mo(u, f, r + a * c, a, 0);
    }
  }
  lineAt(e, n, r, i, o) {
    if (n == Qn.ByHeight)
      return this.blockAt(e, r, i, o);
    if (n == Qn.ByPosNoHeight) {
      let { from: h, to: p } = r.doc.lineAt(e);
      return new Mo(h, p - h, 0, 0, 0);
    }
    let { firstLine: s, perLine: a, perChar: l } = this.heightMetrics(r, o), c = r.doc.lineAt(e), u = a + c.length * l, f = c.number - s, d = i + a * f + l * (c.from - o - f);
    return new Mo(c.from, c.length, Math.max(i, Math.min(d, i + this.height - u)), u, 0);
  }
  forEachLine(e, n, r, i, o, s) {
    e = Math.max(e, o), n = Math.min(n, o + this.length);
    let { firstLine: a, perLine: l, perChar: c } = this.heightMetrics(r, o);
    for (let u = e, f = i; u <= n; ) {
      let d = r.doc.lineAt(u);
      if (u == e) {
        let p = d.number - a;
        f += l * p + c * (e - o - p);
      }
      let h = l + c * d.length;
      s(new Mo(d.from, d.length, f, h, 0)), f += h, u = d.to + 1;
    }
  }
  replace(e, n, r) {
    let i = this.length - n;
    if (i > 0) {
      let o = r[r.length - 1];
      o instanceof Rr ? r[r.length - 1] = new Rr(o.length + i) : r.push(null, new Rr(i - 1));
    }
    if (e > 0) {
      let o = r[0];
      o instanceof Rr ? r[0] = new Rr(e + o.length) : r.unshift(new Rr(e - 1), null);
    }
    return ii.of(r);
  }
  decomposeLeft(e, n) {
    n.push(new Rr(e - 1), null);
  }
  decomposeRight(e, n) {
    n.push(null, new Rr(this.length - e - 1));
  }
  updateHeight(e, n = 0, r = !1, i) {
    let o = n + this.length;
    if (i && i.from <= n + this.length && i.more) {
      let s = [], a = Math.max(n, i.from), l = -1;
      for (i.from > n && s.push(new Rr(i.from - n - 1).updateHeight(e, n)); a <= o && i.more; ) {
        let u = e.doc.lineAt(a).length;
        s.length && s.push(null);
        let f = i.heights[i.index++];
        l == -1 ? l = f : Math.abs(f - l) >= Pd && (l = -2);
        let d = new yi(u, f);
        d.outdated = !1, s.push(d), a += u + 1;
      }
      a <= o && s.push(null, new Rr(o - a).updateHeight(e, a));
      let c = ii.of(s);
      return (l < 0 || Math.abs(c.height - this.height) >= Pd || Math.abs(l - this.heightMetrics(e, n).perLine) >= Pd) && (e.heightChanged = !0), c;
    } else
      (r || this.outdated) && (this.setHeight(e, e.heightForGap(n, n + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class Lq extends ii {
  constructor(e, n, r) {
    super(e.length + n + r.length, e.height + r.height, n | (e.outdated || r.outdated ? 2 : 0)), this.left = e, this.right = r, this.size = e.size + r.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(e, n, r, i) {
    let o = r + this.left.height;
    return e < o ? this.left.blockAt(e, n, r, i) : this.right.blockAt(e, n, o, i + this.left.length + this.break);
  }
  lineAt(e, n, r, i, o) {
    let s = i + this.left.height, a = o + this.left.length + this.break, l = n == Qn.ByHeight ? e < s : e < a, c = l ? this.left.lineAt(e, n, r, i, o) : this.right.lineAt(e, n, r, s, a);
    if (this.break || (l ? c.to < a : c.from > a))
      return c;
    let u = n == Qn.ByPosNoHeight ? Qn.ByPosNoHeight : Qn.ByPos;
    return l ? c.join(this.right.lineAt(a, u, r, s, a)) : this.left.lineAt(a, u, r, i, o).join(c);
  }
  forEachLine(e, n, r, i, o, s) {
    let a = i + this.left.height, l = o + this.left.length + this.break;
    if (this.break)
      e < l && this.left.forEachLine(e, n, r, i, o, s), n >= l && this.right.forEachLine(e, n, r, a, l, s);
    else {
      let c = this.lineAt(l, Qn.ByPos, r, i, o);
      e < c.from && this.left.forEachLine(e, c.from - 1, r, i, o, s), c.to >= e && c.from <= n && s(c), n > c.to && this.right.forEachLine(c.to + 1, n, r, a, l, s);
    }
  }
  replace(e, n, r) {
    let i = this.left.length + this.break;
    if (n < i)
      return this.balanced(this.left.replace(e, n, r), this.right);
    if (e > this.left.length)
      return this.balanced(this.left, this.right.replace(e - i, n - i, r));
    let o = [];
    e > 0 && this.decomposeLeft(e, o);
    let s = o.length;
    for (let a of r)
      o.push(a);
    if (e > 0 && L2(o, s - 1), n < this.length) {
      let a = o.length;
      this.decomposeRight(n, o), L2(o, a);
    }
    return ii.of(o);
  }
  decomposeLeft(e, n) {
    let r = this.left.length;
    if (e <= r)
      return this.left.decomposeLeft(e, n);
    n.push(this.left), this.break && (r++, e >= r && n.push(null)), e > r && this.right.decomposeLeft(e - r, n);
  }
  decomposeRight(e, n) {
    let r = this.left.length, i = r + this.break;
    if (e >= i)
      return this.right.decomposeRight(e - i, n);
    e < r && this.left.decomposeRight(e, n), this.break && e < i && n.push(null), n.push(this.right);
  }
  balanced(e, n) {
    return e.size > 2 * n.size || n.size > 2 * e.size ? ii.of(this.break ? [e, null, n] : [e, n]) : (this.left = e, this.right = n, this.height = e.height + n.height, this.outdated = e.outdated || n.outdated, this.size = e.size + n.size, this.length = e.length + this.break + n.length, this);
  }
  updateHeight(e, n = 0, r = !1, i) {
    let { left: o, right: s } = this, a = n + o.length + this.break, l = null;
    return i && i.from <= n + o.length && i.more ? l = o = o.updateHeight(e, n, r, i) : o.updateHeight(e, n, r), i && i.from <= a + s.length && i.more ? l = s = s.updateHeight(e, a, r, i) : s.updateHeight(e, a, r), l ? this.balanced(o, s) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function L2(t, e) {
  let n, r;
  t[e] == null && (n = t[e - 1]) instanceof Rr && (r = t[e + 1]) instanceof Rr && t.splice(e - 1, 3, new Rr(n.length + 1 + r.length));
}
const Bq = 5;
class Q0 {
  constructor(e, n) {
    this.pos = e, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = e;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(e, n) {
    if (this.lineStart > -1) {
      let r = Math.min(n, this.lineEnd), i = this.nodes[this.nodes.length - 1];
      i instanceof yi ? i.length += r - this.pos : (r > this.pos || !this.isCovered) && this.nodes.push(new yi(r - this.pos, -1)), this.writtenTo = r, n > r && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = n;
  }
  point(e, n, r) {
    if (e < n || r.heightRelevant) {
      let i = r.widget ? r.widget.estimatedHeight : 0, o = r.widget ? r.widget.lineBreaks : 0;
      i < 0 && (i = this.oracle.lineHeight);
      let s = n - e;
      r.block ? this.addBlock(new WC(s, i, r)) : (s || o || i >= Bq) && this.addLineDeco(i, o, s);
    } else
      n > e && this.span(e, n);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: e, to: n } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = e, this.lineEnd = n, this.writtenTo < e && ((this.writtenTo < e - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, e - 1)), this.nodes.push(null)), this.pos > e && this.nodes.push(new yi(this.pos - e, -1)), this.writtenTo = this.pos;
  }
  blankContent(e, n) {
    let r = new Rr(n - e);
    return this.oracle.doc.lineAt(e).to == n && (r.flags |= 4), r;
  }
  ensureLine() {
    this.enterLine();
    let e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (e instanceof yi)
      return e;
    let n = new yi(0, -1);
    return this.nodes.push(n), n;
  }
  addBlock(e) {
    this.enterLine();
    let n = e.deco;
    n && n.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos = this.pos + e.length, n && n.endSide > 0 && (this.covering = e);
  }
  addLineDeco(e, n, r) {
    let i = this.ensureLine();
    i.length += r, i.collapsed += r, i.widgetHeight = Math.max(i.widgetHeight, e), i.breaks += n, this.writtenTo = this.pos = this.pos + r;
  }
  finish(e) {
    let n = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(n instanceof yi) && !this.isCovered ? this.nodes.push(new yi(0, -1)) : (this.writtenTo < this.pos || n == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let r = e;
    for (let i of this.nodes)
      i instanceof yi && i.updateHeight(this.oracle, r), r += i ? i.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(e, n, r, i) {
    let o = new Q0(r, e);
    return En.spans(n, r, i, o, 0), o.finish(r);
  }
}
function qq(t, e, n) {
  let r = new zq();
  return En.compare(t, e, n, r, 0), r.changes;
}
class zq {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(e, n, r, i) {
    (e < n || r && r.heightRelevant || i && i.heightRelevant) && Kg(e, n, this.changes, 5);
  }
}
function Fq(t, e) {
  let n = t.getBoundingClientRect(), r = t.ownerDocument, i = r.defaultView || window, o = Math.max(0, n.left), s = Math.min(i.innerWidth, n.right), a = Math.max(0, n.top), l = Math.min(i.innerHeight, n.bottom);
  for (let c = t.parentNode; c && c != r.body; )
    if (c.nodeType == 1) {
      let u = c, f = window.getComputedStyle(u);
      if ((u.scrollHeight > u.clientHeight || u.scrollWidth > u.clientWidth) && f.overflow != "visible") {
        let d = u.getBoundingClientRect();
        o = Math.max(o, d.left), s = Math.min(s, d.right), a = Math.max(a, d.top), l = c == t.parentNode ? d.bottom : Math.min(l, d.bottom);
      }
      c = f.position == "absolute" || f.position == "fixed" ? u.offsetParent : u.parentNode;
    } else if (c.nodeType == 11)
      c = c.host;
    else
      break;
  return {
    left: o - n.left,
    right: Math.max(o, s) - n.left,
    top: a - (n.top + e),
    bottom: Math.max(a, l) - (n.top + e)
  };
}
function Vq(t, e) {
  let n = t.getBoundingClientRect();
  return {
    left: 0,
    right: n.right - n.left,
    top: e,
    bottom: n.bottom - (n.top + e)
  };
}
class xm {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.size = r;
  }
  static same(e, n) {
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++) {
      let i = e[r], o = n[r];
      if (i.from != o.from || i.to != o.to || i.size != o.size)
        return !1;
    }
    return !0;
  }
  draw(e, n) {
    return Bt.replace({
      widget: new Hq(this.size * (n ? e.scaleY : e.scaleX), n)
    }).range(this.from, this.to);
  }
}
class Hq extends ua {
  constructor(e, n) {
    super(), this.size = e, this.vertical = n;
  }
  eq(e) {
    return e.size == this.size && e.vertical == this.vertical;
  }
  toDOM() {
    let e = document.createElement("div");
    return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class B2 {
  constructor(e) {
    this.state = e, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !0, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = q2, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = cr.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let n = e.facet(K0).some((r) => typeof r != "function" && r.class == "cm-lineWrapping");
    this.heightOracle = new Iq(n), this.stateDeco = e.facet(_u).filter((r) => typeof r != "function"), this.heightMap = ii.empty().applyChanges(this.stateDeco, Cn.empty, this.heightOracle.setDoc(e.doc), [new Ni(0, 0, 0, e.doc.length)]), this.viewport = this.getViewport(0, null), this.updateViewportLines(), this.updateForViewport(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = Bt.set(this.lineGaps.map((r) => r.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let e = [this.viewport], { main: n } = this.state.selection;
    for (let r = 0; r <= 1; r++) {
      let i = r ? n.head : n.anchor;
      if (!e.some(({ from: o, to: s }) => i >= o && i <= s)) {
        let { from: o, to: s } = this.lineBlockAt(i);
        e.push(new zf(o, s));
      }
    }
    this.viewports = e.sort((r, i) => r.from - i.from), this.scaler = this.heightMap.height <= 7e6 ? q2 : new Jq(this.heightOracle, this.heightMap, this.viewports);
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (e) => {
      this.viewportLines.push(this.scaler.scale == 1 ? e : Hc(e, this.scaler));
    });
  }
  update(e, n = null) {
    this.state = e.state;
    let r = this.stateDeco;
    this.stateDeco = this.state.facet(_u).filter((u) => typeof u != "function");
    let i = e.changedRanges, o = Ni.extendWithRanges(i, qq(r, this.stateDeco, e ? e.changes : $r.empty(this.state.doc.length))), s = this.heightMap.height, a = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), o), this.heightMap.height != s && (e.flags |= 2), a ? (this.scrollAnchorPos = e.changes.mapPos(a.from, -1), this.scrollAnchorHeight = a.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
    let l = o.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
    (n && (n.range.head < l.from || n.range.head > l.to) || !this.viewportIsAppropriate(l)) && (l = this.getViewport(0, n));
    let c = !e.changes.empty || e.flags & 2 || l.from != this.viewport.from || l.to != this.viewport.to;
    this.viewport = l, this.updateForViewport(), c && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(), n && (this.scrollTarget = n), !this.mustEnforceCursorAssoc && e.selectionSet && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && !e.state.facet($C) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(e) {
    let n = e.contentDOM, r = window.getComputedStyle(n), i = this.heightOracle, o = r.whiteSpace;
    this.defaultTextDirection = r.direction == "rtl" ? cr.RTL : cr.LTR;
    let s = this.heightOracle.mustRefreshForWrapping(o), a = n.getBoundingClientRect(), l = s || this.mustMeasureContent || this.contentDOMHeight != a.height;
    this.contentDOMHeight = a.height, this.mustMeasureContent = !1;
    let c = 0, u = 0;
    if (a.width && a.height) {
      let x = a.width / n.offsetWidth, b = a.height / n.offsetHeight;
      (x > 0.995 && x < 1.005 || !isFinite(x) || Math.abs(a.width - n.offsetWidth) < 1) && (x = 1), (b > 0.995 && b < 1.005 || !isFinite(b) || Math.abs(a.height - n.offsetHeight) < 1) && (b = 1), (this.scaleX != x || this.scaleY != b) && (this.scaleX = x, this.scaleY = b, c |= 8, s = l = !0);
    }
    let f = (parseInt(r.paddingTop) || 0) * this.scaleY, d = (parseInt(r.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != f || this.paddingBottom != d) && (this.paddingTop = f, this.paddingBottom = d, c |= 10), this.editorWidth != e.scrollDOM.clientWidth && (i.lineWrapping && (l = !0), this.editorWidth = e.scrollDOM.clientWidth, c |= 8);
    let h = e.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != h && (this.scrollAnchorHeight = -1, this.scrollTop = h), this.scrolledToBottom = aC(e.scrollDOM);
    let p = (this.printing ? Vq : Fq)(n, this.paddingTop), m = p.top - this.pixelViewport.top, g = p.bottom - this.pixelViewport.bottom;
    this.pixelViewport = p;
    let v = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (v != this.inView && (this.inView = v, v && (l = !0)), !this.inView && !this.scrollTarget)
      return 0;
    let y = a.width;
    if ((this.contentDOMWidth != y || this.editorHeight != e.scrollDOM.clientHeight) && (this.contentDOMWidth = a.width, this.editorHeight = e.scrollDOM.clientHeight, c |= 8), l) {
      let x = e.docView.measureVisibleLineHeights(this.viewport);
      if (i.mustRefreshForHeights(x) && (s = !0), s || i.lineWrapping && Math.abs(y - this.contentDOMWidth) > i.charWidth) {
        let { lineHeight: b, charWidth: j, textHeight: $ } = e.docView.measureTextSize();
        s = b > 0 && i.refresh(o, b, j, $, y / j, x), s && (e.docView.minWidth = 0, c |= 8);
      }
      m > 0 && g > 0 ? u = Math.max(m, g) : m < 0 && g < 0 && (u = Math.min(m, g)), i.heightChanged = !1;
      for (let b of this.viewports) {
        let j = b.from == this.viewport.from ? x : e.docView.measureVisibleLineHeights(b);
        this.heightMap = (s ? ii.empty().applyChanges(this.stateDeco, Cn.empty, this.heightOracle, [new Ni(0, 0, 0, e.state.doc.length)]) : this.heightMap).updateHeight(i, 0, s, new Dq(b.from, j));
      }
      i.heightChanged && (c |= 2);
    }
    let w = !this.viewportIsAppropriate(this.viewport, u) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return w && (this.viewport = this.getViewport(u, this.scrollTarget)), this.updateForViewport(), (c & 2 || w) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(s ? [] : this.lineGaps, e)), c |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), c;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(e, n) {
    let r = 0.5 - Math.max(-0.5, Math.min(0.5, e / 1e3 / 2)), i = this.heightMap, o = this.heightOracle, { visibleTop: s, visibleBottom: a } = this, l = new zf(i.lineAt(s - r * 1e3, Qn.ByHeight, o, 0, 0).from, i.lineAt(a + (1 - r) * 1e3, Qn.ByHeight, o, 0, 0).to);
    if (n) {
      let { head: c } = n.range;
      if (c < l.from || c > l.to) {
        let u = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), f = i.lineAt(c, Qn.ByPos, o, 0, 0), d;
        n.y == "center" ? d = (f.top + f.bottom) / 2 - u / 2 : n.y == "start" || n.y == "nearest" && c < l.from ? d = f.top : d = f.bottom - u, l = new zf(i.lineAt(d - 1e3 / 2, Qn.ByHeight, o, 0, 0).from, i.lineAt(d + u + 1e3 / 2, Qn.ByHeight, o, 0, 0).to);
      }
    }
    return l;
  }
  mapViewport(e, n) {
    let r = n.mapPos(e.from, -1), i = n.mapPos(e.to, 1);
    return new zf(this.heightMap.lineAt(r, Qn.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(i, Qn.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: e, to: n }, r = 0) {
    if (!this.inView)
      return !0;
    let { top: i } = this.heightMap.lineAt(e, Qn.ByPos, this.heightOracle, 0, 0), { bottom: o } = this.heightMap.lineAt(n, Qn.ByPos, this.heightOracle, 0, 0), { visibleTop: s, visibleBottom: a } = this;
    return (e == 0 || i <= s - Math.max(10, Math.min(
      -r,
      250
      /* VP.MaxCoverMargin */
    ))) && (n == this.state.doc.length || o >= a + Math.max(10, Math.min(
      r,
      250
      /* VP.MaxCoverMargin */
    ))) && i > s - 2 * 1e3 && o < a + 2 * 1e3;
  }
  mapLineGaps(e, n) {
    if (!e.length || n.empty)
      return e;
    let r = [];
    for (let i of e)
      n.touchesRange(i.from, i.to) || r.push(new xm(n.mapPos(i.from), n.mapPos(i.to), i.size));
    return r;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(e, n) {
    let r = this.heightOracle.lineWrapping, i = r ? 1e4 : 2e3, o = i >> 1, s = i << 1;
    if (this.defaultTextDirection != cr.LTR && !r)
      return [];
    let a = [], l = (c, u, f, d) => {
      if (u - c < o)
        return;
      let h = this.state.selection.main, p = [h.from];
      h.empty || p.push(h.to);
      for (let g of p)
        if (g > c && g < u) {
          l(c, g - 10, f, d), l(g + 10, u, f, d);
          return;
        }
      let m = Wq(e, (g) => g.from >= f.from && g.to <= f.to && Math.abs(g.from - c) < o && Math.abs(g.to - u) < o && !p.some((v) => g.from < v && g.to > v));
      if (!m) {
        if (u < f.to && n && r && n.visibleRanges.some((g) => g.from <= u && g.to >= u)) {
          let g = n.moveToLineBoundary(Te.cursor(u), !1, !0).head;
          g > c && (u = g);
        }
        m = new xm(c, u, this.gapSize(f, c, u, d));
      }
      a.push(m);
    };
    for (let c of this.viewportLines) {
      if (c.length < s)
        continue;
      let u = Uq(c.from, c.to, this.stateDeco);
      if (u.total < s)
        continue;
      let f = this.scrollTarget ? this.scrollTarget.range.head : null, d, h;
      if (r) {
        let p = i / this.heightOracle.lineLength * this.heightOracle.lineHeight, m, g;
        if (f != null) {
          let v = Vf(u, f), y = ((this.visibleBottom - this.visibleTop) / 2 + p) / c.height;
          m = v - y, g = v + y;
        } else
          m = (this.visibleTop - c.top - p) / c.height, g = (this.visibleBottom - c.top + p) / c.height;
        d = Ff(u, m), h = Ff(u, g);
      } else {
        let p = u.total * this.heightOracle.charWidth, m = i * this.heightOracle.charWidth, g, v;
        if (f != null) {
          let y = Vf(u, f), w = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + m) / p;
          g = y - w, v = y + w;
        } else
          g = (this.pixelViewport.left - m) / p, v = (this.pixelViewport.right + m) / p;
        d = Ff(u, g), h = Ff(u, v);
      }
      d > c.from && l(c.from, d, c, u), h < c.to && l(h, c.to, c, u);
    }
    return a;
  }
  gapSize(e, n, r, i) {
    let o = Vf(i, r) - Vf(i, n);
    return this.heightOracle.lineWrapping ? e.height * o : i.total * this.heightOracle.charWidth * o;
  }
  updateLineGaps(e) {
    xm.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = Bt.set(e.map((n) => n.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges() {
    let e = this.stateDeco;
    this.lineGaps.length && (e = e.concat(this.lineGapDeco));
    let n = [];
    En.spans(e, this.viewport.from, this.viewport.to, {
      span(i, o) {
        n.push({ from: i, to: o });
      },
      point() {
      }
    }, 20);
    let r = n.length != this.visibleRanges.length || this.visibleRanges.some((i, o) => i.from != n[o].from || i.to != n[o].to);
    return this.visibleRanges = n, r ? 4 : 0;
  }
  lineBlockAt(e) {
    return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find((n) => n.from <= e && n.to >= e) || Hc(this.heightMap.lineAt(e, Qn.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(e) {
    return Hc(this.heightMap.lineAt(this.scaler.fromDOM(e), Qn.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(e) {
    let n = this.lineBlockAtHeight(e + 8);
    return n.from >= this.viewport.from || this.viewportLines[0].top - e > 200 ? n : this.viewportLines[0];
  }
  elementAtHeight(e) {
    return Hc(this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class zf {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}
function Uq(t, e, n) {
  let r = [], i = t, o = 0;
  return En.spans(n, t, e, {
    span() {
    },
    point(s, a) {
      s > i && (r.push({ from: i, to: s }), o += s - i), i = a;
    }
  }, 20), i < e && (r.push({ from: i, to: e }), o += e - i), { total: o, ranges: r };
}
function Ff({ total: t, ranges: e }, n) {
  if (n <= 0)
    return e[0].from;
  if (n >= 1)
    return e[e.length - 1].to;
  let r = Math.floor(t * n);
  for (let i = 0; ; i++) {
    let { from: o, to: s } = e[i], a = s - o;
    if (r <= a)
      return o + r;
    r -= a;
  }
}
function Vf(t, e) {
  let n = 0;
  for (let { from: r, to: i } of t.ranges) {
    if (e <= i) {
      n += e - r;
      break;
    }
    n += i - r;
  }
  return n / t.total;
}
function Wq(t, e) {
  for (let n of t)
    if (e(n))
      return n;
}
const q2 = {
  toDOM(t) {
    return t;
  },
  fromDOM(t) {
    return t;
  },
  scale: 1
};
class Jq {
  constructor(e, n, r) {
    let i = 0, o = 0, s = 0;
    this.viewports = r.map(({ from: a, to: l }) => {
      let c = n.lineAt(a, Qn.ByPos, e, 0, 0).top, u = n.lineAt(l, Qn.ByPos, e, 0, 0).bottom;
      return i += u - c, { from: a, to: l, top: c, bottom: u, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - i) / (n.height - i);
    for (let a of this.viewports)
      a.domTop = s + (a.top - o) * this.scale, s = a.domBottom = a.domTop + (a.bottom - a.top), o = a.bottom;
  }
  toDOM(e) {
    for (let n = 0, r = 0, i = 0; ; n++) {
      let o = n < this.viewports.length ? this.viewports[n] : null;
      if (!o || e < o.top)
        return i + (e - r) * this.scale;
      if (e <= o.bottom)
        return o.domTop + (e - o.top);
      r = o.bottom, i = o.domBottom;
    }
  }
  fromDOM(e) {
    for (let n = 0, r = 0, i = 0; ; n++) {
      let o = n < this.viewports.length ? this.viewports[n] : null;
      if (!o || e < o.domTop)
        return r + (e - i) / this.scale;
      if (e <= o.domBottom)
        return o.top + (e - o.domTop);
      r = o.bottom, i = o.domBottom;
    }
  }
}
function Hc(t, e) {
  if (e.scale == 1)
    return t;
  let n = e.toDOM(t.top), r = e.toDOM(t.bottom);
  return new Mo(t.from, t.length, n, r - n, Array.isArray(t._content) ? t._content.map((i) => Hc(i, e)) : t._content);
}
const Hf = /* @__PURE__ */ vt.define({ combine: (t) => t.join(" ") }), nv = /* @__PURE__ */ vt.define({ combine: (t) => t.indexOf(!0) > -1 }), rv = /* @__PURE__ */ ta.newName(), JC = /* @__PURE__ */ ta.newName(), KC = /* @__PURE__ */ ta.newName(), GC = { "&light": "." + JC, "&dark": "." + KC };
function iv(t, e, n) {
  return new ta(e, {
    finish(r) {
      return /&/.test(r) ? r.replace(/&\w*/, (i) => {
        if (i == "&")
          return t;
        if (!n || !n[i])
          throw new RangeError(`Unsupported selector: ${i}`);
        return n[i];
      }) : t + " " + r;
    }
  });
}
const Kq = /* @__PURE__ */ iv("." + rv, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#444"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace:before": {
    content: "attr(data-display)",
    position: "absolute",
    pointerEvents: "none",
    color: "#888"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, GC), Uc = "￿";
class Gq {
  constructor(e, n) {
    this.points = e, this.text = "", this.lineSeparator = n.facet(gn.lineSeparator);
  }
  append(e) {
    this.text += e;
  }
  lineBreak() {
    this.text += Uc;
  }
  readRange(e, n) {
    if (!e)
      return this;
    let r = e.parentNode;
    for (let i = e; ; ) {
      this.findPointBefore(r, i);
      let o = this.text.length;
      this.readNode(i);
      let s = i.nextSibling;
      if (s == n)
        break;
      let a = Zn.get(i), l = Zn.get(s);
      (a && l ? a.breakAfter : (a ? a.breakAfter : z2(i)) || z2(s) && (i.nodeName != "BR" || i.cmIgnore) && this.text.length > o) && this.lineBreak(), i = s;
    }
    return this.findPointBefore(r, n), this;
  }
  readTextNode(e) {
    let n = e.nodeValue;
    for (let r of this.points)
      r.node == e && (r.pos = this.text.length + Math.min(r.offset, n.length));
    for (let r = 0, i = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let o = -1, s = 1, a;
      if (this.lineSeparator ? (o = n.indexOf(this.lineSeparator, r), s = this.lineSeparator.length) : (a = i.exec(n)) && (o = a.index, s = a[0].length), this.append(n.slice(r, o < 0 ? n.length : o)), o < 0)
        break;
      if (this.lineBreak(), s > 1)
        for (let l of this.points)
          l.node == e && l.pos > this.text.length && (l.pos -= s - 1);
      r = o + s;
    }
  }
  readNode(e) {
    if (e.cmIgnore)
      return;
    let n = Zn.get(e), r = n && n.overrideDOMText;
    if (r != null) {
      this.findPointInside(e, r.length);
      for (let i = r.iter(); !i.next().done; )
        i.lineBreak ? this.lineBreak() : this.append(i.value);
    } else
      e.nodeType == 3 ? this.readTextNode(e) : e.nodeName == "BR" ? e.nextSibling && this.lineBreak() : e.nodeType == 1 && this.readRange(e.firstChild, null);
  }
  findPointBefore(e, n) {
    for (let r of this.points)
      r.node == e && e.childNodes[r.offset] == n && (r.pos = this.text.length);
  }
  findPointInside(e, n) {
    for (let r of this.points)
      (e.nodeType == 3 ? r.node == e : e.contains(r.node)) && (r.pos = this.text.length + (Qq(e, r.node, r.offset) ? n : 0));
  }
}
function Qq(t, e, n) {
  for (; ; ) {
    if (!e || n < hs(e))
      return !1;
    if (e == t)
      return !0;
    n = Mu(e) + 1, e = e.parentNode;
  }
}
function z2(t) {
  return t.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(t.nodeName);
}
class F2 {
  constructor(e, n) {
    this.node = e, this.offset = n, this.pos = -1;
  }
}
class Yq {
  constructor(e, n, r, i) {
    this.typeOver = i, this.bounds = null, this.text = "";
    let { impreciseHead: o, impreciseAnchor: s } = e.docView;
    if (e.state.readOnly && n > -1)
      this.newSel = null;
    else if (n > -1 && (this.bounds = e.docView.domBoundsAround(n, r, 0))) {
      let a = o || s ? [] : ez(e), l = new Gq(a, e.state);
      l.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = l.text, this.newSel = tz(a, this.bounds.from);
    } else {
      let a = e.observer.selectionRange, l = o && o.node == a.focusNode && o.offset == a.focusOffset || !Fg(e.contentDOM, a.focusNode) ? e.state.selection.main.head : e.docView.posFromDOM(a.focusNode, a.focusOffset), c = s && s.node == a.anchorNode && s.offset == a.anchorOffset || !Fg(e.contentDOM, a.anchorNode) ? e.state.selection.main.anchor : e.docView.posFromDOM(a.anchorNode, a.anchorOffset);
      this.newSel = Te.single(c, l);
    }
  }
}
function QC(t, e) {
  let n, { newSel: r } = e, i = t.state.selection.main, o = t.inputState.lastKeyTime > Date.now() - 100 ? t.inputState.lastKeyCode : -1;
  if (e.bounds) {
    let { from: s, to: a } = e.bounds, l = i.from, c = null;
    (o === 8 || jt.android && e.text.length < a - s) && (l = i.to, c = "end");
    let u = Zq(t.state.doc.sliceString(s, a, Uc), e.text, l - s, c);
    u && (jt.chrome && o == 13 && u.toB == u.from + 2 && e.text.slice(u.from, u.toB) == Uc + Uc && u.toB--, n = {
      from: s + u.from,
      to: s + u.toA,
      insert: Cn.of(e.text.slice(u.from, u.toB).split(Uc))
    });
  } else
    r && (!t.hasFocus && t.state.facet(kp) || r.main.eq(i)) && (r = null);
  if (!n && !r)
    return !1;
  if (!n && e.typeOver && !i.empty && r && r.main.empty ? n = { from: i.from, to: i.to, insert: t.state.doc.slice(i.from, i.to) } : n && n.from >= i.from && n.to <= i.to && (n.from != i.from || n.to != i.to) && i.to - i.from - (n.to - n.from) <= 4 ? n = {
    from: i.from,
    to: i.to,
    insert: t.state.doc.slice(i.from, n.from).append(n.insert).append(t.state.doc.slice(n.to, i.to))
  } : (jt.mac || jt.android) && n && n.from == n.to && n.from == i.head - 1 && /^\. ?$/.test(n.insert.toString()) && t.contentDOM.getAttribute("autocorrect") == "off" ? (r && n.insert.length == 2 && (r = Te.single(r.main.anchor - 1, r.main.head - 1)), n = { from: i.from, to: i.to, insert: Cn.of([" "]) }) : jt.chrome && n && n.from == n.to && n.from == i.head && n.insert.toString() == `
 ` && t.lineWrapping && (r && (r = Te.single(r.main.anchor - 1, r.main.head - 1)), n = { from: i.from, to: i.to, insert: Cn.of([" "]) }), n) {
    if (jt.ios && t.inputState.flushIOSKey() || jt.android && (n.from == i.from && n.to == i.to && n.insert.length == 1 && n.insert.lines == 2 && Nl(t.contentDOM, "Enter", 13) || (n.from == i.from - 1 && n.to == i.to && n.insert.length == 0 || o == 8 && n.insert.length < n.to - n.from && n.to > i.head) && Nl(t.contentDOM, "Backspace", 8) || n.from == i.from && n.to == i.to + 1 && n.insert.length == 0 && Nl(t.contentDOM, "Delete", 46)))
      return !0;
    let s = n.insert.toString();
    t.inputState.composing >= 0 && t.inputState.composing++;
    let a, l = () => a || (a = Xq(t, n, r));
    return t.state.facet(wC).some((c) => c(t, n.from, n.to, s, l)) || t.dispatch(l()), !0;
  } else if (r && !r.main.eq(i)) {
    let s = !1, a = "select";
    return t.inputState.lastSelectionTime > Date.now() - 50 && (t.inputState.lastSelectionOrigin == "select" && (s = !0), a = t.inputState.lastSelectionOrigin), t.dispatch({ selection: r, scrollIntoView: s, userEvent: a }), !0;
  } else
    return !1;
}
function Xq(t, e, n) {
  let r, i = t.state, o = i.selection.main;
  if (e.from >= o.from && e.to <= o.to && e.to - e.from >= (o.to - o.from) / 3 && (!n || n.main.empty && n.main.from == e.from + e.insert.length) && t.inputState.composing < 0) {
    let a = o.from < e.from ? i.sliceDoc(o.from, e.from) : "", l = o.to > e.to ? i.sliceDoc(e.to, o.to) : "";
    r = i.replaceSelection(t.state.toText(a + e.insert.sliceString(0, void 0, t.state.lineBreak) + l));
  } else {
    let a = i.changes(e), l = n && n.main.to <= a.newLength ? n.main : void 0;
    if (i.selection.ranges.length > 1 && t.inputState.composing >= 0 && e.to <= o.to && e.to >= o.to - 10) {
      let c = t.state.sliceDoc(e.from, e.to), u, f = n && RC(t, n.main.head);
      if (f) {
        let p = e.insert.length - (e.to - e.from);
        u = { from: f.from, to: f.to - p };
      } else
        u = t.state.doc.lineAt(o.head);
      let d = o.to - e.to, h = o.to - o.from;
      r = i.changeByRange((p) => {
        if (p.from == o.from && p.to == o.to)
          return { changes: a, range: l || p.map(a) };
        let m = p.to - d, g = m - c.length;
        if (p.to - p.from != h || t.state.sliceDoc(g, m) != c || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        p.to >= u.from && p.from <= u.to)
          return { range: p };
        let v = i.changes({ from: g, to: m, insert: e.insert }), y = p.to - o.to;
        return {
          changes: v,
          range: l ? Te.range(Math.max(0, l.anchor + y), Math.max(0, l.head + y)) : p.map(v)
        };
      });
    } else
      r = {
        changes: a,
        selection: l && i.selection.replaceRange(l)
      };
  }
  let s = "input.type";
  return (t.composing || t.inputState.compositionPendingChange && t.inputState.compositionEndedAt > Date.now() - 50) && (t.inputState.compositionPendingChange = !1, s += ".compose", t.inputState.compositionFirstChange && (s += ".start", t.inputState.compositionFirstChange = !1)), i.update(r, { userEvent: s, scrollIntoView: !0 });
}
function Zq(t, e, n, r) {
  let i = Math.min(t.length, e.length), o = 0;
  for (; o < i && t.charCodeAt(o) == e.charCodeAt(o); )
    o++;
  if (o == i && t.length == e.length)
    return null;
  let s = t.length, a = e.length;
  for (; s > 0 && a > 0 && t.charCodeAt(s - 1) == e.charCodeAt(a - 1); )
    s--, a--;
  if (r == "end") {
    let l = Math.max(0, o - Math.min(s, a));
    n -= s + l - o;
  }
  if (s < o && t.length < e.length) {
    let l = n <= o && n >= s ? o - n : 0;
    o -= l, a = o + (a - s), s = o;
  } else if (a < o) {
    let l = n <= o && n >= a ? o - n : 0;
    o -= l, s = o + (s - a), a = o;
  }
  return { from: o, toA: s, toB: a };
}
function ez(t) {
  let e = [];
  if (t.root.activeElement != t.contentDOM)
    return e;
  let { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: o } = t.observer.selectionRange;
  return n && (e.push(new F2(n, r)), (i != n || o != r) && e.push(new F2(i, o))), e;
}
function tz(t, e) {
  if (t.length == 0)
    return null;
  let n = t[0].pos, r = t.length == 2 ? t[1].pos : n;
  return n > -1 && r > -1 ? Te.single(n + e, r + e) : null;
}
const nz = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, wm = jt.ie && jt.ie_version <= 11;
class rz {
  constructor(e) {
    this.view = e, this.active = !1, this.selectionRange = new qB(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.parentCheck = -1, this.dom = e.contentDOM, this.observer = new MutationObserver((n) => {
      for (let r of n)
        this.queue.push(r);
      (jt.ie && jt.ie_version <= 11 || jt.ios && e.composing) && n.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), wm && (this.onCharData = (n) => {
      this.queue.push({
        target: n.target,
        type: "characterData",
        oldValue: n.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var n;
      ((n = this.view.docView) === null || n === void 0 ? void 0 : n.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(e.scrollDOM)), this.addWindowListeners(this.win = e.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((n) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), n.length > 0 && n[n.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((n) => {
      n.length > 0 && n[n.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(e) {
    this.view.inputState.runHandlers("scroll", e), this.intersecting && this.view.measure();
  }
  onScroll(e) {
    this.intersecting && this.flush(!1), this.onScrollChanged(e);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint() {
    this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500);
  }
  updateGaps(e) {
    if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some((n, r) => n != e[r]))) {
      this.gapIntersection.disconnect();
      for (let n of e)
        this.gapIntersection.observe(n);
      this.gaps = e;
    }
  }
  onSelectionChange(e) {
    let n = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: r } = this, i = this.selectionRange;
    if (r.state.facet(kp) ? r.root.activeElement != this.dom : !_d(r.dom, i))
      return;
    let o = i.anchorNode && r.docView.nearest(i.anchorNode);
    if (o && o.ignoreEvent(e)) {
      n || (this.selectionChanged = !1);
      return;
    }
    (jt.ie && jt.ie_version <= 11 || jt.android && jt.chrome) && !r.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    i.focusNode && ah(i.focusNode, i.focusOffset, i.anchorNode, i.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: e } = this, n = jt.safari && e.root.nodeType == 11 && IB(this.dom.ownerDocument) == this.dom && iz(this.view) || sh(e.root);
    if (!n || this.selectionRange.eq(n))
      return !1;
    let r = _d(this.dom, n);
    return r && !this.selectionChanged && e.inputState.lastFocusTime > Date.now() - 200 && e.inputState.lastTouchTime < Date.now() - 300 && FB(this.dom, n) ? (this.view.inputState.lastFocusTime = 0, e.docView.updateSelection(), !1) : (this.selectionRange.setRange(n), r && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(e, n) {
    this.selectionRange.set(e.node, e.offset, n.node, n.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let e = 0, n = null;
    for (let r = this.dom; r; )
      if (r.nodeType == 1)
        !n && e < this.scrollTargets.length && this.scrollTargets[e] == r ? e++ : n || (n = this.scrollTargets.slice(0, e)), n && n.push(r), r = r.assignedSlot || r.parentNode;
      else if (r.nodeType == 11)
        r = r.host;
      else
        break;
    if (e < this.scrollTargets.length && !n && (n = this.scrollTargets.slice(0, e)), n) {
      for (let r of this.scrollTargets)
        r.removeEventListener("scroll", this.onScroll);
      for (let r of this.scrollTargets = n)
        r.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(e) {
    if (!this.active)
      return e();
    try {
      return this.stop(), e();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, nz), wm && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), wm && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(e, n) {
    var r;
    if (!this.delayedAndroidKey) {
      let i = () => {
        let o = this.delayedAndroidKey;
        o && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = o.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && o.force && Nl(this.dom, o.key, o.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(i);
    }
    (!this.delayedAndroidKey || e == "Enter") && (this.delayedAndroidKey = {
      key: e,
      keyCode: n,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((r = this.delayedAndroidKey) === null || r === void 0) && r.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let e of this.observer.takeRecords())
      this.queue.push(e);
    return this.queue;
  }
  processRecords() {
    let e = this.pendingRecords();
    e.length && (this.queue = []);
    let n = -1, r = -1, i = !1;
    for (let o of e) {
      let s = this.readMutation(o);
      s && (s.typeOver && (i = !0), n == -1 ? { from: n, to: r } = s : (n = Math.min(s.from, n), r = Math.max(s.to, r)));
    }
    return { from: n, to: r, typeOver: i };
  }
  readChange() {
    let { from: e, to: n, typeOver: r } = this.processRecords(), i = this.selectionChanged && _d(this.dom, this.selectionRange);
    if (e < 0 && !i)
      return null;
    e > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let o = new Yq(this.view, e, n, r);
    return this.view.docView.domChanged = { newSel: o.newSel ? o.newSel.main : null }, o;
  }
  // Apply pending changes, if any
  flush(e = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    e && this.readSelectionRange();
    let n = this.readChange();
    if (!n)
      return this.view.requestMeasure(), !1;
    let r = this.view.state, i = QC(this.view, n);
    return this.view.state == r && this.view.update([]), i;
  }
  readMutation(e) {
    let n = this.view.docView.nearest(e.target);
    if (!n || n.ignoreMutation(e))
      return null;
    if (n.markDirty(e.type == "attributes"), e.type == "attributes" && (n.flags |= 4), e.type == "childList") {
      let r = V2(n, e.previousSibling || e.target.previousSibling, -1), i = V2(n, e.nextSibling || e.target.nextSibling, 1);
      return {
        from: r ? n.posAfter(r) : n.posAtStart,
        to: i ? n.posBefore(i) : n.posAtEnd,
        typeOver: !1
      };
    } else
      return e.type == "characterData" ? { from: n.posAtStart, to: n.posAtEnd, typeOver: e.target.nodeValue == e.oldValue } : null;
  }
  setWindow(e) {
    e != this.win && (this.removeWindowListeners(this.win), this.win = e, this.addWindowListeners(this.win));
  }
  addWindowListeners(e) {
    e.addEventListener("resize", this.onResize), e.addEventListener("beforeprint", this.onPrint), e.addEventListener("scroll", this.onScroll), e.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(e) {
    e.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onResize), e.removeEventListener("beforeprint", this.onPrint), e.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  destroy() {
    var e, n, r;
    this.stop(), (e = this.intersection) === null || e === void 0 || e.disconnect(), (n = this.gapIntersection) === null || n === void 0 || n.disconnect(), (r = this.resizeScroll) === null || r === void 0 || r.disconnect();
    for (let i of this.scrollTargets)
      i.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey);
  }
}
function V2(t, e, n) {
  for (; e; ) {
    let r = Zn.get(e);
    if (r && r.parent == t)
      return r;
    let i = e.parentNode;
    e = i != t.dom ? i : n > 0 ? e.nextSibling : e.previousSibling;
  }
  return null;
}
function iz(t) {
  let e = null;
  function n(l) {
    l.preventDefault(), l.stopImmediatePropagation(), e = l.getTargetRanges()[0];
  }
  if (t.contentDOM.addEventListener("beforeinput", n, !0), t.dom.ownerDocument.execCommand("indent"), t.contentDOM.removeEventListener("beforeinput", n, !0), !e)
    return null;
  let r = e.startContainer, i = e.startOffset, o = e.endContainer, s = e.endOffset, a = t.docView.domAtPos(t.state.selection.main.anchor);
  return ah(a.node, a.offset, o, s) && ([r, i, o, s] = [o, s, r, i]), { anchorNode: r, anchorOffset: i, focusNode: o, focusOffset: s };
}
class at {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(e = {}) {
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM);
    let { dispatch: n } = e;
    this.dispatchTransactions = e.dispatchTransactions || n && ((r) => r.forEach((i) => n(i, this))) || ((r) => this.update(r)), this.dispatch = this.dispatch.bind(this), this._root = e.root || zB(e.parent) || document, this.viewState = new B2(e.state || gn.create(e)), e.scrollTo && e.scrollTo.is(Lf) && (this.viewState.scrollTarget = e.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(Fc).map((r) => new vm(r));
    for (let r of this.plugins)
      r.update(this);
    this.observer = new rz(this), this.inputState = new bq(this), this.inputState.ensureHandlers(this.plugins), this.docView = new w2(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), e.parent && e.parent.appendChild(this.dom);
  }
  dispatch(...e) {
    let n = e.length == 1 && e[0] instanceof Sr ? e : e.length == 1 && Array.isArray(e[0]) ? e[0] : [this.state.update(...e)];
    this.dispatchTransactions(n, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let n = !1, r = !1, i, o = this.state;
    for (let d of e) {
      if (d.startState != o)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      o = d.state;
    }
    if (this.destroyed) {
      this.viewState.state = o;
      return;
    }
    let s = this.hasFocus, a = 0, l = null;
    e.some((d) => d.annotation(VC)) ? (this.inputState.notifiedFocused = s, a = 1) : s != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = s, l = HC(o, s), l || (a = 1));
    let c = this.observer.delayedAndroidKey, u = null;
    if (c ? (this.observer.clearDelayedAndroidKey(), u = this.observer.readChange(), (u && !this.state.doc.eq(o.doc) || !this.state.selection.eq(o.selection)) && (u = null)) : this.observer.clear(), o.facet(gn.phrases) != this.state.facet(gn.phrases))
      return this.setState(o);
    i = lh.create(this, o, e), i.flags |= a;
    let f = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let d of e) {
        if (f && (f = f.map(d.changes)), d.scrollIntoView) {
          let { main: h } = d.state.selection;
          f = new Il(h.empty ? h : Te.cursor(h.head, h.head > h.anchor ? -1 : 1));
        }
        for (let h of d.effects)
          h.is(Lf) && (f = h.value.clip(this.state));
      }
      this.viewState.update(i, f), this.bidiCache = ch.update(this.bidiCache, i.changes), i.empty || (this.updatePlugins(i), this.inputState.update(i)), n = this.docView.update(i), this.state.facet(Vc) != this.styleModules && this.mountStyles(), r = this.updateAttrs(), this.showAnnouncements(e), this.docView.updateSelection(n, e.some((d) => d.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (i.startState.facet(Hf) != i.state.facet(Hf) && (this.viewState.mustMeasureContent = !0), (n || r || f || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), !i.empty)
      for (let d of this.state.facet(Gg))
        try {
          d(i);
        } catch (h) {
          $i(this.state, h, "update listener");
        }
    (l || u) && Promise.resolve().then(() => {
      l && this.state == l.startState && this.dispatch(l), u && !QC(this, u) && c.force && Nl(this.contentDOM, c.key, c.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = e;
      return;
    }
    this.updateState = 2;
    let n = this.hasFocus;
    try {
      for (let r of this.plugins)
        r.destroy(this);
      this.viewState = new B2(e), this.plugins = e.facet(Fc).map((r) => new vm(r)), this.pluginMap.clear();
      for (let r of this.plugins)
        r.update(this);
      this.docView.destroy(), this.docView = new w2(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    n && this.focus(), this.requestMeasure();
  }
  updatePlugins(e) {
    let n = e.startState.facet(Fc), r = e.state.facet(Fc);
    if (n != r) {
      let i = [];
      for (let o of r) {
        let s = n.indexOf(o);
        if (s < 0)
          i.push(new vm(o));
        else {
          let a = this.plugins[s];
          a.mustUpdate = e, i.push(a);
        }
      }
      for (let o of this.plugins)
        o.mustUpdate != e && o.destroy(this);
      this.plugins = i, this.pluginMap.clear();
    } else
      for (let i of this.plugins)
        i.mustUpdate = e;
    for (let i = 0; i < this.plugins.length; i++)
      this.plugins[i].update(this);
    n != r && this.inputState.ensureHandlers(this.plugins);
  }
  /**
  @internal
  */
  measure(e = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, e && this.observer.forceFlush();
    let n = null, r = this.scrollDOM, i = r.scrollTop * this.scaleY, { scrollAnchorPos: o, scrollAnchorHeight: s } = this.viewState;
    Math.abs(i - this.viewState.scrollTop) > 1 && (s = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let a = 0; ; a++) {
        if (s < 0)
          if (aC(r))
            o = -1, s = this.viewState.heightMap.height;
          else {
            let h = this.viewState.scrollAnchorAt(i);
            o = h.from, s = h.top;
          }
        this.updateState = 1;
        let l = this.viewState.measure(this);
        if (!l && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (a > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let c = [];
        l & 4 || ([this.measureRequests, c] = [c, this.measureRequests]);
        let u = c.map((h) => {
          try {
            return h.read(this);
          } catch (p) {
            return $i(this.state, p), H2;
          }
        }), f = lh.create(this, this.state, []), d = !1;
        f.flags |= l, n ? n.flags |= l : n = f, this.updateState = 2, f.empty || (this.updatePlugins(f), this.inputState.update(f), this.updateAttrs(), d = this.docView.update(f));
        for (let h = 0; h < c.length; h++)
          if (u[h] != H2)
            try {
              let p = c[h];
              p.write && p.write(u[h], this);
            } catch (p) {
              $i(this.state, p);
            }
        if (d && this.docView.updateSelection(!0), !f.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null;
              continue;
            } else {
              let p = (o < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(o).top) - s;
              if (p > 1 || p < -1) {
                i = i + p, r.scrollTop = i / this.scaleY, s = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (n && !n.empty)
      for (let a of this.state.facet(Gg))
        a(n);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return rv + " " + (this.state.facet(nv) ? KC : JC) + " " + this.state.facet(Hf);
  }
  updateAttrs() {
    let e = U2(this, SC, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), n = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      translate: "no",
      contenteditable: this.state.facet(kp) ? "true" : "false",
      class: "cm-content",
      style: `${jt.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (n["aria-readonly"] = "true"), U2(this, K0, n);
    let r = this.observer.ignore(() => {
      let i = Jg(this.contentDOM, this.contentAttrs, n), o = Jg(this.dom, this.editorAttrs, e);
      return i || o;
    });
    return this.editorAttrs = e, this.contentAttrs = n, r;
  }
  showAnnouncements(e) {
    let n = !0;
    for (let r of e)
      for (let i of r.effects)
        if (i.is(at.announce)) {
          n && (this.announceDOM.textContent = ""), n = !1;
          let o = this.announceDOM.appendChild(document.createElement("div"));
          o.textContent = i.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(Vc);
    let e = this.state.facet(at.cspNonce);
    ta.mount(this.root, this.styleModules.concat(Kq).reverse(), e ? { nonce: e } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(e) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), e) {
      if (this.measureRequests.indexOf(e) > -1)
        return;
      if (e.key != null) {
        for (let n = 0; n < this.measureRequests.length; n++)
          if (this.measureRequests[n].key === e.key) {
            this.measureRequests[n] = e;
            return;
          }
      }
      this.measureRequests.push(e);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(e) {
    let n = this.pluginMap.get(e);
    return (n === void 0 || n && n.spec != e) && this.pluginMap.set(e, n = this.plugins.find((r) => r.spec == e) || null), n && n.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(e) {
    return this.readMeasured(), this.viewState.elementAtHeight(e);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(e) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line breaks, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(e) {
    return this.viewState.lineBlockAt(e);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(e, n, r) {
    return bm(this, e, O2(this, e, n, r));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(e, n) {
    return bm(this, e, O2(this, e, n, (r) => vq(this, e.head, r)));
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(e, n, r = !0) {
    return gq(this, e, n, r);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(e, n, r) {
    return bm(this, e, yq(this, e, n, r));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(e) {
    return this.docView.domAtPos(e);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(e, n = 0) {
    return this.docView.posFromDOM(e, n);
  }
  posAtCoords(e, n = !0) {
    return this.readMeasured(), IC(this, e, n);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(e, n = 1) {
    this.readMeasured();
    let r = this.docView.coordsAt(e, n);
    if (!r || r.left == r.right)
      return r;
    let i = this.state.doc.lineAt(e), o = this.bidiSpans(i), s = o[qs.find(o, e - i.from, -1, n)];
    return U0(r, s.dir == cr.LTR == n > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(e) {
    return this.readMeasured(), this.docView.coordsForChar(e);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(e) {
    return !this.state.facet(kC) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(e) {
    if (e.length > oz)
      return TC(e.length);
    let n = this.textDirectionAt(e.from), r;
    for (let o of this.bidiCache)
      if (o.from == e.from && o.dir == n && (o.fresh || _C(o.isolates, r = x2(this, e.from, e.to))))
        return o.order;
    r || (r = x2(this, e.from, e.to));
    let i = nq(e.text, n, r);
    return this.bidiCache.push(new ch(e.from, e.to, n, r, !0, i)), i;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var e;
    return (this.dom.ownerDocument.hasFocus() || jt.safari && ((e = this.inputState) === null || e === void 0 ? void 0 : e.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      oC(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(e) {
    this._root != e && (this._root = e, this.observer.setWindow((e.nodeType == 9 ? e : e.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    for (let e of this.plugins)
      e.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(e, n = {}) {
    return Lf.of(new Il(typeof e == "number" ? Te.cursor(e) : e, n.y, n.x, n.yMargin, n.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop: e, scrollLeft: n } = this.scrollDOM, r = this.viewState.scrollAnchorAt(e);
    return Lf.of(new Il(Te.cursor(r.from), "start", "start", r.top - e, n, !0));
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(e) {
    return ur.define(() => ({}), { eventHandlers: e });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(e) {
    return ur.define(() => ({}), { eventObservers: e });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(e, n) {
    let r = ta.newName(), i = [Hf.of(r), Vc.of(iv(`.${r}`, e))];
    return n && n.dark && i.push(nv.of(!0)), i;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(e) {
    return vc.lowest(Vc.of(iv("." + rv, e, GC)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(e) {
    var n;
    let r = e.querySelector(".cm-content"), i = r && Zn.get(r) || Zn.get(e);
    return ((n = i == null ? void 0 : i.rootView) === null || n === void 0 ? void 0 : n.view) || null;
  }
}
at.styleModule = Vc;
at.inputHandler = wC;
at.focusChangeEffect = jC;
at.perLineTextDirection = kC;
at.exceptionSink = xC;
at.updateListener = Gg;
at.editable = kp;
at.mouseSelectionStyle = bC;
at.dragMovesSelection = yC;
at.clickAddsSelectionRange = vC;
at.decorations = _u;
at.atomicRanges = G0;
at.bidiIsolatedRanges = CC;
at.scrollMargins = OC;
at.darkTheme = nv;
at.cspNonce = /* @__PURE__ */ vt.define({ combine: (t) => t.length ? t[0] : "" });
at.contentAttributes = K0;
at.editorAttributes = SC;
at.lineWrapping = /* @__PURE__ */ at.contentAttributes.of({ class: "cm-lineWrapping" });
at.announce = /* @__PURE__ */ ln.define();
const oz = 4096, H2 = {};
class ch {
  constructor(e, n, r, i, o, s) {
    this.from = e, this.to = n, this.dir = r, this.isolates = i, this.fresh = o, this.order = s;
  }
  static update(e, n) {
    if (n.empty && !e.some((o) => o.fresh))
      return e;
    let r = [], i = e.length ? e[e.length - 1].dir : cr.LTR;
    for (let o = Math.max(0, e.length - 10); o < e.length; o++) {
      let s = e[o];
      s.dir == i && !n.touchesRange(s.from, s.to) && r.push(new ch(n.mapPos(s.from, 1), n.mapPos(s.to, -1), s.dir, s.isolates, !1, s.order));
    }
    return r;
  }
}
function U2(t, e, n) {
  for (let r = t.state.facet(e), i = r.length - 1; i >= 0; i--) {
    let o = r[i], s = typeof o == "function" ? o(t) : o;
    s && Wg(s, n);
  }
  return n;
}
const sz = jt.mac ? "mac" : jt.windows ? "win" : jt.linux ? "linux" : "key";
function az(t, e) {
  const n = t.split(/-(?!$)/);
  let r = n[n.length - 1];
  r == "Space" && (r = " ");
  let i, o, s, a;
  for (let l = 0; l < n.length - 1; ++l) {
    const c = n[l];
    if (/^(cmd|meta|m)$/i.test(c))
      a = !0;
    else if (/^a(lt)?$/i.test(c))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      o = !0;
    else if (/^s(hift)?$/i.test(c))
      s = !0;
    else if (/^mod$/i.test(c))
      e == "mac" ? a = !0 : o = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return i && (r = "Alt-" + r), o && (r = "Ctrl-" + r), a && (r = "Meta-" + r), s && (r = "Shift-" + r), r;
}
function Uf(t, e, n) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n !== !1 && e.shiftKey && (t = "Shift-" + t), t;
}
const lz = /* @__PURE__ */ vc.default(/* @__PURE__ */ at.domEventHandlers({
  keydown(t, e) {
    return XC(YC(e.state), t, e, "editor");
  }
})), uh = /* @__PURE__ */ vt.define({ enables: lz }), W2 = /* @__PURE__ */ new WeakMap();
function YC(t) {
  let e = t.facet(uh), n = W2.get(e);
  return n || W2.set(e, n = fz(e.reduce((r, i) => r.concat(i), []))), n;
}
function cz(t, e, n) {
  return XC(YC(t.state), e, t, n);
}
let Ns = null;
const uz = 4e3;
function fz(t, e = sz) {
  let n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null), i = (s, a) => {
    let l = r[s];
    if (l == null)
      r[s] = a;
    else if (l != a)
      throw new Error("Key binding " + s + " is used both as a regular binding and as a multi-stroke prefix");
  }, o = (s, a, l, c, u) => {
    var f, d;
    let h = n[s] || (n[s] = /* @__PURE__ */ Object.create(null)), p = a.split(/ (?!$)/).map((v) => az(v, e));
    for (let v = 1; v < p.length; v++) {
      let y = p.slice(0, v).join(" ");
      i(y, !0), h[y] || (h[y] = {
        preventDefault: !0,
        stopPropagation: !1,
        run: [(w) => {
          let x = Ns = { view: w, prefix: y, scope: s };
          return setTimeout(() => {
            Ns == x && (Ns = null);
          }, uz), !0;
        }]
      });
    }
    let m = p.join(" ");
    i(m, !1);
    let g = h[m] || (h[m] = {
      preventDefault: !1,
      stopPropagation: !1,
      run: ((d = (f = h._any) === null || f === void 0 ? void 0 : f.run) === null || d === void 0 ? void 0 : d.slice()) || []
    });
    l && g.run.push(l), c && (g.preventDefault = !0), u && (g.stopPropagation = !0);
  };
  for (let s of t) {
    let a = s.scope ? s.scope.split(" ") : ["editor"];
    if (s.any)
      for (let c of a) {
        let u = n[c] || (n[c] = /* @__PURE__ */ Object.create(null));
        u._any || (u._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        for (let f in u)
          u[f].run.push(s.any);
      }
    let l = s[e] || s.key;
    if (l)
      for (let c of a)
        o(c, l, s.run, s.preventDefault, s.stopPropagation), s.shift && o(c, "Shift-" + l, s.shift, s.preventDefault, s.stopPropagation);
  }
  return n;
}
function XC(t, e, n, r) {
  let i = NB(e), o = Nr(i, 0), s = Mi(o) == i.length && i != " ", a = "", l = !1, c = !1, u = !1;
  Ns && Ns.view == n && Ns.scope == r && (a = Ns.prefix + " ", LC.indexOf(e.keyCode) < 0 && (c = !0, Ns = null));
  let f = /* @__PURE__ */ new Set(), d = (g) => {
    if (g) {
      for (let v of g.run)
        if (!f.has(v) && (f.add(v), v(n, e)))
          return g.stopPropagation && (u = !0), !0;
      g.preventDefault && (g.stopPropagation && (u = !0), c = !0);
    }
    return !1;
  }, h = t[r], p, m;
  return h && (d(h[a + Uf(i, e, !s)]) ? l = !0 : s && (e.altKey || e.metaKey || e.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
  !(jt.windows && e.ctrlKey && e.altKey) && (p = na[e.keyCode]) && p != i ? (d(h[a + Uf(p, e, !0)]) || e.shiftKey && (m = Eu[e.keyCode]) != i && m != p && d(h[a + Uf(m, e, !1)])) && (l = !0) : s && e.shiftKey && d(h[a + Uf(i, e, !0)]) && (l = !0), !l && d(h._any) && (l = !0)), c && (l = !0), l && u && e.stopPropagation(), l;
}
class sf {
  /**
  Create a marker with the given class and dimensions. If `width`
  is null, the DOM element will get no width style.
  */
  constructor(e, n, r, i, o) {
    this.className = e, this.left = n, this.top = r, this.width = i, this.height = o;
  }
  draw() {
    let e = document.createElement("div");
    return e.className = this.className, this.adjust(e), e;
  }
  update(e, n) {
    return n.className != this.className ? !1 : (this.adjust(e), !0);
  }
  adjust(e) {
    e.style.left = this.left + "px", e.style.top = this.top + "px", this.width != null && (e.style.width = this.width + "px"), e.style.height = this.height + "px";
  }
  eq(e) {
    return this.left == e.left && this.top == e.top && this.width == e.width && this.height == e.height && this.className == e.className;
  }
  /**
  Create a set of rectangles for the given selection range,
  assigning them theclass`className`. Will create a single
  rectangle for empty ranges, and a set of selection-style
  rectangles covering the range's content (in a bidi-aware
  way) for non-empty ones.
  */
  static forRange(e, n, r) {
    if (r.empty) {
      let i = e.coordsAtPos(r.head, r.assoc || 1);
      if (!i)
        return [];
      let o = ZC(e);
      return [new sf(n, i.left - o.left, i.top - o.top, null, i.bottom - i.top)];
    } else
      return dz(e, n, r);
  }
}
function ZC(t) {
  let e = t.scrollDOM.getBoundingClientRect();
  return { left: (t.textDirection == cr.LTR ? e.left : e.right - t.scrollDOM.clientWidth * t.scaleX) - t.scrollDOM.scrollLeft * t.scaleX, top: e.top - t.scrollDOM.scrollTop * t.scaleY };
}
function J2(t, e, n) {
  let r = Te.cursor(e);
  return {
    from: Math.max(n.from, t.moveToLineBoundary(r, !1, !0).from),
    to: Math.min(n.to, t.moveToLineBoundary(r, !0, !0).from),
    type: ri.Text
  };
}
function dz(t, e, n) {
  if (n.to <= t.viewport.from || n.from >= t.viewport.to)
    return [];
  let r = Math.max(n.from, t.viewport.from), i = Math.min(n.to, t.viewport.to), o = t.textDirection == cr.LTR, s = t.contentDOM, a = s.getBoundingClientRect(), l = ZC(t), c = s.querySelector(".cm-line"), u = c && window.getComputedStyle(c), f = a.left + (u ? parseInt(u.paddingLeft) + Math.min(0, parseInt(u.textIndent)) : 0), d = a.right - (u ? parseInt(u.paddingRight) : 0), h = ev(t, r), p = ev(t, i), m = h.type == ri.Text ? h : null, g = p.type == ri.Text ? p : null;
  if (m && (t.lineWrapping || h.widgetLineBreaks) && (m = J2(t, r, m)), g && (t.lineWrapping || p.widgetLineBreaks) && (g = J2(t, i, g)), m && g && m.from == g.from)
    return y(w(n.from, n.to, m));
  {
    let b = m ? w(n.from, null, m) : x(h, !1), j = g ? w(null, n.to, g) : x(p, !0), $ = [];
    return (m || h).to < (g || p).from - (m && g ? 1 : 0) || h.widgetLineBreaks > 1 && b.bottom + t.defaultLineHeight / 2 < j.top ? $.push(v(f, b.bottom, d, j.top)) : b.bottom < j.top && t.elementAtHeight((b.bottom + j.top) / 2).type == ri.Text && (b.bottom = j.top = (b.bottom + j.top) / 2), y(b).concat($).concat(y(j));
  }
  function v(b, j, $, N) {
    return new sf(
      e,
      b - l.left,
      j - l.top - 0.01,
      $ - b,
      N - j + 0.01
      /* C.Epsilon */
    );
  }
  function y({ top: b, bottom: j, horizontal: $ }) {
    let N = [];
    for (let B = 0; B < $.length; B += 2)
      N.push(v($[B], b, $[B + 1], j));
    return N;
  }
  function w(b, j, $) {
    let N = 1e9, B = -1e9, O = [];
    function I(D, Q, Z, L, R) {
      let V = t.coordsAtPos(D, D == $.to ? -2 : 2), M = t.coordsAtPos(Z, Z == $.from ? 2 : -2);
      !V || !M || (N = Math.min(V.top, M.top, N), B = Math.max(V.bottom, M.bottom, B), R == cr.LTR ? O.push(o && Q ? f : V.left, o && L ? d : M.right) : O.push(!o && L ? f : M.left, !o && Q ? d : V.right));
    }
    let P = b ?? $.from, J = j ?? $.to;
    for (let D of t.visibleRanges)
      if (D.to > P && D.from < J)
        for (let Q = Math.max(D.from, P), Z = Math.min(D.to, J); ; ) {
          let L = t.state.doc.lineAt(Q);
          for (let R of t.bidiSpans(L)) {
            let V = R.from + L.from, M = R.to + L.from;
            if (V >= Z)
              break;
            M > Q && I(Math.max(V, Q), b == null && V <= P, Math.min(M, Z), j == null && M >= J, R.dir);
          }
          if (Q = L.to + 1, Q >= Z)
            break;
        }
    return O.length == 0 && I(P, b == null, J, j == null, t.textDirection), { top: N, bottom: B, horizontal: O };
  }
  function x(b, j) {
    let $ = a.top + (j ? b.top : b.bottom);
    return { top: $, bottom: $, horizontal: [] };
  }
}
function hz(t, e) {
  return t.constructor == e.constructor && t.eq(e);
}
class pz {
  constructor(e, n) {
    this.view = e, this.layer = n, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) }, this.dom = e.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), n.above && this.dom.classList.add("cm-layer-above"), n.class && this.dom.classList.add(n.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(e.state), e.requestMeasure(this.measureReq), n.mount && n.mount(this.dom, e);
  }
  update(e) {
    e.startState.facet(Rd) != e.state.facet(Rd) && this.setOrder(e.state), (this.layer.update(e, this.dom) || e.geometryChanged) && (this.scale(), e.view.requestMeasure(this.measureReq));
  }
  setOrder(e) {
    let n = 0, r = e.facet(Rd);
    for (; n < r.length && r[n] != this.layer; )
      n++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - n);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX: e, scaleY: n } = this.view;
    (e != this.scaleX || n != this.scaleY) && (this.scaleX = e, this.scaleY = n, this.dom.style.transform = `scale(${1 / e}, ${1 / n})`);
  }
  draw(e) {
    if (e.length != this.drawn.length || e.some((n, r) => !hz(n, this.drawn[r]))) {
      let n = this.dom.firstChild, r = 0;
      for (let i of e)
        i.update && n && i.constructor && this.drawn[r].constructor && i.update(n, this.drawn[r]) ? (n = n.nextSibling, r++) : this.dom.insertBefore(i.draw(), n);
      for (; n; ) {
        let i = n.nextSibling;
        n.remove(), n = i;
      }
      this.drawn = e;
    }
  }
  destroy() {
    this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
  }
}
const Rd = /* @__PURE__ */ vt.define();
function e3(t) {
  return [
    ur.define((e) => new pz(e, t)),
    Rd.of(t)
  ];
}
const t3 = !jt.ios, Pu = /* @__PURE__ */ vt.define({
  combine(t) {
    return Ui(t, {
      cursorBlinkRate: 1200,
      drawRangeCursor: !0
    }, {
      cursorBlinkRate: (e, n) => Math.min(e, n),
      drawRangeCursor: (e, n) => e || n
    });
  }
});
function mz(t = {}) {
  return [
    Pu.of(t),
    gz,
    vz,
    yz,
    $C.of(!0)
  ];
}
function n3(t) {
  return t.startState.facet(Pu) != t.state.facet(Pu);
}
const gz = /* @__PURE__ */ e3({
  above: !0,
  markers(t) {
    let { state: e } = t, n = e.facet(Pu), r = [];
    for (let i of e.selection.ranges) {
      let o = i == e.selection.main;
      if (i.empty ? !o || t3 : n.drawRangeCursor) {
        let s = o ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", a = i.empty ? i : Te.cursor(i.head, i.head > i.anchor ? -1 : 1);
        for (let l of sf.forRange(t, s, a))
          r.push(l);
      }
    }
    return r;
  },
  update(t, e) {
    t.transactions.some((r) => r.selection) && (e.style.animationName = e.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
    let n = n3(t);
    return n && K2(t.state, e), t.docChanged || t.selectionSet || n;
  },
  mount(t, e) {
    K2(e.state, t);
  },
  class: "cm-cursorLayer"
});
function K2(t, e) {
  e.style.animationDuration = t.facet(Pu).cursorBlinkRate + "ms";
}
const vz = /* @__PURE__ */ e3({
  above: !1,
  markers(t) {
    return t.state.selection.ranges.map((e) => e.empty ? [] : sf.forRange(t, "cm-selectionBackground", e)).reduce((e, n) => e.concat(n));
  },
  update(t, e) {
    return t.docChanged || t.selectionSet || t.viewportChanged || n3(t);
  },
  class: "cm-selectionLayer"
}), ov = {
  ".cm-line": {
    "& ::selection": { backgroundColor: "transparent !important" },
    "&::selection": { backgroundColor: "transparent !important" }
  }
};
t3 && (ov[".cm-line"].caretColor = "transparent !important", ov[".cm-content"] = { caretColor: "transparent !important" });
const yz = /* @__PURE__ */ vc.highest(/* @__PURE__ */ at.theme(ov)), r3 = /* @__PURE__ */ ln.define({
  map(t, e) {
    return t == null ? null : e.mapPos(t);
  }
}), Wc = /* @__PURE__ */ Cr.define({
  create() {
    return null;
  },
  update(t, e) {
    return t != null && (t = e.changes.mapPos(t)), e.effects.reduce((n, r) => r.is(r3) ? r.value : n, t);
  }
}), bz = /* @__PURE__ */ ur.fromClass(class {
  constructor(t) {
    this.view = t, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(t) {
    var e;
    let n = t.state.field(Wc);
    n == null ? this.cursor != null && ((e = this.cursor) === null || e === void 0 || e.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (t.startState.field(Wc) != n || t.docChanged || t.geometryChanged) && this.view.requestMeasure(this.measureReq));
  }
  readPos() {
    let { view: t } = this, e = t.state.field(Wc), n = e != null && t.coordsAtPos(e);
    if (!n)
      return null;
    let r = t.scrollDOM.getBoundingClientRect();
    return {
      left: n.left - r.left + t.scrollDOM.scrollLeft * t.scaleX,
      top: n.top - r.top + t.scrollDOM.scrollTop * t.scaleY,
      height: n.bottom - n.top
    };
  }
  drawCursor(t) {
    if (this.cursor) {
      let { scaleX: e, scaleY: n } = this.view;
      t ? (this.cursor.style.left = t.left / e + "px", this.cursor.style.top = t.top / n + "px", this.cursor.style.height = t.height / n + "px") : this.cursor.style.left = "-100000px";
    }
  }
  destroy() {
    this.cursor && this.cursor.remove();
  }
  setDropPos(t) {
    this.view.state.field(Wc) != t && this.view.dispatch({ effects: r3.of(t) });
  }
}, {
  eventObservers: {
    dragover(t) {
      this.setDropPos(this.view.posAtCoords({ x: t.clientX, y: t.clientY }));
    },
    dragleave(t) {
      (t.target == this.view.contentDOM || !this.view.contentDOM.contains(t.relatedTarget)) && this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function xz() {
  return [Wc, bz];
}
function G2(t, e, n, r, i) {
  e.lastIndex = 0;
  for (let o = t.iterRange(n, r), s = n, a; !o.next().done; s += o.value.length)
    if (!o.lineBreak)
      for (; a = e.exec(o.value); )
        i(s + a.index, a);
}
function wz(t, e) {
  let n = t.visibleRanges;
  if (n.length == 1 && n[0].from == t.viewport.from && n[0].to == t.viewport.to)
    return n;
  let r = [];
  for (let { from: i, to: o } of n)
    i = Math.max(t.state.doc.lineAt(i).from, i - e), o = Math.min(t.state.doc.lineAt(o).to, o + e), r.length && r[r.length - 1].to >= i ? r[r.length - 1].to = o : r.push({ from: i, to: o });
  return r;
}
class jz {
  /**
  Create a decorator.
  */
  constructor(e) {
    const { regexp: n, decoration: r, decorate: i, boundary: o, maxLength: s = 1e3 } = e;
    if (!n.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    if (this.regexp = n, i)
      this.addMatch = (a, l, c, u) => i(u, c, c + a[0].length, a, l);
    else if (typeof r == "function")
      this.addMatch = (a, l, c, u) => {
        let f = r(a, l, c);
        f && u(c, c + a[0].length, f);
      };
    else if (r)
      this.addMatch = (a, l, c, u) => u(c, c + a[0].length, r);
    else
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    this.boundary = o, this.maxLength = s;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(e) {
    let n = new Fo(), r = n.add.bind(n);
    for (let { from: i, to: o } of wz(e, this.maxLength))
      G2(e.state.doc, this.regexp, i, o, (s, a) => this.addMatch(a, e, s, r));
    return n.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(e, n) {
    let r = 1e9, i = -1;
    return e.docChanged && e.changes.iterChanges((o, s, a, l) => {
      l > e.view.viewport.from && a < e.view.viewport.to && (r = Math.min(a, r), i = Math.max(l, i));
    }), e.viewportChanged || i - r > 1e3 ? this.createDeco(e.view) : i > -1 ? this.updateRange(e.view, n.map(e.changes), r, i) : n;
  }
  updateRange(e, n, r, i) {
    for (let o of e.visibleRanges) {
      let s = Math.max(o.from, r), a = Math.min(o.to, i);
      if (a > s) {
        let l = e.state.doc.lineAt(s), c = l.to < a ? e.state.doc.lineAt(a) : l, u = Math.max(o.from, l.from), f = Math.min(o.to, c.to);
        if (this.boundary) {
          for (; s > l.from; s--)
            if (this.boundary.test(l.text[s - 1 - l.from])) {
              u = s;
              break;
            }
          for (; a < c.to; a++)
            if (this.boundary.test(c.text[a - c.from])) {
              f = a;
              break;
            }
        }
        let d = [], h, p = (m, g, v) => d.push(v.range(m, g));
        if (l == c)
          for (this.regexp.lastIndex = u - l.from; (h = this.regexp.exec(l.text)) && h.index < f - l.from; )
            this.addMatch(h, e, h.index + l.from, p);
        else
          G2(e.state.doc, this.regexp, u, f, (m, g) => this.addMatch(g, e, m, p));
        n = n.update({ filterFrom: u, filterTo: f, filter: (m, g) => m < u || g > f, add: d });
      }
    }
    return n;
  }
}
const sv = /x/.unicode != null ? "gu" : "g", kz = /* @__PURE__ */ new RegExp(`[\0-\b
--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]`, sv), $z = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let jm = null;
function Sz() {
  var t;
  if (jm == null && typeof document < "u" && document.body) {
    let e = document.body.style;
    jm = ((t = e.tabSize) !== null && t !== void 0 ? t : e.MozTabSize) != null;
  }
  return jm || !1;
}
const Nd = /* @__PURE__ */ vt.define({
  combine(t) {
    let e = Ui(t, {
      render: null,
      specialChars: kz,
      addSpecialChars: null
    });
    return (e.replaceTabs = !Sz()) && (e.specialChars = new RegExp("	|" + e.specialChars.source, sv)), e.addSpecialChars && (e.specialChars = new RegExp(e.specialChars.source + "|" + e.addSpecialChars.source, sv)), e;
  }
});
function Cz(t = {}) {
  return [Nd.of(t), Oz()];
}
let Q2 = null;
function Oz() {
  return Q2 || (Q2 = ur.fromClass(class {
    constructor(t) {
      this.view = t, this.decorations = Bt.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(t.state.facet(Nd)), this.decorations = this.decorator.createDeco(t);
    }
    makeDecorator(t) {
      return new jz({
        regexp: t.specialChars,
        decoration: (e, n, r) => {
          let { doc: i } = n.state, o = Nr(e[0], 0);
          if (o == 9) {
            let s = i.lineAt(r), a = n.state.tabSize, l = yc(s.text, a, r - s.from);
            return Bt.replace({
              widget: new _z((a - l % a) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[o] || (this.decorationCache[o] = Bt.replace({ widget: new Mz(t, o) }));
        },
        boundary: t.replaceTabs ? void 0 : /[^]/
      });
    }
    update(t) {
      let e = t.state.facet(Nd);
      t.startState.facet(Nd) != e ? (this.decorator = this.makeDecorator(e), this.decorations = this.decorator.createDeco(t.view)) : this.decorations = this.decorator.updateDeco(t, this.decorations);
    }
  }, {
    decorations: (t) => t.decorations
  }));
}
const Ez = "•";
function Az(t) {
  return t >= 32 ? Ez : t == 10 ? "␤" : String.fromCharCode(9216 + t);
}
class Mz extends ua {
  constructor(e, n) {
    super(), this.options = e, this.code = n;
  }
  eq(e) {
    return e.code == this.code;
  }
  toDOM(e) {
    let n = Az(this.code), r = e.state.phrase("Control character") + " " + ($z[this.code] || "0x" + this.code.toString(16)), i = this.options.render && this.options.render(this.code, r, n);
    if (i)
      return i;
    let o = document.createElement("span");
    return o.textContent = n, o.title = r, o.setAttribute("aria-label", r), o.className = "cm-specialChar", o;
  }
  ignoreEvent() {
    return !1;
  }
}
class _z extends ua {
  constructor(e) {
    super(), this.width = e;
  }
  eq(e) {
    return e.width == this.width;
  }
  toDOM() {
    let e = document.createElement("span");
    return e.textContent = "	", e.className = "cm-tab", e.style.width = this.width + "px", e;
  }
  ignoreEvent() {
    return !1;
  }
}
function Tz() {
  return Rz;
}
const Pz = /* @__PURE__ */ Bt.line({ class: "cm-activeLine" }), Rz = /* @__PURE__ */ ur.fromClass(class {
  constructor(t) {
    this.decorations = this.getDeco(t);
  }
  update(t) {
    (t.docChanged || t.selectionSet) && (this.decorations = this.getDeco(t.view));
  }
  getDeco(t) {
    let e = -1, n = [];
    for (let r of t.state.selection.ranges) {
      let i = t.lineBlockAt(r.head);
      i.from > e && (n.push(Pz.range(i.from)), e = i.from);
    }
    return Bt.set(n);
  }
}, {
  decorations: (t) => t.decorations
}), av = 2e3;
function Nz(t, e, n) {
  let r = Math.min(e.line, n.line), i = Math.max(e.line, n.line), o = [];
  if (e.off > av || n.off > av || e.col < 0 || n.col < 0) {
    let s = Math.min(e.off, n.off), a = Math.max(e.off, n.off);
    for (let l = r; l <= i; l++) {
      let c = t.doc.line(l);
      c.length <= a && o.push(Te.range(c.from + s, c.to + a));
    }
  } else {
    let s = Math.min(e.col, n.col), a = Math.max(e.col, n.col);
    for (let l = r; l <= i; l++) {
      let c = t.doc.line(l), u = Bg(c.text, s, t.tabSize, !0);
      if (u < 0)
        o.push(Te.cursor(c.to));
      else {
        let f = Bg(c.text, a, t.tabSize);
        o.push(Te.range(c.from + u, c.from + f));
      }
    }
  }
  return o;
}
function Iz(t, e) {
  let n = t.coordsAtPos(t.viewport.from);
  return n ? Math.round(Math.abs((n.left - e) / t.defaultCharacterWidth)) : -1;
}
function Y2(t, e) {
  let n = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1), r = t.state.doc.lineAt(n), i = n - r.from, o = i > av ? -1 : i == r.length ? Iz(t, e.clientX) : yc(r.text, t.state.tabSize, n - r.from);
  return { line: r.number, col: o, off: i };
}
function Dz(t, e) {
  let n = Y2(t, e), r = t.state.selection;
  return n ? {
    update(i) {
      if (i.docChanged) {
        let o = i.changes.mapPos(i.startState.doc.line(n.line).from), s = i.state.doc.lineAt(o);
        n = { line: s.number, col: n.col, off: Math.min(n.off, s.length) }, r = r.map(i.changes);
      }
    },
    get(i, o, s) {
      let a = Y2(t, i);
      if (!a)
        return r;
      let l = Nz(t.state, n, a);
      return l.length ? s ? Te.create(l.concat(r.ranges)) : Te.create(l) : r;
    }
  } : null;
}
function Lz(t) {
  let e = (t == null ? void 0 : t.eventFilter) || ((n) => n.altKey && n.button == 0);
  return at.mouseSelectionStyle.of((n, r) => e(r) ? Dz(n, r) : null);
}
const Bz = {
  Alt: [18, (t) => !!t.altKey],
  Control: [17, (t) => !!t.ctrlKey],
  Shift: [16, (t) => !!t.shiftKey],
  Meta: [91, (t) => !!t.metaKey]
}, qz = { style: "cursor: crosshair" };
function zz(t = {}) {
  let [e, n] = Bz[t.key || "Alt"], r = ur.fromClass(class {
    constructor(i) {
      this.view = i, this.isDown = !1;
    }
    set(i) {
      this.isDown != i && (this.isDown = i, this.view.update([]));
    }
  }, {
    eventObservers: {
      keydown(i) {
        this.set(i.keyCode == e || n(i));
      },
      keyup(i) {
        (i.keyCode == e || !n(i)) && this.set(!1);
      },
      mousemove(i) {
        this.set(n(i));
      }
    }
  });
  return [
    r,
    at.contentAttributes.of((i) => {
      var o;
      return !((o = i.plugin(r)) === null || o === void 0) && o.isDown ? qz : null;
    })
  ];
}
const Pc = "-10000px";
class i3 {
  constructor(e, n, r) {
    this.facet = n, this.createTooltipView = r, this.input = e.state.facet(n), this.tooltips = this.input.filter((i) => i), this.tooltipViews = this.tooltips.map(r);
  }
  update(e, n) {
    var r;
    let i = e.state.facet(this.facet), o = i.filter((l) => l);
    if (i === this.input) {
      for (let l of this.tooltipViews)
        l.update && l.update(e);
      return !1;
    }
    let s = [], a = n ? [] : null;
    for (let l = 0; l < o.length; l++) {
      let c = o[l], u = -1;
      if (c) {
        for (let f = 0; f < this.tooltips.length; f++) {
          let d = this.tooltips[f];
          d && d.create == c.create && (u = f);
        }
        if (u < 0)
          s[l] = this.createTooltipView(c), a && (a[l] = !!c.above);
        else {
          let f = s[l] = this.tooltipViews[u];
          a && (a[l] = n[u]), f.update && f.update(e);
        }
      }
    }
    for (let l of this.tooltipViews)
      s.indexOf(l) < 0 && (l.dom.remove(), (r = l.destroy) === null || r === void 0 || r.call(l));
    return n && (a.forEach((l, c) => n[c] = l), n.length = a.length), this.input = i, this.tooltips = o, this.tooltipViews = s, !0;
  }
}
function Fz(t) {
  let { win: e } = t;
  return { top: 0, left: 0, bottom: e.innerHeight, right: e.innerWidth };
}
const km = /* @__PURE__ */ vt.define({
  combine: (t) => {
    var e, n, r;
    return {
      position: jt.ios ? "absolute" : ((e = t.find((i) => i.position)) === null || e === void 0 ? void 0 : e.position) || "fixed",
      parent: ((n = t.find((i) => i.parent)) === null || n === void 0 ? void 0 : n.parent) || null,
      tooltipSpace: ((r = t.find((i) => i.tooltipSpace)) === null || r === void 0 ? void 0 : r.tooltipSpace) || Fz
    };
  }
}), X2 = /* @__PURE__ */ new WeakMap(), Y0 = /* @__PURE__ */ ur.fromClass(class {
  constructor(t) {
    this.view = t, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let e = t.state.facet(km);
    this.position = e.position, this.parent = e.parent, this.classes = t.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.manager = new i3(t, $p, (n) => this.createTooltip(n)), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((n) => {
      Date.now() > this.lastTransaction - 50 && n.length > 0 && n[n.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), t.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let t of this.manager.tooltipViews)
        this.intersectionObserver.observe(t.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(t) {
    t.transactions.length && (this.lastTransaction = Date.now());
    let e = this.manager.update(t, this.above);
    e && this.observeIntersection();
    let n = e || t.geometryChanged, r = t.state.facet(km);
    if (r.position != this.position && !this.madeAbsolute) {
      this.position = r.position;
      for (let i of this.manager.tooltipViews)
        i.dom.style.position = this.position;
      n = !0;
    }
    if (r.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
      for (let i of this.manager.tooltipViews)
        this.container.appendChild(i.dom);
      n = !0;
    } else
      this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    n && this.maybeMeasure();
  }
  createTooltip(t) {
    let e = t.create(this.view);
    if (e.dom.classList.add("cm-tooltip"), t.arrow && !e.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let n = document.createElement("div");
      n.className = "cm-tooltip-arrow", e.dom.appendChild(n);
    }
    return e.dom.style.position = this.position, e.dom.style.top = Pc, e.dom.style.left = "0px", this.container.appendChild(e.dom), e.mount && e.mount(this.view), e;
  }
  destroy() {
    var t, e;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let n of this.manager.tooltipViews)
      n.dom.remove(), (t = n.destroy) === null || t === void 0 || t.call(n);
    this.parent && this.container.remove(), (e = this.intersectionObserver) === null || e === void 0 || e.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let t = this.view.dom.getBoundingClientRect(), e = 1, n = 1, r = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: i } = this.manager.tooltipViews[0];
      if (jt.gecko)
        r = i.offsetParent != this.container.ownerDocument.body;
      else if (this.view.scaleX != 1 || this.view.scaleY != 1)
        r = !0;
      else if (i.style.top == Pc && i.style.left == "0px") {
        let o = i.getBoundingClientRect();
        r = Math.abs(o.top + 1e4) > 1 || Math.abs(o.left) > 1;
      }
    }
    if (r || this.position == "absolute")
      if (this.parent) {
        let i = this.parent.getBoundingClientRect();
        i.width && i.height && (e = i.width / this.parent.offsetWidth, n = i.height / this.parent.offsetHeight);
      } else
        ({ scaleX: e, scaleY: n } = this.view.viewState);
    return {
      editor: t,
      parent: this.parent ? this.container.getBoundingClientRect() : t,
      pos: this.manager.tooltips.map((i, o) => {
        let s = this.manager.tooltipViews[o];
        return s.getCoords ? s.getCoords(i.pos) : this.view.coordsAtPos(i.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: i }) => i.getBoundingClientRect()),
      space: this.view.state.facet(km).tooltipSpace(this.view),
      scaleX: e,
      scaleY: n,
      makeAbsolute: r
    };
  }
  writeMeasure(t) {
    var e;
    if (t.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let a of this.manager.tooltipViews)
        a.dom.style.position = "absolute";
    }
    let { editor: n, space: r, scaleX: i, scaleY: o } = t, s = [];
    for (let a = 0; a < this.manager.tooltips.length; a++) {
      let l = this.manager.tooltips[a], c = this.manager.tooltipViews[a], { dom: u } = c, f = t.pos[a], d = t.size[a];
      if (!f || f.bottom <= Math.max(n.top, r.top) || f.top >= Math.min(n.bottom, r.bottom) || f.right < Math.max(n.left, r.left) - 0.1 || f.left > Math.min(n.right, r.right) + 0.1) {
        u.style.top = Pc;
        continue;
      }
      let h = l.arrow ? c.dom.querySelector(".cm-tooltip-arrow") : null, p = h ? 7 : 0, m = d.right - d.left, g = (e = X2.get(c)) !== null && e !== void 0 ? e : d.bottom - d.top, v = c.offset || Hz, y = this.view.textDirection == cr.LTR, w = d.width > r.right - r.left ? y ? r.left : r.right - d.width : y ? Math.min(f.left - (h ? 14 : 0) + v.x, r.right - m) : Math.max(r.left, f.left - m + (h ? 14 : 0) - v.x), x = this.above[a];
      !l.strictSide && (x ? f.top - (d.bottom - d.top) - v.y < r.top : f.bottom + (d.bottom - d.top) + v.y > r.bottom) && x == r.bottom - f.bottom > f.top - r.top && (x = this.above[a] = !x);
      let b = (x ? f.top - r.top : r.bottom - f.bottom) - p;
      if (b < g && c.resize !== !1) {
        if (b < this.view.defaultLineHeight) {
          u.style.top = Pc;
          continue;
        }
        X2.set(c, g), u.style.height = (g = b) / o + "px";
      } else
        u.style.height && (u.style.height = "");
      let j = x ? f.top - g - p - v.y : f.bottom + p + v.y, $ = w + m;
      if (c.overlap !== !0)
        for (let N of s)
          N.left < $ && N.right > w && N.top < j + g && N.bottom > j && (j = x ? N.top - g - 2 - p : N.bottom + p + 2);
      if (this.position == "absolute" ? (u.style.top = (j - t.parent.top) / o + "px", u.style.left = (w - t.parent.left) / i + "px") : (u.style.top = j / o + "px", u.style.left = w / i + "px"), h) {
        let N = f.left + (y ? v.x : -v.x) - (w + 14 - 7);
        h.style.left = N / i + "px";
      }
      c.overlap !== !0 && s.push({ left: w, top: j, right: $, bottom: j + g }), u.classList.toggle("cm-tooltip-above", x), u.classList.toggle("cm-tooltip-below", !x), c.positioned && c.positioned(t.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let t of this.manager.tooltipViews)
        t.dom.style.top = Pc;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
}), Vz = /* @__PURE__ */ at.baseTheme({
  ".cm-tooltip": {
    zIndex: 100,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), Hz = { x: 0, y: 0 }, $p = /* @__PURE__ */ vt.define({
  enables: [Y0, Vz]
}), fh = /* @__PURE__ */ vt.define();
class Sp {
  // Needs to be static so that host tooltip instances always match
  static create(e) {
    return new Sp(e);
  }
  constructor(e) {
    this.view = e, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new i3(e, fh, (n) => this.createHostedView(n));
  }
  createHostedView(e) {
    let n = e.create(this.view);
    return n.dom.classList.add("cm-tooltip-section"), this.dom.appendChild(n.dom), this.mounted && n.mount && n.mount(this.view), n;
  }
  mount(e) {
    for (let n of this.manager.tooltipViews)
      n.mount && n.mount(e);
    this.mounted = !0;
  }
  positioned(e) {
    for (let n of this.manager.tooltipViews)
      n.positioned && n.positioned(e);
  }
  update(e) {
    this.manager.update(e);
  }
  destroy() {
    var e;
    for (let n of this.manager.tooltipViews)
      (e = n.destroy) === null || e === void 0 || e.call(n);
  }
  passProp(e) {
    let n;
    for (let r of this.manager.tooltipViews) {
      let i = r[e];
      if (i !== void 0) {
        if (n === void 0)
          n = i;
        else if (n !== i)
          return;
      }
    }
    return n;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const Uz = /* @__PURE__ */ $p.compute([fh], (t) => {
  let e = t.facet(fh).filter((n) => n);
  return e.length === 0 ? null : {
    pos: Math.min(...e.map((n) => n.pos)),
    end: Math.max(...e.map((n) => {
      var r;
      return (r = n.end) !== null && r !== void 0 ? r : n.pos;
    })),
    create: Sp.create,
    above: e[0].above,
    arrow: e.some((n) => n.arrow)
  };
});
class Wz {
  constructor(e, n, r, i, o) {
    this.view = e, this.source = n, this.field = r, this.setHover = i, this.hoverTime = o, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: e.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), e.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), e.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active)
      return;
    let e = Date.now() - this.lastMove.time;
    e < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - e) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view: e, lastMove: n } = this, r = e.docView.nearest(n.target);
    if (!r)
      return;
    let i, o = 1;
    if (r instanceof Bs)
      i = r.posAtStart;
    else {
      if (i = e.posAtCoords(n), i == null)
        return;
      let a = e.coordsAtPos(i);
      if (!a || n.y < a.top || n.y > a.bottom || n.x < a.left - e.defaultCharacterWidth || n.x > a.right + e.defaultCharacterWidth)
        return;
      let l = e.bidiSpans(e.state.doc.lineAt(i)).find((u) => u.from <= i && u.to >= i), c = l && l.dir == cr.RTL ? -1 : 1;
      o = n.x < a.left ? -c : c;
    }
    let s = this.source(e, i, o);
    if (s != null && s.then) {
      let a = this.pending = { pos: i };
      s.then((l) => {
        this.pending == a && (this.pending = null, l && e.dispatch({ effects: this.setHover.of(l) }));
      }, (l) => $i(e.state, l, "hover tooltip"));
    } else
      s && e.dispatch({ effects: this.setHover.of(s) });
  }
  get tooltip() {
    let e = this.view.plugin(Y0), n = e ? e.manager.tooltips.findIndex((r) => r.create == Sp.create) : -1;
    return n > -1 ? e.manager.tooltipViews[n] : null;
  }
  mousemove(e) {
    var n;
    this.lastMove = { x: e.clientX, y: e.clientY, target: e.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let { active: r, tooltip: i } = this;
    if (r && i && !Jz(i.dom, e) || this.pending) {
      let { pos: o } = r || this.pending, s = (n = r == null ? void 0 : r.end) !== null && n !== void 0 ? n : o;
      (o == s ? this.view.posAtCoords(this.lastMove) != o : !Kz(this.view, o, s, e.clientX, e.clientY)) && (this.view.dispatch({ effects: this.setHover.of(null) }), this.pending = null);
    }
  }
  mouseleave(e) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1;
    let { active: n } = this;
    if (n) {
      let { tooltip: r } = this;
      r && r.dom.contains(e.relatedTarget) ? this.watchTooltipLeave(r.dom) : this.view.dispatch({ effects: this.setHover.of(null) });
    }
  }
  watchTooltipLeave(e) {
    let n = (r) => {
      e.removeEventListener("mouseleave", n), this.active && !this.view.dom.contains(r.relatedTarget) && this.view.dispatch({ effects: this.setHover.of(null) });
    };
    e.addEventListener("mouseleave", n);
  }
  destroy() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const Wf = 4;
function Jz(t, e) {
  let n = t.getBoundingClientRect();
  return e.clientX >= n.left - Wf && e.clientX <= n.right + Wf && e.clientY >= n.top - Wf && e.clientY <= n.bottom + Wf;
}
function Kz(t, e, n, r, i, o) {
  let s = t.scrollDOM.getBoundingClientRect(), a = t.documentTop + t.documentPadding.top + t.contentHeight;
  if (s.left > r || s.right < r || s.top > i || Math.min(s.bottom, a) < i)
    return !1;
  let l = t.posAtCoords({ x: r, y: i }, !1);
  return l >= e && l <= n;
}
function Gz(t, e = {}) {
  let n = ln.define(), r = Cr.define({
    create() {
      return null;
    },
    update(i, o) {
      if (i && (e.hideOnChange && (o.docChanged || o.selection) || e.hideOn && e.hideOn(o, i)))
        return null;
      if (i && o.docChanged) {
        let s = o.changes.mapPos(i.pos, -1, ni.TrackDel);
        if (s == null)
          return null;
        let a = Object.assign(/* @__PURE__ */ Object.create(null), i);
        a.pos = s, i.end != null && (a.end = o.changes.mapPos(i.end)), i = a;
      }
      for (let s of o.effects)
        s.is(n) && (i = s.value), s.is(Qz) && (i = null);
      return i;
    },
    provide: (i) => fh.from(i)
  });
  return [
    r,
    ur.define((i) => new Wz(
      i,
      t,
      r,
      n,
      e.hoverTime || 300
      /* Hover.Time */
    )),
    Uz
  ];
}
function o3(t, e) {
  let n = t.plugin(Y0);
  if (!n)
    return null;
  let r = n.manager.tooltips.indexOf(e);
  return r < 0 ? null : n.manager.tooltipViews[r];
}
const Qz = /* @__PURE__ */ ln.define(), Z2 = /* @__PURE__ */ vt.define({
  combine(t) {
    let e, n;
    for (let r of t)
      e = e || r.topContainer, n = n || r.bottomContainer;
    return { topContainer: e, bottomContainer: n };
  }
});
function Ru(t, e) {
  let n = t.plugin(s3), r = n ? n.specs.indexOf(e) : -1;
  return r > -1 ? n.panels[r] : null;
}
const s3 = /* @__PURE__ */ ur.fromClass(class {
  constructor(t) {
    this.input = t.state.facet(Nu), this.specs = this.input.filter((n) => n), this.panels = this.specs.map((n) => n(t));
    let e = t.state.facet(Z2);
    this.top = new Jf(t, !0, e.topContainer), this.bottom = new Jf(t, !1, e.bottomContainer), this.top.sync(this.panels.filter((n) => n.top)), this.bottom.sync(this.panels.filter((n) => !n.top));
    for (let n of this.panels)
      n.dom.classList.add("cm-panel"), n.mount && n.mount();
  }
  update(t) {
    let e = t.state.facet(Z2);
    this.top.container != e.topContainer && (this.top.sync([]), this.top = new Jf(t.view, !0, e.topContainer)), this.bottom.container != e.bottomContainer && (this.bottom.sync([]), this.bottom = new Jf(t.view, !1, e.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let n = t.state.facet(Nu);
    if (n != this.input) {
      let r = n.filter((l) => l), i = [], o = [], s = [], a = [];
      for (let l of r) {
        let c = this.specs.indexOf(l), u;
        c < 0 ? (u = l(t.view), a.push(u)) : (u = this.panels[c], u.update && u.update(t)), i.push(u), (u.top ? o : s).push(u);
      }
      this.specs = r, this.panels = i, this.top.sync(o), this.bottom.sync(s);
      for (let l of a)
        l.dom.classList.add("cm-panel"), l.mount && l.mount();
    } else
      for (let r of this.panels)
        r.update && r.update(t);
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {
  provide: (t) => at.scrollMargins.of((e) => {
    let n = e.plugin(t);
    return n && { top: n.top.scrollMargin(), bottom: n.bottom.scrollMargin() };
  })
});
class Jf {
  constructor(e, n, r) {
    this.view = e, this.top = n, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(e) {
    for (let n of this.panels)
      n.destroy && e.indexOf(n) < 0 && n.destroy();
    this.panels = e, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let n = this.container || this.view.dom;
      n.insertBefore(this.dom, this.top ? n.firstChild : null);
    }
    let e = this.dom.firstChild;
    for (let n of this.panels)
      if (n.dom.parentNode == this.dom) {
        for (; e != n.dom; )
          e = ex(e);
        e = e.nextSibling;
      } else
        this.dom.insertBefore(n.dom, e);
    for (; e; )
      e = ex(e);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let e of this.classes.split(" "))
        e && this.container.classList.remove(e);
      for (let e of (this.classes = this.view.themeClasses).split(" "))
        e && this.container.classList.add(e);
    }
  }
}
function ex(t) {
  let e = t.nextSibling;
  return t.remove(), e;
}
const Nu = /* @__PURE__ */ vt.define({
  enables: s3
});
class Vo extends za {
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(e) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(e) {
  }
}
Vo.prototype.elementClass = "";
Vo.prototype.toDOM = void 0;
Vo.prototype.mapMode = ni.TrackBefore;
Vo.prototype.startSide = Vo.prototype.endSide = -1;
Vo.prototype.point = !0;
const Id = /* @__PURE__ */ vt.define(), Yz = {
  class: "",
  renderEmptyElements: !1,
  elementStyle: "",
  markers: () => En.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {}
}, ru = /* @__PURE__ */ vt.define();
function a3(t) {
  return [l3(), ru.of(Object.assign(Object.assign({}, Yz), t))];
}
const lv = /* @__PURE__ */ vt.define({
  combine: (t) => t.some((e) => e)
});
function l3(t) {
  let e = [
    Xz
  ];
  return t && t.fixed === !1 && e.push(lv.of(!0)), e;
}
const Xz = /* @__PURE__ */ ur.fromClass(class {
  constructor(t) {
    this.view = t, this.prevViewport = t.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = t.state.facet(ru).map((e) => new nx(t, e));
    for (let e of this.gutters)
      this.dom.appendChild(e.dom);
    this.fixed = !t.state.facet(lv), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), t.scrollDOM.insertBefore(this.dom, t.contentDOM);
  }
  update(t) {
    if (this.updateGutters(t)) {
      let e = this.prevViewport, n = t.view.viewport, r = Math.min(e.to, n.to) - Math.max(e.from, n.from);
      this.syncGutters(r < (n.to - n.from) * 0.8);
    }
    t.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight + "px"), this.view.state.facet(lv) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = t.view.viewport;
  }
  syncGutters(t) {
    let e = this.dom.nextSibling;
    t && this.dom.remove();
    let n = En.iter(this.view.state.facet(Id), this.view.viewport.from), r = [], i = this.gutters.map((o) => new Zz(o, this.view.viewport, -this.view.documentPadding.top));
    for (let o of this.view.viewportLineBlocks)
      if (r.length && (r = []), Array.isArray(o.type)) {
        let s = !0;
        for (let a of o.type)
          if (a.type == ri.Text && s) {
            cv(n, r, a.from);
            for (let l of i)
              l.line(this.view, a, r);
            s = !1;
          } else if (a.widget)
            for (let l of i)
              l.widget(this.view, a);
      } else if (o.type == ri.Text) {
        cv(n, r, o.from);
        for (let s of i)
          s.line(this.view, o, r);
      } else if (o.widget)
        for (let s of i)
          s.widget(this.view, o);
    for (let o of i)
      o.finish();
    t && this.view.scrollDOM.insertBefore(this.dom, e);
  }
  updateGutters(t) {
    let e = t.startState.facet(ru), n = t.state.facet(ru), r = t.docChanged || t.heightChanged || t.viewportChanged || !En.eq(t.startState.facet(Id), t.state.facet(Id), t.view.viewport.from, t.view.viewport.to);
    if (e == n)
      for (let i of this.gutters)
        i.update(t) && (r = !0);
    else {
      r = !0;
      let i = [];
      for (let o of n) {
        let s = e.indexOf(o);
        s < 0 ? i.push(new nx(this.view, o)) : (this.gutters[s].update(t), i.push(this.gutters[s]));
      }
      for (let o of this.gutters)
        o.dom.remove(), i.indexOf(o) < 0 && o.destroy();
      for (let o of i)
        this.dom.appendChild(o.dom);
      this.gutters = i;
    }
    return r;
  }
  destroy() {
    for (let t of this.gutters)
      t.destroy();
    this.dom.remove();
  }
}, {
  provide: (t) => at.scrollMargins.of((e) => {
    let n = e.plugin(t);
    return !n || n.gutters.length == 0 || !n.fixed ? null : e.textDirection == cr.LTR ? { left: n.dom.offsetWidth * e.scaleX } : { right: n.dom.offsetWidth * e.scaleX };
  })
});
function tx(t) {
  return Array.isArray(t) ? t : [t];
}
function cv(t, e, n) {
  for (; t.value && t.from <= n; )
    t.from == n && e.push(t.value), t.next();
}
class Zz {
  constructor(e, n, r) {
    this.gutter = e, this.height = r, this.i = 0, this.cursor = En.iter(e.markers, n.from);
  }
  addElement(e, n, r) {
    let { gutter: i } = this, o = (n.top - this.height) / e.scaleY, s = n.height / e.scaleY;
    if (this.i == i.elements.length) {
      let a = new c3(e, s, o, r);
      i.elements.push(a), i.dom.appendChild(a.dom);
    } else
      i.elements[this.i].update(e, s, o, r);
    this.height = n.bottom, this.i++;
  }
  line(e, n, r) {
    let i = [];
    cv(this.cursor, i, n.from), r.length && (i = i.concat(r));
    let o = this.gutter.config.lineMarker(e, n, i);
    o && i.unshift(o);
    let s = this.gutter;
    i.length == 0 && !s.config.renderEmptyElements || this.addElement(e, n, i);
  }
  widget(e, n) {
    let r = this.gutter.config.widgetMarker(e, n.widget, n);
    r && this.addElement(e, n, [r]);
  }
  finish() {
    let e = this.gutter;
    for (; e.elements.length > this.i; ) {
      let n = e.elements.pop();
      e.dom.removeChild(n.dom), n.destroy();
    }
  }
}
class nx {
  constructor(e, n) {
    this.view = e, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let r in n.domEventHandlers)
      this.dom.addEventListener(r, (i) => {
        let o = i.target, s;
        if (o != this.dom && this.dom.contains(o)) {
          for (; o.parentNode != this.dom; )
            o = o.parentNode;
          let l = o.getBoundingClientRect();
          s = (l.top + l.bottom) / 2;
        } else
          s = i.clientY;
        let a = e.lineBlockAtHeight(s - e.documentTop);
        n.domEventHandlers[r](e, a, i) && i.preventDefault();
      });
    this.markers = tx(n.markers(e)), n.initialSpacer && (this.spacer = new c3(e, 0, 0, [n.initialSpacer(e)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(e) {
    let n = this.markers;
    if (this.markers = tx(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
      let i = this.config.updateSpacer(this.spacer.markers[0], e);
      i != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [i]);
    }
    let r = e.view.viewport;
    return !En.eq(this.markers, n, r.from, r.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(e) : !1);
  }
  destroy() {
    for (let e of this.elements)
      e.destroy();
  }
}
class c3 {
  constructor(e, n, r, i) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(e, n, r, i);
  }
  update(e, n, r, i) {
    this.height != n && (this.height = n, this.dom.style.height = n + "px"), this.above != r && (this.dom.style.marginTop = (this.above = r) ? r + "px" : ""), eF(this.markers, i) || this.setMarkers(e, i);
  }
  setMarkers(e, n) {
    let r = "cm-gutterElement", i = this.dom.firstChild;
    for (let o = 0, s = 0; ; ) {
      let a = s, l = o < n.length ? n[o++] : null, c = !1;
      if (l) {
        let u = l.elementClass;
        u && (r += " " + u);
        for (let f = s; f < this.markers.length; f++)
          if (this.markers[f].compare(l)) {
            a = f, c = !0;
            break;
          }
      } else
        a = this.markers.length;
      for (; s < a; ) {
        let u = this.markers[s++];
        if (u.toDOM) {
          u.destroy(i);
          let f = i.nextSibling;
          i.remove(), i = f;
        }
      }
      if (!l)
        break;
      l.toDOM && (c ? i = i.nextSibling : this.dom.insertBefore(l.toDOM(e), i)), c && s++;
    }
    this.dom.className = r, this.markers = n;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function eF(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].compare(e[n]))
      return !1;
  return !0;
}
const tF = /* @__PURE__ */ vt.define(), $l = /* @__PURE__ */ vt.define({
  combine(t) {
    return Ui(t, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(e, n) {
        let r = Object.assign({}, e);
        for (let i in n) {
          let o = r[i], s = n[i];
          r[i] = o ? (a, l, c) => o(a, l, c) || s(a, l, c) : s;
        }
        return r;
      }
    });
  }
});
class $m extends Vo {
  constructor(e) {
    super(), this.number = e;
  }
  eq(e) {
    return this.number == e.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function Sm(t, e) {
  return t.state.facet($l).formatNumber(e, t.state);
}
const nF = /* @__PURE__ */ ru.compute([$l], (t) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: !1,
  markers(e) {
    return e.state.facet(tF);
  },
  lineMarker(e, n, r) {
    return r.some((i) => i.toDOM) ? null : new $m(Sm(e, e.state.doc.lineAt(n.from).number));
  },
  widgetMarker: () => null,
  lineMarkerChange: (e) => e.startState.facet($l) != e.state.facet($l),
  initialSpacer(e) {
    return new $m(Sm(e, rx(e.state.doc.lines)));
  },
  updateSpacer(e, n) {
    let r = Sm(n.view, rx(n.view.state.doc.lines));
    return r == e.number ? e : new $m(r);
  },
  domEventHandlers: t.facet($l).domEventHandlers
}));
function rF(t = {}) {
  return [
    $l.of(t),
    l3(),
    nF
  ];
}
function rx(t) {
  let e = 9;
  for (; e < t; )
    e = e * 10 + 9;
  return e;
}
const iF = /* @__PURE__ */ new class extends Vo {
  constructor() {
    super(...arguments), this.elementClass = "cm-activeLineGutter";
  }
}(), oF = /* @__PURE__ */ Id.compute(["selection"], (t) => {
  let e = [], n = -1;
  for (let r of t.selection.ranges) {
    let i = t.doc.lineAt(r.head).from;
    i > n && (n = i, e.push(iF.range(i)));
  }
  return En.of(e);
});
function sF() {
  return oF;
}
const u3 = 1024;
let aF = 0;
class Cm {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}
class bn {
  /**
  Create a new node prop type.
  */
  constructor(e = {}) {
    this.id = aF++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(e) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof e != "function" && (e = fi.match(e)), (n) => {
      let r = e(n);
      return r === void 0 ? null : [this, r];
    };
  }
}
bn.closedBy = new bn({ deserialize: (t) => t.split(" ") });
bn.openedBy = new bn({ deserialize: (t) => t.split(" ") });
bn.group = new bn({ deserialize: (t) => t.split(" ") });
bn.contextHash = new bn({ perNode: !0 });
bn.lookAhead = new bn({ perNode: !0 });
bn.mounted = new bn({ perNode: !0 });
class dh {
  constructor(e, n, r) {
    this.tree = e, this.overlay = n, this.parser = r;
  }
  /**
  @internal
  */
  static get(e) {
    return e && e.props && e.props[bn.mounted.id];
  }
}
const lF = /* @__PURE__ */ Object.create(null);
class fi {
  /**
  @internal
  */
  constructor(e, n, r, i = 0) {
    this.name = e, this.props = n, this.id = r, this.flags = i;
  }
  /**
  Define a node type.
  */
  static define(e) {
    let n = e.props && e.props.length ? /* @__PURE__ */ Object.create(null) : lF, r = (e.top ? 1 : 0) | (e.skipped ? 2 : 0) | (e.error ? 4 : 0) | (e.name == null ? 8 : 0), i = new fi(e.name || "", n, e.id, r);
    if (e.props) {
      for (let o of e.props)
        if (Array.isArray(o) || (o = o(i)), o) {
          if (o[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          n[o[0].id] = o[1];
        }
    }
    return i;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(e) {
    return this.props[e.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(e) {
    if (typeof e == "string") {
      if (this.name == e)
        return !0;
      let n = this.prop(bn.group);
      return n ? n.indexOf(e) > -1 : !1;
    }
    return this.id == e;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in e)
      for (let i of r.split(" "))
        n[i] = e[r];
    return (r) => {
      for (let i = r.prop(bn.group), o = -1; o < (i ? i.length : 0); o++) {
        let s = n[o < 0 ? r.name : i[o]];
        if (s)
          return s;
      }
    };
  }
}
fi.none = new fi(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class X0 {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(e) {
    this.types = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].id != n)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...e) {
    let n = [];
    for (let r of this.types) {
      let i = null;
      for (let o of e) {
        let s = o(r);
        s && (i || (i = Object.assign({}, r.props)), i[s[0].id] = s[1]);
      }
      n.push(i ? new fi(r.name, i, r.id, r.flags) : r);
    }
    return new X0(n);
  }
}
const Kf = /* @__PURE__ */ new WeakMap(), ix = /* @__PURE__ */ new WeakMap();
var Er;
(function(t) {
  t[t.ExcludeBuffers = 1] = "ExcludeBuffers", t[t.IncludeAnonymous = 2] = "IncludeAnonymous", t[t.IgnoreMounts = 4] = "IgnoreMounts", t[t.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Er || (Er = {}));
class xr {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(e, n, r, i, o) {
    if (this.type = e, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [s, a] of o)
        this.props[typeof s == "number" ? s : s.id] = a;
    }
  }
  /**
  @internal
  */
  toString() {
    let e = dh.get(this);
    if (e && !e.overlay)
      return e.tree.toString();
    let n = "";
    for (let r of this.children) {
      let i = r.toString();
      i && (n && (n += ","), n += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(e = 0) {
    return new fv(this.topNode, e);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(e, n = 0, r = 0) {
    let i = Kf.get(this) || this.topNode, o = new fv(i);
    return o.moveTo(e, n), Kf.set(this, o._tree), o;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new Ii(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(e, n = 0) {
    let r = Iu(Kf.get(this) || this.topNode, e, n, !1);
    return Kf.set(this, r), r;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(e, n = 0) {
    let r = Iu(ix.get(this) || this.topNode, e, n, !0);
    return ix.set(this, r), r;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(e, n = 0) {
    return fF(this, e, n);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(e) {
    let { enter: n, leave: r, from: i = 0, to: o = this.length } = e, s = e.mode || 0, a = (s & Er.IncludeAnonymous) > 0;
    for (let l = this.cursor(s | Er.IncludeAnonymous); ; ) {
      let c = !1;
      if (l.from <= o && l.to >= i && (!a && l.type.isAnonymous || n(l) !== !1)) {
        if (l.firstChild())
          continue;
        c = !0;
      }
      for (; c && r && (a || !l.type.isAnonymous) && r(l), !l.nextSibling(); ) {
        if (!l.parent())
          return;
        c = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(e) {
    return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let e = [];
    if (this.props)
      for (let n in this.props)
        e.push([+n, this.props[n]]);
    return e;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(e = {}) {
    return this.children.length <= 8 ? this : t1(fi.none, this.children, this.positions, 0, this.children.length, 0, this.length, (n, r, i) => new xr(this.type, n, r, i, this.propValues), e.makeTree || ((n, r, i) => new xr(fi.none, n, r, i)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(e) {
    return dF(e);
  }
}
xr.empty = new xr(fi.none, [], [], 0);
class Z0 {
  constructor(e, n) {
    this.buffer = e, this.index = n;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new Z0(this.buffer, this.index);
  }
}
class ia {
  /**
  Create a tree buffer.
  */
  constructor(e, n, r) {
    this.buffer = e, this.length = n, this.set = r;
  }
  /**
  @internal
  */
  get type() {
    return fi.none;
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    for (let n = 0; n < this.buffer.length; )
      e.push(this.childString(n)), n = this.buffer[n + 3];
    return e.join(",");
  }
  /**
  @internal
  */
  childString(e) {
    let n = this.buffer[e], r = this.buffer[e + 3], i = this.set.types[n], o = i.name;
    if (/\W/.test(o) && !i.isError && (o = JSON.stringify(o)), e += 4, r == e)
      return o;
    let s = [];
    for (; e < r; )
      s.push(this.childString(e)), e = this.buffer[e + 3];
    return o + "(" + s.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(e, n, r, i, o) {
    let { buffer: s } = this, a = -1;
    for (let l = e; l != n && !(f3(o, i, s[l + 1], s[l + 2]) && (a = l, r > 0)); l = s[l + 3])
      ;
    return a;
  }
  /**
  @internal
  */
  slice(e, n, r) {
    let i = this.buffer, o = new Uint16Array(n - e), s = 0;
    for (let a = e, l = 0; a < n; ) {
      o[l++] = i[a++], o[l++] = i[a++] - r;
      let c = o[l++] = i[a++] - r;
      o[l++] = i[a++] - e, s = Math.max(s, c);
    }
    return new ia(o, s, this.set);
  }
}
function f3(t, e, n, r) {
  switch (t) {
    case -2:
      return n < e;
    case -1:
      return r >= e && n < e;
    case 0:
      return n < e && r > e;
    case 1:
      return n <= e && r > e;
    case 2:
      return r > e;
    case 4:
      return !0;
  }
}
function Iu(t, e, n, r) {
  for (var i; t.from == t.to || (n < 1 ? t.from >= e : t.from > e) || (n > -1 ? t.to <= e : t.to < e); ) {
    let s = !r && t instanceof Ii && t.index < 0 ? null : t.parent;
    if (!s)
      return t;
    t = s;
  }
  let o = r ? 0 : Er.IgnoreOverlays;
  if (r)
    for (let s = t, a = s.parent; a; s = a, a = s.parent)
      s instanceof Ii && s.index < 0 && ((i = a.enter(e, n, o)) === null || i === void 0 ? void 0 : i.from) != s.from && (t = a);
  for (; ; ) {
    let s = t.enter(e, n, o);
    if (!s)
      return t;
    t = s;
  }
}
class d3 {
  cursor(e = 0) {
    return new fv(this, e);
  }
  getChild(e, n = null, r = null) {
    let i = ox(this, e, n, r);
    return i.length ? i[0] : null;
  }
  getChildren(e, n = null, r = null) {
    return ox(this, e, n, r);
  }
  resolve(e, n = 0) {
    return Iu(this, e, n, !1);
  }
  resolveInner(e, n = 0) {
    return Iu(this, e, n, !0);
  }
  matchContext(e) {
    return uv(this, e);
  }
  enterUnfinishedNodesBefore(e) {
    let n = this.childBefore(e), r = this;
    for (; n; ) {
      let i = n.lastChild;
      if (!i || i.to != n.to)
        break;
      i.type.isError && i.from == i.to ? (r = n, n = i.prevSibling) : n = i;
    }
    return r;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class Ii extends d3 {
  constructor(e, n, r, i) {
    super(), this._tree = e, this.from = n, this.index = r, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(e, n, r, i, o = 0) {
    for (let s = this; ; ) {
      for (let { children: a, positions: l } = s._tree, c = n > 0 ? a.length : -1; e != c; e += n) {
        let u = a[e], f = l[e] + s.from;
        if (f3(i, r, f, f + u.length)) {
          if (u instanceof ia) {
            if (o & Er.ExcludeBuffers)
              continue;
            let d = u.findChild(0, u.buffer.length, n, r - f, i);
            if (d > -1)
              return new zs(new cF(s, u, e, f), null, d);
          } else if (o & Er.IncludeAnonymous || !u.type.isAnonymous || e1(u)) {
            let d;
            if (!(o & Er.IgnoreMounts) && (d = dh.get(u)) && !d.overlay)
              return new Ii(d.tree, f, e, s);
            let h = new Ii(u, f, e, s);
            return o & Er.IncludeAnonymous || !h.type.isAnonymous ? h : h.nextChild(n < 0 ? u.children.length - 1 : 0, n, r, i);
          }
        }
      }
      if (o & Er.IncludeAnonymous || !s.type.isAnonymous || (s.index >= 0 ? e = s.index + n : e = n < 0 ? -1 : s._parent._tree.children.length, s = s._parent, !s))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.nextChild(
      0,
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, n, r = 0) {
    let i;
    if (!(r & Er.IgnoreOverlays) && (i = dh.get(this._tree)) && i.overlay) {
      let o = e - this.from;
      for (let { from: s, to: a } of i.overlay)
        if ((n > 0 ? s <= o : s < o) && (n < 0 ? a >= o : a > o))
          return new Ii(i.tree, i.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, e, n, r);
  }
  nextSignificantParent() {
    let e = this;
    for (; e.type.isAnonymous && e._parent; )
      e = e._parent;
    return e;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function ox(t, e, n, r) {
  let i = t.cursor(), o = [];
  if (!i.firstChild())
    return o;
  if (n != null) {
    for (; !i.type.is(n); )
      if (!i.nextSibling())
        return o;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return o;
    if (i.type.is(e) && o.push(i.node), !i.nextSibling())
      return r == null ? o : [];
  }
}
function uv(t, e, n = e.length - 1) {
  for (let r = t.parent; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (e[n] && e[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
class cF {
  constructor(e, n, r, i) {
    this.parent = e, this.buffer = n, this.index = r, this.start = i;
  }
}
class zs extends d3 {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(e, n, r) {
    super(), this.context = e, this._parent = n, this.index = r, this.type = e.buffer.set.types[e.buffer.buffer[r]];
  }
  child(e, n, r) {
    let { buffer: i } = this.context, o = i.findChild(this.index + 4, i.buffer[this.index + 3], e, n - this.context.start, r);
    return o < 0 ? null : new zs(this.context, this, o);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.child(
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.child(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, n, r = 0) {
    if (r & Er.ExcludeBuffers)
      return null;
    let { buffer: i } = this.context, o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, e - this.context.start, n);
    return o < 0 ? null : new zs(this.context, this, o);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(e) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + e,
      e,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: e } = this.context, n = e.buffer[this.index + 3];
    return n < (this._parent ? e.buffer[this._parent.index + 3] : e.buffer.length) ? new zs(this.context, this._parent, n) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: e } = this.context, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new zs(this.context, this._parent, e.findChild(
      n,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let e = [], n = [], { buffer: r } = this.context, i = this.index + 4, o = r.buffer[this.index + 3];
    if (o > i) {
      let s = r.buffer[this.index + 1];
      e.push(r.slice(i, o, s)), n.push(0);
    }
    return new xr(this.type, e, n, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function h3(t) {
  if (!t.length)
    return null;
  let e = 0, n = t[0];
  for (let o = 1; o < t.length; o++) {
    let s = t[o];
    (s.from > n.from || s.to < n.to) && (n = s, e = o);
  }
  let r = n instanceof Ii && n.index < 0 ? null : n.parent, i = t.slice();
  return r ? i[e] = r : i.splice(e, 1), new uF(i, n);
}
class uF {
  constructor(e, n) {
    this.heads = e, this.node = n;
  }
  get next() {
    return h3(this.heads);
  }
}
function fF(t, e, n) {
  let r = t.resolveInner(e, n), i = null;
  for (let o = r instanceof Ii ? r : r.context.parent; o; o = o.parent)
    if (o.index < 0) {
      let s = o.parent;
      (i || (i = [r])).push(s.resolve(e, n)), o = s;
    } else {
      let s = dh.get(o.tree);
      if (s && s.overlay && s.overlay[0].from <= e && s.overlay[s.overlay.length - 1].to >= e) {
        let a = new Ii(s.tree, s.overlay[0].from + o.from, -1, o);
        (i || (i = [r])).push(Iu(a, e, n, !1));
      }
    }
  return i ? h3(i) : r;
}
class fv {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(e, n = 0) {
    if (this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, e instanceof Ii)
      this.yieldNode(e);
    else {
      this._tree = e.context.parent, this.buffer = e.context;
      for (let r = e._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = e, this.yieldBuf(e.index);
    }
  }
  yieldNode(e) {
    return e ? (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0) : !1;
  }
  yieldBuf(e, n) {
    this.index = e;
    let { start: r, buffer: i } = this.buffer;
    return this.type = n || i.set.types[i.buffer[e]], this.from = r + i.buffer[e + 1], this.to = r + i.buffer[e + 2], !0;
  }
  /**
  @internal
  */
  yield(e) {
    return e ? e instanceof Ii ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(e, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, n, r, this.mode));
    let { buffer: i } = this.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], e, n - this.buffer.start, r);
    return o < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(o));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(e) {
    return this.enterChild(
      1,
      e,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(e) {
    return this.enterChild(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(e, n, r = this.mode) {
    return this.buffer ? r & Er.ExcludeBuffers ? !1 : this.enterChild(1, e, n) : this.yield(this._tree.enter(e, n, r));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Er.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let e = this.mode & Er.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e);
  }
  /**
  @internal
  */
  sibling(e) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode)) : !1;
    let { buffer: n } = this.buffer, r = this.stack.length - 1;
    if (e < 0) {
      let i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(n.findChild(
          i,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let i = n.buffer[this.index + 3];
      if (i < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(i);
    }
    return r < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e) {
    let n, r, { buffer: i } = this;
    if (i) {
      if (e > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (let o = 0; o < this.index; o++)
          if (i.buffer.buffer[o + 3] < this.index)
            return !1;
      ({ index: n, parent: r } = i);
    } else
      ({ index: n, _parent: r } = this._tree);
    for (; r; { index: n, _parent: r } = r)
      if (n > -1)
        for (let o = n + e, s = e < 0 ? -1 : r._tree.children.length; o != s; o += e) {
          let a = r._tree.children[o];
          if (this.mode & Er.IncludeAnonymous || a instanceof ia || !a.type.isAnonymous || e1(a))
            return !1;
        }
    return !0;
  }
  move(e, n) {
    if (n && this.enterChild(
      e,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(e))
        return !0;
      if (this.atLastNode(e) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(e = !0) {
    return this.move(1, e);
  }
  /**
  Move to the next node in a last-to-first pre-order traveral. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(e = !0) {
    return this.move(-1, e);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(e, n = 0) {
    for (; (this.from == this.to || (n < 1 ? this.from >= e : this.from > e) || (n > -1 ? this.to <= e : this.to < e)) && this.parent(); )
      ;
    for (; this.enterChild(1, e, n); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let e = this.bufferNode, n = null, r = 0;
    if (e && e.context == this.buffer)
      e:
        for (let i = this.index, o = this.stack.length; o >= 0; ) {
          for (let s = e; s; s = s._parent)
            if (s.index == i) {
              if (i == this.index)
                return s;
              n = s, r = o + 1;
              break e;
            }
          i = this.stack[--o];
        }
    for (let i = r; i < this.stack.length; i++)
      n = new zs(this.buffer, n, this.stack[i]);
    return this.bufferNode = new zs(this.buffer, n, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(e, n) {
    for (let r = 0; ; ) {
      let i = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; i && n && n(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!r)
          return;
        this.parent(), r--, i = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(e) {
    if (!this.buffer)
      return uv(this.node, e);
    let { buffer: n } = this.buffer, { types: r } = n.set;
    for (let i = e.length - 1, o = this.stack.length - 1; i >= 0; o--) {
      if (o < 0)
        return uv(this.node, e, i);
      let s = r[n.buffer[this.stack[o]]];
      if (!s.isAnonymous) {
        if (e[i] && e[i] != s.name)
          return !1;
        i--;
      }
    }
    return !0;
  }
}
function e1(t) {
  return t.children.some((e) => e instanceof ia || !e.type.isAnonymous || e1(e));
}
function dF(t) {
  var e;
  let { buffer: n, nodeSet: r, maxBufferLength: i = u3, reused: o = [], minRepeatType: s = r.types.length } = t, a = Array.isArray(n) ? new Z0(n, n.length) : n, l = r.types, c = 0, u = 0;
  function f(b, j, $, N, B, O) {
    let { id: I, start: P, end: J, size: D } = a, Q = u;
    for (; D < 0; )
      if (a.next(), D == -1) {
        let M = o[I];
        $.push(M), N.push(P - b);
        return;
      } else if (D == -3) {
        c = I;
        return;
      } else if (D == -4) {
        u = I;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${D}`);
    let Z = l[I], L, R, V = P - b;
    if (J - P <= i && (R = g(a.pos - j, B))) {
      let M = new Uint16Array(R.size - R.skip), C = a.pos - R.size, F = M.length;
      for (; a.pos > C; )
        F = v(R.start, M, F);
      L = new ia(M, J - R.start, r), V = R.start - b;
    } else {
      let M = a.pos - D;
      a.next();
      let C = [], F = [], z = I >= s ? I : -1, E = 0, A = J;
      for (; a.pos > M; )
        z >= 0 && a.id == z && a.size >= 0 ? (a.end <= A - i && (p(C, F, P, E, a.end, A, z, Q), E = C.length, A = a.end), a.next()) : O > 2500 ? d(P, M, C, F) : f(P, M, C, F, z, O + 1);
      if (z >= 0 && E > 0 && E < C.length && p(C, F, P, E, P, A, z, Q), C.reverse(), F.reverse(), z > -1 && E > 0) {
        let te = h(Z);
        L = t1(Z, C, F, 0, C.length, 0, J - P, te, te);
      } else
        L = m(Z, C, F, J - P, Q - J);
    }
    $.push(L), N.push(V);
  }
  function d(b, j, $, N) {
    let B = [], O = 0, I = -1;
    for (; a.pos > j; ) {
      let { id: P, start: J, end: D, size: Q } = a;
      if (Q > 4)
        a.next();
      else {
        if (I > -1 && J < I)
          break;
        I < 0 && (I = D - i), B.push(P, J, D), O++, a.next();
      }
    }
    if (O) {
      let P = new Uint16Array(O * 4), J = B[B.length - 2];
      for (let D = B.length - 3, Q = 0; D >= 0; D -= 3)
        P[Q++] = B[D], P[Q++] = B[D + 1] - J, P[Q++] = B[D + 2] - J, P[Q++] = Q;
      $.push(new ia(P, B[2] - J, r)), N.push(J - b);
    }
  }
  function h(b) {
    return (j, $, N) => {
      let B = 0, O = j.length - 1, I, P;
      if (O >= 0 && (I = j[O]) instanceof xr) {
        if (!O && I.type == b && I.length == N)
          return I;
        (P = I.prop(bn.lookAhead)) && (B = $[O] + I.length + P);
      }
      return m(b, j, $, N, B);
    };
  }
  function p(b, j, $, N, B, O, I, P) {
    let J = [], D = [];
    for (; b.length > N; )
      J.push(b.pop()), D.push(j.pop() + $ - B);
    b.push(m(r.types[I], J, D, O - B, P - O)), j.push(B - $);
  }
  function m(b, j, $, N, B = 0, O) {
    if (c) {
      let I = [bn.contextHash, c];
      O = O ? [I].concat(O) : [I];
    }
    if (B > 25) {
      let I = [bn.lookAhead, B];
      O = O ? [I].concat(O) : [I];
    }
    return new xr(b, j, $, N, O);
  }
  function g(b, j) {
    let $ = a.fork(), N = 0, B = 0, O = 0, I = $.end - i, P = { size: 0, start: 0, skip: 0 };
    e:
      for (let J = $.pos - b; $.pos > J; ) {
        let D = $.size;
        if ($.id == j && D >= 0) {
          P.size = N, P.start = B, P.skip = O, O += 4, N += 4, $.next();
          continue;
        }
        let Q = $.pos - D;
        if (D < 0 || Q < J || $.start < I)
          break;
        let Z = $.id >= s ? 4 : 0, L = $.start;
        for ($.next(); $.pos > Q; ) {
          if ($.size < 0)
            if ($.size == -3)
              Z += 4;
            else
              break e;
          else
            $.id >= s && (Z += 4);
          $.next();
        }
        B = L, N += D, O += Z;
      }
    return (j < 0 || N == b) && (P.size = N, P.start = B, P.skip = O), P.size > 4 ? P : void 0;
  }
  function v(b, j, $) {
    let { id: N, start: B, end: O, size: I } = a;
    if (a.next(), I >= 0 && N < s) {
      let P = $;
      if (I > 4) {
        let J = a.pos - (I - 4);
        for (; a.pos > J; )
          $ = v(b, j, $);
      }
      j[--$] = P, j[--$] = O - b, j[--$] = B - b, j[--$] = N;
    } else
      I == -3 ? c = N : I == -4 && (u = N);
    return $;
  }
  let y = [], w = [];
  for (; a.pos > 0; )
    f(t.start || 0, t.bufferStart || 0, y, w, -1, 0);
  let x = (e = t.length) !== null && e !== void 0 ? e : y.length ? w[0] + y[0].length : 0;
  return new xr(l[t.topID], y.reverse(), w.reverse(), x);
}
const sx = /* @__PURE__ */ new WeakMap();
function Dd(t, e) {
  if (!t.isAnonymous || e instanceof ia || e.type != t)
    return 1;
  let n = sx.get(e);
  if (n == null) {
    n = 1;
    for (let r of e.children) {
      if (r.type != t || !(r instanceof xr)) {
        n = 1;
        break;
      }
      n += Dd(t, r);
    }
    sx.set(e, n);
  }
  return n;
}
function t1(t, e, n, r, i, o, s, a, l) {
  let c = 0;
  for (let p = r; p < i; p++)
    c += Dd(t, e[p]);
  let u = Math.ceil(
    c * 1.5 / 8
    /* Balance.BranchFactor */
  ), f = [], d = [];
  function h(p, m, g, v, y) {
    for (let w = g; w < v; ) {
      let x = w, b = m[w], j = Dd(t, p[w]);
      for (w++; w < v; w++) {
        let $ = Dd(t, p[w]);
        if (j + $ >= u)
          break;
        j += $;
      }
      if (w == x + 1) {
        if (j > u) {
          let $ = p[x];
          h($.children, $.positions, 0, $.children.length, m[x] + y);
          continue;
        }
        f.push(p[x]);
      } else {
        let $ = m[w - 1] + p[w - 1].length - b;
        f.push(t1(t, p, m, x, w, b, $, null, l));
      }
      d.push(b + y - o);
    }
  }
  return h(e, n, r, i, 0), (a || l)(f, d, s);
}
class Ra {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(e, n, r, i, o = !1, s = !1) {
    this.from = e, this.to = n, this.tree = r, this.offset = i, this.open = (o ? 1 : 0) | (s ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(e, n = [], r = !1) {
    let i = [new Ra(0, e.length, e, 0, !1, r)];
    for (let o of n)
      o.to > e.length && i.push(o);
    return i;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(e, n, r = 128) {
    if (!n.length)
      return e;
    let i = [], o = 1, s = e.length ? e[0] : null;
    for (let a = 0, l = 0, c = 0; ; a++) {
      let u = a < n.length ? n[a] : null, f = u ? u.fromA : 1e9;
      if (f - l >= r)
        for (; s && s.from < f; ) {
          let d = s;
          if (l >= d.from || f <= d.to || c) {
            let h = Math.max(d.from, l) - c, p = Math.min(d.to, f) - c;
            d = h >= p ? null : new Ra(h, p, d.tree, d.offset + c, a > 0, !!u);
          }
          if (d && i.push(d), s.to > f)
            break;
          s = o < e.length ? e[o++] : null;
        }
      if (!u)
        break;
      l = u.toA, c = u.toA - u.toB;
    }
    return i;
  }
}
class p3 {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(e, n, r) {
    return typeof e == "string" && (e = new hF(e)), r = r ? r.length ? r.map((i) => new Cm(i.from, i.to)) : [new Cm(0, 0)] : [new Cm(0, e.length)], this.createParse(e, n || [], r);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(e, n, r) {
    let i = this.startParse(e, n, r);
    for (; ; ) {
      let o = i.advance();
      if (o)
        return o;
    }
  }
}
class hF {
  constructor(e) {
    this.string = e;
  }
  get length() {
    return this.string.length;
  }
  chunk(e) {
    return this.string.slice(e);
  }
  get lineChunks() {
    return !1;
  }
  read(e, n) {
    return this.string.slice(e, n);
  }
}
new bn({ perNode: !0 });
let pF = 0;
class Eo {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.set = e, this.base = n, this.modified = r, this.id = pF++;
  }
  /**
  Define a new tag. If `parent` is given, the tag is treated as a
  sub-tag of that parent, and
  [highlighters](#highlight.tagHighlighter) that don't mention
  this tag will try to fall back to the parent tag (or grandparent
  tag, etc).
  */
  static define(e) {
    if (e != null && e.base)
      throw new Error("Can not derive from a modified tag");
    let n = new Eo([], null, []);
    if (n.set.push(n), e)
      for (let r of e.set)
        n.set.push(r);
    return n;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier() {
    let e = new hh();
    return (n) => n.modified.indexOf(e) > -1 ? n : hh.get(n.base || n, n.modified.concat(e).sort((r, i) => r.id - i.id));
  }
}
let mF = 0;
class hh {
  constructor() {
    this.instances = [], this.id = mF++;
  }
  static get(e, n) {
    if (!n.length)
      return e;
    let r = n[0].instances.find((a) => a.base == e && gF(n, a.modified));
    if (r)
      return r;
    let i = [], o = new Eo(i, e, n);
    for (let a of n)
      a.instances.push(o);
    let s = vF(n);
    for (let a of e.set)
      if (!a.modified.length)
        for (let l of s)
          i.push(hh.get(a, l));
    return o;
  }
}
function gF(t, e) {
  return t.length == e.length && t.every((n, r) => n == e[r]);
}
function vF(t) {
  let e = [[]];
  for (let n = 0; n < t.length; n++)
    for (let r = 0, i = e.length; r < i; r++)
      e.push(e[r].concat(t[n]));
  return e.sort((n, r) => r.length - n.length);
}
function m3(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    Array.isArray(r) || (r = [r]);
    for (let i of n.split(" "))
      if (i) {
        let o = [], s = 2, a = i;
        for (let f = 0; ; ) {
          if (a == "..." && f > 0 && f + 3 == i.length) {
            s = 1;
            break;
          }
          let d = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(a);
          if (!d)
            throw new RangeError("Invalid path: " + i);
          if (o.push(d[0] == "*" ? "" : d[0][0] == '"' ? JSON.parse(d[0]) : d[0]), f += d[0].length, f == i.length)
            break;
          let h = i[f++];
          if (f == i.length && h == "!") {
            s = 0;
            break;
          }
          if (h != "/")
            throw new RangeError("Invalid path: " + i);
          a = i.slice(f);
        }
        let l = o.length - 1, c = o[l];
        if (!c)
          throw new RangeError("Invalid path: " + i);
        let u = new ph(r, s, l > 0 ? o.slice(0, l) : null);
        e[c] = u.sort(e[c]);
      }
  }
  return g3.add(e);
}
const g3 = new bn();
class ph {
  constructor(e, n, r, i) {
    this.tags = e, this.mode = n, this.context = r, this.next = i;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(e) {
    return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
ph.empty = new ph([], 2, null);
function v3(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let o of t)
    if (!Array.isArray(o.tag))
      n[o.tag.id] = o.class;
    else
      for (let s of o.tag)
        n[s.id] = o.class;
  let { scope: r, all: i = null } = e || {};
  return {
    style: (o) => {
      let s = i;
      for (let a of o)
        for (let l of a.set) {
          let c = n[l.id];
          if (c) {
            s = s ? s + " " + c : c;
            break;
          }
        }
      return s;
    },
    scope: r
  };
}
function yF(t, e) {
  let n = null;
  for (let r of t) {
    let i = r.style(e);
    i && (n = n ? n + " " + i : i);
  }
  return n;
}
function bF(t, e, n, r = 0, i = t.length) {
  let o = new xF(r, Array.isArray(e) ? e : [e], n);
  o.highlightRange(t.cursor(), r, i, "", o.highlighters), o.flush(i);
}
class xF {
  constructor(e, n, r) {
    this.at = e, this.highlighters = n, this.span = r, this.class = "";
  }
  startSpan(e, n) {
    n != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = n);
  }
  flush(e) {
    e > this.at && this.class && this.span(this.at, e, this.class);
  }
  highlightRange(e, n, r, i, o) {
    let { type: s, from: a, to: l } = e;
    if (a >= r || l <= n)
      return;
    s.isTop && (o = this.highlighters.filter((h) => !h.scope || h.scope(s)));
    let c = i, u = wF(e) || ph.empty, f = yF(o, u.tags);
    if (f && (c && (c += " "), c += f, u.mode == 1 && (i += (i ? " " : "") + f)), this.startSpan(Math.max(n, a), c), u.opaque)
      return;
    let d = e.tree && e.tree.prop(bn.mounted);
    if (d && d.overlay) {
      let h = e.node.enter(d.overlay[0].from + a, 1), p = this.highlighters.filter((g) => !g.scope || g.scope(d.tree.type)), m = e.firstChild();
      for (let g = 0, v = a; ; g++) {
        let y = g < d.overlay.length ? d.overlay[g] : null, w = y ? y.from + a : l, x = Math.max(n, v), b = Math.min(r, w);
        if (x < b && m)
          for (; e.from < b && (this.highlightRange(e, x, b, i, o), this.startSpan(Math.min(b, e.to), c), !(e.to >= w || !e.nextSibling())); )
            ;
        if (!y || w > r)
          break;
        v = y.to + a, v > n && (this.highlightRange(h.cursor(), Math.max(n, y.from + a), Math.min(r, v), "", p), this.startSpan(Math.min(r, v), c));
      }
      m && e.parent();
    } else if (e.firstChild()) {
      d && (i = "");
      do
        if (!(e.to <= n)) {
          if (e.from >= r)
            break;
          this.highlightRange(e, n, r, i, o), this.startSpan(Math.min(r, e.to), c);
        }
      while (e.nextSibling());
      e.parent();
    }
  }
}
function wF(t) {
  let e = t.type.prop(g3);
  for (; e && e.context && !t.matchContext(e.context); )
    e = e.next;
  return e || null;
}
const et = Eo.define, Gf = et(), Ms = et(), ax = et(Ms), lx = et(Ms), _s = et(), Qf = et(_s), Om = et(_s), Co = et(), va = et(Co), wo = et(), jo = et(), dv = et(), Rc = et(dv), Yf = et(), Ze = {
  /**
  A comment.
  */
  comment: Gf,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: et(Gf),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: et(Gf),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: et(Gf),
  /**
  Any kind of identifier.
  */
  name: Ms,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: et(Ms),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: ax,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: et(ax),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: lx,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: et(lx),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: et(Ms),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: et(Ms),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: et(Ms),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: et(Ms),
  /**
  A literal value.
  */
  literal: _s,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: Qf,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: et(Qf),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: et(Qf),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: et(Qf),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: Om,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: et(Om),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: et(Om),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: et(_s),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: et(_s),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: et(_s),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: et(_s),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: et(_s),
  /**
  A language keyword.
  */
  keyword: wo,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: et(wo),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: et(wo),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: et(wo),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: et(wo),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: et(wo),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: et(wo),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: et(wo),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: et(wo),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: et(wo),
  /**
  An operator.
  */
  operator: jo,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: et(jo),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: et(jo),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: et(jo),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: et(jo),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: et(jo),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: et(jo),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: et(jo),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: et(jo),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: et(jo),
  /**
  Program or markup punctuation.
  */
  punctuation: dv,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: et(dv),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: Rc,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: et(Rc),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: et(Rc),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: et(Rc),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: et(Rc),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: Co,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: va,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: et(va),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: et(va),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: et(va),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: et(va),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: et(va),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: et(va),
  /**
  A prose separator (such as a horizontal rule).
  */
  contentSeparator: et(Co),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: et(Co),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: et(Co),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: et(Co),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: et(Co),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: et(Co),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: et(Co),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: et(Co),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: et(),
  /**
  Deleted text.
  */
  deleted: et(),
  /**
  Changed text.
  */
  changed: et(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: et(),
  /**
  Metadata or meta-instruction.
  */
  meta: Yf,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: et(Yf),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: et(Yf),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: et(Yf),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: Eo.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: Eo.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: Eo.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: Eo.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: Eo.defineModifier(),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: Eo.defineModifier()
};
v3([
  { tag: Ze.link, class: "tok-link" },
  { tag: Ze.heading, class: "tok-heading" },
  { tag: Ze.emphasis, class: "tok-emphasis" },
  { tag: Ze.strong, class: "tok-strong" },
  { tag: Ze.keyword, class: "tok-keyword" },
  { tag: Ze.atom, class: "tok-atom" },
  { tag: Ze.bool, class: "tok-bool" },
  { tag: Ze.url, class: "tok-url" },
  { tag: Ze.labelName, class: "tok-labelName" },
  { tag: Ze.inserted, class: "tok-inserted" },
  { tag: Ze.deleted, class: "tok-deleted" },
  { tag: Ze.literal, class: "tok-literal" },
  { tag: Ze.string, class: "tok-string" },
  { tag: Ze.number, class: "tok-number" },
  { tag: [Ze.regexp, Ze.escape, Ze.special(Ze.string)], class: "tok-string2" },
  { tag: Ze.variableName, class: "tok-variableName" },
  { tag: Ze.local(Ze.variableName), class: "tok-variableName tok-local" },
  { tag: Ze.definition(Ze.variableName), class: "tok-variableName tok-definition" },
  { tag: Ze.special(Ze.variableName), class: "tok-variableName2" },
  { tag: Ze.definition(Ze.propertyName), class: "tok-propertyName tok-definition" },
  { tag: Ze.typeName, class: "tok-typeName" },
  { tag: Ze.namespace, class: "tok-namespace" },
  { tag: Ze.className, class: "tok-className" },
  { tag: Ze.macroName, class: "tok-macroName" },
  { tag: Ze.propertyName, class: "tok-propertyName" },
  { tag: Ze.operator, class: "tok-operator" },
  { tag: Ze.comment, class: "tok-comment" },
  { tag: Ze.meta, class: "tok-meta" },
  { tag: Ze.invalid, class: "tok-invalid" },
  { tag: Ze.punctuation, class: "tok-punctuation" }
]);
var Em;
const Sl = /* @__PURE__ */ new bn();
function jF(t) {
  return vt.define({
    combine: t ? (e) => e.concat(t) : void 0
  });
}
const kF = /* @__PURE__ */ new bn();
class io {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(e, n, r = [], i = "") {
    this.data = e, this.name = i, gn.prototype.hasOwnProperty("tree") || Object.defineProperty(gn.prototype, "tree", { get() {
      return Zr(this);
    } }), this.parser = n, this.extension = [
      oa.of(this),
      gn.languageData.of((o, s, a) => {
        let l = cx(o, s, a), c = l.type.prop(Sl);
        if (!c)
          return [];
        let u = o.facet(c), f = l.type.prop(kF);
        if (f) {
          let d = l.resolve(s - l.from, a);
          for (let h of f)
            if (h.test(d, o)) {
              let p = o.facet(h.facet);
              return h.type == "replace" ? p : p.concat(u);
            }
        }
        return u;
      })
    ].concat(r);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(e, n, r = -1) {
    return cx(e, n, r).type.prop(Sl) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(e) {
    let n = e.facet(oa);
    if ((n == null ? void 0 : n.data) == this.data)
      return [{ from: 0, to: e.doc.length }];
    if (!n || !n.allowsNesting)
      return [];
    let r = [], i = (o, s) => {
      if (o.prop(Sl) == this.data) {
        r.push({ from: s, to: s + o.length });
        return;
      }
      let a = o.prop(bn.mounted);
      if (a) {
        if (a.tree.prop(Sl) == this.data) {
          if (a.overlay)
            for (let l of a.overlay)
              r.push({ from: l.from + s, to: l.to + s });
          else
            r.push({ from: s, to: s + o.length });
          return;
        } else if (a.overlay) {
          let l = r.length;
          if (i(a.tree, a.overlay[0].from + s), r.length > l)
            return;
        }
      }
      for (let l = 0; l < o.children.length; l++) {
        let c = o.children[l];
        c instanceof xr && i(c, o.positions[l] + s);
      }
    };
    return i(Zr(e), 0), r;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}
io.setState = /* @__PURE__ */ ln.define();
function cx(t, e, n) {
  let r = t.facet(oa), i = Zr(t).topNode;
  if (!r || r.allowsNesting)
    for (let o = i; o; o = o.enter(e, n, Er.ExcludeBuffers))
      o.type.isTop && (i = o);
  return i;
}
class mh extends io {
  constructor(e, n, r) {
    super(e, n, [], r), this.parser = n;
  }
  /**
  Define a language from a parser.
  */
  static define(e) {
    let n = jF(e.languageData);
    return new mh(n, e.parser.configure({
      props: [Sl.add((r) => r.isTop ? n : void 0)]
    }), e.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(e, n) {
    return new mh(this.data, this.parser.configure(e), n || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function Zr(t) {
  let e = t.field(io.state, !1);
  return e ? e.tree : xr.empty;
}
class $F {
  /**
  Create an input object for the given document.
  */
  constructor(e) {
    this.doc = e, this.cursorPos = 0, this.string = "", this.cursor = e.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(e) {
    return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(e) {
    return this.syncTo(e), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(e, n) {
    let r = this.cursorPos - this.string.length;
    return e < r || n >= this.cursorPos ? this.doc.sliceString(e, n) : this.string.slice(e - r, n - r);
  }
}
let Nc = null;
class gh {
  constructor(e, n, r = [], i, o, s, a, l) {
    this.parser = e, this.state = n, this.fragments = r, this.tree = i, this.treeLen = o, this.viewport = s, this.skipped = a, this.scheduleOn = l, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new gh(e, n, [], xr.empty, 0, r, [], null);
  }
  startParse() {
    return this.parser.startParse(new $F(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(e, n) {
    return n != null && n >= this.state.doc.length && (n = void 0), this.tree != xr.empty && this.isDone(n ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var r;
      if (typeof e == "number") {
        let i = Date.now() + e;
        e = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), n != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > n) && n < this.state.doc.length && this.parse.stopAt(n); ; ) {
        let i = this.parse.advance();
        if (i)
          if (this.fragments = this.withoutTempSkipped(Ra.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r = this.parse.stoppedAt) !== null && r !== void 0 ? r : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (n ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (e())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let e, n;
    this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(() => {
      for (; !(n = this.parse.advance()); )
        ;
    }), this.treeLen = e, this.tree = n, this.fragments = this.withoutTempSkipped(Ra.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(e) {
    let n = Nc;
    Nc = this;
    try {
      return e();
    } finally {
      Nc = n;
    }
  }
  withoutTempSkipped(e) {
    for (let n; n = this.tempSkipped.pop(); )
      e = ux(e, n.from, n.to);
    return e;
  }
  /**
  @internal
  */
  changes(e, n) {
    let { fragments: r, tree: i, treeLen: o, viewport: s, skipped: a } = this;
    if (this.takeTree(), !e.empty) {
      let l = [];
      if (e.iterChangedRanges((c, u, f, d) => l.push({ fromA: c, toA: u, fromB: f, toB: d })), r = Ra.applyChanges(r, l), i = xr.empty, o = 0, s = { from: e.mapPos(s.from, -1), to: e.mapPos(s.to, 1) }, this.skipped.length) {
        a = [];
        for (let c of this.skipped) {
          let u = e.mapPos(c.from, 1), f = e.mapPos(c.to, -1);
          u < f && a.push({ from: u, to: f });
        }
      }
    }
    return new gh(this.parser, n, r, i, o, s, a, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(e) {
    if (this.viewport.from == e.from && this.viewport.to == e.to)
      return !1;
    this.viewport = e;
    let n = this.skipped.length;
    for (let r = 0; r < this.skipped.length; r++) {
      let { from: i, to: o } = this.skipped[r];
      i < e.to && o > e.from && (this.fragments = ux(this.fragments, i, o), this.skipped.splice(r--, 1));
    }
    return this.skipped.length >= n ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(e, n) {
    this.skipped.push({ from: e, to: n });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(e) {
    return new class extends p3 {
      createParse(n, r, i) {
        let o = i[0].from, s = i[i.length - 1].to;
        return {
          parsedPos: o,
          advance() {
            let l = Nc;
            if (l) {
              for (let c of i)
                l.tempSkipped.push(c);
              e && (l.scheduleOn = l.scheduleOn ? Promise.all([l.scheduleOn, e]) : e);
            }
            return this.parsedPos = s, new xr(fi.none, [], [], s - o);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(e) {
    e = Math.min(e, this.state.doc.length);
    let n = this.fragments;
    return this.treeLen >= e && n.length && n[0].from == 0 && n[0].to >= e;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return Nc;
  }
}
function ux(t, e, n) {
  return Ra.applyChanges(t, [{ fromA: e, toA: n, fromB: e, toB: n }]);
}
class Xl {
  constructor(e) {
    this.context = e, this.tree = e.tree;
  }
  apply(e) {
    if (!e.docChanged && this.tree == this.context.tree)
      return this;
    let n = this.context.changes(e.changes, e.state), r = this.context.treeLen == e.startState.doc.length ? void 0 : Math.max(e.changes.mapPos(this.context.treeLen), n.viewport.to);
    return n.work(20, r) || n.takeTree(), new Xl(n);
  }
  static init(e) {
    let n = Math.min(3e3, e.doc.length), r = gh.create(e.facet(oa).parser, e, { from: 0, to: n });
    return r.work(20, n) || r.takeTree(), new Xl(r);
  }
}
io.state = /* @__PURE__ */ Cr.define({
  create: Xl.init,
  update(t, e) {
    for (let n of e.effects)
      if (n.is(io.setState))
        return n.value;
    return e.startState.facet(oa) != e.state.facet(oa) ? Xl.init(e.state) : t.apply(e);
  }
});
let y3 = (t) => {
  let e = setTimeout(
    () => t(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(e);
};
typeof requestIdleCallback < "u" && (y3 = (t) => {
  let e = -1, n = setTimeout(
    () => {
      e = requestIdleCallback(t, {
        timeout: 400
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => e < 0 ? clearTimeout(n) : cancelIdleCallback(e);
});
const Am = typeof navigator < "u" && (!((Em = navigator.scheduling) === null || Em === void 0) && Em.isInputPending) ? () => navigator.scheduling.isInputPending() : null, SF = /* @__PURE__ */ ur.fromClass(class {
  constructor(e) {
    this.view = e, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(e) {
    let n = this.view.state.field(io.state).context;
    (n.updateViewport(e.view.viewport) || this.view.viewport.to > n.treeLen) && this.scheduleWork(), (e.docChanged || e.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(n);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: e } = this.view, n = e.field(io.state);
    (n.tree != n.context.tree || !n.context.isDone(e.doc.length)) && (this.working = y3(this.work));
  }
  work(e) {
    this.working = null;
    let n = Date.now();
    if (this.chunkEnd < n && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = n + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: r, viewport: { to: i } } = this.view, o = r.field(io.state);
    if (o.tree == o.context.tree && o.context.isDone(
      i + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let s = Date.now() + Math.min(this.chunkBudget, 100, e && !Am ? Math.max(25, e.timeRemaining() - 5) : 1e9), a = o.context.treeLen < i && r.doc.length > i + 1e3, l = o.context.work(() => Am && Am() || Date.now() > s, i + (a ? 0 : 1e5));
    this.chunkBudget -= Date.now() - n, (l || this.chunkBudget <= 0) && (o.context.takeTree(), this.view.dispatch({ effects: io.setState.of(new Xl(o.context)) })), this.chunkBudget > 0 && !(l && !a) && this.scheduleWork(), this.checkAsyncSchedule(o.context);
  }
  checkAsyncSchedule(e) {
    e.scheduleOn && (this.workScheduled++, e.scheduleOn.then(() => this.scheduleWork()).catch((n) => $i(this.view.state, n)).then(() => this.workScheduled--), e.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), oa = /* @__PURE__ */ vt.define({
  combine(t) {
    return t.length ? t[0] : null;
  },
  enables: (t) => [
    io.state,
    SF,
    at.contentAttributes.compute([t], (e) => {
      let n = e.facet(t);
      return n && n.name ? { "data-language": n.name } : {};
    })
  ]
});
class CF {
  /**
  Create a language support object.
  */
  constructor(e, n = []) {
    this.language = e, this.support = n, this.extension = [e, n];
  }
}
const OF = /* @__PURE__ */ vt.define(), Cp = /* @__PURE__ */ vt.define({
  combine: (t) => {
    if (!t.length)
      return "  ";
    let e = t[0];
    if (!e || /\S/.test(e) || Array.from(e).some((n) => n != e[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(t[0]));
    return e;
  }
});
function sa(t) {
  let e = t.facet(Cp);
  return e.charCodeAt(0) == 9 ? t.tabSize * e.length : e.length;
}
function Du(t, e) {
  let n = "", r = t.tabSize, i = t.facet(Cp)[0];
  if (i == "	") {
    for (; e >= r; )
      n += "	", e -= r;
    i = " ";
  }
  for (let o = 0; o < e; o++)
    n += i;
  return n;
}
function n1(t, e) {
  t instanceof gn && (t = new Op(t));
  for (let r of t.state.facet(OF)) {
    let i = r(t, e);
    if (i !== void 0)
      return i;
  }
  let n = Zr(t.state);
  return n.length >= e ? EF(t, n, e) : null;
}
class Op {
  /**
  Create an indent context.
  */
  constructor(e, n = {}) {
    this.state = e, this.options = n, this.unit = sa(e);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(e, n = 1) {
    let r = this.state.doc.lineAt(e), { simulateBreak: i, simulateDoubleBreak: o } = this.options;
    return i != null && i >= r.from && i <= r.to ? o && i == e ? { text: "", from: e } : (n < 0 ? i < e : i <= e) ? { text: r.text.slice(i - r.from), from: i } : { text: r.text.slice(0, i - r.from), from: r.from } : r;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(e, n = 1) {
    if (this.options.simulateDoubleBreak && e == this.options.simulateBreak)
      return "";
    let { text: r, from: i } = this.lineAt(e, n);
    return r.slice(e - i, Math.min(r.length, e + 100 - i));
  }
  /**
  Find the column for the given position.
  */
  column(e, n = 1) {
    let { text: r, from: i } = this.lineAt(e, n), o = this.countColumn(r, e - i), s = this.options.overrideIndentation ? this.options.overrideIndentation(i) : -1;
    return s > -1 && (o += s - this.countColumn(r, r.search(/\S|$/))), o;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(e, n = e.length) {
    return yc(e, this.state.tabSize, n);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(e, n = 1) {
    let { text: r, from: i } = this.lineAt(e, n), o = this.options.overrideIndentation;
    if (o) {
      let s = o(i);
      if (s > -1)
        return s;
    }
    return this.countColumn(r, r.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const b3 = /* @__PURE__ */ new bn();
function EF(t, e, n) {
  let r = e.resolveStack(n), i = r.node.enterUnfinishedNodesBefore(n);
  if (i != r.node) {
    let o = [];
    for (let s = i; s != r.node; s = s.parent)
      o.push(s);
    for (let s = o.length - 1; s >= 0; s--)
      r = { node: o[s], next: r };
  }
  return x3(r, t, n);
}
function x3(t, e, n) {
  for (let r = t; r; r = r.next) {
    let i = MF(r.node);
    if (i)
      return i(r1.create(e, n, r));
  }
  return 0;
}
function AF(t) {
  return t.pos == t.options.simulateBreak && t.options.simulateDoubleBreak;
}
function MF(t) {
  let e = t.type.prop(b3);
  if (e)
    return e;
  let n = t.firstChild, r;
  if (n && (r = n.type.prop(bn.closedBy))) {
    let i = t.lastChild, o = i && r.indexOf(i.name) > -1;
    return (s) => RF(s, !0, 1, void 0, o && !AF(s) ? i.from : void 0);
  }
  return t.parent == null ? _F : null;
}
function _F() {
  return 0;
}
class r1 extends Op {
  constructor(e, n, r) {
    super(e.state, e.options), this.base = e, this.pos = n, this.context = r;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new r1(e, n, r);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(e) {
    let n = this.state.doc.lineAt(e.from);
    for (; ; ) {
      let r = e.resolve(n.from);
      for (; r.parent && r.parent.from == r.from; )
        r = r.parent;
      if (TF(r, e))
        break;
      n = this.state.doc.lineAt(r.from);
    }
    return this.lineIndent(n.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return x3(this.context.next, this.base, this.pos);
  }
}
function TF(t, e) {
  for (let n = e; n; n = n.parent)
    if (t == n)
      return !0;
  return !1;
}
function PF(t) {
  let e = t.node, n = e.childAfter(e.from), r = e.lastChild;
  if (!n)
    return null;
  let i = t.options.simulateBreak, o = t.state.doc.lineAt(n.from), s = i == null || i <= o.from ? o.to : Math.min(o.to, i);
  for (let a = n.to; ; ) {
    let l = e.childAfter(a);
    if (!l || l == r)
      return null;
    if (!l.type.isSkipped)
      return l.from < s ? n : null;
    a = l.to;
  }
}
function RF(t, e, n, r, i) {
  let o = t.textAfter, s = o.match(/^\s*/)[0].length, a = r && o.slice(s, s + r.length) == r || i == t.pos + s, l = e ? PF(t) : null;
  return l ? a ? t.column(l.from) : t.column(l.to) : t.baseIndent + (a ? 0 : t.unit * n);
}
function fx({ except: t, units: e = 1 } = {}) {
  return (n) => {
    let r = t && t.test(n.textAfter);
    return n.baseIndent + (r ? 0 : e * n.unit);
  };
}
const NF = 200;
function IF() {
  return gn.transactionFilter.of((t) => {
    if (!t.docChanged || !t.isUserEvent("input.type") && !t.isUserEvent("input.complete"))
      return t;
    let e = t.startState.languageDataAt("indentOnInput", t.startState.selection.main.head);
    if (!e.length)
      return t;
    let n = t.newDoc, { head: r } = t.newSelection.main, i = n.lineAt(r);
    if (r > i.from + NF)
      return t;
    let o = n.sliceString(i.from, r);
    if (!e.some((c) => c.test(o)))
      return t;
    let { state: s } = t, a = -1, l = [];
    for (let { head: c } of s.selection.ranges) {
      let u = s.doc.lineAt(c);
      if (u.from == a)
        continue;
      a = u.from;
      let f = n1(s, u.from);
      if (f == null)
        continue;
      let d = /^\s*/.exec(u.text)[0], h = Du(s, f);
      d != h && l.push({ from: u.from, to: u.from + d.length, insert: h });
    }
    return l.length ? [t, { changes: l, sequential: !0 }] : t;
  });
}
const DF = /* @__PURE__ */ vt.define(), w3 = /* @__PURE__ */ new bn();
function LF(t) {
  let e = t.firstChild, n = t.lastChild;
  return e && e.to < n.from ? { from: e.to, to: n.type.isError ? t.to : n.from } : null;
}
function BF(t, e, n) {
  let r = Zr(t);
  if (r.length < n)
    return null;
  let i = r.resolveStack(n, 1), o = null;
  for (let s = i; s; s = s.next) {
    let a = s.node;
    if (a.to <= n || a.from > n)
      continue;
    if (o && a.from < e)
      break;
    let l = a.type.prop(w3);
    if (l && (a.to < r.length - 50 || r.length == t.doc.length || !qF(a))) {
      let c = l(a, t);
      c && c.from <= n && c.from >= e && c.to > n && (o = c);
    }
  }
  return o;
}
function qF(t) {
  let e = t.lastChild;
  return e && e.to == t.to && e.type.isError;
}
function vh(t, e, n) {
  for (let r of t.facet(DF)) {
    let i = r(t, e, n);
    if (i)
      return i;
  }
  return BF(t, e, n);
}
function j3(t, e) {
  let n = e.mapPos(t.from, 1), r = e.mapPos(t.to, -1);
  return n >= r ? void 0 : { from: n, to: r };
}
const Ep = /* @__PURE__ */ ln.define({ map: j3 }), af = /* @__PURE__ */ ln.define({ map: j3 });
function k3(t) {
  let e = [];
  for (let { head: n } of t.state.selection.ranges)
    e.some((r) => r.from <= n && r.to >= n) || e.push(t.lineBlockAt(n));
  return e;
}
const Va = /* @__PURE__ */ Cr.define({
  create() {
    return Bt.none;
  },
  update(t, e) {
    t = t.map(e.changes);
    for (let n of e.effects)
      if (n.is(Ep) && !zF(t, n.value.from, n.value.to)) {
        let { preparePlaceholder: r } = e.state.facet(i1), i = r ? Bt.replace({ widget: new KF(r(e.state, n.value)) }) : dx;
        t = t.update({ add: [i.range(n.value.from, n.value.to)] });
      } else
        n.is(af) && (t = t.update({
          filter: (r, i) => n.value.from != r || n.value.to != i,
          filterFrom: n.value.from,
          filterTo: n.value.to
        }));
    if (e.selection) {
      let n = !1, { head: r } = e.selection.main;
      t.between(r, r, (i, o) => {
        i < r && o > r && (n = !0);
      }), n && (t = t.update({
        filterFrom: r,
        filterTo: r,
        filter: (i, o) => o <= r || i >= r
      }));
    }
    return t;
  },
  provide: (t) => at.decorations.from(t),
  toJSON(t, e) {
    let n = [];
    return t.between(0, e.doc.length, (r, i) => {
      n.push(r, i);
    }), n;
  },
  fromJSON(t) {
    if (!Array.isArray(t) || t.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let e = [];
    for (let n = 0; n < t.length; ) {
      let r = t[n++], i = t[n++];
      if (typeof r != "number" || typeof i != "number")
        throw new RangeError("Invalid JSON for fold state");
      e.push(dx.range(r, i));
    }
    return Bt.set(e, !0);
  }
});
function yh(t, e, n) {
  var r;
  let i = null;
  return (r = t.field(Va, !1)) === null || r === void 0 || r.between(e, n, (o, s) => {
    (!i || i.from > o) && (i = { from: o, to: s });
  }), i;
}
function zF(t, e, n) {
  let r = !1;
  return t.between(e, e, (i, o) => {
    i == e && o == n && (r = !0);
  }), r;
}
function $3(t, e) {
  return t.field(Va, !1) ? e : e.concat(ln.appendConfig.of(C3()));
}
const FF = (t) => {
  for (let e of k3(t)) {
    let n = vh(t.state, e.from, e.to);
    if (n)
      return t.dispatch({ effects: $3(t.state, [Ep.of(n), S3(t, n)]) }), !0;
  }
  return !1;
}, VF = (t) => {
  if (!t.state.field(Va, !1))
    return !1;
  let e = [];
  for (let n of k3(t)) {
    let r = yh(t.state, n.from, n.to);
    r && e.push(af.of(r), S3(t, r, !1));
  }
  return e.length && t.dispatch({ effects: e }), e.length > 0;
};
function S3(t, e, n = !0) {
  let r = t.state.doc.lineAt(e.from).number, i = t.state.doc.lineAt(e.to).number;
  return at.announce.of(`${t.state.phrase(n ? "Folded lines" : "Unfolded lines")} ${r} ${t.state.phrase("to")} ${i}.`);
}
const HF = (t) => {
  let { state: e } = t, n = [];
  for (let r = 0; r < e.doc.length; ) {
    let i = t.lineBlockAt(r), o = vh(e, i.from, i.to);
    o && n.push(Ep.of(o)), r = (o ? t.lineBlockAt(o.to) : i).to + 1;
  }
  return n.length && t.dispatch({ effects: $3(t.state, n) }), !!n.length;
}, UF = (t) => {
  let e = t.state.field(Va, !1);
  if (!e || !e.size)
    return !1;
  let n = [];
  return e.between(0, t.state.doc.length, (r, i) => {
    n.push(af.of({ from: r, to: i }));
  }), t.dispatch({ effects: n }), !0;
}, WF = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: FF },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: VF },
  { key: "Ctrl-Alt-[", run: HF },
  { key: "Ctrl-Alt-]", run: UF }
], JF = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "…"
}, i1 = /* @__PURE__ */ vt.define({
  combine(t) {
    return Ui(t, JF);
  }
});
function C3(t) {
  let e = [Va, YF];
  return t && e.push(i1.of(t)), e;
}
function O3(t, e) {
  let { state: n } = t, r = n.facet(i1), i = (s) => {
    let a = t.lineBlockAt(t.posAtDOM(s.target)), l = yh(t.state, a.from, a.to);
    l && t.dispatch({ effects: af.of(l) }), s.preventDefault();
  };
  if (r.placeholderDOM)
    return r.placeholderDOM(t, i, e);
  let o = document.createElement("span");
  return o.textContent = r.placeholderText, o.setAttribute("aria-label", n.phrase("folded code")), o.title = n.phrase("unfold"), o.className = "cm-foldPlaceholder", o.onclick = i, o;
}
const dx = /* @__PURE__ */ Bt.replace({ widget: /* @__PURE__ */ new class extends ua {
  toDOM(t) {
    return O3(t, null);
  }
}() });
class KF extends ua {
  constructor(e) {
    super(), this.value = e;
  }
  eq(e) {
    return this.value == e.value;
  }
  toDOM(e) {
    return O3(e, this.value);
  }
}
const GF = {
  openText: "⌄",
  closedText: "›",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => !1
};
class Mm extends Vo {
  constructor(e, n) {
    super(), this.config = e, this.open = n;
  }
  eq(e) {
    return this.config == e.config && this.open == e.open;
  }
  toDOM(e) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let n = document.createElement("span");
    return n.textContent = this.open ? this.config.openText : this.config.closedText, n.title = e.state.phrase(this.open ? "Fold line" : "Unfold line"), n;
  }
}
function QF(t = {}) {
  let e = Object.assign(Object.assign({}, GF), t), n = new Mm(e, !0), r = new Mm(e, !1), i = ur.fromClass(class {
    constructor(s) {
      this.from = s.viewport.from, this.markers = this.buildMarkers(s);
    }
    update(s) {
      (s.docChanged || s.viewportChanged || s.startState.facet(oa) != s.state.facet(oa) || s.startState.field(Va, !1) != s.state.field(Va, !1) || Zr(s.startState) != Zr(s.state) || e.foldingChanged(s)) && (this.markers = this.buildMarkers(s.view));
    }
    buildMarkers(s) {
      let a = new Fo();
      for (let l of s.viewportLineBlocks) {
        let c = yh(s.state, l.from, l.to) ? r : vh(s.state, l.from, l.to) ? n : null;
        c && a.add(l.from, l.from, c);
      }
      return a.finish();
    }
  }), { domEventHandlers: o } = e;
  return [
    i,
    a3({
      class: "cm-foldGutter",
      markers(s) {
        var a;
        return ((a = s.plugin(i)) === null || a === void 0 ? void 0 : a.markers) || En.empty;
      },
      initialSpacer() {
        return new Mm(e, !1);
      },
      domEventHandlers: Object.assign(Object.assign({}, o), { click: (s, a, l) => {
        if (o.click && o.click(s, a, l))
          return !0;
        let c = yh(s.state, a.from, a.to);
        if (c)
          return s.dispatch({ effects: af.of(c) }), !0;
        let u = vh(s.state, a.from, a.to);
        return u ? (s.dispatch({ effects: Ep.of(u) }), !0) : !1;
      } })
    }),
    C3()
  ];
}
const YF = /* @__PURE__ */ at.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class lf {
  constructor(e, n) {
    this.specs = e;
    let r;
    function i(a) {
      let l = ta.newName();
      return (r || (r = /* @__PURE__ */ Object.create(null)))["." + l] = a, l;
    }
    const o = typeof n.all == "string" ? n.all : n.all ? i(n.all) : void 0, s = n.scope;
    this.scope = s instanceof io ? (a) => a.prop(Sl) == s.data : s ? (a) => a == s : void 0, this.style = v3(e.map((a) => ({
      tag: a.tag,
      class: a.class || i(Object.assign({}, a, { tag: null }))
    })), {
      all: o
    }).style, this.module = r ? new ta(r) : null, this.themeType = n.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(e, n) {
    return new lf(e, n || {});
  }
}
const hv = /* @__PURE__ */ vt.define(), E3 = /* @__PURE__ */ vt.define({
  combine(t) {
    return t.length ? [t[0]] : null;
  }
});
function _m(t) {
  let e = t.facet(hv);
  return e.length ? e : t.facet(E3);
}
function A3(t, e) {
  let n = [ZF], r;
  return t instanceof lf && (t.module && n.push(at.styleModule.of(t.module)), r = t.themeType), e != null && e.fallback ? n.push(E3.of(t)) : r ? n.push(hv.computeN([at.darkTheme], (i) => i.facet(at.darkTheme) == (r == "dark") ? [t] : [])) : n.push(hv.of(t)), n;
}
class XF {
  constructor(e) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = Zr(e.state), this.decorations = this.buildDeco(e, _m(e.state));
  }
  update(e) {
    let n = Zr(e.state), r = _m(e.state), i = r != _m(e.startState);
    n.length < e.view.viewport.to && !i && n.type == this.tree.type ? this.decorations = this.decorations.map(e.changes) : (n != this.tree || e.viewportChanged || i) && (this.tree = n, this.decorations = this.buildDeco(e.view, r));
  }
  buildDeco(e, n) {
    if (!n || !this.tree.length)
      return Bt.none;
    let r = new Fo();
    for (let { from: i, to: o } of e.visibleRanges)
      bF(this.tree, n, (s, a, l) => {
        r.add(s, a, this.markCache[l] || (this.markCache[l] = Bt.mark({ class: l })));
      }, i, o);
    return r.finish();
  }
}
const ZF = /* @__PURE__ */ vc.high(/* @__PURE__ */ ur.fromClass(XF, {
  decorations: (t) => t.decorations
})), eV = /* @__PURE__ */ lf.define([
  {
    tag: Ze.meta,
    color: "#404740"
  },
  {
    tag: Ze.link,
    textDecoration: "underline"
  },
  {
    tag: Ze.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: Ze.emphasis,
    fontStyle: "italic"
  },
  {
    tag: Ze.strong,
    fontWeight: "bold"
  },
  {
    tag: Ze.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: Ze.keyword,
    color: "#708"
  },
  {
    tag: [Ze.atom, Ze.bool, Ze.url, Ze.contentSeparator, Ze.labelName],
    color: "#219"
  },
  {
    tag: [Ze.literal, Ze.inserted],
    color: "#164"
  },
  {
    tag: [Ze.string, Ze.deleted],
    color: "#a11"
  },
  {
    tag: [Ze.regexp, Ze.escape, /* @__PURE__ */ Ze.special(Ze.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ Ze.definition(Ze.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ Ze.local(Ze.variableName),
    color: "#30a"
  },
  {
    tag: [Ze.typeName, Ze.namespace],
    color: "#085"
  },
  {
    tag: Ze.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ Ze.special(Ze.variableName), Ze.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ Ze.definition(Ze.propertyName),
    color: "#00c"
  },
  {
    tag: Ze.comment,
    color: "#940"
  },
  {
    tag: Ze.invalid,
    color: "#f00"
  }
]), tV = /* @__PURE__ */ at.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), M3 = 1e4, _3 = "()[]{}", T3 = /* @__PURE__ */ vt.define({
  combine(t) {
    return Ui(t, {
      afterCursor: !0,
      brackets: _3,
      maxScanDistance: M3,
      renderMatch: iV
    });
  }
}), nV = /* @__PURE__ */ Bt.mark({ class: "cm-matchingBracket" }), rV = /* @__PURE__ */ Bt.mark({ class: "cm-nonmatchingBracket" });
function iV(t) {
  let e = [], n = t.matched ? nV : rV;
  return e.push(n.range(t.start.from, t.start.to)), t.end && e.push(n.range(t.end.from, t.end.to)), e;
}
const oV = /* @__PURE__ */ Cr.define({
  create() {
    return Bt.none;
  },
  update(t, e) {
    if (!e.docChanged && !e.selection)
      return t;
    let n = [], r = e.state.facet(T3);
    for (let i of e.state.selection.ranges) {
      if (!i.empty)
        continue;
      let o = Po(e.state, i.head, -1, r) || i.head > 0 && Po(e.state, i.head - 1, 1, r) || r.afterCursor && (Po(e.state, i.head, 1, r) || i.head < e.state.doc.length && Po(e.state, i.head + 1, -1, r));
      o && (n = n.concat(r.renderMatch(o, e.state)));
    }
    return Bt.set(n, !0);
  },
  provide: (t) => at.decorations.from(t)
}), sV = [
  oV,
  tV
];
function aV(t = {}) {
  return [T3.of(t), sV];
}
const lV = /* @__PURE__ */ new bn();
function pv(t, e, n) {
  let r = t.prop(e < 0 ? bn.openedBy : bn.closedBy);
  if (r)
    return r;
  if (t.name.length == 1) {
    let i = n.indexOf(t.name);
    if (i > -1 && i % 2 == (e < 0 ? 1 : 0))
      return [n[i + e]];
  }
  return null;
}
function mv(t) {
  let e = t.type.prop(lV);
  return e ? e(t.node) : t;
}
function Po(t, e, n, r = {}) {
  let i = r.maxScanDistance || M3, o = r.brackets || _3, s = Zr(t), a = s.resolveInner(e, n);
  for (let l = a; l; l = l.parent) {
    let c = pv(l.type, n, o);
    if (c && l.from < l.to) {
      let u = mv(l);
      if (u && (n > 0 ? e >= u.from && e < u.to : e > u.from && e <= u.to))
        return cV(t, e, n, l, u, c, o);
    }
  }
  return uV(t, e, n, s, a.type, i, o);
}
function cV(t, e, n, r, i, o, s) {
  let a = r.parent, l = { from: i.from, to: i.to }, c = 0, u = a == null ? void 0 : a.cursor();
  if (u && (n < 0 ? u.childBefore(r.from) : u.childAfter(r.to)))
    do
      if (n < 0 ? u.to <= r.from : u.from >= r.to) {
        if (c == 0 && o.indexOf(u.type.name) > -1 && u.from < u.to) {
          let f = mv(u);
          return { start: l, end: f ? { from: f.from, to: f.to } : void 0, matched: !0 };
        } else if (pv(u.type, n, s))
          c++;
        else if (pv(u.type, -n, s)) {
          if (c == 0) {
            let f = mv(u);
            return {
              start: l,
              end: f && f.from < f.to ? { from: f.from, to: f.to } : void 0,
              matched: !1
            };
          }
          c--;
        }
      }
    while (n < 0 ? u.prevSibling() : u.nextSibling());
  return { start: l, matched: !1 };
}
function uV(t, e, n, r, i, o, s) {
  let a = n < 0 ? t.sliceDoc(e - 1, e) : t.sliceDoc(e, e + 1), l = s.indexOf(a);
  if (l < 0 || l % 2 == 0 != n > 0)
    return null;
  let c = { from: n < 0 ? e - 1 : e, to: n > 0 ? e + 1 : e }, u = t.doc.iterRange(e, n > 0 ? t.doc.length : 0), f = 0;
  for (let d = 0; !u.next().done && d <= o; ) {
    let h = u.value;
    n < 0 && (d += h.length);
    let p = e + d * n;
    for (let m = n > 0 ? 0 : h.length - 1, g = n > 0 ? h.length : -1; m != g; m += n) {
      let v = s.indexOf(h[m]);
      if (!(v < 0 || r.resolveInner(p + m, 1).type != i))
        if (v % 2 == 0 == n > 0)
          f++;
        else {
          if (f == 1)
            return { start: c, end: { from: p + m, to: p + m + 1 }, matched: v >> 1 == l >> 1 };
          f--;
        }
    }
    n > 0 && (d += h.length);
  }
  return u.done ? { start: c, matched: !1 } : null;
}
const fV = /* @__PURE__ */ Object.create(null), hx = [fi.none], px = [], mx = /* @__PURE__ */ Object.create(null), dV = /* @__PURE__ */ Object.create(null);
for (let [t, e] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  dV[t] = /* @__PURE__ */ hV(fV, e);
function Tm(t, e) {
  px.indexOf(t) > -1 || (px.push(t), console.warn(e));
}
function hV(t, e) {
  let n = [];
  for (let a of e.split(" ")) {
    let l = [];
    for (let c of a.split(".")) {
      let u = t[c] || Ze[c];
      u ? typeof u == "function" ? l.length ? l = l.map(u) : Tm(c, `Modifier ${c} used at start of tag`) : l.length ? Tm(c, `Tag ${c} used as modifier`) : l = Array.isArray(u) ? u : [u] : Tm(c, `Unknown highlighting tag ${c}`);
    }
    for (let c of l)
      n.push(c);
  }
  if (!n.length)
    return 0;
  let r = e.replace(/ /g, "_"), i = r + " " + n.map((a) => a.id), o = mx[i];
  if (o)
    return o.id;
  let s = mx[i] = fi.define({
    id: hx.length,
    name: r,
    props: [m3({ [r]: n })]
  });
  return hx.push(s), s.id;
}
const pV = (t) => {
  let { state: e } = t, n = e.doc.lineAt(e.selection.main.from), r = s1(t.state, n.from);
  return r.line ? mV(t) : r.block ? vV(t) : !1;
};
function o1(t, e) {
  return ({ state: n, dispatch: r }) => {
    if (n.readOnly)
      return !1;
    let i = t(e, n);
    return i ? (r(n.update(i)), !0) : !1;
  };
}
const mV = /* @__PURE__ */ o1(
  xV,
  0
  /* CommentOption.Toggle */
), gV = /* @__PURE__ */ o1(
  P3,
  0
  /* CommentOption.Toggle */
), vV = /* @__PURE__ */ o1(
  (t, e) => P3(t, e, bV(e)),
  0
  /* CommentOption.Toggle */
);
function s1(t, e) {
  let n = t.languageDataAt("commentTokens", e);
  return n.length ? n[0] : {};
}
const Ic = 50;
function yV(t, { open: e, close: n }, r, i) {
  let o = t.sliceDoc(r - Ic, r), s = t.sliceDoc(i, i + Ic), a = /\s*$/.exec(o)[0].length, l = /^\s*/.exec(s)[0].length, c = o.length - a;
  if (o.slice(c - e.length, c) == e && s.slice(l, l + n.length) == n)
    return {
      open: { pos: r - a, margin: a && 1 },
      close: { pos: i + l, margin: l && 1 }
    };
  let u, f;
  i - r <= 2 * Ic ? u = f = t.sliceDoc(r, i) : (u = t.sliceDoc(r, r + Ic), f = t.sliceDoc(i - Ic, i));
  let d = /^\s*/.exec(u)[0].length, h = /\s*$/.exec(f)[0].length, p = f.length - h - n.length;
  return u.slice(d, d + e.length) == e && f.slice(p, p + n.length) == n ? {
    open: {
      pos: r + d + e.length,
      margin: /\s/.test(u.charAt(d + e.length)) ? 1 : 0
    },
    close: {
      pos: i - h - n.length,
      margin: /\s/.test(f.charAt(p - 1)) ? 1 : 0
    }
  } : null;
}
function bV(t) {
  let e = [];
  for (let n of t.selection.ranges) {
    let r = t.doc.lineAt(n.from), i = n.to <= r.to ? r : t.doc.lineAt(n.to), o = e.length - 1;
    o >= 0 && e[o].to > r.from ? e[o].to = i.to : e.push({ from: r.from + /^\s*/.exec(r.text)[0].length, to: i.to });
  }
  return e;
}
function P3(t, e, n = e.selection.ranges) {
  let r = n.map((o) => s1(e, o.from).block);
  if (!r.every((o) => o))
    return null;
  let i = n.map((o, s) => yV(e, r[s], o.from, o.to));
  if (t != 2 && !i.every((o) => o))
    return { changes: e.changes(n.map((o, s) => i[s] ? [] : [{ from: o.from, insert: r[s].open + " " }, { from: o.to, insert: " " + r[s].close }])) };
  if (t != 1 && i.some((o) => o)) {
    let o = [];
    for (let s = 0, a; s < i.length; s++)
      if (a = i[s]) {
        let l = r[s], { open: c, close: u } = a;
        o.push({ from: c.pos - l.open.length, to: c.pos + c.margin }, { from: u.pos - u.margin, to: u.pos + l.close.length });
      }
    return { changes: o };
  }
  return null;
}
function xV(t, e, n = e.selection.ranges) {
  let r = [], i = -1;
  for (let { from: o, to: s } of n) {
    let a = r.length, l = 1e9, c = s1(e, o).line;
    if (c) {
      for (let u = o; u <= s; ) {
        let f = e.doc.lineAt(u);
        if (f.from > i && (o == s || s > f.from)) {
          i = f.from;
          let d = /^\s*/.exec(f.text)[0].length, h = d == f.length, p = f.text.slice(d, d + c.length) == c ? d : -1;
          d < f.text.length && d < l && (l = d), r.push({ line: f, comment: p, token: c, indent: d, empty: h, single: !1 });
        }
        u = f.to + 1;
      }
      if (l < 1e9)
        for (let u = a; u < r.length; u++)
          r[u].indent < r[u].line.text.length && (r[u].indent = l);
      r.length == a + 1 && (r[a].single = !0);
    }
  }
  if (t != 2 && r.some((o) => o.comment < 0 && (!o.empty || o.single))) {
    let o = [];
    for (let { line: a, token: l, indent: c, empty: u, single: f } of r)
      (f || !u) && o.push({ from: a.from + c, insert: l + " " });
    let s = e.changes(o);
    return { changes: s, selection: e.selection.map(s, 1) };
  } else if (t != 1 && r.some((o) => o.comment >= 0)) {
    let o = [];
    for (let { line: s, comment: a, token: l } of r)
      if (a >= 0) {
        let c = s.from + a, u = c + l.length;
        s.text[u - s.from] == " " && u++, o.push({ from: c, to: u });
      }
    return { changes: o };
  }
  return null;
}
const gv = /* @__PURE__ */ Ss.define(), wV = /* @__PURE__ */ Ss.define(), jV = /* @__PURE__ */ vt.define(), R3 = /* @__PURE__ */ vt.define({
  combine(t) {
    return Ui(t, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (e, n) => n
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (e, n) => (r, i) => e(r, i) || n(r, i)
    });
  }
}), a1 = /* @__PURE__ */ Cr.define({
  create() {
    return Ro.empty;
  },
  update(t, e) {
    let n = e.state.facet(R3), r = e.annotation(gv);
    if (r) {
      let l = ui.fromTransaction(e, r.selection), c = r.side, u = c == 0 ? t.undone : t.done;
      return l ? u = xh(u, u.length, n.minDepth, l) : u = D3(u, e.startState.selection), new Ro(c == 0 ? r.rest : u, c == 0 ? u : r.rest);
    }
    let i = e.annotation(wV);
    if ((i == "full" || i == "before") && (t = t.isolate()), e.annotation(Sr.addToHistory) === !1)
      return e.changes.empty ? t : t.addMapping(e.changes.desc);
    let o = ui.fromTransaction(e), s = e.annotation(Sr.time), a = e.annotation(Sr.userEvent);
    return o ? t = t.addChanges(o, s, a, n, e) : e.selection && (t = t.addSelection(e.startState.selection, s, a, n.newGroupDelay)), (i == "full" || i == "after") && (t = t.isolate()), t;
  },
  toJSON(t) {
    return { done: t.done.map((e) => e.toJSON()), undone: t.undone.map((e) => e.toJSON()) };
  },
  fromJSON(t) {
    return new Ro(t.done.map(ui.fromJSON), t.undone.map(ui.fromJSON));
  }
});
function kV(t = {}) {
  return [
    a1,
    R3.of(t),
    at.domEventHandlers({
      beforeinput(e, n) {
        let r = e.inputType == "historyUndo" ? l1 : e.inputType == "historyRedo" ? bh : null;
        return r ? (e.preventDefault(), r(n)) : !1;
      }
    })
  ];
}
function Ap(t, e) {
  return function({ state: n, dispatch: r }) {
    if (!e && n.readOnly)
      return !1;
    let i = n.field(a1, !1);
    if (!i)
      return !1;
    let o = i.pop(t, n, e);
    return o ? (r(o), !0) : !1;
  };
}
const l1 = /* @__PURE__ */ Ap(0, !1), bh = /* @__PURE__ */ Ap(1, !1), $V = /* @__PURE__ */ Ap(0, !0), SV = /* @__PURE__ */ Ap(1, !0);
function N3(t) {
  return function(e) {
    let n = e.field(a1, !1);
    if (!n)
      return 0;
    let r = t == 0 ? n.done : n.undone;
    return r.length - (r.length && !r[0].changes ? 1 : 0);
  };
}
const CV = /* @__PURE__ */ N3(
  0
  /* BranchName.Done */
), OV = /* @__PURE__ */ N3(
  1
  /* BranchName.Undone */
);
class ui {
  constructor(e, n, r, i, o) {
    this.changes = e, this.effects = n, this.mapped = r, this.startSelection = i, this.selectionsAfter = o;
  }
  setSelAfter(e) {
    return new ui(this.changes, this.effects, this.mapped, this.startSelection, e);
  }
  toJSON() {
    var e, n, r;
    return {
      changes: (e = this.changes) === null || e === void 0 ? void 0 : e.toJSON(),
      mapped: (n = this.mapped) === null || n === void 0 ? void 0 : n.toJSON(),
      startSelection: (r = this.startSelection) === null || r === void 0 ? void 0 : r.toJSON(),
      selectionsAfter: this.selectionsAfter.map((i) => i.toJSON())
    };
  }
  static fromJSON(e) {
    return new ui(e.changes && $r.fromJSON(e.changes), [], e.mapped && Bo.fromJSON(e.mapped), e.startSelection && Te.fromJSON(e.startSelection), e.selectionsAfter.map(Te.fromJSON));
  }
  // This does not check `addToHistory` and such, it assumes the
  // transaction needs to be converted to an item. Returns null when
  // there are no changes or effects in the transaction.
  static fromTransaction(e, n) {
    let r = Pi;
    for (let i of e.startState.facet(jV)) {
      let o = i(e);
      o.length && (r = r.concat(o));
    }
    return !r.length && e.changes.empty ? null : new ui(e.changes.invert(e.startState.doc), r, void 0, n || e.startState.selection, Pi);
  }
  static selection(e) {
    return new ui(void 0, Pi, void 0, void 0, e);
  }
}
function xh(t, e, n, r) {
  let i = e + 1 > n + 20 ? e - n - 1 : 0, o = t.slice(i, e);
  return o.push(r), o;
}
function EV(t, e) {
  let n = [], r = !1;
  return t.iterChangedRanges((i, o) => n.push(i, o)), e.iterChangedRanges((i, o, s, a) => {
    for (let l = 0; l < n.length; ) {
      let c = n[l++], u = n[l++];
      a >= c && s <= u && (r = !0);
    }
  }), r;
}
function AV(t, e) {
  return t.ranges.length == e.ranges.length && t.ranges.filter((n, r) => n.empty != e.ranges[r].empty).length === 0;
}
function I3(t, e) {
  return t.length ? e.length ? t.concat(e) : t : e;
}
const Pi = [], MV = 200;
function D3(t, e) {
  if (t.length) {
    let n = t[t.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - MV));
    return r.length && r[r.length - 1].eq(e) ? t : (r.push(e), xh(t, t.length - 1, 1e9, n.setSelAfter(r)));
  } else
    return [ui.selection([e])];
}
function _V(t) {
  let e = t[t.length - 1], n = t.slice();
  return n[t.length - 1] = e.setSelAfter(e.selectionsAfter.slice(0, e.selectionsAfter.length - 1)), n;
}
function Pm(t, e) {
  if (!t.length)
    return t;
  let n = t.length, r = Pi;
  for (; n; ) {
    let i = TV(t[n - 1], e, r);
    if (i.changes && !i.changes.empty || i.effects.length) {
      let o = t.slice(0, n);
      return o[n - 1] = i, o;
    } else
      e = i.mapped, n--, r = i.selectionsAfter;
  }
  return r.length ? [ui.selection(r)] : Pi;
}
function TV(t, e, n) {
  let r = I3(t.selectionsAfter.length ? t.selectionsAfter.map((a) => a.map(e)) : Pi, n);
  if (!t.changes)
    return ui.selection(r);
  let i = t.changes.map(e), o = e.mapDesc(t.changes, !0), s = t.mapped ? t.mapped.composeDesc(o) : o;
  return new ui(i, ln.mapEffects(t.effects, e), s, t.startSelection.map(o), r);
}
const PV = /^(input\.type|delete)($|\.)/;
class Ro {
  constructor(e, n, r = 0, i = void 0) {
    this.done = e, this.undone = n, this.prevTime = r, this.prevUserEvent = i;
  }
  isolate() {
    return this.prevTime ? new Ro(this.done, this.undone) : this;
  }
  addChanges(e, n, r, i, o) {
    let s = this.done, a = s[s.length - 1];
    return a && a.changes && !a.changes.empty && e.changes && (!r || PV.test(r)) && (!a.selectionsAfter.length && n - this.prevTime < i.newGroupDelay && i.joinToEvent(o, EV(a.changes, e.changes)) || // For compose (but not compose.start) events, always join with previous event
    r == "input.type.compose") ? s = xh(s, s.length - 1, i.minDepth, new ui(e.changes.compose(a.changes), I3(e.effects, a.effects), a.mapped, a.startSelection, Pi)) : s = xh(s, s.length, i.minDepth, e), new Ro(s, Pi, n, r);
  }
  addSelection(e, n, r, i) {
    let o = this.done.length ? this.done[this.done.length - 1].selectionsAfter : Pi;
    return o.length > 0 && n - this.prevTime < i && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && AV(o[o.length - 1], e) ? this : new Ro(D3(this.done, e), this.undone, n, r);
  }
  addMapping(e) {
    return new Ro(Pm(this.done, e), Pm(this.undone, e), this.prevTime, this.prevUserEvent);
  }
  pop(e, n, r) {
    let i = e == 0 ? this.done : this.undone;
    if (i.length == 0)
      return null;
    let o = i[i.length - 1], s = o.selectionsAfter[0] || n.selection;
    if (r && o.selectionsAfter.length)
      return n.update({
        selection: o.selectionsAfter[o.selectionsAfter.length - 1],
        annotations: gv.of({ side: e, rest: _V(i), selection: s }),
        userEvent: e == 0 ? "select.undo" : "select.redo",
        scrollIntoView: !0
      });
    if (o.changes) {
      let a = i.length == 1 ? Pi : i.slice(0, i.length - 1);
      return o.mapped && (a = Pm(a, o.mapped)), n.update({
        changes: o.changes,
        selection: o.startSelection,
        effects: o.effects,
        annotations: gv.of({ side: e, rest: a, selection: s }),
        filter: !1,
        userEvent: e == 0 ? "undo" : "redo",
        scrollIntoView: !0
      });
    } else
      return null;
  }
}
Ro.empty = /* @__PURE__ */ new Ro(Pi, Pi);
const RV = [
  { key: "Mod-z", run: l1, preventDefault: !0 },
  { key: "Mod-y", mac: "Mod-Shift-z", run: bh, preventDefault: !0 },
  { linux: "Ctrl-Shift-z", run: bh, preventDefault: !0 },
  { key: "Mod-u", run: $V, preventDefault: !0 },
  { key: "Alt-u", mac: "Mod-Shift-u", run: SV, preventDefault: !0 }
];
function bc(t, e) {
  return Te.create(t.ranges.map(e), t.mainIndex);
}
function Yo(t, e) {
  return t.update({ selection: e, scrollIntoView: !0, userEvent: "select" });
}
function go({ state: t, dispatch: e }, n) {
  let r = bc(t.selection, n);
  return r.eq(t.selection) ? !1 : (e(Yo(t, r)), !0);
}
function Mp(t, e) {
  return Te.cursor(e ? t.to : t.from);
}
function L3(t, e) {
  return go(t, (n) => n.empty ? t.moveByChar(n, e) : Mp(n, e));
}
function ei(t) {
  return t.textDirectionAt(t.state.selection.main.head) == cr.LTR;
}
const B3 = (t) => L3(t, !ei(t)), q3 = (t) => L3(t, ei(t));
function z3(t, e) {
  return go(t, (n) => n.empty ? t.moveByGroup(n, e) : Mp(n, e));
}
const NV = (t) => z3(t, !ei(t)), IV = (t) => z3(t, ei(t));
function DV(t, e, n) {
  if (e.type.prop(n))
    return !0;
  let r = e.to - e.from;
  return r && (r > 2 || /[^\s,.;:]/.test(t.sliceDoc(e.from, e.to))) || e.firstChild;
}
function _p(t, e, n) {
  let r = Zr(t).resolveInner(e.head), i = n ? bn.closedBy : bn.openedBy;
  for (let l = e.head; ; ) {
    let c = n ? r.childAfter(l) : r.childBefore(l);
    if (!c)
      break;
    DV(t, c, i) ? r = c : l = n ? c.to : c.from;
  }
  let o = r.type.prop(i), s, a;
  return o && (s = n ? Po(t, r.from, 1) : Po(t, r.to, -1)) && s.matched ? a = n ? s.end.to : s.end.from : a = n ? r.to : r.from, Te.cursor(a, n ? -1 : 1);
}
const LV = (t) => go(t, (e) => _p(t.state, e, !ei(t))), BV = (t) => go(t, (e) => _p(t.state, e, ei(t)));
function F3(t, e) {
  return go(t, (n) => {
    if (!n.empty)
      return Mp(n, e);
    let r = t.moveVertically(n, e);
    return r.head != n.head ? r : t.moveToLineBoundary(n, e);
  });
}
const V3 = (t) => F3(t, !1), H3 = (t) => F3(t, !0);
function U3(t) {
  let e = t.scrollDOM.clientHeight < t.scrollDOM.scrollHeight - 2, n = 0, r = 0, i;
  if (e) {
    for (let o of t.state.facet(at.scrollMargins)) {
      let s = o(t);
      s != null && s.top && (n = Math.max(s == null ? void 0 : s.top, n)), s != null && s.bottom && (r = Math.max(s == null ? void 0 : s.bottom, r));
    }
    i = t.scrollDOM.clientHeight - n - r;
  } else
    i = (t.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: n,
    marginBottom: r,
    selfScroll: e,
    height: Math.max(t.defaultLineHeight, i - 5)
  };
}
function W3(t, e) {
  let n = U3(t), { state: r } = t, i = bc(r.selection, (s) => s.empty ? t.moveVertically(s, e, n.height) : Mp(s, e));
  if (i.eq(r.selection))
    return !1;
  let o;
  if (n.selfScroll) {
    let s = t.coordsAtPos(r.selection.main.head), a = t.scrollDOM.getBoundingClientRect(), l = a.top + n.marginTop, c = a.bottom - n.marginBottom;
    s && s.top > l && s.bottom < c && (o = at.scrollIntoView(i.main.head, { y: "start", yMargin: s.top - l }));
  }
  return t.dispatch(Yo(r, i), { effects: o }), !0;
}
const gx = (t) => W3(t, !1), vv = (t) => W3(t, !0);
function fa(t, e, n) {
  let r = t.lineBlockAt(e.head), i = t.moveToLineBoundary(e, n);
  if (i.head == e.head && i.head != (n ? r.to : r.from) && (i = t.moveToLineBoundary(e, n, !1)), !n && i.head == r.from && r.length) {
    let o = /^\s*/.exec(t.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    o && e.head != r.from + o && (i = Te.cursor(r.from + o));
  }
  return i;
}
const qV = (t) => go(t, (e) => fa(t, e, !0)), zV = (t) => go(t, (e) => fa(t, e, !1)), FV = (t) => go(t, (e) => fa(t, e, !ei(t))), VV = (t) => go(t, (e) => fa(t, e, ei(t))), HV = (t) => go(t, (e) => Te.cursor(t.lineBlockAt(e.head).from, 1)), UV = (t) => go(t, (e) => Te.cursor(t.lineBlockAt(e.head).to, -1));
function WV(t, e, n) {
  let r = !1, i = bc(t.selection, (o) => {
    let s = Po(t, o.head, -1) || Po(t, o.head, 1) || o.head > 0 && Po(t, o.head - 1, 1) || o.head < t.doc.length && Po(t, o.head + 1, -1);
    if (!s || !s.end)
      return o;
    r = !0;
    let a = s.start.from == o.head ? s.end.to : s.end.from;
    return n ? Te.range(o.anchor, a) : Te.cursor(a);
  });
  return r ? (e(Yo(t, i)), !0) : !1;
}
const JV = ({ state: t, dispatch: e }) => WV(t, e, !1);
function Wi(t, e) {
  let n = bc(t.state.selection, (r) => {
    let i = e(r);
    return Te.range(r.anchor, i.head, i.goalColumn, i.bidiLevel || void 0);
  });
  return n.eq(t.state.selection) ? !1 : (t.dispatch(Yo(t.state, n)), !0);
}
function J3(t, e) {
  return Wi(t, (n) => t.moveByChar(n, e));
}
const K3 = (t) => J3(t, !ei(t)), G3 = (t) => J3(t, ei(t));
function Q3(t, e) {
  return Wi(t, (n) => t.moveByGroup(n, e));
}
const KV = (t) => Q3(t, !ei(t)), GV = (t) => Q3(t, ei(t)), QV = (t) => Wi(t, (e) => _p(t.state, e, !ei(t))), YV = (t) => Wi(t, (e) => _p(t.state, e, ei(t)));
function Y3(t, e) {
  return Wi(t, (n) => t.moveVertically(n, e));
}
const X3 = (t) => Y3(t, !1), Z3 = (t) => Y3(t, !0);
function e8(t, e) {
  return Wi(t, (n) => t.moveVertically(n, e, U3(t).height));
}
const vx = (t) => e8(t, !1), yx = (t) => e8(t, !0), XV = (t) => Wi(t, (e) => fa(t, e, !0)), ZV = (t) => Wi(t, (e) => fa(t, e, !1)), eH = (t) => Wi(t, (e) => fa(t, e, !ei(t))), tH = (t) => Wi(t, (e) => fa(t, e, ei(t))), nH = (t) => Wi(t, (e) => Te.cursor(t.lineBlockAt(e.head).from)), rH = (t) => Wi(t, (e) => Te.cursor(t.lineBlockAt(e.head).to)), bx = ({ state: t, dispatch: e }) => (e(Yo(t, { anchor: 0 })), !0), xx = ({ state: t, dispatch: e }) => (e(Yo(t, { anchor: t.doc.length })), !0), wx = ({ state: t, dispatch: e }) => (e(Yo(t, { anchor: t.selection.main.anchor, head: 0 })), !0), jx = ({ state: t, dispatch: e }) => (e(Yo(t, { anchor: t.selection.main.anchor, head: t.doc.length })), !0), iH = ({ state: t, dispatch: e }) => (e(t.update({ selection: { anchor: 0, head: t.doc.length }, userEvent: "select" })), !0), oH = ({ state: t, dispatch: e }) => {
  let n = Tp(t).map(({ from: r, to: i }) => Te.range(r, Math.min(i + 1, t.doc.length)));
  return e(t.update({ selection: Te.create(n), userEvent: "select" })), !0;
}, sH = ({ state: t, dispatch: e }) => {
  let n = bc(t.selection, (r) => {
    var i;
    let o = Zr(t).resolveStack(r.from, 1);
    for (let s = o; s; s = s.next) {
      let { node: a } = s;
      if ((a.from < r.from && a.to >= r.to || a.to > r.to && a.from <= r.from) && (!((i = a.parent) === null || i === void 0) && i.parent))
        return Te.range(a.to, a.from);
    }
    return r;
  });
  return e(Yo(t, n)), !0;
}, aH = ({ state: t, dispatch: e }) => {
  let n = t.selection, r = null;
  return n.ranges.length > 1 ? r = Te.create([n.main]) : n.main.empty || (r = Te.create([Te.cursor(n.main.head)])), r ? (e(Yo(t, r)), !0) : !1;
};
function cf(t, e) {
  if (t.state.readOnly)
    return !1;
  let n = "delete.selection", { state: r } = t, i = r.changeByRange((o) => {
    let { from: s, to: a } = o;
    if (s == a) {
      let l = e(o);
      l < s ? (n = "delete.backward", l = Xf(t, l, !1)) : l > s && (n = "delete.forward", l = Xf(t, l, !0)), s = Math.min(s, l), a = Math.max(a, l);
    } else
      s = Xf(t, s, !1), a = Xf(t, a, !0);
    return s == a ? { range: o } : { changes: { from: s, to: a }, range: Te.cursor(s, s < o.head ? -1 : 1) };
  });
  return i.changes.empty ? !1 : (t.dispatch(r.update(i, {
    scrollIntoView: !0,
    userEvent: n,
    effects: n == "delete.selection" ? at.announce.of(r.phrase("Selection deleted")) : void 0
  })), !0);
}
function Xf(t, e, n) {
  if (t instanceof at)
    for (let r of t.state.facet(at.atomicRanges).map((i) => i(t)))
      r.between(e, e, (i, o) => {
        i < e && o > e && (e = n ? o : i);
      });
  return e;
}
const t8 = (t, e) => cf(t, (n) => {
  let r = n.from, { state: i } = t, o = i.doc.lineAt(r), s, a;
  if (!e && r > o.from && r < o.from + 200 && !/[^ \t]/.test(s = o.text.slice(0, r - o.from))) {
    if (s[s.length - 1] == "	")
      return r - 1;
    let l = yc(s, i.tabSize), c = l % sa(i) || sa(i);
    for (let u = 0; u < c && s[s.length - 1 - u] == " "; u++)
      r--;
    a = r;
  } else
    a = Br(o.text, r - o.from, e, e) + o.from, a == r && o.number != (e ? i.doc.lines : 1) ? a += e ? 1 : -1 : !e && /[\ufe00-\ufe0f]/.test(o.text.slice(a - o.from, r - o.from)) && (a = Br(o.text, a - o.from, !1, !1) + o.from);
  return a;
}), yv = (t) => t8(t, !1), n8 = (t) => t8(t, !0), r8 = (t, e) => cf(t, (n) => {
  let r = n.head, { state: i } = t, o = i.doc.lineAt(r), s = i.charCategorizer(r);
  for (let a = null; ; ) {
    if (r == (e ? o.to : o.from)) {
      r == n.head && o.number != (e ? i.doc.lines : 1) && (r += e ? 1 : -1);
      break;
    }
    let l = Br(o.text, r - o.from, e) + o.from, c = o.text.slice(Math.min(r, l) - o.from, Math.max(r, l) - o.from), u = s(c);
    if (a != null && u != a)
      break;
    (c != " " || r != n.head) && (a = u), r = l;
  }
  return r;
}), i8 = (t) => r8(t, !1), lH = (t) => r8(t, !0), cH = (t) => cf(t, (e) => {
  let n = t.lineBlockAt(e.head).to;
  return e.head < n ? n : Math.min(t.state.doc.length, e.head + 1);
}), uH = (t) => cf(t, (e) => {
  let n = t.moveToLineBoundary(e, !1).head;
  return e.head > n ? n : Math.max(0, e.head - 1);
}), fH = (t) => cf(t, (e) => {
  let n = t.moveToLineBoundary(e, !0).head;
  return e.head < n ? n : Math.min(t.state.doc.length, e.head + 1);
}), dH = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = t.changeByRange((r) => ({
    changes: { from: r.from, to: r.to, insert: Cn.of(["", ""]) },
    range: Te.cursor(r.from)
  }));
  return e(t.update(n, { scrollIntoView: !0, userEvent: "input" })), !0;
}, hH = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = t.changeByRange((r) => {
    if (!r.empty || r.from == 0 || r.from == t.doc.length)
      return { range: r };
    let i = r.from, o = t.doc.lineAt(i), s = i == o.from ? i - 1 : Br(o.text, i - o.from, !1) + o.from, a = i == o.to ? i + 1 : Br(o.text, i - o.from, !0) + o.from;
    return {
      changes: { from: s, to: a, insert: t.doc.slice(i, a).append(t.doc.slice(s, i)) },
      range: Te.cursor(a)
    };
  });
  return n.changes.empty ? !1 : (e(t.update(n, { scrollIntoView: !0, userEvent: "move.character" })), !0);
};
function Tp(t) {
  let e = [], n = -1;
  for (let r of t.selection.ranges) {
    let i = t.doc.lineAt(r.from), o = t.doc.lineAt(r.to);
    if (!r.empty && r.to == o.from && (o = t.doc.lineAt(r.to - 1)), n >= i.number) {
      let s = e[e.length - 1];
      s.to = o.to, s.ranges.push(r);
    } else
      e.push({ from: i.from, to: o.to, ranges: [r] });
    n = o.number + 1;
  }
  return e;
}
function o8(t, e, n) {
  if (t.readOnly)
    return !1;
  let r = [], i = [];
  for (let o of Tp(t)) {
    if (n ? o.to == t.doc.length : o.from == 0)
      continue;
    let s = t.doc.lineAt(n ? o.to + 1 : o.from - 1), a = s.length + 1;
    if (n) {
      r.push({ from: o.to, to: s.to }, { from: o.from, insert: s.text + t.lineBreak });
      for (let l of o.ranges)
        i.push(Te.range(Math.min(t.doc.length, l.anchor + a), Math.min(t.doc.length, l.head + a)));
    } else {
      r.push({ from: s.from, to: o.from }, { from: o.to, insert: t.lineBreak + s.text });
      for (let l of o.ranges)
        i.push(Te.range(l.anchor - a, l.head - a));
    }
  }
  return r.length ? (e(t.update({
    changes: r,
    scrollIntoView: !0,
    selection: Te.create(i, t.selection.mainIndex),
    userEvent: "move.line"
  })), !0) : !1;
}
const pH = ({ state: t, dispatch: e }) => o8(t, e, !1), mH = ({ state: t, dispatch: e }) => o8(t, e, !0);
function s8(t, e, n) {
  if (t.readOnly)
    return !1;
  let r = [];
  for (let i of Tp(t))
    n ? r.push({ from: i.from, insert: t.doc.slice(i.from, i.to) + t.lineBreak }) : r.push({ from: i.to, insert: t.lineBreak + t.doc.slice(i.from, i.to) });
  return e(t.update({ changes: r, scrollIntoView: !0, userEvent: "input.copyline" })), !0;
}
const gH = ({ state: t, dispatch: e }) => s8(t, e, !1), vH = ({ state: t, dispatch: e }) => s8(t, e, !0), yH = (t) => {
  if (t.state.readOnly)
    return !1;
  let { state: e } = t, n = e.changes(Tp(e).map(({ from: i, to: o }) => (i > 0 ? i-- : o < e.doc.length && o++, { from: i, to: o }))), r = bc(e.selection, (i) => t.moveVertically(i, !0)).map(n);
  return t.dispatch({ changes: n, selection: r, scrollIntoView: !0, userEvent: "delete.line" }), !0;
};
function bH(t, e) {
  if (/\(\)|\[\]|\{\}/.test(t.sliceDoc(e - 1, e + 1)))
    return { from: e, to: e };
  let n = Zr(t).resolveInner(e), r = n.childBefore(e), i = n.childAfter(e), o;
  return r && i && r.to <= e && i.from >= e && (o = r.type.prop(bn.closedBy)) && o.indexOf(i.name) > -1 && t.doc.lineAt(r.to).from == t.doc.lineAt(i.from).from && !/\S/.test(t.sliceDoc(r.to, i.from)) ? { from: r.to, to: i.from } : null;
}
const xH = /* @__PURE__ */ a8(!1), wH = /* @__PURE__ */ a8(!0);
function a8(t) {
  return ({ state: e, dispatch: n }) => {
    if (e.readOnly)
      return !1;
    let r = e.changeByRange((i) => {
      let { from: o, to: s } = i, a = e.doc.lineAt(o), l = !t && o == s && bH(e, o);
      t && (o = s = (s <= a.to ? a : e.doc.lineAt(s)).to);
      let c = new Op(e, { simulateBreak: o, simulateDoubleBreak: !!l }), u = n1(c, o);
      for (u == null && (u = yc(/^\s*/.exec(e.doc.lineAt(o).text)[0], e.tabSize)); s < a.to && /\s/.test(a.text[s - a.from]); )
        s++;
      l ? { from: o, to: s } = l : o > a.from && o < a.from + 100 && !/\S/.test(a.text.slice(0, o)) && (o = a.from);
      let f = ["", Du(e, u)];
      return l && f.push(Du(e, c.lineIndent(a.from, -1))), {
        changes: { from: o, to: s, insert: Cn.of(f) },
        range: Te.cursor(o + 1 + f[1].length)
      };
    });
    return n(e.update(r, { scrollIntoView: !0, userEvent: "input" })), !0;
  };
}
function c1(t, e) {
  let n = -1;
  return t.changeByRange((r) => {
    let i = [];
    for (let s = r.from; s <= r.to; ) {
      let a = t.doc.lineAt(s);
      a.number > n && (r.empty || r.to > a.from) && (e(a, i, r), n = a.number), s = a.to + 1;
    }
    let o = t.changes(i);
    return {
      changes: i,
      range: Te.range(o.mapPos(r.anchor, 1), o.mapPos(r.head, 1))
    };
  });
}
const jH = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = /* @__PURE__ */ Object.create(null), r = new Op(t, { overrideIndentation: (o) => {
    let s = n[o];
    return s ?? -1;
  } }), i = c1(t, (o, s, a) => {
    let l = n1(r, o.from);
    if (l == null)
      return;
    /\S/.test(o.text) || (l = 0);
    let c = /^\s*/.exec(o.text)[0], u = Du(t, l);
    (c != u || a.from < o.from + c.length) && (n[o.from] = l, s.push({ from: o.from, to: o.from + c.length, insert: u }));
  });
  return i.changes.empty || e(t.update(i, { userEvent: "indent" })), !0;
}, l8 = ({ state: t, dispatch: e }) => t.readOnly ? !1 : (e(t.update(c1(t, (n, r) => {
  r.push({ from: n.from, insert: t.facet(Cp) });
}), { userEvent: "input.indent" })), !0), c8 = ({ state: t, dispatch: e }) => t.readOnly ? !1 : (e(t.update(c1(t, (n, r) => {
  let i = /^\s*/.exec(n.text)[0];
  if (!i)
    return;
  let o = yc(i, t.tabSize), s = 0, a = Du(t, Math.max(0, o - sa(t)));
  for (; s < i.length && s < a.length && i.charCodeAt(s) == a.charCodeAt(s); )
    s++;
  r.push({ from: n.from + s, to: n.from + i.length, insert: a.slice(s) });
}), { userEvent: "delete.dedent" })), !0), kH = [
  { key: "Ctrl-b", run: B3, shift: K3, preventDefault: !0 },
  { key: "Ctrl-f", run: q3, shift: G3 },
  { key: "Ctrl-p", run: V3, shift: X3 },
  { key: "Ctrl-n", run: H3, shift: Z3 },
  { key: "Ctrl-a", run: HV, shift: nH },
  { key: "Ctrl-e", run: UV, shift: rH },
  { key: "Ctrl-d", run: n8 },
  { key: "Ctrl-h", run: yv },
  { key: "Ctrl-k", run: cH },
  { key: "Ctrl-Alt-h", run: i8 },
  { key: "Ctrl-o", run: dH },
  { key: "Ctrl-t", run: hH },
  { key: "Ctrl-v", run: vv }
], $H = /* @__PURE__ */ [
  { key: "ArrowLeft", run: B3, shift: K3, preventDefault: !0 },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: NV, shift: KV, preventDefault: !0 },
  { mac: "Cmd-ArrowLeft", run: FV, shift: eH, preventDefault: !0 },
  { key: "ArrowRight", run: q3, shift: G3, preventDefault: !0 },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: IV, shift: GV, preventDefault: !0 },
  { mac: "Cmd-ArrowRight", run: VV, shift: tH, preventDefault: !0 },
  { key: "ArrowUp", run: V3, shift: X3, preventDefault: !0 },
  { mac: "Cmd-ArrowUp", run: bx, shift: wx },
  { mac: "Ctrl-ArrowUp", run: gx, shift: vx },
  { key: "ArrowDown", run: H3, shift: Z3, preventDefault: !0 },
  { mac: "Cmd-ArrowDown", run: xx, shift: jx },
  { mac: "Ctrl-ArrowDown", run: vv, shift: yx },
  { key: "PageUp", run: gx, shift: vx },
  { key: "PageDown", run: vv, shift: yx },
  { key: "Home", run: zV, shift: ZV, preventDefault: !0 },
  { key: "Mod-Home", run: bx, shift: wx },
  { key: "End", run: qV, shift: XV, preventDefault: !0 },
  { key: "Mod-End", run: xx, shift: jx },
  { key: "Enter", run: xH },
  { key: "Mod-a", run: iH },
  { key: "Backspace", run: yv, shift: yv },
  { key: "Delete", run: n8 },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: i8 },
  { key: "Mod-Delete", mac: "Alt-Delete", run: lH },
  { mac: "Mod-Backspace", run: uH },
  { mac: "Mod-Delete", run: fH }
].concat(/* @__PURE__ */ kH.map((t) => ({ mac: t.key, run: t.run, shift: t.shift }))), SH = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: LV, shift: QV },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: BV, shift: YV },
  { key: "Alt-ArrowUp", run: pH },
  { key: "Shift-Alt-ArrowUp", run: gH },
  { key: "Alt-ArrowDown", run: mH },
  { key: "Shift-Alt-ArrowDown", run: vH },
  { key: "Escape", run: aH },
  { key: "Mod-Enter", run: wH },
  { key: "Alt-l", mac: "Ctrl-l", run: oH },
  { key: "Mod-i", run: sH, preventDefault: !0 },
  { key: "Mod-[", run: c8 },
  { key: "Mod-]", run: l8 },
  { key: "Mod-Alt-\\", run: jH },
  { key: "Shift-Mod-k", run: yH },
  { key: "Shift-Mod-\\", run: JV },
  { key: "Mod-/", run: pV },
  { key: "Alt-A", run: gV }
].concat($H), CH = { key: "Tab", run: l8, shift: c8 };
function Hn() {
  var t = arguments[0];
  typeof t == "string" && (t = document.createElement(t));
  var e = 1, n = arguments[1];
  if (n && typeof n == "object" && n.nodeType == null && !Array.isArray(n)) {
    for (var r in n)
      if (Object.prototype.hasOwnProperty.call(n, r)) {
        var i = n[r];
        typeof i == "string" ? t.setAttribute(r, i) : i != null && (t[r] = i);
      }
    e++;
  }
  for (; e < arguments.length; e++)
    u8(t, arguments[e]);
  return t;
}
function u8(t, e) {
  if (typeof e == "string")
    t.appendChild(document.createTextNode(e));
  else if (e != null)
    if (e.nodeType != null)
      t.appendChild(e);
    else if (Array.isArray(e))
      for (var n = 0; n < e.length; n++)
        u8(t, e[n]);
    else
      throw new RangeError("Unsupported child node: " + e);
}
class OH {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.diagnostic = r;
  }
}
class $a {
  constructor(e, n, r) {
    this.diagnostics = e, this.panel = n, this.selected = r;
  }
  static init(e, n, r) {
    let i = e, o = r.facet(Ma).markerFilter;
    o && (i = o(i));
    let s = Bt.set(i.map((a) => a.from == a.to || a.from == a.to - 1 && r.doc.lineAt(a.from).to == a.from ? Bt.widget({
      widget: new IH(a),
      diagnostic: a
    }).range(a.from) : Bt.mark({
      attributes: { class: "cm-lintRange cm-lintRange-" + a.severity + (a.markClass ? " " + a.markClass : "") },
      diagnostic: a
    }).range(a.from, a.to)), !0);
    return new $a(s, n, Zl(s));
  }
}
function Zl(t, e = null, n = 0) {
  let r = null;
  return t.between(n, 1e9, (i, o, { spec: s }) => {
    if (!(e && s.diagnostic != e))
      return r = new OH(i, o, s.diagnostic), !1;
  }), r;
}
function f8(t, e) {
  let n = t.startState.doc.lineAt(e.pos);
  return !!(t.effects.some((r) => r.is(Pp)) || t.changes.touchesRange(n.from, n.to));
}
function d8(t, e) {
  return t.field(wi, !1) ? e : e.concat(ln.appendConfig.of(b8));
}
function EH(t, e) {
  return {
    effects: d8(t, [Pp.of(e)])
  };
}
const Pp = /* @__PURE__ */ ln.define(), u1 = /* @__PURE__ */ ln.define(), h8 = /* @__PURE__ */ ln.define(), wi = /* @__PURE__ */ Cr.define({
  create() {
    return new $a(Bt.none, null, null);
  },
  update(t, e) {
    if (e.docChanged) {
      let n = t.diagnostics.map(e.changes), r = null;
      if (t.selected) {
        let i = e.changes.mapPos(t.selected.from, 1);
        r = Zl(n, t.selected.diagnostic, i) || Zl(n, null, i);
      }
      t = new $a(n, t.panel, r);
    }
    for (let n of e.effects)
      n.is(Pp) ? t = $a.init(n.value, t.panel, e.state) : n.is(u1) ? t = new $a(t.diagnostics, n.value ? Rp.open : null, t.selected) : n.is(h8) && (t = new $a(t.diagnostics, t.panel, n.value));
    return t;
  },
  provide: (t) => [
    Nu.from(t, (e) => e.panel),
    at.decorations.from(t, (e) => e.diagnostics)
  ]
}), AH = /* @__PURE__ */ Bt.mark({ class: "cm-lintRange cm-lintRange-active" });
function MH(t, e, n) {
  let { diagnostics: r } = t.state.field(wi), i = [], o = 2e8, s = 0;
  r.between(e - (n < 0 ? 1 : 0), e + (n > 0 ? 1 : 0), (l, c, { spec: u }) => {
    e >= l && e <= c && (l == c || (e > l || n > 0) && (e < c || n < 0)) && (i.push(u.diagnostic), o = Math.min(l, o), s = Math.max(c, s));
  });
  let a = t.state.facet(Ma).tooltipFilter;
  return a && (i = a(i)), i.length ? {
    pos: o,
    end: s,
    above: t.state.doc.lineAt(o).to < s,
    create() {
      return { dom: p8(t, i) };
    }
  } : null;
}
function p8(t, e) {
  return Hn("ul", { class: "cm-tooltip-lint" }, e.map((n) => g8(t, n, !1)));
}
const _H = (t) => {
  let e = t.state.field(wi, !1);
  (!e || !e.panel) && t.dispatch({ effects: d8(t.state, [u1.of(!0)]) });
  let n = Ru(t, Rp.open);
  return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
}, kx = (t) => {
  let e = t.state.field(wi, !1);
  return !e || !e.panel ? !1 : (t.dispatch({ effects: u1.of(!1) }), !0);
}, TH = (t) => {
  let e = t.state.field(wi, !1);
  if (!e)
    return !1;
  let n = t.state.selection.main, r = e.diagnostics.iter(n.to + 1);
  return !r.value && (r = e.diagnostics.iter(0), !r.value || r.from == n.from && r.to == n.to) ? !1 : (t.dispatch({ selection: { anchor: r.from, head: r.to }, scrollIntoView: !0 }), !0);
}, PH = [
  { key: "Mod-Shift-m", run: _H, preventDefault: !0 },
  { key: "F8", run: TH }
], RH = /* @__PURE__ */ ur.fromClass(class {
  constructor(t) {
    this.view = t, this.timeout = -1, this.set = !0;
    let { delay: e } = t.state.facet(Ma);
    this.lintTime = Date.now() + e, this.run = this.run.bind(this), this.timeout = setTimeout(this.run, e);
  }
  run() {
    let t = Date.now();
    if (t < this.lintTime - 10)
      this.timeout = setTimeout(this.run, this.lintTime - t);
    else {
      this.set = !1;
      let { state: e } = this.view, { sources: n } = e.facet(Ma);
      Promise.all(n.map((r) => Promise.resolve(r(this.view)))).then((r) => {
        let i = r.reduce((o, s) => o.concat(s));
        this.view.state.doc == e.doc && this.view.dispatch(EH(this.view.state, i));
      }, (r) => {
        $i(this.view.state, r);
      });
    }
  }
  update(t) {
    let e = t.state.facet(Ma);
    (t.docChanged || e != t.startState.facet(Ma) || e.needsRefresh && e.needsRefresh(t)) && (this.lintTime = Date.now() + e.delay, this.set || (this.set = !0, this.timeout = setTimeout(this.run, e.delay)));
  }
  force() {
    this.set && (this.lintTime = Date.now(), this.run());
  }
  destroy() {
    clearTimeout(this.timeout);
  }
}), Ma = /* @__PURE__ */ vt.define({
  combine(t) {
    return Object.assign({ sources: t.map((e) => e.source) }, Ui(t.map((e) => e.config), {
      delay: 750,
      markerFilter: null,
      tooltipFilter: null,
      needsRefresh: null
    }, {
      needsRefresh: (e, n) => e ? n ? (r) => e(r) || n(r) : e : n
    }));
  }
});
function NH(t, e = {}) {
  return [
    Ma.of({ source: t, config: e }),
    RH,
    b8
  ];
}
function m8(t) {
  let e = [];
  if (t)
    e:
      for (let { name: n } of t) {
        for (let r = 0; r < n.length; r++) {
          let i = n[r];
          if (/[a-zA-Z]/.test(i) && !e.some((o) => o.toLowerCase() == i.toLowerCase())) {
            e.push(i);
            continue e;
          }
        }
        e.push("");
      }
  return e;
}
function g8(t, e, n) {
  var r;
  let i = n ? m8(e.actions) : [];
  return Hn("li", { class: "cm-diagnostic cm-diagnostic-" + e.severity }, Hn("span", { class: "cm-diagnosticText" }, e.renderMessage ? e.renderMessage() : e.message), (r = e.actions) === null || r === void 0 ? void 0 : r.map((o, s) => {
    let a = !1, l = (d) => {
      if (d.preventDefault(), a)
        return;
      a = !0;
      let h = Zl(t.state.field(wi).diagnostics, e);
      h && o.apply(t, h.from, h.to);
    }, { name: c } = o, u = i[s] ? c.indexOf(i[s]) : -1, f = u < 0 ? c : [
      c.slice(0, u),
      Hn("u", c.slice(u, u + 1)),
      c.slice(u + 1)
    ];
    return Hn("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: l,
      onmousedown: l,
      "aria-label": ` Action: ${c}${u < 0 ? "" : ` (access key "${i[s]})"`}.`
    }, f);
  }), e.source && Hn("div", { class: "cm-diagnosticSource" }, e.source));
}
class IH extends ua {
  constructor(e) {
    super(), this.diagnostic = e;
  }
  eq(e) {
    return e.diagnostic == this.diagnostic;
  }
  toDOM() {
    return Hn("span", { class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity });
  }
}
class $x {
  constructor(e, n) {
    this.diagnostic = n, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = g8(e, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class Rp {
  constructor(e) {
    this.view = e, this.items = [];
    let n = (i) => {
      if (i.keyCode == 27)
        kx(this.view), this.view.focus();
      else if (i.keyCode == 38 || i.keyCode == 33)
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      else if (i.keyCode == 40 || i.keyCode == 34)
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      else if (i.keyCode == 36)
        this.moveSelection(0);
      else if (i.keyCode == 35)
        this.moveSelection(this.items.length - 1);
      else if (i.keyCode == 13)
        this.view.focus();
      else if (i.keyCode >= 65 && i.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: o } = this.items[this.selectedIndex], s = m8(o.actions);
        for (let a = 0; a < s.length; a++)
          if (s[a].toUpperCase().charCodeAt(0) == i.keyCode) {
            let l = Zl(this.view.state.field(wi).diagnostics, o);
            l && o.actions[a].apply(e, l.from, l.to);
          }
      } else
        return;
      i.preventDefault();
    }, r = (i) => {
      for (let o = 0; o < this.items.length; o++)
        this.items[o].dom.contains(i.target) && this.moveSelection(o);
    };
    this.list = Hn("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown: n,
      onclick: r
    }), this.dom = Hn("div", { class: "cm-panel-lint" }, this.list, Hn("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => kx(this.view)
    }, "×")), this.update();
  }
  get selectedIndex() {
    let e = this.view.state.field(wi).selected;
    if (!e)
      return -1;
    for (let n = 0; n < this.items.length; n++)
      if (this.items[n].diagnostic == e.diagnostic)
        return n;
    return -1;
  }
  update() {
    let { diagnostics: e, selected: n } = this.view.state.field(wi), r = 0, i = !1, o = null;
    for (e.between(0, this.view.state.doc.length, (s, a, { spec: l }) => {
      let c = -1, u;
      for (let f = r; f < this.items.length; f++)
        if (this.items[f].diagnostic == l.diagnostic) {
          c = f;
          break;
        }
      c < 0 ? (u = new $x(this.view, l.diagnostic), this.items.splice(r, 0, u), i = !0) : (u = this.items[c], c > r && (this.items.splice(r, c - r), i = !0)), n && u.diagnostic == n.diagnostic ? u.dom.hasAttribute("aria-selected") || (u.dom.setAttribute("aria-selected", "true"), o = u) : u.dom.hasAttribute("aria-selected") && u.dom.removeAttribute("aria-selected"), r++;
    }); r < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      i = !0, this.items.pop();
    this.items.length == 0 && (this.items.push(new $x(this.view, {
      from: -1,
      to: -1,
      severity: "info",
      message: this.view.state.phrase("No diagnostics")
    })), i = !0), o ? (this.list.setAttribute("aria-activedescendant", o.id), this.view.requestMeasure({
      key: this,
      read: () => ({ sel: o.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
      write: ({ sel: s, panel: a }) => {
        let l = a.height / this.list.offsetHeight;
        s.top < a.top ? this.list.scrollTop -= (a.top - s.top) / l : s.bottom > a.bottom && (this.list.scrollTop += (s.bottom - a.bottom) / l);
      }
    })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), i && this.sync();
  }
  sync() {
    let e = this.list.firstChild;
    function n() {
      let r = e;
      e = r.nextSibling, r.remove();
    }
    for (let r of this.items)
      if (r.dom.parentNode == this.list) {
        for (; e != r.dom; )
          n();
        e = r.dom.nextSibling;
      } else
        this.list.insertBefore(r.dom, e);
    for (; e; )
      n();
  }
  moveSelection(e) {
    if (this.selectedIndex < 0)
      return;
    let n = this.view.state.field(wi), r = Zl(n.diagnostics, this.items[e].diagnostic);
    r && this.view.dispatch({
      selection: { anchor: r.from, head: r.to },
      scrollIntoView: !0,
      effects: h8.of(r)
    });
  }
  static open(e) {
    return new Rp(e);
  }
}
function Ld(t, e = 'viewBox="0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${e}>${encodeURIComponent(t)}</svg>')`;
}
function Zf(t) {
  return Ld(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${t}" fill="none" stroke-width=".7"/>`, 'width="6" height="3"');
}
const DH = /* @__PURE__ */ at.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ Zf("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ Zf("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ Zf("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ Zf("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
});
function Sx(t) {
  return t == "error" ? 4 : t == "warning" ? 3 : t == "info" ? 2 : 1;
}
class LH extends Vo {
  constructor(e) {
    super(), this.diagnostics = e, this.severity = e.reduce((n, r) => Sx(n) < Sx(r.severity) ? r.severity : n, "hint");
  }
  toDOM(e) {
    let n = document.createElement("div");
    n.className = "cm-lint-marker cm-lint-marker-" + this.severity;
    let r = this.diagnostics, i = e.state.facet(Np).tooltipFilter;
    return i && (r = i(r)), r.length && (n.onmouseover = () => qH(e, n, r)), n;
  }
}
function BH(t, e) {
  let n = (r) => {
    let i = e.getBoundingClientRect();
    if (!(r.clientX > i.left - 10 && r.clientX < i.right + 10 && r.clientY > i.top - 10 && r.clientY < i.bottom + 10)) {
      for (let o = r.target; o; o = o.parentNode)
        if (o.nodeType == 1 && o.classList.contains("cm-tooltip-lint"))
          return;
      window.removeEventListener("mousemove", n), t.state.field(y8) && t.dispatch({ effects: f1.of(null) });
    }
  };
  window.addEventListener("mousemove", n);
}
function qH(t, e, n) {
  function r() {
    let s = t.elementAtHeight(e.getBoundingClientRect().top + 5 - t.documentTop);
    t.coordsAtPos(s.from) && t.dispatch({ effects: f1.of({
      pos: s.from,
      above: !1,
      create() {
        return {
          dom: p8(t, n),
          getCoords: () => e.getBoundingClientRect()
        };
      }
    }) }), e.onmouseout = e.onmousemove = null, BH(t, e);
  }
  let { hoverTime: i } = t.state.facet(Np), o = setTimeout(r, i);
  e.onmouseout = () => {
    clearTimeout(o), e.onmouseout = e.onmousemove = null;
  }, e.onmousemove = () => {
    clearTimeout(o), o = setTimeout(r, i);
  };
}
function zH(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let i of e) {
    let o = t.lineAt(i.from);
    (n[o.from] || (n[o.from] = [])).push(i);
  }
  let r = [];
  for (let i in n)
    r.push(new LH(n[i]).range(+i));
  return En.of(r, !0);
}
const FH = /* @__PURE__ */ a3({
  class: "cm-gutter-lint",
  markers: (t) => t.state.field(v8)
}), v8 = /* @__PURE__ */ Cr.define({
  create() {
    return En.empty;
  },
  update(t, e) {
    t = t.map(e.changes);
    let n = e.state.facet(Np).markerFilter;
    for (let r of e.effects)
      if (r.is(Pp)) {
        let i = r.value;
        n && (i = n(i || [])), t = zH(e.state.doc, i.slice(0));
      }
    return t;
  }
}), f1 = /* @__PURE__ */ ln.define(), y8 = /* @__PURE__ */ Cr.define({
  create() {
    return null;
  },
  update(t, e) {
    return t && e.docChanged && (t = f8(e, t) ? null : Object.assign(Object.assign({}, t), { pos: e.changes.mapPos(t.pos) })), e.effects.reduce((n, r) => r.is(f1) ? r.value : n, t);
  },
  provide: (t) => $p.from(t)
}), VH = /* @__PURE__ */ at.baseTheme({
  ".cm-gutter-lint": {
    width: "1.4em",
    "& .cm-gutterElement": {
      padding: ".2em"
    }
  },
  ".cm-lint-marker": {
    width: "1em",
    height: "1em"
  },
  ".cm-lint-marker-info": {
    content: /* @__PURE__ */ Ld('<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>')
  },
  ".cm-lint-marker-warning": {
    content: /* @__PURE__ */ Ld('<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>')
  },
  ".cm-lint-marker-error": {
    content: /* @__PURE__ */ Ld('<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>')
  }
}), b8 = [
  wi,
  /* @__PURE__ */ at.decorations.compute([wi], (t) => {
    let { selected: e, panel: n } = t.field(wi);
    return !e || !n || e.from == e.to ? Bt.none : Bt.set([
      AH.range(e.from, e.to)
    ]);
  }),
  /* @__PURE__ */ Gz(MH, { hideOn: f8 }),
  DH
], Np = /* @__PURE__ */ vt.define({
  combine(t) {
    return Ui(t, {
      hoverTime: 300,
      markerFilter: null,
      tooltipFilter: null
    });
  }
});
function HH(t = {}) {
  return [Np.of(t), v8, FH, VH, y8];
}
class wh {
  /**
  @internal
  */
  constructor(e, n, r, i, o, s, a, l, c, u = 0, f) {
    this.p = e, this.stack = n, this.state = r, this.reducePos = i, this.pos = o, this.score = s, this.buffer = a, this.bufferBase = l, this.curContext = c, this.lookAhead = u, this.parent = f;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((e, n) => n % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(e, n, r = 0) {
    let i = e.parser.context;
    return new wh(e, [], n, r, r, 0, [], 0, i ? new Cx(i, i.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(e, n) {
    this.stack.push(this.state, n, this.bufferBase + this.buffer.length), this.state = e;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(e) {
    var n;
    let r = e >> 19, i = e & 65535, { parser: o } = this.p, s = o.dynamicPrecedence(i);
    if (s && (this.score += s), r == 0) {
      this.pushState(o.getGoto(this.state, i, !0), this.reducePos), i < o.minRepeatTerm && this.storeNode(i, this.reducePos, this.reducePos, 4, !0), this.reduceContext(i, this.reducePos);
      return;
    }
    let a = this.stack.length - (r - 1) * 3 - (e & 262144 ? 6 : 0), l = a ? this.stack[a - 2] : this.p.ranges[0].from, c = this.reducePos - l;
    c >= 2e3 && !(!((n = this.p.parser.nodeSet.types[i]) === null || n === void 0) && n.isAnonymous) && (l == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = c) : this.p.lastBigReductionSize < c && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = l, this.p.lastBigReductionSize = c));
    let u = a ? this.stack[a - 1] : 0, f = this.bufferBase + this.buffer.length - u;
    if (i < o.minRepeatTerm || e & 131072) {
      let d = o.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(i, l, d, f + 4, !0);
    }
    if (e & 262144)
      this.state = this.stack[a];
    else {
      let d = this.stack[a - 3];
      this.state = o.getGoto(d, i, !0);
    }
    for (; this.stack.length > a; )
      this.stack.pop();
    this.reduceContext(i, l);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(e, n, r, i = 4, o = !1) {
    if (e == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let s = this, a = this.buffer.length;
      if (a == 0 && s.parent && (a = s.bufferBase - s.parent.bufferBase, s = s.parent), a > 0 && s.buffer[a - 4] == 0 && s.buffer[a - 1] > -1) {
        if (n == r)
          return;
        if (s.buffer[a - 2] >= n) {
          s.buffer[a - 2] = r;
          return;
        }
      }
    }
    if (!o || this.pos == r)
      this.buffer.push(e, n, r, i);
    else {
      let s = this.buffer.length;
      if (s > 0 && this.buffer[s - 4] != 0)
        for (; s > 0 && this.buffer[s - 2] > r; )
          this.buffer[s] = this.buffer[s - 4], this.buffer[s + 1] = this.buffer[s - 3], this.buffer[s + 2] = this.buffer[s - 2], this.buffer[s + 3] = this.buffer[s - 1], s -= 4, i > 4 && (i -= 4);
      this.buffer[s] = e, this.buffer[s + 1] = n, this.buffer[s + 2] = r, this.buffer[s + 3] = i;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(e, n, r, i) {
    if (e & 131072)
      this.pushState(e & 65535, this.pos);
    else if (e & 262144)
      this.pos = i, this.shiftContext(n, r), n <= this.p.parser.maxNode && this.buffer.push(n, r, i, 4);
    else {
      let o = e, { parser: s } = this.p;
      (i > this.pos || n <= s.maxNode) && (this.pos = i, s.stateFlag(
        o,
        1
        /* StateFlag.Skipped */
      ) || (this.reducePos = i)), this.pushState(o, r), this.shiftContext(n, r), n <= s.maxNode && this.buffer.push(n, r, i, 4);
    }
  }
  // Apply an action
  /**
  @internal
  */
  apply(e, n, r, i) {
    e & 65536 ? this.reduce(e) : this.shift(e, n, r, i);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(e, n) {
    let r = this.p.reused.length - 1;
    (r < 0 || this.p.reused[r] != e) && (this.p.reused.push(e), r++);
    let i = this.pos;
    this.reducePos = this.pos = i + e.length, this.pushState(n, i), this.buffer.push(
      r,
      i,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    ), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, e, this, this.p.stream.reset(this.pos - e.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let e = this, n = e.buffer.length;
    for (; n > 0 && e.buffer[n - 2] > e.reducePos; )
      n -= 4;
    let r = e.buffer.slice(n), i = e.bufferBase + n;
    for (; e && i == e.bufferBase; )
      e = e.parent;
    return new wh(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, i, this.curContext, this.lookAhead, e);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(e, n) {
    let r = e <= this.p.parser.maxNode;
    r && this.storeNode(e, this.pos, n, 4), this.storeNode(0, this.pos, n, r ? 8 : 4), this.pos = this.reducePos = n, this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(e) {
    for (let n = new UH(this); ; ) {
      let r = this.p.parser.stateSlot(
        n.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(n.state, e);
      if (r == 0)
        return !1;
      if (!(r & 65536))
        return !0;
      n.reduce(r);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(e) {
    if (this.stack.length >= 300)
      return [];
    let n = this.p.parser.nextStates(this.state);
    if (n.length > 8 || this.stack.length >= 120) {
      let i = [];
      for (let o = 0, s; o < n.length; o += 2)
        (s = n[o + 1]) != this.state && this.p.parser.hasAction(s, e) && i.push(n[o], s);
      if (this.stack.length < 120)
        for (let o = 0; i.length < 8 && o < n.length; o += 2) {
          let s = n[o + 1];
          i.some((a, l) => l & 1 && a == s) || i.push(n[o], s);
        }
      n = i;
    }
    let r = [];
    for (let i = 0; i < n.length && r.length < 4; i += 2) {
      let o = n[i + 1];
      if (o == this.state)
        continue;
      let s = this.split();
      s.pushState(o, this.pos), s.storeNode(0, s.pos, s.pos, 4, !0), s.shiftContext(n[i], this.pos), s.reducePos = this.pos, s.score -= 200, r.push(s);
    }
    return r;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: e } = this.p, n = e.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if (!(n & 65536))
      return !1;
    if (!e.validAction(this.state, n)) {
      let r = n >> 19, i = n & 65535, o = this.stack.length - r * 3;
      if (o < 0 || e.getGoto(this.stack[o], i, !1) < 0) {
        let s = this.findForcedReduction();
        if (s == null)
          return !1;
        n = s;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(n), !0;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: e } = this.p, n = [], r = (i, o) => {
      if (!n.includes(i))
        return n.push(i), e.allActions(i, (s) => {
          if (!(s & 393216))
            if (s & 65536) {
              let a = (s >> 19) - o;
              if (a > 1) {
                let l = s & 65535, c = this.stack.length - a * 3;
                if (c >= 0 && e.getGoto(this.stack[c], l, !1) >= 0)
                  return a << 19 | 65536 | l;
              }
            } else {
              let a = r(s, o + 1);
              if (a != null)
                return a;
            }
        });
    };
    return r(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    for (; !this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    ); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return !1;
    let { parser: e } = this.p;
    return e.data[e.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !e.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(e) {
    if (this.state != e.state || this.stack.length != e.stack.length)
      return !1;
    for (let n = 0; n < this.stack.length; n += 3)
      if (this.stack[n] != e.stack[n])
        return !1;
    return !0;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(e) {
    return this.p.parser.dialect.flags[e];
  }
  shiftContext(e, n) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(n)));
  }
  reduceContext(e, n) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(n)));
  }
  /**
  @internal
  */
  emitContext() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(e) {
    if (e != this.curContext.context) {
      let n = new Cx(this.curContext.tracker, e);
      n.hash != this.curContext.hash && this.emitContext(), this.curContext = n;
    }
  }
  /**
  @internal
  */
  setLookAhead(e) {
    e > this.lookAhead && (this.emitLookAhead(), this.lookAhead = e);
  }
  /**
  @internal
  */
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
}
class Cx {
  constructor(e, n) {
    this.tracker = e, this.context = n, this.hash = e.strict ? e.hash(n) : 0;
  }
}
class UH {
  constructor(e) {
    this.start = e, this.state = e.state, this.stack = e.stack, this.base = this.stack.length;
  }
  reduce(e) {
    let n = e & 65535, r = e >> 19;
    r == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (r - 1) * 3;
    let i = this.start.p.parser.getGoto(this.stack[this.base - 3], n, !0);
    this.state = i;
  }
}
class jh {
  constructor(e, n, r) {
    this.stack = e, this.pos = n, this.index = r, this.buffer = e.buffer, this.index == 0 && this.maybeNext();
  }
  static create(e, n = e.bufferBase + e.buffer.length) {
    return new jh(e, n, n - e.bufferBase);
  }
  maybeNext() {
    let e = this.stack.parent;
    e != null && (this.index = this.stack.bufferBase - e.bufferBase, this.stack = e, this.buffer = e.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new jh(this.stack, this.pos, this.index);
  }
}
function ed(t, e = Uint16Array) {
  if (typeof t != "string")
    return t;
  let n = null;
  for (let r = 0, i = 0; r < t.length; ) {
    let o = 0;
    for (; ; ) {
      let s = t.charCodeAt(r++), a = !1;
      if (s == 126) {
        o = 65535;
        break;
      }
      s >= 92 && s--, s >= 34 && s--;
      let l = s - 32;
      if (l >= 46 && (l -= 46, a = !0), o += l, a)
        break;
      o *= 46;
    }
    n ? n[i++] = o : n = new e(o);
  }
  return n;
}
class Bd {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const Ox = new Bd();
class WH {
  /**
  @internal
  */
  constructor(e, n) {
    this.input = e, this.ranges = n, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = Ox, this.rangeIndex = 0, this.pos = this.chunkPos = n[0].from, this.range = n[0], this.end = n[n.length - 1].to, this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(e, n) {
    let r = this.range, i = this.rangeIndex, o = this.pos + e;
    for (; o < r.from; ) {
      if (!i)
        return null;
      let s = this.ranges[--i];
      o -= r.from - s.to, r = s;
    }
    for (; n < 0 ? o > r.to : o >= r.to; ) {
      if (i == this.ranges.length - 1)
        return null;
      let s = this.ranges[++i];
      o += s.from - r.to, r = s;
    }
    return o;
  }
  /**
  @internal
  */
  clipPos(e) {
    if (e >= this.range.from && e < this.range.to)
      return e;
    for (let n of this.ranges)
      if (n.to > e)
        return Math.max(e, n.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(e) {
    let n = this.chunkOff + e, r, i;
    if (n >= 0 && n < this.chunk.length)
      r = this.pos + e, i = this.chunk.charCodeAt(n);
    else {
      let o = this.resolveOffset(e, 1);
      if (o == null)
        return -1;
      if (r = o, r >= this.chunk2Pos && r < this.chunk2Pos + this.chunk2.length)
        i = this.chunk2.charCodeAt(r - this.chunk2Pos);
      else {
        let s = this.rangeIndex, a = this.range;
        for (; a.to <= r; )
          a = this.ranges[++s];
        this.chunk2 = this.input.chunk(this.chunk2Pos = r), r + this.chunk2.length > a.to && (this.chunk2 = this.chunk2.slice(0, a.to - r)), i = this.chunk2.charCodeAt(0);
      }
    }
    return r >= this.token.lookAhead && (this.token.lookAhead = r + 1), i;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(e, n = 0) {
    let r = n ? this.resolveOffset(n, -1) : this.pos;
    if (r == null || r < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = e, this.token.end = r;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: e, chunkPos: n } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = e, this.chunk2Pos = n, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let e = this.input.chunk(this.pos), n = this.pos + e.length;
      this.chunk = n > this.range.to ? e.slice(0, this.range.to - this.pos) : e, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(e = 1) {
    for (this.chunkOff += e; this.pos + e >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      e -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += e, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  /**
  @internal
  */
  reset(e, n) {
    if (n ? (this.token = n, n.start = e, n.lookAhead = e + 1, n.value = n.extended = -1) : this.token = Ox, this.pos != e) {
      if (this.pos = e, e == this.end)
        return this.setDone(), this;
      for (; e < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; e >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      e >= this.chunkPos && e < this.chunkPos + this.chunk.length ? this.chunkOff = e - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(e, n) {
    if (e >= this.chunkPos && n <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(e - this.chunkPos, n - this.chunkPos);
    if (e >= this.chunk2Pos && n <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(e - this.chunk2Pos, n - this.chunk2Pos);
    if (e >= this.range.from && n <= this.range.to)
      return this.input.read(e, n);
    let r = "";
    for (let i of this.ranges) {
      if (i.from >= n)
        break;
      i.to > e && (r += this.input.read(Math.max(i.from, e), Math.min(i.to, n)));
    }
    return r;
  }
}
class Dl {
  constructor(e, n) {
    this.data = e, this.id = n;
  }
  token(e, n) {
    let { parser: r } = n.p;
    JH(this.data, e, n, this.id, r.data, r.tokenPrecTable);
  }
}
Dl.prototype.contextual = Dl.prototype.fallback = Dl.prototype.extend = !1;
Dl.prototype.fallback = Dl.prototype.extend = !1;
function JH(t, e, n, r, i, o) {
  let s = 0, a = 1 << r, { dialect: l } = n.p.parser;
  e:
    for (; a & t[s]; ) {
      let c = t[s + 1];
      for (let h = s + 3; h < c; h += 2)
        if ((t[h + 1] & a) > 0) {
          let p = t[h];
          if (l.allows(p) && (e.token.value == -1 || e.token.value == p || KH(p, e.token.value, i, o))) {
            e.acceptToken(p);
            break;
          }
        }
      let u = e.next, f = 0, d = t[s + 2];
      if (e.next < 0 && d > f && t[c + d * 3 - 3] == 65535) {
        s = t[c + d * 3 - 1];
        continue e;
      }
      for (; f < d; ) {
        let h = f + d >> 1, p = c + h + (h << 1), m = t[p], g = t[p + 1] || 65536;
        if (u < m)
          d = h;
        else if (u >= g)
          f = h + 1;
        else {
          s = t[p + 2], e.advance();
          continue e;
        }
      }
      break;
    }
}
function Ex(t, e, n) {
  for (let r = e, i; (i = t[r]) != 65535; r++)
    if (i == n)
      return r - e;
  return -1;
}
function KH(t, e, n, r) {
  let i = Ex(n, r, e);
  return i < 0 || Ex(n, r, t) < i;
}
const gi = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let Rm = null;
function Ax(t, e, n) {
  let r = t.cursor(Er.IncludeAnonymous);
  for (r.moveTo(e); ; )
    if (!(n < 0 ? r.childBefore(e) : r.childAfter(e)))
      for (; ; ) {
        if ((n < 0 ? r.to < e : r.from > e) && !r.type.isError)
          return n < 0 ? Math.max(0, Math.min(
            r.to - 1,
            e - 25
            /* Safety.Margin */
          )) : Math.min(t.length, Math.max(
            r.from + 1,
            e + 25
            /* Safety.Margin */
          ));
        if (n < 0 ? r.prevSibling() : r.nextSibling())
          break;
        if (!r.parent())
          return n < 0 ? 0 : t.length;
      }
}
class GH {
  constructor(e, n) {
    this.fragments = e, this.nodeSet = n, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let e = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (e) {
      for (this.safeFrom = e.openStart ? Ax(e.tree, e.from + e.offset, 1) - e.offset : e.from, this.safeTo = e.openEnd ? Ax(e.tree, e.to + e.offset, -1) - e.offset : e.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(e.tree), this.start.push(-e.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(e) {
    if (e < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= e; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let n = this.trees.length - 1;
      if (n < 0)
        return this.nextFragment(), null;
      let r = this.trees[n], i = this.index[n];
      if (i == r.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let o = r.children[i], s = this.start[n] + r.positions[i];
      if (s > e)
        return this.nextStart = s, null;
      if (o instanceof xr) {
        if (s == e) {
          if (s < this.safeFrom)
            return null;
          let a = s + o.length;
          if (a <= this.safeTo) {
            let l = o.prop(bn.lookAhead);
            if (!l || a + l < this.fragment.to)
              return o;
          }
        }
        this.index[n]++, s + o.length >= Math.max(this.safeFrom, e) && (this.trees.push(o), this.start.push(s), this.index.push(0));
      } else
        this.index[n]++, this.nextStart = s + o.length;
    }
  }
}
class QH {
  constructor(e, n) {
    this.stream = n, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = e.tokenizers.map((r) => new Bd());
  }
  getActions(e) {
    let n = 0, r = null, { parser: i } = e.p, { tokenizers: o } = i, s = i.stateSlot(
      e.state,
      3
      /* ParseState.TokenizerMask */
    ), a = e.curContext ? e.curContext.hash : 0, l = 0;
    for (let c = 0; c < o.length; c++) {
      if (!(1 << c & s))
        continue;
      let u = o[c], f = this.tokens[c];
      if (!(r && !u.fallback) && ((u.contextual || f.start != e.pos || f.mask != s || f.context != a) && (this.updateCachedToken(f, u, e), f.mask = s, f.context = a), f.lookAhead > f.end + 25 && (l = Math.max(f.lookAhead, l)), f.value != 0)) {
        let d = n;
        if (f.extended > -1 && (n = this.addActions(e, f.extended, f.end, n)), n = this.addActions(e, f.value, f.end, n), !u.extend && (r = f, n > d))
          break;
      }
    }
    for (; this.actions.length > n; )
      this.actions.pop();
    return l && e.setLookAhead(l), !r && e.pos == this.stream.end && (r = new Bd(), r.value = e.p.parser.eofTerm, r.start = r.end = e.pos, n = this.addActions(e, r.value, r.end, n)), this.mainToken = r, this.actions;
  }
  getMainToken(e) {
    if (this.mainToken)
      return this.mainToken;
    let n = new Bd(), { pos: r, p: i } = e;
    return n.start = r, n.end = Math.min(r + 1, i.stream.end), n.value = r == i.stream.end ? i.parser.eofTerm : 0, n;
  }
  updateCachedToken(e, n, r) {
    let i = this.stream.clipPos(r.pos);
    if (n.token(this.stream.reset(i, e), r), e.value > -1) {
      let { parser: o } = r.p;
      for (let s = 0; s < o.specialized.length; s++)
        if (o.specialized[s] == e.value) {
          let a = o.specializers[s](this.stream.read(e.start, e.end), r);
          if (a >= 0 && r.p.parser.dialect.allows(a >> 1)) {
            a & 1 ? e.extended = a >> 1 : e.value = a >> 1;
            break;
          }
        }
    } else
      e.value = 0, e.end = this.stream.clipPos(i + 1);
  }
  putAction(e, n, r, i) {
    for (let o = 0; o < i; o += 3)
      if (this.actions[o] == e)
        return i;
    return this.actions[i++] = e, this.actions[i++] = n, this.actions[i++] = r, i;
  }
  addActions(e, n, r, i) {
    let { state: o } = e, { parser: s } = e.p, { data: a } = s;
    for (let l = 0; l < 2; l++)
      for (let c = s.stateSlot(
        o,
        l ? 2 : 1
        /* ParseState.Actions */
      ); ; c += 3) {
        if (a[c] == 65535)
          if (a[c + 1] == 1)
            c = es(a, c + 2);
          else {
            i == 0 && a[c + 1] == 2 && (i = this.putAction(es(a, c + 2), n, r, i));
            break;
          }
        a[c] == n && (i = this.putAction(es(a, c + 1), n, r, i));
      }
    return i;
  }
}
class YH {
  constructor(e, n, r, i) {
    this.parser = e, this.input = n, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new WH(n, i), this.tokens = new QH(e, this.stream), this.topTerm = e.top[1];
    let { from: o } = i[0];
    this.stacks = [wh.start(this, e.top[0], o)], this.fragments = r.length && this.stream.end - o > e.bufferLength * 4 ? new GH(r, e.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let e = this.stacks, n = this.minStackPos, r = this.stacks = [], i, o;
    if (this.bigReductionCount > 300 && e.length == 1) {
      let [s] = e;
      for (; s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let s = 0; s < e.length; s++) {
      let a = e[s];
      for (; ; ) {
        if (this.tokens.mainToken = null, a.pos > n)
          r.push(a);
        else {
          if (this.advanceStack(a, r, e))
            continue;
          {
            i || (i = [], o = []), i.push(a);
            let l = this.tokens.getMainToken(a);
            o.push(l.value, l.end);
          }
        }
        break;
      }
    }
    if (!r.length) {
      let s = i && ZH(i);
      if (s)
        return gi && console.log("Finish with " + this.stackID(s)), this.stackToTree(s);
      if (this.parser.strict)
        throw gi && i && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + n);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && i) {
      let s = this.stoppedAt != null && i[0].pos > this.stoppedAt ? i[0] : this.runRecovery(i, o, r);
      if (s)
        return gi && console.log("Force-finish " + this.stackID(s)), this.stackToTree(s.forceAll());
    }
    if (this.recovering) {
      let s = this.recovering == 1 ? 1 : this.recovering * 3;
      if (r.length > s)
        for (r.sort((a, l) => l.score - a.score); r.length > s; )
          r.pop();
      r.some((a) => a.reducePos > n) && this.recovering--;
    } else if (r.length > 1) {
      e:
        for (let s = 0; s < r.length - 1; s++) {
          let a = r[s];
          for (let l = s + 1; l < r.length; l++) {
            let c = r[l];
            if (a.sameState(c) || a.buffer.length > 500 && c.buffer.length > 500)
              if ((a.score - c.score || a.buffer.length - c.buffer.length) > 0)
                r.splice(l--, 1);
              else {
                r.splice(s--, 1);
                continue e;
              }
          }
        }
      r.length > 12 && r.splice(
        12,
        r.length - 12
        /* Rec.MaxStackCount */
      );
    }
    this.minStackPos = r[0].pos;
    for (let s = 1; s < r.length; s++)
      r[s].pos < this.minStackPos && (this.minStackPos = r[s].pos);
    return null;
  }
  stopAt(e) {
    if (this.stoppedAt != null && this.stoppedAt < e)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = e;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(e, n, r) {
    let i = e.pos, { parser: o } = this, s = gi ? this.stackID(e) + " -> " : "";
    if (this.stoppedAt != null && i > this.stoppedAt)
      return e.forceReduce() ? e : null;
    if (this.fragments) {
      let c = e.curContext && e.curContext.tracker.strict, u = c ? e.curContext.hash : 0;
      for (let f = this.fragments.nodeAt(i); f; ) {
        let d = this.parser.nodeSet.types[f.type.id] == f.type ? o.getGoto(e.state, f.type.id) : -1;
        if (d > -1 && f.length && (!c || (f.prop(bn.contextHash) || 0) == u))
          return e.useNode(f, d), gi && console.log(s + this.stackID(e) + ` (via reuse of ${o.getName(f.type.id)})`), !0;
        if (!(f instanceof xr) || f.children.length == 0 || f.positions[0] > 0)
          break;
        let h = f.children[0];
        if (h instanceof xr && f.positions[0] == 0)
          f = h;
        else
          break;
      }
    }
    let a = o.stateSlot(
      e.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (a > 0)
      return e.reduce(a), gi && console.log(s + this.stackID(e) + ` (via always-reduce ${o.getName(
        a & 65535
        /* Action.ValueMask */
      )})`), !0;
    if (e.stack.length >= 8400)
      for (; e.stack.length > 6e3 && e.forceReduce(); )
        ;
    let l = this.tokens.getActions(e);
    for (let c = 0; c < l.length; ) {
      let u = l[c++], f = l[c++], d = l[c++], h = c == l.length || !r, p = h ? e : e.split(), m = this.tokens.mainToken;
      if (p.apply(u, f, m ? m.start : p.pos, d), gi && console.log(s + this.stackID(p) + ` (via ${u & 65536 ? `reduce of ${o.getName(
        u & 65535
        /* Action.ValueMask */
      )}` : "shift"} for ${o.getName(f)} @ ${i}${p == e ? "" : ", split"})`), h)
        return !0;
      p.pos > i ? n.push(p) : r.push(p);
    }
    return !1;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(e, n) {
    let r = e.pos;
    for (; ; ) {
      if (!this.advanceStack(e, null, null))
        return !1;
      if (e.pos > r)
        return Mx(e, n), !0;
    }
  }
  runRecovery(e, n, r) {
    let i = null, o = !1;
    for (let s = 0; s < e.length; s++) {
      let a = e[s], l = n[s << 1], c = n[(s << 1) + 1], u = gi ? this.stackID(a) + " -> " : "";
      if (a.deadEnd && (o || (o = !0, a.restart(), gi && console.log(u + this.stackID(a) + " (restarted)"), this.advanceFully(a, r))))
        continue;
      let f = a.split(), d = u;
      for (let h = 0; f.forceReduce() && h < 10 && (gi && console.log(d + this.stackID(f) + " (via force-reduce)"), !this.advanceFully(f, r)); h++)
        gi && (d = this.stackID(f) + " -> ");
      for (let h of a.recoverByInsert(l))
        gi && console.log(u + this.stackID(h) + " (via recover-insert)"), this.advanceFully(h, r);
      this.stream.end > a.pos ? (c == a.pos && (c++, l = 0), a.recoverByDelete(l, c), gi && console.log(u + this.stackID(a) + ` (via recover-delete ${this.parser.getName(l)})`), Mx(a, r)) : (!i || i.score < a.score) && (i = a);
    }
    return i;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(e) {
    return e.close(), xr.build({
      buffer: jh.create(e),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: e.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(e) {
    let n = (Rm || (Rm = /* @__PURE__ */ new WeakMap())).get(e);
    return n || Rm.set(e, n = String.fromCodePoint(this.nextStackID++)), n + e;
  }
}
function Mx(t, e) {
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    if (r.pos == t.pos && r.sameState(t)) {
      e[n].score < t.score && (e[n] = t);
      return;
    }
  }
  e.push(t);
}
class XH {
  constructor(e, n, r) {
    this.source = e, this.flags = n, this.disabled = r;
  }
  allows(e) {
    return !this.disabled || this.disabled[e] == 0;
  }
}
class kh extends p3 {
  /**
  @internal
  */
  constructor(e) {
    if (super(), this.wrappers = [], e.version != 14)
      throw new RangeError(`Parser version (${e.version}) doesn't match runtime version (14)`);
    let n = e.nodeNames.split(" ");
    this.minRepeatTerm = n.length;
    for (let a = 0; a < e.repeatNodeCount; a++)
      n.push("");
    let r = Object.keys(e.topRules).map((a) => e.topRules[a][1]), i = [];
    for (let a = 0; a < n.length; a++)
      i.push([]);
    function o(a, l, c) {
      i[a].push([l, l.deserialize(String(c))]);
    }
    if (e.nodeProps)
      for (let a of e.nodeProps) {
        let l = a[0];
        typeof l == "string" && (l = bn[l]);
        for (let c = 1; c < a.length; ) {
          let u = a[c++];
          if (u >= 0)
            o(u, l, a[c++]);
          else {
            let f = a[c + -u];
            for (let d = -u; d > 0; d--)
              o(a[c++], l, f);
            c++;
          }
        }
      }
    this.nodeSet = new X0(n.map((a, l) => fi.define({
      name: l >= this.minRepeatTerm ? void 0 : a,
      id: l,
      props: i[l],
      top: r.indexOf(l) > -1,
      error: l == 0,
      skipped: e.skippedNodes && e.skippedNodes.indexOf(l) > -1
    }))), e.propSources && (this.nodeSet = this.nodeSet.extend(...e.propSources)), this.strict = !1, this.bufferLength = u3;
    let s = ed(e.tokenData);
    this.context = e.context, this.specializerSpecs = e.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let a = 0; a < this.specializerSpecs.length; a++)
      this.specialized[a] = this.specializerSpecs[a].term;
    this.specializers = this.specializerSpecs.map(_x), this.states = ed(e.states, Uint32Array), this.data = ed(e.stateData), this.goto = ed(e.goto), this.maxTerm = e.maxTerm, this.tokenizers = e.tokenizers.map((a) => typeof a == "number" ? new Dl(s, a) : a), this.topRules = e.topRules, this.dialects = e.dialects || {}, this.dynamicPrecedences = e.dynamicPrecedences || null, this.tokenPrecTable = e.tokenPrec, this.termNames = e.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(e, n, r) {
    let i = new YH(this, e, n, r);
    for (let o of this.wrappers)
      i = o(i, e, n, r);
    return i;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(e, n, r = !1) {
    let i = this.goto;
    if (n >= i[0])
      return -1;
    for (let o = i[n + 1]; ; ) {
      let s = i[o++], a = s & 1, l = i[o++];
      if (a && r)
        return l;
      for (let c = o + (s >> 1); o < c; o++)
        if (i[o] == e)
          return l;
      if (a)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(e, n) {
    let r = this.data;
    for (let i = 0; i < 2; i++)
      for (let o = this.stateSlot(
        e,
        i ? 2 : 1
        /* ParseState.Actions */
      ), s; ; o += 3) {
        if ((s = r[o]) == 65535)
          if (r[o + 1] == 1)
            s = r[o = es(r, o + 2)];
          else {
            if (r[o + 1] == 2)
              return es(r, o + 2);
            break;
          }
        if (s == n || s == 0)
          return es(r, o + 1);
      }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(e, n) {
    return this.states[e * 6 + n];
  }
  /**
  @internal
  */
  stateFlag(e, n) {
    return (this.stateSlot(
      e,
      0
      /* ParseState.Flags */
    ) & n) > 0;
  }
  /**
  @internal
  */
  validAction(e, n) {
    return !!this.allActions(e, (r) => r == n ? !0 : null);
  }
  /**
  @internal
  */
  allActions(e, n) {
    let r = this.stateSlot(
      e,
      4
      /* ParseState.DefaultReduce */
    ), i = r ? n(r) : void 0;
    for (let o = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); i == null; o += 3) {
      if (this.data[o] == 65535)
        if (this.data[o + 1] == 1)
          o = es(this.data, o + 2);
        else
          break;
      i = n(es(this.data, o + 1));
    }
    return i;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(e) {
    let n = [];
    for (let r = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); ; r += 3) {
      if (this.data[r] == 65535)
        if (this.data[r + 1] == 1)
          r = es(this.data, r + 2);
        else
          break;
      if (!(this.data[r + 2] & 1)) {
        let i = this.data[r + 1];
        n.some((o, s) => s & 1 && o == i) || n.push(this.data[r], i);
      }
    }
    return n;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(e) {
    let n = Object.assign(Object.create(kh.prototype), this);
    if (e.props && (n.nodeSet = this.nodeSet.extend(...e.props)), e.top) {
      let r = this.topRules[e.top];
      if (!r)
        throw new RangeError(`Invalid top rule name ${e.top}`);
      n.top = r;
    }
    return e.tokenizers && (n.tokenizers = this.tokenizers.map((r) => {
      let i = e.tokenizers.find((o) => o.from == r);
      return i ? i.to : r;
    })), e.specializers && (n.specializers = this.specializers.slice(), n.specializerSpecs = this.specializerSpecs.map((r, i) => {
      let o = e.specializers.find((a) => a.from == r.external);
      if (!o)
        return r;
      let s = Object.assign(Object.assign({}, r), { external: o.to });
      return n.specializers[i] = _x(s), s;
    })), e.contextTracker && (n.context = e.contextTracker), e.dialect && (n.dialect = this.parseDialect(e.dialect)), e.strict != null && (n.strict = e.strict), e.wrap && (n.wrappers = n.wrappers.concat(e.wrap)), e.bufferLength != null && (n.bufferLength = e.bufferLength), n;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(e) {
    return this.termNames ? this.termNames[e] : String(e <= this.maxNode && this.nodeSet.types[e].name || e);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(e) {
    let n = this.dynamicPrecedences;
    return n == null ? 0 : n[e] || 0;
  }
  /**
  @internal
  */
  parseDialect(e) {
    let n = Object.keys(this.dialects), r = n.map(() => !1);
    if (e)
      for (let o of e.split(" ")) {
        let s = n.indexOf(o);
        s >= 0 && (r[s] = !0);
      }
    let i = null;
    for (let o = 0; o < n.length; o++)
      if (!r[o])
        for (let s = this.dialects[n[o]], a; (a = this.data[s++]) != 65535; )
          (i || (i = new Uint8Array(this.maxTerm + 1)))[a] = 1;
    return new XH(e, r, i);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(e) {
    return new kh(e);
  }
}
function es(t, e) {
  return t[e] | t[e + 1] << 16;
}
function ZH(t) {
  let e = null;
  for (let n of t) {
    let r = n.p.stoppedAt;
    (n.pos == n.p.stream.end || r != null && n.pos > r) && n.p.parser.stateFlag(
      n.state,
      2
      /* StateFlag.Accepting */
    ) && (!e || e.score < n.score) && (e = n);
  }
  return e;
}
function _x(t) {
  if (t.external) {
    let e = t.extend ? 1 : 0;
    return (n, r) => t.external(n, r) << 1 | e;
  }
  return t.get;
}
const eU = m3({
  String: Ze.string,
  Number: Ze.number,
  "True False": Ze.bool,
  PropertyName: Ze.propertyName,
  Null: Ze.null,
  ",": Ze.separator,
  "[ ]": Ze.squareBracket,
  "{ }": Ze.brace
}), tU = kh.deserialize({
  version: 14,
  states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#CjOOQO'#Cp'#CpQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CrOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59U,59UO!iQPO,59UOVQPO,59QOqQPO'#CkO!nQPO,59^OOQO1G.k1G.kOVQPO'#ClO!vQPO,59aOOQO1G.p1G.pOOQO1G.l1G.lOOQO,59V,59VOOQO-E6i-E6iOOQO,59W,59WOOQO-E6j-E6j",
  stateData: "#O~OcOS~OQSORSOSSOTSOWQO]ROePO~OVXOeUO~O[[O~PVOg^O~Oh_OVfX~OVaO~OhbO[iX~O[dO~Oh_OVfa~OhbO[ia~O",
  goto: "!kjPPPPPPkPPkqwPPk{!RPPP!XP!ePP!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
  nodeNames: "⚠ JsonText True False Null Number String } { Object Property PropertyName ] [ Array",
  maxTerm: 25,
  nodeProps: [
    ["openedBy", 7, "{", 12, "["],
    ["closedBy", 8, "}", 13, "]"]
  ],
  propSources: [eU],
  skippedNodes: [0],
  repeatNodeCount: 2,
  tokenData: "(|~RaXY!WYZ!W]^!Wpq!Wrs!]|}$u}!O$z!Q!R%T!R![&c![!]&t!}#O&y#P#Q'O#Y#Z'T#b#c'r#h#i(Z#o#p(r#q#r(w~!]Oc~~!`Wpq!]qr!]rs!xs#O!]#O#P!}#P;'S!];'S;=`$o<%lO!]~!}Oe~~#QXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#m~#pR!Q![#y!c!i#y#T#Z#y~#|R!Q![$V!c!i$V#T#Z$V~$YR!Q![$c!c!i$c#T#Z$c~$fR!Q![!]!c!i!]#T#Z!]~$rP;=`<%l!]~$zOh~~$}Q!Q!R%T!R![&c~%YRT~!O!P%c!g!h%w#X#Y%w~%fP!Q![%i~%nRT~!Q![%i!g!h%w#X#Y%w~%zR{|&T}!O&T!Q![&Z~&WP!Q![&Z~&`PT~!Q![&Z~&hST~!O!P%c!Q![&c!g!h%w#X#Y%w~&yOg~~'OO]~~'TO[~~'WP#T#U'Z~'^P#`#a'a~'dP#g#h'g~'jP#X#Y'm~'rOR~~'uP#i#j'x~'{P#`#a(O~(RP#`#a(U~(ZOS~~(^P#f#g(a~(dP#i#j(g~(jP#X#Y(m~(rOQ~~(wOW~~(|OV~",
  tokenizers: [0],
  topRules: { JsonText: [0, 1] },
  tokenPrec: 0
}), nU = /* @__PURE__ */ mh.define({
  name: "json",
  parser: /* @__PURE__ */ tU.configure({
    props: [
      /* @__PURE__ */ b3.add({
        Object: /* @__PURE__ */ fx({ except: /^\s*\}/ }),
        Array: /* @__PURE__ */ fx({ except: /^\s*\]/ })
      }),
      /* @__PURE__ */ w3.add({
        "Object Array": LF
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["[", "{", '"'] },
    indentOnInput: /^\s*[\}\]]$/
  }
});
function rU() {
  return new CF(nU);
}
const Tx = typeof String.prototype.normalize == "function" ? (t) => t.normalize("NFKD") : (t) => t;
class ec {
  /**
  Create a text cursor. The query is the search string, `from` to
  `to` provides the region to search.
  
  When `normalize` is given, it will be called, on both the query
  string and the content it is matched against, before comparing.
  You can, for example, create a case-insensitive search by
  passing `s => s.toLowerCase()`.
  
  Text is always normalized with
  [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
  (when supported).
  */
  constructor(e, n, r = 0, i = e.length, o, s) {
    this.test = s, this.value = { from: 0, to: 0 }, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = e.iterRange(r, i), this.bufferStart = r, this.normalize = o ? (a) => o(Tx(a)) : Tx, this.query = this.normalize(n);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done)
        return -1;
      this.bufferPos = 0, this.buffer = this.iter.value;
    }
    return Nr(this.buffer, this.bufferPos);
  }
  /**
  Look for the next match. Updates the iterator's
  [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
  [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
  at least once before using the cursor.
  */
  next() {
    for (; this.matches.length; )
      this.matches.pop();
    return this.nextOverlapping();
  }
  /**
  The `next` method will ignore matches that partially overlap a
  previous match. This method behaves like `next`, but includes
  such matches.
  */
  nextOverlapping() {
    for (; ; ) {
      let e = this.peek();
      if (e < 0)
        return this.done = !0, this;
      let n = z0(e), r = this.bufferStart + this.bufferPos;
      this.bufferPos += Mi(e);
      let i = this.normalize(n);
      for (let o = 0, s = r; ; o++) {
        let a = i.charCodeAt(o), l = this.match(a, s);
        if (o == i.length - 1) {
          if (l)
            return this.value = l, this;
          break;
        }
        s == r && o < n.length && n.charCodeAt(o) == a && s++;
      }
    }
  }
  match(e, n) {
    let r = null;
    for (let i = 0; i < this.matches.length; i += 2) {
      let o = this.matches[i], s = !1;
      this.query.charCodeAt(o) == e && (o == this.query.length - 1 ? r = { from: this.matches[i + 1], to: n + 1 } : (this.matches[i]++, s = !0)), s || (this.matches.splice(i, 2), i -= 2);
    }
    return this.query.charCodeAt(0) == e && (this.query.length == 1 ? r = { from: n, to: n + 1 } : this.matches.push(1, n)), r && this.test && !this.test(r.from, r.to, this.buffer, this.bufferStart) && (r = null), r;
  }
}
typeof Symbol < "u" && (ec.prototype[Symbol.iterator] = function() {
  return this;
});
const x8 = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") }, d1 = "gm" + (/x/.unicode == null ? "" : "u");
class w8 {
  /**
  Create a cursor that will search the given range in the given
  document. `query` should be the raw pattern (as you'd pass it to
  `new RegExp`).
  */
  constructor(e, n, r, i = 0, o = e.length) {
    if (this.text = e, this.to = o, this.curLine = "", this.done = !1, this.value = x8, /\\[sWDnr]|\n|\r|\[\^/.test(n))
      return new j8(e, n, r, i, o);
    this.re = new RegExp(n, d1 + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.iter = e.iter();
    let s = e.lineAt(i);
    this.curLineStart = s.from, this.matchPos = $h(e, i), this.getLine(this.curLineStart);
  }
  getLine(e) {
    this.iter.next(e), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
  }
  /**
  Move to the next match, if there is one.
  */
  next() {
    for (let e = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = e;
      let n = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (n) {
        let r = this.curLineStart + n.index, i = r + n[0].length;
        if (this.matchPos = $h(this.text, i + (r == i ? 1 : 0)), r == this.curLineStart + this.curLine.length && this.nextLine(), (r < i || r > this.value.to) && (!this.test || this.test(r, i, n)))
          return this.value = { from: r, to: i, match: n }, this;
        e = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to)
        this.nextLine(), e = 0;
      else
        return this.done = !0, this;
    }
  }
}
const Nm = /* @__PURE__ */ new WeakMap();
class Ll {
  constructor(e, n) {
    this.from = e, this.text = n;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(e, n, r) {
    let i = Nm.get(e);
    if (!i || i.from >= r || i.to <= n) {
      let a = new Ll(n, e.sliceString(n, r));
      return Nm.set(e, a), a;
    }
    if (i.from == n && i.to == r)
      return i;
    let { text: o, from: s } = i;
    return s > n && (o = e.sliceString(n, s) + o, s = n), i.to < r && (o += e.sliceString(i.to, r)), Nm.set(e, new Ll(s, o)), new Ll(n, o.slice(n - s, r - s));
  }
}
class j8 {
  constructor(e, n, r, i, o) {
    this.text = e, this.to = o, this.done = !1, this.value = x8, this.matchPos = $h(e, i), this.re = new RegExp(n, d1 + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.flat = Ll.get(e, i, this.chunkEnd(
      i + 5e3
      /* Chunk.Base */
    ));
  }
  chunkEnd(e) {
    return e >= this.to ? this.to : this.text.lineAt(e).to;
  }
  next() {
    for (; ; ) {
      let e = this.re.lastIndex = this.matchPos - this.flat.from, n = this.re.exec(this.flat.text);
      if (n && !n[0] && n.index == e && (this.re.lastIndex = e + 1, n = this.re.exec(this.flat.text)), n) {
        let r = this.flat.from + n.index, i = r + n[0].length;
        if ((this.flat.to >= this.to || n.index + n[0].length <= this.flat.text.length - 10) && (!this.test || this.test(r, i, n)))
          return this.value = { from: r, to: i, match: n }, this.matchPos = $h(this.text, i + (r == i ? 1 : 0)), this;
      }
      if (this.flat.to == this.to)
        return this.done = !0, this;
      this.flat = Ll.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
typeof Symbol < "u" && (w8.prototype[Symbol.iterator] = j8.prototype[Symbol.iterator] = function() {
  return this;
});
function iU(t) {
  try {
    return new RegExp(t, d1), !0;
  } catch {
    return !1;
  }
}
function $h(t, e) {
  if (e >= t.length)
    return e;
  let n = t.lineAt(e), r;
  for (; e < n.to && (r = n.text.charCodeAt(e - n.from)) >= 56320 && r < 57344; )
    e++;
  return e;
}
function bv(t) {
  let e = String(t.state.doc.lineAt(t.state.selection.main.head).number), n = Hn("input", { class: "cm-textfield", name: "line", value: e }), r = Hn("form", {
    class: "cm-gotoLine",
    onkeydown: (o) => {
      o.keyCode == 27 ? (o.preventDefault(), t.dispatch({ effects: Sh.of(!1) }), t.focus()) : o.keyCode == 13 && (o.preventDefault(), i());
    },
    onsubmit: (o) => {
      o.preventDefault(), i();
    }
  }, Hn("label", t.state.phrase("Go to line"), ": ", n), " ", Hn("button", { class: "cm-button", type: "submit" }, t.state.phrase("go")));
  function i() {
    let o = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(n.value);
    if (!o)
      return;
    let { state: s } = t, a = s.doc.lineAt(s.selection.main.head), [, l, c, u, f] = o, d = u ? +u.slice(1) : 0, h = c ? +c : a.number;
    if (c && f) {
      let g = h / 100;
      l && (g = g * (l == "-" ? -1 : 1) + a.number / s.doc.lines), h = Math.round(s.doc.lines * g);
    } else
      c && l && (h = h * (l == "-" ? -1 : 1) + a.number);
    let p = s.doc.line(Math.max(1, Math.min(s.doc.lines, h))), m = Te.cursor(p.from + Math.max(0, Math.min(d, p.length)));
    t.dispatch({
      effects: [Sh.of(!1), at.scrollIntoView(m.from, { y: "center" })],
      selection: m
    }), t.focus();
  }
  return { dom: r };
}
const Sh = /* @__PURE__ */ ln.define(), Px = /* @__PURE__ */ Cr.define({
  create() {
    return !0;
  },
  update(t, e) {
    for (let n of e.effects)
      n.is(Sh) && (t = n.value);
    return t;
  },
  provide: (t) => Nu.from(t, (e) => e ? bv : null)
}), oU = (t) => {
  let e = Ru(t, bv);
  if (!e) {
    let n = [Sh.of(!0)];
    t.state.field(Px, !1) == null && n.push(ln.appendConfig.of([Px, sU])), t.dispatch({ effects: n }), e = Ru(t, bv);
  }
  return e && e.dom.querySelector("input").select(), !0;
}, sU = /* @__PURE__ */ at.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    "& label": { fontSize: "80%" }
  }
}), aU = {
  highlightWordAroundCursor: !1,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: !1
}, k8 = /* @__PURE__ */ vt.define({
  combine(t) {
    return Ui(t, aU, {
      highlightWordAroundCursor: (e, n) => e || n,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function lU(t) {
  let e = [hU, dU];
  return t && e.push(k8.of(t)), e;
}
const cU = /* @__PURE__ */ Bt.mark({ class: "cm-selectionMatch" }), uU = /* @__PURE__ */ Bt.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function Rx(t, e, n, r) {
  return (n == 0 || t(e.sliceDoc(n - 1, n)) != rr.Word) && (r == e.doc.length || t(e.sliceDoc(r, r + 1)) != rr.Word);
}
function fU(t, e, n, r) {
  return t(e.sliceDoc(n, n + 1)) == rr.Word && t(e.sliceDoc(r - 1, r)) == rr.Word;
}
const dU = /* @__PURE__ */ ur.fromClass(class {
  constructor(t) {
    this.decorations = this.getDeco(t);
  }
  update(t) {
    (t.selectionSet || t.docChanged || t.viewportChanged) && (this.decorations = this.getDeco(t.view));
  }
  getDeco(t) {
    let e = t.state.facet(k8), { state: n } = t, r = n.selection;
    if (r.ranges.length > 1)
      return Bt.none;
    let i = r.main, o, s = null;
    if (i.empty) {
      if (!e.highlightWordAroundCursor)
        return Bt.none;
      let l = n.wordAt(i.head);
      if (!l)
        return Bt.none;
      s = n.charCategorizer(i.head), o = n.sliceDoc(l.from, l.to);
    } else {
      let l = i.to - i.from;
      if (l < e.minSelectionLength || l > 200)
        return Bt.none;
      if (e.wholeWords) {
        if (o = n.sliceDoc(i.from, i.to), s = n.charCategorizer(i.head), !(Rx(s, n, i.from, i.to) && fU(s, n, i.from, i.to)))
          return Bt.none;
      } else if (o = n.sliceDoc(i.from, i.to).trim(), !o)
        return Bt.none;
    }
    let a = [];
    for (let l of t.visibleRanges) {
      let c = new ec(n.doc, o, l.from, l.to);
      for (; !c.next().done; ) {
        let { from: u, to: f } = c.value;
        if ((!s || Rx(s, n, u, f)) && (i.empty && u <= i.from && f >= i.to ? a.push(uU.range(u, f)) : (u >= i.to || f <= i.from) && a.push(cU.range(u, f)), a.length > e.maxMatches))
          return Bt.none;
      }
    }
    return Bt.set(a);
  }
}, {
  decorations: (t) => t.decorations
}), hU = /* @__PURE__ */ at.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
}), pU = ({ state: t, dispatch: e }) => {
  let { selection: n } = t, r = Te.create(n.ranges.map((i) => t.wordAt(i.head) || Te.cursor(i.head)), n.mainIndex);
  return r.eq(n) ? !1 : (e(t.update({ selection: r })), !0);
};
function mU(t, e) {
  let { main: n, ranges: r } = t.selection, i = t.wordAt(n.head), o = i && i.from == n.from && i.to == n.to;
  for (let s = !1, a = new ec(t.doc, e, r[r.length - 1].to); ; )
    if (a.next(), a.done) {
      if (s)
        return null;
      a = new ec(t.doc, e, 0, Math.max(0, r[r.length - 1].from - 1)), s = !0;
    } else {
      if (s && r.some((l) => l.from == a.value.from))
        continue;
      if (o) {
        let l = t.wordAt(a.value.from);
        if (!l || l.from != a.value.from || l.to != a.value.to)
          continue;
      }
      return a.value;
    }
}
const gU = ({ state: t, dispatch: e }) => {
  let { ranges: n } = t.selection;
  if (n.some((o) => o.from === o.to))
    return pU({ state: t, dispatch: e });
  let r = t.sliceDoc(n[0].from, n[0].to);
  if (t.selection.ranges.some((o) => t.sliceDoc(o.from, o.to) != r))
    return !1;
  let i = mU(t, r);
  return i ? (e(t.update({
    selection: t.selection.addRange(Te.range(i.from, i.to), !1),
    effects: at.scrollIntoView(i.to)
  })), !0) : !1;
}, ll = /* @__PURE__ */ vt.define({
  combine(t) {
    return Ui(t, {
      top: !1,
      caseSensitive: !1,
      literal: !1,
      regexp: !1,
      wholeWord: !1,
      createPanel: (e) => new AU(e),
      scrollToMatch: (e) => at.scrollIntoView(e)
    });
  }
});
function vU(t) {
  return t ? [ll.of(t), wv] : wv;
}
class $8 {
  /**
  Create a query object.
  */
  constructor(e) {
    this.search = e.search, this.caseSensitive = !!e.caseSensitive, this.literal = !!e.literal, this.regexp = !!e.regexp, this.replace = e.replace || "", this.valid = !!this.search && (!this.regexp || iU(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!e.wholeWord;
  }
  /**
  @internal
  */
  unquote(e) {
    return this.literal ? e : e.replace(/\\([nrt\\])/g, (n, r) => r == "n" ? `
` : r == "r" ? "\r" : r == "t" ? "	" : "\\");
  }
  /**
  Compare this query to another query.
  */
  eq(e) {
    return this.search == e.search && this.replace == e.replace && this.caseSensitive == e.caseSensitive && this.regexp == e.regexp && this.wholeWord == e.wholeWord;
  }
  /**
  @internal
  */
  create() {
    return this.regexp ? new wU(this) : new bU(this);
  }
  /**
  Get a search cursor for this query, searching through the given
  range in the given state.
  */
  getCursor(e, n = 0, r) {
    let i = e.doc ? e : gn.create({ doc: e });
    return r == null && (r = i.doc.length), this.regexp ? yl(this, i, n, r) : vl(this, i, n, r);
  }
}
class S8 {
  constructor(e) {
    this.spec = e;
  }
}
function vl(t, e, n, r) {
  return new ec(e.doc, t.unquoted, n, r, t.caseSensitive ? void 0 : (i) => i.toLowerCase(), t.wholeWord ? yU(e.doc, e.charCategorizer(e.selection.main.head)) : void 0);
}
function yU(t, e) {
  return (n, r, i, o) => ((o > n || o + i.length < r) && (o = Math.max(0, n - 2), i = t.sliceString(o, Math.min(t.length, r + 2))), (e(Ch(i, n - o)) != rr.Word || e(Oh(i, n - o)) != rr.Word) && (e(Oh(i, r - o)) != rr.Word || e(Ch(i, r - o)) != rr.Word));
}
class bU extends S8 {
  constructor(e) {
    super(e);
  }
  nextMatch(e, n, r) {
    let i = vl(this.spec, e, r, e.doc.length).nextOverlapping();
    return i.done && (i = vl(this.spec, e, 0, n).nextOverlapping()), i.done ? null : i.value;
  }
  // Searching in reverse is, rather than implementing an inverted search
  // cursor, done by scanning chunk after chunk forward.
  prevMatchInRange(e, n, r) {
    for (let i = r; ; ) {
      let o = Math.max(n, i - 1e4 - this.spec.unquoted.length), s = vl(this.spec, e, o, i), a = null;
      for (; !s.nextOverlapping().done; )
        a = s.value;
      if (a)
        return a;
      if (o == n)
        return null;
      i -= 1e4;
    }
  }
  prevMatch(e, n, r) {
    return this.prevMatchInRange(e, 0, n) || this.prevMatchInRange(e, r, e.doc.length);
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(e, n) {
    let r = vl(this.spec, e, 0, e.doc.length), i = [];
    for (; !r.next().done; ) {
      if (i.length >= n)
        return null;
      i.push(r.value);
    }
    return i;
  }
  highlight(e, n, r, i) {
    let o = vl(this.spec, e, Math.max(0, n - this.spec.unquoted.length), Math.min(r + this.spec.unquoted.length, e.doc.length));
    for (; !o.next().done; )
      i(o.value.from, o.value.to);
  }
}
function yl(t, e, n, r) {
  return new w8(e.doc, t.search, {
    ignoreCase: !t.caseSensitive,
    test: t.wholeWord ? xU(e.charCategorizer(e.selection.main.head)) : void 0
  }, n, r);
}
function Ch(t, e) {
  return t.slice(Br(t, e, !1), e);
}
function Oh(t, e) {
  return t.slice(e, Br(t, e));
}
function xU(t) {
  return (e, n, r) => !r[0].length || (t(Ch(r.input, r.index)) != rr.Word || t(Oh(r.input, r.index)) != rr.Word) && (t(Oh(r.input, r.index + r[0].length)) != rr.Word || t(Ch(r.input, r.index + r[0].length)) != rr.Word);
}
class wU extends S8 {
  nextMatch(e, n, r) {
    let i = yl(this.spec, e, r, e.doc.length).next();
    return i.done && (i = yl(this.spec, e, 0, n).next()), i.done ? null : i.value;
  }
  prevMatchInRange(e, n, r) {
    for (let i = 1; ; i++) {
      let o = Math.max(
        n,
        r - i * 1e4
        /* FindPrev.ChunkSize */
      ), s = yl(this.spec, e, o, r), a = null;
      for (; !s.next().done; )
        a = s.value;
      if (a && (o == n || a.from > o + 10))
        return a;
      if (o == n)
        return null;
    }
  }
  prevMatch(e, n, r) {
    return this.prevMatchInRange(e, 0, n) || this.prevMatchInRange(e, r, e.doc.length);
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace).replace(/\$([$&\d+])/g, (n, r) => r == "$" ? "$" : r == "&" ? e.match[0] : r != "0" && +r < e.match.length ? e.match[r] : n);
  }
  matchAll(e, n) {
    let r = yl(this.spec, e, 0, e.doc.length), i = [];
    for (; !r.next().done; ) {
      if (i.length >= n)
        return null;
      i.push(r.value);
    }
    return i;
  }
  highlight(e, n, r, i) {
    let o = yl(this.spec, e, Math.max(
      0,
      n - 250
      /* RegExp.HighlightMargin */
    ), Math.min(r + 250, e.doc.length));
    for (; !o.next().done; )
      i(o.value.from, o.value.to);
  }
}
const Lu = /* @__PURE__ */ ln.define(), h1 = /* @__PURE__ */ ln.define(), Us = /* @__PURE__ */ Cr.define({
  create(t) {
    return new Im(xv(t).create(), null);
  },
  update(t, e) {
    for (let n of e.effects)
      n.is(Lu) ? t = new Im(n.value.create(), t.panel) : n.is(h1) && (t = new Im(t.query, n.value ? p1 : null));
    return t;
  },
  provide: (t) => Nu.from(t, (e) => e.panel)
});
class Im {
  constructor(e, n) {
    this.query = e, this.panel = n;
  }
}
const jU = /* @__PURE__ */ Bt.mark({ class: "cm-searchMatch" }), kU = /* @__PURE__ */ Bt.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), $U = /* @__PURE__ */ ur.fromClass(class {
  constructor(t) {
    this.view = t, this.decorations = this.highlight(t.state.field(Us));
  }
  update(t) {
    let e = t.state.field(Us);
    (e != t.startState.field(Us) || t.docChanged || t.selectionSet || t.viewportChanged) && (this.decorations = this.highlight(e));
  }
  highlight({ query: t, panel: e }) {
    if (!e || !t.spec.valid)
      return Bt.none;
    let { view: n } = this, r = new Fo();
    for (let i = 0, o = n.visibleRanges, s = o.length; i < s; i++) {
      let { from: a, to: l } = o[i];
      for (; i < s - 1 && l > o[i + 1].from - 2 * 250; )
        l = o[++i].to;
      t.highlight(n.state, a, l, (c, u) => {
        let f = n.state.selection.ranges.some((d) => d.from == c && d.to == u);
        r.add(c, u, f ? kU : jU);
      });
    }
    return r.finish();
  }
}, {
  decorations: (t) => t.decorations
});
function uf(t) {
  return (e) => {
    let n = e.state.field(Us, !1);
    return n && n.query.spec.valid ? t(e, n) : m1(e);
  };
}
const Eh = /* @__PURE__ */ uf((t, { query: e }) => {
  let { to: n } = t.state.selection.main, r = e.nextMatch(t.state, n, n);
  if (!r)
    return !1;
  let i = Te.single(r.from, r.to), o = t.state.facet(ll);
  return t.dispatch({
    selection: i,
    effects: [v1(t, r), o.scrollToMatch(i.main, t)],
    userEvent: "select.search"
  }), O8(t), !0;
}), Ah = /* @__PURE__ */ uf((t, { query: e }) => {
  let { state: n } = t, { from: r } = n.selection.main, i = e.prevMatch(n, r, r);
  if (!i)
    return !1;
  let o = Te.single(i.from, i.to), s = t.state.facet(ll);
  return t.dispatch({
    selection: o,
    effects: [v1(t, i), s.scrollToMatch(o.main, t)],
    userEvent: "select.search"
  }), O8(t), !0;
}), SU = /* @__PURE__ */ uf((t, { query: e }) => {
  let n = e.matchAll(t.state, 1e3);
  return !n || !n.length ? !1 : (t.dispatch({
    selection: Te.create(n.map((r) => Te.range(r.from, r.to))),
    userEvent: "select.search.matches"
  }), !0);
}), CU = ({ state: t, dispatch: e }) => {
  let n = t.selection;
  if (n.ranges.length > 1 || n.main.empty)
    return !1;
  let { from: r, to: i } = n.main, o = [], s = 0;
  for (let a = new ec(t.doc, t.sliceDoc(r, i)); !a.next().done; ) {
    if (o.length > 1e3)
      return !1;
    a.value.from == r && (s = o.length), o.push(Te.range(a.value.from, a.value.to));
  }
  return e(t.update({
    selection: Te.create(o, s),
    userEvent: "select.search.matches"
  })), !0;
}, Nx = /* @__PURE__ */ uf((t, { query: e }) => {
  let { state: n } = t, { from: r, to: i } = n.selection.main;
  if (n.readOnly)
    return !1;
  let o = e.nextMatch(n, r, r);
  if (!o)
    return !1;
  let s = [], a, l, c = [];
  if (o.from == r && o.to == i && (l = n.toText(e.getReplacement(o)), s.push({ from: o.from, to: o.to, insert: l }), o = e.nextMatch(n, o.from, o.to), c.push(at.announce.of(n.phrase("replaced match on line $", n.doc.lineAt(r).number) + "."))), o) {
    let u = s.length == 0 || s[0].from >= o.to ? 0 : o.to - o.from - l.length;
    a = Te.single(o.from - u, o.to - u), c.push(v1(t, o)), c.push(n.facet(ll).scrollToMatch(a.main, t));
  }
  return t.dispatch({
    changes: s,
    selection: a,
    effects: c,
    userEvent: "input.replace"
  }), !0;
}), OU = /* @__PURE__ */ uf((t, { query: e }) => {
  if (t.state.readOnly)
    return !1;
  let n = e.matchAll(t.state, 1e9).map((i) => {
    let { from: o, to: s } = i;
    return { from: o, to: s, insert: e.getReplacement(i) };
  });
  if (!n.length)
    return !1;
  let r = t.state.phrase("replaced $ matches", n.length) + ".";
  return t.dispatch({
    changes: n,
    effects: at.announce.of(r),
    userEvent: "input.replace.all"
  }), !0;
});
function p1(t) {
  return t.state.facet(ll).createPanel(t);
}
function xv(t, e) {
  var n, r, i, o, s;
  let a = t.selection.main, l = a.empty || a.to > a.from + 100 ? "" : t.sliceDoc(a.from, a.to);
  if (e && !l)
    return e;
  let c = t.facet(ll);
  return new $8({
    search: ((n = e == null ? void 0 : e.literal) !== null && n !== void 0 ? n : c.literal) ? l : l.replace(/\n/g, "\\n"),
    caseSensitive: (r = e == null ? void 0 : e.caseSensitive) !== null && r !== void 0 ? r : c.caseSensitive,
    literal: (i = e == null ? void 0 : e.literal) !== null && i !== void 0 ? i : c.literal,
    regexp: (o = e == null ? void 0 : e.regexp) !== null && o !== void 0 ? o : c.regexp,
    wholeWord: (s = e == null ? void 0 : e.wholeWord) !== null && s !== void 0 ? s : c.wholeWord
  });
}
function C8(t) {
  let e = Ru(t, p1);
  return e && e.dom.querySelector("[main-field]");
}
function O8(t) {
  let e = C8(t);
  e && e == t.root.activeElement && e.select();
}
const m1 = (t) => {
  let e = t.state.field(Us, !1);
  if (e && e.panel) {
    let n = C8(t);
    if (n && n != t.root.activeElement) {
      let r = xv(t.state, e.query.spec);
      r.valid && t.dispatch({ effects: Lu.of(r) }), n.focus(), n.select();
    }
  } else
    t.dispatch({ effects: [
      h1.of(!0),
      e ? Lu.of(xv(t.state, e.query.spec)) : ln.appendConfig.of(wv)
    ] });
  return !0;
}, g1 = (t) => {
  let e = t.state.field(Us, !1);
  if (!e || !e.panel)
    return !1;
  let n = Ru(t, p1);
  return n && n.dom.contains(t.root.activeElement) && t.focus(), t.dispatch({ effects: h1.of(!1) }), !0;
}, EU = [
  { key: "Mod-f", run: m1, scope: "editor search-panel" },
  { key: "F3", run: Eh, shift: Ah, scope: "editor search-panel", preventDefault: !0 },
  { key: "Mod-g", run: Eh, shift: Ah, scope: "editor search-panel", preventDefault: !0 },
  { key: "Escape", run: g1, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: CU },
  { key: "Mod-Alt-g", run: oU },
  { key: "Mod-d", run: gU, preventDefault: !0 }
];
class AU {
  constructor(e) {
    this.view = e;
    let n = this.query = e.state.field(Us).query.spec;
    this.commit = this.commit.bind(this), this.searchField = Hn("input", {
      value: n.search,
      placeholder: vi(e, "Find"),
      "aria-label": vi(e, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.replaceField = Hn("input", {
      value: n.replace,
      placeholder: vi(e, "Replace"),
      "aria-label": vi(e, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.caseField = Hn("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: n.caseSensitive,
      onchange: this.commit
    }), this.reField = Hn("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: n.regexp,
      onchange: this.commit
    }), this.wordField = Hn("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: n.wholeWord,
      onchange: this.commit
    });
    function r(i, o, s) {
      return Hn("button", { class: "cm-button", name: i, onclick: o, type: "button" }, s);
    }
    this.dom = Hn("div", { onkeydown: (i) => this.keydown(i), class: "cm-search" }, [
      this.searchField,
      r("next", () => Eh(e), [vi(e, "next")]),
      r("prev", () => Ah(e), [vi(e, "previous")]),
      r("select", () => SU(e), [vi(e, "all")]),
      Hn("label", null, [this.caseField, vi(e, "match case")]),
      Hn("label", null, [this.reField, vi(e, "regexp")]),
      Hn("label", null, [this.wordField, vi(e, "by word")]),
      ...e.state.readOnly ? [] : [
        Hn("br"),
        this.replaceField,
        r("replace", () => Nx(e), [vi(e, "replace")]),
        r("replaceAll", () => OU(e), [vi(e, "replace all")])
      ],
      Hn("button", {
        name: "close",
        onclick: () => g1(e),
        "aria-label": vi(e, "close"),
        type: "button"
      }, ["×"])
    ]);
  }
  commit() {
    let e = new $8({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    e.eq(this.query) || (this.query = e, this.view.dispatch({ effects: Lu.of(e) }));
  }
  keydown(e) {
    cz(this.view, e, "search-panel") ? e.preventDefault() : e.keyCode == 13 && e.target == this.searchField ? (e.preventDefault(), (e.shiftKey ? Ah : Eh)(this.view)) : e.keyCode == 13 && e.target == this.replaceField && (e.preventDefault(), Nx(this.view));
  }
  update(e) {
    for (let n of e.transactions)
      for (let r of n.effects)
        r.is(Lu) && !r.value.eq(this.query) && this.setQuery(r.value);
  }
  setQuery(e) {
    this.query = e, this.searchField.value = e.search, this.replaceField.value = e.replace, this.caseField.checked = e.caseSensitive, this.reField.checked = e.regexp, this.wordField.checked = e.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(ll).top;
  }
}
function vi(t, e) {
  return t.state.phrase(e);
}
const td = 30, nd = /[\s\.,:;?!]/;
function v1(t, { from: e, to: n }) {
  let r = t.state.doc.lineAt(e), i = t.state.doc.lineAt(n).to, o = Math.max(r.from, e - td), s = Math.min(i, n + td), a = t.state.sliceDoc(o, s);
  if (o != r.from) {
    for (let l = 0; l < td; l++)
      if (!nd.test(a[l + 1]) && nd.test(a[l])) {
        a = a.slice(l);
        break;
      }
  }
  if (s != i) {
    for (let l = a.length - 1; l > a.length - td; l--)
      if (!nd.test(a[l - 1]) && nd.test(a[l])) {
        a = a.slice(0, l);
        break;
      }
  }
  return at.announce.of(`${t.state.phrase("current match")}. ${a} ${t.state.phrase("on line")} ${r.number}.`);
}
const MU = /* @__PURE__ */ at.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
}), wv = [
  Us,
  /* @__PURE__ */ vc.low($U),
  MU
];
class E8 {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(e, n, r) {
    this.state = e, this.pos = n, this.explicit = r, this.abortListeners = [];
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(e) {
    let n = Zr(this.state).resolveInner(this.pos, -1);
    for (; n && e.indexOf(n.name) < 0; )
      n = n.parent;
    return n ? {
      from: n.from,
      to: this.pos,
      text: this.state.sliceDoc(n.from, this.pos),
      type: n.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(e) {
    let n = this.state.doc.lineAt(this.pos), r = Math.max(n.from, this.pos - 250), i = n.text.slice(r - n.from, this.pos - n.from), o = i.search(A8(e, !1));
    return o < 0 ? null : { from: r + o, to: this.pos, text: i.slice(o) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  */
  addEventListener(e, n) {
    e == "abort" && this.abortListeners && this.abortListeners.push(n);
  }
}
function Ix(t) {
  let e = Object.keys(t).join(""), n = /\w/.test(e);
  return n && (e = e.replace(/\w/g, "")), `[${n ? "\\w" : ""}${e.replace(/[^\w\s]/g, "\\$&")}]`;
}
function _U(t) {
  let e = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null);
  for (let { label: i } of t) {
    e[i[0]] = !0;
    for (let o = 1; o < i.length; o++)
      n[i[o]] = !0;
  }
  let r = Ix(e) + Ix(n) + "*$";
  return [new RegExp("^" + r), new RegExp(r)];
}
function TU(t) {
  let e = t.map((i) => typeof i == "string" ? { label: i } : i), [n, r] = e.every((i) => /^\w+$/.test(i.label)) ? [/\w*$/, /\w+$/] : _U(e);
  return (i) => {
    let o = i.matchBefore(r);
    return o || i.explicit ? { from: o ? o.from : i.pos, options: e, validFor: n } : null;
  };
}
class Dx {
  constructor(e, n, r, i) {
    this.completion = e, this.source = n, this.match = r, this.score = i;
  }
}
function Ws(t) {
  return t.selection.main.from;
}
function A8(t, e) {
  var n;
  let { source: r } = t, i = e && r[0] != "^", o = r[r.length - 1] != "$";
  return !i && !o ? t : new RegExp(`${i ? "^" : ""}(?:${r})${o ? "$" : ""}`, (n = t.flags) !== null && n !== void 0 ? n : t.ignoreCase ? "i" : "");
}
const PU = /* @__PURE__ */ Ss.define();
function RU(t, e, n, r) {
  let { main: i } = t.selection, o = n - i.from, s = r - i.from;
  return Object.assign(Object.assign({}, t.changeByRange((a) => a != i && n != r && t.sliceDoc(a.from + o, a.from + s) != t.sliceDoc(n, r) ? { range: a } : {
    changes: { from: a.from + o, to: r == i.from ? a.to : a.from + s, insert: e },
    range: Te.cursor(a.from + o + e.length)
  })), { scrollIntoView: !0, userEvent: "input.complete" });
}
const Lx = /* @__PURE__ */ new WeakMap();
function NU(t) {
  if (!Array.isArray(t))
    return t;
  let e = Lx.get(t);
  return e || Lx.set(t, e = TU(t)), e;
}
const y1 = /* @__PURE__ */ ln.define(), Bu = /* @__PURE__ */ ln.define();
class IU {
  constructor(e) {
    this.pattern = e, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let n = 0; n < e.length; ) {
      let r = Nr(e, n), i = Mi(r);
      this.chars.push(r);
      let o = e.slice(n, n + i), s = o.toUpperCase();
      this.folded.push(Nr(s == o ? o.toLowerCase() : s, 0)), n += i;
    }
    this.astral = e.length != this.chars.length;
  }
  ret(e, n) {
    return this.score = e, this.matched = n, !0;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(e) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (e.length < this.pattern.length)
      return !1;
    let { chars: n, folded: r, any: i, precise: o, byWord: s } = this;
    if (n.length == 1) {
      let y = Nr(e, 0), w = Mi(y), x = w == e.length ? 0 : -100;
      if (y != n[0])
        if (y == r[0])
          x += -200;
        else
          return !1;
      return this.ret(x, [0, w]);
    }
    let a = e.indexOf(this.pattern);
    if (a == 0)
      return this.ret(e.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let l = n.length, c = 0;
    if (a < 0) {
      for (let y = 0, w = Math.min(e.length, 200); y < w && c < l; ) {
        let x = Nr(e, y);
        (x == n[c] || x == r[c]) && (i[c++] = y), y += Mi(x);
      }
      if (c < l)
        return !1;
    }
    let u = 0, f = 0, d = !1, h = 0, p = -1, m = -1, g = /[a-z]/.test(e), v = !0;
    for (let y = 0, w = Math.min(e.length, 200), x = 0; y < w && f < l; ) {
      let b = Nr(e, y);
      a < 0 && (u < l && b == n[u] && (o[u++] = y), h < l && (b == n[h] || b == r[h] ? (h == 0 && (p = y), m = y + 1, h++) : h = 0));
      let j, $ = b < 255 ? b >= 48 && b <= 57 || b >= 97 && b <= 122 ? 2 : b >= 65 && b <= 90 ? 1 : 0 : (j = z0(b)) != j.toLowerCase() ? 1 : j != j.toUpperCase() ? 2 : 0;
      (!y || $ == 1 && g || x == 0 && $ != 0) && (n[f] == b || r[f] == b && (d = !0) ? s[f++] = y : s.length && (v = !1)), x = $, y += Mi(b);
    }
    return f == l && s[0] == 0 && v ? this.result(-100 + (d ? -200 : 0), s, e) : h == l && p == 0 ? this.ret(-200 - e.length + (m == e.length ? 0 : -100), [0, m]) : a > -1 ? this.ret(-700 - e.length, [a, a + this.pattern.length]) : h == l ? this.ret(-900 - e.length, [p, m]) : f == l ? this.result(-100 + (d ? -200 : 0) + -700 + (v ? 0 : -1100), s, e) : n.length == 2 ? !1 : this.result((i[0] ? -700 : 0) + -200 + -1100, i, e);
  }
  result(e, n, r) {
    let i = [], o = 0;
    for (let s of n) {
      let a = s + (this.astral ? Mi(Nr(r, s)) : 1);
      o && i[o - 1] == s ? i[o - 1] = a : (i[o++] = s, i[o++] = a);
    }
    return this.ret(e - r.length, i);
  }
}
const Gr = /* @__PURE__ */ vt.define({
  combine(t) {
    return Ui(t, {
      activateOnTyping: !0,
      selectOnOpen: !0,
      override: null,
      closeOnBlur: !0,
      maxRenderedOptions: 100,
      defaultKeymap: !0,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: !1,
      icons: !0,
      addToOptions: [],
      positionInfo: DU,
      compareCompletions: (e, n) => e.label.localeCompare(n.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (e, n) => e && n,
      closeOnBlur: (e, n) => e && n,
      icons: (e, n) => e && n,
      tooltipClass: (e, n) => (r) => Bx(e(r), n(r)),
      optionClass: (e, n) => (r) => Bx(e(r), n(r)),
      addToOptions: (e, n) => e.concat(n)
    });
  }
});
function Bx(t, e) {
  return t ? e ? t + " " + e : t : e;
}
function DU(t, e, n, r, i, o) {
  let s = t.textDirection == cr.RTL, a = s, l = !1, c = "top", u, f, d = e.left - i.left, h = i.right - e.right, p = r.right - r.left, m = r.bottom - r.top;
  if (a && d < Math.min(p, h) ? a = !1 : !a && h < Math.min(p, d) && (a = !0), p <= (a ? d : h))
    u = Math.max(i.top, Math.min(n.top, i.bottom - m)) - e.top, f = Math.min(400, a ? d : h);
  else {
    l = !0, f = Math.min(
      400,
      (s ? e.right : i.right - e.left) - 30
      /* Info.Margin */
    );
    let y = i.bottom - e.bottom;
    y >= m || y > e.top ? u = n.bottom - e.top : (c = "bottom", u = e.bottom - n.top);
  }
  let g = (e.bottom - e.top) / o.offsetHeight, v = (e.right - e.left) / o.offsetWidth;
  return {
    style: `${c}: ${u / g}px; max-width: ${f / v}px`,
    class: "cm-completionInfo-" + (l ? s ? "left-narrow" : "right-narrow" : a ? "left" : "right")
  };
}
function LU(t) {
  let e = t.addToOptions.slice();
  return t.icons && e.push({
    render(n) {
      let r = document.createElement("div");
      return r.classList.add("cm-completionIcon"), n.type && r.classList.add(...n.type.split(/\s+/g).map((i) => "cm-completionIcon-" + i)), r.setAttribute("aria-hidden", "true"), r;
    },
    position: 20
  }), e.push({
    render(n, r, i, o) {
      let s = document.createElement("span");
      s.className = "cm-completionLabel";
      let a = n.displayLabel || n.label, l = 0;
      for (let c = 0; c < o.length; ) {
        let u = o[c++], f = o[c++];
        u > l && s.appendChild(document.createTextNode(a.slice(l, u)));
        let d = s.appendChild(document.createElement("span"));
        d.appendChild(document.createTextNode(a.slice(u, f))), d.className = "cm-completionMatchedText", l = f;
      }
      return l < a.length && s.appendChild(document.createTextNode(a.slice(l))), s;
    },
    position: 50
  }, {
    render(n) {
      if (!n.detail)
        return null;
      let r = document.createElement("span");
      return r.className = "cm-completionDetail", r.textContent = n.detail, r;
    },
    position: 80
  }), e.sort((n, r) => n.position - r.position).map((n) => n.render);
}
function Dm(t, e, n) {
  if (t <= n)
    return { from: 0, to: t };
  if (e < 0 && (e = 0), e <= t >> 1) {
    let i = Math.floor(e / n);
    return { from: i * n, to: (i + 1) * n };
  }
  let r = Math.floor((t - e) / n);
  return { from: t - (r + 1) * n, to: t - r * n };
}
class BU {
  constructor(e, n, r) {
    this.view = e, this.stateField = n, this.applyCompletion = r, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (l) => this.placeInfo(l),
      key: this
    }, this.space = null, this.currentClass = "";
    let i = e.state.field(n), { options: o, selected: s } = i.open, a = e.state.facet(Gr);
    this.optionContent = LU(a), this.optionClass = a.optionClass, this.tooltipClass = a.tooltipClass, this.range = Dm(o.length, s, a.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(e.state), this.dom.addEventListener("mousedown", (l) => {
      let { options: c } = e.state.field(n).open;
      for (let u = l.target, f; u && u != this.dom; u = u.parentNode)
        if (u.nodeName == "LI" && (f = /-(\d+)$/.exec(u.id)) && +f[1] < c.length) {
          this.applyCompletion(e, c[+f[1]]), l.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (l) => {
      let c = e.state.field(this.stateField, !1);
      c && c.tooltip && e.state.facet(Gr).closeOnBlur && l.relatedTarget != e.contentDOM && e.dispatch({ effects: Bu.of(null) });
    }), this.showOptions(o, i.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(e, n) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e, n, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(e) {
    var n;
    let r = e.state.field(this.stateField), i = e.startState.field(this.stateField);
    if (this.updateTooltipClass(e.state), r != i) {
      let { options: o, selected: s, disabled: a } = r.open;
      (!i.open || i.open.options != o) && (this.range = Dm(o.length, s, e.state.facet(Gr).maxRenderedOptions), this.showOptions(o, r.id)), this.updateSel(), a != ((n = i.open) === null || n === void 0 ? void 0 : n.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!a);
    }
  }
  updateTooltipClass(e) {
    let n = this.tooltipClass(e);
    if (n != this.currentClass) {
      for (let r of this.currentClass.split(" "))
        r && this.dom.classList.remove(r);
      for (let r of n.split(" "))
        r && this.dom.classList.add(r);
      this.currentClass = n;
    }
  }
  positioned(e) {
    this.space = e, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let e = this.view.state.field(this.stateField), n = e.open;
    if ((n.selected > -1 && n.selected < this.range.from || n.selected >= this.range.to) && (this.range = Dm(n.options.length, n.selected, this.view.state.facet(Gr).maxRenderedOptions), this.showOptions(n.options, e.id)), this.updateSelectedOption(n.selected)) {
      this.destroyInfo();
      let { completion: r } = n.options[n.selected], { info: i } = r;
      if (!i)
        return;
      let o = typeof i == "string" ? document.createTextNode(i) : i(r);
      if (!o)
        return;
      "then" in o ? o.then((s) => {
        s && this.view.state.field(this.stateField, !1) == e && this.addInfoPane(s, r);
      }).catch((s) => $i(this.view.state, s, "completion info")) : this.addInfoPane(o, r);
    }
  }
  addInfoPane(e, n) {
    this.destroyInfo();
    let r = this.info = document.createElement("div");
    if (r.className = "cm-tooltip cm-completionInfo", e.nodeType != null)
      r.appendChild(e), this.infoDestroy = null;
    else {
      let { dom: i, destroy: o } = e;
      r.appendChild(i), this.infoDestroy = o || null;
    }
    this.dom.appendChild(r), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(e) {
    let n = null;
    for (let r = this.list.firstChild, i = this.range.from; r; r = r.nextSibling, i++)
      r.nodeName != "LI" || !r.id ? i-- : i == e ? r.hasAttribute("aria-selected") || (r.setAttribute("aria-selected", "true"), n = r) : r.hasAttribute("aria-selected") && r.removeAttribute("aria-selected");
    return n && zU(this.list, n), n;
  }
  measureInfo() {
    let e = this.dom.querySelector("[aria-selected]");
    if (!e || !this.info)
      return null;
    let n = this.dom.getBoundingClientRect(), r = this.info.getBoundingClientRect(), i = e.getBoundingClientRect(), o = this.space;
    if (!o) {
      let s = this.dom.ownerDocument.defaultView || window;
      o = { left: 0, top: 0, right: s.innerWidth, bottom: s.innerHeight };
    }
    return i.top > Math.min(o.bottom, n.bottom) - 10 || i.bottom < Math.max(o.top, n.top) + 10 ? null : this.view.state.facet(Gr).positionInfo(this.view, n, i, r, o, this.dom);
  }
  placeInfo(e) {
    this.info && (e ? (e.style && (this.info.style.cssText = e.style), this.info.className = "cm-tooltip cm-completionInfo " + (e.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(e, n, r) {
    const i = document.createElement("ul");
    i.id = n, i.setAttribute("role", "listbox"), i.setAttribute("aria-expanded", "true"), i.setAttribute("aria-label", this.view.state.phrase("Completions"));
    let o = null;
    for (let s = r.from; s < r.to; s++) {
      let { completion: a, match: l } = e[s], { section: c } = a;
      if (c) {
        let d = typeof c == "string" ? c : c.name;
        if (d != o && (s > r.from || r.from == 0))
          if (o = d, typeof c != "string" && c.header)
            i.appendChild(c.header(c));
          else {
            let h = i.appendChild(document.createElement("completion-section"));
            h.textContent = d;
          }
      }
      const u = i.appendChild(document.createElement("li"));
      u.id = n + "-" + s, u.setAttribute("role", "option");
      let f = this.optionClass(a);
      f && (u.className = f);
      for (let d of this.optionContent) {
        let h = d(a, this.view.state, this.view, l);
        h && u.appendChild(h);
      }
    }
    return r.from && i.classList.add("cm-completionListIncompleteTop"), r.to < e.length && i.classList.add("cm-completionListIncompleteBottom"), i;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}
function qU(t, e) {
  return (n) => new BU(n, t, e);
}
function zU(t, e) {
  let n = t.getBoundingClientRect(), r = e.getBoundingClientRect(), i = n.height / t.offsetHeight;
  r.top < n.top ? t.scrollTop -= (n.top - r.top) / i : r.bottom > n.bottom && (t.scrollTop += (r.bottom - n.bottom) / i);
}
function qx(t) {
  return (t.boost || 0) * 100 + (t.apply ? 10 : 0) + (t.info ? 5 : 0) + (t.type ? 1 : 0);
}
function FU(t, e) {
  let n = [], r = null, i = (l) => {
    n.push(l);
    let { section: c } = l.completion;
    if (c) {
      r || (r = []);
      let u = typeof c == "string" ? c : c.name;
      r.some((f) => f.name == u) || r.push(typeof c == "string" ? { name: u } : c);
    }
  };
  for (let l of t)
    if (l.hasResult()) {
      let c = l.result.getMatch;
      if (l.result.filter === !1)
        for (let u of l.result.options)
          i(new Dx(u, l.source, c ? c(u) : [], 1e9 - n.length));
      else {
        let u = new IU(e.sliceDoc(l.from, l.to));
        for (let f of l.result.options)
          if (u.match(f.label)) {
            let d = f.displayLabel ? c ? c(f, u.matched) : [] : u.matched;
            i(new Dx(f, l.source, d, u.score + (f.boost || 0)));
          }
      }
    }
  if (r) {
    let l = /* @__PURE__ */ Object.create(null), c = 0, u = (f, d) => {
      var h, p;
      return ((h = f.rank) !== null && h !== void 0 ? h : 1e9) - ((p = d.rank) !== null && p !== void 0 ? p : 1e9) || (f.name < d.name ? -1 : 1);
    };
    for (let f of r.sort(u))
      c -= 1e5, l[f.name] = c;
    for (let f of n) {
      let { section: d } = f.completion;
      d && (f.score += l[typeof d == "string" ? d : d.name]);
    }
  }
  let o = [], s = null, a = e.facet(Gr).compareCompletions;
  for (let l of n.sort((c, u) => u.score - c.score || a(c.completion, u.completion))) {
    let c = l.completion;
    !s || s.label != c.label || s.detail != c.detail || s.type != null && c.type != null && s.type != c.type || s.apply != c.apply || s.boost != c.boost ? o.push(l) : qx(l.completion) > qx(s) && (o[o.length - 1] = l), s = l.completion;
  }
  return o;
}
class Cl {
  constructor(e, n, r, i, o, s) {
    this.options = e, this.attrs = n, this.tooltip = r, this.timestamp = i, this.selected = o, this.disabled = s;
  }
  setSelected(e, n) {
    return e == this.selected || e >= this.options.length ? this : new Cl(this.options, zx(n, e), this.tooltip, this.timestamp, e, this.disabled);
  }
  static build(e, n, r, i, o) {
    let s = FU(e, n);
    if (!s.length)
      return i && e.some(
        (l) => l.state == 1
        /* State.Pending */
      ) ? new Cl(i.options, i.attrs, i.tooltip, i.timestamp, i.selected, !0) : null;
    let a = n.facet(Gr).selectOnOpen ? 0 : -1;
    if (i && i.selected != a && i.selected != -1) {
      let l = i.options[i.selected].completion;
      for (let c = 0; c < s.length; c++)
        if (s[c].completion == l) {
          a = c;
          break;
        }
    }
    return new Cl(s, zx(r, a), {
      pos: e.reduce((l, c) => c.hasResult() ? Math.min(l, c.from) : l, 1e8),
      create: JU,
      above: o.aboveCursor
    }, i ? i.timestamp : Date.now(), a, !1);
  }
  map(e) {
    return new Cl(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: e.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
}
class Mh {
  constructor(e, n, r) {
    this.active = e, this.id = n, this.open = r;
  }
  static start() {
    return new Mh(UU, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(e) {
    let { state: n } = e, r = n.facet(Gr), o = (r.override || n.languageDataAt("autocomplete", Ws(n)).map(NU)).map((a) => (this.active.find((c) => c.source == a) || new li(
      a,
      this.active.some(
        (c) => c.state != 0
        /* State.Inactive */
      ) ? 1 : 0
      /* State.Inactive */
    )).update(e, r));
    o.length == this.active.length && o.every((a, l) => a == this.active[l]) && (o = this.active);
    let s = this.open;
    s && e.docChanged && (s = s.map(e.changes)), e.selection || o.some((a) => a.hasResult() && e.changes.touchesRange(a.from, a.to)) || !VU(o, this.active) ? s = Cl.build(o, n, this.id, s, r) : s && s.disabled && !o.some(
      (a) => a.state == 1
      /* State.Pending */
    ) && (s = null), !s && o.every(
      (a) => a.state != 1
      /* State.Pending */
    ) && o.some((a) => a.hasResult()) && (o = o.map((a) => a.hasResult() ? new li(
      a.source,
      0
      /* State.Inactive */
    ) : a));
    for (let a of e.effects)
      a.is(_8) && (s = s && s.setSelected(a.value, this.id));
    return o == this.active && s == this.open ? this : new Mh(o, this.id, s);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : HU;
  }
}
function VU(t, e) {
  if (t == e)
    return !0;
  for (let n = 0, r = 0; ; ) {
    for (; n < t.length && !t[n].hasResult; )
      n++;
    for (; r < e.length && !e[r].hasResult; )
      r++;
    let i = n == t.length, o = r == e.length;
    if (i || o)
      return i == o;
    if (t[n++].result != e[r++].result)
      return !1;
  }
}
const HU = {
  "aria-autocomplete": "list"
};
function zx(t, e) {
  let n = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": t
  };
  return e > -1 && (n["aria-activedescendant"] = t + "-" + e), n;
}
const UU = [];
function jv(t) {
  return t.isUserEvent("input.type") ? "input" : t.isUserEvent("delete.backward") ? "delete" : null;
}
class li {
  constructor(e, n, r = -1) {
    this.source = e, this.state = n, this.explicitPos = r;
  }
  hasResult() {
    return !1;
  }
  update(e, n) {
    let r = jv(e), i = this;
    r ? i = i.handleUserEvent(e, r, n) : e.docChanged ? i = i.handleChange(e) : e.selection && i.state != 0 && (i = new li(
      i.source,
      0
      /* State.Inactive */
    ));
    for (let o of e.effects)
      if (o.is(y1))
        i = new li(i.source, 1, o.value ? Ws(e.state) : -1);
      else if (o.is(Bu))
        i = new li(
          i.source,
          0
          /* State.Inactive */
        );
      else if (o.is(M8))
        for (let s of o.value)
          s.source == i.source && (i = s);
    return i;
  }
  handleUserEvent(e, n, r) {
    return n == "delete" || !r.activateOnTyping ? this.map(e.changes) : new li(
      this.source,
      1
      /* State.Pending */
    );
  }
  handleChange(e) {
    return e.changes.touchesRange(Ws(e.startState)) ? new li(
      this.source,
      0
      /* State.Inactive */
    ) : this.map(e.changes);
  }
  map(e) {
    return e.empty || this.explicitPos < 0 ? this : new li(this.source, this.state, e.mapPos(this.explicitPos));
  }
}
class Bl extends li {
  constructor(e, n, r, i, o) {
    super(e, 2, n), this.result = r, this.from = i, this.to = o;
  }
  hasResult() {
    return !0;
  }
  handleUserEvent(e, n, r) {
    var i;
    let o = e.changes.mapPos(this.from), s = e.changes.mapPos(this.to, 1), a = Ws(e.state);
    if ((this.explicitPos < 0 ? a <= o : a < this.from) || a > s || n == "delete" && Ws(e.startState) == this.from)
      return new li(
        this.source,
        n == "input" && r.activateOnTyping ? 1 : 0
        /* State.Inactive */
      );
    let l = this.explicitPos < 0 ? -1 : e.changes.mapPos(this.explicitPos), c;
    return WU(this.result.validFor, e.state, o, s) ? new Bl(this.source, l, this.result, o, s) : this.result.update && (c = this.result.update(this.result, o, s, new E8(e.state, a, l >= 0))) ? new Bl(this.source, l, c, c.from, (i = c.to) !== null && i !== void 0 ? i : Ws(e.state)) : new li(this.source, 1, l);
  }
  handleChange(e) {
    return e.changes.touchesRange(this.from, this.to) ? new li(
      this.source,
      0
      /* State.Inactive */
    ) : this.map(e.changes);
  }
  map(e) {
    return e.empty ? this : new Bl(this.source, this.explicitPos < 0 ? -1 : e.mapPos(this.explicitPos), this.result, e.mapPos(this.from), e.mapPos(this.to, 1));
  }
}
function WU(t, e, n, r) {
  if (!t)
    return !1;
  let i = e.sliceDoc(n, r);
  return typeof t == "function" ? t(i, n, r, e) : A8(t, !0).test(i);
}
const M8 = /* @__PURE__ */ ln.define({
  map(t, e) {
    return t.map((n) => n.map(e));
  }
}), _8 = /* @__PURE__ */ ln.define(), bi = /* @__PURE__ */ Cr.define({
  create() {
    return Mh.start();
  },
  update(t, e) {
    return t.update(e);
  },
  provide: (t) => [
    $p.from(t, (e) => e.tooltip),
    at.contentAttributes.from(t, (e) => e.attrs)
  ]
});
function T8(t, e) {
  const n = e.completion.apply || e.completion.label;
  let r = t.state.field(bi).active.find((i) => i.source == e.source);
  return r instanceof Bl ? (typeof n == "string" ? t.dispatch(Object.assign(Object.assign({}, RU(t.state, n, r.from, r.to)), { annotations: PU.of(e.completion) })) : n(t, e.completion, r.from, r.to), !0) : !1;
}
const JU = /* @__PURE__ */ qU(bi, T8);
function rd(t, e = "option") {
  return (n) => {
    let r = n.state.field(bi, !1);
    if (!r || !r.open || r.open.disabled || Date.now() - r.open.timestamp < n.state.facet(Gr).interactionDelay)
      return !1;
    let i = 1, o;
    e == "page" && (o = o3(n, r.open.tooltip)) && (i = Math.max(2, Math.floor(o.dom.offsetHeight / o.dom.querySelector("li").offsetHeight) - 1));
    let { length: s } = r.open.options, a = r.open.selected > -1 ? r.open.selected + i * (t ? 1 : -1) : t ? 0 : s - 1;
    return a < 0 ? a = e == "page" ? 0 : s - 1 : a >= s && (a = e == "page" ? s - 1 : 0), n.dispatch({ effects: _8.of(a) }), !0;
  };
}
const KU = (t) => {
  let e = t.state.field(bi, !1);
  return t.state.readOnly || !e || !e.open || e.open.selected < 0 || e.open.disabled || Date.now() - e.open.timestamp < t.state.facet(Gr).interactionDelay ? !1 : T8(t, e.open.options[e.open.selected]);
}, GU = (t) => t.state.field(bi, !1) ? (t.dispatch({ effects: y1.of(!0) }), !0) : !1, QU = (t) => {
  let e = t.state.field(bi, !1);
  return !e || !e.active.some(
    (n) => n.state != 0
    /* State.Inactive */
  ) ? !1 : (t.dispatch({ effects: Bu.of(null) }), !0);
};
class YU {
  constructor(e, n) {
    this.active = e, this.context = n, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}
const XU = 50, ZU = 1e3, eW = /* @__PURE__ */ ur.fromClass(class {
  constructor(t) {
    this.view = t, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.composing = 0;
    for (let e of t.state.field(bi).active)
      e.state == 1 && this.startQuery(e);
  }
  update(t) {
    let e = t.state.field(bi);
    if (!t.selectionSet && !t.docChanged && t.startState.field(bi) == e)
      return;
    let n = t.transactions.some((r) => (r.selection || r.docChanged) && !jv(r));
    for (let r = 0; r < this.running.length; r++) {
      let i = this.running[r];
      if (n || i.updates.length + t.transactions.length > XU && Date.now() - i.time > ZU) {
        for (let o of i.context.abortListeners)
          try {
            o();
          } catch (s) {
            $i(this.view.state, s);
          }
        i.context.abortListeners = null, this.running.splice(r--, 1);
      } else
        i.updates.push(...t.transactions);
    }
    if (this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), this.debounceUpdate = e.active.some((r) => r.state == 1 && !this.running.some((i) => i.active.source == r.source)) ? setTimeout(() => this.startUpdate(), 50) : -1, this.composing != 0)
      for (let r of t.transactions)
        jv(r) == "input" ? this.composing = 2 : this.composing == 2 && r.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1;
    let { state: t } = this.view, e = t.field(bi);
    for (let n of e.active)
      n.state == 1 && !this.running.some((r) => r.active.source == n.source) && this.startQuery(n);
  }
  startQuery(t) {
    let { state: e } = this.view, n = Ws(e), r = new E8(e, n, t.explicitPos == n), i = new YU(t, r);
    this.running.push(i), Promise.resolve(t.source(r)).then((o) => {
      i.context.aborted || (i.done = o || null, this.scheduleAccept());
    }, (o) => {
      this.view.dispatch({ effects: Bu.of(null) }), $i(this.view.state, o);
    });
  }
  scheduleAccept() {
    this.running.every((t) => t.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Gr).updateSyncTime));
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var t;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let e = [], n = this.view.state.facet(Gr);
    for (let r = 0; r < this.running.length; r++) {
      let i = this.running[r];
      if (i.done === void 0)
        continue;
      if (this.running.splice(r--, 1), i.done) {
        let s = new Bl(i.active.source, i.active.explicitPos, i.done, i.done.from, (t = i.done.to) !== null && t !== void 0 ? t : Ws(i.updates.length ? i.updates[0].startState : this.view.state));
        for (let a of i.updates)
          s = s.update(a, n);
        if (s.hasResult()) {
          e.push(s);
          continue;
        }
      }
      let o = this.view.state.field(bi).active.find((s) => s.source == i.active.source);
      if (o && o.state == 1)
        if (i.done == null) {
          let s = new li(
            i.active.source,
            0
            /* State.Inactive */
          );
          for (let a of i.updates)
            s = s.update(a, n);
          s.state != 1 && e.push(s);
        } else
          this.startQuery(o);
    }
    e.length && this.view.dispatch({ effects: M8.of(e) });
  }
}, {
  eventHandlers: {
    blur(t) {
      let e = this.view.state.field(bi, !1);
      if (e && e.tooltip && this.view.state.facet(Gr).closeOnBlur) {
        let n = e.open && o3(this.view, e.open.tooltip);
        (!n || !n.dom.contains(t.relatedTarget)) && this.view.dispatch({ effects: Bu.of(null) });
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: y1.of(!1) }), 20), this.composing = 0;
    }
  }
}), tW = /* @__PURE__ */ at.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
}), qu = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
}, _a = /* @__PURE__ */ ln.define({
  map(t, e) {
    let n = e.mapPos(t, -1, ni.TrackAfter);
    return n ?? void 0;
  }
}), b1 = /* @__PURE__ */ new class extends za {
}();
b1.startSide = 1;
b1.endSide = -1;
const P8 = /* @__PURE__ */ Cr.define({
  create() {
    return En.empty;
  },
  update(t, e) {
    if (t = t.map(e.changes), e.selection) {
      let n = e.state.doc.lineAt(e.selection.main.head);
      t = t.update({ filter: (r) => r >= n.from && r <= n.to });
    }
    for (let n of e.effects)
      n.is(_a) && (t = t.update({ add: [b1.range(n.value, n.value + 1)] }));
    return t;
  }
});
function nW() {
  return [iW, P8];
}
const Lm = "()[]{}<>";
function R8(t) {
  for (let e = 0; e < Lm.length; e += 2)
    if (Lm.charCodeAt(e) == t)
      return Lm.charAt(e + 1);
  return z0(t < 128 ? t : t + 1);
}
function N8(t, e) {
  return t.languageDataAt("closeBrackets", e)[0] || qu;
}
const rW = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), iW = /* @__PURE__ */ at.inputHandler.of((t, e, n, r) => {
  if ((rW ? t.composing : t.compositionStarted) || t.state.readOnly)
    return !1;
  let i = t.state.selection.main;
  if (r.length > 2 || r.length == 2 && Mi(Nr(r, 0)) == 1 || e != i.from || n != i.to)
    return !1;
  let o = aW(t.state, r);
  return o ? (t.dispatch(o), !0) : !1;
}), oW = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let r = N8(t, t.selection.main.head).brackets || qu.brackets, i = null, o = t.changeByRange((s) => {
    if (s.empty) {
      let a = lW(t.doc, s.head);
      for (let l of r)
        if (l == a && Ip(t.doc, s.head) == R8(Nr(l, 0)))
          return {
            changes: { from: s.head - l.length, to: s.head + l.length },
            range: Te.cursor(s.head - l.length)
          };
    }
    return { range: i = s };
  });
  return i || e(t.update(o, { scrollIntoView: !0, userEvent: "delete.backward" })), !i;
}, sW = [
  { key: "Backspace", run: oW }
];
function aW(t, e) {
  let n = N8(t, t.selection.main.head), r = n.brackets || qu.brackets;
  for (let i of r) {
    let o = R8(Nr(i, 0));
    if (e == i)
      return o == i ? fW(t, i, r.indexOf(i + i + i) > -1, n) : cW(t, i, o, n.before || qu.before);
    if (e == o && I8(t, t.selection.main.from))
      return uW(t, i, o);
  }
  return null;
}
function I8(t, e) {
  let n = !1;
  return t.field(P8).between(0, t.doc.length, (r) => {
    r == e && (n = !0);
  }), n;
}
function Ip(t, e) {
  let n = t.sliceString(e, e + 2);
  return n.slice(0, Mi(Nr(n, 0)));
}
function lW(t, e) {
  let n = t.sliceString(e - 2, e);
  return Mi(Nr(n, 0)) == n.length ? n : n.slice(1);
}
function cW(t, e, n, r) {
  let i = null, o = t.changeByRange((s) => {
    if (!s.empty)
      return {
        changes: [{ insert: e, from: s.from }, { insert: n, from: s.to }],
        effects: _a.of(s.to + e.length),
        range: Te.range(s.anchor + e.length, s.head + e.length)
      };
    let a = Ip(t.doc, s.head);
    return !a || /\s/.test(a) || r.indexOf(a) > -1 ? {
      changes: { insert: e + n, from: s.head },
      effects: _a.of(s.head + e.length),
      range: Te.cursor(s.head + e.length)
    } : { range: i = s };
  });
  return i ? null : t.update(o, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function uW(t, e, n) {
  let r = null, i = t.changeByRange((o) => o.empty && Ip(t.doc, o.head) == n ? {
    changes: { from: o.head, to: o.head + n.length, insert: n },
    range: Te.cursor(o.head + n.length)
  } : r = { range: o });
  return r ? null : t.update(i, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function fW(t, e, n, r) {
  let i = r.stringPrefixes || qu.stringPrefixes, o = null, s = t.changeByRange((a) => {
    if (!a.empty)
      return {
        changes: [{ insert: e, from: a.from }, { insert: e, from: a.to }],
        effects: _a.of(a.to + e.length),
        range: Te.range(a.anchor + e.length, a.head + e.length)
      };
    let l = a.head, c = Ip(t.doc, l), u;
    if (c == e) {
      if (Fx(t, l))
        return {
          changes: { insert: e + e, from: l },
          effects: _a.of(l + e.length),
          range: Te.cursor(l + e.length)
        };
      if (I8(t, l)) {
        let d = n && t.sliceDoc(l, l + e.length * 3) == e + e + e ? e + e + e : e;
        return {
          changes: { from: l, to: l + d.length, insert: d },
          range: Te.cursor(l + d.length)
        };
      }
    } else {
      if (n && t.sliceDoc(l - 2 * e.length, l) == e + e && (u = Vx(t, l - 2 * e.length, i)) > -1 && Fx(t, u))
        return {
          changes: { insert: e + e + e + e, from: l },
          effects: _a.of(l + e.length),
          range: Te.cursor(l + e.length)
        };
      if (t.charCategorizer(l)(c) != rr.Word && Vx(t, l, i) > -1 && !dW(t, l, e, i))
        return {
          changes: { insert: e + e, from: l },
          effects: _a.of(l + e.length),
          range: Te.cursor(l + e.length)
        };
    }
    return { range: o = a };
  });
  return o ? null : t.update(s, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function Fx(t, e) {
  let n = Zr(t).resolveInner(e + 1);
  return n.parent && n.from == e;
}
function dW(t, e, n, r) {
  let i = Zr(t).resolveInner(e, -1), o = r.reduce((s, a) => Math.max(s, a.length), 0);
  for (let s = 0; s < 5; s++) {
    let a = t.sliceDoc(i.from, Math.min(i.to, i.from + n.length + o)), l = a.indexOf(n);
    if (!l || l > -1 && r.indexOf(a.slice(0, l)) > -1) {
      let u = i.firstChild;
      for (; u && u.from == i.from && u.to - u.from > n.length + l; ) {
        if (t.sliceDoc(u.to - n.length, u.to) == n)
          return !1;
        u = u.firstChild;
      }
      return !0;
    }
    let c = i.to == e && i.parent;
    if (!c)
      break;
    i = c;
  }
  return !1;
}
function Vx(t, e, n) {
  let r = t.charCategorizer(e);
  if (r(t.sliceDoc(e - 1, e)) != rr.Word)
    return e;
  for (let i of n) {
    let o = e - i.length;
    if (t.sliceDoc(o, e) == i && r(t.sliceDoc(o - 1, o)) != rr.Word)
      return o;
  }
  return -1;
}
function hW(t = {}) {
  return [
    bi,
    Gr.of(t),
    eW,
    pW,
    tW
  ];
}
const D8 = [
  { key: "Ctrl-Space", run: GU },
  { key: "Escape", run: QU },
  { key: "ArrowDown", run: /* @__PURE__ */ rd(!0) },
  { key: "ArrowUp", run: /* @__PURE__ */ rd(!1) },
  { key: "PageDown", run: /* @__PURE__ */ rd(!0, "page") },
  { key: "PageUp", run: /* @__PURE__ */ rd(!1, "page") },
  { key: "Enter", run: KU }
], pW = /* @__PURE__ */ vc.highest(/* @__PURE__ */ uh.computeN([Gr], (t) => t.facet(Gr).defaultKeymap ? [D8] : []));
function mW(t, e = t.state) {
  const n = /* @__PURE__ */ new Set();
  for (const { from: r, to: i } of t.visibleRanges) {
    let o = r;
    for (; o <= i; ) {
      const s = e.doc.lineAt(o);
      n.has(s) || n.add(s), o = s.to + 1;
    }
  }
  return n;
}
function kv(t) {
  const e = t.selection.main.head;
  return t.doc.lineAt(e);
}
function Hx(t, e) {
  let n = 0;
  e:
    for (let r = 0; r < t.length; r++)
      switch (t[r]) {
        case " ": {
          n += 1;
          continue e;
        }
        case "	": {
          n += e - n % e;
          continue e;
        }
        case "\r":
          continue e;
        default:
          break e;
      }
  return n;
}
const _h = /* @__PURE__ */ vt.define({
  combine(t) {
    return Ui(t, {
      highlightActiveBlock: !0,
      hideFirstIndent: !1,
      markerType: "fullScope",
      thickness: 1
    });
  }
});
class gW {
  /**
   * @param lines - The set of lines to get the indentation map for.
   * @param state - The {@link EditorState} to derive the indentation map from.
   * @param unitWidth - The width of the editor's indent unit.
   * @param markerType - The type of indentation to use (terminate at end of scope vs last line of code in scope)
   */
  constructor(e, n, r, i) {
    this.lines = e, this.state = n, this.map = /* @__PURE__ */ new Map(), this.unitWidth = r, this.markerType = i;
    for (const o of this.lines)
      this.add(o);
    this.state.facet(_h).highlightActiveBlock && this.findAndSetActiveLines();
  }
  /**
   * Checks if the indentation map has an entry for the given line.
   *
   * @param line - The {@link Line} or line number to check for.
   */
  has(e) {
    return this.map.has(typeof e == "number" ? e : e.number);
  }
  /**
   * Returns the {@link IndentEntry} for the given line.
   *
   * Note that this function will throw an error if the line does not exist in the map.
   *
   * @param line - The {@link Line} or line number to get the entry for.
   */
  get(e) {
    const n = this.map.get(typeof e == "number" ? e : e.number);
    if (!n)
      throw new Error("Line not found in indentation map");
    return n;
  }
  /**
   * Sets the {@link IndentEntry} for the given line.
   *
   * @param line - The {@link Line} to set the entry for.
   * @param col - The visual beginning whitespace width of the line.
   * @param level - The indentation level of the line.
   */
  set(e, n, r) {
    const i = !e.text.trim().length, o = { line: e, col: n, level: r, empty: i };
    return this.map.set(o.line.number, o), o;
  }
  /**
   * Adds a line to the indentation map.
   *
   * @param line - The {@link Line} to add to the map.
   */
  add(e) {
    if (this.has(e))
      return this.get(e);
    if (!e.length || !e.text.trim().length) {
      if (e.number === 1)
        return this.set(e, 0, 0);
      if (e.number === this.state.doc.lines) {
        const s = this.closestNonEmpty(e, -1);
        return this.set(e, 0, s.level);
      }
      const i = this.closestNonEmpty(e, -1), o = this.closestNonEmpty(e, 1);
      return i.level >= o.level && this.markerType !== "codeOnly" ? this.set(e, 0, i.level) : i.empty && i.level === 0 && o.level !== 0 ? this.set(e, 0, 0) : o.level > i.level ? this.set(e, 0, i.level + 1) : this.set(e, 0, o.level);
    }
    const n = Hx(e.text, this.state.tabSize), r = Math.floor(n / this.unitWidth);
    return this.set(e, n, r);
  }
  /**
   * Finds the closest non-empty line, starting from the given line.
   *
   * @param from - The {@link Line} to start from.
   * @param dir - The direction to search in. Either `1` or `-1`.
   */
  closestNonEmpty(e, n) {
    let r = e.number + n;
    for (; n === -1 ? r >= 1 : r <= this.state.doc.lines; ) {
      if (this.has(r)) {
        const s = this.get(r);
        if (!s.empty)
          return s;
      }
      const o = this.state.doc.line(r);
      if (o.text.trim().length) {
        const s = Hx(o.text, this.state.tabSize), a = Math.floor(s / this.unitWidth);
        return this.set(o, s, a);
      }
      r += n;
    }
    const i = this.state.doc.line(n === -1 ? 1 : this.state.doc.lines);
    return this.set(i, 0, 0);
  }
  /**
   * Finds the state's active block (via the current selection) and sets all
   * the active indent level for the lines in the block.
   */
  findAndSetActiveLines() {
    const e = kv(this.state);
    if (!this.has(e))
      return;
    let n = this.get(e);
    if (this.has(n.line.number + 1)) {
      const o = this.get(n.line.number + 1);
      o.level > n.level && (n = o);
    }
    if (this.has(n.line.number - 1)) {
      const o = this.get(n.line.number - 1);
      o.level > n.level && (n = o);
    }
    if (n.level === 0)
      return;
    n.active = n.level;
    let r, i;
    for (r = n.line.number; r > 1; r--) {
      if (!this.has(r - 1))
        continue;
      const o = this.get(r - 1);
      if (o.level < n.level)
        break;
      o.active = n.level;
    }
    for (i = n.line.number; i < this.state.doc.lines; i++) {
      if (!this.has(i + 1))
        continue;
      const o = this.get(i + 1);
      if (o.level < n.level)
        break;
      o.active = n.level;
    }
  }
}
function vW(t) {
  const e = {
    light: "#F0F1F2",
    dark: "#2B3245",
    activeLight: "#E4E5E6",
    activeDark: "#3C445C"
  };
  let n = e;
  return t && (n = Object.assign(Object.assign({}, e), t)), at.baseTheme({
    "&light": {
      "--indent-marker-bg-color": n.light,
      "--indent-marker-active-bg-color": n.activeLight
    },
    "&dark": {
      "--indent-marker-bg-color": n.dark,
      "--indent-marker-active-bg-color": n.activeDark
    },
    ".cm-line": {
      position: "relative"
    },
    // this pseudo-element is used to draw the indent markers,
    // while still allowing the line to have its own background.
    ".cm-indent-markers::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "var(--indent-markers)",
      pointerEvents: "none",
      zIndex: "-1"
    }
  });
}
function id(t, e, n, r, i) {
  return `${`repeating-linear-gradient(to right, var(${t}) 0 ${e}px, transparent ${e}px ${n}ch)`} ${r * n}.5ch/calc(${n * i}ch - 1px) no-repeat`;
}
function yW(t, e, n, r) {
  const { level: i, active: o } = t;
  if (n && i === 0)
    return [];
  const s = n ? 1 : 0, a = [];
  if (o !== void 0) {
    const l = o - s - 1;
    l > 0 && a.push(id("--indent-marker-bg-color", r, e, s, l)), a.push(id("--indent-marker-active-bg-color", r, e, o - 1, 1)), o !== i && a.push(id("--indent-marker-bg-color", r, e, o, i - o));
  } else
    a.push(id("--indent-marker-bg-color", r, e, s, i - s));
  return a.join(",");
}
class bW {
  constructor(e) {
    this.view = e, this.unitWidth = sa(e.state), this.currentLineNumber = kv(e.state).number, this.generate(e.state);
  }
  update(e) {
    const n = sa(e.state), r = n !== this.unitWidth;
    r && (this.unitWidth = n);
    const i = kv(e.state).number, o = i !== this.currentLineNumber;
    this.currentLineNumber = i;
    const s = e.state.facet(_h).highlightActiveBlock && o;
    (e.docChanged || e.viewportChanged || r || s) && this.generate(e.state);
  }
  generate(e) {
    const n = new Fo(), r = mW(this.view, e), { hideFirstIndent: i, markerType: o, thickness: s } = e.facet(_h), a = new gW(r, e, this.unitWidth, o);
    for (const l of r) {
      const c = a.get(l.number);
      if (!(c != null && c.level))
        continue;
      const u = yW(c, this.unitWidth, i, s);
      n.add(l.from, l.from, Bt.line({
        class: "cm-indent-markers",
        attributes: {
          style: `--indent-markers: ${u}`
        }
      }));
    }
    this.decorations = n.finish();
  }
}
function xW(t = {}) {
  return [
    _h.of(t),
    vW(t.colors),
    ur.fromClass(bW, {
      decorations: (e) => e.decorations
    })
  ];
}
class wW {
  constructor(e) {
    this.view = e, this.indentUnit = sa(e.state), this.initialPaddingLeft = null, this.generate(e.state);
  }
  update(e) {
    const n = sa(e.state);
    (n !== this.indentUnit || e.docChanged || e.viewportChanged) && (this.indentUnit = n, this.generate(e.state));
  }
  generate(e) {
    const n = new Fo();
    this.initialPaddingLeft ? this.addStyleToBuilder(n, e, this.initialPaddingLeft) : this.view.requestMeasure({
      read: (r) => {
        const i = r.contentDOM.querySelector(".cm-line");
        i && (this.initialPaddingLeft = window.getComputedStyle(i).getPropertyValue("padding-left"), this.addStyleToBuilder(n, e, this.initialPaddingLeft)), this.decorations = n.finish();
      }
    }), this.decorations = n.finish();
  }
  addStyleToBuilder(e, n, r) {
    const i = this.getVisibleLines(n);
    for (const o of i) {
      const s = this.getIndentSize(o), a = `calc(${s + this.indentUnit}ch + ${r})`;
      e.add(o.from, o.from, Bt.line({
        attributes: {
          style: `padding-left: ${a}; text-indent: -${s + this.indentUnit}ch;`
        }
      }));
    }
  }
  // Get all lines that are currently visible in the viewport.
  getVisibleLines(e) {
    const n = /* @__PURE__ */ new Set();
    let r = null;
    for (const { from: i, to: o } of this.view.visibleRanges) {
      let s = i;
      for (; s <= o; ) {
        const a = e.doc.lineAt(s);
        r !== a && (n.add(a), r = a), s = a.to + 1;
      }
    }
    return n;
  }
  getIndentSize(e) {
    return e.text.length - e.text.trimStart().length;
  }
}
const jW = [
  ur.fromClass(wW, {
    decorations: (t) => t.decorations
  })
];
var Ux = { exports: {} }, L8 = {}, ao = {}, tc = {}, ff = {}, hn = {}, zu = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.regexpCode = t.getEsmExportName = t.getProperty = t.safeStringify = t.stringify = t.strConcat = t.addCodeArg = t.str = t._ = t.nil = t._Code = t.Name = t.IDENTIFIER = t._CodeOrName = void 0;
  class e {
  }
  t._CodeOrName = e, t.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
  class n extends e {
    constructor(y) {
      if (super(), !t.IDENTIFIER.test(y))
        throw new Error("CodeGen: name must be a valid identifier");
      this.str = y;
    }
    toString() {
      return this.str;
    }
    emptyStr() {
      return !1;
    }
    get names() {
      return { [this.str]: 1 };
    }
  }
  t.Name = n;
  class r extends e {
    constructor(y) {
      super(), this._items = typeof y == "string" ? [y] : y;
    }
    toString() {
      return this.str;
    }
    emptyStr() {
      if (this._items.length > 1)
        return !1;
      const y = this._items[0];
      return y === "" || y === '""';
    }
    get str() {
      var y;
      return (y = this._str) !== null && y !== void 0 ? y : this._str = this._items.reduce((w, x) => `${w}${x}`, "");
    }
    get names() {
      var y;
      return (y = this._names) !== null && y !== void 0 ? y : this._names = this._items.reduce((w, x) => (x instanceof n && (w[x.str] = (w[x.str] || 0) + 1), w), {});
    }
  }
  t._Code = r, t.nil = new r("");
  function i(v, ...y) {
    const w = [v[0]];
    let x = 0;
    for (; x < y.length; )
      a(w, y[x]), w.push(v[++x]);
    return new r(w);
  }
  t._ = i;
  const o = new r("+");
  function s(v, ...y) {
    const w = [h(v[0])];
    let x = 0;
    for (; x < y.length; )
      w.push(o), a(w, y[x]), w.push(o, h(v[++x]));
    return l(w), new r(w);
  }
  t.str = s;
  function a(v, y) {
    y instanceof r ? v.push(...y._items) : y instanceof n ? v.push(y) : v.push(f(y));
  }
  t.addCodeArg = a;
  function l(v) {
    let y = 1;
    for (; y < v.length - 1; ) {
      if (v[y] === o) {
        const w = c(v[y - 1], v[y + 1]);
        if (w !== void 0) {
          v.splice(y - 1, 3, w);
          continue;
        }
        v[y++] = "+";
      }
      y++;
    }
  }
  function c(v, y) {
    if (y === '""')
      return v;
    if (v === '""')
      return y;
    if (typeof v == "string")
      return y instanceof n || v[v.length - 1] !== '"' ? void 0 : typeof y != "string" ? `${v.slice(0, -1)}${y}"` : y[0] === '"' ? v.slice(0, -1) + y.slice(1) : void 0;
    if (typeof y == "string" && y[0] === '"' && !(v instanceof n))
      return `"${v}${y.slice(1)}`;
  }
  function u(v, y) {
    return y.emptyStr() ? v : v.emptyStr() ? y : s`${v}${y}`;
  }
  t.strConcat = u;
  function f(v) {
    return typeof v == "number" || typeof v == "boolean" || v === null ? v : h(Array.isArray(v) ? v.join(",") : v);
  }
  function d(v) {
    return new r(h(v));
  }
  t.stringify = d;
  function h(v) {
    return JSON.stringify(v).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
  }
  t.safeStringify = h;
  function p(v) {
    return typeof v == "string" && t.IDENTIFIER.test(v) ? new r(`.${v}`) : i`[${v}]`;
  }
  t.getProperty = p;
  function m(v) {
    if (typeof v == "string" && t.IDENTIFIER.test(v))
      return new r(`${v}`);
    throw new Error(`CodeGen: invalid export name: ${v}, use explicit $id name mapping`);
  }
  t.getEsmExportName = m;
  function g(v) {
    return new r(v.toString());
  }
  t.regexpCode = g;
})(zu);
var $v = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.ValueScope = t.ValueScopeName = t.Scope = t.varKinds = t.UsedValueState = void 0;
  const e = zu;
  class n extends Error {
    constructor(c) {
      super(`CodeGen: "code" for ${c} not defined`), this.value = c.value;
    }
  }
  var r;
  (function(l) {
    l[l.Started = 0] = "Started", l[l.Completed = 1] = "Completed";
  })(r = t.UsedValueState || (t.UsedValueState = {})), t.varKinds = {
    const: new e.Name("const"),
    let: new e.Name("let"),
    var: new e.Name("var")
  };
  class i {
    constructor({ prefixes: c, parent: u } = {}) {
      this._names = {}, this._prefixes = c, this._parent = u;
    }
    toName(c) {
      return c instanceof e.Name ? c : this.name(c);
    }
    name(c) {
      return new e.Name(this._newName(c));
    }
    _newName(c) {
      const u = this._names[c] || this._nameGroup(c);
      return `${c}${u.index++}`;
    }
    _nameGroup(c) {
      var u, f;
      if (!((f = (u = this._parent) === null || u === void 0 ? void 0 : u._prefixes) === null || f === void 0) && f.has(c) || this._prefixes && !this._prefixes.has(c))
        throw new Error(`CodeGen: prefix "${c}" is not allowed in this scope`);
      return this._names[c] = { prefix: c, index: 0 };
    }
  }
  t.Scope = i;
  class o extends e.Name {
    constructor(c, u) {
      super(u), this.prefix = c;
    }
    setValue(c, { property: u, itemIndex: f }) {
      this.value = c, this.scopePath = (0, e._)`.${new e.Name(u)}[${f}]`;
    }
  }
  t.ValueScopeName = o;
  const s = (0, e._)`\n`;
  class a extends i {
    constructor(c) {
      super(c), this._values = {}, this._scope = c.scope, this.opts = { ...c, _n: c.lines ? s : e.nil };
    }
    get() {
      return this._scope;
    }
    name(c) {
      return new o(c, this._newName(c));
    }
    value(c, u) {
      var f;
      if (u.ref === void 0)
        throw new Error("CodeGen: ref must be passed in value");
      const d = this.toName(c), { prefix: h } = d, p = (f = u.key) !== null && f !== void 0 ? f : u.ref;
      let m = this._values[h];
      if (m) {
        const y = m.get(p);
        if (y)
          return y;
      } else
        m = this._values[h] = /* @__PURE__ */ new Map();
      m.set(p, d);
      const g = this._scope[h] || (this._scope[h] = []), v = g.length;
      return g[v] = u.ref, d.setValue(u, { property: h, itemIndex: v }), d;
    }
    getValue(c, u) {
      const f = this._values[c];
      if (f)
        return f.get(u);
    }
    scopeRefs(c, u = this._values) {
      return this._reduceValues(u, (f) => {
        if (f.scopePath === void 0)
          throw new Error(`CodeGen: name "${f}" has no value`);
        return (0, e._)`${c}${f.scopePath}`;
      });
    }
    scopeCode(c = this._values, u, f) {
      return this._reduceValues(c, (d) => {
        if (d.value === void 0)
          throw new Error(`CodeGen: name "${d}" has no value`);
        return d.value.code;
      }, u, f);
    }
    _reduceValues(c, u, f = {}, d) {
      let h = e.nil;
      for (const p in c) {
        const m = c[p];
        if (!m)
          continue;
        const g = f[p] = f[p] || /* @__PURE__ */ new Map();
        m.forEach((v) => {
          if (g.has(v))
            return;
          g.set(v, r.Started);
          let y = u(v);
          if (y) {
            const w = this.opts.es5 ? t.varKinds.var : t.varKinds.const;
            h = (0, e._)`${h}${w} ${v} = ${y};${this.opts._n}`;
          } else if (y = d == null ? void 0 : d(v))
            h = (0, e._)`${h}${y}${this.opts._n}`;
          else
            throw new n(v);
          g.set(v, r.Completed);
        });
      }
      return h;
    }
  }
  t.ValueScope = a;
})($v);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.or = t.and = t.not = t.CodeGen = t.operators = t.varKinds = t.ValueScopeName = t.ValueScope = t.Scope = t.Name = t.regexpCode = t.stringify = t.getProperty = t.nil = t.strConcat = t.str = t._ = void 0;
  const e = zu, n = $v;
  var r = zu;
  Object.defineProperty(t, "_", { enumerable: !0, get: function() {
    return r._;
  } }), Object.defineProperty(t, "str", { enumerable: !0, get: function() {
    return r.str;
  } }), Object.defineProperty(t, "strConcat", { enumerable: !0, get: function() {
    return r.strConcat;
  } }), Object.defineProperty(t, "nil", { enumerable: !0, get: function() {
    return r.nil;
  } }), Object.defineProperty(t, "getProperty", { enumerable: !0, get: function() {
    return r.getProperty;
  } }), Object.defineProperty(t, "stringify", { enumerable: !0, get: function() {
    return r.stringify;
  } }), Object.defineProperty(t, "regexpCode", { enumerable: !0, get: function() {
    return r.regexpCode;
  } }), Object.defineProperty(t, "Name", { enumerable: !0, get: function() {
    return r.Name;
  } });
  var i = $v;
  Object.defineProperty(t, "Scope", { enumerable: !0, get: function() {
    return i.Scope;
  } }), Object.defineProperty(t, "ValueScope", { enumerable: !0, get: function() {
    return i.ValueScope;
  } }), Object.defineProperty(t, "ValueScopeName", { enumerable: !0, get: function() {
    return i.ValueScopeName;
  } }), Object.defineProperty(t, "varKinds", { enumerable: !0, get: function() {
    return i.varKinds;
  } }), t.operators = {
    GT: new e._Code(">"),
    GTE: new e._Code(">="),
    LT: new e._Code("<"),
    LTE: new e._Code("<="),
    EQ: new e._Code("==="),
    NEQ: new e._Code("!=="),
    NOT: new e._Code("!"),
    OR: new e._Code("||"),
    AND: new e._Code("&&"),
    ADD: new e._Code("+")
  };
  class o {
    optimizeNodes() {
      return this;
    }
    optimizeNames(E, A) {
      return this;
    }
  }
  class s extends o {
    constructor(E, A, te) {
      super(), this.varKind = E, this.name = A, this.rhs = te;
    }
    render({ es5: E, _n: A }) {
      const te = E ? n.varKinds.var : this.varKind, ge = this.rhs === void 0 ? "" : ` = ${this.rhs}`;
      return `${te} ${this.name}${ge};` + A;
    }
    optimizeNames(E, A) {
      if (E[this.name.str])
        return this.rhs && (this.rhs = D(this.rhs, E, A)), this;
    }
    get names() {
      return this.rhs instanceof e._CodeOrName ? this.rhs.names : {};
    }
  }
  class a extends o {
    constructor(E, A, te) {
      super(), this.lhs = E, this.rhs = A, this.sideEffects = te;
    }
    render({ _n: E }) {
      return `${this.lhs} = ${this.rhs};` + E;
    }
    optimizeNames(E, A) {
      if (!(this.lhs instanceof e.Name && !E[this.lhs.str] && !this.sideEffects))
        return this.rhs = D(this.rhs, E, A), this;
    }
    get names() {
      const E = this.lhs instanceof e.Name ? {} : { ...this.lhs.names };
      return J(E, this.rhs);
    }
  }
  class l extends a {
    constructor(E, A, te, ge) {
      super(E, te, ge), this.op = A;
    }
    render({ _n: E }) {
      return `${this.lhs} ${this.op}= ${this.rhs};` + E;
    }
  }
  class c extends o {
    constructor(E) {
      super(), this.label = E, this.names = {};
    }
    render({ _n: E }) {
      return `${this.label}:` + E;
    }
  }
  class u extends o {
    constructor(E) {
      super(), this.label = E, this.names = {};
    }
    render({ _n: E }) {
      return `break${this.label ? ` ${this.label}` : ""};` + E;
    }
  }
  class f extends o {
    constructor(E) {
      super(), this.error = E;
    }
    render({ _n: E }) {
      return `throw ${this.error};` + E;
    }
    get names() {
      return this.error.names;
    }
  }
  class d extends o {
    constructor(E) {
      super(), this.code = E;
    }
    render({ _n: E }) {
      return `${this.code};` + E;
    }
    optimizeNodes() {
      return `${this.code}` ? this : void 0;
    }
    optimizeNames(E, A) {
      return this.code = D(this.code, E, A), this;
    }
    get names() {
      return this.code instanceof e._CodeOrName ? this.code.names : {};
    }
  }
  class h extends o {
    constructor(E = []) {
      super(), this.nodes = E;
    }
    render(E) {
      return this.nodes.reduce((A, te) => A + te.render(E), "");
    }
    optimizeNodes() {
      const { nodes: E } = this;
      let A = E.length;
      for (; A--; ) {
        const te = E[A].optimizeNodes();
        Array.isArray(te) ? E.splice(A, 1, ...te) : te ? E[A] = te : E.splice(A, 1);
      }
      return E.length > 0 ? this : void 0;
    }
    optimizeNames(E, A) {
      const { nodes: te } = this;
      let ge = te.length;
      for (; ge--; ) {
        const ke = te[ge];
        ke.optimizeNames(E, A) || (Q(E, ke.names), te.splice(ge, 1));
      }
      return te.length > 0 ? this : void 0;
    }
    get names() {
      return this.nodes.reduce((E, A) => P(E, A.names), {});
    }
  }
  class p extends h {
    render(E) {
      return "{" + E._n + super.render(E) + "}" + E._n;
    }
  }
  class m extends h {
  }
  class g extends p {
  }
  g.kind = "else";
  class v extends p {
    constructor(E, A) {
      super(A), this.condition = E;
    }
    render(E) {
      let A = `if(${this.condition})` + super.render(E);
      return this.else && (A += "else " + this.else.render(E)), A;
    }
    optimizeNodes() {
      super.optimizeNodes();
      const E = this.condition;
      if (E === !0)
        return this.nodes;
      let A = this.else;
      if (A) {
        const te = A.optimizeNodes();
        A = this.else = Array.isArray(te) ? new g(te) : te;
      }
      if (A)
        return E === !1 ? A instanceof v ? A : A.nodes : this.nodes.length ? this : new v(Z(E), A instanceof v ? [A] : A.nodes);
      if (!(E === !1 || !this.nodes.length))
        return this;
    }
    optimizeNames(E, A) {
      var te;
      if (this.else = (te = this.else) === null || te === void 0 ? void 0 : te.optimizeNames(E, A), !!(super.optimizeNames(E, A) || this.else))
        return this.condition = D(this.condition, E, A), this;
    }
    get names() {
      const E = super.names;
      return J(E, this.condition), this.else && P(E, this.else.names), E;
    }
  }
  v.kind = "if";
  class y extends p {
  }
  y.kind = "for";
  class w extends y {
    constructor(E) {
      super(), this.iteration = E;
    }
    render(E) {
      return `for(${this.iteration})` + super.render(E);
    }
    optimizeNames(E, A) {
      if (super.optimizeNames(E, A))
        return this.iteration = D(this.iteration, E, A), this;
    }
    get names() {
      return P(super.names, this.iteration.names);
    }
  }
  class x extends y {
    constructor(E, A, te, ge) {
      super(), this.varKind = E, this.name = A, this.from = te, this.to = ge;
    }
    render(E) {
      const A = E.es5 ? n.varKinds.var : this.varKind, { name: te, from: ge, to: ke } = this;
      return `for(${A} ${te}=${ge}; ${te}<${ke}; ${te}++)` + super.render(E);
    }
    get names() {
      const E = J(super.names, this.from);
      return J(E, this.to);
    }
  }
  class b extends y {
    constructor(E, A, te, ge) {
      super(), this.loop = E, this.varKind = A, this.name = te, this.iterable = ge;
    }
    render(E) {
      return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(E);
    }
    optimizeNames(E, A) {
      if (super.optimizeNames(E, A))
        return this.iterable = D(this.iterable, E, A), this;
    }
    get names() {
      return P(super.names, this.iterable.names);
    }
  }
  class j extends p {
    constructor(E, A, te) {
      super(), this.name = E, this.args = A, this.async = te;
    }
    render(E) {
      return `${this.async ? "async " : ""}function ${this.name}(${this.args})` + super.render(E);
    }
  }
  j.kind = "func";
  class $ extends h {
    render(E) {
      return "return " + super.render(E);
    }
  }
  $.kind = "return";
  class N extends p {
    render(E) {
      let A = "try" + super.render(E);
      return this.catch && (A += this.catch.render(E)), this.finally && (A += this.finally.render(E)), A;
    }
    optimizeNodes() {
      var E, A;
      return super.optimizeNodes(), (E = this.catch) === null || E === void 0 || E.optimizeNodes(), (A = this.finally) === null || A === void 0 || A.optimizeNodes(), this;
    }
    optimizeNames(E, A) {
      var te, ge;
      return super.optimizeNames(E, A), (te = this.catch) === null || te === void 0 || te.optimizeNames(E, A), (ge = this.finally) === null || ge === void 0 || ge.optimizeNames(E, A), this;
    }
    get names() {
      const E = super.names;
      return this.catch && P(E, this.catch.names), this.finally && P(E, this.finally.names), E;
    }
  }
  class B extends p {
    constructor(E) {
      super(), this.error = E;
    }
    render(E) {
      return `catch(${this.error})` + super.render(E);
    }
  }
  B.kind = "catch";
  class O extends p {
    render(E) {
      return "finally" + super.render(E);
    }
  }
  O.kind = "finally";
  class I {
    constructor(E, A = {}) {
      this._values = {}, this._blockStarts = [], this._constants = {}, this.opts = { ...A, _n: A.lines ? `
` : "" }, this._extScope = E, this._scope = new n.Scope({ parent: E }), this._nodes = [new m()];
    }
    toString() {
      return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(E) {
      return this._scope.name(E);
    }
    // reserves unique name in the external scope
    scopeName(E) {
      return this._extScope.name(E);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(E, A) {
      const te = this._extScope.value(E, A);
      return (this._values[te.prefix] || (this._values[te.prefix] = /* @__PURE__ */ new Set())).add(te), te;
    }
    getScopeValue(E, A) {
      return this._extScope.getValue(E, A);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(E) {
      return this._extScope.scopeRefs(E, this._values);
    }
    scopeCode() {
      return this._extScope.scopeCode(this._values);
    }
    _def(E, A, te, ge) {
      const ke = this._scope.toName(A);
      return te !== void 0 && ge && (this._constants[ke.str] = te), this._leafNode(new s(E, ke, te)), ke;
    }
    // `const` declaration (`var` in es5 mode)
    const(E, A, te) {
      return this._def(n.varKinds.const, E, A, te);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(E, A, te) {
      return this._def(n.varKinds.let, E, A, te);
    }
    // `var` declaration with optional assignment
    var(E, A, te) {
      return this._def(n.varKinds.var, E, A, te);
    }
    // assignment code
    assign(E, A, te) {
      return this._leafNode(new a(E, A, te));
    }
    // `+=` code
    add(E, A) {
      return this._leafNode(new l(E, t.operators.ADD, A));
    }
    // appends passed SafeExpr to code or executes Block
    code(E) {
      return typeof E == "function" ? E() : E !== e.nil && this._leafNode(new d(E)), this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...E) {
      const A = ["{"];
      for (const [te, ge] of E)
        A.length > 1 && A.push(","), A.push(te), (te !== ge || this.opts.es5) && (A.push(":"), (0, e.addCodeArg)(A, ge));
      return A.push("}"), new e._Code(A);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(E, A, te) {
      if (this._blockNode(new v(E)), A && te)
        this.code(A).else().code(te).endIf();
      else if (A)
        this.code(A).endIf();
      else if (te)
        throw new Error('CodeGen: "else" body without "then" body');
      return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(E) {
      return this._elseNode(new v(E));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
      return this._elseNode(new g());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
      return this._endBlockNode(v, g);
    }
    _for(E, A) {
      return this._blockNode(E), A && this.code(A).endFor(), this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(E, A) {
      return this._for(new w(E), A);
    }
    // `for` statement for a range of values
    forRange(E, A, te, ge, ke = this.opts.es5 ? n.varKinds.var : n.varKinds.let) {
      const Ce = this._scope.toName(E);
      return this._for(new x(ke, Ce, A, te), () => ge(Ce));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(E, A, te, ge = n.varKinds.const) {
      const ke = this._scope.toName(E);
      if (this.opts.es5) {
        const Ce = A instanceof e.Name ? A : this.var("_arr", A);
        return this.forRange("_i", 0, (0, e._)`${Ce}.length`, (we) => {
          this.var(ke, (0, e._)`${Ce}[${we}]`), te(ke);
        });
      }
      return this._for(new b("of", ge, ke, A), () => te(ke));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(E, A, te, ge = this.opts.es5 ? n.varKinds.var : n.varKinds.const) {
      if (this.opts.ownProperties)
        return this.forOf(E, (0, e._)`Object.keys(${A})`, te);
      const ke = this._scope.toName(E);
      return this._for(new b("in", ge, ke, A), () => te(ke));
    }
    // end `for` loop
    endFor() {
      return this._endBlockNode(y);
    }
    // `label` statement
    label(E) {
      return this._leafNode(new c(E));
    }
    // `break` statement
    break(E) {
      return this._leafNode(new u(E));
    }
    // `return` statement
    return(E) {
      const A = new $();
      if (this._blockNode(A), this.code(E), A.nodes.length !== 1)
        throw new Error('CodeGen: "return" should have one node');
      return this._endBlockNode($);
    }
    // `try` statement
    try(E, A, te) {
      if (!A && !te)
        throw new Error('CodeGen: "try" without "catch" and "finally"');
      const ge = new N();
      if (this._blockNode(ge), this.code(E), A) {
        const ke = this.name("e");
        this._currNode = ge.catch = new B(ke), A(ke);
      }
      return te && (this._currNode = ge.finally = new O(), this.code(te)), this._endBlockNode(B, O);
    }
    // `throw` statement
    throw(E) {
      return this._leafNode(new f(E));
    }
    // start self-balancing block
    block(E, A) {
      return this._blockStarts.push(this._nodes.length), E && this.code(E).endBlock(A), this;
    }
    // end the current self-balancing block
    endBlock(E) {
      const A = this._blockStarts.pop();
      if (A === void 0)
        throw new Error("CodeGen: not in self-balancing block");
      const te = this._nodes.length - A;
      if (te < 0 || E !== void 0 && te !== E)
        throw new Error(`CodeGen: wrong number of nodes: ${te} vs ${E} expected`);
      return this._nodes.length = A, this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(E, A = e.nil, te, ge) {
      return this._blockNode(new j(E, A, te)), ge && this.code(ge).endFunc(), this;
    }
    // end function definition
    endFunc() {
      return this._endBlockNode(j);
    }
    optimize(E = 1) {
      for (; E-- > 0; )
        this._root.optimizeNodes(), this._root.optimizeNames(this._root.names, this._constants);
    }
    _leafNode(E) {
      return this._currNode.nodes.push(E), this;
    }
    _blockNode(E) {
      this._currNode.nodes.push(E), this._nodes.push(E);
    }
    _endBlockNode(E, A) {
      const te = this._currNode;
      if (te instanceof E || A && te instanceof A)
        return this._nodes.pop(), this;
      throw new Error(`CodeGen: not in block "${A ? `${E.kind}/${A.kind}` : E.kind}"`);
    }
    _elseNode(E) {
      const A = this._currNode;
      if (!(A instanceof v))
        throw new Error('CodeGen: "else" without "if"');
      return this._currNode = A.else = E, this;
    }
    get _root() {
      return this._nodes[0];
    }
    get _currNode() {
      const E = this._nodes;
      return E[E.length - 1];
    }
    set _currNode(E) {
      const A = this._nodes;
      A[A.length - 1] = E;
    }
  }
  t.CodeGen = I;
  function P(z, E) {
    for (const A in E)
      z[A] = (z[A] || 0) + (E[A] || 0);
    return z;
  }
  function J(z, E) {
    return E instanceof e._CodeOrName ? P(z, E.names) : z;
  }
  function D(z, E, A) {
    if (z instanceof e.Name)
      return te(z);
    if (!ge(z))
      return z;
    return new e._Code(z._items.reduce((ke, Ce) => (Ce instanceof e.Name && (Ce = te(Ce)), Ce instanceof e._Code ? ke.push(...Ce._items) : ke.push(Ce), ke), []));
    function te(ke) {
      const Ce = A[ke.str];
      return Ce === void 0 || E[ke.str] !== 1 ? ke : (delete E[ke.str], Ce);
    }
    function ge(ke) {
      return ke instanceof e._Code && ke._items.some((Ce) => Ce instanceof e.Name && E[Ce.str] === 1 && A[Ce.str] !== void 0);
    }
  }
  function Q(z, E) {
    for (const A in E)
      z[A] = (z[A] || 0) - (E[A] || 0);
  }
  function Z(z) {
    return typeof z == "boolean" || typeof z == "number" || z === null ? !z : (0, e._)`!${F(z)}`;
  }
  t.not = Z;
  const L = C(t.operators.AND);
  function R(...z) {
    return z.reduce(L);
  }
  t.and = R;
  const V = C(t.operators.OR);
  function M(...z) {
    return z.reduce(V);
  }
  t.or = M;
  function C(z) {
    return (E, A) => E === e.nil ? A : A === e.nil ? E : (0, e._)`${F(E)} ${z} ${F(A)}`;
  }
  function F(z) {
    return z instanceof e.Name ? z : (0, e._)`(${z})`;
  }
})(hn);
var jn = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.checkStrictMode = t.getErrorPath = t.Type = t.useFunc = t.setEvaluated = t.evaluatedPropsToName = t.mergeEvaluated = t.eachItem = t.unescapeJsonPointer = t.escapeJsonPointer = t.escapeFragment = t.unescapeFragment = t.schemaRefOrVal = t.schemaHasRulesButRef = t.schemaHasRules = t.checkUnknownRules = t.alwaysValidSchema = t.toHash = void 0;
  const e = hn, n = zu;
  function r(j) {
    const $ = {};
    for (const N of j)
      $[N] = !0;
    return $;
  }
  t.toHash = r;
  function i(j, $) {
    return typeof $ == "boolean" ? $ : Object.keys($).length === 0 ? !0 : (o(j, $), !s($, j.self.RULES.all));
  }
  t.alwaysValidSchema = i;
  function o(j, $ = j.schema) {
    const { opts: N, self: B } = j;
    if (!N.strictSchema || typeof $ == "boolean")
      return;
    const O = B.RULES.keywords;
    for (const I in $)
      O[I] || b(j, `unknown keyword: "${I}"`);
  }
  t.checkUnknownRules = o;
  function s(j, $) {
    if (typeof j == "boolean")
      return !j;
    for (const N in j)
      if ($[N])
        return !0;
    return !1;
  }
  t.schemaHasRules = s;
  function a(j, $) {
    if (typeof j == "boolean")
      return !j;
    for (const N in j)
      if (N !== "$ref" && $.all[N])
        return !0;
    return !1;
  }
  t.schemaHasRulesButRef = a;
  function l({ topSchemaRef: j, schemaPath: $ }, N, B, O) {
    if (!O) {
      if (typeof N == "number" || typeof N == "boolean")
        return N;
      if (typeof N == "string")
        return (0, e._)`${N}`;
    }
    return (0, e._)`${j}${$}${(0, e.getProperty)(B)}`;
  }
  t.schemaRefOrVal = l;
  function c(j) {
    return d(decodeURIComponent(j));
  }
  t.unescapeFragment = c;
  function u(j) {
    return encodeURIComponent(f(j));
  }
  t.escapeFragment = u;
  function f(j) {
    return typeof j == "number" ? `${j}` : j.replace(/~/g, "~0").replace(/\//g, "~1");
  }
  t.escapeJsonPointer = f;
  function d(j) {
    return j.replace(/~1/g, "/").replace(/~0/g, "~");
  }
  t.unescapeJsonPointer = d;
  function h(j, $) {
    if (Array.isArray(j))
      for (const N of j)
        $(N);
    else
      $(j);
  }
  t.eachItem = h;
  function p({ mergeNames: j, mergeToName: $, mergeValues: N, resultToName: B }) {
    return (O, I, P, J) => {
      const D = P === void 0 ? I : P instanceof e.Name ? (I instanceof e.Name ? j(O, I, P) : $(O, I, P), P) : I instanceof e.Name ? ($(O, P, I), I) : N(I, P);
      return J === e.Name && !(D instanceof e.Name) ? B(O, D) : D;
    };
  }
  t.mergeEvaluated = {
    props: p({
      mergeNames: (j, $, N) => j.if((0, e._)`${N} !== true && ${$} !== undefined`, () => {
        j.if((0, e._)`${$} === true`, () => j.assign(N, !0), () => j.assign(N, (0, e._)`${N} || {}`).code((0, e._)`Object.assign(${N}, ${$})`));
      }),
      mergeToName: (j, $, N) => j.if((0, e._)`${N} !== true`, () => {
        $ === !0 ? j.assign(N, !0) : (j.assign(N, (0, e._)`${N} || {}`), g(j, N, $));
      }),
      mergeValues: (j, $) => j === !0 ? !0 : { ...j, ...$ },
      resultToName: m
    }),
    items: p({
      mergeNames: (j, $, N) => j.if((0, e._)`${N} !== true && ${$} !== undefined`, () => j.assign(N, (0, e._)`${$} === true ? true : ${N} > ${$} ? ${N} : ${$}`)),
      mergeToName: (j, $, N) => j.if((0, e._)`${N} !== true`, () => j.assign(N, $ === !0 ? !0 : (0, e._)`${N} > ${$} ? ${N} : ${$}`)),
      mergeValues: (j, $) => j === !0 ? !0 : Math.max(j, $),
      resultToName: (j, $) => j.var("items", $)
    })
  };
  function m(j, $) {
    if ($ === !0)
      return j.var("props", !0);
    const N = j.var("props", (0, e._)`{}`);
    return $ !== void 0 && g(j, N, $), N;
  }
  t.evaluatedPropsToName = m;
  function g(j, $, N) {
    Object.keys(N).forEach((B) => j.assign((0, e._)`${$}${(0, e.getProperty)(B)}`, !0));
  }
  t.setEvaluated = g;
  const v = {};
  function y(j, $) {
    return j.scopeValue("func", {
      ref: $,
      code: v[$.code] || (v[$.code] = new n._Code($.code))
    });
  }
  t.useFunc = y;
  var w;
  (function(j) {
    j[j.Num = 0] = "Num", j[j.Str = 1] = "Str";
  })(w = t.Type || (t.Type = {}));
  function x(j, $, N) {
    if (j instanceof e.Name) {
      const B = $ === w.Num;
      return N ? B ? (0, e._)`"[" + ${j} + "]"` : (0, e._)`"['" + ${j} + "']"` : B ? (0, e._)`"/" + ${j}` : (0, e._)`"/" + ${j}.replace(/~/g, "~0").replace(/\\//g, "~1")`;
    }
    return N ? (0, e.getProperty)(j).toString() : "/" + f(j);
  }
  t.getErrorPath = x;
  function b(j, $, N = j.opts.strictSchema) {
    if (N) {
      if ($ = `strict mode: ${$}`, N === !0)
        throw new Error($);
      j.self.logger.warn($);
    }
  }
  t.checkStrictMode = b;
})(jn);
var Xo = {};
Object.defineProperty(Xo, "__esModule", { value: !0 });
const Vr = hn, kW = {
  // validation function arguments
  data: new Vr.Name("data"),
  // args passed from referencing schema
  valCxt: new Vr.Name("valCxt"),
  instancePath: new Vr.Name("instancePath"),
  parentData: new Vr.Name("parentData"),
  parentDataProperty: new Vr.Name("parentDataProperty"),
  rootData: new Vr.Name("rootData"),
  dynamicAnchors: new Vr.Name("dynamicAnchors"),
  // function scoped variables
  vErrors: new Vr.Name("vErrors"),
  errors: new Vr.Name("errors"),
  this: new Vr.Name("this"),
  // "globals"
  self: new Vr.Name("self"),
  scope: new Vr.Name("scope"),
  // JTD serialize/parse name for JSON string and position
  json: new Vr.Name("json"),
  jsonPos: new Vr.Name("jsonPos"),
  jsonLen: new Vr.Name("jsonLen"),
  jsonPart: new Vr.Name("jsonPart")
};
Xo.default = kW;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.extendErrors = t.resetErrorsCount = t.reportExtraError = t.reportError = t.keyword$DataError = t.keywordError = void 0;
  const e = hn, n = jn, r = Xo;
  t.keywordError = {
    message: ({ keyword: g }) => (0, e.str)`must pass "${g}" keyword validation`
  }, t.keyword$DataError = {
    message: ({ keyword: g, schemaType: v }) => v ? (0, e.str)`"${g}" keyword must be ${v} ($data)` : (0, e.str)`"${g}" keyword is invalid ($data)`
  };
  function i(g, v = t.keywordError, y, w) {
    const { it: x } = g, { gen: b, compositeRule: j, allErrors: $ } = x, N = f(g, v, y);
    w ?? (j || $) ? l(b, N) : c(x, (0, e._)`[${N}]`);
  }
  t.reportError = i;
  function o(g, v = t.keywordError, y) {
    const { it: w } = g, { gen: x, compositeRule: b, allErrors: j } = w, $ = f(g, v, y);
    l(x, $), b || j || c(w, r.default.vErrors);
  }
  t.reportExtraError = o;
  function s(g, v) {
    g.assign(r.default.errors, v), g.if((0, e._)`${r.default.vErrors} !== null`, () => g.if(v, () => g.assign((0, e._)`${r.default.vErrors}.length`, v), () => g.assign(r.default.vErrors, null)));
  }
  t.resetErrorsCount = s;
  function a({ gen: g, keyword: v, schemaValue: y, data: w, errsCount: x, it: b }) {
    if (x === void 0)
      throw new Error("ajv implementation error");
    const j = g.name("err");
    g.forRange("i", x, r.default.errors, ($) => {
      g.const(j, (0, e._)`${r.default.vErrors}[${$}]`), g.if((0, e._)`${j}.instancePath === undefined`, () => g.assign((0, e._)`${j}.instancePath`, (0, e.strConcat)(r.default.instancePath, b.errorPath))), g.assign((0, e._)`${j}.schemaPath`, (0, e.str)`${b.errSchemaPath}/${v}`), b.opts.verbose && (g.assign((0, e._)`${j}.schema`, y), g.assign((0, e._)`${j}.data`, w));
    });
  }
  t.extendErrors = a;
  function l(g, v) {
    const y = g.const("err", v);
    g.if((0, e._)`${r.default.vErrors} === null`, () => g.assign(r.default.vErrors, (0, e._)`[${y}]`), (0, e._)`${r.default.vErrors}.push(${y})`), g.code((0, e._)`${r.default.errors}++`);
  }
  function c(g, v) {
    const { gen: y, validateName: w, schemaEnv: x } = g;
    x.$async ? y.throw((0, e._)`new ${g.ValidationError}(${v})`) : (y.assign((0, e._)`${w}.errors`, v), y.return(!1));
  }
  const u = {
    keyword: new e.Name("keyword"),
    schemaPath: new e.Name("schemaPath"),
    params: new e.Name("params"),
    propertyName: new e.Name("propertyName"),
    message: new e.Name("message"),
    schema: new e.Name("schema"),
    parentSchema: new e.Name("parentSchema")
  };
  function f(g, v, y) {
    const { createErrors: w } = g.it;
    return w === !1 ? (0, e._)`{}` : d(g, v, y);
  }
  function d(g, v, y = {}) {
    const { gen: w, it: x } = g, b = [
      h(x, y),
      p(g, y)
    ];
    return m(g, v, b), w.object(...b);
  }
  function h({ errorPath: g }, { instancePath: v }) {
    const y = v ? (0, e.str)`${g}${(0, n.getErrorPath)(v, n.Type.Str)}` : g;
    return [r.default.instancePath, (0, e.strConcat)(r.default.instancePath, y)];
  }
  function p({ keyword: g, it: { errSchemaPath: v } }, { schemaPath: y, parentSchema: w }) {
    let x = w ? v : (0, e.str)`${v}/${g}`;
    return y && (x = (0, e.str)`${x}${(0, n.getErrorPath)(y, n.Type.Str)}`), [u.schemaPath, x];
  }
  function m(g, { params: v, message: y }, w) {
    const { keyword: x, data: b, schemaValue: j, it: $ } = g, { opts: N, propertyName: B, topSchemaRef: O, schemaPath: I } = $;
    w.push([u.keyword, x], [u.params, typeof v == "function" ? v(g) : v || (0, e._)`{}`]), N.messages && w.push([u.message, typeof y == "function" ? y(g) : y]), N.verbose && w.push([u.schema, j], [u.parentSchema, (0, e._)`${O}${I}`], [r.default.data, b]), B && w.push([u.propertyName, B]);
  }
})(ff);
Object.defineProperty(tc, "__esModule", { value: !0 });
tc.boolOrEmptySchema = tc.topBoolOrEmptySchema = void 0;
const $W = ff, SW = hn, CW = Xo, OW = {
  message: "boolean schema is false"
};
function EW(t) {
  const { gen: e, schema: n, validateName: r } = t;
  n === !1 ? B8(t, !1) : typeof n == "object" && n.$async === !0 ? e.return(CW.default.data) : (e.assign((0, SW._)`${r}.errors`, null), e.return(!0));
}
tc.topBoolOrEmptySchema = EW;
function AW(t, e) {
  const { gen: n, schema: r } = t;
  r === !1 ? (n.var(e, !1), B8(t)) : n.var(e, !0);
}
tc.boolOrEmptySchema = AW;
function B8(t, e) {
  const { gen: n, data: r } = t, i = {
    gen: n,
    keyword: "false schema",
    data: r,
    schema: !1,
    schemaCode: !1,
    schemaValue: !1,
    params: {},
    it: t
  };
  (0, $W.reportError)(i, OW, void 0, e);
}
var df = {}, Ha = {};
Object.defineProperty(Ha, "__esModule", { value: !0 });
Ha.getRules = Ha.isJSONType = void 0;
const MW = ["string", "number", "integer", "boolean", "null", "object", "array"], _W = new Set(MW);
function TW(t) {
  return typeof t == "string" && _W.has(t);
}
Ha.isJSONType = TW;
function PW() {
  const t = {
    number: { type: "number", rules: [] },
    string: { type: "string", rules: [] },
    array: { type: "array", rules: [] },
    object: { type: "object", rules: [] }
  };
  return {
    types: { ...t, integer: !0, boolean: !0, null: !0 },
    rules: [{ rules: [] }, t.number, t.string, t.array, t.object],
    post: { rules: [] },
    all: {},
    keywords: {}
  };
}
Ha.getRules = PW;
var as = {};
Object.defineProperty(as, "__esModule", { value: !0 });
as.shouldUseRule = as.shouldUseGroup = as.schemaHasRulesForType = void 0;
function RW({ schema: t, self: e }, n) {
  const r = e.RULES.types[n];
  return r && r !== !0 && q8(t, r);
}
as.schemaHasRulesForType = RW;
function q8(t, e) {
  return e.rules.some((n) => z8(t, n));
}
as.shouldUseGroup = q8;
function z8(t, e) {
  var n;
  return t[e.keyword] !== void 0 || ((n = e.definition.implements) === null || n === void 0 ? void 0 : n.some((r) => t[r] !== void 0));
}
as.shouldUseRule = z8;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.reportTypeError = t.checkDataTypes = t.checkDataType = t.coerceAndCheckDataType = t.getJSONTypes = t.getSchemaTypes = t.DataType = void 0;
  const e = Ha, n = as, r = ff, i = hn, o = jn;
  var s;
  (function(w) {
    w[w.Correct = 0] = "Correct", w[w.Wrong = 1] = "Wrong";
  })(s = t.DataType || (t.DataType = {}));
  function a(w) {
    const x = l(w.type);
    if (x.includes("null")) {
      if (w.nullable === !1)
        throw new Error("type: null contradicts nullable: false");
    } else {
      if (!x.length && w.nullable !== void 0)
        throw new Error('"nullable" cannot be used without "type"');
      w.nullable === !0 && x.push("null");
    }
    return x;
  }
  t.getSchemaTypes = a;
  function l(w) {
    const x = Array.isArray(w) ? w : w ? [w] : [];
    if (x.every(e.isJSONType))
      return x;
    throw new Error("type must be JSONType or JSONType[]: " + x.join(","));
  }
  t.getJSONTypes = l;
  function c(w, x) {
    const { gen: b, data: j, opts: $ } = w, N = f(x, $.coerceTypes), B = x.length > 0 && !(N.length === 0 && x.length === 1 && (0, n.schemaHasRulesForType)(w, x[0]));
    if (B) {
      const O = m(x, j, $.strictNumbers, s.Wrong);
      b.if(O, () => {
        N.length ? d(w, x, N) : v(w);
      });
    }
    return B;
  }
  t.coerceAndCheckDataType = c;
  const u = /* @__PURE__ */ new Set(["string", "number", "integer", "boolean", "null"]);
  function f(w, x) {
    return x ? w.filter((b) => u.has(b) || x === "array" && b === "array") : [];
  }
  function d(w, x, b) {
    const { gen: j, data: $, opts: N } = w, B = j.let("dataType", (0, i._)`typeof ${$}`), O = j.let("coerced", (0, i._)`undefined`);
    N.coerceTypes === "array" && j.if((0, i._)`${B} == 'object' && Array.isArray(${$}) && ${$}.length == 1`, () => j.assign($, (0, i._)`${$}[0]`).assign(B, (0, i._)`typeof ${$}`).if(m(x, $, N.strictNumbers), () => j.assign(O, $))), j.if((0, i._)`${O} !== undefined`);
    for (const P of b)
      (u.has(P) || P === "array" && N.coerceTypes === "array") && I(P);
    j.else(), v(w), j.endIf(), j.if((0, i._)`${O} !== undefined`, () => {
      j.assign($, O), h(w, O);
    });
    function I(P) {
      switch (P) {
        case "string":
          j.elseIf((0, i._)`${B} == "number" || ${B} == "boolean"`).assign(O, (0, i._)`"" + ${$}`).elseIf((0, i._)`${$} === null`).assign(O, (0, i._)`""`);
          return;
        case "number":
          j.elseIf((0, i._)`${B} == "boolean" || ${$} === null
              || (${B} == "string" && ${$} && ${$} == +${$})`).assign(O, (0, i._)`+${$}`);
          return;
        case "integer":
          j.elseIf((0, i._)`${B} === "boolean" || ${$} === null
              || (${B} === "string" && ${$} && ${$} == +${$} && !(${$} % 1))`).assign(O, (0, i._)`+${$}`);
          return;
        case "boolean":
          j.elseIf((0, i._)`${$} === "false" || ${$} === 0 || ${$} === null`).assign(O, !1).elseIf((0, i._)`${$} === "true" || ${$} === 1`).assign(O, !0);
          return;
        case "null":
          j.elseIf((0, i._)`${$} === "" || ${$} === 0 || ${$} === false`), j.assign(O, null);
          return;
        case "array":
          j.elseIf((0, i._)`${B} === "string" || ${B} === "number"
              || ${B} === "boolean" || ${$} === null`).assign(O, (0, i._)`[${$}]`);
      }
    }
  }
  function h({ gen: w, parentData: x, parentDataProperty: b }, j) {
    w.if((0, i._)`${x} !== undefined`, () => w.assign((0, i._)`${x}[${b}]`, j));
  }
  function p(w, x, b, j = s.Correct) {
    const $ = j === s.Correct ? i.operators.EQ : i.operators.NEQ;
    let N;
    switch (w) {
      case "null":
        return (0, i._)`${x} ${$} null`;
      case "array":
        N = (0, i._)`Array.isArray(${x})`;
        break;
      case "object":
        N = (0, i._)`${x} && typeof ${x} == "object" && !Array.isArray(${x})`;
        break;
      case "integer":
        N = B((0, i._)`!(${x} % 1) && !isNaN(${x})`);
        break;
      case "number":
        N = B();
        break;
      default:
        return (0, i._)`typeof ${x} ${$} ${w}`;
    }
    return j === s.Correct ? N : (0, i.not)(N);
    function B(O = i.nil) {
      return (0, i.and)((0, i._)`typeof ${x} == "number"`, O, b ? (0, i._)`isFinite(${x})` : i.nil);
    }
  }
  t.checkDataType = p;
  function m(w, x, b, j) {
    if (w.length === 1)
      return p(w[0], x, b, j);
    let $;
    const N = (0, o.toHash)(w);
    if (N.array && N.object) {
      const B = (0, i._)`typeof ${x} != "object"`;
      $ = N.null ? B : (0, i._)`!${x} || ${B}`, delete N.null, delete N.array, delete N.object;
    } else
      $ = i.nil;
    N.number && delete N.integer;
    for (const B in N)
      $ = (0, i.and)($, p(B, x, b, j));
    return $;
  }
  t.checkDataTypes = m;
  const g = {
    message: ({ schema: w }) => `must be ${w}`,
    params: ({ schema: w, schemaValue: x }) => typeof w == "string" ? (0, i._)`{type: ${w}}` : (0, i._)`{type: ${x}}`
  };
  function v(w) {
    const x = y(w);
    (0, r.reportError)(x, g);
  }
  t.reportTypeError = v;
  function y(w) {
    const { gen: x, data: b, schema: j } = w, $ = (0, o.schemaRefOrVal)(w, j, "type");
    return {
      gen: x,
      keyword: "type",
      data: b,
      schema: j.type,
      schemaCode: $,
      schemaValue: $,
      parentSchema: j,
      params: {},
      it: w
    };
  }
})(df);
var Dp = {};
Object.defineProperty(Dp, "__esModule", { value: !0 });
Dp.assignDefaults = void 0;
const fl = hn, NW = jn;
function IW(t, e) {
  const { properties: n, items: r } = t.schema;
  if (e === "object" && n)
    for (const i in n)
      Wx(t, i, n[i].default);
  else
    e === "array" && Array.isArray(r) && r.forEach((i, o) => Wx(t, o, i.default));
}
Dp.assignDefaults = IW;
function Wx(t, e, n) {
  const { gen: r, compositeRule: i, data: o, opts: s } = t;
  if (n === void 0)
    return;
  const a = (0, fl._)`${o}${(0, fl.getProperty)(e)}`;
  if (i) {
    (0, NW.checkStrictMode)(t, `default is ignored for: ${a}`);
    return;
  }
  let l = (0, fl._)`${a} === undefined`;
  s.useDefaults === "empty" && (l = (0, fl._)`${l} || ${a} === null || ${a} === ""`), r.if(l, (0, fl._)`${a} = ${(0, fl.stringify)(n)}`);
}
var No = {}, dn = {};
Object.defineProperty(dn, "__esModule", { value: !0 });
dn.validateUnion = dn.validateArray = dn.usePattern = dn.callValidateCode = dn.schemaProperties = dn.allSchemaProperties = dn.noPropertyInData = dn.propertyInData = dn.isOwnProperty = dn.hasPropFunc = dn.reportMissingProp = dn.checkMissingProp = dn.checkReportMissingProp = void 0;
const Yn = hn, x1 = jn, Es = Xo, DW = jn;
function LW(t, e) {
  const { gen: n, data: r, it: i } = t;
  n.if(j1(n, r, e, i.opts.ownProperties), () => {
    t.setParams({ missingProperty: (0, Yn._)`${e}` }, !0), t.error();
  });
}
dn.checkReportMissingProp = LW;
function BW({ gen: t, data: e, it: { opts: n } }, r, i) {
  return (0, Yn.or)(...r.map((o) => (0, Yn.and)(j1(t, e, o, n.ownProperties), (0, Yn._)`${i} = ${o}`)));
}
dn.checkMissingProp = BW;
function qW(t, e) {
  t.setParams({ missingProperty: e }, !0), t.error();
}
dn.reportMissingProp = qW;
function F8(t) {
  return t.scopeValue("func", {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    ref: Object.prototype.hasOwnProperty,
    code: (0, Yn._)`Object.prototype.hasOwnProperty`
  });
}
dn.hasPropFunc = F8;
function w1(t, e, n) {
  return (0, Yn._)`${F8(t)}.call(${e}, ${n})`;
}
dn.isOwnProperty = w1;
function zW(t, e, n, r) {
  const i = (0, Yn._)`${e}${(0, Yn.getProperty)(n)} !== undefined`;
  return r ? (0, Yn._)`${i} && ${w1(t, e, n)}` : i;
}
dn.propertyInData = zW;
function j1(t, e, n, r) {
  const i = (0, Yn._)`${e}${(0, Yn.getProperty)(n)} === undefined`;
  return r ? (0, Yn.or)(i, (0, Yn.not)(w1(t, e, n))) : i;
}
dn.noPropertyInData = j1;
function V8(t) {
  return t ? Object.keys(t).filter((e) => e !== "__proto__") : [];
}
dn.allSchemaProperties = V8;
function FW(t, e) {
  return V8(e).filter((n) => !(0, x1.alwaysValidSchema)(t, e[n]));
}
dn.schemaProperties = FW;
function VW({ schemaCode: t, data: e, it: { gen: n, topSchemaRef: r, schemaPath: i, errorPath: o }, it: s }, a, l, c) {
  const u = c ? (0, Yn._)`${t}, ${e}, ${r}${i}` : e, f = [
    [Es.default.instancePath, (0, Yn.strConcat)(Es.default.instancePath, o)],
    [Es.default.parentData, s.parentData],
    [Es.default.parentDataProperty, s.parentDataProperty],
    [Es.default.rootData, Es.default.rootData]
  ];
  s.opts.dynamicRef && f.push([Es.default.dynamicAnchors, Es.default.dynamicAnchors]);
  const d = (0, Yn._)`${u}, ${n.object(...f)}`;
  return l !== Yn.nil ? (0, Yn._)`${a}.call(${l}, ${d})` : (0, Yn._)`${a}(${d})`;
}
dn.callValidateCode = VW;
const HW = (0, Yn._)`new RegExp`;
function UW({ gen: t, it: { opts: e } }, n) {
  const r = e.unicodeRegExp ? "u" : "", { regExp: i } = e.code, o = i(n, r);
  return t.scopeValue("pattern", {
    key: o.toString(),
    ref: o,
    code: (0, Yn._)`${i.code === "new RegExp" ? HW : (0, DW.useFunc)(t, i)}(${n}, ${r})`
  });
}
dn.usePattern = UW;
function WW(t) {
  const { gen: e, data: n, keyword: r, it: i } = t, o = e.name("valid");
  if (i.allErrors) {
    const a = e.let("valid", !0);
    return s(() => e.assign(a, !1)), a;
  }
  return e.var(o, !0), s(() => e.break()), o;
  function s(a) {
    const l = e.const("len", (0, Yn._)`${n}.length`);
    e.forRange("i", 0, l, (c) => {
      t.subschema({
        keyword: r,
        dataProp: c,
        dataPropType: x1.Type.Num
      }, o), e.if((0, Yn.not)(o), a);
    });
  }
}
dn.validateArray = WW;
function JW(t) {
  const { gen: e, schema: n, keyword: r, it: i } = t;
  if (!Array.isArray(n))
    throw new Error("ajv implementation error");
  if (n.some((l) => (0, x1.alwaysValidSchema)(i, l)) && !i.opts.unevaluated)
    return;
  const s = e.let("valid", !1), a = e.name("_valid");
  e.block(() => n.forEach((l, c) => {
    const u = t.subschema({
      keyword: r,
      schemaProp: c,
      compositeRule: !0
    }, a);
    e.assign(s, (0, Yn._)`${s} || ${a}`), t.mergeValidEvaluated(u, a) || e.if((0, Yn.not)(s));
  })), t.result(s, () => t.reset(), () => t.error(!0));
}
dn.validateUnion = JW;
Object.defineProperty(No, "__esModule", { value: !0 });
No.validateKeywordUsage = No.validSchemaType = No.funcKeywordCode = No.macroKeywordCode = void 0;
const ti = hn, Sa = Xo, KW = dn, GW = ff;
function QW(t, e) {
  const { gen: n, keyword: r, schema: i, parentSchema: o, it: s } = t, a = e.macro.call(s.self, i, o, s), l = H8(n, r, a);
  s.opts.validateSchema !== !1 && s.self.validateSchema(a, !0);
  const c = n.name("valid");
  t.subschema({
    schema: a,
    schemaPath: ti.nil,
    errSchemaPath: `${s.errSchemaPath}/${r}`,
    topSchemaRef: l,
    compositeRule: !0
  }, c), t.pass(c, () => t.error(!0));
}
No.macroKeywordCode = QW;
function YW(t, e) {
  var n;
  const { gen: r, keyword: i, schema: o, parentSchema: s, $data: a, it: l } = t;
  ZW(l, e);
  const c = !a && e.compile ? e.compile.call(l.self, o, s, l) : e.validate, u = H8(r, i, c), f = r.let("valid");
  t.block$data(f, d), t.ok((n = e.valid) !== null && n !== void 0 ? n : f);
  function d() {
    if (e.errors === !1)
      m(), e.modifying && Jx(t), g(() => t.error());
    else {
      const v = e.async ? h() : p();
      e.modifying && Jx(t), g(() => XW(t, v));
    }
  }
  function h() {
    const v = r.let("ruleErrs", null);
    return r.try(() => m((0, ti._)`await `), (y) => r.assign(f, !1).if((0, ti._)`${y} instanceof ${l.ValidationError}`, () => r.assign(v, (0, ti._)`${y}.errors`), () => r.throw(y))), v;
  }
  function p() {
    const v = (0, ti._)`${u}.errors`;
    return r.assign(v, null), m(ti.nil), v;
  }
  function m(v = e.async ? (0, ti._)`await ` : ti.nil) {
    const y = l.opts.passContext ? Sa.default.this : Sa.default.self, w = !("compile" in e && !a || e.schema === !1);
    r.assign(f, (0, ti._)`${v}${(0, KW.callValidateCode)(t, u, y, w)}`, e.modifying);
  }
  function g(v) {
    var y;
    r.if((0, ti.not)((y = e.valid) !== null && y !== void 0 ? y : f), v);
  }
}
No.funcKeywordCode = YW;
function Jx(t) {
  const { gen: e, data: n, it: r } = t;
  e.if(r.parentData, () => e.assign(n, (0, ti._)`${r.parentData}[${r.parentDataProperty}]`));
}
function XW(t, e) {
  const { gen: n } = t;
  n.if((0, ti._)`Array.isArray(${e})`, () => {
    n.assign(Sa.default.vErrors, (0, ti._)`${Sa.default.vErrors} === null ? ${e} : ${Sa.default.vErrors}.concat(${e})`).assign(Sa.default.errors, (0, ti._)`${Sa.default.vErrors}.length`), (0, GW.extendErrors)(t);
  }, () => t.error());
}
function ZW({ schemaEnv: t }, e) {
  if (e.async && !t.$async)
    throw new Error("async keyword in sync schema");
}
function H8(t, e, n) {
  if (n === void 0)
    throw new Error(`keyword "${e}" failed to compile`);
  return t.scopeValue("keyword", typeof n == "function" ? { ref: n } : { ref: n, code: (0, ti.stringify)(n) });
}
function eJ(t, e, n = !1) {
  return !e.length || e.some((r) => r === "array" ? Array.isArray(t) : r === "object" ? t && typeof t == "object" && !Array.isArray(t) : typeof t == r || n && typeof t > "u");
}
No.validSchemaType = eJ;
function tJ({ schema: t, opts: e, self: n, errSchemaPath: r }, i, o) {
  if (Array.isArray(i.keyword) ? !i.keyword.includes(o) : i.keyword !== o)
    throw new Error("ajv implementation error");
  const s = i.dependencies;
  if (s != null && s.some((a) => !Object.prototype.hasOwnProperty.call(t, a)))
    throw new Error(`parent schema must have dependencies of ${o}: ${s.join(",")}`);
  if (i.validateSchema && !i.validateSchema(t[o])) {
    const l = `keyword "${o}" value is invalid at path "${r}": ` + n.errorsText(i.validateSchema.errors);
    if (e.validateSchema === "log")
      n.logger.error(l);
    else
      throw new Error(l);
  }
}
No.validateKeywordUsage = tJ;
var Js = {};
Object.defineProperty(Js, "__esModule", { value: !0 });
Js.extendSubschemaMode = Js.extendSubschemaData = Js.getSubschema = void 0;
const _o = hn, U8 = jn;
function nJ(t, { keyword: e, schemaProp: n, schema: r, schemaPath: i, errSchemaPath: o, topSchemaRef: s }) {
  if (e !== void 0 && r !== void 0)
    throw new Error('both "keyword" and "schema" passed, only one allowed');
  if (e !== void 0) {
    const a = t.schema[e];
    return n === void 0 ? {
      schema: a,
      schemaPath: (0, _o._)`${t.schemaPath}${(0, _o.getProperty)(e)}`,
      errSchemaPath: `${t.errSchemaPath}/${e}`
    } : {
      schema: a[n],
      schemaPath: (0, _o._)`${t.schemaPath}${(0, _o.getProperty)(e)}${(0, _o.getProperty)(n)}`,
      errSchemaPath: `${t.errSchemaPath}/${e}/${(0, U8.escapeFragment)(n)}`
    };
  }
  if (r !== void 0) {
    if (i === void 0 || o === void 0 || s === void 0)
      throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
    return {
      schema: r,
      schemaPath: i,
      topSchemaRef: s,
      errSchemaPath: o
    };
  }
  throw new Error('either "keyword" or "schema" must be passed');
}
Js.getSubschema = nJ;
function rJ(t, e, { dataProp: n, dataPropType: r, data: i, dataTypes: o, propertyName: s }) {
  if (i !== void 0 && n !== void 0)
    throw new Error('both "data" and "dataProp" passed, only one allowed');
  const { gen: a } = e;
  if (n !== void 0) {
    const { errorPath: c, dataPathArr: u, opts: f } = e, d = a.let("data", (0, _o._)`${e.data}${(0, _o.getProperty)(n)}`, !0);
    l(d), t.errorPath = (0, _o.str)`${c}${(0, U8.getErrorPath)(n, r, f.jsPropertySyntax)}`, t.parentDataProperty = (0, _o._)`${n}`, t.dataPathArr = [...u, t.parentDataProperty];
  }
  if (i !== void 0) {
    const c = i instanceof _o.Name ? i : a.let("data", i, !0);
    l(c), s !== void 0 && (t.propertyName = s);
  }
  o && (t.dataTypes = o);
  function l(c) {
    t.data = c, t.dataLevel = e.dataLevel + 1, t.dataTypes = [], e.definedProperties = /* @__PURE__ */ new Set(), t.parentData = e.data, t.dataNames = [...e.dataNames, c];
  }
}
Js.extendSubschemaData = rJ;
function iJ(t, { jtdDiscriminator: e, jtdMetadata: n, compositeRule: r, createErrors: i, allErrors: o }) {
  r !== void 0 && (t.compositeRule = r), i !== void 0 && (t.createErrors = i), o !== void 0 && (t.allErrors = o), t.jtdDiscriminator = e, t.jtdMetadata = n;
}
Js.extendSubschemaMode = iJ;
var Dr = {}, W8 = function t(e, n) {
  if (e === n)
    return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor)
      return !1;
    var r, i, o;
    if (Array.isArray(e)) {
      if (r = e.length, r != n.length)
        return !1;
      for (i = r; i-- !== 0; )
        if (!t(e[i], n[i]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === n.toString();
    if (o = Object.keys(e), r = o.length, r !== Object.keys(n).length)
      return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, o[i]))
        return !1;
    for (i = r; i-- !== 0; ) {
      var s = o[i];
      if (!t(e[s], n[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}, J8 = { exports: {} }, Fs = J8.exports = function(t, e, n) {
  typeof e == "function" && (n = e, e = {}), n = e.cb || n;
  var r = typeof n == "function" ? n : n.pre || function() {
  }, i = n.post || function() {
  };
  qd(e, r, i, t, "", t);
};
Fs.keywords = {
  additionalItems: !0,
  items: !0,
  contains: !0,
  additionalProperties: !0,
  propertyNames: !0,
  not: !0,
  if: !0,
  then: !0,
  else: !0
};
Fs.arrayKeywords = {
  items: !0,
  allOf: !0,
  anyOf: !0,
  oneOf: !0
};
Fs.propsKeywords = {
  $defs: !0,
  definitions: !0,
  properties: !0,
  patternProperties: !0,
  dependencies: !0
};
Fs.skipKeywords = {
  default: !0,
  enum: !0,
  const: !0,
  required: !0,
  maximum: !0,
  minimum: !0,
  exclusiveMaximum: !0,
  exclusiveMinimum: !0,
  multipleOf: !0,
  maxLength: !0,
  minLength: !0,
  pattern: !0,
  format: !0,
  maxItems: !0,
  minItems: !0,
  uniqueItems: !0,
  maxProperties: !0,
  minProperties: !0
};
function qd(t, e, n, r, i, o, s, a, l, c) {
  if (r && typeof r == "object" && !Array.isArray(r)) {
    e(r, i, o, s, a, l, c);
    for (var u in r) {
      var f = r[u];
      if (Array.isArray(f)) {
        if (u in Fs.arrayKeywords)
          for (var d = 0; d < f.length; d++)
            qd(t, e, n, f[d], i + "/" + u + "/" + d, o, i, u, r, d);
      } else if (u in Fs.propsKeywords) {
        if (f && typeof f == "object")
          for (var h in f)
            qd(t, e, n, f[h], i + "/" + u + "/" + oJ(h), o, i, u, r, h);
      } else
        (u in Fs.keywords || t.allKeys && !(u in Fs.skipKeywords)) && qd(t, e, n, f, i + "/" + u, o, i, u, r);
    }
    n(r, i, o, s, a, l, c);
  }
}
function oJ(t) {
  return t.replace(/~/g, "~0").replace(/\//g, "~1");
}
var sJ = J8.exports;
Object.defineProperty(Dr, "__esModule", { value: !0 });
Dr.getSchemaRefs = Dr.resolveUrl = Dr.normalizeId = Dr._getFullPath = Dr.getFullPath = Dr.inlineRef = void 0;
const aJ = jn, lJ = W8, cJ = sJ, uJ = /* @__PURE__ */ new Set([
  "type",
  "format",
  "pattern",
  "maxLength",
  "minLength",
  "maxProperties",
  "minProperties",
  "maxItems",
  "minItems",
  "maximum",
  "minimum",
  "uniqueItems",
  "multipleOf",
  "required",
  "enum",
  "const"
]);
function fJ(t, e = !0) {
  return typeof t == "boolean" ? !0 : e === !0 ? !Sv(t) : e ? K8(t) <= e : !1;
}
Dr.inlineRef = fJ;
const dJ = /* @__PURE__ */ new Set([
  "$ref",
  "$recursiveRef",
  "$recursiveAnchor",
  "$dynamicRef",
  "$dynamicAnchor"
]);
function Sv(t) {
  for (const e in t) {
    if (dJ.has(e))
      return !0;
    const n = t[e];
    if (Array.isArray(n) && n.some(Sv) || typeof n == "object" && Sv(n))
      return !0;
  }
  return !1;
}
function K8(t) {
  let e = 0;
  for (const n in t) {
    if (n === "$ref")
      return 1 / 0;
    if (e++, !uJ.has(n) && (typeof t[n] == "object" && (0, aJ.eachItem)(t[n], (r) => e += K8(r)), e === 1 / 0))
      return 1 / 0;
  }
  return e;
}
function G8(t, e = "", n) {
  n !== !1 && (e = ql(e));
  const r = t.parse(e);
  return Q8(t, r);
}
Dr.getFullPath = G8;
function Q8(t, e) {
  return t.serialize(e).split("#")[0] + "#";
}
Dr._getFullPath = Q8;
const hJ = /#\/?$/;
function ql(t) {
  return t ? t.replace(hJ, "") : "";
}
Dr.normalizeId = ql;
function pJ(t, e, n) {
  return n = ql(n), t.resolve(e, n);
}
Dr.resolveUrl = pJ;
const mJ = /^[a-z_][-a-z0-9._]*$/i;
function gJ(t, e) {
  if (typeof t == "boolean")
    return {};
  const { schemaId: n, uriResolver: r } = this.opts, i = ql(t[n] || e), o = { "": i }, s = G8(r, i, !1), a = {}, l = /* @__PURE__ */ new Set();
  return cJ(t, { allKeys: !0 }, (f, d, h, p) => {
    if (p === void 0)
      return;
    const m = s + d;
    let g = o[p];
    typeof f[n] == "string" && (g = v.call(this, f[n])), y.call(this, f.$anchor), y.call(this, f.$dynamicAnchor), o[d] = g;
    function v(w) {
      const x = this.opts.uriResolver.resolve;
      if (w = ql(g ? x(g, w) : w), l.has(w))
        throw u(w);
      l.add(w);
      let b = this.refs[w];
      return typeof b == "string" && (b = this.refs[b]), typeof b == "object" ? c(f, b.schema, w) : w !== ql(m) && (w[0] === "#" ? (c(f, a[w], w), a[w] = f) : this.refs[w] = m), w;
    }
    function y(w) {
      if (typeof w == "string") {
        if (!mJ.test(w))
          throw new Error(`invalid anchor "${w}"`);
        v.call(this, `#${w}`);
      }
    }
  }), a;
  function c(f, d, h) {
    if (d !== void 0 && !lJ(f, d))
      throw u(h);
  }
  function u(f) {
    return new Error(`reference "${f}" resolves to more than one schema`);
  }
}
Dr.getSchemaRefs = gJ;
Object.defineProperty(ao, "__esModule", { value: !0 });
ao.getData = ao.KeywordCxt = ao.validateFunctionCode = void 0;
const Y8 = tc, Kx = df, k1 = as, Th = df, vJ = Dp, iu = No, Bm = Js, St = hn, zt = Xo, yJ = Dr, ls = jn, Dc = ff;
function bJ(t) {
  if (e6(t) && (t6(t), Z8(t))) {
    jJ(t);
    return;
  }
  X8(t, () => (0, Y8.topBoolOrEmptySchema)(t));
}
ao.validateFunctionCode = bJ;
function X8({ gen: t, validateName: e, schema: n, schemaEnv: r, opts: i }, o) {
  i.code.es5 ? t.func(e, (0, St._)`${zt.default.data}, ${zt.default.valCxt}`, r.$async, () => {
    t.code((0, St._)`"use strict"; ${Gx(n, i)}`), wJ(t, i), t.code(o);
  }) : t.func(e, (0, St._)`${zt.default.data}, ${xJ(i)}`, r.$async, () => t.code(Gx(n, i)).code(o));
}
function xJ(t) {
  return (0, St._)`{${zt.default.instancePath}="", ${zt.default.parentData}, ${zt.default.parentDataProperty}, ${zt.default.rootData}=${zt.default.data}${t.dynamicRef ? (0, St._)`, ${zt.default.dynamicAnchors}={}` : St.nil}}={}`;
}
function wJ(t, e) {
  t.if(zt.default.valCxt, () => {
    t.var(zt.default.instancePath, (0, St._)`${zt.default.valCxt}.${zt.default.instancePath}`), t.var(zt.default.parentData, (0, St._)`${zt.default.valCxt}.${zt.default.parentData}`), t.var(zt.default.parentDataProperty, (0, St._)`${zt.default.valCxt}.${zt.default.parentDataProperty}`), t.var(zt.default.rootData, (0, St._)`${zt.default.valCxt}.${zt.default.rootData}`), e.dynamicRef && t.var(zt.default.dynamicAnchors, (0, St._)`${zt.default.valCxt}.${zt.default.dynamicAnchors}`);
  }, () => {
    t.var(zt.default.instancePath, (0, St._)`""`), t.var(zt.default.parentData, (0, St._)`undefined`), t.var(zt.default.parentDataProperty, (0, St._)`undefined`), t.var(zt.default.rootData, zt.default.data), e.dynamicRef && t.var(zt.default.dynamicAnchors, (0, St._)`{}`);
  });
}
function jJ(t) {
  const { schema: e, opts: n, gen: r } = t;
  X8(t, () => {
    n.$comment && e.$comment && r6(t), OJ(t), r.let(zt.default.vErrors, null), r.let(zt.default.errors, 0), n.unevaluated && kJ(t), n6(t), MJ(t);
  });
}
function kJ(t) {
  const { gen: e, validateName: n } = t;
  t.evaluated = e.const("evaluated", (0, St._)`${n}.evaluated`), e.if((0, St._)`${t.evaluated}.dynamicProps`, () => e.assign((0, St._)`${t.evaluated}.props`, (0, St._)`undefined`)), e.if((0, St._)`${t.evaluated}.dynamicItems`, () => e.assign((0, St._)`${t.evaluated}.items`, (0, St._)`undefined`));
}
function Gx(t, e) {
  const n = typeof t == "object" && t[e.schemaId];
  return n && (e.code.source || e.code.process) ? (0, St._)`/*# sourceURL=${n} */` : St.nil;
}
function $J(t, e) {
  if (e6(t) && (t6(t), Z8(t))) {
    SJ(t, e);
    return;
  }
  (0, Y8.boolOrEmptySchema)(t, e);
}
function Z8({ schema: t, self: e }) {
  if (typeof t == "boolean")
    return !t;
  for (const n in t)
    if (e.RULES.all[n])
      return !0;
  return !1;
}
function e6(t) {
  return typeof t.schema != "boolean";
}
function SJ(t, e) {
  const { schema: n, gen: r, opts: i } = t;
  i.$comment && n.$comment && r6(t), EJ(t), AJ(t);
  const o = r.const("_errs", zt.default.errors);
  n6(t, o), r.var(e, (0, St._)`${o} === ${zt.default.errors}`);
}
function t6(t) {
  (0, ls.checkUnknownRules)(t), CJ(t);
}
function n6(t, e) {
  if (t.opts.jtd)
    return Qx(t, [], !1, e);
  const n = (0, Kx.getSchemaTypes)(t.schema), r = (0, Kx.coerceAndCheckDataType)(t, n);
  Qx(t, n, !r, e);
}
function CJ(t) {
  const { schema: e, errSchemaPath: n, opts: r, self: i } = t;
  e.$ref && r.ignoreKeywordsWithRef && (0, ls.schemaHasRulesButRef)(e, i.RULES) && i.logger.warn(`$ref: keywords ignored in schema at path "${n}"`);
}
function OJ(t) {
  const { schema: e, opts: n } = t;
  e.default !== void 0 && n.useDefaults && n.strictSchema && (0, ls.checkStrictMode)(t, "default is ignored in the schema root");
}
function EJ(t) {
  const e = t.schema[t.opts.schemaId];
  e && (t.baseId = (0, yJ.resolveUrl)(t.opts.uriResolver, t.baseId, e));
}
function AJ(t) {
  if (t.schema.$async && !t.schemaEnv.$async)
    throw new Error("async schema in sync schema");
}
function r6({ gen: t, schemaEnv: e, schema: n, errSchemaPath: r, opts: i }) {
  const o = n.$comment;
  if (i.$comment === !0)
    t.code((0, St._)`${zt.default.self}.logger.log(${o})`);
  else if (typeof i.$comment == "function") {
    const s = (0, St.str)`${r}/$comment`, a = t.scopeValue("root", { ref: e.root });
    t.code((0, St._)`${zt.default.self}.opts.$comment(${o}, ${s}, ${a}.schema)`);
  }
}
function MJ(t) {
  const { gen: e, schemaEnv: n, validateName: r, ValidationError: i, opts: o } = t;
  n.$async ? e.if((0, St._)`${zt.default.errors} === 0`, () => e.return(zt.default.data), () => e.throw((0, St._)`new ${i}(${zt.default.vErrors})`)) : (e.assign((0, St._)`${r}.errors`, zt.default.vErrors), o.unevaluated && _J(t), e.return((0, St._)`${zt.default.errors} === 0`));
}
function _J({ gen: t, evaluated: e, props: n, items: r }) {
  n instanceof St.Name && t.assign((0, St._)`${e}.props`, n), r instanceof St.Name && t.assign((0, St._)`${e}.items`, r);
}
function Qx(t, e, n, r) {
  const { gen: i, schema: o, data: s, allErrors: a, opts: l, self: c } = t, { RULES: u } = c;
  if (o.$ref && (l.ignoreKeywordsWithRef || !(0, ls.schemaHasRulesButRef)(o, u))) {
    i.block(() => s6(t, "$ref", u.all.$ref.definition));
    return;
  }
  l.jtd || TJ(t, e), i.block(() => {
    for (const d of u.rules)
      f(d);
    f(u.post);
  });
  function f(d) {
    (0, k1.shouldUseGroup)(o, d) && (d.type ? (i.if((0, Th.checkDataType)(d.type, s, l.strictNumbers)), Yx(t, d), e.length === 1 && e[0] === d.type && n && (i.else(), (0, Th.reportTypeError)(t)), i.endIf()) : Yx(t, d), a || i.if((0, St._)`${zt.default.errors} === ${r || 0}`));
  }
}
function Yx(t, e) {
  const { gen: n, schema: r, opts: { useDefaults: i } } = t;
  i && (0, vJ.assignDefaults)(t, e.type), n.block(() => {
    for (const o of e.rules)
      (0, k1.shouldUseRule)(r, o) && s6(t, o.keyword, o.definition, e.type);
  });
}
function TJ(t, e) {
  t.schemaEnv.meta || !t.opts.strictTypes || (PJ(t, e), t.opts.allowUnionTypes || RJ(t, e), NJ(t, t.dataTypes));
}
function PJ(t, e) {
  if (e.length) {
    if (!t.dataTypes.length) {
      t.dataTypes = e;
      return;
    }
    e.forEach((n) => {
      i6(t.dataTypes, n) || $1(t, `type "${n}" not allowed by context "${t.dataTypes.join(",")}"`);
    }), DJ(t, e);
  }
}
function RJ(t, e) {
  e.length > 1 && !(e.length === 2 && e.includes("null")) && $1(t, "use allowUnionTypes to allow union type keyword");
}
function NJ(t, e) {
  const n = t.self.RULES.all;
  for (const r in n) {
    const i = n[r];
    if (typeof i == "object" && (0, k1.shouldUseRule)(t.schema, i)) {
      const { type: o } = i.definition;
      o.length && !o.some((s) => IJ(e, s)) && $1(t, `missing type "${o.join(",")}" for keyword "${r}"`);
    }
  }
}
function IJ(t, e) {
  return t.includes(e) || e === "number" && t.includes("integer");
}
function i6(t, e) {
  return t.includes(e) || e === "integer" && t.includes("number");
}
function DJ(t, e) {
  const n = [];
  for (const r of t.dataTypes)
    i6(e, r) ? n.push(r) : e.includes("integer") && r === "number" && n.push("integer");
  t.dataTypes = n;
}
function $1(t, e) {
  const n = t.schemaEnv.baseId + t.errSchemaPath;
  e += ` at "${n}" (strictTypes)`, (0, ls.checkStrictMode)(t, e, t.opts.strictTypes);
}
class o6 {
  constructor(e, n, r) {
    if ((0, iu.validateKeywordUsage)(e, n, r), this.gen = e.gen, this.allErrors = e.allErrors, this.keyword = r, this.data = e.data, this.schema = e.schema[r], this.$data = n.$data && e.opts.$data && this.schema && this.schema.$data, this.schemaValue = (0, ls.schemaRefOrVal)(e, this.schema, r, this.$data), this.schemaType = n.schemaType, this.parentSchema = e.schema, this.params = {}, this.it = e, this.def = n, this.$data)
      this.schemaCode = e.gen.const("vSchema", a6(this.$data, e));
    else if (this.schemaCode = this.schemaValue, !(0, iu.validSchemaType)(this.schema, n.schemaType, n.allowUndefined))
      throw new Error(`${r} value must be ${JSON.stringify(n.schemaType)}`);
    ("code" in n ? n.trackErrors : n.errors !== !1) && (this.errsCount = e.gen.const("_errs", zt.default.errors));
  }
  result(e, n, r) {
    this.failResult((0, St.not)(e), n, r);
  }
  failResult(e, n, r) {
    this.gen.if(e), r ? r() : this.error(), n ? (this.gen.else(), n(), this.allErrors && this.gen.endIf()) : this.allErrors ? this.gen.endIf() : this.gen.else();
  }
  pass(e, n) {
    this.failResult((0, St.not)(e), void 0, n);
  }
  fail(e) {
    if (e === void 0) {
      this.error(), this.allErrors || this.gen.if(!1);
      return;
    }
    this.gen.if(e), this.error(), this.allErrors ? this.gen.endIf() : this.gen.else();
  }
  fail$data(e) {
    if (!this.$data)
      return this.fail(e);
    const { schemaCode: n } = this;
    this.fail((0, St._)`${n} !== undefined && (${(0, St.or)(this.invalid$data(), e)})`);
  }
  error(e, n, r) {
    if (n) {
      this.setParams(n), this._error(e, r), this.setParams({});
      return;
    }
    this._error(e, r);
  }
  _error(e, n) {
    (e ? Dc.reportExtraError : Dc.reportError)(this, this.def.error, n);
  }
  $dataError() {
    (0, Dc.reportError)(this, this.def.$dataError || Dc.keyword$DataError);
  }
  reset() {
    if (this.errsCount === void 0)
      throw new Error('add "trackErrors" to keyword definition');
    (0, Dc.resetErrorsCount)(this.gen, this.errsCount);
  }
  ok(e) {
    this.allErrors || this.gen.if(e);
  }
  setParams(e, n) {
    n ? Object.assign(this.params, e) : this.params = e;
  }
  block$data(e, n, r = St.nil) {
    this.gen.block(() => {
      this.check$data(e, r), n();
    });
  }
  check$data(e = St.nil, n = St.nil) {
    if (!this.$data)
      return;
    const { gen: r, schemaCode: i, schemaType: o, def: s } = this;
    r.if((0, St.or)((0, St._)`${i} === undefined`, n)), e !== St.nil && r.assign(e, !0), (o.length || s.validateSchema) && (r.elseIf(this.invalid$data()), this.$dataError(), e !== St.nil && r.assign(e, !1)), r.else();
  }
  invalid$data() {
    const { gen: e, schemaCode: n, schemaType: r, def: i, it: o } = this;
    return (0, St.or)(s(), a());
    function s() {
      if (r.length) {
        if (!(n instanceof St.Name))
          throw new Error("ajv implementation error");
        const l = Array.isArray(r) ? r : [r];
        return (0, St._)`${(0, Th.checkDataTypes)(l, n, o.opts.strictNumbers, Th.DataType.Wrong)}`;
      }
      return St.nil;
    }
    function a() {
      if (i.validateSchema) {
        const l = e.scopeValue("validate$data", { ref: i.validateSchema });
        return (0, St._)`!${l}(${n})`;
      }
      return St.nil;
    }
  }
  subschema(e, n) {
    const r = (0, Bm.getSubschema)(this.it, e);
    (0, Bm.extendSubschemaData)(r, this.it, e), (0, Bm.extendSubschemaMode)(r, e);
    const i = { ...this.it, ...r, items: void 0, props: void 0 };
    return $J(i, n), i;
  }
  mergeEvaluated(e, n) {
    const { it: r, gen: i } = this;
    r.opts.unevaluated && (r.props !== !0 && e.props !== void 0 && (r.props = ls.mergeEvaluated.props(i, e.props, r.props, n)), r.items !== !0 && e.items !== void 0 && (r.items = ls.mergeEvaluated.items(i, e.items, r.items, n)));
  }
  mergeValidEvaluated(e, n) {
    const { it: r, gen: i } = this;
    if (r.opts.unevaluated && (r.props !== !0 || r.items !== !0))
      return i.if(n, () => this.mergeEvaluated(e, St.Name)), !0;
  }
}
ao.KeywordCxt = o6;
function s6(t, e, n, r) {
  const i = new o6(t, n, e);
  "code" in n ? n.code(i, r) : i.$data && n.validate ? (0, iu.funcKeywordCode)(i, n) : "macro" in n ? (0, iu.macroKeywordCode)(i, n) : (n.compile || n.validate) && (0, iu.funcKeywordCode)(i, n);
}
const LJ = /^\/(?:[^~]|~0|~1)*$/, BJ = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function a6(t, { dataLevel: e, dataNames: n, dataPathArr: r }) {
  let i, o;
  if (t === "")
    return zt.default.rootData;
  if (t[0] === "/") {
    if (!LJ.test(t))
      throw new Error(`Invalid JSON-pointer: ${t}`);
    i = t, o = zt.default.rootData;
  } else {
    const c = BJ.exec(t);
    if (!c)
      throw new Error(`Invalid JSON-pointer: ${t}`);
    const u = +c[1];
    if (i = c[2], i === "#") {
      if (u >= e)
        throw new Error(l("property/index", u));
      return r[e - u];
    }
    if (u > e)
      throw new Error(l("data", u));
    if (o = n[e - u], !i)
      return o;
  }
  let s = o;
  const a = i.split("/");
  for (const c of a)
    c && (o = (0, St._)`${o}${(0, St.getProperty)((0, ls.unescapeJsonPointer)(c))}`, s = (0, St._)`${s} && ${o}`);
  return s;
  function l(c, u) {
    return `Cannot access ${c} ${u} levels up, current level is ${e}`;
  }
}
ao.getData = a6;
var hf = {};
Object.defineProperty(hf, "__esModule", { value: !0 });
class qJ extends Error {
  constructor(e) {
    super("validation failed"), this.errors = e, this.ajv = this.validation = !0;
  }
}
hf.default = qJ;
var pf = {};
Object.defineProperty(pf, "__esModule", { value: !0 });
const qm = Dr;
class zJ extends Error {
  constructor(e, n, r, i) {
    super(i || `can't resolve reference ${r} from id ${n}`), this.missingRef = (0, qm.resolveUrl)(e, n, r), this.missingSchema = (0, qm.normalizeId)((0, qm.getFullPath)(e, this.missingRef));
  }
}
pf.default = zJ;
var ci = {};
Object.defineProperty(ci, "__esModule", { value: !0 });
ci.resolveSchema = ci.getCompilingSchema = ci.resolveRef = ci.compileSchema = ci.SchemaEnv = void 0;
const Qi = hn, FJ = hf, ya = Xo, eo = Dr, Xx = jn, VJ = ao;
class Lp {
  constructor(e) {
    var n;
    this.refs = {}, this.dynamicAnchors = {};
    let r;
    typeof e.schema == "object" && (r = e.schema), this.schema = e.schema, this.schemaId = e.schemaId, this.root = e.root || this, this.baseId = (n = e.baseId) !== null && n !== void 0 ? n : (0, eo.normalizeId)(r == null ? void 0 : r[e.schemaId || "$id"]), this.schemaPath = e.schemaPath, this.localRefs = e.localRefs, this.meta = e.meta, this.$async = r == null ? void 0 : r.$async, this.refs = {};
  }
}
ci.SchemaEnv = Lp;
function S1(t) {
  const e = l6.call(this, t);
  if (e)
    return e;
  const n = (0, eo.getFullPath)(this.opts.uriResolver, t.root.baseId), { es5: r, lines: i } = this.opts.code, { ownProperties: o } = this.opts, s = new Qi.CodeGen(this.scope, { es5: r, lines: i, ownProperties: o });
  let a;
  t.$async && (a = s.scopeValue("Error", {
    ref: FJ.default,
    code: (0, Qi._)`require("ajv/dist/runtime/validation_error").default`
  }));
  const l = s.scopeName("validate");
  t.validateName = l;
  const c = {
    gen: s,
    allErrors: this.opts.allErrors,
    data: ya.default.data,
    parentData: ya.default.parentData,
    parentDataProperty: ya.default.parentDataProperty,
    dataNames: [ya.default.data],
    dataPathArr: [Qi.nil],
    dataLevel: 0,
    dataTypes: [],
    definedProperties: /* @__PURE__ */ new Set(),
    topSchemaRef: s.scopeValue("schema", this.opts.code.source === !0 ? { ref: t.schema, code: (0, Qi.stringify)(t.schema) } : { ref: t.schema }),
    validateName: l,
    ValidationError: a,
    schema: t.schema,
    schemaEnv: t,
    rootId: n,
    baseId: t.baseId || n,
    schemaPath: Qi.nil,
    errSchemaPath: t.schemaPath || (this.opts.jtd ? "" : "#"),
    errorPath: (0, Qi._)`""`,
    opts: this.opts,
    self: this
  };
  let u;
  try {
    this._compilations.add(t), (0, VJ.validateFunctionCode)(c), s.optimize(this.opts.code.optimize);
    const f = s.toString();
    u = `${s.scopeRefs(ya.default.scope)}return ${f}`, this.opts.code.process && (u = this.opts.code.process(u, t));
    const h = new Function(`${ya.default.self}`, `${ya.default.scope}`, u)(this, this.scope.get());
    if (this.scope.value(l, { ref: h }), h.errors = null, h.schema = t.schema, h.schemaEnv = t, t.$async && (h.$async = !0), this.opts.code.source === !0 && (h.source = { validateName: l, validateCode: f, scopeValues: s._values }), this.opts.unevaluated) {
      const { props: p, items: m } = c;
      h.evaluated = {
        props: p instanceof Qi.Name ? void 0 : p,
        items: m instanceof Qi.Name ? void 0 : m,
        dynamicProps: p instanceof Qi.Name,
        dynamicItems: m instanceof Qi.Name
      }, h.source && (h.source.evaluated = (0, Qi.stringify)(h.evaluated));
    }
    return t.validate = h, t;
  } catch (f) {
    throw delete t.validate, delete t.validateName, u && this.logger.error("Error compiling schema, function code:", u), f;
  } finally {
    this._compilations.delete(t);
  }
}
ci.compileSchema = S1;
function HJ(t, e, n) {
  var r;
  n = (0, eo.resolveUrl)(this.opts.uriResolver, e, n);
  const i = t.refs[n];
  if (i)
    return i;
  let o = JJ.call(this, t, n);
  if (o === void 0) {
    const s = (r = t.localRefs) === null || r === void 0 ? void 0 : r[n], { schemaId: a } = this.opts;
    s && (o = new Lp({ schema: s, schemaId: a, root: t, baseId: e }));
  }
  if (o !== void 0)
    return t.refs[n] = UJ.call(this, o);
}
ci.resolveRef = HJ;
function UJ(t) {
  return (0, eo.inlineRef)(t.schema, this.opts.inlineRefs) ? t.schema : t.validate ? t : S1.call(this, t);
}
function l6(t) {
  for (const e of this._compilations)
    if (WJ(e, t))
      return e;
}
ci.getCompilingSchema = l6;
function WJ(t, e) {
  return t.schema === e.schema && t.root === e.root && t.baseId === e.baseId;
}
function JJ(t, e) {
  let n;
  for (; typeof (n = this.refs[e]) == "string"; )
    e = n;
  return n || this.schemas[e] || Bp.call(this, t, e);
}
function Bp(t, e) {
  const n = this.opts.uriResolver.parse(e), r = (0, eo._getFullPath)(this.opts.uriResolver, n);
  let i = (0, eo.getFullPath)(this.opts.uriResolver, t.baseId, void 0);
  if (Object.keys(t.schema).length > 0 && r === i)
    return zm.call(this, n, t);
  const o = (0, eo.normalizeId)(r), s = this.refs[o] || this.schemas[o];
  if (typeof s == "string") {
    const a = Bp.call(this, t, s);
    return typeof (a == null ? void 0 : a.schema) != "object" ? void 0 : zm.call(this, n, a);
  }
  if (typeof (s == null ? void 0 : s.schema) == "object") {
    if (s.validate || S1.call(this, s), o === (0, eo.normalizeId)(e)) {
      const { schema: a } = s, { schemaId: l } = this.opts, c = a[l];
      return c && (i = (0, eo.resolveUrl)(this.opts.uriResolver, i, c)), new Lp({ schema: a, schemaId: l, root: t, baseId: i });
    }
    return zm.call(this, n, s);
  }
}
ci.resolveSchema = Bp;
const KJ = /* @__PURE__ */ new Set([
  "properties",
  "patternProperties",
  "enum",
  "dependencies",
  "definitions"
]);
function zm(t, { baseId: e, schema: n, root: r }) {
  var i;
  if (((i = t.fragment) === null || i === void 0 ? void 0 : i[0]) !== "/")
    return;
  for (const a of t.fragment.slice(1).split("/")) {
    if (typeof n == "boolean")
      return;
    const l = n[(0, Xx.unescapeFragment)(a)];
    if (l === void 0)
      return;
    n = l;
    const c = typeof n == "object" && n[this.opts.schemaId];
    !KJ.has(a) && c && (e = (0, eo.resolveUrl)(this.opts.uriResolver, e, c));
  }
  let o;
  if (typeof n != "boolean" && n.$ref && !(0, Xx.schemaHasRulesButRef)(n, this.RULES)) {
    const a = (0, eo.resolveUrl)(this.opts.uriResolver, e, n.$ref);
    o = Bp.call(this, r, a);
  }
  const { schemaId: s } = this.opts;
  if (o = o || new Lp({ schema: n, schemaId: s, root: r, baseId: e }), o.schema !== o.root.schema)
    return o;
}
const GJ = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#", QJ = "Meta-schema for $data reference (JSON AnySchema extension proposal)", YJ = "object", XJ = [
  "$data"
], ZJ = {
  $data: {
    type: "string",
    anyOf: [
      {
        format: "relative-json-pointer"
      },
      {
        format: "json-pointer"
      }
    ]
  }
}, eK = !1, tK = {
  $id: GJ,
  description: QJ,
  type: YJ,
  required: XJ,
  properties: ZJ,
  additionalProperties: eK
};
var C1 = {}, Cv = { exports: {} };
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
(function(t, e) {
  (function(n, r) {
    r(e);
  })(FD, function(n) {
    function r() {
      for (var U = arguments.length, G = Array(U), re = 0; re < U; re++)
        G[re] = arguments[re];
      if (G.length > 1) {
        G[0] = G[0].slice(0, -1);
        for (var ae = G.length - 1, ve = 1; ve < ae; ++ve)
          G[ve] = G[ve].slice(1, -1);
        return G[ae] = G[ae].slice(1), G.join("");
      } else
        return G[0];
    }
    function i(U) {
      return "(?:" + U + ")";
    }
    function o(U) {
      return U === void 0 ? "undefined" : U === null ? "null" : Object.prototype.toString.call(U).split(" ").pop().split("]").shift().toLowerCase();
    }
    function s(U) {
      return U.toUpperCase();
    }
    function a(U) {
      return U != null ? U instanceof Array ? U : typeof U.length != "number" || U.split || U.setInterval || U.call ? [U] : Array.prototype.slice.call(U) : [];
    }
    function l(U, G) {
      var re = U;
      if (G)
        for (var ae in G)
          re[ae] = G[ae];
      return re;
    }
    function c(U) {
      var G = "[A-Za-z]", re = "[0-9]", ae = r(re, "[A-Fa-f]"), ve = i(i("%[EFef]" + ae + "%" + ae + ae + "%" + ae + ae) + "|" + i("%[89A-Fa-f]" + ae + "%" + ae + ae) + "|" + i("%" + ae + ae)), pt = "[\\:\\/\\?\\#\\[\\]\\@]", xt = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", Vt = r(pt, xt), vn = U ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", Mn = U ? "[\\uE000-\\uF8FF]" : "[]", Ht = r(G, re, "[\\-\\.\\_\\~]", vn);
      i(G + r(G, re, "[\\+\\-\\.]") + "*"), i(i(ve + "|" + r(Ht, xt, "[\\:]")) + "*");
      var mn = i(i("25[0-5]") + "|" + i("2[0-4]" + re) + "|" + i("1" + re + re) + "|" + i("0?[1-9]" + re) + "|0?0?" + re), K = i(mn + "\\." + mn + "\\." + mn + "\\." + mn), pe = i(ae + "{1,4}"), Ne = i(i(pe + "\\:" + pe) + "|" + K), ze = i(i(pe + "\\:") + "{6}" + Ne), Ve = i("\\:\\:" + i(pe + "\\:") + "{5}" + Ne), Ct = i(i(pe) + "?\\:\\:" + i(pe + "\\:") + "{4}" + Ne), _t = i(i(i(pe + "\\:") + "{0,1}" + pe) + "?\\:\\:" + i(pe + "\\:") + "{3}" + Ne), ut = i(i(i(pe + "\\:") + "{0,2}" + pe) + "?\\:\\:" + i(pe + "\\:") + "{2}" + Ne), $t = i(i(i(pe + "\\:") + "{0,3}" + pe) + "?\\:\\:" + pe + "\\:" + Ne), kt = i(i(i(pe + "\\:") + "{0,4}" + pe) + "?\\:\\:" + Ne), sn = i(i(i(pe + "\\:") + "{0,5}" + pe) + "?\\:\\:" + pe), yn = i(i(i(pe + "\\:") + "{0,6}" + pe) + "?\\:\\:"), qn = i([ze, Ve, Ct, _t, ut, $t, kt, sn, yn].join("|")), Or = i(i(Ht + "|" + ve) + "+");
      i("[vV]" + ae + "+\\." + r(Ht, xt, "[\\:]") + "+"), i(i(ve + "|" + r(Ht, xt)) + "*");
      var yo = i(ve + "|" + r(Ht, xt, "[\\:\\@]"));
      return i(i(ve + "|" + r(Ht, xt, "[\\@]")) + "+"), i(i(yo + "|" + r("[\\/\\?]", Mn)) + "*"), {
        NOT_SCHEME: new RegExp(r("[^]", G, re, "[\\+\\-\\.]"), "g"),
        NOT_USERINFO: new RegExp(r("[^\\%\\:]", Ht, xt), "g"),
        NOT_HOST: new RegExp(r("[^\\%\\[\\]\\:]", Ht, xt), "g"),
        NOT_PATH: new RegExp(r("[^\\%\\/\\:\\@]", Ht, xt), "g"),
        NOT_PATH_NOSCHEME: new RegExp(r("[^\\%\\/\\@]", Ht, xt), "g"),
        NOT_QUERY: new RegExp(r("[^\\%]", Ht, xt, "[\\:\\@\\/\\?]", Mn), "g"),
        NOT_FRAGMENT: new RegExp(r("[^\\%]", Ht, xt, "[\\:\\@\\/\\?]"), "g"),
        ESCAPE: new RegExp(r("[^]", Ht, xt), "g"),
        UNRESERVED: new RegExp(Ht, "g"),
        OTHER_CHARS: new RegExp(r("[^\\%]", Ht, Vt), "g"),
        PCT_ENCODED: new RegExp(ve, "g"),
        IPV4ADDRESS: new RegExp("^(" + K + ")$"),
        IPV6ADDRESS: new RegExp("^\\[?(" + qn + ")" + i(i("\\%25|\\%(?!" + ae + "{2})") + "(" + Or + ")") + "?\\]?$")
        //RFC 6874, with relaxed parsing rules
      };
    }
    var u = c(!1), f = c(!0), d = /* @__PURE__ */ function() {
      function U(G, re) {
        var ae = [], ve = !0, pt = !1, xt = void 0;
        try {
          for (var Vt = G[Symbol.iterator](), vn; !(ve = (vn = Vt.next()).done) && (ae.push(vn.value), !(re && ae.length === re)); ve = !0)
            ;
        } catch (Mn) {
          pt = !0, xt = Mn;
        } finally {
          try {
            !ve && Vt.return && Vt.return();
          } finally {
            if (pt)
              throw xt;
          }
        }
        return ae;
      }
      return function(G, re) {
        if (Array.isArray(G))
          return G;
        if (Symbol.iterator in Object(G))
          return U(G, re);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    }(), h = function(U) {
      if (Array.isArray(U)) {
        for (var G = 0, re = Array(U.length); G < U.length; G++)
          re[G] = U[G];
        return re;
      } else
        return Array.from(U);
    }, p = 2147483647, m = 36, g = 1, v = 26, y = 38, w = 700, x = 72, b = 128, j = "-", $ = /^xn--/, N = /[^\0-\x7E]/, B = /[\x2E\u3002\uFF0E\uFF61]/g, O = {
      overflow: "Overflow: input needs wider integers to process",
      "not-basic": "Illegal input >= 0x80 (not a basic code point)",
      "invalid-input": "Invalid input"
    }, I = m - g, P = Math.floor, J = String.fromCharCode;
    function D(U) {
      throw new RangeError(O[U]);
    }
    function Q(U, G) {
      for (var re = [], ae = U.length; ae--; )
        re[ae] = G(U[ae]);
      return re;
    }
    function Z(U, G) {
      var re = U.split("@"), ae = "";
      re.length > 1 && (ae = re[0] + "@", U = re[1]), U = U.replace(B, ".");
      var ve = U.split("."), pt = Q(ve, G).join(".");
      return ae + pt;
    }
    function L(U) {
      for (var G = [], re = 0, ae = U.length; re < ae; ) {
        var ve = U.charCodeAt(re++);
        if (ve >= 55296 && ve <= 56319 && re < ae) {
          var pt = U.charCodeAt(re++);
          (pt & 64512) == 56320 ? G.push(((ve & 1023) << 10) + (pt & 1023) + 65536) : (G.push(ve), re--);
        } else
          G.push(ve);
      }
      return G;
    }
    var R = function(G) {
      return String.fromCodePoint.apply(String, h(G));
    }, V = function(G) {
      return G - 48 < 10 ? G - 22 : G - 65 < 26 ? G - 65 : G - 97 < 26 ? G - 97 : m;
    }, M = function(G, re) {
      return G + 22 + 75 * (G < 26) - ((re != 0) << 5);
    }, C = function(G, re, ae) {
      var ve = 0;
      for (
        G = ae ? P(G / w) : G >> 1, G += P(G / re);
        /* no initialization */
        G > I * v >> 1;
        ve += m
      )
        G = P(G / I);
      return P(ve + (I + 1) * G / (G + y));
    }, F = function(G) {
      var re = [], ae = G.length, ve = 0, pt = b, xt = x, Vt = G.lastIndexOf(j);
      Vt < 0 && (Vt = 0);
      for (var vn = 0; vn < Vt; ++vn)
        G.charCodeAt(vn) >= 128 && D("not-basic"), re.push(G.charCodeAt(vn));
      for (var Mn = Vt > 0 ? Vt + 1 : 0; Mn < ae; ) {
        for (
          var Ht = ve, mn = 1, K = m;
          ;
          /* no condition */
          K += m
        ) {
          Mn >= ae && D("invalid-input");
          var pe = V(G.charCodeAt(Mn++));
          (pe >= m || pe > P((p - ve) / mn)) && D("overflow"), ve += pe * mn;
          var Ne = K <= xt ? g : K >= xt + v ? v : K - xt;
          if (pe < Ne)
            break;
          var ze = m - Ne;
          mn > P(p / ze) && D("overflow"), mn *= ze;
        }
        var Ve = re.length + 1;
        xt = C(ve - Ht, Ve, Ht == 0), P(ve / Ve) > p - pt && D("overflow"), pt += P(ve / Ve), ve %= Ve, re.splice(ve++, 0, pt);
      }
      return String.fromCodePoint.apply(String, re);
    }, z = function(G) {
      var re = [];
      G = L(G);
      var ae = G.length, ve = b, pt = 0, xt = x, Vt = !0, vn = !1, Mn = void 0;
      try {
        for (var Ht = G[Symbol.iterator](), mn; !(Vt = (mn = Ht.next()).done); Vt = !0) {
          var K = mn.value;
          K < 128 && re.push(J(K));
        }
      } catch (bo) {
        vn = !0, Mn = bo;
      } finally {
        try {
          !Vt && Ht.return && Ht.return();
        } finally {
          if (vn)
            throw Mn;
        }
      }
      var pe = re.length, Ne = pe;
      for (pe && re.push(j); Ne < ae; ) {
        var ze = p, Ve = !0, Ct = !1, _t = void 0;
        try {
          for (var ut = G[Symbol.iterator](), $t; !(Ve = ($t = ut.next()).done); Ve = !0) {
            var kt = $t.value;
            kt >= ve && kt < ze && (ze = kt);
          }
        } catch (bo) {
          Ct = !0, _t = bo;
        } finally {
          try {
            !Ve && ut.return && ut.return();
          } finally {
            if (Ct)
              throw _t;
          }
        }
        var sn = Ne + 1;
        ze - ve > P((p - pt) / sn) && D("overflow"), pt += (ze - ve) * sn, ve = ze;
        var yn = !0, qn = !1, Or = void 0;
        try {
          for (var yo = G[Symbol.iterator](), pa; !(yn = (pa = yo.next()).done); yn = !0) {
            var pi = pa.value;
            if (pi < ve && ++pt > p && D("overflow"), pi == ve) {
              for (
                var Oi = pt, Ji = m;
                ;
                /* no condition */
                Ji += m
              ) {
                var Nn = Ji <= xt ? g : Ji >= xt + v ? v : Ji - xt;
                if (Oi < Nn)
                  break;
                var ma = Oi - Nn, oi = m - Nn;
                re.push(J(M(Nn + ma % oi, 0))), Oi = P(ma / oi);
              }
              re.push(J(M(Oi, 0))), xt = C(pt, sn, Ne == pe), pt = 0, ++Ne;
            }
          }
        } catch (bo) {
          qn = !0, Or = bo;
        } finally {
          try {
            !yn && yo.return && yo.return();
          } finally {
            if (qn)
              throw Or;
          }
        }
        ++pt, ++ve;
      }
      return re.join("");
    }, E = function(G) {
      return Z(G, function(re) {
        return $.test(re) ? F(re.slice(4).toLowerCase()) : re;
      });
    }, A = function(G) {
      return Z(G, function(re) {
        return N.test(re) ? "xn--" + z(re) : re;
      });
    }, te = {
      /**
       * A string representing the current Punycode.js version number.
       * @memberOf punycode
       * @type String
       */
      version: "2.1.0",
      /**
       * An object of methods to convert from JavaScript's internal character
       * representation (UCS-2) to Unicode code points, and back.
       * @see <https://mathiasbynens.be/notes/javascript-encoding>
       * @memberOf punycode
       * @type Object
       */
      ucs2: {
        decode: L,
        encode: R
      },
      decode: F,
      encode: z,
      toASCII: A,
      toUnicode: E
    }, ge = {};
    function ke(U) {
      var G = U.charCodeAt(0), re = void 0;
      return G < 16 ? re = "%0" + G.toString(16).toUpperCase() : G < 128 ? re = "%" + G.toString(16).toUpperCase() : G < 2048 ? re = "%" + (G >> 6 | 192).toString(16).toUpperCase() + "%" + (G & 63 | 128).toString(16).toUpperCase() : re = "%" + (G >> 12 | 224).toString(16).toUpperCase() + "%" + (G >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (G & 63 | 128).toString(16).toUpperCase(), re;
    }
    function Ce(U) {
      for (var G = "", re = 0, ae = U.length; re < ae; ) {
        var ve = parseInt(U.substr(re + 1, 2), 16);
        if (ve < 128)
          G += String.fromCharCode(ve), re += 3;
        else if (ve >= 194 && ve < 224) {
          if (ae - re >= 6) {
            var pt = parseInt(U.substr(re + 4, 2), 16);
            G += String.fromCharCode((ve & 31) << 6 | pt & 63);
          } else
            G += U.substr(re, 6);
          re += 6;
        } else if (ve >= 224) {
          if (ae - re >= 9) {
            var xt = parseInt(U.substr(re + 4, 2), 16), Vt = parseInt(U.substr(re + 7, 2), 16);
            G += String.fromCharCode((ve & 15) << 12 | (xt & 63) << 6 | Vt & 63);
          } else
            G += U.substr(re, 9);
          re += 9;
        } else
          G += U.substr(re, 3), re += 3;
      }
      return G;
    }
    function we(U, G) {
      function re(ae) {
        var ve = Ce(ae);
        return ve.match(G.UNRESERVED) ? ve : ae;
      }
      return U.scheme && (U.scheme = String(U.scheme).replace(G.PCT_ENCODED, re).toLowerCase().replace(G.NOT_SCHEME, "")), U.userinfo !== void 0 && (U.userinfo = String(U.userinfo).replace(G.PCT_ENCODED, re).replace(G.NOT_USERINFO, ke).replace(G.PCT_ENCODED, s)), U.host !== void 0 && (U.host = String(U.host).replace(G.PCT_ENCODED, re).toLowerCase().replace(G.NOT_HOST, ke).replace(G.PCT_ENCODED, s)), U.path !== void 0 && (U.path = String(U.path).replace(G.PCT_ENCODED, re).replace(U.scheme ? G.NOT_PATH : G.NOT_PATH_NOSCHEME, ke).replace(G.PCT_ENCODED, s)), U.query !== void 0 && (U.query = String(U.query).replace(G.PCT_ENCODED, re).replace(G.NOT_QUERY, ke).replace(G.PCT_ENCODED, s)), U.fragment !== void 0 && (U.fragment = String(U.fragment).replace(G.PCT_ENCODED, re).replace(G.NOT_FRAGMENT, ke).replace(G.PCT_ENCODED, s)), U;
    }
    function le(U) {
      return U.replace(/^0*(.*)/, "$1") || "0";
    }
    function rt(U, G) {
      var re = U.match(G.IPV4ADDRESS) || [], ae = d(re, 2), ve = ae[1];
      return ve ? ve.split(".").map(le).join(".") : U;
    }
    function Be(U, G) {
      var re = U.match(G.IPV6ADDRESS) || [], ae = d(re, 3), ve = ae[1], pt = ae[2];
      if (ve) {
        for (var xt = ve.toLowerCase().split("::").reverse(), Vt = d(xt, 2), vn = Vt[0], Mn = Vt[1], Ht = Mn ? Mn.split(":").map(le) : [], mn = vn.split(":").map(le), K = G.IPV4ADDRESS.test(mn[mn.length - 1]), pe = K ? 7 : 8, Ne = mn.length - pe, ze = Array(pe), Ve = 0; Ve < pe; ++Ve)
          ze[Ve] = Ht[Ve] || mn[Ne + Ve] || "";
        K && (ze[pe - 1] = rt(ze[pe - 1], G));
        var Ct = ze.reduce(function(sn, yn, qn) {
          if (!yn || yn === "0") {
            var Or = sn[sn.length - 1];
            Or && Or.index + Or.length === qn ? Or.length++ : sn.push({ index: qn, length: 1 });
          }
          return sn;
        }, []), _t = Ct.sort(function(sn, yn) {
          return yn.length - sn.length;
        })[0], ut = void 0;
        if (_t && _t.length > 1) {
          var $t = ze.slice(0, _t.index), kt = ze.slice(_t.index + _t.length);
          ut = $t.join(":") + "::" + kt.join(":");
        } else
          ut = ze.join(":");
        return pt && (ut += "%" + pt), ut;
      } else
        return U;
    }
    var nt = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, oe = "".match(/(){0}/)[1] === void 0;
    function We(U) {
      var G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, re = {}, ae = G.iri !== !1 ? f : u;
      G.reference === "suffix" && (U = (G.scheme ? G.scheme + ":" : "") + "//" + U);
      var ve = U.match(nt);
      if (ve) {
        oe ? (re.scheme = ve[1], re.userinfo = ve[3], re.host = ve[4], re.port = parseInt(ve[5], 10), re.path = ve[6] || "", re.query = ve[7], re.fragment = ve[8], isNaN(re.port) && (re.port = ve[5])) : (re.scheme = ve[1] || void 0, re.userinfo = U.indexOf("@") !== -1 ? ve[3] : void 0, re.host = U.indexOf("//") !== -1 ? ve[4] : void 0, re.port = parseInt(ve[5], 10), re.path = ve[6] || "", re.query = U.indexOf("?") !== -1 ? ve[7] : void 0, re.fragment = U.indexOf("#") !== -1 ? ve[8] : void 0, isNaN(re.port) && (re.port = U.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? ve[4] : void 0)), re.host && (re.host = Be(rt(re.host, ae), ae)), re.scheme === void 0 && re.userinfo === void 0 && re.host === void 0 && re.port === void 0 && !re.path && re.query === void 0 ? re.reference = "same-document" : re.scheme === void 0 ? re.reference = "relative" : re.fragment === void 0 ? re.reference = "absolute" : re.reference = "uri", G.reference && G.reference !== "suffix" && G.reference !== re.reference && (re.error = re.error || "URI is not a " + G.reference + " reference.");
        var pt = ge[(G.scheme || re.scheme || "").toLowerCase()];
        if (!G.unicodeSupport && (!pt || !pt.unicodeSupport)) {
          if (re.host && (G.domainHost || pt && pt.domainHost))
            try {
              re.host = te.toASCII(re.host.replace(ae.PCT_ENCODED, Ce).toLowerCase());
            } catch (xt) {
              re.error = re.error || "Host's domain name can not be converted to ASCII via punycode: " + xt;
            }
          we(re, u);
        } else
          we(re, ae);
        pt && pt.parse && pt.parse(re, G);
      } else
        re.error = re.error || "URI can not be parsed.";
      return re;
    }
    function Rt(U, G) {
      var re = G.iri !== !1 ? f : u, ae = [];
      return U.userinfo !== void 0 && (ae.push(U.userinfo), ae.push("@")), U.host !== void 0 && ae.push(Be(rt(String(U.host), re), re).replace(re.IPV6ADDRESS, function(ve, pt, xt) {
        return "[" + pt + (xt ? "%25" + xt : "") + "]";
      })), (typeof U.port == "number" || typeof U.port == "string") && (ae.push(":"), ae.push(String(U.port))), ae.length ? ae.join("") : void 0;
    }
    var de = /^\.\.?\//, Se = /^\/\.(\/|$)/, rn = /^\/\.\.(\/|$)/, Dt = /^\/?(?:.|\n)*?(?=\/|$)/;
    function Xt(U) {
      for (var G = []; U.length; )
        if (U.match(de))
          U = U.replace(de, "");
        else if (U.match(Se))
          U = U.replace(Se, "/");
        else if (U.match(rn))
          U = U.replace(rn, "/"), G.pop();
        else if (U === "." || U === "..")
          U = "";
        else {
          var re = U.match(Dt);
          if (re) {
            var ae = re[0];
            U = U.slice(ae.length), G.push(ae);
          } else
            throw new Error("Unexpected dot segment condition");
        }
      return G.join("");
    }
    function Ue(U) {
      var G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, re = G.iri ? f : u, ae = [], ve = ge[(G.scheme || U.scheme || "").toLowerCase()];
      if (ve && ve.serialize && ve.serialize(U, G), U.host && !re.IPV6ADDRESS.test(U.host)) {
        if (G.domainHost || ve && ve.domainHost)
          try {
            U.host = G.iri ? te.toUnicode(U.host) : te.toASCII(U.host.replace(re.PCT_ENCODED, Ce).toLowerCase());
          } catch (Vt) {
            U.error = U.error || "Host's domain name can not be converted to " + (G.iri ? "Unicode" : "ASCII") + " via punycode: " + Vt;
          }
      }
      we(U, re), G.reference !== "suffix" && U.scheme && (ae.push(U.scheme), ae.push(":"));
      var pt = Rt(U, G);
      if (pt !== void 0 && (G.reference !== "suffix" && ae.push("//"), ae.push(pt), U.path && U.path.charAt(0) !== "/" && ae.push("/")), U.path !== void 0) {
        var xt = U.path;
        !G.absolutePath && (!ve || !ve.absolutePath) && (xt = Xt(xt)), pt === void 0 && (xt = xt.replace(/^\/\//, "/%2F")), ae.push(xt);
      }
      return U.query !== void 0 && (ae.push("?"), ae.push(U.query)), U.fragment !== void 0 && (ae.push("#"), ae.push(U.fragment)), ae.join("");
    }
    function kn(U, G) {
      var re = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ae = arguments[3], ve = {};
      return ae || (U = We(Ue(U, re), re), G = We(Ue(G, re), re)), re = re || {}, !re.tolerant && G.scheme ? (ve.scheme = G.scheme, ve.userinfo = G.userinfo, ve.host = G.host, ve.port = G.port, ve.path = Xt(G.path || ""), ve.query = G.query) : (G.userinfo !== void 0 || G.host !== void 0 || G.port !== void 0 ? (ve.userinfo = G.userinfo, ve.host = G.host, ve.port = G.port, ve.path = Xt(G.path || ""), ve.query = G.query) : (G.path ? (G.path.charAt(0) === "/" ? ve.path = Xt(G.path) : ((U.userinfo !== void 0 || U.host !== void 0 || U.port !== void 0) && !U.path ? ve.path = "/" + G.path : U.path ? ve.path = U.path.slice(0, U.path.lastIndexOf("/") + 1) + G.path : ve.path = G.path, ve.path = Xt(ve.path)), ve.query = G.query) : (ve.path = U.path, G.query !== void 0 ? ve.query = G.query : ve.query = U.query), ve.userinfo = U.userinfo, ve.host = U.host, ve.port = U.port), ve.scheme = U.scheme), ve.fragment = G.fragment, ve;
    }
    function fn(U, G, re) {
      var ae = l({ scheme: "null" }, re);
      return Ue(kn(We(U, ae), We(G, ae), ae, !0), ae);
    }
    function q(U, G) {
      return typeof U == "string" ? U = Ue(We(U, G), G) : o(U) === "object" && (U = We(Ue(U, G), G)), U;
    }
    function ee(U, G, re) {
      return typeof U == "string" ? U = Ue(We(U, re), re) : o(U) === "object" && (U = Ue(U, re)), typeof G == "string" ? G = Ue(We(G, re), re) : o(G) === "object" && (G = Ue(G, re)), U === G;
    }
    function ne(U, G) {
      return U && U.toString().replace(!G || !G.iri ? u.ESCAPE : f.ESCAPE, ke);
    }
    function he(U, G) {
      return U && U.toString().replace(!G || !G.iri ? u.PCT_ENCODED : f.PCT_ENCODED, Ce);
    }
    var je = {
      scheme: "http",
      domainHost: !0,
      parse: function(G, re) {
        return G.host || (G.error = G.error || "HTTP URIs must have a host."), G;
      },
      serialize: function(G, re) {
        var ae = String(G.scheme).toLowerCase() === "https";
        return (G.port === (ae ? 443 : 80) || G.port === "") && (G.port = void 0), G.path || (G.path = "/"), G;
      }
    }, _e = {
      scheme: "https",
      domainHost: je.domainHost,
      parse: je.parse,
      serialize: je.serialize
    };
    function yt(U) {
      return typeof U.secure == "boolean" ? U.secure : String(U.scheme).toLowerCase() === "wss";
    }
    var Xe = {
      scheme: "ws",
      domainHost: !0,
      parse: function(G, re) {
        var ae = G;
        return ae.secure = yt(ae), ae.resourceName = (ae.path || "/") + (ae.query ? "?" + ae.query : ""), ae.path = void 0, ae.query = void 0, ae;
      },
      serialize: function(G, re) {
        if ((G.port === (yt(G) ? 443 : 80) || G.port === "") && (G.port = void 0), typeof G.secure == "boolean" && (G.scheme = G.secure ? "wss" : "ws", G.secure = void 0), G.resourceName) {
          var ae = G.resourceName.split("?"), ve = d(ae, 2), pt = ve[0], xt = ve[1];
          G.path = pt && pt !== "/" ? pt : void 0, G.query = xt, G.resourceName = void 0;
        }
        return G.fragment = void 0, G;
      }
    }, Zt = {
      scheme: "wss",
      domainHost: Xe.domainHost,
      parse: Xe.parse,
      serialize: Xe.serialize
    }, on = {}, Jt = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", Ge = "[0-9A-Fa-f]", xn = i(i("%[EFef]" + Ge + "%" + Ge + Ge + "%" + Ge + Ge) + "|" + i("%[89A-Fa-f]" + Ge + "%" + Ge + Ge) + "|" + i("%" + Ge + Ge)), Dn = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", wn = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", $n = r(wn, '[\\"\\\\]'), Rn = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]", Jn = new RegExp(Jt, "g"), pn = new RegExp(xn, "g"), me = new RegExp(r("[^]", Dn, "[\\.]", '[\\"]', $n), "g"), Ke = new RegExp(r("[^]", Jt, Rn), "g"), It = Ke;
    function Nt(U) {
      var G = Ce(U);
      return G.match(Jn) ? G : U;
    }
    var ce = {
      scheme: "mailto",
      parse: function(G, re) {
        var ae = G, ve = ae.to = ae.path ? ae.path.split(",") : [];
        if (ae.path = void 0, ae.query) {
          for (var pt = !1, xt = {}, Vt = ae.query.split("&"), vn = 0, Mn = Vt.length; vn < Mn; ++vn) {
            var Ht = Vt[vn].split("=");
            switch (Ht[0]) {
              case "to":
                for (var mn = Ht[1].split(","), K = 0, pe = mn.length; K < pe; ++K)
                  ve.push(mn[K]);
                break;
              case "subject":
                ae.subject = he(Ht[1], re);
                break;
              case "body":
                ae.body = he(Ht[1], re);
                break;
              default:
                pt = !0, xt[he(Ht[0], re)] = he(Ht[1], re);
                break;
            }
          }
          pt && (ae.headers = xt);
        }
        ae.query = void 0;
        for (var Ne = 0, ze = ve.length; Ne < ze; ++Ne) {
          var Ve = ve[Ne].split("@");
          if (Ve[0] = he(Ve[0]), re.unicodeSupport)
            Ve[1] = he(Ve[1], re).toLowerCase();
          else
            try {
              Ve[1] = te.toASCII(he(Ve[1], re).toLowerCase());
            } catch (Ct) {
              ae.error = ae.error || "Email address's domain name can not be converted to ASCII via punycode: " + Ct;
            }
          ve[Ne] = Ve.join("@");
        }
        return ae;
      },
      serialize: function(G, re) {
        var ae = G, ve = a(G.to);
        if (ve) {
          for (var pt = 0, xt = ve.length; pt < xt; ++pt) {
            var Vt = String(ve[pt]), vn = Vt.lastIndexOf("@"), Mn = Vt.slice(0, vn).replace(pn, Nt).replace(pn, s).replace(me, ke), Ht = Vt.slice(vn + 1);
            try {
              Ht = re.iri ? te.toUnicode(Ht) : te.toASCII(he(Ht, re).toLowerCase());
            } catch (Ne) {
              ae.error = ae.error || "Email address's domain name can not be converted to " + (re.iri ? "Unicode" : "ASCII") + " via punycode: " + Ne;
            }
            ve[pt] = Mn + "@" + Ht;
          }
          ae.path = ve.join(",");
        }
        var mn = G.headers = G.headers || {};
        G.subject && (mn.subject = G.subject), G.body && (mn.body = G.body);
        var K = [];
        for (var pe in mn)
          mn[pe] !== on[pe] && K.push(pe.replace(pn, Nt).replace(pn, s).replace(Ke, ke) + "=" + mn[pe].replace(pn, Nt).replace(pn, s).replace(It, ke));
        return K.length && (ae.query = K.join("&")), ae;
      }
    }, qe = /^([^\:]+)\:(.*)/, Fe = {
      scheme: "urn",
      parse: function(G, re) {
        var ae = G.path && G.path.match(qe), ve = G;
        if (ae) {
          var pt = re.scheme || ve.scheme || "urn", xt = ae[1].toLowerCase(), Vt = ae[2], vn = pt + ":" + (re.nid || xt), Mn = ge[vn];
          ve.nid = xt, ve.nss = Vt, ve.path = void 0, Mn && (ve = Mn.parse(ve, re));
        } else
          ve.error = ve.error || "URN can not be parsed.";
        return ve;
      },
      serialize: function(G, re) {
        var ae = re.scheme || G.scheme || "urn", ve = G.nid, pt = ae + ":" + (re.nid || ve), xt = ge[pt];
        xt && (G = xt.serialize(G, re));
        var Vt = G, vn = G.nss;
        return Vt.path = (ve || re.nid) + ":" + vn, Vt;
      }
    }, Lt = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, qt = {
      scheme: "urn:uuid",
      parse: function(G, re) {
        var ae = G;
        return ae.uuid = ae.nss, ae.nss = void 0, !re.tolerant && (!ae.uuid || !ae.uuid.match(Lt)) && (ae.error = ae.error || "UUID is not valid."), ae;
      },
      serialize: function(G, re) {
        var ae = G;
        return ae.nss = (G.uuid || "").toLowerCase(), ae;
      }
    };
    ge[je.scheme] = je, ge[_e.scheme] = _e, ge[Xe.scheme] = Xe, ge[Zt.scheme] = Zt, ge[ce.scheme] = ce, ge[Fe.scheme] = Fe, ge[qt.scheme] = qt, n.SCHEMES = ge, n.pctEncChar = ke, n.pctDecChars = Ce, n.parse = We, n.removeDotSegments = Xt, n.serialize = Ue, n.resolveComponents = kn, n.resolve = fn, n.normalize = q, n.equal = ee, n.escapeComponent = ne, n.unescapeComponent = he, Object.defineProperty(n, "__esModule", { value: !0 });
  });
})(Cv, Cv.exports);
var nK = Cv.exports;
Object.defineProperty(C1, "__esModule", { value: !0 });
const c6 = nK;
c6.code = 'require("ajv/dist/runtime/uri").default';
C1.default = c6;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.CodeGen = t.Name = t.nil = t.stringify = t.str = t._ = t.KeywordCxt = void 0;
  var e = ao;
  Object.defineProperty(t, "KeywordCxt", { enumerable: !0, get: function() {
    return e.KeywordCxt;
  } });
  var n = hn;
  Object.defineProperty(t, "_", { enumerable: !0, get: function() {
    return n._;
  } }), Object.defineProperty(t, "str", { enumerable: !0, get: function() {
    return n.str;
  } }), Object.defineProperty(t, "stringify", { enumerable: !0, get: function() {
    return n.stringify;
  } }), Object.defineProperty(t, "nil", { enumerable: !0, get: function() {
    return n.nil;
  } }), Object.defineProperty(t, "Name", { enumerable: !0, get: function() {
    return n.Name;
  } }), Object.defineProperty(t, "CodeGen", { enumerable: !0, get: function() {
    return n.CodeGen;
  } });
  const r = hf, i = pf, o = Ha, s = ci, a = hn, l = Dr, c = df, u = jn, f = tK, d = C1, h = (M, C) => new RegExp(M, C);
  h.code = "new RegExp";
  const p = ["removeAdditional", "useDefaults", "coerceTypes"], m = /* @__PURE__ */ new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
  ]), g = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
  }, v = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
  }, y = 200;
  function w(M) {
    var C, F, z, E, A, te, ge, ke, Ce, we, le, rt, Be, nt, oe, We, Rt, de, Se, rn, Dt, Xt, Ue, kn, fn;
    const q = M.strict, ee = (C = M.code) === null || C === void 0 ? void 0 : C.optimize, ne = ee === !0 || ee === void 0 ? 1 : ee || 0, he = (z = (F = M.code) === null || F === void 0 ? void 0 : F.regExp) !== null && z !== void 0 ? z : h, je = (E = M.uriResolver) !== null && E !== void 0 ? E : d.default;
    return {
      strictSchema: (te = (A = M.strictSchema) !== null && A !== void 0 ? A : q) !== null && te !== void 0 ? te : !0,
      strictNumbers: (ke = (ge = M.strictNumbers) !== null && ge !== void 0 ? ge : q) !== null && ke !== void 0 ? ke : !0,
      strictTypes: (we = (Ce = M.strictTypes) !== null && Ce !== void 0 ? Ce : q) !== null && we !== void 0 ? we : "log",
      strictTuples: (rt = (le = M.strictTuples) !== null && le !== void 0 ? le : q) !== null && rt !== void 0 ? rt : "log",
      strictRequired: (nt = (Be = M.strictRequired) !== null && Be !== void 0 ? Be : q) !== null && nt !== void 0 ? nt : !1,
      code: M.code ? { ...M.code, optimize: ne, regExp: he } : { optimize: ne, regExp: he },
      loopRequired: (oe = M.loopRequired) !== null && oe !== void 0 ? oe : y,
      loopEnum: (We = M.loopEnum) !== null && We !== void 0 ? We : y,
      meta: (Rt = M.meta) !== null && Rt !== void 0 ? Rt : !0,
      messages: (de = M.messages) !== null && de !== void 0 ? de : !0,
      inlineRefs: (Se = M.inlineRefs) !== null && Se !== void 0 ? Se : !0,
      schemaId: (rn = M.schemaId) !== null && rn !== void 0 ? rn : "$id",
      addUsedSchema: (Dt = M.addUsedSchema) !== null && Dt !== void 0 ? Dt : !0,
      validateSchema: (Xt = M.validateSchema) !== null && Xt !== void 0 ? Xt : !0,
      validateFormats: (Ue = M.validateFormats) !== null && Ue !== void 0 ? Ue : !0,
      unicodeRegExp: (kn = M.unicodeRegExp) !== null && kn !== void 0 ? kn : !0,
      int32range: (fn = M.int32range) !== null && fn !== void 0 ? fn : !0,
      uriResolver: je
    };
  }
  class x {
    constructor(C = {}) {
      this.schemas = {}, this.refs = {}, this.formats = {}, this._compilations = /* @__PURE__ */ new Set(), this._loading = {}, this._cache = /* @__PURE__ */ new Map(), C = this.opts = { ...C, ...w(C) };
      const { es5: F, lines: z } = this.opts.code;
      this.scope = new a.ValueScope({ scope: {}, prefixes: m, es5: F, lines: z }), this.logger = P(C.logger);
      const E = C.validateFormats;
      C.validateFormats = !1, this.RULES = (0, o.getRules)(), b.call(this, g, C, "NOT SUPPORTED"), b.call(this, v, C, "DEPRECATED", "warn"), this._metaOpts = O.call(this), C.formats && N.call(this), this._addVocabularies(), this._addDefaultMetaSchema(), C.keywords && B.call(this, C.keywords), typeof C.meta == "object" && this.addMetaSchema(C.meta), $.call(this), C.validateFormats = E;
    }
    _addVocabularies() {
      this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
      const { $data: C, meta: F, schemaId: z } = this.opts;
      let E = f;
      z === "id" && (E = { ...f }, E.id = E.$id, delete E.$id), F && C && this.addMetaSchema(E, E[z], !1);
    }
    defaultMeta() {
      const { meta: C, schemaId: F } = this.opts;
      return this.opts.defaultMeta = typeof C == "object" ? C[F] || C : void 0;
    }
    validate(C, F) {
      let z;
      if (typeof C == "string") {
        if (z = this.getSchema(C), !z)
          throw new Error(`no schema with key or ref "${C}"`);
      } else
        z = this.compile(C);
      const E = z(F);
      return "$async" in z || (this.errors = z.errors), E;
    }
    compile(C, F) {
      const z = this._addSchema(C, F);
      return z.validate || this._compileSchemaEnv(z);
    }
    compileAsync(C, F) {
      if (typeof this.opts.loadSchema != "function")
        throw new Error("options.loadSchema should be a function");
      const { loadSchema: z } = this.opts;
      return E.call(this, C, F);
      async function E(we, le) {
        await A.call(this, we.$schema);
        const rt = this._addSchema(we, le);
        return rt.validate || te.call(this, rt);
      }
      async function A(we) {
        we && !this.getSchema(we) && await E.call(this, { $ref: we }, !0);
      }
      async function te(we) {
        try {
          return this._compileSchemaEnv(we);
        } catch (le) {
          if (!(le instanceof i.default))
            throw le;
          return ge.call(this, le), await ke.call(this, le.missingSchema), te.call(this, we);
        }
      }
      function ge({ missingSchema: we, missingRef: le }) {
        if (this.refs[we])
          throw new Error(`AnySchema ${we} is loaded but ${le} cannot be resolved`);
      }
      async function ke(we) {
        const le = await Ce.call(this, we);
        this.refs[we] || await A.call(this, le.$schema), this.refs[we] || this.addSchema(le, we, F);
      }
      async function Ce(we) {
        const le = this._loading[we];
        if (le)
          return le;
        try {
          return await (this._loading[we] = z(we));
        } finally {
          delete this._loading[we];
        }
      }
    }
    // Adds schema to the instance
    addSchema(C, F, z, E = this.opts.validateSchema) {
      if (Array.isArray(C)) {
        for (const te of C)
          this.addSchema(te, void 0, z, E);
        return this;
      }
      let A;
      if (typeof C == "object") {
        const { schemaId: te } = this.opts;
        if (A = C[te], A !== void 0 && typeof A != "string")
          throw new Error(`schema ${te} must be string`);
      }
      return F = (0, l.normalizeId)(F || A), this._checkUnique(F), this.schemas[F] = this._addSchema(C, z, F, E, !0), this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(C, F, z = this.opts.validateSchema) {
      return this.addSchema(C, F, !0, z), this;
    }
    //  Validate schema against its meta-schema
    validateSchema(C, F) {
      if (typeof C == "boolean")
        return !0;
      let z;
      if (z = C.$schema, z !== void 0 && typeof z != "string")
        throw new Error("$schema must be a string");
      if (z = z || this.opts.defaultMeta || this.defaultMeta(), !z)
        return this.logger.warn("meta-schema not available"), this.errors = null, !0;
      const E = this.validate(z, C);
      if (!E && F) {
        const A = "schema is invalid: " + this.errorsText();
        if (this.opts.validateSchema === "log")
          this.logger.error(A);
        else
          throw new Error(A);
      }
      return E;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(C) {
      let F;
      for (; typeof (F = j.call(this, C)) == "string"; )
        C = F;
      if (F === void 0) {
        const { schemaId: z } = this.opts, E = new s.SchemaEnv({ schema: {}, schemaId: z });
        if (F = s.resolveSchema.call(this, E, C), !F)
          return;
        this.refs[C] = F;
      }
      return F.validate || this._compileSchemaEnv(F);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(C) {
      if (C instanceof RegExp)
        return this._removeAllSchemas(this.schemas, C), this._removeAllSchemas(this.refs, C), this;
      switch (typeof C) {
        case "undefined":
          return this._removeAllSchemas(this.schemas), this._removeAllSchemas(this.refs), this._cache.clear(), this;
        case "string": {
          const F = j.call(this, C);
          return typeof F == "object" && this._cache.delete(F.schema), delete this.schemas[C], delete this.refs[C], this;
        }
        case "object": {
          const F = C;
          this._cache.delete(F);
          let z = C[this.opts.schemaId];
          return z && (z = (0, l.normalizeId)(z), delete this.schemas[z], delete this.refs[z]), this;
        }
        default:
          throw new Error("ajv.removeSchema: invalid parameter");
      }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(C) {
      for (const F of C)
        this.addKeyword(F);
      return this;
    }
    addKeyword(C, F) {
      let z;
      if (typeof C == "string")
        z = C, typeof F == "object" && (this.logger.warn("these parameters are deprecated, see docs for addKeyword"), F.keyword = z);
      else if (typeof C == "object" && F === void 0) {
        if (F = C, z = F.keyword, Array.isArray(z) && !z.length)
          throw new Error("addKeywords: keyword must be string or non-empty array");
      } else
        throw new Error("invalid addKeywords parameters");
      if (D.call(this, z, F), !F)
        return (0, u.eachItem)(z, (A) => Q.call(this, A)), this;
      L.call(this, F);
      const E = {
        ...F,
        type: (0, c.getJSONTypes)(F.type),
        schemaType: (0, c.getJSONTypes)(F.schemaType)
      };
      return (0, u.eachItem)(z, E.type.length === 0 ? (A) => Q.call(this, A, E) : (A) => E.type.forEach((te) => Q.call(this, A, E, te))), this;
    }
    getKeyword(C) {
      const F = this.RULES.all[C];
      return typeof F == "object" ? F.definition : !!F;
    }
    // Remove keyword
    removeKeyword(C) {
      const { RULES: F } = this;
      delete F.keywords[C], delete F.all[C];
      for (const z of F.rules) {
        const E = z.rules.findIndex((A) => A.keyword === C);
        E >= 0 && z.rules.splice(E, 1);
      }
      return this;
    }
    // Add format
    addFormat(C, F) {
      return typeof F == "string" && (F = new RegExp(F)), this.formats[C] = F, this;
    }
    errorsText(C = this.errors, { separator: F = ", ", dataVar: z = "data" } = {}) {
      return !C || C.length === 0 ? "No errors" : C.map((E) => `${z}${E.instancePath} ${E.message}`).reduce((E, A) => E + F + A);
    }
    $dataMetaSchema(C, F) {
      const z = this.RULES.all;
      C = JSON.parse(JSON.stringify(C));
      for (const E of F) {
        const A = E.split("/").slice(1);
        let te = C;
        for (const ge of A)
          te = te[ge];
        for (const ge in z) {
          const ke = z[ge];
          if (typeof ke != "object")
            continue;
          const { $data: Ce } = ke.definition, we = te[ge];
          Ce && we && (te[ge] = V(we));
        }
      }
      return C;
    }
    _removeAllSchemas(C, F) {
      for (const z in C) {
        const E = C[z];
        (!F || F.test(z)) && (typeof E == "string" ? delete C[z] : E && !E.meta && (this._cache.delete(E.schema), delete C[z]));
      }
    }
    _addSchema(C, F, z, E = this.opts.validateSchema, A = this.opts.addUsedSchema) {
      let te;
      const { schemaId: ge } = this.opts;
      if (typeof C == "object")
        te = C[ge];
      else {
        if (this.opts.jtd)
          throw new Error("schema must be object");
        if (typeof C != "boolean")
          throw new Error("schema must be object or boolean");
      }
      let ke = this._cache.get(C);
      if (ke !== void 0)
        return ke;
      z = (0, l.normalizeId)(te || z);
      const Ce = l.getSchemaRefs.call(this, C, z);
      return ke = new s.SchemaEnv({ schema: C, schemaId: ge, meta: F, baseId: z, localRefs: Ce }), this._cache.set(ke.schema, ke), A && !z.startsWith("#") && (z && this._checkUnique(z), this.refs[z] = ke), E && this.validateSchema(C, !0), ke;
    }
    _checkUnique(C) {
      if (this.schemas[C] || this.refs[C])
        throw new Error(`schema with key or id "${C}" already exists`);
    }
    _compileSchemaEnv(C) {
      if (C.meta ? this._compileMetaSchema(C) : s.compileSchema.call(this, C), !C.validate)
        throw new Error("ajv implementation error");
      return C.validate;
    }
    _compileMetaSchema(C) {
      const F = this.opts;
      this.opts = this._metaOpts;
      try {
        s.compileSchema.call(this, C);
      } finally {
        this.opts = F;
      }
    }
  }
  t.default = x, x.ValidationError = r.default, x.MissingRefError = i.default;
  function b(M, C, F, z = "error") {
    for (const E in M) {
      const A = E;
      A in C && this.logger[z](`${F}: option ${E}. ${M[A]}`);
    }
  }
  function j(M) {
    return M = (0, l.normalizeId)(M), this.schemas[M] || this.refs[M];
  }
  function $() {
    const M = this.opts.schemas;
    if (M)
      if (Array.isArray(M))
        this.addSchema(M);
      else
        for (const C in M)
          this.addSchema(M[C], C);
  }
  function N() {
    for (const M in this.opts.formats) {
      const C = this.opts.formats[M];
      C && this.addFormat(M, C);
    }
  }
  function B(M) {
    if (Array.isArray(M)) {
      this.addVocabulary(M);
      return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for (const C in M) {
      const F = M[C];
      F.keyword || (F.keyword = C), this.addKeyword(F);
    }
  }
  function O() {
    const M = { ...this.opts };
    for (const C of p)
      delete M[C];
    return M;
  }
  const I = { log() {
  }, warn() {
  }, error() {
  } };
  function P(M) {
    if (M === !1)
      return I;
    if (M === void 0)
      return console;
    if (M.log && M.warn && M.error)
      return M;
    throw new Error("logger must implement log, warn and error methods");
  }
  const J = /^[a-z_$][a-z0-9_$:-]*$/i;
  function D(M, C) {
    const { RULES: F } = this;
    if ((0, u.eachItem)(M, (z) => {
      if (F.keywords[z])
        throw new Error(`Keyword ${z} is already defined`);
      if (!J.test(z))
        throw new Error(`Keyword ${z} has invalid name`);
    }), !!C && C.$data && !("code" in C || "validate" in C))
      throw new Error('$data keyword must have "code" or "validate" function');
  }
  function Q(M, C, F) {
    var z;
    const E = C == null ? void 0 : C.post;
    if (F && E)
      throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: A } = this;
    let te = E ? A.post : A.rules.find(({ type: ke }) => ke === F);
    if (te || (te = { type: F, rules: [] }, A.rules.push(te)), A.keywords[M] = !0, !C)
      return;
    const ge = {
      keyword: M,
      definition: {
        ...C,
        type: (0, c.getJSONTypes)(C.type),
        schemaType: (0, c.getJSONTypes)(C.schemaType)
      }
    };
    C.before ? Z.call(this, te, ge, C.before) : te.rules.push(ge), A.all[M] = ge, (z = C.implements) === null || z === void 0 || z.forEach((ke) => this.addKeyword(ke));
  }
  function Z(M, C, F) {
    const z = M.rules.findIndex((E) => E.keyword === F);
    z >= 0 ? M.rules.splice(z, 0, C) : (M.rules.push(C), this.logger.warn(`rule ${F} is not defined`));
  }
  function L(M) {
    let { metaSchema: C } = M;
    C !== void 0 && (M.$data && this.opts.$data && (C = V(C)), M.validateSchema = this.compile(C, !0));
  }
  const R = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
  };
  function V(M) {
    return { anyOf: [M, R] };
  }
})(L8);
var O1 = {}, E1 = {}, A1 = {};
Object.defineProperty(A1, "__esModule", { value: !0 });
const rK = {
  keyword: "id",
  code() {
    throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
  }
};
A1.default = rK;
var Ua = {};
Object.defineProperty(Ua, "__esModule", { value: !0 });
Ua.callRef = Ua.getValidate = void 0;
const iK = pf, Zx = dn, ai = hn, dl = Xo, ew = ci, od = jn, oK = {
  keyword: "$ref",
  schemaType: "string",
  code(t) {
    const { gen: e, schema: n, it: r } = t, { baseId: i, schemaEnv: o, validateName: s, opts: a, self: l } = r, { root: c } = o;
    if ((n === "#" || n === "#/") && i === c.baseId)
      return f();
    const u = ew.resolveRef.call(l, c, i, n);
    if (u === void 0)
      throw new iK.default(r.opts.uriResolver, i, n);
    if (u instanceof ew.SchemaEnv)
      return d(u);
    return h(u);
    function f() {
      if (o === c)
        return zd(t, s, o, o.$async);
      const p = e.scopeValue("root", { ref: c });
      return zd(t, (0, ai._)`${p}.validate`, c, c.$async);
    }
    function d(p) {
      const m = u6(t, p);
      zd(t, m, p, p.$async);
    }
    function h(p) {
      const m = e.scopeValue("schema", a.code.source === !0 ? { ref: p, code: (0, ai.stringify)(p) } : { ref: p }), g = e.name("valid"), v = t.subschema({
        schema: p,
        dataTypes: [],
        schemaPath: ai.nil,
        topSchemaRef: m,
        errSchemaPath: n
      }, g);
      t.mergeEvaluated(v), t.ok(g);
    }
  }
};
function u6(t, e) {
  const { gen: n } = t;
  return e.validate ? n.scopeValue("validate", { ref: e.validate }) : (0, ai._)`${n.scopeValue("wrapper", { ref: e })}.validate`;
}
Ua.getValidate = u6;
function zd(t, e, n, r) {
  const { gen: i, it: o } = t, { allErrors: s, schemaEnv: a, opts: l } = o, c = l.passContext ? dl.default.this : ai.nil;
  r ? u() : f();
  function u() {
    if (!a.$async)
      throw new Error("async schema referenced by sync schema");
    const p = i.let("valid");
    i.try(() => {
      i.code((0, ai._)`await ${(0, Zx.callValidateCode)(t, e, c)}`), h(e), s || i.assign(p, !0);
    }, (m) => {
      i.if((0, ai._)`!(${m} instanceof ${o.ValidationError})`, () => i.throw(m)), d(m), s || i.assign(p, !1);
    }), t.ok(p);
  }
  function f() {
    t.result((0, Zx.callValidateCode)(t, e, c), () => h(e), () => d(e));
  }
  function d(p) {
    const m = (0, ai._)`${p}.errors`;
    i.assign(dl.default.vErrors, (0, ai._)`${dl.default.vErrors} === null ? ${m} : ${dl.default.vErrors}.concat(${m})`), i.assign(dl.default.errors, (0, ai._)`${dl.default.vErrors}.length`);
  }
  function h(p) {
    var m;
    if (!o.opts.unevaluated)
      return;
    const g = (m = n == null ? void 0 : n.validate) === null || m === void 0 ? void 0 : m.evaluated;
    if (o.props !== !0)
      if (g && !g.dynamicProps)
        g.props !== void 0 && (o.props = od.mergeEvaluated.props(i, g.props, o.props));
      else {
        const v = i.var("props", (0, ai._)`${p}.evaluated.props`);
        o.props = od.mergeEvaluated.props(i, v, o.props, ai.Name);
      }
    if (o.items !== !0)
      if (g && !g.dynamicItems)
        g.items !== void 0 && (o.items = od.mergeEvaluated.items(i, g.items, o.items));
      else {
        const v = i.var("items", (0, ai._)`${p}.evaluated.items`);
        o.items = od.mergeEvaluated.items(i, v, o.items, ai.Name);
      }
  }
}
Ua.callRef = zd;
Ua.default = oK;
Object.defineProperty(E1, "__esModule", { value: !0 });
const sK = A1, aK = Ua, lK = [
  "$schema",
  "$id",
  "$defs",
  "$vocabulary",
  { keyword: "$comment" },
  "definitions",
  sK.default,
  aK.default
];
E1.default = lK;
var M1 = {}, _1 = {};
Object.defineProperty(_1, "__esModule", { value: !0 });
const Ph = hn, As = Ph.operators, Rh = {
  maximum: { okStr: "<=", ok: As.LTE, fail: As.GT },
  minimum: { okStr: ">=", ok: As.GTE, fail: As.LT },
  exclusiveMaximum: { okStr: "<", ok: As.LT, fail: As.GTE },
  exclusiveMinimum: { okStr: ">", ok: As.GT, fail: As.LTE }
}, cK = {
  message: ({ keyword: t, schemaCode: e }) => (0, Ph.str)`must be ${Rh[t].okStr} ${e}`,
  params: ({ keyword: t, schemaCode: e }) => (0, Ph._)`{comparison: ${Rh[t].okStr}, limit: ${e}}`
}, uK = {
  keyword: Object.keys(Rh),
  type: "number",
  schemaType: "number",
  $data: !0,
  error: cK,
  code(t) {
    const { keyword: e, data: n, schemaCode: r } = t;
    t.fail$data((0, Ph._)`${n} ${Rh[e].fail} ${r} || isNaN(${n})`);
  }
};
_1.default = uK;
var T1 = {};
Object.defineProperty(T1, "__esModule", { value: !0 });
const ou = hn, fK = {
  message: ({ schemaCode: t }) => (0, ou.str)`must be multiple of ${t}`,
  params: ({ schemaCode: t }) => (0, ou._)`{multipleOf: ${t}}`
}, dK = {
  keyword: "multipleOf",
  type: "number",
  schemaType: "number",
  $data: !0,
  error: fK,
  code(t) {
    const { gen: e, data: n, schemaCode: r, it: i } = t, o = i.opts.multipleOfPrecision, s = e.let("res"), a = o ? (0, ou._)`Math.abs(Math.round(${s}) - ${s}) > 1e-${o}` : (0, ou._)`${s} !== parseInt(${s})`;
    t.fail$data((0, ou._)`(${r} === 0 || (${s} = ${n}/${r}, ${a}))`);
  }
};
T1.default = dK;
var P1 = {}, R1 = {};
Object.defineProperty(R1, "__esModule", { value: !0 });
function f6(t) {
  const e = t.length;
  let n = 0, r = 0, i;
  for (; r < e; )
    n++, i = t.charCodeAt(r++), i >= 55296 && i <= 56319 && r < e && (i = t.charCodeAt(r), (i & 64512) === 56320 && r++);
  return n;
}
R1.default = f6;
f6.code = 'require("ajv/dist/runtime/ucs2length").default';
Object.defineProperty(P1, "__esModule", { value: !0 });
const Ca = hn, hK = jn, pK = R1, mK = {
  message({ keyword: t, schemaCode: e }) {
    const n = t === "maxLength" ? "more" : "fewer";
    return (0, Ca.str)`must NOT have ${n} than ${e} characters`;
  },
  params: ({ schemaCode: t }) => (0, Ca._)`{limit: ${t}}`
}, gK = {
  keyword: ["maxLength", "minLength"],
  type: "string",
  schemaType: "number",
  $data: !0,
  error: mK,
  code(t) {
    const { keyword: e, data: n, schemaCode: r, it: i } = t, o = e === "maxLength" ? Ca.operators.GT : Ca.operators.LT, s = i.opts.unicode === !1 ? (0, Ca._)`${n}.length` : (0, Ca._)`${(0, hK.useFunc)(t.gen, pK.default)}(${n})`;
    t.fail$data((0, Ca._)`${s} ${o} ${r}`);
  }
};
P1.default = gK;
var N1 = {};
Object.defineProperty(N1, "__esModule", { value: !0 });
const vK = dn, Nh = hn, yK = {
  message: ({ schemaCode: t }) => (0, Nh.str)`must match pattern "${t}"`,
  params: ({ schemaCode: t }) => (0, Nh._)`{pattern: ${t}}`
}, bK = {
  keyword: "pattern",
  type: "string",
  schemaType: "string",
  $data: !0,
  error: yK,
  code(t) {
    const { data: e, $data: n, schema: r, schemaCode: i, it: o } = t, s = o.opts.unicodeRegExp ? "u" : "", a = n ? (0, Nh._)`(new RegExp(${i}, ${s}))` : (0, vK.usePattern)(t, r);
    t.fail$data((0, Nh._)`!${a}.test(${e})`);
  }
};
N1.default = bK;
var I1 = {};
Object.defineProperty(I1, "__esModule", { value: !0 });
const su = hn, xK = {
  message({ keyword: t, schemaCode: e }) {
    const n = t === "maxProperties" ? "more" : "fewer";
    return (0, su.str)`must NOT have ${n} than ${e} properties`;
  },
  params: ({ schemaCode: t }) => (0, su._)`{limit: ${t}}`
}, wK = {
  keyword: ["maxProperties", "minProperties"],
  type: "object",
  schemaType: "number",
  $data: !0,
  error: xK,
  code(t) {
    const { keyword: e, data: n, schemaCode: r } = t, i = e === "maxProperties" ? su.operators.GT : su.operators.LT;
    t.fail$data((0, su._)`Object.keys(${n}).length ${i} ${r}`);
  }
};
I1.default = wK;
var D1 = {};
Object.defineProperty(D1, "__esModule", { value: !0 });
const Lc = dn, au = hn, jK = jn, kK = {
  message: ({ params: { missingProperty: t } }) => (0, au.str)`must have required property '${t}'`,
  params: ({ params: { missingProperty: t } }) => (0, au._)`{missingProperty: ${t}}`
}, $K = {
  keyword: "required",
  type: "object",
  schemaType: "array",
  $data: !0,
  error: kK,
  code(t) {
    const { gen: e, schema: n, schemaCode: r, data: i, $data: o, it: s } = t, { opts: a } = s;
    if (!o && n.length === 0)
      return;
    const l = n.length >= a.loopRequired;
    if (s.allErrors ? c() : u(), a.strictRequired) {
      const h = t.parentSchema.properties, { definedProperties: p } = t.it;
      for (const m of n)
        if ((h == null ? void 0 : h[m]) === void 0 && !p.has(m)) {
          const g = s.schemaEnv.baseId + s.errSchemaPath, v = `required property "${m}" is not defined at "${g}" (strictRequired)`;
          (0, jK.checkStrictMode)(s, v, s.opts.strictRequired);
        }
    }
    function c() {
      if (l || o)
        t.block$data(au.nil, f);
      else
        for (const h of n)
          (0, Lc.checkReportMissingProp)(t, h);
    }
    function u() {
      const h = e.let("missing");
      if (l || o) {
        const p = e.let("valid", !0);
        t.block$data(p, () => d(h, p)), t.ok(p);
      } else
        e.if((0, Lc.checkMissingProp)(t, n, h)), (0, Lc.reportMissingProp)(t, h), e.else();
    }
    function f() {
      e.forOf("prop", r, (h) => {
        t.setParams({ missingProperty: h }), e.if((0, Lc.noPropertyInData)(e, i, h, a.ownProperties), () => t.error());
      });
    }
    function d(h, p) {
      t.setParams({ missingProperty: h }), e.forOf(h, r, () => {
        e.assign(p, (0, Lc.propertyInData)(e, i, h, a.ownProperties)), e.if((0, au.not)(p), () => {
          t.error(), e.break();
        });
      }, au.nil);
    }
  }
};
D1.default = $K;
var L1 = {};
Object.defineProperty(L1, "__esModule", { value: !0 });
const lu = hn, SK = {
  message({ keyword: t, schemaCode: e }) {
    const n = t === "maxItems" ? "more" : "fewer";
    return (0, lu.str)`must NOT have ${n} than ${e} items`;
  },
  params: ({ schemaCode: t }) => (0, lu._)`{limit: ${t}}`
}, CK = {
  keyword: ["maxItems", "minItems"],
  type: "array",
  schemaType: "number",
  $data: !0,
  error: SK,
  code(t) {
    const { keyword: e, data: n, schemaCode: r } = t, i = e === "maxItems" ? lu.operators.GT : lu.operators.LT;
    t.fail$data((0, lu._)`${n}.length ${i} ${r}`);
  }
};
L1.default = CK;
var B1 = {}, mf = {};
Object.defineProperty(mf, "__esModule", { value: !0 });
const d6 = W8;
d6.code = 'require("ajv/dist/runtime/equal").default';
mf.default = d6;
Object.defineProperty(B1, "__esModule", { value: !0 });
const Fm = df, Pr = hn, OK = jn, EK = mf, AK = {
  message: ({ params: { i: t, j: e } }) => (0, Pr.str)`must NOT have duplicate items (items ## ${e} and ${t} are identical)`,
  params: ({ params: { i: t, j: e } }) => (0, Pr._)`{i: ${t}, j: ${e}}`
}, MK = {
  keyword: "uniqueItems",
  type: "array",
  schemaType: "boolean",
  $data: !0,
  error: AK,
  code(t) {
    const { gen: e, data: n, $data: r, schema: i, parentSchema: o, schemaCode: s, it: a } = t;
    if (!r && !i)
      return;
    const l = e.let("valid"), c = o.items ? (0, Fm.getSchemaTypes)(o.items) : [];
    t.block$data(l, u, (0, Pr._)`${s} === false`), t.ok(l);
    function u() {
      const p = e.let("i", (0, Pr._)`${n}.length`), m = e.let("j");
      t.setParams({ i: p, j: m }), e.assign(l, !0), e.if((0, Pr._)`${p} > 1`, () => (f() ? d : h)(p, m));
    }
    function f() {
      return c.length > 0 && !c.some((p) => p === "object" || p === "array");
    }
    function d(p, m) {
      const g = e.name("item"), v = (0, Fm.checkDataTypes)(c, g, a.opts.strictNumbers, Fm.DataType.Wrong), y = e.const("indices", (0, Pr._)`{}`);
      e.for((0, Pr._)`;${p}--;`, () => {
        e.let(g, (0, Pr._)`${n}[${p}]`), e.if(v, (0, Pr._)`continue`), c.length > 1 && e.if((0, Pr._)`typeof ${g} == "string"`, (0, Pr._)`${g} += "_"`), e.if((0, Pr._)`typeof ${y}[${g}] == "number"`, () => {
          e.assign(m, (0, Pr._)`${y}[${g}]`), t.error(), e.assign(l, !1).break();
        }).code((0, Pr._)`${y}[${g}] = ${p}`);
      });
    }
    function h(p, m) {
      const g = (0, OK.useFunc)(e, EK.default), v = e.name("outer");
      e.label(v).for((0, Pr._)`;${p}--;`, () => e.for((0, Pr._)`${m} = ${p}; ${m}--;`, () => e.if((0, Pr._)`${g}(${n}[${p}], ${n}[${m}])`, () => {
        t.error(), e.assign(l, !1).break(v);
      })));
    }
  }
};
B1.default = MK;
var q1 = {};
Object.defineProperty(q1, "__esModule", { value: !0 });
const Ov = hn, _K = jn, TK = mf, PK = {
  message: "must be equal to constant",
  params: ({ schemaCode: t }) => (0, Ov._)`{allowedValue: ${t}}`
}, RK = {
  keyword: "const",
  $data: !0,
  error: PK,
  code(t) {
    const { gen: e, data: n, $data: r, schemaCode: i, schema: o } = t;
    r || o && typeof o == "object" ? t.fail$data((0, Ov._)`!${(0, _K.useFunc)(e, TK.default)}(${n}, ${i})`) : t.fail((0, Ov._)`${o} !== ${n}`);
  }
};
q1.default = RK;
var z1 = {};
Object.defineProperty(z1, "__esModule", { value: !0 });
const Jc = hn, NK = jn, IK = mf, DK = {
  message: "must be equal to one of the allowed values",
  params: ({ schemaCode: t }) => (0, Jc._)`{allowedValues: ${t}}`
}, LK = {
  keyword: "enum",
  schemaType: "array",
  $data: !0,
  error: DK,
  code(t) {
    const { gen: e, data: n, $data: r, schema: i, schemaCode: o, it: s } = t;
    if (!r && i.length === 0)
      throw new Error("enum must have non-empty array");
    const a = i.length >= s.opts.loopEnum;
    let l;
    const c = () => l ?? (l = (0, NK.useFunc)(e, IK.default));
    let u;
    if (a || r)
      u = e.let("valid"), t.block$data(u, f);
    else {
      if (!Array.isArray(i))
        throw new Error("ajv implementation error");
      const h = e.const("vSchema", o);
      u = (0, Jc.or)(...i.map((p, m) => d(h, m)));
    }
    t.pass(u);
    function f() {
      e.assign(u, !1), e.forOf("v", o, (h) => e.if((0, Jc._)`${c()}(${n}, ${h})`, () => e.assign(u, !0).break()));
    }
    function d(h, p) {
      const m = i[p];
      return typeof m == "object" && m !== null ? (0, Jc._)`${c()}(${n}, ${h}[${p}])` : (0, Jc._)`${n} === ${m}`;
    }
  }
};
z1.default = LK;
Object.defineProperty(M1, "__esModule", { value: !0 });
const BK = _1, qK = T1, zK = P1, FK = N1, VK = I1, HK = D1, UK = L1, WK = B1, JK = q1, KK = z1, GK = [
  // number
  BK.default,
  qK.default,
  // string
  zK.default,
  FK.default,
  // object
  VK.default,
  HK.default,
  // array
  UK.default,
  WK.default,
  // any
  { keyword: "type", schemaType: ["string", "array"] },
  { keyword: "nullable", schemaType: "boolean" },
  JK.default,
  KK.default
];
M1.default = GK;
var F1 = {}, xc = {};
Object.defineProperty(xc, "__esModule", { value: !0 });
xc.validateAdditionalItems = void 0;
const Oa = hn, Ev = jn, QK = {
  message: ({ params: { len: t } }) => (0, Oa.str)`must NOT have more than ${t} items`,
  params: ({ params: { len: t } }) => (0, Oa._)`{limit: ${t}}`
}, YK = {
  keyword: "additionalItems",
  type: "array",
  schemaType: ["boolean", "object"],
  before: "uniqueItems",
  error: QK,
  code(t) {
    const { parentSchema: e, it: n } = t, { items: r } = e;
    if (!Array.isArray(r)) {
      (0, Ev.checkStrictMode)(n, '"additionalItems" is ignored when "items" is not an array of schemas');
      return;
    }
    h6(t, r);
  }
};
function h6(t, e) {
  const { gen: n, schema: r, data: i, keyword: o, it: s } = t;
  s.items = !0;
  const a = n.const("len", (0, Oa._)`${i}.length`);
  if (r === !1)
    t.setParams({ len: e.length }), t.pass((0, Oa._)`${a} <= ${e.length}`);
  else if (typeof r == "object" && !(0, Ev.alwaysValidSchema)(s, r)) {
    const c = n.var("valid", (0, Oa._)`${a} <= ${e.length}`);
    n.if((0, Oa.not)(c), () => l(c)), t.ok(c);
  }
  function l(c) {
    n.forRange("i", e.length, a, (u) => {
      t.subschema({ keyword: o, dataProp: u, dataPropType: Ev.Type.Num }, c), s.allErrors || n.if((0, Oa.not)(c), () => n.break());
    });
  }
}
xc.validateAdditionalItems = h6;
xc.default = YK;
var V1 = {}, wc = {};
Object.defineProperty(wc, "__esModule", { value: !0 });
wc.validateTuple = void 0;
const tw = hn, Fd = jn, XK = dn, ZK = {
  keyword: "items",
  type: "array",
  schemaType: ["object", "array", "boolean"],
  before: "uniqueItems",
  code(t) {
    const { schema: e, it: n } = t;
    if (Array.isArray(e))
      return p6(t, "additionalItems", e);
    n.items = !0, !(0, Fd.alwaysValidSchema)(n, e) && t.ok((0, XK.validateArray)(t));
  }
};
function p6(t, e, n = t.schema) {
  const { gen: r, parentSchema: i, data: o, keyword: s, it: a } = t;
  u(i), a.opts.unevaluated && n.length && a.items !== !0 && (a.items = Fd.mergeEvaluated.items(r, n.length, a.items));
  const l = r.name("valid"), c = r.const("len", (0, tw._)`${o}.length`);
  n.forEach((f, d) => {
    (0, Fd.alwaysValidSchema)(a, f) || (r.if((0, tw._)`${c} > ${d}`, () => t.subschema({
      keyword: s,
      schemaProp: d,
      dataProp: d
    }, l)), t.ok(l));
  });
  function u(f) {
    const { opts: d, errSchemaPath: h } = a, p = n.length, m = p === f.minItems && (p === f.maxItems || f[e] === !1);
    if (d.strictTuples && !m) {
      const g = `"${s}" is ${p}-tuple, but minItems or maxItems/${e} are not specified or different at path "${h}"`;
      (0, Fd.checkStrictMode)(a, g, d.strictTuples);
    }
  }
}
wc.validateTuple = p6;
wc.default = ZK;
Object.defineProperty(V1, "__esModule", { value: !0 });
const eG = wc, tG = {
  keyword: "prefixItems",
  type: "array",
  schemaType: ["array"],
  before: "uniqueItems",
  code: (t) => (0, eG.validateTuple)(t, "items")
};
V1.default = tG;
var H1 = {};
Object.defineProperty(H1, "__esModule", { value: !0 });
const nw = hn, nG = jn, rG = dn, iG = xc, oG = {
  message: ({ params: { len: t } }) => (0, nw.str)`must NOT have more than ${t} items`,
  params: ({ params: { len: t } }) => (0, nw._)`{limit: ${t}}`
}, sG = {
  keyword: "items",
  type: "array",
  schemaType: ["object", "boolean"],
  before: "uniqueItems",
  error: oG,
  code(t) {
    const { schema: e, parentSchema: n, it: r } = t, { prefixItems: i } = n;
    r.items = !0, !(0, nG.alwaysValidSchema)(r, e) && (i ? (0, iG.validateAdditionalItems)(t, i) : t.ok((0, rG.validateArray)(t)));
  }
};
H1.default = sG;
var U1 = {};
Object.defineProperty(U1, "__esModule", { value: !0 });
const Ei = hn, sd = jn, aG = {
  message: ({ params: { min: t, max: e } }) => e === void 0 ? (0, Ei.str)`must contain at least ${t} valid item(s)` : (0, Ei.str)`must contain at least ${t} and no more than ${e} valid item(s)`,
  params: ({ params: { min: t, max: e } }) => e === void 0 ? (0, Ei._)`{minContains: ${t}}` : (0, Ei._)`{minContains: ${t}, maxContains: ${e}}`
}, lG = {
  keyword: "contains",
  type: "array",
  schemaType: ["object", "boolean"],
  before: "uniqueItems",
  trackErrors: !0,
  error: aG,
  code(t) {
    const { gen: e, schema: n, parentSchema: r, data: i, it: o } = t;
    let s, a;
    const { minContains: l, maxContains: c } = r;
    o.opts.next ? (s = l === void 0 ? 1 : l, a = c) : s = 1;
    const u = e.const("len", (0, Ei._)`${i}.length`);
    if (t.setParams({ min: s, max: a }), a === void 0 && s === 0) {
      (0, sd.checkStrictMode)(o, '"minContains" == 0 without "maxContains": "contains" keyword ignored');
      return;
    }
    if (a !== void 0 && s > a) {
      (0, sd.checkStrictMode)(o, '"minContains" > "maxContains" is always invalid'), t.fail();
      return;
    }
    if ((0, sd.alwaysValidSchema)(o, n)) {
      let m = (0, Ei._)`${u} >= ${s}`;
      a !== void 0 && (m = (0, Ei._)`${m} && ${u} <= ${a}`), t.pass(m);
      return;
    }
    o.items = !0;
    const f = e.name("valid");
    a === void 0 && s === 1 ? h(f, () => e.if(f, () => e.break())) : s === 0 ? (e.let(f, !0), a !== void 0 && e.if((0, Ei._)`${i}.length > 0`, d)) : (e.let(f, !1), d()), t.result(f, () => t.reset());
    function d() {
      const m = e.name("_valid"), g = e.let("count", 0);
      h(m, () => e.if(m, () => p(g)));
    }
    function h(m, g) {
      e.forRange("i", 0, u, (v) => {
        t.subschema({
          keyword: "contains",
          dataProp: v,
          dataPropType: sd.Type.Num,
          compositeRule: !0
        }, m), g();
      });
    }
    function p(m) {
      e.code((0, Ei._)`${m}++`), a === void 0 ? e.if((0, Ei._)`${m} >= ${s}`, () => e.assign(f, !0).break()) : (e.if((0, Ei._)`${m} > ${a}`, () => e.assign(f, !1).break()), s === 1 ? e.assign(f, !0) : e.if((0, Ei._)`${m} >= ${s}`, () => e.assign(f, !0)));
    }
  }
};
U1.default = lG;
var m6 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.validateSchemaDeps = t.validatePropertyDeps = t.error = void 0;
  const e = hn, n = jn, r = dn;
  t.error = {
    message: ({ params: { property: l, depsCount: c, deps: u } }) => {
      const f = c === 1 ? "property" : "properties";
      return (0, e.str)`must have ${f} ${u} when property ${l} is present`;
    },
    params: ({ params: { property: l, depsCount: c, deps: u, missingProperty: f } }) => (0, e._)`{property: ${l},
    missingProperty: ${f},
    depsCount: ${c},
    deps: ${u}}`
    // TODO change to reference
  };
  const i = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: t.error,
    code(l) {
      const [c, u] = o(l);
      s(l, c), a(l, u);
    }
  };
  function o({ schema: l }) {
    const c = {}, u = {};
    for (const f in l) {
      if (f === "__proto__")
        continue;
      const d = Array.isArray(l[f]) ? c : u;
      d[f] = l[f];
    }
    return [c, u];
  }
  function s(l, c = l.schema) {
    const { gen: u, data: f, it: d } = l;
    if (Object.keys(c).length === 0)
      return;
    const h = u.let("missing");
    for (const p in c) {
      const m = c[p];
      if (m.length === 0)
        continue;
      const g = (0, r.propertyInData)(u, f, p, d.opts.ownProperties);
      l.setParams({
        property: p,
        depsCount: m.length,
        deps: m.join(", ")
      }), d.allErrors ? u.if(g, () => {
        for (const v of m)
          (0, r.checkReportMissingProp)(l, v);
      }) : (u.if((0, e._)`${g} && (${(0, r.checkMissingProp)(l, m, h)})`), (0, r.reportMissingProp)(l, h), u.else());
    }
  }
  t.validatePropertyDeps = s;
  function a(l, c = l.schema) {
    const { gen: u, data: f, keyword: d, it: h } = l, p = u.name("valid");
    for (const m in c)
      (0, n.alwaysValidSchema)(h, c[m]) || (u.if(
        (0, r.propertyInData)(u, f, m, h.opts.ownProperties),
        () => {
          const g = l.subschema({ keyword: d, schemaProp: m }, p);
          l.mergeValidEvaluated(g, p);
        },
        () => u.var(p, !0)
        // TODO var
      ), l.ok(p));
  }
  t.validateSchemaDeps = a, t.default = i;
})(m6);
var W1 = {};
Object.defineProperty(W1, "__esModule", { value: !0 });
const g6 = hn, cG = jn, uG = {
  message: "property name must be valid",
  params: ({ params: t }) => (0, g6._)`{propertyName: ${t.propertyName}}`
}, fG = {
  keyword: "propertyNames",
  type: "object",
  schemaType: ["object", "boolean"],
  error: uG,
  code(t) {
    const { gen: e, schema: n, data: r, it: i } = t;
    if ((0, cG.alwaysValidSchema)(i, n))
      return;
    const o = e.name("valid");
    e.forIn("key", r, (s) => {
      t.setParams({ propertyName: s }), t.subschema({
        keyword: "propertyNames",
        data: s,
        dataTypes: ["string"],
        propertyName: s,
        compositeRule: !0
      }, o), e.if((0, g6.not)(o), () => {
        t.error(!0), i.allErrors || e.break();
      });
    }), t.ok(o);
  }
};
W1.default = fG;
var qp = {};
Object.defineProperty(qp, "__esModule", { value: !0 });
const ad = dn, Yi = hn, dG = Xo, ld = jn, hG = {
  message: "must NOT have additional properties",
  params: ({ params: t }) => (0, Yi._)`{additionalProperty: ${t.additionalProperty}}`
}, pG = {
  keyword: "additionalProperties",
  type: ["object"],
  schemaType: ["boolean", "object"],
  allowUndefined: !0,
  trackErrors: !0,
  error: hG,
  code(t) {
    const { gen: e, schema: n, parentSchema: r, data: i, errsCount: o, it: s } = t;
    if (!o)
      throw new Error("ajv implementation error");
    const { allErrors: a, opts: l } = s;
    if (s.props = !0, l.removeAdditional !== "all" && (0, ld.alwaysValidSchema)(s, n))
      return;
    const c = (0, ad.allSchemaProperties)(r.properties), u = (0, ad.allSchemaProperties)(r.patternProperties);
    f(), t.ok((0, Yi._)`${o} === ${dG.default.errors}`);
    function f() {
      e.forIn("key", i, (g) => {
        !c.length && !u.length ? p(g) : e.if(d(g), () => p(g));
      });
    }
    function d(g) {
      let v;
      if (c.length > 8) {
        const y = (0, ld.schemaRefOrVal)(s, r.properties, "properties");
        v = (0, ad.isOwnProperty)(e, y, g);
      } else
        c.length ? v = (0, Yi.or)(...c.map((y) => (0, Yi._)`${g} === ${y}`)) : v = Yi.nil;
      return u.length && (v = (0, Yi.or)(v, ...u.map((y) => (0, Yi._)`${(0, ad.usePattern)(t, y)}.test(${g})`))), (0, Yi.not)(v);
    }
    function h(g) {
      e.code((0, Yi._)`delete ${i}[${g}]`);
    }
    function p(g) {
      if (l.removeAdditional === "all" || l.removeAdditional && n === !1) {
        h(g);
        return;
      }
      if (n === !1) {
        t.setParams({ additionalProperty: g }), t.error(), a || e.break();
        return;
      }
      if (typeof n == "object" && !(0, ld.alwaysValidSchema)(s, n)) {
        const v = e.name("valid");
        l.removeAdditional === "failing" ? (m(g, v, !1), e.if((0, Yi.not)(v), () => {
          t.reset(), h(g);
        })) : (m(g, v), a || e.if((0, Yi.not)(v), () => e.break()));
      }
    }
    function m(g, v, y) {
      const w = {
        keyword: "additionalProperties",
        dataProp: g,
        dataPropType: ld.Type.Str
      };
      y === !1 && Object.assign(w, {
        compositeRule: !0,
        createErrors: !1,
        allErrors: !1
      }), t.subschema(w, v);
    }
  }
};
qp.default = pG;
var J1 = {};
Object.defineProperty(J1, "__esModule", { value: !0 });
const mG = ao, rw = dn, Vm = jn, iw = qp, gG = {
  keyword: "properties",
  type: "object",
  schemaType: "object",
  code(t) {
    const { gen: e, schema: n, parentSchema: r, data: i, it: o } = t;
    o.opts.removeAdditional === "all" && r.additionalProperties === void 0 && iw.default.code(new mG.KeywordCxt(o, iw.default, "additionalProperties"));
    const s = (0, rw.allSchemaProperties)(n);
    for (const f of s)
      o.definedProperties.add(f);
    o.opts.unevaluated && s.length && o.props !== !0 && (o.props = Vm.mergeEvaluated.props(e, (0, Vm.toHash)(s), o.props));
    const a = s.filter((f) => !(0, Vm.alwaysValidSchema)(o, n[f]));
    if (a.length === 0)
      return;
    const l = e.name("valid");
    for (const f of a)
      c(f) ? u(f) : (e.if((0, rw.propertyInData)(e, i, f, o.opts.ownProperties)), u(f), o.allErrors || e.else().var(l, !0), e.endIf()), t.it.definedProperties.add(f), t.ok(l);
    function c(f) {
      return o.opts.useDefaults && !o.compositeRule && n[f].default !== void 0;
    }
    function u(f) {
      t.subschema({
        keyword: "properties",
        schemaProp: f,
        dataProp: f
      }, l);
    }
  }
};
J1.default = gG;
var K1 = {};
Object.defineProperty(K1, "__esModule", { value: !0 });
const ow = dn, cd = hn, sw = jn, aw = jn, vG = {
  keyword: "patternProperties",
  type: "object",
  schemaType: "object",
  code(t) {
    const { gen: e, schema: n, data: r, parentSchema: i, it: o } = t, { opts: s } = o, a = (0, ow.allSchemaProperties)(n), l = a.filter((m) => (0, sw.alwaysValidSchema)(o, n[m]));
    if (a.length === 0 || l.length === a.length && (!o.opts.unevaluated || o.props === !0))
      return;
    const c = s.strictSchema && !s.allowMatchingProperties && i.properties, u = e.name("valid");
    o.props !== !0 && !(o.props instanceof cd.Name) && (o.props = (0, aw.evaluatedPropsToName)(e, o.props));
    const { props: f } = o;
    d();
    function d() {
      for (const m of a)
        c && h(m), o.allErrors ? p(m) : (e.var(u, !0), p(m), e.if(u));
    }
    function h(m) {
      for (const g in c)
        new RegExp(m).test(g) && (0, sw.checkStrictMode)(o, `property ${g} matches pattern ${m} (use allowMatchingProperties)`);
    }
    function p(m) {
      e.forIn("key", r, (g) => {
        e.if((0, cd._)`${(0, ow.usePattern)(t, m)}.test(${g})`, () => {
          const v = l.includes(m);
          v || t.subschema({
            keyword: "patternProperties",
            schemaProp: m,
            dataProp: g,
            dataPropType: aw.Type.Str
          }, u), o.opts.unevaluated && f !== !0 ? e.assign((0, cd._)`${f}[${g}]`, !0) : !v && !o.allErrors && e.if((0, cd.not)(u), () => e.break());
        });
      });
    }
  }
};
K1.default = vG;
var G1 = {};
Object.defineProperty(G1, "__esModule", { value: !0 });
const yG = jn, bG = {
  keyword: "not",
  schemaType: ["object", "boolean"],
  trackErrors: !0,
  code(t) {
    const { gen: e, schema: n, it: r } = t;
    if ((0, yG.alwaysValidSchema)(r, n)) {
      t.fail();
      return;
    }
    const i = e.name("valid");
    t.subschema({
      keyword: "not",
      compositeRule: !0,
      createErrors: !1,
      allErrors: !1
    }, i), t.failResult(i, () => t.reset(), () => t.error());
  },
  error: { message: "must NOT be valid" }
};
G1.default = bG;
var Q1 = {};
Object.defineProperty(Q1, "__esModule", { value: !0 });
const xG = dn, wG = {
  keyword: "anyOf",
  schemaType: "array",
  trackErrors: !0,
  code: xG.validateUnion,
  error: { message: "must match a schema in anyOf" }
};
Q1.default = wG;
var Y1 = {};
Object.defineProperty(Y1, "__esModule", { value: !0 });
const Vd = hn, jG = jn, kG = {
  message: "must match exactly one schema in oneOf",
  params: ({ params: t }) => (0, Vd._)`{passingSchemas: ${t.passing}}`
}, $G = {
  keyword: "oneOf",
  schemaType: "array",
  trackErrors: !0,
  error: kG,
  code(t) {
    const { gen: e, schema: n, parentSchema: r, it: i } = t;
    if (!Array.isArray(n))
      throw new Error("ajv implementation error");
    if (i.opts.discriminator && r.discriminator)
      return;
    const o = n, s = e.let("valid", !1), a = e.let("passing", null), l = e.name("_valid");
    t.setParams({ passing: a }), e.block(c), t.result(s, () => t.reset(), () => t.error(!0));
    function c() {
      o.forEach((u, f) => {
        let d;
        (0, jG.alwaysValidSchema)(i, u) ? e.var(l, !0) : d = t.subschema({
          keyword: "oneOf",
          schemaProp: f,
          compositeRule: !0
        }, l), f > 0 && e.if((0, Vd._)`${l} && ${s}`).assign(s, !1).assign(a, (0, Vd._)`[${a}, ${f}]`).else(), e.if(l, () => {
          e.assign(s, !0), e.assign(a, f), d && t.mergeEvaluated(d, Vd.Name);
        });
      });
    }
  }
};
Y1.default = $G;
var X1 = {};
Object.defineProperty(X1, "__esModule", { value: !0 });
const SG = jn, CG = {
  keyword: "allOf",
  schemaType: "array",
  code(t) {
    const { gen: e, schema: n, it: r } = t;
    if (!Array.isArray(n))
      throw new Error("ajv implementation error");
    const i = e.name("valid");
    n.forEach((o, s) => {
      if ((0, SG.alwaysValidSchema)(r, o))
        return;
      const a = t.subschema({ keyword: "allOf", schemaProp: s }, i);
      t.ok(i), t.mergeEvaluated(a);
    });
  }
};
X1.default = CG;
var Z1 = {};
Object.defineProperty(Z1, "__esModule", { value: !0 });
const Ih = hn, v6 = jn, OG = {
  message: ({ params: t }) => (0, Ih.str)`must match "${t.ifClause}" schema`,
  params: ({ params: t }) => (0, Ih._)`{failingKeyword: ${t.ifClause}}`
}, EG = {
  keyword: "if",
  schemaType: ["object", "boolean"],
  trackErrors: !0,
  error: OG,
  code(t) {
    const { gen: e, parentSchema: n, it: r } = t;
    n.then === void 0 && n.else === void 0 && (0, v6.checkStrictMode)(r, '"if" without "then" and "else" is ignored');
    const i = lw(r, "then"), o = lw(r, "else");
    if (!i && !o)
      return;
    const s = e.let("valid", !0), a = e.name("_valid");
    if (l(), t.reset(), i && o) {
      const u = e.let("ifClause");
      t.setParams({ ifClause: u }), e.if(a, c("then", u), c("else", u));
    } else
      i ? e.if(a, c("then")) : e.if((0, Ih.not)(a), c("else"));
    t.pass(s, () => t.error(!0));
    function l() {
      const u = t.subschema({
        keyword: "if",
        compositeRule: !0,
        createErrors: !1,
        allErrors: !1
      }, a);
      t.mergeEvaluated(u);
    }
    function c(u, f) {
      return () => {
        const d = t.subschema({ keyword: u }, a);
        e.assign(s, a), t.mergeValidEvaluated(d, s), f ? e.assign(f, (0, Ih._)`${u}`) : t.setParams({ ifClause: u });
      };
    }
  }
};
function lw(t, e) {
  const n = t.schema[e];
  return n !== void 0 && !(0, v6.alwaysValidSchema)(t, n);
}
Z1.default = EG;
var ey = {};
Object.defineProperty(ey, "__esModule", { value: !0 });
const AG = jn, MG = {
  keyword: ["then", "else"],
  schemaType: ["object", "boolean"],
  code({ keyword: t, parentSchema: e, it: n }) {
    e.if === void 0 && (0, AG.checkStrictMode)(n, `"${t}" without "if" is ignored`);
  }
};
ey.default = MG;
Object.defineProperty(F1, "__esModule", { value: !0 });
const _G = xc, TG = V1, PG = wc, RG = H1, NG = U1, IG = m6, DG = W1, LG = qp, BG = J1, qG = K1, zG = G1, FG = Q1, VG = Y1, HG = X1, UG = Z1, WG = ey;
function JG(t = !1) {
  const e = [
    // any
    zG.default,
    FG.default,
    VG.default,
    HG.default,
    UG.default,
    WG.default,
    // object
    DG.default,
    LG.default,
    IG.default,
    BG.default,
    qG.default
  ];
  return t ? e.push(TG.default, RG.default) : e.push(_G.default, PG.default), e.push(NG.default), e;
}
F1.default = JG;
var ty = {}, ny = {};
Object.defineProperty(ny, "__esModule", { value: !0 });
const mr = hn, KG = {
  message: ({ schemaCode: t }) => (0, mr.str)`must match format "${t}"`,
  params: ({ schemaCode: t }) => (0, mr._)`{format: ${t}}`
}, GG = {
  keyword: "format",
  type: ["number", "string"],
  schemaType: "string",
  $data: !0,
  error: KG,
  code(t, e) {
    const { gen: n, data: r, $data: i, schema: o, schemaCode: s, it: a } = t, { opts: l, errSchemaPath: c, schemaEnv: u, self: f } = a;
    if (!l.validateFormats)
      return;
    i ? d() : h();
    function d() {
      const p = n.scopeValue("formats", {
        ref: f.formats,
        code: l.code.formats
      }), m = n.const("fDef", (0, mr._)`${p}[${s}]`), g = n.let("fType"), v = n.let("format");
      n.if((0, mr._)`typeof ${m} == "object" && !(${m} instanceof RegExp)`, () => n.assign(g, (0, mr._)`${m}.type || "string"`).assign(v, (0, mr._)`${m}.validate`), () => n.assign(g, (0, mr._)`"string"`).assign(v, m)), t.fail$data((0, mr.or)(y(), w()));
      function y() {
        return l.strictSchema === !1 ? mr.nil : (0, mr._)`${s} && !${v}`;
      }
      function w() {
        const x = u.$async ? (0, mr._)`(${m}.async ? await ${v}(${r}) : ${v}(${r}))` : (0, mr._)`${v}(${r})`, b = (0, mr._)`(typeof ${v} == "function" ? ${x} : ${v}.test(${r}))`;
        return (0, mr._)`${v} && ${v} !== true && ${g} === ${e} && !${b}`;
      }
    }
    function h() {
      const p = f.formats[o];
      if (!p) {
        y();
        return;
      }
      if (p === !0)
        return;
      const [m, g, v] = w(p);
      m === e && t.pass(x());
      function y() {
        if (l.strictSchema === !1) {
          f.logger.warn(b());
          return;
        }
        throw new Error(b());
        function b() {
          return `unknown format "${o}" ignored in schema at path "${c}"`;
        }
      }
      function w(b) {
        const j = b instanceof RegExp ? (0, mr.regexpCode)(b) : l.code.formats ? (0, mr._)`${l.code.formats}${(0, mr.getProperty)(o)}` : void 0, $ = n.scopeValue("formats", { key: o, ref: b, code: j });
        return typeof b == "object" && !(b instanceof RegExp) ? [b.type || "string", b.validate, (0, mr._)`${$}.validate`] : ["string", b, $];
      }
      function x() {
        if (typeof p == "object" && !(p instanceof RegExp) && p.async) {
          if (!u.$async)
            throw new Error("async format in sync schema");
          return (0, mr._)`await ${v}(${r})`;
        }
        return typeof g == "function" ? (0, mr._)`${v}(${r})` : (0, mr._)`${v}.test(${r})`;
      }
    }
  }
};
ny.default = GG;
Object.defineProperty(ty, "__esModule", { value: !0 });
const QG = ny, YG = [QG.default];
ty.default = YG;
var nc = {};
Object.defineProperty(nc, "__esModule", { value: !0 });
nc.contentVocabulary = nc.metadataVocabulary = void 0;
nc.metadataVocabulary = [
  "title",
  "description",
  "default",
  "deprecated",
  "readOnly",
  "writeOnly",
  "examples"
];
nc.contentVocabulary = [
  "contentMediaType",
  "contentEncoding",
  "contentSchema"
];
Object.defineProperty(O1, "__esModule", { value: !0 });
const XG = E1, ZG = M1, eQ = F1, tQ = ty, cw = nc, nQ = [
  XG.default,
  ZG.default,
  (0, eQ.default)(),
  tQ.default,
  cw.metadataVocabulary,
  cw.contentVocabulary
];
O1.default = nQ;
var ry = {}, y6 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.DiscrError = void 0, function(e) {
    e.Tag = "tag", e.Mapping = "mapping";
  }(t.DiscrError || (t.DiscrError = {}));
})(y6);
Object.defineProperty(ry, "__esModule", { value: !0 });
const bl = hn, Av = y6, uw = ci, rQ = jn, iQ = {
  message: ({ params: { discrError: t, tagName: e } }) => t === Av.DiscrError.Tag ? `tag "${e}" must be string` : `value of tag "${e}" must be in oneOf`,
  params: ({ params: { discrError: t, tag: e, tagName: n } }) => (0, bl._)`{error: ${t}, tag: ${n}, tagValue: ${e}}`
}, oQ = {
  keyword: "discriminator",
  type: "object",
  schemaType: "object",
  error: iQ,
  code(t) {
    const { gen: e, data: n, schema: r, parentSchema: i, it: o } = t, { oneOf: s } = i;
    if (!o.opts.discriminator)
      throw new Error("discriminator: requires discriminator option");
    const a = r.propertyName;
    if (typeof a != "string")
      throw new Error("discriminator: requires propertyName");
    if (r.mapping)
      throw new Error("discriminator: mapping is not supported");
    if (!s)
      throw new Error("discriminator: requires oneOf keyword");
    const l = e.let("valid", !1), c = e.const("tag", (0, bl._)`${n}${(0, bl.getProperty)(a)}`);
    e.if((0, bl._)`typeof ${c} == "string"`, () => u(), () => t.error(!1, { discrError: Av.DiscrError.Tag, tag: c, tagName: a })), t.ok(l);
    function u() {
      const h = d();
      e.if(!1);
      for (const p in h)
        e.elseIf((0, bl._)`${c} === ${p}`), e.assign(l, f(h[p]));
      e.else(), t.error(!1, { discrError: Av.DiscrError.Mapping, tag: c, tagName: a }), e.endIf();
    }
    function f(h) {
      const p = e.name("valid"), m = t.subschema({ keyword: "oneOf", schemaProp: h }, p);
      return t.mergeEvaluated(m, bl.Name), p;
    }
    function d() {
      var h;
      const p = {}, m = v(i);
      let g = !0;
      for (let x = 0; x < s.length; x++) {
        let b = s[x];
        b != null && b.$ref && !(0, rQ.schemaHasRulesButRef)(b, o.self.RULES) && (b = uw.resolveRef.call(o.self, o.schemaEnv.root, o.baseId, b == null ? void 0 : b.$ref), b instanceof uw.SchemaEnv && (b = b.schema));
        const j = (h = b == null ? void 0 : b.properties) === null || h === void 0 ? void 0 : h[a];
        if (typeof j != "object")
          throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${a}"`);
        g = g && (m || v(b)), y(j, x);
      }
      if (!g)
        throw new Error(`discriminator: "${a}" must be required`);
      return p;
      function v({ required: x }) {
        return Array.isArray(x) && x.includes(a);
      }
      function y(x, b) {
        if (x.const)
          w(x.const, b);
        else if (x.enum)
          for (const j of x.enum)
            w(j, b);
        else
          throw new Error(`discriminator: "properties/${a}" must have "const" or "enum"`);
      }
      function w(x, b) {
        if (typeof x != "string" || x in p)
          throw new Error(`discriminator: "${a}" values must be unique strings`);
        p[x] = b;
      }
    }
  }
};
ry.default = oQ;
const sQ = "http://json-schema.org/draft-07/schema#", aQ = "http://json-schema.org/draft-07/schema#", lQ = "Core schema meta-schema", cQ = {
  schemaArray: {
    type: "array",
    minItems: 1,
    items: {
      $ref: "#"
    }
  },
  nonNegativeInteger: {
    type: "integer",
    minimum: 0
  },
  nonNegativeIntegerDefault0: {
    allOf: [
      {
        $ref: "#/definitions/nonNegativeInteger"
      },
      {
        default: 0
      }
    ]
  },
  simpleTypes: {
    enum: [
      "array",
      "boolean",
      "integer",
      "null",
      "number",
      "object",
      "string"
    ]
  },
  stringArray: {
    type: "array",
    items: {
      type: "string"
    },
    uniqueItems: !0,
    default: []
  }
}, uQ = [
  "object",
  "boolean"
], fQ = {
  $id: {
    type: "string",
    format: "uri-reference"
  },
  $schema: {
    type: "string",
    format: "uri"
  },
  $ref: {
    type: "string",
    format: "uri-reference"
  },
  $comment: {
    type: "string"
  },
  title: {
    type: "string"
  },
  description: {
    type: "string"
  },
  default: !0,
  readOnly: {
    type: "boolean",
    default: !1
  },
  examples: {
    type: "array",
    items: !0
  },
  multipleOf: {
    type: "number",
    exclusiveMinimum: 0
  },
  maximum: {
    type: "number"
  },
  exclusiveMaximum: {
    type: "number"
  },
  minimum: {
    type: "number"
  },
  exclusiveMinimum: {
    type: "number"
  },
  maxLength: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minLength: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  pattern: {
    type: "string",
    format: "regex"
  },
  additionalItems: {
    $ref: "#"
  },
  items: {
    anyOf: [
      {
        $ref: "#"
      },
      {
        $ref: "#/definitions/schemaArray"
      }
    ],
    default: !0
  },
  maxItems: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minItems: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  uniqueItems: {
    type: "boolean",
    default: !1
  },
  contains: {
    $ref: "#"
  },
  maxProperties: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minProperties: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  required: {
    $ref: "#/definitions/stringArray"
  },
  additionalProperties: {
    $ref: "#"
  },
  definitions: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    default: {}
  },
  properties: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    default: {}
  },
  patternProperties: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    propertyNames: {
      format: "regex"
    },
    default: {}
  },
  dependencies: {
    type: "object",
    additionalProperties: {
      anyOf: [
        {
          $ref: "#"
        },
        {
          $ref: "#/definitions/stringArray"
        }
      ]
    }
  },
  propertyNames: {
    $ref: "#"
  },
  const: !0,
  enum: {
    type: "array",
    items: !0,
    minItems: 1,
    uniqueItems: !0
  },
  type: {
    anyOf: [
      {
        $ref: "#/definitions/simpleTypes"
      },
      {
        type: "array",
        items: {
          $ref: "#/definitions/simpleTypes"
        },
        minItems: 1,
        uniqueItems: !0
      }
    ]
  },
  format: {
    type: "string"
  },
  contentMediaType: {
    type: "string"
  },
  contentEncoding: {
    type: "string"
  },
  if: {
    $ref: "#"
  },
  then: {
    $ref: "#"
  },
  else: {
    $ref: "#"
  },
  allOf: {
    $ref: "#/definitions/schemaArray"
  },
  anyOf: {
    $ref: "#/definitions/schemaArray"
  },
  oneOf: {
    $ref: "#/definitions/schemaArray"
  },
  not: {
    $ref: "#"
  }
}, dQ = {
  $schema: sQ,
  $id: aQ,
  title: lQ,
  definitions: cQ,
  type: uQ,
  properties: fQ,
  default: !0
};
(function(t, e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MissingRefError = e.ValidationError = e.CodeGen = e.Name = e.nil = e.stringify = e.str = e._ = e.KeywordCxt = void 0;
  const n = L8, r = O1, i = ry, o = dQ, s = ["/properties"], a = "http://json-schema.org/draft-07/schema";
  class l extends n.default {
    _addVocabularies() {
      super._addVocabularies(), r.default.forEach((p) => this.addVocabulary(p)), this.opts.discriminator && this.addKeyword(i.default);
    }
    _addDefaultMetaSchema() {
      if (super._addDefaultMetaSchema(), !this.opts.meta)
        return;
      const p = this.opts.$data ? this.$dataMetaSchema(o, s) : o;
      this.addMetaSchema(p, a, !1), this.refs["http://json-schema.org/schema"] = a;
    }
    defaultMeta() {
      return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(a) ? a : void 0);
    }
  }
  t.exports = e = l, Object.defineProperty(e, "__esModule", { value: !0 }), e.default = l;
  var c = ao;
  Object.defineProperty(e, "KeywordCxt", { enumerable: !0, get: function() {
    return c.KeywordCxt;
  } });
  var u = hn;
  Object.defineProperty(e, "_", { enumerable: !0, get: function() {
    return u._;
  } }), Object.defineProperty(e, "str", { enumerable: !0, get: function() {
    return u.str;
  } }), Object.defineProperty(e, "stringify", { enumerable: !0, get: function() {
    return u.stringify;
  } }), Object.defineProperty(e, "nil", { enumerable: !0, get: function() {
    return u.nil;
  } }), Object.defineProperty(e, "Name", { enumerable: !0, get: function() {
    return u.Name;
  } }), Object.defineProperty(e, "CodeGen", { enumerable: !0, get: function() {
    return u.CodeGen;
  } });
  var f = hf;
  Object.defineProperty(e, "ValidationError", { enumerable: !0, get: function() {
    return f.default;
  } });
  var d = pf;
  Object.defineProperty(e, "MissingRefError", { enumerable: !0, get: function() {
    return d.default;
  } });
})(Ux, Ux.exports);
var hQ = {};
(function(t) {
  (function(e) {
    function n(q) {
      return q !== null ? Object.prototype.toString.call(q) === "[object Array]" : !1;
    }
    function r(q) {
      return q !== null ? Object.prototype.toString.call(q) === "[object Object]" : !1;
    }
    function i(q, ee) {
      if (q === ee)
        return !0;
      var ne = Object.prototype.toString.call(q);
      if (ne !== Object.prototype.toString.call(ee))
        return !1;
      if (n(q) === !0) {
        if (q.length !== ee.length)
          return !1;
        for (var he = 0; he < q.length; he++)
          if (i(q[he], ee[he]) === !1)
            return !1;
        return !0;
      }
      if (r(q) === !0) {
        var je = {};
        for (var _e in q)
          if (hasOwnProperty.call(q, _e)) {
            if (i(q[_e], ee[_e]) === !1)
              return !1;
            je[_e] = !0;
          }
        for (var yt in ee)
          if (hasOwnProperty.call(ee, yt) && je[yt] !== !0)
            return !1;
        return !0;
      }
      return !1;
    }
    function o(q) {
      if (q === "" || q === !1 || q === null)
        return !0;
      if (n(q) && q.length === 0)
        return !0;
      if (r(q)) {
        for (var ee in q)
          if (q.hasOwnProperty(ee))
            return !1;
        return !0;
      } else
        return !1;
    }
    function s(q) {
      for (var ee = Object.keys(q), ne = [], he = 0; he < ee.length; he++)
        ne.push(q[ee[he]]);
      return ne;
    }
    var a;
    typeof String.prototype.trimLeft == "function" ? a = function(q) {
      return q.trimLeft();
    } : a = function(q) {
      return q.match(/^\s*(.*)/)[1];
    };
    var l = 0, c = 1, u = 2, f = 3, d = 4, h = 5, p = 6, m = 7, g = 8, v = 9, y = {
      0: "number",
      1: "any",
      2: "string",
      3: "array",
      4: "object",
      5: "boolean",
      6: "expression",
      7: "null",
      8: "Array<number>",
      9: "Array<string>"
    }, w = "EOF", x = "UnquotedIdentifier", b = "QuotedIdentifier", j = "Rbracket", $ = "Rparen", N = "Comma", B = "Colon", O = "Rbrace", I = "Number", P = "Current", J = "Expref", D = "Pipe", Q = "Or", Z = "And", L = "EQ", R = "GT", V = "LT", M = "GTE", C = "LTE", F = "NE", z = "Flatten", E = "Star", A = "Filter", te = "Dot", ge = "Not", ke = "Lbrace", Ce = "Lbracket", we = "Lparen", le = "Literal", rt = {
      ".": te,
      "*": E,
      ",": N,
      ":": B,
      "{": ke,
      "}": O,
      "]": j,
      "(": we,
      ")": $,
      "@": P
    }, Be = {
      "<": !0,
      ">": !0,
      "=": !0,
      "!": !0
    }, nt = {
      " ": !0,
      "	": !0,
      "\n": !0
    };
    function oe(q) {
      return q >= "a" && q <= "z" || q >= "A" && q <= "Z" || q === "_";
    }
    function We(q) {
      return q >= "0" && q <= "9" || q === "-";
    }
    function Rt(q) {
      return q >= "a" && q <= "z" || q >= "A" && q <= "Z" || q >= "0" && q <= "9" || q === "_";
    }
    function de() {
    }
    de.prototype = {
      tokenize: function(q) {
        var ee = [];
        this._current = 0;
        for (var ne, he, je; this._current < q.length; )
          if (oe(q[this._current]))
            ne = this._current, he = this._consumeUnquotedIdentifier(q), ee.push({
              type: x,
              value: he,
              start: ne
            });
          else if (rt[q[this._current]] !== void 0)
            ee.push({
              type: rt[q[this._current]],
              value: q[this._current],
              start: this._current
            }), this._current++;
          else if (We(q[this._current]))
            je = this._consumeNumber(q), ee.push(je);
          else if (q[this._current] === "[")
            je = this._consumeLBracket(q), ee.push(je);
          else if (q[this._current] === '"')
            ne = this._current, he = this._consumeQuotedIdentifier(q), ee.push({
              type: b,
              value: he,
              start: ne
            });
          else if (q[this._current] === "'")
            ne = this._current, he = this._consumeRawStringLiteral(q), ee.push({
              type: le,
              value: he,
              start: ne
            });
          else if (q[this._current] === "`") {
            ne = this._current;
            var _e = this._consumeLiteral(q);
            ee.push({
              type: le,
              value: _e,
              start: ne
            });
          } else if (Be[q[this._current]] !== void 0)
            ee.push(this._consumeOperator(q));
          else if (nt[q[this._current]] !== void 0)
            this._current++;
          else if (q[this._current] === "&")
            ne = this._current, this._current++, q[this._current] === "&" ? (this._current++, ee.push({ type: Z, value: "&&", start: ne })) : ee.push({ type: J, value: "&", start: ne });
          else if (q[this._current] === "|")
            ne = this._current, this._current++, q[this._current] === "|" ? (this._current++, ee.push({ type: Q, value: "||", start: ne })) : ee.push({ type: D, value: "|", start: ne });
          else {
            var yt = new Error("Unknown character:" + q[this._current]);
            throw yt.name = "LexerError", yt;
          }
        return ee;
      },
      _consumeUnquotedIdentifier: function(q) {
        var ee = this._current;
        for (this._current++; this._current < q.length && Rt(q[this._current]); )
          this._current++;
        return q.slice(ee, this._current);
      },
      _consumeQuotedIdentifier: function(q) {
        var ee = this._current;
        this._current++;
        for (var ne = q.length; q[this._current] !== '"' && this._current < ne; ) {
          var he = this._current;
          q[he] === "\\" && (q[he + 1] === "\\" || q[he + 1] === '"') ? he += 2 : he++, this._current = he;
        }
        return this._current++, JSON.parse(q.slice(ee, this._current));
      },
      _consumeRawStringLiteral: function(q) {
        var ee = this._current;
        this._current++;
        for (var ne = q.length; q[this._current] !== "'" && this._current < ne; ) {
          var he = this._current;
          q[he] === "\\" && (q[he + 1] === "\\" || q[he + 1] === "'") ? he += 2 : he++, this._current = he;
        }
        this._current++;
        var je = q.slice(ee + 1, this._current - 1);
        return je.replace("\\'", "'");
      },
      _consumeNumber: function(q) {
        var ee = this._current;
        this._current++;
        for (var ne = q.length; We(q[this._current]) && this._current < ne; )
          this._current++;
        var he = parseInt(q.slice(ee, this._current));
        return { type: I, value: he, start: ee };
      },
      _consumeLBracket: function(q) {
        var ee = this._current;
        return this._current++, q[this._current] === "?" ? (this._current++, { type: A, value: "[?", start: ee }) : q[this._current] === "]" ? (this._current++, { type: z, value: "[]", start: ee }) : { type: Ce, value: "[", start: ee };
      },
      _consumeOperator: function(q) {
        var ee = this._current, ne = q[ee];
        if (this._current++, ne === "!")
          return q[this._current] === "=" ? (this._current++, { type: F, value: "!=", start: ee }) : { type: ge, value: "!", start: ee };
        if (ne === "<")
          return q[this._current] === "=" ? (this._current++, { type: C, value: "<=", start: ee }) : { type: V, value: "<", start: ee };
        if (ne === ">")
          return q[this._current] === "=" ? (this._current++, { type: M, value: ">=", start: ee }) : { type: R, value: ">", start: ee };
        if (ne === "=" && q[this._current] === "=")
          return this._current++, { type: L, value: "==", start: ee };
      },
      _consumeLiteral: function(q) {
        this._current++;
        for (var ee = this._current, ne = q.length, he; q[this._current] !== "`" && this._current < ne; ) {
          var je = this._current;
          q[je] === "\\" && (q[je + 1] === "\\" || q[je + 1] === "`") ? je += 2 : je++, this._current = je;
        }
        var _e = a(q.slice(ee, this._current));
        return _e = _e.replace("\\`", "`"), this._looksLikeJSON(_e) ? he = JSON.parse(_e) : he = JSON.parse('"' + _e + '"'), this._current++, he;
      },
      _looksLikeJSON: function(q) {
        var ee = '[{"', ne = ["true", "false", "null"], he = "-0123456789";
        if (q === "")
          return !1;
        if (ee.indexOf(q[0]) >= 0)
          return !0;
        if (ne.indexOf(q) >= 0)
          return !0;
        if (he.indexOf(q[0]) >= 0)
          try {
            return JSON.parse(q), !0;
          } catch {
            return !1;
          }
        else
          return !1;
      }
    };
    var Se = {};
    Se[w] = 0, Se[x] = 0, Se[b] = 0, Se[j] = 0, Se[$] = 0, Se[N] = 0, Se[O] = 0, Se[I] = 0, Se[P] = 0, Se[J] = 0, Se[D] = 1, Se[Q] = 2, Se[Z] = 3, Se[L] = 5, Se[R] = 5, Se[V] = 5, Se[M] = 5, Se[C] = 5, Se[F] = 5, Se[z] = 9, Se[E] = 20, Se[A] = 21, Se[te] = 40, Se[ge] = 45, Se[ke] = 50, Se[Ce] = 55, Se[we] = 60;
    function rn() {
    }
    rn.prototype = {
      parse: function(q) {
        this._loadTokens(q), this.index = 0;
        var ee = this.expression(0);
        if (this._lookahead(0) !== w) {
          var ne = this._lookaheadToken(0), he = new Error(
            "Unexpected token type: " + ne.type + ", value: " + ne.value
          );
          throw he.name = "ParserError", he;
        }
        return ee;
      },
      _loadTokens: function(q) {
        var ee = new de(), ne = ee.tokenize(q);
        ne.push({ type: w, value: "", start: q.length }), this.tokens = ne;
      },
      expression: function(q) {
        var ee = this._lookaheadToken(0);
        this._advance();
        for (var ne = this.nud(ee), he = this._lookahead(0); q < Se[he]; )
          this._advance(), ne = this.led(he, ne), he = this._lookahead(0);
        return ne;
      },
      _lookahead: function(q) {
        return this.tokens[this.index + q].type;
      },
      _lookaheadToken: function(q) {
        return this.tokens[this.index + q];
      },
      _advance: function() {
        this.index++;
      },
      nud: function(q) {
        var ee, ne, he;
        switch (q.type) {
          case le:
            return { type: "Literal", value: q.value };
          case x:
            return { type: "Field", name: q.value };
          case b:
            var je = { type: "Field", name: q.value };
            if (this._lookahead(0) === we)
              throw new Error("Quoted identifier not allowed for function names.");
            return je;
          case ge:
            return ne = this.expression(Se.Not), { type: "NotExpression", children: [ne] };
          case E:
            return ee = { type: "Identity" }, ne = null, this._lookahead(0) === j ? ne = { type: "Identity" } : ne = this._parseProjectionRHS(Se.Star), { type: "ValueProjection", children: [ee, ne] };
          case A:
            return this.led(q.type, { type: "Identity" });
          case ke:
            return this._parseMultiselectHash();
          case z:
            return ee = { type: z, children: [{ type: "Identity" }] }, ne = this._parseProjectionRHS(Se.Flatten), { type: "Projection", children: [ee, ne] };
          case Ce:
            return this._lookahead(0) === I || this._lookahead(0) === B ? (ne = this._parseIndexExpression(), this._projectIfSlice({ type: "Identity" }, ne)) : this._lookahead(0) === E && this._lookahead(1) === j ? (this._advance(), this._advance(), ne = this._parseProjectionRHS(Se.Star), {
              type: "Projection",
              children: [{ type: "Identity" }, ne]
            }) : this._parseMultiselectList();
          case P:
            return { type: P };
          case J:
            return he = this.expression(Se.Expref), { type: "ExpressionReference", children: [he] };
          case we:
            for (var _e = []; this._lookahead(0) !== $; )
              this._lookahead(0) === P ? (he = { type: P }, this._advance()) : he = this.expression(0), _e.push(he);
            return this._match($), _e[0];
          default:
            this._errorToken(q);
        }
      },
      led: function(q, ee) {
        var ne;
        switch (q) {
          case te:
            var he = Se.Dot;
            return this._lookahead(0) !== E ? (ne = this._parseDotRHS(he), { type: "Subexpression", children: [ee, ne] }) : (this._advance(), ne = this._parseProjectionRHS(he), { type: "ValueProjection", children: [ee, ne] });
          case D:
            return ne = this.expression(Se.Pipe), { type: D, children: [ee, ne] };
          case Q:
            return ne = this.expression(Se.Or), { type: "OrExpression", children: [ee, ne] };
          case Z:
            return ne = this.expression(Se.And), { type: "AndExpression", children: [ee, ne] };
          case we:
            for (var je = ee.name, _e = [], yt, Xe; this._lookahead(0) !== $; )
              this._lookahead(0) === P ? (yt = { type: P }, this._advance()) : yt = this.expression(0), this._lookahead(0) === N && this._match(N), _e.push(yt);
            return this._match($), Xe = { type: "Function", name: je, children: _e }, Xe;
          case A:
            var Zt = this.expression(0);
            return this._match(j), this._lookahead(0) === z ? ne = { type: "Identity" } : ne = this._parseProjectionRHS(Se.Filter), { type: "FilterProjection", children: [ee, ne, Zt] };
          case z:
            var on = { type: z, children: [ee] }, Jt = this._parseProjectionRHS(Se.Flatten);
            return { type: "Projection", children: [on, Jt] };
          case L:
          case F:
          case R:
          case M:
          case V:
          case C:
            return this._parseComparator(ee, q);
          case Ce:
            var Ge = this._lookaheadToken(0);
            return Ge.type === I || Ge.type === B ? (ne = this._parseIndexExpression(), this._projectIfSlice(ee, ne)) : (this._match(E), this._match(j), ne = this._parseProjectionRHS(Se.Star), { type: "Projection", children: [ee, ne] });
          default:
            this._errorToken(this._lookaheadToken(0));
        }
      },
      _match: function(q) {
        if (this._lookahead(0) === q)
          this._advance();
        else {
          var ee = this._lookaheadToken(0), ne = new Error("Expected " + q + ", got: " + ee.type);
          throw ne.name = "ParserError", ne;
        }
      },
      _errorToken: function(q) {
        var ee = new Error("Invalid token (" + q.type + '): "' + q.value + '"');
        throw ee.name = "ParserError", ee;
      },
      _parseIndexExpression: function() {
        if (this._lookahead(0) === B || this._lookahead(1) === B)
          return this._parseSliceExpression();
        var q = {
          type: "Index",
          value: this._lookaheadToken(0).value
        };
        return this._advance(), this._match(j), q;
      },
      _projectIfSlice: function(q, ee) {
        var ne = { type: "IndexExpression", children: [q, ee] };
        return ee.type === "Slice" ? {
          type: "Projection",
          children: [ne, this._parseProjectionRHS(Se.Star)]
        } : ne;
      },
      _parseSliceExpression: function() {
        for (var q = [null, null, null], ee = 0, ne = this._lookahead(0); ne !== j && ee < 3; ) {
          if (ne === B)
            ee++, this._advance();
          else if (ne === I)
            q[ee] = this._lookaheadToken(0).value, this._advance();
          else {
            var he = this._lookahead(0), je = new Error("Syntax error, unexpected token: " + he.value + "(" + he.type + ")");
            throw je.name = "Parsererror", je;
          }
          ne = this._lookahead(0);
        }
        return this._match(j), {
          type: "Slice",
          children: q
        };
      },
      _parseComparator: function(q, ee) {
        var ne = this.expression(Se[ee]);
        return { type: "Comparator", name: ee, children: [q, ne] };
      },
      _parseDotRHS: function(q) {
        var ee = this._lookahead(0), ne = [x, b, E];
        if (ne.indexOf(ee) >= 0)
          return this.expression(q);
        if (ee === Ce)
          return this._match(Ce), this._parseMultiselectList();
        if (ee === ke)
          return this._match(ke), this._parseMultiselectHash();
      },
      _parseProjectionRHS: function(q) {
        var ee;
        if (Se[this._lookahead(0)] < 10)
          ee = { type: "Identity" };
        else if (this._lookahead(0) === Ce)
          ee = this.expression(q);
        else if (this._lookahead(0) === A)
          ee = this.expression(q);
        else if (this._lookahead(0) === te)
          this._match(te), ee = this._parseDotRHS(q);
        else {
          var ne = this._lookaheadToken(0), he = new Error("Sytanx error, unexpected token: " + ne.value + "(" + ne.type + ")");
          throw he.name = "ParserError", he;
        }
        return ee;
      },
      _parseMultiselectList: function() {
        for (var q = []; this._lookahead(0) !== j; ) {
          var ee = this.expression(0);
          if (q.push(ee), this._lookahead(0) === N && (this._match(N), this._lookahead(0) === j))
            throw new Error("Unexpected token Rbracket");
        }
        return this._match(j), { type: "MultiSelectList", children: q };
      },
      _parseMultiselectHash: function() {
        for (var q = [], ee = [x, b], ne, he, je, _e; ; ) {
          if (ne = this._lookaheadToken(0), ee.indexOf(ne.type) < 0)
            throw new Error("Expecting an identifier token, got: " + ne.type);
          if (he = ne.value, this._advance(), this._match(B), je = this.expression(0), _e = { type: "KeyValuePair", name: he, value: je }, q.push(_e), this._lookahead(0) === N)
            this._match(N);
          else if (this._lookahead(0) === O) {
            this._match(O);
            break;
          }
        }
        return { type: "MultiSelectHash", children: q };
      }
    };
    function Dt(q) {
      this.runtime = q;
    }
    Dt.prototype = {
      search: function(q, ee) {
        return this.visit(q, ee);
      },
      visit: function(q, ee) {
        var ne, he, je, _e, yt, Xe, Zt, on, Jt, Ge;
        switch (q.type) {
          case "Field":
            return ee !== null && r(ee) ? (Xe = ee[q.name], Xe === void 0 ? null : Xe) : null;
          case "Subexpression":
            for (je = this.visit(q.children[0], ee), Ge = 1; Ge < q.children.length; Ge++)
              if (je = this.visit(q.children[1], je), je === null)
                return null;
            return je;
          case "IndexExpression":
            return Zt = this.visit(q.children[0], ee), on = this.visit(q.children[1], Zt), on;
          case "Index":
            if (!n(ee))
              return null;
            var xn = q.value;
            return xn < 0 && (xn = ee.length + xn), je = ee[xn], je === void 0 && (je = null), je;
          case "Slice":
            if (!n(ee))
              return null;
            var Dn = q.children.slice(0), wn = this.computeSliceParams(ee.length, Dn), $n = wn[0], Rn = wn[1], Jn = wn[2];
            if (je = [], Jn > 0)
              for (Ge = $n; Ge < Rn; Ge += Jn)
                je.push(ee[Ge]);
            else
              for (Ge = $n; Ge > Rn; Ge += Jn)
                je.push(ee[Ge]);
            return je;
          case "Projection":
            var pn = this.visit(q.children[0], ee);
            if (!n(pn))
              return null;
            for (Jt = [], Ge = 0; Ge < pn.length; Ge++)
              he = this.visit(q.children[1], pn[Ge]), he !== null && Jt.push(he);
            return Jt;
          case "ValueProjection":
            if (pn = this.visit(q.children[0], ee), !r(pn))
              return null;
            Jt = [];
            var me = s(pn);
            for (Ge = 0; Ge < me.length; Ge++)
              he = this.visit(q.children[1], me[Ge]), he !== null && Jt.push(he);
            return Jt;
          case "FilterProjection":
            if (pn = this.visit(q.children[0], ee), !n(pn))
              return null;
            var Ke = [], It = [];
            for (Ge = 0; Ge < pn.length; Ge++)
              ne = this.visit(q.children[2], pn[Ge]), o(ne) || Ke.push(pn[Ge]);
            for (var Nt = 0; Nt < Ke.length; Nt++)
              he = this.visit(q.children[1], Ke[Nt]), he !== null && It.push(he);
            return It;
          case "Comparator":
            switch (_e = this.visit(q.children[0], ee), yt = this.visit(q.children[1], ee), q.name) {
              case L:
                je = i(_e, yt);
                break;
              case F:
                je = !i(_e, yt);
                break;
              case R:
                je = _e > yt;
                break;
              case M:
                je = _e >= yt;
                break;
              case V:
                je = _e < yt;
                break;
              case C:
                je = _e <= yt;
                break;
              default:
                throw new Error("Unknown comparator: " + q.name);
            }
            return je;
          case z:
            var ce = this.visit(q.children[0], ee);
            if (!n(ce))
              return null;
            var qe = [];
            for (Ge = 0; Ge < ce.length; Ge++)
              he = ce[Ge], n(he) ? qe.push.apply(qe, he) : qe.push(he);
            return qe;
          case "Identity":
            return ee;
          case "MultiSelectList":
            if (ee === null)
              return null;
            for (Jt = [], Ge = 0; Ge < q.children.length; Ge++)
              Jt.push(this.visit(q.children[Ge], ee));
            return Jt;
          case "MultiSelectHash":
            if (ee === null)
              return null;
            Jt = {};
            var Fe;
            for (Ge = 0; Ge < q.children.length; Ge++)
              Fe = q.children[Ge], Jt[Fe.name] = this.visit(Fe.value, ee);
            return Jt;
          case "OrExpression":
            return ne = this.visit(q.children[0], ee), o(ne) && (ne = this.visit(q.children[1], ee)), ne;
          case "AndExpression":
            return _e = this.visit(q.children[0], ee), o(_e) === !0 ? _e : this.visit(q.children[1], ee);
          case "NotExpression":
            return _e = this.visit(q.children[0], ee), o(_e);
          case "Literal":
            return q.value;
          case D:
            return Zt = this.visit(q.children[0], ee), this.visit(q.children[1], Zt);
          case P:
            return ee;
          case "Function":
            var Lt = [];
            for (Ge = 0; Ge < q.children.length; Ge++)
              Lt.push(this.visit(q.children[Ge], ee));
            return this.runtime.callFunction(q.name, Lt);
          case "ExpressionReference":
            var qt = q.children[0];
            return qt.jmespathType = J, qt;
          default:
            throw new Error("Unknown node type: " + q.type);
        }
      },
      computeSliceParams: function(q, ee) {
        var ne = ee[0], he = ee[1], je = ee[2], _e = [null, null, null];
        if (je === null)
          je = 1;
        else if (je === 0) {
          var yt = new Error("Invalid slice, step cannot be 0");
          throw yt.name = "RuntimeError", yt;
        }
        var Xe = je < 0;
        return ne === null ? ne = Xe ? q - 1 : 0 : ne = this.capSliceRange(q, ne, je), he === null ? he = Xe ? -1 : q : he = this.capSliceRange(q, he, je), _e[0] = ne, _e[1] = he, _e[2] = je, _e;
      },
      capSliceRange: function(q, ee, ne) {
        return ee < 0 ? (ee += q, ee < 0 && (ee = ne < 0 ? -1 : 0)) : ee >= q && (ee = ne < 0 ? q - 1 : q), ee;
      }
    };
    function Xt(q) {
      this._interpreter = q, this.functionTable = {
        // name: [function, <signature>]
        // The <signature> can be:
        //
        // {
        //   args: [[type1, type2], [type1, type2]],
        //   variadic: true|false
        // }
        //
        // Each arg in the arg list is a list of valid types
        // (if the function is overloaded and supports multiple
        // types.  If the type is "any" then no type checking
        // occurs on the argument.  Variadic is optional
        // and if not provided is assumed to be false.
        abs: { _func: this._functionAbs, _signature: [{ types: [l] }] },
        avg: { _func: this._functionAvg, _signature: [{ types: [g] }] },
        ceil: { _func: this._functionCeil, _signature: [{ types: [l] }] },
        contains: {
          _func: this._functionContains,
          _signature: [
            { types: [u, f] },
            { types: [c] }
          ]
        },
        ends_with: {
          _func: this._functionEndsWith,
          _signature: [{ types: [u] }, { types: [u] }]
        },
        floor: { _func: this._functionFloor, _signature: [{ types: [l] }] },
        length: {
          _func: this._functionLength,
          _signature: [{ types: [u, f, d] }]
        },
        map: {
          _func: this._functionMap,
          _signature: [{ types: [p] }, { types: [f] }]
        },
        max: {
          _func: this._functionMax,
          _signature: [{ types: [g, v] }]
        },
        merge: {
          _func: this._functionMerge,
          _signature: [{ types: [d], variadic: !0 }]
        },
        max_by: {
          _func: this._functionMaxBy,
          _signature: [{ types: [f] }, { types: [p] }]
        },
        sum: { _func: this._functionSum, _signature: [{ types: [g] }] },
        starts_with: {
          _func: this._functionStartsWith,
          _signature: [{ types: [u] }, { types: [u] }]
        },
        min: {
          _func: this._functionMin,
          _signature: [{ types: [g, v] }]
        },
        min_by: {
          _func: this._functionMinBy,
          _signature: [{ types: [f] }, { types: [p] }]
        },
        type: { _func: this._functionType, _signature: [{ types: [c] }] },
        keys: { _func: this._functionKeys, _signature: [{ types: [d] }] },
        values: { _func: this._functionValues, _signature: [{ types: [d] }] },
        sort: { _func: this._functionSort, _signature: [{ types: [v, g] }] },
        sort_by: {
          _func: this._functionSortBy,
          _signature: [{ types: [f] }, { types: [p] }]
        },
        join: {
          _func: this._functionJoin,
          _signature: [
            { types: [u] },
            { types: [v] }
          ]
        },
        reverse: {
          _func: this._functionReverse,
          _signature: [{ types: [u, f] }]
        },
        to_array: { _func: this._functionToArray, _signature: [{ types: [c] }] },
        to_string: { _func: this._functionToString, _signature: [{ types: [c] }] },
        to_number: { _func: this._functionToNumber, _signature: [{ types: [c] }] },
        not_null: {
          _func: this._functionNotNull,
          _signature: [{ types: [c], variadic: !0 }]
        }
      };
    }
    Xt.prototype = {
      callFunction: function(q, ee) {
        var ne = this.functionTable[q];
        if (ne === void 0)
          throw new Error("Unknown function: " + q + "()");
        return this._validateArgs(q, ee, ne._signature), ne._func.call(this, ee);
      },
      _validateArgs: function(q, ee, ne) {
        var he;
        if (ne[ne.length - 1].variadic) {
          if (ee.length < ne.length)
            throw he = ne.length === 1 ? " argument" : " arguments", new Error("ArgumentError: " + q + "() takes at least" + ne.length + he + " but received " + ee.length);
        } else if (ee.length !== ne.length)
          throw he = ne.length === 1 ? " argument" : " arguments", new Error("ArgumentError: " + q + "() takes " + ne.length + he + " but received " + ee.length);
        for (var je, _e, yt, Xe = 0; Xe < ne.length; Xe++) {
          yt = !1, je = ne[Xe].types, _e = this._getTypeName(ee[Xe]);
          for (var Zt = 0; Zt < je.length; Zt++)
            if (this._typeMatches(_e, je[Zt], ee[Xe])) {
              yt = !0;
              break;
            }
          if (!yt) {
            var on = je.map(function(Jt) {
              return y[Jt];
            }).join(",");
            throw new Error("TypeError: " + q + "() expected argument " + (Xe + 1) + " to be type " + on + " but received type " + y[_e] + " instead.");
          }
        }
      },
      _typeMatches: function(q, ee, ne) {
        if (ee === c)
          return !0;
        if (ee === v || ee === g || ee === f) {
          if (ee === f)
            return q === f;
          if (q === f) {
            var he;
            ee === g ? he = l : ee === v && (he = u);
            for (var je = 0; je < ne.length; je++)
              if (!this._typeMatches(
                this._getTypeName(ne[je]),
                he,
                ne[je]
              ))
                return !1;
            return !0;
          }
        } else
          return q === ee;
      },
      _getTypeName: function(q) {
        switch (Object.prototype.toString.call(q)) {
          case "[object String]":
            return u;
          case "[object Number]":
            return l;
          case "[object Array]":
            return f;
          case "[object Boolean]":
            return h;
          case "[object Null]":
            return m;
          case "[object Object]":
            return q.jmespathType === J ? p : d;
        }
      },
      _functionStartsWith: function(q) {
        return q[0].lastIndexOf(q[1]) === 0;
      },
      _functionEndsWith: function(q) {
        var ee = q[0], ne = q[1];
        return ee.indexOf(ne, ee.length - ne.length) !== -1;
      },
      _functionReverse: function(q) {
        var ee = this._getTypeName(q[0]);
        if (ee === u) {
          for (var ne = q[0], he = "", je = ne.length - 1; je >= 0; je--)
            he += ne[je];
          return he;
        } else {
          var _e = q[0].slice(0);
          return _e.reverse(), _e;
        }
      },
      _functionAbs: function(q) {
        return Math.abs(q[0]);
      },
      _functionCeil: function(q) {
        return Math.ceil(q[0]);
      },
      _functionAvg: function(q) {
        for (var ee = 0, ne = q[0], he = 0; he < ne.length; he++)
          ee += ne[he];
        return ee / ne.length;
      },
      _functionContains: function(q) {
        return q[0].indexOf(q[1]) >= 0;
      },
      _functionFloor: function(q) {
        return Math.floor(q[0]);
      },
      _functionLength: function(q) {
        return r(q[0]) ? Object.keys(q[0]).length : q[0].length;
      },
      _functionMap: function(q) {
        for (var ee = [], ne = this._interpreter, he = q[0], je = q[1], _e = 0; _e < je.length; _e++)
          ee.push(ne.visit(he, je[_e]));
        return ee;
      },
      _functionMerge: function(q) {
        for (var ee = {}, ne = 0; ne < q.length; ne++) {
          var he = q[ne];
          for (var je in he)
            ee[je] = he[je];
        }
        return ee;
      },
      _functionMax: function(q) {
        if (q[0].length > 0) {
          var ee = this._getTypeName(q[0][0]);
          if (ee === l)
            return Math.max.apply(Math, q[0]);
          for (var ne = q[0], he = ne[0], je = 1; je < ne.length; je++)
            he.localeCompare(ne[je]) < 0 && (he = ne[je]);
          return he;
        } else
          return null;
      },
      _functionMin: function(q) {
        if (q[0].length > 0) {
          var ee = this._getTypeName(q[0][0]);
          if (ee === l)
            return Math.min.apply(Math, q[0]);
          for (var ne = q[0], he = ne[0], je = 1; je < ne.length; je++)
            ne[je].localeCompare(he) < 0 && (he = ne[je]);
          return he;
        } else
          return null;
      },
      _functionSum: function(q) {
        for (var ee = 0, ne = q[0], he = 0; he < ne.length; he++)
          ee += ne[he];
        return ee;
      },
      _functionType: function(q) {
        switch (this._getTypeName(q[0])) {
          case l:
            return "number";
          case u:
            return "string";
          case f:
            return "array";
          case d:
            return "object";
          case h:
            return "boolean";
          case p:
            return "expref";
          case m:
            return "null";
        }
      },
      _functionKeys: function(q) {
        return Object.keys(q[0]);
      },
      _functionValues: function(q) {
        for (var ee = q[0], ne = Object.keys(ee), he = [], je = 0; je < ne.length; je++)
          he.push(ee[ne[je]]);
        return he;
      },
      _functionJoin: function(q) {
        var ee = q[0], ne = q[1];
        return ne.join(ee);
      },
      _functionToArray: function(q) {
        return this._getTypeName(q[0]) === f ? q[0] : [q[0]];
      },
      _functionToString: function(q) {
        return this._getTypeName(q[0]) === u ? q[0] : JSON.stringify(q[0]);
      },
      _functionToNumber: function(q) {
        var ee = this._getTypeName(q[0]), ne;
        return ee === l ? q[0] : ee === u && (ne = +q[0], !isNaN(ne)) ? ne : null;
      },
      _functionNotNull: function(q) {
        for (var ee = 0; ee < q.length; ee++)
          if (this._getTypeName(q[ee]) !== m)
            return q[ee];
        return null;
      },
      _functionSort: function(q) {
        var ee = q[0].slice(0);
        return ee.sort(), ee;
      },
      _functionSortBy: function(q) {
        var ee = q[0].slice(0);
        if (ee.length === 0)
          return ee;
        var ne = this._interpreter, he = q[1], je = this._getTypeName(
          ne.visit(he, ee[0])
        );
        if ([l, u].indexOf(je) < 0)
          throw new Error("TypeError");
        for (var _e = this, yt = [], Xe = 0; Xe < ee.length; Xe++)
          yt.push([Xe, ee[Xe]]);
        yt.sort(function(on, Jt) {
          var Ge = ne.visit(he, on[1]), xn = ne.visit(he, Jt[1]);
          if (_e._getTypeName(Ge) !== je)
            throw new Error(
              "TypeError: expected " + je + ", received " + _e._getTypeName(Ge)
            );
          if (_e._getTypeName(xn) !== je)
            throw new Error(
              "TypeError: expected " + je + ", received " + _e._getTypeName(xn)
            );
          return Ge > xn ? 1 : Ge < xn ? -1 : on[0] - Jt[0];
        });
        for (var Zt = 0; Zt < yt.length; Zt++)
          ee[Zt] = yt[Zt][1];
        return ee;
      },
      _functionMaxBy: function(q) {
        for (var ee = q[1], ne = q[0], he = this.createKeyFunction(ee, [l, u]), je = -1 / 0, _e, yt, Xe = 0; Xe < ne.length; Xe++)
          yt = he(ne[Xe]), yt > je && (je = yt, _e = ne[Xe]);
        return _e;
      },
      _functionMinBy: function(q) {
        for (var ee = q[1], ne = q[0], he = this.createKeyFunction(ee, [l, u]), je = 1 / 0, _e, yt, Xe = 0; Xe < ne.length; Xe++)
          yt = he(ne[Xe]), yt < je && (je = yt, _e = ne[Xe]);
        return _e;
      },
      createKeyFunction: function(q, ee) {
        var ne = this, he = this._interpreter, je = function(_e) {
          var yt = he.visit(q, _e);
          if (ee.indexOf(ne._getTypeName(yt)) < 0) {
            var Xe = "TypeError: expected one of " + ee + ", received " + ne._getTypeName(yt);
            throw new Error(Xe);
          }
          return yt;
        };
        return je;
      }
    };
    function Ue(q) {
      var ee = new rn(), ne = ee.parse(q);
      return ne;
    }
    function kn(q) {
      var ee = new de();
      return ee.tokenize(q);
    }
    function fn(q, ee) {
      var ne = new rn(), he = new Xt(), je = new Dt(he);
      he._interpreter = je;
      var _e = ne.parse(ee);
      return je.search(_e, q);
    }
    e.tokenize = kn, e.compile = Ue, e.search = fn, e.strictDeepEqual = i;
  })(t);
})(hQ);
var pQ = ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"], mQ = ["mainAxis", "crossAxis", "limiter"];
function b6(t, e) {
  if (t == null)
    return {};
  var n, r, i = function(s, a) {
    if (s == null)
      return {};
    var l, c, u = {}, f = Object.keys(s);
    for (c = 0; c < f.length; c++)
      l = f[c], a.indexOf(l) >= 0 || (u[l] = s[l]);
    return u;
  }(t, e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (r = 0; r < o.length; r++)
      n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (i[n] = t[n]);
  }
  return i;
}
function qr(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = zp(t)) || e && t && typeof t.length == "number") {
      n && (t = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
      }, e: function(l) {
        throw l;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, s = !0, a = !1;
  return { s: function() {
    n = n.call(t);
  }, n: function() {
    var l = n.next();
    return s = l.done, l;
  }, e: function(l) {
    a = !0, o = l;
  }, f: function() {
    try {
      s || n.return == null || n.return();
    } finally {
      if (a)
        throw o;
    }
  } };
}
function Ie() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  Ie = function() {
    return e;
  };
  var t, e = {}, n = Object.prototype, r = n.hasOwnProperty, i = Object.defineProperty || function(Z, L, R) {
    Z[L] = R.value;
  }, o = typeof Symbol == "function" ? Symbol : {}, s = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", l = o.toStringTag || "@@toStringTag";
  function c(Z, L, R) {
    return Object.defineProperty(Z, L, { value: R, enumerable: !0, configurable: !0, writable: !0 }), Z[L];
  }
  try {
    c({}, "");
  } catch {
    c = function(L, R, V) {
      return L[R] = V;
    };
  }
  function u(Z, L, R, V) {
    var M = L && L.prototype instanceof v ? L : v, C = Object.create(M.prototype), F = new D(V || []);
    return i(C, "_invoke", { value: O(Z, R, F) }), C;
  }
  function f(Z, L, R) {
    try {
      return { type: "normal", arg: Z.call(L, R) };
    } catch (V) {
      return { type: "throw", arg: V };
    }
  }
  e.wrap = u;
  var d = "suspendedStart", h = "suspendedYield", p = "executing", m = "completed", g = {};
  function v() {
  }
  function y() {
  }
  function w() {
  }
  var x = {};
  c(x, s, function() {
    return this;
  });
  var b = Object.getPrototypeOf, j = b && b(b(Q([])));
  j && j !== n && r.call(j, s) && (x = j);
  var $ = w.prototype = v.prototype = Object.create(x);
  function N(Z) {
    ["next", "throw", "return"].forEach(function(L) {
      c(Z, L, function(R) {
        return this._invoke(L, R);
      });
    });
  }
  function B(Z, L) {
    function R(M, C, F, z) {
      var E = f(Z[M], Z, C);
      if (E.type !== "throw") {
        var A = E.arg, te = A.value;
        return te && hr(te) == "object" && r.call(te, "__await") ? L.resolve(te.__await).then(function(ge) {
          R("next", ge, F, z);
        }, function(ge) {
          R("throw", ge, F, z);
        }) : L.resolve(te).then(function(ge) {
          A.value = ge, F(A);
        }, function(ge) {
          return R("throw", ge, F, z);
        });
      }
      z(E.arg);
    }
    var V;
    i(this, "_invoke", { value: function(M, C) {
      function F() {
        return new L(function(z, E) {
          R(M, C, z, E);
        });
      }
      return V = V ? V.then(F, F) : F();
    } });
  }
  function O(Z, L, R) {
    var V = d;
    return function(M, C) {
      if (V === p)
        throw new Error("Generator is already running");
      if (V === m) {
        if (M === "throw")
          throw C;
        return { value: t, done: !0 };
      }
      for (R.method = M, R.arg = C; ; ) {
        var F = R.delegate;
        if (F) {
          var z = I(F, R);
          if (z) {
            if (z === g)
              continue;
            return z;
          }
        }
        if (R.method === "next")
          R.sent = R._sent = R.arg;
        else if (R.method === "throw") {
          if (V === d)
            throw V = m, R.arg;
          R.dispatchException(R.arg);
        } else
          R.method === "return" && R.abrupt("return", R.arg);
        V = p;
        var E = f(Z, L, R);
        if (E.type === "normal") {
          if (V = R.done ? m : h, E.arg === g)
            continue;
          return { value: E.arg, done: R.done };
        }
        E.type === "throw" && (V = m, R.method = "throw", R.arg = E.arg);
      }
    };
  }
  function I(Z, L) {
    var R = L.method, V = Z.iterator[R];
    if (V === t)
      return L.delegate = null, R === "throw" && Z.iterator.return && (L.method = "return", L.arg = t, I(Z, L), L.method === "throw") || R !== "return" && (L.method = "throw", L.arg = new TypeError("The iterator does not provide a '" + R + "' method")), g;
    var M = f(V, Z.iterator, L.arg);
    if (M.type === "throw")
      return L.method = "throw", L.arg = M.arg, L.delegate = null, g;
    var C = M.arg;
    return C ? C.done ? (L[Z.resultName] = C.value, L.next = Z.nextLoc, L.method !== "return" && (L.method = "next", L.arg = t), L.delegate = null, g) : C : (L.method = "throw", L.arg = new TypeError("iterator result is not an object"), L.delegate = null, g);
  }
  function P(Z) {
    var L = { tryLoc: Z[0] };
    1 in Z && (L.catchLoc = Z[1]), 2 in Z && (L.finallyLoc = Z[2], L.afterLoc = Z[3]), this.tryEntries.push(L);
  }
  function J(Z) {
    var L = Z.completion || {};
    L.type = "normal", delete L.arg, Z.completion = L;
  }
  function D(Z) {
    this.tryEntries = [{ tryLoc: "root" }], Z.forEach(P, this), this.reset(!0);
  }
  function Q(Z) {
    if (Z || Z === "") {
      var L = Z[s];
      if (L)
        return L.call(Z);
      if (typeof Z.next == "function")
        return Z;
      if (!isNaN(Z.length)) {
        var R = -1, V = function M() {
          for (; ++R < Z.length; )
            if (r.call(Z, R))
              return M.value = Z[R], M.done = !1, M;
          return M.value = t, M.done = !0, M;
        };
        return V.next = V;
      }
    }
    throw new TypeError(hr(Z) + " is not iterable");
  }
  return y.prototype = w, i($, "constructor", { value: w, configurable: !0 }), i(w, "constructor", { value: y, configurable: !0 }), y.displayName = c(w, l, "GeneratorFunction"), e.isGeneratorFunction = function(Z) {
    var L = typeof Z == "function" && Z.constructor;
    return !!L && (L === y || (L.displayName || L.name) === "GeneratorFunction");
  }, e.mark = function(Z) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(Z, w) : (Z.__proto__ = w, c(Z, l, "GeneratorFunction")), Z.prototype = Object.create($), Z;
  }, e.awrap = function(Z) {
    return { __await: Z };
  }, N(B.prototype), c(B.prototype, a, function() {
    return this;
  }), e.AsyncIterator = B, e.async = function(Z, L, R, V, M) {
    M === void 0 && (M = Promise);
    var C = new B(u(Z, L, R, V), M);
    return e.isGeneratorFunction(L) ? C : C.next().then(function(F) {
      return F.done ? F.value : C.next();
    });
  }, N($), c($, l, "Generator"), c($, s, function() {
    return this;
  }), c($, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(Z) {
    var L = Object(Z), R = [];
    for (var V in L)
      R.push(V);
    return R.reverse(), function M() {
      for (; R.length; ) {
        var C = R.pop();
        if (C in L)
          return M.value = C, M.done = !1, M;
      }
      return M.done = !0, M;
    };
  }, e.values = Q, D.prototype = { constructor: D, reset: function(Z) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(J), !Z)
      for (var L in this)
        L.charAt(0) === "t" && r.call(this, L) && !isNaN(+L.slice(1)) && (this[L] = t);
  }, stop: function() {
    this.done = !0;
    var Z = this.tryEntries[0].completion;
    if (Z.type === "throw")
      throw Z.arg;
    return this.rval;
  }, dispatchException: function(Z) {
    if (this.done)
      throw Z;
    var L = this;
    function R(E, A) {
      return C.type = "throw", C.arg = Z, L.next = E, A && (L.method = "next", L.arg = t), !!A;
    }
    for (var V = this.tryEntries.length - 1; V >= 0; --V) {
      var M = this.tryEntries[V], C = M.completion;
      if (M.tryLoc === "root")
        return R("end");
      if (M.tryLoc <= this.prev) {
        var F = r.call(M, "catchLoc"), z = r.call(M, "finallyLoc");
        if (F && z) {
          if (this.prev < M.catchLoc)
            return R(M.catchLoc, !0);
          if (this.prev < M.finallyLoc)
            return R(M.finallyLoc);
        } else if (F) {
          if (this.prev < M.catchLoc)
            return R(M.catchLoc, !0);
        } else {
          if (!z)
            throw new Error("try statement without catch or finally");
          if (this.prev < M.finallyLoc)
            return R(M.finallyLoc);
        }
      }
    }
  }, abrupt: function(Z, L) {
    for (var R = this.tryEntries.length - 1; R >= 0; --R) {
      var V = this.tryEntries[R];
      if (V.tryLoc <= this.prev && r.call(V, "finallyLoc") && this.prev < V.finallyLoc) {
        var M = V;
        break;
      }
    }
    M && (Z === "break" || Z === "continue") && M.tryLoc <= L && L <= M.finallyLoc && (M = null);
    var C = M ? M.completion : {};
    return C.type = Z, C.arg = L, M ? (this.method = "next", this.next = M.finallyLoc, g) : this.complete(C);
  }, complete: function(Z, L) {
    if (Z.type === "throw")
      throw Z.arg;
    return Z.type === "break" || Z.type === "continue" ? this.next = Z.arg : Z.type === "return" ? (this.rval = this.arg = Z.arg, this.method = "return", this.next = "end") : Z.type === "normal" && L && (this.next = L), g;
  }, finish: function(Z) {
    for (var L = this.tryEntries.length - 1; L >= 0; --L) {
      var R = this.tryEntries[L];
      if (R.finallyLoc === Z)
        return this.complete(R.completion, R.afterLoc), J(R), g;
    }
  }, catch: function(Z) {
    for (var L = this.tryEntries.length - 1; L >= 0; --L) {
      var R = this.tryEntries[L];
      if (R.tryLoc === Z) {
        var V = R.completion;
        if (V.type === "throw") {
          var M = V.arg;
          J(R);
        }
        return M;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(Z, L, R) {
    return this.delegate = { iterator: Q(Z), resultName: L, nextLoc: R }, this.method === "next" && (this.arg = t), g;
  } }, e;
}
function fw(t, e, n, r, i, o, s) {
  try {
    var a = t[o](s), l = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(l) : Promise.resolve(l).then(r, i);
}
function Tt(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(r, i) {
      var o = t.apply(e, n);
      function s(l) {
        fw(o, r, i, s, a, "next", l);
      }
      function a(l) {
        fw(o, r, i, s, a, "throw", l);
      }
      s(void 0);
    });
  };
}
function Et(t, e) {
  return w6(t) || function(n, r) {
    var i = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (i != null) {
      var o, s, a, l, c = [], u = !0, f = !1;
      try {
        if (a = (i = i.call(n)).next, r === 0) {
          if (Object(i) !== i)
            return;
          u = !1;
        } else
          for (; !(u = (o = a.call(i)).done) && (c.push(o.value), c.length !== r); u = !0)
            ;
      } catch (d) {
        f = !0, s = d;
      } finally {
        try {
          if (!u && i.return != null && (l = i.return(), Object(l) !== l))
            return;
        } finally {
          if (f)
            throw s;
        }
      }
      return c;
    }
  }(t, e) || zp(t, e) || x6();
}
function x6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function w6(t) {
  if (Array.isArray(t))
    return t;
}
function lt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Mv(t, e);
}
function Mv(t, e) {
  return Mv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Mv(t, e);
}
function ct(t) {
  var e = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var n, r = Dh(t);
    if (e) {
      var i = Dh(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else
      n = r.apply(this, arguments);
    return function(o, s) {
      if (s && (hr(s) === "object" || typeof s == "function"))
        return s;
      if (s !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return ft(o);
    }(this, n);
  };
}
function ft(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Dh(t) {
  return Dh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Dh(t);
}
function dw(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? dw(Object(n), !0).forEach(function(r) {
      Si(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : dw(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Qe(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function hw(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, j6(r.key), r);
  }
}
function Ye(t, e, n) {
  return e && hw(t.prototype, e), n && hw(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Si(t, e, n) {
  return (e = j6(e)) in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function j6(t) {
  var e = function(n, r) {
    if (hr(n) !== "object" || n === null)
      return n;
    var i = n[Symbol.toPrimitive];
    if (i !== void 0) {
      var o = i.call(n, r || "default");
      if (hr(o) !== "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(t, "string");
  return hr(e) === "symbol" ? e : String(e);
}
function Ft(t) {
  return function(e) {
    if (Array.isArray(e))
      return _v(e);
  }(t) || k6(t) || zp(t) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function zp(t, e) {
  if (t) {
    if (typeof t == "string")
      return _v(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _v(t, e) : void 0;
  }
}
function k6(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function _v(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function hr(t) {
  return hr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, hr(t);
}
function Pe() {
}
var $6 = function(t) {
  return t;
};
function di(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}
function S6(t) {
  return t();
}
function pw() {
  return /* @__PURE__ */ Object.create(null);
}
function An(t) {
  t.forEach(S6);
}
function Ar(t) {
  return typeof t == "function";
}
function wr(t, e) {
  return t != t ? e == e : t !== e || t && hr(t) === "object" || typeof t == "function";
}
function Pt(t, e) {
  return t != t ? e == e : t !== e;
}
function ir(t, e, n, r) {
  if (t) {
    var i = C6(t, e, n, r);
    return t[0](i);
  }
}
function C6(t, e, n, r) {
  return t[1] && r ? di(n.ctx.slice(), t[1](r(e))) : n.ctx;
}
function or(t, e, n, r) {
  if (t[2] && r) {
    var i = t[2](r(n));
    if (e.dirty === void 0)
      return i;
    if (hr(i) === "object") {
      for (var o = [], s = Math.max(e.dirty.length, i.length), a = 0; a < s; a += 1)
        o[a] = e.dirty[a] | i[a];
      return o;
    }
    return e.dirty | i;
  }
  return e.dirty;
}
function sr(t, e, n, r, i, o) {
  if (i) {
    var s = C6(e, n, r, o);
    t.p(s, i);
  }
}
function ar(t) {
  if (t.ctx.length > 32) {
    for (var e = [], n = t.ctx.length / 32, r = 0; r < n; r++)
      e[r] = -1;
    return e;
  }
  return -1;
}
function O6(t) {
  var e = {};
  for (var n in t)
    n[0] !== "$" && (e[n] = t[n]);
  return e;
}
function Lh(t, e) {
  var n = {};
  for (var r in e = new Set(e), t)
    e.has(r) || r[0] === "$" || (n[r] = t[r]);
  return n;
}
function Un(t) {
  return t ?? "";
}
function Mr(t) {
  return t && Ar(t.destroy) ? t.destroy : Pe;
}
var E6 = typeof window < "u", gQ = E6 ? function() {
  return window.performance.now();
} : function() {
  return Date.now();
}, iy = E6 ? function(t) {
  return requestAnimationFrame(t);
} : Pe, cu = /* @__PURE__ */ new Set();
function A6(t) {
  cu.forEach(function(e) {
    e.c(t) || (cu.delete(e), e.f());
  }), cu.size !== 0 && iy(A6);
}
var oy = typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : global;
function T(t, e) {
  t.appendChild(e);
}
function At(t, e, n) {
  var r = sy(t);
  if (!r.getElementById(e)) {
    var i = H("style");
    i.id = e, i.textContent = n, M6(r, i);
  }
}
function sy(t) {
  if (!t)
    return document;
  var e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
  return e && e.host ? e : t.ownerDocument;
}
function vQ(t) {
  var e = H("style");
  return e.textContent = "/* empty */", M6(sy(t), e), e.sheet;
}
function M6(t, e) {
  return T(t.head || t, e), e.sheet;
}
function X(t, e, n) {
  t.insertBefore(e, n || null);
}
function Y(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function fr(t, e) {
  for (var n = 0; n < t.length; n += 1)
    t[n] && t[n].d(e);
}
function H(t) {
  return document.createElement(t);
}
function Ho(t) {
  return document.createElementNS("http://www.w3.org/2000/svg", t);
}
function Le(t) {
  return document.createTextNode(t);
}
function se() {
  return Le(" ");
}
function un() {
  return Le("");
}
function Oe(t, e, n, r) {
  return t.addEventListener(e, n, r), function() {
    return t.removeEventListener(e, n, r);
  };
}
function Wa(t) {
  return function(e) {
    return e.preventDefault(), t.call(this, e);
  };
}
function po(t) {
  return function(e) {
    return e.stopPropagation(), t.call(this, e);
  };
}
function k(t, e, n) {
  n == null ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n);
}
var yQ = ["width", "height"];
function mw(t, e) {
  var n = Object.getOwnPropertyDescriptors(t.__proto__);
  for (var r in e)
    e[r] == null ? t.removeAttribute(r) : r === "style" ? t.style.cssText = e[r] : r === "__value" ? t.value = t[r] = e[r] : n[r] && n[r].set && yQ.indexOf(r) === -1 ? t[r] = e[r] : k(t, r, e[r]);
}
function rc(t, e) {
  for (var n in e)
    k(t, n, e[n]);
}
function bt(t, e) {
  e = "" + e, t.data !== e && (t.data = e);
}
function Uo(t, e) {
  t.value = e ?? "";
}
function Qr(t, e, n, r) {
  n == null ? t.style.removeProperty(e) : t.style.setProperty(e, n, r ? "important" : "");
}
function gw(t, e, n) {
  for (var r = 0; r < t.options.length; r += 1) {
    var i = t.options[r];
    if (i.__value === e)
      return void (i.selected = !0);
  }
  n && e === void 0 || (t.selectedIndex = -1);
}
function $e(t, e, n) {
  t.classList.toggle(e, !!n);
}
function _6(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.bubbles, i = r !== void 0 && r, o = n.cancelable;
  return new CustomEvent(t, { detail: e, bubbles: i, cancelable: o !== void 0 && o });
}
function Wo(t, e) {
  return new t(e);
}
var Fu, Bh = /* @__PURE__ */ new Map(), Tv = 0;
function vw(t, e, n, r, i, o, s) {
  for (var a = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 0, l = 16.666 / r, c = `{
`, u = 0; u <= 1; u += l) {
    var f = e + (n - e) * o(u);
    c += 100 * u + "%{".concat(s(f, 1 - f), `}
`);
  }
  var d = c + "100% {".concat(s(n, 1 - n), `}
}`), h = "__svelte_".concat(function(w) {
    for (var x = 5381, b = w.length; b--; )
      x = (x << 5) - x ^ w.charCodeAt(b);
    return x >>> 0;
  }(d), "_").concat(a), p = sy(t), m = Bh.get(p) || function(w, x) {
    var b = { stylesheet: vQ(x), rules: {} };
    return Bh.set(w, b), b;
  }(p, t), g = m.stylesheet, v = m.rules;
  v[h] || (v[h] = !0, g.insertRule("@keyframes ".concat(h, " ").concat(d), g.cssRules.length));
  var y = t.style.animation || "";
  return t.style.animation = "".concat(y ? "".concat(y, ", ") : "").concat(h, " ").concat(r, "ms linear ").concat(i, "ms 1 both"), Tv += 1, h;
}
function bQ(t, e) {
  var n = (t.style.animation || "").split(", "), r = n.filter(e ? function(o) {
    return o.indexOf(e) < 0;
  } : function(o) {
    return o.indexOf("__svelte") === -1;
  }), i = n.length - r.length;
  i && (t.style.animation = r.join(", "), (Tv -= i) || iy(function() {
    Tv || (Bh.forEach(function(o) {
      var s = o.stylesheet.ownerNode;
      s && Y(s);
    }), Bh.clear());
  }));
}
function uu(t) {
  Fu = t;
}
function jc() {
  if (!Fu)
    throw new Error("Function called outside component initialization");
  return Fu;
}
function Fi(t) {
  jc().$$.on_mount.push(t);
}
function Ci(t) {
  jc().$$.on_destroy.push(t);
}
function T6() {
  var t = jc();
  return function(e, n) {
    var r = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).cancelable, i = r !== void 0 && r, o = t.$$.callbacks[e];
    if (o) {
      var s = _6(e, n, { cancelable: i });
      return o.slice().forEach(function(a) {
        a.call(t, s);
      }), !s.defaultPrevented;
    }
    return !0;
  };
}
function P6(t, e) {
  return jc().$$.context.set(t, e), e;
}
function _r(t) {
  return jc().$$.context.get(t);
}
function ud(t, e) {
  var n = this, r = t.$$.callbacks[e.type];
  r && r.slice().forEach(function(i) {
    return i.call(n, e);
  });
}
var xl = [], Kt = [], zl = [], Pv = [], R6 = Promise.resolve(), Rv = !1;
function N6() {
  Rv || (Rv = !0, R6.then(I6));
}
function lr() {
  return N6(), R6;
}
function Ja(t) {
  zl.push(t);
}
function to(t) {
  Pv.push(t);
}
var fd, Hm = /* @__PURE__ */ new Set(), hl = 0;
function I6() {
  if (hl === 0) {
    var t = Fu;
    do {
      try {
        for (; hl < xl.length; ) {
          var e = xl[hl];
          hl++, uu(e), xQ(e.$$);
        }
      } catch (i) {
        throw xl.length = 0, hl = 0, i;
      }
      for (uu(null), xl.length = 0, hl = 0; Kt.length; )
        Kt.pop()();
      for (var n = 0; n < zl.length; n += 1) {
        var r = zl[n];
        Hm.has(r) || (Hm.add(r), r());
      }
      zl.length = 0;
    } while (xl.length);
    for (; Pv.length; )
      Pv.pop()();
    Rv = !1, Hm.clear(), uu(t);
  }
}
function xQ(t) {
  if (t.fragment !== null) {
    t.update(), An(t.before_update);
    var e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(Ja);
  }
}
function Um(t, e, n) {
  t.dispatchEvent(_6("".concat(e ? "intro" : "outro").concat(n)));
}
var ns, Hd = /* @__PURE__ */ new Set();
function Ae() {
  ns = { r: 0, c: [], p: ns };
}
function Me() {
  ns.r || An(ns.c), ns = ns.p;
}
function S(t, e) {
  t && t.i && (Hd.delete(t), t.i(e));
}
function _(t, e, n, r) {
  if (t && t.o) {
    if (Hd.has(t))
      return;
    Hd.add(t), ns.c.push(function() {
      Hd.delete(t), r && (n && t.d(1), r());
    }), t.o(e);
  } else
    r && r();
}
var wQ = { duration: 0 };
function dd(t, e, n, r) {
  var i, o = e(t, n, { direction: "both" }), s = r ? 0 : 1, a = null, l = null, c = null;
  function u() {
    c && bQ(t, c);
  }
  function f(h, p) {
    var m = h.b - s;
    return p *= Math.abs(m), { a: s, b: h.b, d: m, duration: p, start: h.start, end: h.start + p, group: h.group };
  }
  function d(h) {
    var p, m = o || wQ, g = m.delay, v = g === void 0 ? 0 : g, y = m.duration, w = y === void 0 ? 300 : y, x = m.easing, b = x === void 0 ? $6 : x, j = m.tick, $ = j === void 0 ? Pe : j, N = m.css, B = { start: gQ() + v, b: h };
    h || (B.group = ns, ns.r += 1), "inert" in t && (h ? i !== void 0 && (t.inert = i) : (i = t.inert, t.inert = !0)), a || l ? l = B : (N && (u(), c = vw(t, s, h, w, v, b, N)), h && $(0, 1), a = f(B, w), Ja(function() {
      return Um(t, h, "start");
    }), p = function(O) {
      if (l && O > l.start && (a = f(l, w), l = null, Um(t, a.b, "start"), N && (u(), c = vw(t, s, a.b, a.duration, 0, b, o.css))), a) {
        if (O >= a.end)
          $(s = a.b, 1 - s), Um(t, a.b, "end"), l || (a.b ? u() : --a.group.r || An(a.group.c)), a = null;
        else if (O >= a.start) {
          var I = O - a.start;
          s = a.a + a.d * b(I / a.duration), $(s, 1 - s);
        }
      }
      return !(!a && !l);
    }, cu.size === 0 && iy(A6), new Promise(function(O) {
      cu.add({ c: p, f: O });
    }));
  }
  return { run: function(h) {
    Ar(o) ? (fd || (fd = Promise.resolve()).then(function() {
      fd = null;
    }), fd).then(function() {
      o = o({ direction: h ? "in" : "out" }), d(h);
    }) : d(h);
  }, end: function() {
    u(), a = l = null;
  } };
}
function Ot(t) {
  return (t == null ? void 0 : t.length) !== void 0 ? t : Array.from(t);
}
function jQ(t, e) {
  t.d(1), e.delete(t.key);
}
function ay(t, e) {
  _(t, 1, 1, function() {
    e.delete(t.key);
  });
}
function Fp(t, e, n, r, i, o, s, a, l, c, u, f) {
  for (var d = t.length, h = o.length, p = d, m = {}; p--; )
    m[t[p].key] = p;
  var g = [], v = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), w = [];
  p = h;
  for (var x = function() {
    var J = f(i, o, p), D = n(J), Q = s.get(D);
    Q ? r && w.push(function() {
      return Q.p(J, e);
    }) : (Q = c(D, J)).c(), v.set(D, g[p] = Q), D in m && y.set(D, Math.abs(p - m[D]));
  }; p--; )
    x();
  var b = /* @__PURE__ */ new Set(), j = /* @__PURE__ */ new Set();
  function $(J) {
    S(J, 1), J.m(a, u), s.set(J.key, J), u = J.first, h--;
  }
  for (; d && h; ) {
    var N = g[h - 1], B = t[d - 1], O = N.key, I = B.key;
    N === B ? (u = N.first, d--, h--) : v.has(I) ? !s.has(O) || b.has(O) ? $(N) : j.has(I) ? d-- : y.get(O) > y.get(I) ? (j.add(O), $(N)) : (b.add(I), d--) : (l(B, s), d--);
  }
  for (; d--; ) {
    var P = t[d];
    v.has(P.key) || l(P, s);
  }
  for (; h; )
    $(g[h - 1]);
  return An(w), g;
}
function Vi(t, e) {
  for (var n = {}, r = {}, i = { $$scope: 1 }, o = t.length; o--; ) {
    var s = t[o], a = e[o];
    if (a) {
      for (var l in s)
        l in a || (r[l] = 1);
      for (var c in a)
        i[c] || (n[c] = a[c], i[c] = 1);
      t[o] = a;
    } else
      for (var u in s)
        i[u] = 1;
  }
  for (var f in r)
    f in n || (n[f] = void 0);
  return n;
}
function Ka(t) {
  return hr(t) === "object" && t !== null ? t : {};
}
function no(t, e, n) {
  var r = t.$$.props[e];
  r !== void 0 && (t.$$.bound[r] = n, n(t.$$.ctx[r]));
}
function xe(t) {
  t && t.c();
}
function ye(t, e, n) {
  var r = t.$$, i = r.fragment, o = r.after_update;
  i && i.m(e, n), Ja(function() {
    var s, a = t.$$.on_mount.map(S6).filter(Ar);
    t.$$.on_destroy ? (s = t.$$.on_destroy).push.apply(s, Ft(a)) : An(a), t.$$.on_mount = [];
  }), o.forEach(Ja);
}
function be(t, e) {
  var n, r, i, o = t.$$;
  o.fragment !== null && (n = o.after_update, r = [], i = [], zl.forEach(function(s) {
    return n.indexOf(s) === -1 ? r.push(s) : i.push(s);
  }), i.forEach(function(s) {
    return s();
  }), zl = r, An(o.on_destroy), o.fragment && o.fragment.d(e), o.on_destroy = o.fragment = null, o.ctx = []);
}
function dt(t, e, n, r, i, o) {
  var s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, a = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [-1], l = Fu;
  uu(t);
  var c = t.$$ = { fragment: null, ctx: [], props: o, update: Pe, not_equal: i, bound: pw(), on_mount: [], on_destroy: [], on_disconnect: [], before_update: [], after_update: [], context: new Map(e.context || (l ? l.$$.context : [])), callbacks: pw(), dirty: a, skip_bound: !1, root: e.target || l.$$.root };
  s && s(c.root);
  var u = !1;
  if (c.ctx = n ? n(t, e.props || {}, function(d, h) {
    var p = !(arguments.length <= 2) && arguments.length - 2 ? arguments.length <= 2 ? void 0 : arguments[2] : h;
    return c.ctx && i(c.ctx[d], c.ctx[d] = p) && (!c.skip_bound && c.bound[d] && c.bound[d](p), u && function(m, g) {
      m.$$.dirty[0] === -1 && (xl.push(m), N6(), m.$$.dirty.fill(0)), m.$$.dirty[g / 31 | 0] |= 1 << g % 31;
    }(t, d)), h;
  }) : [], c.update(), u = !0, An(c.before_update), c.fragment = !!r && r(c.ctx), e.target) {
    if (e.hydrate) {
      var f = function(d) {
        return Array.from(d.childNodes);
      }(e.target);
      c.fragment && c.fragment.l(f), f.forEach(Y);
    } else
      c.fragment && c.fragment.c();
    e.intro && S(t.$$.fragment), ye(t, e.target, e.anchor), I6();
  }
  uu(l);
}
var ht = function() {
  function t() {
    Qe(this, t), Si(this, "$$", void 0), Si(this, "$$set", void 0);
  }
  return Ye(t, [{ key: "$destroy", value: function() {
    be(this, 1), this.$destroy = Pe;
  } }, { key: "$on", value: function(e, n) {
    if (!Ar(n))
      return Pe;
    var r = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return r.push(n), function() {
      var i = r.indexOf(n);
      i !== -1 && r.splice(i, 1);
    };
  } }, { key: "$set", value: function(e) {
    var n;
    this.$$set && (n = e, Object.keys(n).length !== 0) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  } }]), t;
}();
function Tr(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(r) {
    var i = function(o) {
      try {
        if (typeof window < "u" && window.localStorage !== void 0)
          return window.localStorage[o];
      } catch {
      }
    }("debug");
    return i != null && i.endsWith("*") ? r.startsWith(i.slice(0, -1)) : r === i;
  }(t);
  if (!e)
    return kQ;
  var n = function(r) {
    for (var i = 0, o = 0; o < r.length; o++)
      i = (i << 5) - i + r.charCodeAt(o), i |= 0;
    return yw[Math.abs(i) % yw.length];
  }(t);
  return function() {
    for (var r, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    (r = console).log.apply(r, ["%c".concat(t), "color:".concat(n)].concat(o));
  };
}
function kQ() {
}
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add("4");
var yw = ["#0000CC", "#0099FF", "#009400", "#8dd200", "#CCCC00", "#CC9933", "#ae04e7", "#ff35d7", "#FF3333", "#FF6600", "#FF9933", "#FFCC33"];
function $Q(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.delay, r = n === void 0 ? 0 : n, i = e.duration, o = i === void 0 ? 400 : i, s = e.easing, a = s === void 0 ? $6 : s, l = +getComputedStyle(t).opacity;
  return { delay: r, duration: o, easing: a, css: function(c) {
    return "opacity: ".concat(c * l);
  } };
}
var SQ = oy.window;
function CQ(t) {
  At(t, "svelte-n7cvum", `.svelte-n7cvum{box-sizing:border-box}.bg.svelte-n7cvum{position:fixed;z-index:1000;top:0;left:0;display:flex;flex-direction:column;justify-content:center;width:100vw;height:100vh;background:rgba(0, 0, 0, 0.66)}@supports (-webkit-touch-callout: none){}.wrap.svelte-n7cvum{position:relative;margin:2rem;max-height:100%}.window.svelte-n7cvum{position:relative;width:40rem;max-width:100%;max-height:100%;margin:2rem auto;color:black;border-radius:0.5rem;background:white}.content.svelte-n7cvum{position:relative;padding:1rem;max-height:calc(100vh - 4rem);overflow:auto}.close.svelte-n7cvum{display:block;box-sizing:border-box;position:absolute;z-index:1000;top:1rem;right:1rem;margin:0;padding:0;width:1.5rem;height:1.5rem;border:0;color:black;border-radius:1.5rem;background:white;box-shadow:0 0 0 1px black;transition:transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),
      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);-webkit-appearance:none}.close.svelte-n7cvum:before,.close.svelte-n7cvum:after{content:'';display:block;box-sizing:border-box;position:absolute;top:50%;width:1rem;height:1px;background:black;transform-origin:center;transition:height 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),
      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1)}.close.svelte-n7cvum:before{-webkit-transform:translate(0, -50%) rotate(45deg);-moz-transform:translate(0, -50%) rotate(45deg);transform:translate(0, -50%) rotate(45deg);left:0.25rem}.close.svelte-n7cvum:after{-webkit-transform:translate(0, -50%) rotate(-45deg);-moz-transform:translate(0, -50%) rotate(-45deg);transform:translate(0, -50%) rotate(-45deg);left:0.25rem}.close.svelte-n7cvum:hover{background:black}.close.svelte-n7cvum:hover:before,.close.svelte-n7cvum:hover:after{height:2px;background:white}.close.svelte-n7cvum:focus{border-color:#3399ff;box-shadow:0 0 0 2px #3399ff}.close.svelte-n7cvum:active{transform:scale(0.9)}.close.svelte-n7cvum:hover,.close.svelte-n7cvum:focus,.close.svelte-n7cvum:active{outline:none}`);
}
function bw(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w = t[1].closeButton && xw(t), x = t[2];
  return x && (s = Wo(x, {})), { c: function() {
    e = H("div"), n = H("div"), r = H("div"), w && w.c(), i = se(), o = H("div"), s && xe(s.$$.fragment), k(o, "class", a = Un(t[1].classContent) + " svelte-n7cvum"), k(o, "style", t[9]), $e(o, "content", !t[0]), k(r, "class", l = Un(t[1].classWindow) + " svelte-n7cvum"), k(r, "role", "dialog"), k(r, "aria-modal", "true"), k(r, "aria-label", c = t[1].ariaLabelledBy ? null : t[1].ariaLabel || null), k(r, "aria-labelledby", u = t[1].ariaLabelledBy || null), k(r, "style", t[8]), $e(r, "window", !t[0]), k(n, "class", d = Un(t[1].classWindowWrap) + " svelte-n7cvum"), k(n, "style", t[7]), $e(n, "wrap", !t[0]), k(e, "aria-hidden", "true"), k(e, "id", h = t[1].id), k(e, "class", p = Un(t[1].classBg) + " svelte-n7cvum"), k(e, "style", t[6]), $e(e, "bg", !t[0]);
  }, m: function(b, j) {
    X(b, e, j), T(e, n), T(n, r), w && w.m(r, null), T(r, i), T(r, o), s && ye(s, o, null), t[50](r), t[51](n), t[52](e), g = !0, v || (y = [Oe(r, "introstart", function() {
      Ar(t[13]) && t[13].apply(this, arguments);
    }), Oe(r, "outrostart", function() {
      Ar(t[14]) && t[14].apply(this, arguments);
    }), Oe(r, "introend", function() {
      Ar(t[15]) && t[15].apply(this, arguments);
    }), Oe(r, "outroend", function() {
      Ar(t[16]) && t[16].apply(this, arguments);
    }), Oe(e, "mousedown", t[20]), Oe(e, "mouseup", t[21])], v = !0);
  }, p: function(b, j) {
    if ((t = b)[1].closeButton ? w ? (w.p(t, j), 2 & j[0] && S(w, 1)) : ((w = xw(t)).c(), S(w, 1), w.m(r, i)) : w && (Ae(), _(w, 1, 1, function() {
      w = null;
    }), Me()), 4 & j[0] && x !== (x = t[2])) {
      if (s) {
        Ae();
        var $ = s;
        _($.$$.fragment, 1, 0, function() {
          be($, 1);
        }), Me();
      }
      x ? (xe((s = Wo(x, {})).$$.fragment), S(s.$$.fragment, 1), ye(s, o, null)) : s = null;
    }
    (!g || 2 & j[0] && a !== (a = Un(t[1].classContent) + " svelte-n7cvum")) && k(o, "class", a), (!g || 512 & j[0]) && k(o, "style", t[9]), (!g || 3 & j[0]) && $e(o, "content", !t[0]), (!g || 2 & j[0] && l !== (l = Un(t[1].classWindow) + " svelte-n7cvum")) && k(r, "class", l), (!g || 2 & j[0] && c !== (c = t[1].ariaLabelledBy ? null : t[1].ariaLabel || null)) && k(r, "aria-label", c), (!g || 2 & j[0] && u !== (u = t[1].ariaLabelledBy || null)) && k(r, "aria-labelledby", u), (!g || 256 & j[0]) && k(r, "style", t[8]), (!g || 3 & j[0]) && $e(r, "window", !t[0]), (!g || 2 & j[0] && d !== (d = Un(t[1].classWindowWrap) + " svelte-n7cvum")) && k(n, "class", d), (!g || 128 & j[0]) && k(n, "style", t[7]), (!g || 3 & j[0]) && $e(n, "wrap", !t[0]), (!g || 2 & j[0] && h !== (h = t[1].id)) && k(e, "id", h), (!g || 2 & j[0] && p !== (p = Un(t[1].classBg) + " svelte-n7cvum")) && k(e, "class", p), (!g || 64 & j[0]) && k(e, "style", t[6]), (!g || 3 & j[0]) && $e(e, "bg", !t[0]);
  }, i: function(b) {
    g || (S(w), s && S(s.$$.fragment, b), b && Ja(function() {
      g && (f || (f = dd(r, t[12], t[1].transitionWindowProps, !0)), f.run(1));
    }), b && Ja(function() {
      g && (m || (m = dd(e, t[11], t[1].transitionBgProps, !0)), m.run(1));
    }), g = !0);
  }, o: function(b) {
    _(w), s && _(s.$$.fragment, b), b && (f || (f = dd(r, t[12], t[1].transitionWindowProps, !1)), f.run(0)), b && (m || (m = dd(e, t[11], t[1].transitionBgProps, !1)), m.run(0)), g = !1;
  }, d: function(b) {
    b && Y(e), w && w.d(), s && be(s), t[50](null), b && f && f.end(), t[51](null), t[52](null), b && m && m.end(), v = !1, An(y);
  } };
}
function xw(t) {
  var e, n, r, i, o, s = [EQ, OQ], a = [];
  function l(c, u) {
    return 2 & u[0] && (e = null), e == null && (e = !!c[17](c[1].closeButton)), e ? 0 : 1;
  }
  return n = l(t, [-1, -1, -1]), r = a[n] = s[n](t), { c: function() {
    r.c(), i = un();
  }, m: function(c, u) {
    a[n].m(c, u), X(c, i, u), o = !0;
  }, p: function(c, u) {
    var f = n;
    (n = l(c, u)) === f ? a[n].p(c, u) : (Ae(), _(a[f], 1, 1, function() {
      a[f] = null;
    }), Me(), (r = a[n]) ? r.p(c, u) : (r = a[n] = s[n](c)).c(), S(r, 1), r.m(i.parentNode, i));
  }, i: function(c) {
    o || (S(r), o = !0);
  }, o: function(c) {
    _(r), o = !1;
  }, d: function(c) {
    c && Y(i), a[n].d(c);
  } };
}
function OQ(t) {
  var e, n, r, i;
  return { c: function() {
    k(e = H("button"), "class", n = Un(t[1].classCloseButton) + " svelte-n7cvum"), k(e, "aria-label", "Close modal"), k(e, "style", t[10]), k(e, "type", "button"), $e(e, "close", !t[0]);
  }, m: function(o, s) {
    X(o, e, s), r || (i = Oe(e, "click", t[18]), r = !0);
  }, p: function(o, s) {
    2 & s[0] && n !== (n = Un(o[1].classCloseButton) + " svelte-n7cvum") && k(e, "class", n), 1024 & s[0] && k(e, "style", o[10]), 3 & s[0] && $e(e, "close", !o[0]);
  }, i: Pe, o: Pe, d: function(o) {
    o && Y(e), r = !1, i();
  } };
}
function EQ(t) {
  var e, n, r, i = t[1].closeButton;
  function o(s, a) {
    return { props: { onClose: s[18] } };
  }
  return i && (e = Wo(i, o(t))), { c: function() {
    e && xe(e.$$.fragment), n = un();
  }, m: function(s, a) {
    e && ye(e, s, a), X(s, n, a), r = !0;
  }, p: function(s, a) {
    if (2 & a[0] && i !== (i = s[1].closeButton)) {
      if (e) {
        Ae();
        var l = e;
        _(l.$$.fragment, 1, 0, function() {
          be(l, 1);
        }), Me();
      }
      i ? (xe((e = Wo(i, o(s))).$$.fragment), S(e.$$.fragment, 1), ye(e, n.parentNode, n)) : e = null;
    }
  }, i: function(s) {
    r || (e && S(e.$$.fragment, s), r = !0);
  }, o: function(s) {
    e && _(e.$$.fragment, s), r = !1;
  }, d: function(s) {
    s && Y(n), e && be(e, s);
  } };
}
function AQ(t) {
  var e, n, r, i, o = t[2] && bw(t), s = t[49].default, a = ir(s, t, t[48], null);
  return { c: function() {
    o && o.c(), e = se(), a && a.c();
  }, m: function(l, c) {
    o && o.m(l, c), X(l, e, c), a && a.m(l, c), n = !0, r || (i = Oe(SQ, "keydown", t[19]), r = !0);
  }, p: function(l, c) {
    l[2] ? o ? (o.p(l, c), 4 & c[0] && S(o, 1)) : ((o = bw(l)).c(), S(o, 1), o.m(e.parentNode, e)) : o && (Ae(), _(o, 1, 1, function() {
      o = null;
    }), Me()), a && a.p && (!n || 131072 & c[1]) && sr(a, s, l, l[48], n ? or(s, l[48], c, null) : ar(l[48]), null);
  }, i: function(l) {
    n || (S(o), S(a, l), n = !0);
  }, o: function(l) {
    _(o), _(a, l), n = !1;
  }, d: function(l) {
    l && Y(e), o && o.d(l), a && a.d(l), r = !1, i();
  } };
}
function D6(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(n) {
    return new t(fe(fe({}, n), {}, { props: fe(fe({}, e), n.props) }));
  };
}
function MQ(t, e, n) {
  var r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y = e.$$slots, w = y === void 0 ? {} : y, x = e.$$scope, b = T6(), j = P6, $ = e.isTabbable, N = $ === void 0 ? function(U) {
    return U.tabIndex >= 0 && !U.hidden && !U.disabled && U.style.display !== "none" && U.type !== "hidden" && !!(U.offsetWidth || U.offsetHeight || U.getClientRects().length);
  } : $, B = e.show, O = B === void 0 ? null : B, I = e.id, P = I === void 0 ? null : I, J = e.key, D = J === void 0 ? "simple-modal" : J, Q = e.ariaLabel, Z = Q === void 0 ? null : Q, L = e.ariaLabelledBy, R = L === void 0 ? null : L, V = e.closeButton, M = V === void 0 || V, C = e.closeOnEsc, F = C === void 0 || C, z = e.closeOnOuterClick, E = z === void 0 || z, A = e.styleBg, te = A === void 0 ? {} : A, ge = e.styleWindowWrap, ke = ge === void 0 ? {} : ge, Ce = e.styleWindow, we = Ce === void 0 ? {} : Ce, le = e.styleContent, rt = le === void 0 ? {} : le, Be = e.styleCloseButton, nt = Be === void 0 ? {} : Be, oe = e.classBg, We = oe === void 0 ? null : oe, Rt = e.classWindowWrap, de = Rt === void 0 ? null : Rt, Se = e.classWindow, rn = Se === void 0 ? null : Se, Dt = e.classContent, Xt = Dt === void 0 ? null : Dt, Ue = e.classCloseButton, kn = Ue === void 0 ? null : Ue, fn = e.unstyled, q = fn !== void 0 && fn, ee = e.setContext, ne = ee === void 0 ? j : ee, he = e.transitionBg, je = he === void 0 ? $Q : he, _e = e.transitionBgProps, yt = _e === void 0 ? { duration: 250 } : _e, Xe = e.transitionWindow, Zt = Xe === void 0 ? je : Xe, on = e.transitionWindowProps, Jt = on === void 0 ? yt : on, Ge = e.disableFocusTrap, xn = Ge !== void 0 && Ge, Dn = { id: P, ariaLabel: Z, ariaLabelledBy: R, closeButton: M, closeOnEsc: F, closeOnOuterClick: E, styleBg: te, styleWindowWrap: ke, styleWindow: we, styleContent: rt, styleCloseButton: nt, classBg: We, classWindowWrap: de, classWindow: rn, classContent: Xt, classCloseButton: kn, transitionBg: je, transitionBgProps: yt, transitionWindow: Zt, transitionWindowProps: Jt, disableFocusTrap: xn, isTabbable: N, unstyled: q }, wn = fe({}, Dn), $n = null, Rn = function(U) {
    return U ? Object.keys(U).reduce(function(G, re) {
      return "".concat(G, "; ").concat(function(ae) {
        return ae.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
      }(re), ": ").concat(U[re]);
    }, "") : "";
  }, Jn = function(U) {
    return !!(U && U.constructor && U.call && U.apply);
  }, pn = function() {
  }, me = pn, Ke = pn, It = pn, Nt = pn, ce = function(U) {
    var G = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, re = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    n(2, $n = D6(U, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {})), n(1, wn = fe(fe({}, Dn), G)), n(6, a = Rn(Object.assign({}, { width: window.innerWidth, height: window.innerHeight }, wn.styleBg))), n(7, l = Rn(wn.styleWindowWrap)), n(8, c = Rn(wn.styleWindow)), n(9, u = Rn(wn.styleContent)), n(10, f = Rn(wn.styleCloseButton)), n(11, d = wn.transitionBg), n(12, h = wn.transitionWindow), Fe(), n(13, me = function(ae) {
      re.onOpen && re.onOpen(ae), b("open"), b("opening");
    }), n(14, Ke = function(ae) {
      re.onClose && re.onClose(ae), b("close"), b("closing");
    }), n(15, It = function(ae) {
      re.onOpened && re.onOpened(ae), b("opened");
    }), n(16, Nt = function(ae) {
      re.onClosed && re.onClosed(ae), b("closed");
    });
  }, qe = function() {
    var U = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    $n && (n(14, Ke = U.onClose || Ke), n(16, Nt = U.onClosed || Nt), n(2, $n = null), Lt());
  }, Fe = function() {
    s = window.scrollY, p = document.body.style.position, m = document.body.style.overflow, g = document.body.style.width, document.body.style.position = "fixed", document.body.style.top = "-".concat(s, "px"), document.body.style.overflow = "hidden", document.body.style.width = "100%";
  }, Lt = function() {
    document.body.style.position = p || "", document.body.style.top = "", document.body.style.overflow = m || "", document.body.style.width = g || "", window.scrollTo({ top: s, left: 0, behavior: "instant" });
  };
  ne(D, { open: ce, close: qe });
  var qt = !1;
  return Ci(function() {
    qt && qe();
  }), Fi(function() {
    n(47, qt = !0);
  }), t.$$set = function(U) {
    "isTabbable" in U && n(22, N = U.isTabbable), "show" in U && n(23, O = U.show), "id" in U && n(24, P = U.id), "key" in U && n(25, D = U.key), "ariaLabel" in U && n(26, Z = U.ariaLabel), "ariaLabelledBy" in U && n(27, R = U.ariaLabelledBy), "closeButton" in U && n(28, M = U.closeButton), "closeOnEsc" in U && n(29, F = U.closeOnEsc), "closeOnOuterClick" in U && n(30, E = U.closeOnOuterClick), "styleBg" in U && n(31, te = U.styleBg), "styleWindowWrap" in U && n(32, ke = U.styleWindowWrap), "styleWindow" in U && n(33, we = U.styleWindow), "styleContent" in U && n(34, rt = U.styleContent), "styleCloseButton" in U && n(35, nt = U.styleCloseButton), "classBg" in U && n(36, We = U.classBg), "classWindowWrap" in U && n(37, de = U.classWindowWrap), "classWindow" in U && n(38, rn = U.classWindow), "classContent" in U && n(39, Xt = U.classContent), "classCloseButton" in U && n(40, kn = U.classCloseButton), "unstyled" in U && n(0, q = U.unstyled), "setContext" in U && n(41, ne = U.setContext), "transitionBg" in U && n(42, je = U.transitionBg), "transitionBgProps" in U && n(43, yt = U.transitionBgProps), "transitionWindow" in U && n(44, Zt = U.transitionWindow), "transitionWindowProps" in U && n(45, Jt = U.transitionWindowProps), "disableFocusTrap" in U && n(46, xn = U.disableFocusTrap), "$$scope" in U && n(48, x = U.$$scope);
  }, t.$$.update = function() {
    8388608 & t.$$.dirty[0] | 65536 & t.$$.dirty[1] && qt && (Jn(O) ? ce(O) : qe());
  }, [q, wn, $n, r, i, o, a, l, c, u, f, d, h, me, Ke, It, Nt, Jn, qe, function(U) {
    if (wn.closeOnEsc && $n && U.key === "Escape" && (U.preventDefault(), qe()), $n && U.key === "Tab" && !wn.disableFocusTrap) {
      var G = o.querySelectorAll("*"), re = Array.from(G).filter(wn.isTabbable).sort(function(ve, pt) {
        return ve.tabIndex - pt.tabIndex;
      }), ae = re.indexOf(document.activeElement);
      ae === -1 && U.shiftKey && (ae = 0), ae += re.length + (U.shiftKey ? -1 : 1), re[ae %= re.length].focus(), U.preventDefault();
    }
  }, function(U) {
    !wn.closeOnOuterClick || U.target !== r && U.target !== i || (v = U.target);
  }, function(U) {
    wn.closeOnOuterClick && U.target === v && (U.preventDefault(), qe());
  }, N, O, P, D, Z, R, M, F, E, te, ke, we, rt, nt, We, de, rn, Xt, kn, ne, je, yt, Zt, Jt, xn, qt, x, w, function(U) {
    Kt[U ? "unshift" : "push"](function() {
      n(5, o = U);
    });
  }, function(U) {
    Kt[U ? "unshift" : "push"](function() {
      n(4, i = U);
    });
  }, function(U) {
    Kt[U ? "unshift" : "push"](function() {
      n(3, r = U);
    });
  }];
}
var Lr, On, ro, gs, lo, Di, Ks, L6 = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, MQ, AQ, wr, { isTabbable: 22, show: 23, id: 24, key: 25, ariaLabel: 26, ariaLabelledBy: 27, closeButton: 28, closeOnEsc: 29, closeOnOuterClick: 30, styleBg: 31, styleWindowWrap: 32, styleWindow: 33, styleContent: 34, styleCloseButton: 35, classBg: 36, classWindowWrap: 37, classWindow: 38, classContent: 39, classCloseButton: 40, unstyled: 0, setContext: 41, transitionBg: 42, transitionBgProps: 43, transitionWindow: 44, transitionWindowProps: 45, disableFocusTrap: 46 }, CQ, [-1, -1, -1]), i;
  }
  return Ye(n);
}();
(function(t) {
  t.text = "text", t.tree = "tree", t.table = "table";
})(Lr || (Lr = {})), function(t) {
  t.after = "after", t.inside = "inside", t.key = "key", t.value = "value", t.multi = "multi", t.text = "text";
}(On || (On = {})), function(t) {
  t.after = "after", t.key = "key", t.value = "value", t.inside = "inside";
}(ro || (ro = {})), function(t) {
  t.info = "info", t.warning = "warning", t.error = "error";
}(gs || (gs = {})), function(t) {
  t.key = "key", t.value = "value";
}(lo || (lo = {})), function(t) {
  t.asc = "asc", t.desc = "desc";
}(Di || (Di = {})), function(t) {
  t.no = "no", t.self = "self", t.nextInside = "nextInside";
}(Ks || (Ks = {}));
var ww = 50, _Q = 200, TQ = 400, PQ = 1200, B6 = 1e3, Vu = 100, Ol = 100, Nv = 2e4, Ga = [{ start: 0, end: Vu }], RQ = 104857600, NQ = 1048576, Iv = 10485760, q6 = 10240, Qa = { closeButton: !1, classBg: "jse-modal-bg", classWindow: "jse-modal-window", classWindowWrap: "jse-modal-window-wrap", classContent: "jse-modal-container" }, IQ = fe(fe({}, Qa), {}, { classWindow: "jse-modal-window jse-modal-window-sort" }), DQ = fe(fe({}, Qa), {}, { classWindow: "jse-modal-window jse-modal-window-transform" }), LQ = fe(fe({}, Qa), {}, { classWindow: "jse-modal-window jse-modal-window-jsoneditor" }), ly = "Insert or paste contents, enter [ insert a new array, enter { to insert a new object, or start typing to insert a new value", cy = "Open context menu (Click here, right click on the selection, or use the context menu button or Ctrl+Q)", vs = "hover-insert-inside", Hu = "hover-insert-after", Dv = "hover-collection", Wm = "valid", jw = "repairable", rs = 336, is = 260, BQ = Si(Si({}, Di.asc, "ascending"), Di.desc, "descending"), qQ = 0;
function fu() {
  return ++qQ;
}
function zr(t) {
  return parseInt(t, 10);
}
function uy(t) {
  return zQ.test(t);
}
var zQ = /^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$/;
function Wn(t) {
  return hr(t) === "object" && t !== null && t.constructor.name === "Object";
}
function Xn(t) {
  return hr(t) === "object" && t !== null && (t.constructor.name === "Object" || t.constructor.name === "Array");
}
function Lv(t) {
  if (typeof t == "number")
    return t > 9466848e5 && isFinite(t) && Math.floor(t) === t && !isNaN(new Date(t).valueOf());
  if (typeof t == "bigint")
    return Lv(Number(t));
  try {
    var e = t && t.valueOf();
    if (e !== t)
      return Lv(e);
  } catch {
    return !1;
  }
  return !1;
}
function z6(t) {
  var e = window.document.createElement("div");
  e.style.color = t;
  var n = e.style.color;
  return n !== "" ? n.replace(/\s+/g, "").toLowerCase() : null;
}
function fy(t, e) {
  if (typeof t == "number" || typeof t == "string" || typeof t == "boolean" || t === void 0)
    return hr(t);
  if (typeof t == "bigint")
    return "number";
  if (t === null)
    return "null";
  if (Array.isArray(t))
    return "array";
  if (Wn(t))
    return "object";
  var n = e.stringify(t);
  return n && uy(n) ? "number" : n === "true" || n === "false" ? "boolean" : n === "null" ? "null" : "unknown";
}
var FQ = /^https?:\/\/\S+$/;
function Vp(t) {
  return typeof t == "string" && FQ.test(t);
}
function kc(t, e) {
  if (t === "")
    return "";
  var n = t.trim();
  return n === "null" ? null : n === "true" || n !== "false" && (uy(n) ? e.parse(n) : t);
}
function VQ(t) {
  return HQ.test(t);
}
var HQ = /^-?[0-9]+$/, UQ = 1e4, WQ = [];
function Bv(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = {};
  if (!Array.isArray(t))
    throw new TypeError("Array expected");
  function r(s, a) {
    (!Array.isArray(s) && !Wn(s) || e && a.length > 0) && (n[Je(a)] = !0), Wn(s) && Object.keys(s).forEach(function(l) {
      r(s[l], a.concat(l));
    });
  }
  for (var i = Math.min(t.length, UQ), o = 0; o < i; o++)
    r(t[o], WQ);
  return Object.keys(n).sort().map(uo);
}
function F6(t, e, n) {
  if (!(e <= t))
    for (var r = t; r < e; r++)
      n(r);
}
function qh(t, e) {
  return t.length > e ? t.slice(0, e) : t;
}
function kw(t) {
  return fe({}, t);
}
function $w(t) {
  return Object.values(t);
}
function Sw(t, e, n, r) {
  var i = t.slice(0), o = i.splice(e, n);
  return i.splice.apply(i, [e + r, 0].concat(Ft(o))), i;
}
function gf(t, e) {
  try {
    return e.parse(t);
  } catch {
    return e.parse(Lo(t));
  }
}
function V6(t, e) {
  try {
    return gf(t, e);
  } catch {
    return;
  }
}
function Hp(t, e) {
  t = t.replace(U6, "");
  try {
    return e(t);
  } catch {
  }
  try {
    return e("[" + t + "]");
  } catch {
  }
  try {
    return e("{" + t + "}");
  } catch {
  }
  throw new Error("Failed to parse partial JSON");
}
function H6(t) {
  t = t.replace(U6, "");
  try {
    return Lo(t);
  } catch {
  }
  try {
    var e = Lo("[" + t + "]");
    return e.substring(1, e.length - 1);
  } catch {
  }
  try {
    var n = Lo("{" + t + "}");
    return n.substring(1, n.length - 1);
  } catch {
  }
  throw new Error("Failed to repair partial JSON");
}
var U6 = /,\s*$/;
function ic(t, e) {
  var n = Ow.exec(e);
  if (n) {
    var r = zr(n[2]), i = function(h, p) {
      for (var m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : h.length, v = 0, y = m; y < g; y++)
        h.charAt(y) === p && v++;
      return v;
    }(t, `
`, 0, r), o = r - t.lastIndexOf(`
`, r) - 1;
    return { position: r, line: i, column: o, message: e.replace(Ow, function() {
      return "line ".concat(i + 1, " column ").concat(o + 1);
    }) };
  }
  var s = GQ.exec(e), a = s ? zr(s[1]) : null, l = a !== null ? a - 1 : null, c = QQ.exec(e), u = c ? zr(c[1]) : null, f = u !== null ? u - 1 : null, d = l !== null && f !== null ? function(h, p, m) {
    for (var g = h.indexOf(`
`), v = 1; v < p && g !== -1; )
      g = h.indexOf(`
`, g + 1), v++;
    return g !== -1 ? g + m + 1 : null;
  }(t, l, f) : null;
  return { position: d, line: l, column: f, message: e.replace(/^JSON.parse: /, "").replace(/ of the JSON data$/, "") };
}
function Jm(t) {
  return Wn(t) ? t.json !== void 0 ? t.text !== void 0 ? 'Content must contain either a property "json" or a property "text" but not both' : null : t.text === void 0 ? 'Content must contain either a property "json" or a property "text"' : typeof t.text != "string" ? 'Content "text" property must be a string containing a JSON document. Did you mean to use the "json" property instead?' : null : "Content must be an object";
}
function oc(t) {
  return Wn(t) && typeof t.text == "string";
}
function dy(t) {
  return Wn(t) && t.json !== void 0 && !oc(t);
}
function JQ(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : JSON;
  return oc(t) ? t : { text: n.stringify(t.json, null, e) };
}
function Cw(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : JSON;
  return dy(t) ? t : { json: e.parse(t.text) };
}
function qv(t, e, n) {
  return JQ(t, e, n).text;
}
function W6(t, e) {
  return KQ(t, e) > e;
}
function KQ(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1 / 0;
  if (oc(t))
    return t.text.length;
  var n = t.json, r = 0;
  return function i(o) {
    if (Array.isArray(o)) {
      if ((r += o.length - 1 + 2) > e)
        return r;
      for (var s = 0; s < o.length; s++)
        if (i(o[s]), r > e)
          return r;
    } else if (Wn(o)) {
      var a = Object.keys(o);
      r += 2 + a.length + (a.length - 1);
      for (var l = 0; l < a.length; l++) {
        var c = a[l], u = o[c];
        r += c.length + 2, i(u);
      }
    } else
      r += typeof o == "string" ? o.length + 2 : String(o).length;
  }(n), r;
}
var Ow = /(position|char) (\d+)/, GQ = /line (\d+)/, QQ = /column (\d+)/;
function YQ(t, e) {
  return t.parse === e.parse && t.stringify === e.stringify;
}
function Ew(t) {
  return XQ.test(t) && t.length > 2;
}
var XQ = /^[[{]\S/;
function hy(t) {
  var e = t.escapeControlCharacters, n = t.escapeUnicodeCharacters;
  return e ? n ? ZQ : eY : n ? tY : nY;
}
var ZQ = { escapeValue: function(t) {
  return J6(Q6(String(t)));
}, unescapeValue: function(t) {
  return Y6(K6(t));
} }, eY = { escapeValue: function(t) {
  return Q6(String(t));
}, unescapeValue: function(t) {
  return Y6(t);
} }, tY = { escapeValue: function(t) {
  return J6(String(t));
}, unescapeValue: function(t) {
  return K6(t);
} }, nY = { escapeValue: function(t) {
  return String(t);
}, unescapeValue: function(t) {
  return t;
} };
function J6(t) {
  return t.replace(/[^\x20-\x7F]/g, function(e) {
    var n;
    return e === "\b" || e === "\f" || e === `
` || e === "\r" || e === "	" ? e : "\\u" + ("000" + ((n = e.codePointAt(0)) === null || n === void 0 ? void 0 : n.toString(16))).slice(-4);
  });
}
function K6(t) {
  return t.replace(/\\u[a-fA-F0-9]{4}/g, function(e) {
    try {
      var n = JSON.parse('"' + e + '"');
      return G6[n] || n;
    } catch {
      return e;
    }
  });
}
var G6 = { '"': '\\"', "\\": "\\\\", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t" }, rY = { '\\"': '"', "\\\\": "\\", "\\/": "/", "\\b": "\b", "\\f": "\f", "\\n": `
`, "\\r": "\r", "\\t": "	" };
function Q6(t) {
  return t.replace(/["\b\f\n\r\t\\]/g, function(e) {
    return G6[e] || e;
  });
}
function Y6(t) {
  return t.replace(/\\["bfnrt\\]/g, function(e) {
    return rY[e] || e;
  });
}
function Ya(t) {
  return typeof t != "string" ? String(t) : t.endsWith(`
`) ? t + `
` : t;
}
function py(t, e) {
  return vf(t, function(n) {
    return n.nodeName.toUpperCase() === e.toUpperCase();
  });
}
function Ta(t, e, n) {
  return vf(t, function(r) {
    return function(i, o, s) {
      return typeof i.getAttribute == "function" && i.getAttribute(o) === s;
    }(r, e, n);
  });
}
function vf(t, e) {
  return !!my(t, e);
}
function my(t, e) {
  for (var n = t; n && !e(n); )
    n = n.parentNode;
  return n || void 0;
}
function X6(t) {
  if (t.firstChild != null) {
    var e = document.createRange(), n = window.getSelection();
    e.setStart(t, 1), e.collapse(!0), n == null || n.removeAllRanges(), n == null || n.addRange(e);
  } else
    t.focus();
}
function zh(t, e, n, r) {
  var i = $c(t);
  if (i) {
    var o = i.document.activeElement ? i.document.activeElement : null;
    o && o.isContentEditable && (o.textContent = n ? e : o.textContent + e, X6(o), r && r(o));
  }
}
function $c(t) {
  return t && t.ownerDocument ? t.ownerDocument.defaultView : null;
}
function gy(t) {
  var e = $c(t), n = e == null ? void 0 : e.document.activeElement;
  return !!n && vf(n, function(r) {
    return r === t;
  });
}
function Z6(t, e) {
  return my(t, function(n) {
    return n.nodeName === e;
  });
}
function Km(t) {
  return Ta(t, "data-type", "selectable-key") ? On.key : Ta(t, "data-type", "selectable-value") ? On.value : Ta(t, "data-type", "insert-selection-area-inside") ? On.inside : Ta(t, "data-type", "insert-selection-area-after") ? On.after : On.multi;
}
function sc(t) {
  return encodeURIComponent(Je(t));
}
function e5(t) {
  var e = my(t, function(r) {
    return !(r == null || !r.hasAttribute) && r.hasAttribute("data-path");
  }), n = e == null ? void 0 : e.getAttribute("data-path");
  return n ? uo(decodeURIComponent(n)) : null;
}
function iY(t) {
  var e = t.allElements, n = t.currentElement, r = t.direction, i = t.hasPrio, o = i === void 0 ? function() {
    return !0;
  } : i, s = t.margin, a = s === void 0 ? 10 : s, l = zI(e.filter(function(w) {
    var x = w.getBoundingClientRect();
    return x.width > 0 && x.height > 0;
  }), u), c = u(n);
  function u(w) {
    var x = w.getBoundingClientRect();
    return { x: x.left + x.width / 2, y: x.top + x.height / 2, rect: x, element: w };
  }
  function f(w, x) {
    var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, j = w.x - x.x, $ = (w.y - x.y) * b;
    return Math.sqrt(j * j + $ * $);
  }
  var d = function(w) {
    return f(w, c);
  };
  if (r === "Left" || r === "Right") {
    var h = r === "Left" ? l.filter(function(w) {
      return x = c, w.rect.left + a < x.rect.left;
      var x;
    }) : l.filter(function(w) {
      return x = c, w.rect.right > x.rect.right + a;
      var x;
    }), p = h.filter(function(w) {
      return x = w, b = c, Math.abs(x.y - b.y) < a;
      var x, b;
    }), m = Cf(p, d) || Cf(h, function(w) {
      return f(w, c, 10);
    });
    return m == null ? void 0 : m.element;
  }
  if (r === "Up" || r === "Down") {
    var g = r === "Up" ? l.filter(function(w) {
      return x = c, w.y + a < x.y;
      var x;
    }) : l.filter(function(w) {
      return x = c, w.y > x.y + a;
      var x;
    }), v = g.filter(function(w) {
      return o(w.element);
    }), y = Cf(v, d) || Cf(g, d);
    return y == null ? void 0 : y.element;
  }
}
function t5(t) {
  return !!t && t.nodeName === "DIV" && typeof t.refresh == "function" && typeof t.cancel == "function";
}
function da(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "+", n = [];
  t.ctrlKey && n.push("Ctrl"), t.metaKey && n.push("Ctrl"), t.altKey && n.push("Alt"), t.shiftKey && n.push("Shift");
  var r = t.key.length === 1 ? t.key.toUpperCase() : t.key;
  return r in oY || n.push(r), n.join(e);
}
var oY = { Ctrl: !0, Command: !0, Control: !0, Alt: !0, Option: !0, Shift: !0 }, Gm = oy.window;
function sY(t) {
  At(t, "svelte-1r8q3m8", ".jse-absolute-popup.svelte-1r8q3m8.svelte-1r8q3m8{position:relative;left:0;top:0;width:0;height:0;z-index:1001}.jse-absolute-popup.svelte-1r8q3m8 .jse-hidden-input.svelte-1r8q3m8{position:fixed;left:0;top:0;width:0;height:0;padding:0;margin:0;border:none;outline:none;overflow:hidden}.jse-absolute-popup.svelte-1r8q3m8 .jse-absolute-popup-content.svelte-1r8q3m8{position:absolute}");
}
function Aw(t) {
  var e, n, r, i, o, s, a = [t[0].props], l = t[0].component;
  function c(u, f) {
    var d = {};
    if (f !== void 0 && 1 & f)
      d = Vi(a, [Ka(u[0].props)]);
    else
      for (var h = 0; h < a.length; h += 1)
        d = di(d, a[h]);
    return { props: d };
  }
  return l && (i = Wo(l, c(t))), { c: function() {
    e = H("div"), n = H("input"), r = se(), i && xe(i.$$.fragment), k(n, "type", "text"), n.readOnly = !0, k(n, "tabindex", "-1"), k(n, "class", "jse-hidden-input svelte-1r8q3m8"), k(e, "class", "jse-absolute-popup-content svelte-1r8q3m8"), k(e, "style", o = Mw(t[1], t[0].options));
  }, m: function(u, f) {
    X(u, e, f), T(e, n), t[7](n), T(e, r), i && ye(i, e, null), s = !0;
  }, p: function(u, f) {
    if (1 & f && l !== (l = u[0].component)) {
      if (i) {
        Ae();
        var d = i;
        _(d.$$.fragment, 1, 0, function() {
          be(d, 1);
        }), Me();
      }
      l ? (xe((i = Wo(l, c(u, f))).$$.fragment), S(i.$$.fragment, 1), ye(i, e, null)) : i = null;
    } else if (l) {
      var h = 1 & f ? Vi(a, [Ka(u[0].props)]) : {};
      i.$set(h);
    }
    (!s || 3 & f && o !== (o = Mw(u[1], u[0].options))) && k(e, "style", o);
  }, i: function(u) {
    s || (i && S(i.$$.fragment, u), s = !0);
  }, o: function(u) {
    i && _(i.$$.fragment, u), s = !1;
  }, d: function(u) {
    u && Y(e), t[7](null), i && be(i);
  } };
}
function aY(t) {
  var e, n, r, i, o = t[1] && Aw(t);
  return { c: function() {
    e = H("div"), o && o.c(), k(e, "role", "none"), k(e, "class", "jse-absolute-popup svelte-1r8q3m8");
  }, m: function(s, a) {
    X(s, e, a), o && o.m(e, null), t[8](e), n = !0, r || (i = [Oe(Gm, "mousedown", t[3], !0), Oe(Gm, "keydown", t[4], !0), Oe(Gm, "wheel", t[5], !0), Oe(e, "mousedown", lY), Oe(e, "keydown", t[4])], r = !0);
  }, p: function(s, a) {
    var l = Et(a, 1)[0];
    s[1] ? o ? (o.p(s, l), 2 & l && S(o, 1)) : ((o = Aw(s)).c(), S(o, 1), o.m(e, null)) : o && (Ae(), _(o, 1, 1, function() {
      o = null;
    }), Me());
  }, i: function(s) {
    n || (S(o), n = !0);
  }, o: function(s) {
    _(o), n = !1;
  }, d: function(s) {
    s && Y(e), o && o.d(), t[8](null), r = !1, An(i);
  } };
}
function lY(t) {
  t.stopPropagation();
}
function Mw(t, e) {
  var n = t.getBoundingClientRect(), r = function() {
    if (e.anchor) {
      var l = e.anchor, c = e.width, u = c === void 0 ? 0 : c, f = e.height, d = f === void 0 ? 0 : f, h = e.offsetTop, p = h === void 0 ? 0 : h, m = e.offsetLeft, g = m === void 0 ? 0 : m, v = e.position, y = l.getBoundingClientRect(), w = y.left, x = y.top, b = y.bottom, j = y.right, $ = v === "top" || x + d > window.innerHeight && x > d, N = v === "left" || w + u > window.innerWidth && w > u;
      return { left: N ? j - g : w + g, top: $ ? x - p : b + p, positionAbove: $, positionLeft: N };
    }
    if (typeof e.left == "number" && typeof e.top == "number") {
      var B = e.left, O = e.top, I = e.width, P = I === void 0 ? 0 : I, J = e.height, D = J === void 0 ? 0 : J;
      return { left: B, top: O, positionAbove: O + D > window.innerHeight && O > D, positionLeft: B + P > window.innerWidth && B > P };
    }
    throw new Error('Invalid config: pass either "left" and "top", or pass "anchor"');
  }(), i = r.left, o = r.top, s = r.positionAbove, a = r.positionLeft;
  return (s ? "bottom: ".concat(n.top - o, "px;") : "top: ".concat(o - n.top, "px;")) + (a ? "right: ".concat(n.left - i, "px;") : "left: ".concat(i - n.left, "px;"));
}
function cY(t, e, n) {
  var r, i, o = e.popup, s = e.closeAbsolutePopup;
  function a(l) {
    o.options && o.options.closeOnOuterClick && !vf(l.target, function(c) {
      return c === r;
    }) && s(o.id);
  }
  return Fi(function() {
    i && i.focus();
  }), t.$$set = function(l) {
    "popup" in l && n(0, o = l.popup), "closeAbsolutePopup" in l && n(6, s = l.closeAbsolutePopup);
  }, [o, r, i, function(l) {
    a(l);
  }, function(l) {
    da(l) === "Escape" && s(o.id);
  }, function(l) {
    a(l);
  }, s, function(l) {
    Kt[l ? "unshift" : "push"](function() {
      n(2, i = l);
    });
  }, function(l) {
    Kt[l ? "unshift" : "push"](function() {
      n(1, r = l);
    });
  }];
}
var uY = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, cY, aY, wr, { popup: 0, closeAbsolutePopup: 6 }, sY), i;
  }
  return Ye(n);
}();
function _w(t, e, n) {
  var r = t.slice();
  return r[6] = e[n], r;
}
function Tw(t) {
  var e, n;
  return e = new uY({ props: { popup: t[6], closeAbsolutePopup: t[1] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.popup = r[6]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function fY(t) {
  for (var e, n, r = Ot(t[0]), i = [], o = 0; o < r.length; o += 1)
    i[o] = Tw(_w(t, r, o));
  var s = function(c) {
    return _(i[c], 1, 1, function() {
      i[c] = null;
    });
  }, a = t[3].default, l = ir(a, t, t[2], null);
  return { c: function() {
    for (var c = 0; c < i.length; c += 1)
      i[c].c();
    e = se(), l && l.c();
  }, m: function(c, u) {
    for (var f = 0; f < i.length; f += 1)
      i[f] && i[f].m(c, u);
    X(c, e, u), l && l.m(c, u), n = !0;
  }, p: function(c, u) {
    var f = Et(u, 1)[0];
    if (3 & f) {
      var d;
      for (r = Ot(c[0]), d = 0; d < r.length; d += 1) {
        var h = _w(c, r, d);
        i[d] ? (i[d].p(h, f), S(i[d], 1)) : (i[d] = Tw(h), i[d].c(), S(i[d], 1), i[d].m(e.parentNode, e));
      }
      for (Ae(), d = r.length; d < i.length; d += 1)
        s(d);
      Me();
    }
    l && l.p && (!n || 4 & f) && sr(l, a, c, c[2], n ? or(a, c[2], f, null) : ar(c[2]), null);
  }, i: function(c) {
    if (!n) {
      for (var u = 0; u < r.length; u += 1)
        S(i[u]);
      S(l, c), n = !0;
    }
  }, o: function(c) {
    i = i.filter(Boolean);
    for (var u = 0; u < i.length; u += 1)
      _(i[u]);
    _(l, c), n = !1;
  }, d: function(c) {
    c && Y(e), fr(i, c), l && l.d(c);
  } };
}
function dY(t, e, n) {
  var r = e.$$slots, i = r === void 0 ? {} : r, o = e.$$scope, s = Tr("jsoneditor:AbsolutePopup"), a = [];
  function l(c) {
    var u = a.findIndex(function(d) {
      return d.id === c;
    });
    if (u !== -1) {
      var f = a[u];
      f.options.onClose && f.options.onClose(), n(0, a = a.filter(function(d) {
        return d.id !== c;
      }));
    }
  }
  return P6("absolute-popup", { openAbsolutePopup: function(c, u, f) {
    s("open...", u, f);
    var d = { id: fu(), component: c, props: u || {}, options: f || {} };
    return n(0, a = [].concat(Ft(a), [d])), d.id;
  }, closeAbsolutePopup: l }), t.$$set = function(c) {
    "$$scope" in c && n(2, o = c.$$scope);
  }, t.$$.update = function() {
    1 & t.$$.dirty && s("popups", a);
  }, [a, l, o, i];
}
var n5 = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, dY, fY, Pt, {}), i;
  }
  return Ye(n);
}();
function hi(t) {
  return t.map(function(e, n) {
    return r5.test(e) ? "[" + e + "]" : /[.[\]]/.test(e) || e === "" ? '["' + (e.replace(/"/g, '\\"') + '"]') : (n > 0 ? "." : "") + e;
  }).join("");
}
function hY(t) {
  for (var e = [], n = 0; n < t.length; )
    t[n] === "." && n++, t[n] === "[" ? (n++, t[n] === '"' ? (n++, e.push(r(function(o) {
      return o === '"';
    }, !0)), i('"')) : e.push(r(function(o) {
      return o === "]";
    })), i("]")) : e.push(r(function(o) {
      return o === "." || o === "[";
    }));
  function r(o) {
    for (var s = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], a = ""; n < t.length && !o(t[n]); )
      s && t[n] === "\\" && t[n + 1] === '"' ? (a += '"', n += 2) : (a += t[n], n++);
    return a;
  }
  function i(o) {
    if (t[n] !== o)
      throw new SyntaxError("Invalid JSON path: ".concat(o, " expected at position ").concat(n));
    n++;
  }
  return e;
}
function Kc(t) {
  return { value: t, label: nn(t) ? "(item root)" : hi(t) };
}
function ba(t) {
  return t.map(function(e) {
    return r5.test(e) ? "?.[".concat(e, "]") : pY.test(e) ? "?.".concat(e) : "?.[".concat(JSON.stringify(e), "]");
  }).join("");
}
var pY = /^[a-zA-Z$_][a-zA-Z$_\d]*$/, r5 = /^\d+$/;
function yf(t, e) {
  for (var n = new Set(e), r = t.replace(/ \(copy( \d+)?\)$/, ""), i = t, o = 1; n.has(i); ) {
    var s = "copy" + (o > 1 ? " " + o : "");
    i = "".concat(r, " (").concat(s, ")"), o++;
  }
  return i;
}
function ys(t, e) {
  var n = e - 3;
  return t.length > e ? t.substring(0, n) + "..." : t;
}
function mY(t) {
  if (t === "")
    return "";
  var e = t.toLowerCase();
  if (e === "null")
    return null;
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  if (e !== "undefined") {
    var n = Number(t), r = parseFloat(t);
    return isNaN(n) || isNaN(r) ? t : n;
  }
}
var gY = { id: "javascript", name: "JavaScript", description: `
<p>
  Enter a JavaScript function to filter, sort, or transform the data.
</p>
`, createQuery: function(t, e) {
  var n = e.filter, r = e.sort, i = e.projection, o = [`  return data
`];
  if (n && n.path && n.relation && n.value) {
    var s = "item => item".concat(ba(n.path)), a = mY(n.value), l = typeof a == "string" ? "'".concat(n.value, "'") : VQ(n.value) && !Number.isSafeInteger(a) ? "".concat(n.value, "n") : n.value;
    o.push("    .filter(".concat(s, " ").concat(n.relation, " ").concat(l, `)
`));
  }
  if (r && r.path && r.direction && (r.direction === "desc" ? o.push(`    .slice()
    .sort((a, b) => {
      // sort descending
` + "      const valueA = a".concat(ba(r.path), `
`) + "      const valueB = b".concat(ba(r.path), `
`) + `      return valueA > valueB ? -1 : valueA < valueB ? 1 : 0
    })
`) : o.push(`    .slice()
    .sort((a, b) => {
      // sort ascending
` + "      const valueA = a".concat(ba(r.path), `
`) + "      const valueB = b".concat(ba(r.path), `
`) + `      return valueA > valueB ? 1 : valueA < valueB ? -1 : 0
    })
`)), i && i.paths)
    if (i.paths.length > 1) {
      var c = i.paths.map(function(f) {
        var d = f[f.length - 1] || "item", h = "item".concat(ba(f));
        return "      ".concat(JSON.stringify(d), ": ").concat(h);
      });
      o.push(`    .map(item => ({
`.concat(c.join(`,
`), `})
    )
`));
    } else {
      var u = "item".concat(ba(i.paths[0]));
      o.push("    .map(item => ".concat(u, `)
`));
    }
  return `function query (data) {
`.concat(o.join(""), "}");
}, executeQuery: function(t, e) {
  var n = new Function(`"use strict";

` + e + `

if (typeof query !== "function") {
  throw new Error("Cannot execute query: expecting a function named 'query' but is undefined")
}

return query;
`)()(t);
  return n !== void 0 ? n : null;
} };
function vY(t) {
  var e;
  return { c: function() {
    e = Ho("g");
  }, m: function(n, r) {
    X(n, e, r), e.innerHTML = t[0];
  }, p: function(n, r) {
    1 & Et(r, 1)[0] && (e.innerHTML = n[0]);
  }, i: Pe, o: Pe, d: function(n) {
    n && Y(e);
  } };
}
function yY(t, e, n) {
  var r = 870711, i = "", o = e.data;
  function s(a) {
    if (!a || !a.raw)
      return "";
    var l = a.raw, c = {};
    return l = l.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function(u, f) {
      var d = "fa-".concat((r += 1).toString(16));
      return c[f] = d, ' id="'.concat(d, '"');
    }), l = l.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function(u, f, d, h) {
      var p = f || h;
      return p && c[p] ? "#".concat(c[p]) : u;
    }), l;
  }
  return t.$$set = function(a) {
    "data" in a && n(1, o = a.data);
  }, t.$$.update = function() {
    2 & t.$$.dirty && n(0, i = s(o));
  }, [i, o];
}
var bY = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, yY, vY, wr, { data: 1 }), i;
  }
  return Ye(n);
}();
function xY(t) {
  At(t, "svelte-1mc5hvj", ".fa-icon.svelte-1mc5hvj{display:inline-block;fill:currentColor}.fa-flip-horizontal.svelte-1mc5hvj{transform:scale(-1, 1)}.fa-flip-vertical.svelte-1mc5hvj{transform:scale(1, -1)}.fa-spin.svelte-1mc5hvj{animation:svelte-1mc5hvj-fa-spin 1s 0s infinite linear}.fa-inverse.svelte-1mc5hvj{color:#fff}.fa-pulse.svelte-1mc5hvj{animation:svelte-1mc5hvj-fa-spin 1s infinite steps(8)}@keyframes svelte-1mc5hvj-fa-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}");
}
function wY(t) {
  for (var e, n, r, i, o = t[12].default, s = ir(o, t, t[11], null), a = [{ version: "1.1" }, { class: n = "fa-icon " + t[0] }, { width: t[1] }, { height: t[2] }, { "aria-label": t[9] }, { role: r = t[9] ? "img" : "presentation" }, { viewBox: t[3] }, { style: t[8] }, t[10]], l = {}, c = 0; c < a.length; c += 1)
    l = di(l, a[c]);
  return { c: function() {
    e = Ho("svg"), s && s.c(), rc(e, l), $e(e, "fa-spin", t[4]), $e(e, "fa-pulse", t[6]), $e(e, "fa-inverse", t[5]), $e(e, "fa-flip-horizontal", t[7] === "horizontal"), $e(e, "fa-flip-vertical", t[7] === "vertical"), $e(e, "svelte-1mc5hvj", !0);
  }, m: function(u, f) {
    X(u, e, f), s && s.m(e, null), i = !0;
  }, p: function(u, f) {
    var d = Et(f, 1)[0];
    s && s.p && (!i || 2048 & d) && sr(s, o, u, u[11], i ? or(o, u[11], d, null) : ar(u[11]), null), rc(e, l = Vi(a, [{ version: "1.1" }, (!i || 1 & d && n !== (n = "fa-icon " + u[0])) && { class: n }, (!i || 2 & d) && { width: u[1] }, (!i || 4 & d) && { height: u[2] }, (!i || 512 & d) && { "aria-label": u[9] }, (!i || 512 & d && r !== (r = u[9] ? "img" : "presentation")) && { role: r }, (!i || 8 & d) && { viewBox: u[3] }, (!i || 256 & d) && { style: u[8] }, 1024 & d && u[10]])), $e(e, "fa-spin", u[4]), $e(e, "fa-pulse", u[6]), $e(e, "fa-inverse", u[5]), $e(e, "fa-flip-horizontal", u[7] === "horizontal"), $e(e, "fa-flip-vertical", u[7] === "vertical"), $e(e, "svelte-1mc5hvj", !0);
  }, i: function(u) {
    i || (S(s, u), i = !0);
  }, o: function(u) {
    _(s, u), i = !1;
  }, d: function(u) {
    u && Y(e), s && s.d(u);
  } };
}
function jY(t, e, n) {
  var r = ["class", "width", "height", "box", "spin", "inverse", "pulse", "flip", "style", "label"], i = Lh(e, r), o = e, s = o.$$slots, a = s === void 0 ? {} : s, l = o.$$scope, c = e.class, u = c === void 0 ? "" : c, f = e.width, d = e.height, h = e.box, p = h === void 0 ? "0 0 0 0" : h, m = e.spin, g = m !== void 0 && m, v = e.inverse, y = v !== void 0 && v, w = e.pulse, x = w !== void 0 && w, b = e.flip, j = b === void 0 ? "none" : b, $ = e.style, N = $ === void 0 ? "" : $, B = e.label, O = B === void 0 ? "" : B;
  return t.$$set = function(I) {
    e = di(di({}, e), O6(I)), n(10, i = Lh(e, r)), "class" in I && n(0, u = I.class), "width" in I && n(1, f = I.width), "height" in I && n(2, d = I.height), "box" in I && n(3, p = I.box), "spin" in I && n(4, g = I.spin), "inverse" in I && n(5, y = I.inverse), "pulse" in I && n(6, x = I.pulse), "flip" in I && n(7, j = I.flip), "style" in I && n(8, N = I.style), "label" in I && n(9, O = I.label), "$$scope" in I && n(11, l = I.$$scope);
  }, [u, f, d, p, g, y, x, j, N, O, i, l, a];
}
var kY = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, jY, wY, wr, { class: 0, width: 1, height: 2, box: 3, spin: 4, inverse: 5, pulse: 6, flip: 7, style: 8, label: 9 }, xY), i;
  }
  return Ye(n);
}();
function Pw(t, e, n) {
  var r = t.slice();
  return r[24] = e[n], r;
}
function Rw(t, e, n) {
  var r = t.slice();
  return r[27] = e[n], r;
}
function Nw(t) {
  var e, n, r, i, o = t[6].paths && Iw(t), s = t[6].polygons && Lw(t), a = t[6].raw && qw(t);
  return { c: function() {
    o && o.c(), e = se(), s && s.c(), n = se(), a && a.c(), r = un();
  }, m: function(l, c) {
    o && o.m(l, c), X(l, e, c), s && s.m(l, c), X(l, n, c), a && a.m(l, c), X(l, r, c), i = !0;
  }, p: function(l, c) {
    l[6].paths ? o ? o.p(l, c) : ((o = Iw(l)).c(), o.m(e.parentNode, e)) : o && (o.d(1), o = null), l[6].polygons ? s ? s.p(l, c) : ((s = Lw(l)).c(), s.m(n.parentNode, n)) : s && (s.d(1), s = null), l[6].raw ? a ? (a.p(l, c), 64 & c && S(a, 1)) : ((a = qw(l)).c(), S(a, 1), a.m(r.parentNode, r)) : a && (Ae(), _(a, 1, 1, function() {
      a = null;
    }), Me());
  }, i: function(l) {
    i || (S(a), i = !0);
  }, o: function(l) {
    _(a), i = !1;
  }, d: function(l) {
    l && (Y(e), Y(n), Y(r)), o && o.d(l), s && s.d(l), a && a.d(l);
  } };
}
function Iw(t) {
  for (var e, n = Ot(t[6].paths), r = [], i = 0; i < n.length; i += 1)
    r[i] = Dw(Rw(t, n, i));
  return { c: function() {
    for (var o = 0; o < r.length; o += 1)
      r[o].c();
    e = un();
  }, m: function(o, s) {
    for (var a = 0; a < r.length; a += 1)
      r[a] && r[a].m(o, s);
    X(o, e, s);
  }, p: function(o, s) {
    if (64 & s) {
      var a;
      for (n = Ot(o[6].paths), a = 0; a < n.length; a += 1) {
        var l = Rw(o, n, a);
        r[a] ? r[a].p(l, s) : (r[a] = Dw(l), r[a].c(), r[a].m(e.parentNode, e));
      }
      for (; a < r.length; a += 1)
        r[a].d(1);
      r.length = n.length;
    }
  }, d: function(o) {
    o && Y(e), fr(r, o);
  } };
}
function Dw(t) {
  for (var e, n = [t[27]], r = {}, i = 0; i < n.length; i += 1)
    r = di(r, n[i]);
  return { c: function() {
    rc(e = Ho("path"), r);
  }, m: function(o, s) {
    X(o, e, s);
  }, p: function(o, s) {
    rc(e, r = Vi(n, [64 & s && o[27]]));
  }, d: function(o) {
    o && Y(e);
  } };
}
function Lw(t) {
  for (var e, n = Ot(t[6].polygons), r = [], i = 0; i < n.length; i += 1)
    r[i] = Bw(Pw(t, n, i));
  return { c: function() {
    for (var o = 0; o < r.length; o += 1)
      r[o].c();
    e = un();
  }, m: function(o, s) {
    for (var a = 0; a < r.length; a += 1)
      r[a] && r[a].m(o, s);
    X(o, e, s);
  }, p: function(o, s) {
    if (64 & s) {
      var a;
      for (n = Ot(o[6].polygons), a = 0; a < n.length; a += 1) {
        var l = Pw(o, n, a);
        r[a] ? r[a].p(l, s) : (r[a] = Bw(l), r[a].c(), r[a].m(e.parentNode, e));
      }
      for (; a < r.length; a += 1)
        r[a].d(1);
      r.length = n.length;
    }
  }, d: function(o) {
    o && Y(e), fr(r, o);
  } };
}
function Bw(t) {
  for (var e, n = [t[24]], r = {}, i = 0; i < n.length; i += 1)
    r = di(r, n[i]);
  return { c: function() {
    rc(e = Ho("polygon"), r);
  }, m: function(o, s) {
    X(o, e, s);
  }, p: function(o, s) {
    rc(e, r = Vi(n, [64 & s && o[24]]));
  }, d: function(o) {
    o && Y(e);
  } };
}
function qw(t) {
  var e, n, r;
  function i(s) {
    t[16](s);
  }
  var o = {};
  return t[6] !== void 0 && (o.data = t[6]), e = new bY({ props: o }), Kt.push(function() {
    return no(e, "data", i);
  }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(s, a) {
    ye(e, s, a), r = !0;
  }, p: function(s, a) {
    var l = {};
    !n && 64 & a && (n = !0, l.data = s[6], to(function() {
      return n = !1;
    })), e.$set(l);
  }, i: function(s) {
    r || (S(e.$$.fragment, s), r = !0);
  }, o: function(s) {
    _(e.$$.fragment, s), r = !1;
  }, d: function(s) {
    be(e, s);
  } };
}
function $Y(t) {
  var e, n = t[15].default, r = ir(n, t, t[17], null), i = r || function(o) {
    var s, a, l = o[6] && Nw(o);
    return { c: function() {
      l && l.c(), s = un();
    }, m: function(c, u) {
      l && l.m(c, u), X(c, s, u), a = !0;
    }, p: function(c, u) {
      c[6] ? l ? (l.p(c, u), 64 & u && S(l, 1)) : ((l = Nw(c)).c(), S(l, 1), l.m(s.parentNode, s)) : l && (Ae(), _(l, 1, 1, function() {
        l = null;
      }), Me());
    }, i: function(c) {
      a || (S(l), a = !0);
    }, o: function(c) {
      _(l), a = !1;
    }, d: function(c) {
      c && Y(s), l && l.d(c);
    } };
  }(t);
  return { c: function() {
    i && i.c();
  }, m: function(o, s) {
    i && i.m(o, s), e = !0;
  }, p: function(o, s) {
    r ? r.p && (!e || 131072 & s) && sr(r, n, o, o[17], e ? or(n, o[17], s, null) : ar(o[17]), null) : i && i.p && (!e || 64 & s) && i.p(o, e ? s : -1);
  }, i: function(o) {
    e || (S(i, o), e = !0);
  }, o: function(o) {
    _(i, o), e = !1;
  }, d: function(o) {
    i && i.d(o);
  } };
}
function SY(t) {
  for (var e, n, r = [{ label: t[5] }, { width: t[7] }, { height: t[8] }, { box: t[10] }, { style: t[9] }, { spin: t[1] }, { flip: t[4] }, { inverse: t[2] }, { pulse: t[3] }, { class: t[0] }, t[11]], i = { $$slots: { default: [$Y] }, $$scope: { ctx: t } }, o = 0; o < r.length; o += 1)
    i = di(i, r[o]);
  return e = new kY({ props: i }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(s, a) {
    ye(e, s, a), n = !0;
  }, p: function(s, a) {
    var l = Et(a, 1)[0], c = 4031 & l ? Vi(r, [32 & l && { label: s[5] }, 128 & l && { width: s[7] }, 256 & l && { height: s[8] }, 1024 & l && { box: s[10] }, 512 & l && { style: s[9] }, 2 & l && { spin: s[1] }, 16 & l && { flip: s[4] }, 4 & l && { inverse: s[2] }, 8 & l && { pulse: s[3] }, 1 & l && { class: s[0] }, 2048 & l && Ka(s[11])]) : {};
    131136 & l && (c.$$scope = { dirty: l, ctx: s }), e.$set(c);
  }, i: function(s) {
    n || (S(e.$$.fragment, s), n = !0);
  }, o: function(s) {
    _(e.$$.fragment, s), n = !1;
  }, d: function(s) {
    be(e, s);
  } };
}
function CY(t, e, n) {
  var r, i, o, s = ["class", "data", "scale", "spin", "inverse", "pulse", "flip", "label", "style"], a = Lh(e, s), l = e, c = l.$$slots, u = c === void 0 ? {} : c, f = l.$$scope, d = e.class, h = d === void 0 ? "" : d, p = e.data, m = e.scale, g = m === void 0 ? 1 : m, v = e.spin, y = v !== void 0 && v, w = e.inverse, x = w !== void 0 && w, b = e.pulse, j = b !== void 0 && b, $ = e.flip, N = $ === void 0 ? void 0 : $, B = e.label, O = B === void 0 ? "" : B, I = e.style, P = I === void 0 ? "" : I, J = 10, D = 10;
  function Q() {
    var L = 1;
    return g !== void 0 && (L = Number(g)), isNaN(L) || L <= 0 ? (console.warn('Invalid prop: prop "scale" should be a number over 0.'), 1) : 1 * L;
  }
  function Z() {
    return r ? Math.max(r.width, r.height) / 16 : 1;
  }
  return t.$$set = function(L) {
    e = di(di({}, e), O6(L)), n(11, a = Lh(e, s)), "class" in L && n(0, h = L.class), "data" in L && n(12, p = L.data), "scale" in L && n(13, g = L.scale), "spin" in L && n(1, y = L.spin), "inverse" in L && n(2, x = L.inverse), "pulse" in L && n(3, j = L.pulse), "flip" in L && n(4, N = L.flip), "label" in L && n(5, O = L.label), "style" in L && n(14, P = L.style), "$$scope" in L && n(17, f = L.$$scope);
  }, t.$$.update = function() {
    28672 & t.$$.dirty && (n(6, r = function(L) {
      var R;
      if (L) {
        if (!("definition" in L)) {
          if ("iconName" in L && "icon" in L) {
            L.iconName;
            var V = Et(L.icon, 5), M = V[0], C = V[1], F = V[4];
            R = { width: M, height: C, paths: (Array.isArray(F) ? F : [F]).map(function(z) {
              return { d: z };
            }) };
          } else
            R = L[Object.keys(L)[0]];
          return R;
        }
        console.error("`import faIconName from '@fortawesome/package-name/faIconName` not supported - Please use `import { faIconName } from '@fortawesome/package-name/faIconName'` instead");
      }
    }(p)), n(7, J = r ? r.width / Z() * Q() : 0), n(8, D = r ? r.height / Z() * Q() : 0), n(9, i = function() {
      var L = "";
      P !== null && (L += P);
      var R = Q();
      return R === 1 ? L.length === 0 ? "" : L : (L === "" || L.endsWith(";") || (L += "; "), "".concat(L, "font-size: ").concat(R, "em"));
    }()), n(10, o = r ? "0 0 ".concat(r.width, " ").concat(r.height) : "0 0 ".concat(J, " ").concat(D)));
  }, [h, y, x, j, N, O, r, J, D, i, o, a, p, g, P, u, function(L) {
    n(6, r = L), n(12, p), n(14, P), n(13, g);
  }, f];
}
var cn = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, CY, SY, wr, { class: 0, data: 12, scale: 13, spin: 1, inverse: 2, pulse: 3, flip: 4, label: 5, style: 14 }), i;
  }
  return Ye(n);
}();
function OY(t) {
  At(t, "svelte-68vtq4", ".jse-boolean-toggle.svelte-68vtq4{padding:0;margin:1px 0 0;vertical-align:top;display:inline-flex;color:var(--jse-value-color-boolean, #ff8c00)}.jse-boolean-toggle.svelte-68vtq4:not(.jse-readonly){cursor:pointer}");
}
function EY(t) {
  var e, n, r, i, o, s, a;
  return n = new cn({ props: { data: t[0] === !0 ? ku : $u } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), k(e, "role", "checkbox"), k(e, "tabindex", "-1"), k(e, "aria-checked", r = t[0] === !0), k(e, "class", "jse-boolean-toggle svelte-68vtq4"), k(e, "title", i = t[1] ? "Boolean value ".concat(t[0]) : "Click to toggle this boolean value"), $e(e, "jse-readonly", t[1]);
  }, m: function(l, c) {
    X(l, e, c), ye(n, e, null), o = !0, s || (a = Oe(e, "mousedown", t[2]), s = !0);
  }, p: function(l, c) {
    var u = Et(c, 1)[0], f = {};
    1 & u && (f.data = l[0] === !0 ? ku : $u), n.$set(f), (!o || 1 & u && r !== (r = l[0] === !0)) && k(e, "aria-checked", r), (!o || 3 & u && i !== (i = l[1] ? "Boolean value ".concat(l[0]) : "Click to toggle this boolean value")) && k(e, "title", i), (!o || 2 & u) && $e(e, "jse-readonly", l[1]);
  }, i: function(l) {
    o || (S(n.$$.fragment, l), o = !0);
  }, o: function(l) {
    _(n.$$.fragment, l), o = !1;
  }, d: function(l) {
    l && Y(e), be(n), s = !1, a();
  } };
}
function AY(t, e, n) {
  var r = e.path, i = e.value, o = e.readOnly, s = e.onPatch, a = e.focus;
  return t.$$set = function(l) {
    "path" in l && n(3, r = l.path), "value" in l && n(0, i = l.value), "readOnly" in l && n(1, o = l.readOnly), "onPatch" in l && n(4, s = l.onPatch), "focus" in l && n(5, a = l.focus);
  }, [i, o, function(l) {
    l.stopPropagation(), o || (s([{ op: "replace", path: Je(r), value: !i }]), a());
  }, r, s, a];
}
var MY = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, AY, EY, Pt, { path: 3, value: 0, readOnly: 1, onPatch: 4, focus: 5 }, OY), i;
  }
  return Ye(n);
}();
function _Y(t) {
  At(t, "svelte-1f4ayrt", ".jse-color-picker-popup.svelte-1f4ayrt .picker_wrapper.popup,.jse-color-picker-popup.svelte-1f4ayrt .picker_wrapper.popup .picker_arrow::before,.jse-color-picker-popup.svelte-1f4ayrt .picker_wrapper.popup .picker_arrow::after{background:var(--jse-color-picker-background, var(--jse-panel-background, #ebebeb));line-height:normal}.jse-color-picker-popup.svelte-1f4ayrt .picker_slider,.jse-color-picker-popup.svelte-1f4ayrt .picker_sl,.jse-color-picker-popup.svelte-1f4ayrt .picker_editor input,.jse-color-picker-popup.svelte-1f4ayrt .picker_sample,.jse-color-picker-popup.svelte-1f4ayrt .picker_done button{box-shadow:var(--jse-color-picker-border-box-shadow, #cbcbcb 0 0 0 1px)}.jse-color-picker-popup.svelte-1f4ayrt .picker_editor input{background:var(--jse-background-color, #fff);color:var(--jse-text-color, #4d4d4d)}.jse-color-picker-popup.svelte-1f4ayrt .picker_done button{background:var(--jse-button-background, #e0e0e0);color:var(--jse-button-color, var(--jse-text-color, #4d4d4d))}.jse-color-picker-popup.svelte-1f4ayrt .picker_done button:hover{background:var(--jse-button-background-highlight, #e7e7e7)}");
}
function TY(t) {
  var e;
  return { c: function() {
    k(e = H("div"), "class", "jse-color-picker-popup svelte-1f4ayrt");
  }, m: function(n, r) {
    X(n, e, r), t[4](e);
  }, p: Pe, i: Pe, o: Pe, d: function(n) {
    n && Y(e), t[4](null);
  } };
}
function PY(t, e, n) {
  var r, i = e.color, o = e.onChange, s = e.showOnTop, a = function() {
  };
  return Fi(Tt(Ie().mark(function l() {
    var c, u, f;
    return Ie().wrap(function(d) {
      for (; ; )
        switch (d.prev = d.next) {
          case 0:
            return d.next = 2, import("./vanilla-picker-NKbIFE8h.mjs");
          case 2:
            if (d.t1 = c = d.sent, d.t0 = d.t1 === null, d.t0) {
              d.next = 6;
              break;
            }
            d.t0 = c === void 0;
          case 6:
            if (!d.t0) {
              d.next = 10;
              break;
            }
            d.t2 = void 0, d.next = 11;
            break;
          case 10:
            d.t2 = c.default;
          case 11:
            u = d.t2, f = new u({ parent: r, color: i, popup: s ? "top" : "bottom", onDone: function(h) {
              var p = h.rgba[3] === 1 ? h.hex.substring(0, 7) : h.hex;
              o(p);
            } }), f.show(), a = function() {
              f.destroy();
            };
          case 15:
          case "end":
            return d.stop();
        }
    }, l);
  }))), Ci(function() {
    a();
  }), t.$$set = function(l) {
    "color" in l && n(1, i = l.color), "onChange" in l && n(2, o = l.onChange), "showOnTop" in l && n(3, s = l.showOnTop);
  }, [r, i, o, s, function(l) {
    Kt[l ? "unshift" : "push"](function() {
      n(0, r = l);
    });
  }];
}
var RY = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, PY, TY, wr, { color: 1, onChange: 2, showOnTop: 3 }, _Y), i;
  }
  return Ye(n);
}();
function NY(t) {
  At(t, "svelte-1zzxwe", ".jse-color-picker-button.svelte-1zzxwe{font-size:var(--jse-font-size-mono, 14px);width:var(--jse-color-picker-button-size, 1em);height:var(--jse-color-picker-button-size, 1em);box-sizing:border-box;padding:0;margin:2px 0 0;display:inline-flex;vertical-align:top;border:1px solid var(--jse-text-color, #4d4d4d);border-radius:2px;background:inherit;outline:none}.jse-color-picker-button.svelte-1zzxwe:not(.jse-readonly){cursor:pointer}");
}
function IY(t) {
  var e, n, r, i;
  return { c: function() {
    k(e = H("button"), "type", "button"), k(e, "class", "jse-color-picker-button svelte-1zzxwe"), Qr(e, "background", t[2]), k(e, "title", n = t[1] ? "Color ".concat(t[0]) : "Click to open a color picker"), $e(e, "jse-readonly", t[1]);
  }, m: function(o, s) {
    X(o, e, s), r || (i = Oe(e, "click", t[3]), r = !0);
  }, p: function(o, s) {
    var a = Et(s, 1)[0];
    4 & a && Qr(e, "background", o[2]), 3 & a && n !== (n = o[1] ? "Color ".concat(o[0]) : "Click to open a color picker") && k(e, "title", n), 2 & a && $e(e, "jse-readonly", o[1]);
  }, i: Pe, o: Pe, d: function(o) {
    o && Y(e), r = !1, i();
  } };
}
function DY(t, e, n) {
  var r, i = _r("absolute-popup").openAbsolutePopup, o = e.path, s = e.value, a = e.readOnly, l = e.onPatch, c = e.focus;
  function u(d) {
    l([{ op: "replace", path: Je(o), value: d }]), f();
  }
  function f() {
    c();
  }
  return t.$$set = function(d) {
    "path" in d && n(4, o = d.path), "value" in d && n(0, s = d.value), "readOnly" in d && n(1, a = d.readOnly), "onPatch" in d && n(5, l = d.onPatch), "focus" in d && n(6, c = d.focus);
  }, t.$$.update = function() {
    1 & t.$$.dirty && n(2, r = z6(s));
  }, [s, a, r, function(d) {
    if (!a) {
      var h = d.target.getBoundingClientRect().top, p = $c(d.target).innerHeight;
      i(RY, { color: s, onChange: u, showOnTop: p - h < 300 && h > 300 }, { anchor: d.target, closeOnOuterClick: !0, onClose: f, offsetTop: 18, offsetLeft: -8, height: 300 });
    }
  }, o, l, c];
}
var LY = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, DY, IY, Pt, { path: 4, value: 0, readOnly: 1, onPatch: 5, focus: 6 }, NY), i;
  }
  return Ye(n);
}();
function i5(t) {
  for (var e = fD(t, function(a) {
    return a.start;
  }), n = [e[0]], r = 0; r < e.length; r++) {
    var i = n.length - 1, o = n[i], s = e[r];
    s.start <= o.end ? n[i] = { start: Math.min(o.start, s.start), end: Math.max(o.end, s.end) } : n.push(s);
  }
  return n;
}
function BY(t, e) {
  return t.some(function(n) {
    return e >= n.start && e < n.end;
  });
}
function zv(t) {
  return Fh(t) + Vu;
}
function Fh(t) {
  return Math.floor(t / Vu) * Vu;
}
function Vh(t) {
  var e = { expandedMap: {}, enforceStringMap: {}, visibleSectionsMap: {}, selection: { type: On.value, path: [], edit: !1 }, sortedColumn: null };
  return t != null && t.select && t.json !== void 0 && (e = fe(fe({}, e), {}, { selection: t.select(t.json, e) })), t != null && t.expand && (e = Ai(t.json, e, [], t.expand)), e;
}
function Up(t, e) {
  return t.visibleSectionsMap[e] || Ga;
}
function vy(t, e, n) {
  e.forEach(function(r) {
    var i = r.start, o = r.end;
    F6(i, Math.min(t.length, o), n);
  });
}
function Fv(t, e, n) {
  for (var r = fe({}, e.expandedMap), i = fe({}, e.visibleSectionsMap), o = 0; o < n.length; o++) {
    var s = n.slice(0, o), a = Je(s), l = it(t, s);
    if (Xn(l) && (r[a] = !0), Array.isArray(l) && o < n.length) {
      var c = i[a] || Ga, u = zr(n[o]);
      if (!BY(c, u)) {
        var f = Fh(u), d = { start: f, end: zv(f) };
        i[a] = i5(c.concat(d));
      }
    }
  }
  return fe(fe({}, e), {}, { expandedMap: r, visibleSectionsMap: i });
}
function Ai(t, e, n, r) {
  var i = fe({}, e.expandedMap), o = n.slice(), s = t !== void 0 ? it(t, n) : t;
  return s !== void 0 && function a(l) {
    var c = o.length;
    if (Array.isArray(l)) {
      if (r(o)) {
        var u = Je(o);
        if (i[u] = !0, l.length > 0) {
          var f = Up(e, u);
          vy(l, f, function(g) {
            o[c] = String(g), a(l[g]);
          }), o.pop();
        }
      }
    } else if (Wn(l) && r(o)) {
      i[Je(o)] = !0;
      var d = Object.keys(l);
      if (d.length > 0) {
        var h, p = qr(d);
        try {
          for (p.s(); !(h = p.n()).done; ) {
            var m = h.value;
            o[c] = m, a(l[m]);
          }
        } catch (g) {
          p.e(g);
        } finally {
          p.f();
        }
        o.pop();
      }
    }
  }(s), fe(fe({}, e), {}, { expandedMap: i });
}
function zw(t, e) {
  var n = Fl(t.expandedMap, e), r = Fl(t.enforceStringMap, e), i = Fl(t.visibleSectionsMap, e);
  return fe(fe({}, t), {}, { expandedMap: n, enforceStringMap: r, visibleSectionsMap: i });
}
function o5(t, e, n) {
  if (n) {
    var r = fe({}, t.enforceStringMap);
    return r[e] = n, fe(fe({}, t), {}, { enforceStringMap: r });
  }
  if (typeof t.enforceStringMap[e] == "boolean") {
    var i = fe({}, t.enforceStringMap);
    return delete i[e], fe(fe({}, t), {}, { enforceStringMap: i });
  }
  return t;
}
function s5(t, e, n) {
  var r = so(t, n), i = n.reduce(function(o, s) {
    return bS(s) ? Fw(r, o, s) : xS(s) ? Vw(r, o, s) : T0(s) ? function(a, l, c) {
      var u = c.path, f = Zm(a, l.expandedMap), d = Zm(a, l.enforceStringMap), h = Zm(a, l.visibleSectionsMap);
      return er(c.value) || Tn(c.value) || delete f[u], Tn(c.value) || delete h[u], (er(c.value) || Tn(c.value)) && delete d[u], fe(fe({}, l), {}, { expandedMap: f, enforceStringMap: d, visibleSectionsMap: h });
    }(r, o, s) : wg(s) || Ml(s) ? function(a, l, c) {
      if (Ml(c) && c.from === c.path)
        return l;
      var u = function(y) {
        return c.path + y.substring(c.from.length);
      }, f = Xm(Qm(l.expandedMap, c.from), u), d = Xm(Qm(l.enforceStringMap, c.from), u), h = Xm(Qm(l.visibleSectionsMap, c.from), u), p = l;
      Ml(c) && (p = Vw(a, p, { op: "remove", path: c.from })), p = Fw(a, p, { op: "add", path: c.path, value: null });
      var m = Ym(p.expandedMap, f), g = Ym(p.enforceStringMap, d), v = Ym(p.visibleSectionsMap, h);
      return fe(fe({}, l), {}, { expandedMap: m, enforceStringMap: g, visibleSectionsMap: v });
    }(r, o, s) : o;
  }, e);
  return { json: r, documentState: i };
}
function Fw(t, e, n) {
  var r = Do(t, n.path), i = en(r), o = Je(i), s = it(t, i);
  if (Tn(s)) {
    var a = zr(Yt(r)), l = Vl(e.expandedMap, i, a, 1), c = Vl(e.enforceStringMap, i, a, 1), u = Vl(e.visibleSectionsMap, i, a, 1);
    return u = a5(u, o, function(f) {
      return l5(f, a, 1);
    }), fe(fe({}, e), {}, { expandedMap: l, enforceStringMap: c, visibleSectionsMap: u });
  }
  return e;
}
function Vw(t, e, n) {
  var r = Do(t, n.path), i = en(r), o = Je(i), s = it(t, i), a = e.expandedMap, l = e.enforceStringMap, c = e.visibleSectionsMap;
  if (a = Fl(a, r), l = Fl(l, r), c = Fl(c, r), Tn(s)) {
    var u = zr(Yt(r));
    a = Vl(a, i, u, -1), l = Vl(l, i, u, -1), c = a5(c = Vl(c, i, u, -1), o, function(f) {
      return l5(f, u, -1);
    });
  }
  return fe(fe({}, e), {}, { expandedMap: a, enforceStringMap: l, visibleSectionsMap: c });
}
function Fl(t, e) {
  var n = {}, r = Je(e);
  return Object.keys(t).forEach(function(i) {
    yp(i, r) || (n[i] = t[i]);
  }), n;
}
function Qm(t, e) {
  var n = {};
  return Object.keys(t).forEach(function(r) {
    yp(r, e) && (n[r] = t[r]);
  }), n;
}
function Ym(t, e) {
  return fe(fe({}, t), e);
}
function Xm(t, e) {
  var n = {};
  return Object.keys(t).forEach(function(r) {
    var i = e(r);
    n[i] = t[r];
  }), n;
}
function Vl(t, e, n, r) {
  for (var i = e.length, o = Je(e), s = [], a = 0, l = Object.keys(t); a < l.length; a++) {
    var c = l[a];
    if (yp(c, o)) {
      var u = uo(c), f = zr(u[i]);
      f >= n && (u[i] = String(f + r), s.push({ oldPointer: c, newPointer: Je(u), value: t[c] }));
    }
  }
  if (s.length === 0)
    return t;
  var d = fe({}, t);
  return s.forEach(function(h) {
    delete d[h.oldPointer];
  }), s.forEach(function(h) {
    d[h.newPointer] = h.value;
  }), d;
}
function Zm(t, e) {
  var n = {};
  return Object.keys(e).filter(function(r) {
    return Ri(t, Do(t, r));
  }).forEach(function(r) {
    n[r] = e[r];
  }), n;
}
function a5(t, e, n) {
  var r = t[e];
  if (e in t) {
    var i = n(r);
    if (!tn(r, i)) {
      var o = fe({}, t);
      return i === void 0 ? delete o[e] : o[e] = i, o;
    }
  }
  return t;
}
function l5(t, e, n) {
  return function(r) {
    for (var i = r.slice(0), o = 1; o < i.length; )
      i[o - 1].end === i[o].start && (i[o - 1] = { start: i[o - 1].start, end: i[o].end }, i.splice(o)), o++;
    return i;
  }(t.map(function(r) {
    return { start: r.start > e ? r.start + n : r.start, end: r.end > e ? r.end + n : r.end };
  }));
}
function bs(t, e, n, r) {
  var i = e ? e[n] : void 0;
  return typeof i == "boolean" ? i : function(o, s) {
    return typeof o == "string" && typeof kc(o, s) != "string";
  }(t, r);
}
function bf(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], r = t.indexOf(e);
  return r !== -1 ? n ? t.slice(r) : t.slice(r + 1) : [];
}
function yy(t, e) {
  var n = [];
  return function r(i, o) {
    n.push(o);
    var s = Je(o);
    if (i && e.expandedMap[s] === !0) {
      if (Tn(i)) {
        var a = Up(e, s);
        vy(i, a, function(l) {
          r(i[l], o.concat(String(l)));
        });
      }
      er(i) && Object.keys(i).forEach(function(l) {
        r(i[l], o.concat(l));
      });
    }
  }(t, []), n;
}
function c5(t, e) {
  var n = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], r = [];
  return function i(o, s) {
    r.push({ path: s, type: ro.value });
    var a = Je(s);
    if (o && e.expandedMap[a] === !0) {
      if (n && r.push({ path: s, type: ro.inside }), Tn(o)) {
        var l = Up(e, a);
        vy(o, l, function(c) {
          var u = s.concat(String(c));
          i(o[c], u), n && r.push({ path: u, type: ro.after });
        });
      }
      er(o) && Object.keys(o).forEach(function(c) {
        var u = s.concat(c);
        r.push({ path: u, type: ro.key }), i(o[c], u), n && r.push({ path: u, type: ro.after });
      });
    }
  }(t, []), r;
}
function eg(t, e, n) {
  var r = yy(t, e), i = r.map(Je).indexOf(Je(n));
  return i !== -1 && i < r.length - 1 ? r[i + 1] : null;
}
function Is(t, e, n) {
  var r = it(t, n);
  return r === void 0 ? e : Ai(t, e, n, W6({ json: r }, q6) ? To : du);
}
function To(t) {
  return t.length === 0 || t.length === 1 && t[0] === "0";
}
function du() {
  return !0;
}
function ji(t) {
  return t && t.type === On.after || !1;
}
function vr(t) {
  return t && t.type === On.inside || !1;
}
function dr(t) {
  return t && t.type === On.key || !1;
}
function an(t) {
  return t && t.type === On.value || !1;
}
function Sn(t) {
  return t && t.type === On.multi || !1;
}
function Wp(t) {
  return Sn(t) && tn(t.focusPath, t.anchorPath);
}
function Vv(t) {
  return t && t.type === On.text || !1;
}
function Gs(t, e) {
  var n = [];
  return function(r, i, o) {
    if (i) {
      var s = Na(i), a = mt(i);
      if (tn(s, a))
        return o(s);
      if (r !== void 0) {
        var l = f5(s, a);
        if (s.length === l.length || a.length === l.length)
          return o(l);
        var c = Wr(s, a), u = os(r, c), f = Qs(r, c), d = us(r, c, u), h = us(r, c, f);
        if (!(d === -1 || h === -1)) {
          var p = it(r, l);
          if (er(p)) {
            for (var m = Object.keys(p), g = d; g <= h; g++) {
              var v = o(l.concat(m[g]));
              if (v !== void 0)
                return v;
            }
            return;
          }
          if (Tn(p)) {
            for (var y = d; y <= h; y++) {
              var w = o(l.concat(String(y)));
              if (w !== void 0)
                return w;
            }
            return;
          }
          throw new Error("Failed to create selection");
        }
      }
    }
  }(t, e, function(r) {
    n.push(r);
  }), n;
}
function u5(t) {
  return vr(t) ? t.path : en(mt(t));
}
function os(t, e) {
  if (!Sn(e))
    return e.path;
  var n = us(t, e, e.anchorPath);
  return us(t, e, e.focusPath) < n ? e.focusPath : e.anchorPath;
}
function Qs(t, e) {
  if (!Sn(e))
    return e.path;
  var n = us(t, e, e.anchorPath);
  return us(t, e, e.focusPath) > n ? e.focusPath : e.anchorPath;
}
function Hw(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], r = e.selection;
  if (!r)
    return null;
  var i = n ? mt(r) : os(t, r), o = function(l, c, u) {
    var f = yy(l, c), d = f.map(Je), h = Je(u), p = d.indexOf(h);
    return p !== -1 && p > 0 ? f[p - 1] : null;
  }(t, e, i);
  if (n)
    return vr(r) || ji(r) ? o !== null ? Wr(i, i) : null : o !== null ? Wr(Na(r), o) : null;
  if (ji(r) || vr(r))
    return Wt(i, !1);
  if (dr(r)) {
    if (o == null || o.length === 0)
      return null;
    var s = en(o), a = it(t, s);
    return Array.isArray(a) || nn(o) ? Wt(o, !1) : Li(o, !1);
  }
  return an(r), o !== null ? Wt(o, !1) : null;
}
function Uw(t, e, n) {
  var r = e.selection;
  if (!r)
    return { caret: null, previous: null, next: null };
  var i = c5(t, e, n), o = i.findIndex(function(s) {
    return tn(s.path, mt(r)) && String(s.type) === String(r.type);
  });
  return { caret: o !== -1 ? i[o] : null, previous: o !== -1 && o > 0 ? i[o - 1] : null, next: o !== -1 && o < i.length - 1 ? i[o + 1] : null };
}
function pl(t, e) {
  for (var n = yy(t, e), r = 0; r < n.length - 1 && n[r + 1].length > n[r].length; )
    r++;
  var i = n[r];
  return i === void 0 || i.length === 0 || Array.isArray(it(t, en(i))) ? Wt(i, !1) : Li(i, !1);
}
function ac(t, e) {
  if (e.length === 1) {
    var n = ss(e);
    if (n.op === "replace")
      return Wt(Do(t, n.path), !1);
  }
  if (!nn(e) && e.every(function(s) {
    return s.op === "move";
  })) {
    var r = ss(e), i = e.slice(1);
    if ((wg(r) || Ml(r)) && r.from !== r.path && i.every(function(s) {
      return (wg(s) || Ml(s)) && s.from === s.path;
    }))
      return Li(Do(t, r.path), !1);
  }
  var o = e.filter(function(s) {
    return s.op !== "test" && s.op !== "remove" && (s.op !== "move" || s.from !== s.path) && typeof s.path == "string";
  }).map(function(s) {
    return Do(t, s.path);
  });
  return nn(o) ? null : { type: On.multi, anchorPath: ss(o), focusPath: Yt(o) };
}
function f5(t, e) {
  for (var n = 0; n < t.length && n < e.length && t[n] === e[n]; )
    n++;
  return t.slice(0, n);
}
function Hh(t) {
  return dr(t) || an(t) || Wp(t);
}
function Ww(t, e) {
  return Hh(e) && Xn(it(t, mt(e))) ? mt(e) : en(mt(e));
}
function aa(t, e) {
  if (t.length < e.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function Hr(t) {
  var e = t.selection;
  return (dr(e) || an(e)) && e.edit ? fe(fe({}, t), {}, { selection: fe(fe({}, e), {}, { edit: !1 }) }) : t;
}
function Li(t, e) {
  return { type: On.key, path: t, edit: e };
}
function Wt(t, e) {
  return { type: On.value, path: t, edit: e };
}
function xs(t) {
  return { type: On.inside, path: t };
}
function cs(t) {
  return { type: On.after, path: t };
}
function Wr(t, e) {
  var n = f5(t, e), r = t.length > n.length && e.length > n.length;
  return { type: On.multi, anchorPath: r ? n.concat(t[n.length]) : n, focusPath: r ? n.concat(e[n.length]) : n };
}
function d5(t, e, n, r) {
  if (dr(e))
    return String(Yt(e.path));
  if (an(e)) {
    var i = it(t, e.path);
    return typeof i == "string" ? i : r.stringify(i, null, n);
  }
  if (Sn(e)) {
    if (nn(e.focusPath))
      return r.stringify(t, null, n);
    var o = u5(e), s = it(t, o);
    if (Array.isArray(s)) {
      if (Wp(e)) {
        var a = it(t, e.focusPath);
        return r.stringify(a, null, n);
      }
      return Gs(t, e).map(function(l) {
        var c = it(t, l);
        return "".concat(r.stringify(c, null, n), ",");
      }).join(`
`);
    }
    return Gs(t, e).map(function(l) {
      var c = Yt(l), u = it(t, l);
      return "".concat(r.stringify(c), ": ").concat(r.stringify(u, null, n), ",");
    }).join(`
`);
  }
  return null;
}
function Hi(t) {
  return (dr(t) || an(t)) && t.edit === !0;
}
function Sc(t) {
  return dr(t) || an(t) || Sn(t);
}
function Ud(t) {
  return dr(t) || an(t) || Wp(t);
}
function Hv(t) {
  switch (t.type) {
    case ro.key:
      return Li(t.path, !1);
    case ro.value:
      return Wt(t.path, !1);
    case ro.after:
      return cs(t.path);
    case ro.inside:
      return xs(t.path);
  }
}
function Jw(t, e, n) {
  switch (e) {
    case On.key:
      return Li(n, !1);
    case On.value:
      return Wt(n, !1);
    case On.after:
      return cs(n);
    case On.inside:
      return xs(n);
    case On.multi:
    case On.text:
      return Wr(n, n);
  }
}
function Kw(t, e, n) {
  return e && (Uu(t, e, n) || aa(Sn(e) ? en(e.focusPath) : e.path, n)) ? e : null;
}
function Uu(t, e, n) {
  if (t === void 0 || !e)
    return !1;
  if (dr(e) || vr(e) || ji(e))
    return tn(e.path, n);
  if (an(e))
    return aa(n, e.path);
  if (Sn(e)) {
    var r = os(t, e), i = Qs(t, e), o = en(e.focusPath);
    if (!aa(n, o) || n.length <= o.length)
      return !1;
    var s = us(t, e, r), a = us(t, e, i), l = us(t, e, n);
    return l !== -1 && l >= s && l <= a;
  }
  return !1;
}
function us(t, e, n) {
  var r = en(e.focusPath);
  if (!aa(n, r) || n.length <= r.length)
    return -1;
  var i = n[r.length], o = it(t, r);
  if (er(o))
    return Object.keys(o).indexOf(i);
  if (Tn(o)) {
    var s = zr(i);
    if (s < o.length)
      return s;
  }
  return -1;
}
function mt(t) {
  return Sn(t) ? t.focusPath : t.path;
}
function Na(t) {
  return Sn(t) ? t.anchorPath : t.path;
}
function Jo() {
  for (var t = [], e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  for (var i = 0, o = n; i < o.length; i++) {
    var s = o[i];
    if (typeof s == "string" && t.push(s), s && hr(s) === "object")
      for (var a in s)
        Object.hasOwnProperty.call(s, a) && s[a] && t.push(a);
  }
  return t.join(" ");
}
function Wu(t, e) {
  return Jo("jse-value", "jse-" + fy(t, e), { "jse-url": Vp(t), "jse-empty": typeof t == "string" && t.length === 0 });
}
function qY(t) {
  At(t, "svelte-zwlnit", ".jse-value.jse-string.svelte-zwlnit{color:var(--jse-value-color-string, #008000)}.jse-value.jse-object.svelte-zwlnit,.jse-value.jse-array.svelte-zwlnit{min-width:16px;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-value.jse-number.svelte-zwlnit{color:var(--jse-value-color-number, #ee422e)}.jse-value.jse-boolean.svelte-zwlnit{color:var(--jse-value-color-boolean, #ff8c00)}.jse-value.jse-null.svelte-zwlnit{color:var(--jse-value-color-null, #004ed0)}.jse-value.jse-invalid.svelte-zwlnit{color:var(--jse-text-color, #4d4d4d)}.jse-value.jse-url.svelte-zwlnit{color:var(--jse-value-color-url, #008000);text-decoration:underline}div.jse-editable-div.svelte-zwlnit{min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;cursor:text !important;word-break:normal;white-space:pre-wrap;overflow-wrap:anywhere}div.jse-editable-div.jse-short-text.svelte-zwlnit{overflow-wrap:normal}div.jse-editable-div[contenteditable=true].svelte-zwlnit{outline:var(--jse-edit-outline, 2px solid #656565);background:inherit !important;position:relative;border-radius:0;z-index:3}div.jse-editable-div.jse-empty.svelte-zwlnit:not(:focus){outline:1px dotted var(--jse-tag-background, rgba(0, 0, 0, 0.2));-moz-outline-radius:2px}div.jse-editable-div.jse-empty.svelte-zwlnit::after{pointer-events:none;color:var(--jse-tag-background, rgba(0, 0, 0, 0.2))}");
}
function zY(t) {
  var e, n, r, i;
  return { c: function() {
    k(e = H("div"), "role", "textbox"), k(e, "tabindex", "0"), k(e, "class", n = Un(Jo("jse-editable-div", t[2], { "jse-short-text": t[0] })) + " svelte-zwlnit"), k(e, "contenteditable", "true"), k(e, "spellcheck", "false");
  }, m: function(o, s) {
    X(o, e, s), t[13](e), r || (i = [Oe(e, "input", t[3]), Oe(e, "keydown", t[4]), Oe(e, "paste", t[5]), Oe(e, "blur", t[6])], r = !0);
  }, p: function(o, s) {
    5 & Et(s, 1)[0] && n !== (n = Un(Jo("jse-editable-div", o[2], { "jse-short-text": o[0] })) + " svelte-zwlnit") && k(e, "class", n);
  }, i: Pe, o: Pe, d: function(o) {
    o && Y(e), t[13](null), r = !1, An(i);
  } };
}
function FY(t, e, n) {
  var r, i, o = Tr("jsoneditor:EditableDiv"), s = e.value, a = e.shortText, l = a !== void 0 && a, c = e.onChange, u = e.onCancel, f = e.onFind, d = e.onPaste, h = d === void 0 ? nr : d, p = e.onValueClass, m = p === void 0 ? function() {
    return "";
  } : p, g = !1;
  function v() {
    return r ? function(b) {
      return b.replace(/\n$/, "");
    }(r.innerText) : "";
  }
  function y(b) {
    r && n(1, r.innerText = Ya(b), r);
  }
  function w() {
    var b = v();
    b === "" && y(""), n(2, i = m(b));
  }
  function x() {
    g = !0, u();
  }
  return Fi(function() {
    o("onMount", { value: s }), y(s), r && (X6(r), n(1, r.refresh = w, r), n(1, r.cancel = x, r));
  }), Ci(function() {
    var b = v();
    o("onDestroy", { closed: g, value: s, newValue: b }), g || b === s || c(b, Ks.no);
  }), t.$$set = function(b) {
    "value" in b && n(7, s = b.value), "shortText" in b && n(0, l = b.shortText), "onChange" in b && n(8, c = b.onChange), "onCancel" in b && n(9, u = b.onCancel), "onFind" in b && n(10, f = b.onFind), "onPaste" in b && n(11, h = b.onPaste), "onValueClass" in b && n(12, m = b.onValueClass);
  }, t.$$.update = function() {
    4224 & t.$$.dirty && n(2, i = m(s));
  }, [l, r, i, w, function(b) {
    b.stopPropagation();
    var j = da(b);
    if (j === "Escape" && x(), j === "Enter" || j === "Tab") {
      g = !0;
      var $ = v();
      c($, Ks.nextInside);
    }
    j === "Ctrl+F" && (b.preventDefault(), f(!1)), j === "Ctrl+H" && (b.preventDefault(), f(!0));
  }, function(b) {
    if (b.stopPropagation(), h && b.clipboardData) {
      var j = b.clipboardData.getData("text/plain");
      h(j);
    }
  }, function() {
    var b = document.hasFocus(), j = v();
    o("handleBlur", { hasFocus: b, closed: g, value: s, newValue: j }), document.hasFocus() && !g && (g = !0, j !== s && c(j, Ks.self));
  }, s, c, u, f, h, m, function(b) {
    Kt[b ? "unshift" : "push"](function() {
      n(1, r = b);
    });
  }];
}
var h5 = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, FY, zY, Pt, { value: 7, shortText: 0, onChange: 8, onCancel: 9, onFind: 10, onPaste: 11, onValueClass: 12 }, qY), i;
  }
  return Ye(n);
}();
function VY(t) {
  var e, n;
  return e = new h5({ props: { value: t[1].escapeValue(t[0]), onChange: t[3], onCancel: t[4], onPaste: t[5], onFind: t[2], onValueClass: t[6] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = Et(i, 1)[0], s = {};
    3 & o && (s.value = r[1].escapeValue(r[0])), 4 & o && (s.onFind = r[2]), e.$set(s);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function HY(t, e, n) {
  var r = e.path, i = e.value, o = e.parser, s = e.normalization, a = e.enforceString, l = e.onPatch, c = e.onPasteJson, u = e.onSelect, f = e.onFind, d = e.focus, h = e.findNextInside;
  function p(m) {
    return a ? m : kc(m, o);
  }
  return t.$$set = function(m) {
    "path" in m && n(7, r = m.path), "value" in m && n(0, i = m.value), "parser" in m && n(8, o = m.parser), "normalization" in m && n(1, s = m.normalization), "enforceString" in m && n(9, a = m.enforceString), "onPatch" in m && n(10, l = m.onPatch), "onPasteJson" in m && n(11, c = m.onPasteJson), "onSelect" in m && n(12, u = m.onSelect), "onFind" in m && n(2, f = m.onFind), "focus" in m && n(13, d = m.focus), "findNextInside" in m && n(14, h = m.findNextInside);
  }, [i, s, f, function(m, g) {
    l([{ op: "replace", path: Je(r), value: p(s.unescapeValue(m)) }], function(v, y) {
      if (!y.selection || tn(r, mt(y.selection))) {
        var w = g === Ks.nextInside ? h(r) : Wt(r, !1);
        return { state: fe(fe({}, y), {}, { selection: w }) };
      }
    }), d();
  }, function() {
    u(Wt(r, !1)), d();
  }, function(m) {
    try {
      var g = o.parse(m);
      Xn(g) && c({ path: r, contents: g });
    } catch {
    }
  }, function(m) {
    return Wu(p(s.unescapeValue(m)), o);
  }, r, o, a, l, c, u, d, h];
}
var UY = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, HY, VY, Pt, { path: 7, value: 0, parser: 8, normalization: 1, enforceString: 9, onPatch: 10, onPasteJson: 11, onSelect: 12, onFind: 2, focus: 13, findNextInside: 14 }), i;
  }
  return Ye(n);
}();
function El(t, e, n) {
  var r = en(e), i = it(t, r);
  if (Tn(i)) {
    var o = zr(Yt(e));
    return n.map(function(c, u) {
      return { op: "add", path: Je(r.concat(String(o + u))), value: c.value };
    });
  }
  if (er(i)) {
    var s = Yt(e), a = Object.keys(i), l = s !== void 0 ? bf(a, s, !0) : [];
    return [].concat(Ft(n.map(function(c) {
      var u = yf(c.key, a);
      return { op: "add", path: Je(r.concat(u)), value: c.value };
    })), Ft(l.map(function(c) {
      return Xa(r, c);
    })));
  }
  throw new Error("Cannot create insert operations: parent must be an Object or Array");
}
function Uv(t, e, n) {
  var r = it(t, e);
  if (Array.isArray(r)) {
    var i = r.length;
    return n.map(function(o, s) {
      return { op: "add", path: Je(e.concat(String(i + s))), value: o.value };
    });
  }
  return n.map(function(o) {
    var s = yf(o.key, Object.keys(r));
    return { op: "add", path: Je(e.concat(s)), value: o.value };
  });
}
function xf(t, e, n, r) {
  var i = yf(r, e.filter(function(s) {
    return s !== n;
  })), o = bf(e, n, !1);
  return [{ op: "move", from: Je(t.concat(n)), path: Je(t.concat(i)) }].concat(Ft(o.map(function(s) {
    return Xa(t, s);
  })));
}
function p5(t, e) {
  var n = Yt(e);
  if (nn(n))
    throw new Error("Cannot duplicate root object");
  var r = en(n), i = Yt(n), o = it(t, r);
  if (Tn(o)) {
    var s = Yt(e), a = s ? zr(Yt(s)) + 1 : 0;
    return Ft(e.map(function(u, f) {
      return { op: "copy", from: Je(u), path: Je(r.concat(String(f + a))) };
    }));
  }
  if (er(o)) {
    var l = Object.keys(o), c = i !== void 0 ? bf(l, i, !1) : [];
    return [].concat(Ft(e.map(function(u) {
      var f = yf(Yt(u), l);
      return { op: "copy", from: Je(u), path: Je(r.concat(f)) };
    })), Ft(c.map(function(u) {
      return Xa(r, u);
    })));
  }
  throw new Error("Cannot create duplicate operations: parent must be an Object or Array");
}
function m5(t, e, n, r) {
  if (dr(e)) {
    var i = V6(n, r), o = en(e.path), s = it(t, o);
    return xf(o, Object.keys(s), Yt(e.path), typeof i == "string" ? i : n);
  }
  if (an(e) || Sn(e) && nn(e.focusPath))
    try {
      return [{ op: "replace", path: Je(mt(e)), value: Hp(n, function(j) {
        return gf(j, r);
      }) }];
    } catch {
      return [{ op: "replace", path: Je(mt(e)), value: n }];
    }
  if (Sn(e)) {
    var a = tg(n, r);
    return function(j, $, N) {
      var B = ss($), O = en(B), I = it(j, O);
      if (Tn(I)) {
        var P = ss($), J = P ? zr(Yt(P)) : 0;
        return [].concat(Ft(Uh($)), Ft(N.map(function(C, F) {
          return { op: "add", path: Je(O.concat(String(F + J))), value: C.value };
        })));
      }
      if (er(I)) {
        var D = Yt($), Q = en(D), Z = Yt(D), L = Object.keys(I), R = Z !== void 0 ? bf(L, Z, !1) : [], V = new Set($.map(function(C) {
          return Yt(C);
        })), M = L.filter(function(C) {
          return !V.has(C);
        });
        return [].concat(Ft(Uh($)), Ft(N.map(function(C) {
          var F = yf(C.key, M);
          return { op: "add", path: Je(Q.concat(F)), value: C.value };
        })), Ft(R.map(function(C) {
          return Xa(Q, C);
        })));
      }
      throw new Error("Cannot create replace operations: parent must be an Object or Array");
    }(t, Gs(t, e), a);
  }
  if (ji(e)) {
    var l = tg(n, r), c = e.path, u = en(c), f = it(t, u);
    if (Tn(f)) {
      var d = zr(Yt(c));
      return El(t, u.concat(String(d + 1)), l);
    }
    if (er(f)) {
      var h = String(Yt(c)), p = Object.keys(f);
      if (nn(p) || Yt(p) === h)
        return Uv(t, u, l);
      var m = p.indexOf(h), g = p[m + 1];
      return El(t, u.concat(g), l);
    }
    throw new Error("Cannot create insert operations: parent must be an Object or Array");
  }
  if (vr(e)) {
    var v = tg(n, r), y = e.path, w = it(t, y);
    if (Tn(w))
      return El(t, y.concat("0"), v);
    if (er(w)) {
      var x = Object.keys(w);
      if (nn(x))
        return Uv(t, y, v);
      var b = ss(x);
      return El(t, y.concat(b), v);
    }
    throw new Error("Cannot create insert operations: parent must be an Object or Array");
  }
  throw new Error("Cannot insert: unsupported type of selection " + JSON.stringify(e));
}
function Uh(t) {
  return t.map(function(e) {
    return { op: "remove", path: Je(e) };
  }).reverse();
}
function Xa(t, e) {
  return { op: "move", from: Je(t.concat(e)), path: Je(t.concat(e)) };
}
function tg(t, e) {
  var n = /^\s*{/.test(t), r = /^\s*\[/.test(t), i = V6(t, e), o = i !== void 0 ? i : Hp(t, function(s) {
    return gf(s, e);
  });
  return n && Wn(o) || r && Array.isArray(o) ? [{ key: "New item", value: o }] : Array.isArray(o) ? o.map(function(s, a) {
    return { key: "New item " + a, value: s };
  }) : Wn(o) ? Object.keys(o).map(function(s) {
    return { key: s, value: o[s] };
  }) : [{ key: "New item", value: o }];
}
function g5(t, e) {
  if (dr(e)) {
    var n = en(e.path), r = it(t, n), i = xf(n, Object.keys(r), Yt(e.path), "");
    return { operations: i, newSelection: ac(t, i) };
  }
  if (an(e))
    return { operations: [{ op: "replace", path: Je(e.path), value: "" }], newSelection: e };
  if (Sn(e)) {
    var o = Gs(t, e), s = Uh(o), a = Yt(o);
    if (nn(a))
      return { operations: [{ op: "replace", path: "", value: "" }], newSelection: Wt([], !1) };
    var l = en(a), c = it(t, l);
    if (Tn(c)) {
      var u = ss(o), f = zr(Yt(u));
      return { operations: s, newSelection: f === 0 ? xs(l) : cs(l.concat(String(f - 1))) };
    }
    if (er(c)) {
      var d = Object.keys(c), h = ss(o), p = Yt(h), m = d.indexOf(p), g = d[m - 1];
      return { operations: s, newSelection: m === 0 ? xs(l) : cs(l.concat(g)) };
    }
    throw new Error("Cannot create remove operations: parent must be an Object or Array");
  }
  throw new Error("Cannot remove: unsupported type of selection " + JSON.stringify(e));
}
function v5(t, e) {
  return SS(t, e, { before: function(n, r, i) {
    if (xS(r)) {
      var o = uo(r.path);
      return { revertOperations: [].concat(Ft(i), Ft(Gw(n, o))) };
    }
    if (Ml(r)) {
      var s = uo(r.from);
      return { revertOperations: [].concat(Ft(i), Ft(Gw(n, s))) };
    }
    return { revertOperations: i };
  } });
}
function Gw(t, e) {
  var n = en(e), r = Yt(e), i = it(t, n);
  return er(i) ? bf(Object.keys(i), r, !1).map(function(o) {
    return Xa(n, o);
  }) : [];
}
function WY(t) {
  var e = t.activeIndex < t.items.length - 1 ? t.activeIndex + 1 : t.items.length > 0 ? 0 : -1, n = t.items[e], r = t.items.map(function(i, o) {
    return fe(fe({}, i), {}, { active: o === e });
  });
  return fe(fe({}, t), {}, { items: r, itemsMap: vp(r, function(i) {
    return Je(i.path);
  }), activeItem: n, activeIndex: e });
}
function JY(t) {
  var e = t.activeIndex > 0 ? t.activeIndex - 1 : t.items.length - 1, n = t.items[e], r = t.items.map(function(i, o) {
    return fe(fe({}, i), {}, { active: o === e });
  });
  return fe(fe({}, t), {}, { items: r, itemsMap: vp(r, function(i) {
    return Je(i.path);
  }), activeItem: n, activeIndex: e });
}
function y5(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1 / 0, r = [], i = [];
  function o(s) {
    r.length < n && r.push(s);
  }
  return typeof t == "string" && t !== "" && function s(a, l) {
    if (Tn(l)) {
      var c = i.length;
      i.push("0");
      for (var u = 0; u < l.length; u++)
        if (i[c] = String(u), s(a, l[u]), r.length >= n)
          return;
      i.pop();
    } else if (er(l)) {
      var f = Object.keys(l), d = i.length;
      i.push("");
      for (var h = 0, p = f; h < p.length; h++) {
        var m = p[h];
        if (i[d] = m, Qw(m, a, i, lo.key, o), s(a, l[m]), r.length >= n)
          return;
      }
      i.pop();
    } else
      Qw(String(l), a, i, lo.value, o);
  }(t.toLowerCase(), e), r;
}
function Qw(t, e, n, r, i) {
  var o = t.toLowerCase(), s = 0, a = -1, l = -1;
  do
    (l = o.indexOf(e, a)) !== -1 && (a = l + e.length, i({ path: n.slice(0), field: r, fieldIndex: s, start: l, end: a }), s++);
  while (l !== -1);
}
function Wv(t, e, n, r) {
  return t.substring(0, n) + e + t.substring(r);
}
function Yw(t, e, n) {
  var r = t;
  return qI(n, function(i) {
    r = Wv(r, e, i.start, i.end);
  }), r;
}
function KY(t, e, n, r, i) {
  var o = r.field, s = r.path, a = r.start, l = r.end;
  if (o === lo.key) {
    var c = en(s), u = it(t, c), f = Yt(s), d = xf(c, Object.keys(u), f, Wv(f, n, a, l));
    return { newSelection: ac(t, d), operations: d };
  }
  if (o === lo.value) {
    var h = it(t, s);
    if (h === void 0)
      throw new Error("Cannot replace: path not found ".concat(Je(s)));
    var p = typeof h == "string" ? h : String(h), m = Je(s), g = bs(h, e.enforceStringMap, m, i), v = Wv(p, n, a, l), y = [{ op: "replace", path: Je(s), value: g ? v : kc(v, i) }];
    return { newSelection: ac(t, y), operations: y };
  }
  throw new Error("Cannot replace: unknown type of search result field ".concat(o));
}
function GY(t, e, n, r, i) {
  for (var o = y5(n, t, 1 / 0), s = [], a = 0; a < o.length; a++) {
    var l = o[a - 1], c = o[a];
    a !== 0 && c.field === l.field && tn(c.path, l.path) ? Yt(s).items.push(c) : s.push({ path: c.path, field: c.field, items: [c] });
  }
  s.sort(function(d, h) {
    return d.field !== h.field ? d.field === lo.key ? 1 : -1 : h.path.length - d.path.length;
  });
  var u = [], f = null;
  return s.forEach(function(d) {
    var h = d.field, p = d.path, m = d.items;
    if (h === lo.key) {
      var g = en(p), v = it(t, g), y = Yt(p), w = xf(g, Object.keys(v), y, Yw(y, r, m));
      u = u.concat(w), f = ac(t, w);
    } else {
      if (h !== lo.value)
        throw new Error("Cannot replace: unknown type of search result field ".concat(h));
      var x = it(t, p);
      if (x === void 0)
        throw new Error("Cannot replace: path not found ".concat(Je(p)));
      var b = typeof x == "string" ? x : String(x), j = Je(p), $ = bs(x, e.enforceStringMap, j, i), N = Yw(b, r, m), B = [{ op: "replace", path: Je(p), value: $ ? N : kc(N, i) }];
      u = u.concat(B), f = ac(t, B);
    }
  }), { operations: u, newSelection: f };
}
function Xw(t) {
  return t.path.concat(t.field, String(t.fieldIndex));
}
function QY(t, e) {
  var n, r = t == null || (n = t[e]) === null || n === void 0 ? void 0 : n.filter(function(i) {
    return i.field === lo.key;
  });
  if (r && r.length !== 0)
    return r;
}
function Zw(t, e) {
  var n, r = t == null || (n = t[e]) === null || n === void 0 ? void 0 : n.filter(function(i) {
    return i.field === lo.value;
  });
  if (r && r.length !== 0)
    return r;
}
function YY(t) {
  At(t, "svelte-1n1l5ny", ".jse-highlight.svelte-1n1l5ny{background-color:var(--jse-search-match-color, #ffe665);outline:var(--jse-search-match-outline, 1px solid #ffd700)}.jse-highlight.jse-active.svelte-1n1l5ny{background-color:var(--jse-search-match-active-color, #ffd700);outline:var(--jse-search-match-active-outline, 1px solid #e1be00)}");
}
function ej(t, e, n) {
  var r = t.slice();
  return r[3] = e[n], r;
}
function XY(t) {
  var e, n, r = Ya(t[3].text) + "";
  return { c: function() {
    e = H("span"), n = Le(r), k(e, "class", "jse-highlight svelte-1n1l5ny"), $e(e, "jse-active", t[3].active);
  }, m: function(i, o) {
    X(i, e, o), T(e, n);
  }, p: function(i, o) {
    1 & o && r !== (r = Ya(i[3].text) + "") && bt(n, r), 1 & o && $e(e, "jse-active", i[3].active);
  }, d: function(i) {
    i && Y(e);
  } };
}
function ZY(t) {
  var e, n = t[3].text + "";
  return { c: function() {
    e = Le(n);
  }, m: function(r, i) {
    X(r, e, i);
  }, p: function(r, i) {
    1 & i && n !== (n = r[3].text + "") && bt(e, n);
  }, d: function(r) {
    r && Y(e);
  } };
}
function tj(t) {
  var e;
  function n(o, s) {
    return o[3].type === "normal" ? ZY : XY;
  }
  var r = n(t), i = r(t);
  return { c: function() {
    i.c(), e = un();
  }, m: function(o, s) {
    i.m(o, s), X(o, e, s);
  }, p: function(o, s) {
    r === (r = n(o)) && i ? i.p(o, s) : (i.d(1), (i = r(o)) && (i.c(), i.m(e.parentNode, e)));
  }, d: function(o) {
    o && Y(e), i.d(o);
  } };
}
function eX(t) {
  for (var e, n = Ot(t[0]), r = [], i = 0; i < n.length; i += 1)
    r[i] = tj(ej(t, n, i));
  return { c: function() {
    for (var o = 0; o < r.length; o += 1)
      r[o].c();
    e = un();
  }, m: function(o, s) {
    for (var a = 0; a < r.length; a += 1)
      r[a] && r[a].m(o, s);
    X(o, e, s);
  }, p: function(o, s) {
    var a = Et(s, 1)[0];
    if (1 & a) {
      var l;
      for (n = Ot(o[0]), l = 0; l < n.length; l += 1) {
        var c = ej(o, n, l);
        r[l] ? r[l].p(c, a) : (r[l] = tj(c), r[l].c(), r[l].m(e.parentNode, e));
      }
      for (; l < r.length; l += 1)
        r[l].d(1);
      r.length = n.length;
    }
  }, i: Pe, o: Pe, d: function(o) {
    o && Y(e), fr(r, o);
  } };
}
function tX(t, e, n) {
  var r, i = e.text, o = e.searchResultItems;
  return t.$$set = function(s) {
    "text" in s && n(1, i = s.text), "searchResultItems" in s && n(2, o = s.searchResultItems);
  }, t.$$.update = function() {
    6 & t.$$.dirty && n(0, r = function(s, a) {
      var l, c = [], u = 0, f = qr(a);
      try {
        for (f.s(); !(l = f.n()).done; ) {
          var d = l.value, h = s.slice(u, d.start);
          h !== "" && c.push({ type: "normal", text: h, active: !1 });
          var p = s.slice(d.start, d.end);
          c.push({ type: "highlight", text: p, active: d.active }), u = d.end;
        }
      } catch (g) {
        f.e(g);
      } finally {
        f.f();
      }
      var m = Yt(a);
      return m && m.end < s.length && c.push({ type: "normal", text: s.slice(m.end), active: !1 }), c;
    }(String(i), o));
  }, [r, i, o];
}
var b5 = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, tX, eX, wr, { text: 1, searchResultItems: 2 }, YY), i;
  }
  return Ye(n);
}();
function nX(t) {
  At(t, "svelte-1v88515", '.jse-value.jse-string.svelte-1v88515{color:var(--jse-value-color-string, #008000)}.jse-value.jse-object.svelte-1v88515,.jse-value.jse-array.svelte-1v88515{min-width:16px;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-value.jse-number.svelte-1v88515{color:var(--jse-value-color-number, #ee422e)}.jse-value.jse-boolean.svelte-1v88515{color:var(--jse-value-color-boolean, #ff8c00)}.jse-value.jse-null.svelte-1v88515{color:var(--jse-value-color-null, #004ed0)}.jse-value.jse-invalid.svelte-1v88515{color:var(--jse-text-color, #4d4d4d)}.jse-value.jse-url.svelte-1v88515{color:var(--jse-value-color-url, #008000);text-decoration:underline}.jse-value.svelte-1v88515{min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;cursor:var(--jse-contents-cursor, pointer);word-break:normal;overflow-wrap:anywhere;white-space:pre-wrap}.jse-value.svelte-1v88515:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-value.jse-empty.svelte-1v88515{min-width:4em;outline:1px dotted var(--jse-tag-background, rgba(0, 0, 0, 0.2));-moz-outline-radius:2px}.jse-value.jse-empty.svelte-1v88515::after{pointer-events:none;color:var(--jse-tag-background, rgba(0, 0, 0, 0.2));content:"value"}');
}
function rX(t) {
  var e, n = Ya(t[1].escapeValue(t[0])) + "";
  return { c: function() {
    e = Le(n);
  }, m: function(r, i) {
    X(r, e, i);
  }, p: function(r, i) {
    3 & i && n !== (n = Ya(r[1].escapeValue(r[0])) + "") && bt(e, n);
  }, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
function iX(t) {
  var e, n;
  return e = new b5({ props: { text: t[1].escapeValue(t[0]), searchResultItems: t[3] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    3 & i && (o.text = r[1].escapeValue(r[0])), 8 & i && (o.searchResultItems = r[3]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function oX(t) {
  var e, n, r, i, o, s, a, l, c = [iX, rX], u = [];
  function f(d, h) {
    return d[3] ? 0 : 1;
  }
  return n = f(t), r = u[n] = c[n](t), { c: function() {
    e = H("div"), r.c(), k(e, "role", "button"), k(e, "tabindex", "-1"), k(e, "data-type", "selectable-value"), k(e, "class", i = Un(Wu(t[0], t[2])) + " svelte-1v88515"), k(e, "title", o = t[4] ? "Ctrl+Click or Ctrl+Enter to open url in new window" : null);
  }, m: function(d, h) {
    X(d, e, h), u[n].m(e, null), s = !0, a || (l = [Oe(e, "click", t[5]), Oe(e, "dblclick", t[6])], a = !0);
  }, p: function(d, h) {
    var p = Et(h, 1)[0], m = n;
    (n = f(d)) === m ? u[n].p(d, p) : (Ae(), _(u[m], 1, 1, function() {
      u[m] = null;
    }), Me(), (r = u[n]) ? r.p(d, p) : (r = u[n] = c[n](d)).c(), S(r, 1), r.m(e, null)), (!s || 5 & p && i !== (i = Un(Wu(d[0], d[2])) + " svelte-1v88515")) && k(e, "class", i), (!s || 16 & p && o !== (o = d[4] ? "Ctrl+Click or Ctrl+Enter to open url in new window" : null)) && k(e, "title", o);
  }, i: function(d) {
    s || (S(r), s = !0);
  }, o: function(d) {
    _(r), s = !1;
  }, d: function(d) {
    d && Y(e), u[n].d(), a = !1, An(l);
  } };
}
function sX(t, e, n) {
  var r, i = e.path, o = e.value, s = e.readOnly, a = e.normalization, l = e.parser, c = e.onSelect, u = e.searchResultItems;
  return t.$$set = function(f) {
    "path" in f && n(7, i = f.path), "value" in f && n(0, o = f.value), "readOnly" in f && n(8, s = f.readOnly), "normalization" in f && n(1, a = f.normalization), "parser" in f && n(2, l = f.parser), "onSelect" in f && n(9, c = f.onSelect), "searchResultItems" in f && n(3, u = f.searchResultItems);
  }, t.$$.update = function() {
    1 & t.$$.dirty && n(4, r = Vp(o));
  }, [o, a, l, u, r, function(f) {
    typeof o == "string" && r && f.ctrlKey && (f.preventDefault(), f.stopPropagation(), window.open(o, "_blank"));
  }, function(f) {
    s || (f.preventDefault(), c(Wt(i, !0)));
  }, i, s, c];
}
var aX = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, sX, oX, Pt, { path: 7, value: 0, readOnly: 8, normalization: 1, parser: 2, onSelect: 9, searchResultItems: 3 }, nX), i;
  }
  return Ye(n);
}();
function lX(t) {
  At(t, "svelte-1sftg37", '.jse-tooltip.svelte-1sftg37{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);border-radius:3px;background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));white-space:nowrap;box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}');
}
function cX(t) {
  var e, n;
  return { c: function() {
    e = H("div"), n = Le(t[0]), k(e, "class", "jse-tooltip svelte-1sftg37");
  }, m: function(r, i) {
    X(r, e, i), T(e, n);
  }, p: function(r, i) {
    1 & Et(i, 1)[0] && bt(n, r[0]);
  }, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
function uX(t, e, n) {
  var r = e.text;
  return t.$$set = function(i) {
    "text" in i && n(0, r = i.text);
  }, [r];
}
var fX = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, uX, cX, wr, { text: 0 }, lX), i;
  }
  return Ye(n);
}();
function by(t, e) {
  var n, r = e.text, i = e.openAbsolutePopup, o = e.closeAbsolutePopup;
  function s() {
    n = i(fX, { text: r }, { position: "top", width: 10 * r.length, offsetTop: 3, anchor: t, closeOnOuterClick: !0 });
  }
  function a() {
    o(n);
  }
  return t.addEventListener("mouseenter", s), t.addEventListener("mouseleave", a), { destroy: function() {
    t.removeEventListener("mouseenter", s), t.removeEventListener("mouseleave", a);
  } };
}
function dX(t) {
  At(t, "svelte-1sqrs1u", ".jse-timestamp.svelte-1sqrs1u{padding:0;margin:0;vertical-align:middle;display:inline-flex;color:var(--jse-value-color-number, #ee422e)}");
}
function hX(t) {
  var e, n, r, i, o, s;
  return n = new cn({ props: { data: zL } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), k(e, "class", "jse-timestamp svelte-1sqrs1u");
  }, m: function(a, l) {
    X(a, e, l), ye(n, e, null), i = !0, o || (s = Mr(r = by.call(null, e, fe({ text: t[0] }, t[1]))), o = !0);
  }, p: function(a, l) {
    var c = Et(l, 1)[0];
    r && Ar(r.update) && 1 & c && r.update.call(null, fe({ text: a[0] }, a[1]));
  }, i: function(a) {
    i || (S(n.$$.fragment, a), i = !0);
  }, o: function(a) {
    _(n.$$.fragment, a), i = !1;
  }, d: function(a) {
    a && Y(e), be(n), o = !1, s();
  } };
}
function pX(t, e, n) {
  var r, i = _r("absolute-popup"), o = e.value;
  return t.$$set = function(s) {
    "value" in s && n(2, o = s.value);
  }, t.$$.update = function() {
    4 & t.$$.dirty && n(0, r = "Time: ".concat(new Date(o).toString()));
  }, [r, i, o];
}
var mX = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, pX, hX, Pt, { value: 2 }, dX), i;
  }
  return Ye(n);
}();
function gX(t) {
  var e = t.path, n = t.value, r = t.readOnly, i = t.enforceString, o = t.searchResultItems, s = t.isEditing, a = t.parser, l = t.normalization, c = t.onPatch, u = t.onPasteJson, f = t.onSelect, d = t.onFind, h = t.findNextInside, p = t.focus, m = [];
  return !s && /* @__PURE__ */ function(g) {
    return g === !0 || g === !1;
  }(n) && m.push({ component: MY, props: { path: e, value: n, readOnly: r, onPatch: c, focus: p } }), !s && function(g) {
    return typeof g == "string" && !!z6(g);
  }(n) && m.push({ component: LY, props: { path: e, value: n, readOnly: r, onPatch: c, focus: p } }), s && m.push({ component: UY, props: { path: e, value: n, enforceString: i, parser: a, normalization: l, onPatch: c, onPasteJson: u, onSelect: f, onFind: d, findNextInside: h, focus: p } }), s || m.push({ component: aX, props: { path: e, value: n, readOnly: r, parser: a, normalization: l, searchResultItems: o, onSelect: f } }), !s && Lv(n) && m.push({ component: mX, props: { value: n } }), m;
}
var Bc = {}, hd = { showWizard: !0, showOriginal: !0 }, Wh = Math.min, Ia = Math.max, Jh = Math.round, pd = Math.floor, la = function(t) {
  return { x: t, y: t };
}, vX = { left: "right", right: "left", bottom: "top", top: "bottom" }, yX = { start: "end", end: "start" };
function nj(t, e, n) {
  return Ia(t, Wh(e, n));
}
function Jp(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Za(t) {
  return t.split("-")[0];
}
function Kp(t) {
  return t.split("-")[1];
}
function x5(t) {
  return t === "x" ? "y" : "x";
}
function w5(t) {
  return t === "y" ? "height" : "width";
}
function Gp(t) {
  return ["top", "bottom"].includes(Za(t)) ? "y" : "x";
}
function j5(t) {
  return x5(Gp(t));
}
function bX(t, e, n) {
  n === void 0 && (n = !1);
  var r = Kp(t), i = j5(t), o = w5(i), s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (s = Kh(s)), [s, Kh(s)];
}
function xX(t) {
  var e = Kh(t);
  return [Jv(t), e, Jv(e)];
}
function Jv(t) {
  return t.replace(/start|end/g, function(e) {
    return yX[e];
  });
}
function wX(t, e, n, r) {
  var i = Kp(t), o = function(s, a, l) {
    var c = ["left", "right"], u = ["right", "left"];
    switch (s) {
      case "top":
      case "bottom":
        return l ? a ? u : c : a ? c : u;
      case "left":
      case "right":
        return a ? ["top", "bottom"] : ["bottom", "top"];
      default:
        return [];
    }
  }(Za(t), n === "start", r);
  return i && (o = o.map(function(s) {
    return s + "-" + i;
  }), e && (o = o.concat(o.map(Jv)))), o;
}
function Kh(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return vX[e];
  });
}
function jX(t) {
  return typeof t != "number" ? function(e) {
    return fe({ top: 0, right: 0, bottom: 0, left: 0 }, e);
  }(t) : { top: t, right: t, bottom: t, left: t };
}
function Gh(t) {
  return fe(fe({}, t), {}, { top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height });
}
function rj(t, e, n) {
  var r, i = t.reference, o = t.floating, s = Gp(e), a = j5(e), l = w5(a), c = Za(e), u = s === "y", f = i.x + i.width / 2 - o.width / 2, d = i.y + i.height / 2 - o.height / 2, h = i[l] / 2 - o[l] / 2;
  switch (c) {
    case "top":
      r = { x: f, y: i.y - o.height };
      break;
    case "bottom":
      r = { x: f, y: i.y + i.height };
      break;
    case "right":
      r = { x: i.x + i.width, y: d };
      break;
    case "left":
      r = { x: i.x - o.width, y: d };
      break;
    default:
      r = { x: i.x, y: i.y };
  }
  switch (Kp(e)) {
    case "start":
      r[a] -= h * (n && u ? -1 : 1);
      break;
    case "end":
      r[a] += h * (n && u ? -1 : 1);
  }
  return r;
}
var kX = function() {
  var t = Tt(Ie().mark(function e(n, r, i) {
    var o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N, B, O, I, P, J, D;
    return Ie().wrap(function(Q) {
      for (; ; )
        switch (Q.prev = Q.next) {
          case 0:
            return o = i.placement, s = o === void 0 ? "bottom" : o, a = i.strategy, l = a === void 0 ? "absolute" : a, c = i.middleware, u = c === void 0 ? [] : c, f = i.platform, d = u.filter(Boolean), Q.next = 4, f.isRTL == null ? void 0 : f.isRTL(r);
          case 4:
            return h = Q.sent, Q.next = 7, f.getElementRects({ reference: n, floating: r, strategy: l });
          case 7:
            p = Q.sent, m = rj(p, s, h), g = m.x, v = m.y, y = s, w = {}, x = 0, b = 0;
          case 13:
            if (!(b < d.length)) {
              Q.next = 46;
              break;
            }
            return j = d[b], $ = j.name, N = j.fn, Q.next = 17, N({ x: g, y: v, initialPlacement: s, placement: y, strategy: l, middlewareData: w, rects: p, platform: f, elements: { reference: n, floating: r } });
          case 17:
            if (B = Q.sent, O = B.x, I = B.y, P = B.data, J = B.reset, g = O ?? g, v = I ?? v, w = fe(fe({}, w), {}, Si({}, $, fe(fe({}, w[$]), P))), !(J && x <= 50)) {
              Q.next = 43;
              break;
            }
            if (x++, hr(J) !== "object") {
              Q.next = 41;
              break;
            }
            if (J.placement && (y = J.placement), !J.rects) {
              Q.next = 38;
              break;
            }
            if (J.rects !== !0) {
              Q.next = 36;
              break;
            }
            return Q.next = 33, f.getElementRects({ reference: n, floating: r, strategy: l });
          case 33:
            Q.t0 = Q.sent, Q.next = 37;
            break;
          case 36:
            Q.t0 = J.rects;
          case 37:
            p = Q.t0;
          case 38:
            D = rj(p, y, h), g = D.x, v = D.y;
          case 41:
            return b = -1, Q.abrupt("continue", 43);
          case 43:
            b++, Q.next = 13;
            break;
          case 46:
            return Q.abrupt("return", { x: g, y: v, placement: y, strategy: l, middlewareData: w });
          case 47:
          case "end":
            return Q.stop();
        }
    }, e);
  }));
  return function(e, n, r) {
    return t.apply(this, arguments);
  };
}();
function k5(t, e) {
  return Kv.apply(this, arguments);
}
function Kv() {
  return Kv = Tt(Ie().mark(function t(e, n) {
    var r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N, B, O, I;
    return Ie().wrap(function(P) {
      for (; ; )
        switch (P.prev = P.next) {
          case 0:
            return n === void 0 && (n = {}), i = e.x, o = e.y, s = e.platform, a = e.rects, l = e.elements, c = e.strategy, u = Jp(n, e), f = u.boundary, d = f === void 0 ? "clippingAncestors" : f, h = u.rootBoundary, p = h === void 0 ? "viewport" : h, m = u.elementContext, g = m === void 0 ? "floating" : m, v = u.altBoundary, y = v !== void 0 && v, w = u.padding, x = jX(w === void 0 ? 0 : w), b = g === "floating" ? "reference" : "floating", j = l[y ? b : g], P.t0 = Gh, P.t1 = s, P.next = 10, s.isElement == null ? void 0 : s.isElement(j);
          case 10:
            if (P.t2 = r = P.sent, P.t2 == null) {
              P.next = 15;
              break;
            }
            P.t3 = r, P.next = 16;
            break;
          case 15:
            P.t3 = !0;
          case 16:
            if (!P.t3) {
              P.next = 20;
              break;
            }
            P.t4 = j, P.next = 26;
            break;
          case 20:
            if (P.t5 = j.contextElement, P.t5) {
              P.next = 25;
              break;
            }
            return P.next = 24, s.getDocumentElement == null ? void 0 : s.getDocumentElement(l.floating);
          case 24:
            P.t5 = P.sent;
          case 25:
            P.t4 = P.t5;
          case 26:
            return P.t6 = P.t4, P.t7 = d, P.t8 = p, P.t9 = c, P.t10 = { element: P.t6, boundary: P.t7, rootBoundary: P.t8, strategy: P.t9 }, P.next = 33, P.t1.getClippingRect.call(P.t1, P.t10);
          case 33:
            return P.t11 = P.sent, $ = (0, P.t0)(P.t11), N = g === "floating" ? fe(fe({}, a.floating), {}, { x: i, y: o }) : a.reference, P.next = 38, s.getOffsetParent == null ? void 0 : s.getOffsetParent(l.floating);
          case 38:
            return B = P.sent, P.next = 41, s.isElement == null ? void 0 : s.isElement(B);
          case 41:
            if (!P.sent) {
              P.next = 50;
              break;
            }
            return P.next = 44, s.getScale == null ? void 0 : s.getScale(B);
          case 44:
            if (P.t13 = P.sent, P.t13) {
              P.next = 47;
              break;
            }
            P.t13 = { x: 1, y: 1 };
          case 47:
            P.t12 = P.t13, P.next = 51;
            break;
          case 50:
            P.t12 = { x: 1, y: 1 };
          case 51:
            if (O = P.t12, P.t14 = Gh, !s.convertOffsetParentRelativeRectToViewportRelativeRect) {
              P.next = 59;
              break;
            }
            return P.next = 56, s.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: N, offsetParent: B, strategy: c });
          case 56:
            P.t15 = P.sent, P.next = 60;
            break;
          case 59:
            P.t15 = N;
          case 60:
            return P.t16 = P.t15, I = (0, P.t14)(P.t16), P.abrupt("return", { top: ($.top - I.top + x.top) / O.y, bottom: (I.bottom - $.bottom + x.bottom) / O.y, left: ($.left - I.left + x.left) / O.x, right: (I.right - $.right + x.right) / O.x });
          case 63:
          case "end":
            return P.stop();
        }
    }, t);
  })), Kv.apply(this, arguments);
}
var $X = function(t) {
  return t === void 0 && (t = {}), { name: "flip", options: t, fn: function(e) {
    return Tt(Ie().mark(function n() {
      var r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N, B, O, I, P, J, D, Q, Z, L, R, V, M, C, F, z;
      return Ie().wrap(function(E) {
        for (; ; )
          switch (E.prev = E.next) {
            case 0:
              if (o = e.placement, s = e.middlewareData, a = e.rects, l = e.initialPlacement, c = e.platform, u = e.elements, f = Jp(t, e), d = f.mainAxis, h = d === void 0 || d, p = f.crossAxis, m = p === void 0 || p, g = f.fallbackPlacements, v = f.fallbackStrategy, y = v === void 0 ? "bestFit" : v, w = f.fallbackAxisSideDirection, x = w === void 0 ? "none" : w, b = f.flipAlignment, j = b === void 0 || b, $ = b6(f, pQ), (r = s.arrow) == null || !r.alignmentOffset) {
                E.next = 4;
                break;
              }
              return E.abrupt("return", {});
            case 4:
              return N = Za(o), B = Za(l) === l, E.next = 8, c.isRTL == null ? void 0 : c.isRTL(u.floating);
            case 8:
              return O = E.sent, I = g || (B || !j ? [Kh(l)] : xX(l)), g || x === "none" || I.push.apply(I, Ft(wX(l, j, x, O))), P = [l].concat(Ft(I)), E.next = 14, k5(e, $);
            case 14:
              if (J = E.sent, D = [], Q = ((i = s.flip) == null ? void 0 : i.overflows) || [], h && D.push(J[N]), m && (Z = bX(o, a, O), D.push(J[Z[0]], J[Z[1]])), Q = [].concat(Ft(Q), [{ placement: o, overflows: D }]), D.every(function(A) {
                return A <= 0;
              })) {
                E.next = 37;
                break;
              }
              if (V = (((L = s.flip) == null ? void 0 : L.index) || 0) + 1, !(M = P[V])) {
                E.next = 25;
                break;
              }
              return E.abrupt("return", { data: { index: V, overflows: Q }, reset: { placement: M } });
            case 25:
              if (C = (R = Q.filter(function(A) {
                return A.overflows[0] <= 0;
              }).sort(function(A, te) {
                return A.overflows[1] - te.overflows[1];
              })[0]) == null ? void 0 : R.placement) {
                E.next = 35;
                break;
              }
              E.t0 = y, E.next = E.t0 === "bestFit" ? 30 : E.t0 === "initialPlacement" ? 33 : 35;
              break;
            case 30:
              return z = (F = Q.map(function(A) {
                return [A.placement, A.overflows.filter(function(te) {
                  return te > 0;
                }).reduce(function(te, ge) {
                  return te + ge;
                }, 0)];
              }).sort(function(A, te) {
                return A[1] - te[1];
              })[0]) == null ? void 0 : F[0], z && (C = z), E.abrupt("break", 35);
            case 33:
              return C = l, E.abrupt("break", 35);
            case 35:
              if (o === C) {
                E.next = 37;
                break;
              }
              return E.abrupt("return", { reset: { placement: C } });
            case 37:
              return E.abrupt("return", {});
            case 38:
            case "end":
              return E.stop();
          }
      }, n);
    }))();
  } };
};
function SX(t, e) {
  return Gv.apply(this, arguments);
}
function Gv() {
  return Gv = Tt(Ie().mark(function t(e, n) {
    var r, i, o, s, a, l, c, u, f, d, h, p, m, g;
    return Ie().wrap(function(v) {
      for (; ; )
        switch (v.prev = v.next) {
          case 0:
            return r = e.placement, i = e.platform, o = e.elements, v.next = 3, i.isRTL == null ? void 0 : i.isRTL(o.floating);
          case 3:
            return s = v.sent, a = Za(r), l = Kp(r), c = Gp(r) === "y", u = ["left", "top"].includes(a) ? -1 : 1, f = s && c ? -1 : 1, d = Jp(n, e), h = typeof d == "number" ? { mainAxis: d, crossAxis: 0, alignmentAxis: null } : fe({ mainAxis: 0, crossAxis: 0, alignmentAxis: null }, d), p = h.mainAxis, m = h.crossAxis, g = h.alignmentAxis, l && typeof g == "number" && (m = l === "end" ? -1 * g : g), v.abrupt("return", c ? { x: m * f, y: p * u } : { x: p * u, y: m * f });
          case 13:
          case "end":
            return v.stop();
        }
    }, t);
  })), Gv.apply(this, arguments);
}
var CX = function(t) {
  return t === void 0 && (t = {}), { name: "shift", options: t, fn: function(e) {
    return Tt(Ie().mark(function n() {
      var r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N, B, O;
      return Ie().wrap(function(I) {
        for (; ; )
          switch (I.prev = I.next) {
            case 0:
              return r = e.x, i = e.y, o = e.placement, s = Jp(t, e), a = s.mainAxis, l = a === void 0 || a, c = s.crossAxis, u = c !== void 0 && c, f = s.limiter, d = f === void 0 ? { fn: function(P) {
                return { x: P.x, y: P.y };
              } } : f, h = b6(s, mQ), p = { x: r, y: i }, I.next = 5, k5(e, h);
            case 5:
              return m = I.sent, g = Gp(Za(o)), v = x5(g), y = p[v], w = p[g], l && (x = v === "y" ? "bottom" : "right", b = y + m[v === "y" ? "top" : "left"], j = y - m[x], y = nj(b, y, j)), u && ($ = g === "y" ? "bottom" : "right", N = w + m[g === "y" ? "top" : "left"], B = w - m[$], w = nj(N, w, B)), O = d.fn(fe(fe({}, e), {}, Si(Si({}, v, y), g, w))), I.abrupt("return", fe(fe({}, O), {}, { data: { x: O.x - r, y: O.y - i } }));
            case 14:
            case "end":
              return I.stop();
          }
      }, n);
    }))();
  } };
};
function ca(t) {
  return $5(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function ki(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function fs(t) {
  var e;
  return (e = ($5(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function $5(t) {
  return t instanceof Node || t instanceof ki(t).Node;
}
function ds(t) {
  return t instanceof Element || t instanceof ki(t).Element;
}
function Ko(t) {
  return t instanceof HTMLElement || t instanceof ki(t).HTMLElement;
}
function ij(t) {
  return typeof ShadowRoot < "u" && (t instanceof ShadowRoot || t instanceof ki(t).ShadowRoot);
}
function Ju(t) {
  var e = Bi(t), n = e.overflow, r = e.overflowX, i = e.overflowY, o = e.display;
  return /auto|scroll|overlay|hidden|clip/.test(n + i + r) && !["inline", "contents"].includes(o);
}
function OX(t) {
  return ["table", "td", "th"].includes(ca(t));
}
function Qv(t) {
  var e = xy(), n = Bi(t);
  return n.transform !== "none" || n.perspective !== "none" || !!n.containerType && n.containerType !== "normal" || !e && !!n.backdropFilter && n.backdropFilter !== "none" || !e && !!n.filter && n.filter !== "none" || ["transform", "perspective", "filter"].some(function(r) {
    return (n.willChange || "").includes(r);
  }) || ["paint", "layout", "strict", "content"].some(function(r) {
    return (n.contain || "").includes(r);
  });
}
function xy() {
  return !(typeof CSS > "u" || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function Qp(t) {
  return ["html", "body", "#document"].includes(ca(t));
}
function Bi(t) {
  return ki(t).getComputedStyle(t);
}
function Yp(t) {
  return ds(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function lc(t) {
  if (ca(t) === "html")
    return t;
  var e = t.assignedSlot || t.parentNode || ij(t) && t.host || fs(t);
  return ij(e) ? e.host : e;
}
function S5(t) {
  var e = lc(t);
  return Qp(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Ko(e) && Ju(e) ? e : S5(e);
}
function Ku(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  var i = S5(t), o = i === ((r = t.ownerDocument) == null ? void 0 : r.body), s = ki(i);
  return o ? e.concat(s, s.visualViewport || [], Ju(i) ? i : [], s.frameElement && n ? Ku(s.frameElement) : []) : e.concat(i, Ku(i, [], n));
}
function C5(t) {
  var e = Bi(t), n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0, i = Ko(t), o = i ? t.offsetWidth : n, s = i ? t.offsetHeight : r, a = Jh(n) !== o || Jh(r) !== s;
  return a && (n = o, r = s), { width: n, height: r, $: a };
}
function wy(t) {
  return ds(t) ? t : t.contextElement;
}
function Hl(t) {
  var e = wy(t);
  if (!Ko(e))
    return la(1);
  var n = e.getBoundingClientRect(), r = C5(e), i = r.width, o = r.height, s = r.$, a = (s ? Jh(n.width) : n.width) / i, l = (s ? Jh(n.height) : n.height) / o;
  return a && Number.isFinite(a) || (a = 1), l && Number.isFinite(l) || (l = 1), { x: a, y: l };
}
var EX = la(0);
function O5(t) {
  var e = ki(t);
  return xy() && e.visualViewport ? { x: e.visualViewport.offsetLeft, y: e.visualViewport.offsetTop } : EX;
}
function el(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var i = t.getBoundingClientRect(), o = wy(t), s = la(1);
  e && (r ? ds(r) && (s = Hl(r)) : s = Hl(t));
  var a = function(x, b, j) {
    return b === void 0 && (b = !1), !(!j || b && j !== ki(x)) && b;
  }(o, n, r) ? O5(o) : la(0), l = (i.left + a.x) / s.x, c = (i.top + a.y) / s.y, u = i.width / s.x, f = i.height / s.y;
  if (o)
    for (var d = ki(o), h = r && ds(r) ? ki(r) : r, p = d.frameElement; p && r && h !== d; ) {
      var m = Hl(p), g = p.getBoundingClientRect(), v = Bi(p), y = g.left + (p.clientLeft + parseFloat(v.paddingLeft)) * m.x, w = g.top + (p.clientTop + parseFloat(v.paddingTop)) * m.y;
      l *= m.x, c *= m.y, u *= m.x, f *= m.y, l += y, c += w, p = ki(p).frameElement;
    }
  return Gh({ width: u, height: f, x: l, y: c });
}
function E5(t) {
  return el(fs(t)).left + Yp(t).scrollLeft;
}
function oj(t, e, n) {
  var r;
  if (e === "viewport")
    r = function(o, s) {
      var a = ki(o), l = fs(o), c = a.visualViewport, u = l.clientWidth, f = l.clientHeight, d = 0, h = 0;
      if (c) {
        u = c.width, f = c.height;
        var p = xy();
        (!p || p && s === "fixed") && (d = c.offsetLeft, h = c.offsetTop);
      }
      return { width: u, height: f, x: d, y: h };
    }(t, n);
  else if (e === "document")
    r = function(o) {
      var s = fs(o), a = Yp(o), l = o.ownerDocument.body, c = Ia(s.scrollWidth, s.clientWidth, l.scrollWidth, l.clientWidth), u = Ia(s.scrollHeight, s.clientHeight, l.scrollHeight, l.clientHeight), f = -a.scrollLeft + E5(o), d = -a.scrollTop;
      return Bi(l).direction === "rtl" && (f += Ia(s.clientWidth, l.clientWidth) - c), { width: c, height: u, x: f, y: d };
    }(fs(t));
  else if (ds(e))
    r = function(o, s) {
      var a = el(o, !0, s === "fixed"), l = a.top + o.clientTop, c = a.left + o.clientLeft, u = Ko(o) ? Hl(o) : la(1);
      return { width: o.clientWidth * u.x, height: o.clientHeight * u.y, x: c * u.x, y: l * u.y };
    }(e, n);
  else {
    var i = O5(t);
    r = fe(fe({}, e), {}, { x: e.x - i.x, y: e.y - i.y });
  }
  return Gh(r);
}
function A5(t, e) {
  var n = lc(t);
  return !(n === e || !ds(n) || Qp(n)) && (Bi(n).position === "fixed" || A5(n, e));
}
function AX(t, e, n) {
  var r = Ko(e), i = fs(e), o = n === "fixed", s = el(t, !0, o, e), a = { scrollLeft: 0, scrollTop: 0 }, l = la(0);
  if (r || !r && !o)
    if ((ca(e) !== "body" || Ju(i)) && (a = Yp(e)), r) {
      var c = el(e, !0, o, e);
      l.x = c.x + e.clientLeft, l.y = c.y + e.clientTop;
    } else
      i && (l.x = E5(i));
  return { x: s.left + a.scrollLeft - l.x, y: s.top + a.scrollTop - l.y, width: s.width, height: s.height };
}
function sj(t, e) {
  return Ko(t) && Bi(t).position !== "fixed" ? e ? e(t) : t.offsetParent : null;
}
function aj(t, e) {
  var n = ki(t);
  if (!Ko(t))
    return n;
  for (var r = sj(t, e); r && OX(r) && Bi(r).position === "static"; )
    r = sj(r, e);
  return r && (ca(r) === "html" || ca(r) === "body" && Bi(r).position === "static" && !Qv(r)) ? n : r || function(i) {
    for (var o = lc(i); Ko(o) && !Qp(o); ) {
      if (Qv(o))
        return o;
      o = lc(o);
    }
    return null;
  }(t) || n;
}
var MX = { convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  var e = t.rect, n = t.offsetParent, r = t.strategy, i = Ko(n), o = fs(n);
  if (n === o)
    return e;
  var s = { scrollLeft: 0, scrollTop: 0 }, a = la(1), l = la(0);
  if ((i || !i && r !== "fixed") && ((ca(n) !== "body" || Ju(o)) && (s = Yp(n)), Ko(n))) {
    var c = el(n);
    a = Hl(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return { width: e.width * a.x, height: e.height * a.y, x: e.x * a.x - s.scrollLeft * a.x + l.x, y: e.y * a.y - s.scrollTop * a.y + l.y };
}, getDocumentElement: fs, getClippingRect: function(t) {
  var e = t.element, n = t.boundary, r = t.rootBoundary, i = t.strategy, o = n === "clippingAncestors" ? function(c, u) {
    var f = u.get(c);
    if (f)
      return f;
    for (var d = Ku(c, [], !1).filter(function(y) {
      return ds(y) && ca(y) !== "body";
    }), h = null, p = Bi(c).position === "fixed", m = p ? lc(c) : c; ds(m) && !Qp(m); ) {
      var g = Bi(m), v = Qv(m);
      v || g.position !== "fixed" || (h = null), (p ? !v && !h : !v && g.position === "static" && h && ["absolute", "fixed"].includes(h.position) || Ju(m) && !v && A5(c, m)) ? d = d.filter(function(y) {
        return y !== m;
      }) : h = g, m = lc(m);
    }
    return u.set(c, d), d;
  }(e, this._c) : [].concat(n), s = [].concat(Ft(o), [r]), a = s[0], l = s.reduce(function(c, u) {
    var f = oj(e, u, i);
    return c.top = Ia(f.top, c.top), c.right = Wh(f.right, c.right), c.bottom = Wh(f.bottom, c.bottom), c.left = Ia(f.left, c.left), c;
  }, oj(e, a, i));
  return { width: l.right - l.left, height: l.bottom - l.top, x: l.left, y: l.top };
}, getOffsetParent: aj, getElementRects: function() {
  var t = Tt(Ie().mark(function e(n) {
    var r, i, o, s, a;
    return Ie().wrap(function(l) {
      for (; ; )
        switch (l.prev = l.next) {
          case 0:
            return r = n.reference, i = n.floating, o = n.strategy, s = this.getOffsetParent || aj, a = this.getDimensions, l.t0 = AX, l.t1 = r, l.next = 7, s(i);
          case 7:
            return l.t2 = l.sent, l.t3 = o, l.t4 = (0, l.t0)(l.t1, l.t2, l.t3), l.t5 = fe, l.t6 = { x: 0, y: 0 }, l.next = 14, a(i);
          case 14:
            return l.t7 = l.sent, l.t8 = (0, l.t5)(l.t6, l.t7), l.abrupt("return", { reference: l.t4, floating: l.t8 });
          case 17:
          case "end":
            return l.stop();
        }
    }, e, this);
  }));
  return function(e) {
    return t.apply(this, arguments);
  };
}(), getClientRects: function(t) {
  return Array.from(t.getClientRects());
}, getDimensions: function(t) {
  return C5(t);
}, getScale: Hl, isElement: ds, isRTL: function(t) {
  return Bi(t).direction === "rtl";
} };
function _X(t, e, n, r) {
  r === void 0 && (r = {});
  var i = r, o = i.ancestorScroll, s = o === void 0 || o, a = i.ancestorResize, l = a === void 0 || a, c = i.elementResize, u = c === void 0 ? typeof ResizeObserver == "function" : c, f = i.layoutShift, d = f === void 0 ? typeof IntersectionObserver == "function" : f, h = i.animationFrame, p = h !== void 0 && h, m = wy(t), g = s || l ? [].concat(Ft(m ? Ku(m) : []), Ft(Ku(e))) : [];
  g.forEach(function(j) {
    s && j.addEventListener("scroll", n, { passive: !0 }), l && j.addEventListener("resize", n);
  });
  var v, y = m && d ? function(j, $) {
    var N, B = null, O = fs(j);
    function I() {
      clearTimeout(N), B && B.disconnect(), B = null;
    }
    return function P(J, D) {
      J === void 0 && (J = !1), D === void 0 && (D = 1), I();
      var Q = j.getBoundingClientRect(), Z = Q.left, L = Q.top, R = Q.width, V = Q.height;
      if (J || $(), R && V) {
        var M = { rootMargin: -pd(L) + "px " + -pd(O.clientWidth - (Z + R)) + "px " + -pd(O.clientHeight - (L + V)) + "px " + -pd(Z) + "px", threshold: Ia(0, Wh(1, D)) || 1 }, C = !0;
        try {
          B = new IntersectionObserver(F, fe(fe({}, M), {}, { root: O.ownerDocument }));
        } catch {
          B = new IntersectionObserver(F, M);
        }
        B.observe(j);
      }
      function F(z) {
        var E = z[0].intersectionRatio;
        if (E !== D) {
          if (!C)
            return P();
          E ? P(!1, E) : N = setTimeout(function() {
            P(!1, 1e-7);
          }, 100);
        }
        C = !1;
      }
    }(!0), I;
  }(m, n) : null, w = -1, x = null;
  u && (x = new ResizeObserver(function(j) {
    var $ = Et(j, 1)[0];
    $ && $.target === m && x && (x.unobserve(e), cancelAnimationFrame(w), w = requestAnimationFrame(function() {
      x && x.observe(e);
    })), n();
  }), m && !p && x.observe(m), x.observe(e));
  var b = p ? el(t) : null;
  return p && function j() {
    var $ = el(t);
    !b || $.x === b.x && $.y === b.y && $.width === b.width && $.height === b.height || n(), b = $, v = requestAnimationFrame(j);
  }(), n(), function() {
    g.forEach(function(j) {
      s && j.removeEventListener("scroll", n), l && j.removeEventListener("resize", n);
    }), y && y(), x && x.disconnect(), x = null, p && cancelAnimationFrame(v);
  };
}
var TX = function(t, e, n) {
  var r = /* @__PURE__ */ new Map(), i = fe({ platform: MX }, n), o = fe(fe({}, i.platform), {}, { _c: r });
  return kX(t, e, fe(fe({}, i), {}, { platform: o }));
};
function PX(t) {
  var e = t.loadOptions, n = t.filterText, r = t.items, i = t.multiple, o = t.value, s = t.itemId, a = t.groupBy, l = t.filterSelectedItems, c = t.itemFilter, u = t.convertStringItemsToObjects, f = t.filterGroupedItems, d = t.label;
  if (r && e)
    return r;
  if (!r)
    return [];
  r && r.length > 0 && hr(r[0]) !== "object" && (r = u(r));
  var h = r.filter(function(p) {
    var m = c(p[d], n, p);
    return m && i && o != null && o.length && (m = !o.some(function(g) {
      return !!l && g[s] === p[s];
    })), m;
  });
  return a && (h = f(h)), h;
}
function RX(t) {
  return Yv.apply(this, arguments);
}
function Yv() {
  return Yv = Tt(Ie().mark(function t(e) {
    var n, r, i, o, s;
    return Ie().wrap(function(a) {
      for (; ; )
        switch (a.prev = a.next) {
          case 0:
            return n = e.dispatch, r = e.loadOptions, i = e.convertStringItemsToObjects, o = e.filterText, a.next = 3, r(o).catch(function(l) {
              console.warn("svelte-select loadOptions error :>> ", l), n("error", { type: "loadOptions", details: l });
            });
          case 3:
            if (!(s = a.sent) || s.cancelled) {
              a.next = 7;
              break;
            }
            return s ? (s && s.length > 0 && hr(s[0]) !== "object" && (s = i(s)), n("loaded", { items: s })) : s = [], a.abrupt("return", { filteredItems: s, loading: !1, focused: !0, listOpen: !0 });
          case 7:
          case "end":
            return a.stop();
        }
    }, t);
  })), Yv.apply(this, arguments);
}
function NX(t) {
  At(t, "svelte-qbd276", "svg.svelte-qbd276{width:var(--chevron-icon-width, 20px);height:var(--chevron-icon-width, 20px);color:var(--chevron-icon-colour, currentColor)}");
}
function IX(t) {
  var e, n;
  return { c: function() {
    e = Ho("svg"), k(n = Ho("path"), "fill", "currentColor"), k(n, "d", `M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747
          3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0
          1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502
          0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0
          0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z`), k(e, "width", "100%"), k(e, "height", "100%"), k(e, "viewBox", "0 0 20 20"), k(e, "focusable", "false"), k(e, "aria-hidden", "true"), k(e, "class", "svelte-qbd276");
  }, m: function(r, i) {
    X(r, e, i), T(e, n);
  }, p: Pe, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
var DX = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, null, IX, wr, {}, NX), i;
  }
  return Ye(n);
}();
function LX(t) {
  At(t, "svelte-whdbu1", "svg.svelte-whdbu1{width:var(--clear-icon-width, 20px);height:var(--clear-icon-width, 20px);color:var(--clear-icon-color, currentColor)}");
}
function BX(t) {
  var e, n;
  return { c: function() {
    e = Ho("svg"), k(n = Ho("path"), "fill", "currentColor"), k(n, "d", `M34.923,37.251L24,26.328L13.077,37.251L9.436,33.61l10.923-10.923L9.436,11.765l3.641-3.641L24,19.047L34.923,8.124
    l3.641,3.641L27.641,22.688L38.564,33.61L34.923,37.251z`), k(e, "width", "100%"), k(e, "height", "100%"), k(e, "viewBox", "-2 -2 50 50"), k(e, "focusable", "false"), k(e, "aria-hidden", "true"), k(e, "role", "presentation"), k(e, "class", "svelte-whdbu1");
  }, m: function(r, i) {
    X(r, e, i), T(e, n);
  }, p: Pe, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
var Qh = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, null, BX, wr, {}, LX), i;
  }
  return Ye(n);
}();
function qX(t) {
  At(t, "svelte-1p3nqvd", ".loading.svelte-1p3nqvd{width:var(--spinner-width, 20px);height:var(--spinner-height, 20px);color:var(--spinner-color, var(--icons-color));animation:svelte-1p3nqvd-rotate 0.75s linear infinite;transform-origin:center center;transform:none}.circle_path.svelte-1p3nqvd{stroke-dasharray:90;stroke-linecap:round}@keyframes svelte-1p3nqvd-rotate{100%{transform:rotate(360deg)}}");
}
function zX(t) {
  var e, n;
  return { c: function() {
    e = Ho("svg"), k(n = Ho("circle"), "class", "circle_path svelte-1p3nqvd"), k(n, "cx", "50"), k(n, "cy", "50"), k(n, "r", "20"), k(n, "fill", "none"), k(n, "stroke", "currentColor"), k(n, "stroke-width", "5"), k(n, "stroke-miterlimit", "10"), k(e, "class", "loading svelte-1p3nqvd"), k(e, "viewBox", "25 25 50 50");
  }, m: function(r, i) {
    X(r, e, i), T(e, n);
  }, p: Pe, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
var FX = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, null, zX, wr, {}, qX), i;
  }
  return Ye(n);
}();
function VX(t) {
  At(t, "svelte-82qwg8", ".svelte-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{--borderRadius:var(--border-radius);--clearSelectColor:var(--clear-select-color);--clearSelectWidth:var(--clear-select-width);--disabledBackground:var(--disabled-background);--disabledBorderColor:var(--disabled-border-color);--disabledColor:var(--disabled-color);--disabledPlaceholderColor:var(--disabled-placeholder-color);--disabledPlaceholderOpacity:var(--disabled-placeholder-opacity);--errorBackground:var(--error-background);--errorBorder:var(--error-border);--groupItemPaddingLeft:var(--group-item-padding-left);--groupTitleColor:var(--group-title-color);--groupTitleFontSize:var(--group-title-font-size);--groupTitleFontWeight:var(--group-title-font-weight);--groupTitlePadding:var(--group-title-padding);--groupTitleTextTransform:var(--group-title-text-transform);--groupTitleBorderColor:var(--group-title-border-color);--groupTitleBorderWidth:var(--group-title-border-width);--groupTitleBorderStyle:var(--group-title-border-style);--indicatorColor:var(--chevron-color);--indicatorHeight:var(--chevron-height);--indicatorWidth:var(--chevron-width);--inputColor:var(--input-color);--inputLeft:var(--input-left);--inputLetterSpacing:var(--input-letter-spacing);--inputMargin:var(--input-margin);--inputPadding:var(--input-padding);--itemActiveBackground:var(--item-active-background);--itemColor:var(--item-color);--itemFirstBorderRadius:var(--item-first-border-radius);--itemHoverBG:var(--item-hover-bg);--itemHoverColor:var(--item-hover-color);--itemIsActiveBG:var(--item-is-active-bg);--itemIsActiveColor:var(--item-is-active-color);--itemIsNotSelectableColor:var(--item-is-not-selectable-color);--itemPadding:var(--item-padding);--listBackground:var(--list-background);--listBorder:var(--list-border);--listBorderRadius:var(--list-border-radius);--listEmptyColor:var(--list-empty-color);--listEmptyPadding:var(--list-empty-padding);--listEmptyTextAlign:var(--list-empty-text-align);--listMaxHeight:var(--list-max-height);--listPosition:var(--list-position);--listShadow:var(--list-shadow);--listZIndex:var(--list-z-index);--multiItemBG:var(--multi-item-bg);--multiItemBorderRadius:var(--multi-item-border-radius);--multiItemDisabledHoverBg:var(--multi-item-disabled-hover-bg);--multiItemDisabledHoverColor:var(--multi-item-disabled-hover-color);--multiItemHeight:var(--multi-item-height);--multiItemMargin:var(--multi-item-margin);--multiItemPadding:var(--multi-item-padding);--multiSelectInputMargin:var(--multi-select-input-margin);--multiSelectInputPadding:var(--multi-select-input-padding);--multiSelectPadding:var(--multi-select-padding);--placeholderColor:var(--placeholder-color);--placeholderOpacity:var(--placeholder-opacity);--selectedItemPadding:var(--selected-item-padding);--spinnerColor:var(--spinner-color);--spinnerHeight:var(--spinner-height);--spinnerWidth:var(--spinner-width);--internal-padding:0 0 0 16px;border:var(--border, 1px solid #d8dbdf);border-radius:var(--border-radius, 6px);min-height:var(--height, 42px);position:relative;display:flex;align-items:stretch;padding:var(--padding, var(--internal-padding));background:var(--background, #fff);margin:var(--margin, 0);width:var(--width, 100%);font-size:var(--font-size, 16px);max-height:var(--max-height)}.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{box-sizing:var(--box-sizing, border-box)}.svelte-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:hover{border:var(--border-hover, 1px solid #b2b8bf)}.value-container.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;flex:1 1 0%;flex-wrap:wrap;align-items:center;gap:5px 10px;padding:var(--value-container-padding, 5px 0);position:relative;overflow:var(--value-container-overflow, hidden);align-self:stretch}.prepend.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.indicators.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;flex-shrink:0;align-items:center}.indicators.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{position:var(--indicators-position);top:var(--indicators-top);right:var(--indicators-right);bottom:var(--indicators-bottom)}input.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{position:absolute;cursor:default;border:none;color:var(--input-color, var(--item-color));padding:var(--input-padding, 0);letter-spacing:var(--input-letter-spacing, inherit);margin:var(--input-margin, 0);min-width:10px;top:0;right:0;bottom:0;left:0;background:transparent;font-size:var(--font-size, 16px)}.svelte-82qwg8:not(.multi)>.value-container.svelte-82qwg8>input.svelte-82qwg8{width:100%;height:100%}input.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8::placeholder{color:var(--placeholder-color, #78848f);opacity:var(--placeholder-opacity, 1)}input.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:focus{outline:none}.svelte-select.focused.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{border:var(--border-focused, 1px solid #006fe8);border-radius:var(--border-radius-focused, var(--border-radius, 6px))}.disabled.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{background:var(--disabled-background, #ebedef);border-color:var(--disabled-border-color, #ebedef);color:var(--disabled-color, #c1c6cc)}.disabled.svelte-82qwg8 input.svelte-82qwg8.svelte-82qwg8::placeholder{color:var(--disabled-placeholder-color, #c1c6cc);opacity:var(--disabled-placeholder-opacity, 1)}.selected-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{position:relative;overflow:var(--selected-item-overflow, hidden);padding:var(--selected-item-padding, 0 20px 0 0);text-overflow:ellipsis;white-space:nowrap;color:var(--selected-item-color, inherit);font-size:var(--font-size, 16px)}.multi.svelte-82qwg8 .selected-item.svelte-82qwg8.svelte-82qwg8{position:absolute;line-height:var(--height, 42px);height:var(--height, 42px)}.selected-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:focus{outline:none}.hide-selected-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{opacity:0}.icon.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;align-items:center;justify-content:center}.clear-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{all:unset;display:flex;align-items:center;justify-content:center;width:var(--clear-select-width, 40px);height:var(--clear-select-height, 100%);color:var(--clear-select-color, var(--icons-color));margin:var(--clear-select-margin, 0);pointer-events:all;flex-shrink:0}.clear-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:focus{outline:var(--clear-select-focus-outline, 1px solid #006fe8)}.loading.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{width:var(--loading-width, 40px);height:var(--loading-height);color:var(--loading-color, var(--icons-color));margin:var(--loading--margin, 0);flex-shrink:0}.chevron.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{width:var(--chevron-width, 40px);height:var(--chevron-height, 40px);background:var(--chevron-background, transparent);pointer-events:var(--chevron-pointer-events, none);color:var(--chevron-color, var(--icons-color));border:var(--chevron-border, 0 0 0 1px solid #d8dbdf);flex-shrink:0}.multi.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{padding:var(--multi-select-padding, var(--internal-padding))}.multi.svelte-82qwg8 input.svelte-82qwg8.svelte-82qwg8{padding:var(--multi-select-input-padding, 0);position:relative;margin:var(--multi-select-input-margin, 5px 0);flex:1 1 40px}.svelte-select.error.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{border:var(--error-border, 1px solid #ff2d55);background:var(--error-background, #fff)}.a11y-text.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{z-index:9999;border:0px;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0px;white-space:nowrap}.multi-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{background:var(--multi-item-bg, #ebedef);margin:var(--multi-item-margin, 0);outline:var(--multi-item-outline, 1px solid #ddd);border-radius:var(--multi-item-border-radius, 4px);height:var(--multi-item-height, 25px);line-height:var(--multi-item-height, 25px);display:flex;cursor:default;padding:var(--multi-item-padding, 0 5px);overflow:hidden;gap:var(--multi-item-gap, 4px);outline-offset:-1px;max-width:var(--multi-max-width, none);color:var(--multi-item-color, var(--item-color))}.multi-item.disabled.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:hover{background:var(--multi-item-disabled-hover-bg, #ebedef);color:var(--multi-item-disabled-hover-color, #c1c6cc)}.multi-item-text.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.multi-item-clear.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;align-items:center;justify-content:center;--clear-icon-color:var(--multi-item-clear-icon-color, #000)}.multi-item.active.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{outline:var(--multi-item-active-outline, 1px solid #006fe8)}.svelte-select-list.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{box-shadow:var(--list-shadow, 0 2px 3px 0 rgba(44, 62, 80, 0.24));border-radius:var(--list-border-radius, 4px);max-height:var(--list-max-height, 252px);overflow-y:auto;background:var(--list-background, #fff);position:var(--list-position, absolute);z-index:var(--list-z-index, 2);border:var(--list-border)}.prefloat.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{opacity:0;pointer-events:none}.list-group-title.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{color:var(--group-title-color, #8f8f8f);cursor:default;font-size:var(--group-title-font-size, 16px);font-weight:var(--group-title-font-weight, 600);height:var(--height, 42px);line-height:var(--height, 42px);padding:var(--group-title-padding, 0 20px);text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;text-transform:var(--group-title-text-transform, uppercase);border-width:var(--group-title-border-width, medium);border-style:var(--group-title-border-style, none);border-color:var(--group-title-border-color, color)}.empty.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{text-align:var(--list-empty-text-align, center);padding:var(--list-empty-padding, 20px 0);color:var(--list-empty-color, #78848f)}.item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{cursor:default;height:var(--item-height, var(--height, 42px));line-height:var(--item-line-height, var(--height, 42px));padding:var(--item-padding, 0 20px);color:var(--item-color, inherit);text-overflow:ellipsis;overflow:hidden;white-space:nowrap;transition:var(--item-transition, all 0.2s);align-items:center;width:100%}.item.group-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{padding-left:var(--group-item-padding-left, 40px)}.item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:active{background:var(--item-active-background, #b9daff)}.item.active.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{background:var(--item-is-active-bg, #007aff);color:var(--item-is-active-color, #fff)}.item.first.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{border-radius:var(--item-first-border-radius, 4px 4px 0 0)}.item.hover.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:not(.active){background:var(--item-hover-bg, #e7f2ff);color:var(--item-hover-color, inherit)}.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.item.hover.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.item.active.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:active{color:var(--item-is-not-selectable-color, #999);background:transparent}.required.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{opacity:0;z-index:-1;position:absolute;top:0;left:0;bottom:0;right:0}");
}
var HX = function(t) {
  return { value: 8 & t[0] };
}, lj = function(t) {
  return { value: t[3] };
}, UX = function(t) {
  return { value: 8 & t[0] };
}, cj = function(t) {
  return { value: t[3] };
}, WX = function(t) {
  return { listOpen: 64 & t[0] };
}, uj = function(t) {
  return { listOpen: t[6] };
}, JX = function(t) {
  return {};
}, fj = function(t) {
  return {};
}, KX = function(t) {
  return {};
}, dj = function(t) {
  return {};
}, GX = function(t) {
  return { selection: 8 & t[0] };
}, hj = function(t) {
  return { selection: t[3] };
};
function pj(t, e, n) {
  var r = t.slice();
  return r[126] = e[n], r[128] = n, r;
}
var QX = function(t) {
  return {};
}, mj = function(t) {
  return {};
}, YX = function(t) {
  return { selection: 8 & t[0] };
}, gj = function(t) {
  return { selection: t[126], index: t[128] };
}, XX = function(t) {
  return {};
}, vj = function(t) {
  return {};
}, ZX = function(t) {
  return {};
}, yj = function(t) {
  return {};
}, eZ = function(t) {
  return {};
}, bj = function(t) {
  return {};
};
function xj(t, e, n) {
  var r = t.slice();
  return r[126] = e[n], r[128] = n, r;
}
var tZ = function(t) {
  return { item: 16777216 & t[0] };
}, wj = function(t) {
  return { item: t[126], index: t[128] };
}, nZ = function(t) {
  return { filteredItems: 16777216 & t[0] };
}, jj = function(t) {
  return { filteredItems: t[24] };
}, rZ = function(t) {
  return {};
}, kj = function(t) {
  return {};
};
function $j(t) {
  var e, n, r, i, o, s, a, l, c = t[50]["list-prepend"] && Sj(t), u = [sZ, oZ, iZ], f = [];
  function d(p, m) {
    return p[50].list ? 0 : p[24].length > 0 ? 1 : p[19] ? -1 : 2;
  }
  ~(r = d(t)) && (i = f[r] = u[r](t));
  var h = t[50]["list-append"] && Oj(t);
  return { c: function() {
    e = H("div"), c && c.c(), n = se(), i && i.c(), o = se(), h && h.c(), k(e, "class", "svelte-select-list svelte-82qwg8"), $e(e, "prefloat", t[28]);
  }, m: function(p, m) {
    X(p, e, m), c && c.m(e, null), T(e, n), ~r && f[r].m(e, null), T(e, o), h && h.m(e, null), t[91](e), s = !0, a || (l = [Mr(t[49].call(null, e)), Oe(e, "scroll", t[41]), Oe(e, "pointerup", po(Wa(t[85]))), Oe(e, "mousedown", po(Wa(t[86])))], a = !0);
  }, p: function(p, m) {
    p[50]["list-prepend"] ? c ? (c.p(p, m), 524288 & m[1] && S(c, 1)) : ((c = Sj(p)).c(), S(c, 1), c.m(e, n)) : c && (Ae(), _(c, 1, 1, function() {
      c = null;
    }), Me());
    var g = r;
    (r = d(p)) === g ? ~r && f[r].p(p, m) : (i && (Ae(), _(f[g], 1, 1, function() {
      f[g] = null;
    }), Me()), ~r ? ((i = f[r]) ? i.p(p, m) : (i = f[r] = u[r](p)).c(), S(i, 1), i.m(e, o)) : i = null), p[50]["list-append"] ? h ? (h.p(p, m), 524288 & m[1] && S(h, 1)) : ((h = Oj(p)).c(), S(h, 1), h.m(e, null)) : h && (Ae(), _(h, 1, 1, function() {
      h = null;
    }), Me()), (!s || 268435456 & m[0]) && $e(e, "prefloat", p[28]);
  }, i: function(p) {
    s || (S(c), S(i), S(h), s = !0);
  }, o: function(p) {
    _(c), _(i), _(h), s = !1;
  }, d: function(p) {
    p && Y(e), c && c.d(), ~r && f[r].d(), h && h.d(), t[91](null), a = !1, An(l);
  } };
}
function Sj(t) {
  var e, n = t[83]["list-prepend"], r = ir(n, t, t[82], kj);
  return { c: function() {
    r && r.c();
  }, m: function(i, o) {
    r && r.m(i, o), e = !0;
  }, p: function(i, o) {
    r && r.p && (!e || 1048576 & o[2]) && sr(r, n, i, i[82], e ? or(n, i[82], o, rZ) : ar(i[82]), kj);
  }, i: function(i) {
    e || (S(r, i), e = !0);
  }, o: function(i) {
    _(r, i), e = !1;
  }, d: function(i) {
    r && r.d(i);
  } };
}
function iZ(t) {
  var e, n, r = t[83].empty, i = ir(r, t, t[82], bj), o = i || { c: function() {
    (n = H("div")).textContent = "No options", k(n, "class", "empty svelte-82qwg8");
  }, m: function(s, a) {
    X(s, n, a);
  }, p: Pe, d: function(s) {
    s && Y(n);
  } };
  return { c: function() {
    o && o.c();
  }, m: function(s, a) {
    o && o.m(s, a), e = !0;
  }, p: function(s, a) {
    i && i.p && (!e || 1048576 & a[2]) && sr(i, r, s, s[82], e ? or(r, s[82], a, eZ) : ar(s[82]), bj);
  }, i: function(s) {
    e || (S(o, s), e = !0);
  }, o: function(s) {
    _(o, s), e = !1;
  }, d: function(s) {
    o && o.d(s);
  } };
}
function oZ(t) {
  for (var e, n, r = Ot(t[24]), i = [], o = 0; o < r.length; o += 1)
    i[o] = Cj(xj(t, r, o));
  var s = function(a) {
    return _(i[a], 1, 1, function() {
      i[a] = null;
    });
  };
  return { c: function() {
    for (var a = 0; a < i.length; a += 1)
      i[a].c();
    e = un();
  }, m: function(a, l) {
    for (var c = 0; c < i.length; c += 1)
      i[c] && i[c].m(a, l);
    X(a, e, l), n = !0;
  }, p: function(a, l) {
    if (1627402376 & l[0] | 28672 & l[1] | 1048576 & l[2]) {
      var c;
      for (r = Ot(a[24]), c = 0; c < r.length; c += 1) {
        var u = xj(a, r, c);
        i[c] ? (i[c].p(u, l), S(i[c], 1)) : (i[c] = Cj(u), i[c].c(), S(i[c], 1), i[c].m(e.parentNode, e));
      }
      for (Ae(), c = r.length; c < i.length; c += 1)
        s(c);
      Me();
    }
  }, i: function(a) {
    if (!n) {
      for (var l = 0; l < r.length; l += 1)
        S(i[l]);
      n = !0;
    }
  }, o: function(a) {
    i = i.filter(Boolean);
    for (var l = 0; l < i.length; l += 1)
      _(i[l]);
    n = !1;
  }, d: function(a) {
    a && Y(e), fr(i, a);
  } };
}
function sZ(t) {
  var e, n = t[83].list, r = ir(n, t, t[82], jj);
  return { c: function() {
    r && r.c();
  }, m: function(i, o) {
    r && r.m(i, o), e = !0;
  }, p: function(i, o) {
    r && r.p && (!e || 16777216 & o[0] | 1048576 & o[2]) && sr(r, n, i, i[82], e ? or(n, i[82], o, nZ) : ar(i[82]), jj);
  }, i: function(i) {
    e || (S(r, i), e = !0);
  }, o: function(i) {
    _(r, i), e = !1;
  }, d: function(i) {
    r && r.d(i);
  } };
}
function Cj(t) {
  var e, n, r, i, o, s, a, l, c = t[83].item, u = ir(c, t, t[82], wj), f = u || function(m) {
    var g, v, y = ((g = m[126]) === null || g === void 0 ? void 0 : g[m[12]]) + "";
    return { c: function() {
      v = Le(y);
    }, m: function(w, x) {
      X(w, v, x);
    }, p: function(w, x) {
      var b;
      16781312 & x[0] && y !== (y = ((b = w[126]) === null || b === void 0 ? void 0 : b[w[12]]) + "") && bt(v, y);
    }, d: function(w) {
      w && Y(v);
    } };
  }(t);
  function d() {
    return t[88](t[128]);
  }
  function h() {
    return t[89](t[128]);
  }
  function p() {
    return t[90](t[126], t[128]);
  }
  return { c: function() {
    var m;
    e = H("div"), n = H("div"), f && f.c(), o = se(), k(n, "class", "item svelte-82qwg8"), $e(n, "list-group-title", t[126].groupHeader), $e(n, "active", t[45](t[126], t[3], t[13])), $e(n, "first", t[128] === 0), $e(n, "hover", t[7] === t[128]), $e(n, "group-item", t[126].groupItem), $e(n, "not-selectable", ((m = t[126]) === null || m === void 0 ? void 0 : m.selectable) === !1), k(e, "class", "list-item svelte-82qwg8"), k(e, "tabindex", "-1"), k(e, "role", "none");
  }, m: function(m, g) {
    X(m, e, g), T(e, n), f && f.m(n, null), T(e, o), s = !0, a || (l = [Mr(r = t[46].call(null, n, { scroll: t[45](t[126], t[3], t[13]), listDom: t[30] })), Mr(i = t[47].call(null, n, { scroll: t[29] === t[128], listDom: t[30] })), Oe(e, "mouseover", d), Oe(e, "focus", h), Oe(e, "click", po(p)), Oe(e, "keydown", po(Wa(t[87])))], a = !0);
  }, p: function(m, g) {
    var v;
    t = m, u ? u.p && (!s || 16777216 & g[0] | 1048576 & g[2]) && sr(u, c, t, t[82], s ? or(c, t[82], g, tZ) : ar(t[82]), wj) : f && f.p && (!s || 16781312 & g[0]) && f.p(t, s ? g : [-1, -1, -1, -1, -1]), r && Ar(r.update) && 1090527240 & g[0] && r.update.call(null, { scroll: t[45](t[126], t[3], t[13]), listDom: t[30] }), i && Ar(i.update) && 1610612736 & g[0] && i.update.call(null, { scroll: t[29] === t[128], listDom: t[30] }), (!s || 16777216 & g[0]) && $e(n, "list-group-title", t[126].groupHeader), (!s || 16785416 & g[0] | 16384 & g[1]) && $e(n, "active", t[45](t[126], t[3], t[13])), (!s || 128 & g[0]) && $e(n, "hover", t[7] === t[128]), (!s || 16777216 & g[0]) && $e(n, "group-item", t[126].groupItem), (!s || 16777216 & g[0]) && $e(n, "not-selectable", ((v = t[126]) === null || v === void 0 ? void 0 : v.selectable) === !1);
  }, i: function(m) {
    s || (S(f, m), s = !0);
  }, o: function(m) {
    _(f, m), s = !1;
  }, d: function(m) {
    m && Y(e), f && f.d(m), a = !1, An(l);
  } };
}
function Oj(t) {
  var e, n = t[83]["list-append"], r = ir(n, t, t[82], yj);
  return { c: function() {
    r && r.c();
  }, m: function(i, o) {
    r && r.m(i, o), e = !0;
  }, p: function(i, o) {
    r && r.p && (!e || 1048576 & o[2]) && sr(r, n, i, i[82], e ? or(n, i[82], o, ZX) : ar(i[82]), yj);
  }, i: function(i) {
    e || (S(r, i), e = !0);
  }, o: function(i) {
    _(r, i), e = !1;
  }, d: function(i) {
    r && r.d(i);
  } };
}
function Ej(t) {
  var e, n, r, i, o;
  return { c: function() {
    e = H("span"), n = Le(t[32]), r = se(), i = H("span"), o = Le(t[31]), k(e, "id", "aria-selection"), k(e, "class", "svelte-82qwg8"), k(i, "id", "aria-context"), k(i, "class", "svelte-82qwg8");
  }, m: function(s, a) {
    X(s, e, a), T(e, n), X(s, r, a), X(s, i, a), T(i, o);
  }, p: function(s, a) {
    2 & a[1] && bt(n, s[32]), 1 & a[1] && bt(o, s[31]);
  }, d: function(s) {
    s && (Y(e), Y(r), Y(i));
  } };
}
function Aj(t) {
  var e, n, r, i, o = [lZ, aZ], s = [];
  function a(l, c) {
    return l[9] ? 0 : 1;
  }
  return e = a(t), n = s[e] = o[e](t), { c: function() {
    n.c(), r = un();
  }, m: function(l, c) {
    s[e].m(l, c), X(l, r, c), i = !0;
  }, p: function(l, c) {
    var u = e;
    (e = a(l)) === u ? s[e].p(l, c) : (Ae(), _(s[u], 1, 1, function() {
      s[u] = null;
    }), Me(), (n = s[e]) ? n.p(l, c) : (n = s[e] = o[e](l)).c(), S(n, 1), n.m(r.parentNode, r));
  }, i: function(l) {
    i || (S(n), i = !0);
  }, o: function(l) {
    _(n), i = !1;
  }, d: function(l) {
    l && Y(r), s[e].d(l);
  } };
}
function aZ(t) {
  var e, n, r = t[83].selection, i = ir(r, t, t[82], hj), o = i || function(s) {
    var a, l = s[3][s[12]] + "";
    return { c: function() {
      a = Le(l);
    }, m: function(c, u) {
      X(c, a, u);
    }, p: function(c, u) {
      4104 & u[0] && l !== (l = c[3][c[12]] + "") && bt(a, l);
    }, d: function(c) {
      c && Y(a);
    } };
  }(t);
  return { c: function() {
    e = H("div"), o && o.c(), k(e, "class", "selected-item svelte-82qwg8"), $e(e, "hide-selected-item", t[35]);
  }, m: function(s, a) {
    X(s, e, a), o && o.m(e, null), n = !0;
  }, p: function(s, a) {
    i ? i.p && (!n || 8 & a[0] | 1048576 & a[2]) && sr(i, r, s, s[82], n ? or(r, s[82], a, GX) : ar(s[82]), hj) : o && o.p && (!n || 4104 & a[0]) && o.p(s, n ? a : [-1, -1, -1, -1, -1]), (!n || 16 & a[1]) && $e(e, "hide-selected-item", s[35]);
  }, i: function(s) {
    n || (S(o, s), n = !0);
  }, o: function(s) {
    _(o, s), n = !1;
  }, d: function(s) {
    s && Y(e), o && o.d(s);
  } };
}
function lZ(t) {
  for (var e, n, r = Ot(t[3]), i = [], o = 0; o < r.length; o += 1)
    i[o] = _j(pj(t, r, o));
  var s = function(a) {
    return _(i[a], 1, 1, function() {
      i[a] = null;
    });
  };
  return { c: function() {
    for (var a = 0; a < i.length; a += 1)
      i[a].c();
    e = un();
  }, m: function(a, l) {
    for (var c = 0; c < i.length; c += 1)
      i[c] && i[c].m(a, l);
    X(a, e, l), n = !0;
  }, p: function(a, l) {
    if (67116040 & l[0] | 32 & l[1] | 1048576 & l[2]) {
      var c;
      for (r = Ot(a[3]), c = 0; c < r.length; c += 1) {
        var u = pj(a, r, c);
        i[c] ? (i[c].p(u, l), S(i[c], 1)) : (i[c] = _j(u), i[c].c(), S(i[c], 1), i[c].m(e.parentNode, e));
      }
      for (Ae(), c = r.length; c < i.length; c += 1)
        s(c);
      Me();
    }
  }, i: function(a) {
    if (!n) {
      for (var l = 0; l < r.length; l += 1)
        S(i[l]);
      n = !0;
    }
  }, o: function(a) {
    i = i.filter(Boolean);
    for (var l = 0; l < i.length; l += 1)
      _(i[l]);
    n = !1;
  }, d: function(a) {
    a && Y(e), fr(i, a);
  } };
}
function Mj(t) {
  var e, n, r, i, o = t[83]["multi-clear-icon"], s = ir(o, t, t[82], mj), a = s || function(c) {
    var u, f;
    return u = new Qh({}), { c: function() {
      xe(u.$$.fragment);
    }, m: function(d, h) {
      ye(u, d, h), f = !0;
    }, i: function(d) {
      f || (S(u.$$.fragment, d), f = !0);
    }, o: function(d) {
      _(u.$$.fragment, d), f = !1;
    }, d: function(d) {
      be(u, d);
    } };
  }();
  function l() {
    return t[92](t[128]);
  }
  return { c: function() {
    e = H("div"), a && a.c(), k(e, "class", "multi-item-clear svelte-82qwg8");
  }, m: function(c, u) {
    X(c, e, u), a && a.m(e, null), n = !0, r || (i = Oe(e, "pointerup", po(Wa(l))), r = !0);
  }, p: function(c, u) {
    t = c, s && s.p && (!n || 1048576 & u[2]) && sr(s, o, t, t[82], n ? or(o, t[82], u, QX) : ar(t[82]), mj);
  }, i: function(c) {
    n || (S(a, c), n = !0);
  }, o: function(c) {
    _(a, c), n = !1;
  }, d: function(c) {
    c && Y(e), a && a.d(c), r = !1, i();
  } };
}
function _j(t) {
  var e, n, r, i, o, s, a, l = t[83].selection, c = ir(l, t, t[82], gj), u = c || function(h) {
    var p, m = h[126][h[12]] + "";
    return { c: function() {
      p = Le(m);
    }, m: function(g, v) {
      X(g, p, v);
    }, p: function(g, v) {
      4104 & v[0] && m !== (m = g[126][g[12]] + "") && bt(p, m);
    }, d: function(g) {
      g && Y(p);
    } };
  }(t), f = !t[11] && !t[10] && Qh && Mj(t);
  function d() {
    return t[93](t[128]);
  }
  return { c: function() {
    e = H("div"), n = H("span"), u && u.c(), r = se(), f && f.c(), i = se(), k(n, "class", "multi-item-text svelte-82qwg8"), k(e, "class", "multi-item svelte-82qwg8"), k(e, "role", "none"), $e(e, "active", t[26] === t[128]), $e(e, "disabled", t[11]);
  }, m: function(h, p) {
    X(h, e, p), T(e, n), u && u.m(n, null), T(e, r), f && f.m(e, null), T(e, i), o = !0, s || (a = [Oe(e, "click", Wa(d)), Oe(e, "keydown", po(Wa(t[84])))], s = !0);
  }, p: function(h, p) {
    t = h, c ? c.p && (!o || 8 & p[0] | 1048576 & p[2]) && sr(c, l, t, t[82], o ? or(l, t[82], p, YX) : ar(t[82]), gj) : u && u.p && (!o || 4104 & p[0]) && u.p(t, o ? p : [-1, -1, -1, -1, -1]), t[11] || t[10] || !Qh ? f && (Ae(), _(f, 1, 1, function() {
      f = null;
    }), Me()) : f ? (f.p(t, p), 3072 & p[0] && S(f, 1)) : ((f = Mj(t)).c(), S(f, 1), f.m(e, i)), (!o || 67108864 & p[0]) && $e(e, "active", t[26] === t[128]), (!o || 2048 & p[0]) && $e(e, "disabled", t[11]);
  }, i: function(h) {
    o || (S(u, h), S(f), o = !0);
  }, o: function(h) {
    _(u, h), _(f), o = !1;
  }, d: function(h) {
    h && Y(e), u && u.d(h), f && f.d(), s = !1, An(a);
  } };
}
function Tj(t) {
  var e, n, r = t[83]["loading-icon"], i = ir(r, t, t[82], dj), o = i || function(s) {
    var a, l;
    return a = new FX({}), { c: function() {
      xe(a.$$.fragment);
    }, m: function(c, u) {
      ye(a, c, u), l = !0;
    }, i: function(c) {
      l || (S(a.$$.fragment, c), l = !0);
    }, o: function(c) {
      _(a.$$.fragment, c), l = !1;
    }, d: function(c) {
      be(a, c);
    } };
  }();
  return { c: function() {
    e = H("div"), o && o.c(), k(e, "class", "icon loading svelte-82qwg8"), k(e, "aria-hidden", "true");
  }, m: function(s, a) {
    X(s, e, a), o && o.m(e, null), n = !0;
  }, p: function(s, a) {
    i && i.p && (!n || 1048576 & a[2]) && sr(i, r, s, s[82], n ? or(r, s[82], a, KX) : ar(s[82]), dj);
  }, i: function(s) {
    n || (S(o, s), n = !0);
  }, o: function(s) {
    _(o, s), n = !1;
  }, d: function(s) {
    s && Y(e), o && o.d(s);
  } };
}
function Pj(t) {
  var e, n, r, i, o = t[83]["clear-icon"], s = ir(o, t, t[82], fj), a = s || function(l) {
    var c, u;
    return c = new Qh({}), { c: function() {
      xe(c.$$.fragment);
    }, m: function(f, d) {
      ye(c, f, d), u = !0;
    }, i: function(f) {
      u || (S(c.$$.fragment, f), u = !0);
    }, o: function(f) {
      _(c.$$.fragment, f), u = !1;
    }, d: function(f) {
      be(c, f);
    } };
  }();
  return { c: function() {
    e = H("button"), a && a.c(), k(e, "type", "button"), k(e, "class", "icon clear-select svelte-82qwg8");
  }, m: function(l, c) {
    X(l, e, c), a && a.m(e, null), n = !0, r || (i = Oe(e, "click", t[22]), r = !0);
  }, p: function(l, c) {
    s && s.p && (!n || 1048576 & c[2]) && sr(s, o, l, l[82], n ? or(o, l[82], c, JX) : ar(l[82]), fj);
  }, i: function(l) {
    n || (S(a, l), n = !0);
  }, o: function(l) {
    _(a, l), n = !1;
  }, d: function(l) {
    l && Y(e), a && a.d(l), r = !1, i();
  } };
}
function Rj(t) {
  var e, n, r = t[83]["chevron-icon"], i = ir(r, t, t[82], uj), o = i || function(s) {
    var a, l;
    return a = new DX({}), { c: function() {
      xe(a.$$.fragment);
    }, m: function(c, u) {
      ye(a, c, u), l = !0;
    }, i: function(c) {
      l || (S(a.$$.fragment, c), l = !0);
    }, o: function(c) {
      _(a.$$.fragment, c), l = !1;
    }, d: function(c) {
      be(a, c);
    } };
  }();
  return { c: function() {
    e = H("div"), o && o.c(), k(e, "class", "icon chevron svelte-82qwg8"), k(e, "aria-hidden", "true");
  }, m: function(s, a) {
    X(s, e, a), o && o.m(e, null), n = !0;
  }, p: function(s, a) {
    i && i.p && (!n || 64 & a[0] | 1048576 & a[2]) && sr(i, r, s, s[82], n ? or(r, s[82], a, WX) : ar(s[82]), uj);
  }, i: function(s) {
    n || (S(o, s), n = !0);
  }, o: function(s) {
    _(o, s), n = !1;
  }, d: function(s) {
    s && Y(e), o && o.d(s);
  } };
}
function Nj(t) {
  var e, n, r = t[83].required, i = ir(r, t, t[82], lj), o = i || { c: function() {
    k(n = H("select"), "class", "required svelte-82qwg8"), n.required = !0, k(n, "tabindex", "-1"), k(n, "aria-hidden", "true");
  }, m: function(s, a) {
    X(s, n, a);
  }, p: Pe, d: function(s) {
    s && Y(n);
  } };
  return { c: function() {
    o && o.c();
  }, m: function(s, a) {
    o && o.m(s, a), e = !0;
  }, p: function(s, a) {
    i && i.p && (!e || 8 & a[0] | 1048576 & a[2]) && sr(i, r, s, s[82], e ? or(r, s[82], a, HX) : ar(s[82]), lj);
  }, i: function(s) {
    e || (S(o, s), e = !0);
  }, o: function(s) {
    _(o, s), e = !1;
  }, d: function(s) {
    o && o.d(s);
  } };
}
function cZ(t) {
  for (var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b = t[6] && $j(t), j = t[2] && Ej(t), $ = t[83].prepend, N = ir($, t, t[82], vj), B = t[25] && Aj(t), O = [{ readOnly: u = !t[17] }, t[27], { placeholder: t[33] }, { style: t[18] }, { disabled: t[11] }], I = {}, P = 0; P < O.length; P += 1)
    I = di(I, O[P]);
  var J = t[5] && Tj(t), D = t[34] && Pj(t), Q = t[20] && Rj(t), Z = t[83]["input-hidden"], L = ir(Z, t, t[82], cj), R = L || /* @__PURE__ */ function(M) {
    var C, F;
    return { c: function() {
      k(C = H("input"), "name", M[8]), k(C, "type", "hidden"), C.value = F = M[3] ? JSON.stringify(M[3]) : null, k(C, "class", "svelte-82qwg8");
    }, m: function(z, E) {
      X(z, C, E);
    }, p: function(z, E) {
      256 & E[0] && k(C, "name", z[8]), 8 & E[0] && F !== (F = z[3] ? JSON.stringify(z[3]) : null) && (C.value = F);
    }, d: function(z) {
      z && Y(C);
    } };
  }(t), V = t[16] && (!t[3] || t[3].length === 0) && Nj(t);
  return { c: function() {
    e = H("div"), b && b.c(), n = se(), r = H("span"), j && j.c(), i = se(), o = H("div"), N && N.c(), s = se(), a = H("div"), B && B.c(), l = se(), c = H("input"), f = se(), d = H("div"), J && J.c(), h = se(), D && D.c(), p = se(), Q && Q.c(), m = se(), R && R.c(), g = se(), V && V.c(), k(r, "aria-live", "polite"), k(r, "aria-atomic", "false"), k(r, "aria-relevant", "additions text"), k(r, "class", "a11y-text svelte-82qwg8"), k(o, "class", "prepend svelte-82qwg8"), mw(c, I), $e(c, "svelte-82qwg8", !0), k(a, "class", "value-container svelte-82qwg8"), k(d, "class", "indicators svelte-82qwg8"), k(e, "class", v = "svelte-select " + t[21] + " svelte-82qwg8"), k(e, "style", t[14]), k(e, "role", "none"), $e(e, "multi", t[9]), $e(e, "disabled", t[11]), $e(e, "focused", t[2]), $e(e, "list-open", t[6]), $e(e, "show-chevron", t[20]), $e(e, "error", t[15]);
  }, m: function(M, C) {
    X(M, e, C), b && b.m(e, null), T(e, n), T(e, r), j && j.m(r, null), T(e, i), T(e, o), N && N.m(o, null), T(e, s), T(e, a), B && B.m(a, null), T(a, l), T(a, c), c.autofocus && c.focus(), t[94](c), Uo(c, t[4]), T(e, f), T(e, d), J && J.m(d, null), T(d, h), D && D.m(d, null), T(d, p), Q && Q.m(d, null), T(e, m), R && R.m(e, null), T(e, g), V && V.m(e, null), t[96](e), y = !0, w || (x = [Oe(window, "click", t[42]), Oe(window, "keydown", t[37]), Oe(c, "keydown", t[37]), Oe(c, "blur", t[39]), Oe(c, "focus", t[38]), Oe(c, "input", t[95]), Oe(e, "pointerup", Wa(t[40])), Mr(t[48].call(null, e))], w = !0);
  }, p: function(M, C) {
    M[6] ? b ? (b.p(M, C), 64 & C[0] && S(b, 1)) : ((b = $j(M)).c(), S(b, 1), b.m(e, n)) : b && (Ae(), _(b, 1, 1, function() {
      b = null;
    }), Me()), M[2] ? j ? j.p(M, C) : ((j = Ej(M)).c(), j.m(r, null)) : j && (j.d(1), j = null), N && N.p && (!y || 1048576 & C[2]) && sr(N, $, M, M[82], y ? or($, M[82], C, XX) : ar(M[82]), vj), M[25] ? B ? (B.p(M, C), 33554432 & C[0] && S(B, 1)) : ((B = Aj(M)).c(), S(B, 1), B.m(a, l)) : B && (Ae(), _(B, 1, 1, function() {
      B = null;
    }), Me()), mw(c, I = Vi(O, [(!y || 131072 & C[0] && u !== (u = !M[17])) && { readOnly: u }, 134217728 & C[0] && M[27], (!y || 4 & C[1]) && { placeholder: M[33] }, (!y || 262144 & C[0]) && { style: M[18] }, (!y || 2048 & C[0]) && { disabled: M[11] }])), 16 & C[0] && c.value !== M[4] && Uo(c, M[4]), $e(c, "svelte-82qwg8", !0), M[5] ? J ? (J.p(M, C), 32 & C[0] && S(J, 1)) : ((J = Tj(M)).c(), S(J, 1), J.m(d, h)) : J && (Ae(), _(J, 1, 1, function() {
      J = null;
    }), Me()), M[34] ? D ? (D.p(M, C), 8 & C[1] && S(D, 1)) : ((D = Pj(M)).c(), S(D, 1), D.m(d, p)) : D && (Ae(), _(D, 1, 1, function() {
      D = null;
    }), Me()), M[20] ? Q ? (Q.p(M, C), 1048576 & C[0] && S(Q, 1)) : ((Q = Rj(M)).c(), S(Q, 1), Q.m(d, null)) : Q && (Ae(), _(Q, 1, 1, function() {
      Q = null;
    }), Me()), L ? L.p && (!y || 8 & C[0] | 1048576 & C[2]) && sr(L, Z, M, M[82], y ? or(Z, M[82], C, UX) : ar(M[82]), cj) : R && R.p && (!y || 264 & C[0]) && R.p(M, y ? C : [-1, -1, -1, -1, -1]), !M[16] || M[3] && M[3].length !== 0 ? V && (Ae(), _(V, 1, 1, function() {
      V = null;
    }), Me()) : V ? (V.p(M, C), 65544 & C[0] && S(V, 1)) : ((V = Nj(M)).c(), S(V, 1), V.m(e, null)), (!y || 2097152 & C[0] && v !== (v = "svelte-select " + M[21] + " svelte-82qwg8")) && k(e, "class", v), (!y || 16384 & C[0]) && k(e, "style", M[14]), (!y || 2097664 & C[0]) && $e(e, "multi", M[9]), (!y || 2099200 & C[0]) && $e(e, "disabled", M[11]), (!y || 2097156 & C[0]) && $e(e, "focused", M[2]), (!y || 2097216 & C[0]) && $e(e, "list-open", M[6]), (!y || 3145728 & C[0]) && $e(e, "show-chevron", M[20]), (!y || 2129920 & C[0]) && $e(e, "error", M[15]);
  }, i: function(M) {
    y || (S(b), S(N, M), S(B), S(J), S(D), S(Q), S(R, M), S(V), y = !0);
  }, o: function(M) {
    _(b), _(N, M), _(B), _(J), _(D), _(Q), _(R, M), _(V), y = !1;
  }, d: function(M) {
    M && Y(e), b && b.d(), j && j.d(), N && N.d(M), B && B.d(), t[94](null), J && J.d(), D && D.d(), Q && Q.d(), R && R.d(M), V && V.d(), t[96](null), w = !1, An(x);
  } };
}
function Ij(t) {
  return t.map(function(e, n) {
    return { index: n, value: e, label: "".concat(e) };
  });
}
function uZ(t, e, n) {
  var r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w = e.$$slots, x = w === void 0 ? {} : w, b = e.$$scope, j = function(ie) {
    var ot = {};
    for (var Mt in ie)
      ot[Mt] = !0;
    return ot;
  }(x), $ = T6(), N = e.justValue, B = N === void 0 ? null : N, O = e.filter, I = O === void 0 ? PX : O, P = e.getItems, J = P === void 0 ? RX : P, D = e.id, Q = D === void 0 ? null : D, Z = e.name, L = Z === void 0 ? null : Z, R = e.container, V = R === void 0 ? void 0 : R, M = e.input, C = M === void 0 ? void 0 : M, F = e.multiple, z = F !== void 0 && F, E = e.multiFullItemClearable, A = E !== void 0 && E, te = e.disabled, ge = te !== void 0 && te, ke = e.focused, Ce = ke !== void 0 && ke, we = e.value, le = we === void 0 ? null : we, rt = e.filterText, Be = rt === void 0 ? "" : rt, nt = e.placeholder, oe = nt === void 0 ? "Please select" : nt, We = e.placeholderAlwaysShow, Rt = We !== void 0 && We, de = e.items, Se = de === void 0 ? null : de, rn = e.label, Dt = rn === void 0 ? "label" : rn, Xt = e.itemFilter, Ue = Xt === void 0 ? function(ie, ot, Mt) {
    return "".concat(ie).toLowerCase().includes(ot.toLowerCase());
  } : Xt, kn = e.groupBy, fn = kn === void 0 ? void 0 : kn, q = e.groupFilter, ee = q === void 0 ? function(ie) {
    return ie;
  } : q, ne = e.groupHeaderSelectable, he = ne !== void 0 && ne, je = e.itemId, _e = je === void 0 ? "value" : je, yt = e.loadOptions, Xe = yt === void 0 ? void 0 : yt, Zt = e.containerStyles, on = Zt === void 0 ? "" : Zt, Jt = e.hasError, Ge = Jt !== void 0 && Jt, xn = e.filterSelectedItems, Dn = xn === void 0 || xn, wn = e.required, $n = wn !== void 0 && wn, Rn = e.closeListOnChange, Jn = Rn === void 0 || Rn, pn = e.clearFilterTextOnBlur, me = pn === void 0 || pn, Ke = e.createGroupHeaderItem, It = Ke === void 0 ? function(ie, ot) {
    return Si({ value: ie }, Dt, ie);
  } : Ke, Nt = e.searchable, ce = Nt === void 0 || Nt, qe = e.inputStyles, Fe = qe === void 0 ? "" : qe, Lt = e.clearable, qt = Lt === void 0 || Lt, U = e.loading, G = U !== void 0 && U, re = e.listOpen, ae = re !== void 0 && re, ve = e.debounce, pt = ve === void 0 ? function(ie) {
    var ot = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    clearTimeout(d), d = setTimeout(ie, ot);
  } : ve, xt = e.debounceWait, Vt = xt === void 0 ? 300 : xt, vn = e.hideEmptyState, Mn = vn !== void 0 && vn, Ht = e.inputAttributes, mn = Ht === void 0 ? {} : Ht, K = e.listAutoWidth, pe = K === void 0 || K, Ne = e.showChevron, ze = Ne !== void 0 && Ne, Ve = e.listOffset, Ct = Ve === void 0 ? 5 : Ve, _t = e.hoverItemIndex, ut = _t === void 0 ? 0 : _t, $t = e.floatingConfig, kt = $t === void 0 ? {} : $t, sn = e.class, yn = sn === void 0 ? "" : sn;
  function qn(ie) {
    var ot = [], Mt = {};
    ie.forEach(function(Gt) {
      var Ut = fn(Gt);
      ot.includes(Ut) || (ot.push(Ut), Mt[Ut] = [], Ut && Mt[Ut].push(Object.assign(It(Ut, Gt), { id: Ut, groupHeader: !0, selectable: he }))), Mt[Ut].push(Object.assign({ groupItem: !!Ut }, Gt));
    });
    var _n = [];
    return ee(ot).forEach(function(Gt) {
      Mt[Gt] && _n.push.apply(_n, Ft(Mt[Gt]));
    }), _n;
  }
  function Or() {
    var ie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, ot = arguments.length > 1 ? arguments[1] : void 0;
    n(7, ut = ie < 0 ? 0 : ie), !ot && fn && c[ut] && !c[ut].selectable && Fr(1);
  }
  function yo() {
    var ie = !0;
    if (le) {
      var ot = [], Mt = [];
      le.forEach(function(_n) {
        ot.includes(_n[_e]) ? ie = !1 : (ot.push(_n[_e]), Mt.push(_n));
      }), ie || n(3, le = Mt);
    }
    return ie;
  }
  function pa(ie) {
    var ot = ie ? ie[_e] : le[_e];
    return Se.find(function(Mt) {
      return Mt[_e] === ot;
    });
  }
  function pi(ie) {
    return Oi.apply(this, arguments);
  }
  function Oi() {
    return (Oi = Tt(Ie().mark(function ie(ot) {
      var Mt;
      return Ie().wrap(function(_n) {
        for (; ; )
          switch (_n.prev = _n.next) {
            case 0:
              Mt = le[ot], le.length === 1 ? n(3, le = void 0) : n(3, le = le.filter(function(Gt) {
                return Gt !== Mt;
              })), $("clear", Mt);
            case 3:
            case "end":
              return _n.stop();
          }
      }, ie);
    }))).apply(this, arguments);
  }
  function Ji(ie) {
    var ot, Mt;
    Ce && C === ((ot = document) === null || ot === void 0 ? void 0 : ot.activeElement) || (ie && $("focus", ie), (Mt = C) === null || Mt === void 0 || Mt.focus(), n(2, Ce = !0));
  }
  function Nn(ie) {
    return ma.apply(this, arguments);
  }
  function ma() {
    return (ma = Tt(Ie().mark(function ie(ot) {
      var Mt;
      return Ie().wrap(function(_n) {
        for (; ; )
          switch (_n.prev = _n.next) {
            case 0:
              if (!wt) {
                _n.next = 2;
                break;
              }
              return _n.abrupt("return");
            case 2:
              (ae || Ce) && ($("blur", ot), oi(), n(2, Ce = !1), n(26, h = void 0), (Mt = C) === null || Mt === void 0 || Mt.blur());
            case 3:
            case "end":
              return _n.stop();
          }
      }, ie);
    }))).apply(this, arguments);
  }
  function oi() {
    me && n(4, Be = ""), n(6, ae = !1);
  }
  y = Tt(Ie().mark(function ie() {
    return Ie().wrap(function(ot) {
      for (; ; )
        switch (ot.prev = ot.next) {
          case 0:
            n(78, p = le), n(79, m = Be), n(80, g = z);
          case 3:
          case "end":
            return ot.stop();
        }
    }, ie);
  })), jc().$$.before_update.push(y), Fi(function() {
    ae && n(2, Ce = !0), Ce && C && C.focus();
  });
  var bo = e.ariaValues, W = bo === void 0 ? function(ie) {
    return "Option ".concat(ie, ", selected.");
  } : bo, ue = e.ariaListOpen, Ee = ue === void 0 ? function(ie, ot) {
    return "You are currently focused on option ".concat(ie, ". There are ").concat(ot, " results available.");
  } : ue, Re = e.ariaFocused, De = Re === void 0 ? function() {
    return "Select is focused, type to refine list, press down to open the menu.";
  } : Re, He, st = null;
  function gt() {
    clearTimeout(He), He = setTimeout(function() {
      wt = !1;
    }, 100);
  }
  Ci(function() {
    var ie;
    (ie = st) === null || ie === void 0 || ie.remove();
  });
  var wt = !1;
  function In(ie) {
    ie && ie.selectable !== !1 && function(ot) {
      if (ot) {
        n(4, Be = "");
        var Mt = Object.assign({}, ot);
        if (Mt.groupHeader && !Mt.selectable)
          return;
        n(3, le = z ? le ? le.concat([Mt]) : [Mt] : n(3, le = Mt)), setTimeout(function() {
          Jn && oi(), n(26, h = void 0), $("change", le), $("select", ot);
        });
      }
    }(ie);
  }
  function zn(ie) {
    wt || n(7, ut = ie);
  }
  function Pn(ie) {
    var ot = ie.item, Mt = ie.i;
    if ((ot == null ? void 0 : ot.selectable) !== !1)
      return le && !z && le[_e] === ot[_e] ? oi() : void (function(_n) {
        return _n.groupHeader && _n.selectable || _n.selectable || !_n.hasOwnProperty("selectable");
      }(ot) && (n(7, ut = Mt), In(ot)));
  }
  function Fr(ie) {
    if (c.filter(function(Mt) {
      return !Object.hasOwn(Mt, "selectable") || Mt.selectable === !0;
    }).length === 0)
      return n(7, ut = 0);
    ie > 0 && ut === c.length - 1 ? n(7, ut = 0) : n(7, ie < 0 && ut === 0 ? ut = c.length - 1 : ut += ie);
    var ot = c[ut];
    ot && ot.selectable === !1 && (ie !== 1 && ie !== -1 || Fr(ie));
  }
  var yr = mi, Ln = mi;
  function mi(ie) {
    return { update: function(ot) {
      ot.scroll && (gt(), ie.scrollIntoView({ behavior: "auto", block: "nearest" }));
    } };
  }
  var tr, pr = { strategy: "absolute", placement: "bottom-start", middleware: [(tr = Ct, tr === void 0 && (tr = 0), { name: "offset", options: tr, fn: function(ie) {
    return Tt(Ie().mark(function ot() {
      var Mt, _n, Gt;
      return Ie().wrap(function(Ut) {
        for (; ; )
          switch (Ut.prev = Ut.next) {
            case 0:
              return Mt = ie.x, _n = ie.y, Ut.next = 3, SX(ie, tr);
            case 3:
              return Gt = Ut.sent, Ut.abrupt("return", { x: Mt + Gt.x, y: _n + Gt.y, data: Gt });
            case 5:
            case "end":
              return Ut.stop();
          }
      }, ot);
    }))();
  } }), $X(), CX()], autoUpdate: !1 }, Oc = /* @__PURE__ */ function(ie) {
    var ot, Mt, _n = { autoUpdate: !0 }, Gt = ie, Ut = function(Ki) {
      return fe(fe(fe({}, _n), ie || {}), Ki || {});
    }, si = function(Ki) {
      ot && Mt && (Gt = Ut(Ki), TX(ot, Mt, Gt).then(function(Gi) {
        var Zo;
        Object.assign(Mt.style, { position: Gi.strategy, left: "".concat(Gi.x, "px"), top: "".concat(Gi.y, "px") }), !((Zo = Gt) === null || Zo === void 0) && Zo.onComputed && Gt.onComputed(Gi);
      }));
    }, iO = function(Ki) {
      Ci(Ki.subscribe(function(Gi) {
        ot === void 0 ? (ot = Gi, si()) : (Object.assign(ot, Gi), si());
      }));
    };
    return [function(Ki) {
      if ("subscribe" in Ki)
        return iO(Ki), {};
      ot = Ki, si();
    }, function(Ki, Gi) {
      var Zo;
      Mt = Ki, Gt = Ut(Gi), setTimeout(function() {
        return si(Gi);
      }, 0), si(Gi);
      var Ry = function() {
        Zo && (Zo(), Zo = void 0);
      }, Ny = function() {
        var cl = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Gt || {}).autoUpdate;
        if (Ry(), cl !== !1)
          return _X(ot, Mt, function() {
            return si(Gt);
          }, cl === !0 ? {} : cl);
      };
      return Zo = Ny(), { update: function(cl) {
        si(cl), Zo = Ny(cl);
      }, destroy: function() {
        Ry();
      } };
    }, si];
  }(pr), Cs = Et(Oc, 3), tO = Cs[0], nO = Cs[1], rO = Cs[2], tm = !0;
  return t.$$set = function(ie) {
    "justValue" in ie && n(52, B = ie.justValue), "filter" in ie && n(53, I = ie.filter), "getItems" in ie && n(54, J = ie.getItems), "id" in ie && n(55, Q = ie.id), "name" in ie && n(8, L = ie.name), "container" in ie && n(0, V = ie.container), "input" in ie && n(1, C = ie.input), "multiple" in ie && n(9, z = ie.multiple), "multiFullItemClearable" in ie && n(10, A = ie.multiFullItemClearable), "disabled" in ie && n(11, ge = ie.disabled), "focused" in ie && n(2, Ce = ie.focused), "value" in ie && n(3, le = ie.value), "filterText" in ie && n(4, Be = ie.filterText), "placeholder" in ie && n(56, oe = ie.placeholder), "placeholderAlwaysShow" in ie && n(57, Rt = ie.placeholderAlwaysShow), "items" in ie && n(51, Se = ie.items), "label" in ie && n(12, Dt = ie.label), "itemFilter" in ie && n(58, Ue = ie.itemFilter), "groupBy" in ie && n(59, fn = ie.groupBy), "groupFilter" in ie && n(60, ee = ie.groupFilter), "groupHeaderSelectable" in ie && n(61, he = ie.groupHeaderSelectable), "itemId" in ie && n(13, _e = ie.itemId), "loadOptions" in ie && n(62, Xe = ie.loadOptions), "containerStyles" in ie && n(14, on = ie.containerStyles), "hasError" in ie && n(15, Ge = ie.hasError), "filterSelectedItems" in ie && n(63, Dn = ie.filterSelectedItems), "required" in ie && n(16, $n = ie.required), "closeListOnChange" in ie && n(64, Jn = ie.closeListOnChange), "clearFilterTextOnBlur" in ie && n(65, me = ie.clearFilterTextOnBlur), "createGroupHeaderItem" in ie && n(66, It = ie.createGroupHeaderItem), "searchable" in ie && n(17, ce = ie.searchable), "inputStyles" in ie && n(18, Fe = ie.inputStyles), "clearable" in ie && n(68, qt = ie.clearable), "loading" in ie && n(5, G = ie.loading), "listOpen" in ie && n(6, ae = ie.listOpen), "debounce" in ie && n(69, pt = ie.debounce), "debounceWait" in ie && n(70, Vt = ie.debounceWait), "hideEmptyState" in ie && n(19, Mn = ie.hideEmptyState), "inputAttributes" in ie && n(71, mn = ie.inputAttributes), "listAutoWidth" in ie && n(72, pe = ie.listAutoWidth), "showChevron" in ie && n(20, ze = ie.showChevron), "listOffset" in ie && n(73, Ct = ie.listOffset), "hoverItemIndex" in ie && n(7, ut = ie.hoverItemIndex), "floatingConfig" in ie && n(74, kt = ie.floatingConfig), "class" in ie && n(21, yn = ie.class), "ariaValues" in ie && n(75, W = ie.ariaValues), "ariaListOpen" in ie && n(76, Ee = ie.ariaListOpen), "ariaFocused" in ie && n(77, De = ie.ariaFocused), "$$scope" in ie && n(82, b = ie.$$scope);
  }, t.$$.update = function() {
    var ie, ot, Mt, _n;
    8 & t.$$.dirty[0] | 1048576 & t.$$.dirty[1] && le && function() {
      if (typeof le == "string") {
        var Gt = (Se || []).find(function(Ut) {
          return Ut[_e] === le;
        });
        n(3, le = Gt || Si(Si({}, _e, le), "label", le));
      } else
        z && Array.isArray(le) && le.length > 0 && n(3, le = le.map(function(Ut) {
          return typeof Ut == "string" ? { value: Ut, label: Ut } : Ut;
        }));
    }(), 131072 & t.$$.dirty[0] | 512 & t.$$.dirty[2] && (!mn && ce || (n(27, v = Object.assign({ autocapitalize: "none", autocomplete: "off", autocorrect: "off", spellcheck: !1, tabindex: 0, type: "text", "aria-autocomplete": "list" }, mn)), Q && n(27, v.id = Q, v), ce || n(27, v.readonly = !0, v))), 512 & t.$$.dirty[0] && z && le && (Array.isArray(le) ? n(3, le = Ft(le)) : n(3, le = [le])), 512 & t.$$.dirty[0] | 262144 & t.$$.dirty[2] && g && !z && le && n(3, le = null), 520 & t.$$.dirty[0] && z && le && le.length > 1 && yo(), 8 & t.$$.dirty[0] && le && (z ? JSON.stringify(le) !== JSON.stringify(p) && yo() && $("input", le) : p && JSON.stringify(le[_e]) === JSON.stringify(p[_e]) || $("input", le)), 520 & t.$$.dirty[0] | 65536 & t.$$.dirty[2] && !le && z && p && $("input", le), 6 & t.$$.dirty[0] && !Ce && C && oi(), 16 & t.$$.dirty[0] | 131072 & t.$$.dirty[2] && Be !== m && (Xe || Be.length !== 0) && (Xe ? pt(Tt(Ie().mark(function Gt() {
      var Ut;
      return Ie().wrap(function(si) {
        for (; ; )
          switch (si.prev = si.next) {
            case 0:
              return n(5, G = !0), si.next = 3, J({ dispatch: $, loadOptions: Xe, convertStringItemsToObjects: Ij, filterText: Be });
            case 3:
              (Ut = si.sent) ? (n(5, G = Ut.loading), n(6, ae = ae ? Ut.listOpen : Be.length > 0), n(2, Ce = ae && Ut.focused), n(51, Se = fn ? qn(Ut.filteredItems) : Ut.filteredItems)) : (n(5, G = !1), n(2, Ce = !0), n(6, ae = !0));
            case 5:
            case "end":
              return si.stop();
          }
      }, Gt);
    })), Vt) : (n(6, ae = !0), z && n(26, h = void 0))), 12824 & t.$$.dirty[0] | 407896064 & t.$$.dirty[1] | 3 & t.$$.dirty[2] && n(24, c = I({ loadOptions: Xe, filterText: Be, items: Se, multiple: z, value: le, itemId: _e, groupBy: fn, label: Dt, filterSelectedItems: Dn, itemFilter: Ue, convertStringItemsToObjects: Ij, filterGroupedItems: qn })), 16777800 & t.$$.dirty[0] && !z && ae && le && c && Or(c.findIndex(function(Gt) {
      return Gt[_e] === le[_e];
    }), !0), 576 & t.$$.dirty[0] && ae && z && n(7, ut = 0), 16 & t.$$.dirty[0] && Be && n(7, ut = 0), 128 & t.$$.dirty[0] && $("hoverItem", ut), 520 & t.$$.dirty[0] && n(25, r = z ? le && le.length > 0 : le), 33554448 & t.$$.dirty[0] && n(35, i = r && Be.length > 0), 33556512 & t.$$.dirty[0] | 64 & t.$$.dirty[2] && n(34, o = r && qt && !ge && !G), 520 & t.$$.dirty[0] | 100663296 & t.$$.dirty[1] && n(33, s = Rt && z || z && ((ie = le) === null || ie === void 0 ? void 0 : ie.length) === 0 ? oe : le ? "" : oe), 520 & t.$$.dirty[0] && n(32, a = le ? (ot = void 0, ot = z && le.length > 0 ? le.map(function(Gt) {
      return Gt[Dt];
    }).join(", ") : le[Dt], W(ot)) : ""), 16777412 & t.$$.dirty[0] && n(31, l = function() {
      if (!c || c.length === 0)
        return "";
      var Gt = c[ut];
      if (ae && Gt) {
        var Ut = c ? c.length : 0;
        return Ee(Gt[Dt], Ut);
      }
      return De();
    }()), 1048576 & t.$$.dirty[1] && function(Gt) {
      Gt && Gt.length !== 0 && !Gt.some(function(Ut) {
        return hr(Ut) !== "object";
      }) && le && (z ? !le.some(function(Ut) {
        return !Ut || !Ut[_e];
      }) : le[_e]) && (Array.isArray(le) ? n(3, le = le.map(function(Ut) {
        return pa(Ut) || Ut;
      })) : n(3, le = pa() || le));
    }(Se), 8712 & t.$$.dirty[0] && n(52, B = z ? le ? le.map(function(Gt) {
      return Gt[_e];
    }) : null : le && le[_e]), 520 & t.$$.dirty[0] | 65536 & t.$$.dirty[2] && (z || !p || le || $("input", le)), 16777800 & t.$$.dirty[0] && ae && c && !z && !le && Or(), 16777216 & t.$$.dirty[0] && function(Gt) {
      ae && $("filter", Gt);
    }(c), 1 & t.$$.dirty[0] | 4096 & t.$$.dirty[2] && V && ((Mt = kt) === null || Mt === void 0 ? void 0 : Mt.autoUpdate) === void 0 && n(81, pr.autoUpdate = !0, pr), 1 & t.$$.dirty[0] | 528384 & t.$$.dirty[2] && V && kt && rO(Object.assign(pr, kt)), 8388608 & t.$$.dirty[0] && n(30, u = !!st), 8388672 & t.$$.dirty[0] && function(Gt, Ut) {
      if (!Gt || !Ut)
        return n(28, tm = !0);
      setTimeout(function() {
        n(28, tm = !1);
      }, 0);
    }(st, ae), 8388673 & t.$$.dirty[0] && ae && V && st && (_n = V.getBoundingClientRect().width, n(23, st.style.width = pe ? _n + "px" : "auto", st)), 128 & t.$$.dirty[0] && n(29, f = ut), 70 & t.$$.dirty[0] && C && ae && !Ce && Ji();
  }, [V, C, Ce, le, Be, G, ae, ut, L, z, A, ge, Dt, _e, on, Ge, $n, ce, Fe, Mn, ze, yn, function() {
    $("clear", le), n(3, le = void 0), oi(), Ji();
  }, st, c, r, h, v, tm, f, u, l, a, s, o, i, pi, function(ie) {
    if (Ce)
      switch (ie.stopPropagation(), ie.key) {
        case "Escape":
          ie.preventDefault(), oi();
          break;
        case "Enter":
          if (ie.preventDefault(), ae) {
            if (c.length === 0)
              break;
            var ot = c[ut];
            if (le && !z && le[_e] === ot[_e]) {
              oi();
              break;
            }
            In(c[ut]);
          }
          break;
        case "ArrowDown":
          ie.preventDefault(), ae ? Fr(1) : (n(6, ae = !0), n(26, h = void 0));
          break;
        case "ArrowUp":
          ie.preventDefault(), ae ? Fr(-1) : (n(6, ae = !0), n(26, h = void 0));
          break;
        case "Tab":
          if (ae && Ce) {
            if (c.length === 0 || le && le[_e] === c[ut][_e])
              return oi();
            ie.preventDefault(), In(c[ut]), oi();
          }
          break;
        case "Backspace":
          if (!z || Be.length > 0)
            return;
          if (z && le && le.length > 0) {
            if (pi(h !== void 0 ? h : le.length - 1), h === 0 || h === void 0)
              break;
            n(26, h = le.length > h ? h - 1 : void 0);
          }
          break;
        case "ArrowLeft":
          if (!le || !z || Be.length > 0)
            return;
          h === void 0 ? n(26, h = le.length - 1) : le.length > h && h !== 0 && n(26, h -= 1);
          break;
        case "ArrowRight":
          if (!le || !z || Be.length > 0 || h === void 0)
            return;
          h === le.length - 1 ? n(26, h = void 0) : h < le.length - 1 && n(26, h += 1);
      }
  }, Ji, Nn, function() {
    if (!ge)
      return Be.length > 0 ? n(6, ae = !0) : void n(6, ae = !ae);
  }, gt, function(ie) {
    var ot;
    ae || Ce || !V || V.contains(ie.target) || (ot = st) !== null && ot !== void 0 && ot.contains(ie.target) || Nn();
  }, zn, Pn, function(ie, ot, Mt) {
    if (!z)
      return ot && ot[Mt] === ie[Mt];
  }, yr, Ln, tO, nO, j, Se, B, I, J, Q, oe, Rt, Ue, fn, ee, he, Xe, Dn, Jn, me, It, function() {
    return c;
  }, qt, pt, Vt, mn, pe, Ct, kt, W, Ee, De, p, m, g, pr, b, x, function(ie) {
    ud.call(this, t, ie);
  }, function(ie) {
    ud.call(this, t, ie);
  }, function(ie) {
    ud.call(this, t, ie);
  }, function(ie) {
    ud.call(this, t, ie);
  }, function(ie) {
    return zn(ie);
  }, function(ie) {
    return zn(ie);
  }, function(ie, ot) {
    return Pn({ item: ie, i: ot });
  }, function(ie) {
    Kt[ie ? "unshift" : "push"](function() {
      n(23, st = ie);
    });
  }, function(ie) {
    return pi(ie);
  }, function(ie) {
    return A ? pi(ie) : {};
  }, function(ie) {
    Kt[ie ? "unshift" : "push"](function() {
      n(1, C = ie);
    });
  }, function() {
    Be = this.value, n(4, Be);
  }, function(ie) {
    Kt[ie ? "unshift" : "push"](function() {
      n(0, V = ie);
    });
  }];
}
var Ea = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, uZ, cZ, wr, { justValue: 52, filter: 53, getItems: 54, id: 55, name: 8, container: 0, input: 1, multiple: 9, multiFullItemClearable: 10, disabled: 11, focused: 2, value: 3, filterText: 4, placeholder: 56, placeholderAlwaysShow: 57, items: 51, label: 12, itemFilter: 58, groupBy: 59, groupFilter: 60, groupHeaderSelectable: 61, itemId: 13, loadOptions: 62, containerStyles: 14, hasError: 15, filterSelectedItems: 63, required: 16, closeListOnChange: 64, clearFilterTextOnBlur: 65, createGroupHeaderItem: 66, getFilteredItems: 67, searchable: 17, inputStyles: 18, clearable: 68, loading: 5, listOpen: 6, debounce: 69, debounceWait: 70, hideEmptyState: 19, inputAttributes: 71, listAutoWidth: 72, showChevron: 20, listOffset: 73, hoverItemIndex: 7, floatingConfig: 74, class: 21, handleClear: 22, ariaValues: 75, ariaListOpen: 76, ariaFocused: 77 }, VX, [-1, -1, -1, -1, -1]), i;
  }
  return Ye(n, [{ key: "getFilteredItems", get: function() {
    return this.$$.ctx[67];
  } }, { key: "handleClear", get: function() {
    return this.$$.ctx[22];
  } }]), n;
}();
function fZ(t) {
  At(t, "svelte-ijtq0l", "table.jse-transform-wizard.svelte-ijtq0l.svelte-ijtq0l{border-collapse:collapse;border-spacing:0;width:100%}table.jse-transform-wizard.svelte-ijtq0l input.svelte-ijtq0l{font-family:inherit;font-size:inherit}table.jse-transform-wizard.svelte-ijtq0l tr th.svelte-ijtq0l{font-weight:normal;text-align:left;width:60px}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l{width:100%;display:flex;flex-direction:row;margin-bottom:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select .multi-item{align-items:center}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select .value-container{gap:0 !important}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-filter-path{flex:4;margin-right:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-filter-relation{flex:1.5;margin-right:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-sort-path{flex:3;margin-right:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-sort-direction{flex:1}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-projection-paths{flex:1}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select input{box-sizing:border-box}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal .jse-filter-value.svelte-ijtq0l{flex:4;padding:4px 8px;border:var(--jse-input-border, 1px solid #d8dbdf);border-radius:var(--jse-input-radius, 3px);outline:none;background:var(--jse-input-background, var(--jse-background-color, #fff));color:inherit}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal .jse-filter-value.svelte-ijtq0l:focus{border:var(--jse-input-border-focus, 1px solid var(--jse-input-border-focus, var(--jse-theme-color, #3883fa)))}");
}
function dZ(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N, B, O, I, P, J, D, Q, Z, L, R, V;
  function M(we) {
    t[16](we);
  }
  var C = { class: "jse-filter-path", showChevron: !0, items: t[7] };
  function F(we) {
    t[17](we);
  }
  t[0] !== void 0 && (C.value = t[0]), a = new Ea({ props: C }), Kt.push(function() {
    return no(a, "value", M);
  });
  var z = { class: "jse-filter-relation", showChevron: !0, items: t[8] };
  function E(we) {
    t[19](we);
  }
  t[1] !== void 0 && (z.value = t[1]), u = new Ea({ props: z }), Kt.push(function() {
    return no(u, "value", F);
  });
  var A = { class: "jse-sort-path", showChevron: !0, items: t[7] };
  function te(we) {
    t[20](we);
  }
  t[3] !== void 0 && (A.value = t[3]), x = new Ea({ props: A }), Kt.push(function() {
    return no(x, "value", E);
  });
  var ge = { class: "jse-sort-direction", showChevron: !0, items: t[9] };
  function ke(we) {
    t[21](we);
  }
  t[4] !== void 0 && (ge.value = t[4]), $ = new Ea({ props: ge }), Kt.push(function() {
    return no($, "value", te);
  });
  var Ce = { class: "jse-projection-paths", multiple: !0, showChevron: !0, items: t[6] };
  return t[5] !== void 0 && (Ce.value = t[5]), Q = new Ea({ props: Ce }), Kt.push(function() {
    return no(Q, "value", ke);
  }), { c: function() {
    e = H("table"), n = H("tr"), (r = H("th")).textContent = "Filter", i = se(), o = H("td"), s = H("div"), xe(a.$$.fragment), c = se(), xe(u.$$.fragment), d = se(), h = H("input"), p = se(), m = H("tr"), (g = H("th")).textContent = "Sort", v = se(), y = H("td"), w = H("div"), xe(x.$$.fragment), j = se(), xe($.$$.fragment), B = se(), O = H("tr"), (I = H("th")).textContent = "Pick", P = se(), J = H("td"), D = H("div"), xe(Q.$$.fragment), k(r, "class", "svelte-ijtq0l"), k(h, "class", "jse-filter-value svelte-ijtq0l"), k(s, "class", "jse-horizontal svelte-ijtq0l"), k(g, "class", "svelte-ijtq0l"), k(w, "class", "jse-horizontal svelte-ijtq0l"), k(I, "class", "svelte-ijtq0l"), k(D, "class", "jse-horizontal svelte-ijtq0l"), k(e, "class", "jse-transform-wizard svelte-ijtq0l");
  }, m: function(we, le) {
    X(we, e, le), T(e, n), T(n, r), T(n, i), T(n, o), T(o, s), ye(a, s, null), T(s, c), ye(u, s, null), T(s, d), T(s, h), Uo(h, t[2]), T(e, p), T(e, m), T(m, g), T(m, v), T(m, y), T(y, w), ye(x, w, null), T(w, j), ye($, w, null), T(e, B), T(e, O), T(O, I), T(O, P), T(O, J), T(J, D), ye(Q, D, null), L = !0, R || (V = Oe(h, "input", t[18]), R = !0);
  }, p: function(we, le) {
    var rt = Et(le, 1)[0], Be = {};
    128 & rt && (Be.items = we[7]), !l && 1 & rt && (l = !0, Be.value = we[0], to(function() {
      return l = !1;
    })), a.$set(Be);
    var nt = {};
    !f && 2 & rt && (f = !0, nt.value = we[1], to(function() {
      return f = !1;
    })), u.$set(nt), 4 & rt && h.value !== we[2] && Uo(h, we[2]);
    var oe = {};
    128 & rt && (oe.items = we[7]), !b && 8 & rt && (b = !0, oe.value = we[3], to(function() {
      return b = !1;
    })), x.$set(oe);
    var We = {};
    !N && 16 & rt && (N = !0, We.value = we[4], to(function() {
      return N = !1;
    })), $.$set(We);
    var Rt = {};
    64 & rt && (Rt.items = we[6]), !Z && 32 & rt && (Z = !0, Rt.value = we[5], to(function() {
      return Z = !1;
    })), Q.$set(Rt);
  }, i: function(we) {
    L || (S(a.$$.fragment, we), S(u.$$.fragment, we), S(x.$$.fragment, we), S($.$$.fragment, we), S(Q.$$.fragment, we), L = !0);
  }, o: function(we) {
    _(a.$$.fragment, we), _(u.$$.fragment, we), _(x.$$.fragment, we), _($.$$.fragment, we), _(Q.$$.fragment, we), L = !1;
  }, d: function(we) {
    we && Y(e), be(a), be(u), be(x), be($), be(Q), R = !1, V();
  } };
}
function hZ(t, e, n) {
  var r, i, o, s, a, l, c, u, f, d, h, p = Tr("jsoneditor:TransformWizard"), m = e.json, g = e.queryOptions, v = g === void 0 ? {} : g, y = e.onChange, w = ["==", "!=", "<", "<=", ">", ">="].map(function(O) {
    return { value: O, label: O };
  }), x = [{ value: "asc", label: "ascending" }, { value: "desc", label: "descending" }], b = (r = v) !== null && r !== void 0 && (r = r.filter) !== null && r !== void 0 && r.path ? Kc(v.filter.path) : null, j = (i = v) !== null && i !== void 0 && (i = i.filter) !== null && i !== void 0 && i.relation ? w.find(function(O) {
    var I;
    return O.value === ((I = v.filter) === null || I === void 0 ? void 0 : I.relation);
  }) : null, $ = ((o = v) === null || o === void 0 || (o = o.filter) === null || o === void 0 ? void 0 : o.value) || "", N = (s = v) !== null && s !== void 0 && (s = s.sort) !== null && s !== void 0 && s.path ? Kc(v.sort.path) : null, B = (a = v) !== null && a !== void 0 && (a = a.sort) !== null && a !== void 0 && a.direction ? x.find(function(O) {
    var I;
    return O.value === ((I = v.sort) === null || I === void 0 ? void 0 : I.direction);
  }) : null;
  return t.$$set = function(O) {
    "json" in O && n(11, m = O.json), "queryOptions" in O && n(10, v = O.queryOptions), "onChange" in O && n(12, y = O.onChange);
  }, t.$$.update = function() {
    var O, I, P, J, D, Q, Z, L, R, V, M, C, F;
    2048 & t.$$.dirty && n(15, l = Array.isArray(m)), 34816 & t.$$.dirty && n(14, c = l ? Bv(m) : []), 34816 & t.$$.dirty && n(13, u = l ? Bv(m, !0) : []), 16384 & t.$$.dirty && n(7, f = c.map(Kc)), 8192 & t.$$.dirty && n(6, d = u ? u.map(Kc) : []), 1088 & t.$$.dirty && n(5, h = (O = v) !== null && O !== void 0 && (O = O.projection) !== null && O !== void 0 && O.paths && d ? v.projection.paths.map(function(z) {
      return d.find(function(E) {
        return tn(E.value, z);
      });
    }).filter(function(z) {
      return !!z;
    }) : null), 1 & t.$$.dirty && (P = ((I = b) === null || I === void 0 ? void 0 : I.value) || null, tn((J = v) === null || J === void 0 || (J = J.filter) === null || J === void 0 ? void 0 : J.path, P) || (p("changeFilterPath", P), n(10, v = Xi(v, ["filter", "path"], P, !0)), y(v))), 2 & t.$$.dirty && (Q = ((D = j) === null || D === void 0 ? void 0 : D.value) || null, tn((Z = v) === null || Z === void 0 || (Z = Z.filter) === null || Z === void 0 ? void 0 : Z.relation, Q) || (p("changeFilterRelation", Q), n(10, v = Xi(v, ["filter", "relation"], Q, !0)), y(v))), 4 & t.$$.dirty && (L = $ || null, tn((R = v) === null || R === void 0 || (R = R.filter) === null || R === void 0 ? void 0 : R.value, L) || (p("changeFilterValue", L), n(10, v = Xi(v, ["filter", "value"], L, !0)), y(v))), 8 & t.$$.dirty && function(z) {
      var E;
      tn((E = v) === null || E === void 0 || (E = E.sort) === null || E === void 0 ? void 0 : E.path, z) || (p("changeSortPath", z), n(10, v = Xi(v, ["sort", "path"], z, !0)), y(v));
    }(((V = N) === null || V === void 0 ? void 0 : V.value) || null), 16 & t.$$.dirty && (C = ((M = B) === null || M === void 0 ? void 0 : M.value) || null, tn((F = v) === null || F === void 0 || (F = F.sort) === null || F === void 0 ? void 0 : F.direction, C) || (p("changeSortDirection", C), n(10, v = Xi(v, ["sort", "direction"], C, !0)), y(v))), 32 & t.$$.dirty && function(z) {
      var E;
      tn((E = v) === null || E === void 0 || (E = E.projection) === null || E === void 0 ? void 0 : E.paths, z) || (p("changeProjectionPaths", z), n(10, v = Xi(v, ["projection", "paths"], z, !0)), y(v));
    }(h ? h.map(function(z) {
      return z.value;
    }) : null);
  }, [b, j, $, N, B, h, d, f, w, x, v, m, y, u, c, l, function(O) {
    n(0, b = O);
  }, function(O) {
    n(1, j = O);
  }, function() {
    $ = this.value, n(2, $);
  }, function(O) {
    n(3, N = O);
  }, function(O) {
    n(4, B = O);
  }, function(O) {
    n(5, h = O), n(10, v), n(6, d), n(13, u), n(15, l), n(11, m);
  }];
}
var pZ = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, hZ, dZ, Pt, { json: 11, queryOptions: 10, onChange: 12 }, fZ), i;
  }
  return Ye(n);
}();
function mZ(t) {
  At(t, "svelte-1wg043c", '.jse-select-query-language.svelte-1wg043c.svelte-1wg043c{position:relative;width:32px}.jse-select-query-language.svelte-1wg043c .jse-select-query-language-container.svelte-1wg043c{position:absolute;top:0;right:0;display:flex;flex-direction:column;box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}.jse-select-query-language.svelte-1wg043c .jse-select-query-language-container .jse-query-language.svelte-1wg043c{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;text-align:left;padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));white-space:nowrap;color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));background:var(--jse-context-menu-background, #656565)}.jse-select-query-language.svelte-1wg043c .jse-select-query-language-container .jse-query-language.svelte-1wg043c:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}');
}
function Dj(t, e, n) {
  var r = t.slice();
  return r[5] = e[n], r;
}
function gZ(t) {
  var e, n;
  return e = new cn({ props: { data: $u } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function vZ(t) {
  var e, n;
  return e = new cn({ props: { data: ku } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Lj(t) {
  var e, n, r, i, o, s, a, l, c, u, f = t[5].name + "", d = [vZ, gZ], h = [];
  function p(g, v) {
    return g[5].id === g[0] ? 0 : 1;
  }
  function m() {
    return t[4](t[5]);
  }
  return n = p(t), r = h[n] = d[n](t), { c: function() {
    e = H("button"), r.c(), i = se(), o = Le(f), s = se(), k(e, "type", "button"), k(e, "class", "jse-query-language svelte-1wg043c"), k(e, "title", a = "Select ".concat(t[5].name, " as query language")), $e(e, "selected", t[5].id === t[0]);
  }, m: function(g, v) {
    X(g, e, v), h[n].m(e, null), T(e, i), T(e, o), T(e, s), l = !0, c || (u = Oe(e, "click", m), c = !0);
  }, p: function(g, v) {
    var y = n;
    (n = p(t = g)) !== y && (Ae(), _(h[y], 1, 1, function() {
      h[y] = null;
    }), Me(), (r = h[n]) || (r = h[n] = d[n](t)).c(), S(r, 1), r.m(e, i)), (!l || 2 & v) && f !== (f = t[5].name + "") && bt(o, f), (!l || 2 & v && a !== (a = "Select ".concat(t[5].name, " as query language"))) && k(e, "title", a), (!l || 3 & v) && $e(e, "selected", t[5].id === t[0]);
  }, i: function(g) {
    l || (S(r), l = !0);
  }, o: function(g) {
    _(r), l = !1;
  }, d: function(g) {
    g && Y(e), h[n].d(), c = !1, u();
  } };
}
function yZ(t) {
  for (var e, n, r, i = Ot(t[1]), o = [], s = 0; s < i.length; s += 1)
    o[s] = Lj(Dj(t, i, s));
  var a = function(l) {
    return _(o[l], 1, 1, function() {
      o[l] = null;
    });
  };
  return { c: function() {
    e = H("div"), n = H("div");
    for (var l = 0; l < o.length; l += 1)
      o[l].c();
    k(n, "class", "jse-select-query-language-container svelte-1wg043c"), k(e, "class", "jse-select-query-language svelte-1wg043c");
  }, m: function(l, c) {
    X(l, e, c), T(e, n);
    for (var u = 0; u < o.length; u += 1)
      o[u] && o[u].m(n, null);
    r = !0;
  }, p: function(l, c) {
    var u = Et(c, 1)[0];
    if (7 & u) {
      var f;
      for (i = Ot(l[1]), f = 0; f < i.length; f += 1) {
        var d = Dj(l, i, f);
        o[f] ? (o[f].p(d, u), S(o[f], 1)) : (o[f] = Lj(d), o[f].c(), S(o[f], 1), o[f].m(n, null));
      }
      for (Ae(), f = i.length; f < o.length; f += 1)
        a(f);
      Me();
    }
  }, i: function(l) {
    if (!r) {
      for (var c = 0; c < i.length; c += 1)
        S(o[c]);
      r = !0;
    }
  }, o: function(l) {
    o = o.filter(Boolean);
    for (var c = 0; c < o.length; c += 1)
      _(o[c]);
    r = !1;
  }, d: function(l) {
    l && Y(e), fr(o, l);
  } };
}
function bZ(t, e, n) {
  var r = e.queryLanguages, i = e.queryLanguageId, o = e.onChangeQueryLanguage;
  function s(a) {
    n(0, i = a), o(a);
  }
  return t.$$set = function(a) {
    "queryLanguages" in a && n(1, r = a.queryLanguages), "queryLanguageId" in a && n(0, i = a.queryLanguageId), "onChangeQueryLanguage" in a && n(3, o = a.onChangeQueryLanguage);
  }, [i, r, s, o, function(a) {
    return s(a.id);
  }];
}
var xZ = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, bZ, yZ, wr, { queryLanguages: 1, queryLanguageId: 0, onChangeQueryLanguage: 3 }, mZ), i;
  }
  return Ye(n);
}();
function wZ(t) {
  At(t, "svelte-1n68mbh", ".jse-header.svelte-1n68mbh.svelte-1n68mbh{display:flex;background:var(--jse-theme-color, #3883fa);color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff))}.jse-header.svelte-1n68mbh .jse-title.svelte-1n68mbh{flex:1;padding:5px;vertical-align:middle}.jse-header.svelte-1n68mbh button.svelte-1n68mbh{border:none;background:transparent;min-width:32px;color:inherit;cursor:pointer}.jse-header.svelte-1n68mbh button.svelte-1n68mbh:hover{background:rgba(255, 255, 255, 0.1)}");
}
function Bj(t) {
  var e, n, r, i, o;
  return n = new cn({ props: { data: rB } }), { c: function() {
    e = H("button"), xe(n.$$.fragment), k(e, "type", "button"), k(e, "class", "jse-config svelte-1n68mbh"), k(e, "title", "Select a query language");
  }, m: function(s, a) {
    X(s, e, a), ye(n, e, null), t[6](e), r = !0, i || (o = Oe(e, "click", t[3]), i = !0);
  }, p: Pe, i: function(s) {
    r || (S(n.$$.fragment, s), r = !0);
  }, o: function(s) {
    _(n.$$.fragment, s), r = !1;
  }, d: function(s) {
    s && Y(e), be(n), t[6](null), i = !1, o();
  } };
}
function jZ(t) {
  var e, n, r, i, o, s, a, l, c, u = t[0].length > 1 && Bj(t);
  return s = new cn({ props: { data: Gl } }), { c: function() {
    e = H("div"), (n = H("div")).textContent = "Transform", r = se(), u && u.c(), i = se(), o = H("button"), xe(s.$$.fragment), k(n, "class", "jse-title svelte-1n68mbh"), k(o, "type", "button"), k(o, "class", "jse-close svelte-1n68mbh"), k(e, "class", "jse-header svelte-1n68mbh");
  }, m: function(f, d) {
    X(f, e, d), T(e, n), T(e, r), u && u.m(e, null), T(e, i), T(e, o), ye(s, o, null), a = !0, l || (c = Oe(o, "click", t[7]), l = !0);
  }, p: function(f, d) {
    var h = Et(d, 1)[0];
    f[0].length > 1 ? u ? (u.p(f, h), 1 & h && S(u, 1)) : ((u = Bj(f)).c(), S(u, 1), u.m(e, i)) : u && (Ae(), _(u, 1, 1, function() {
      u = null;
    }), Me());
  }, i: function(f) {
    a || (S(u), S(s.$$.fragment, f), a = !0);
  }, o: function(f) {
    _(u), _(s.$$.fragment, f), a = !1;
  }, d: function(f) {
    f && Y(e), u && u.d(), be(s), l = !1, c();
  } };
}
function kZ(t, e, n) {
  var r, i, o = e.queryLanguages, s = e.queryLanguageId, a = e.onChangeQueryLanguage, l = _r("simple-modal").close, c = _r("absolute-popup"), u = c.openAbsolutePopup, f = c.closeAbsolutePopup;
  return t.$$set = function(d) {
    "queryLanguages" in d && n(0, o = d.queryLanguages), "queryLanguageId" in d && n(4, s = d.queryLanguageId), "onChangeQueryLanguage" in d && n(5, a = d.onChangeQueryLanguage);
  }, [o, r, l, function() {
    i = u(xZ, { queryLanguages: o, queryLanguageId: s, onChangeQueryLanguage: function(d) {
      f(i), a(d);
    } }, { position: "bottom", offsetTop: -2, offsetLeft: 0, anchor: r, closeOnOuterClick: !0 });
  }, s, a, function(d) {
    Kt[d ? "unshift" : "push"](function() {
      n(1, r = d);
    });
  }, function() {
    return l();
  }];
}
var $Z = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, kZ, jZ, Pt, { queryLanguages: 0, queryLanguageId: 4, onChangeQueryLanguage: 5 }, wZ), i;
  }
  return Ye(n);
}(), ng = Tr("jsoneditor:AutoScrollHandler"), SZ = function(t, e, n, r) {
  return (t /= r / 2) < 1 ? n / 2 * t * t + e : -n / 2 * (--t * (t - 2) - 1) + e;
}, M5 = function() {
  var t, e, n, r, i, o, s, a, l, c, u, f, d;
  function h(g) {
    return g.getBoundingClientRect().top - (t.getBoundingClientRect ? t.getBoundingClientRect().top : 0) + n;
  }
  function p(g) {
    t.scrollTo ? t.scrollTo(t.scrollLeft, g) : t.scrollTop = g;
  }
  function m(g) {
    c || (c = g), p(o(u = g - c, n, a, l)), d = !0, u < l ? requestAnimationFrame(m) : function() {
      p(n + a), e && s && (e.setAttribute("tabindex", "-1"), e.focus()), typeof f == "function" && f(), c = 0, d = !1;
    }();
  }
  return function(g) {
    var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    switch (l = 1e3, i = v.offset || 0, f = v.callback, o = v.easing || SZ, s = v.a11y || !1, hr(v.container)) {
      case "object":
        t = v.container;
        break;
      case "string":
        t = document.querySelector(v.container);
        break;
      default:
        t = window.document.documentElement;
    }
    switch (n = t.scrollTop, hr(g)) {
      case "number":
        e = void 0, s = !1, r = n + g;
        break;
      case "object":
        r = h(e = g);
        break;
      case "string":
        e = document.querySelector(g), r = h(e);
    }
    switch (a = r - n + i, hr(v.duration)) {
      case "number":
        l = v.duration;
        break;
      case "function":
        l = v.duration(a);
    }
    d ? c = 0 : requestAnimationFrame(m);
  };
}, CZ = 1e3, md = Tr("jsoneditor:History");
function _5() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.maxItems || CZ, n = [], r = 0;
  function i() {
    return r < n.length;
  }
  function o() {
    return r > 0;
  }
  function s() {
    return { canUndo: i(), canRedo: o(), length: n.length };
  }
  function a() {
    t.onChange && t.onChange(s());
  }
  return { add: function(l) {
    md("add", l), n = [l].concat(n.slice(r)).slice(0, e), r = 0, a();
  }, clear: function() {
    md("clear"), n = [], r = 0, a();
  }, getState: s, undo: function() {
    if (i()) {
      var l = n[r];
      return r += 1, md("undo", l), a(), l;
    }
  }, redo: function() {
    if (o())
      return md("redo", n[r -= 1]), a(), n[r];
  } };
}
function Al(t, e) {
  var n = Date.now(), r = t();
  return e(Date.now() - n), r;
}
var wl = Tr("validation");
function T5(t, e, n, r) {
  return wl("validateJSON"), e ? e(n !== r ? r.parse(n.stringify(t)) : t) : [];
}
function OZ(t, e, n, r) {
  if (wl("validateText"), t.length > RQ)
    return { validationErrors: [{ path: [], message: "Validation turned off: the document is too large", severity: gs.info }] };
  if (t.length === 0)
    return null;
  try {
    var i = Al(function() {
      return n.parse(t);
    }, function(l) {
      return wl("validate: parsed json in ".concat(l, " ms"));
    });
    if (!e)
      return null;
    var o = n === r ? i : Al(function() {
      return r.parse(t);
    }, function(l) {
      return wl("validate: parsed json with the validationParser in ".concat(l, " ms"));
    }), s = Al(function() {
      return e(o);
    }, function(l) {
      return wl("validate: validated json in ".concat(l, " ms"));
    });
    return nn(s) ? null : { validationErrors: s };
  } catch (l) {
    var a = Al(function() {
      return function(c, u) {
        if (c.length > NQ)
          return !1;
        try {
          return u.parse(Lo(c)), !0;
        } catch {
          return !1;
        }
      }(t, n);
    }, function(c) {
      return wl("validate: checked whether repairable in ".concat(c, " ms"));
    });
    return { parseError: ic(t, l.message || l.toString()), isRepairable: a };
  }
}
var gd = Tr("jsoneditor:FocusTracker");
function jy(t) {
  var e, n = t.onMount, r = t.onDestroy, i = t.getWindow, o = t.hasFocus, s = t.onFocus, a = t.onBlur, l = !1;
  function c() {
    var f = o();
    f && (clearTimeout(e), l || (gd("focus"), s(), l = f));
  }
  function u() {
    l && (clearTimeout(e), e = setTimeout(function() {
      o() || (gd("blur"), l = !1, a());
    }));
  }
  n(function() {
    gd("mount FocusTracker");
    var f = i();
    f && (f.addEventListener("focusin", c, !0), f.addEventListener("focusout", u, !0));
  }), r(function() {
    gd("destroy FocusTracker");
    var f = i();
    f && (f.removeEventListener("focusin", c, !0), f.removeEventListener("focusout", u, !0));
  });
}
function EZ(t) {
  At(t, "svelte-p1zf9f", '.jse-message.svelte-p1zf9f.svelte-p1zf9f{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);padding:var(--jse-padding, 10px);display:flex;gap:var(--jse-padding, 10px);flex-wrap:wrap;align-items:stretch}.jse-message.jse-success.svelte-p1zf9f.svelte-p1zf9f{background:var(--message-success-background, #9ac45d);color:var(--jse-message-success-color, #fff)}.jse-message.svelte-p1zf9f .jse-text.svelte-p1zf9f{display:flex;flex:1;min-width:60%;align-items:center}.jse-message.svelte-p1zf9f .jse-text.jse-clickable.svelte-p1zf9f{cursor:pointer}.jse-message.svelte-p1zf9f .jse-text.jse-clickable.svelte-p1zf9f:hover{background-color:rgba(255, 255, 255, 0.1)}.jse-message.jse-error.svelte-p1zf9f.svelte-p1zf9f{background:var(--jse-message-error-background, var(--jse-error-color, #ee5341));color:var(--jse-message-error-color, #fff)}.jse-message.jse-warning.svelte-p1zf9f.svelte-p1zf9f{background:var(--jse-message-warning-background, #ffde5c);color:var(--jse-message-warning-color, #4d4d4d)}.jse-message.jse-info.svelte-p1zf9f.svelte-p1zf9f{background:var(--jse-message-info-background, #4f91ff);color:var(--jse-message-info-color, #fff)}.jse-message.svelte-p1zf9f .jse-actions.svelte-p1zf9f{display:flex;gap:var(--jse-padding, 10px)}.jse-message.svelte-p1zf9f .jse-actions button.jse-action.svelte-p1zf9f{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-message-action-background, rgba(255, 255, 255, 0.2));color:inherit;padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px)}.jse-message.svelte-p1zf9f .jse-actions button.jse-action.svelte-p1zf9f:hover{background:var(--jse-message-action-background-highlight, rgba(255, 255, 255, 0.3))}');
}
function qj(t, e, n) {
  var r = t.slice();
  return r[9] = e[n], r;
}
function zj(t) {
  var e, n;
  return e = new cn({ props: { data: t[1] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2 & i && (o.data = r[1]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Fj(t) {
  var e, n;
  return e = new cn({ props: { data: t[9].icon } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    8 & i && (o.data = r[9].icon), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Vj(t) {
  var e, n, r, i, o, s, a, l, c, u = t[9].text + "", f = t[9].icon && Fj(t);
  function d() {
    return t[7](t[9]);
  }
  function h() {
    return t[8](t[9]);
  }
  return { c: function() {
    e = H("button"), f && f.c(), n = se(), r = Le(u), i = se(), k(e, "type", "button"), k(e, "class", "jse-button jse-action jse-primary svelte-p1zf9f"), k(e, "title", o = t[9].title), e.disabled = s = t[9].disabled;
  }, m: function(p, m) {
    X(p, e, m), f && f.m(e, null), T(e, n), T(e, r), T(e, i), a = !0, l || (c = [Oe(e, "click", d), Oe(e, "mousedown", h)], l = !0);
  }, p: function(p, m) {
    (t = p)[9].icon ? f ? (f.p(t, m), 8 & m && S(f, 1)) : ((f = Fj(t)).c(), S(f, 1), f.m(e, n)) : f && (Ae(), _(f, 1, 1, function() {
      f = null;
    }), Me()), (!a || 8 & m) && u !== (u = t[9].text + "") && bt(r, u), (!a || 8 & m && o !== (o = t[9].title)) && k(e, "title", o), (!a || 8 & m && s !== (s = t[9].disabled)) && (e.disabled = s);
  }, i: function(p) {
    a || (S(f), a = !0);
  }, o: function(p) {
    _(f), a = !1;
  }, d: function(p) {
    p && Y(e), f && f.d(), l = !1, An(c);
  } };
}
function AZ(t) {
  for (var e, n, r, i, o, s, a, l, c, u, f, d = t[1] && zj(t), h = Ot(t[3]), p = [], m = 0; m < h.length; m += 1)
    p[m] = Vj(qj(t, h, m));
  var g = function(v) {
    return _(p[v], 1, 1, function() {
      p[v] = null;
    });
  };
  return { c: function() {
    e = H("div"), n = H("div"), r = H("div"), d && d.c(), i = se(), o = Le(t[2]), s = se(), a = H("div");
    for (var v = 0; v < p.length; v += 1)
      p[v].c();
    k(r, "class", "jse-text-centered"), k(n, "role", "button"), k(n, "tabindex", "-1"), k(n, "class", "jse-text svelte-p1zf9f"), $e(n, "jse-clickable", !!t[4]), k(a, "class", "jse-actions svelte-p1zf9f"), k(e, "class", l = "jse-message jse-" + t[0] + " svelte-p1zf9f");
  }, m: function(v, y) {
    X(v, e, y), T(e, n), T(n, r), d && d.m(r, null), T(r, i), T(r, o), T(e, s), T(e, a);
    for (var w = 0; w < p.length; w += 1)
      p[w] && p[w].m(a, null);
    c = !0, u || (f = Oe(n, "click", t[5]), u = !0);
  }, p: function(v, y) {
    var w = Et(y, 1)[0];
    if (v[1] ? d ? (d.p(v, w), 2 & w && S(d, 1)) : ((d = zj(v)).c(), S(d, 1), d.m(r, i)) : d && (Ae(), _(d, 1, 1, function() {
      d = null;
    }), Me()), (!c || 4 & w) && bt(o, v[2]), (!c || 16 & w) && $e(n, "jse-clickable", !!v[4]), 8 & w) {
      var x;
      for (h = Ot(v[3]), x = 0; x < h.length; x += 1) {
        var b = qj(v, h, x);
        p[x] ? (p[x].p(b, w), S(p[x], 1)) : (p[x] = Vj(b), p[x].c(), S(p[x], 1), p[x].m(a, null));
      }
      for (Ae(), x = h.length; x < p.length; x += 1)
        g(x);
      Me();
    }
    (!c || 1 & w && l !== (l = "jse-message jse-" + v[0] + " svelte-p1zf9f")) && k(e, "class", l);
  }, i: function(v) {
    if (!c) {
      S(d);
      for (var y = 0; y < h.length; y += 1)
        S(p[y]);
      c = !0;
    }
  }, o: function(v) {
    _(d), p = p.filter(Boolean);
    for (var y = 0; y < p.length; y += 1)
      _(p[y]);
    c = !1;
  }, d: function(v) {
    v && Y(e), d && d.d(), fr(p, v), u = !1, f();
  } };
}
function MZ(t, e, n) {
  var r = e.type, i = r === void 0 ? "success" : r, o = e.icon, s = o === void 0 ? void 0 : o, a = e.message, l = a === void 0 ? void 0 : a, c = e.actions, u = c === void 0 ? [] : c, f = e.onClick, d = f === void 0 ? void 0 : f, h = e.onClose, p = h === void 0 ? void 0 : h;
  return p && Ci(p), t.$$set = function(m) {
    "type" in m && n(0, i = m.type), "icon" in m && n(1, s = m.icon), "message" in m && n(2, l = m.message), "actions" in m && n(3, u = m.actions), "onClick" in m && n(4, d = m.onClick), "onClose" in m && n(6, p = m.onClose);
  }, [i, s, l, u, d, function() {
    d && d();
  }, p, function(m) {
    m.onClick && m.onClick();
  }, function(m) {
    m.onMouseDown && m.onMouseDown();
  }];
}
var vo = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, MZ, AZ, Pt, { type: 0, icon: 1, message: 2, actions: 3, onClick: 4, onClose: 6 }, EZ), i;
  }
  return Ye(n);
}();
function _Z(t) {
  At(t, "svelte-1ifg4t0", '.jse-validation-errors-overview.svelte-1ifg4t0.svelte-1ifg4t0{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);background:var(--jse-message-warning-background, #ffde5c);color:var(--jse-message-warning-color, #4d4d4d);overflow:auto;max-height:25%}.jse-validation-errors-overview.svelte-1ifg4t0 table.svelte-1ifg4t0{border-collapse:collapse;width:100%}.jse-validation-errors-overview.svelte-1ifg4t0 table tr.svelte-1ifg4t0{cursor:pointer}.jse-validation-errors-overview.svelte-1ifg4t0 table tr.svelte-1ifg4t0:hover{background-color:rgba(255, 255, 255, 0.1)}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td.svelte-1ifg4t0{padding:4px var(--jse-padding, 10px);vertical-align:middle}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td.jse-validation-error-icon.svelte-1ifg4t0{width:36px;box-sizing:border-box}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td.jse-validation-error-action.svelte-1ifg4t0{width:36px;box-sizing:border-box;padding:0}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td.jse-validation-error-action button.jse-validation-errors-collapse.svelte-1ifg4t0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;width:36px;height:26px;cursor:pointer}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td.jse-validation-error-action button.jse-validation-errors-collapse.svelte-1ifg4t0:hover{background-color:rgba(255, 255, 255, 0.2)}.jse-validation-errors-overview.svelte-1ifg4t0 table tr td div.jse-validation-errors-expand.svelte-1ifg4t0{display:inline-block;position:relative;top:3px}');
}
function Hj(t, e, n) {
  var r = t.slice();
  return r[7] = e[n], r[9] = n, r;
}
function Uj(t) {
  var e, n, r, i, o = [PZ, TZ], s = [];
  function a(l, c) {
    return l[2] || l[3] === 1 ? 0 : 1;
  }
  return n = a(t), r = s[n] = o[n](t), { c: function() {
    e = H("div"), r.c(), k(e, "class", "jse-validation-errors-overview svelte-1ifg4t0");
  }, m: function(l, c) {
    X(l, e, c), s[n].m(e, null), i = !0;
  }, p: function(l, c) {
    var u = n;
    (n = a(l)) === u ? s[n].p(l, c) : (Ae(), _(s[u], 1, 1, function() {
      s[u] = null;
    }), Me(), (r = s[n]) ? r.p(l, c) : (r = s[n] = o[n](l)).c(), S(r, 1), r.m(e, null));
  }, i: function(l) {
    i || (S(r), i = !0);
  }, o: function(l) {
    _(r), i = !1;
  }, d: function(l) {
    l && Y(e), s[n].d();
  } };
}
function TZ(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p;
  return o = new cn({ props: { data: al } }), f = new cn({ props: { data: IS } }), { c: function() {
    e = H("table"), n = H("tbody"), r = H("tr"), i = H("td"), xe(o.$$.fragment), s = se(), a = H("td"), l = Le(t[3]), c = Le(` validation errors
              `), u = H("div"), xe(f.$$.fragment), k(i, "class", "jse-validation-error-icon svelte-1ifg4t0"), k(u, "class", "jse-validation-errors-expand svelte-1ifg4t0"), k(a, "class", "jse-validation-error-count svelte-1ifg4t0"), k(r, "class", "jse-validation-error svelte-1ifg4t0"), k(e, "class", "jse-validation-errors-overview-collapsed svelte-1ifg4t0");
  }, m: function(m, g) {
    X(m, e, g), T(e, n), T(n, r), T(r, i), ye(o, i, null), T(r, s), T(r, a), T(a, l), T(a, c), T(a, u), ye(f, u, null), d = !0, h || (p = Oe(r, "click", t[5]), h = !0);
  }, p: function(m, g) {
    (!d || 8 & g) && bt(l, m[3]);
  }, i: function(m) {
    d || (S(o.$$.fragment, m), S(f.$$.fragment, m), d = !0);
  }, o: function(m) {
    _(o.$$.fragment, m), _(f.$$.fragment, m), d = !1;
  }, d: function(m) {
    m && Y(e), be(o), be(f), h = !1, p();
  } };
}
function PZ(t) {
  for (var e, n, r, i, o = Ot(qh(t[0], Ol)), s = [], a = 0; a < o.length; a += 1)
    s[a] = Jj(Hj(t, o, a));
  var l = function(u) {
    return _(s[u], 1, 1, function() {
      s[u] = null;
    });
  }, c = t[3] > Ol && Kj(t);
  return { c: function() {
    e = H("table"), n = H("tbody");
    for (var u = 0; u < s.length; u += 1)
      s[u].c();
    r = se(), c && c.c(), k(e, "class", "jse-validation-errors-overview-expanded svelte-1ifg4t0");
  }, m: function(u, f) {
    X(u, e, f), T(e, n);
    for (var d = 0; d < s.length; d += 1)
      s[d] && s[d].m(n, null);
    T(n, r), c && c.m(n, null), i = !0;
  }, p: function(u, f) {
    if (19 & f) {
      var d;
      for (o = Ot(qh(u[0], Ol)), d = 0; d < o.length; d += 1) {
        var h = Hj(u, o, d);
        s[d] ? (s[d].p(h, f), S(s[d], 1)) : (s[d] = Jj(h), s[d].c(), S(s[d], 1), s[d].m(n, r));
      }
      for (Ae(), d = o.length; d < s.length; d += 1)
        l(d);
      Me();
    }
    u[3] > Ol ? c ? c.p(u, f) : ((c = Kj(u)).c(), c.m(n, null)) : c && (c.d(1), c = null);
  }, i: function(u) {
    if (!i) {
      for (var f = 0; f < o.length; f += 1)
        S(s[f]);
      i = !0;
    }
  }, o: function(u) {
    s = s.filter(Boolean);
    for (var f = 0; f < s.length; f += 1)
      _(s[f]);
    i = !1;
  }, d: function(u) {
    u && Y(e), fr(s, u), c && c.d();
  } };
}
function Wj(t) {
  var e, n, r, i, o;
  return n = new cn({ props: { data: sB } }), { c: function() {
    e = H("button"), xe(n.$$.fragment), k(e, "type", "button"), k(e, "class", "jse-validation-errors-collapse svelte-1ifg4t0"), k(e, "title", "Collapse validation errors");
  }, m: function(s, a) {
    X(s, e, a), ye(n, e, null), r = !0, i || (o = Oe(e, "click", po(t[4])), i = !0);
  }, p: Pe, i: function(s) {
    r || (S(n.$$.fragment, s), r = !0);
  }, o: function(s) {
    _(n.$$.fragment, s), r = !1;
  }, d: function(s) {
    s && Y(e), be(n), i = !1, o();
  } };
}
function Jj(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m = hi(t[7].path) + "", g = t[7].message + "";
  r = new cn({ props: { data: al } });
  var v = t[9] === 0 && t[0].length > 1 && Wj(t);
  function y() {
    return t[6](t[7]);
  }
  return { c: function() {
    e = H("tr"), n = H("td"), xe(r.$$.fragment), i = se(), o = H("td"), s = Le(m), a = se(), l = H("td"), c = Le(g), u = se(), f = H("td"), v && v.c(), k(n, "class", "jse-validation-error-icon svelte-1ifg4t0"), k(o, "class", "jse-validation-error-path svelte-1ifg4t0"), k(l, "class", "jse-validation-error-message svelte-1ifg4t0"), k(f, "class", "jse-validation-error-action svelte-1ifg4t0"), k(e, "class", "jse-validation-error svelte-1ifg4t0");
  }, m: function(w, x) {
    X(w, e, x), T(e, n), ye(r, n, null), T(e, i), T(e, o), T(o, s), T(e, a), T(e, l), T(l, c), T(e, u), T(e, f), v && v.m(f, null), d = !0, h || (p = Oe(e, "click", y), h = !0);
  }, p: function(w, x) {
    t = w, (!d || 1 & x) && m !== (m = hi(t[7].path) + "") && bt(s, m), (!d || 1 & x) && g !== (g = t[7].message + "") && bt(c, g), t[9] === 0 && t[0].length > 1 ? v ? (v.p(t, x), 1 & x && S(v, 1)) : ((v = Wj(t)).c(), S(v, 1), v.m(f, null)) : v && (Ae(), _(v, 1, 1, function() {
      v = null;
    }), Me());
  }, i: function(w) {
    d || (S(r.$$.fragment, w), S(v), d = !0);
  }, o: function(w) {
    _(r.$$.fragment, w), _(v), d = !1;
  }, d: function(w) {
    w && Y(e), be(r), v && v.d(), h = !1, p();
  } };
}
function Kj(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d = t[3] - Ol + "";
  return { c: function() {
    e = H("tr"), n = H("td"), r = se(), i = H("td"), o = se(), s = H("td"), a = Le("(and "), l = Le(d), c = Le(" more errors)"), u = se(), f = H("td"), k(n, "class", "svelte-1ifg4t0"), k(i, "class", "svelte-1ifg4t0"), k(s, "class", "svelte-1ifg4t0"), k(f, "class", "svelte-1ifg4t0"), k(e, "class", "jse-validation-error svelte-1ifg4t0");
  }, m: function(h, p) {
    X(h, e, p), T(e, n), T(e, r), T(e, i), T(e, o), T(e, s), T(s, a), T(s, l), T(s, c), T(e, u), T(e, f);
  }, p: function(h, p) {
    8 & p && d !== (d = h[3] - Ol + "") && bt(l, d);
  }, d: function(h) {
    h && Y(e);
  } };
}
function RZ(t) {
  var e, n, r = !nn(t[0]), i = r && Uj(t);
  return { c: function() {
    i && i.c(), e = un();
  }, m: function(o, s) {
    i && i.m(o, s), X(o, e, s), n = !0;
  }, p: function(o, s) {
    var a = Et(s, 1)[0];
    1 & a && (r = !nn(o[0])), r ? i ? (i.p(o, a), 1 & a && S(i, 1)) : ((i = Uj(o)).c(), S(i, 1), i.m(e.parentNode, e)) : i && (Ae(), _(i, 1, 1, function() {
      i = null;
    }), Me());
  }, i: function(o) {
    n || (S(i), n = !0);
  }, o: function(o) {
    _(i), n = !1;
  }, d: function(o) {
    o && Y(e), i && i.d(o);
  } };
}
function NZ(t, e, n) {
  var r, i = e.validationErrors, o = e.selectError, s = !0;
  return t.$$set = function(a) {
    "validationErrors" in a && n(0, i = a.validationErrors), "selectError" in a && n(1, o = a.selectError);
  }, t.$$.update = function() {
    1 & t.$$.dirty && n(3, r = i.length);
  }, [i, o, s, r, function() {
    n(2, s = !1);
  }, function() {
    n(2, s = !0);
  }, function(a) {
    setTimeout(function() {
      return o(a);
    });
  }];
}
var ky = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, NZ, RZ, Pt, { validationErrors: 0, selectError: 1 }, _Z), i;
  }
  return Ye(n);
}(), IZ = typeof navigator < "u" && navigator.platform.toUpperCase().indexOf("MAC") >= 0;
function DZ(t) {
  At(t, "svelte-1n68mbh", ".jse-header.svelte-1n68mbh.svelte-1n68mbh{display:flex;background:var(--jse-theme-color, #3883fa);color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff))}.jse-header.svelte-1n68mbh .jse-title.svelte-1n68mbh{flex:1;padding:5px;vertical-align:middle}.jse-header.svelte-1n68mbh button.svelte-1n68mbh{border:none;background:transparent;min-width:32px;color:inherit;cursor:pointer}.jse-header.svelte-1n68mbh button.svelte-1n68mbh:hover{background:rgba(255, 255, 255, 0.1)}");
}
function LZ(t) {
  var e, n, r, i, o, s, a, l, c;
  return s = new cn({ props: { data: Gl } }), { c: function() {
    e = H("div"), n = H("div"), r = Le(t[0]), i = se(), o = H("button"), xe(s.$$.fragment), k(n, "class", "jse-title svelte-1n68mbh"), k(o, "type", "button"), k(o, "class", "jse-close svelte-1n68mbh"), k(e, "class", "jse-header svelte-1n68mbh");
  }, m: function(u, f) {
    X(u, e, f), T(e, n), T(n, r), T(e, i), T(e, o), ye(s, o, null), a = !0, l || (c = Oe(o, "click", t[3]), l = !0);
  }, p: function(u, f) {
    var d = Et(f, 1)[0];
    (!a || 1 & d) && bt(r, u[0]);
  }, i: function(u) {
    a || (S(s.$$.fragment, u), a = !0);
  }, o: function(u) {
    _(s.$$.fragment, u), a = !1;
  }, d: function(u) {
    u && Y(e), be(s), l = !1, c();
  } };
}
function BZ(t, e, n) {
  var r = e.title, i = r === void 0 ? "Modal" : r, o = e.onClose, s = o === void 0 ? void 0 : o, a = _r("simple-modal").close;
  return t.$$set = function(l) {
    "title" in l && n(0, i = l.title), "onClose" in l && n(1, s = l.onClose);
  }, [i, s, a, function() {
    s ? s() : a();
  }];
}
var $y = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, BZ, LZ, Pt, { title: 0, onClose: 1 }, DZ), i;
  }
  return Ye(n);
}();
function qZ(t) {
  At(t, "svelte-18bor9q", '.jse-modal.svelte-18bor9q.svelte-18bor9q{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-18bor9q .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-18bor9q .jse-modal-contents.svelte-18bor9q{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-18bor9q .jse-modal-contents .jse-actions.svelte-18bor9q{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-18bor9q .jse-modal-contents .jse-actions button.jse-primary.svelte-18bor9q{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-18bor9q .jse-modal-contents .jse-actions button.jse-primary.svelte-18bor9q:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-18bor9q .jse-modal-contents .jse-actions button.jse-primary.svelte-18bor9q:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;height:auto;min-height:500px;max-height:calc(100vh - 6rem);display:flex}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0}.jse-modal.jse-copy-paste.svelte-18bor9q .jse-shortcuts.svelte-18bor9q{display:flex;flex-wrap:wrap;justify-content:space-around;margin:calc(2 * var(--jse-padding, 10px)) 0}.jse-modal.jse-copy-paste.svelte-18bor9q .jse-shortcuts .jse-shortcut .jse-key.svelte-18bor9q{font-size:200%;color:var(--jse-theme-color, #3883fa)}');
}
function zZ(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N;
  return n = new $y({ props: { title: "Copying and pasting" } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), r = se(), i = H("div"), (o = H("div")).textContent = "These actions are unavailable via the menu. Please use:", s = se(), a = H("div"), l = H("div"), (c = H("div")).textContent = "".concat(t[1], "+C"), u = Le(`
        for copy`), f = se(), d = H("div"), (h = H("div")).textContent = "".concat(t[1], "+X"), p = Le(`
        for cut`), m = se(), g = H("div"), (v = H("div")).textContent = "".concat(t[1], "+V"), y = Le(`
        for paste`), w = se(), x = H("div"), (b = H("button")).textContent = "Close", k(c, "class", "jse-key svelte-18bor9q"), k(l, "class", "jse-shortcut"), k(h, "class", "jse-key svelte-18bor9q"), k(d, "class", "jse-shortcut"), k(v, "class", "jse-key svelte-18bor9q"), k(g, "class", "jse-shortcut"), k(a, "class", "jse-shortcuts svelte-18bor9q"), k(b, "type", "button"), k(b, "class", "jse-primary svelte-18bor9q"), k(x, "class", "jse-actions svelte-18bor9q"), k(i, "class", "jse-modal-contents svelte-18bor9q"), k(e, "class", "jse-modal jse-copy-paste svelte-18bor9q");
  }, m: function(B, O) {
    X(B, e, O), ye(n, e, null), T(e, r), T(e, i), T(i, o), T(i, s), T(i, a), T(a, l), T(l, c), T(l, u), T(a, f), T(a, d), T(d, h), T(d, p), T(a, m), T(a, g), T(g, v), T(g, y), T(i, w), T(i, x), T(x, b), j = !0, $ || (N = Oe(b, "click", t[0]), $ = !0);
  }, p: Pe, i: function(B) {
    j || (S(n.$$.fragment, B), j = !0);
  }, o: function(B) {
    _(n.$$.fragment, B), j = !1;
  }, d: function(B) {
    B && Y(e), be(n), $ = !1, N();
  } };
}
function FZ(t) {
  return [_r("simple-modal").close, IZ ? "⌘" : "Ctrl"];
}
var P5 = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, FZ, zZ, Pt, {}, qZ), i;
  }
  return Ye(n);
}();
function R5(t) {
  return !!t && (t.type === "space" || t.space === !0);
}
function Xp(t) {
  return !!t && (t.type === "separator" || t.separator === !0);
}
function VZ(t) {
  return !!t && t.type === "label" && typeof t.text == "string";
}
function wf(t) {
  return !!t && typeof t.onClick == "function";
}
function Sy(t) {
  return !!t && t.type === "dropdown-button" && wf(t.main) && Array.isArray(t.items);
}
function HZ(t) {
  return !!t && t.type === "row" && Array.isArray(t.items);
}
function UZ(t) {
  return !!t && t.type === "column" && Array.isArray(t.items);
}
function Gj(t) {
  return Wn(t) && Wn(t.parseError);
}
function WZ(t) {
  return Wn(t) && Array.isArray(t.validationErrors);
}
function JZ(t) {
  At(t, "svelte-7deygj", '.jse-menu.svelte-7deygj.svelte-7deygj{background:var(--jse-theme-color, #3883fa);font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-main-menu, 14px);color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));display:flex;flex-wrap:wrap;align-items:stretch;position:relative}.jse-menu.svelte-7deygj .jse-button.svelte-7deygj{font-family:inherit;font-size:inherit;line-height:1.5em;border:none;background:transparent;color:inherit;cursor:pointer;width:var(--jse-menu-button-size, 32px);height:var(--jse-menu-button-size, 32px);padding:calc(0.5 * var(--jse-padding, 10px));margin:0;border-radius:0;display:inline-flex;align-items:center;text-align:center;justify-content:center}.jse-menu.svelte-7deygj .jse-button.svelte-7deygj:hover,.jse-menu.svelte-7deygj .jse-button.svelte-7deygj:focus{background:var(--jse-theme-color-highlight, #5f9dff)}.jse-menu.svelte-7deygj .jse-button.svelte-7deygj:disabled{color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));opacity:0.5;background:transparent}.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj{width:auto;height:calc(var(--jse-menu-button-size, 32px) - var(--jse-padding, 10px));margin:calc(0.5 * var(--jse-padding, 10px)) 0;padding:0 calc(0.5 * var(--jse-padding, 10px)) 1px;border:1px solid var(--jse-menu-color, var(--jse-text-color-inverse, #fff))}.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj:not(.jse-last){border-right:none}.jse-menu.svelte-7deygj .jse-button.jse-group-button.jse-first.svelte-7deygj{margin-left:calc(0.5 * var(--jse-padding, 10px))}.jse-menu.svelte-7deygj .jse-button.jse-group-button.jse-last.svelte-7deygj{margin-right:calc(0.5 * var(--jse-padding, 10px))}.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj:hover,.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj:focus{background:var(--jse-theme-color-highlight, #5f9dff)}.jse-menu.svelte-7deygj .jse-button.jse-group-button.jse-selected.svelte-7deygj{background:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));color:var(--jse-theme-color, #3883fa)}.jse-menu.svelte-7deygj .jse-space.svelte-7deygj{flex:1}.jse-menu.svelte-7deygj .jse-separator.svelte-7deygj{background:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));opacity:0.3;width:1px;margin:3px}');
}
var KZ = function(t) {
  return {};
}, Qj = function(t) {
  return {};
};
function Yj(t, e, n) {
  var r = t.slice();
  return r[3] = e[n], r;
}
var GZ = function(t) {
  return {};
}, Xj = function(t) {
  return {};
};
function QZ(t) {
  var e, n = nk(t[3]) + "";
  return { c: function() {
    e = Le(n);
  }, m: function(r, i) {
    X(r, e, i);
  }, p: function(r, i) {
    1 & i && n !== (n = nk(r[3]) + "") && bt(e, n);
  }, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
function YZ(t) {
  var e, n, r, i, o, s, a, l, c = t[3].icon && Zj(t), u = t[3].text && ek(t);
  return { c: function() {
    e = H("button"), c && c.c(), n = se(), u && u.c(), k(e, "type", "button"), k(e, "class", r = "jse-button " + t[3].className + " svelte-7deygj"), k(e, "title", i = t[3].title), e.disabled = o = t[3].disabled || !1;
  }, m: function(f, d) {
    X(f, e, d), c && c.m(e, null), T(e, n), u && u.m(e, null), s = !0, a || (l = Oe(e, "click", function() {
      Ar(t[3].onClick) && t[3].onClick.apply(this, arguments);
    }), a = !0);
  }, p: function(f, d) {
    (t = f)[3].icon ? c ? (c.p(t, d), 1 & d && S(c, 1)) : ((c = Zj(t)).c(), S(c, 1), c.m(e, n)) : c && (Ae(), _(c, 1, 1, function() {
      c = null;
    }), Me()), t[3].text ? u ? u.p(t, d) : ((u = ek(t)).c(), u.m(e, null)) : u && (u.d(1), u = null), (!s || 1 & d && r !== (r = "jse-button " + t[3].className + " svelte-7deygj")) && k(e, "class", r), (!s || 1 & d && i !== (i = t[3].title)) && k(e, "title", i), (!s || 1 & d && o !== (o = t[3].disabled || !1)) && (e.disabled = o);
  }, i: function(f) {
    s || (S(c), s = !0);
  }, o: function(f) {
    _(c), s = !1;
  }, d: function(f) {
    f && Y(e), c && c.d(), u && u.d(), a = !1, l();
  } };
}
function XZ(t) {
  var e;
  return { c: function() {
    k(e = H("div"), "class", "jse-space svelte-7deygj");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, i: Pe, o: Pe, d: function(n) {
    n && Y(e);
  } };
}
function ZZ(t) {
  var e;
  return { c: function() {
    k(e = H("div"), "class", "jse-separator svelte-7deygj");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, i: Pe, o: Pe, d: function(n) {
    n && Y(e);
  } };
}
function Zj(t) {
  var e, n;
  return e = new cn({ props: { data: t[3].icon } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.data = r[3].icon), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function ek(t) {
  var e, n = t[3].text + "";
  return { c: function() {
    e = Le(n);
  }, m: function(r, i) {
    X(r, e, i);
  }, p: function(r, i) {
    1 & i && n !== (n = r[3].text + "") && bt(e, n);
  }, d: function(r) {
    r && Y(e);
  } };
}
function tk(t) {
  var e, n, r, i, o, s, a, l = [ZZ, XZ, YZ, QZ], c = [];
  function u(f, d) {
    return 1 & d && (e = null), 1 & d && (n = null), 1 & d && (r = null), e == null && (e = !!Xp(f[3])), e ? 0 : (n == null && (n = !!R5(f[3])), n ? 1 : (r == null && (r = !!wf(f[3])), r ? 2 : 3));
  }
  return i = u(t, -1), o = c[i] = l[i](t), { c: function() {
    o.c(), s = un();
  }, m: function(f, d) {
    c[i].m(f, d), X(f, s, d), a = !0;
  }, p: function(f, d) {
    var h = i;
    (i = u(f, d)) === h ? c[i].p(f, d) : (Ae(), _(c[h], 1, 1, function() {
      c[h] = null;
    }), Me(), (o = c[i]) ? o.p(f, d) : (o = c[i] = l[i](f)).c(), S(o, 1), o.m(s.parentNode, s));
  }, i: function(f) {
    a || (S(o), a = !0);
  }, o: function(f) {
    _(o), a = !1;
  }, d: function(f) {
    f && Y(s), c[i].d(f);
  } };
}
function eee(t) {
  for (var e, n, r, i, o = t[2].left, s = ir(o, t, t[1], Xj), a = Ot(t[0]), l = [], c = 0; c < a.length; c += 1)
    l[c] = tk(Yj(t, a, c));
  var u = function(h) {
    return _(l[h], 1, 1, function() {
      l[h] = null;
    });
  }, f = t[2].right, d = ir(f, t, t[1], Qj);
  return { c: function() {
    e = H("div"), s && s.c(), n = se();
    for (var h = 0; h < l.length; h += 1)
      l[h].c();
    r = se(), d && d.c(), k(e, "class", "jse-menu svelte-7deygj");
  }, m: function(h, p) {
    X(h, e, p), s && s.m(e, null), T(e, n);
    for (var m = 0; m < l.length; m += 1)
      l[m] && l[m].m(e, null);
    T(e, r), d && d.m(e, null), i = !0;
  }, p: function(h, p) {
    var m = Et(p, 1)[0];
    if (s && s.p && (!i || 2 & m) && sr(s, o, h, h[1], i ? or(o, h[1], m, GZ) : ar(h[1]), Xj), 1 & m) {
      var g;
      for (a = Ot(h[0]), g = 0; g < a.length; g += 1) {
        var v = Yj(h, a, g);
        l[g] ? (l[g].p(v, m), S(l[g], 1)) : (l[g] = tk(v), l[g].c(), S(l[g], 1), l[g].m(e, r));
      }
      for (Ae(), g = a.length; g < l.length; g += 1)
        u(g);
      Me();
    }
    d && d.p && (!i || 2 & m) && sr(d, f, h, h[1], i ? or(f, h[1], m, KZ) : ar(h[1]), Qj);
  }, i: function(h) {
    if (!i) {
      S(s, h);
      for (var p = 0; p < a.length; p += 1)
        S(l[p]);
      S(d, h), i = !0;
    }
  }, o: function(h) {
    _(s, h), l = l.filter(Boolean);
    for (var p = 0; p < l.length; p += 1)
      _(l[p]);
    _(d, h), i = !1;
  }, d: function(h) {
    h && Y(e), s && s.d(h), fr(l, h), d && d.d(h);
  } };
}
function nk(t) {
  return console.error("Unknown type of menu item", t), "???";
}
function tee(t, e, n) {
  var r = e.$$slots, i = r === void 0 ? {} : r, o = e.$$scope, s = e.items, a = s === void 0 ? [] : s;
  return t.$$set = function(l) {
    "items" in l && n(0, a = l.items), "$$scope" in l && n(1, o = l.$$scope);
  }, [a, o, i];
}
var Zp = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, tee, eee, Pt, { items: 0 }, JZ), i;
  }
  return Ye(n);
}();
function nee(t) {
  At(t, "svelte-1d84pok", '.jse-json-repair-component.svelte-1d84pok.svelte-1d84pok{flex:1;display:flex;flex-direction:column;background:var(--jse-background-color, #fff);color:var(--jse-text-color, #4d4d4d)}.jse-json-repair-component.svelte-1d84pok .jse-menu .jse-info.svelte-1d84pok{padding:calc(0.5 * var(--jse-padding, 10px));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);vertical-align:center}.jse-json-repair-component.svelte-1d84pok .jse-json-text.svelte-1d84pok{flex:1;border:none;padding:2px;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);background:var(--jse-input-background, var(--jse-background-color, #fff));color:var(--jse-text-color, #4d4d4d);resize:none;outline:none}');
}
function ree(t) {
  var e;
  return { c: function() {
    (e = H("div")).textContent = "Repair invalid JSON, then click apply", k(e, "slot", "left"), k(e, "class", "jse-info svelte-1d84pok");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, d: function(n) {
    n && Y(e);
  } };
}
function iee(t) {
  var e, n;
  return e = new vo({ props: { type: "success", message: "JSON is valid now and can be parsed.", actions: t[5] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    32 & i && (o.actions = r[5]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function oee(t) {
  var e, n;
  return e = new vo({ props: { type: "error", icon: al, message: "Cannot parse JSON: ".concat(t[2].message), actions: t[6] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    4 & i && (o.message = "Cannot parse JSON: ".concat(r[2].message)), 64 & i && (o.actions = r[6]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function see(t) {
  var e, n, r, i, o, s, a, l, c, u;
  n = new Zp({ props: { items: t[4], $$slots: { left: [ree] }, $$scope: { ctx: t } } });
  var f = [oee, iee], d = [];
  function h(p, m) {
    return p[2] ? 0 : 1;
  }
  return i = h(t), o = d[i] = f[i](t), { c: function() {
    e = H("div"), xe(n.$$.fragment), r = se(), o.c(), s = se(), (a = H("textarea")).readOnly = t[1], k(a, "class", "jse-json-text svelte-1d84pok"), k(a, "autocomplete", "off"), k(a, "autocapitalize", "off"), k(a, "spellcheck", "false"), a.value = t[0], k(e, "class", "jse-json-repair-component svelte-1d84pok");
  }, m: function(p, m) {
    X(p, e, m), ye(n, e, null), T(e, r), d[i].m(e, null), T(e, s), T(e, a), t[16](a), l = !0, c || (u = Oe(a, "input", t[7]), c = !0);
  }, p: function(p, m) {
    var g = Et(m, 1)[0], v = {};
    16 & g && (v.items = p[4]), 8388608 & g && (v.$$scope = { dirty: g, ctx: p }), n.$set(v);
    var y = i;
    (i = h(p)) === y ? d[i].p(p, g) : (Ae(), _(d[y], 1, 1, function() {
      d[y] = null;
    }), Me(), (o = d[i]) ? o.p(p, g) : (o = d[i] = f[i](p)).c(), S(o, 1), o.m(e, s)), (!l || 2 & g) && (a.readOnly = p[1]), (!l || 1 & g) && (a.value = p[0]);
  }, i: function(p) {
    l || (S(n.$$.fragment, p), S(o), l = !0);
  }, o: function(p) {
    _(n.$$.fragment, p), _(o), l = !1;
  }, d: function(p) {
    p && Y(e), be(n), d[i].d(), t[16](null), c = !1, u();
  } };
}
function aee(t, e, n) {
  var r, i, o, s, a, l, c, u, f = e.text, d = f === void 0 ? "" : f, h = e.readOnly, p = h !== void 0 && h, m = e.onParse, g = e.onRepair, v = e.onChange, y = v === void 0 ? null : v, w = e.onApply, x = e.onCancel, b = Tr("jsoneditor:JSONRepair");
  function j() {
    w(d);
  }
  return t.$$set = function($) {
    "text" in $ && n(0, d = $.text), "readOnly" in $ && n(1, p = $.readOnly), "onParse" in $ && n(8, m = $.onParse), "onRepair" in $ && n(9, g = $.onRepair), "onChange" in $ && n(10, y = $.onChange), "onApply" in $ && n(11, w = $.onApply), "onCancel" in $ && n(12, x = $.onCancel);
  }, t.$$.update = function() {
    1 & t.$$.dirty && n(2, r = function($) {
      try {
        return m($), null;
      } catch (N) {
        return ic($, N.message);
      }
    }(d)), 1 & t.$$.dirty && n(15, i = function($) {
      try {
        return g($), !0;
      } catch {
        return !1;
      }
    }(d)), 4 & t.$$.dirty && b("error", r), 4096 & t.$$.dirty && n(4, u = [{ type: "space" }, { type: "button", icon: Gl, title: "Cancel repair", className: "jse-cancel", onClick: x }]), 57344 & t.$$.dirty && n(6, a = i ? [o, s] : [o]), 2 & t.$$.dirty && n(5, l = [{ icon: Su, text: "Apply", title: "Apply fixed JSON", disabled: p, onClick: j }]);
  }, n(13, o = { icon: aB, text: "Show me", title: "Scroll to the error location", onClick: function() {
    if (c && r) {
      var $ = r.position != null ? r.position : 0;
      c.setSelectionRange($, $), c.focus();
    }
  } }), n(14, s = { icon: xp, text: "Auto repair", title: "Automatically repair JSON", onClick: function() {
    try {
      n(0, d = g(d)), y && y(d);
    } catch {
    }
  } }), [d, p, r, c, u, l, a, function($) {
    b("handleChange");
    var N = $.target.value;
    d !== N && (n(0, d = N), y && y(d));
  }, m, g, y, w, x, o, s, i, function($) {
    Kt[$ ? "unshift" : "push"](function() {
      n(3, c = $);
    });
  }];
}
var lee = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, aee, see, Pt, { text: 0, readOnly: 1, onParse: 8, onRepair: 9, onChange: 10, onApply: 11, onCancel: 12 }, nee), i;
  }
  return Ye(n);
}(), jl = [];
function rk(t) {
  if (t.key === "Escape") {
    var e = Yt(jl);
    e && e();
  }
}
function em(t, e) {
  return nn(jl) && window.addEventListener("keydown", rk), jl.push(e), { destroy: function() {
    jl = jl.filter(function(n) {
      return n !== e;
    }), nn(jl) && window.removeEventListener("keydown", rk);
  } };
}
function cee(t) {
  At(t, "svelte-rn18r0", '.jse-modal.jse-repair.svelte-rn18r0{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}');
}
function uee(t) {
  var e, n, r, i, o, s;
  function a(c) {
    t[7](c);
  }
  var l = { onParse: t[1], onRepair: t[2], onApply: t[4], onCancel: t[5] };
  return t[0] !== void 0 && (l.text = t[0]), n = new lee({ props: l }), Kt.push(function() {
    return no(n, "text", a);
  }), { c: function() {
    e = H("div"), xe(n.$$.fragment), k(e, "class", "jse-modal jse-repair svelte-rn18r0");
  }, m: function(c, u) {
    X(c, e, u), ye(n, e, null), i = !0, o || (s = Mr(em.call(null, e, t[3])), o = !0);
  }, p: function(c, u) {
    var f = Et(u, 1)[0], d = {};
    2 & f && (d.onParse = c[1]), 4 & f && (d.onRepair = c[2]), !r && 1 & f && (r = !0, d.text = c[0], to(function() {
      return r = !1;
    })), n.$set(d);
  }, i: function(c) {
    i || (S(n.$$.fragment, c), i = !0);
  }, o: function(c) {
    _(n.$$.fragment, c), i = !1;
  }, d: function(c) {
    c && Y(e), be(n), o = !1, s();
  } };
}
function fee(t, e, n) {
  var r = e.text, i = e.onParse, o = e.onRepair, s = e.onApply, a = _r("simple-modal").close;
  return t.$$set = function(l) {
    "text" in l && n(0, r = l.text), "onParse" in l && n(1, i = l.onParse), "onRepair" in l && n(2, o = l.onRepair), "onApply" in l && n(6, s = l.onApply);
  }, [r, i, o, a, function(l) {
    a(), s(l);
  }, function() {
    a();
  }, s, function(l) {
    n(0, r = l);
  }];
}
var N5 = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, fee, uee, Pt, { text: 0, onParse: 1, onRepair: 2, onApply: 6 }, cee), i;
  }
  return Ye(n);
}();
function dee(t) {
  At(t, "svelte-szeu2l", 'button.jse-context-menu-button.svelte-szeu2l{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;flex:1;white-space:nowrap;padding:var(--jse-padding, 10px);color:inherit}button.jse-context-menu-button.svelte-szeu2l:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}button.jse-context-menu-button.svelte-szeu2l:focus{background:var(--jse-context-menu-background-highlight, #7a7a7a);z-index:1}button.jse-context-menu-button.svelte-szeu2l:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}button.jse-context-menu-button.left.svelte-szeu2l{text-align:left}button.jse-context-menu-button.svelte-szeu2l svg{width:16px}');
}
function ik(t) {
  var e, n;
  return e = new cn({ props: { data: t[0].icon } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.data = r[0].icon), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function ok(t) {
  var e, n = t[0].text + "";
  return { c: function() {
    e = Le(n);
  }, m: function(r, i) {
    X(r, e, i);
  }, p: function(r, i) {
    1 & i && n !== (n = r[0].text + "") && bt(e, n);
  }, d: function(r) {
    r && Y(e);
  } };
}
function hee(t) {
  var e, n, r, i, o, s, a, l, c = t[0].icon && ik(t), u = t[0].text && ok(t);
  return { c: function() {
    e = H("button"), c && c.c(), n = se(), u && u.c(), k(e, "type", "button"), k(e, "class", r = Un(Jo("jse-context-menu-button", t[1], t[0].className)) + " svelte-szeu2l"), k(e, "title", i = t[0].title), e.disabled = o = t[0].disabled || !1;
  }, m: function(f, d) {
    X(f, e, d), c && c.m(e, null), T(e, n), u && u.m(e, null), s = !0, a || (l = Oe(e, "click", function() {
      Ar(t[0].onClick) && t[0].onClick.apply(this, arguments);
    }), a = !0);
  }, p: function(f, d) {
    var h = Et(d, 1)[0];
    (t = f)[0].icon ? c ? (c.p(t, h), 1 & h && S(c, 1)) : ((c = ik(t)).c(), S(c, 1), c.m(e, n)) : c && (Ae(), _(c, 1, 1, function() {
      c = null;
    }), Me()), t[0].text ? u ? u.p(t, h) : ((u = ok(t)).c(), u.m(e, null)) : u && (u.d(1), u = null), (!s || 3 & h && r !== (r = Un(Jo("jse-context-menu-button", t[1], t[0].className)) + " svelte-szeu2l")) && k(e, "class", r), (!s || 1 & h && i !== (i = t[0].title)) && k(e, "title", i), (!s || 1 & h && o !== (o = t[0].disabled || !1)) && (e.disabled = o);
  }, i: function(f) {
    s || (S(c), s = !0);
  }, o: function(f) {
    _(c), s = !1;
  }, d: function(f) {
    f && Y(e), c && c.d(), u && u.d(), a = !1, l();
  } };
}
function pee(t, e, n) {
  var r = e.item, i = e.className, o = i === void 0 ? void 0 : i;
  return t.$$set = function(s) {
    "item" in s && n(0, r = s.item), "className" in s && n(1, o = s.className);
  }, [r, o];
}
var Cy = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, pee, hee, wr, { item: 0, className: 1 }, dee), i;
  }
  return Ye(n);
}();
function mee(t) {
  At(t, "svelte-9i012w", '.jse-dropdown-button.svelte-9i012w.svelte-9i012w{flex:1;line-height:normal;border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;position:relative;padding:0;display:flex}.jse-dropdown-button.svelte-9i012w ul.svelte-9i012w{margin:0;padding:0}.jse-dropdown-button.svelte-9i012w ul li.svelte-9i012w{margin:0;padding:0;list-style-type:none}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;width:2em;background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));border-radius:0}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.jse-visible.svelte-9i012w{background:var(--jse-context-menu-background, #656565)}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w:focus{z-index:1}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items.svelte-9i012w{display:none;position:absolute;top:100%;left:0;z-index:1;background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items.jse-visible.svelte-9i012w{display:block}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items button.svelte-9i012w{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;width:100%;text-align:left;padding:var(--jse-padding, 10px);margin:0}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items button.svelte-9i012w:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items button.svelte-9i012w:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}');
}
function sk(t, e, n) {
  var r = t.slice();
  return r[11] = e[n], r;
}
var gee = function(t) {
  return {};
}, ak = function(t) {
  return {};
};
function lk(t) {
  var e, n;
  return e = new cn({ props: { data: t[11].icon } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.data = r[11].icon), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function ck(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d = t[11].text + "", h = t[11].icon && lk(t);
  function p() {
    return t[9](t[11]);
  }
  return { c: function() {
    e = H("li"), n = H("button"), h && h.c(), r = se(), i = Le(d), l = se(), k(n, "type", "button"), k(n, "title", o = t[11].title), n.disabled = s = t[11].disabled, k(n, "class", a = Un(t[11].className) + " svelte-9i012w"), k(e, "class", "svelte-9i012w");
  }, m: function(m, g) {
    X(m, e, g), T(e, n), h && h.m(n, null), T(n, r), T(n, i), T(e, l), c = !0, u || (f = Oe(n, "click", p), u = !0);
  }, p: function(m, g) {
    (t = m)[11].icon ? h ? (h.p(t, g), 1 & g && S(h, 1)) : ((h = lk(t)).c(), S(h, 1), h.m(n, r)) : h && (Ae(), _(h, 1, 1, function() {
      h = null;
    }), Me()), (!c || 1 & g) && d !== (d = t[11].text + "") && bt(i, d), (!c || 1 & g && o !== (o = t[11].title)) && k(n, "title", o), (!c || 1 & g && s !== (s = t[11].disabled)) && (n.disabled = s), (!c || 1 & g && a !== (a = Un(t[11].className) + " svelte-9i012w")) && k(n, "class", a);
  }, i: function(m) {
    c || (S(h), c = !0);
  }, o: function(m) {
    _(h), c = !1;
  }, d: function(m) {
    m && Y(e), h && h.d(), u = !1, f();
  } };
}
function vee(t) {
  var e, n, r, i, o, s, a, l, c, u, f = t[8].defaultItem, d = ir(f, t, t[7], ak);
  i = new cn({ props: { data: Ti } });
  for (var h = Ot(t[0]), p = [], m = 0; m < h.length; m += 1)
    p[m] = ck(sk(t, h, m));
  var g = function(v) {
    return _(p[v], 1, 1, function() {
      p[v] = null;
    });
  };
  return { c: function() {
    e = H("div"), d && d.c(), n = se(), r = H("button"), xe(i.$$.fragment), o = se(), s = H("div"), a = H("ul");
    for (var v = 0; v < p.length; v += 1)
      p[v].c();
    k(r, "type", "button"), k(r, "class", "jse-open-dropdown svelte-9i012w"), k(r, "data-type", "jse-open-dropdown"), r.disabled = t[4], $e(r, "jse-visible", t[3]), k(a, "class", "svelte-9i012w"), k(s, "class", "jse-dropdown-items svelte-9i012w"), Qr(s, "width", t[2]), $e(s, "jse-visible", t[3]), k(e, "role", "button"), k(e, "tabindex", "0"), k(e, "class", "jse-dropdown-button svelte-9i012w"), k(e, "title", t[1]);
  }, m: function(v, y) {
    X(v, e, y), d && d.m(e, null), T(e, n), T(e, r), ye(i, r, null), T(e, o), T(e, s), T(s, a);
    for (var w = 0; w < p.length; w += 1)
      p[w] && p[w].m(a, null);
    l = !0, c || (u = [Oe(r, "click", t[5]), Oe(e, "click", t[6])], c = !0);
  }, p: function(v, y) {
    var w = Et(y, 1)[0];
    if (d && d.p && (!l || 128 & w) && sr(d, f, v, v[7], l ? or(f, v[7], w, gee) : ar(v[7]), ak), (!l || 16 & w) && (r.disabled = v[4]), (!l || 8 & w) && $e(r, "jse-visible", v[3]), 1 & w) {
      var x;
      for (h = Ot(v[0]), x = 0; x < h.length; x += 1) {
        var b = sk(v, h, x);
        p[x] ? (p[x].p(b, w), S(p[x], 1)) : (p[x] = ck(b), p[x].c(), S(p[x], 1), p[x].m(a, null));
      }
      for (Ae(), x = h.length; x < p.length; x += 1)
        g(x);
      Me();
    }
    (!l || 4 & w) && Qr(s, "width", v[2]), (!l || 8 & w) && $e(s, "jse-visible", v[3]), (!l || 2 & w) && k(e, "title", v[1]);
  }, i: function(v) {
    if (!l) {
      S(d, v), S(i.$$.fragment, v);
      for (var y = 0; y < h.length; y += 1)
        S(p[y]);
      l = !0;
    }
  }, o: function(v) {
    _(d, v), _(i.$$.fragment, v), p = p.filter(Boolean);
    for (var y = 0; y < p.length; y += 1)
      _(p[y]);
    l = !1;
  }, d: function(v) {
    v && Y(e), d && d.d(v), be(i), fr(p, v), c = !1, An(u);
  } };
}
function yee(t, e, n) {
  var r, i = e.$$slots, o = i === void 0 ? {} : i, s = e.$$scope, a = e.items, l = a === void 0 ? [] : a, c = e.title, u = c === void 0 ? void 0 : c, f = e.width, d = f === void 0 ? "120px" : f, h = !1;
  function p() {
    n(3, h = !1);
  }
  function m(g) {
    da(g) === "Escape" && (g.preventDefault(), n(3, h = !1));
  }
  return Fi(function() {
    document.addEventListener("click", p), document.addEventListener("keydown", m);
  }), Ci(function() {
    document.removeEventListener("click", p), document.removeEventListener("keydown", m);
  }), t.$$set = function(g) {
    "items" in g && n(0, l = g.items), "title" in g && n(1, u = g.title), "width" in g && n(2, d = g.width), "$$scope" in g && n(7, s = g.$$scope);
  }, t.$$.update = function() {
    1 & t.$$.dirty && n(4, r = l.every(function(g) {
      return g.disabled === !0;
    }));
  }, [l, u, d, h, r, function() {
    var g = h;
    setTimeout(function() {
      return n(3, h = !g);
    });
  }, p, s, o, function(g) {
    return g.onClick();
  }];
}
var bee = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, yee, vee, Pt, { items: 0, title: 1, width: 2 }, mee), i;
  }
  return Ye(n);
}();
function xee(t) {
  At(t, "svelte-szeu2l", 'button.jse-context-menu-button.svelte-szeu2l{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;flex:1;white-space:nowrap;padding:var(--jse-padding, 10px);color:inherit}button.jse-context-menu-button.svelte-szeu2l:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}button.jse-context-menu-button.svelte-szeu2l:focus{background:var(--jse-context-menu-background-highlight, #7a7a7a);z-index:1}button.jse-context-menu-button.svelte-szeu2l:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}button.jse-context-menu-button.left.svelte-szeu2l{text-align:left}button.jse-context-menu-button.svelte-szeu2l svg{width:16px}');
}
function uk(t) {
  var e, n;
  return e = new cn({ props: { data: t[0].main.icon } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.data = r[0].main.icon), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function wee(t) {
  var e, n, r, i, o, s, a, l, c, u = t[0].main.text + "", f = t[0].main.icon && uk(t);
  return { c: function() {
    e = H("button"), f && f.c(), n = se(), r = Le(u), k(e, "class", i = Un(Jo("jse-context-menu-button", t[1], t[0].main.className)) + " svelte-szeu2l"), k(e, "type", "button"), k(e, "slot", "defaultItem"), k(e, "title", o = t[0].main.title), e.disabled = s = t[0].main.disabled || !1;
  }, m: function(d, h) {
    X(d, e, h), f && f.m(e, null), T(e, n), T(e, r), a = !0, l || (c = Oe(e, "click", function() {
      Ar(t[0].main.onClick) && t[0].main.onClick.apply(this, arguments);
    }), l = !0);
  }, p: function(d, h) {
    (t = d)[0].main.icon ? f ? (f.p(t, h), 1 & h && S(f, 1)) : ((f = uk(t)).c(), S(f, 1), f.m(e, n)) : f && (Ae(), _(f, 1, 1, function() {
      f = null;
    }), Me()), (!a || 1 & h) && u !== (u = t[0].main.text + "") && bt(r, u), (!a || 3 & h && i !== (i = Un(Jo("jse-context-menu-button", t[1], t[0].main.className)) + " svelte-szeu2l")) && k(e, "class", i), (!a || 1 & h && o !== (o = t[0].main.title)) && k(e, "title", o), (!a || 1 & h && s !== (s = t[0].main.disabled || !1)) && (e.disabled = s);
  }, i: function(d) {
    a || (S(f), a = !0);
  }, o: function(d) {
    _(f), a = !1;
  }, d: function(d) {
    d && Y(e), f && f.d(), l = !1, c();
  } };
}
function jee(t) {
  var e, n;
  return e = new bee({ props: { width: t[0].width, items: t[0].items, $$slots: { defaultItem: [wee] }, $$scope: { ctx: t } } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = Et(i, 1)[0], s = {};
    1 & o && (s.width = r[0].width), 1 & o && (s.items = r[0].items), 7 & o && (s.$$scope = { dirty: o, ctx: r }), e.$set(s);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function kee(t, e, n) {
  var r = e.item, i = e.className, o = i === void 0 ? void 0 : i;
  return t.$$set = function(s) {
    "item" in s && n(0, r = s.item), "className" in s && n(1, o = s.className);
  }, [r, o];
}
var Oy = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, kee, jee, wr, { item: 0, className: 1 }, xee), i;
  }
  return Ye(n);
}();
function $ee(t) {
  At(t, "svelte-vtd7md", '.jse-contextmenu.svelte-vtd7md.svelte-vtd7md{box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff))}.jse-contextmenu.svelte-vtd7md .jse-row.svelte-vtd7md{display:flex;flex-direction:row;align-items:flex-start;justify-content:stretch}.jse-contextmenu.svelte-vtd7md .jse-row div.jse-label.svelte-vtd7md{flex:1;white-space:nowrap;padding:var(--jse-padding, 10px);color:var(--jse-context-menu-color-disabled, #9d9d9d);line-height:normal}.jse-contextmenu.svelte-vtd7md .jse-row div.jse-tip.svelte-vtd7md{flex:1;background:var(--jse-context-menu-tip-background, rgba(255, 255, 255, 0.2));color:var(--context-menu-tip-color, inherit);margin:calc(0.5 * var(--jse-padding, 10px));padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);font-size:80%;line-height:1.3em;display:flex;flex-direction:row;align-items:start;gap:var(--jse-padding, 10px);border-radius:3px}.jse-contextmenu.svelte-vtd7md .jse-row div.jse-tip div.jse-tip-icon.svelte-vtd7md{padding-top:calc(0.5 * var(--jse-padding, 10px))}.jse-contextmenu.svelte-vtd7md .jse-column.svelte-vtd7md{flex:1;display:flex;flex-direction:column;align-items:stretch}.jse-contextmenu.svelte-vtd7md .jse-column.svelte-vtd7md:not(:last-child){border-right:1px solid var(--jse-context-menu-separator-color, #7a7a7a)}.jse-contextmenu.svelte-vtd7md .jse-separator.svelte-vtd7md{width:100%;height:1px;background:var(--jse-context-menu-separator-color, #7a7a7a)}');
}
function fk(t, e, n) {
  var r = t.slice();
  return r[6] = e[n], r;
}
function dk(t, e, n) {
  var r = t.slice();
  return r[9] = e[n], r;
}
function hk(t, e, n) {
  var r = t.slice();
  return r[12] = e[n], r;
}
function See(t) {
  var e, n = cc(t[6]) + "";
  return { c: function() {
    e = Le(n);
  }, m: function(r, i) {
    X(r, e, i);
  }, p: function(r, i) {
    1 & i && n !== (n = cc(r[6]) + "") && bt(e, n);
  }, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
function Cee(t) {
  var e;
  return { c: function() {
    k(e = H("div"), "class", "jse-separator svelte-vtd7md");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, i: Pe, o: Pe, d: function(n) {
    n && Y(e);
  } };
}
function Oee(t) {
  for (var e, n, r = Ot(t[6].items), i = [], o = 0; o < r.length; o += 1)
    i[o] = mk(dk(t, r, o));
  var s = function(a) {
    return _(i[a], 1, 1, function() {
      i[a] = null;
    });
  };
  return { c: function() {
    e = H("div");
    for (var a = 0; a < i.length; a += 1)
      i[a].c();
    k(e, "class", "jse-row svelte-vtd7md");
  }, m: function(a, l) {
    X(a, e, l);
    for (var c = 0; c < i.length; c += 1)
      i[c] && i[c].m(e, null);
    n = !0;
  }, p: function(a, l) {
    if (1 & l) {
      var c;
      for (r = Ot(a[6].items), c = 0; c < r.length; c += 1) {
        var u = dk(a, r, c);
        i[c] ? (i[c].p(u, l), S(i[c], 1)) : (i[c] = mk(u), i[c].c(), S(i[c], 1), i[c].m(e, null));
      }
      for (Ae(), c = r.length; c < i.length; c += 1)
        s(c);
      Me();
    }
  }, i: function(a) {
    if (!n) {
      for (var l = 0; l < r.length; l += 1)
        S(i[l]);
      n = !0;
    }
  }, o: function(a) {
    i = i.filter(Boolean);
    for (var l = 0; l < i.length; l += 1)
      _(i[l]);
    n = !1;
  }, d: function(a) {
    a && Y(e), fr(i, a);
  } };
}
function Eee(t) {
  var e, n;
  return e = new Oy({ props: { item: t[6] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.item = r[6]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Aee(t) {
  var e, n;
  return e = new Cy({ props: { item: t[6] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.item = r[6]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Mee(t) {
  var e, n = cc(t[9]) + "";
  return { c: function() {
    e = Le(n);
  }, m: function(r, i) {
    X(r, e, i);
  }, p: function(r, i) {
    1 & i && n !== (n = cc(r[9]) + "") && bt(e, n);
  }, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
function _ee(t) {
  var e;
  return { c: function() {
    k(e = H("div"), "class", "jse-separator svelte-vtd7md");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, i: Pe, o: Pe, d: function(n) {
    n && Y(e);
  } };
}
function Tee(t) {
  for (var e, n, r = Ot(t[9].items), i = [], o = 0; o < r.length; o += 1)
    i[o] = pk(hk(t, r, o));
  var s = function(a) {
    return _(i[a], 1, 1, function() {
      i[a] = null;
    });
  };
  return { c: function() {
    e = H("div");
    for (var a = 0; a < i.length; a += 1)
      i[a].c();
    k(e, "class", "jse-column svelte-vtd7md");
  }, m: function(a, l) {
    X(a, e, l);
    for (var c = 0; c < i.length; c += 1)
      i[c] && i[c].m(e, null);
    n = !0;
  }, p: function(a, l) {
    if (1 & l) {
      var c;
      for (r = Ot(a[9].items), c = 0; c < r.length; c += 1) {
        var u = hk(a, r, c);
        i[c] ? (i[c].p(u, l), S(i[c], 1)) : (i[c] = pk(u), i[c].c(), S(i[c], 1), i[c].m(e, null));
      }
      for (Ae(), c = r.length; c < i.length; c += 1)
        s(c);
      Me();
    }
  }, i: function(a) {
    if (!n) {
      for (var l = 0; l < r.length; l += 1)
        S(i[l]);
      n = !0;
    }
  }, o: function(a) {
    i = i.filter(Boolean);
    for (var l = 0; l < i.length; l += 1)
      _(i[l]);
    n = !1;
  }, d: function(a) {
    a && Y(e), fr(i, a);
  } };
}
function Pee(t) {
  var e, n;
  return e = new Oy({ props: { item: t[9] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.item = r[9]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Ree(t) {
  var e, n;
  return e = new Cy({ props: { item: t[9] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.item = r[9]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Nee(t) {
  var e, n = cc(t[12]) + "";
  return { c: function() {
    e = Le(n);
  }, m: function(r, i) {
    X(r, e, i);
  }, p: function(r, i) {
    1 & i && n !== (n = cc(r[12]) + "") && bt(e, n);
  }, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
function Iee(t) {
  var e, n, r = t[12].text + "";
  return { c: function() {
    e = H("div"), n = Le(r), k(e, "class", "jse-label svelte-vtd7md");
  }, m: function(i, o) {
    X(i, e, o), T(e, n);
  }, p: function(i, o) {
    1 & o && r !== (r = i[12].text + "") && bt(n, r);
  }, i: Pe, o: Pe, d: function(i) {
    i && Y(e);
  } };
}
function Dee(t) {
  var e;
  return { c: function() {
    k(e = H("div"), "class", "jse-separator svelte-vtd7md");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, i: Pe, o: Pe, d: function(n) {
    n && Y(e);
  } };
}
function Lee(t) {
  var e, n;
  return e = new Oy({ props: { className: "left", item: t[12] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.item = r[12]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Bee(t) {
  var e, n;
  return e = new Cy({ props: { className: "left", item: t[12] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i && (o.item = r[12]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function pk(t) {
  var e, n, r, i, o, s, a, l, c = [Bee, Lee, Dee, Iee, Nee], u = [];
  function f(d, h) {
    return 1 & h && (e = null), 1 & h && (n = null), 1 & h && (r = null), 1 & h && (i = null), e == null && (e = !!wf(d[12])), e ? 0 : (n == null && (n = !!Sy(d[12])), n ? 1 : (r == null && (r = !!Xp(d[12])), r ? 2 : (i == null && (i = !!VZ(d[12])), i ? 3 : 4)));
  }
  return o = f(t, -1), s = u[o] = c[o](t), { c: function() {
    s.c(), a = un();
  }, m: function(d, h) {
    u[o].m(d, h), X(d, a, h), l = !0;
  }, p: function(d, h) {
    var p = o;
    (o = f(d, h)) === p ? u[o].p(d, h) : (Ae(), _(u[p], 1, 1, function() {
      u[p] = null;
    }), Me(), (s = u[o]) ? s.p(d, h) : (s = u[o] = c[o](d)).c(), S(s, 1), s.m(a.parentNode, a));
  }, i: function(d) {
    l || (S(s), l = !0);
  }, o: function(d) {
    _(s), l = !1;
  }, d: function(d) {
    d && Y(a), u[o].d(d);
  } };
}
function mk(t) {
  var e, n, r, i, o, s, a, l, c = [Ree, Pee, Tee, _ee, Mee], u = [];
  function f(d, h) {
    return 1 & h && (e = null), 1 & h && (n = null), 1 & h && (r = null), 1 & h && (i = null), e == null && (e = !!wf(d[9])), e ? 0 : (n == null && (n = !!Sy(d[9])), n ? 1 : (r == null && (r = !!UZ(d[9])), r ? 2 : (i == null && (i = !!Xp(d[9])), i ? 3 : 4)));
  }
  return o = f(t, -1), s = u[o] = c[o](t), { c: function() {
    s.c(), a = un();
  }, m: function(d, h) {
    u[o].m(d, h), X(d, a, h), l = !0;
  }, p: function(d, h) {
    var p = o;
    (o = f(d, h)) === p ? u[o].p(d, h) : (Ae(), _(u[p], 1, 1, function() {
      u[p] = null;
    }), Me(), (s = u[o]) ? s.p(d, h) : (s = u[o] = c[o](d)).c(), S(s, 1), s.m(a.parentNode, a));
  }, i: function(d) {
    l || (S(s), l = !0);
  }, o: function(d) {
    _(s), l = !1;
  }, d: function(d) {
    d && Y(a), u[o].d(d);
  } };
}
function gk(t) {
  var e, n, r, i, o, s, a, l, c = [Aee, Eee, Oee, Cee, See], u = [];
  function f(d, h) {
    return 1 & h && (e = null), 1 & h && (n = null), 1 & h && (r = null), 1 & h && (i = null), e == null && (e = !!wf(d[6])), e ? 0 : (n == null && (n = !!Sy(d[6])), n ? 1 : (r == null && (r = !!HZ(d[6])), r ? 2 : (i == null && (i = !!Xp(d[6])), i ? 3 : 4)));
  }
  return o = f(t, -1), s = u[o] = c[o](t), { c: function() {
    s.c(), a = un();
  }, m: function(d, h) {
    u[o].m(d, h), X(d, a, h), l = !0;
  }, p: function(d, h) {
    var p = o;
    (o = f(d, h)) === p ? u[o].p(d, h) : (Ae(), _(u[p], 1, 1, function() {
      u[p] = null;
    }), Me(), (s = u[o]) ? s.p(d, h) : (s = u[o] = c[o](d)).c(), S(s, 1), s.m(a.parentNode, a));
  }, i: function(d) {
    l || (S(s), l = !0);
  }, o: function(d) {
    _(s), l = !1;
  }, d: function(d) {
    d && Y(a), u[o].d(d);
  } };
}
function vk(t) {
  var e, n, r, i, o, s, a, l;
  return i = new cn({ props: { data: BL } }), { c: function() {
    e = H("div"), n = H("div"), r = H("div"), xe(i.$$.fragment), o = se(), s = H("div"), a = Le(t[1]), k(r, "class", "jse-tip-icon svelte-vtd7md"), k(s, "class", "jse-tip-text"), k(n, "class", "jse-tip svelte-vtd7md"), k(e, "class", "jse-row svelte-vtd7md");
  }, m: function(c, u) {
    X(c, e, u), T(e, n), T(n, r), ye(i, r, null), T(n, o), T(n, s), T(s, a), l = !0;
  }, p: function(c, u) {
    (!l || 2 & u) && bt(a, c[1]);
  }, i: function(c) {
    l || (S(i.$$.fragment, c), l = !0);
  }, o: function(c) {
    _(i.$$.fragment, c), l = !1;
  }, d: function(c) {
    c && Y(e), be(i);
  } };
}
function qee(t) {
  for (var e, n, r, i, o, s = Ot(t[0]), a = [], l = 0; l < s.length; l += 1)
    a[l] = gk(fk(t, s, l));
  var c = function(f) {
    return _(a[f], 1, 1, function() {
      a[f] = null;
    });
  }, u = t[1] && vk(t);
  return { c: function() {
    e = H("div");
    for (var f = 0; f < a.length; f += 1)
      a[f].c();
    n = se(), u && u.c(), k(e, "role", "menu"), k(e, "tabindex", "-1"), k(e, "class", "jse-contextmenu svelte-vtd7md");
  }, m: function(f, d) {
    X(f, e, d);
    for (var h = 0; h < a.length; h += 1)
      a[h] && a[h].m(e, null);
    T(e, n), u && u.m(e, null), t[4](e), r = !0, i || (o = Oe(e, "keydown", t[3]), i = !0);
  }, p: function(f, d) {
    var h = Et(d, 1)[0];
    if (1 & h) {
      var p;
      for (s = Ot(f[0]), p = 0; p < s.length; p += 1) {
        var m = fk(f, s, p);
        a[p] ? (a[p].p(m, h), S(a[p], 1)) : (a[p] = gk(m), a[p].c(), S(a[p], 1), a[p].m(e, n));
      }
      for (Ae(), p = s.length; p < a.length; p += 1)
        c(p);
      Me();
    }
    f[1] ? u ? (u.p(f, h), 2 & h && S(u, 1)) : ((u = vk(f)).c(), S(u, 1), u.m(e, null)) : u && (Ae(), _(u, 1, 1, function() {
      u = null;
    }), Me());
  }, i: function(f) {
    if (!r) {
      for (var d = 0; d < s.length; d += 1)
        S(a[d]);
      S(u), r = !0;
    }
  }, o: function(f) {
    a = a.filter(Boolean);
    for (var d = 0; d < a.length; d += 1)
      _(a[d]);
    _(u), r = !1;
  }, d: function(f) {
    f && Y(e), fr(a, f), u && u.d(), t[4](null), i = !1, o();
  } };
}
function cc(t) {
  return console.error("Unknown type of context menu item", t), "???";
}
function zee(t, e, n) {
  var r, i = e.items, o = e.tip;
  Fi(function() {
    var a = Array.from(r.querySelectorAll("button")).find(function(l) {
      return !l.disabled;
    });
    a && a.focus();
  });
  var s = { ArrowUp: "Up", ArrowDown: "Down", ArrowLeft: "Left", ArrowRight: "Right" };
  return t.$$set = function(a) {
    "items" in a && n(0, i = a.items), "tip" in a && n(1, o = a.tip);
  }, [i, o, r, function(a) {
    var l = da(a), c = s[l];
    if (c && a.target) {
      a.preventDefault();
      var u = iY({ allElements: Array.from(r.querySelectorAll("button:not([disabled])")), currentElement: a.target, direction: c, hasPrio: function(f) {
        return f.getAttribute("data-type") !== "jse-open-dropdown";
      } });
      u && u.focus();
    }
  }, function(a) {
    Kt[a ? "unshift" : "push"](function() {
      n(2, r = a);
    });
  }];
}
var I5 = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, zee, qee, Pt, { items: 0, tip: 1 }, $ee), i;
  }
  return Ye(n);
}();
function Fee(t) {
  var e, n;
  return e = new I5({ props: { items: t[1], tip: t[0] ? "Tip: you can open this context menu via right-click or with Ctrl+Q" : void 0 } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2 & i[0] && (o.items = r[1]), 1 & i[0] && (o.tip = r[0] ? "Tip: you can open this context menu via right-click or with Ctrl+Q" : void 0), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Vee(t, e, n) {
  var r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $ = e.json, N = e.documentState, B = e.parser, O = e.showTip, I = e.onCloseContextMenu, P = e.onEditKey, J = e.onEditValue, D = e.onToggleEnforceString, Q = e.onCut, Z = e.onCopy, L = e.onPaste, R = e.onRemove, V = e.onDuplicate, M = e.onExtract, C = e.onInsertBefore, F = e.onInsert, z = e.onConvert, E = e.onInsertAfter, A = e.onSort, te = e.onTransform;
  function ge() {
    I(), P();
  }
  function ke() {
    I(), J();
  }
  function Ce() {
    I(), D();
  }
  function we() {
    I(), Q(!0);
  }
  function le() {
    I(), Q(!1);
  }
  function rt() {
    I(), Z(!0);
  }
  function Be() {
    I(), Z(!1);
  }
  function nt() {
    I(), L();
  }
  function oe() {
    I(), R();
  }
  function We() {
    I(), V();
  }
  function Rt() {
    I(), M();
  }
  function de(Ue) {
    I(), c ? z(Ue) : F(Ue);
  }
  function Se() {
    I(), A();
  }
  function rn() {
    I(), te();
  }
  function Dt() {
    I(), C();
  }
  function Xt() {
    I(), E();
  }
  return t.$$set = function(Ue) {
    "json" in Ue && n(2, $ = Ue.json), "documentState" in Ue && n(3, N = Ue.documentState), "parser" in Ue && n(4, B = Ue.parser), "showTip" in Ue && n(0, O = Ue.showTip), "onCloseContextMenu" in Ue && n(5, I = Ue.onCloseContextMenu), "onEditKey" in Ue && n(6, P = Ue.onEditKey), "onEditValue" in Ue && n(7, J = Ue.onEditValue), "onToggleEnforceString" in Ue && n(8, D = Ue.onToggleEnforceString), "onCut" in Ue && n(9, Q = Ue.onCut), "onCopy" in Ue && n(10, Z = Ue.onCopy), "onPaste" in Ue && n(11, L = Ue.onPaste), "onRemove" in Ue && n(12, R = Ue.onRemove), "onDuplicate" in Ue && n(13, V = Ue.onDuplicate), "onExtract" in Ue && n(14, M = Ue.onExtract), "onInsertBefore" in Ue && n(15, C = Ue.onInsertBefore), "onInsert" in Ue && n(16, F = Ue.onInsert), "onConvert" in Ue && n(17, z = Ue.onConvert), "onInsertAfter" in Ue && n(18, E = Ue.onInsertAfter), "onSort" in Ue && n(19, A = Ue.onSort), "onTransform" in Ue && n(20, te = Ue.onTransform);
  }, t.$$.update = function() {
    8 & t.$$.dirty[0] && n(37, r = N.selection), 4 & t.$$.dirty[0] && n(39, i = $ !== void 0), 64 & t.$$.dirty[1] && n(31, o = !!r), 64 & t.$$.dirty[1] && n(21, s = !!r && nn(mt(r))), 4 & t.$$.dirty[0] | 64 & t.$$.dirty[1] && n(38, a = r ? it($, mt(r)) : void 0), 128 & t.$$.dirty[1] && n(35, l = Array.isArray(a) ? "Edit array" : Wn(a) ? "Edit object" : "Edit value"), 320 & t.$$.dirty[1] && n(22, c = i && (Sn(r) || dr(r) || an(r))), 6291456 & t.$$.dirty[0] | 256 & t.$$.dirty[1] && n(30, u = i && c && !s), 2097152 & t.$$.dirty[0] | 320 & t.$$.dirty[1] && n(29, f = i && r != null && (Sn(r) || an(r)) && !s), 2097156 & t.$$.dirty[0] | 320 & t.$$.dirty[1] && n(36, d = i && r != null && Hh(r) && !s && !Array.isArray(it($, en(mt(r))))), 320 & t.$$.dirty[1] && n(34, h = i && r != null && Hh(r)), 136 & t.$$.dirty[1] && n(32, p = h && !Xn(a)), 4194304 & t.$$.dirty[0] && n(25, m = c), 33554432 & t.$$.dirty[0] && n(24, g = m ? "Convert to:" : "Insert:"), 33554432 & t.$$.dirty[0] | 1 & t.$$.dirty[1] && n(28, v = !m && o), 33554432 & t.$$.dirty[0] | 193 & t.$$.dirty[1] && n(27, y = m ? Ud(r) && !Wn(a) : o), 33554432 & t.$$.dirty[0] | 193 & t.$$.dirty[1] && n(26, w = m ? Ud(r) && !Array.isArray(a) : o), 33554432 & t.$$.dirty[0] | 193 & t.$$.dirty[1] && n(23, x = m ? Ud(r) && Xn(a) : o), 24 & t.$$.dirty[0] | 192 & t.$$.dirty[1] && n(33, b = !(r == null || !a) && bs(a, N.enforceStringMap, Je(mt(r)), B)), 2145386496 & t.$$.dirty[0] | 63 & t.$$.dirty[1] && n(1, j = [{ type: "row", items: [{ type: "button", onClick: ge, icon: Tl, text: "Edit key", title: "Edit the key (Double-click on the key)", disabled: !d }, { type: "dropdown-button", main: { type: "button", onClick: ke, icon: Tl, text: l, title: "Edit the value (Double-click on the value)", disabled: !h }, width: "11em", items: [{ type: "button", icon: Tl, text: l, title: "Edit the value (Double-click on the value)", onClick: ke, disabled: !h }, { type: "button", icon: b ? ku : $u, text: "Enforce string", title: "Enforce keeping the value as string when it contains a numeric value", onClick: Ce, disabled: !p }] }] }, { type: "separator" }, { type: "row", items: [{ type: "dropdown-button", main: { type: "button", onClick: we, icon: _l, text: "Cut", title: "Cut selected contents, formatted with indentation (Ctrl+X)", disabled: !c }, width: "10em", items: [{ type: "button", icon: _l, text: "Cut formatted", title: "Cut selected contents, formatted with indentation (Ctrl+X)", onClick: we, disabled: !c }, { type: "button", icon: _l, text: "Cut compacted", title: "Cut selected contents, without indentation (Ctrl+Shift+X)", onClick: le, disabled: !c }] }, { type: "dropdown-button", main: { type: "button", onClick: rt, icon: Vs, text: "Copy", title: "Copy selected contents, formatted with indentation (Ctrl+C)", disabled: !c }, width: "12em", items: [{ type: "button", icon: Vs, text: "Copy formatted", title: "Copy selected contents, formatted with indentation (Ctrl+C)", onClick: rt, disabled: !c }, { type: "button", icon: Vs, text: "Copy compacted", title: "Copy selected contents, without indentation (Ctrl+Shift+C)", onClick: Be, disabled: !c }] }, { type: "button", onClick: nt, icon: NS, text: "Paste", title: "Paste clipboard contents (Ctrl+V)", disabled: !o }] }, { type: "separator" }, { type: "row", items: [{ type: "column", items: [{ type: "button", onClick: We, icon: BS, text: "Duplicate", title: "Duplicate selected contents (Ctrl+D)", disabled: !u }, { type: "button", onClick: Rt, icon: tB, text: "Extract", title: "Extract selected contents", disabled: !f }, { type: "button", onClick: Se, icon: wp, text: "Sort", title: "Sort array or object contents", disabled: !c }, { type: "button", onClick: rn, icon: bp, text: "Transform", title: "Transform array or object contents (filter, sort, project)", disabled: !c }, { type: "button", onClick: oe, icon: Og, text: "Remove", title: "Remove selected contents (Delete)", disabled: !c }] }, { type: "column", items: [{ type: "label", text: g }, { type: "button", onClick: function() {
      return de("structure");
    }, icon: m ? Rf : kl, text: "Structure", title: g + " structure", disabled: !v }, { type: "button", onClick: function() {
      return de("object");
    }, icon: m ? Rf : kl, text: "Object", title: g + " structure", disabled: !y }, { type: "button", onClick: function() {
      return de("array");
    }, icon: m ? Rf : kl, text: "Array", title: g + " array", disabled: !w }, { type: "button", onClick: function() {
      return de("value");
    }, icon: m ? Rf : kl, text: "Value", title: g + " value", disabled: !x }] }] }, { type: "separator" }, { type: "row", items: [{ type: "button", onClick: Dt, icon: QL, text: "Insert before", title: "Select area before current entry to insert or paste contents", disabled: !c || s }, { type: "button", onClick: Xt, icon: UL, text: "Insert after", title: "Select area after current entry to insert or paste contents", disabled: !c || s }] }]);
  }, [O, j, $, N, B, I, P, J, D, Q, Z, L, R, V, M, C, F, z, E, A, te, s, c, x, g, m, w, y, v, f, u, o, p, b, h, l, d, r, a, i];
}
var Hee = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Vee, Fee, Pt, { json: 2, documentState: 3, parser: 4, showTip: 0, onCloseContextMenu: 5, onEditKey: 6, onEditValue: 7, onToggleEnforceString: 8, onCut: 9, onCopy: 10, onPaste: 11, onRemove: 12, onDuplicate: 13, onExtract: 14, onInsertBefore: 15, onInsert: 16, onConvert: 17, onInsertAfter: 18, onSort: 19, onTransform: 20 }, null, [-1, -1]), i;
  }
  return Ye(n);
}();
function Uee(t) {
  At(t, "svelte-lajpxi", 'div.jse-collapsed-items.svelte-lajpxi.svelte-lajpxi{margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);color:var(--jse-collapsed-items-link-color, rgba(0, 0, 0, 0.38));padding:calc(0.5 * var(--jse-padding, 10px));border:8px solid transparent;border-width:8px 0;background-color:var(--jse-contents-background-color, transparent);background-image:linear-gradient(var(--jse-collapsed-items-background-color, #f5f5f5), var(--jse-collapsed-items-background-color, #f5f5f5)), linear-gradient(to bottom right, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%), linear-gradient(to bottom left, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%), linear-gradient(to top right, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%), linear-gradient(to top left, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%);background-repeat:repeat, repeat-x, repeat-x, repeat-x, repeat-x;background-position:0 0, 8px 0, 8px 0, 8px 100%, 8px 100%;background-size:auto auto, 16px 16px, 16px 16px, 16px 16px, 16px 16px;background-clip:padding-box, border-box, border-box, border-box, border-box;background-origin:padding-box, border-box, border-box, border-box, border-box;display:flex}div.jse-collapsed-items.svelte-lajpxi div.jse-text.svelte-lajpxi,div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi{margin:0 calc(0.5 * var(--jse-padding, 10px))}div.jse-collapsed-items.svelte-lajpxi div.jse-text.svelte-lajpxi{display:inline}div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi{font-family:inherit;font-size:inherit;color:var(--jse-collapsed-items-link-color, rgba(0, 0, 0, 0.38));background:none;border:none;padding:0;text-decoration:underline;cursor:pointer}div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi:hover,div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi:focus{color:var(--jse-collapsed-items-link-color-highlight, #ee5341)}');
}
function yk(t, e, n) {
  var r = t.slice();
  return r[13] = e[n], r;
}
function bk(t) {
  var e, n, r, i, o, s, a, l, c = t[13].start + "", u = t[13].end + "";
  function f() {
    return t[12](t[13]);
  }
  return { c: function() {
    e = H("button"), n = Le("show "), r = Le(c), i = Le("-"), o = Le(u), s = se(), k(e, "type", "button"), k(e, "class", "jse-expand-items svelte-lajpxi");
  }, m: function(d, h) {
    X(d, e, h), T(e, n), T(e, r), T(e, i), T(e, o), T(e, s), a || (l = Oe(e, "click", f), a = !0);
  }, p: function(d, h) {
    t = d, 16 & h && c !== (c = t[13].start + "") && bt(r, c), 16 & h && u !== (u = t[13].end + "") && bt(o, u);
  }, d: function(d) {
    d && Y(e), a = !1, l();
  } };
}
function Wee(t) {
  for (var e, n, r, i, o, s, a, l, c, u, f = Ot(t[4]), d = [], h = 0; h < f.length; h += 1)
    d[h] = bk(yk(t, f, h));
  return { c: function() {
    e = H("div"), n = H("div"), r = H("div"), i = Le("Items "), o = Le(t[3]), s = Le("-"), a = Le(t[2]), l = se();
    for (var p = 0; p < d.length; p += 1)
      d[p].c();
    k(r, "class", "jse-text svelte-lajpxi"), k(e, "role", "none"), k(e, "class", "jse-collapsed-items svelte-lajpxi"), $e(e, "jse-selected", t[5]), Qr(e, "--level", t[0].length + 2);
  }, m: function(p, m) {
    X(p, e, m), T(e, n), T(n, r), T(r, i), T(r, o), T(r, s), T(r, a), T(n, l);
    for (var g = 0; g < d.length; g += 1)
      d[g] && d[g].m(n, null);
    c || (u = Oe(e, "mousemove", Jee), c = !0);
  }, p: function(p, m) {
    var g = Et(m, 1)[0];
    if (8 & g && bt(o, p[3]), 4 & g && bt(a, p[2]), 19 & g) {
      var v;
      for (f = Ot(p[4]), v = 0; v < f.length; v += 1) {
        var y = yk(p, f, v);
        d[v] ? d[v].p(y, g) : (d[v] = bk(y), d[v].c(), d[v].m(n, null));
      }
      for (; v < d.length; v += 1)
        d[v].d(1);
      d.length = f.length;
    }
    32 & g && $e(e, "jse-selected", p[5]), 1 & g && Qr(e, "--level", p[0].length + 2);
  }, i: Pe, o: Pe, d: function(p) {
    p && Y(e), fr(d, p), c = !1, u();
  } };
}
function Jee(t) {
  t.stopPropagation();
}
function Kee(t, e, n) {
  var r, i, o, s, a, l = e.visibleSections, c = e.sectionIndex, u = e.total, f = e.path, d = e.selection, h = e.onExpandSection, p = e.context;
  return t.$$set = function(m) {
    "visibleSections" in m && n(6, l = m.visibleSections), "sectionIndex" in m && n(7, c = m.sectionIndex), "total" in m && n(8, u = m.total), "path" in m && n(0, f = m.path), "selection" in m && n(9, d = m.selection), "onExpandSection" in m && n(1, h = m.onExpandSection), "context" in m && n(10, p = m.context);
  }, t.$$.update = function() {
    192 & t.$$.dirty && n(11, r = l[c]), 2048 & t.$$.dirty && n(3, i = r.end), 448 & t.$$.dirty && n(2, o = l[c + 1] ? l[c + 1].start : u), 1545 & t.$$.dirty && n(5, s = Uu(p.getJson(), d, f.concat(String(i)))), 12 & t.$$.dirty && n(4, a = function(m, g) {
      var v = { start: m, end: Math.min(zv(m), g) }, y = Math.max(Fh((m + g) / 2), m), w = { start: y, end: Math.min(zv(y), g) }, x = Fh(g), b = x === g ? x - Vu : x, j = { start: Math.max(b, m), end: g }, $ = [v], N = w.start >= v.end && w.end <= j.start;
      return N && $.push(w), j.start >= (N ? w.end : v.end) && $.push(j), $;
    }(i, o));
  }, [f, h, o, i, a, s, l, c, u, d, p, r, function(m) {
    return h(f, m);
  }];
}
var Gee = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Kee, Wee, Pt, { visibleSections: 6, sectionIndex: 7, total: 8, path: 0, selection: 9, onExpandSection: 1, context: 10 }, Uee), i;
  }
  return Ye(n);
}();
function Qee(t) {
  At(t, "svelte-6k6355", ".jse-context-menu-pointer.svelte-6k6355{position:absolute;top:calc(-0.5 * var(--jse-context-menu-pointer-size, calc(1em + 4px)));right:calc(-0.5 * var(--jse-context-menu-pointer-size, calc(1em + 4px)));width:var(--jse-context-menu-pointer-size, calc(1em + 4px));height:var(--jse-context-menu-pointer-size, calc(1em + 4px));padding:0;margin:0;cursor:pointer;background:transparent;border-radius:2px;background:var(--jse-context-menu-pointer-background, var(--jse-context-menu-background, #656565));color:var(--jse-context-menu-pointer-color, var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff)));border:none;box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}.jse-context-menu-pointer.svelte-6k6355:hover{background:var(--jse-context-menu-pointer-background-highlight, var(--jse-context-menu-background-highlight, #7a7a7a))}");
}
function Yee(t) {
  var e, n, r, i, o;
  return n = new cn({ props: { data: Ti } }), { c: function() {
    e = H("button"), xe(n.$$.fragment), k(e, "type", "button"), k(e, "class", "jse-context-menu-pointer svelte-6k6355"), k(e, "title", cy), $e(e, "jse-selected", t[0]);
  }, m: function(s, a) {
    X(s, e, a), ye(n, e, null), r = !0, i || (o = Oe(e, "click", t[1]), i = !0);
  }, p: function(s, a) {
    var l = Et(a, 1)[0];
    (!r || 1 & l) && $e(e, "jse-selected", s[0]);
  }, i: function(s) {
    r || (S(n.$$.fragment, s), r = !0);
  }, o: function(s) {
    _(n.$$.fragment, s), r = !1;
  }, d: function(s) {
    s && Y(e), be(n), i = !1, o();
  } };
}
function Xee(t, e, n) {
  var r = e.selected, i = e.onContextMenu;
  return t.$$set = function(o) {
    "selected" in o && n(0, r = o.selected), "onContextMenu" in o && n(2, i = o.onContextMenu);
  }, [r, function(o) {
    for (var s = o.target; s && s.nodeName !== "BUTTON"; )
      s = s.parentNode;
    s && i({ anchor: s, left: 0, top: 0, width: is, height: rs, offsetTop: 2, offsetLeft: 0, showTip: !0 });
  }, i];
}
var ha = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Xee, Yee, Pt, { selected: 0, onContextMenu: 2 }, Qee), i;
  }
  return Ye(n);
}();
function Zee(t) {
  At(t, "svelte-10xe8tv", '.jse-key.svelte-10xe8tv{display:inline-block;min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;color:var(--jse-key-color, #1a1a1a);cursor:var(--jse-contents-cursor, pointer);word-break:normal;overflow-wrap:normal;white-space:pre-wrap}.jse-key.svelte-10xe8tv:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-key.svelte-10xe8tv:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-key.jse-empty.svelte-10xe8tv{min-width:3em;outline:1px dotted var(--jse-tag-background, rgba(0, 0, 0, 0.2));-moz-outline-radius:2px}.jse-key.jse-empty.svelte-10xe8tv::after{pointer-events:none;color:var(--jse-tag-background, rgba(0, 0, 0, 0.2));content:"key"}');
}
function ete(t) {
  var e, n, r, i, o, s, a, l = [rte, nte], c = [];
  function u(f, d) {
    return f[1] ? 0 : 1;
  }
  return n = u(t), r = c[n] = l[n](t), { c: function() {
    e = H("div"), r.c(), k(e, "role", "none"), k(e, "data-type", "selectable-key"), k(e, "class", i = Un(t[6](t[0])) + " svelte-10xe8tv");
  }, m: function(f, d) {
    X(f, e, d), c[n].m(e, null), o = !0, s || (a = Oe(e, "dblclick", t[5]), s = !0);
  }, p: function(f, d) {
    var h = n;
    (n = u(f)) === h ? c[n].p(f, d) : (Ae(), _(c[h], 1, 1, function() {
      c[h] = null;
    }), Me(), (r = c[n]) ? r.p(f, d) : (r = c[n] = l[n](f)).c(), S(r, 1), r.m(e, null)), (!o || 1 & d && i !== (i = Un(f[6](f[0])) + " svelte-10xe8tv")) && k(e, "class", i);
  }, i: function(f) {
    o || (S(r), o = !0);
  }, o: function(f) {
    _(r), o = !1;
  }, d: function(f) {
    f && Y(e), c[n].d(), s = !1, a();
  } };
}
function tte(t) {
  var e, n;
  return e = new h5({ props: { value: t[2].normalization.escapeValue(t[0]), shortText: !0, onChange: t[7], onCancel: t[8], onFind: t[2].onFind } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    5 & i && (o.value = r[2].normalization.escapeValue(r[0])), 4 & i && (o.onFind = r[2].onFind), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function nte(t) {
  var e, n = Ya(t[2].normalization.escapeValue(t[0])) + "";
  return { c: function() {
    e = Le(n);
  }, m: function(r, i) {
    X(r, e, i);
  }, p: function(r, i) {
    5 & i && n !== (n = Ya(r[2].normalization.escapeValue(r[0])) + "") && bt(e, n);
  }, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
function rte(t) {
  var e, n;
  return e = new b5({ props: { text: t[2].normalization.escapeValue(t[0]), searchResultItems: t[1] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    5 & i && (o.text = r[2].normalization.escapeValue(r[0])), 2 & i && (o.searchResultItems = r[1]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function xk(t) {
  var e, n;
  return e = new ha({ props: { selected: !0, onContextMenu: t[2].onContextMenu } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    4 & i && (o.onContextMenu = r[2].onContextMenu), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function ite(t) {
  var e, n, r, i, o, s = [tte, ete], a = [];
  function l(u, f) {
    return !u[2].readOnly && u[4] ? 0 : 1;
  }
  e = l(t), n = a[e] = s[e](t);
  var c = !t[2].readOnly && t[3] && !t[4] && xk(t);
  return { c: function() {
    n.c(), r = se(), c && c.c(), i = un();
  }, m: function(u, f) {
    a[e].m(u, f), X(u, r, f), c && c.m(u, f), X(u, i, f), o = !0;
  }, p: function(u, f) {
    var d = Et(f, 1)[0], h = e;
    (e = l(u)) === h ? a[e].p(u, d) : (Ae(), _(a[h], 1, 1, function() {
      a[h] = null;
    }), Me(), (n = a[e]) ? n.p(u, d) : (n = a[e] = s[e](u)).c(), S(n, 1), n.m(r.parentNode, r)), u[2].readOnly || !u[3] || u[4] ? c && (Ae(), _(c, 1, 1, function() {
      c = null;
    }), Me()) : c ? (c.p(u, d), 28 & d && S(c, 1)) : ((c = xk(u)).c(), S(c, 1), c.m(i.parentNode, i));
  }, i: function(u) {
    o || (S(n), S(c), o = !0);
  }, o: function(u) {
    _(n), _(c), o = !1;
  }, d: function(u) {
    u && (Y(r), Y(i)), a[e].d(u), c && c.d(u);
  } };
}
function ote(t, e, n) {
  var r, i, o = e.path, s = e.key, a = e.selection, l = e.searchResultItems, c = e.onUpdateKey, u = e.context;
  return t.$$set = function(f) {
    "path" in f && n(9, o = f.path), "key" in f && n(0, s = f.key), "selection" in f && n(10, a = f.selection), "searchResultItems" in f && n(1, l = f.searchResultItems), "onUpdateKey" in f && n(11, c = f.onUpdateKey), "context" in f && n(2, u = f.context);
  }, t.$$.update = function() {
    1536 & t.$$.dirty && n(3, r = !!a && dr(a) && tn(a.path, o)), 1032 & t.$$.dirty && n(4, i = r && Hi(a));
  }, [s, l, u, r, i, function(f) {
    i || u.readOnly || (f.preventDefault(), u.onSelect(Li(o, !0)));
  }, function(f) {
    return Jo("jse-key", { "jse-empty": f === "" });
  }, function(f, d) {
    var h = c(s, u.normalization.unescapeValue(f)), p = en(o).concat(h);
    u.onSelect(d === Ks.nextInside ? Wt(p, !1) : Li(p, !1)), d !== Ks.self && u.focus();
  }, function() {
    u.onSelect(Li(o, !1)), u.focus();
  }, o, a, c];
}
var ste = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, ote, ite, Pt, { path: 9, key: 0, selection: 10, searchResultItems: 1, onUpdateKey: 11, context: 2 }, Zee), i;
  }
  return Ye(n);
}();
function wk(t, e, n) {
  var r = t.slice();
  return r[8] = e[n], r;
}
function jk(t) {
  var e, n, r, i = [t[8].props], o = t[8].component;
  function s(a, l) {
    var c = {};
    if (l !== void 0 && 1 & l)
      c = Vi(i, [Ka(a[8].props)]);
    else
      for (var u = 0; u < i.length; u += 1)
        c = di(c, i[u]);
    return { props: c };
  }
  return o && (e = Wo(o, s(t))), { c: function() {
    e && xe(e.$$.fragment), n = un();
  }, m: function(a, l) {
    e && ye(e, a, l), X(a, n, l), r = !0;
  }, p: function(a, l) {
    if (1 & l && o !== (o = a[8].component)) {
      if (e) {
        Ae();
        var c = e;
        _(c.$$.fragment, 1, 0, function() {
          be(c, 1);
        }), Me();
      }
      o ? (xe((e = Wo(o, s(a, l))).$$.fragment), S(e.$$.fragment, 1), ye(e, n.parentNode, n)) : e = null;
    } else if (o) {
      var u = 1 & l ? Vi(i, [Ka(a[8].props)]) : {};
      e.$set(u);
    }
  }, i: function(a) {
    r || (e && S(e.$$.fragment, a), r = !0);
  }, o: function(a) {
    e && _(e.$$.fragment, a), r = !1;
  }, d: function(a) {
    a && Y(n), e && be(e, a);
  } };
}
function kk(t) {
  var e, n, r = t[8].component, i = jk(t);
  return { c: function() {
    i.c(), e = un();
  }, m: function(o, s) {
    i.m(o, s), X(o, e, s), n = !0;
  }, p: function(o, s) {
    1 & s && Pt(r, r = o[8].component) ? (Ae(), _(i, 1, 1, Pe), Me(), (i = jk(o)).c(), S(i, 1), i.m(e.parentNode, e)) : i.p(o, s);
  }, i: function(o) {
    n || (S(i), n = !0);
  }, o: function(o) {
    _(i), n = !1;
  }, d: function(o) {
    o && Y(e), i.d(o);
  } };
}
function ate(t) {
  for (var e, n, r = Ot(t[0]), i = [], o = 0; o < r.length; o += 1)
    i[o] = kk(wk(t, r, o));
  var s = function(a) {
    return _(i[a], 1, 1, function() {
      i[a] = null;
    });
  };
  return { c: function() {
    for (var a = 0; a < i.length; a += 1)
      i[a].c();
    e = un();
  }, m: function(a, l) {
    for (var c = 0; c < i.length; c += 1)
      i[c] && i[c].m(a, l);
    X(a, e, l), n = !0;
  }, p: function(a, l) {
    var c = Et(l, 1)[0];
    if (1 & c) {
      var u;
      for (r = Ot(a[0]), u = 0; u < r.length; u += 1) {
        var f = wk(a, r, u);
        i[u] ? (i[u].p(f, c), S(i[u], 1)) : (i[u] = kk(f), i[u].c(), S(i[u], 1), i[u].m(e.parentNode, e));
      }
      for (Ae(), u = r.length; u < i.length; u += 1)
        s(u);
      Me();
    }
  }, i: function(a) {
    if (!n) {
      for (var l = 0; l < r.length; l += 1)
        S(i[l]);
      n = !0;
    }
  }, o: function(a) {
    i = i.filter(Boolean);
    for (var l = 0; l < i.length; l += 1)
      _(i[l]);
    n = !1;
  }, d: function(a) {
    a && Y(e), fr(i, a);
  } };
}
function lte(t, e, n) {
  var r, i, o = e.path, s = e.value, a = e.context, l = e.enforceString, c = e.selection, u = e.searchResultItems;
  return t.$$set = function(f) {
    "path" in f && n(1, o = f.path), "value" in f && n(2, s = f.value), "context" in f && n(3, a = f.context), "enforceString" in f && n(4, l = f.enforceString), "selection" in f && n(5, c = f.selection), "searchResultItems" in f && n(6, u = f.searchResultItems);
  }, t.$$.update = function() {
    32 & t.$$.dirty && n(7, r = an(c) && Hi(c)), 254 & t.$$.dirty && n(0, i = a.onRenderValue({ path: o, value: s, readOnly: a.readOnly, enforceString: l, isEditing: r, parser: a.parser, normalization: a.normalization, selection: c, searchResultItems: u, onPatch: a.onPatch, onPasteJson: a.onPasteJson, onSelect: a.onSelect, onFind: a.onFind, findNextInside: a.findNextInside, focus: a.focus }));
  }, [i, o, s, a, l, c, u, r];
}
var cte = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, lte, ate, Pt, { path: 1, value: 2, context: 3, enforceString: 4, selection: 5, searchResultItems: 6 }), i;
  }
  return Ye(n);
}(), ute = cte, jr = { selecting: !1, selectionAnchor: null, selectionAnchorType: null, selectionFocus: null, dragging: !1 };
function rg(t) {
  var e = t.json, n = t.documentState, r = t.deltaY, i = t.items;
  if (!n.selection)
    return { operations: void 0, updatedSelection: null, offset: 0 };
  var o = n.selection, s = r < 0 ? function(f) {
    for (var d = f.json, h = f.items, p = f.selection, m = f.deltaY, g = os(d, p), v = h.findIndex(function($) {
      return tn($.path, g);
    }), y = function() {
      var $;
      return ($ = h[w - 1]) === null || $ === void 0 ? void 0 : $.height;
    }, w = v, x = 0; y() !== void 0 && Math.abs(m) > x + y() / 2; )
      x += y(), w -= 1;
    var b = h[w].path, j = w - v;
    return w !== v && h[w] !== void 0 ? { beforePath: b, offset: j } : void 0;
  }({ json: e, selection: o, deltaY: r, items: i }) : function(f) {
    for (var d, h = f.json, p = f.items, m = f.selection, g = f.deltaY, v = Qs(h, m), y = p.findIndex(function(I) {
      return tn(I.path, v);
    }), w = 0, x = y, b = function() {
      var I;
      return (I = p[x + 1]) === null || I === void 0 ? void 0 : I.height;
    }; b() !== void 0 && Math.abs(g) > w + b() / 2; )
      w += b(), x += 1;
    var j = en(v), $ = it(h, j), N = Array.isArray($), B = (d = p[N ? x : x + 1]) === null || d === void 0 ? void 0 : d.path, O = x - y;
    return B ? { beforePath: B, offset: O } : { append: !0, offset: O };
  }({ json: e, selection: o, deltaY: r, items: i });
  if (!s || s.offset === 0)
    return { operations: void 0, updatedSelection: null, offset: 0 };
  var a = function(f, d, h) {
    if (!d)
      return [];
    var p = "beforePath" in h ? h.beforePath : void 0, m = "append" in h ? h.append : void 0, g = en(mt(d)), v = it(f, g);
    if (!(m || p && aa(p, g) && p.length > g.length))
      return [];
    var y = os(f, d), w = Qs(f, d), x = Yt(y), b = Yt(w), j = p ? p[g.length] : void 0;
    if (!er(v)) {
      if (Tn(v)) {
        var $ = zr(x), N = zr(b), B = j !== void 0 ? zr(j) : v.length;
        return gD(N - $ + 1, B < $ ? function(D) {
          return { op: "move", from: Je(g.concat(String($ + D))), path: Je(g.concat(String(B + D))) };
        } : function() {
          return { op: "move", from: Je(g.concat(String($))), path: Je(g.concat(String(B))) };
        });
      }
      throw new Error("Cannot create move operations: parent must be an Object or Array");
    }
    var O = Object.keys(v), I = O.indexOf(x), P = O.indexOf(b), J = m ? O.length : j !== void 0 ? O.indexOf(j) : -1;
    return I !== -1 && P !== -1 && J !== -1 ? J > I ? [].concat(Ft(O.slice(I, P + 1)), Ft(O.slice(J, O.length))).map(function(D) {
      return Xa(g, D);
    }) : [].concat(Ft(O.slice(J, I)), Ft(O.slice(P + 1, O.length))).map(function(D) {
      return Xa(g, D);
    }) : [];
  }(e, o, s), l = en(os(e, o)), c = it(e, l);
  if (Array.isArray(c)) {
    var u = function(f) {
      var d, h, p = f.items, m = f.json, g = f.selection, v = f.offset, y = os(m, g), w = Qs(m, g), x = p.findIndex(function(N) {
        return tn(N.path, y);
      }), b = p.findIndex(function(N) {
        return tn(N.path, w);
      }), j = (d = p[x + v]) === null || d === void 0 ? void 0 : d.path, $ = (h = p[b + v]) === null || h === void 0 ? void 0 : h.path;
      return Wr(j, $);
    }({ items: i, json: e, selection: o, offset: s.offset });
    return { operations: a, updatedSelection: u, offset: s.offset };
  }
  return { operations: a, updatedSelection: null, offset: s.offset };
}
function ko(t, e) {
  return function(n, r) {
    if (n) {
      for (var i = {}, o = 0, s = Object.keys(n); o < s.length; o++) {
        var a = s[o];
        r(a, n[a]) && (i[a] = n[a]);
      }
      return Object.keys(i).length > 0 ? i : void 0;
    }
  }(t, function(n) {
    return yp(n, e);
  });
}
function fte(t) {
  At(t, "svelte-g0bfge", 'button.jse-validation-error.svelte-g0bfge{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;padding:0;margin:0;vertical-align:top;display:inline-flex;color:var(--jse-warning-color, #fdc539)}');
}
function dte(t) {
  var e, n, r, i, o, s;
  return n = new cn({ props: { data: al } }), { c: function() {
    e = H("button"), xe(n.$$.fragment), k(e, "type", "button"), k(e, "class", "jse-validation-error svelte-g0bfge");
  }, m: function(a, l) {
    X(a, e, l), ye(n, e, null), i = !0, o || (s = [Oe(e, "click", function() {
      Ar(t[0]) && t[0].apply(this, arguments);
    }), Mr(r = by.call(null, e, fe({ text: t[1] }, t[2])))], o = !0);
  }, p: function(a, l) {
    var c = Et(l, 1)[0];
    t = a, r && Ar(r.update) && 2 & c && r.update.call(null, fe({ text: t[1] }, t[2]));
  }, i: function(a) {
    i || (S(n.$$.fragment, a), i = !0);
  }, o: function(a) {
    _(n.$$.fragment, a), i = !1;
  }, d: function(a) {
    a && Y(e), be(n), o = !1, An(s);
  } };
}
function hte(t, e, n) {
  var r, i = _r("absolute-popup"), o = e.validationError, s = e.onExpand;
  return t.$$set = function(a) {
    "validationError" in a && n(3, o = a.validationError), "onExpand" in a && n(0, s = a.onExpand);
  }, t.$$.update = function() {
    8 & t.$$.dirty && n(1, r = o.isChildError ? "Contains invalid data" : o.message);
  }, [s, r, i, o];
}
var Cc = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, hte, dte, wr, { validationError: 3, onExpand: 0 }, fte), i;
  }
  return Ye(n);
}();
function pte(t) {
  At(t, "svelte-1koa14y", '.jse-json-node.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{position:relative;color:var(--jse-text-color, #4d4d4d)}.jse-json-node.jse-root.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{min-height:100%;padding-bottom:2px;box-sizing:border-box}.jse-json-node.jse-root.svelte-1koa14y>.jse-header-outer.svelte-1koa14y .jse-context-menu-pointer,.jse-json-node.jse-root.svelte-1koa14y>.jse-contents-outer.svelte-1koa14y>.jse-contents.svelte-1koa14y .jse-context-menu-pointer{top:0;right:calc(-2px - var(--jse-context-menu-pointer-size, calc(1em + 4px)))}.jse-json-node.jse-root.svelte-1koa14y>.jse-contents-outer.svelte-1koa14y>.jse-contents.svelte-1koa14y.svelte-1koa14y{padding-left:0}.jse-json-node.svelte-1koa14y .jse-props.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.svelte-1koa14y .jse-items.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{position:relative}.jse-json-node.svelte-1koa14y .jse-header-outer.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.svelte-1koa14y .jse-footer-outer.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{display:flex;margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)))}.jse-json-node.svelte-1koa14y .jse-header.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{position:relative}.jse-json-node.svelte-1koa14y .jse-header .jse-meta.svelte-1koa14y>.jse-meta-inner.svelte-1koa14y.svelte-1koa14y{display:flex;justify-content:center}.jse-json-node.svelte-1koa14y .jse-contents-outer.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{display:flex;margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)))}.jse-json-node.svelte-1koa14y .jse-header.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.svelte-1koa14y .jse-contents.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{display:flex;flex-direction:row;align-items:start}.jse-json-node.svelte-1koa14y .jse-contents.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{padding-left:var(--jse-indent-size, calc(1em + 4px))}.jse-json-node.svelte-1koa14y .jse-footer.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{display:inline-flex;padding-left:calc(var(--jse-indent-size, calc(1em + 4px)) + 5px)}.jse-json-node.svelte-1koa14y .jse-header.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.svelte-1koa14y .jse-contents.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.svelte-1koa14y .jse-footer.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{background:var(--jse-contents-background-color, transparent)}.jse-json-node.svelte-1koa14y .jse-insert-selection-area.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{visibility:hidden;padding:0 calc(0.5 * var(--jse-padding, 10px));flex:1}.jse-json-node.svelte-1koa14y .jse-insert-selection-area.jse-inside.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{display:inline-flex;align-items:center}.jse-json-node.svelte-1koa14y .jse-insert-selection-area.jse-after.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{display:flex;align-items:flex-end}.jse-json-node.svelte-1koa14y .jse-context-menu-pointer-anchor.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{position:relative}.jse-json-node.svelte-1koa14y .jse-insert-area.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{display:flex;position:relative;z-index:1;margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)));max-width:250px;min-width:100px;height:0;margin-right:calc(0.5 * var(--jse-padding, 10px));outline:1px solid}.jse-json-node.svelte-1koa14y .jse-insert-area.svelte-1koa14y .jse-context-menu-pointer{right:-1px;background:var(--jse-context-menu-pointer-hover-background, #b2b2b2)}.jse-json-node.svelte-1koa14y .jse-insert-area.jse-hovered.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{outline-color:var(--jse-context-menu-pointer-hover-background, #b2b2b2)}.jse-json-node.svelte-1koa14y:hover>.jse-contents-outer .jse-insert-selection-area.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y:not(.jse-selected),.jse-json-node.svelte-1koa14y .jse-header-outer.svelte-1koa14y:hover>.jse-insert-selection-area.svelte-1koa14y.svelte-1koa14y:not(.jse-selected),.jse-json-node.svelte-1koa14y .jse-footer-outer:hover .jse-insert-selection-area.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y:not(.jse-selected){visibility:visible}.jse-json-node.jse-hovered.svelte-1koa14y>.jse-header-outer.svelte-1koa14y>.jse-header.svelte-1koa14y>.jse-meta.svelte-1koa14y,.jse-json-node.jse-hovered.svelte-1koa14y .jse-props .jse-header.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-hovered.svelte-1koa14y .jse-items .jse-header.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-hovered.svelte-1koa14y .jse-props .jse-contents.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-hovered.svelte-1koa14y .jse-items .jse-contents.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-hovered.svelte-1koa14y .jse-footer.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-json-node.jse-selected.svelte-1koa14y>.jse-header-outer.svelte-1koa14y>.jse-header.svelte-1koa14y>.jse-meta.svelte-1koa14y,.jse-json-node.jse-selected.svelte-1koa14y .jse-props .jse-header.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected.svelte-1koa14y .jse-items .jse-header.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected.svelte-1koa14y .jse-props .jse-contents.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected.svelte-1koa14y .jse-items .jse-contents.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected.svelte-1koa14y .jse-header.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected.svelte-1koa14y .jse-contents.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected.svelte-1koa14y .jse-footer.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected.svelte-1koa14y .jse-key,.jse-json-node.jse-selected.svelte-1koa14y .jse-value{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.jse-selected.svelte-1koa14y .jse-expand.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{background:var(--jse-selection-background-color, #d3d3d3)}.jse-json-node.jse-selected-key.svelte-1koa14y>.jse-contents-outer.svelte-1koa14y>.jse-contents.svelte-1koa14y>.jse-identifier>.jse-key,.jse-json-node.jse-selected-key.svelte-1koa14y>.jse-header-outer.svelte-1koa14y>.jse-header.svelte-1koa14y>.jse-identifier>.jse-key{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.jse-selected-value.svelte-1koa14y>.jse-contents-outer.svelte-1koa14y>.jse-contents.svelte-1koa14y>.jse-value{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.svelte-1koa14y .jse-collapsed-items.jse-selected,.jse-json-node.jse-selected.svelte-1koa14y .jse-collapsed-items,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-collapsed-items{background-color:var(--jse-selection-background-color, #d3d3d3);--jse-collapsed-items-background-color:var(--jse-collapsed-items-selected-background-color, #c2c2c2)}.jse-json-node.jse-selected-value.svelte-1koa14y .jse-meta.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected-value.svelte-1koa14y>.jse-header-outer.svelte-1koa14y>.jse-header.svelte-1koa14y>.jse-meta.svelte-1koa14y,.jse-json-node.jse-selected-value.svelte-1koa14y>.jse-footer-outer.svelte-1koa14y>.jse-footer.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-contents.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-header.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-footer.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-expand.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-contents.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-header.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-footer.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-expand.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{background:var(--jse-selection-background-color, #d3d3d3)}.jse-json-node.jse-selected-value.svelte-1koa14y .jse-meta.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-meta.svelte-1koa14y .jse-value,.jse-json-node.jse-selected-value.svelte-1koa14y>.jse-header-outer.svelte-1koa14y>.jse-header.svelte-1koa14y>.jse-meta.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y>.jse-header-outer.svelte-1koa14y>.jse-header.svelte-1koa14y>.jse-meta.svelte-1koa14y .jse-value,.jse-json-node.jse-selected-value.svelte-1koa14y>.jse-footer-outer.svelte-1koa14y>.jse-footer.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y>.jse-footer-outer.svelte-1koa14y>.jse-footer.svelte-1koa14y .jse-value,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-contents.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-contents.svelte-1koa14y .jse-value,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-header.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-header.svelte-1koa14y .jse-value,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-footer.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-footer.svelte-1koa14y .jse-value,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-expand.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-props .jse-expand.svelte-1koa14y .jse-value,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-contents.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-contents.svelte-1koa14y .jse-value,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-header.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-header.svelte-1koa14y .jse-value,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-footer.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-footer.svelte-1koa14y .jse-value,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-expand.svelte-1koa14y .jse-key,.jse-json-node.jse-selected-value.svelte-1koa14y .jse-items .jse-expand.svelte-1koa14y .jse-value{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.jse-readonly.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{--jse-contents-selected-cursor:pointer}.jse-json-node.svelte-1koa14y .jse-insert-area.jse-selected.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{outline-color:var(--jse-context-menu-pointer-background, var(--jse-context-menu-background, #656565))}.jse-json-node.svelte-1koa14y .jse-insert-area.jse-selected.svelte-1koa14y .jse-context-menu-pointer{background:var(--jse-context-menu-pointer-background, var(--jse-context-menu-background, #656565))}.jse-json-node.svelte-1koa14y .jse-insert-area.jse-selected.svelte-1koa14y .jse-context-menu-pointer:hover{background:var(--jse-context-menu-pointer-background-highlight, var(--jse-context-menu-background-highlight, #7a7a7a))}.jse-main:not(.jse-focus) .jse-json-node.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{--jse-selection-background-color:var(--jse-selection-background-inactive-color, #e8e8e8);--jse-context-menu-pointer-background:var(--jse-context-menu-pointer-hover-background, #b2b2b2)}.jse-expand.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{width:var(--jse-indent-size, calc(1em + 4px));padding:0;margin:0;border:none;cursor:pointer;background:transparent;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38));font-size:var(--jse-font-size-mono, 14px);height:var(--jse-line-height, calc(1em + 4px))}.jse-expand.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y:hover{opacity:0.8}.jse-meta.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-separator.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-index.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y,.jse-bracket.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{vertical-align:top;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-index.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{padding:0 calc(0.5 * var(--jse-padding, 10px))}.jse-bracket.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{padding:0 2px}.jse-bracket.jse-expanded.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{padding-right:var(--jse-padding, 10px)}.jse-tag.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{border:none;font-size:80%;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);color:var(--jse-tag-color, var(--jse-text-color-inverse, #fff));background:var(--jse-tag-background, rgba(0, 0, 0, 0.2));border-radius:2px;cursor:pointer;display:inline-block;padding:0 4px;line-height:normal;margin:1px 0}.jse-tag.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y:hover{opacity:0.8}.jse-tag.jse-expanded.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{opacity:0.7;cursor:inherit}.jse-identifier.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y.svelte-1koa14y{vertical-align:top;position:relative}');
}
var mte = function(t) {
  return {};
}, $k = function(t) {
  return {};
};
function Sk(t, e, n) {
  var r = t.slice();
  return r[52] = e[n], r;
}
var gte = function(t) {
  return {};
}, Ck = function(t) {
  return {};
};
function Ok(t, e, n) {
  var r = t.slice();
  return r[46] = e[n], r[48] = n, r;
}
function Ek(t, e, n) {
  var r = t.slice();
  return r[49] = e[n], r;
}
var vte = function(t) {
  return {};
}, Ak = function(t) {
  return {};
};
function yte(t) {
  var e, n, r, i, o, s, a, l, c, u = !t[8].readOnly && t[16] && t[7] && (an(t[7]) || Sn(t[7])) && !Hi(t[7]) && tn(mt(t[7]), t[1]), f = t[33].identifier, d = ir(f, t, t[34], $k), h = !t[17] && Mk();
  o = new ute({ props: { path: t[1], value: t[0], enforceString: t[13], selection: t[16] ? t[7] : null, searchResultItems: Zw(t[6], t[9]), context: t[8] } });
  var p = u && _k(t), m = t[15] && Tk(t), g = !t[17] && Pk(t);
  return { c: function() {
    e = H("div"), n = H("div"), d && d.c(), r = se(), h && h.c(), i = se(), xe(o.$$.fragment), s = se(), p && p.c(), a = se(), m && m.c(), l = se(), g && g.c(), k(n, "class", "jse-contents svelte-1koa14y"), k(e, "class", "jse-contents-outer svelte-1koa14y");
  }, m: function(v, y) {
    X(v, e, y), T(e, n), d && d.m(n, null), T(n, r), h && h.m(n, null), T(n, i), ye(o, n, null), T(n, s), p && p.m(n, null), T(e, a), m && m.m(e, null), T(e, l), g && g.m(e, null), c = !0;
  }, p: function(v, y) {
    d && d.p && (!c || 8 & y[1]) && sr(d, f, v, v[34], c ? or(f, v[34], y, mte) : ar(v[34]), $k), v[17] ? h && (h.d(1), h = null) : h || ((h = Mk()).c(), h.m(n, i));
    var w = {};
    2 & y[0] && (w.path = v[1]), 1 & y[0] && (w.value = v[0]), 8192 & y[0] && (w.enforceString = v[13]), 65664 & y[0] && (w.selection = v[16] ? v[7] : null), 576 & y[0] && (w.searchResultItems = Zw(v[6], v[9])), 256 & y[0] && (w.context = v[8]), o.$set(w), 65922 & y[0] && (u = !v[8].readOnly && v[16] && v[7] && (an(v[7]) || Sn(v[7])) && !Hi(v[7]) && tn(mt(v[7]), v[1])), u ? p ? (p.p(v, y), 65922 & y[0] && S(p, 1)) : ((p = _k(v)).c(), S(p, 1), p.m(n, null)) : p && (Ae(), _(p, 1, 1, function() {
      p = null;
    }), Me()), v[15] ? m ? (m.p(v, y), 32768 & y[0] && S(m, 1)) : ((m = Tk(v)).c(), S(m, 1), m.m(e, l)) : m && (Ae(), _(m, 1, 1, function() {
      m = null;
    }), Me()), v[17] ? g && (g.d(1), g = null) : g ? g.p(v, y) : ((g = Pk(v)).c(), g.m(e, null));
  }, i: function(v) {
    c || (S(d, v), S(o.$$.fragment, v), S(p), S(m), c = !0);
  }, o: function(v) {
    _(d, v), _(o.$$.fragment, v), _(p), _(m), c = !1;
  }, d: function(v) {
    v && Y(e), d && d.d(v), h && h.d(), be(o), p && p.d(), m && m.d(), g && g.d();
  } };
}
function bte(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w = !t[8].readOnly && t[16] && t[7] && (an(t[7]) || Sn(t[7])) && !t[7].edit && tn(mt(t[7]), t[1]), x = [jte, wte], b = [];
  function j(V, M) {
    return V[12] ? 0 : 1;
  }
  i = j(t), o = b[i] = x[i](t);
  var $ = t[33].identifier, N = ir($, t, t[34], Ck), B = !t[17] && Rk();
  function O(V, M) {
    return V[12] ? $te : kte;
  }
  var I = O(t), P = I(t), J = w && Nk(t), D = t[15] && (!t[12] || !t[15].isChildError) && Ik(t);
  function Q(V, M) {
    return V[12] ? Cte : V[17] ? void 0 : Ste;
  }
  var Z = Q(t), L = Z && Z(t), R = t[12] && Dk(t);
  return { c: function() {
    e = H("div"), n = H("div"), r = H("button"), o.c(), s = se(), N && N.c(), a = se(), B && B.c(), l = se(), c = H("div"), u = H("div"), P.c(), f = se(), J && J.c(), d = se(), D && D.c(), h = se(), L && L.c(), p = se(), R && R.c(), m = un(), k(r, "type", "button"), k(r, "class", "jse-expand svelte-1koa14y"), k(r, "title", "Expand or collapse this object (Ctrl+Click to expand/collapse recursively)"), k(u, "class", "jse-meta-inner svelte-1koa14y"), k(c, "class", "jse-meta svelte-1koa14y"), k(c, "data-type", "selectable-value"), k(n, "class", "jse-header svelte-1koa14y"), k(e, "class", "jse-header-outer svelte-1koa14y");
  }, m: function(V, M) {
    X(V, e, M), T(e, n), T(n, r), b[i].m(r, null), T(n, s), N && N.m(n, null), T(n, a), B && B.m(n, null), T(n, l), T(n, c), T(c, u), P.m(u, null), T(n, f), J && J.m(n, null), T(e, d), D && D.m(e, null), T(e, h), L && L.m(e, null), X(V, p, M), R && R.m(V, M), X(V, m, M), g = !0, v || (y = Oe(r, "click", t[20]), v = !0);
  }, p: function(V, M) {
    var C = i;
    (i = j(V)) !== C && (Ae(), _(b[C], 1, 1, function() {
      b[C] = null;
    }), Me(), (o = b[i]) || (o = b[i] = x[i](V)).c(), S(o, 1), o.m(r, null)), N && N.p && (!g || 8 & M[1]) && sr(N, $, V, V[34], g ? or($, V[34], M, gte) : ar(V[34]), Ck), V[17] ? B && (B.d(1), B = null) : B || ((B = Rk()).c(), B.m(n, l)), I === (I = O(V)) && P ? P.p(V, M) : (P.d(1), (P = I(V)) && (P.c(), P.m(u, null))), 65922 & M[0] && (w = !V[8].readOnly && V[16] && V[7] && (an(V[7]) || Sn(V[7])) && !V[7].edit && tn(mt(V[7]), V[1])), w ? J ? (J.p(V, M), 65922 & M[0] && S(J, 1)) : ((J = Nk(V)).c(), S(J, 1), J.m(n, null)) : J && (Ae(), _(J, 1, 1, function() {
      J = null;
    }), Me()), !V[15] || V[12] && V[15].isChildError ? D && (Ae(), _(D, 1, 1, function() {
      D = null;
    }), Me()) : D ? (D.p(V, M), 36864 & M[0] && S(D, 1)) : ((D = Ik(V)).c(), S(D, 1), D.m(e, h)), Z === (Z = Q(V)) && L ? L.p(V, M) : (L && L.d(1), (L = Z && Z(V)) && (L.c(), L.m(e, null))), V[12] ? R ? (R.p(V, M), 4096 & M[0] && S(R, 1)) : ((R = Dk(V)).c(), S(R, 1), R.m(m.parentNode, m)) : R && (Ae(), _(R, 1, 1, function() {
      R = null;
    }), Me());
  }, i: function(V) {
    g || (S(o), S(N, V), S(J), S(D), S(R), g = !0);
  }, o: function(V) {
    _(o), _(N, V), _(J), _(D), _(R), g = !1;
  }, d: function(V) {
    V && (Y(e), Y(p), Y(m)), b[i].d(), N && N.d(V), B && B.d(), P.d(), J && J.d(), D && D.d(), L && L.d(), R && R.d(V), v = !1, y();
  } };
}
function xte(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w = !t[8].readOnly && t[16] && t[7] && (an(t[7]) || Sn(t[7])) && !t[7].edit && tn(mt(t[7]), t[1]), x = [Ate, Ete], b = [];
  function j(V, M) {
    return V[12] ? 0 : 1;
  }
  i = j(t), o = b[i] = x[i](t);
  var $ = t[33].identifier, N = ir($, t, t[34], Ak), B = !t[17] && zk();
  function O(V, M) {
    return V[12] ? _te : Mte;
  }
  var I = O(t), P = I(t), J = w && Fk(t), D = t[15] && (!t[12] || !t[15].isChildError) && Vk(t);
  function Q(V, M) {
    return V[12] ? Pte : Tte;
  }
  var Z = Q(t), L = Z(t), R = t[12] && Hk(t);
  return { c: function() {
    e = H("div"), n = H("div"), r = H("button"), o.c(), s = se(), N && N.c(), a = se(), B && B.c(), l = se(), c = H("div"), u = H("div"), P.c(), f = se(), J && J.c(), d = se(), D && D.c(), h = se(), L.c(), p = se(), R && R.c(), m = un(), k(r, "type", "button"), k(r, "class", "jse-expand svelte-1koa14y"), k(r, "title", "Expand or collapse this array (Ctrl+Click to expand/collapse recursively)"), k(u, "class", "jse-meta-inner svelte-1koa14y"), k(u, "data-type", "selectable-value"), k(c, "class", "jse-meta svelte-1koa14y"), k(n, "class", "jse-header svelte-1koa14y"), k(e, "class", "jse-header-outer svelte-1koa14y");
  }, m: function(V, M) {
    X(V, e, M), T(e, n), T(n, r), b[i].m(r, null), T(n, s), N && N.m(n, null), T(n, a), B && B.m(n, null), T(n, l), T(n, c), T(c, u), P.m(u, null), T(n, f), J && J.m(n, null), T(e, d), D && D.m(e, null), T(e, h), L.m(e, null), X(V, p, M), R && R.m(V, M), X(V, m, M), g = !0, v || (y = Oe(r, "click", t[20]), v = !0);
  }, p: function(V, M) {
    var C = i;
    (i = j(V)) !== C && (Ae(), _(b[C], 1, 1, function() {
      b[C] = null;
    }), Me(), (o = b[i]) || (o = b[i] = x[i](V)).c(), S(o, 1), o.m(r, null)), N && N.p && (!g || 8 & M[1]) && sr(N, $, V, V[34], g ? or($, V[34], M, vte) : ar(V[34]), Ak), V[17] ? B && (B.d(1), B = null) : B || ((B = zk()).c(), B.m(n, l)), I === (I = O(V)) && P ? P.p(V, M) : (P.d(1), (P = I(V)) && (P.c(), P.m(u, null))), 65922 & M[0] && (w = !V[8].readOnly && V[16] && V[7] && (an(V[7]) || Sn(V[7])) && !V[7].edit && tn(mt(V[7]), V[1])), w ? J ? (J.p(V, M), 65922 & M[0] && S(J, 1)) : ((J = Fk(V)).c(), S(J, 1), J.m(n, null)) : J && (Ae(), _(J, 1, 1, function() {
      J = null;
    }), Me()), !V[15] || V[12] && V[15].isChildError ? D && (Ae(), _(D, 1, 1, function() {
      D = null;
    }), Me()) : D ? (D.p(V, M), 36864 & M[0] && S(D, 1)) : ((D = Vk(V)).c(), S(D, 1), D.m(e, h)), Z === (Z = Q(V)) && L ? L.p(V, M) : (L.d(1), (L = Z(V)) && (L.c(), L.m(e, null))), V[12] ? R ? (R.p(V, M), 4096 & M[0] && S(R, 1)) : ((R = Hk(V)).c(), S(R, 1), R.m(m.parentNode, m)) : R && (Ae(), _(R, 1, 1, function() {
      R = null;
    }), Me());
  }, i: function(V) {
    g || (S(o), S(N, V), S(J), S(D), S(R), g = !0);
  }, o: function(V) {
    _(o), _(N, V), _(J), _(D), _(R), g = !1;
  }, d: function(V) {
    V && (Y(e), Y(p), Y(m)), b[i].d(), N && N.d(V), B && B.d(), P.d(), J && J.d(), D && D.d(), L.d(), R && R.d(V), v = !1, y();
  } };
}
function Mk(t) {
  var e;
  return { c: function() {
    (e = H("div")).textContent = ":", k(e, "class", "jse-separator svelte-1koa14y");
  }, m: function(n, r) {
    X(n, e, r);
  }, d: function(n) {
    n && Y(e);
  } };
}
function _k(t) {
  var e, n, r;
  return n = new ha({ props: { selected: !0, onContextMenu: t[8].onContextMenu } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), k(e, "class", "jse-context-menu-pointer-anchor svelte-1koa14y");
  }, m: function(i, o) {
    X(i, e, o), ye(n, e, null), r = !0;
  }, p: function(i, o) {
    var s = {};
    256 & o[0] && (s.onContextMenu = i[8].onContextMenu), n.$set(s);
  }, i: function(i) {
    r || (S(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    _(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && Y(e), be(n);
  } };
}
function Tk(t) {
  var e, n;
  return e = new Cc({ props: { validationError: t[15], onExpand: t[21] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    32768 & i[0] && (o.validationError = r[15]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Pk(t) {
  var e, n, r;
  return { c: function() {
    k(e = H("div"), "role", "none"), k(e, "class", "jse-insert-selection-area jse-after svelte-1koa14y"), k(e, "data-type", "insert-selection-area-after");
  }, m: function(i, o) {
    X(i, e, o), n || (r = Oe(e, "click", t[29]), n = !0);
  }, p: Pe, d: function(i) {
    i && Y(e), n = !1, r();
  } };
}
function wte(t) {
  var e, n;
  return e = new cn({ props: { data: Ds } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function jte(t) {
  var e, n;
  return e = new cn({ props: { data: Ti } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Rk(t) {
  var e;
  return { c: function() {
    (e = H("div")).textContent = ":", k(e, "class", "jse-separator svelte-1koa14y");
  }, m: function(n, r) {
    X(n, e, r);
  }, d: function(n) {
    n && Y(e);
  } };
}
function kte(t) {
  var e, n, r, i, o, s, a, l, c, u, f = Object.keys(t[0]).length + "", d = Object.keys(t[0]).length === 1 ? "prop" : "props";
  return { c: function() {
    (e = H("div")).textContent = "{", n = se(), r = H("button"), i = Le(f), o = se(), s = Le(d), a = se(), (l = H("div")).textContent = "}", k(e, "class", "jse-bracket svelte-1koa14y"), k(r, "type", "button"), k(r, "class", "jse-tag svelte-1koa14y"), k(l, "class", "jse-bracket svelte-1koa14y");
  }, m: function(h, p) {
    X(h, e, p), X(h, n, p), X(h, r, p), T(r, i), T(r, o), T(r, s), X(h, a, p), X(h, l, p), c || (u = Oe(r, "click", t[21]), c = !0);
  }, p: function(h, p) {
    1 & p[0] && f !== (f = Object.keys(h[0]).length + "") && bt(i, f), 1 & p[0] && d !== (d = Object.keys(h[0]).length === 1 ? "prop" : "props") && bt(s, d);
  }, d: function(h) {
    h && (Y(e), Y(n), Y(r), Y(a), Y(l)), c = !1, u();
  } };
}
function $te(t) {
  var e;
  return { c: function() {
    (e = H("div")).textContent = "{", k(e, "class", "jse-bracket jse-expanded svelte-1koa14y");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, d: function(n) {
    n && Y(e);
  } };
}
function Nk(t) {
  var e, n, r;
  return n = new ha({ props: { selected: !0, onContextMenu: t[8].onContextMenu } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), k(e, "class", "jse-context-menu-pointer-anchor svelte-1koa14y");
  }, m: function(i, o) {
    X(i, e, o), ye(n, e, null), r = !0;
  }, p: function(i, o) {
    var s = {};
    256 & o[0] && (s.onContextMenu = i[8].onContextMenu), n.$set(s);
  }, i: function(i) {
    r || (S(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    _(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && Y(e), be(n);
  } };
}
function Ik(t) {
  var e, n;
  return e = new Cc({ props: { validationError: t[15], onExpand: t[21] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    32768 & i[0] && (o.validationError = r[15]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Ste(t) {
  var e, n, r;
  return { c: function() {
    k(e = H("div"), "role", "none"), k(e, "class", "jse-insert-selection-area jse-after svelte-1koa14y"), k(e, "data-type", "insert-selection-area-after");
  }, m: function(i, o) {
    X(i, e, o), n || (r = Oe(e, "click", t[29]), n = !0);
  }, p: Pe, d: function(i) {
    i && Y(e), n = !1, r();
  } };
}
function Cte(t) {
  var e, n, r;
  return { c: function() {
    k(e = H("div"), "role", "none"), k(e, "class", "jse-insert-selection-area jse-inside svelte-1koa14y"), k(e, "data-type", "insert-selection-area-inside");
  }, m: function(i, o) {
    X(i, e, o), n || (r = Oe(e, "click", t[28]), n = !0);
  }, p: Pe, d: function(i) {
    i && Y(e), n = !1, r();
  } };
}
function Dk(t) {
  for (var e, n, r, i, o, s, a, l = !t[8].readOnly && (t[10] === vs || t[16] && vr(t[7])), c = l && Lk(t), u = Ot(t[18](t[1], t[0], t[2], t[3], t[4], t[5], t[6], t[7], t[11])), f = [], d = 0; d < u.length; d += 1)
    f[d] = Bk(Sk(t, u, d));
  var h = function(m) {
    return _(f[m], 1, 1, function() {
      f[m] = null;
    });
  }, p = !t[17] && qk(t);
  return { c: function() {
    e = H("div"), c && c.c(), n = se();
    for (var m = 0; m < f.length; m += 1)
      f[m].c();
    r = se(), i = H("div"), (o = H("div")).innerHTML = '<div class="jse-bracket svelte-1koa14y">}</div>', s = se(), p && p.c(), k(e, "class", "jse-props svelte-1koa14y"), k(o, "data-type", "selectable-value"), k(o, "class", "jse-footer svelte-1koa14y"), k(i, "class", "jse-footer-outer svelte-1koa14y");
  }, m: function(m, g) {
    X(m, e, g), c && c.m(e, null), T(e, n);
    for (var v = 0; v < f.length; v += 1)
      f[v] && f[v].m(e, null);
    X(m, r, g), X(m, i, g), T(i, o), T(i, s), p && p.m(i, null), a = !0;
  }, p: function(m, g) {
    if (66944 & g[0] && (l = !m[8].readOnly && (m[10] === vs || m[16] && vr(m[7]))), l ? c ? (c.p(m, g), 66944 & g[0] && S(c, 1)) : ((c = Lk(m)).c(), S(c, 1), c.m(e, n)) : c && (Ae(), _(c, 1, 1, function() {
      c = null;
    }), Me()), 38013439 & g[0]) {
      var v;
      for (u = Ot(m[18](m[1], m[0], m[2], m[3], m[4], m[5], m[6], m[7], m[11])), v = 0; v < u.length; v += 1) {
        var y = Sk(m, u, v);
        f[v] ? (f[v].p(y, g), S(f[v], 1)) : (f[v] = Bk(y), f[v].c(), S(f[v], 1), f[v].m(e, null));
      }
      for (Ae(), v = u.length; v < f.length; v += 1)
        h(v);
      Me();
    }
    m[17] ? p && (p.d(1), p = null) : p ? p.p(m, g) : ((p = qk(m)).c(), p.m(i, null));
  }, i: function(m) {
    if (!a) {
      S(c);
      for (var g = 0; g < u.length; g += 1)
        S(f[g]);
      a = !0;
    }
  }, o: function(m) {
    _(c), f = f.filter(Boolean);
    for (var g = 0; g < f.length; g += 1)
      _(f[g]);
    a = !1;
  }, d: function(m) {
    m && (Y(e), Y(r), Y(i)), c && c.d(), fr(f, m), p && p.d();
  } };
}
function Lk(t) {
  var e, n, r;
  return n = new ha({ props: { selected: t[16] && vr(t[7]), onContextMenu: t[30] } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), k(e, "class", "jse-insert-area jse-inside svelte-1koa14y"), k(e, "data-type", "insert-selection-area-inside"), k(e, "title", ly), $e(e, "jse-hovered", t[10] === vs), $e(e, "jse-selected", t[16] && vr(t[7])), Qr(e, "--level", t[1].length + 1);
  }, m: function(i, o) {
    X(i, e, o), ye(n, e, null), r = !0;
  }, p: function(i, o) {
    var s = {};
    65664 & o[0] && (s.selected = i[16] && vr(i[7])), n.$set(s), (!r || 1024 & o[0]) && $e(e, "jse-hovered", i[10] === vs), (!r || 65664 & o[0]) && $e(e, "jse-selected", i[16] && vr(i[7])), 2 & o[0] && Qr(e, "--level", i[1].length + 1);
  }, i: function(i) {
    r || (S(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    _(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && Y(e), be(n);
  } };
}
function Ote(t) {
  var e, n, r, i;
  return n = new ste({ props: { path: t[52].path, key: t[52].key, selection: t[52].selection, searchResultItems: t[52].keySearchResultItemsMap, context: t[8], onUpdateKey: t[22] } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), r = se(), k(e, "slot", "identifier"), k(e, "class", "jse-identifier svelte-1koa14y");
  }, m: function(o, s) {
    X(o, e, s), ye(n, e, null), T(e, r), i = !0;
  }, p: function(o, s) {
    var a = {};
    2303 & s[0] && (a.path = o[52].path), 2303 & s[0] && (a.key = o[52].key), 2303 & s[0] && (a.selection = o[52].selection), 2303 & s[0] && (a.searchResultItems = o[52].keySearchResultItemsMap), 256 & s[0] && (a.context = o[8]), n.$set(a);
  }, i: function(o) {
    i || (S(n.$$.fragment, o), i = !0);
  }, o: function(o) {
    _(n.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && Y(e), be(n);
  } };
}
function Bk(t) {
  var e, n;
  return e = new Ey({ props: { value: t[52].value, path: t[52].path, expandedMap: t[52].expandedMap, enforceStringMap: t[52].enforceStringMap, visibleSectionsMap: t[52].visibleSectionsMap, validationErrorsMap: t[52].validationErrorsMap, searchResultItemsMap: t[52].valueSearchResultItemsMap, selection: t[52].selection, context: t[8], onDragSelectionStart: t[25], $$slots: { identifier: [Ote] }, $$scope: { ctx: t } } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2303 & i[0] && (o.value = r[52].value), 2303 & i[0] && (o.path = r[52].path), 2303 & i[0] && (o.expandedMap = r[52].expandedMap), 2303 & i[0] && (o.enforceStringMap = r[52].enforceStringMap), 2303 & i[0] && (o.visibleSectionsMap = r[52].visibleSectionsMap), 2303 & i[0] && (o.validationErrorsMap = r[52].validationErrorsMap), 2303 & i[0] && (o.searchResultItemsMap = r[52].valueSearchResultItemsMap), 2303 & i[0] && (o.selection = r[52].selection), 256 & i[0] && (o.context = r[8]), 2559 & i[0] | 8 & i[1] && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function qk(t) {
  var e, n, r;
  return { c: function() {
    k(e = H("div"), "role", "none"), k(e, "class", "jse-insert-selection-area jse-after svelte-1koa14y"), k(e, "data-type", "insert-selection-area-after");
  }, m: function(i, o) {
    X(i, e, o), n || (r = Oe(e, "click", t[29]), n = !0);
  }, p: Pe, d: function(i) {
    i && Y(e), n = !1, r();
  } };
}
function Ete(t) {
  var e, n;
  return e = new cn({ props: { data: Ds } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Ate(t) {
  var e, n;
  return e = new cn({ props: { data: Ti } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function zk(t) {
  var e;
  return { c: function() {
    (e = H("div")).textContent = ":", k(e, "class", "jse-separator svelte-1koa14y");
  }, m: function(n, r) {
    X(n, e, r);
  }, d: function(n) {
    n && Y(e);
  } };
}
function Mte(t) {
  var e, n, r, i, o, s, a, l, c, u, f = t[0].length + "", d = t[0].length === 1 ? "item" : "items";
  return { c: function() {
    (e = H("div")).textContent = "[", n = se(), r = H("button"), i = Le(f), o = se(), s = Le(d), a = se(), (l = H("div")).textContent = "]", k(e, "class", "jse-bracket svelte-1koa14y"), k(r, "type", "button"), k(r, "class", "jse-tag svelte-1koa14y"), k(l, "class", "jse-bracket svelte-1koa14y");
  }, m: function(h, p) {
    X(h, e, p), X(h, n, p), X(h, r, p), T(r, i), T(r, o), T(r, s), X(h, a, p), X(h, l, p), c || (u = Oe(r, "click", t[21]), c = !0);
  }, p: function(h, p) {
    1 & p[0] && f !== (f = h[0].length + "") && bt(i, f), 1 & p[0] && d !== (d = h[0].length === 1 ? "item" : "items") && bt(s, d);
  }, d: function(h) {
    h && (Y(e), Y(n), Y(r), Y(a), Y(l)), c = !1, u();
  } };
}
function _te(t) {
  var e, n, r, i, o, s, a, l = t[0].length + "", c = t[0].length === 1 ? "item" : "items";
  return { c: function() {
    (e = H("div")).textContent = "[", n = se(), r = H("span"), i = Le(l), o = se(), s = Le(c), a = Le(`
               `), k(e, "class", "jse-bracket svelte-1koa14y"), k(r, "class", "jse-tag jse-expanded svelte-1koa14y");
  }, m: function(u, f) {
    X(u, e, f), X(u, n, f), X(u, r, f), T(r, i), T(r, o), T(r, s), X(u, a, f);
  }, p: function(u, f) {
    1 & f[0] && l !== (l = u[0].length + "") && bt(i, l), 1 & f[0] && c !== (c = u[0].length === 1 ? "item" : "items") && bt(s, c);
  }, d: function(u) {
    u && (Y(e), Y(n), Y(r), Y(a));
  } };
}
function Fk(t) {
  var e, n, r;
  return n = new ha({ props: { selected: !0, onContextMenu: t[8].onContextMenu } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), k(e, "class", "jse-context-menu-pointer-anchor svelte-1koa14y");
  }, m: function(i, o) {
    X(i, e, o), ye(n, e, null), r = !0;
  }, p: function(i, o) {
    var s = {};
    256 & o[0] && (s.onContextMenu = i[8].onContextMenu), n.$set(s);
  }, i: function(i) {
    r || (S(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    _(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && Y(e), be(n);
  } };
}
function Vk(t) {
  var e, n;
  return e = new Cc({ props: { validationError: t[15], onExpand: t[21] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    32768 & i[0] && (o.validationError = r[15]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Tte(t) {
  var e, n, r;
  return { c: function() {
    k(e = H("div"), "role", "none"), k(e, "class", "jse-insert-selection-area jse-after svelte-1koa14y"), k(e, "data-type", "insert-selection-area-after");
  }, m: function(i, o) {
    X(i, e, o), n || (r = Oe(e, "click", t[29]), n = !0);
  }, p: Pe, d: function(i) {
    i && Y(e), n = !1, r();
  } };
}
function Pte(t) {
  var e, n, r;
  return { c: function() {
    k(e = H("div"), "role", "none"), k(e, "class", "jse-insert-selection-area jse-inside svelte-1koa14y"), k(e, "data-type", "insert-selection-area-inside");
  }, m: function(i, o) {
    X(i, e, o), n || (r = Oe(e, "click", t[28]), n = !0);
  }, p: Pe, d: function(i) {
    i && Y(e), n = !1, r();
  } };
}
function Hk(t) {
  for (var e, n, r, i, o, s, a, l = !t[8].readOnly && (t[10] === vs || t[16] && vr(t[7])), c = [], u = /* @__PURE__ */ new Map(), f = l && Uk(t), d = Ot(t[14] || Ga), h = function(y) {
    return y[48];
  }, p = 0; p < d.length; p += 1) {
    var m = Ok(t, d, p), g = h(m);
    u.set(g, c[p] = Kk(g, m));
  }
  var v = !t[17] && Gk(t);
  return { c: function() {
    e = H("div"), f && f.c(), n = se();
    for (var y = 0; y < c.length; y += 1)
      c[y].c();
    r = se(), i = H("div"), (o = H("div")).innerHTML = '<span class="jse-bracket svelte-1koa14y">]</span>', s = se(), v && v.c(), k(e, "class", "jse-items svelte-1koa14y"), k(o, "data-type", "selectable-value"), k(o, "class", "jse-footer svelte-1koa14y"), k(i, "class", "jse-footer-outer svelte-1koa14y");
  }, m: function(y, w) {
    X(y, e, w), f && f.m(e, null), T(e, n);
    for (var x = 0; x < c.length; x += 1)
      c[x] && c[x].m(e, null);
    X(y, r, w), X(y, i, w), T(i, o), T(i, s), v && v.m(i, null), a = !0;
  }, p: function(y, w) {
    66944 & w[0] && (l = !y[8].readOnly && (y[10] === vs || y[16] && vr(y[7]))), l ? f ? (f.p(y, w), 66944 & w[0] && S(f, 1)) : ((f = Uk(y)).c(), S(f, 1), f.m(e, n)) : f && (Ae(), _(f, 1, 1, function() {
      f = null;
    }), Me()), 34097663 & w[0] && (d = Ot(y[14] || Ga), Ae(), c = Fp(c, w, h, 1, y, d, u, e, ay, Kk, null, Ok), Me()), y[17] ? v && (v.d(1), v = null) : v ? v.p(y, w) : ((v = Gk(y)).c(), v.m(i, null));
  }, i: function(y) {
    if (!a) {
      S(f);
      for (var w = 0; w < d.length; w += 1)
        S(c[w]);
      a = !0;
    }
  }, o: function(y) {
    _(f);
    for (var w = 0; w < c.length; w += 1)
      _(c[w]);
    a = !1;
  }, d: function(y) {
    y && (Y(e), Y(r), Y(i)), f && f.d();
    for (var w = 0; w < c.length; w += 1)
      c[w].d();
    v && v.d();
  } };
}
function Uk(t) {
  var e, n, r;
  return n = new ha({ props: { selected: t[16] && vr(t[7]), onContextMenu: t[30] } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), k(e, "class", "jse-insert-area jse-inside svelte-1koa14y"), k(e, "data-type", "insert-selection-area-inside"), k(e, "title", ly), $e(e, "jse-hovered", t[10] === vs), $e(e, "jse-selected", t[16] && vr(t[7])), Qr(e, "--level", t[1].length + 1);
  }, m: function(i, o) {
    X(i, e, o), ye(n, e, null), r = !0;
  }, p: function(i, o) {
    var s = {};
    65664 & o[0] && (s.selected = i[16] && vr(i[7])), n.$set(s), (!r || 1024 & o[0]) && $e(e, "jse-hovered", i[10] === vs), (!r || 65664 & o[0]) && $e(e, "jse-selected", i[16] && vr(i[7])), 2 & o[0] && Qr(e, "--level", i[1].length + 1);
  }, i: function(i) {
    r || (S(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    _(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && Y(e), be(n);
  } };
}
function Rte(t) {
  var e, n, r, i = t[49].index + "";
  return { c: function() {
    e = H("div"), n = H("div"), r = Le(i), k(n, "class", "jse-index svelte-1koa14y"), k(e, "slot", "identifier"), k(e, "class", "jse-identifier svelte-1koa14y");
  }, m: function(o, s) {
    X(o, e, s), T(e, n), T(n, r);
  }, p: function(o, s) {
    18687 & s[0] && i !== (i = o[49].index + "") && bt(r, i);
  }, d: function(o) {
    o && Y(e);
  } };
}
function Wk(t, e) {
  var n, r, i;
  return r = new Ey({ props: { value: e[49].value, path: e[49].path, expandedMap: e[49].expandedMap, enforceStringMap: e[49].enforceStringMap, visibleSectionsMap: e[49].visibleSectionsMap, validationErrorsMap: e[49].validationErrorsMap, searchResultItemsMap: e[49].searchResultItemsMap, selection: e[49].selection, context: e[8], onDragSelectionStart: e[25], $$slots: { identifier: [Rte] }, $$scope: { ctx: e } } }), { key: t, first: null, c: function() {
    n = un(), xe(r.$$.fragment), this.first = n;
  }, m: function(o, s) {
    X(o, n, s), ye(r, o, s), i = !0;
  }, p: function(o, s) {
    e = o;
    var a = {};
    18687 & s[0] && (a.value = e[49].value), 18687 & s[0] && (a.path = e[49].path), 18687 & s[0] && (a.expandedMap = e[49].expandedMap), 18687 & s[0] && (a.enforceStringMap = e[49].enforceStringMap), 18687 & s[0] && (a.visibleSectionsMap = e[49].visibleSectionsMap), 18687 & s[0] && (a.validationErrorsMap = e[49].validationErrorsMap), 18687 & s[0] && (a.searchResultItemsMap = e[49].searchResultItemsMap), 18687 & s[0] && (a.selection = e[49].selection), 256 & s[0] && (a.context = e[8]), 18687 & s[0] | 8 & s[1] && (a.$$scope = { dirty: s, ctx: e }), r.$set(a);
  }, i: function(o) {
    i || (S(r.$$.fragment, o), i = !0);
  }, o: function(o) {
    _(r.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && Y(n), be(r, o);
  } };
}
function Jk(t) {
  var e, n;
  return e = new Gee({ props: { visibleSections: t[14] || Ga, sectionIndex: t[48], total: t[0].length, path: t[1], onExpandSection: t[8].onExpandSection, selection: t[7], context: t[8] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    16384 & i[0] && (o.visibleSections = r[14] || Ga), 16384 & i[0] && (o.sectionIndex = r[48]), 1 & i[0] && (o.total = r[0].length), 2 & i[0] && (o.path = r[1]), 256 & i[0] && (o.onExpandSection = r[8].onExpandSection), 128 & i[0] && (o.selection = r[7]), 256 & i[0] && (o.context = r[8]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Kk(t, e) {
  for (var n, r, i, o, s = [], a = /* @__PURE__ */ new Map(), l = Ot(e[19](e[1], e[0], e[46], e[2], e[3], e[4], e[5], e[6], e[7], e[11])), c = function(p) {
    return p[49].index;
  }, u = 0; u < l.length; u += 1) {
    var f = Ek(e, l, u), d = c(f);
    a.set(d, s[u] = Wk(d, f));
  }
  var h = e[46].end < e[0].length && Jk(e);
  return { key: t, first: null, c: function() {
    n = un();
    for (var p = 0; p < s.length; p += 1)
      s[p].c();
    r = se(), h && h.c(), i = un(), this.first = n;
  }, m: function(p, m) {
    X(p, n, m);
    for (var g = 0; g < s.length; g += 1)
      s[g] && s[g].m(p, m);
    X(p, r, m), h && h.m(p, m), X(p, i, m), o = !0;
  }, p: function(p, m) {
    e = p, 34097663 & m[0] && (l = Ot(e[19](e[1], e[0], e[46], e[2], e[3], e[4], e[5], e[6], e[7], e[11])), Ae(), s = Fp(s, m, c, 1, e, l, a, r.parentNode, ay, Wk, r, Ek), Me()), e[46].end < e[0].length ? h ? (h.p(e, m), 16385 & m[0] && S(h, 1)) : ((h = Jk(e)).c(), S(h, 1), h.m(i.parentNode, i)) : h && (Ae(), _(h, 1, 1, function() {
      h = null;
    }), Me());
  }, i: function(p) {
    if (!o) {
      for (var m = 0; m < l.length; m += 1)
        S(s[m]);
      S(h), o = !0;
    }
  }, o: function(p) {
    for (var m = 0; m < s.length; m += 1)
      _(s[m]);
    _(h), o = !1;
  }, d: function(p) {
    p && (Y(n), Y(r), Y(i));
    for (var m = 0; m < s.length; m += 1)
      s[m].d(p);
    h && h.d(p);
  } };
}
function Gk(t) {
  var e, n, r;
  return { c: function() {
    k(e = H("div"), "role", "none"), k(e, "class", "jse-insert-selection-area jse-after svelte-1koa14y"), k(e, "data-type", "insert-selection-area-after");
  }, m: function(i, o) {
    X(i, e, o), n || (r = Oe(e, "click", t[29]), n = !0);
  }, p: Pe, d: function(i) {
    i && Y(e), n = !1, r();
  } };
}
function Qk(t) {
  var e, n, r;
  return n = new ha({ props: { selected: t[16] && ji(t[7]), onContextMenu: t[31] } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), k(e, "class", "jse-insert-area jse-after svelte-1koa14y"), k(e, "data-type", "insert-selection-area-after"), k(e, "title", ly), $e(e, "jse-hovered", t[10] === Hu), $e(e, "jse-selected", t[16] && ji(t[7]));
  }, m: function(i, o) {
    X(i, e, o), ye(n, e, null), r = !0;
  }, p: function(i, o) {
    var s = {};
    65664 & o[0] && (s.selected = i[16] && ji(i[7])), n.$set(s), (!r || 1024 & o[0]) && $e(e, "jse-hovered", i[10] === Hu), (!r || 65664 & o[0]) && $e(e, "jse-selected", i[16] && ji(i[7]));
  }, i: function(i) {
    r || (S(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    _(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && Y(e), be(n);
  } };
}
function Nte(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d = !t[8].readOnly && (t[10] === Hu || t[16] && ji(t[7])), h = [xte, bte, yte], p = [];
  function m(v, y) {
    return 1 & y[0] && (n = null), 1 & y[0] && (r = null), n == null && (n = !!Array.isArray(v[0])), n ? 0 : (r == null && (r = !!Wn(v[0])), r ? 1 : 2);
  }
  i = m(t, [-1, -1]), o = p[i] = h[i](t);
  var g = d && Qk(t);
  return { c: function() {
    e = H("div"), o.c(), s = se(), g && g.c(), k(e, "role", "treeitem"), k(e, "tabindex", "-1"), k(e, "class", a = Un(Jo("jse-json-node", { "jse-expanded": t[12] }, t[8].onClassName(t[1], t[0]))) + " svelte-1koa14y"), k(e, "data-path", l = sc(t[1])), k(e, "aria-selected", t[16]), $e(e, "jse-root", t[17]), $e(e, "jse-selected", t[16] && Sn(t[7])), $e(e, "jse-selected-key", t[16] && dr(t[7])), $e(e, "jse-selected-value", t[16] && an(t[7])), $e(e, "jse-readonly", t[8].readOnly), $e(e, "jse-hovered", t[10] === Dv), Qr(e, "--level", t[1].length);
  }, m: function(v, y) {
    X(v, e, y), p[i].m(e, null), T(e, s), g && g.m(e, null), c = !0, u || (f = [Oe(e, "mousedown", t[23]), Oe(e, "mousemove", t[24]), Oe(e, "mouseover", t[26]), Oe(e, "mouseout", t[27]), Oe(e, "focus", void 0), Oe(e, "blur", void 0)], u = !0);
  }, p: function(v, y) {
    var w = i;
    (i = m(v, y)) === w ? p[i].p(v, y) : (Ae(), _(p[w], 1, 1, function() {
      p[w] = null;
    }), Me(), (o = p[i]) ? o.p(v, y) : (o = p[i] = h[i](v)).c(), S(o, 1), o.m(e, s)), 66944 & y[0] && (d = !v[8].readOnly && (v[10] === Hu || v[16] && ji(v[7]))), d ? g ? (g.p(v, y), 66944 & y[0] && S(g, 1)) : ((g = Qk(v)).c(), S(g, 1), g.m(e, null)) : g && (Ae(), _(g, 1, 1, function() {
      g = null;
    }), Me()), (!c || 4355 & y[0] && a !== (a = Un(Jo("jse-json-node", { "jse-expanded": v[12] }, v[8].onClassName(v[1], v[0]))) + " svelte-1koa14y")) && k(e, "class", a), (!c || 2 & y[0] && l !== (l = sc(v[1]))) && k(e, "data-path", l), (!c || 65536 & y[0]) && k(e, "aria-selected", v[16]), (!c || 135427 & y[0]) && $e(e, "jse-root", v[17]), (!c || 70019 & y[0]) && $e(e, "jse-selected", v[16] && Sn(v[7])), (!c || 70019 & y[0]) && $e(e, "jse-selected-key", v[16] && dr(v[7])), (!c || 70019 & y[0]) && $e(e, "jse-selected-value", v[16] && an(v[7])), (!c || 4355 & y[0]) && $e(e, "jse-readonly", v[8].readOnly), (!c || 5379 & y[0]) && $e(e, "jse-hovered", v[10] === Dv), 2 & y[0] && Qr(e, "--level", v[1].length);
  }, i: function(v) {
    c || (S(o), S(g), c = !0);
  }, o: function(v) {
    _(o), _(g), c = !1;
  }, d: function(v) {
    v && Y(e), p[i].d(), g && g.d(), u = !1, An(f);
  } };
}
function Ite(t, e, n) {
  var r, i, o, s, a, l, c, u = e.$$slots, f = u === void 0 ? {} : u, d = e.$$scope, h = e.value, p = e.path, m = e.expandedMap, g = e.enforceStringMap, v = e.visibleSectionsMap, y = e.validationErrorsMap, w = e.searchResultItemsMap, x = e.selection, b = e.context, j = e.onDragSelectionStart, $ = Tr("jsoneditor:JSONNode"), N = void 0, B = void 0, O = void 0, I = pp(function(R) {
    return R;
  }, hi);
  function P(R) {
    b.onDrag(R);
  }
  function J(R) {
    jr.selecting && (jr.selecting = !1, R.stopPropagation()), b.onDragEnd(), document.removeEventListener("mousemove", P, !0), document.removeEventListener("mouseup", J);
  }
  function D() {
    var R;
    return ((R = b.findElement([])) === null || R === void 0 || (R = R.getBoundingClientRect()) === null || R === void 0 ? void 0 : R.top) || 0;
  }
  function Q(R, V) {
    var M = D() - R.initialContentTop;
    return V.clientY - R.initialClientY - M;
  }
  function Z(R) {
    if (O) {
      var V = b.getJson(), M = b.getDocumentState(), C = Q(O, R), F = rg({ json: V, documentState: M, deltaY: C, items: O.items }).offset;
      F !== O.offset && ($("drag selection", F, C), n(11, O = fe(fe({}, O), {}, { offset: F, didMoveItems: !0 })));
    }
  }
  function L(R) {
    if (O) {
      var V = b.getJson(), M = rg({ json: V, documentState: b.getDocumentState(), deltaY: Q(O, R), items: O.items }), C = M.operations, F = M.updatedSelection;
      if (C)
        b.onPatch(C, function(A, te) {
          return { state: fe(fe({}, te), {}, { selection: F || x }) };
        });
      else if (R.target === O.initialTarget && !O.didMoveItems) {
        var z = Km(R.target), E = e5(R.target);
        E && b.onSelect(Jw(0, z, E));
      }
      n(11, O = void 0), jr.dragging = !1, document.removeEventListener("mousemove", Z, !0), document.removeEventListener("mouseup", L);
    }
  }
  return t.$$set = function(R) {
    "value" in R && n(0, h = R.value), "path" in R && n(1, p = R.path), "expandedMap" in R && n(2, m = R.expandedMap), "enforceStringMap" in R && n(3, g = R.enforceStringMap), "visibleSectionsMap" in R && n(4, v = R.visibleSectionsMap), "validationErrorsMap" in R && n(5, y = R.validationErrorsMap), "searchResultItemsMap" in R && n(6, w = R.searchResultItemsMap), "selection" in R && n(7, x = R.selection), "context" in R && n(8, b = R.context), "onDragSelectionStart" in R && n(32, j = R.onDragSelectionStart), "$$scope" in R && n(34, d = R.$$scope);
  }, t.$$.update = function() {
    2 & t.$$.dirty[0] && n(9, i = Je(p)), 516 & t.$$.dirty[0] && n(12, o = !!m && m[i] === !0), 777 & t.$$.dirty[0] && n(13, s = bs(h, g, i, b.parser)), 528 & t.$$.dirty[0] && n(14, a = v ? v[i] : void 0), 544 & t.$$.dirty[0] && n(15, l = y ? y[i] : void 0), 386 & t.$$.dirty[0] && n(16, c = Uu(b.getJson(), x, p)), 2 & t.$$.dirty[0] && n(17, r = p.length === 0);
  }, [h, p, m, g, v, y, w, x, b, i, N, O, o, s, a, l, c, r, function(R, V, M, C, F, z, E, A, te) {
    var ge = Object.keys(V).map(function(ke) {
      var Ce = I(R.concat(ke)), we = zb(i, ke);
      return { key: ke, value: V[ke], path: Ce, expandedMap: ko(M, we), enforceStringMap: ko(C, we), visibleSectionsMap: ko(F, we), validationErrorsMap: ko(z, we), keySearchResultItemsMap: QY(E, we), valueSearchResultItemsMap: ko(E, we), selection: Kw(b.getJson(), A, Ce) };
    });
    return te && te.offset !== 0 && (ge = Sw(ge, te.selectionStartIndex, te.selectionItemsCount, te.offset)), ge;
  }, function(R, V, M, C, F, z, E, A, te, ge) {
    for (var ke = M.start, Ce = Math.min(M.end, V.length), we = [], le = ke; le < Ce; le++) {
      var rt = I(R.concat(String(le))), Be = zb(i, le);
      we.push({ index: le, value: V[le], path: rt, expandedMap: ko(C, Be), enforceStringMap: ko(F, Be), visibleSectionsMap: ko(z, Be), validationErrorsMap: ko(E, Be), searchResultItemsMap: ko(A, Be), selection: Kw(b.getJson(), te, rt) });
    }
    if (ge && ge.offset !== 0) {
      var nt = we.map(function(We) {
        return We.index;
      });
      we = Sw(we, ge.selectionStartIndex, ge.selectionItemsCount, ge.offset);
      for (var oe = 0; oe < we.length; oe++)
        we[oe].index = nt[oe];
    }
    return we;
  }, function(R) {
    R.stopPropagation();
    var V = R.ctrlKey;
    b.onExpand(p, !o, V);
  }, function(R) {
    R.stopPropagation(), b.onExpand(p, !0);
  }, function(R, V) {
    var M = xf(p, Object.keys(h), R, V);
    return b.onPatch(M), Yt(uo(M[0].path));
  }, function(R) {
    if (!(function(E) {
      return E.nodeName === "DIV" && E.contentEditable === "true";
    }(R.target) || R.which === 1 && py(R.target, "BUTTON"))) {
      R.stopPropagation(), R.preventDefault(), b.focus(), document.addEventListener("mousemove", P, !0), document.addEventListener("mouseup", J);
      var V = Km(R.target), M = b.getJson(), C = b.getDocumentState();
      if (!x || V === On.after || V === On.inside || x.type !== V && x.type !== On.multi || !Uu(M, x, p))
        if (jr.selecting = !0, jr.selectionAnchor = p, jr.selectionAnchorType = V, jr.selectionFocus = p, R.shiftKey) {
          var F = b.getDocumentState().selection;
          F && b.onSelect(Wr(Na(F), p));
        } else if (V === On.multi)
          if (r && R.target.hasAttribute("data-path")) {
            var z = Yt(c5(h, C));
            b.onSelect(Hv(z));
          } else
            b.onSelect(Wr(p, p));
        else
          b.onSelect(Jw(0, V, p));
      else
        R.button === 0 && j(R);
    }
  }, function(R) {
    if (jr.selecting) {
      R.preventDefault(), R.stopPropagation(), jr.selectionFocus == null && window.getSelection && window.getSelection().empty();
      var V = Km(R.target);
      tn(p, jr.selectionFocus) && V === jr.selectionAnchorType || (jr.selectionFocus = p, jr.selectionAnchorType = V, b.onSelect(Wr(jr.selectionAnchor || jr.selectionFocus, jr.selectionFocus)));
    }
  }, function(R) {
    if (!b.readOnly && x) {
      var V = en(mt(x));
      if (tn(p, V)) {
        var M = function(A, te) {
          var ge = [];
          function ke(We) {
            var Rt = p.concat(We), de = b.findElement(Rt);
            de != null && ge.push({ path: Rt, height: de.clientHeight });
          }
          if (Array.isArray(h)) {
            var Ce = os(b.getJson(), A), we = Qs(b.getJson(), A), le = Yt(Ce), rt = Yt(we), Be = te.find(function(We) {
              return le >= We.start && rt <= We.end;
            });
            if (!Be)
              return null;
            var nt = Be.start, oe = Be.end;
            F6(nt, Math.min(h.length, oe), function(We) {
              return ke(String(We));
            });
          } else
            Object.keys(h).forEach(ke);
          return ge;
        }(x, a || Ga);
        if ($("dragSelectionStart", { selection: x, items: M }), M) {
          var C = b.getJson(), F = os(C, x), z = M.findIndex(function(A) {
            return tn(A.path, F);
          }), E = rg({ json: C, documentState: b.getDocumentState(), deltaY: 0, items: M }).offset;
          n(11, O = { initialTarget: R.target, initialClientY: R.clientY, initialContentTop: D(), selectionStartIndex: z, selectionItemsCount: Gs(C, x).length, items: M, offset: E, didMoveItems: !1 }), jr.dragging = !0, document.addEventListener("mousemove", Z, !0), document.addEventListener("mouseup", L);
        } else
          $("Cannot drag the current selection (probably spread over multiple sections)");
      } else
        j(R);
    }
  }, function(R) {
    jr.selecting || jr.dragging || (R.stopPropagation(), Ta(R.target, "data-type", "selectable-value") ? n(10, N = Dv) : Ta(R.target, "data-type", "insert-selection-area-inside") ? n(10, N = vs) : Ta(R.target, "data-type", "insert-selection-area-after") && n(10, N = Hu), clearTimeout(B));
  }, function(R) {
    R.stopPropagation(), B = setTimeout(function() {
      return n(10, N = void 0);
    });
  }, function(R) {
    R.shiftKey || (R.stopPropagation(), R.preventDefault(), b.onSelect(xs(p)));
  }, function(R) {
    R.shiftKey || (R.stopPropagation(), R.preventDefault(), b.onSelect(cs(p)));
  }, function(R) {
    b.onSelect(xs(p)), b.onContextMenu(R);
  }, function(R) {
    b.onSelect(cs(p)), b.onContextMenu(R);
  }, j, f, d];
}
var Ey = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Ite, Nte, Pt, { value: 0, path: 1, expandedMap: 2, enforceStringMap: 3, visibleSectionsMap: 4, validationErrorsMap: 5, searchResultItemsMap: 6, selection: 7, context: 8, onDragSelectionStart: 32 }, pte, [-1, -1]), i;
  }
  return Ye(n);
}(), Dte = Ey, Lte = { prefix: "fas", iconName: "jsoneditor-expand", icon: [512, 512, [], "", "M 0,448 V 512 h 512 v -64 z M 0,0 V 64 H 512 V 0 Z M 256,96 128,224 h 256 z M 256,416 384,288 H 128 Z"] }, Bte = { prefix: "fas", iconName: "jsoneditor-collapse", icon: [512, 512, [], "", "m 0,224 v 64 h 512 v -64 z M 256,192 384,64 H 128 Z M 256,320 128,448 h 256 z"] }, Xv = { prefix: "fas", iconName: "jsoneditor-format", icon: [512, 512, [], "", "M 0,32 v 64 h 416 v -64 z M 160,160 v 64 h 352 v -64 z M 160,288 v 64 h 288 v -64 z M 0,416 v 64 h 320 v -64 z"] }, qte = { prefix: "fas", iconName: "jsoneditor-compact", icon: [512, 512, [], "", "M 0,32 v 64 h 512 v -64 z M 0,160 v 64 h 512 v -64 z M 0,288 v 64 h 352 v -64 z"] };
function zte(t) {
  var e, n;
  return e = new Zp({ props: { items: t[0] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & Et(i, 1)[0] && (o.items = r[0]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Fte(t, e, n) {
  var r, i, o, s, a, l, c, u = e.json, f = e.selection, d = e.readOnly, h = e.showSearch, p = h !== void 0 && h, m = e.historyState, g = e.onExpandAll, v = e.onCollapseAll, y = e.onUndo, w = e.onRedo, x = e.onSort, b = e.onTransform, j = e.onContextMenu, $ = e.onCopy, N = e.onRenderMenu;
  function B() {
    n(1, p = !p);
  }
  return t.$$set = function(O) {
    "json" in O && n(2, u = O.json), "selection" in O && n(3, f = O.selection), "readOnly" in O && n(4, d = O.readOnly), "showSearch" in O && n(1, p = O.showSearch), "historyState" in O && n(5, m = O.historyState), "onExpandAll" in O && n(6, g = O.onExpandAll), "onCollapseAll" in O && n(7, v = O.onCollapseAll), "onUndo" in O && n(8, y = O.onUndo), "onRedo" in O && n(9, w = O.onRedo), "onSort" in O && n(10, x = O.onSort), "onTransform" in O && n(11, b = O.onTransform), "onContextMenu" in O && n(12, j = O.onContextMenu), "onCopy" in O && n(13, $ = O.onCopy), "onRenderMenu" in O && n(14, N = O.onRenderMenu);
  }, t.$$.update = function() {
    4 & t.$$.dirty && n(20, r = u !== void 0), 1048584 & t.$$.dirty && n(19, i = r && (Sn(f) || dr(f) || an(f))), 68 & t.$$.dirty && n(15, s = { type: "button", icon: Lte, title: "Expand all", className: "jse-expand-all", onClick: g, disabled: !Xn(u) }), 132 & t.$$.dirty && n(16, a = { type: "button", icon: Bte, title: "Collapse all", className: "jse-collapse-all", onClick: v, disabled: !Xn(u) }), 4 & t.$$.dirty && n(17, l = { type: "button", icon: q0, title: "Search (Ctrl+F)", className: "jse-search", onClick: B, disabled: u === void 0 }), 769844 & t.$$.dirty && n(18, c = d ? [s, a, { type: "separator" }, { type: "button", icon: Vs, title: "Copy (Ctrl+C)", className: "jse-copy", onClick: $, disabled: !i }, { type: "separator" }, l, { type: "space" }] : [s, a, { type: "separator" }, { type: "button", icon: wp, title: "Sort", className: "jse-sort", onClick: x, disabled: d || u === void 0 }, { type: "button", icon: bp, title: "Transform contents (filter, sort, project)", className: "jse-transform", onClick: b, disabled: d || u === void 0 }, l, { type: "button", icon: DS, title: cy, className: "jse-contextmenu", onClick: j }, { type: "separator" }, { type: "button", icon: B0, title: "Undo (Ctrl+Z)", className: "jse-undo", onClick: y, disabled: !m.canUndo }, { type: "button", icon: L0, title: "Redo (Ctrl+Shift+Z)", className: "jse-redo", onClick: w, disabled: !m.canRedo }, { type: "space" }]), 278528 & t.$$.dirty && n(0, o = N(c) || c);
  }, [o, p, u, f, d, m, g, v, y, w, x, b, j, $, N, s, a, l, c, i, r];
}
var Vte = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Fte, zte, Pt, { json: 2, selection: 3, readOnly: 4, showSearch: 1, historyState: 5, onExpandAll: 6, onCollapseAll: 7, onUndo: 8, onRedo: 9, onSort: 10, onTransform: 11, onContextMenu: 12, onCopy: 13, onRenderMenu: 14 }), i;
  }
  return Ye(n);
}();
function Hte(t) {
  At(t, "svelte-s2toti", '.jse-welcome.svelte-s2toti.svelte-s2toti{flex:1;overflow:auto;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);display:flex;flex-direction:column;align-items:center;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-welcome.svelte-s2toti.svelte-s2toti:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-welcome.svelte-s2toti .jse-space.jse-before.svelte-s2toti{flex:1}.jse-welcome.svelte-s2toti .jse-space.jse-after.svelte-s2toti{flex:2}.jse-welcome.svelte-s2toti .jse-contents.svelte-s2toti{display:flex;flex-direction:column;max-width:300px;margin:2em var(--jse-padding, 10px);gap:var(--jse-padding, 10px)}.jse-welcome.svelte-s2toti .jse-contents .jse-welcome-info.svelte-s2toti{color:var(--jse-panel-color-readonly, #b2b2b2)}.jse-welcome.svelte-s2toti .jse-contents button.svelte-s2toti{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-welcome.svelte-s2toti .jse-contents button.svelte-s2toti:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-welcome.svelte-s2toti .jse-contents button.svelte-s2toti:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}');
}
function Yk(t) {
  var e, n, r, i, o, s, a;
  return { c: function() {
    (e = H("div")).innerHTML = "You can paste clipboard data using <b>Ctrl+V</b>, or use the following options:", n = se(), (r = H("button")).textContent = "Create object", i = se(), (o = H("button")).textContent = "Create array", k(e, "class", "jse-welcome-info svelte-s2toti"), k(r, "title", "Create an empty JSON object (press '{')"), k(r, "class", "svelte-s2toti"), k(o, "title", "Create an empty JSON array (press '[')"), k(o, "class", "svelte-s2toti");
  }, m: function(l, c) {
    X(l, e, c), X(l, n, c), X(l, r, c), X(l, i, c), X(l, o, c), s || (a = [Oe(r, "click", po(t[4])), Oe(o, "click", po(t[5]))], s = !0);
  }, p: Pe, d: function(l) {
    l && (Y(e), Y(n), Y(r), Y(i), Y(o)), s = !1, An(a);
  } };
}
function Ute(t) {
  var e, n, r, i, o, s, a, l, c, u, f = !t[0] && Yk(t);
  return { c: function() {
    e = H("div"), n = H("div"), r = se(), i = H("div"), (o = H("div")).textContent = "Empty document", s = se(), f && f.c(), a = se(), l = H("div"), k(n, "class", "jse-space jse-before svelte-s2toti"), k(o, "class", "jse-welcome-title"), k(i, "class", "jse-contents svelte-s2toti"), k(l, "class", "jse-space jse-after svelte-s2toti"), k(e, "class", "jse-welcome svelte-s2toti"), k(e, "role", "none");
  }, m: function(d, h) {
    X(d, e, h), T(e, n), T(e, r), T(e, i), T(i, o), T(i, s), f && f.m(i, null), T(e, a), T(e, l), c || (u = Oe(e, "click", t[6]), c = !0);
  }, p: function(d, h) {
    var p = Et(h, 1)[0];
    d[0] ? f && (f.d(1), f = null) : f ? f.p(d, p) : ((f = Yk(d)).c(), f.m(i, null));
  }, i: Pe, o: Pe, d: function(d) {
    d && Y(e), f && f.d(), c = !1, u();
  } };
}
function Wte(t, e, n) {
  var r = e.readOnly, i = e.onCreateArray, o = e.onCreateObject, s = e.onClick;
  return t.$$set = function(a) {
    "readOnly" in a && n(0, r = a.readOnly), "onCreateArray" in a && n(1, i = a.onCreateArray), "onCreateObject" in a && n(2, o = a.onCreateObject), "onClick" in a && n(3, s = a.onClick);
  }, [r, i, o, s, function() {
    return o();
  }, function() {
    return i();
  }, function() {
    return s();
  }];
}
var Jte = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Wte, Ute, Pt, { readOnly: 0, onCreateArray: 1, onCreateObject: 2, onClick: 3 }, Hte), i;
  }
  return Ye(n);
}();
function Zv(t, e) {
  var n = typeof t == "string" ? t.toLowerCase() : t, r = typeof e == "string" ? e.toLowerCase() : e;
  return hB(n, r);
}
function D5(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (Tn(it(t, e))) {
    if (n === void 0)
      throw new Error("Cannot sort: no property selected by which to sort the array");
    return function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, l = /* @__PURE__ */ function(u, f) {
        return function(d, h) {
          var p = it(d, u), m = it(h, u);
          return p === void 0 ? f : m === void 0 ? -f : typeof p != "string" && typeof m != "string" ? p > m ? f : p < m ? -f : 0 : f * Zv(p, m);
        };
      }(s, a), c = it(i, o);
      return [{ op: "replace", path: Je(o), value: c.slice(0).sort(l) }];
    }(t, e, n, r);
  }
  if (Wn(t))
    return function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, a = it(i, o), l = Object.keys(a).slice();
      l.sort(function(h, p) {
        return s * Zv(h, p);
      });
      for (var c = [], u = 0; u < l.length; u++) {
        var f = l[u], d = Je(o.concat(f));
        c.push({ op: "move", from: d, path: d });
      }
      return c;
    }(t, e, r);
  throw new Error("Cannot sort: no array or object");
}
function Kte(t) {
  At(t, "svelte-12glmu0", '.jse-navigation-bar-dropdown.svelte-12glmu0.svelte-12glmu0{position:absolute;top:100%;left:0;z-index:3;background:var(--jse-navigation-bar-background, var(--jse-background-color, #fff));color:var(--jse-navigation-bar-dropdown-color, #656565);box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24));display:flex;flex-direction:column;max-height:300px;overflow:auto;min-width:80px}.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.svelte-12glmu0{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);border:none;background:transparent;color:inherit;cursor:pointer;outline:none;text-align:left;white-space:nowrap;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding, 10px)) 36px}.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.svelte-12glmu0:focus,.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.svelte-12glmu0:hover{background:var(--jse-navigation-bar-background-highlight, #e5e5e5)}.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.jse-selected.svelte-12glmu0{background:var(--jse-navigation-bar-dropdown-color, #656565);color:var(--jse-navigation-bar-background, var(--jse-background-color, #fff))}');
}
function Xk(t, e, n) {
  var r = t.slice();
  return r[4] = e[n], r;
}
function Zk(t, e) {
  var n, r, i, o, s, a = ys(e[4].toString(), t$) + "";
  function l() {
    return e[3](e[4]);
  }
  return { key: t, first: null, c: function() {
    n = H("button"), r = Le(a), k(n, "type", "button"), k(n, "class", "jse-navigation-bar-dropdown-item svelte-12glmu0"), k(n, "title", i = e[4].toString()), $e(n, "jse-selected", e[4] === e[1]), this.first = n;
  }, m: function(c, u) {
    X(c, n, u), T(n, r), o || (s = Oe(n, "click", po(l)), o = !0);
  }, p: function(c, u) {
    e = c, 1 & u && a !== (a = ys(e[4].toString(), t$) + "") && bt(r, a), 1 & u && i !== (i = e[4].toString()) && k(n, "title", i), 3 & u && $e(n, "jse-selected", e[4] === e[1]);
  }, d: function(c) {
    c && Y(n), o = !1, s();
  } };
}
function e$(t) {
  var e, n;
  return { c: function() {
    e = H("button"), n = Le("..."), k(e, "type", "button"), k(e, "class", "jse-navigation-bar-dropdown-item svelte-12glmu0"), k(e, "title", "Limited to " + Gc + " items");
  }, m: function(r, i) {
    X(r, e, i), T(e, n);
  }, p: Pe, d: function(r) {
    r && Y(e);
  } };
}
function Gte(t) {
  for (var e, n, r = [], i = /* @__PURE__ */ new Map(), o = Ot(qh(t[0], Gc)), s = function(f) {
    return f[4];
  }, a = 0; a < o.length; a += 1) {
    var l = Xk(t, o, a), c = s(l);
    i.set(c, r[a] = Zk(c, l));
  }
  var u = t[0].length > Gc && e$();
  return { c: function() {
    e = H("div");
    for (var f = 0; f < r.length; f += 1)
      r[f].c();
    n = se(), u && u.c(), k(e, "class", "jse-navigation-bar-dropdown svelte-12glmu0");
  }, m: function(f, d) {
    X(f, e, d);
    for (var h = 0; h < r.length; h += 1)
      r[h] && r[h].m(e, null);
    T(e, n), u && u.m(e, null);
  }, p: function(f, d) {
    var h = Et(d, 1)[0];
    7 & h && (o = Ot(qh(f[0], Gc)), r = Fp(r, h, s, 1, f, o, i, e, jQ, Zk, n, Xk)), f[0].length > Gc ? u ? u.p(f, h) : ((u = e$()).c(), u.m(e, null)) : u && (u.d(1), u = null);
  }, i: Pe, o: Pe, d: function(f) {
    f && Y(e);
    for (var d = 0; d < r.length; d += 1)
      r[d].d();
    u && u.d();
  } };
}
var Gc = 100, t$ = 30;
function Qte(t, e, n) {
  var r = e.items, i = e.selectedItem, o = e.onSelect;
  return t.$$set = function(s) {
    "items" in s && n(0, r = s.items), "selectedItem" in s && n(1, i = s.selectedItem), "onSelect" in s && n(2, o = s.onSelect);
  }, [r, i, o, function(s) {
    return o(s);
  }];
}
var Yte = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Qte, Gte, Pt, { items: 0, selectedItem: 1, onSelect: 2 }, Kte), i;
  }
  return Ye(n);
}();
function Xte(t) {
  At(t, "svelte-x08607", ".jse-navigation-bar-item.svelte-x08607.svelte-x08607{position:relative;display:flex}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.svelte-x08607{font-family:inherit;font-size:inherit;padding:calc(0.5 * var(--jse-padding, 10px)) 2px;border:none;background:transparent;color:inherit;cursor:pointer;outline:none;min-width:2em;white-space:nowrap}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.svelte-x08607:focus,.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.svelte-x08607:hover{background:var(--jse-panel-button-background-highlight, #e0e0e0);color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d))}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.jse-navigation-bar-arrow.svelte-x08607{padding:2px var(--jse-padding, 10px) 0}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.jse-navigation-bar-arrow.jse-open.svelte-x08607{background:var(--jse-navigation-bar-background, var(--jse-background-color, #fff));color:var(--jse-navigation-bar-dropdown-color, #656565)}.jse-navigation-bar-item.svelte-x08607.svelte-x08607:last-child{padding-right:var(--jse-padding, 10px)}");
}
function n$(t) {
  var e, n, r, i;
  return { c: function() {
    e = H("button"), n = Le(t[2]), k(e, "type", "button"), k(e, "class", "jse-navigation-bar-button svelte-x08607");
  }, m: function(o, s) {
    X(o, e, s), T(e, n), r || (i = Oe(e, "click", t[9]), r = !0);
  }, p: function(o, s) {
    4 & s && bt(n, o[2]);
  }, d: function(o) {
    o && Y(e), r = !1, i();
  } };
}
function Zte(t) {
  var e, n, r, i, o, s, a;
  r = new cn({ props: { data: IS } });
  var l = t[2] !== void 0 && n$(t);
  return { c: function() {
    e = H("div"), n = H("button"), xe(r.$$.fragment), i = se(), l && l.c(), k(n, "type", "button"), k(n, "class", "jse-navigation-bar-button jse-navigation-bar-arrow svelte-x08607"), $e(n, "jse-open", t[1]), k(e, "class", "jse-navigation-bar-item svelte-x08607");
  }, m: function(c, u) {
    X(c, e, u), T(e, n), ye(r, n, null), T(e, i), l && l.m(e, null), t[10](e), o = !0, s || (a = Oe(n, "click", t[4]), s = !0);
  }, p: function(c, u) {
    var f = Et(u, 1)[0];
    (!o || 2 & f) && $e(n, "jse-open", c[1]), c[2] !== void 0 ? l ? l.p(c, f) : ((l = n$(c)).c(), l.m(e, null)) : l && (l.d(1), l = null);
  }, i: function(c) {
    o || (S(r.$$.fragment, c), o = !0);
  }, o: function(c) {
    _(r.$$.fragment, c), o = !1;
  }, d: function(c) {
    c && Y(e), be(r), l && l.d(), t[10](null), s = !1, a();
  } };
}
function ene(t, e, n) {
  var r, i, o, s, a = _r("absolute-popup"), l = a.openAbsolutePopup, c = a.closeAbsolutePopup, u = e.path, f = e.index, d = e.onSelect, h = e.getItems, p = !1;
  function m(g) {
    c(s), d(r.concat(g));
  }
  return t.$$set = function(g) {
    "path" in g && n(5, u = g.path), "index" in g && n(6, f = g.index), "onSelect" in g && n(7, d = g.onSelect), "getItems" in g && n(8, h = g.getItems);
  }, t.$$.update = function() {
    96 & t.$$.dirty && (r = u.slice(0, f)), 96 & t.$$.dirty && n(2, i = u[f]);
  }, [o, p, i, m, function() {
    if (o) {
      n(1, p = !0);
      var g = { items: h(r), selectedItem: i, onSelect: m };
      s = l(Yte, g, { anchor: o, closeOnOuterClick: !0, onClose: function() {
        n(1, p = !1);
      } });
    }
  }, u, f, d, h, function() {
    return m(i);
  }, function(g) {
    Kt[g ? "unshift" : "push"](function() {
      n(0, o = g);
    });
  }];
}
var L5 = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, ene, Zte, Pt, { path: 5, index: 6, onSelect: 7, getItems: 8 }, Xte), i;
  }
  return Ye(n);
}();
function Ay(t) {
  var e, n;
  if (navigator.clipboard)
    return navigator.clipboard.writeText(t);
  if ((e = (n = document).queryCommandSupported) !== null && e !== void 0 && e.call(n, "copy")) {
    var r = document.createElement("textarea");
    r.value = t, r.style.position = "fixed", r.style.opacity = "0", document.body.appendChild(r), r.select();
    try {
      document.execCommand("copy");
    } catch (i) {
      console.error(i);
    } finally {
      document.body.removeChild(r);
    }
  } else
    console.error("Copy failed.");
}
function tne(t) {
  At(t, "svelte-1844qyt", ".jse-navigation-bar-path-editor.svelte-1844qyt.svelte-1844qyt{flex:1;display:flex;border:var(--jse-edit-outline, 2px solid #656565);background:var(--jse-background-color, #fff)}.jse-navigation-bar-path-editor.svelte-1844qyt input.jse-navigation-bar-text.svelte-1844qyt{flex:1;font-family:inherit;font-size:inherit;padding:0 5px 1px;background:var(--jse-background-color, #fff);color:var(--jse-text-color, #4d4d4d);border:none;outline:none}.jse-navigation-bar-path-editor.svelte-1844qyt button.svelte-1844qyt{border:none;background:var(--jse-background-color, #fff);cursor:pointer;font-family:inherit;font-size:80%;color:inherit}.jse-navigation-bar-path-editor.svelte-1844qyt button.jse-navigation-bar-copy.copied.svelte-1844qyt{color:var(--message-success-background, #9ac45d)}.jse-navigation-bar-path-editor.svelte-1844qyt button.jse-navigation-bar-validation-error.svelte-1844qyt{color:var(--jse-error-color, #ee5341)}.jse-navigation-bar-path-editor.error.svelte-1844qyt.svelte-1844qyt{border-color:var(--jse-error-color, #ee5341)}.jse-navigation-bar-path-editor.error.svelte-1844qyt input.jse-navigation-bar-text.svelte-1844qyt{color:var(--jse-error-color, #ee5341)}.jse-navigation-bar-path-editor.svelte-1844qyt .jse-copied-text.svelte-1844qyt{background:var(--message-success-background, #9ac45d);color:var(--jse-message-success-color, #fff);position:relative;margin:2px;padding:0 5px;border-radius:3px}");
}
function r$(t) {
  var e, n, r, i, o, s;
  return n = new cn({ props: { data: al } }), { c: function() {
    e = H("button"), xe(n.$$.fragment), k(e, "type", "button"), k(e, "class", "jse-navigation-bar-validation-error svelte-1844qyt");
  }, m: function(a, l) {
    X(a, e, l), ye(n, e, null), i = !0, o || (s = Mr(r = by.call(null, e, fe({ text: t[3] }, t[4]))), o = !0);
  }, p: function(a, l) {
    r && Ar(r.update) && 8 & l && r.update.call(null, fe({ text: a[3] }, a[4]));
  }, i: function(a) {
    i || (S(n.$$.fragment, a), i = !0);
  }, o: function(a) {
    _(n.$$.fragment, a), i = !1;
  }, d: function(a) {
    a && Y(e), be(n), o = !1, s();
  } };
}
function i$(t) {
  var e;
  return { c: function() {
    (e = H("div")).textContent = "Copied!", k(e, "class", "jse-copied-text svelte-1844qyt");
  }, m: function(n, r) {
    X(n, e, r);
  }, d: function(n) {
    n && Y(e);
  } };
}
function nne(t) {
  var e, n, r, i, o, s, a, l, c, u, f = t[3] && r$(t), d = t[2] && i$();
  return a = new cn({ props: { data: Vs } }), { c: function() {
    e = H("div"), n = H("input"), r = se(), f && f.c(), i = se(), d && d.c(), o = se(), s = H("button"), xe(a.$$.fragment), k(n, "type", "text"), k(n, "class", "jse-navigation-bar-text svelte-1844qyt"), n.value = t[0], k(s, "type", "button"), k(s, "class", "jse-navigation-bar-copy svelte-1844qyt"), k(s, "title", "Copy selected path to the clipboard"), $e(s, "copied", t[2]), k(e, "class", "jse-navigation-bar-path-editor svelte-1844qyt"), $e(e, "error", t[3]);
  }, m: function(h, p) {
    X(h, e, p), T(e, n), t[15](n), T(e, r), f && f.m(e, null), T(e, i), d && d.m(e, null), T(e, o), T(e, s), ye(a, s, null), l = !0, c || (u = [Oe(n, "keydown", po(t[6])), Oe(n, "input", t[5]), Oe(s, "click", t[7])], c = !0);
  }, p: function(h, p) {
    var m = Et(p, 1)[0];
    (!l || 1 & m && n.value !== h[0]) && (n.value = h[0]), h[3] ? f ? (f.p(h, m), 8 & m && S(f, 1)) : ((f = r$(h)).c(), S(f, 1), f.m(e, i)) : f && (Ae(), _(f, 1, 1, function() {
      f = null;
    }), Me()), h[2] ? d || ((d = i$()).c(), d.m(e, o)) : d && (d.d(1), d = null), (!l || 4 & m) && $e(s, "copied", h[2]), (!l || 8 & m) && $e(e, "error", h[3]);
  }, i: function(h) {
    l || (S(f), S(a.$$.fragment, h), l = !0);
  }, o: function(h) {
    _(f), _(a.$$.fragment, h), l = !1;
  }, d: function(h) {
    h && Y(e), t[15](null), f && f.d(), d && d.d(), be(a), c = !1, An(u);
  } };
}
function rne(t, e, n) {
  var r, i, o, s = _r("absolute-popup"), a = e.path, l = e.pathParser, c = e.onChange, u = e.onClose, f = e.onError, d = e.pathExists, h = !1, p = void 0, m = !1;
  function g() {
    i.focus();
  }
  function v(y) {
    try {
      var w = l.parse(y);
      return function(x) {
        if (!d(x))
          throw new Error("Path does not exist in current document");
      }(w), { path: w, error: void 0 };
    } catch (x) {
      return { path: void 0, error: x };
    }
  }
  return Fi(function() {
    g();
  }), Ci(function() {
    clearTimeout(p);
  }), t.$$set = function(y) {
    "path" in y && n(8, a = y.path), "pathParser" in y && n(9, l = y.pathParser), "onChange" in y && n(10, c = y.onChange), "onClose" in y && n(11, u = y.onClose), "onError" in y && n(12, f = y.onError), "pathExists" in y && n(13, d = y.pathExists);
  }, t.$$.update = function() {
    768 & t.$$.dirty && n(0, o = l.stringify(a)), 16385 & t.$$.dirty && n(3, r = h ? v(o).error : void 0);
  }, [o, i, m, r, s, function(y) {
    n(0, o = y.currentTarget.value);
  }, function(y) {
    var w = da(y);
    if (w === "Escape" && u(), w === "Enter") {
      n(14, h = !0);
      var x = v(o);
      x.path !== void 0 ? c(x.path) : f(x.error);
    }
  }, function() {
    Ay(o), n(2, m = !0), p = setTimeout(function() {
      return n(2, m = !1);
    }, 1e3), g();
  }, a, l, c, u, f, d, h, function(y) {
    Kt[y ? "unshift" : "push"](function() {
      n(1, i = y);
    });
  }];
}
var ine = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, rne, nne, wr, { path: 8, pathParser: 9, onChange: 10, onClose: 11, onError: 12, pathExists: 13 }, tne), i;
  }
  return Ye(n);
}();
function one(t) {
  At(t, "svelte-1aycet9", '.jse-navigation-bar.svelte-1aycet9.svelte-1aycet9{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-button-color, inherit);padding:0;margin:0;display:flex;overflow:auto;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.svelte-1aycet9{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);color:var(--jse-panel-color-readonly, #b2b2b2);background:transparent;border:none;display:flex;cursor:pointer;outline:none;align-items:center}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.flex.svelte-1aycet9{flex:1}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.svelte-1aycet9:focus,.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.svelte-1aycet9:hover,.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.editing.svelte-1aycet9{background:var(--jse-panel-button-background-highlight, #e0e0e0);color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d));transition:color 0.2s ease-in, background 0.2s ease-in}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit .jse-navigation-bar-space.svelte-1aycet9{flex:1;text-align:left}');
}
function o$(t, e, n) {
  var r = t.slice();
  return r[18] = e[n], r[20] = n, r;
}
function sne(t) {
  var e, n;
  return e = new ine({ props: { path: t[3], onClose: t[11], onChange: t[12], onError: t[1], pathExists: t[8], pathParser: t[2] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    8 & i && (o.path = r[3]), 2 & i && (o.onError = r[1]), 4 & i && (o.pathParser = r[2]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function ane(t) {
  for (var e, n, r, i = [], o = /* @__PURE__ */ new Map(), s = Ot(t[3]), a = function(d) {
    return d[20];
  }, l = 0; l < s.length; l += 1) {
    var c = o$(t, s, l), u = a(c);
    o.set(u, i[l] = s$(u, c));
  }
  var f = t[6] && a$(t);
  return { c: function() {
    for (var d = 0; d < i.length; d += 1)
      i[d].c();
    e = se(), f && f.c(), n = un();
  }, m: function(d, h) {
    for (var p = 0; p < i.length; p += 1)
      i[p] && i[p].m(d, h);
    X(d, e, h), f && f.m(d, h), X(d, n, h), r = !0;
  }, p: function(d, h) {
    648 & h && (s = Ot(d[3]), Ae(), i = Fp(i, h, a, 1, d, s, o, e.parentNode, ay, s$, e, o$), Me()), d[6] ? f ? (f.p(d, h), 64 & h && S(f, 1)) : ((f = a$(d)).c(), S(f, 1), f.m(n.parentNode, n)) : f && (Ae(), _(f, 1, 1, function() {
      f = null;
    }), Me());
  }, i: function(d) {
    if (!r) {
      for (var h = 0; h < s.length; h += 1)
        S(i[h]);
      S(f), r = !0;
    }
  }, o: function(d) {
    for (var h = 0; h < i.length; h += 1)
      _(i[h]);
    _(f), r = !1;
  }, d: function(d) {
    d && (Y(e), Y(n));
    for (var h = 0; h < i.length; h += 1)
      i[h].d(d);
    f && f.d(d);
  } };
}
function s$(t, e) {
  var n, r, i;
  return r = new L5({ props: { getItems: e[7], path: e[3], index: e[20], onSelect: e[9] } }), { key: t, first: null, c: function() {
    n = un(), xe(r.$$.fragment), this.first = n;
  }, m: function(o, s) {
    X(o, n, s), ye(r, o, s), i = !0;
  }, p: function(o, s) {
    e = o;
    var a = {};
    8 & s && (a.path = e[3]), 8 & s && (a.index = e[20]), r.$set(a);
  }, i: function(o) {
    i || (S(r.$$.fragment, o), i = !0);
  }, o: function(o) {
    _(r.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && Y(n), be(r, o);
  } };
}
function a$(t) {
  var e, n;
  return e = new L5({ props: { getItems: t[7], path: t[3], index: t[3].length, onSelect: t[9] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    8 & i && (o.path = r[3]), 8 & i && (o.index = r[3].length), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function lne(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p = Xn(t[0]) || t[5] ? " " : "Navigation bar", m = [ane, sne], g = [];
  function v(y, w) {
    return y[5] ? 1 : 0;
  }
  return n = v(t), r = g[n] = m[n](t), c = new cn({ props: { data: t[5] ? Xb : Qb } }), { c: function() {
    e = H("div"), r.c(), i = se(), o = H("button"), s = H("span"), a = Le(p), l = se(), xe(c.$$.fragment), k(s, "class", "jse-navigation-bar-space svelte-1aycet9"), k(o, "type", "button"), k(o, "class", "jse-navigation-bar-edit svelte-1aycet9"), k(o, "title", u = t[5] ? "Cancel editing the selected path" : "Edit the selected path"), $e(o, "flex", !t[5]), $e(o, "editing", t[5]), k(e, "class", "jse-navigation-bar svelte-1aycet9");
  }, m: function(y, w) {
    X(y, e, w), g[n].m(e, null), T(e, i), T(e, o), T(o, s), T(s, a), T(o, l), ye(c, o, null), t[15](e), f = !0, d || (h = Oe(o, "click", t[10]), d = !0);
  }, p: function(y, w) {
    var x = Et(w, 1)[0], b = n;
    (n = v(y)) === b ? g[n].p(y, x) : (Ae(), _(g[b], 1, 1, function() {
      g[b] = null;
    }), Me(), (r = g[n]) ? r.p(y, x) : (r = g[n] = m[n](y)).c(), S(r, 1), r.m(e, i)), (!f || 33 & x) && p !== (p = Xn(y[0]) || y[5] ? " " : "Navigation bar") && bt(a, p);
    var j = {};
    32 & x && (j.data = y[5] ? Xb : Qb), c.$set(j), (!f || 32 & x && u !== (u = y[5] ? "Cancel editing the selected path" : "Edit the selected path")) && k(o, "title", u), (!f || 32 & x) && $e(o, "flex", !y[5]), (!f || 32 & x) && $e(o, "editing", y[5]);
  }, i: function(y) {
    f || (S(r), S(c.$$.fragment, y), f = !0);
  }, o: function(y) {
    _(r), _(c.$$.fragment, y), f = !1;
  }, d: function(y) {
    y && Y(e), g[n].d(), be(c), t[15](null), d = !1, h();
  } };
}
function cne(t, e, n) {
  var r, i, o, s = Tr("jsoneditor:NavigationBar"), a = e.json, l = e.selection, c = e.onSelect, u = e.onError, f = e.pathParser, d = !1;
  function h(m) {
    s("select path", JSON.stringify(m)), c(Wr(m, m));
  }
  function p() {
    n(5, d = !1);
  }
  return t.$$set = function(m) {
    "json" in m && n(0, a = m.json), "selection" in m && n(13, l = m.selection), "onSelect" in m && n(14, c = m.onSelect), "onError" in m && n(1, u = m.onError), "pathParser" in m && n(2, f = m.pathParser);
  }, t.$$.update = function() {
    8192 & t.$$.dirty && n(3, r = l ? mt(l) : []), 9 & t.$$.dirty && n(6, i = Xn(it(a, r))), 8 & t.$$.dirty && setTimeout(function() {
      if (o && o.scrollTo) {
        var m = o.scrollWidth - o.clientWidth;
        m > 0 && (s("scrollTo ", m), o.scrollTo({ left: m, behavior: "smooth" }));
      }
    });
  }, [a, u, f, r, o, d, i, function(m) {
    s("get items for path", m);
    var g = it(a, m);
    if (Array.isArray(g))
      return cD(0, g.length).map(String);
    if (Wn(g)) {
      var v = Object.keys(g).slice(0);
      return v.sort(Zv), v;
    }
    return [];
  }, function(m) {
    return Ri(a, m);
  }, h, function() {
    n(5, d = !d);
  }, p, function(m) {
    p(), h(m);
  }, l, c, function(m) {
    Kt[m ? "unshift" : "push"](function() {
      n(4, o = m);
    });
  }];
}
var une = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, cne, lne, Pt, { json: 0, selection: 13, onSelect: 14, onError: 1, pathParser: 2 }, one), i;
  }
  return Ye(n);
}();
function fne(t) {
  At(t, "svelte-1vkjt6l", '.jse-search-box.svelte-1vkjt6l.svelte-1vkjt6l{border:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7));border-radius:3px;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color-readonly, #b2b2b2);box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24));display:inline-block;width:400px;max-width:100%;overflow:auto}.jse-search-box.svelte-1vkjt6l .jse-search-form.svelte-1vkjt6l{display:flex;align-items:stretch}.jse-search-box.svelte-1vkjt6l .jse-search-form button.svelte-1vkjt6l,.jse-search-box.svelte-1vkjt6l .jse-search-form input.svelte-1vkjt6l{font-family:inherit;font-size:inherit}.jse-search-box.svelte-1vkjt6l .jse-search-form button.svelte-1vkjt6l{display:block;text-align:center;border:none;padding:0 5px;margin:0;cursor:pointer;color:var(--jse-panel-button-color, inherit);background:var(--jse-panel-button-background, transparent)}.jse-search-box.svelte-1vkjt6l .jse-search-form button.svelte-1vkjt6l:hover{color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d));background:var(--jse-panel-button-background-highlight, #e0e0e0)}.jse-search-box.svelte-1vkjt6l .jse-search-form input.svelte-1vkjt6l{color:var(--jse-panel-color, var(--jse-text-color, #4d4d4d));border:var(--jse-input-border, 1px solid #d8dbdf);border-radius:3px;background:var(--jse-input-background, var(--jse-background-color, #fff));height:28px;padding:0 5px;margin:0;flex:1;width:0;min-width:50px;outline:none}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-replace-toggle.svelte-1vkjt6l{padding:var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px));min-width:20px;background:var(--jse-panel-button-background-highlight, #e0e0e0)}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents.svelte-1vkjt6l{flex:1;display:flex;flex-direction:column;padding:calc(0.5 * var(--jse-padding, 10px));gap:calc(0.5 * var(--jse-padding, 10px))}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-search-section.svelte-1vkjt6l{flex:1;display:flex;align-items:center;position:relative;padding-left:32px}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-search-section .jse-search-icon.svelte-1vkjt6l{color:inherit;cursor:inherit;background:inherit;position:absolute;top:calc(0.5 * var(--jse-padding, 10px));left:calc(0.5 * var(--jse-padding, 10px))}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-search-section label.jse-search-input-label.svelte-1vkjt6l{flex:1;display:flex}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-search-section .jse-search-count.svelte-1vkjt6l{color:inherit;font-size:80%;visibility:hidden;padding:0 5px;min-width:36px;text-align:center}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-search-section .jse-search-count.jse-visible.svelte-1vkjt6l{visibility:visible}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-replace-section.svelte-1vkjt6l{padding-left:32px;flex:1;display:flex}.jse-search-box.svelte-1vkjt6l .jse-search-form .jse-search-contents .jse-replace-section button.svelte-1vkjt6l{width:auto}');
}
function l$(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N, B, O, I, P, J = (t[3] !== -1 ? "".concat(t[3] + 1, "/") : "") + "", D = !t[4] && c$(t), Q = [hne, dne], Z = [];
  function L(V, M) {
    return V[2] ? 0 : 1;
  }
  a = L(t), l = Z[a] = Q[a](t), y = new cn({ props: { data: cB } }), b = new cn({ props: { data: KL } }), N = new cn({ props: { data: Gl } });
  var R = t[0] && !t[4] && u$(t);
  return { c: function() {
    e = H("div"), n = H("form"), D && D.c(), r = se(), i = H("div"), o = H("div"), s = H("div"), l.c(), c = se(), u = H("label"), f = H("input"), d = se(), h = H("div"), p = Le(J), m = Le(t[10]), g = se(), v = H("button"), xe(y.$$.fragment), w = se(), x = H("button"), xe(b.$$.fragment), j = se(), $ = H("button"), xe(N.$$.fragment), B = se(), R && R.c(), k(s, "class", "jse-search-icon svelte-1vkjt6l"), k(f, "class", "jse-search-input svelte-1vkjt6l"), k(f, "title", "Enter text to search"), k(f, "type", "text"), k(f, "placeholder", "Find"), k(u, "class", "jse-search-input-label svelte-1vkjt6l"), k(u, "about", "jse-search input"), k(h, "class", "jse-search-count svelte-1vkjt6l"), $e(h, "jse-visible", t[8] !== ""), k(v, "type", "button"), k(v, "class", "jse-search-next svelte-1vkjt6l"), k(v, "title", "Go to next search result (Enter)"), k(x, "type", "button"), k(x, "class", "jse-search-previous svelte-1vkjt6l"), k(x, "title", "Go to previous search result (Shift+Enter)"), k($, "type", "button"), k($, "class", "jse-search-clear svelte-1vkjt6l"), k($, "title", "Close search box (Esc)"), k(o, "class", "jse-search-section svelte-1vkjt6l"), k(i, "class", "jse-search-contents svelte-1vkjt6l"), k(n, "class", "jse-search-form svelte-1vkjt6l"), k(e, "class", "jse-search-box svelte-1vkjt6l");
  }, m: function(V, M) {
    X(V, e, M), T(e, n), D && D.m(n, null), T(n, r), T(n, i), T(i, o), T(o, s), Z[a].m(s, null), T(o, c), T(o, u), T(u, f), Uo(f, t[8]), T(o, d), T(o, h), T(h, p), T(h, m), T(o, g), T(o, v), ye(y, v, null), T(o, w), T(o, x), ye(b, x, null), T(o, j), T(o, $), ye(N, $, null), T(i, B), R && R.m(i, null), O = !0, I || (P = [Oe(f, "input", t[21]), Mr(mne.call(null, f)), Oe(v, "click", t[22]), Oe(x, "click", t[23]), Oe($, "click", t[24]), Oe(n, "submit", t[12]), Oe(n, "keydown", t[13])], I = !0);
  }, p: function(V, M) {
    V[4] ? D && (Ae(), _(D, 1, 1, function() {
      D = null;
    }), Me()) : D ? (D.p(V, M), 16 & M && S(D, 1)) : ((D = c$(V)).c(), S(D, 1), D.m(n, r));
    var C = a;
    (a = L(V)) !== C && (Ae(), _(Z[C], 1, 1, function() {
      Z[C] = null;
    }), Me(), (l = Z[a]) || (l = Z[a] = Q[a](V)).c(), S(l, 1), l.m(s, null)), 256 & M && f.value !== V[8] && Uo(f, V[8]), (!O || 8 & M) && J !== (J = (V[3] !== -1 ? "".concat(V[3] + 1, "/") : "") + "") && bt(p, J), (!O || 1024 & M) && bt(m, V[10]), (!O || 256 & M) && $e(h, "jse-visible", V[8] !== ""), V[0] && !V[4] ? R ? R.p(V, M) : ((R = u$(V)).c(), R.m(i, null)) : R && (R.d(1), R = null);
  }, i: function(V) {
    O || (S(D), S(l), S(y.$$.fragment, V), S(b.$$.fragment, V), S(N.$$.fragment, V), O = !0);
  }, o: function(V) {
    _(D), _(l), _(y.$$.fragment, V), _(b.$$.fragment, V), _(N.$$.fragment, V), O = !1;
  }, d: function(V) {
    V && Y(e), D && D.d(), Z[a].d(), be(y), be(b), be(N), R && R.d(), I = !1, An(P);
  } };
}
function c$(t) {
  var e, n, r, i, o;
  return n = new cn({ props: { data: t[0] ? Ti : Ds } }), { c: function() {
    e = H("button"), xe(n.$$.fragment), k(e, "type", "button"), k(e, "class", "jse-replace-toggle svelte-1vkjt6l"), k(e, "title", "Toggle visibility of replace options (Ctrl+H)");
  }, m: function(s, a) {
    X(s, e, a), ye(n, e, null), r = !0, i || (o = Oe(e, "click", t[11]), i = !0);
  }, p: function(s, a) {
    var l = {};
    1 & a && (l.data = s[0] ? Ti : Ds), n.$set(l);
  }, i: function(s) {
    r || (S(n.$$.fragment, s), r = !0);
  }, o: function(s) {
    _(n.$$.fragment, s), r = !1;
  }, d: function(s) {
    s && Y(e), be(n), i = !1, o();
  } };
}
function dne(t) {
  var e, n;
  return e = new cn({ props: { data: q0 } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function hne(t) {
  var e, n;
  return e = new cn({ props: { data: FL, spin: !0 } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function u$(t) {
  var e, n, r, i, o, s, a, l;
  return { c: function() {
    e = H("div"), n = H("input"), r = se(), (i = H("button")).textContent = "Replace", o = se(), (s = H("button")).textContent = "All", k(n, "class", "jse-replace-input svelte-1vkjt6l"), k(n, "title", "Enter replacement text"), k(n, "type", "text"), k(n, "placeholder", "Replace"), k(i, "type", "button"), k(i, "title", "Replace current occurrence (Ctrl+Enter)"), k(i, "class", "svelte-1vkjt6l"), k(s, "type", "button"), k(s, "title", "Replace all occurrences"), k(s, "class", "svelte-1vkjt6l"), k(e, "class", "jse-replace-section svelte-1vkjt6l");
  }, m: function(c, u) {
    X(c, e, u), T(e, n), Uo(n, t[9]), T(e, r), T(e, i), T(e, o), T(e, s), a || (l = [Oe(n, "input", t[25]), Oe(i, "click", t[14]), Oe(s, "click", t[15])], a = !0);
  }, p: function(c, u) {
    512 & u && n.value !== c[9] && Uo(n, c[9]);
  }, d: function(c) {
    c && Y(e), a = !1, An(l);
  } };
}
function pne(t) {
  var e, n, r = t[1] && l$(t);
  return { c: function() {
    r && r.c(), e = un();
  }, m: function(i, o) {
    r && r.m(i, o), X(i, e, o), n = !0;
  }, p: function(i, o) {
    var s = Et(o, 1)[0];
    i[1] ? r ? (r.p(i, s), 2 & s && S(r, 1)) : ((r = l$(i)).c(), S(r, 1), r.m(e.parentNode, e)) : r && (Ae(), _(r, 1, 1, function() {
      r = null;
    }), Me());
  }, i: function(i) {
    n || (S(r), n = !0);
  }, o: function(i) {
    _(r), n = !1;
  }, d: function(i) {
    i && Y(e), r && r.d(i);
  } };
}
function mne(t) {
  t.select();
}
function gne(t, e, n) {
  var r, i, o = e.show, s = o !== void 0 && o, a = e.searching, l = e.resultCount, c = l === void 0 ? 0 : l, u = e.activeIndex, f = u === void 0 ? 0 : u, d = e.showReplace, h = d !== void 0 && d, p = e.readOnly, m = p !== void 0 && p, g = e.onChange, v = g === void 0 ? nr : g, y = e.onPrevious, w = y === void 0 ? nr : y, x = e.onNext, b = x === void 0 ? nr : x, j = e.onReplace, $ = j === void 0 ? nr : j, N = e.onReplaceAll, B = N === void 0 ? nr : N, O = e.onClose, I = O === void 0 ? nr : O, P = "", J = "", D = "";
  function Q() {
    n(0, h = !h && !m);
  }
  function Z() {
    m || $(P, D);
  }
  return t.$$set = function(L) {
    "show" in L && n(1, s = L.show), "searching" in L && n(2, a = L.searching), "resultCount" in L && n(16, c = L.resultCount), "activeIndex" in L && n(3, f = L.activeIndex), "showReplace" in L && n(0, h = L.showReplace), "readOnly" in L && n(4, m = L.readOnly), "onChange" in L && n(17, v = L.onChange), "onPrevious" in L && n(5, w = L.onPrevious), "onNext" in L && n(6, b = L.onNext), "onReplace" in L && n(18, $ = L.onReplace), "onReplaceAll" in L && n(19, B = L.onReplaceAll), "onClose" in L && n(7, I = L.onClose);
  }, t.$$.update = function() {
    65536 & t.$$.dirty && n(10, r = c >= B6 ? "".concat(999, "+") : String(c)), 131072 & t.$$.dirty && n(20, i = ef(v, 300)), 1048832 & t.$$.dirty && i(P), 2 & t.$$.dirty && s && P !== "" && v(P);
  }, [h, s, a, f, m, w, b, I, P, D, r, Q, function(L) {
    L.preventDefault(), P !== J ? (J = P, i.cancel(), v(P)) : b();
  }, function(L) {
    L.stopPropagation();
    var R = da(L);
    R === "Enter" && (L.preventDefault(), b()), R === "Shift+Enter" && (L.preventDefault(), w()), R === "Ctrl+Enter" && (L.preventDefault(), h ? Z() : b()), R === "Ctrl+H" && (L.preventDefault(), Q()), R === "Escape" && (L.preventDefault(), I());
  }, Z, function() {
    m || B(P, D);
  }, c, v, $, B, i, function() {
    P = this.value, n(8, P);
  }, function() {
    return b();
  }, function() {
    return w();
  }, function() {
    return I();
  }, function() {
    D = this.value, n(9, D);
  }];
}
var vne = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, gne, pne, Pt, { show: 1, searching: 2, resultCount: 16, activeIndex: 3, showReplace: 0, readOnly: 4, onChange: 17, onPrevious: 5, onNext: 6, onReplace: 18, onReplaceAll: 19, onClose: 7 }, fne), i;
  }
  return Ye(n);
}(), Gu = Symbol("path");
function yne(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1 / 0, r = {};
  Array.isArray(t) && function(o, s, a) {
    if (o.length < s)
      o.forEach(a);
    else
      for (var l = s > 1 ? (o.length - 1) / (s - 1) : o.length, c = 0; c < s; c++) {
        var u = Math.floor(c * l);
        a(o[u], u, o);
      }
  }(t, n, function(o) {
    Wn(o) ? B5(o, r, e) : r[Gu] = !0;
  });
  var i = [];
  return Gu in r && i.push([]), q5(r, [], i, e), i;
}
function B5(t, e, n) {
  for (var r in t) {
    var i = t[r], o = e[r] || (e[r] = {});
    Wn(i) && n ? B5(i, o, n) : o[Gu] === void 0 && (o[Gu] = !0);
  }
}
function q5(t, e, n, r) {
  for (var i in t) {
    var o = e.concat(i), s = t[i];
    s && s[Gu] === !0 && n.push(o), er(s) && r && q5(s, o, n, r);
  }
}
function bne(t, e, n, r, i) {
  for (var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 80, s = Tn(n) ? n.length : 0, a = function(v, y) {
    var w = Object.values(v);
    if (nn(w))
      return y;
    var x = function(b, j) {
      return b + j;
    };
    return w.reduce(x) / w.length;
  }(r, i), l = t - o, c = e + 2 * o, u = function(v) {
    return r[v] || i;
  }, f = 0, d = 0; d < l && f < s; )
    d += u(f), f++;
  f > 0 && (d -= u(--f));
  for (var h = f, p = 0; p < c && h < s; )
    p += u(h), h++;
  for (var m = 0, g = h; g < s; g++)
    m += u(g);
  return { startIndex: f, endIndex: h, startHeight: d, endHeight: m, averageItemHeight: a, visibleHeight: p, visibleItems: Tn(n) ? n.slice(f, h) : [] };
}
function ig(t, e, n, r) {
  for (var i = _i(t, e).rowIndex, o = 0, s = 0; s < i; s++)
    o += n[s] || r;
  return o;
}
function _i(t, e) {
  var n, r = w6(n = t) || k6(n) || zp(n) || x6(), i = r[0], o = r.slice(1), s = parseInt(i, 10);
  return { rowIndex: isNaN(s) ? -1 : s, columnIndex: e.findIndex(function(a) {
    return aa(o, a);
  }) };
}
function Pa(t, e) {
  var n = t.rowIndex, r = t.columnIndex;
  return [String(n)].concat(Ft(e[r]));
}
function xne(t, e) {
  var n = Et(rD(t, function(a) {
    return uy(a.path[0]);
  }), 2), r = n[0], i = n[1], o = vp(r, wne), s = QI(o, function(a) {
    var l = { row: [], columns: {} };
    return a.forEach(function(c) {
      var u = function(f, d) {
        var h = _i(f.path, d);
        return h.columnIndex !== -1 ? h.columnIndex : -1;
      }(c, e);
      u !== -1 ? (l.columns[u] === void 0 && (l.columns[u] = []), l.columns[u].push(c)) : l.row.push(c);
    }), l;
  });
  return { root: i, rows: s };
}
function uc(t, e) {
  if (e && e.length !== 0)
    return e.length === 1 ? e[0] : { path: t, message: "Multiple validation issues: " + e.map(function(n) {
      return hi(n.path) + " " + n.message;
    }).join(", "), severity: gs.warning };
}
function wne(t) {
  return parseInt(t.path[0], 10);
}
function jne(t, e, n) {
  return e.some(function(r) {
    return function(i, o, s) {
      if (!i)
        return !1;
      if (o.op === "replace") {
        var a = _i(uo(o.path), s), l = a.rowIndex, c = a.columnIndex, u = s.findIndex(function(f) {
          return tn(f, i.path);
        });
        if (l !== -1 && c !== -1 && c !== u)
          return !1;
      }
      return !0;
    }(t.sortedColumn, r, n);
  }) ? fe(fe({}, t), {}, { sortedColumn: null }) : t;
}
var Yr = Tr("jsoneditor:actions");
function z5(t) {
  return e0.apply(this, arguments);
}
function e0() {
  return e0 = Tt(Ie().mark(function t(e) {
    var n, r, i, o, s, a, l, c, u, f;
    return Ie().wrap(function(d) {
      for (; ; )
        switch (d.prev = d.next) {
          case 0:
            if (n = e.json, r = e.documentState, i = e.indentation, o = e.readOnly, s = e.parser, a = e.onPatch, !o && n !== void 0 && r.selection && Sc(r.selection)) {
              d.next = 3;
              break;
            }
            return d.abrupt("return");
          case 3:
            if ((l = d5(n, r.selection, i, s)) != null) {
              d.next = 6;
              break;
            }
            return d.abrupt("return");
          case 6:
            return Yr("cut", { selection: r.selection, clipboard: l, indentation: i }), d.next = 9, Ay(l);
          case 9:
            c = g5(n, r.selection), u = c.operations, f = c.newSelection, a(u, function(h, p) {
              return { state: fe(fe({}, p), {}, { selection: f }) };
            });
          case 11:
          case "end":
            return d.stop();
        }
    }, t);
  })), e0.apply(this, arguments);
}
function F5(t) {
  return t0.apply(this, arguments);
}
function t0() {
  return t0 = Tt(Ie().mark(function t(e) {
    var n, r, i, o, s;
    return Ie().wrap(function(a) {
      for (; ; )
        switch (a.prev = a.next) {
          case 0:
            if (n = e.json, r = e.documentState, i = e.indentation, o = e.parser, (s = d5(n, r.selection, i, o)) != null) {
              a.next = 4;
              break;
            }
            return a.abrupt("return");
          case 4:
            return Yr("copy", { clipboard: s, indentation: i }), a.next = 7, Ay(s);
          case 7:
          case "end":
            return a.stop();
        }
    }, t);
  })), t0.apply(this, arguments);
}
function V5(t) {
  var e = t.clipboardText, n = t.json, r = t.selection, i = t.readOnly, o = t.parser, s = t.onPatch, a = t.onChangeText, l = t.openRepairModal;
  if (!i)
    try {
      c(e);
    } catch {
      l(e, function(f) {
        Yr("repaired pasted text: ", f), c(f);
      });
    }
  function c(u) {
    if (n !== void 0) {
      var f = r || Wt([], !1), d = m5(n, f, u, o);
      Yr("paste", { pastedText: u, operations: d, selectionNonNull: f }), s(d, function(h, p) {
        var m = p;
        return d.filter(function(g) {
          return (bS(g) || T0(g)) && Xn(g.value);
        }).forEach(function(g) {
          var v = Do(n, g.path);
          m = Is(h, m, v);
        }), { state: m };
      });
    } else
      Yr("paste text", { pastedText: u }), a(e, function(h, p) {
        if (h)
          return { state: Is(h, p, []) };
      });
  }
}
function H5(t) {
  var e = t.json, n = t.text, r = t.documentState, i = t.keepSelection, o = t.readOnly, s = t.onChange, a = t.onPatch;
  if (!o && r.selection) {
    var l = e !== void 0 && (dr(r.selection) || an(r.selection)) ? Wr(r.selection.path, r.selection.path) : r.selection;
    if (nn(mt(r.selection)))
      Yr("remove root", { selection: r.selection }), s && s({ text: "", json: void 0 }, e !== void 0 ? { text: void 0, json: e } : { text: n || "", json: e }, { contentErrors: null, patchResult: null });
    else if (e !== void 0) {
      var c = g5(e, l), u = c.operations, f = c.newSelection;
      Yr("remove", { operations: u, selection: r.selection, newSelection: f }), a(u, function(d, h) {
        return { state: fe(fe({}, h), {}, { selection: i ? r.selection : f }) };
      });
    }
  }
}
function kne(t) {
  var e = t.json, n = t.documentState, r = t.columns, i = t.readOnly, o = t.onPatch;
  if (!i && e !== void 0 && n.selection && Sc(n.selection)) {
    var s = _i(mt(n.selection), r), a = s.rowIndex, l = s.columnIndex;
    Yr("duplicate row", { rowIndex: a });
    var c = [String(a)];
    o(p5(e, [c]), function(u, f) {
      var d = Wt(Pa({ rowIndex: a < e.length ? a + 1 : a, columnIndex: l }, r), !1);
      return { state: fe(fe({}, f), {}, { selection: d }) };
    });
  }
}
function $ne(t) {
  var e = t.json, n = t.documentState, r = t.columns, i = t.readOnly, o = t.onPatch;
  if (!i && e !== void 0 && n.selection && Sc(n.selection)) {
    var s = _i(mt(n.selection), r).rowIndex;
    Yr("insert before row", { rowIndex: s }), o(El(e, [String(s)], [{ key: "", value: er(e[0]) ? {} : "" }]));
  }
}
function Sne(t) {
  var e = t.json, n = t.documentState, r = t.columns, i = t.readOnly, o = t.onPatch;
  if (!i && e !== void 0 && n.selection && Sc(n.selection)) {
    var s = _i(mt(n.selection), r), a = s.rowIndex, l = s.columnIndex;
    Yr("insert after row", { rowIndex: a });
    var c = a + 1, u = [String(c)], f = [{ key: "", value: er(e[0]) ? {} : "" }];
    o(c < e.length ? El(e, u, f) : Uv(e, [], f), function(d, h) {
      var p = Wt(Pa({ rowIndex: c, columnIndex: l }, r), !1);
      return { state: fe(fe({}, h), {}, { selection: p }) };
    });
  }
}
function Cne(t) {
  var e = t.json, n = t.documentState, r = t.columns, i = t.readOnly, o = t.onPatch;
  if (!i && e !== void 0 && n.selection && Sc(n.selection)) {
    var s = _i(mt(n.selection), r), a = s.rowIndex, l = s.columnIndex;
    Yr("remove row", { rowIndex: a }), o(Uh([[String(a)]]), function(c, u) {
      var f = a < c.length ? a : a > 0 ? a - 1 : void 0, d = f !== void 0 ? Wt(Pa({ rowIndex: f, columnIndex: l }, r), !1) : null;
      return Yr("remove row new selection", { rowIndex: a, newRowIndex: f, newSelection: d }), { state: fe(fe({}, u), {}, { selection: d }) };
    });
  }
}
function Yh(t) {
  var e = t.insertType, n = t.selectInside, r = t.refJsonEditor, i = t.json, o = t.selection, s = t.readOnly, a = t.parser, l = t.onPatch, c = t.onReplaceJson;
  if (!s) {
    var u = function(m, g, v) {
      if (v === "object")
        return {};
      if (v === "array")
        return [];
      if (v === "structure" && m !== void 0) {
        var y = g ? u5(g) : [], w = it(m, y);
        if (Array.isArray(w) && !nn(w)) {
          var x = ss(w);
          return Xn(x) ? R9(x, function(b) {
            return Array.isArray(b) ? [] : Wn(b) ? void 0 : "";
          }) : "";
        }
      }
      return "";
    }(i, o, e);
    if (i !== void 0) {
      var f = a.stringify(u), d = m5(i, o, f, a);
      Yr("onInsert", { insertType: e, operations: d, newValue: u, data: f });
      var h = Yt(d.filter(function(m) {
        return m.op === "add" || m.op === "replace";
      }));
      l(d, function(m, g) {
        if (h) {
          var v = Do(m, h.path);
          if (Xn(u))
            return { state: fe(fe({}, Ai(m, g, v, du)), {}, { selection: n ? xs(v) : g.selection }) };
          if (u === "") {
            var y = nn(v) ? null : it(m, en(v));
            return { state: Fv(m, fe(fe({}, g), {}, { selection: Wn(y) ? Li(v, !0) : Wt(v, !0) }), v) };
          }
        }
      }), Yr("after patch"), h && u === "" && Xh(function() {
        return zh(r, "", !0, Zh);
      });
    } else {
      Yr("onInsert", { insertType: e, newValue: u });
      var p = [];
      c(u, function(m, g) {
        return { state: fe(fe({}, Is(m, g, p)), {}, { selection: Xn(u) ? xs(p) : Wt(p, !0) }) };
      });
    }
  }
}
function U5(t) {
  return n0.apply(this, arguments);
}
function n0() {
  return n0 = Tt(Ie().mark(function t(e) {
    var n, r, i, o, s, a, l, c, u, f, d, h;
    return Ie().wrap(function(p) {
      for (; ; )
        switch (p.prev = p.next) {
          case 0:
            if (n = e.char, r = e.selectInside, i = e.refJsonEditor, o = e.json, s = e.selection, a = e.readOnly, l = e.parser, c = e.onPatch, u = e.onReplaceJson, f = e.onSelect, !a) {
              p.next = 3;
              break;
            }
            return p.abrupt("return");
          case 3:
            if (!dr(s)) {
              p.next = 8;
              break;
            }
            return d = !s.edit, f(fe(fe({}, s), {}, { edit: !0 })), Xh(function() {
              return zh(i, n, d, Zh);
            }), p.abrupt("return");
          case 8:
            if (n !== "{") {
              p.next = 12;
              break;
            }
            Yh({ insertType: "object", selectInside: r, refJsonEditor: i, json: o, selection: s, readOnly: a, parser: l, onPatch: c, onReplaceJson: u }), p.next = 23;
            break;
          case 12:
            if (n !== "[") {
              p.next = 16;
              break;
            }
            Yh({ insertType: "array", selectInside: r, refJsonEditor: i, json: o, selection: s, readOnly: a, parser: l, onPatch: c, onReplaceJson: u }), p.next = 23;
            break;
          case 16:
            if (!an(s) || o === void 0) {
              p.next = 20;
              break;
            }
            Xn(it(o, s.path)) || (h = !s.edit, f(fe(fe({}, s), {}, { edit: !0 })), Xh(function() {
              return zh(i, n, h, Zh);
            })), p.next = 23;
            break;
          case 20:
            return Yr("onInsertValueWithCharacter", { char: n }), p.next = 23, One({ char: n, refJsonEditor: i, json: o, selection: s, readOnly: a, parser: l, onPatch: c, onReplaceJson: u });
          case 23:
          case "end":
            return p.stop();
        }
    }, t);
  })), n0.apply(this, arguments);
}
function One(t) {
  return r0.apply(this, arguments);
}
function r0() {
  return r0 = Tt(Ie().mark(function t(e) {
    var n, r, i, o, s, a, l, c, u;
    return Ie().wrap(function(f) {
      for (; ; )
        switch (f.prev = f.next) {
          case 0:
            if (n = e.char, r = e.refJsonEditor, i = e.json, o = e.selection, s = e.readOnly, a = e.parser, l = e.onPatch, c = e.onReplaceJson, !s) {
              f.next = 3;
              break;
            }
            return f.abrupt("return");
          case 3:
            Yh({ insertType: "value", selectInside: !1, refJsonEditor: r, json: i, selection: o, readOnly: s, parser: a, onPatch: l, onReplaceJson: c }), u = !Hi(o), Xh(function() {
              return zh(r, n, u, Zh);
            });
          case 6:
          case "end":
            return f.stop();
        }
    }, t);
  })), r0.apply(this, arguments);
}
function Xh(t) {
  setTimeout(function() {
    return setTimeout(t);
  });
}
function Zh(t) {
  t == null || t.refresh();
}
function Ene(t) {
  At(t, "svelte-l2z0i3", '.jse-json-preview.svelte-l2z0i3{flex:1;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-panel-color-readonly, #b2b2b2);overflow:auto;white-space:pre-wrap;padding:2px;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7);border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}');
}
function Ane(t) {
  var e, n;
  return { c: function() {
    e = H("div"), n = Le(t[0]), k(e, "class", "jse-json-preview svelte-l2z0i3");
  }, m: function(r, i) {
    X(r, e, i), T(e, n);
  }, p: function(r, i) {
    1 & Et(i, 1)[0] && bt(n, r[0]);
  }, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
function Mne(t, e, n) {
  var r, i, o = e.text, s = e.json, a = e.indentation, l = e.parser;
  return t.$$set = function(c) {
    "text" in c && n(1, o = c.text), "json" in c && n(2, s = c.json), "indentation" in c && n(3, a = c.indentation), "parser" in c && n(4, l = c.parser);
  }, t.$$.update = function() {
    6 & t.$$.dirty && n(5, r = s !== void 0 ? { json: s } : { text: o || "" }), 56 & t.$$.dirty && n(0, i = ys(qv(r, a, l), Nv));
  }, [i, o, s, a, l, r];
}
var W5 = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Mne, Ane, wr, { text: 1, json: 2, indentation: 3, parser: 4 }, Ene), i;
  }
  return Ye(n);
}(), _ne = oy.window;
function Tne(t) {
  At(t, "svelte-vx4hzc", '.jse-tree-mode.svelte-vx4hzc.svelte-vx4hzc{flex:1;display:flex;flex-direction:column;position:relative;background:var(--jse-background-color, #fff);min-width:0;min-height:0;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-text-color, #4d4d4d);line-height:var(--jse-line-height, calc(1em + 4px))}.jse-tree-mode.svelte-vx4hzc .jse-hidden-input-label .jse-hidden-input.svelte-vx4hzc{position:fixed;top:-10px;left:-10px;width:1px;height:1px;padding:0;border:0;outline:none}.jse-tree-mode.svelte-vx4hzc .jse-search-box-container.svelte-vx4hzc{position:relative;height:0;top:var(--jse-padding, 10px);margin-right:calc(var(--jse-padding, 10px) + 20px);margin-left:var(--jse-padding, 10px);text-align:right;z-index:3}.jse-tree-mode.no-main-menu.svelte-vx4hzc.svelte-vx4hzc{border-top:var(--jse-main-border, 1px solid #d7d7d7)}.jse-tree-mode.svelte-vx4hzc .jse-contents.svelte-vx4hzc{border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7);flex:1;overflow:auto;position:relative;padding:2px;display:flex;flex-direction:column}.jse-tree-mode.svelte-vx4hzc .jse-contents.svelte-vx4hzc:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-tree-mode.svelte-vx4hzc .jse-contents .jse-loading-space.svelte-vx4hzc{flex:1}.jse-tree-mode.svelte-vx4hzc .jse-contents .jse-loading.svelte-vx4hzc{flex:2;text-align:center;color:var(--jse-panel-color-readonly, #b2b2b2);box-sizing:border-box;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}');
}
function f$(t) {
  var e, n, r;
  function i(s) {
    t[78](s);
  }
  var o = { json: t[11], selection: t[17].selection, readOnly: t[0], historyState: t[23], onExpandAll: t[41], onCollapseAll: t[42], onUndo: t[37], onRedo: t[38], onSort: t[39], onTransform: t[40], onContextMenu: t[46], onCopy: t[34], onRenderMenu: t[7] };
  return t[20] !== void 0 && (o.showSearch = t[20]), e = new Vte({ props: o }), Kt.push(function() {
    return no(e, "showSearch", i);
  }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(s, a) {
    ye(e, s, a), r = !0;
  }, p: function(s, a) {
    var l = {};
    2048 & a[0] && (l.json = s[11]), 131072 & a[0] && (l.selection = s[17].selection), 1 & a[0] && (l.readOnly = s[0]), 8388608 & a[0] && (l.historyState = s[23]), 128 & a[0] && (l.onRenderMenu = s[7]), !n && 1048576 & a[0] && (n = !0, l.showSearch = s[20], to(function() {
      return n = !1;
    })), e.$set(l);
  }, i: function(s) {
    r || (S(e.$$.fragment, s), r = !0);
  }, o: function(s) {
    _(e.$$.fragment, s), r = !1;
  }, d: function(s) {
    be(e, s);
  } };
}
function d$(t) {
  var e, n;
  return e = new une({ props: { json: t[11], selection: t[17].selection, onSelect: t[50], onError: t[6], pathParser: t[4] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2048 & i[0] && (o.json = r[11]), 131072 & i[0] && (o.selection = r[17].selection), 64 & i[0] && (o.onError = r[6]), 16 & i[0] && (o.pathParser = r[4]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Pne(t) {
  var e;
  return { c: function() {
    (e = H("div")).innerHTML = '<div class="jse-loading-space svelte-vx4hzc"></div> <div class="jse-loading svelte-vx4hzc">loading...</div>', k(e, "class", "jse-contents svelte-vx4hzc");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, i: Pe, o: Pe, d: function(n) {
    n && Y(e);
  } };
}
function Rne(t) {
  var e, n, r, i, o, s, a, l, c, u = [Ine, Nne], f = [];
  function d(h, p) {
    return h[11] === void 0 ? 0 : 1;
  }
  return i = d(t), o = f[i] = u[i](t), { c: function() {
    e = H("label"), n = H("input"), r = se(), o.c(), s = un(), k(n, "type", "text"), n.readOnly = !0, k(n, "tabindex", "-1"), k(n, "class", "jse-hidden-input svelte-vx4hzc"), k(e, "class", "jse-hidden-input-label");
  }, m: function(h, p) {
    X(h, e, p), T(e, n), t[79](n), X(h, r, p), f[i].m(h, p), X(h, s, p), a = !0, l || (c = Oe(n, "paste", t[35]), l = !0);
  }, p: function(h, p) {
    var m = i;
    (i = d(h)) === m ? f[i].p(h, p) : (Ae(), _(f[m], 1, 1, function() {
      f[m] = null;
    }), Me(), (o = f[i]) ? o.p(h, p) : (o = f[i] = u[i](h)).c(), S(o, 1), o.m(s.parentNode, s));
  }, i: function(h) {
    a || (S(o), a = !0);
  }, o: function(h) {
    _(o), a = !1;
  }, d: function(h) {
    h && (Y(e), Y(r), Y(s)), t[79](null), f[i].d(h), l = !1, c();
  } };
}
function Nne(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h;
  o = new vne({ props: { show: t[20], resultCount: ((e = t[18]) === null || e === void 0 || (e = e.items) === null || e === void 0 ? void 0 : e.length) || 0, activeIndex: ((n = t[18]) === null || n === void 0 ? void 0 : n.activeIndex) || 0, showReplace: t[21], searching: t[22], readOnly: t[0], onChange: t[27], onNext: t[28], onPrevious: t[29], onReplace: t[30], onReplaceAll: t[31], onClose: t[32] } }), l = new Dte({ props: { value: t[11], path: [], expandedMap: t[17].expandedMap, enforceStringMap: t[17].enforceStringMap, visibleSectionsMap: t[17].visibleSectionsMap, validationErrorsMap: t[25], searchResultItemsMap: (r = t[18]) === null || r === void 0 ? void 0 : r.itemsMap, selection: t[17].selection, context: t[13], onDragSelectionStart: nr } });
  var p = t[19] && h$(t), m = t[24] && p$(t);
  return d = new ky({ props: { validationErrors: t[12], selectError: t[33] } }), { c: function() {
    i = H("div"), xe(o.$$.fragment), s = se(), a = H("div"), xe(l.$$.fragment), c = se(), p && p.c(), u = se(), m && m.c(), f = se(), xe(d.$$.fragment), k(i, "class", "jse-search-box-container svelte-vx4hzc"), k(a, "class", "jse-contents svelte-vx4hzc"), k(a, "data-jsoneditor-scrollable-contents", !0);
  }, m: function(g, v) {
    X(g, i, v), ye(o, i, null), X(g, s, v), X(g, a, v), ye(l, a, null), t[83](a), X(g, c, v), p && p.m(g, v), X(g, u, v), m && m.m(g, v), X(g, f, v), ye(d, g, v), h = !0;
  }, p: function(g, v) {
    var y, w, x, b = {};
    1048576 & v[0] && (b.show = g[20]), 262144 & v[0] && (b.resultCount = ((y = g[18]) === null || y === void 0 || (y = y.items) === null || y === void 0 ? void 0 : y.length) || 0), 262144 & v[0] && (b.activeIndex = ((w = g[18]) === null || w === void 0 ? void 0 : w.activeIndex) || 0), 2097152 & v[0] && (b.showReplace = g[21]), 4194304 & v[0] && (b.searching = g[22]), 1 & v[0] && (b.readOnly = g[0]), o.$set(b);
    var j = {};
    2048 & v[0] && (j.value = g[11]), 131072 & v[0] && (j.expandedMap = g[17].expandedMap), 131072 & v[0] && (j.enforceStringMap = g[17].enforceStringMap), 131072 & v[0] && (j.visibleSectionsMap = g[17].visibleSectionsMap), 33554432 & v[0] && (j.validationErrorsMap = g[25]), 262144 & v[0] && (j.searchResultItemsMap = (x = g[18]) === null || x === void 0 ? void 0 : x.itemsMap), 131072 & v[0] && (j.selection = g[17].selection), 8192 & v[0] && (j.context = g[13]), l.$set(j), g[19] ? p ? (p.p(g, v), 524288 & v[0] && S(p, 1)) : ((p = h$(g)).c(), S(p, 1), p.m(u.parentNode, u)) : p && (Ae(), _(p, 1, 1, function() {
      p = null;
    }), Me()), g[24] ? m ? (m.p(g, v), 16777216 & v[0] && S(m, 1)) : ((m = p$(g)).c(), S(m, 1), m.m(f.parentNode, f)) : m && (Ae(), _(m, 1, 1, function() {
      m = null;
    }), Me());
    var $ = {};
    4096 & v[0] && ($.validationErrors = g[12]), d.$set($);
  }, i: function(g) {
    h || (S(o.$$.fragment, g), S(l.$$.fragment, g), S(p), S(m), S(d.$$.fragment, g), h = !0);
  }, o: function(g) {
    _(o.$$.fragment, g), _(l.$$.fragment, g), _(p), _(m), _(d.$$.fragment, g), h = !1;
  }, d: function(g) {
    g && (Y(i), Y(s), Y(a), Y(c), Y(u), Y(f)), be(o), be(l), t[83](null), p && p.d(g), m && m.d(g), be(d, g);
  } };
}
function Ine(t) {
  var e, n, r, i, o = [Lne, Dne], s = [];
  function a(l, c) {
    return l[16] === "" || l[16] === void 0 ? 0 : 1;
  }
  return e = a(t), n = s[e] = o[e](t), { c: function() {
    n.c(), r = un();
  }, m: function(l, c) {
    s[e].m(l, c), X(l, r, c), i = !0;
  }, p: function(l, c) {
    var u = e;
    (e = a(l)) === u ? s[e].p(l, c) : (Ae(), _(s[u], 1, 1, function() {
      s[u] = null;
    }), Me(), (n = s[e]) ? n.p(l, c) : (n = s[e] = o[e](l)).c(), S(n, 1), n.m(r.parentNode, r));
  }, i: function(l) {
    i || (S(n), i = !0);
  }, o: function(l) {
    _(n), i = !1;
  }, d: function(l) {
    l && Y(r), s[e].d(l);
  } };
}
function h$(t) {
  var e, n;
  return e = new vo({ props: { type: "info", message: "You pasted a JSON ".concat(Array.isArray(t[19].contents) ? "array" : "object", " as text"), actions: [{ icon: xp, text: "Paste as JSON instead", title: "Replace the value with the pasted JSON", onMouseDown: t[47] }, { text: "Leave as is", title: "Keep the JSON embedded in the value", onClick: t[48] }] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    524288 & i[0] && (o.message = "You pasted a JSON ".concat(Array.isArray(r[19].contents) ? "array" : "object", " as text")), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function p$(t) {
  var e, n;
  return e = new vo({ props: { type: "success", message: "The loaded JSON document was invalid but is successfully repaired.", actions: t[0] ? [] : [{ icon: Su, text: "Ok", title: "Accept the repaired document", onClick: t[8] }, { icon: ea, text: "Repair manually instead", title: "Leave the document unchanged and repair it manually instead", onClick: t[49] }], onClose: t[9] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i[0] && (o.actions = r[0] ? [] : [{ icon: Su, text: "Ok", title: "Accept the repaired document", onClick: r[8] }, { icon: ea, text: "Repair manually instead", title: "Leave the document unchanged and repair it manually instead", onClick: r[49] }]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Dne(t) {
  var e, n, r, i;
  return e = new vo({ props: { type: "error", message: "The loaded JSON document is invalid and could not be repaired automatically.", actions: t[0] ? [] : [{ icon: ea, text: "Repair manually", title: 'Open the document in "code" mode and repair it manually', onClick: t[49] }] } }), r = new W5({ props: { text: t[16], json: t[11], indentation: t[5], parser: t[3] } }), { c: function() {
    xe(e.$$.fragment), n = se(), xe(r.$$.fragment);
  }, m: function(o, s) {
    ye(e, o, s), X(o, n, s), ye(r, o, s), i = !0;
  }, p: function(o, s) {
    var a = {};
    1 & s[0] && (a.actions = o[0] ? [] : [{ icon: ea, text: "Repair manually", title: 'Open the document in "code" mode and repair it manually', onClick: o[49] }]), e.$set(a);
    var l = {};
    65536 & s[0] && (l.text = o[16]), 2048 & s[0] && (l.json = o[11]), 32 & s[0] && (l.indentation = o[5]), 8 & s[0] && (l.parser = o[3]), r.$set(l);
  }, i: function(o) {
    i || (S(e.$$.fragment, o), S(r.$$.fragment, o), i = !0);
  }, o: function(o) {
    _(e.$$.fragment, o), _(r.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && Y(n), be(e, o), be(r, o);
  } };
}
function Lne(t) {
  var e, n;
  return e = new Jte({ props: { readOnly: t[0], onCreateObject: t[80], onCreateArray: t[81], onClick: t[82] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i[0] && (o.readOnly = r[0]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Bne(t) {
  var e, n, r, i, o, s, a, l, c = t[1] && f$(t), u = t[2] && d$(t), f = [Rne, Pne], d = [];
  return i = function(h, p) {
    return h[26] ? 1 : 0;
  }(t), o = d[i] = f[i](t), { c: function() {
    e = H("div"), c && c.c(), n = se(), u && u.c(), r = se(), o.c(), k(e, "role", "tree"), k(e, "tabindex", "-1"), k(e, "class", "jse-tree-mode svelte-vx4hzc"), $e(e, "no-main-menu", !t[1]);
  }, m: function(h, p) {
    X(h, e, p), c && c.m(e, null), T(e, n), u && u.m(e, null), T(e, r), d[i].m(e, null), t[84](e), s = !0, a || (l = [Oe(_ne, "mousedown", t[51]), Oe(e, "keydown", t[43]), Oe(e, "mousedown", t[44]), Oe(e, "contextmenu", t[45])], a = !0);
  }, p: function(h, p) {
    h[1] ? c ? (c.p(h, p), 2 & p[0] && S(c, 1)) : ((c = f$(h)).c(), S(c, 1), c.m(e, n)) : c && (Ae(), _(c, 1, 1, function() {
      c = null;
    }), Me()), h[2] ? u ? (u.p(h, p), 4 & p[0] && S(u, 1)) : ((u = d$(h)).c(), S(u, 1), u.m(e, r)) : u && (Ae(), _(u, 1, 1, function() {
      u = null;
    }), Me()), o.p(h, p), (!s || 2 & p[0]) && $e(e, "no-main-menu", !h[1]);
  }, i: function(h) {
    s || (S(c), S(u), S(o), s = !0);
  }, o: function(h) {
    _(c), _(u), _(o), s = !1;
  }, d: function(h) {
    h && Y(e), c && c.d(), u && u.d(), d[i].d(), t[84](null), a = !1, An(l);
  } };
}
function qne(t, e, n) {
  var r, i = Tr("jsoneditor:TreeMode"), o = typeof window > "u";
  i("isSSR:", o);
  var s, a, l, c, u, f = _r("simple-modal").open, d = Kl(), h = Kl(), p = _r("absolute-popup"), m = p.openAbsolutePopup, g = p.closeAbsolutePopup, v = !1, y = M5(), w = e.readOnly, x = e.externalContent, b = e.externalSelection, j = e.mainMenuBar, $ = e.navigationBar, N = e.escapeControlCharacters, B = e.escapeUnicodeCharacters, O = e.parser, I = e.parseMemoizeOne, P = e.validator, J = e.validationParser, D = e.pathParser, Q = e.indentation, Z = e.onError, L = e.onChange, R = e.onChangeMode, V = e.onSelect, M = e.onRenderValue, C = e.onRenderMenu, F = e.onClassName, z = e.onFocus, E = e.onBlur, A = e.onSortModal, te = e.onTransformModal, ge = e.onJSONEditorModal, ke = !1;
  jy({ onMount: Fi, onDestroy: Ci, getWindow: function() {
    return $c(l);
  }, hasFocus: function() {
    return ke && document.hasFocus() || gy(l);
  }, onFocus: function() {
    v = !0, z && z();
  }, onBlur: function() {
    v = !1, E && E();
  } });
  var Ce = void 0;
  function we(W) {
    i("updateSelection", W);
    var ue = typeof W == "function" ? W(oe.selection) || null : W;
    tn(ue, oe.selection) || (n(17, oe = fe(fe({}, oe), {}, { selection: ue })), V(ue));
  }
  var le, rt, Be, nt = !1, oe = Vh(), We = !1, Rt = !1, de = !1, Se = "";
  function rn(W) {
    return Dt.apply(this, arguments);
  }
  function Dt() {
    return Dt = Tt(Ie().mark(function W(ue) {
      return Ie().wrap(function(Ee) {
        for (; ; )
          switch (Ee.prev = Ee.next) {
            case 0:
              return i("search text updated", ue), n(77, Se = ue), Ee.next = 4, lr();
            case 4:
              return Ee.next = 6, q();
            case 6:
            case "end":
              return Ee.stop();
          }
      }, W);
    })), Dt.apply(this, arguments);
  }
  function Xt() {
    return (Xt = Tt(Ie().mark(function W() {
      return Ie().wrap(function(ue) {
        for (; ; )
          switch (ue.prev = ue.next) {
            case 0:
              return n(18, le = le ? WY(le) : void 0), ue.next = 3, q();
            case 3:
            case "end":
              return ue.stop();
          }
      }, W);
    }))).apply(this, arguments);
  }
  function Ue() {
    return (Ue = Tt(Ie().mark(function W() {
      return Ie().wrap(function(ue) {
        for (; ; )
          switch (ue.prev = ue.next) {
            case 0:
              return n(18, le = le ? JY(le) : void 0), ue.next = 3, q();
            case 3:
            case "end":
              return ue.stop();
          }
      }, W);
    }))).apply(this, arguments);
  }
  function kn() {
    return (kn = Tt(Ie().mark(function W(ue, Ee) {
      var Re, De, He, st, gt;
      return Ie().wrap(function(wt) {
        for (; ; )
          switch (wt.prev = wt.next) {
            case 0:
              if (De = (Re = le) === null || Re === void 0 ? void 0 : Re.activeItem, i("handleReplace", { replacementText: Ee, activeItem: De }), De && c !== void 0) {
                wt.next = 4;
                break;
              }
              return wt.abrupt("return");
            case 4:
              return He = KY(c, oe, Ee, De, O), st = He.operations, gt = He.newSelection, kt(st, function(In, zn) {
                return { state: fe(fe({}, zn), {}, { selection: gt }) };
              }), wt.next = 8, lr();
            case 8:
              return wt.next = 10, q();
            case 10:
            case "end":
              return wt.stop();
          }
      }, W);
    }))).apply(this, arguments);
  }
  function fn() {
    return fn = Tt(Ie().mark(function W(ue, Ee) {
      var Re, De, He;
      return Ie().wrap(function(st) {
        for (; ; )
          switch (st.prev = st.next) {
            case 0:
              return i("handleReplaceAll", { text: ue, replacementText: Ee }), Re = GY(c, oe, ue, Ee, O), De = Re.operations, He = Re.newSelection, kt(De, function(gt, wt) {
                return { state: fe(fe({}, wt), {}, { selection: He }) };
              }), st.next = 5, lr();
            case 5:
              return st.next = 7, q();
            case 7:
            case "end":
              return st.stop();
          }
      }, W);
    })), fn.apply(this, arguments);
  }
  function q() {
    return ee.apply(this, arguments);
  }
  function ee() {
    return (ee = Tt(Ie().mark(function W() {
      var ue, Ee, Re;
      return Ie().wrap(function(De) {
        for (; ; )
          switch (De.prev = De.next) {
            case 0:
              if (Ee = (ue = le) === null || ue === void 0 ? void 0 : ue.activeItem, i("focusActiveSearchResult", le), !Ee || c === void 0) {
                De.next = 9;
                break;
              }
              return Re = Ee.path, n(17, oe = fe(fe({}, Fv(c, oe, Re)), {}, { selection: null })), De.next = 7, lr();
            case 7:
              return De.next = 9, Ve(Re);
            case 9:
            case "end":
              return De.stop();
          }
      }, W);
    }))).apply(this, arguments);
  }
  var ne = _5({ onChange: function(W) {
    n(23, he = W);
  } }), he = ne.getState(), je, _e, yt = hD(function(W, ue) {
    if (W === "")
      return i("clearing search result"), void (le !== void 0 && n(18, le = void 0));
    n(22, de = !0), setTimeout(function() {
      i("searching...", W);
      var Ee = y5(W, ue, B6);
      n(18, le = function(Re, De, He) {
        var st = He != null && He.activeItem ? Xw(He.activeItem) : void 0, gt = De.findIndex(function(Pn) {
          return tn(st, Xw(Pn));
        }), wt = gt !== -1 ? gt : (He == null ? void 0 : He.activeIndex) !== void 0 && (He == null ? void 0 : He.activeIndex) < De.length ? He == null ? void 0 : He.activeIndex : De.length > 0 ? 0 : -1, In = De.map(function(Pn, Fr) {
          return fe(fe({}, Pn), {}, { active: Fr === wt });
        }), zn = In[wt];
        return { items: In, itemsMap: vp(In, function(Pn) {
          return Je(Pn.path);
        }), activeItem: zn, activeIndex: wt };
      }(0, Ee, le)), n(22, de = !1);
    });
  }, 300), Xe = !1, Zt = [], on = nf(T5);
  function Jt(W, ue, Ee, Re) {
    Al(function() {
      var De;
      try {
        De = on(W, ue, Ee, Re);
      } catch (He) {
        De = [{ path: [], message: "Failed to validate: " + He.message, severity: gs.warning }];
      }
      tn(De, Zt) || (i("validationErrors changed:", De), n(12, Zt = De));
    }, function(De) {
      return i("validationErrors updated in ".concat(De, " ms"));
    });
  }
  function Ge() {
    return i("validate"), Ce ? { parseError: Ce, isRepairable: !1 } : (Jt(c, P, O, J), nn(Zt) ? null : { validationErrors: Zt });
  }
  function xn() {
    return c;
  }
  function Dn() {
    return oe;
  }
  function wn(W) {
    W.json !== void 0 && function(ue) {
      if (ue !== void 0) {
        var Ee = !tn(c, ue);
        if (i("update external json", { isChanged: Ee, currentlyText: c === void 0 }), !!Ee) {
          var Re = { json: c, text: u }, De = oe, He = c, st = u, gt = Xe;
          n(11, c = ue), $n(c), n(16, u = void 0), n(24, Xe = !1), Ce = void 0, Rn(c), Jn({ previousJson: He, previousState: De, previousText: st, previousTextIsRepaired: gt }), $t(Re, null);
        }
      }
    }(W.json), W.text !== void 0 && function(ue) {
      if (!(ue === void 0 || x.json !== void 0)) {
        var Ee = ue !== u;
        if (i("update external text", { isChanged: Ee }), !!Ee) {
          var Re = { json: c, text: u }, De = c, He = oe, st = u, gt = Xe;
          try {
            n(11, c = I(ue)), $n(c), n(16, u = ue), n(24, Xe = !1), Ce = void 0;
          } catch (wt) {
            try {
              n(11, c = I(Lo(ue))), $n(c), n(16, u = ue), n(24, Xe = !0), Ce = void 0, Rn(c);
            } catch {
              n(11, c = void 0), n(16, u = x.text), n(24, Xe = !1), Ce = u !== void 0 && u !== "" ? ic(u, wt.message || String(wt)) : void 0;
            }
          }
          Rn(c), Jn({ previousJson: De, previousState: He, previousText: st, previousTextIsRepaired: gt }), $t(Re, null);
        }
      }
    }(W.text);
  }
  function $n(W) {
    nt || (nt = !0, n(17, oe = Ai(W, oe, [], function(ue) {
      return W6({ json: ue }, q6) ? To : du;
    }(W))));
  }
  function Rn(W) {
    oe.selection && (Ri(W, Na(oe.selection)) && Ri(W, mt(oe.selection)) || (i("clearing selection: path does not exist anymore", oe.selection), n(17, oe = fe(fe({}, oe), {}, { selection: pl(W, oe) }))));
  }
  function Jn(W) {
    var ue = W.previousJson, Ee = W.previousState, Re = W.previousText, De = W.previousTextIsRepaired;
    ue === void 0 && Re === void 0 || (c !== void 0 ? ue !== void 0 ? ne.add({ undo: { patch: [{ op: "replace", path: "", value: ue }], state: Hr(Ee), json: void 0, text: Re, textIsRepaired: De }, redo: { patch: [{ op: "replace", path: "", value: c }], state: Hr(oe), json: void 0, text: u, textIsRepaired: Xe } }) : ne.add({ undo: { patch: void 0, json: void 0, text: Re, state: Hr(Ee), textIsRepaired: De }, redo: { patch: void 0, json: c, state: Hr(oe), text: u, textIsRepaired: Xe } }) : ue !== void 0 && ne.add({ undo: { patch: void 0, json: ue, state: Hr(Ee), text: Re, textIsRepaired: De }, redo: { patch: void 0, json: void 0, text: u, textIsRepaired: Xe, state: Hr(oe) } }));
  }
  function pn(W, ue) {
    if (i("patch", W, ue), c === void 0)
      throw new Error("Cannot apply patch: no JSON");
    var Ee = { json: c, text: u }, Re = c, De = oe, He = u, st = Xe, gt = v5(c, W), wt = s5(c, oe, W), In = ac(c, W), zn = function(Ln, mi) {
      return mi || !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2] ? fe(fe({}, Ln), {}, { selection: mi }) : Ln;
    }(wt.documentState, In, !1);
    i("patch updatedSelection", In);
    var Pn = typeof ue == "function" ? ue(wt.json, zn) : void 0;
    n(11, c = Pn && Pn.json !== void 0 ? Pn.json : wt.json);
    var Fr = Pn && Pn.state !== void 0 ? Pn.state : zn;
    n(17, oe = Fr), n(16, u = void 0), n(24, Xe = !1), n(19, Be = void 0), Ce = void 0, Rn(c), ne.add({ undo: { patch: gt, json: void 0, text: He, state: Hr(De), textIsRepaired: st }, redo: { patch: W, json: void 0, state: Hr(Fr), text: u, textIsRepaired: Xe } });
    var yr = { json: c, previousJson: Re, undo: gt, redo: W };
    return $t(Ee, yr), yr;
  }
  function me() {
    !w && oe.selection && we(Li(mt(oe.selection), !0));
  }
  function Ke() {
    if (!w && oe.selection) {
      var W = mt(oe.selection), ue = it(c, W);
      Xn(ue) ? function(Ee, Re) {
        i("openJSONEditorModal", { path: Ee, value: Re }), ke = !0, ge({ content: { json: Re }, path: Ee, onPatch: _e.onPatch, onClose: function() {
          ke = !1, Nn();
        } });
      }(W, ue) : we(Wt(W, !0));
    }
  }
  function It() {
    if (!w && an(oe.selection)) {
      var W = mt(oe.selection), ue = Je(W), Ee = it(c, W), Re = !bs(Ee, oe.enforceStringMap, ue, O), De = Re ? String(Ee) : kc(String(Ee), O);
      i("handleToggleEnforceString", { enforceString: Re, value: Ee, updatedValue: De }), kt([{ op: "replace", path: ue, value: De }], function(He, st) {
        return { state: o5(st, ue, Re) };
      });
    }
  }
  function Nt() {
    return ce.apply(this, arguments);
  }
  function ce() {
    return ce = Tt(Ie().mark(function W() {
      var ue, Ee = arguments;
      return Ie().wrap(function(Re) {
        for (; ; )
          switch (Re.prev = Re.next) {
            case 0:
              return ue = !(Ee.length > 0 && Ee[0] !== void 0) || Ee[0], Re.next = 3, z5({ json: c, documentState: oe, indentation: ue ? Q : void 0, readOnly: w, parser: O, onPatch: kt });
            case 3:
            case "end":
              return Re.stop();
          }
      }, W);
    })), ce.apply(this, arguments);
  }
  function qe() {
    return Fe.apply(this, arguments);
  }
  function Fe() {
    return Fe = Tt(Ie().mark(function W() {
      var ue, Ee = arguments;
      return Ie().wrap(function(Re) {
        for (; ; )
          switch (Re.prev = Re.next) {
            case 0:
              if (ue = !(Ee.length > 0 && Ee[0] !== void 0) || Ee[0], c !== void 0) {
                Re.next = 3;
                break;
              }
              return Re.abrupt("return");
            case 3:
              return Re.next = 5, F5({ json: c, documentState: oe, indentation: ue ? Q : void 0, parser: O });
            case 5:
            case "end":
              return Re.stop();
          }
      }, W);
    })), Fe.apply(this, arguments);
  }
  function Lt() {
    f(P5, {}, fe(fe({}, Qa), {}, { styleWindow: { width: "450px" } }), { onClose: function() {
      return Nn();
    } });
  }
  function qt(W, ue) {
    f(N5, { text: W, onParse: function(Ee) {
      return Hp(Ee, function(Re) {
        return gf(Re, O);
      });
    }, onRepair: H6, onApply: ue }, fe(fe({}, Qa), {}, { styleWindow: { width: "600px", height: "500px" }, styleContent: { padding: 0, height: "100%" } }), { onClose: function() {
      return Nn();
    } });
  }
  function U() {
    H5({ json: c, text: u, documentState: oe, keepSelection: !1, readOnly: w, onChange: L, onPatch: kt });
  }
  function G() {
    !w && c !== void 0 && oe.selection && Sc(oe.selection) && !nn(mt(oe.selection)) && (i("duplicate", { selection: oe.selection }), kt(p5(c, Gs(c, oe.selection))));
  }
  function re() {
    if (!w && oe.selection && (Sn(oe.selection) || an(oe.selection)) && !nn(mt(oe.selection))) {
      i("extract", { selection: oe.selection });
      var W = function(ue, Ee) {
        if (an(Ee))
          return [{ op: "move", from: Je(Ee.path), path: "" }];
        if (!Sn(Ee))
          throw new Error("Cannot create extract operations: parent must be an Object or Array");
        var Re = en(Ee.focusPath), De = it(ue, Re);
        if (Tn(De))
          return [{ op: "replace", path: "", value: Gs(ue, Ee).map(function(st) {
            var gt = zr(Yt(st));
            return De[gt];
          }) }];
        if (er(De)) {
          var He = {};
          return Gs(ue, Ee).forEach(function(st) {
            var gt = String(Yt(st));
            He[gt] = De[gt];
          }), [{ op: "replace", path: "", value: He }];
        }
        throw new Error("Cannot extract: unsupported type of selection " + JSON.stringify(Ee));
      }(c, oe.selection);
      kt(W, function(ue, Ee) {
        if (Xn(ue))
          return { state: Is(ue, Ee, []) };
      });
    }
  }
  function ae(W) {
    c !== void 0 && Yh({ insertType: W, selectInside: !0, refJsonEditor: l, json: c, selection: oe.selection, readOnly: w, parser: O, onPatch: kt, onReplaceJson: sn });
  }
  function ve(W) {
    dr(oe.selection) && we(Wt(oe.selection.path, !1)), oe.selection || we(pl(c, oe)), ae(W);
  }
  function pt(W) {
    if (!w && oe.selection)
      if (Ud(oe.selection))
        try {
          var ue = Na(oe.selection), Ee = it(c, ue), Re = function(He, st, gt) {
            if (st === "array") {
              if (Array.isArray(He))
                return He;
              if (Wn(He))
                return $w(He);
              if (typeof He == "string")
                try {
                  var wt = gt.parse(He);
                  if (Array.isArray(wt))
                    return wt;
                  if (Wn(wt))
                    return $w(wt);
                } catch {
                  return [He];
                }
              return [He];
            }
            if (st === "object") {
              if (Array.isArray(He))
                return kw(He);
              if (Wn(He))
                return He;
              if (typeof He == "string")
                try {
                  var In = gt.parse(He);
                  if (Wn(In))
                    return In;
                  if (Array.isArray(In))
                    return kw(In);
                } catch {
                  return { value: He };
                }
              return { value: He };
            }
            if (st === "value")
              return Xn(He) ? gt.stringify(He) : He;
            throw new Error("Cannot convert ".concat(fy(He, gt), " to ").concat(st));
          }(Ee, W, O);
          if (Re === Ee)
            return;
          var De = [{ op: "replace", path: Je(ue), value: Re }];
          i("handleConvert", { selection: oe.selection, path: ue, type: W, operations: De }), kt(De, function(He, st) {
            return { state: oe.selection ? Is(He, st, mt(oe.selection)) : oe };
          });
        } catch (He) {
          Z(He);
        }
      else
        Z(new Error("Cannot convert current selection to ".concat(W)));
  }
  function xt() {
    if (oe.selection) {
      var W = Hw(c, oe, !1), ue = en(mt(oe.selection));
      W && !nn(mt(W)) && tn(ue, en(mt(W))) ? we(cs(mt(W))) : we(xs(ue)), i("insert before", { selection: oe.selection, selectionBefore: W, parentPath: ue }), lr().then(Oi);
    }
  }
  function Vt() {
    if (oe.selection) {
      var W = Qs(c, oe.selection);
      i("insert after", W), we(cs(W)), lr().then(Oi);
    }
  }
  function vn(W) {
    return Mn.apply(this, arguments);
  }
  function Mn() {
    return (Mn = Tt(Ie().mark(function W(ue) {
      return Ie().wrap(function(Ee) {
        for (; ; )
          switch (Ee.prev = Ee.next) {
            case 0:
              return Ee.next = 2, U5({ char: ue, selectInside: !0, refJsonEditor: l, json: c, selection: oe.selection, readOnly: w, parser: O, onPatch: kt, onReplaceJson: sn, onSelect: we });
            case 2:
            case "end":
              return Ee.stop();
          }
      }, W);
    }))).apply(this, arguments);
  }
  function Ht() {
    if (!w && ne.getState().canUndo) {
      var W = ne.undo();
      if (W) {
        var ue = { json: c, text: u };
        n(11, c = W.undo.patch ? so(c, W.undo.patch) : W.undo.json), n(17, oe = W.undo.state), n(16, u = W.undo.text), n(24, Xe = W.undo.textIsRepaired), Ce = void 0, i("undo", { item: W, json: c, documentState: oe }), $t(ue, { json: c, previousJson: ue.json, redo: W.undo.patch, undo: W.redo.patch }), Nn(), oe.selection && Ve(mt(oe.selection), !1);
      }
    }
  }
  function mn() {
    if (!w && ne.getState().canRedo) {
      var W = ne.redo();
      if (W) {
        var ue = { json: c, text: u };
        n(11, c = W.redo.patch ? so(c, W.redo.patch) : W.redo.json), n(17, oe = W.redo.state), n(16, u = W.redo.text), n(24, Xe = W.redo.textIsRepaired), Ce = void 0, i("redo", { item: W, json: c, documentState: oe }), $t(ue, { json: c, previousJson: ue.json, redo: W.redo.patch, undo: W.undo.patch }), Nn(), oe.selection && Ve(mt(oe.selection), !1);
      }
    }
  }
  function K(W) {
    var ue;
    w || c === void 0 || (ke = !0, A({ id: d, json: c, rootPath: W, onSort: (ue = Tt(Ie().mark(function Ee(Re) {
      var De;
      return Ie().wrap(function(He) {
        for (; ; )
          switch (He.prev = He.next) {
            case 0:
              De = Re.operations, i("onSort", W, De), kt(De, function(st, gt) {
                return { state: fe(fe({}, Is(st, gt, W)), {}, { selection: Wt(W, !1) }) };
              });
            case 3:
            case "end":
              return He.stop();
          }
      }, Ee);
    })), function(Ee) {
      return ue.apply(this, arguments);
    }), onClose: function() {
      ke = !1, Nn();
    } }));
  }
  function pe() {
    oe.selection && K(Ww(c, oe.selection));
  }
  function Ne(W) {
    if (c !== void 0) {
      var ue = W.id, Ee = W.onTransform, Re = W.onClose, De = W.rootPath || [];
      ke = !0, te({ id: ue || h, json: c, rootPath: De, onTransform: function(He) {
        Ee ? Ee({ operations: He, json: c, transformedJson: so(c, He) }) : (i("onTransform", De, He), kt(He, function(st, gt) {
          return { state: fe(fe({}, Is(st, gt, De)), {}, { selection: Wt(De, !1) }) };
        }));
      }, onClose: function() {
        ke = !1, Nn(), Re && Re();
      } });
    }
  }
  function ze() {
    oe.selection && Ne({ rootPath: Ww(c, oe.selection) });
  }
  function Ve(W) {
    return Ct.apply(this, arguments);
  }
  function Ct() {
    return Ct = Tt(Ie().mark(function W(ue) {
      var Ee, Re, De, He, st, gt = arguments;
      return Ie().wrap(function(wt) {
        for (; ; )
          switch (wt.prev = wt.next) {
            case 0:
              return Ee = !(gt.length > 1 && gt[1] !== void 0) || gt[1], n(17, oe = Fv(c, oe, ue)), wt.next = 4, lr();
            case 4:
              if (Re = _t(ue), i("scrollTo", { path: ue, elem: Re, refContents: s }), Re && s) {
                wt.next = 8;
                break;
              }
              return wt.abrupt("return", Promise.resolve());
            case 8:
              if (De = s.getBoundingClientRect(), He = Re.getBoundingClientRect(), Ee) {
                wt.next = 13;
                break;
              }
              if (!(He.bottom > De.top && He.top < De.bottom)) {
                wt.next = 13;
                break;
              }
              return wt.abrupt("return", Promise.resolve());
            case 13:
              return st = -De.height / 4, wt.abrupt("return", new Promise(function(In) {
                y(Re, { container: s, offset: st, duration: 300, callback: function() {
                  return In();
                } });
              }));
            case 15:
            case "end":
              return wt.stop();
          }
      }, W);
    })), Ct.apply(this, arguments);
  }
  function _t(W) {
    return s ? s.querySelector('div[data-path="'.concat(sc(W), '"]')) : null;
  }
  function ut(W) {
    var ue = _t(W);
    if (ue && s) {
      var Ee = s.getBoundingClientRect(), Re = ue.getBoundingClientRect(), De = Xn(it(c, W)) ? 20 : Re.height;
      Re.top < Ee.top + 20 ? y(ue, { container: s, offset: -20, duration: 0 }) : Re.top + De > Ee.bottom - 20 && y(ue, { container: s, offset: -(Ee.height - De - 20), duration: 0 });
    }
  }
  function $t(W, ue) {
    (W.json !== void 0 || (W == null ? void 0 : W.text) !== void 0) && (u !== void 0 ? L({ text: u, json: void 0 }, W, { contentErrors: Ge(), patchResult: ue }) : c !== void 0 && L({ text: void 0, json: c }, W, { contentErrors: Ge(), patchResult: ue }));
  }
  function kt(W, ue) {
    if (!w)
      return i("handlePatch", W, ue), pn(W, ue);
  }
  function sn(W, ue) {
    var Ee = oe, Re = c, De = u, He = { json: c, text: u }, st = Xe, gt = Ai(c, oe, [], To), wt = typeof ue == "function" ? ue(W, gt) : void 0;
    n(11, c = wt && wt.json !== void 0 ? wt.json : W), n(17, oe = wt && wt.state !== void 0 ? wt.state : gt), n(16, u = void 0), n(24, Xe = !1), Ce = void 0, Rn(c), Jn({ previousJson: Re, previousState: Ee, previousText: De, previousTextIsRepaired: st }), $t(He, null);
  }
  function yn(W, ue) {
    i("handleChangeText");
    var Ee = oe, Re = c, De = u, He = { json: c, text: u }, st = Xe;
    try {
      n(11, c = I(W)), n(17, oe = Ai(c, oe, [], To)), n(16, u = void 0), n(24, Xe = !1), Ce = void 0;
    } catch (wt) {
      try {
        n(11, c = I(Lo(W))), n(17, oe = Ai(c, oe, [], To)), n(16, u = W), n(24, Xe = !0), Ce = void 0;
      } catch {
        n(11, c = void 0), n(17, oe = Vh({ json: c, expand: To })), n(16, u = W), n(24, Xe = !1), Ce = u !== "" ? ic(u, wt.message || String(wt)) : void 0;
      }
    }
    if (typeof ue == "function") {
      var gt = ue(c, oe);
      n(11, c = gt && gt.json ? gt.json : c), n(17, oe = gt && gt.state ? gt.state : oe);
    }
    Rn(c), Jn({ previousJson: Re, previousState: Ee, previousText: De, previousTextIsRepaired: st }), $t(He, null);
  }
  function qn(W, ue) {
    var Ee = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
    i("expand", { path: W, expanded: ue, recursive: Ee }), n(17, oe = ue ? Ee ? Ai(c, oe, W, du) : function(Re, De) {
      return fe(fe({}, Re), {}, { expandedMap: fe(fe({}, Re.expandedMap), {}, Si({}, Je(De), !0)) });
    }(oe, W) : zw(oe, W)), oe.selection && !ue && function(Re, De) {
      return aa(mt(Re), De) && (mt(Re).length > De.length || vr(Re));
    }(oe.selection, W) && we(null), Nn();
  }
  function Or(W) {
    i("openFind", { findAndReplace: W }), n(20, We = !1), n(21, Rt = !1), lr().then(function() {
      n(20, We = !0), n(21, Rt = W);
    });
  }
  function yo(W, ue) {
    i("handleExpandSection", W, ue);
    var Ee = Je(W);
    n(17, oe = function(Re, De, He, st) {
      return fe(fe({}, De), {}, { visibleSectionsMap: fe(fe({}, De.visibleSectionsMap), {}, Si({}, He, i5(Up(De, He).concat(st)))) });
    }(0, oe, Ee, ue));
  }
  function pa(W) {
    i("pasted json as text", W), n(19, Be = W);
  }
  function pi(W) {
    var ue = W.anchor, Ee = W.left, Re = W.top, De = W.width, He = W.height, st = W.offsetTop, gt = W.offsetLeft, wt = W.showTip;
    ke = !0;
    var In = m(Hee, { json: c, documentState: oe, parser: O, showTip: wt, onEditKey: me, onEditValue: Ke, onToggleEnforceString: It, onCut: Nt, onCopy: qe, onPaste: Lt, onRemove: U, onDuplicate: G, onExtract: re, onInsertBefore: xt, onInsert: ve, onConvert: pt, onInsertAfter: Vt, onSort: pe, onTransform: ze, onCloseContextMenu: function() {
      g(In), Nn();
    } }, { left: Ee, top: Re, offsetTop: st, offsetLeft: gt, width: De, height: He, anchor: ue, closeOnOuterClick: !0, onClose: function() {
      ke = !1, Nn();
    } });
  }
  function Oi(W) {
    if (!w && !Hi(oe.selection)) {
      if (W && (W.stopPropagation(), W.preventDefault()), W && W.type === "contextmenu" && W.target !== a)
        pi({ left: W.clientX, top: W.clientY, width: is, height: rs, showTip: !1 });
      else {
        var ue, Ee = (ue = s) === null || ue === void 0 ? void 0 : ue.querySelector(".jse-context-menu-pointer.jse-selected");
        if (Ee)
          pi({ anchor: Ee, offsetTop: 2, width: is, height: rs, showTip: !1 });
        else {
          var Re, De = (Re = s) === null || Re === void 0 ? void 0 : Re.getBoundingClientRect();
          De && pi({ top: De.top + 2, left: De.left + 2, width: is, height: rs, showTip: !1 });
        }
      }
      return !1;
    }
  }
  function Ji() {
    return (Ji = Tt(Ie().mark(function W() {
      var ue, Ee, Re, De, He;
      return Ie().wrap(function(st) {
        for (; ; )
          switch (st.prev = st.next) {
            case 0:
              if (i("apply pasted json", Be), Be) {
                st.next = 3;
                break;
              }
              return st.abrupt("return");
            case 3:
              Re = (Ee = Be).path, De = Ee.contents, n(19, Be = void 0), t5(He = ((ue = s) === null || ue === void 0 ? void 0 : ue.querySelector(".jse-editable-div")) || null) && He.cancel(), kt([{ op: "replace", path: Je(Re), value: De }], function(gt, wt) {
                return { state: Is(gt, wt, Re) };
              }), setTimeout(Nn);
            case 10:
            case "end":
              return st.stop();
          }
      }, W);
    }))).apply(this, arguments);
  }
  function Nn() {
    i("focus"), a && (a.focus(), a.select());
  }
  function ma(W) {
    return function(ue, Ee, Re) {
      var De = en(Re), He = [Yt(Re)], st = it(ue, De), gt = st ? eg(st, Ee, He) : void 0;
      return gt ? Wt(De.concat(gt), !1) : cs(Re);
    }(c, oe, W);
  }
  function oi(W) {
    r && r.onDrag(W);
  }
  function bo() {
    r && r.onDragEnd();
  }
  return t.$$set = function(W) {
    "readOnly" in W && n(0, w = W.readOnly), "externalContent" in W && n(52, x = W.externalContent), "externalSelection" in W && n(53, b = W.externalSelection), "mainMenuBar" in W && n(1, j = W.mainMenuBar), "navigationBar" in W && n(2, $ = W.navigationBar), "escapeControlCharacters" in W && n(54, N = W.escapeControlCharacters), "escapeUnicodeCharacters" in W && n(55, B = W.escapeUnicodeCharacters), "parser" in W && n(3, O = W.parser), "parseMemoizeOne" in W && n(56, I = W.parseMemoizeOne), "validator" in W && n(57, P = W.validator), "validationParser" in W && n(58, J = W.validationParser), "pathParser" in W && n(4, D = W.pathParser), "indentation" in W && n(5, Q = W.indentation), "onError" in W && n(6, Z = W.onError), "onChange" in W && n(59, L = W.onChange), "onChangeMode" in W && n(60, R = W.onChangeMode), "onSelect" in W && n(61, V = W.onSelect), "onRenderValue" in W && n(62, M = W.onRenderValue), "onRenderMenu" in W && n(7, C = W.onRenderMenu), "onClassName" in W && n(63, F = W.onClassName), "onFocus" in W && n(64, z = W.onFocus), "onBlur" in W && n(65, E = W.onBlur), "onSortModal" in W && n(66, A = W.onSortModal), "onTransformModal" in W && n(67, te = W.onTransformModal), "onJSONEditorModal" in W && n(68, ge = W.onJSONEditorModal);
  }, t.$$.update = function() {
    25165824 & t.$$.dirty[1] && n(76, rt = hy({ escapeControlCharacters: N, escapeUnicodeCharacters: B })), 2097152 & t.$$.dirty[1] && wn(x), 4194304 & t.$$.dirty[1] && function(W) {
      if (!tn(oe.selection, W)) {
        if (i("applyExternalSelection", W), Vv(W))
          return;
        we(W);
      }
    }(b), 2048 & t.$$.dirty[0] | 32768 & t.$$.dirty[2] && yt(Se, c), 2056 & t.$$.dirty[0] | 201326592 & t.$$.dirty[1] && Jt(c, P, O, J), 4096 & t.$$.dirty[0] && n(25, je = function(W) {
      var ue = {};
      return W.forEach(function(Ee) {
        ue[Je(Ee.path)] = Ee;
      }), W.forEach(function(Ee) {
        for (var Re = Ee.path; Re.length > 0; ) {
          Re = en(Re);
          var De = Je(Re);
          De in ue || (ue[De] = { isChildError: !0, path: Re, message: "Contains invalid data", severity: gs.warning });
        }
      }), ue;
    }(Zt)), 1024 & t.$$.dirty[0] && (r = s ? function(W) {
      var ue, Ee;
      function Re(gt) {
        return gt < 20 ? _Q : gt < 50 ? TQ : PQ;
      }
      function De() {
        if (W) {
          var gt = (ue || 0) * (ww / 1e3);
          W.scrollTop += gt;
        }
      }
      function He(gt) {
        Ee && gt === ue || (st(), ng("startAutoScroll", gt), ue = gt, Ee = setInterval(De, ww));
      }
      function st() {
        Ee && (ng("stopAutoScroll"), clearInterval(Ee), Ee = void 0, ue = void 0);
      }
      return ng("createAutoScrollHandler", W), { onDrag: function(gt) {
        if (W) {
          var wt = gt.clientY, In = W.getBoundingClientRect(), zn = In.top, Pn = In.bottom;
          wt < zn ? He(-Re(zn - wt)) : wt > Pn ? He(Re(wt - Pn)) : st();
        }
      }, onDragEnd: function() {
        st();
      } };
    }(s) : void 0), 9 & t.$$.dirty[0] | 16387 & t.$$.dirty[2] && n(13, _e = { readOnly: w, parser: O, normalization: rt, getJson: xn, getDocumentState: Dn, findElement: _t, findNextInside: ma, focus: Nn, onPatch: kt, onInsert: ae, onExpand: qn, onSelect: we, onFind: Or, onExpandSection: yo, onPasteJson: pa, onRenderValue: M, onContextMenu: pi, onClassName: F || function() {
    }, onDrag: oi, onDragEnd: bo }), 8192 & t.$$.dirty[0] && i("context changed", _e);
  }, [w, j, $, O, D, Q, Z, C, function() {
    return Xe && c !== void 0 && sn(c), c !== void 0 ? { json: c } : { text: u || "" };
  }, Nn, s, c, Zt, _e, a, l, u, oe, le, Be, We, Rt, de, he, Xe, je, o, rn, function() {
    return Xt.apply(this, arguments);
  }, function() {
    return Ue.apply(this, arguments);
  }, function(W, ue) {
    return kn.apply(this, arguments);
  }, function(W, ue) {
    return fn.apply(this, arguments);
  }, function() {
    n(20, We = !1), n(21, Rt = !1), rn(""), Nn();
  }, function(W) {
    i("select validation error", W), we(Wt(W.path, !1)), Ve(W.path);
  }, qe, function(W) {
    W.preventDefault(), V5({ clipboardText: W.clipboardData.getData("text/plain"), json: c, selection: oe.selection, readOnly: w, parser: O, onPatch: kt, onChangeText: yn, openRepairModal: qt });
  }, vn, Ht, mn, function() {
    K([]);
  }, function() {
    Ne({ rootPath: [] });
  }, function() {
    qn([], !0, !0);
  }, function() {
    qn([], !1, !0);
  }, function(W) {
    var ue = da(W), Ee = W.shiftKey;
    if (i("keydown", { combo: ue, key: W.key }), ue === "Ctrl+X" && (W.preventDefault(), Nt(!0)), ue === "Ctrl+Shift+X" && (W.preventDefault(), Nt(!1)), ue === "Ctrl+C" && (W.preventDefault(), qe(!0)), ue === "Ctrl+Shift+C" && (W.preventDefault(), qe(!1)), ue === "Ctrl+D" && (W.preventDefault(), G()), ue !== "Delete" && ue !== "Backspace" || (W.preventDefault(), U()), ue === "Insert" && (W.preventDefault(), ae("structure")), ue === "Ctrl+A" && (W.preventDefault(), we(Wt([], !1))), ue === "Ctrl+Q" && Oi(W), ue === "ArrowUp" || ue === "Shift+ArrowUp") {
      W.preventDefault();
      var Re = oe.selection ? Hw(c, oe, Ee) || oe.selection : pl(c, oe);
      we(Re), ut(mt(Re));
    }
    if (ue === "ArrowDown" || ue === "Shift+ArrowDown") {
      W.preventDefault();
      var De = oe.selection ? function(zn, Pn) {
        var Fr = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], yr = Pn.selection;
        if (!yr)
          return null;
        var Ln = Fr ? mt(yr) : Qs(zn, yr), mi = Xn(it(zn, Ln)) ? zw(Pn, Ln) : Pn, tr = eg(zn, Pn, Ln), pr = eg(zn, mi, Ln);
        if (Fr)
          return vr(yr) ? tr !== null ? Wr(tr, tr) : null : ji(yr) ? pr !== null ? Wr(pr, pr) : null : pr !== null ? Wr(Na(yr), pr) : null;
        if (ji(yr))
          return pr !== null ? Wt(pr, !1) : null;
        if (vr(yr) || an(yr))
          return tr !== null ? Wt(tr, !1) : null;
        if (dr(yr)) {
          if (tr === null || tr.length === 0)
            return null;
          var Oc = en(tr), Cs = it(zn, Oc);
          return Array.isArray(Cs) ? Wt(tr, !1) : Li(tr, !1);
        }
        return Sn(yr) ? pr !== null ? Wt(pr, !1) : tr !== null ? Wt(tr, !1) : null : null;
      }(c, oe, Ee) || oe.selection : pl(c, oe);
      we(De), ut(mt(De));
    }
    if (ue === "ArrowLeft" || ue === "Shift+ArrowLeft") {
      W.preventDefault();
      var He = oe.selection ? function(zn, Pn) {
        var Fr = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], yr = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], Ln = Pn.selection;
        if (!Ln)
          return null;
        var mi = Uw(zn, Pn, yr), tr = mi.caret, pr = mi.previous;
        if (Fr)
          return Sn(Ln) ? null : Wr(Ln.path, Ln.path);
        if (tr && pr)
          return Hv(pr);
        var Oc = en(mt(Ln)), Cs = it(zn, Oc);
        return an(Ln) && Array.isArray(Cs) ? Wr(Ln.path, Ln.path) : Sn(Ln) && !Array.isArray(Cs) ? Li(Ln.focusPath, !1) : null;
      }(c, oe, Ee, !w) || oe.selection : pl(c, oe);
      we(He), ut(mt(He));
    }
    if (ue === "ArrowRight" || ue === "Shift+ArrowRight") {
      W.preventDefault();
      var st = oe.selection && c !== void 0 ? function(zn, Pn) {
        var Fr = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], yr = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], Ln = Pn.selection;
        if (!Ln)
          return null;
        var mi = Uw(zn, Pn, yr), tr = mi.caret, pr = mi.next;
        return Fr ? Sn(Ln) ? null : Wr(Ln.path, Ln.path) : tr && pr ? Hv(pr) : Sn(Ln) ? Wt(Ln.focusPath, !1) : null;
      }(c, oe, Ee, !w) || oe.selection : pl(c, oe);
      we(st), ut(mt(st));
    }
    if (ue === "Enter" && oe.selection) {
      if (Wp(oe.selection)) {
        var gt = oe.selection.focusPath, wt = it(c, en(gt));
        Array.isArray(wt) && we(Wt(gt, !1));
      }
      dr(oe.selection) && (W.preventDefault(), we(fe(fe({}, oe.selection), {}, { edit: !0 }))), an(oe.selection) && (W.preventDefault(), Xn(it(c, oe.selection.path)) ? qn(oe.selection.path, !0) : we(fe(fe({}, oe.selection), {}, { edit: !0 })));
    }
    if (ue.replace(/^Shift\+/, "").length === 1 && oe.selection)
      return W.preventDefault(), void vn(W.key);
    if (ue === "Enter" && (ji(oe.selection) || vr(oe.selection)))
      return W.preventDefault(), void vn("");
    if (ue === "Ctrl+Enter" && an(oe.selection)) {
      var In = it(c, oe.selection.path);
      Vp(In) && window.open(String(In), "_blank");
    }
    ue === "Escape" && oe.selection && (W.preventDefault(), we(null)), ue === "Ctrl+F" && (W.preventDefault(), Or(!1)), ue === "Ctrl+H" && (W.preventDefault(), Or(!0)), ue === "Ctrl+Z" && (W.preventDefault(), Ht()), ue === "Ctrl+Shift+Z" && (W.preventDefault(), mn());
  }, function(W) {
    i("handleMouseDown", W), py(W.target, "BUTTON") || W.target.isContentEditable || (Nn(), oe.selection || c !== void 0 || u !== "" && u !== void 0 || (i("createDefaultSelection"), n(17, oe = fe(fe({}, oe), {}, { selection: Wt([], !1) }))));
  }, Oi, function(W) {
    w || pi({ anchor: Z6(W.target, "BUTTON"), offsetTop: 0, width: is, height: rs, showTip: !0 });
  }, function() {
    return Ji.apply(this, arguments);
  }, function() {
    i("clear pasted json"), n(19, Be = void 0), Nn();
  }, function() {
    R(Lr.text);
  }, function(W) {
    we(W), Nn(), Ve(mt(W));
  }, function(W) {
    var ue = !vf(W.target, function(Ee) {
      return Ee === l;
    });
    ue && Hi(oe.selection) && (i("click outside the editor, stop edit mode"), we(function(Ee) {
      return dr(Ee) || an(Ee) ? fe(fe({}, Ee), {}, { edit: !1 }) : Ee;
    }), v && a && (a.focus(), a.blur()), i("blur (outside editor)"), a && a.blur());
  }, x, b, N, B, I, P, J, L, R, V, M, F, z, E, A, te, ge, function() {
    var W = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : du;
    i("expand");
    var ue = fe(fe({}, oe), {}, { expandedMap: {}, visibleSectionsMap: {} });
    n(17, oe = Ai(c, ue, [], W));
  }, Ge, xn, pn, Ne, Ve, _t, rt, Se, function(W) {
    n(20, We = W);
  }, function(W) {
    Kt[W ? "unshift" : "push"](function() {
      n(14, a = W);
    });
  }, function() {
    Nn(), vn("{");
  }, function() {
    Nn(), vn("[");
  }, function() {
    Nn();
  }, function(W) {
    Kt[W ? "unshift" : "push"](function() {
      n(10, s = W);
    });
  }, function(W) {
    Kt[W ? "unshift" : "push"](function() {
      n(15, l = W);
    });
  }];
}
var My = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, qne, Bne, Pt, { readOnly: 0, externalContent: 52, externalSelection: 53, mainMenuBar: 1, navigationBar: 2, escapeControlCharacters: 54, escapeUnicodeCharacters: 55, parser: 3, parseMemoizeOne: 56, validator: 57, validationParser: 58, pathParser: 4, indentation: 5, onError: 6, onChange: 59, onChangeMode: 60, onSelect: 61, onRenderValue: 62, onRenderMenu: 7, onClassName: 63, onFocus: 64, onBlur: 65, onSortModal: 66, onTransformModal: 67, onJSONEditorModal: 68, expand: 69, validate: 70, getJson: 71, patch: 72, acceptAutoRepair: 8, openTransformModal: 73, scrollTo: 74, findElement: 75, focus: 9 }, Tne, [-1, -1, -1, -1, -1]), i;
  }
  return Ye(n, [{ key: "expand", get: function() {
    return this.$$.ctx[69];
  } }, { key: "validate", get: function() {
    return this.$$.ctx[70];
  } }, { key: "getJson", get: function() {
    return this.$$.ctx[71];
  } }, { key: "patch", get: function() {
    return this.$$.ctx[72];
  } }, { key: "acceptAutoRepair", get: function() {
    return this.$$.ctx[8];
  } }, { key: "openTransformModal", get: function() {
    return this.$$.ctx[73];
  } }, { key: "scrollTo", get: function() {
    return this.$$.ctx[74];
  } }, { key: "findElement", get: function() {
    return this.$$.ctx[75];
  } }, { key: "focus", get: function() {
    return this.$$.ctx[9];
  } }]), n;
}();
function zne(t) {
  At(t, "svelte-l4qqoi", '.jse-modal.svelte-l4qqoi.svelte-l4qqoi{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-l4qqoi .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-l4qqoi .jse-modal-contents.svelte-l4qqoi{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-l4qqoi .jse-modal-contents .jse-actions.svelte-l4qqoi{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-l4qqoi .jse-modal-contents .jse-actions button.jse-primary.svelte-l4qqoi{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-l4qqoi .jse-modal-contents .jse-actions button.jse-primary.svelte-l4qqoi:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-l4qqoi .jse-modal-contents .jse-actions button.jse-primary.svelte-l4qqoi:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;height:auto;min-height:500px;max-height:calc(100vh - 6rem);display:flex}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents.svelte-l4qqoi{color:inherit;min-height:0;padding:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents.svelte-l4qqoi{flex:1;display:flex;gap:calc(2 * var(--jse-padding, 10px));min-height:0;box-sizing:border-box;padding:0 calc(2 * var(--jse-padding, 10px)) var(--jse-padding, 10px)}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents.svelte-l4qqoi{flex:1;display:flex;flex-direction:column}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-l4qqoi p{margin:var(--jse-padding, 10px) 0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-l4qqoi p:first-child{margin-top:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-l4qqoi p:last-child{margin-bottom:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-l4qqoi code{background:var(--jse-modal-code-background, rgba(0, 0, 0, 0.05));font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px)}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents textarea.jse-query.svelte-l4qqoi{flex:1;outline:none;resize:vertical}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents.svelte-l4qqoi{flex:1;display:flex;flex-direction:column;gap:calc(2 * var(--jse-padding, 10px))}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents .jse-original-data.svelte-l4qqoi{flex:1;display:flex;flex-direction:column;min-height:0;box-sizing:border-box}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents .jse-original-data.jse-hide.svelte-l4qqoi{flex:none}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents .jse-preview-data.svelte-l4qqoi{flex:1;display:flex;flex-direction:column;min-height:0;box-sizing:border-box}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents.jse-hide-original-data.svelte-l4qqoi{flex-direction:column;gap:0;margin-bottom:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-actions.svelte-l4qqoi{padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px)) calc(2 * var(--jse-padding, 10px))}@media screen and (max-width: 1200px){.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents.svelte-l4qqoi{flex-direction:column;overflow:auto}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-query-contents textarea.jse-query.svelte-l4qqoi{min-height:150px;flex:none}.jse-modal.jse-transform.svelte-l4qqoi .jse-modal-contents .jse-main-contents .jse-data-contents.svelte-l4qqoi .jse-tree-mode{height:300px;flex:none}}.jse-modal.jse-transform.svelte-l4qqoi .jse-label.svelte-l4qqoi{font-weight:bold;display:block;box-sizing:border-box}.jse-modal.jse-transform.svelte-l4qqoi .jse-label .jse-label-inner.svelte-l4qqoi{margin-top:calc(2 * var(--jse-padding, 10px));margin-bottom:calc(0.5 * var(--jse-padding, 10px));box-sizing:border-box}.jse-modal.jse-transform.svelte-l4qqoi .jse-label .jse-label-inner button.svelte-l4qqoi{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;font-weight:bold;padding:0}.jse-modal.jse-transform.svelte-l4qqoi .jse-tree-mode{flex:1;background:var(--jse-input-background-readonly, transparent);box-shadow:none;box-sizing:border-box;--jse-main-border:var(--jse-input-border, 1px solid #d8dbdf)}.jse-modal.jse-transform.svelte-l4qqoi input.svelte-l4qqoi,.jse-modal.jse-transform.svelte-l4qqoi textarea.svelte-l4qqoi{border:var(--jse-input-border, 1px solid #d8dbdf);outline:none;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding, 10px));font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:inherit;background:var(--jse-input-background, var(--jse-background-color, #fff))}.jse-modal.jse-transform.svelte-l4qqoi input.svelte-l4qqoi:focus,.jse-modal.jse-transform.svelte-l4qqoi textarea.svelte-l4qqoi:focus{border:var(--jse-input-border-focus, 1px solid var(--jse-input-border-focus, var(--jse-theme-color, #3883fa)))}.jse-modal.jse-transform.svelte-l4qqoi input.svelte-l4qqoi:read-only,.jse-modal.jse-transform.svelte-l4qqoi textarea.svelte-l4qqoi:read-only{background:var(--jse-input-background-readonly, transparent)}.jse-modal.jse-transform.svelte-l4qqoi .jse-preview.jse-error.svelte-l4qqoi{flex:1;background:var(--jse-input-background-readonly, transparent);border:var(--jse-input-border, 1px solid #d8dbdf);color:var(--jse-error-color, #ee5341);padding:calc(0.5 * var(--jse-padding, 10px))}.jse-modal.jse-transform.svelte-l4qqoi a{color:var(--jse-a-color, #156fc5)}.jse-modal.jse-transform.svelte-l4qqoi a:hover{color:var(--jse-a-color-highlight, #0f508d)}');
}
function m$(t) {
  var e, n, r, i, o, s = [Vne, Fne], a = [];
  function l(c, u) {
    return 4096 & u[0] && (e = null), e == null && (e = !!Array.isArray(c[12])), e ? 0 : 1;
  }
  return n = l(t, [-1, -1]), r = a[n] = s[n](t), { c: function() {
    r.c(), i = un();
  }, m: function(c, u) {
    a[n].m(c, u), X(c, i, u), o = !0;
  }, p: function(c, u) {
    var f = n;
    (n = l(c, u)) === f ? a[n].p(c, u) : (Ae(), _(a[f], 1, 1, function() {
      a[f] = null;
    }), Me(), (r = a[n]) ? r.p(c, u) : (r = a[n] = s[n](c)).c(), S(r, 1), r.m(i.parentNode, i));
  }, i: function(c) {
    o || (S(r), o = !0);
  }, o: function(c) {
    _(r), o = !1;
  }, d: function(c) {
    c && Y(i), a[n].d(c);
  } };
}
function Fne(t) {
  var e;
  return { c: function() {
    e = Le("(Only available for arrays, not for objects)");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, i: Pe, o: Pe, d: function(n) {
    n && Y(e);
  } };
}
function Vne(t) {
  var e, n;
  return e = new pZ({ props: { queryOptions: t[13], json: t[12], onChange: t[22] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    8192 & i[0] && (o.queryOptions = r[13]), 4096 & i[0] && (o.json = r[12]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function g$(t) {
  var e, n;
  return e = new My({ props: { externalContent: t[15], externalSelection: null, readOnly: !0, mainMenuBar: !1, navigationBar: !1, indentation: t[2], escapeControlCharacters: t[3], escapeUnicodeCharacters: t[4], parser: t[5], parseMemoizeOne: t[6], onRenderValue: t[10], onRenderMenu: t[34], onError: console.error, onChange: nr, onChangeMode: nr, onSelect: nr, onFocus: nr, onBlur: nr, onSortModal: nr, onTransformModal: nr, onJSONEditorModal: nr, onClassName: t[11], validator: null, validationParser: t[7], pathParser: t[8] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    32768 & i[0] && (o.externalContent = r[15]), 4 & i[0] && (o.indentation = r[2]), 8 & i[0] && (o.escapeControlCharacters = r[3]), 16 & i[0] && (o.escapeUnicodeCharacters = r[4]), 32 & i[0] && (o.parser = r[5]), 64 & i[0] && (o.parseMemoizeOne = r[6]), 1024 & i[0] && (o.onRenderValue = r[10]), 2048 & i[0] && (o.onClassName = r[11]), 128 & i[0] && (o.validationParser = r[7]), 256 & i[0] && (o.pathParser = r[8]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Hne(t) {
  var e, n;
  return { c: function() {
    e = H("div"), n = Le(t[18]), k(e, "class", "jse-preview jse-error svelte-l4qqoi");
  }, m: function(r, i) {
    X(r, e, i), T(e, n);
  }, p: function(r, i) {
    262144 & i[0] && bt(n, r[18]);
  }, i: Pe, o: Pe, d: function(r) {
    r && Y(e);
  } };
}
function Une(t) {
  var e, n;
  return e = new My({ props: { externalContent: t[19], externalSelection: null, readOnly: !0, mainMenuBar: !1, navigationBar: !1, indentation: t[2], escapeControlCharacters: t[3], escapeUnicodeCharacters: t[4], parser: t[5], parseMemoizeOne: t[6], onRenderValue: t[10], onRenderMenu: t[35], onError: console.error, onChange: nr, onChangeMode: nr, onSelect: nr, onFocus: nr, onBlur: nr, onSortModal: nr, onTransformModal: nr, onJSONEditorModal: nr, onClassName: t[11], validator: null, validationParser: t[7], pathParser: t[8] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    524288 & i[0] && (o.externalContent = r[19]), 4 & i[0] && (o.indentation = r[2]), 8 & i[0] && (o.escapeControlCharacters = r[3]), 16 & i[0] && (o.escapeUnicodeCharacters = r[4]), 32 & i[0] && (o.parser = r[5]), 64 & i[0] && (o.parseMemoizeOne = r[6]), 1024 & i[0] && (o.onRenderValue = r[10]), 2048 & i[0] && (o.onClassName = r[11]), 128 & i[0] && (o.validationParser = r[7]), 256 & i[0] && (o.pathParser = r[8]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Wne(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N, B, O, I, P, J, D, Q, Z, L, R, V, M, C, F, z, E, A, te, ge, ke, Ce, we, le, rt = t[21](t[0]).description + "";
  e = new $Z({ props: { queryLanguages: t[9], queryLanguageId: t[0], onChangeQueryLanguage: t[27] } }), y = new cn({ props: { data: t[16] ? Ti : Ds } });
  var Be = t[16] && m$(t);
  Q = new cn({ props: { data: t[17] ? Ti : Ds } });
  var nt = t[17] && g$(t), oe = [Une, Hne], We = [];
  function Rt(de, Se) {
    return de[18] ? 1 : 0;
  }
  return F = Rt(t), z = We[F] = oe[F](t), { c: function() {
    xe(e.$$.fragment), n = se(), r = H("div"), i = H("div"), o = H("div"), (s = H("div")).innerHTML = '<div class="jse-label-inner svelte-l4qqoi">Language</div>', a = se(), l = H("div"), c = se(), (u = H("div")).innerHTML = '<div class="jse-label-inner svelte-l4qqoi">Path</div>', f = se(), d = H("input"), p = se(), m = H("div"), g = H("div"), v = H("button"), xe(y.$$.fragment), w = Le(`
                Wizard`), x = se(), Be && Be.c(), b = se(), (j = H("div")).innerHTML = '<div class="jse-label-inner svelte-l4qqoi">Query</div>', $ = se(), N = H("textarea"), B = se(), O = H("div"), I = H("div"), P = H("div"), J = H("div"), D = H("button"), xe(Q.$$.fragment), Z = Le(`
                  Original`), L = se(), nt && nt.c(), R = se(), V = H("div"), (M = H("div")).innerHTML = '<div class="jse-label-inner svelte-l4qqoi">Preview</div>', C = se(), z.c(), E = se(), A = H("div"), te = H("button"), ge = Le("Transform"), k(s, "class", "jse-label svelte-l4qqoi"), k(l, "class", "jse-description svelte-l4qqoi"), k(u, "class", "jse-label svelte-l4qqoi"), k(d, "class", "jse-path svelte-l4qqoi"), k(d, "type", "text"), d.readOnly = !0, k(d, "title", "Selected path"), d.value = h = nn(t[1]) ? "(document root)" : hi(t[1]), k(v, "type", "button"), k(v, "class", "svelte-l4qqoi"), k(g, "class", "jse-label-inner svelte-l4qqoi"), k(m, "class", "jse-label svelte-l4qqoi"), k(j, "class", "jse-label svelte-l4qqoi"), k(N, "class", "jse-query svelte-l4qqoi"), k(N, "spellcheck", "false"), N.value = t[14], k(o, "class", "jse-query-contents svelte-l4qqoi"), k(D, "type", "button"), k(D, "class", "svelte-l4qqoi"), k(J, "class", "jse-label-inner svelte-l4qqoi"), k(P, "class", "jse-label svelte-l4qqoi"), k(I, "class", "jse-original-data svelte-l4qqoi"), $e(I, "jse-hide", !t[17]), k(M, "class", "jse-label svelte-l4qqoi"), k(V, "class", "jse-preview-data svelte-l4qqoi"), k(O, "class", "jse-data-contents svelte-l4qqoi"), $e(O, "jse-hide-original-data", !t[17]), k(i, "class", "jse-main-contents svelte-l4qqoi"), k(te, "type", "button"), k(te, "class", "jse-primary svelte-l4qqoi"), te.disabled = ke = !!t[18], k(A, "class", "jse-actions svelte-l4qqoi"), k(r, "class", "jse-modal-contents svelte-l4qqoi");
  }, m: function(de, Se) {
    ye(e, de, Se), X(de, n, Se), X(de, r, Se), T(r, i), T(i, o), T(o, s), T(o, a), T(o, l), l.innerHTML = rt, T(o, c), T(o, u), T(o, f), T(o, d), T(o, p), T(o, m), T(m, g), T(g, v), ye(y, v, null), T(v, w), T(o, x), Be && Be.m(o, null), T(o, b), T(o, j), T(o, $), T(o, N), T(i, B), T(i, O), T(O, I), T(I, P), T(P, J), T(J, D), ye(Q, D, null), T(D, Z), T(I, L), nt && nt.m(I, null), T(O, R), T(O, V), T(V, M), T(V, C), We[F].m(V, null), T(r, E), T(r, A), T(A, te), T(te, ge), Ce = !0, we || (le = [Oe(v, "click", t[25]), Oe(N, "input", t[23]), Oe(D, "click", t[26]), Oe(te, "click", t[24]), Mr(Kne.call(null, te))], we = !0);
  }, p: function(de, Se) {
    var rn = {};
    512 & Se[0] && (rn.queryLanguages = de[9]), 1 & Se[0] && (rn.queryLanguageId = de[0]), e.$set(rn), (!Ce || 1 & Se[0]) && rt !== (rt = de[21](de[0]).description + "") && (l.innerHTML = rt), (!Ce || 2 & Se[0] && h !== (h = nn(de[1]) ? "(document root)" : hi(de[1])) && d.value !== h) && (d.value = h);
    var Dt = {};
    65536 & Se[0] && (Dt.data = de[16] ? Ti : Ds), y.$set(Dt), de[16] ? Be ? (Be.p(de, Se), 65536 & Se[0] && S(Be, 1)) : ((Be = m$(de)).c(), S(Be, 1), Be.m(o, b)) : Be && (Ae(), _(Be, 1, 1, function() {
      Be = null;
    }), Me()), (!Ce || 16384 & Se[0]) && (N.value = de[14]);
    var Xt = {};
    131072 & Se[0] && (Xt.data = de[17] ? Ti : Ds), Q.$set(Xt), de[17] ? nt ? (nt.p(de, Se), 131072 & Se[0] && S(nt, 1)) : ((nt = g$(de)).c(), S(nt, 1), nt.m(I, null)) : nt && (Ae(), _(nt, 1, 1, function() {
      nt = null;
    }), Me()), (!Ce || 131072 & Se[0]) && $e(I, "jse-hide", !de[17]);
    var Ue = F;
    (F = Rt(de)) === Ue ? We[F].p(de, Se) : (Ae(), _(We[Ue], 1, 1, function() {
      We[Ue] = null;
    }), Me(), (z = We[F]) ? z.p(de, Se) : (z = We[F] = oe[F](de)).c(), S(z, 1), z.m(V, null)), (!Ce || 131072 & Se[0]) && $e(O, "jse-hide-original-data", !de[17]), (!Ce || 262144 & Se[0] && ke !== (ke = !!de[18])) && (te.disabled = ke);
  }, i: function(de) {
    Ce || (S(e.$$.fragment, de), S(y.$$.fragment, de), S(Be), S(Q.$$.fragment, de), S(nt), S(z), Ce = !0);
  }, o: function(de) {
    _(e.$$.fragment, de), _(y.$$.fragment, de), _(Be), _(Q.$$.fragment, de), _(nt), _(z), Ce = !1;
  }, d: function(de) {
    de && (Y(n), Y(r)), be(e, de), be(y), Be && Be.d(), be(Q), nt && nt.d(), We[F].d(), we = !1, An(le);
  } };
}
function Jne(t) {
  var e, n, r, i, o;
  return n = new n5({ props: { $$slots: { default: [Wne] }, $$scope: { ctx: t } } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), k(e, "class", "jse-modal jse-transform svelte-l4qqoi");
  }, m: function(s, a) {
    X(s, e, a), ye(n, e, null), r = !0, i || (o = Mr(em.call(null, e, t[20])), i = !0);
  }, p: function(s, a) {
    var l = {};
    1048575 & a[0] | 2048 & a[1] && (l.$$scope = { dirty: a, ctx: s }), n.$set(l);
  }, i: function(s) {
    r || (S(n.$$.fragment, s), r = !0);
  }, o: function(s) {
    _(n.$$.fragment, s), r = !1;
  }, d: function(s) {
    s && Y(e), be(n), i = !1, o();
  } };
}
function Kne(t) {
  t.focus();
}
function Gne(t, e, n) {
  var r, i, o = Tr("jsoneditor:TransformModal"), s = e.id, a = s === void 0 ? "transform-modal-" + fu() : s, l = e.json, c = e.rootPath, u = c === void 0 ? [] : c, f = e.indentation, d = e.escapeControlCharacters, h = e.escapeUnicodeCharacters, p = e.parser, m = e.parseMemoizeOne, g = e.validationParser, v = e.pathParser, y = e.queryLanguages, w = e.queryLanguageId, x = e.onChangeQueryLanguage, b = e.onRenderValue, j = e.onClassName, $ = e.onTransform, N = _r("simple-modal").close, B = "".concat(a, ":").concat(Je(u)), O = Bc[B] || {}, I = hd.showWizard !== !1, P = hd.showOriginal !== !1, J = O.queryOptions || {}, D = w === O.queryLanguageId && O.query ? O.query : R(w).createQuery(l, O.queryOptions || {}), Q = O.isManual || !1, Z = void 0, L = { text: "" };
  function R(M) {
    return y.find(function(C) {
      return C.id === M;
    }) || y[0];
  }
  var V = ef(function(M, C) {
    if (M === void 0)
      return n(19, L = { text: "" }), void n(18, Z = "Error: No JSON");
    try {
      o("previewTransform", { query: C });
      var F = R(w).executeQuery(M, C, p);
      n(19, L = { json: F }), n(18, Z = void 0);
    } catch (z) {
      n(19, L = { text: "" }), n(18, Z = String(z));
    }
  }, 300);
  return t.$$set = function(M) {
    "id" in M && n(28, a = M.id), "json" in M && n(29, l = M.json), "rootPath" in M && n(1, u = M.rootPath), "indentation" in M && n(2, f = M.indentation), "escapeControlCharacters" in M && n(3, d = M.escapeControlCharacters), "escapeUnicodeCharacters" in M && n(4, h = M.escapeUnicodeCharacters), "parser" in M && n(5, p = M.parser), "parseMemoizeOne" in M && n(6, m = M.parseMemoizeOne), "validationParser" in M && n(7, g = M.validationParser), "pathParser" in M && n(8, v = M.pathParser), "queryLanguages" in M && n(9, y = M.queryLanguages), "queryLanguageId" in M && n(0, w = M.queryLanguageId), "onChangeQueryLanguage" in M && n(30, x = M.onChangeQueryLanguage), "onRenderValue" in M && n(10, b = M.onRenderValue), "onClassName" in M && n(11, j = M.onClassName), "onTransform" in M && n(31, $ = M.onTransform);
  }, t.$$.update = function() {
    536870914 & t.$$.dirty[0] && n(12, r = it(l, u)), 4096 & t.$$.dirty[0] && n(15, i = r ? { json: r } : { text: "" }), 20480 & t.$$.dirty[0] && V(r, D), 24577 & t.$$.dirty[0] | 6 & t.$$.dirty[1] && (n(32, Bc[B] = { queryOptions: J, query: D, queryLanguageId: w, isManual: Q }, Bc), o("store state in memory", B, Bc[B]));
  }, [w, u, f, d, h, p, m, g, v, y, b, j, r, J, D, i, I, P, Z, L, N, R, function(M) {
    n(13, J = M), n(14, D = R(w).createQuery(l, M)), n(33, Q = !1), o("updateQueryByWizard", { queryOptions: J, query: D, isManual: Q });
  }, function(M) {
    n(14, D = M.target.value), n(33, Q = !0), o("handleChangeQuery", { query: D, isManual: Q });
  }, function() {
    if (r === void 0)
      return n(19, L = { text: "" }), void n(18, Z = "Error: No JSON");
    try {
      o("handleTransform", { query: D });
      var M = R(w).executeQuery(r, D, p);
      $([{ op: "replace", path: Je(u), value: M }]), N();
    } catch (C) {
      console.error(C), n(19, L = { text: "" }), n(18, Z = String(C));
    }
  }, function() {
    n(16, I = !I), hd.showWizard = I;
  }, function() {
    n(17, P = !P), hd.showOriginal = P;
  }, function(M) {
    o("handleChangeQueryLanguage", M), n(0, w = M), x(M);
    var C = R(w);
    n(14, D = C.createQuery(l, J)), n(33, Q = !1);
  }, a, l, x, $, Bc, Q, function() {
  }, function() {
  }];
}
var Qne = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Gne, Jne, Pt, { id: 28, json: 29, rootPath: 1, indentation: 2, escapeControlCharacters: 3, escapeUnicodeCharacters: 4, parser: 5, parseMemoizeOne: 6, validationParser: 7, pathParser: 8, queryLanguages: 9, queryLanguageId: 0, onChangeQueryLanguage: 30, onRenderValue: 10, onClassName: 11, onTransform: 31 }, zne, [-1, -1]), i;
  }
  return Ye(n);
}(), ml = {};
function Yne(t) {
  At(t, "svelte-qjdk97", '.jse-modal.svelte-qjdk97.svelte-qjdk97{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-qjdk97 .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-qjdk97 .jse-modal-contents.svelte-qjdk97{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-qjdk97 .jse-modal-contents .jse-actions.svelte-qjdk97{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-qjdk97 .jse-modal-contents .jse-actions button.jse-primary.svelte-qjdk97{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-qjdk97 .jse-modal-contents .jse-actions button.jse-primary.svelte-qjdk97:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-qjdk97 .jse-modal-contents .jse-actions button.jse-primary.svelte-qjdk97:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;height:auto;min-height:500px;max-height:calc(100vh - 6rem);display:flex}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0}.jse-modal.jse-sort.svelte-qjdk97 table.svelte-qjdk97{width:100%;border-collapse:collapse;border-spacing:0}.jse-modal.jse-sort.svelte-qjdk97 table th.svelte-qjdk97,.jse-modal.jse-sort.svelte-qjdk97 table td.svelte-qjdk97{text-align:left;vertical-align:middle;font-weight:normal;padding-bottom:var(--jse-padding, 10px)}.jse-modal.jse-sort.svelte-qjdk97 table th input.jse-path.svelte-qjdk97,.jse-modal.jse-sort.svelte-qjdk97 table td input.jse-path.svelte-qjdk97{width:100%;box-sizing:border-box;padding:6px 16px;border:var(--jse-input-border, 1px solid #d8dbdf);border-radius:var(--jse-input-radius, 3px);font-family:inherit;font-size:inherit;background:inherit;color:inherit;outline:none}.jse-modal.jse-sort.svelte-qjdk97 table th input.jse-path.svelte-qjdk97:read-only,.jse-modal.jse-sort.svelte-qjdk97 table td input.jse-path.svelte-qjdk97:read-only{background:var(--jse-input-background-readonly, transparent)}.jse-modal.jse-sort.svelte-qjdk97 table th.svelte-qjdk97 .svelte-select input,.jse-modal.jse-sort.svelte-qjdk97 table td.svelte-qjdk97 .svelte-select input{box-sizing:border-box}.jse-modal.jse-sort.svelte-qjdk97 .jse-space.svelte-qjdk97{height:200px}.jse-modal.jse-sort.svelte-qjdk97 .jse-space .jse-error.svelte-qjdk97{color:var(--jse-error-color, #ee5341)}');
}
function v$(t) {
  var e, n, r, i, o, s, a;
  function l(u) {
    t[14](u);
  }
  var c = { showChevron: !0, items: t[5] };
  return t[1] !== void 0 && (c.value = t[1]), o = new Ea({ props: c }), Kt.push(function() {
    return no(o, "value", l);
  }), { c: function() {
    e = H("tr"), (n = H("th")).textContent = "Property", r = se(), i = H("td"), xe(o.$$.fragment), k(n, "class", "svelte-qjdk97"), k(i, "class", "svelte-qjdk97");
  }, m: function(u, f) {
    X(u, e, f), T(e, n), T(e, r), T(e, i), ye(o, i, null), a = !0;
  }, p: function(u, f) {
    var d = {};
    32 & f && (d.items = u[5]), !s && 2 & f && (s = !0, d.value = u[1], to(function() {
      return s = !1;
    })), o.$set(d);
  }, i: function(u) {
    a || (S(o.$$.fragment, u), a = !0);
  }, o: function(u) {
    _(o.$$.fragment, u), a = !1;
  }, d: function(u) {
    u && Y(e), be(o);
  } };
}
function y$(t) {
  var e, n;
  return { c: function() {
    e = H("div"), n = Le(t[4]), k(e, "class", "jse-error svelte-qjdk97");
  }, m: function(r, i) {
    X(r, e, i), T(e, n);
  }, p: function(r, i) {
    16 & i && bt(n, r[4]);
  }, d: function(r) {
    r && Y(e);
  } };
}
function Xne(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N, B, O, I, P, J, D, Q, Z, L;
  r = new $y({ props: { title: t[3] ? "Sort array items" : "Sort object keys" } });
  var R = t[3] && (t[5] && ((e = t[5]) === null || e === void 0 ? void 0 : e.length) > 1 || t[1] === void 0) && v$(t);
  function V(F) {
    t[15](F);
  }
  var M = { showChevron: !0, clearable: !1, items: t[7] };
  t[2] !== void 0 && (M.value = t[2]), j = new Ea({ props: M }), Kt.push(function() {
    return no(j, "value", V);
  });
  var C = t[4] && y$(t);
  return { c: function() {
    var F;
    n = H("div"), xe(r.$$.fragment), i = se(), o = H("div"), s = H("table"), (a = H("colgroup")).innerHTML = '<col width="25%"/> <col width="75%"/>', l = se(), c = H("tbody"), u = H("tr"), (f = H("th")).textContent = "Path", d = se(), h = H("td"), p = H("input"), g = se(), R && R.c(), v = se(), y = H("tr"), (w = H("th")).textContent = "Direction", x = se(), b = H("td"), xe(j.$$.fragment), N = se(), B = H("div"), C && C.c(), O = se(), I = H("div"), P = H("button"), J = Le("Sort"), k(f, "class", "svelte-qjdk97"), k(p, "class", "jse-path svelte-qjdk97"), k(p, "type", "text"), p.readOnly = !0, k(p, "title", "Selected path"), p.value = m = nn(t[0]) ? "(document root)" : hi(t[0]), k(h, "class", "svelte-qjdk97"), k(w, "class", "svelte-qjdk97"), k(b, "class", "svelte-qjdk97"), k(s, "class", "svelte-qjdk97"), k(B, "class", "jse-space svelte-qjdk97"), k(P, "type", "button"), k(P, "class", "jse-primary svelte-qjdk97"), P.disabled = D = !!(t[3] && t[5] && ((F = t[5]) === null || F === void 0 ? void 0 : F.length) > 1) && !t[1], k(I, "class", "jse-actions svelte-qjdk97"), k(o, "class", "jse-modal-contents svelte-qjdk97"), k(n, "class", "jse-modal jse-sort svelte-qjdk97");
  }, m: function(F, z) {
    X(F, n, z), ye(r, n, null), T(n, i), T(n, o), T(o, s), T(s, a), T(s, l), T(s, c), T(c, u), T(u, f), T(u, d), T(u, h), T(h, p), T(c, g), R && R.m(c, null), T(c, v), T(c, y), T(y, w), T(y, x), T(y, b), ye(j, b, null), T(o, N), T(o, B), C && C.m(B, null), T(o, O), T(o, I), T(I, P), T(P, J), Q = !0, Z || (L = [Oe(P, "click", t[8]), Mr(Zne.call(null, P)), Mr(em.call(null, n, t[6]))], Z = !0);
  }, p: function(F, z) {
    var E, A, te = Et(z, 1)[0], ge = {};
    8 & te && (ge.title = F[3] ? "Sort array items" : "Sort object keys"), r.$set(ge), (!Q || 1 & te && m !== (m = nn(F[0]) ? "(document root)" : hi(F[0])) && p.value !== m) && (p.value = m), F[3] && (F[5] && ((E = F[5]) === null || E === void 0 ? void 0 : E.length) > 1 || F[1] === void 0) ? R ? (R.p(F, te), 42 & te && S(R, 1)) : ((R = v$(F)).c(), S(R, 1), R.m(c, v)) : R && (Ae(), _(R, 1, 1, function() {
      R = null;
    }), Me());
    var ke = {};
    !$ && 4 & te && ($ = !0, ke.value = F[2], to(function() {
      return $ = !1;
    })), j.$set(ke), F[4] ? C ? C.p(F, te) : ((C = y$(F)).c(), C.m(B, null)) : C && (C.d(1), C = null), (!Q || 42 & te && D !== (D = !!(F[3] && F[5] && ((A = F[5]) === null || A === void 0 ? void 0 : A.length) > 1) && !F[1])) && (P.disabled = D);
  }, i: function(F) {
    Q || (S(r.$$.fragment, F), S(R), S(j.$$.fragment, F), Q = !0);
  }, o: function(F) {
    _(r.$$.fragment, F), _(R), _(j.$$.fragment, F), Q = !1;
  }, d: function(F) {
    F && Y(n), be(r), R && R.d(), be(j), C && C.d(), Z = !1, An(L);
  } };
}
function Zne(t) {
  t.focus();
}
function ere(t, e, n) {
  var r, i, o, s, a, l = Tr("jsoneditor:SortModal"), c = e.id, u = e.json, f = e.rootPath, d = e.onSort, h = _r("simple-modal").close, p = "".concat(c, ":").concat(Je(f)), m = it(u, f), g = { value: 1, label: "ascending" }, v = [g, { value: -1, label: "descending" }], y = (r = ml[p]) === null || r === void 0 ? void 0 : r.selectedProperty, w = ((i = ml[p]) === null || i === void 0 ? void 0 : i.selectedDirection) || g, x = void 0;
  return t.$$set = function(b) {
    "id" in b && n(9, c = b.id), "json" in b && n(10, u = b.json), "rootPath" in b && n(0, f = b.rootPath), "onSort" in b && n(11, d = b.onSort);
  }, t.$$.update = function() {
    8 & t.$$.dirty && n(13, s = o && m !== void 0 ? Bv(m) : void 0), 8192 & t.$$.dirty && n(5, a = s ? s.map(Kc) : void 0), 4102 & t.$$.dirty && (n(12, ml[p] = { selectedProperty: y, selectedDirection: w }, ml), l("store state in memory", p, ml[p]));
  }, n(3, o = Array.isArray(m)), [f, y, w, o, x, a, h, v, function() {
    try {
      var b, j, $;
      n(4, x = void 0);
      var N = ((b = y) === null || b === void 0 ? void 0 : b.value) || ((j = a) === null || j === void 0 || (j = j[0]) === null || j === void 0 ? void 0 : j.value) || [], B = ($ = w) === null || $ === void 0 ? void 0 : $.value, O = D5(u, f, N, B);
      d({ operations: O, rootPath: f, itemPath: N, direction: B }), h();
    } catch (I) {
      n(4, x = String(I));
    }
  }, c, u, d, ml, s, function(b) {
    n(1, y = b);
  }, function(b) {
    n(2, w = b);
  }];
}
var tre = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, ere, Xne, Pt, { id: 9, json: 10, rootPath: 0, onSort: 11 }, Yne), i;
  }
  return Ye(n);
}();
function Zi() {
}
function vd(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e3;
  if (t < 0.9 * e)
    return t.toFixed() + " B";
  var n = t / e;
  if (n < 0.9 * e)
    return n.toFixed(1) + " KB";
  var r = n / e;
  if (r < 0.9 * e)
    return r.toFixed(1) + " MB";
  var i = r / e;
  return i < 0.9 * e ? i.toFixed(1) + " GB" : (i / e).toFixed(1) + " TB";
}
function nre(t) {
  var e, n;
  return e = new Zp({ props: { items: t[0] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & Et(i, 1)[0] && (o.items = r[0]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function rre(t, e, n) {
  var r, i, o = e.readOnly, s = o !== void 0 && o, a = e.onFormat, l = e.onCompact, c = e.onSort, u = e.onTransform, f = e.onToggleSearch, d = e.onUndo, h = e.onRedo, p = e.canUndo, m = e.canRedo, g = e.canFormat, v = e.canCompact, y = e.canSort, w = e.canTransform, x = e.onRenderMenu, b = { type: "button", icon: q0, title: "Search (Ctrl+F)", className: "jse-search", onClick: f };
  return t.$$set = function(j) {
    "readOnly" in j && n(1, s = j.readOnly), "onFormat" in j && n(2, a = j.onFormat), "onCompact" in j && n(3, l = j.onCompact), "onSort" in j && n(4, c = j.onSort), "onTransform" in j && n(5, u = j.onTransform), "onToggleSearch" in j && n(6, f = j.onToggleSearch), "onUndo" in j && n(7, d = j.onUndo), "onRedo" in j && n(8, h = j.onRedo), "canUndo" in j && n(9, p = j.canUndo), "canRedo" in j && n(10, m = j.canRedo), "canFormat" in j && n(11, g = j.canFormat), "canCompact" in j && n(12, v = j.canCompact), "canSort" in j && n(13, y = j.canSort), "canTransform" in j && n(14, w = j.canTransform), "onRenderMenu" in j && n(15, x = j.onRenderMenu);
  }, t.$$.update = function() {
    32702 & t.$$.dirty && n(16, i = s ? [b, { type: "space" }] : [{ type: "button", icon: Xv, title: "Format JSON: add proper indentation and new lines (Ctrl+I)", className: "jse-format", onClick: a, disabled: s || !g }, { type: "button", icon: qte, title: "Compact JSON: remove all white spacing and new lines (Ctrl+Shift+I)", className: "jse-compact", onClick: l, disabled: s || !v }, { type: "separator" }, { type: "button", icon: wp, title: "Sort", className: "jse-sort", onClick: c, disabled: s || !y }, { type: "button", icon: bp, title: "Transform contents (filter, sort, project)", className: "jse-transform", onClick: u, disabled: s || !w }, b, { type: "separator" }, { type: "button", icon: B0, title: "Undo (Ctrl+Z)", className: "jse-undo", onClick: d, disabled: !p }, { type: "button", icon: L0, title: "Redo (Ctrl+Shift+Z)", className: "jse-redo", onClick: h, disabled: !m }, { type: "space" }]), 98304 & t.$$.dirty && n(0, r = x(i) || i);
  }, [r, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, i];
}
var ire = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, rre, nre, Pt, { readOnly: 1, onFormat: 2, onCompact: 3, onSort: 4, onTransform: 5, onToggleSearch: 6, onUndo: 7, onRedo: 8, canUndo: 9, canRedo: 10, canFormat: 11, canCompact: 12, canSort: 13, canTransform: 14, onRenderMenu: 15 }), i;
  }
  return Ye(n);
}();
function ore(t) {
  At(t, "svelte-hhcn0f", '.jse-status-bar.svelte-hhcn0f.svelte-hhcn0f{background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color-readonly, #b2b2b2);font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);margin:0;border-top:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7));border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7);display:flex;gap:var(--jse-padding, 10px)}.jse-status-bar.svelte-hhcn0f.svelte-hhcn0f:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-status-bar.svelte-hhcn0f .jse-status-bar-info.svelte-hhcn0f{padding:2px}');
}
function b$(t) {
  var e, n, r;
  return { c: function() {
    e = H("div"), n = Le("Line: "), r = Le(t[0]), k(e, "class", "jse-status-bar-info svelte-hhcn0f");
  }, m: function(i, o) {
    X(i, e, o), T(e, n), T(e, r);
  }, p: function(i, o) {
    1 & o && bt(r, i[0]);
  }, d: function(i) {
    i && Y(e);
  } };
}
function x$(t) {
  var e, n, r;
  return { c: function() {
    e = H("div"), n = Le("Column: "), r = Le(t[1]), k(e, "class", "jse-status-bar-info svelte-hhcn0f");
  }, m: function(i, o) {
    X(i, e, o), T(e, n), T(e, r);
  }, p: function(i, o) {
    2 & o && bt(r, i[1]);
  }, d: function(i) {
    i && Y(e);
  } };
}
function w$(t) {
  var e, n, r, i;
  return { c: function() {
    e = H("div"), n = Le("Selection: "), r = Le(t[2]), i = Le(" characters"), k(e, "class", "jse-status-bar-info svelte-hhcn0f");
  }, m: function(o, s) {
    X(o, e, s), T(e, n), T(e, r), T(e, i);
  }, p: function(o, s) {
    4 & s && bt(r, o[2]);
  }, d: function(o) {
    o && Y(e);
  } };
}
function sre(t) {
  var e, n, r, i = t[0] !== void 0 && b$(t), o = t[1] !== void 0 && x$(t), s = t[2] !== void 0 && t[2] > 0 && w$(t);
  return { c: function() {
    e = H("div"), i && i.c(), n = se(), o && o.c(), r = se(), s && s.c(), k(e, "class", "jse-status-bar svelte-hhcn0f");
  }, m: function(a, l) {
    X(a, e, l), i && i.m(e, null), T(e, n), o && o.m(e, null), T(e, r), s && s.m(e, null);
  }, p: function(a, l) {
    var c = Et(l, 1)[0];
    a[0] !== void 0 ? i ? i.p(a, c) : ((i = b$(a)).c(), i.m(e, n)) : i && (i.d(1), i = null), a[1] !== void 0 ? o ? o.p(a, c) : ((o = x$(a)).c(), o.m(e, r)) : o && (o.d(1), o = null), a[2] !== void 0 && a[2] > 0 ? s ? s.p(a, c) : ((s = w$(a)).c(), s.m(e, null)) : s && (s.d(1), s = null);
  }, i: Pe, o: Pe, d: function(a) {
    a && Y(e), i && i.d(), o && o.d(), s && s.d();
  } };
}
function are(t, e, n) {
  var r, i, o, s, a, l = e.editorState;
  return t.$$set = function(c) {
    "editorState" in c && n(3, l = c.editorState);
  }, t.$$.update = function() {
    var c, u, f;
    8 & t.$$.dirty && n(4, r = (c = l) === null || c === void 0 || (c = c.selection) === null || c === void 0 || (c = c.main) === null || c === void 0 ? void 0 : c.head), 24 & t.$$.dirty && n(5, i = (u = l) === null || u === void 0 || (u = u.doc) === null || u === void 0 ? void 0 : u.lineAt(r)), 32 & t.$$.dirty && n(0, o = i ? i.number : void 0), 48 & t.$$.dirty && n(1, s = i ? r - i.from + 1 : void 0), 8 & t.$$.dirty && n(2, a = (f = l) === null || f === void 0 || (f = f.selection) === null || f === void 0 || (f = f.ranges) === null || f === void 0 ? void 0 : f.reduce(function(d, h) {
      return d + h.to - h.from;
    }, 0));
  }, [o, s, a, l, r, i];
}
var lre = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, are, sre, wr, { editorState: 3 }, ore), i;
  }
  return Ye(n);
}(), cre = 0, br = function() {
  function t() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Qe(this, t), this.id = cre++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || function() {
      throw new Error("This node type doesn't define a deserialize function");
    };
  }
  return Ye(t, [{ key: "add", value: function(e) {
    var n = this;
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof e != "function" && (e = tl.match(e)), function(r) {
      var i = e(r);
      return i === void 0 ? null : [n, i];
    };
  } }]), t;
}();
br.closedBy = new br({ deserialize: function(t) {
  return t.split(" ");
} }), br.openedBy = new br({ deserialize: function(t) {
  return t.split(" ");
} }), br.group = new br({ deserialize: function(t) {
  return t.split(" ");
} }), br.contextHash = new br({ perNode: !0 }), br.lookAhead = new br({ perNode: !0 }), br.mounted = new br({ perNode: !0 });
var ep = function() {
  function t(e, n, r) {
    Qe(this, t), this.tree = e, this.overlay = n, this.parser = r;
  }
  return Ye(t, null, [{ key: "get", value: function(e) {
    return e && e.props && e.props[br.mounted.id];
  } }]), t;
}(), ure = /* @__PURE__ */ Object.create(null), tl = function() {
  function t(e, n, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    Qe(this, t), this.name = e, this.props = n, this.id = r, this.flags = i;
  }
  return Ye(t, [{ key: "prop", value: function(e) {
    return this.props[e.id];
  } }, { key: "isTop", get: function() {
    return (1 & this.flags) > 0;
  } }, { key: "isSkipped", get: function() {
    return (2 & this.flags) > 0;
  } }, { key: "isError", get: function() {
    return (4 & this.flags) > 0;
  } }, { key: "isAnonymous", get: function() {
    return (8 & this.flags) > 0;
  } }, { key: "is", value: function(e) {
    if (typeof e == "string") {
      if (this.name == e)
        return !0;
      var n = this.prop(br.group);
      return !!n && n.indexOf(e) > -1;
    }
    return this.id == e;
  } }], [{ key: "define", value: function(e) {
    var n = e.props && e.props.length ? /* @__PURE__ */ Object.create(null) : ure, r = (e.top ? 1 : 0) | (e.skipped ? 2 : 0) | (e.error ? 4 : 0) | (e.name == null ? 8 : 0), i = new t(e.name || "", n, e.id, r);
    if (e.props) {
      var o, s = qr(e.props);
      try {
        for (s.s(); !(o = s.n()).done; ) {
          var a = o.value;
          if (Array.isArray(a) || (a = a(i)), a) {
            if (a[0].perNode)
              throw new RangeError("Can't store a per-node prop on a node type");
            n[a[0].id] = a[1];
          }
        }
      } catch (l) {
        s.e(l);
      } finally {
        s.f();
      }
    }
    return i;
  } }, { key: "match", value: function(e) {
    var n = /* @__PURE__ */ Object.create(null);
    for (var r in e) {
      var i, o = qr(r.split(" "));
      try {
        for (o.s(); !(i = o.n()).done; ) {
          var s = i.value;
          n[s] = e[r];
        }
      } catch (a) {
        o.e(a);
      } finally {
        o.f();
      }
    }
    return function(a) {
      for (var l = a.prop(br.group), c = -1; c < (l ? l.length : 0); c++) {
        var u = n[c < 0 ? a.name : l[c]];
        if (u)
          return u;
      }
    };
  } }]), t;
}();
tl.none = new tl("", /* @__PURE__ */ Object.create(null), 0, 8);
var Jr, yd = /* @__PURE__ */ new WeakMap(), j$ = /* @__PURE__ */ new WeakMap();
(function(t) {
  t[t.ExcludeBuffers = 1] = "ExcludeBuffers", t[t.IncludeAnonymous = 2] = "IncludeAnonymous", t[t.IgnoreMounts = 4] = "IgnoreMounts", t[t.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Jr || (Jr = {}));
var Da = function() {
  function t(e, n, r, i, o) {
    if (Qe(this, t), this.type = e, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      var s, a = qr(o);
      try {
        for (a.s(); !(s = a.n()).done; ) {
          var l = Et(s.value, 2), c = l[0], u = l[1];
          this.props[typeof c == "number" ? c : c.id] = u;
        }
      } catch (f) {
        a.e(f);
      } finally {
        a.f();
      }
    }
  }
  return Ye(t, [{ key: "toString", value: function() {
    var e = ep.get(this);
    if (e && !e.overlay)
      return e.tree.toString();
    var n, r = "", i = qr(this.children);
    try {
      for (i.s(); !(n = i.n()).done; ) {
        var o = n.value.toString();
        o && (r && (r += ","), r += o);
      }
    } catch (s) {
      i.e(s);
    } finally {
      i.f();
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (r.length ? "(" + r + ")" : "") : r;
  } }, { key: "cursor", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new s0(this.topNode, e);
  } }, { key: "cursorAt", value: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = yd.get(this) || this.topNode, i = new s0(r);
    return i.moveTo(e, n), yd.set(this, i._tree), i;
  } }, { key: "topNode", get: function() {
    return new Ys(this, 0, 0, null);
  } }, { key: "resolve", value: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = hu(yd.get(this) || this.topNode, e, n, !1);
    return yd.set(this, r), r;
  } }, { key: "resolveInner", value: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = hu(j$.get(this) || this.topNode, e, n, !0);
    return j$.set(this, r), r;
  } }, { key: "resolveStack", value: function(e) {
    return function(n, r, i) {
      for (var o = n.resolveInner(r, i), s = null, a = o instanceof Ys ? o : o.context.parent; a; a = a.parent)
        if (a.index < 0) {
          var l = a.parent;
          (s || (s = [o])).push(l.resolve(r, i)), a = l;
        } else {
          var c = ep.get(a.tree);
          if (c && c.overlay && c.overlay[0].from <= r && c.overlay[c.overlay.length - 1].to >= r) {
            var u = new Ys(c.tree, c.overlay[0].from + a.from, -1, a);
            (s || (s = [o])).push(hu(u, r, i, !1));
          }
        }
      return s ? G5(s) : o;
    }(this, e, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0);
  } }, { key: "iterate", value: function(e) {
    for (var n = e.enter, r = e.leave, i = e.from, o = i === void 0 ? 0 : i, s = e.to, a = s === void 0 ? this.length : s, l = e.mode || 0, c = (l & Jr.IncludeAnonymous) > 0, u = this.cursor(l | Jr.IncludeAnonymous); ; ) {
      var f = !1;
      if (u.from <= a && u.to >= o && (!c && u.type.isAnonymous || n(u) !== !1)) {
        if (u.firstChild())
          continue;
        f = !0;
      }
      for (; f && r && (c || !u.type.isAnonymous) && r(u), !u.nextSibling(); ) {
        if (!u.parent())
          return;
        f = !0;
      }
    }
  } }, { key: "prop", value: function(e) {
    return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
  } }, { key: "propValues", get: function() {
    var e = [];
    if (this.props)
      for (var n in this.props)
        e.push([+n, this.props[n]]);
    return e;
  } }, { key: "balance", value: function() {
    var e = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.children.length <= 8 ? this : Ty(tl.none, this.children, this.positions, 0, this.children.length, 0, this.length, function(r, i, o) {
      return new t(e.type, r, i, o, e.propValues);
    }, n.makeTree || function(r, i, o) {
      return new t(tl.none, r, i, o);
    });
  } }], [{ key: "build", value: function(e) {
    return pre(e);
  } }]), t;
}();
Da.empty = new Da(tl.none, [], [], 0);
var fre = function() {
  function t(e, n) {
    Qe(this, t), this.buffer = e, this.index = n;
  }
  return Ye(t, [{ key: "id", get: function() {
    return this.buffer[this.index - 4];
  } }, { key: "start", get: function() {
    return this.buffer[this.index - 3];
  } }, { key: "end", get: function() {
    return this.buffer[this.index - 2];
  } }, { key: "size", get: function() {
    return this.buffer[this.index - 1];
  } }, { key: "pos", get: function() {
    return this.index;
  } }, { key: "next", value: function() {
    this.index -= 4;
  } }, { key: "fork", value: function() {
    return new t(this.buffer, this.index);
  } }]), t;
}(), fc = function() {
  function t(e, n, r) {
    Qe(this, t), this.buffer = e, this.length = n, this.set = r;
  }
  return Ye(t, [{ key: "type", get: function() {
    return tl.none;
  } }, { key: "toString", value: function() {
    for (var e = [], n = 0; n < this.buffer.length; )
      e.push(this.childString(n)), n = this.buffer[n + 3];
    return e.join(",");
  } }, { key: "childString", value: function(e) {
    var n = this.buffer[e], r = this.buffer[e + 3], i = this.set.types[n], o = i.name;
    if (/\W/.test(o) && !i.isError && (o = JSON.stringify(o)), r == (e += 4))
      return o;
    for (var s = []; e < r; )
      s.push(this.childString(e)), e = this.buffer[e + 3];
    return o + "(" + s.join(",") + ")";
  } }, { key: "findChild", value: function(e, n, r, i, o) {
    for (var s = this.buffer, a = -1, l = e; l != n && !(J5(o, i, s[l + 1], s[l + 2]) && (a = l, r > 0)); l = s[l + 3])
      ;
    return a;
  } }, { key: "slice", value: function(e, n, r) {
    for (var i = this.buffer, o = new Uint16Array(n - e), s = 0, a = e, l = 0; a < n; ) {
      o[l++] = i[a++], o[l++] = i[a++] - r;
      var c = o[l++] = i[a++] - r;
      o[l++] = i[a++] - e, s = Math.max(s, c);
    }
    return new t(o, s, this.set);
  } }]), t;
}();
function J5(t, e, n, r) {
  switch (t) {
    case -2:
      return n < e;
    case -1:
      return r >= e && n < e;
    case 0:
      return n < e && r > e;
    case 1:
      return n <= e && r > e;
    case 2:
      return r > e;
    case 4:
      return !0;
  }
}
function hu(t, e, n, r) {
  for (var i; t.from == t.to || (n < 1 ? t.from >= e : t.from > e) || (n > -1 ? t.to <= e : t.to < e); ) {
    var o = !r && t instanceof Ys && t.index < 0 ? null : t.parent;
    if (!o)
      return t;
    t = o;
  }
  var s = r ? 0 : Jr.IgnoreOverlays;
  if (r)
    for (var a = t, l = a.parent; l; l = (a = l).parent)
      a instanceof Ys && a.index < 0 && ((i = l.enter(e, n, s)) === null || i === void 0 ? void 0 : i.from) != a.from && (t = l);
  for (; ; ) {
    var c = t.enter(e, n, s);
    if (!c)
      return t;
    t = c;
  }
}
var K5 = function() {
  function t() {
    Qe(this, t);
  }
  return Ye(t, [{ key: "cursor", value: function() {
    return new s0(this, arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0);
  } }, { key: "getChild", value: function(e) {
    var n = k$(this, e, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null);
    return n.length ? n[0] : null;
  } }, { key: "getChildren", value: function(e) {
    return k$(this, e, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null);
  } }, { key: "resolve", value: function(e) {
    return hu(this, e, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, !1);
  } }, { key: "resolveInner", value: function(e) {
    return hu(this, e, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, !0);
  } }, { key: "matchContext", value: function(e) {
    return i0(this, e);
  } }, { key: "enterUnfinishedNodesBefore", value: function(e) {
    for (var n = this.childBefore(e), r = this; n; ) {
      var i = n.lastChild;
      if (!i || i.to != n.to)
        break;
      i.type.isError && i.from == i.to ? (r = n, n = i.prevSibling) : n = i;
    }
    return r;
  } }, { key: "node", get: function() {
    return this;
  } }, { key: "next", get: function() {
    return this.parent;
  } }]), t;
}(), Ys = function(t) {
  lt(n, K5);
  var e = ct(n);
  function n(r, i, o, s) {
    var a;
    return Qe(this, n), (a = e.call(this))._tree = r, a.from = i, a.index = o, a._parent = s, a;
  }
  return Ye(n, [{ key: "type", get: function() {
    return this._tree.type;
  } }, { key: "name", get: function() {
    return this._tree.type.name;
  } }, { key: "to", get: function() {
    return this.from + this._tree.length;
  } }, { key: "nextChild", value: function(r, i, o, s) {
    for (var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, l = this; ; ) {
      for (var c = l._tree, u = c.children, f = c.positions, d = i > 0 ? u.length : -1; r != d; r += i) {
        var h = u[r], p = f[r] + l.from;
        if (J5(s, o, p, p + h.length)) {
          if (h instanceof fc) {
            if (a & Jr.ExcludeBuffers)
              continue;
            var m = h.findChild(0, h.buffer.length, i, o - p, s);
            if (m > -1)
              return new o0(new dre(l, h, r, p), null, m);
          } else if (a & Jr.IncludeAnonymous || !h.type.isAnonymous || _y(h)) {
            var g = void 0;
            if (!(a & Jr.IgnoreMounts) && (g = ep.get(h)) && !g.overlay)
              return new n(g.tree, p, r, l);
            var v = new n(h, p, r, l);
            return a & Jr.IncludeAnonymous || !v.type.isAnonymous ? v : v.nextChild(i < 0 ? h.children.length - 1 : 0, i, o, s);
          }
        }
      }
      if (a & Jr.IncludeAnonymous || !l.type.isAnonymous || (r = l.index >= 0 ? l.index + i : i < 0 ? -1 : l._parent._tree.children.length, !(l = l._parent)))
        return null;
    }
  } }, { key: "firstChild", get: function() {
    return this.nextChild(0, 1, 0, 4);
  } }, { key: "lastChild", get: function() {
    return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
  } }, { key: "childAfter", value: function(r) {
    return this.nextChild(0, 1, r, 2);
  } }, { key: "childBefore", value: function(r) {
    return this.nextChild(this._tree.children.length - 1, -1, r, -2);
  } }, { key: "enter", value: function(r, i) {
    var o, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!(s & Jr.IgnoreOverlays) && (o = ep.get(this._tree)) && o.overlay) {
      var a, l = r - this.from, c = qr(o.overlay);
      try {
        for (c.s(); !(a = c.n()).done; ) {
          var u = a.value, f = u.from, d = u.to;
          if ((i > 0 ? f <= l : f < l) && (i < 0 ? d >= l : d > l))
            return new n(o.tree, o.overlay[0].from + this.from, -1, this);
        }
      } catch (h) {
        c.e(h);
      } finally {
        c.f();
      }
    }
    return this.nextChild(0, 1, r, i, s);
  } }, { key: "nextSignificantParent", value: function() {
    for (var r = this; r.type.isAnonymous && r._parent; )
      r = r._parent;
    return r;
  } }, { key: "parent", get: function() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  } }, { key: "nextSibling", get: function() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
  } }, { key: "prevSibling", get: function() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
  } }, { key: "tree", get: function() {
    return this._tree;
  } }, { key: "toTree", value: function() {
    return this._tree;
  } }, { key: "toString", value: function() {
    return this._tree.toString();
  } }]), n;
}();
function k$(t, e, n, r) {
  var i = t.cursor(), o = [];
  if (!i.firstChild())
    return o;
  if (n != null) {
    for (; !i.type.is(n); )
      if (!i.nextSibling())
        return o;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return o;
    if (i.type.is(e) && o.push(i.node), !i.nextSibling())
      return r == null ? o : [];
  }
}
function i0(t, e) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.length - 1, r = t.parent; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (e[n] && e[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
var dre = Ye(function t(e, n, r, i) {
  Qe(this, t), this.parent = e, this.buffer = n, this.index = r, this.start = i;
}), o0 = function(t) {
  lt(n, K5);
  var e = ct(n);
  function n(r, i, o) {
    var s;
    return Qe(this, n), (s = e.call(this)).context = r, s._parent = i, s.index = o, s.type = r.buffer.set.types[r.buffer.buffer[o]], s;
  }
  return Ye(n, [{ key: "name", get: function() {
    return this.type.name;
  } }, { key: "from", get: function() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  } }, { key: "to", get: function() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  } }, { key: "child", value: function(r, i, o) {
    var s = this.context.buffer, a = s.findChild(this.index + 4, s.buffer[this.index + 3], r, i - this.context.start, o);
    return a < 0 ? null : new n(this.context, this, a);
  } }, { key: "firstChild", get: function() {
    return this.child(1, 0, 4);
  } }, { key: "lastChild", get: function() {
    return this.child(-1, 0, 4);
  } }, { key: "childAfter", value: function(r) {
    return this.child(1, r, 2);
  } }, { key: "childBefore", value: function(r) {
    return this.child(-1, r, -2);
  } }, { key: "enter", value: function(r, i) {
    if ((arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0) & Jr.ExcludeBuffers)
      return null;
    var o = this.context.buffer, s = o.findChild(this.index + 4, o.buffer[this.index + 3], i > 0 ? 1 : -1, r - this.context.start, i);
    return s < 0 ? null : new n(this.context, this, s);
  } }, { key: "parent", get: function() {
    return this._parent || this.context.parent.nextSignificantParent();
  } }, { key: "externalSibling", value: function(r) {
    return this._parent ? null : this.context.parent.nextChild(this.context.index + r, r, 0, 4);
  } }, { key: "nextSibling", get: function() {
    var r = this.context.buffer, i = r.buffer[this.index + 3];
    return i < (this._parent ? r.buffer[this._parent.index + 3] : r.buffer.length) ? new n(this.context, this._parent, i) : this.externalSibling(1);
  } }, { key: "prevSibling", get: function() {
    var r = this.context.buffer, i = this._parent ? this._parent.index + 4 : 0;
    return this.index == i ? this.externalSibling(-1) : new n(this.context, this._parent, r.findChild(i, this.index, -1, 0, 4));
  } }, { key: "tree", get: function() {
    return null;
  } }, { key: "toTree", value: function() {
    var r = [], i = [], o = this.context.buffer, s = this.index + 4, a = o.buffer[this.index + 3];
    if (a > s) {
      var l = o.buffer[this.index + 1];
      r.push(o.slice(s, a, l)), i.push(0);
    }
    return new Da(this.type, r, i, this.to - this.from);
  } }, { key: "toString", value: function() {
    return this.context.buffer.childString(this.index);
  } }]), n;
}();
function G5(t) {
  if (!t.length)
    return null;
  for (var e = 0, n = t[0], r = 1; r < t.length; r++) {
    var i = t[r];
    (i.from > n.from || i.to < n.to) && (n = i, e = r);
  }
  var o = n instanceof Ys && n.index < 0 ? null : n.parent, s = t.slice();
  return o ? s[e] = o : s.splice(e, 1), new hre(s, n);
}
var hre = function() {
  function t(e, n) {
    Qe(this, t), this.heads = e, this.node = n;
  }
  return Ye(t, [{ key: "next", get: function() {
    return G5(this.heads);
  } }]), t;
}(), s0 = function() {
  function t(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (Qe(this, t), this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, e instanceof Ys)
      this.yieldNode(e);
    else {
      this._tree = e.context.parent, this.buffer = e.context;
      for (var r = e._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = e, this.yieldBuf(e.index);
    }
  }
  return Ye(t, [{ key: "name", get: function() {
    return this.type.name;
  } }, { key: "yieldNode", value: function(e) {
    return !!e && (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0);
  } }, { key: "yieldBuf", value: function(e, n) {
    this.index = e;
    var r = this.buffer, i = r.start, o = r.buffer;
    return this.type = n || o.set.types[o.buffer[e]], this.from = i + o.buffer[e + 1], this.to = i + o.buffer[e + 2], !0;
  } }, { key: "yield", value: function(e) {
    return !!e && (e instanceof Ys ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)));
  } }, { key: "toString", value: function() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  } }, { key: "enterChild", value: function(e, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, n, r, this.mode));
    var i = this.buffer.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], e, n - this.buffer.start, r);
    return !(o < 0) && (this.stack.push(this.index), this.yieldBuf(o));
  } }, { key: "firstChild", value: function() {
    return this.enterChild(1, 0, 4);
  } }, { key: "lastChild", value: function() {
    return this.enterChild(-1, 0, 4);
  } }, { key: "childAfter", value: function(e) {
    return this.enterChild(1, e, 2);
  } }, { key: "childBefore", value: function(e) {
    return this.enterChild(-1, e, -2);
  } }, { key: "enter", value: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.mode;
    return this.buffer ? !(r & Jr.ExcludeBuffers) && this.enterChild(1, e, n) : this.yield(this._tree.enter(e, n, r));
  } }, { key: "parent", value: function() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Jr.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    var e = this.mode & Jr.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e);
  } }, { key: "sibling", value: function(e) {
    if (!this.buffer)
      return !!this._tree._parent && this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode));
    var n = this.buffer.buffer, r = this.stack.length - 1;
    if (e < 0) {
      var i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(n.findChild(i, this.index, -1, 0, 4));
    } else {
      var o = n.buffer[this.index + 3];
      if (o < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(o);
    }
    return r < 0 && this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode));
  } }, { key: "nextSibling", value: function() {
    return this.sibling(1);
  } }, { key: "prevSibling", value: function() {
    return this.sibling(-1);
  } }, { key: "atLastNode", value: function(e) {
    var n, r, i = this.buffer;
    if (i) {
      if (e > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (var o = 0; o < this.index; o++)
          if (i.buffer.buffer[o + 3] < this.index)
            return !1;
      n = i.index, r = i.parent;
    } else {
      var s = this._tree;
      n = s.index, r = s._parent;
    }
    for (; r; n = (a = r).index, r = a._parent, a) {
      var a;
      if (n > -1)
        for (var l = n + e, c = e < 0 ? -1 : r._tree.children.length; l != c; l += e) {
          var u = r._tree.children[l];
          if (this.mode & Jr.IncludeAnonymous || u instanceof fc || !u.type.isAnonymous || _y(u))
            return !1;
        }
    }
    return !0;
  } }, { key: "move", value: function(e, n) {
    if (n && this.enterChild(e, 0, 4))
      return !0;
    for (; ; ) {
      if (this.sibling(e))
        return !0;
      if (this.atLastNode(e) || !this.parent())
        return !1;
    }
  } }, { key: "next", value: function() {
    var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return this.move(1, e);
  } }, { key: "prev", value: function() {
    var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return this.move(-1, e);
  } }, { key: "moveTo", value: function(e) {
    for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0; (this.from == this.to || (n < 1 ? this.from >= e : this.from > e) || (n > -1 ? this.to <= e : this.to < e)) && this.parent(); )
      ;
    for (; this.enterChild(1, e, n); )
      ;
    return this;
  } }, { key: "node", get: function() {
    if (!this.buffer)
      return this._tree;
    var e = this.bufferNode, n = null, r = 0;
    if (e && e.context == this.buffer)
      e:
        for (var i = this.index, o = this.stack.length; o >= 0; ) {
          for (var s = e; s; s = s._parent)
            if (s.index == i) {
              if (i == this.index)
                return s;
              n = s, r = o + 1;
              break e;
            }
          i = this.stack[--o];
        }
    for (var a = r; a < this.stack.length; a++)
      n = new o0(this.buffer, n, this.stack[a]);
    return this.bufferNode = new o0(this.buffer, n, this.index);
  } }, { key: "tree", get: function() {
    return this.buffer ? null : this._tree._tree;
  } }, { key: "iterate", value: function(e, n) {
    for (var r = 0; ; ) {
      var i = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; i && n && n(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!r)
          return;
        this.parent(), r--, i = !0;
      }
    }
  } }, { key: "matchContext", value: function(e) {
    if (!this.buffer)
      return i0(this.node, e);
    for (var n = this.buffer.buffer, r = n.set.types, i = e.length - 1, o = this.stack.length - 1; i >= 0; o--) {
      if (o < 0)
        return i0(this.node, e, i);
      var s = r[n.buffer[this.stack[o]]];
      if (!s.isAnonymous) {
        if (e[i] && e[i] != s.name)
          return !1;
        i--;
      }
    }
    return !0;
  } }]), t;
}();
function _y(t) {
  return t.children.some(function(e) {
    return e instanceof fc || !e.type.isAnonymous || _y(e);
  });
}
function pre(t) {
  var e, n = t.buffer, r = t.nodeSet, i = t.maxBufferLength, o = i === void 0 ? 1024 : i, s = t.reused, a = s === void 0 ? [] : s, l = t.minRepeatType, c = l === void 0 ? r.types.length : l, u = Array.isArray(n) ? new fre(n, n.length) : n, f = r.types, d = 0, h = 0;
  function p(j, $, N, B, O, I) {
    for (var P = u.id, J = u.start, D = u.end, Q = u.size, Z = h; Q < 0; ) {
      if (u.next(), Q == -1) {
        var L = a[P];
        return N.push(L), void B.push(J - j);
      }
      if (Q == -3)
        return void (d = P);
      if (Q == -4)
        return void (h = P);
      throw new RangeError("Unrecognized record size: ".concat(Q));
    }
    var R, V, M = f[P], C = J - j;
    if (D - J <= o && (V = function(rt, Be) {
      var nt = u.fork(), oe = 0, We = 0, Rt = 0, de = nt.end - o, Se = { size: 0, start: 0, skip: 0 };
      e:
        for (var rn = nt.pos - rt; nt.pos > rn; ) {
          var Dt = nt.size;
          if (nt.id == Be && Dt >= 0)
            Se.size = oe, Se.start = We, Se.skip = Rt, Rt += 4, oe += 4, nt.next();
          else {
            var Xt = nt.pos - Dt;
            if (Dt < 0 || Xt < rn || nt.start < de)
              break;
            var Ue = nt.id >= c ? 4 : 0, kn = nt.start;
            for (nt.next(); nt.pos > Xt; ) {
              if (nt.size < 0) {
                if (nt.size != -3)
                  break e;
                Ue += 4;
              } else
                nt.id >= c && (Ue += 4);
              nt.next();
            }
            We = kn, oe += Dt, Rt += Ue;
          }
        }
      return (Be < 0 || oe == rt) && (Se.size = oe, Se.start = We, Se.skip = Rt), Se.size > 4 ? Se : void 0;
    }(u.pos - $, O))) {
      for (var F = new Uint16Array(V.size - V.skip), z = u.pos - V.size, E = F.length; u.pos > z; )
        E = y(V.start, F, E);
      R = new fc(F, D - V.start, r), C = V.start - j;
    } else {
      var A = u.pos - Q;
      u.next();
      for (var te = [], ge = [], ke = P >= c ? P : -1, Ce = 0, we = D; u.pos > A; )
        ke >= 0 && u.id == ke && u.size >= 0 ? (u.end <= we - o && (g(te, ge, J, Ce, u.end, we, ke, Z), Ce = te.length, we = u.end), u.next()) : I > 2500 ? m(J, A, te, ge) : p(J, A, te, ge, ke, I + 1);
      if (ke >= 0 && Ce > 0 && Ce < te.length && g(te, ge, J, Ce, J, we, ke, Z), te.reverse(), ge.reverse(), ke > -1 && Ce > 0) {
        var le = /* @__PURE__ */ function(rt) {
          return function(Be, nt, oe) {
            var We, Rt, de = 0, Se = Be.length - 1;
            if (Se >= 0 && (We = Be[Se]) instanceof Da) {
              if (!Se && We.type == rt && We.length == oe)
                return We;
              (Rt = We.prop(br.lookAhead)) && (de = nt[Se] + We.length + Rt);
            }
            return v(rt, Be, nt, oe, de);
          };
        }(M);
        R = Ty(M, te, ge, 0, te.length, 0, D - J, le, le);
      } else
        R = v(M, te, ge, D - J, Z - D);
    }
    N.push(R), B.push(C);
  }
  function m(j, $, N, B) {
    for (var O = [], I = 0, P = -1; u.pos > $; ) {
      var J = u.id, D = u.start, Q = u.end;
      if (u.size > 4)
        u.next();
      else {
        if (P > -1 && D < P)
          break;
        P < 0 && (P = Q - o), O.push(J, D, Q), I++, u.next();
      }
    }
    if (I) {
      for (var Z = new Uint16Array(4 * I), L = O[O.length - 2], R = O.length - 3, V = 0; R >= 0; R -= 3)
        Z[V++] = O[R], Z[V++] = O[R + 1] - L, Z[V++] = O[R + 2] - L, Z[V++] = V;
      N.push(new fc(Z, O[2] - L, r)), B.push(L - j);
    }
  }
  function g(j, $, N, B, O, I, P, J) {
    for (var D = [], Q = []; j.length > B; )
      D.push(j.pop()), Q.push($.pop() + N - O);
    j.push(v(r.types[P], D, Q, I - O, J - I)), $.push(O - N);
  }
  function v(j, $, N, B) {
    var O = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, I = arguments.length > 5 ? arguments[5] : void 0;
    if (d) {
      var P = [br.contextHash, d];
      I = I ? [P].concat(I) : [P];
    }
    if (O > 25) {
      var J = [br.lookAhead, O];
      I = I ? [J].concat(I) : [J];
    }
    return new Da(j, $, N, B, I);
  }
  function y(j, $, N) {
    var B = u.id, O = u.start, I = u.end, P = u.size;
    if (u.next(), P >= 0 && B < c) {
      var J = N;
      if (P > 4)
        for (var D = u.pos - (P - 4); u.pos > D; )
          N = y(j, $, N);
      $[--N] = J, $[--N] = I - j, $[--N] = O - j, $[--N] = B;
    } else
      P == -3 ? d = B : P == -4 && (h = B);
    return N;
  }
  for (var w = [], x = []; u.pos > 0; )
    p(t.start || 0, t.bufferStart || 0, w, x, -1, 0);
  var b = (e = t.length) !== null && e !== void 0 ? e : w.length ? x[0] + w[0].length : 0;
  return new Da(f[t.topID], w.reverse(), x.reverse(), b);
}
var $$ = /* @__PURE__ */ new WeakMap();
function Wd(t, e) {
  if (!t.isAnonymous || e instanceof fc || e.type != t)
    return 1;
  var n = $$.get(e);
  if (n == null) {
    n = 1;
    var r, i = qr(e.children);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value;
        if (o.type != t || !(o instanceof Da)) {
          n = 1;
          break;
        }
        n += Wd(t, o);
      }
    } catch (s) {
      i.e(s);
    } finally {
      i.f();
    }
    $$.set(e, n);
  }
  return n;
}
function Ty(t, e, n, r, i, o, s, a, l) {
  for (var c = 0, u = r; u < i; u++)
    c += Wd(t, e[u]);
  var f = Math.ceil(1.5 * c / 8), d = [], h = [];
  return function p(m, g, v, y, w) {
    for (var x = v; x < y; ) {
      var b = x, j = g[x], $ = Wd(t, m[x]);
      for (x++; x < y; x++) {
        var N = Wd(t, m[x]);
        if ($ + N >= f)
          break;
        $ += N;
      }
      if (x == b + 1) {
        if ($ > f) {
          var B = m[b];
          p(B.children, B.positions, 0, B.children.length, g[b] + w);
          continue;
        }
        d.push(m[b]);
      } else {
        var O = g[x - 1] + m[x - 1].length - j;
        d.push(Ty(t, m, g, b, x, j, O, null, l));
      }
      h.push(j + w - o);
    }
  }(e, n, r, i, 0), (a || l)(d, h, s);
}
new br({ perNode: !0 });
var mre = 0, Ts = function() {
  function t(e, n, r) {
    Qe(this, t), this.set = e, this.base = n, this.modified = r, this.id = mre++;
  }
  return Ye(t, null, [{ key: "define", value: function(e) {
    if (e != null && e.base)
      throw new Error("Can not derive from a modified tag");
    var n = new t([], null, []);
    if (n.set.push(n), e) {
      var r, i = qr(e.set);
      try {
        for (i.s(); !(r = i.n()).done; ) {
          var o = r.value;
          n.set.push(o);
        }
      } catch (s) {
        i.e(s);
      } finally {
        i.f();
      }
    }
    return n;
  } }, { key: "defineModifier", value: function() {
    var e = new S$();
    return function(n) {
      return n.modified.indexOf(e) > -1 ? n : S$.get(n.base || n, n.modified.concat(e).sort(function(r, i) {
        return r.id - i.id;
      }));
    };
  } }]), t;
}(), gre = 0, S$ = function() {
  function t() {
    Qe(this, t), this.instances = [], this.id = gre++;
  }
  return Ye(t, null, [{ key: "get", value: function(e, n) {
    if (!n.length)
      return e;
    var r = n[0].instances.find(function(m) {
      return m.base == e && (g = n, v = m.modified, g.length == v.length && g.every(function(y, w) {
        return y == v[w];
      }));
      var g, v;
    });
    if (r)
      return r;
    var i, o = [], s = new Ts(o, e, n), a = qr(n);
    try {
      for (a.s(); !(i = a.n()).done; )
        i.value.instances.push(s);
    } catch (m) {
      a.e(m);
    } finally {
      a.f();
    }
    var l, c = function(m) {
      for (var g = [[]], v = 0; v < m.length; v++)
        for (var y = 0, w = g.length; y < w; y++)
          g.push(g[y].concat(m[v]));
      return g.sort(function(x, b) {
        return b.length - x.length;
      });
    }(n), u = qr(e.set);
    try {
      for (u.s(); !(l = u.n()).done; ) {
        var f = l.value;
        if (!f.modified.length) {
          var d, h = qr(c);
          try {
            for (h.s(); !(d = h.n()).done; ) {
              var p = d.value;
              o.push(t.get(f, p));
            }
          } catch (m) {
            h.e(m);
          } finally {
            h.f();
          }
        }
      }
    } catch (m) {
      u.e(m);
    } finally {
      u.f();
    }
    return s;
  } }]), t;
}();
new br();
var tt = Ts.define, bd = tt(), Ps = tt(), C$ = tt(Ps), O$ = tt(Ps), Rs = tt(), xd = tt(Rs), og = tt(Rs), Oo = tt(), xa = tt(Oo), $o = tt(), So = tt(), a0 = tt(), qc = tt(a0), wd = tt(), Qt = { comment: bd, lineComment: tt(bd), blockComment: tt(bd), docComment: tt(bd), name: Ps, variableName: tt(Ps), typeName: C$, tagName: tt(C$), propertyName: O$, attributeName: tt(O$), className: tt(Ps), labelName: tt(Ps), namespace: tt(Ps), macroName: tt(Ps), literal: Rs, string: xd, docString: tt(xd), character: tt(xd), attributeValue: tt(xd), number: og, integer: tt(og), float: tt(og), bool: tt(Rs), regexp: tt(Rs), escape: tt(Rs), color: tt(Rs), url: tt(Rs), keyword: $o, self: tt($o), null: tt($o), atom: tt($o), unit: tt($o), modifier: tt($o), operatorKeyword: tt($o), controlKeyword: tt($o), definitionKeyword: tt($o), moduleKeyword: tt($o), operator: So, derefOperator: tt(So), arithmeticOperator: tt(So), logicOperator: tt(So), bitwiseOperator: tt(So), compareOperator: tt(So), updateOperator: tt(So), definitionOperator: tt(So), typeOperator: tt(So), controlOperator: tt(So), punctuation: a0, separator: tt(a0), bracket: qc, angleBracket: tt(qc), squareBracket: tt(qc), paren: tt(qc), brace: tt(qc), content: Oo, heading: xa, heading1: tt(xa), heading2: tt(xa), heading3: tt(xa), heading4: tt(xa), heading5: tt(xa), heading6: tt(xa), contentSeparator: tt(Oo), list: tt(Oo), quote: tt(Oo), emphasis: tt(Oo), strong: tt(Oo), link: tt(Oo), monospace: tt(Oo), strikethrough: tt(Oo), inserted: tt(), deleted: tt(), changed: tt(), invalid: tt(), meta: wd, documentMeta: tt(wd), annotation: tt(wd), processingInstruction: tt(wd), definition: Ts.defineModifier(), constant: Ts.defineModifier(), function: Ts.defineModifier(), standard: Ts.defineModifier(), local: Ts.defineModifier(), special: Ts.defineModifier() };
(function(t, e) {
  var n, r = /* @__PURE__ */ Object.create(null), i = qr(t);
  try {
    for (i.s(); !(n = i.n()).done; ) {
      var o = n.value;
      if (Array.isArray(o.tag)) {
        var s, a = qr(o.tag);
        try {
          for (a.s(); !(s = a.n()).done; ) {
            var l = s.value;
            r[l.id] = o.class;
          }
        } catch (u) {
          a.e(u);
        } finally {
          a.f();
        }
      } else
        r[o.tag.id] = o.class;
    }
  } catch (u) {
    i.e(u);
  } finally {
    i.f();
  }
  var c = e || {};
  c.scope, c.all;
})([{ tag: Qt.link, class: "tok-link" }, { tag: Qt.heading, class: "tok-heading" }, { tag: Qt.emphasis, class: "tok-emphasis" }, { tag: Qt.strong, class: "tok-strong" }, { tag: Qt.keyword, class: "tok-keyword" }, { tag: Qt.atom, class: "tok-atom" }, { tag: Qt.bool, class: "tok-bool" }, { tag: Qt.url, class: "tok-url" }, { tag: Qt.labelName, class: "tok-labelName" }, { tag: Qt.inserted, class: "tok-inserted" }, { tag: Qt.deleted, class: "tok-deleted" }, { tag: Qt.literal, class: "tok-literal" }, { tag: Qt.string, class: "tok-string" }, { tag: Qt.number, class: "tok-number" }, { tag: [Qt.regexp, Qt.escape, Qt.special(Qt.string)], class: "tok-string2" }, { tag: Qt.variableName, class: "tok-variableName" }, { tag: Qt.local(Qt.variableName), class: "tok-variableName tok-local" }, { tag: Qt.definition(Qt.variableName), class: "tok-variableName tok-definition" }, { tag: Qt.special(Qt.variableName), class: "tok-variableName2" }, { tag: Qt.definition(Qt.propertyName), class: "tok-propertyName tok-definition" }, { tag: Qt.typeName, class: "tok-typeName" }, { tag: Qt.namespace, class: "tok-namespace" }, { tag: Qt.className, class: "tok-className" }, { tag: Qt.macroName, class: "tok-macroName" }, { tag: Qt.propertyName, class: "tok-propertyName" }, { tag: Qt.operator, class: "tok-operator" }, { tag: Qt.comment, class: "tok-comment" }, { tag: Qt.meta, class: "tok-meta" }, { tag: Qt.invalid, class: "tok-invalid" }, { tag: Qt.punctuation, class: "tok-punctuation" }]);
var Py = lf.define([{ tag: Qt.propertyName, color: "var(--internal-key-color)" }, { tag: Qt.number, color: "var(--internal-value-color-number)" }, { tag: Qt.bool, color: "var(--internal-value-color-boolean)" }, { tag: Qt.string, color: "var(--internal-value-color-string)" }, { tag: Qt.keyword, color: "var(--internal-value-color-null)" }]), vre = A3(Py), yre = Py.style;
function bre(t) {
  At(t, "svelte-a0poeb", '.jse-text-mode.svelte-a0poeb.svelte-a0poeb{--internal-key-color:var(--jse-key-color, #1a1a1a);--internal-value-color-number:var(--jse-value-color-number, #ee422e);--internal-value-color-boolean:var(--jse-value-color-boolean, #ff8c00);--internal-value-color-string:var(--jse-value-color-string, #008000);--internal-value-color-null:var(--jse-value-color-null, #004ed0);flex:1;box-sizing:border-box;display:flex;flex-direction:column;background:var(--jse-background-color, #fff)}.jse-text-mode.no-main-menu.svelte-a0poeb.svelte-a0poeb{border-top:var(--jse-main-border, 1px solid #d7d7d7)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb{flex:1;display:flex;position:relative;flex-direction:column;overflow:hidden;min-width:0;min-height:0;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-text-mode.svelte-a0poeb .jse-contents.jse-hidden.svelte-a0poeb{visibility:hidden;position:absolute;top:0;left:0}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor{flex:1;overflow:hidden}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-scroller{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);line-height:var(--jse-line-height, calc(1em + 4px));color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-gutters{background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color-readonly, #b2b2b2);border-right:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-activeLine,.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-activeLineGutter{background:var(--jse-active-line-background-color, rgba(0, 0, 0, 0.06))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-selectionBackground{background:var(--jse-selection-background-color, #d3d3d3)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-searchMatch{background-color:var(--jse-search-match-color, #ffe665);outline:var(--jse-search-match-outline, 1px solid #ffd700)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-searchMatch.cm-searchMatch-selected{background-color:var(--jse-search-match-active-color, #ffd700);outline:var(--jse-search-match-active-outline, 1px solid #e1be00)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-selectionMatch{background-color:var(--jse-search-match-background-color, rgba(153, 255, 119, 0.5019607843))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-foldPlaceholder{background:var(--jse-tag-background, rgba(0, 0, 0, 0.2));color:var(--jse-tag-color, var(--jse-text-color-inverse, #fff));border:none;padding:0 var(--jse-padding, 10px)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-tooltip{font-size:var(--jse-font-size, 16px);font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);color:var(--jse-tooltip-color, var(--jse-text-color, #4d4d4d));background:var(--jse-tooltip-background, var(--jse-modal-background, #f5f5f5));border:var(--jse-tooltip-border, var(--jse-main-border, 1px solid #d7d7d7))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-diagnosticAction{background:var(--jse-tooltip-action-button-color, var(--jse-text-color-inverse, #fff));background:var(--jse-tooltip-action-button-background, #4d4d4d)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-panels{border-bottom:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search{background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color, var(--jse-text-color, #4d4d4d));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search input{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-text-mode-search, 80%);color:var(--jse-input-color, var(--jse-text-color, #4d4d4d));border:var(--jse-input-border, 1px solid #d8dbdf);background:var(--jse-input-background, var(--jse-background-color, #fff));margin-right:2px}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search button{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-text-mode-search, 80%);color:var(--jse-panel-button-color, inherit);background:var(--jse-panel-button-background, transparent);border:none;cursor:pointer;text-transform:capitalize;padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);margin:0}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search button:hover{color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d));background:var(--jse-panel-button-background-highlight, #e0e0e0)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search label{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-text-mode-search, 80%);padding-left:var(--jse-padding, 10px)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search label input{margin-right:2px}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search button[name="close"]{width:32px;height:32px;font-size:24px;line-height:24px;padding:0;right:0;top:-4px}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-cursor-primary{border-color:var(--jse-text-color, #4d4d4d)}.jse-text-mode.svelte-a0poeb .jse-contents .jse-loading-space.svelte-a0poeb{flex:1}.jse-text-mode.svelte-a0poeb .jse-contents .jse-loading.svelte-a0poeb{flex:2;text-align:center;color:var(--jse-panel-color-readonly, #b2b2b2);box-sizing:border-box;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}.jse-text-mode.svelte-a0poeb .jse-contents.jse-preview.svelte-a0poeb{flex:1;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-panel-color-readonly, #b2b2b2);overflow:auto;white-space:pre-wrap;word-break:break-word;padding:2px}');
}
function sg(t) {
  var e = t.slice(), n = e[11].length === 0;
  return e[98] = n, e;
}
function E$(t) {
  var e, n;
  return e = new ire({ props: { readOnly: t[1], onFormat: t[17], onCompact: t[18], onSort: t[19], onTransform: t[20], onToggleSearch: t[21], onUndo: t[22], onRedo: t[23], canFormat: !t[98], canCompact: !t[98], canSort: !t[98], canTransform: !t[98], canUndo: t[12], canRedo: t[13], onRenderMenu: t[4] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2 & i[0] && (o.readOnly = r[1]), 2048 & i[0] && (o.canFormat = !r[98]), 2048 & i[0] && (o.canCompact = !r[98]), 2048 & i[0] && (o.canSort = !r[98]), 2048 & i[0] && (o.canTransform = !r[98]), 4096 & i[0] && (o.canUndo = r[12]), 8192 & i[0] && (o.canRedo = r[13]), 16 & i[0] && (o.onRenderMenu = r[4]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function xre(t) {
  var e;
  return { c: function() {
    (e = H("div")).innerHTML = '<div class="jse-loading-space svelte-a0poeb"></div> <div class="jse-loading svelte-a0poeb">loading...</div>', k(e, "class", "jse-contents svelte-a0poeb");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, i: Pe, o: Pe, d: function(n) {
    n && Y(e);
  } };
}
function wre(t) {
  var e, n, r, i, o, s = t[97] && A$(t), a = !t[97] && M$(t);
  return { c: function() {
    e = H("div"), n = se(), s && s.c(), r = se(), a && a.c(), i = un(), k(e, "class", "jse-contents svelte-a0poeb"), $e(e, "jse-hidden", t[97]);
  }, m: function(l, c) {
    X(l, e, c), t[52](e), X(l, n, c), s && s.m(l, c), X(l, r, c), a && a.m(l, c), X(l, i, c), o = !0;
  }, p: function(l, c) {
    (!o || 268438016 & c[0]) && $e(e, "jse-hidden", l[97]), l[97] ? s ? (s.p(l, c), 2560 & c[0] && S(s, 1)) : ((s = A$(l)).c(), S(s, 1), s.m(r.parentNode, r)) : s && (Ae(), _(s, 1, 1, function() {
      s = null;
    }), Me()), l[97] ? a && (Ae(), _(a, 1, 1, function() {
      a = null;
    }), Me()) : a ? (a.p(l, c), 2560 & c[0] && S(a, 1)) : ((a = M$(l)).c(), S(a, 1), a.m(i.parentNode, i));
  }, i: function(l) {
    o || (S(s), S(a), o = !0);
  }, o: function(l) {
    _(s), _(a), o = !1;
  }, d: function(l) {
    l && (Y(e), Y(n), Y(r), Y(i)), t[52](null), s && s.d(l), a && a.d(l);
  } };
}
function A$(t) {
  var e, n, r, i, o, s = ys(t[11] || "", Nv) + "";
  return e = new vo({ props: { icon: al, type: "error", message: "The JSON document is larger than ".concat(vd(Iv, 1024), ", ") + "and may crash your browser when loading it in text mode. Actual size: ".concat(vd(t[11].length, 1024), "."), actions: [{ text: "Open anyway", title: "Open the document in text mode. This may freeze or crash your browser.", onClick: t[24] }, { text: "Open in tree mode", title: "Open the document in tree mode. Tree mode can handle large documents.", onClick: t[25] }, { text: "Cancel", title: "Cancel opening this large document.", onClick: t[26] }], onClose: t[5] } }), { c: function() {
    xe(e.$$.fragment), n = se(), r = H("div"), i = Le(s), k(r, "class", "jse-contents jse-preview svelte-a0poeb");
  }, m: function(a, l) {
    ye(e, a, l), X(a, n, l), X(a, r, l), T(r, i), o = !0;
  }, p: function(a, l) {
    var c = {};
    2048 & l[0] && (c.message = "The JSON document is larger than ".concat(vd(Iv, 1024), ", ") + "and may crash your browser when loading it in text mode. Actual size: ".concat(vd(a[11].length, 1024), ".")), e.$set(c), (!o || 2048 & l[0]) && s !== (s = ys(a[11] || "", Nv) + "") && bt(i, s);
  }, i: function(a) {
    o || (S(e.$$.fragment, a), o = !0);
  }, o: function(a) {
    _(e.$$.fragment, a), o = !1;
  }, d: function(a) {
    a && (Y(n), Y(r)), be(e, a);
  } };
}
function M$(t) {
  var e, n, r, i, o, s = !t[14] && t[0] && Ew(t[11]), a = t[3] && _$(t), l = t[14] && T$(t), c = s && P$(t);
  return i = new ky({ props: { validationErrors: t[10], selectError: t[27] } }), { c: function() {
    a && a.c(), e = se(), l && l.c(), n = se(), c && c.c(), r = se(), xe(i.$$.fragment);
  }, m: function(u, f) {
    a && a.m(u, f), X(u, e, f), l && l.m(u, f), X(u, n, f), c && c.m(u, f), X(u, r, f), ye(i, u, f), o = !0;
  }, p: function(u, f) {
    u[3] ? a ? (a.p(u, f), 8 & f[0] && S(a, 1)) : ((a = _$(u)).c(), S(a, 1), a.m(e.parentNode, e)) : a && (Ae(), _(a, 1, 1, function() {
      a = null;
    }), Me()), u[14] ? l ? (l.p(u, f), 16384 & f[0] && S(l, 1)) : ((l = T$(u)).c(), S(l, 1), l.m(n.parentNode, n)) : l && (Ae(), _(l, 1, 1, function() {
      l = null;
    }), Me()), 18433 & f[0] && (s = !u[14] && u[0] && Ew(u[11])), s ? c ? (c.p(u, f), 18433 & f[0] && S(c, 1)) : ((c = P$(u)).c(), S(c, 1), c.m(r.parentNode, r)) : c && (Ae(), _(c, 1, 1, function() {
      c = null;
    }), Me());
    var d = {};
    1024 & f[0] && (d.validationErrors = u[10]), i.$set(d);
  }, i: function(u) {
    o || (S(a), S(l), S(c), S(i.$$.fragment, u), o = !0);
  }, o: function(u) {
    _(a), _(l), _(c), _(i.$$.fragment, u), o = !1;
  }, d: function(u) {
    u && (Y(e), Y(n), Y(r)), a && a.d(u), l && l.d(u), c && c.d(u), be(i, u);
  } };
}
function _$(t) {
  var e, n;
  return e = new lre({ props: { editorState: t[8] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    256 & i[0] && (o.editorState = r[8]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function T$(t) {
  var e, n;
  return e = new vo({ props: { type: "error", icon: al, message: t[14].message, actions: t[15], onClick: t[29], onClose: t[5] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    16384 & i[0] && (o.message = r[14].message), 32768 & i[0] && (o.actions = r[15]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function P$(t) {
  var e, n;
  return e = new vo({ props: { type: "success", message: "Do you want to format the JSON?", actions: [{ icon: Xv, text: "Format", title: "Format JSON: add proper indentation and new lines (Ctrl+I)", onClick: t[17] }, { icon: Gl, text: "No thanks", title: "Close this message", onClick: t[53] }], onClose: t[5] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i[0] && (o.actions = [{ icon: Xv, text: "Format", title: "Format JSON: add proper indentation and new lines (Ctrl+I)", onClick: r[17] }, { icon: Gl, text: "No thanks", title: "Close this message", onClick: r[53] }]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function jre(t) {
  var e, n, r, i, o, s = t[2] && E$(sg(t)), a = [wre, xre], l = [];
  function c(u, f) {
    return f === 0 ? function(d) {
      var h = d.slice(), p = h[28](h[11], h[9]);
      return h[97] = p, h;
    }(u) : u;
  }
  return r = function(u, f) {
    return u[16] ? 1 : 0;
  }(t), i = l[r] = a[r](c(t, r)), { c: function() {
    e = H("div"), s && s.c(), n = se(), i.c(), k(e, "class", "jse-text-mode svelte-a0poeb"), $e(e, "no-main-menu", !t[2]);
  }, m: function(u, f) {
    X(u, e, f), s && s.m(e, null), T(e, n), l[r].m(e, null), t[54](e), o = !0;
  }, p: function(u, f) {
    u[2] ? s ? (s.p(sg(u), f), 4 & f[0] && S(s, 1)) : ((s = E$(sg(u))).c(), S(s, 1), s.m(e, n)) : s && (Ae(), _(s, 1, 1, function() {
      s = null;
    }), Me()), i.p(c(u, r), f), (!o || 4 & f[0]) && $e(e, "no-main-menu", !u[2]);
  }, i: function(u) {
    o || (S(s), S(i), o = !0);
  }, o: function(u) {
    _(s), _(i), o = !1;
  }, d: function(u) {
    u && Y(e), s && s.d(), l[r].d(), t[54](null);
  } };
}
function R$(t) {
  return { from: t.from || 0, to: t.to || 0, message: t.message || "", actions: t.actions, severity: t.severity };
}
function kre(t, e, n) {
  var r, i, o, s, a, l, c = e.readOnly, u = e.mainMenuBar, f = e.statusBar, d = e.askToFormat, h = e.externalContent, p = e.externalSelection, m = e.indentation, g = e.tabSize, v = e.escapeUnicodeCharacters, y = e.parser, w = e.validator, x = e.validationParser, b = e.onChange, j = e.onChangeMode, $ = e.onSelect, N = e.onError, B = e.onFocus, O = e.onBlur, I = e.onRenderMenu, P = e.onSortModal, J = e.onTransformModal, D = Tr("jsoneditor:TextMode"), Q = { key: "Mod-i", run: nt, shift: oe, preventDefault: !0 }, Z = typeof window > "u";
  D("isSSR:", Z);
  var L = !1, R = [], V = new ts(), M = new ts(), C = new ts(), F = new ts(), z = new ts(), E = h, A = qv(E, m, y), te = v;
  Fi(Tt(Ie().mark(function me() {
    return Ie().wrap(function(Ke) {
      for (; ; )
        switch (Ke.prev = Ke.next) {
          case 0:
            if (!Z) {
              Ke.next = 2;
              break;
            }
            return Ke.abrupt("return");
          case 2:
            try {
              a = Dt({ target: o, initialText: Ge(A, L) ? "" : r.escapeValue(A), readOnly: c, indentation: m });
            } catch (It) {
              console.error(It);
            }
          case 3:
          case "end":
            return Ke.stop();
        }
    }, me);
  }))), Ci(function() {
    a && (D("Destroy CodeMirror editor"), a.destroy());
  });
  var ge = !1, ke = !1, Ce = Kl(), we = Kl();
  function le() {
    a && (D("focus"), a.focus());
  }
  var rt = !1;
  function Be(me) {
    D("patch", me);
    var Ke = y.parse(A), It = so(Ke, me), Nt = SS(Ke, me);
    return fn({ text: y.stringify(It, null, m) }), { json: It, previousJson: Ke, undo: Nt, redo: me };
  }
  function nt() {
    if (D("format"), c)
      return !1;
    try {
      var me = y.parse(A);
      return fn({ text: y.stringify(me, null, m) }), n(0, d = !0), !0;
    } catch (Ke) {
      N(Ke);
    }
    return !1;
  }
  function oe() {
    if (D("compact"), c)
      return !1;
    try {
      var me = y.parse(A);
      return fn({ text: y.stringify(me) }), n(0, d = !1), !0;
    } catch (Ke) {
      N(Ke);
    }
    return !1;
  }
  function We() {
    if (D("repair"), !c)
      try {
        fn({ text: Lo(A) }), n(51, xn = Wm), n(14, Dn = null);
      } catch (me) {
        N(me);
      }
  }
  function Rt(me) {
    var Ke = me.id, It = me.rootPath, Nt = me.onTransform, ce = me.onClose;
    try {
      var qe = y.parse(A);
      rt = !0, J({ id: Ke || we, json: qe, rootPath: It || [], onTransform: function(Fe) {
        Nt ? Nt({ operations: Fe, json: qe, transformedJson: so(qe, Fe) }) : (D("onTransform", Fe), Be(Fe));
      }, onClose: function() {
        rt = !1, le(), ce && ce();
      } });
    } catch (Fe) {
      N(Fe);
    }
  }
  function de(me, Ke) {
    D("setSelection", { anchor: me, head: Ke }), a && a.dispatch(a.state.update({ selection: { anchor: me, head: Ke }, scrollIntoView: !0 }));
  }
  function Se(me, Ke) {
    if (Ke.state.selection.ranges.length === 1) {
      var It = Ke.state.selection.ranges[0], Nt = A.slice(It.from, It.to);
      if (Nt === "{" || Nt === "[") {
        var ce = th.parse(A), qe = Object.keys(ce.pointers).find(function(Lt) {
          var qt;
          return ((qt = ce.pointers[Lt].value) === null || qt === void 0 ? void 0 : qt.pos) === It.from;
        }), Fe = ce.pointers[qe];
        qe && Fe && Fe.value && Fe.valueEnd && (D("pointer found, selecting inner contents of path:", qe, Fe), de(Fe.value.pos + 1, Fe.valueEnd.pos - 1));
      }
    }
  }
  function rn() {
    return NH(wn, { delay: 300 });
  }
  function Dt(me) {
    var Ke = me.target, It = me.initialText, Nt = me.readOnly, ce = me.indentation;
    D("Create CodeMirror editor", { readOnly: Nt, indentation: ce });
    var qe = gn.create({ doc: It, selection: q(p), extensions: [uh.of([CH, Q]), V.of(rn()), HH(), rF(), sF(), Cz(), kV(), QF(), mz(), xz(), gn.allowMultipleSelections.of(!0), IF(), A3(eV, { fallback: !0 }), aV(), nW(), hW(), Lz(), zz(), Tz(), lU(), uh.of([].concat(Ft(sW), Ft(SH), Ft(EU), Ft(RV), Ft(WF), Ft(D8), Ft(PH))), vre, xW({ hideFirstIndent: !0 }), at.domEventHandlers({ dblclick: Se }), at.updateListener.of(function(Fe) {
      n(8, l = Fe.state), Fe.docChanged ? Xe() : Fe.selectionSet && Jt();
    }), rU(), vU({ top: !0 }), M.of(gn.readOnly.of(Nt)), F.of(gn.tabSize.of(g)), C.of(_e(ce)), z.of(at.theme({}, { dark: Xt() })), at.lineWrapping, jW] });
    return a = new at({ state: qe, parent: Ke });
  }
  function Xt() {
    return !!o && getComputedStyle(o).getPropertyValue("--jse-theme").includes("dark");
  }
  function Ue(me) {
    var Ke = me.path, It = me.message, Nt = function(ce, qe) {
      try {
        var Fe = th.parse(ce), Lt = Je(qe), qt = Fe.pointers[Lt];
        if (qt)
          return { path: qe, line: qt.key ? qt.key.line : qt.value ? qt.value.line : 0, column: qt.key ? qt.key.column : qt.value ? qt.value.column : 0, from: qt.key ? qt.key.pos : qt.value ? qt.value.pos : 0, to: qt.keyEnd ? qt.keyEnd.pos : qt.valueEnd ? qt.valueEnd.pos : 0 };
      } catch (U) {
        console.error(U);
      }
      return null;
    }(r.escapeValue(A), Ke);
    return { path: Ke, line: Nt.line, column: Nt.column, from: Nt.from, to: Nt.to, message: It, severity: gs.warning, actions: [] };
  }
  function kn(me, Ke) {
    var It = me.line, Nt = me.column, ce = me.position, qe = me.message;
    return { path: [], line: It, column: Nt, from: ce, to: ce, severity: gs.error, message: qe, actions: Ke && !c ? [{ name: "Auto repair", apply: function() {
      return We();
    } }] : null };
  }
  function fn(me) {
    var Ke = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], It = qv(me, m, y), Nt = !tn(me, E), ce = E;
    E = me, n(11, A = It), D("setCodeMirrorContent", { isChanged: Nt, forceUpdate: Ke }), a && (Nt || Ke) && (Ge(A, L) || a.dispatch({ changes: { from: 0, to: a.state.doc.length, insert: r.escapeValue(A) } }), yt(), Nt && on(E, ce));
  }
  function q(me) {
    return Vv(me) ? Te.fromJSON(me) : void 0;
  }
  function ee() {
    return (ee = Tt(Ie().mark(function me() {
      return Ie().wrap(function(Ke) {
        for (; ; )
          switch (Ke.prev = Ke.next) {
            case 0:
              return D("refresh"), Ke.next = 3, he();
            case 3:
            case "end":
              return Ke.stop();
          }
      }, me);
    }))).apply(this, arguments);
  }
  function ne() {
    if (a) {
      var me = a ? r.unescapeValue(a.state.doc.toString()) : "", Ke = me !== A;
      if (D("onChangeCodeMirrorValue", { isChanged: Ke }), Ke) {
        var It = E;
        n(11, A = me), E = { text: A }, yt(), on(E, It), lr().then(Jt);
      }
    }
  }
  function he() {
    return je.apply(this, arguments);
  }
  function je() {
    return (je = Tt(Ie().mark(function me() {
      var Ke;
      return Ie().wrap(function(It) {
        for (; ; )
          switch (It.prev = It.next) {
            case 0:
              return It.next = 2, lr();
            case 2:
              a && (Ke = Xt(), D("updateTheme", { dark: Ke }), a.dispatch({ effects: [z.reconfigure(at.theme({}, { dark: Ke }))] }));
            case 3:
            case "end":
              return It.stop();
          }
      }, me);
    }))).apply(this, arguments);
  }
  function _e(me) {
    return Cp.of(typeof me == "number" ? " ".repeat(me) : me);
  }
  function yt() {
    n(12, ge = CV(a.state) > 0), n(13, ke = OV(a.state) > 0), D({ canUndo: ge, canRedo: ke });
  }
  Ci(function() {
    Zt();
  }), jy({ onMount: Fi, onDestroy: Ci, getWindow: function() {
    return $c(s);
  }, hasFocus: function() {
    return rt && document.hasFocus() || gy(s);
  }, onFocus: B, onBlur: function() {
    Zt(), O();
  } });
  var Xe = ef(ne, 300);
  function Zt() {
    Xe.flush();
  }
  function on(me, Ke) {
    b && b(me, Ke, { contentErrors: $n(), patchResult: null });
  }
  function Jt() {
    $(fe({ type: On.text }, l.selection.toJSON()));
  }
  function Ge(me, Ke) {
    return !!me && me.length > Iv && !Ke;
  }
  var xn = Wm, Dn = null;
  function wn() {
    if (Ge(A, L))
      return [];
    var me = $n();
    return Gj(me) ? [R$(kn(me.parseError, me.isRepairable))] : WZ(me) ? me.validationErrors.map(Ue).map(R$) : [];
  }
  function $n() {
    D("validate:start"), Zt();
    var me = Rn(r.escapeValue(A), w, y, x);
    return Gj(me) ? (n(51, xn = me.isRepairable ? jw : "invalid"), n(14, Dn = me.parseError), n(10, R = [])) : (n(51, xn = Wm), n(14, Dn = null), n(10, R = (me == null ? void 0 : me.validationErrors) || [])), D("validate:end"), me;
  }
  var Rn = nf(OZ);
  function Jn() {
    Dn && function(me) {
      D("select parse error", me);
      var Ke = kn(me, !1);
      de(Ke.from != null ? Ke.from : 0, Ke.to != null ? Ke.to : 0), le();
    }(Dn);
  }
  var pn = { icon: YL, text: "Show me", title: "Move to the parse error location", onClick: Jn };
  return t.$$set = function(me) {
    "readOnly" in me && n(1, c = me.readOnly), "mainMenuBar" in me && n(2, u = me.mainMenuBar), "statusBar" in me && n(3, f = me.statusBar), "askToFormat" in me && n(0, d = me.askToFormat), "externalContent" in me && n(30, h = me.externalContent), "externalSelection" in me && n(31, p = me.externalSelection), "indentation" in me && n(32, m = me.indentation), "tabSize" in me && n(33, g = me.tabSize), "escapeUnicodeCharacters" in me && n(34, v = me.escapeUnicodeCharacters), "parser" in me && n(35, y = me.parser), "validator" in me && n(36, w = me.validator), "validationParser" in me && n(37, x = me.validationParser), "onChange" in me && n(38, b = me.onChange), "onChangeMode" in me && n(39, j = me.onChangeMode), "onSelect" in me && n(40, $ = me.onSelect), "onError" in me && n(41, N = me.onError), "onFocus" in me && n(42, B = me.onFocus), "onBlur" in me && n(43, O = me.onBlur), "onRenderMenu" in me && n(4, I = me.onRenderMenu), "onSortModal" in me && n(44, P = me.onSortModal), "onTransformModal" in me && n(45, J = me.onTransformModal);
  }, t.$$.update = function() {
    8 & t.$$.dirty[1] && (r = hy({ escapeControlCharacters: !1, escapeUnicodeCharacters: v })), 1073741824 & t.$$.dirty[0] && fn(h), 1 & t.$$.dirty[1] && function(me) {
      if (Vv(me)) {
        var Ke = q(me);
        !a || !Ke || l && l.selection.eq(Ke) || (D("applyExternalSelection", Ke), a.dispatch({ selection: Ke }));
      }
    }(p), 32 & t.$$.dirty[1] && function(me) {
      D("updateLinter", me), a && a.dispatch({ effects: V.reconfigure(rn()) });
    }(w), 2 & t.$$.dirty[1] && function(me) {
      a && (D("updateIndentation", me), a.dispatch({ effects: C.reconfigure(_e(me)) }));
    }(m), 4 & t.$$.dirty[1] && function(me) {
      a && (D("updateTabSize", me), a.dispatch({ effects: F.reconfigure(gn.tabSize.of(me)) }));
    }(g), 2 & t.$$.dirty[0] && function(me) {
      a && (D("updateReadOnly", me), a.dispatch({ effects: [M.reconfigure(gn.readOnly.of(me))] }));
    }(c), 524296 & t.$$.dirty[1] && te !== v && (n(50, te = v), D("forceUpdateText", { escapeUnicodeCharacters: v }), a && a.dispatch({ changes: { from: 0, to: a.state.doc.length, insert: r.escapeValue(A) } })), 2 & t.$$.dirty[0] | 1048576 & t.$$.dirty[1] && n(15, i = xn !== jw || c ? [pn] : [{ icon: xp, text: "Auto repair", title: "Automatically repair JSON", onClick: We }, pn]);
  }, [d, c, u, f, I, le, o, s, l, L, R, A, ge, ke, Dn, i, Z, nt, oe, function() {
    var me;
    if (!c)
      try {
        var Ke = y.parse(A);
        rt = !0, P({ id: Ce, json: Ke, rootPath: [], onSort: (me = Tt(Ie().mark(function It(Nt) {
          var ce;
          return Ie().wrap(function(qe) {
            for (; ; )
              switch (qe.prev = qe.next) {
                case 0:
                  ce = Nt.operations, D("onSort", ce), Be(ce);
                case 3:
                case "end":
                  return qe.stop();
              }
          }, It);
        })), function(It) {
          return me.apply(this, arguments);
        }), onClose: function() {
          rt = !1, le();
        } });
      } catch (It) {
        N(It);
      }
  }, function() {
    c || Rt({ rootPath: [] });
  }, function() {
    a && (o && o.querySelector(".cm-search") ? g1(a) : m1(a));
  }, function() {
    c || a && (l1(a), le());
  }, function() {
    c || a && (bh(a), le());
  }, function() {
    n(9, L = !0), fn(h, !0);
  }, function() {
    j(Lr.tree);
  }, function() {
    ne();
  }, function(me) {
    D("select validation error", me);
    var Ke = Ue(me);
    de(Ke.from, Ke.to), le();
  }, Ge, Jn, h, p, m, g, v, y, w, x, b, j, $, N, B, O, P, J, Be, Rt, function() {
    return ee.apply(this, arguments);
  }, $n, te, xn, function(me) {
    Kt[me ? "unshift" : "push"](function() {
      n(6, o = me);
    });
  }, function() {
    return n(0, d = !1);
  }, function(me) {
    Kt[me ? "unshift" : "push"](function() {
      n(7, s = me);
    });
  }];
}
Py.style = function(t) {
  return yre(t || []);
};
var $re = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, kre, jre, Pt, { readOnly: 1, mainMenuBar: 2, statusBar: 3, askToFormat: 0, externalContent: 30, externalSelection: 31, indentation: 32, tabSize: 33, escapeUnicodeCharacters: 34, parser: 35, validator: 36, validationParser: 37, onChange: 38, onChangeMode: 39, onSelect: 40, onError: 41, onFocus: 42, onBlur: 43, onRenderMenu: 4, onSortModal: 44, onTransformModal: 45, focus: 5, patch: 46, openTransformModal: 47, refresh: 48, validate: 49 }, bre, [-1, -1, -1, -1]), i;
  }
  return Ye(n, [{ key: "focus", get: function() {
    return this.$$.ctx[5];
  } }, { key: "patch", get: function() {
    return this.$$.ctx[46];
  } }, { key: "openTransformModal", get: function() {
    return this.$$.ctx[47];
  } }, { key: "refresh", get: function() {
    return this.$$.ctx[48];
  } }, { key: "validate", get: function() {
    return this.$$.ctx[49];
  } }]), n;
}();
function Sre(t) {
  var e, n;
  return e = new Zp({ props: { items: t[0] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & Et(i, 1)[0] && (o.items = r[0]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Cre(t, e, n) {
  var r, i, o = e.json, s = e.readOnly, a = e.historyState, l = e.onSort, c = e.onTransform, u = e.onContextMenu, f = e.onUndo, d = e.onRedo, h = e.onRenderMenu;
  return t.$$set = function(p) {
    "json" in p && n(1, o = p.json), "readOnly" in p && n(2, s = p.readOnly), "historyState" in p && n(3, a = p.historyState), "onSort" in p && n(4, l = p.onSort), "onTransform" in p && n(5, c = p.onTransform), "onContextMenu" in p && n(6, u = p.onContextMenu), "onUndo" in p && n(7, f = p.onUndo), "onRedo" in p && n(8, d = p.onRedo), "onRenderMenu" in p && n(9, h = p.onRenderMenu);
  }, t.$$.update = function() {
    510 & t.$$.dirty && n(10, r = s ? [{ type: "space" }] : [{ type: "button", icon: wp, title: "Sort", className: "jse-sort", onClick: l, disabled: s || o === void 0 }, { type: "button", icon: bp, title: "Transform contents (filter, sort, project)", className: "jse-transform", onClick: c, disabled: s || o === void 0 }, { type: "button", icon: DS, title: cy, className: "jse-contextmenu", onClick: u }, { type: "separator" }, { type: "button", icon: B0, title: "Undo (Ctrl+Z)", className: "jse-undo", onClick: f, disabled: !a.canUndo }, { type: "button", icon: L0, title: "Redo (Ctrl+Shift+Z)", className: "jse-redo", onClick: d, disabled: !a.canRedo }, { type: "space" }]), 1536 & t.$$.dirty && n(0, i = h(r) || r);
  }, [i, o, s, a, l, c, u, f, d, h, r];
}
var Ore = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Cre, Sre, Pt, { json: 1, readOnly: 2, historyState: 3, onSort: 4, onTransform: 5, onContextMenu: 6, onUndo: 7, onRedo: 8, onRenderMenu: 9 }), i;
  }
  return Ye(n);
}();
function N$(t, e, n) {
  var r = t.slice();
  return r[9] = e[n], r;
}
function I$(t) {
  var e, n, r, i = [t[9].props], o = t[9].component;
  function s(a, l) {
    var c = {};
    if (l !== void 0 && 1 & l)
      c = Vi(i, [Ka(a[9].props)]);
    else
      for (var u = 0; u < i.length; u += 1)
        c = di(c, i[u]);
    return { props: c };
  }
  return o && (e = Wo(o, s(t))), { c: function() {
    e && xe(e.$$.fragment), n = un();
  }, m: function(a, l) {
    e && ye(e, a, l), X(a, n, l), r = !0;
  }, p: function(a, l) {
    if (1 & l && o !== (o = a[9].component)) {
      if (e) {
        Ae();
        var c = e;
        _(c.$$.fragment, 1, 0, function() {
          be(c, 1);
        }), Me();
      }
      o ? (xe((e = Wo(o, s(a, l))).$$.fragment), S(e.$$.fragment, 1), ye(e, n.parentNode, n)) : e = null;
    } else if (o) {
      var u = 1 & l ? Vi(i, [Ka(a[9].props)]) : {};
      e.$set(u);
    }
  }, i: function(a) {
    r || (e && S(e.$$.fragment, a), r = !0);
  }, o: function(a) {
    e && _(e.$$.fragment, a), r = !1;
  }, d: function(a) {
    a && Y(n), e && be(e, a);
  } };
}
function D$(t) {
  var e, n, r = t[9].component, i = I$(t);
  return { c: function() {
    i.c(), e = un();
  }, m: function(o, s) {
    i.m(o, s), X(o, e, s), n = !0;
  }, p: function(o, s) {
    1 & s && Pt(r, r = o[9].component) ? (Ae(), _(i, 1, 1, Pe), Me(), (i = I$(o)).c(), S(i, 1), i.m(e.parentNode, e)) : i.p(o, s);
  }, i: function(o) {
    n || (S(i), n = !0);
  }, o: function(o) {
    _(i), n = !1;
  }, d: function(o) {
    o && Y(e), i.d(o);
  } };
}
function Ere(t) {
  for (var e, n, r = Ot(t[0]), i = [], o = 0; o < r.length; o += 1)
    i[o] = D$(N$(t, r, o));
  var s = function(a) {
    return _(i[a], 1, 1, function() {
      i[a] = null;
    });
  };
  return { c: function() {
    for (var a = 0; a < i.length; a += 1)
      i[a].c();
    e = un();
  }, m: function(a, l) {
    for (var c = 0; c < i.length; c += 1)
      i[c] && i[c].m(a, l);
    X(a, e, l), n = !0;
  }, p: function(a, l) {
    var c = Et(l, 1)[0];
    if (1 & c) {
      var u;
      for (r = Ot(a[0]), u = 0; u < r.length; u += 1) {
        var f = N$(a, r, u);
        i[u] ? (i[u].p(f, c), S(i[u], 1)) : (i[u] = D$(f), i[u].c(), S(i[u], 1), i[u].m(e.parentNode, e));
      }
      for (Ae(), u = r.length; u < i.length; u += 1)
        s(u);
      Me();
    }
  }, i: function(a) {
    if (!n) {
      for (var l = 0; l < r.length; l += 1)
        S(i[l]);
      n = !0;
    }
  }, o: function(a) {
    i = i.filter(Boolean);
    for (var l = 0; l < i.length; l += 1)
      _(i[l]);
    n = !1;
  }, d: function(a) {
    a && Y(e), fr(i, a);
  } };
}
function Are(t, e, n) {
  var r, i, o = e.path, s = e.value, a = e.context, l = e.enforceString, c = e.selection, u = e.searchResultItems;
  function f(d, h) {
    return a.onPatch(function(p, m) {
      return p.flatMap(function(g) {
        if (T0(g)) {
          var v = uo(g.path);
          if (v.length > 0) {
            for (var y = [g], w = en(v); w.length > 0 && !Ri(m, w); )
              y.unshift({ op: "add", path: Je(w), value: {} }), w = en(w);
            return y;
          }
        }
        return g;
      });
    }(d, a.getJson()), h);
  }
  return t.$$set = function(d) {
    "path" in d && n(1, o = d.path), "value" in d && n(2, s = d.value), "context" in d && n(3, a = d.context), "enforceString" in d && n(4, l = d.enforceString), "selection" in d && n(5, c = d.selection), "searchResultItems" in d && n(6, u = d.searchResultItems);
  }, t.$$.update = function() {
    40 & t.$$.dirty && n(7, r = !a.readOnly && an(c) && Hi(c)), 254 & t.$$.dirty && n(0, i = a.onRenderValue({ path: o, value: s, readOnly: a.readOnly, enforceString: l, isEditing: r, parser: a.parser, normalization: a.normalization, selection: c, searchResultItems: u, onPatch: f, onPasteJson: a.onPasteJson, onSelect: a.onSelect, onFind: a.onFind, findNextInside: a.findNextInside, focus: a.focus }));
  }, [i, o, s, a, l, c, u, r];
}
var Mre = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Are, Ere, Pt, { path: 1, value: 2, context: 3, enforceString: 4, selection: 5, searchResultItems: 6 }), i;
  }
  return Ye(n);
}();
function _re(t) {
  At(t, "svelte-1o4m3u7", '.jse-inline-value.svelte-1o4m3u7{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);line-height:var(--jse-line-height, calc(1em + 4px));border:none;padding:0 calc(0.5 * var(--jse-padding, 10px));background:transparent;color:inherit;cursor:pointer}.jse-inline-value.svelte-1o4m3u7:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-inline-value.jse-selected.svelte-1o4m3u7{background:var(--jse-selection-background-color, #d3d3d3)}');
}
function Tre(t) {
  var e, n, r, i, o = ys(t[2].stringify(t[1]), 50) + "";
  return { c: function() {
    e = H("button"), n = Le(o), k(e, "type", "button"), k(e, "class", "jse-inline-value svelte-1o4m3u7"), $e(e, "jse-selected", t[3]);
  }, m: function(s, a) {
    X(s, e, a), T(e, n), r || (i = Oe(e, "dblclick", t[5]), r = !0);
  }, p: function(s, a) {
    var l = Et(a, 1)[0];
    6 & l && o !== (o = ys(s[2].stringify(s[1]), 50) + "") && bt(n, o), 8 & l && $e(e, "jse-selected", s[3]);
  }, i: Pe, o: Pe, d: function(s) {
    s && Y(e), r = !1, i();
  } };
}
function Pre(t, e, n) {
  var r = e.path, i = e.value, o = e.parser, s = e.isSelected, a = e.onEdit;
  return t.$$set = function(l) {
    "path" in l && n(0, r = l.path), "value" in l && n(1, i = l.value), "parser" in l && n(2, o = l.parser), "isSelected" in l && n(3, s = l.isSelected), "onEdit" in l && n(4, a = l.onEdit);
  }, [r, i, o, s, a, function() {
    return a(r);
  }];
}
var Rre = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Pre, Tre, Pt, { path: 0, value: 1, parser: 2, isSelected: 3, onEdit: 4 }, _re), i;
  }
  return Ye(n);
}();
function Nre(t) {
  At(t, "svelte-2v0aqj", ".jse-column-header.svelte-2v0aqj.svelte-2v0aqj{background:none;border:none;font-family:inherit;font-size:inherit;color:inherit;display:flex;gap:var(--jse-padding, 10px);padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px)) calc(0.5 * var(--jse-padding, 10px));width:100%}.jse-column-header.svelte-2v0aqj.svelte-2v0aqj:hover{background:var(--jse-table-header-background-highlight, #e8e8e8)}.jse-column-header.svelte-2v0aqj.svelte-2v0aqj:not(.jse-column-header.jse-readonly){cursor:pointer}.jse-column-header.svelte-2v0aqj span.jse-column-sort-icon.svelte-2v0aqj{height:1em}");
}
function L$(t) {
  var e, n, r, i;
  return n = new cn({ props: { data: t[1] === Di.asc ? Ti : Yb } }), { c: function() {
    e = H("span"), xe(n.$$.fragment), k(e, "class", "jse-column-sort-icon svelte-2v0aqj"), k(e, "title", r = "Currently sorted in ".concat(t[2], " order"));
  }, m: function(o, s) {
    X(o, e, s), ye(n, e, null), i = !0;
  }, p: function(o, s) {
    var a = {};
    2 & s && (a.data = o[1] === Di.asc ? Ti : Yb), n.$set(a), (!i || 4 & s && r !== (r = "Currently sorted in ".concat(o[2], " order"))) && k(e, "title", r);
  }, i: function(o) {
    i || (S(n.$$.fragment, o), i = !0);
  }, o: function(o) {
    _(n.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && Y(e), be(n);
  } };
}
function Ire(t) {
  var e, n, r, i, o, s, a, l, c = ys(t[3], 50) + "", u = t[1] !== void 0 && L$(t);
  return { c: function() {
    e = H("button"), n = H("span"), r = Le(c), i = se(), u && u.c(), k(n, "class", "jse-column-name"), k(e, "type", "button"), k(e, "class", "jse-column-header svelte-2v0aqj"), k(e, "title", o = t[0] ? t[3] : t[3] + " (Click to sort the data by this column)"), $e(e, "jse-readonly", t[0]);
  }, m: function(f, d) {
    X(f, e, d), T(e, n), T(n, r), T(e, i), u && u.m(e, null), s = !0, a || (l = Oe(e, "click", t[4]), a = !0);
  }, p: function(f, d) {
    var h = Et(d, 1)[0];
    (!s || 8 & h) && c !== (c = ys(f[3], 50) + "") && bt(r, c), f[1] !== void 0 ? u ? (u.p(f, h), 2 & h && S(u, 1)) : ((u = L$(f)).c(), S(u, 1), u.m(e, null)) : u && (Ae(), _(u, 1, 1, function() {
      u = null;
    }), Me()), (!s || 9 & h && o !== (o = f[0] ? f[3] : f[3] + " (Click to sort the data by this column)")) && k(e, "title", o), (!s || 1 & h) && $e(e, "jse-readonly", f[0]);
  }, i: function(f) {
    s || (S(u), s = !0);
  }, o: function(f) {
    _(u), s = !1;
  }, d: function(f) {
    f && Y(e), u && u.d(), a = !1, l();
  } };
}
function Dre(t, e, n) {
  var r, i, o, s = e.path, a = e.sortedColumn, l = e.readOnly, c = e.onSort;
  return t.$$set = function(u) {
    "path" in u && n(5, s = u.path), "sortedColumn" in u && n(6, a = u.sortedColumn), "readOnly" in u && n(0, l = u.readOnly), "onSort" in u && n(7, c = u.onSort);
  }, t.$$.update = function() {
    var u;
    32 & t.$$.dirty && n(3, r = nn(s) ? "values" : hi(s)), 96 & t.$$.dirty && n(1, i = a && tn(s, (u = a) === null || u === void 0 ? void 0 : u.path) ? a.sortDirection : void 0), 2 & t.$$.dirty && n(2, o = i ? BQ[i] : void 0);
  }, [l, i, o, r, function() {
    l || c({ path: s, sortDirection: i === Di.asc ? Di.desc : Di.asc });
  }, s, a, c];
}
var jd, kd, Lre = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Dre, Ire, Pt, { path: 5, sortedColumn: 6, readOnly: 0, onSort: 7 }, Nre), i;
  }
  return Ye(n);
}();
function Q5(t, e) {
  return jd || (kd = /* @__PURE__ */ new WeakMap(), jd = new ResizeObserver(function(n) {
    var r, i = qr(n);
    try {
      for (i.s(); !(r = i.n()).done; ) {
        var o = r.value, s = kd.get(o.target);
        s && s(o.target);
      }
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
  })), kd.set(t, e), jd.observe(t), { destroy: function() {
    kd.delete(t), jd.unobserve(t);
  } };
}
function Bre(t) {
  var e, n;
  return e = new I5({ props: { items: t[1], tip: t[0] ? "Tip: you can open this context menu via right-click or with Ctrl+Q" : void 0 } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    2 & i[0] && (o.items = r[1]), 1 & i[0] && (o.tip = r[0] ? "Tip: you can open this context menu via right-click or with Ctrl+Q" : void 0), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function qre(t, e, n) {
  var r, i, o, s, a, l, c, u, f, d = e.json, h = e.documentState, p = e.parser, m = e.showTip, g = e.onCloseContextMenu, v = e.onEditValue, y = e.onEditRow, w = e.onToggleEnforceString, x = e.onCut, b = e.onCopy, j = e.onPaste, $ = e.onRemove, N = e.onDuplicateRow, B = e.onInsertBeforeRow, O = e.onInsertAfterRow, I = e.onRemoveRow;
  function P() {
    g(), v();
  }
  function J() {
    g(), y();
  }
  function D() {
    g(), w();
  }
  function Q() {
    g(), x(!0);
  }
  function Z() {
    g(), x(!1);
  }
  function L() {
    g(), b(!0);
  }
  function R() {
    g(), b(!1);
  }
  function V() {
    g(), j();
  }
  function M() {
    g(), $();
  }
  function C() {
    g(), N();
  }
  function F() {
    g(), B();
  }
  function z() {
    g(), O();
  }
  function E() {
    g(), I();
  }
  return t.$$set = function(A) {
    "json" in A && n(2, d = A.json), "documentState" in A && n(3, h = A.documentState), "parser" in A && n(4, p = A.parser), "showTip" in A && n(0, m = A.showTip), "onCloseContextMenu" in A && n(5, g = A.onCloseContextMenu), "onEditValue" in A && n(6, v = A.onEditValue), "onEditRow" in A && n(7, y = A.onEditRow), "onToggleEnforceString" in A && n(8, w = A.onToggleEnforceString), "onCut" in A && n(9, x = A.onCut), "onCopy" in A && n(10, b = A.onCopy), "onPaste" in A && n(11, j = A.onPaste), "onRemove" in A && n(12, $ = A.onRemove), "onDuplicateRow" in A && n(13, N = A.onDuplicateRow), "onInsertBeforeRow" in A && n(14, B = A.onInsertBeforeRow), "onInsertAfterRow" in A && n(15, O = A.onInsertAfterRow), "onRemoveRow" in A && n(16, I = A.onRemoveRow);
  }, t.$$.update = function() {
    8 & t.$$.dirty[0] && n(22, r = h.selection), 4 & t.$$.dirty[0] && n(24, i = d !== void 0), 4194304 & t.$$.dirty[0] && n(17, o = !!r), 4194308 & t.$$.dirty[0] && n(23, s = d !== void 0 && r ? it(d, mt(r)) : void 0), 20971520 & t.$$.dirty[0] && n(18, a = i && (Sn(r) || dr(r) || an(r))), 20971520 & t.$$.dirty[0] && n(21, l = i && r != null && Hh(r)), 10485760 & t.$$.dirty[0] && n(19, c = l && !Xn(s)), 12582936 & t.$$.dirty[0] && n(20, u = r != null && bs(s, h.enforceStringMap, Je(mt(r)), p)), 4063232 & t.$$.dirty[0] && n(1, f = [{ type: "separator" }, { type: "row", items: [{ type: "column", items: [{ type: "label", text: "Table cell:" }, { type: "dropdown-button", main: { type: "button", onClick: P, icon: Tl, text: "Edit", title: "Edit the value (Double-click on the value)", disabled: !l }, width: "11em", items: [{ type: "button", icon: Tl, text: "Edit", title: "Edit the value (Double-click on the value)", onClick: P, disabled: !l }, { type: "button", icon: u ? ku : $u, text: "Enforce string", title: "Enforce keeping the value as string when it contains a numeric value", onClick: D, disabled: !c }] }, { type: "dropdown-button", main: { type: "button", onClick: Q, icon: _l, text: "Cut", title: "Cut selected contents, formatted with indentation (Ctrl+X)", disabled: !a }, width: "10em", items: [{ type: "button", icon: _l, text: "Cut formatted", title: "Cut selected contents, formatted with indentation (Ctrl+X)", onClick: Q, disabled: !a }, { type: "button", icon: _l, text: "Cut compacted", title: "Cut selected contents, without indentation (Ctrl+Shift+X)", onClick: Z, disabled: !a }] }, { type: "dropdown-button", main: { type: "button", onClick: L, icon: Vs, text: "Copy", title: "Copy selected contents, formatted with indentation (Ctrl+C)", disabled: !a }, width: "12em", items: [{ type: "button", icon: Vs, text: "Copy formatted", title: "Copy selected contents, formatted with indentation (Ctrl+C)", onClick: L, disabled: !a }, { type: "button", icon: Vs, text: "Copy compacted", title: "Copy selected contents, without indentation (Ctrl+Shift+C)", onClick: R, disabled: !a }] }, { type: "button", onClick: V, icon: NS, text: "Paste", title: "Paste clipboard contents (Ctrl+V)", disabled: !o }, { type: "button", onClick: M, icon: Og, text: "Remove", title: "Remove selected contents (Delete)", disabled: !a }] }, { type: "column", items: [{ type: "label", text: "Table row:" }, { type: "button", onClick: J, icon: Tl, text: "Edit row", title: "Edit the current row", disabled: !a }, { type: "button", onClick: C, icon: BS, text: "Duplicate row", title: "Duplicate the current row", disabled: !o }, { type: "button", onClick: F, icon: kl, text: "Insert before", title: "Insert a row before the current row", disabled: !o }, { type: "button", onClick: z, icon: kl, text: "Insert after", title: "Insert a row after the current row", disabled: !o }, { type: "button", onClick: E, icon: Og, text: "Remove row", title: "Remove current row", disabled: !o }] }] }]);
  }, [m, f, d, h, p, g, v, y, w, x, b, j, $, N, B, O, I, o, a, c, u, l, r, s, i];
}
var zre = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, qre, Bre, Pt, { json: 2, documentState: 3, parser: 4, showTip: 0, onCloseContextMenu: 5, onEditValue: 6, onEditRow: 7, onToggleEnforceString: 8, onCut: 9, onCopy: 10, onPaste: 11, onRemove: 12, onDuplicateRow: 13, onInsertBeforeRow: 14, onInsertAfterRow: 15, onRemoveRow: 16 }, null, [-1, -1]), i;
  }
  return Ye(n);
}();
function Fre(t) {
  At(t, "svelte-fxr3ye", '.jse-table-mode-welcome.svelte-fxr3ye.svelte-fxr3ye{flex:1;display:flex;flex-direction:column;overflow:auto;align-items:center;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode-welcome.svelte-fxr3ye.svelte-fxr3ye:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode-welcome.svelte-fxr3ye .jse-space.jse-before.svelte-fxr3ye{flex:1}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays.svelte-fxr3ye{display:flex;flex-direction:column;gap:var(--jse-padding, 10px);max-width:300px;margin:2em var(--jse-padding, 10px);font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays .jse-nested-arrays-info.svelte-fxr3ye{color:var(--jse-panel-color-readonly, #b2b2b2)}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action.svelte-fxr3ye{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px;text-align:left}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action.svelte-fxr3ye:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action.svelte-fxr3ye:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action .jse-nested-array-count.svelte-fxr3ye{opacity:0.5;white-space:nowrap}.jse-table-mode-welcome.svelte-fxr3ye .jse-space.jse-after.svelte-fxr3ye{flex:2}');
}
function B$(t, e, n) {
  var r = t.slice();
  r[13] = e[n];
  var i = it(r[0], r[13]).length;
  return r[14] = i, r;
}
function Vre(t) {
  var e, n;
  return { c: function() {
    e = Le(t[7]), n = Le(" cannot be opened in table mode.");
  }, m: function(r, i) {
    X(r, e, i), X(r, n, i);
  }, p: function(r, i) {
    128 & i && bt(e, r[7]);
  }, d: function(r) {
    r && (Y(e), Y(n));
  } };
}
function Hre(t) {
  var e;
  return { c: function() {
    e = Le(`An object cannot be opened in table mode. You can open a nested array instead, or open the
        document in tree mode.`);
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, d: function(n) {
    n && Y(e);
  } };
}
function Ure(t) {
  var e;
  return { c: function() {
    e = Le("You can open the document in tree mode instead.");
  }, m: function(n, r) {
    X(n, e, r);
  }, d: function(n) {
    n && Y(e);
  } };
}
function Wre(t) {
  var e, n, r;
  return { c: function() {
    e = Le("You can open the document in tree mode instead, or paste a JSON Array using "), (n = H("b")).textContent = "Ctrl+V", r = Le(".");
  }, m: function(i, o) {
    X(i, e, o), X(i, n, o), X(i, r, o);
  }, d: function(i) {
    i && (Y(e), Y(n), Y(r));
  } };
}
function q$(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p = hi(t[13]) + "", m = t[14] + "", g = t[14] !== 1 ? "items" : "item";
  function v() {
    return t[11](t[13]);
  }
  return { c: function() {
    e = H("button"), n = Le(t[8]), r = Le(' "'), i = Le(p), o = Le(`"
        `), s = H("span"), a = Le("("), l = Le(m), c = se(), u = Le(g), f = Le(")"), k(s, "class", "jse-nested-array-count svelte-fxr3ye"), k(e, "type", "button"), k(e, "class", "jse-nested-array-action svelte-fxr3ye");
  }, m: function(y, w) {
    X(y, e, w), T(e, n), T(e, r), T(e, i), T(e, o), T(e, s), T(s, a), T(s, l), T(s, c), T(s, u), T(s, f), d || (h = Oe(e, "click", v), d = !0);
  }, p: function(y, w) {
    t = y, 256 & w && bt(n, t[8]), 16 & w && p !== (p = hi(t[13]) + "") && bt(i, p), 17 & w && m !== (m = t[14] + "") && bt(l, m), 17 & w && g !== (g = t[14] !== 1 ? "items" : "item") && bt(u, g);
  }, d: function(y) {
    y && Y(e), d = !1, h();
  } };
}
function Jre(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y;
  function w(P, J) {
    return P[6] ? Hre : Vre;
  }
  var x = w(t), b = x(t);
  function j(P, J) {
    return P[5] && !P[1] ? Wre : Ure;
  }
  for (var $ = j(t), N = $(t), B = Ot(t[4]), O = [], I = 0; I < B.length; I += 1)
    O[I] = q$(B$(t, B, I));
  return { c: function() {
    e = H("div"), n = H("div"), r = se(), i = H("div"), o = H("div"), s = Le(t[7]), a = se(), l = H("div"), b.c(), c = se(), N.c(), u = se();
    for (var P = 0; P < O.length; P += 1)
      O[P].c();
    f = se(), d = H("button"), h = Le(t[8]), p = Le(" in tree mode"), m = se(), g = H("div"), k(n, "class", "jse-space jse-before svelte-fxr3ye"), k(o, "class", "jse-nested-arrays-title"), k(l, "class", "jse-nested-arrays-info svelte-fxr3ye"), k(d, "type", "button"), k(d, "class", "jse-nested-array-action svelte-fxr3ye"), k(i, "class", "jse-nested-arrays svelte-fxr3ye"), k(g, "class", "jse-space jse-after svelte-fxr3ye"), k(e, "class", "jse-table-mode-welcome svelte-fxr3ye");
  }, m: function(P, J) {
    X(P, e, J), T(e, n), T(e, r), T(e, i), T(i, o), T(o, s), T(i, a), T(i, l), b.m(l, null), T(l, c), N.m(l, null), T(i, u);
    for (var D = 0; D < O.length; D += 1)
      O[D] && O[D].m(i, null);
    T(i, f), T(i, d), T(d, h), T(d, p), T(e, m), T(e, g), v || (y = Oe(d, "click", t[12]), v = !0);
  }, p: function(P, J) {
    var D = Et(J, 1)[0];
    if (128 & D && bt(s, P[7]), x === (x = w(P)) && b ? b.p(P, D) : (b.d(1), (b = x(P)) && (b.c(), b.m(l, c))), $ !== ($ = j(P)) && (N.d(1), (N = $(P)) && (N.c(), N.m(l, null))), 277 & D) {
      var Q;
      for (B = Ot(P[4]), Q = 0; Q < B.length; Q += 1) {
        var Z = B$(P, B, Q);
        O[Q] ? O[Q].p(Z, D) : (O[Q] = q$(Z), O[Q].c(), O[Q].m(i, f));
      }
      for (; Q < O.length; Q += 1)
        O[Q].d(1);
      O.length = B.length;
    }
    256 & D && bt(h, P[8]);
  }, i: Pe, o: Pe, d: function(P) {
    P && Y(e), b.d(), N.d(), fr(O, P), v = !1, y();
  } };
}
function Kre(t, e, n) {
  var r, i, o, s, a, l = e.text, c = e.json, u = e.readOnly, f = e.parser, d = e.openJSONEditorModal, h = e.onChangeMode;
  return t.$$set = function(p) {
    "text" in p && n(9, l = p.text), "json" in p && n(0, c = p.json), "readOnly" in p && n(1, u = p.readOnly), "parser" in p && n(10, f = p.parser), "openJSONEditorModal" in p && n(2, d = p.openJSONEditorModal), "onChangeMode" in p && n(3, h = p.onChangeMode);
  }, t.$$.update = function() {
    2 & t.$$.dirty && n(8, r = u ? "View" : "Edit"), 1 & t.$$.dirty && n(4, a = c ? function(p) {
      var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, g = [];
      return function v(y, w) {
        er(y) && w.length < m && Object.keys(y).forEach(function(x) {
          v(y[x], w.concat(x));
        }), Tn(y) && g.push(w);
      }(p, []), g;
    }(c).slice(0, 99).filter(function(p) {
      return p.length > 0;
    }) : []), 16 & t.$$.dirty && n(6, i = !nn(a)), 513 & t.$$.dirty && n(5, o = c === void 0 && (l === "" || l === void 0)), 1121 & t.$$.dirty && n(7, s = i ? "Object with nested arrays" : o ? "An empty document" : er(c) ? "An object" : Tn(c) ? "An empty array" : "A ".concat(fy(c, f)));
  }, [c, u, d, h, a, o, i, s, r, l, f, function(p) {
    return d(p);
  }, function() {
    return h(Lr.tree);
  }];
}
var Gre = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Kre, Jre, Pt, { text: 9, json: 0, readOnly: 1, parser: 10, openJSONEditorModal: 2, onChangeMode: 3 }, Fre), i;
  }
  return Ye(n);
}();
function Qre(t) {
  At(t, "svelte-1nml1r3", ".jse-column-header.svelte-1nml1r3{background:none;border:none;font-family:inherit;font-size:inherit;color:inherit;display:flex;gap:var(--jse-padding, 10px);padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px)) calc(0.5 * var(--jse-padding, 10px));width:100%}.jse-column-header.svelte-1nml1r3:hover{background:var(--jse-table-header-background-highlight, #e8e8e8)}.jse-column-header.svelte-1nml1r3:not(.jse-column-header.jse-readonly){cursor:pointer}");
}
function Yre(t) {
  var e, n, r, i, o, s;
  return n = new cn({ props: { data: uB } }), { c: function() {
    e = H("button"), xe(n.$$.fragment), k(e, "type", "button"), k(e, "class", "jse-column-header svelte-1nml1r3"), k(e, "title", r = "The Columns are created by sampling ".concat(t[1], " items out of ").concat(t[0], ". ") + "If you're missing a column, click here to sample all of the items instead of a subset. This is slower.");
  }, m: function(a, l) {
    X(a, e, l), ye(n, e, null), i = !0, o || (s = Oe(e, "click", t[3]), o = !0);
  }, p: function(a, l) {
    var c = Et(l, 1)[0];
    (!i || 3 & c && r !== (r = "The Columns are created by sampling ".concat(a[1], " items out of ").concat(a[0], ". ") + "If you're missing a column, click here to sample all of the items instead of a subset. This is slower.")) && k(e, "title", r);
  }, i: function(a) {
    i || (S(n.$$.fragment, a), i = !0);
  }, o: function(a) {
    _(n.$$.fragment, a), i = !1;
  }, d: function(a) {
    a && Y(e), be(n), o = !1, s();
  } };
}
function Xre(t, e, n) {
  var r = e.count, i = e.maxSampleCount, o = e.onRefresh;
  return t.$$set = function(s) {
    "count" in s && n(0, r = s.count), "maxSampleCount" in s && n(1, i = s.maxSampleCount), "onRefresh" in s && n(2, o = s.onRefresh);
  }, [r, i, o, function() {
    return o();
  }];
}
var Zre = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Xre, Yre, Pt, { count: 0, maxSampleCount: 1, onRefresh: 2 }, Qre), i;
  }
  return Ye(n);
}();
function eie(t) {
  At(t, "svelte-1bunebm", '.jse-table-mode.svelte-1bunebm.svelte-1bunebm{flex:1;display:flex;flex-direction:column;position:relative;background:var(--jse-background-color, #fff);min-width:0;min-height:0;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-text-color, #4d4d4d);line-height:var(--jse-line-height, calc(1em + 4px))}.jse-table-mode.no-main-menu.svelte-1bunebm.svelte-1bunebm{border-top:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode.svelte-1bunebm .jse-hidden-input-label.svelte-1bunebm{position:fixed;right:0;top:0;width:0;height:0}.jse-table-mode.svelte-1bunebm .jse-hidden-input-label .jse-hidden-input.svelte-1bunebm{width:0;height:0;padding:0;border:0;outline:none}.jse-table-mode.svelte-1bunebm .jse-contents.svelte-1bunebm{flex:1;align-items:start;flex-direction:column;display:flex;overflow:auto;overflow-anchor:none;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode.svelte-1bunebm .jse-contents.svelte-1bunebm:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main.svelte-1bunebm{border-collapse:collapse;border-spacing:0}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-invisible-start-section td.svelte-1bunebm,.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-invisible-end-section td.svelte-1bunebm{margin:0;padding:0}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-invisible-end-section td.svelte-1bunebm{padding-bottom:var(--jse-padding, 10px)}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row.svelte-1bunebm:hover{background-color:var(--jse-table-row-odd-background, rgba(0, 0, 0, 0.05))}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.svelte-1bunebm{padding:0 var(--jse-padding, 10px) 0 0;vertical-align:top;white-space:nowrap;height:var(--jse-line-height, calc(1em + 4px))}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-header.svelte-1bunebm,.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-gutter.svelte-1bunebm{font-weight:normal;text-align:left;color:var(--jse-text-readonly, #8d8d8d);background:var(--jse-table-header-background, #f5f5f5)}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-header.svelte-1bunebm{padding:0;position:sticky;top:0}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-header .jse-table-root-error.svelte-1bunebm{padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px)) calc(0.5 * var(--jse-padding, 10px))}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-gutter.svelte-1bunebm{padding:0 var(--jse-padding, 10px) 0 calc(0.5 * var(--jse-padding, 10px))}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-selected-value.svelte-1bunebm>.jse-value{background:var(--jse-selection-background-color, #d3d3d3)}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.svelte-1bunebm div{display:inline-flex}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.svelte-1bunebm div.jse-value{overflow-wrap:normal;white-space:nowrap;vertical-align:top;display:inline-block}.jse-table-mode.svelte-1bunebm .jse-contents table.jse-table-main .jse-table-row .jse-table-cell .jse-context-menu-anchor.svelte-1bunebm{position:relative;vertical-align:top}.jse-table-mode.svelte-1bunebm .jse-contents.jse-contents-loading.svelte-1bunebm{align-items:unset}.jse-table-mode.svelte-1bunebm .jse-contents.jse-contents-loading .jse-loading-space.svelte-1bunebm{flex:1}.jse-table-mode.svelte-1bunebm .jse-contents.jse-contents-loading .jse-loading.svelte-1bunebm{flex:2;text-align:center;color:var(--jse-panel-color-readonly, #b2b2b2);box-sizing:border-box;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}');
}
function z$(t, e, n) {
  var r = t.slice();
  r[122] = e[n], r[126] = n;
  var i = r[23].startIndex + r[126];
  r[123] = i;
  var o = r[22].rows[r[123]];
  return r[124] = o, r;
}
function F$(t, e, n) {
  var r, i = t.slice();
  i[127] = e[n], i[133] = n;
  var o = [String(i[123])].concat(i[127]);
  i[128] = o;
  var s = it(i[122], i[127]);
  i[129] = s;
  var a = an(i[11].selection) && aa(i[11].selection.path, i[128]);
  i[130] = a;
  var l = (r = i[124]) === null || r === void 0 ? void 0 : r.columns[i[133]];
  return i[131] = l, i;
}
function V$(t, e, n) {
  var r = t.slice();
  return r[127] = e[n], r;
}
function H$(t) {
  var e, n;
  return e = new Ore({ props: { json: t[8], readOnly: t[0], historyState: t[20], onSort: t[41], onTransform: t[42], onUndo: t[43], onRedo: t[44], onContextMenu: t[33], onRenderMenu: t[5] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    256 & i[0] && (o.json = r[8]), 1 & i[0] && (o.readOnly = r[0]), 1048576 & i[0] && (o.historyState = r[20]), 32 & i[0] && (o.onRenderMenu = r[5]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function tie(t) {
  var e;
  return { c: function() {
    (e = H("div")).innerHTML = '<div class="jse-loading-space svelte-1bunebm"></div> <div class="jse-loading svelte-1bunebm">loading...</div>', k(e, "class", "jse-contents jse-contents-loading svelte-1bunebm");
  }, m: function(n, r) {
    X(n, e, r);
  }, p: Pe, i: Pe, o: Pe, d: function(n) {
    n && Y(e);
  } };
}
function nie(t) {
  var e, n, r, i, o, s, a, l, c, u = [oie, iie, rie], f = [];
  function d(h, p) {
    return h[25] ? 0 : h[17] && h[16] !== void 0 && h[16] !== "" ? 1 : 2;
  }
  return i = d(t), o = f[i] = u[i](t), { c: function() {
    e = H("label"), n = H("input"), r = se(), o.c(), s = un(), k(n, "type", "text"), n.readOnly = !0, k(n, "tabindex", "-1"), k(n, "class", "jse-hidden-input svelte-1bunebm"), k(e, "class", "jse-hidden-input-label svelte-1bunebm");
  }, m: function(h, p) {
    X(h, e, p), T(e, n), t[72](n), X(h, r, p), f[i].m(h, p), X(h, s, p), a = !0, l || (c = Oe(n, "paste", t[38]), l = !0);
  }, p: function(h, p) {
    var m = i;
    (i = d(h)) === m ? f[i].p(h, p) : (Ae(), _(f[m], 1, 1, function() {
      f[m] = null;
    }), Me(), (o = f[i]) ? o.p(h, p) : (o = f[i] = u[i](h)).c(), S(o, 1), o.m(s.parentNode, s));
  }, i: function(h) {
    a || (S(o), a = !0);
  }, o: function(h) {
    _(o), a = !1;
  }, d: function(h) {
    h && (Y(e), Y(r), Y(s)), t[72](null), f[i].d(h), l = !1, c();
  } };
}
function rie(t) {
  var e, n;
  return e = new Gre({ props: { text: t[16], json: t[8], readOnly: t[0], parser: t[2], openJSONEditorModal: t[40], onChangeMode: t[4] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    65536 & i[0] && (o.text = r[16]), 256 & i[0] && (o.json = r[8]), 1 & i[0] && (o.readOnly = r[0]), 4 & i[0] && (o.parser = r[2]), 16 & i[0] && (o.onChangeMode = r[4]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function iie(t) {
  var e, n, r, i;
  return e = new vo({ props: { type: "error", message: "The loaded JSON document is invalid and could not be repaired automatically.", actions: t[0] ? [] : [{ icon: ea, text: "Repair manually", title: 'Open the document in "code" mode and repair it manually', onClick: t[36] }] } }), r = new W5({ props: { text: t[16], json: t[8], indentation: t[3], parser: t[2] } }), { c: function() {
    xe(e.$$.fragment), n = se(), xe(r.$$.fragment);
  }, m: function(o, s) {
    ye(e, o, s), X(o, n, s), ye(r, o, s), i = !0;
  }, p: function(o, s) {
    var a = {};
    1 & s[0] && (a.actions = o[0] ? [] : [{ icon: ea, text: "Repair manually", title: 'Open the document in "code" mode and repair it manually', onClick: o[36] }]), e.$set(a);
    var l = {};
    65536 & s[0] && (l.text = o[16]), 256 & s[0] && (l.json = o[8]), 8 & s[0] && (l.indentation = o[3]), 4 & s[0] && (l.parser = o[2]), r.$set(l);
  }, i: function(o) {
    i || (S(e.$$.fragment, o), S(r.$$.fragment, o), i = !0);
  }, o: function(o) {
    _(e.$$.fragment, o), _(r.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && Y(n), be(e, o), be(r, o);
  } };
}
function oie(t) {
  for (var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N, B = !nn((e = t[22]) === null || e === void 0 ? void 0 : e.root), O = B && U$(t), I = Ot(t[10]), P = [], J = 0; J < I.length; J += 1)
    P[J] = W$(V$(t, I, J));
  for (var D = function(F) {
    return _(P[F], 1, 1, function() {
      P[F] = null;
    });
  }, Q = t[24] && J$(t), Z = Ot(t[23].visibleItems), L = [], R = 0; R < Z.length; R += 1)
    L[R] = e4(z$(t, Z, R));
  var V = function(F) {
    return _(L[F], 1, 1, function() {
      L[F] = null;
    });
  }, M = t[18] && t4(t), C = t[19] && n4(t);
  return b = new ky({ props: { validationErrors: t[12], selectError: t[39] } }), { c: function() {
    n = H("div"), r = H("table"), i = H("tbody"), o = H("tr"), s = H("th"), O && O.c(), a = se();
    for (var F = 0; F < P.length; F += 1)
      P[F].c();
    l = se(), Q && Q.c(), c = se(), u = H("tr"), f = H("td"), h = se();
    for (var z = 0; z < L.length; z += 1)
      L[z].c();
    p = se(), m = H("tr"), g = H("td"), y = se(), M && M.c(), w = se(), C && C.c(), x = se(), xe(b.$$.fragment), k(s, "class", "jse-table-cell jse-table-cell-header svelte-1bunebm"), k(o, "class", "jse-table-row jse-table-row-header svelte-1bunebm"), k(f, "colspan", d = t[10].length), k(f, "class", "svelte-1bunebm"), Qr(f, "height", t[23].startHeight + "px"), k(u, "class", "jse-table-invisible-start-section"), k(g, "colspan", v = t[10].length), k(g, "class", "svelte-1bunebm"), Qr(g, "height", t[23].endHeight + "px"), k(m, "class", "jse-table-invisible-end-section"), k(r, "class", "jse-table-main svelte-1bunebm"), k(r, "cellpadding", "0"), k(r, "cellspacing", "0"), k(n, "class", "jse-contents svelte-1bunebm");
  }, m: function(F, z) {
    X(F, n, z), T(n, r), T(r, i), T(i, o), T(o, s), O && O.m(s, null), T(o, a);
    for (var E = 0; E < P.length; E += 1)
      P[E] && P[E].m(o, null);
    T(o, l), Q && Q.m(o, null), T(i, c), T(i, u), T(u, f), T(i, h);
    for (var A = 0; A < L.length; A += 1)
      L[A] && L[A].m(i, null);
    T(i, p), T(i, m), T(m, g), t[75](n), X(F, y, z), M && M.m(F, z), X(F, w, z), C && C.m(F, z), X(F, x, z), ye(b, F, z), j = !0, $ || (N = [Mr(Q5.call(null, n, t[45])), Oe(n, "scroll", t[29])], $ = !0);
  }, p: function(F, z) {
    var E;
    if (4194304 & z[0] && (B = !nn((E = F[22]) === null || E === void 0 ? void 0 : E.root)), B ? O ? (O.p(F, z), 4194304 & z[0] && S(O, 1)) : ((O = U$(F)).c(), S(O, 1), O.m(s, null)) : O && (Ae(), _(O, 1, 1, function() {
      O = null;
    }), Me()), 268438529 & z[0]) {
      var A;
      for (I = Ot(F[10]), A = 0; A < I.length; A += 1) {
        var te = V$(F, I, A);
        P[A] ? (P[A].p(te, z), S(P[A], 1)) : (P[A] = W$(te), P[A].c(), S(P[A], 1), P[A].m(o, l));
      }
      for (Ae(), A = I.length; A < P.length; A += 1)
        D(A);
      Me();
    }
    if (F[24] ? Q ? (Q.p(F, z), 16777216 & z[0] && S(Q, 1)) : ((Q = J$(F)).c(), S(Q, 1), Q.m(o, null)) : Q && (Ae(), _(Q, 1, 1, function() {
      Q = null;
    }), Me()), (!j || 1024 & z[0] && d !== (d = F[10].length)) && k(f, "colspan", d), 8388608 & z[0] && Qr(f, "height", F[23].startHeight + "px"), 165678085 & z[0] | 33281 & z[1]) {
      var ge;
      for (Z = Ot(F[23].visibleItems), ge = 0; ge < Z.length; ge += 1) {
        var ke = z$(F, Z, ge);
        L[ge] ? (L[ge].p(ke, z), S(L[ge], 1)) : (L[ge] = e4(ke), L[ge].c(), S(L[ge], 1), L[ge].m(i, p));
      }
      for (Ae(), ge = Z.length; ge < L.length; ge += 1)
        V(ge);
      Me();
    }
    (!j || 1024 & z[0] && v !== (v = F[10].length)) && k(g, "colspan", v), 8388608 & z[0] && Qr(g, "height", F[23].endHeight + "px"), F[18] ? M ? (M.p(F, z), 262144 & z[0] && S(M, 1)) : ((M = t4(F)).c(), S(M, 1), M.m(w.parentNode, w)) : M && (Ae(), _(M, 1, 1, function() {
      M = null;
    }), Me()), F[19] ? C ? (C.p(F, z), 524288 & z[0] && S(C, 1)) : ((C = n4(F)).c(), S(C, 1), C.m(x.parentNode, x)) : C && (Ae(), _(C, 1, 1, function() {
      C = null;
    }), Me());
    var Ce = {};
    4096 & z[0] && (Ce.validationErrors = F[12]), b.$set(Ce);
  }, i: function(F) {
    if (!j) {
      S(O);
      for (var z = 0; z < I.length; z += 1)
        S(P[z]);
      S(Q);
      for (var E = 0; E < Z.length; E += 1)
        S(L[E]);
      S(M), S(C), S(b.$$.fragment, F), j = !0;
    }
  }, o: function(F) {
    _(O), P = P.filter(Boolean);
    for (var z = 0; z < P.length; z += 1)
      _(P[z]);
    _(Q), L = L.filter(Boolean);
    for (var E = 0; E < L.length; E += 1)
      _(L[E]);
    _(M), _(C), _(b.$$.fragment, F), j = !1;
  }, d: function(F) {
    F && (Y(n), Y(y), Y(w), Y(x)), O && O.d(), fr(P, F), Q && Q.d(), fr(L, F), t[75](null), M && M.d(F), C && C.d(F), be(b, F), $ = !1, An(N);
  } };
}
function U$(t) {
  var e, n, r, i;
  return r = new Cc({ props: { validationError: uc([], (e = t[22]) === null || e === void 0 ? void 0 : e.root), onExpand: Zi } }), { c: function() {
    n = H("div"), xe(r.$$.fragment), k(n, "class", "jse-table-root-error svelte-1bunebm");
  }, m: function(o, s) {
    X(o, n, s), ye(r, n, null), i = !0;
  }, p: function(o, s) {
    var a, l = {};
    4194304 & s[0] && (l.validationError = uc([], (a = o[22]) === null || a === void 0 ? void 0 : a.root)), r.$set(l);
  }, i: function(o) {
    i || (S(r.$$.fragment, o), i = !0);
  }, o: function(o) {
    _(r.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && Y(n), be(r);
  } };
}
function W$(t) {
  var e, n, r;
  return n = new Lre({ props: { path: t[127], sortedColumn: t[11].sortedColumn, readOnly: t[0], onSort: t[28] } }), { c: function() {
    e = H("th"), xe(n.$$.fragment), k(e, "class", "jse-table-cell jse-table-cell-header svelte-1bunebm");
  }, m: function(i, o) {
    X(i, e, o), ye(n, e, null), r = !0;
  }, p: function(i, o) {
    var s = {};
    1024 & o[0] && (s.path = i[127]), 2048 & o[0] && (s.sortedColumn = i[11].sortedColumn), 1 & o[0] && (s.readOnly = i[0]), n.$set(s);
  }, i: function(i) {
    r || (S(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    _(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && Y(e), be(n);
  } };
}
function J$(t) {
  var e, n, r;
  return n = new Zre({ props: { count: Array.isArray(t[8]) ? t[8].length : 0, maxSampleCount: t[9], onRefresh: t[73] } }), { c: function() {
    e = H("th"), xe(n.$$.fragment), k(e, "class", "jse-table-cell jse-table-cell-header svelte-1bunebm");
  }, m: function(i, o) {
    X(i, e, o), ye(n, e, null), r = !0;
  }, p: function(i, o) {
    var s = {};
    256 & o[0] && (s.count = Array.isArray(i[8]) ? i[8].length : 0), 512 & o[0] && (s.maxSampleCount = i[9]), 512 & o[0] && (s.onRefresh = i[73]), n.$set(s);
  }, i: function(i) {
    r || (S(n.$$.fragment, i), r = !0);
  }, o: function(i) {
    _(n.$$.fragment, i), r = !1;
  }, d: function(i) {
    i && Y(e), be(n);
  } };
}
function K$(t) {
  var e, n;
  return e = new Cc({ props: { validationError: uc([String(t[123])], t[124].row), onExpand: Zi } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    12582912 & i[0] && (o.validationError = uc([String(r[123])], r[124].row)), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function G$(t) {
  var e, n, r, i, o, s, a, l, c = t[123] + "", u = !nn((e = t[124]) === null || e === void 0 ? void 0 : e.row), f = u && K$(t);
  function d() {
    for (var h, p = arguments.length, m = new Array(p), g = 0; g < p; g++)
      m[g] = arguments[g];
    return (h = t)[74].apply(h, [t[123]].concat(m));
  }
  return { c: function() {
    n = H("th"), r = Le(c), i = se(), f && f.c(), k(n, "class", "jse-table-cell jse-table-cell-gutter svelte-1bunebm");
  }, m: function(h, p) {
    X(h, n, p), T(n, r), T(n, i), f && f.m(n, null), s = !0, a || (l = Mr(o = Q5.call(null, n, d)), a = !0);
  }, p: function(h, p) {
    var m;
    t = h, (!s || 8388608 & p[0]) && c !== (c = t[123] + "") && bt(r, c), 12582912 & p[0] && (u = !nn((m = t[124]) === null || m === void 0 ? void 0 : m.row)), u ? f ? (f.p(t, p), 12582912 & p[0] && S(f, 1)) : ((f = K$(t)).c(), S(f, 1), f.m(n, null)) : f && (Ae(), _(f, 1, 1, function() {
      f = null;
    }), Me()), o && Ar(o.update) && 8388608 & p[0] && o.update.call(null, d);
  }, i: function(h) {
    s || (S(f), s = !0);
  }, o: function(h) {
    _(f), s = !1;
  }, d: function(h) {
    h && Y(n), f && f.d(), a = !1, l();
  } };
}
function sie(t) {
  var e, n;
  return e = new Mre({ props: { path: t[128], value: t[129] !== void 0 ? t[129] : "", enforceString: bs(t[129], t[11].enforceStringMap, Je(t[128]), t[21].parser), selection: t[130] ? t[11].selection : null, searchResultItems: t[27], context: t[21] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    8389632 & i[0] && (o.path = r[128]), 8389632 & i[0] && (o.value = r[129] !== void 0 ? r[129] : ""), 10488832 & i[0] && (o.enforceString = bs(r[129], r[11].enforceStringMap, Je(r[128]), r[21].parser)), 8391680 & i[0] && (o.selection = r[130] ? r[11].selection : null), 2097152 & i[0] && (o.context = r[21]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function aie(t) {
  var e, n;
  return e = new Rre({ props: { path: t[128], value: t[129], parser: t[2], isSelected: t[130], onEdit: t[40] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    8389632 & i[0] && (o.path = r[128]), 8389632 & i[0] && (o.value = r[129]), 4 & i[0] && (o.parser = r[2]), 8391680 & i[0] && (o.isSelected = r[130]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Q$(t) {
  var e, n, r, i;
  return n = new ha({ props: { selected: !0, onContextMenu: t[31] } }), { c: function() {
    e = H("div"), xe(n.$$.fragment), r = se(), k(e, "class", "jse-context-menu-anchor svelte-1bunebm");
  }, m: function(o, s) {
    X(o, e, s), ye(n, e, null), X(o, r, s), i = !0;
  }, p: Pe, i: function(o) {
    i || (S(n.$$.fragment, o), i = !0);
  }, o: function(o) {
    _(n.$$.fragment, o), i = !1;
  }, d: function(o) {
    o && (Y(e), Y(r)), be(n);
  } };
}
function Y$(t) {
  var e, n;
  return e = new Cc({ props: { validationError: uc(t[128], t[131]), onExpand: Zi } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    12583936 & i[0] && (o.validationError = uc(r[128], r[131])), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function X$(t) {
  var e, n, r, i, o, s, a, l, c = !t[0] && t[130] && !Hi(t[11].selection), u = !nn(t[131]), f = [aie, sie], d = [];
  function h(g, v) {
    return 8389632 & v[0] && (n = null), n == null && (n = !!Xn(g[129])), n ? 0 : 1;
  }
  r = h(t, [-1, -1, -1, -1, -1]), i = d[r] = f[r](t);
  var p = c && Q$(t), m = u && Y$(t);
  return { c: function() {
    e = H("td"), i.c(), o = un(), p && p.c(), s = un(), m && m.c(), k(e, "class", "jse-table-cell svelte-1bunebm"), k(e, "data-path", a = sc(t[128])), $e(e, "jse-selected-value", t[130]);
  }, m: function(g, v) {
    X(g, e, v), d[r].m(e, null), T(e, o), p && p.m(e, null), T(e, s), m && m.m(e, null), l = !0;
  }, p: function(g, v) {
    var y = r;
    (r = h(g, v)) === y ? d[r].p(g, v) : (Ae(), _(d[y], 1, 1, function() {
      d[y] = null;
    }), Me(), (i = d[r]) ? i.p(g, v) : (i = d[r] = f[r](g)).c(), S(i, 1), i.m(e, o)), 8391681 & v[0] && (c = !g[0] && g[130] && !Hi(g[11].selection)), c ? p ? (p.p(g, v), 8391681 & v[0] && S(p, 1)) : ((p = Q$(g)).c(), S(p, 1), p.m(e, s)) : p && (Ae(), _(p, 1, 1, function() {
      p = null;
    }), Me()), 12582912 & v[0] && (u = !nn(g[131])), u ? m ? (m.p(g, v), 12582912 & v[0] && S(m, 1)) : ((m = Y$(g)).c(), S(m, 1), m.m(e, null)) : m && (Ae(), _(m, 1, 1, function() {
      m = null;
    }), Me()), (!l || 8389632 & v[0] && a !== (a = sc(g[128]))) && k(e, "data-path", a), (!l || 8391680 & v[0]) && $e(e, "jse-selected-value", g[130]);
  }, i: function(g) {
    l || (S(i), S(p), S(m), l = !0);
  }, o: function(g) {
    _(i), _(p), _(m), l = !1;
  }, d: function(g) {
    g && Y(e), d[r].d(), p && p.d(), m && m.d();
  } };
}
function Z$(t) {
  var e;
  return { c: function() {
    k(e = H("td"), "class", "jse-table-cell svelte-1bunebm");
  }, m: function(n, r) {
    X(n, e, r);
  }, d: function(n) {
    n && Y(e);
  } };
}
function e4(t) {
  for (var e, n, r, i, o = t[123], s = G$(t), a = Ot(t[10]), l = [], c = 0; c < a.length; c += 1)
    l[c] = X$(F$(t, a, c));
  var u = function(d) {
    return _(l[d], 1, 1, function() {
      l[d] = null;
    });
  }, f = t[24] && Z$();
  return { c: function() {
    e = H("tr"), s.c(), n = se();
    for (var d = 0; d < l.length; d += 1)
      l[d].c();
    r = se(), f && f.c(), k(e, "class", "jse-table-row svelte-1bunebm");
  }, m: function(d, h) {
    X(d, e, h), s.m(e, null), T(e, n);
    for (var p = 0; p < l.length; p += 1)
      l[p] && l[p].m(e, null);
    T(e, r), f && f.m(e, null), i = !0;
  }, p: function(d, h) {
    if (8388608 & h[0] && Pt(o, o = d[123]) ? (Ae(), _(s, 1, 1, Pe), Me(), (s = G$(d)).c(), S(s, 1), s.m(e, n)) : s.p(d, h), 148900869 & h[0] | 513 & h[1]) {
      var p;
      for (a = Ot(d[10]), p = 0; p < a.length; p += 1) {
        var m = F$(d, a, p);
        l[p] ? (l[p].p(m, h), S(l[p], 1)) : (l[p] = X$(m), l[p].c(), S(l[p], 1), l[p].m(e, r));
      }
      for (Ae(), p = a.length; p < l.length; p += 1)
        u(p);
      Me();
    }
    d[24] ? f || ((f = Z$()).c(), f.m(e, null)) : f && (f.d(1), f = null);
  }, i: function(d) {
    if (!i) {
      S(s);
      for (var h = 0; h < a.length; h += 1)
        S(l[h]);
      i = !0;
    }
  }, o: function(d) {
    _(s), l = l.filter(Boolean);
    for (var h = 0; h < l.length; h += 1)
      _(l[h]);
    i = !1;
  }, d: function(d) {
    d && Y(e), s.d(d), fr(l, d), f && f.d();
  } };
}
function t4(t) {
  var e, n;
  return e = new vo({ props: { type: "info", message: "You pasted a JSON ".concat(Array.isArray(t[18].contents) ? "array" : "object", " as text"), actions: [{ icon: xp, text: "Paste as JSON instead", title: "Paste the text as JSON instead of a single value", onMouseDown: t[34] }, { text: "Leave as is", title: "Keep the pasted content as a single value", onClick: t[35] }] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    262144 & i[0] && (o.message = "You pasted a JSON ".concat(Array.isArray(r[18].contents) ? "array" : "object", " as text")), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function n4(t) {
  var e, n;
  return e = new vo({ props: { type: "success", message: "The loaded JSON document was invalid but is successfully repaired.", actions: t[0] ? [] : [{ icon: Su, text: "Ok", title: "Accept the repaired document", onClick: t[7] }, { icon: ea, text: "Repair manually instead", title: "Leave the document unchanged and repair it manually instead", onClick: t[36] }], onClose: t[6] } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    1 & i[0] && (o.actions = r[0] ? [] : [{ icon: Su, text: "Ok", title: "Accept the repaired document", onClick: r[7] }, { icon: ea, text: "Repair manually instead", title: "Leave the document unchanged and repair it manually instead", onClick: r[36] }]), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function lie(t) {
  var e, n, r, i, o, s, a, l = t[1] && H$(t), c = [nie, tie], u = [];
  return r = function(f, d) {
    return f[26] ? 1 : 0;
  }(t), i = u[r] = c[r](t), { c: function() {
    e = H("div"), l && l.c(), n = se(), i.c(), k(e, "role", "table"), k(e, "class", "jse-table-mode svelte-1bunebm"), $e(e, "no-main-menu", !t[1]);
  }, m: function(f, d) {
    X(f, e, d), l && l.m(e, null), T(e, n), u[r].m(e, null), t[76](e), o = !0, s || (a = [Oe(e, "mousedown", t[30]), Oe(e, "keydown", t[37]), Oe(e, "contextmenu", t[32])], s = !0);
  }, p: function(f, d) {
    f[1] ? l ? (l.p(f, d), 2 & d[0] && S(l, 1)) : ((l = H$(f)).c(), S(l, 1), l.m(e, n)) : l && (Ae(), _(l, 1, 1, function() {
      l = null;
    }), Me()), i.p(f, d), (!o || 2 & d[0]) && $e(e, "no-main-menu", !f[1]);
  }, i: function(f) {
    o || (S(l), S(i), o = !0);
  }, o: function(f) {
    _(l), _(i), o = !1;
  }, d: function(f) {
    f && Y(e), l && l.d(), u[r].d(), t[76](null), s = !1, An(a);
  } };
}
var zc = 18;
function cie(t, e, n) {
  var r, i, o, s, a = Tr("jsoneditor:TableMode"), l = _r("simple-modal").open, c = _r("absolute-popup"), u = c.openAbsolutePopup, f = c.closeAbsolutePopup, d = M5(), h = Kl(), p = Kl(), m = typeof window > "u";
  a("isSSR:", m);
  var g, v, y, w, x, b, j = e.readOnly, $ = e.externalContent, N = e.externalSelection, B = e.mainMenuBar, O = e.escapeControlCharacters, I = e.escapeUnicodeCharacters, P = e.flattenColumns, J = e.parser, D = e.parseMemoizeOne, Q = e.validator, Z = e.validationParser, L = e.indentation, R = e.onChange, V = e.onChangeMode, M = e.onSelect, C = e.onRenderValue, F = e.onRenderMenu, z = e.onFocus, E = e.onBlur, A = e.onSortModal, te = e.onTransformModal, ge = e.onJSONEditorModal;
  jy({ onMount: Fi, onDestroy: Ci, getWindow: function() {
    return $c(v);
  }, hasFocus: function() {
    return rt && document.hasFocus() || gy(v);
  }, onFocus: function() {
    z && z();
  }, onBlur: function() {
    E && E();
  } });
  var ke, Ce = void 0, we = 1e4, le = [], rt = !1, Be = {}, nt = 600, oe = 0;
  function We(K) {
    a("updateSelection", K);
    var pe = typeof K == "function" ? K(de.selection) || null : K;
    tn(pe, de.selection) || (n(11, de = fe(fe({}, de), {}, { selection: pe })), M(pe));
  }
  function Rt(K) {
    de.selection && K !== void 0 && (Ri(K, Na(de.selection)) && Ri(K, mt(de.selection)) || (a("clearing selection: path does not exist anymore", de.selection), n(11, de = fe(fe({}, de), {}, { selection: null }))));
  }
  var de = Vh(), Se = !1, rn, Dt = _5({ onChange: function(K) {
    n(20, Xt = K);
  } }), Xt = Dt.getState();
  function Ue(K) {
    var pe = x, Ne = oc(K) ? K.text !== b : !tn(pe, K.json);
    if (a("update external content", { isChanged: Ne }), Ne) {
      var ze = { json: x, text: b }, Ve = x, Ct = de, _t = b, ut = Se;
      if (oc(K))
        try {
          n(8, x = D(K.text)), n(16, b = K.text), n(19, Se = !1), n(17, Ce = void 0);
        } catch ($t) {
          try {
            n(8, x = D(Lo(K.text))), n(16, b = K.text), n(19, Se = !0), n(17, Ce = void 0);
          } catch {
            n(8, x = void 0), n(16, b = $.text), n(19, Se = !1), n(17, Ce = b !== void 0 && b !== "" ? ic(b, $t.message || String($t)) : void 0);
          }
        }
      else
        n(8, x = K.json), n(16, b = void 0), n(19, Se = !1), n(17, Ce = void 0);
      Rt(x), de.sortedColumn && n(11, de = fe(fe({}, de), {}, { sortedColumn: null })), kn({ previousJson: Ve, previousState: Ct, previousText: _t, previousTextIsRepaired: ut }), _e(ze, null);
    }
  }
  function kn(K) {
    var pe = K.previousJson, Ne = K.previousState, ze = K.previousText, Ve = K.previousTextIsRepaired;
    pe === void 0 && ze === void 0 || (x !== void 0 ? pe !== void 0 ? Dt.add({ undo: { patch: [{ op: "replace", path: "", value: pe }], state: Hr(Ne), json: void 0, text: ze, textIsRepaired: Ve }, redo: { patch: [{ op: "replace", path: "", value: x }], state: Hr(de), json: void 0, text: b, textIsRepaired: Se } }) : Dt.add({ undo: { patch: void 0, json: void 0, text: ze, state: Hr(Ne), textIsRepaired: Ve }, redo: { patch: void 0, json: x, state: Hr(de), text: b, textIsRepaired: Se } }) : pe !== void 0 && Dt.add({ undo: { patch: void 0, json: pe, state: Hr(Ne), text: ze, textIsRepaired: Ve }, redo: { patch: void 0, json: void 0, text: b, textIsRepaired: Se, state: Hr(de) } }));
  }
  var fn = [], q = nf(T5);
  function ee(K, pe, Ne, ze) {
    Al(function() {
      var Ve;
      try {
        Ve = q(K, pe, Ne, ze);
      } catch (Ct) {
        Ve = [{ path: [], message: "Failed to validate: " + Ct.message, severity: gs.warning }];
      }
      tn(Ve, fn) || (a("validationErrors changed:", Ve), n(12, fn = Ve));
    }, function(Ve) {
      return a("validationErrors updated in ".concat(Ve, " ms"));
    });
  }
  function ne() {
    return a("validate"), Ce ? { parseError: Ce, isRepairable: !1 } : (ee(x, Q, J, Z), nn(fn) ? null : { validationErrors: fn });
  }
  function he(K, pe) {
    if (a("patch", K, pe), x === void 0)
      throw new Error("Cannot apply patch: no JSON");
    var Ne = { json: x }, ze = x, Ve = de, Ct = Se, _t = v5(x, K), ut = s5(x, de, K).json, $t = jne(de, K, le), kt = typeof pe == "function" ? pe(ut, $t) : void 0;
    n(8, x = kt && kt.json !== void 0 ? kt.json : ut);
    var sn = kt && kt.state !== void 0 ? kt.state : $t;
    n(11, de = sn), n(16, b = void 0), n(19, Se = !1), n(18, ke = void 0), n(17, Ce = void 0), Dt.add({ undo: { patch: _t, json: void 0, text: void 0, state: Hr(Ve), textIsRepaired: Ct }, redo: { patch: K, json: void 0, state: Hr(sn), text: void 0, textIsRepaired: Se } });
    var yn = { json: x, previousJson: ze, undo: _t, redo: K };
    return _e(Ne, yn), yn;
  }
  function je(K, pe) {
    if (!j)
      return he(K, pe);
  }
  function _e(K, pe) {
    (K.json !== void 0 || (K == null ? void 0 : K.text) !== void 0) && R && (b !== void 0 ? R({ text: b, json: void 0 }, K, { contentErrors: ne(), patchResult: pe }) : x !== void 0 && R({ text: void 0, json: x }, K, { contentErrors: ne(), patchResult: pe }));
  }
  function yt(K) {
    a("handleFind", K);
  }
  function Xe(K) {
    a("pasted json as text", K), n(18, ke = K);
  }
  function Zt(K) {
    var pe = parseInt(K[0]), Ne = [String(pe + 1)].concat(Ft(K.slice(1)));
    return Ri(x, Ne) ? Wt(Ne, !1) : Wt(K, !1);
  }
  function on() {
    a("focus"), w && (w.focus(), w.select());
  }
  function Jt() {
    de.selection || We(!Tn(x) || nn(x) || nn(le) ? null : Wt(["0"].concat(Ft(le[0])), !1));
  }
  function Ge(K) {
    var pe = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], Ne = ig(K, le, Be, zc), ze = Ne - oe, Ve = wn(K);
    if (a("scrollTo", { path: K, top: Ne, scrollTop: oe, elem: Ve }), !y)
      return Promise.resolve();
    var Ct = y.getBoundingClientRect();
    if (Ve && !pe) {
      var _t = Ve.getBoundingClientRect();
      if (_t.bottom > Ct.top && _t.top < Ct.bottom)
        return Promise.resolve();
    }
    var ut = -Ct.height / 4;
    return new Promise(Ve ? function($t) {
      d(Ve, { container: y, offset: ut, duration: 300, callback: function() {
        xn(K), $t();
      } });
    } : function($t) {
      var kt;
      d(ze, { container: y, offset: ut, duration: 300, callback: (kt = Tt(Ie().mark(function sn() {
        return Ie().wrap(function(yn) {
          for (; ; )
            switch (yn.prev = yn.next) {
              case 0:
                return yn.next = 2, lr();
              case 2:
                if (ig(K, le, Be, zc) === Ne) {
                  yn.next = 8;
                  break;
                }
                return yn.next = 6, Ge(K, pe);
              case 6:
                yn.next = 9;
                break;
              case 8:
                xn(K);
              case 9:
                $t();
              case 10:
              case "end":
                return yn.stop();
            }
        }, sn);
      })), function() {
        return kt.apply(this, arguments);
      }) });
    });
  }
  function xn(K) {
    var pe = wn(K);
    if (pe && y) {
      var Ne = y.getBoundingClientRect(), ze = pe.getBoundingClientRect();
      if (ze.right > Ne.right) {
        var Ve = ze.right - Ne.right;
        n(14, y.scrollLeft += Ve, y);
      }
      if (ze.left < Ne.left) {
        var Ct = Ne.left - ze.left;
        n(14, y.scrollLeft -= Ct, y);
      }
    }
  }
  function Dn(K) {
    (function(pe) {
      if (y) {
        var Ne = _i(pe, le).rowIndex, ze = ig(pe, le, Be, zc), Ve = ze + (Be[Ne] || zc), Ct = y.getBoundingClientRect(), _t = oe, ut = oe + Ct.height - 18;
        if (Ve > ut) {
          var $t = Ve - ut;
          n(14, y.scrollTop += $t, y);
        }
        if (ze < _t) {
          var kt = _t - ze;
          n(14, y.scrollTop -= kt, y);
        }
      }
    })(K), xn(K);
  }
  function wn(K) {
    return y ? y.querySelector('td[data-path="'.concat(sc(K), '"]')) : null;
  }
  function $n(K) {
    var pe = K.anchor, Ne = K.left, ze = K.top, Ve = K.width, Ct = K.height, _t = K.offsetTop, ut = K.offsetLeft, $t = K.showTip;
    rt = !0;
    var kt = u(zre, { json: x, documentState: de, parser: J, showTip: $t, onEditValue: Jn, onEditRow: pn, onToggleEnforceString: me, onCut: Nt, onCopy: qe, onPaste: It, onRemove: Lt, onDuplicateRow: qt, onInsertBeforeRow: U, onInsertAfterRow: G, onRemoveRow: re, onCloseContextMenu: function() {
      f(kt), on();
    } }, { left: Ne, top: ze, offsetTop: _t, offsetLeft: ut, width: Ve, height: Ct, anchor: pe, closeOnOuterClick: !0, onClose: function() {
      rt = !1, on();
    } });
  }
  function Rn(K) {
    if (!j && !Hi(de.selection)) {
      if (K && (K.stopPropagation(), K.preventDefault()), K && K.type === "contextmenu" && K.target !== w)
        $n({ left: K.clientX, top: K.clientY, width: is, height: rs, showTip: !1 });
      else {
        var pe, Ne = (pe = y) === null || pe === void 0 ? void 0 : pe.querySelector(".jse-table-cell.jse-selected-value");
        if (Ne)
          $n({ anchor: Ne, offsetTop: 2, width: is, height: rs, showTip: !1 });
        else {
          var ze, Ve = (ze = y) === null || ze === void 0 ? void 0 : ze.getBoundingClientRect();
          Ve && $n({ top: Ve.top + 2, left: Ve.left + 2, width: is, height: rs, showTip: !1 });
        }
      }
      return !1;
    }
  }
  function Jn() {
    if (!j && de.selection) {
      var K = mt(de.selection);
      Xn(it(x, K)) ? Vt(K) : We(Wt(K, !0));
    }
  }
  function pn() {
    !j && de.selection && Vt(mt(de.selection).slice(0, 1));
  }
  function me() {
    if (!j && an(de.selection)) {
      var K = de.selection.path, pe = Je(K), Ne = it(x, K), ze = !bs(Ne, de.enforceStringMap, pe, J), Ve = ze ? String(Ne) : kc(String(Ne), J);
      a("handleToggleEnforceString", { enforceString: ze, value: Ne, updatedValue: Ve }), je([{ op: "replace", path: pe, value: Ve }], function(Ct, _t) {
        return { state: o5(_t, pe, ze) };
      });
    }
  }
  function Ke() {
    return (Ke = Tt(Ie().mark(function K() {
      var pe, Ne, ze, Ve, Ct;
      return Ie().wrap(function(_t) {
        for (; ; )
          switch (_t.prev = _t.next) {
            case 0:
              if (a("apply pasted json", ke), ke) {
                _t.next = 3;
                break;
              }
              return _t.abrupt("return");
            case 3:
              ze = (Ne = ke).path, Ve = Ne.contents, t5(Ct = ((pe = y) === null || pe === void 0 ? void 0 : pe.querySelector(".jse-editable-div")) || null) && Ct.cancel(), je([{ op: "replace", path: Je(ze), value: Ve }]), setTimeout(on);
            case 9:
            case "end":
              return _t.stop();
          }
      }, K);
    }))).apply(this, arguments);
  }
  function It() {
    l(P5, {}, fe(fe({}, Qa), {}, { styleWindow: { width: "450px" } }), { onClose: function() {
      return on();
    } });
  }
  function Nt(K) {
    return ce.apply(this, arguments);
  }
  function ce() {
    return (ce = Tt(Ie().mark(function K(pe) {
      return Ie().wrap(function(Ne) {
        for (; ; )
          switch (Ne.prev = Ne.next) {
            case 0:
              return Ne.next = 2, z5({ json: x, documentState: de, indentation: pe ? L : void 0, readOnly: j, parser: J, onPatch: je });
            case 2:
            case "end":
              return Ne.stop();
          }
      }, K);
    }))).apply(this, arguments);
  }
  function qe() {
    return Fe.apply(this, arguments);
  }
  function Fe() {
    return Fe = Tt(Ie().mark(function K() {
      var pe, Ne = arguments;
      return Ie().wrap(function(ze) {
        for (; ; )
          switch (ze.prev = ze.next) {
            case 0:
              if (pe = !(Ne.length > 0 && Ne[0] !== void 0) || Ne[0], x !== void 0) {
                ze.next = 3;
                break;
              }
              return ze.abrupt("return");
            case 3:
              return ze.next = 5, F5({ json: x, documentState: de, indentation: pe ? L : void 0, parser: J });
            case 5:
            case "end":
              return ze.stop();
          }
      }, K);
    })), Fe.apply(this, arguments);
  }
  function Lt() {
    H5({ json: x, text: b, documentState: de, keepSelection: !0, readOnly: j, onChange: R, onPatch: je });
  }
  function qt() {
    kne({ json: x, documentState: de, columns: le, readOnly: j, onPatch: je });
  }
  function U() {
    $ne({ json: x, documentState: de, columns: le, readOnly: j, onPatch: je });
  }
  function G() {
    Sne({ json: x, documentState: de, columns: le, readOnly: j, onPatch: je });
  }
  function re() {
    Cne({ json: x, documentState: de, columns: le, readOnly: j, onPatch: je });
  }
  function ae() {
    return (ae = Tt(Ie().mark(function K(pe) {
      return Ie().wrap(function(Ne) {
        for (; ; )
          switch (Ne.prev = Ne.next) {
            case 0:
              return Ne.next = 2, U5({ char: pe, selectInside: !1, refJsonEditor: v, json: x, selection: de.selection, readOnly: j, parser: J, onPatch: je, onReplaceJson: ve, onSelect: We });
            case 2:
            case "end":
              return Ne.stop();
          }
      }, K);
    }))).apply(this, arguments);
  }
  function ve(K, pe) {
    var Ne = de, ze = x, Ve = b, Ct = { json: x, text: b }, _t = Se, ut = Ai(x, de, [], To), $t = typeof pe == "function" ? pe(K, ut) : void 0;
    n(8, x = $t && $t.json !== void 0 ? $t.json : K), n(11, de = $t && $t.state !== void 0 ? $t.state : ut), n(16, b = void 0), n(19, Se = !1), n(17, Ce = void 0), Rt(x), kn({ previousJson: ze, previousState: Ne, previousText: Ve, previousTextIsRepaired: _t }), _e(Ct, null);
  }
  function pt(K, pe) {
    a("handleChangeText");
    var Ne = de, ze = x, Ve = b, Ct = { json: x, text: b }, _t = Se;
    try {
      n(8, x = D(K)), n(11, de = Ai(x, de, [], To)), n(16, b = void 0), n(19, Se = !1), n(17, Ce = void 0);
    } catch ($t) {
      try {
        n(8, x = D(Lo(K))), n(11, de = Ai(x, de, [], To)), n(16, b = K), n(19, Se = !0), n(17, Ce = void 0);
      } catch {
        n(8, x = void 0), n(11, de = Vh({ json: x, expand: To })), n(16, b = K), n(19, Se = !1), n(17, Ce = b !== "" ? ic(b, $t.message || String($t)) : void 0);
      }
    }
    if (typeof pe == "function") {
      var ut = pe(x, de);
      n(8, x = ut && ut.json ? ut.json : x), n(11, de = ut && ut.state ? ut.state : de);
    }
    Rt(x), kn({ previousJson: ze, previousState: Ne, previousText: Ve, previousTextIsRepaired: _t }), _e(Ct, null);
  }
  function xt(K) {
    if (x !== void 0) {
      var pe = K.id, Ne = K.onTransform, ze = K.onClose, Ve = K.rootPath || [];
      rt = !0, te({ id: pe || p, json: x, rootPath: Ve || [], onTransform: function(Ct) {
        Ne ? Ne({ operations: Ct, json: x, transformedJson: so(x, Ct) }) : (a("onTransform", Ve, Ct), je(Ct));
      }, onClose: function() {
        rt = !1, on(), ze && ze();
      } });
    }
  }
  function Vt(K) {
    a("openJSONEditorModal", { path: K }), rt = !0, ge({ content: { json: it(x, K) }, path: K, onPatch: rn.onPatch, onClose: function() {
      rt = !1, on();
    } });
  }
  function vn(K, pe) {
    l(N5, { text: K, onParse: function(Ne) {
      return Hp(Ne, function(ze) {
        return gf(ze, J);
      });
    }, onRepair: H6, onApply: pe }, fe(fe({}, Qa), {}, { styleWindow: { width: "600px", height: "500px" }, styleContent: { padding: 0, height: "100%" } }), { onClose: function() {
      return on();
    } });
  }
  function Mn() {
    if (!j && Dt.getState().canUndo) {
      var K = Dt.undo();
      if (K) {
        var pe = { json: x, text: b };
        n(8, x = K.undo.patch ? so(x, K.undo.patch) : K.undo.json), n(11, de = K.undo.state), n(16, b = K.undo.text), n(19, Se = K.undo.textIsRepaired), n(17, Ce = void 0), a("undo", { item: K, json: x }), _e(pe, { json: x, previousJson: pe.json, redo: K.undo.patch, undo: K.redo.patch }), on(), de.selection && Ge(mt(de.selection), !1);
      }
    }
  }
  function Ht() {
    if (!j && Dt.getState().canRedo) {
      var K = Dt.redo();
      if (K) {
        var pe = { json: x, text: b };
        n(8, x = K.redo.patch ? so(x, K.redo.patch) : K.redo.json), n(11, de = K.redo.state), n(16, b = K.redo.text), n(19, Se = K.redo.textIsRepaired), n(17, Ce = void 0), a("redo", { item: K, json: x }), _e(pe, { json: x, previousJson: pe.json, redo: K.redo.patch, undo: K.undo.patch }), on(), de.selection && Ge(mt(de.selection), !1);
      }
    }
  }
  function mn(K, pe) {
    n(69, Be[pe] = K.getBoundingClientRect().height, Be);
  }
  return t.$$set = function(K) {
    "readOnly" in K && n(0, j = K.readOnly), "externalContent" in K && n(47, $ = K.externalContent), "externalSelection" in K && n(48, N = K.externalSelection), "mainMenuBar" in K && n(1, B = K.mainMenuBar), "escapeControlCharacters" in K && n(49, O = K.escapeControlCharacters), "escapeUnicodeCharacters" in K && n(50, I = K.escapeUnicodeCharacters), "flattenColumns" in K && n(51, P = K.flattenColumns), "parser" in K && n(2, J = K.parser), "parseMemoizeOne" in K && n(52, D = K.parseMemoizeOne), "validator" in K && n(53, Q = K.validator), "validationParser" in K && n(54, Z = K.validationParser), "indentation" in K && n(3, L = K.indentation), "onChange" in K && n(55, R = K.onChange), "onChangeMode" in K && n(4, V = K.onChangeMode), "onSelect" in K && n(56, M = K.onSelect), "onRenderValue" in K && n(57, C = K.onRenderValue), "onRenderMenu" in K && n(5, F = K.onRenderMenu), "onFocus" in K && n(58, z = K.onFocus), "onBlur" in K && n(59, E = K.onBlur), "onSortModal" in K && n(60, A = K.onSortModal), "onTransformModal" in K && n(61, te = K.onTransformModal), "onJSONEditorModal" in K && n(62, ge = K.onJSONEditorModal);
  }, t.$$.update = function() {
    786432 & t.$$.dirty[1] && n(68, g = hy({ escapeControlCharacters: O, escapeUnicodeCharacters: I })), 65536 & t.$$.dirty[1] && Ue($), 131072 & t.$$.dirty[1] && function(K) {
      tn(de.selection, K) || (a("applyExternalSelection", K), We(K));
    }(N), 1792 & t.$$.dirty[0] | 1048576 & t.$$.dirty[1] && n(10, le = Tn(x) ? function(K, pe) {
      var Ne, ze = new Set(pe.map(Je)), Ve = new Set(K.map(Je)), Ct = qr(ze);
      try {
        for (Ct.s(); !(Ne = Ct.n()).done; ) {
          var _t = Ne.value;
          Ve.has(_t) || ze.delete(_t);
        }
      } catch (sn) {
        Ct.e(sn);
      } finally {
        Ct.f();
      }
      var ut, $t = qr(Ve);
      try {
        for ($t.s(); !(ut = $t.n()).done; ) {
          var kt = ut.value;
          ze.has(kt) || ze.add(kt);
        }
      } catch (sn) {
        $t.e(sn);
      } finally {
        $t.f();
      }
      return Ft(ze).map(uo);
    }(yne(x, P, we), le) : []), 1280 & t.$$.dirty[0] && n(25, r = x && !nn(le)), 768 & t.$$.dirty[0] && n(24, i = Array.isArray(x) && x.length > we), 256 & t.$$.dirty[0] | 896 & t.$$.dirty[2] && n(23, o = bne(oe, nt, x, Be, zc)), 256 & t.$$.dirty[0] && y && y.scrollTo({ top: y.scrollTop, left: y.scrollLeft }), 2309 & t.$$.dirty[0] | 67108864 & t.$$.dirty[1] | 64 & t.$$.dirty[2] && n(21, rn = { readOnly: j, parser: J, normalization: g, getJson: function() {
      return x;
    }, getDocumentState: function() {
      return de;
    }, findElement: wn, findNextInside: Zt, focus: on, onPatch: je, onSelect: We, onFind: yt, onPasteJson: Xe, onRenderValue: C }), 260 & t.$$.dirty[0] | 12582912 & t.$$.dirty[1] && ee(x, Q, J, Z), 5120 & t.$$.dirty[0] && n(22, s = xne(fn, le));
  }, [j, B, J, L, V, F, on, function() {
    if (Se && x !== void 0) {
      var K = de, pe = x, Ne = b, ze = { json: x, text: b }, Ve = Se;
      n(16, b = void 0), n(19, Se = !1), Rt(x), kn({ previousJson: pe, previousState: K, previousText: Ne, previousTextIsRepaired: Ve }), _e(ze, null);
    }
    return { json: x, text: b };
  }, x, we, le, de, fn, v, y, w, b, Ce, ke, Se, Xt, rn, s, o, i, r, m, void 0, function(K) {
    if (!j) {
      a("onSortByHeader", K);
      var pe = K.sortDirection === Di.desc ? -1 : 1;
      je(D5(x, [], K.path, pe), function(Ne, ze) {
        return { state: fe(fe({}, ze), {}, { sortedColumn: K }) };
      });
    }
  }, function(K) {
    n(71, oe = K.target.scrollTop);
  }, function(K) {
    var pe = K != null && K.target ? e5(K.target) : void 0;
    if (pe) {
      if (Hi(de.selection) && Uu(x, de.selection, pe))
        return;
      We(Wt(pe, !1)), K.preventDefault();
    }
    py(K.target, "BUTTON") || K.target.isContentEditable || on();
  }, $n, Rn, function(K) {
    j || $n({ anchor: Z6(K.target, "BUTTON"), offsetTop: 0, width: is, height: rs, showTip: !0 });
  }, function() {
    return Ke.apply(this, arguments);
  }, function() {
    a("clear pasted json"), n(18, ke = void 0), on();
  }, function() {
    V(Lr.text);
  }, function(K) {
    var pe = da(K);
    if (a("keydown", { combo: pe, key: K.key }), pe === "Ctrl+X" && (K.preventDefault(), Nt(!0)), pe === "Ctrl+Shift+X" && (K.preventDefault(), Nt(!1)), pe === "Ctrl+C" && (K.preventDefault(), qe(!0)), pe === "Ctrl+Shift+C" && (K.preventDefault(), qe(!1)), pe === "Ctrl+D" && K.preventDefault(), pe !== "Delete" && pe !== "Backspace" || (K.preventDefault(), Lt()), pe === "Insert" && K.preventDefault(), pe === "Ctrl+A" && K.preventDefault(), pe === "Ctrl+Q" && Rn(K), pe === "ArrowLeft" && (K.preventDefault(), Jt(), de.selection)) {
      var Ne = function($t, kt) {
        var sn = _i(mt(kt), $t), yn = sn.rowIndex, qn = sn.columnIndex;
        return qn > 0 ? Wt(Pa({ rowIndex: yn, columnIndex: qn - 1 }, $t), !1) : kt;
      }(le, de.selection);
      We(Ne), Dn(mt(Ne));
    }
    if (pe === "ArrowRight" && (K.preventDefault(), Jt(), de.selection)) {
      var ze = function($t, kt) {
        var sn = _i(mt(kt), $t), yn = sn.rowIndex, qn = sn.columnIndex;
        return qn < $t.length - 1 ? Wt(Pa({ rowIndex: yn, columnIndex: qn + 1 }, $t), !1) : kt;
      }(le, de.selection);
      We(ze), Dn(mt(ze));
    }
    if (pe === "ArrowUp" && (K.preventDefault(), Jt(), de.selection)) {
      var Ve = function($t, kt) {
        var sn = _i(mt(kt), $t), yn = sn.rowIndex, qn = sn.columnIndex;
        return yn > 0 ? Wt(Pa({ rowIndex: yn - 1, columnIndex: qn }, $t), !1) : kt;
      }(le, de.selection);
      We(Ve), Dn(mt(Ve));
    }
    if (pe === "ArrowDown" && (K.preventDefault(), Jt(), de.selection)) {
      var Ct = function($t, kt, sn) {
        var yn = _i(mt(sn), kt), qn = yn.rowIndex, Or = yn.columnIndex;
        return qn < $t.length - 1 ? Wt(Pa({ rowIndex: qn + 1, columnIndex: Or }, kt), !1) : sn;
      }(x, le, de.selection);
      We(Ct), Dn(mt(Ct));
    }
    if (pe === "Enter" && de.selection && an(de.selection)) {
      K.preventDefault();
      var _t = de.selection.path;
      Xn(it(x, _t)) ? Vt(_t) : j || We(fe(fe({}, de.selection), {}, { edit: !0 }));
    }
    if (pe.replace(/^Shift\+/, "").length === 1 && de.selection)
      return K.preventDefault(), void function($t) {
        ae.apply(this, arguments);
      }(K.key);
    if (pe === "Ctrl+Enter" && an(de.selection)) {
      var ut = it(x, de.selection.path);
      Vp(ut) && window.open(String(ut), "_blank");
    }
    pe === "Escape" && de.selection && (K.preventDefault(), We(null)), pe === "Ctrl+F" && K.preventDefault(), pe === "Ctrl+H" && K.preventDefault(), pe === "Ctrl+Z" && (K.preventDefault(), Mn()), pe === "Ctrl+Shift+Z" && (K.preventDefault(), Ht());
  }, function(K) {
    K.preventDefault(), V5({ clipboardText: K.clipboardData.getData("text/plain"), json: x, selection: de.selection, readOnly: j, parser: J, onPatch: je, onChangeText: pt, openRepairModal: vn });
  }, function(K) {
    a("select validation error", K), We(Wt(K.path, !1)), Ge(K.path);
  }, Vt, function() {
    (function(K) {
      j || x === void 0 || (rt = !0, A({ id: h, json: x, rootPath: K, onSort: function(pe) {
        var Ne = pe.operations, ze = pe.itemPath, Ve = pe.direction;
        a("onSort", Ne, K, ze, Ve), je(Ne, function(Ct, _t) {
          return { state: fe(fe({}, _t), {}, { sortedColumn: { path: ze, sortDirection: Ve === -1 ? Di.desc : Di.asc } }) };
        });
      }, onClose: function() {
        rt = !1, on();
      } }));
    })([]);
  }, function() {
    xt({ rootPath: [] });
  }, Mn, Ht, function(K) {
    n(70, nt = K.getBoundingClientRect().height);
  }, mn, $, N, O, I, P, D, Q, Z, R, M, C, z, E, A, te, ge, ne, he, Ge, wn, xt, g, Be, nt, oe, function(K) {
    Kt[K ? "unshift" : "push"](function() {
      n(15, w = K);
    });
  }, function() {
    return n(9, we = 1 / 0);
  }, function(K, pe) {
    return mn(pe, K);
  }, function(K) {
    Kt[K ? "unshift" : "push"](function() {
      n(14, y = K);
    });
  }, function(K) {
    Kt[K ? "unshift" : "push"](function() {
      n(13, v = K);
    });
  }];
}
var uie = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, cie, lie, Pt, { readOnly: 0, externalContent: 47, externalSelection: 48, mainMenuBar: 1, escapeControlCharacters: 49, escapeUnicodeCharacters: 50, flattenColumns: 51, parser: 2, parseMemoizeOne: 52, validator: 53, validationParser: 54, indentation: 3, onChange: 55, onChangeMode: 4, onSelect: 56, onRenderValue: 57, onRenderMenu: 5, onFocus: 58, onBlur: 59, onSortModal: 60, onTransformModal: 61, onJSONEditorModal: 62, validate: 63, patch: 64, focus: 6, acceptAutoRepair: 7, scrollTo: 65, findElement: 66, openTransformModal: 67 }, eie, [-1, -1, -1, -1, -1]), i;
  }
  return Ye(n, [{ key: "validate", get: function() {
    return this.$$.ctx[63];
  } }, { key: "patch", get: function() {
    return this.$$.ctx[64];
  } }, { key: "focus", get: function() {
    return this.$$.ctx[6];
  } }, { key: "acceptAutoRepair", get: function() {
    return this.$$.ctx[7];
  } }, { key: "scrollTo", get: function() {
    return this.$$.ctx[65];
  } }, { key: "findElement", get: function() {
    return this.$$.ctx[66];
  } }, { key: "openTransformModal", get: function() {
    return this.$$.ctx[67];
  } }]), n;
}();
function fie(t) {
  var e, n, r = { externalContent: t[0], externalSelection: t[1], readOnly: t[2], indentation: t[3], mainMenuBar: t[6], navigationBar: t[7], escapeControlCharacters: t[10], escapeUnicodeCharacters: t[11], parser: t[13], parseMemoizeOne: t[14], validator: t[15], validationParser: t[16], pathParser: t[17], onError: t[23], onChange: t[18], onChangeMode: t[19], onSelect: t[20], onRenderValue: t[21], onClassName: t[22], onFocus: t[24], onBlur: t[25], onRenderMenu: t[32], onSortModal: t[26], onTransformModal: t[27], onJSONEditorModal: t[28] };
  return e = new My({ props: r }), t[47](e), { c: function() {
    xe(e.$$.fragment);
  }, m: function(i, o) {
    ye(e, i, o), n = !0;
  }, p: function(i, o) {
    var s = {};
    1 & o[0] && (s.externalContent = i[0]), 2 & o[0] && (s.externalSelection = i[1]), 4 & o[0] && (s.readOnly = i[2]), 8 & o[0] && (s.indentation = i[3]), 64 & o[0] && (s.mainMenuBar = i[6]), 128 & o[0] && (s.navigationBar = i[7]), 1024 & o[0] && (s.escapeControlCharacters = i[10]), 2048 & o[0] && (s.escapeUnicodeCharacters = i[11]), 8192 & o[0] && (s.parser = i[13]), 16384 & o[0] && (s.parseMemoizeOne = i[14]), 32768 & o[0] && (s.validator = i[15]), 65536 & o[0] && (s.validationParser = i[16]), 131072 & o[0] && (s.pathParser = i[17]), 8388608 & o[0] && (s.onError = i[23]), 262144 & o[0] && (s.onChange = i[18]), 524288 & o[0] && (s.onChangeMode = i[19]), 1048576 & o[0] && (s.onSelect = i[20]), 2097152 & o[0] && (s.onRenderValue = i[21]), 4194304 & o[0] && (s.onClassName = i[22]), 16777216 & o[0] && (s.onFocus = i[24]), 33554432 & o[0] && (s.onBlur = i[25]), 2 & o[1] && (s.onRenderMenu = i[32]), 67108864 & o[0] && (s.onSortModal = i[26]), 134217728 & o[0] && (s.onTransformModal = i[27]), 268435456 & o[0] && (s.onJSONEditorModal = i[28]), e.$set(s);
  }, i: function(i) {
    n || (S(e.$$.fragment, i), n = !0);
  }, o: function(i) {
    _(e.$$.fragment, i), n = !1;
  }, d: function(i) {
    t[47](null), be(e, i);
  } };
}
function die(t) {
  var e, n, r = { externalContent: t[0], externalSelection: t[1], readOnly: t[2], mainMenuBar: t[6], escapeControlCharacters: t[10], escapeUnicodeCharacters: t[11], flattenColumns: t[12], parser: t[13], parseMemoizeOne: t[14], validator: t[15], validationParser: t[16], indentation: t[3], onChange: t[18], onChangeMode: t[19], onSelect: t[20], onRenderValue: t[21], onFocus: t[24], onBlur: t[25], onRenderMenu: t[32], onSortModal: t[26], onTransformModal: t[27], onJSONEditorModal: t[28] };
  return e = new uie({ props: r }), t[46](e), { c: function() {
    xe(e.$$.fragment);
  }, m: function(i, o) {
    ye(e, i, o), n = !0;
  }, p: function(i, o) {
    var s = {};
    1 & o[0] && (s.externalContent = i[0]), 2 & o[0] && (s.externalSelection = i[1]), 4 & o[0] && (s.readOnly = i[2]), 64 & o[0] && (s.mainMenuBar = i[6]), 1024 & o[0] && (s.escapeControlCharacters = i[10]), 2048 & o[0] && (s.escapeUnicodeCharacters = i[11]), 4096 & o[0] && (s.flattenColumns = i[12]), 8192 & o[0] && (s.parser = i[13]), 16384 & o[0] && (s.parseMemoizeOne = i[14]), 32768 & o[0] && (s.validator = i[15]), 65536 & o[0] && (s.validationParser = i[16]), 8 & o[0] && (s.indentation = i[3]), 262144 & o[0] && (s.onChange = i[18]), 524288 & o[0] && (s.onChangeMode = i[19]), 1048576 & o[0] && (s.onSelect = i[20]), 2097152 & o[0] && (s.onRenderValue = i[21]), 16777216 & o[0] && (s.onFocus = i[24]), 33554432 & o[0] && (s.onBlur = i[25]), 2 & o[1] && (s.onRenderMenu = i[32]), 67108864 & o[0] && (s.onSortModal = i[26]), 134217728 & o[0] && (s.onTransformModal = i[27]), 268435456 & o[0] && (s.onJSONEditorModal = i[28]), e.$set(s);
  }, i: function(i) {
    n || (S(e.$$.fragment, i), n = !0);
  }, o: function(i) {
    _(e.$$.fragment, i), n = !1;
  }, d: function(i) {
    t[46](null), be(e, i);
  } };
}
function hie(t) {
  var e, n, r = { externalContent: t[0], externalSelection: t[1], readOnly: t[2], indentation: t[3], tabSize: t[4], mainMenuBar: t[6], statusBar: t[8], askToFormat: t[9], escapeUnicodeCharacters: t[11], parser: t[13], validator: t[15], validationParser: t[16], onChange: t[18], onSelect: t[20], onChangeMode: t[19], onError: t[23], onFocus: t[24], onBlur: t[25], onRenderMenu: t[32], onSortModal: t[26], onTransformModal: t[27] };
  return e = new $re({ props: r }), t[45](e), { c: function() {
    xe(e.$$.fragment);
  }, m: function(i, o) {
    ye(e, i, o), n = !0;
  }, p: function(i, o) {
    var s = {};
    1 & o[0] && (s.externalContent = i[0]), 2 & o[0] && (s.externalSelection = i[1]), 4 & o[0] && (s.readOnly = i[2]), 8 & o[0] && (s.indentation = i[3]), 16 & o[0] && (s.tabSize = i[4]), 64 & o[0] && (s.mainMenuBar = i[6]), 256 & o[0] && (s.statusBar = i[8]), 512 & o[0] && (s.askToFormat = i[9]), 2048 & o[0] && (s.escapeUnicodeCharacters = i[11]), 8192 & o[0] && (s.parser = i[13]), 32768 & o[0] && (s.validator = i[15]), 65536 & o[0] && (s.validationParser = i[16]), 262144 & o[0] && (s.onChange = i[18]), 1048576 & o[0] && (s.onSelect = i[20]), 524288 & o[0] && (s.onChangeMode = i[19]), 8388608 & o[0] && (s.onError = i[23]), 16777216 & o[0] && (s.onFocus = i[24]), 33554432 & o[0] && (s.onBlur = i[25]), 2 & o[1] && (s.onRenderMenu = i[32]), 67108864 & o[0] && (s.onSortModal = i[26]), 134217728 & o[0] && (s.onTransformModal = i[27]), e.$set(s);
  }, i: function(i) {
    n || (S(e.$$.fragment, i), n = !0);
  }, o: function(i) {
    _(e.$$.fragment, i), n = !1;
  }, d: function(i) {
    t[45](null), be(e, i);
  } };
}
function pie(t) {
  var e, n, r, i, o = [hie, die, fie], s = [];
  function a(l, c) {
    return l[5] === Lr.text || l[5] === "code" ? 0 : l[5] === Lr.table ? 1 : 2;
  }
  return e = a(t), n = s[e] = o[e](t), { c: function() {
    n.c(), r = un();
  }, m: function(l, c) {
    s[e].m(l, c), X(l, r, c), i = !0;
  }, p: function(l, c) {
    var u = e;
    (e = a(l)) === u ? s[e].p(l, c) : (Ae(), _(s[u], 1, 1, function() {
      s[u] = null;
    }), Me(), (n = s[e]) ? n.p(l, c) : (n = s[e] = o[e](l)).c(), S(n, 1), n.m(r.parentNode, r));
  }, i: function(l) {
    i || (S(n), i = !0);
  }, o: function(l) {
    _(n), i = !1;
  }, d: function(l) {
    l && Y(r), s[e].d(l);
  } };
}
function mie(t, e, n) {
  var r, i, o, s, a, l = e.content, c = e.selection, u = e.readOnly, f = e.indentation, d = e.tabSize, h = e.mode, p = e.mainMenuBar, m = e.navigationBar, g = e.statusBar, v = e.askToFormat, y = e.escapeControlCharacters, w = e.escapeUnicodeCharacters, x = e.flattenColumns, b = e.parser, j = e.parseMemoizeOne, $ = e.validator, N = e.validationParser, B = e.pathParser, O = e.insideModal, I = e.onChange, P = e.onChangeMode, J = e.onSelect, D = e.onRenderValue, Q = e.onClassName, Z = e.onRenderMenu, L = e.onError, R = e.onFocus, V = e.onBlur, M = e.onSortModal, C = e.onTransformModal, F = e.onJSONEditorModal, z = { type: "separator" };
  function E() {
    return (E = Tt(Ie().mark(function A() {
      return Ie().wrap(function(te) {
        for (; ; )
          switch (te.prev = te.next) {
            case 0:
              if (!o) {
                te.next = 3;
                break;
              }
              return te.next = 3, o.refresh();
            case 3:
            case "end":
              return te.stop();
          }
      }, A);
    }))).apply(this, arguments);
  }
  return t.$$set = function(A) {
    "content" in A && n(0, l = A.content), "selection" in A && n(1, c = A.selection), "readOnly" in A && n(2, u = A.readOnly), "indentation" in A && n(3, f = A.indentation), "tabSize" in A && n(4, d = A.tabSize), "mode" in A && n(5, h = A.mode), "mainMenuBar" in A && n(6, p = A.mainMenuBar), "navigationBar" in A && n(7, m = A.navigationBar), "statusBar" in A && n(8, g = A.statusBar), "askToFormat" in A && n(9, v = A.askToFormat), "escapeControlCharacters" in A && n(10, y = A.escapeControlCharacters), "escapeUnicodeCharacters" in A && n(11, w = A.escapeUnicodeCharacters), "flattenColumns" in A && n(12, x = A.flattenColumns), "parser" in A && n(13, b = A.parser), "parseMemoizeOne" in A && n(14, j = A.parseMemoizeOne), "validator" in A && n(15, $ = A.validator), "validationParser" in A && n(16, N = A.validationParser), "pathParser" in A && n(17, B = A.pathParser), "insideModal" in A && n(33, O = A.insideModal), "onChange" in A && n(18, I = A.onChange), "onChangeMode" in A && n(19, P = A.onChangeMode), "onSelect" in A && n(20, J = A.onSelect), "onRenderValue" in A && n(21, D = A.onRenderValue), "onClassName" in A && n(22, Q = A.onClassName), "onRenderMenu" in A && n(34, Z = A.onRenderMenu), "onError" in A && n(23, L = A.onError), "onFocus" in A && n(24, R = A.onFocus), "onBlur" in A && n(25, V = A.onBlur), "onSortModal" in A && n(26, M = A.onSortModal), "onTransformModal" in A && n(27, C = A.onTransformModal), "onJSONEditorModal" in A && n(28, F = A.onJSONEditorModal);
  }, t.$$.update = function() {
    524320 & t.$$.dirty[0] && n(44, s = [{ type: "button", text: "text", title: "Switch to text mode (current mode: ".concat(h, ")"), className: "jse-group-button jse-first" + (h === Lr.text || h === "code" ? " jse-selected" : ""), onClick: function() {
      return P(Lr.text);
    } }, { type: "button", text: "tree", title: "Switch to tree mode (current mode: ".concat(h, ")"), className: "jse-group-button " + (h === Lr.tree ? " jse-selected" : ""), onClick: function() {
      return P(Lr.tree);
    } }, { type: "button", text: "table", title: "Switch to table mode (current mode: ".concat(h, ")"), className: "jse-group-button jse-last" + (h === Lr.table ? " jse-selected" : ""), onClick: function() {
      return P(Lr.table);
    } }]), 32 & t.$$.dirty[0] | 8204 & t.$$.dirty[1] && n(32, a = function(A) {
      var te = R5(A[0]) ? s.concat(A) : s.concat(z, A);
      return Z(te, { mode: h, modal: O }) || te;
    });
  }, [l, c, u, f, d, h, p, m, g, v, y, w, x, b, j, $, N, B, I, P, J, D, Q, L, R, V, M, C, F, r, i, o, a, O, Z, function(A) {
    if (r)
      return r.patch(A);
    if (i)
      return i.patch(A);
    if (o)
      return o.patch(A);
    throw new Error('Method patch is not available in mode "'.concat(h, '"'));
  }, function(A) {
    if (r)
      return r.expand(A);
    throw new Error('Method expand is not available in mode "'.concat(h, '"'));
  }, function(A) {
    if (o)
      o.openTransformModal(A);
    else if (r)
      r.openTransformModal(A);
    else {
      if (!i)
        throw new Error('Method transform is not available in mode "'.concat(h, '"'));
      i.openTransformModal(A);
    }
  }, function() {
    if (o)
      return o.validate();
    if (r)
      return r.validate();
    if (i)
      return i.validate();
    throw new Error('Method validate is not available in mode "'.concat(h, '"'));
  }, function() {
    return r ? r.acceptAutoRepair() : l;
  }, function(A) {
    if (r)
      return r.scrollTo(A);
    if (i)
      return i.scrollTo(A);
    throw new Error('Method scrollTo is not available in mode "'.concat(h, '"'));
  }, function(A) {
    if (r)
      return r.findElement(A);
    if (i)
      return i.findElement(A);
    throw new Error('Method findElement is not available in mode "'.concat(h, '"'));
  }, function() {
    o ? o.focus() : r ? r.focus() : i && i.focus();
  }, function() {
    return E.apply(this, arguments);
  }, s, function(A) {
    Kt[A ? "unshift" : "push"](function() {
      n(31, o = A);
    });
  }, function(A) {
    Kt[A ? "unshift" : "push"](function() {
      n(30, i = A);
    });
  }, function(A) {
    Kt[A ? "unshift" : "push"](function() {
      n(29, r = A);
    });
  }];
}
var Y5 = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, mie, pie, wr, { content: 0, selection: 1, readOnly: 2, indentation: 3, tabSize: 4, mode: 5, mainMenuBar: 6, navigationBar: 7, statusBar: 8, askToFormat: 9, escapeControlCharacters: 10, escapeUnicodeCharacters: 11, flattenColumns: 12, parser: 13, parseMemoizeOne: 14, validator: 15, validationParser: 16, pathParser: 17, insideModal: 33, onChange: 18, onChangeMode: 19, onSelect: 20, onRenderValue: 21, onClassName: 22, onRenderMenu: 34, onError: 23, onFocus: 24, onBlur: 25, onSortModal: 26, onTransformModal: 27, onJSONEditorModal: 28, patch: 35, expand: 36, transform: 37, validate: 38, acceptAutoRepair: 39, scrollTo: 40, findElement: 41, focus: 42, refresh: 43 }, null, [-1, -1]), i;
  }
  return Ye(n, [{ key: "patch", get: function() {
    return this.$$.ctx[35];
  } }, { key: "expand", get: function() {
    return this.$$.ctx[36];
  } }, { key: "transform", get: function() {
    return this.$$.ctx[37];
  } }, { key: "validate", get: function() {
    return this.$$.ctx[38];
  } }, { key: "acceptAutoRepair", get: function() {
    return this.$$.ctx[39];
  } }, { key: "scrollTo", get: function() {
    return this.$$.ctx[40];
  } }, { key: "findElement", get: function() {
    return this.$$.ctx[41];
  } }, { key: "focus", get: function() {
    return this.$$.ctx[42];
  } }, { key: "refresh", get: function() {
    return this.$$.ctx[43];
  } }]), n;
}();
function gie(t) {
  At(t, "svelte-1m3nfgb", '.jse-modal.svelte-1m3nfgb.svelte-1m3nfgb{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-1m3nfgb .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-1m3nfgb .jse-modal-contents.svelte-1m3nfgb{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-1m3nfgb .jse-modal-contents .jse-actions.svelte-1m3nfgb{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-1m3nfgb .jse-modal-contents .jse-actions button.jse-primary.svelte-1m3nfgb{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-1m3nfgb .jse-modal-contents .jse-actions button.jse-primary.svelte-1m3nfgb:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-1m3nfgb .jse-modal-contents .jse-actions button.jse-primary.svelte-1m3nfgb:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;height:auto;min-height:500px;max-height:calc(100vh - 6rem);display:flex}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-modal-contents.svelte-1m3nfgb{padding-top:0}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-modal-contents .jse-label.svelte-1m3nfgb{font-weight:bold;display:block;box-sizing:border-box}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-modal-contents .jse-label .jse-label-inner.svelte-1m3nfgb{margin-top:calc(2 * var(--jse-padding, 10px));margin-bottom:calc(0.5 * var(--jse-padding, 10px));box-sizing:border-box}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-modal-contents .jse-label .jse-label-inner button.svelte-1m3nfgb{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;font-weight:bold;padding:0}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-modal-contents .jse-modal-inline-editor.svelte-1m3nfgb{flex:1;min-height:150px;min-width:0;display:flex;--jse-theme-color:var(--jse-modal-editor-theme-color, var(--jse-modal-theme-color, #707070));--jse-theme-color-highlight:var(--jse-modal-editor-theme-color-highlight, var(--jse-modal-theme-color-highlight, #646464))}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-actions.svelte-1m3nfgb{gap:var(--jse-padding, 10px);align-items:center}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-actions .jse-error.svelte-1m3nfgb{flex:1;color:var(--jse-error-color, #ee5341)}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-actions button.jse-secondary.svelte-1m3nfgb{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-secondary-background, #d3d3d3);color:var(--jse-button-secondary-color, var(--jse-text-color, #4d4d4d));padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-actions button.jse-secondary.svelte-1m3nfgb:hover{background:var(--jse-button-secondary-background-highlight, #e1e1e1)}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb .jse-actions button.jse-secondary.svelte-1m3nfgb:disabled{background:var(--jse-button-secondary-background-disabled, #9d9d9d)}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb input.svelte-1m3nfgb{border:var(--jse-input-border, 1px solid #d8dbdf);outline:none;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding, 10px));font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:inherit;background:var(--jse-input-background, var(--jse-background-color, #fff))}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb input.svelte-1m3nfgb:focus{border:var(--jse-input-border-focus, 1px solid var(--jse-input-border-focus, var(--jse-theme-color, #3883fa)))}.jse-modal.jse-jsoneditor-modal.svelte-1m3nfgb input.svelte-1m3nfgb:read-only{background:var(--jse-input-background-readonly, transparent)}');
}
function r4(t) {
  var e, n;
  return { c: function() {
    e = H("div"), n = Le(t[21]), k(e, "class", "jse-error svelte-1m3nfgb");
  }, m: function(r, i) {
    X(r, e, i), T(e, n);
  }, p: function(r, i) {
    2097152 & i[0] && bt(n, r[21]);
  }, d: function(r) {
    r && Y(e);
  } };
}
function i4(t) {
  var e, n, r, i, o, s;
  return n = new cn({ props: { data: WL } }), { c: function() {
    e = H("button"), xe(n.$$.fragment), r = Le(" Back"), k(e, "type", "button"), k(e, "class", "jse-secondary svelte-1m3nfgb");
  }, m: function(a, l) {
    X(a, e, l), ye(n, e, null), T(e, r), i = !0, o || (s = Oe(e, "click", t[26]), o = !0);
  }, p: Pe, i: function(a) {
    i || (S(n.$$.fragment, a), i = !0);
  }, o: function(a) {
    _(n.$$.fragment, a), i = !1;
  }, d: function(a) {
    a && Y(e), be(n), o = !1, s();
  } };
}
function vie(t) {
  var e, n, r;
  return { c: function() {
    (e = H("button")).textContent = "Close", k(e, "type", "button"), k(e, "class", "jse-primary svelte-1m3nfgb");
  }, m: function(i, o) {
    X(i, e, o), n || (r = [Oe(e, "click", t[26]), Mr(X5.call(null, e))], n = !0);
  }, p: Pe, d: function(i) {
    i && Y(e), n = !1, An(r);
  } };
}
function yie(t) {
  var e, n, r;
  return { c: function() {
    (e = H("button")).textContent = "Apply", k(e, "type", "button"), k(e, "class", "jse-primary svelte-1m3nfgb");
  }, m: function(i, o) {
    X(i, e, o), n || (r = [Oe(e, "click", t[25]), Mr(X5.call(null, e))], n = !0);
  }, p: Pe, d: function(i) {
    i && Y(e), n = !1, An(r);
  } };
}
function bie(t) {
  var e, n, r, i, o, s, a, l, c, u, f, d, h, p, m, g, v, y, w;
  n = new $y({ props: { title: "Edit nested content " + (t[19].length > 1 ? " (".concat(t[19].length, ")") : ""), onClose: t[26] } });
  var x = { mode: t[22].mode, content: t[22].content, selection: t[22].selection, readOnly: t[0], indentation: t[1], tabSize: t[2], statusBar: t[5], askToFormat: t[6], mainMenuBar: t[3], navigationBar: t[4], escapeControlCharacters: t[7], escapeUnicodeCharacters: t[8], flattenColumns: t[9], parser: t[10], parseMemoizeOne: t[23], validator: t[11], validationParser: t[12], pathParser: t[13], insideModal: !0, onError: t[30], onChange: t[27], onChangeMode: t[29], onSelect: t[28], onRenderValue: t[14], onClassName: t[15], onFocus: Zi, onBlur: Zi, onRenderMenu: t[16], onSortModal: t[17], onTransformModal: t[18], onJSONEditorModal: t[31] };
  d = new Y5({ props: x }), t[36](d);
  var b = t[21] && r4(t), j = t[19].length > 1 && i4(t);
  function $(O, I) {
    return O[0] ? vie : yie;
  }
  var N = $(t), B = N(t);
  return { c: function() {
    e = H("div"), xe(n.$$.fragment), r = se(), i = H("div"), (o = H("div")).innerHTML = '<div class="jse-label-inner svelte-1m3nfgb">Path</div>', s = se(), a = H("input"), l = se(), (c = H("div")).innerHTML = '<div class="jse-label-inner svelte-1m3nfgb">Contents</div>', u = se(), f = H("div"), xe(d.$$.fragment), h = se(), p = H("div"), b && b.c(), m = se(), j && j.c(), g = se(), B.c(), k(o, "class", "jse-label svelte-1m3nfgb"), k(a, "class", "jse-path svelte-1m3nfgb"), k(a, "type", "text"), a.readOnly = !0, k(a, "title", "Selected path"), a.value = t[24], k(c, "class", "jse-label svelte-1m3nfgb"), k(f, "class", "jse-modal-inline-editor svelte-1m3nfgb"), k(p, "class", "jse-actions svelte-1m3nfgb"), k(i, "class", "jse-modal-contents svelte-1m3nfgb"), k(e, "class", "jse-modal jse-jsoneditor-modal svelte-1m3nfgb");
  }, m: function(O, I) {
    X(O, e, I), ye(n, e, null), T(e, r), T(e, i), T(i, o), T(i, s), T(i, a), T(i, l), T(i, c), T(i, u), T(i, f), ye(d, f, null), T(i, h), T(i, p), b && b.m(p, null), T(p, m), j && j.m(p, null), T(p, g), B.m(p, null), v = !0, y || (w = Mr(em.call(null, e, t[26])), y = !0);
  }, p: function(O, I) {
    var P = {};
    524288 & I[0] && (P.title = "Edit nested content " + (O[19].length > 1 ? " (".concat(O[19].length, ")") : "")), n.$set(P), (!v || 16777216 & I[0] && a.value !== O[24]) && (a.value = O[24]);
    var J = {};
    4194304 & I[0] && (J.mode = O[22].mode), 4194304 & I[0] && (J.content = O[22].content), 4194304 & I[0] && (J.selection = O[22].selection), 1 & I[0] && (J.readOnly = O[0]), 2 & I[0] && (J.indentation = O[1]), 4 & I[0] && (J.tabSize = O[2]), 32 & I[0] && (J.statusBar = O[5]), 64 & I[0] && (J.askToFormat = O[6]), 8 & I[0] && (J.mainMenuBar = O[3]), 16 & I[0] && (J.navigationBar = O[4]), 128 & I[0] && (J.escapeControlCharacters = O[7]), 256 & I[0] && (J.escapeUnicodeCharacters = O[8]), 512 & I[0] && (J.flattenColumns = O[9]), 1024 & I[0] && (J.parser = O[10]), 8388608 & I[0] && (J.parseMemoizeOne = O[23]), 2048 & I[0] && (J.validator = O[11]), 4096 & I[0] && (J.validationParser = O[12]), 8192 & I[0] && (J.pathParser = O[13]), 16384 & I[0] && (J.onRenderValue = O[14]), 32768 & I[0] && (J.onClassName = O[15]), 65536 & I[0] && (J.onRenderMenu = O[16]), 131072 & I[0] && (J.onSortModal = O[17]), 262144 & I[0] && (J.onTransformModal = O[18]), d.$set(J), O[21] ? b ? b.p(O, I) : ((b = r4(O)).c(), b.m(p, m)) : b && (b.d(1), b = null), O[19].length > 1 ? j ? (j.p(O, I), 524288 & I[0] && S(j, 1)) : ((j = i4(O)).c(), S(j, 1), j.m(p, g)) : j && (Ae(), _(j, 1, 1, function() {
      j = null;
    }), Me()), N === (N = $(O)) && B ? B.p(O, I) : (B.d(1), (B = N(O)) && (B.c(), B.m(p, null)));
  }, i: function(O) {
    v || (S(n.$$.fragment, O), S(d.$$.fragment, O), S(j), v = !0);
  }, o: function(O) {
    _(n.$$.fragment, O), _(d.$$.fragment, O), _(j), v = !1;
  }, d: function(O) {
    O && Y(e), be(n), t[36](null), be(d), b && b.d(), j && j.d(), B.d(), y = !1, w();
  } };
}
function X5(t) {
  t.focus();
}
function xie(t, e, n) {
  var r, i, o, s, a, l = Tr("jsoneditor:JSONEditorModal"), c = e.content, u = e.path, f = e.onPatch, d = e.readOnly, h = e.indentation, p = e.tabSize, m = e.mainMenuBar, g = e.navigationBar, v = e.statusBar, y = e.askToFormat, w = e.escapeControlCharacters, x = e.escapeUnicodeCharacters, b = e.flattenColumns, j = e.parser, $ = e.validator, N = e.validationParser, B = e.pathParser, O = e.onRenderValue, I = e.onClassName, P = e.onRenderMenu, J = e.onSortModal, D = e.onTransformModal, Q = _r("simple-modal").close, Z = { mode: V(c), content: c, selection: null, relativePath: u }, L = [Z], R = void 0;
  function V(C) {
    return dy(C) && Tn(C.json) ? Lr.table : Lr.tree;
  }
  function M() {
    var C, F = ((C = Yt(L)) === null || C === void 0 ? void 0 : C.selection) || null;
    F && a.scrollTo(mt(F));
  }
  return t.$$set = function(C) {
    "content" in C && n(32, c = C.content), "path" in C && n(33, u = C.path), "onPatch" in C && n(34, f = C.onPatch), "readOnly" in C && n(0, d = C.readOnly), "indentation" in C && n(1, h = C.indentation), "tabSize" in C && n(2, p = C.tabSize), "mainMenuBar" in C && n(3, m = C.mainMenuBar), "navigationBar" in C && n(4, g = C.navigationBar), "statusBar" in C && n(5, v = C.statusBar), "askToFormat" in C && n(6, y = C.askToFormat), "escapeControlCharacters" in C && n(7, w = C.escapeControlCharacters), "escapeUnicodeCharacters" in C && n(8, x = C.escapeUnicodeCharacters), "flattenColumns" in C && n(9, b = C.flattenColumns), "parser" in C && n(10, j = C.parser), "validator" in C && n(11, $ = C.validator), "validationParser" in C && n(12, N = C.validationParser), "pathParser" in C && n(13, B = C.pathParser), "onRenderValue" in C && n(14, O = C.onRenderValue), "onClassName" in C && n(15, I = C.onClassName), "onRenderMenu" in C && n(16, P = C.onRenderMenu), "onSortModal" in C && n(17, J = C.onSortModal), "onTransformModal" in C && n(18, D = C.onTransformModal);
  }, t.$$.update = function() {
    524288 & t.$$.dirty[0] && n(22, r = Yt(L) || Z), 524288 & t.$$.dirty[0] && n(35, i = L.flatMap(function(C) {
      return C.relativePath;
    })), 16 & t.$$.dirty[1] && n(24, o = nn(i) ? "(document root)" : hi(i)), 1024 & t.$$.dirty[0] && n(23, s = nf(j.parse));
  }, [d, h, p, m, g, v, y, w, x, b, j, $, N, B, O, I, P, J, D, L, a, R, r, s, o, function() {
    if (l("handleApply"), !d)
      try {
        n(21, R = void 0);
        var C = r.relativePath, F = r.content, z = [{ op: "replace", path: Je(C), value: Cw(F, j).json }];
        if (L.length > 1) {
          var E = Cw(L[L.length - 2].content, j).json, A = { json: so(E, z) }, te = fe(fe({}, L[L.length - 2] || Z), {}, { content: A });
          n(19, L = [].concat(Ft(L.slice(0, L.length - 2)), [te])), lr().then(M);
        } else
          f(z), Q();
      } catch (ge) {
        n(21, R = String(ge));
      }
  }, function() {
    l("handleClose"), L.length > 1 ? (n(19, L = en(L)), lr().then(M), n(21, R = void 0)) : Q();
  }, function(C) {
    l("handleChange", C);
    var F = fe(fe({}, r), {}, { content: C });
    n(19, L = [].concat(Ft(en(L)), [F]));
  }, function(C) {
    l("handleChangeSelection", C);
    var F = fe(fe({}, r), {}, { selection: C });
    n(19, L = [].concat(Ft(en(L)), [F]));
  }, function(C) {
    l("handleChangeMode", C);
    var F = fe(fe({}, r), {}, { mode: C });
    n(19, L = [].concat(Ft(en(L)), [F]));
  }, function(C) {
    n(21, R = C.toString()), console.error(C);
  }, function(C) {
    var F = C.content, z = C.path;
    l("handleJSONEditorModal", { content: F, path: z });
    var E = { mode: V(F), content: F, selection: null, relativePath: z };
    n(19, L = [].concat(Ft(L), [E]));
  }, c, u, f, i, function(C) {
    Kt[C ? "unshift" : "push"](function() {
      n(20, a = C);
    });
  }];
}
var wie = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, xie, bie, Pt, { content: 32, path: 33, onPatch: 34, readOnly: 0, indentation: 1, tabSize: 2, mainMenuBar: 3, navigationBar: 4, statusBar: 5, askToFormat: 6, escapeControlCharacters: 7, escapeUnicodeCharacters: 8, flattenColumns: 9, parser: 10, validator: 11, validationParser: 12, pathParser: 13, onRenderValue: 14, onClassName: 15, onRenderMenu: 16, onSortModal: 17, onTransformModal: 18 }, gie, [-1, -1]), i;
  }
  return Ye(n);
}();
function jie(t, e, n) {
  var r = _r("simple-modal");
  return [r.open, r.close];
}
var kie = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, jie, null, Pt, { open: 0, close: 1 }), i;
  }
  return Ye(n, [{ key: "open", get: function() {
    return this.$$.ctx[0];
  } }, { key: "close", get: function() {
    return this.$$.ctx[1];
  } }]), n;
}();
function $ie(t) {
  At(t, "svelte-ybuk0j", '.jse-main.svelte-ybuk0j{width:100%;height:100%;min-width:0;min-height:150px;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;position:relative;display:flex;flex-direction:row}');
}
function o4(t) {
  var e, n, r = { mode: t[1], content: t[0], selection: t[2], readOnly: t[3], indentation: t[4], tabSize: t[5], statusBar: t[8], askToFormat: t[9], mainMenuBar: t[6], navigationBar: t[7], escapeControlCharacters: t[10], escapeUnicodeCharacters: t[11], flattenColumns: t[12], parser: t[13], parseMemoizeOne: t[26], validator: t[14], validationParser: t[15], pathParser: t[16], insideModal: !1, onError: t[20], onChange: t[27], onChangeMode: t[31], onSelect: t[28], onRenderValue: t[17], onClassName: t[18], onFocus: t[29], onBlur: t[30], onRenderMenu: t[19], onSortModal: t[33], onTransformModal: t[32], onJSONEditorModal: t[34] };
  return e = new Y5({ props: r }), t[61](e), { c: function() {
    xe(e.$$.fragment);
  }, m: function(i, o) {
    ye(e, i, o), n = !0;
  }, p: function(i, o) {
    var s = {};
    2 & o[0] && (s.mode = i[1]), 1 & o[0] && (s.content = i[0]), 4 & o[0] && (s.selection = i[2]), 8 & o[0] && (s.readOnly = i[3]), 16 & o[0] && (s.indentation = i[4]), 32 & o[0] && (s.tabSize = i[5]), 256 & o[0] && (s.statusBar = i[8]), 512 & o[0] && (s.askToFormat = i[9]), 64 & o[0] && (s.mainMenuBar = i[6]), 128 & o[0] && (s.navigationBar = i[7]), 1024 & o[0] && (s.escapeControlCharacters = i[10]), 2048 & o[0] && (s.escapeUnicodeCharacters = i[11]), 4096 & o[0] && (s.flattenColumns = i[12]), 8192 & o[0] && (s.parser = i[13]), 67108864 & o[0] && (s.parseMemoizeOne = i[26]), 16384 & o[0] && (s.validator = i[14]), 32768 & o[0] && (s.validationParser = i[15]), 65536 & o[0] && (s.pathParser = i[16]), 1048576 & o[0] && (s.onError = i[20]), 131072 & o[0] && (s.onRenderValue = i[17]), 262144 & o[0] && (s.onClassName = i[18]), 524288 & o[0] && (s.onRenderMenu = i[19]), e.$set(s);
  }, i: function(i) {
    n || (S(e.$$.fragment, i), n = !0);
  }, o: function(i) {
    _(e.$$.fragment, i), n = !1;
  }, d: function(i) {
    t[61](null), be(e, i);
  } };
}
function Sie(t) {
  var e, n, r, i, o, s = t[21];
  function a(u) {
    t[60](u);
  }
  var l = {};
  t[24] !== void 0 && (l.open = t[24]), e = new kie({ props: l }), Kt.push(function() {
    return no(e, "open", a);
  });
  var c = o4(t);
  return { c: function() {
    xe(e.$$.fragment), r = se(), i = H("div"), c.c(), k(i, "class", "jse-main svelte-ybuk0j"), $e(i, "jse-focus", t[22]);
  }, m: function(u, f) {
    ye(e, u, f), X(u, r, f), X(u, i, f), c.m(i, null), o = !0;
  }, p: function(u, f) {
    var d = {};
    !n && 16777216 & f[0] && (n = !0, d.open = u[24], to(function() {
      return n = !1;
    })), e.$set(d), 2097152 & f[0] && Pt(s, s = u[21]) ? (Ae(), _(c, 1, 1, Pe), Me(), (c = o4(u)).c(), S(c, 1), c.m(i, null)) : c.p(u, f), (!o || 4194304 & f[0]) && $e(i, "jse-focus", u[22]);
  }, i: function(u) {
    o || (S(e.$$.fragment, u), S(c), o = !0);
  }, o: function(u) {
    _(e.$$.fragment, u), _(c), o = !1;
  }, d: function(u) {
    u && (Y(r), Y(i)), be(e, u), c.d(u);
  } };
}
function Cie(t) {
  var e, n;
  return e = new L6({ props: { closeOnEsc: !1, $$slots: { default: [Sie] }, $$scope: { ctx: t } } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    100663295 & i[0] | 4 & i[2] && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Oie(t) {
  for (var e, n, r, i = [{ show: (e = t[25]) === null || e === void 0 ? void 0 : e.component }, LQ, { closeOnEsc: !1 }], o = { $$slots: { default: [Cie] }, $$scope: { ctx: t } }, s = 0; s < i.length; s += 1)
    o = di(o, i[s]);
  return (n = new L6({ props: o })).$on("close", t[35]), { c: function() {
    xe(n.$$.fragment);
  }, m: function(a, l) {
    ye(n, a, l), r = !0;
  }, p: function(a, l) {
    var c, u = 33554432 & l[0] ? Vi(i, [{ show: (c = a[25]) === null || c === void 0 ? void 0 : c.component }, i[1], i[2]]) : {};
    100663295 & l[0] | 4 & l[2] && (u.$$scope = { dirty: l, ctx: a }), n.$set(u);
  }, i: function(a) {
    r || (S(n.$$.fragment, a), r = !0);
  }, o: function(a) {
    _(n.$$.fragment, a), r = !1;
  }, d: function(a) {
    be(n, a);
  } };
}
function Eie(t) {
  var e, n;
  return e = new n5({ props: { $$slots: { default: [Oie] }, $$scope: { ctx: t } } }), { c: function() {
    xe(e.$$.fragment);
  }, m: function(r, i) {
    ye(e, r, i), n = !0;
  }, p: function(r, i) {
    var o = {};
    134217727 & i[0] | 4 & i[2] && (o.$$scope = { dirty: i, ctx: r }), e.$set(o);
  }, i: function(r) {
    n || (S(e.$$.fragment, r), n = !0);
  }, o: function(r) {
    _(e.$$.fragment, r), n = !1;
  }, d: function(r) {
    be(e, r);
  } };
}
function Aie(t, e, n) {
  var r, i, o, s = Tr("jsoneditor:JSONEditor"), a = e.content, l = a === void 0 ? { text: "" } : a, c = e.selection, u = c === void 0 ? null : c, f = e.readOnly, d = f !== void 0 && f, h = e.indentation, p = h === void 0 ? 2 : h, m = e.tabSize, g = m === void 0 ? 4 : m, v = e.mode, y = v === void 0 ? Lr.tree : v, w = e.mainMenuBar, x = w === void 0 || w, b = e.navigationBar, j = b === void 0 || b, $ = e.statusBar, N = $ === void 0 || $, B = e.askToFormat, O = B === void 0 || B, I = e.escapeControlCharacters, P = I !== void 0 && I, J = e.escapeUnicodeCharacters, D = J !== void 0 && J, Q = e.flattenColumns, Z = Q === void 0 || Q, L = e.parser, R = L === void 0 ? JSON : L, V = e.validator, M = V === void 0 ? null : V, C = e.validationParser, F = C === void 0 ? JSON : C, z = e.pathParser, E = z === void 0 ? { parse: hY, stringify: hi } : z, A = e.queryLanguages, te = A === void 0 ? [gY] : A, ge = e.queryLanguageId, ke = ge === void 0 ? te[0].id : ge, Ce = e.onChangeQueryLanguage, we = Ce === void 0 ? Zi : Ce, le = e.onChange, rt = le === void 0 ? null : le, Be = e.onSelect, nt = Be === void 0 ? Zi : Be, oe = e.onRenderValue, We = oe === void 0 ? gX : oe, Rt = e.onClassName, de = Rt === void 0 ? function() {
  } : Rt, Se = e.onRenderMenu, rn = Se === void 0 ? Zi : Se, Dt = e.onChangeMode, Xt = Dt === void 0 ? Zi : Dt, Ue = e.onError, kn = Ue === void 0 ? function(ce) {
    console.error(ce), alert(ce.toString());
  } : Ue, fn = e.onFocus, q = fn === void 0 ? Zi : fn, ee = e.onBlur, ne = ee === void 0 ? Zi : ee, he = fu(), je = !1, _e = null, yt = R;
  function Xe() {
    return (Xe = Tt(Ie().mark(function ce(qe) {
      var Fe;
      return Ie().wrap(function(Lt) {
        for (; ; )
          switch (Lt.prev = Lt.next) {
            case 0:
              if (s("set"), !(Fe = Jm(qe))) {
                Lt.next = 4;
                break;
              }
              throw new Error(Fe);
            case 4:
              return n(21, he = fu()), Lt.next = 7, lr();
            case 7:
              n(0, l = qe);
            case 8:
            case "end":
              return Lt.stop();
          }
      }, ce);
    }))).apply(this, arguments);
  }
  function Zt() {
    return (Zt = Tt(Ie().mark(function ce(qe) {
      var Fe;
      return Ie().wrap(function(Lt) {
        for (; ; )
          switch (Lt.prev = Lt.next) {
            case 0:
              if (s("update"), !(Fe = Jm(qe))) {
                Lt.next = 4;
                break;
              }
              throw new Error(Fe);
            case 4:
              return n(0, l = qe), Lt.next = 7, lr();
            case 7:
            case "end":
              return Lt.stop();
          }
      }, ce);
    }))).apply(this, arguments);
  }
  function on() {
    return (on = Tt(Ie().mark(function ce(qe) {
      var Fe;
      return Ie().wrap(function(Lt) {
        for (; ; )
          switch (Lt.prev = Lt.next) {
            case 0:
              if (!oc(l)) {
                Lt.next = 8;
                break;
              }
              Lt.prev = 1, n(0, l = { json: R.parse(l.text), text: void 0 }), Lt.next = 8;
              break;
            case 5:
              throw Lt.prev = 5, Lt.t0 = Lt.catch(1), new Error("Cannot apply patch: current document contains invalid JSON");
            case 8:
              return Fe = i.patch(qe), Lt.next = 11, lr();
            case 11:
              return Lt.abrupt("return", Fe);
            case 12:
            case "end":
              return Lt.stop();
          }
      }, ce, null, [[1, 5]]);
    }))).apply(this, arguments);
  }
  function Jt() {
    return (Jt = Tt(Ie().mark(function ce(qe) {
      return Ie().wrap(function(Fe) {
        for (; ; )
          switch (Fe.prev = Fe.next) {
            case 0:
              return n(2, u = qe), Fe.next = 3, lr();
            case 3:
            case "end":
              return Fe.stop();
          }
      }, ce);
    }))).apply(this, arguments);
  }
  function Ge() {
    return (Ge = Tt(Ie().mark(function ce(qe) {
      return Ie().wrap(function(Fe) {
        for (; ; )
          switch (Fe.prev = Fe.next) {
            case 0:
              return i.expand(qe), Fe.next = 3, lr();
            case 3:
            case "end":
              return Fe.stop();
          }
      }, ce);
    }))).apply(this, arguments);
  }
  function xn() {
    return xn = Tt(Ie().mark(function ce() {
      var qe;
      return Ie().wrap(function(Fe) {
        for (; ; )
          switch (Fe.prev = Fe.next) {
            case 0:
              return qe = i.acceptAutoRepair(), Fe.next = 3, lr();
            case 3:
              return Fe.abrupt("return", qe);
            case 4:
            case "end":
              return Fe.stop();
          }
      }, ce);
    })), xn.apply(this, arguments);
  }
  function Dn() {
    return (Dn = Tt(Ie().mark(function ce(qe) {
      return Ie().wrap(function(Fe) {
        for (; ; )
          switch (Fe.prev = Fe.next) {
            case 0:
              return Fe.next = 2, i.scrollTo(qe);
            case 2:
            case "end":
              return Fe.stop();
          }
      }, ce);
    }))).apply(this, arguments);
  }
  function wn() {
    return $n.apply(this, arguments);
  }
  function $n() {
    return ($n = Tt(Ie().mark(function ce() {
      return Ie().wrap(function(qe) {
        for (; ; )
          switch (qe.prev = qe.next) {
            case 0:
              return i.focus(), qe.next = 3, lr();
            case 3:
            case "end":
              return qe.stop();
          }
      }, ce);
    }))).apply(this, arguments);
  }
  function Rn() {
    return (Rn = Tt(Ie().mark(function ce() {
      return Ie().wrap(function(qe) {
        for (; ; )
          switch (qe.prev = qe.next) {
            case 0:
              return qe.next = 2, i.refresh();
            case 2:
            case "end":
              return qe.stop();
          }
      }, ce);
    }))).apply(this, arguments);
  }
  function Jn() {
    return (Jn = Tt(Ie().mark(function ce(qe) {
      return Ie().wrap(function(Fe) {
        for (; ; )
          switch (Fe.prev = Fe.next) {
            case 0:
              return this.$set(qe), Fe.next = 3, lr();
            case 3:
            case "end":
              return Fe.stop();
          }
      }, ce, this);
    }))).apply(this, arguments);
  }
  function pn() {
    return (pn = Tt(Ie().mark(function ce() {
      return Ie().wrap(function(qe) {
        for (; ; )
          switch (qe.prev = qe.next) {
            case 0:
              return this.$destroy(), qe.next = 3, lr();
            case 3:
            case "end":
              return qe.stop();
          }
      }, ce, this);
    }))).apply(this, arguments);
  }
  function me() {
    return (me = Tt(Ie().mark(function ce(qe) {
      return Ie().wrap(function(Fe) {
        for (; ; )
          switch (Fe.prev = Fe.next) {
            case 0:
              if (y !== qe) {
                Fe.next = 2;
                break;
              }
              return Fe.abrupt("return");
            case 2:
              return n(1, y = qe), Fe.next = 5, lr();
            case 5:
              return Fe.next = 7, wn();
            case 7:
              Xt(qe);
            case 8:
            case "end":
              return Fe.stop();
          }
      }, ce);
    }))).apply(this, arguments);
  }
  function Ke(ce) {
    s("handleChangeQueryLanguage", ce), n(36, ke = ce), we(ce);
  }
  function It(ce) {
    var qe = ce.id, Fe = ce.json, Lt = ce.rootPath, qt = ce.onTransform, U = ce.onClose;
    d || o(Qne, { id: qe, json: Fe, rootPath: Lt, indentation: p, escapeControlCharacters: P, escapeUnicodeCharacters: D, parser: R, parseMemoizeOne: r, validationParser: F, pathParser: E, queryLanguages: te, queryLanguageId: ke, onChangeQueryLanguage: Ke, onRenderValue: We, onClassName: de, onTransform: qt }, DQ, { onClose: U });
  }
  function Nt(ce) {
    var qe = ce.id, Fe = ce.json, Lt = ce.rootPath, qt = ce.onSort, U = ce.onClose;
    d || o(tre, { id: qe, json: Fe, rootPath: Lt, onSort: qt }, IQ, { onClose: U });
  }
  return t.$$set = function(ce) {
    "content" in ce && n(0, l = ce.content), "selection" in ce && n(2, u = ce.selection), "readOnly" in ce && n(3, d = ce.readOnly), "indentation" in ce && n(4, p = ce.indentation), "tabSize" in ce && n(5, g = ce.tabSize), "mode" in ce && n(1, y = ce.mode), "mainMenuBar" in ce && n(6, x = ce.mainMenuBar), "navigationBar" in ce && n(7, j = ce.navigationBar), "statusBar" in ce && n(8, N = ce.statusBar), "askToFormat" in ce && n(9, O = ce.askToFormat), "escapeControlCharacters" in ce && n(10, P = ce.escapeControlCharacters), "escapeUnicodeCharacters" in ce && n(11, D = ce.escapeUnicodeCharacters), "flattenColumns" in ce && n(12, Z = ce.flattenColumns), "parser" in ce && n(13, R = ce.parser), "validator" in ce && n(14, M = ce.validator), "validationParser" in ce && n(15, F = ce.validationParser), "pathParser" in ce && n(16, E = ce.pathParser), "queryLanguages" in ce && n(37, te = ce.queryLanguages), "queryLanguageId" in ce && n(36, ke = ce.queryLanguageId), "onChangeQueryLanguage" in ce && n(38, we = ce.onChangeQueryLanguage), "onChange" in ce && n(39, rt = ce.onChange), "onSelect" in ce && n(40, nt = ce.onSelect), "onRenderValue" in ce && n(17, We = ce.onRenderValue), "onClassName" in ce && n(18, de = ce.onClassName), "onRenderMenu" in ce && n(19, rn = ce.onRenderMenu), "onChangeMode" in ce && n(41, Xt = ce.onChangeMode), "onError" in ce && n(20, kn = ce.onError), "onFocus" in ce && n(42, q = ce.onFocus), "onBlur" in ce && n(43, ne = ce.onBlur);
  }, t.$$.update = function() {
    if (8193 & t.$$.dirty[0] | 268435456 & t.$$.dirty[1] && (YQ(R, yt) || (s("parser changed, recreate editor"), dy(l) && n(0, l = { json: R.parse(yt.stringify(l.json)) }), n(59, yt = R), n(21, he = fu()))), 1 & t.$$.dirty[0]) {
      var ce = Jm(l);
      ce && console.error("Error: " + ce);
    }
    8192 & t.$$.dirty[0] && n(26, r = nf(R.parse)), 2 & t.$$.dirty[0] && (s("mode changed to", y), y === "code" && console.warn('Deprecation warning: "code" mode is renamed to "text". Please use mode="text" instead.'));
  }, [l, y, u, d, p, g, x, j, N, O, P, D, Z, R, M, F, E, We, de, rn, kn, he, je, i, o, _e, r, function(ce, qe, Fe) {
    n(0, l = ce), rt && rt(ce, qe, Fe);
  }, function(ce) {
    n(2, u = ce), nt(ce);
  }, function() {
    n(22, je = !0), q && q();
  }, function() {
    n(22, je = !1), ne && ne();
  }, function(ce) {
    return me.apply(this, arguments);
  }, It, Nt, function(ce) {
    var qe = ce.content, Fe = ce.path, Lt = ce.onPatch, qt = ce.onClose;
    s("onJSONEditorModal", { content: qe, path: Fe }), n(25, _e = { component: D6(wie, { content: qe, path: Fe, onPatch: Lt, readOnly: d, indentation: p, tabSize: g, mainMenuBar: x, navigationBar: j, statusBar: N, askToFormat: O, escapeControlCharacters: P, escapeUnicodeCharacters: D, flattenColumns: Z, parser: R, validator: void 0, validationParser: F, pathParser: E, onRenderValue: We, onClassName: de, onRenderMenu: rn, onSortModal: Nt, onTransformModal: It }), callbacks: { onClose: qt } });
  }, function() {
    var ce, qe;
    (ce = _e) === null || ce === void 0 || (ce = ce.callbacks) === null || ce === void 0 || (qe = ce.onClose) === null || qe === void 0 || qe.call(ce), n(25, _e = null);
  }, ke, te, we, rt, nt, Xt, q, ne, function() {
    return l;
  }, function(ce) {
    return Xe.apply(this, arguments);
  }, function(ce) {
    return Zt.apply(this, arguments);
  }, function(ce) {
    return on.apply(this, arguments);
  }, function(ce) {
    return Jt.apply(this, arguments);
  }, function(ce) {
    return Ge.apply(this, arguments);
  }, function(ce) {
    i.transform(ce);
  }, function() {
    return i.validate();
  }, function() {
    return xn.apply(this, arguments);
  }, function(ce) {
    return Dn.apply(this, arguments);
  }, function(ce) {
    return i.findElement(ce);
  }, wn, function() {
    return Rn.apply(this, arguments);
  }, function(ce) {
    return Jn.apply(this, arguments);
  }, function() {
    return pn.apply(this, arguments);
  }, yt, function(ce) {
    n(24, o = ce);
  }, function(ce) {
    Kt[ce ? "unshift" : "push"](function() {
      n(23, i = ce);
    });
  }];
}
var Mie = function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Aie, Eie, Pt, { content: 0, selection: 2, readOnly: 3, indentation: 4, tabSize: 5, mode: 1, mainMenuBar: 6, navigationBar: 7, statusBar: 8, askToFormat: 9, escapeControlCharacters: 10, escapeUnicodeCharacters: 11, flattenColumns: 12, parser: 13, validator: 14, validationParser: 15, pathParser: 16, queryLanguages: 37, queryLanguageId: 36, onChangeQueryLanguage: 38, onChange: 39, onSelect: 40, onRenderValue: 17, onClassName: 18, onRenderMenu: 19, onChangeMode: 41, onError: 20, onFocus: 42, onBlur: 43, get: 44, set: 45, update: 46, patch: 47, select: 48, expand: 49, transform: 50, validate: 51, acceptAutoRepair: 52, scrollTo: 53, findElement: 54, focus: 55, refresh: 56, updateProps: 57, destroy: 58 }, $ie, [-1, -1, -1]), i;
  }
  return Ye(n, [{ key: "get", get: function() {
    return this.$$.ctx[44];
  } }, { key: "set", get: function() {
    return this.$$.ctx[45];
  } }, { key: "update", get: function() {
    return this.$$.ctx[46];
  } }, { key: "patch", get: function() {
    return this.$$.ctx[47];
  } }, { key: "select", get: function() {
    return this.$$.ctx[48];
  } }, { key: "expand", get: function() {
    return this.$$.ctx[49];
  } }, { key: "transform", get: function() {
    return this.$$.ctx[50];
  } }, { key: "validate", get: function() {
    return this.$$.ctx[51];
  } }, { key: "acceptAutoRepair", get: function() {
    return this.$$.ctx[52];
  } }, { key: "scrollTo", get: function() {
    return this.$$.ctx[53];
  } }, { key: "findElement", get: function() {
    return this.$$.ctx[54];
  } }, { key: "focus", get: function() {
    return this.$$.ctx[55];
  } }, { key: "refresh", get: function() {
    return this.$$.ctx[56];
  } }, { key: "updateProps", get: function() {
    return this.$$.ctx[57];
  } }, { key: "destroy", get: function() {
    return this.$$.ctx[58];
  } }]), n;
}();
function _ie(t) {
  At(t, "svelte-9wp3tj", ".jse-value.jse-string.svelte-9wp3tj{color:var(--jse-value-color-string, #008000)}.jse-value.jse-object.svelte-9wp3tj,.jse-value.jse-array.svelte-9wp3tj{min-width:16px;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-value.jse-number.svelte-9wp3tj{color:var(--jse-value-color-number, #ee422e)}.jse-value.jse-boolean.svelte-9wp3tj{color:var(--jse-value-color-boolean, #ff8c00)}.jse-value.jse-null.svelte-9wp3tj{color:var(--jse-value-color-null, #004ed0)}.jse-value.jse-invalid.svelte-9wp3tj{color:var(--jse-text-color, #4d4d4d)}.jse-value.jse-url.svelte-9wp3tj{color:var(--jse-value-color-url, #008000);text-decoration:underline}.jse-enum-value.svelte-9wp3tj{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06));border:none;padding:0;font-family:inherit;font-size:inherit;cursor:pointer;outline:none}.jse-enum-value.jse-selected.svelte-9wp3tj{background:var(--jse-selection-background-color, #d3d3d3);color:inherit}.jse-enum-value.jse-value.svelte-9wp3tj:focus{color:var(--jse-text-color, #4d4d4d)}.jse-json-node.jse-selected .jse-enum-value.svelte-9wp3tj{background:transparent}");
}
function s4(t, e, n) {
  var r = t.slice();
  return r[13] = e[n], r;
}
function a4(t) {
  var e, n, r, i = t[13].text + "";
  return { c: function() {
    e = H("option"), n = Le(i), e.__value = r = t[13].value, Uo(e, e.__value);
  }, m: function(o, s) {
    X(o, e, s), T(e, n);
  }, p: function(o, s) {
    4 & s && i !== (i = o[13].text + "") && bt(n, i), 4 & s && r !== (r = o[13].value) && (e.__value = r, Uo(e, e.__value));
  }, d: function(o) {
    o && Y(e);
  } };
}
function Tie(t) {
  for (var e, n, r, i, o = Ot(t[2]), s = [], a = 0; a < o.length; a += 1)
    s[a] = a4(s4(t, o, a));
  return { c: function() {
    e = H("select");
    for (var l = 0; l < s.length; l += 1)
      s[l].c();
    k(e, "class", n = Un("jse-enum-value ".concat(Wu(t[4], t[0]))) + " svelte-9wp3tj"), t[4] === void 0 && Ja(function() {
      return t[10].call(e);
    }), $e(e, "jse-selected", an(t[1]));
  }, m: function(l, c) {
    X(l, e, c);
    for (var u = 0; u < s.length; u += 1)
      s[u] && s[u].m(e, null);
    gw(e, t[4], !0), t[11](e), r || (i = [Oe(e, "change", t[10]), Oe(e, "change", t[5]), Oe(e, "mousedown", Pie)], r = !0);
  }, p: function(l, c) {
    var u = Et(c, 1)[0];
    if (4 & u) {
      var f;
      for (o = Ot(l[2]), f = 0; f < o.length; f += 1) {
        var d = s4(l, o, f);
        s[f] ? s[f].p(d, u) : (s[f] = a4(d), s[f].c(), s[f].m(e, null));
      }
      for (; f < s.length; f += 1)
        s[f].d(1);
      s.length = o.length;
    }
    17 & u && n !== (n = Un("jse-enum-value ".concat(Wu(l[4], l[0]))) + " svelte-9wp3tj") && k(e, "class", n), 16 & u && gw(e, l[4]), 19 & u && $e(e, "jse-selected", an(l[1]));
  }, i: Pe, o: Pe, d: function(l) {
    l && Y(e), fr(s, l), t[11](null), r = !1, An(i);
  } };
}
function Pie(t) {
  t.stopPropagation();
}
function Rie(t, e, n) {
  var r, i = e.path, o = e.value, s = e.parser, a = e.readOnly, l = e.selection, c = e.onPatch, u = e.options, f = o;
  return t.$$set = function(d) {
    "path" in d && n(6, i = d.path), "value" in d && n(7, o = d.value), "parser" in d && n(0, s = d.parser), "readOnly" in d && n(8, a = d.readOnly), "selection" in d && n(1, l = d.selection), "onPatch" in d && n(9, c = d.onPatch), "options" in d && n(2, u = d.options);
  }, t.$$.update = function() {
    128 & t.$$.dirty && n(4, f = o), 2 & t.$$.dirty && function(d) {
      d && r && r.focus();
    }(l);
  }, [s, l, u, r, f, function(d) {
    d.stopPropagation(), a || c([{ op: "replace", path: Je(i), value: f }]);
  }, i, o, a, c, function() {
    var d;
    d = this.querySelector(":checked"), f = d && d.__value, n(4, f), n(7, o);
  }, function(d) {
    Kt[d ? "unshift" : "push"](function() {
      n(3, r = d), n(2, u);
    });
  }];
}
(function(t) {
  lt(n, ht);
  var e = ct(n);
  function n(r) {
    var i;
    return Qe(this, n), dt(ft(i = e.call(this)), r, Rie, Tie, Pt, { path: 6, value: 7, parser: 0, readOnly: 8, selection: 1, onPatch: 9, options: 2 }, _ie), i;
  }
  return Ye(n);
})();
const Nie = "JsonEditorVue", $d = l0 ? "modelValue" : "value", l4 = l0 ? "update:modelValue" : "input", Sd = [
  "mainMenuBar",
  "navigationBar",
  "statusBar",
  "askToFormat",
  "readOnly",
  "escapeControlCharacters",
  "escapeUnicodeCharacters",
  "flattenColumns"
], Z5 = oO({
  name: Nie,
  props: {
    [$d]: {},
    mode: {
      type: String
    },
    ...Object.fromEntries(
      Sd.map((t) => [
        t,
        {
          type: Boolean,
          default: void 0
        }
      ])
    )
  },
  emits: {
    [l4](t) {
      return !0;
    },
    "update:mode": function(t) {
      return !0;
    }
  },
  setup(t, { attrs: e, emit: n, expose: r }) {
    var f;
    const i = (f = sO()) == null ? void 0 : f.proxy, o = nm(), s = nm(!1), a = nm(!1), l = ef((d) => {
      if (a.value) {
        a.value = !1;
        return;
      }
      s.value = !0, n(
        l4,
        d.text === void 0 ? d.json : d.text
      );
    }, 100), c = (d) => {
      n("update:mode", d);
    }, u = (d, h) => (...p) => {
      d(...p), h(...p);
    };
    return r == null || r({ jsonEditor: o }), aO(() => {
      var d;
      (d = o.value) == null || d.destroy();
    }), lO(() => {
      const d = gl([t.mode, Jd.mode], {
        type: String
      }), h = gl([t[$d], Jd[$d]]), p = Object.fromEntries(
        Array.from(Sd, (g) => [g, gl([t[g], Jd[g]])]).filter(
          ([, g]) => g !== void 0
        )
      ), m = gl(
        [
          p,
          e,
          eO,
          {
            // Both user input & setting value programmatically will trigger onChange
            onChange: l,
            onChangeMode: c,
            mode: d,
            ...h !== void 0 && {
              content: {
                json: h
              }
            }
          }
        ],
        {
          type: Object,
          mergeFunction: u
        }
      );
      o.value = new Mie({
        target: i == null ? void 0 : i.$refs.jsonEditorRef,
        props: m
      }), jf(
        () => t[$d],
        (g) => {
          if (s.value) {
            s.value = !1;
            return;
          }
          o.value && (a.value = !0, o.value.set(
            [void 0, ""].includes(g) ? { text: "" } : { json: g }
          ));
        },
        {
          deep: !0
        }
      ), jf(
        () => t.mode,
        (g) => {
          var v;
          (v = o.value) == null || v.updateProps({
            mode: g
          });
        }
      ), jf(
        () => Array.from(Sd, (g) => t[g]),
        (g) => {
          var v;
          (v = o.value) == null || v.updateProps(
            Object.fromEntries(Array.from(g, (y, w) => [Sd[w], y]).filter(([, y]) => y !== void 0))
          );
        }
      ), jf(
        () => e,
        (g) => {
          var y;
          const v = {};
          g.onChange && (v.onChange = l), g.onChangeMode && (v.onChangeMode = c), (y = o.value) == null || y.updateProps(
            Object.getOwnPropertyNames(v).length > 0 ? gl([g, v], {
              type: Object,
              mergeFunction: u
            }) : g
          );
        },
        {
          deep: !0
        }
      ), r || (r = (g) => {
        for (const v in g)
          i[v] = cO(g[v]);
      }, r({ jsonEditor: o }));
    }), () => uO("div", { ref: "jsonEditorRef" });
  }
}), Jd = {}, eO = {};
function Iie(t) {
  return t.install = (e, n = {}) => {
    const { props: r, attrs: i } = rP(n, { props: Z5.props });
    Object.assign(Jd, r), Object.assign(eO, i), e.component(t.name, t);
  }, t;
}
const qie = Iie(Z5);
export {
  qie as default
};
//# sourceMappingURL=json-editor-vue.mjs.map
